/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSONObject: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type ActionLogDto = {
  __typename: 'ActionLogDto';
  /** Действие над сущностью */
  action: Scalars['String']['output'];
  create_by: UserDto;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Описание */
  description: Scalars['String']['output'];
  /** Id сущности */
  entity_id: Scalars['Float']['output'];
  /** Вид сущности */
  entity_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Дополнительная информация */
  meta: Scalars['String']['output'];
  /** ID родителя */
  parent_id?: Maybe<Scalars['Int']['output']>;
  /** Тип родителя */
  parent_type?: Maybe<Scalars['String']['output']>;
  /** Предыдущее значение */
  payload?: Maybe<Scalars['String']['output']>;
};

export type ActionLogList = {
  __typename: 'ActionLogList';
  items: Array<ActionLogDto>;
  totalCount: Scalars['Float']['output'];
};

export type AddCarriagesByDateDto = {
  /** Идентификатор показателя для месяца */
  carriage_group_indicator_id: Scalars['Int']['input'];
  /** Показатели по типам вагонов */
  carriage_type_indicators: Array<CreateCarriageGroupCarriageTypeIndicatorsDto>;
  /** Задан ли состав по датам */
  is_calendar_active: Scalars['Boolean']['input'];
};

export type ApproveCarriageGroupRequestDto = {
  /** Принять все ГВ */
  is_approve_all_carriage_groups: Scalars['Boolean']['input'];
  table_block_id?: InputMaybe<Scalars['Int']['input']>;
  train_schema_id: Scalars['Int']['input'];
};

export type AuthenticationMutationEntryPoint = {
  __typename: 'AuthenticationMutationEntryPoint';
  /** Обновления токена */
  refreshToken: RefreshTokenResponseDto;
  /** Вход в систему */
  signIn: TokenResponseDto;
  /** Завершение сессии */
  singOut?: Maybe<Scalars['Void']['output']>;
};


export type AuthenticationMutationEntryPointRefreshTokenArgs = {
  data: RefreshTokenRequestDto;
};


export type AuthenticationMutationEntryPointSignInArgs = {
  data: SignInRequestDto;
};

export type AvailableServiceClassDto = {
  __typename: 'AvailableServiceClassDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  /** Класс обслуживания */
  service_class: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type AvailableServiceClassList = {
  __typename: 'AvailableServiceClassList';
  items: Array<AvailableServiceClassDto>;
  totalCount: Scalars['Float']['output'];
};

export type AvailableServiceClassMutationEntryPoint = {
  __typename: 'AvailableServiceClassMutationEntryPoint';
  /** Создание класса обслуживания */
  create: AvailableServiceClassDto;
  /** Обновление класса обслуживания */
  update: AvailableServiceClassDto;
};


export type AvailableServiceClassMutationEntryPointCreateArgs = {
  data: CreateAvailableServiceClassDto;
};


export type AvailableServiceClassMutationEntryPointUpdateArgs = {
  data: UpdateAvailableServiceClassDto;
};

export type AvailableServiceClassQueryEntryPoint = {
  __typename: 'AvailableServiceClassQueryEntryPoint';
  /** Доступные классы обслуживания по entityId */
  byEntityId: AvailableServiceClassDto;
  /** Список изменений станции */
  history: AvailableServiceClassList;
  /** Список доступных классов обслуживания */
  list: AvailableServiceClassList;
};


export type AvailableServiceClassQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type AvailableServiceClassQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<AvailableServiceClassQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type AvailableServiceClassQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<AvailableServiceClassQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<AvailableServiceClassQueryResolver_List_FilterInputType>;
};

export type AvailableServiceClassQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  service_class?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type AvailableServiceClassQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<AvailableServiceClassQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<AvailableServiceClassQueryResolver_List_BaseFilterInputType>>;
  service_class?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type AvailableServiceClassQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<AvailableServiceClassQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<AvailableServiceClassQueryResolver_List_BaseFilterInputType>>;
  service_class?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type AvailableServiceClassQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  service_class?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type Boolean_PropertyFilterInputType = {
  /** Группа вагнонов заблокирована для изменений */
  between?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Группа вагнонов заблокирована для изменений */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Группа вагнонов заблокирована для изменений */
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Группа вагнонов заблокирована для изменений */
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  /** Группа вагнонов заблокирована для изменений */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Группа вагнонов заблокирована для изменений */
  in_arr?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Группа вагнонов заблокирована для изменений */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Группа вагнонов заблокирована для изменений */
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Группа вагнонов заблокирована для изменений */
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  /** Группа вагнонов заблокирована для изменений */
  neq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Группа вагнонов заблокирована для изменений */
  notbetween?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Группа вагнонов заблокирована для изменений */
  notin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Группа вагнонов заблокирована для изменений */
  notlike?: InputMaybe<Scalars['String']['input']>;
  /** Группа вагнонов заблокирована для изменений */
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BorderControlDto = {
  __typename: 'BorderControlDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  /** Направление */
  direction: Scalars['String']['output'];
  for_station: StationDto;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type BranchArgsDto = {
  /** Код */
  railway_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Период */
  range: RangeInputDto;
};

export type BranchDto = {
  __typename: 'BranchDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Является ли данная запись последней актуальной */
  is_latest: Scalars['Boolean']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  /** Название филиала */
  name: Scalars['String']['output'];
  /** Наименование в nmrvag (ЦСУ) */
  name_nmrvag: Scalars['String']['output'];
  railways: Array<RailwayDto>;
  /** Краткое наименование филиала */
  short_name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  /** Код в nmrvag (ЦСУ) */
  vladr: Scalars['String']['output'];
};

export type BranchList = {
  __typename: 'BranchList';
  items: Array<BranchDto>;
  totalCount: Scalars['Float']['output'];
};

export type BranchMutationEntryPoint = {
  __typename: 'BranchMutationEntryPoint';
  /** Создание филиала */
  create: BranchDto;
  /** Создать версию филиала */
  createVersion: BranchDto;
  /** Удалить филиал */
  delete: Scalars['Boolean']['output'];
  /** Обновить филиал */
  update: BranchDto;
};


export type BranchMutationEntryPointCreateArgs = {
  data: CreateBranchDto;
};


export type BranchMutationEntryPointCreateVersionArgs = {
  data: CreateVersionBranchDto;
};


export type BranchMutationEntryPointDeleteArgs = {
  id: Scalars['Float']['input'];
};


export type BranchMutationEntryPointUpdateArgs = {
  data: UpdateBranchDto;
};

export type BranchQueryEntryPoint = {
  __typename: 'BranchQueryEntryPoint';
  /** Филиал АО «ФПК» по id */
  byEntityId: BranchDto;
  /** Список изменений филиала АО «ФПК» */
  history: BranchList;
  /** Список филиалов АО «ФПК» */
  list: BranchList;
};


export type BranchQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type BranchQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<BranchQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type BranchQueryEntryPointListArgs = {
  data: BranchArgsDto;
  order_by?: InputMaybe<Array<BranchQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<BranchQueryResolver_List_FilterInputType>;
};

export type BranchQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_latest?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  name_nmrvag?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  vladr?: InputMaybe<SortType>;
};

export type BranchQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<BranchQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_latest?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  name_nmrvag?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<BranchQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  vladr?: InputMaybe<String_PropertyFilterInputType>;
};

export type BranchQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<BranchQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_latest?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  name_nmrvag?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<BranchQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  vladr?: InputMaybe<String_PropertyFilterInputType>;
};

export type BranchQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_latest?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  name_nmrvag?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  vladr?: InputMaybe<SortType>;
};

export type BranchesTrainsDto = {
  __typename: 'BranchesTrainsDto';
  /** Филиал ФПК - количество пар поездов */
  pairs_count: Array<TrainPairsDashboardDto>;
  /** Филиалы ФПК - количество предприятий */
  subdivisions: Array<SubdivisionsDto>;
};

export type ByTypeAsuDimensionIdQueryDataDto = {
  /** Id габарита вагона */
  carriage_dimension_id: Scalars['Int']['input'];
  /** Id типа вагона АСУПВ */
  carriage_type_asu_id: Scalars['Int']['input'];
};

export type CacheControlScope =
  | 'PRIVATE'
  | 'PUBLIC';

export type CalculateIndicatorsTableAreasDto = {
  __typename: 'CalculateIndicatorsTableAreasDto';
  /** Расстояние между станциями */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Дата отправки */
  from_date?: Maybe<Scalars['String']['output']>;
  from_station?: Maybe<StationDto>;
  /** Расход топлива */
  gas_consumption?: Maybe<Scalars['Float']['output']>;
  /** Цена топлива */
  gas_price?: Maybe<Scalars['Float']['output']>;
  /** Стоимость аренды состава */
  locomotive_rent_cost?: Maybe<Scalars['Float']['output']>;
  locomotive_series?: Maybe<LocomotiveSeriesDto>;
  /** Стоимость бригады */
  locomotive_team_cost?: Maybe<Scalars['Float']['output']>;
  /** Стоимость технического обслуживания */
  locomotive_tech_service_price?: Maybe<Scalars['Float']['output']>;
  /** Расход электричества */
  power_consumption?: Maybe<Scalars['Float']['output']>;
  /** Цена электричества */
  power_price?: Maybe<Scalars['Float']['output']>;
  /** Продолжительность поездки с подготовкой */
  prep_time?: Maybe<Scalars['Float']['output']>;
  /** Номер секции */
  section_quantity?: Maybe<Scalars['Float']['output']>;
  /** Дата прибытия */
  to_date?: Maybe<Scalars['String']['output']>;
  to_station?: Maybe<StationDto>;
  traction_directorate?: Maybe<TractionDirectorateDto>;
  traction_directorate_team?: Maybe<Array<TractionDirectorateDto>>;
  /** Стоимость поездки */
  trip_cost?: Maybe<Scalars['Float']['output']>;
  /** Продолжительность поездки */
  trip_time?: Maybe<Scalars['Float']['output']>;
};

export type CalculateIndicatorsTableDto = {
  __typename: 'CalculateIndicatorsTableDto';
  /** Расстояние между станциями */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Дата отправления */
  from_date?: Maybe<Scalars['String']['output']>;
  from_station?: Maybe<StationDto>;
  /** Расход топлива */
  gas_consumption?: Maybe<Scalars['Float']['output']>;
  /** Стоимость топлива */
  gas_price?: Maybe<Scalars['Float']['output']>;
  /** Список смены локомотивов */
  locomotive_areas?: Maybe<Array<CalculateIndicatorsTableAreasDto>>;
  /** Стоимость аренды */
  locomotive_rent_cost?: Maybe<Scalars['Float']['output']>;
  locomotive_series: Array<LocomotiveSeriesDto>;
  /** Стоимость аренды локомотивной бригады */
  locomotive_team_cost?: Maybe<Scalars['Float']['output']>;
  /** Стоимость технического обслуживания */
  locomotive_tech_service_price?: Maybe<Scalars['Float']['output']>;
  /** Стоимость электричества */
  power_consumption?: Maybe<Scalars['Float']['output']>;
  /** Стоимость электричества */
  power_price?: Maybe<Scalars['Float']['output']>;
  /** Продолжительность поездки с подготовкой */
  prep_time?: Maybe<Scalars['Float']['output']>;
  /** Номер схемы */
  schema_id?: Maybe<Scalars['Float']['output']>;
  /** Дата прибытия */
  to_date?: Maybe<Scalars['String']['output']>;
  to_station?: Maybe<StationDto>;
  traction_directorate_teams: Array<TractionDirectorateDto>;
  traction_directorates: Array<TractionDirectorateDto>;
  /** Номер поезда */
  train_number?: Maybe<Scalars['String']['output']>;
  /** Стоимость поездки */
  trip_cost?: Maybe<Scalars['Float']['output']>;
  /** Продолжительность поездки */
  trip_time?: Maybe<Scalars['Float']['output']>;
  trips_from_period: Scalars['Int']['output'];
};

export type CalculateIndicatorsTableForLocomotives = {
  __typename: 'CalculateIndicatorsTableForLocomotives';
  current: CalculateIndicatorsTableListWithSchemasDto;
  period: CalculateIndicatorsTableListWithSchemasDto;
};

export type CalculateIndicatorsTableList = {
  __typename: 'CalculateIndicatorsTableList';
  items: Array<CalculateIndicatorsTableForLocomotives>;
  totalCount: Scalars['Float']['output'];
};

export type CalculateIndicatorsTableListWithSchemasDto = {
  __typename: 'CalculateIndicatorsTableListWithSchemasDto';
  branch?: Maybe<BranchDto>;
  /** Расстояние между станциями */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Дата отправления */
  from_date?: Maybe<Scalars['String']['output']>;
  from_station?: Maybe<StationDto>;
  /** Расход топлива */
  gas_consumption?: Maybe<Scalars['Float']['output']>;
  /** Стоимость топлива */
  gas_price?: Maybe<Scalars['Float']['output']>;
  /** Стоимость аренды */
  locomotive_rent_cost?: Maybe<Scalars['Float']['output']>;
  locomotive_series: Array<LocomotiveSeriesDto>;
  /** Стоимость аренды локомотивной бригады */
  locomotive_team_cost?: Maybe<Scalars['Float']['output']>;
  /** Стоимость технического обслуживания */
  locomotive_tech_service_price?: Maybe<Scalars['Float']['output']>;
  passenger_carrier?: Maybe<PassengerCarrierDto>;
  /** Стоимость электричества */
  power_consumption?: Maybe<Scalars['Float']['output']>;
  /** Стоимость электричества */
  power_price?: Maybe<Scalars['Float']['output']>;
  /** Продолжительность поездки с подготовкой */
  prep_time?: Maybe<Scalars['Float']['output']>;
  railway_administration?: Maybe<RailwayAdministrationDto>;
  schemas: Array<CalculateIndicatorsTableDto>;
  /** Дата прибытия */
  to_date?: Maybe<Scalars['String']['output']>;
  to_station?: Maybe<StationDto>;
  traction_directorate_teams: Array<TractionDirectorateDto>;
  traction_directorates: Array<TractionDirectorateDto>;
  /** Номер поезда */
  train_number: Scalars['String']['output'];
  /** Стоимость поездки */
  trip_cost?: Maybe<Scalars['Float']['output']>;
  /** Продолжительность поездки */
  trip_time?: Maybe<Scalars['Float']['output']>;
  trips_from_period: Scalars['Int']['output'];
};

export type CapacityCompareDto = {
  __typename: 'CapacityCompareDto';
  /** по филиалам */
  items: Array<CapacityRowCompareDto>;
  /** по фпк */
  total: CapacityCompareTotalDto;
};

export type CapacityCompareTotalDto = {
  __typename: 'CapacityCompareTotalDto';
  carriages_quantity_compare: Scalars['Float']['output'];
  carriages_quantity_compare_dereg: Scalars['Float']['output'];
  carriages_quantity_compare_reg: Scalars['Float']['output'];
  carriages_quantity_current: Scalars['Float']['output'];
  carriages_quantity_current_dereg: Scalars['Float']['output'];
  carriages_quantity_current_reg: Scalars['Float']['output'];
  carriages_quantity_tolerance: Scalars['Float']['output'];
  carriages_quantity_tolerance_dereg: Scalars['Float']['output'];
  carriages_quantity_tolerance_reg: Scalars['Float']['output'];
  carriages_turnover_compare: Scalars['Float']['output'];
  carriages_turnover_compare_dereg: Scalars['Float']['output'];
  carriages_turnover_compare_reg: Scalars['Float']['output'];
  carriages_turnover_current: Scalars['Float']['output'];
  carriages_turnover_current_dereg: Scalars['Float']['output'];
  carriages_turnover_current_reg: Scalars['Float']['output'];
  carriages_turnover_tolerance: Scalars['Float']['output'];
  carriages_turnover_tolerance_dereg: Scalars['Float']['output'];
  carriages_turnover_tolerance_reg: Scalars['Float']['output'];
  seats_quantity_compare: Scalars['Float']['output'];
  seats_quantity_compare_dereg: Scalars['Float']['output'];
  seats_quantity_compare_reg: Scalars['Float']['output'];
  seats_quantity_current: Scalars['Float']['output'];
  seats_quantity_current_dereg: Scalars['Float']['output'];
  seats_quantity_current_reg: Scalars['Float']['output'];
  seats_quantity_tolerance: Scalars['Float']['output'];
  seats_quantity_tolerance_dereg: Scalars['Float']['output'];
  seats_quantity_tolerance_reg: Scalars['Float']['output'];
  seats_turnover_compare: Scalars['Float']['output'];
  seats_turnover_compare_dereg: Scalars['Float']['output'];
  seats_turnover_compare_reg: Scalars['Float']['output'];
  seats_turnover_current: Scalars['Float']['output'];
  seats_turnover_current_dereg: Scalars['Float']['output'];
  seats_turnover_current_reg: Scalars['Float']['output'];
  seats_turnover_tolerance: Scalars['Float']['output'];
  seats_turnover_tolerance_dereg: Scalars['Float']['output'];
  seats_turnover_tolerance_reg: Scalars['Float']['output'];
  trains_quantity_compare: Scalars['Float']['output'];
  trains_quantity_compare_dereg: Scalars['Float']['output'];
  trains_quantity_compare_reg: Scalars['Float']['output'];
  trains_quantity_current: Scalars['Float']['output'];
  trains_quantity_current_dereg: Scalars['Float']['output'];
  trains_quantity_current_reg: Scalars['Float']['output'];
  trains_quantity_tolerance: Scalars['Float']['output'];
  trains_quantity_tolerance_dereg: Scalars['Float']['output'];
  trains_quantity_tolerance_reg: Scalars['Float']['output'];
  trains_turnover_compare: Scalars['Float']['output'];
  trains_turnover_compare_dereg: Scalars['Float']['output'];
  trains_turnover_compare_reg: Scalars['Float']['output'];
  trains_turnover_current: Scalars['Float']['output'];
  trains_turnover_current_dereg: Scalars['Float']['output'];
  trains_turnover_current_reg: Scalars['Float']['output'];
  trains_turnover_tolerance: Scalars['Float']['output'];
  trains_turnover_tolerance_dereg: Scalars['Float']['output'];
  trains_turnover_tolerance_reg: Scalars['Float']['output'];
};

export type CapacityCurrentDto = {
  __typename: 'CapacityCurrentDto';
  /** по филиалам */
  items: Array<CapacityRowCurrentDto>;
  /** по фпк */
  total: CapacityCurrentTotalDto;
};

export type CapacityCurrentTotalDto = {
  __typename: 'CapacityCurrentTotalDto';
  carriages_quantity_compare: Scalars['Float']['output'];
  carriages_quantity_compare_dereg: Scalars['Float']['output'];
  carriages_quantity_compare_reg: Scalars['Float']['output'];
  carriages_quantity_current: Scalars['Float']['output'];
  carriages_quantity_current_dereg: Scalars['Float']['output'];
  carriages_quantity_current_reg: Scalars['Float']['output'];
  carriages_quantity_percentage: Scalars['Float']['output'];
  carriages_quantity_percentage_dereg: Scalars['Float']['output'];
  carriages_quantity_percentage_reg: Scalars['Float']['output'];
  carriages_quantity_plan: Scalars['Float']['output'];
  carriages_quantity_plan_dereg: Scalars['Float']['output'];
  carriages_quantity_plan_reg: Scalars['Float']['output'];
  carriages_turnover_compare: Scalars['Float']['output'];
  carriages_turnover_compare_dereg: Scalars['Float']['output'];
  carriages_turnover_compare_reg: Scalars['Float']['output'];
  carriages_turnover_current: Scalars['Float']['output'];
  carriages_turnover_current_dereg: Scalars['Float']['output'];
  carriages_turnover_current_reg: Scalars['Float']['output'];
  carriages_turnover_percentage: Scalars['Float']['output'];
  carriages_turnover_percentage_dereg: Scalars['Float']['output'];
  carriages_turnover_percentage_reg: Scalars['Float']['output'];
  carriages_turnover_plan: Scalars['Float']['output'];
  carriages_turnover_plan_dereg: Scalars['Float']['output'];
  carriages_turnover_plan_reg: Scalars['Float']['output'];
  seats_quantity_compare: Scalars['Float']['output'];
  seats_quantity_compare_dereg: Scalars['Float']['output'];
  seats_quantity_compare_reg: Scalars['Float']['output'];
  seats_quantity_current: Scalars['Float']['output'];
  seats_quantity_current_dereg: Scalars['Float']['output'];
  seats_quantity_current_reg: Scalars['Float']['output'];
  seats_quantity_percentage: Scalars['Float']['output'];
  seats_quantity_percentage_dereg: Scalars['Float']['output'];
  seats_quantity_percentage_reg: Scalars['Float']['output'];
  seats_quantity_plan: Scalars['Float']['output'];
  seats_quantity_plan_dereg: Scalars['Float']['output'];
  seats_quantity_plan_reg: Scalars['Float']['output'];
  seats_turnover_compare: Scalars['Float']['output'];
  seats_turnover_compare_dereg: Scalars['Float']['output'];
  seats_turnover_compare_reg: Scalars['Float']['output'];
  seats_turnover_current: Scalars['Float']['output'];
  seats_turnover_current_dereg: Scalars['Float']['output'];
  seats_turnover_current_reg: Scalars['Float']['output'];
  seats_turnover_percentage: Scalars['Float']['output'];
  seats_turnover_percentage_dereg: Scalars['Float']['output'];
  seats_turnover_percentage_reg: Scalars['Float']['output'];
  seats_turnover_plan: Scalars['Float']['output'];
  seats_turnover_plan_dereg: Scalars['Float']['output'];
  seats_turnover_plan_reg: Scalars['Float']['output'];
  trains_quantity_compare: Scalars['Float']['output'];
  trains_quantity_compare_dereg: Scalars['Float']['output'];
  trains_quantity_compare_reg: Scalars['Float']['output'];
  trains_quantity_current: Scalars['Float']['output'];
  trains_quantity_current_dereg: Scalars['Float']['output'];
  trains_quantity_current_reg: Scalars['Float']['output'];
  trains_quantity_percentage: Scalars['Float']['output'];
  trains_quantity_percentage_dereg: Scalars['Float']['output'];
  trains_quantity_percentage_reg: Scalars['Float']['output'];
  trains_quantity_plan: Scalars['Float']['output'];
  trains_quantity_plan_dereg: Scalars['Float']['output'];
  trains_quantity_plan_reg: Scalars['Float']['output'];
  trains_turnover_compare: Scalars['Float']['output'];
  trains_turnover_compare_dereg: Scalars['Float']['output'];
  trains_turnover_compare_reg: Scalars['Float']['output'];
  trains_turnover_current: Scalars['Float']['output'];
  trains_turnover_current_dereg: Scalars['Float']['output'];
  trains_turnover_current_reg: Scalars['Float']['output'];
  trains_turnover_percentage: Scalars['Float']['output'];
  trains_turnover_percentage_dereg: Scalars['Float']['output'];
  trains_turnover_percentage_reg: Scalars['Float']['output'];
  trains_turnover_plan: Scalars['Float']['output'];
  trains_turnover_plan_dereg: Scalars['Float']['output'];
  trains_turnover_plan_reg: Scalars['Float']['output'];
};

export type CapacityDto = {
  __typename: 'CapacityDto';
  /** выгрузка на дату */
  compare: CapacityCompareDto;
  /** актуальная выгрузка */
  current: CapacityCurrentDto;
};

export type CapacityRequestDto = {
  /** год и месяц (ГГГГ-ММ) */
  date: Scalars['String']['input'];
  /** дата сравнения (ГГГГ-ММ-ДД) */
  date_compare: Scalars['String']['input'];
  /** к плану / прошлому году */
  type: Scalars['String']['input'];
};

export type CapacityRowCompareDto = {
  __typename: 'CapacityRowCompareDto';
  /** филиал */
  branch?: Maybe<BranchDto>;
  carriages_quantity_compare: Scalars['Float']['output'];
  carriages_quantity_compare_dereg: Scalars['Float']['output'];
  carriages_quantity_compare_reg: Scalars['Float']['output'];
  carriages_quantity_current: Scalars['Float']['output'];
  carriages_quantity_current_dereg: Scalars['Float']['output'];
  carriages_quantity_current_reg: Scalars['Float']['output'];
  carriages_quantity_tolerance: Scalars['Float']['output'];
  carriages_quantity_tolerance_dereg: Scalars['Float']['output'];
  carriages_quantity_tolerance_reg: Scalars['Float']['output'];
  carriages_turnover_compare: Scalars['Float']['output'];
  carriages_turnover_compare_dereg: Scalars['Float']['output'];
  carriages_turnover_compare_reg: Scalars['Float']['output'];
  carriages_turnover_current: Scalars['Float']['output'];
  carriages_turnover_current_dereg: Scalars['Float']['output'];
  carriages_turnover_current_reg: Scalars['Float']['output'];
  carriages_turnover_tolerance: Scalars['Float']['output'];
  carriages_turnover_tolerance_dereg: Scalars['Float']['output'];
  carriages_turnover_tolerance_reg: Scalars['Float']['output'];
  seats_quantity_compare: Scalars['Float']['output'];
  seats_quantity_compare_dereg: Scalars['Float']['output'];
  seats_quantity_compare_reg: Scalars['Float']['output'];
  seats_quantity_current: Scalars['Float']['output'];
  seats_quantity_current_dereg: Scalars['Float']['output'];
  seats_quantity_current_reg: Scalars['Float']['output'];
  seats_quantity_tolerance: Scalars['Float']['output'];
  seats_quantity_tolerance_dereg: Scalars['Float']['output'];
  seats_quantity_tolerance_reg: Scalars['Float']['output'];
  seats_turnover_compare: Scalars['Float']['output'];
  seats_turnover_compare_dereg: Scalars['Float']['output'];
  seats_turnover_compare_reg: Scalars['Float']['output'];
  seats_turnover_current: Scalars['Float']['output'];
  seats_turnover_current_dereg: Scalars['Float']['output'];
  seats_turnover_current_reg: Scalars['Float']['output'];
  seats_turnover_tolerance: Scalars['Float']['output'];
  seats_turnover_tolerance_dereg: Scalars['Float']['output'];
  seats_turnover_tolerance_reg: Scalars['Float']['output'];
  trains_quantity_compare: Scalars['Float']['output'];
  trains_quantity_compare_dereg: Scalars['Float']['output'];
  trains_quantity_compare_reg: Scalars['Float']['output'];
  trains_quantity_current: Scalars['Float']['output'];
  trains_quantity_current_dereg: Scalars['Float']['output'];
  trains_quantity_current_reg: Scalars['Float']['output'];
  trains_quantity_tolerance: Scalars['Float']['output'];
  trains_quantity_tolerance_dereg: Scalars['Float']['output'];
  trains_quantity_tolerance_reg: Scalars['Float']['output'];
  trains_turnover_compare: Scalars['Float']['output'];
  trains_turnover_compare_dereg: Scalars['Float']['output'];
  trains_turnover_compare_reg: Scalars['Float']['output'];
  trains_turnover_current: Scalars['Float']['output'];
  trains_turnover_current_dereg: Scalars['Float']['output'];
  trains_turnover_current_reg: Scalars['Float']['output'];
  trains_turnover_tolerance: Scalars['Float']['output'];
  trains_turnover_tolerance_dereg: Scalars['Float']['output'];
  trains_turnover_tolerance_reg: Scalars['Float']['output'];
};

export type CapacityRowCurrentDto = {
  __typename: 'CapacityRowCurrentDto';
  /** филиал */
  branch?: Maybe<BranchDto>;
  carriages_quantity_compare: Scalars['Float']['output'];
  carriages_quantity_compare_dereg: Scalars['Float']['output'];
  carriages_quantity_compare_reg: Scalars['Float']['output'];
  carriages_quantity_current: Scalars['Float']['output'];
  carriages_quantity_current_dereg: Scalars['Float']['output'];
  carriages_quantity_current_reg: Scalars['Float']['output'];
  carriages_quantity_percentage: Scalars['Float']['output'];
  carriages_quantity_percentage_dereg: Scalars['Float']['output'];
  carriages_quantity_percentage_reg: Scalars['Float']['output'];
  carriages_quantity_plan: Scalars['Float']['output'];
  carriages_quantity_plan_dereg: Scalars['Float']['output'];
  carriages_quantity_plan_reg: Scalars['Float']['output'];
  carriages_turnover_compare: Scalars['Float']['output'];
  carriages_turnover_compare_dereg: Scalars['Float']['output'];
  carriages_turnover_compare_reg: Scalars['Float']['output'];
  carriages_turnover_current: Scalars['Float']['output'];
  carriages_turnover_current_dereg: Scalars['Float']['output'];
  carriages_turnover_current_reg: Scalars['Float']['output'];
  carriages_turnover_percentage: Scalars['Float']['output'];
  carriages_turnover_percentage_dereg: Scalars['Float']['output'];
  carriages_turnover_percentage_reg: Scalars['Float']['output'];
  carriages_turnover_plan: Scalars['Float']['output'];
  carriages_turnover_plan_dereg: Scalars['Float']['output'];
  carriages_turnover_plan_reg: Scalars['Float']['output'];
  seats_quantity_compare: Scalars['Float']['output'];
  seats_quantity_compare_dereg: Scalars['Float']['output'];
  seats_quantity_compare_reg: Scalars['Float']['output'];
  seats_quantity_current: Scalars['Float']['output'];
  seats_quantity_current_dereg: Scalars['Float']['output'];
  seats_quantity_current_reg: Scalars['Float']['output'];
  seats_quantity_percentage: Scalars['Float']['output'];
  seats_quantity_percentage_dereg: Scalars['Float']['output'];
  seats_quantity_percentage_reg: Scalars['Float']['output'];
  seats_quantity_plan: Scalars['Float']['output'];
  seats_quantity_plan_dereg: Scalars['Float']['output'];
  seats_quantity_plan_reg: Scalars['Float']['output'];
  seats_turnover_compare: Scalars['Float']['output'];
  seats_turnover_compare_dereg: Scalars['Float']['output'];
  seats_turnover_compare_reg: Scalars['Float']['output'];
  seats_turnover_current: Scalars['Float']['output'];
  seats_turnover_current_dereg: Scalars['Float']['output'];
  seats_turnover_current_reg: Scalars['Float']['output'];
  seats_turnover_percentage: Scalars['Float']['output'];
  seats_turnover_percentage_dereg: Scalars['Float']['output'];
  seats_turnover_percentage_reg: Scalars['Float']['output'];
  seats_turnover_plan: Scalars['Float']['output'];
  seats_turnover_plan_dereg: Scalars['Float']['output'];
  seats_turnover_plan_reg: Scalars['Float']['output'];
  trains_quantity_compare: Scalars['Float']['output'];
  trains_quantity_compare_dereg: Scalars['Float']['output'];
  trains_quantity_compare_reg: Scalars['Float']['output'];
  trains_quantity_current: Scalars['Float']['output'];
  trains_quantity_current_dereg: Scalars['Float']['output'];
  trains_quantity_current_reg: Scalars['Float']['output'];
  trains_quantity_percentage: Scalars['Float']['output'];
  trains_quantity_percentage_dereg: Scalars['Float']['output'];
  trains_quantity_percentage_reg: Scalars['Float']['output'];
  trains_quantity_plan: Scalars['Float']['output'];
  trains_quantity_plan_dereg: Scalars['Float']['output'];
  trains_quantity_plan_reg: Scalars['Float']['output'];
  trains_turnover_compare: Scalars['Float']['output'];
  trains_turnover_compare_dereg: Scalars['Float']['output'];
  trains_turnover_compare_reg: Scalars['Float']['output'];
  trains_turnover_current: Scalars['Float']['output'];
  trains_turnover_current_dereg: Scalars['Float']['output'];
  trains_turnover_current_reg: Scalars['Float']['output'];
  trains_turnover_percentage: Scalars['Float']['output'];
  trains_turnover_percentage_dereg: Scalars['Float']['output'];
  trains_turnover_percentage_reg: Scalars['Float']['output'];
  trains_turnover_plan: Scalars['Float']['output'];
  trains_turnover_plan_dereg: Scalars['Float']['output'];
  trains_turnover_plan_reg: Scalars['Float']['output'];
};

export type CarriageAdditionalParameterDto = {
  __typename: 'CarriageAdditionalParameterDto';
  carriage_additional_seats_signs: Array<CarriageAdditionalSeatsSignDto>;
  carriage_seats_allocations: Array<CarriageSeatsAllocationDto>;
  carriage_train_info?: Maybe<CarriageTrainInfoDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Порядковый номер */
  order_number: Scalars['Int']['output'];
  train: TrainDto;
  turnover: TurnoverDto;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageAdditionalSeatSignDto = {
  __typename: 'CarriageAdditionalSeatSignDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  /** Название типа */
  name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageAdditionalSeatSignList = {
  __typename: 'CarriageAdditionalSeatSignList';
  items: Array<CarriageAdditionalSeatSignDto>;
  totalCount: Scalars['Float']['output'];
};

export type CarriageAdditionalSeatSignMutationEntryPoint = {
  __typename: 'CarriageAdditionalSeatSignMutationEntryPoint';
  /** Добавить тип признака мест */
  create: CarriageAdditionalSeatSignDto;
  /** Обновить тип признака мест */
  update: CarriageAdditionalSeatSignDto;
};


export type CarriageAdditionalSeatSignMutationEntryPointCreateArgs = {
  data: CreateCarriageAdditionalSeatSignDto;
};


export type CarriageAdditionalSeatSignMutationEntryPointUpdateArgs = {
  data: UpdateCarriageAdditionalSeatSignDto;
};

export type CarriageAdditionalSeatSignQueryEntryPoint = {
  __typename: 'CarriageAdditionalSeatSignQueryEntryPoint';
  /** Тип признака места по id */
  byEntityId: CarriageAdditionalSeatSignDto;
  /** Список изменений типа признака мест */
  history: CarriageAdditionalSeatSignList;
  /** Список типов признаков мест */
  list: CarriageAdditionalSeatSignList;
};


export type CarriageAdditionalSeatSignQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type CarriageAdditionalSeatSignQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<CarriageAdditionalSeatSignQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type CarriageAdditionalSeatSignQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<CarriageAdditionalSeatSignQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<CarriageAdditionalSeatSignQueryResolver_List_FilterInputType>;
};

export type CarriageAdditionalSeatSignQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageAdditionalSeatSignQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageAdditionalSeatSignQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageAdditionalSeatSignQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageAdditionalSeatSignQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<CarriageAdditionalSeatSignQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageAdditionalSeatSignQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageAdditionalSeatSignQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageAdditionalSeatsSignDto = {
  __typename: 'CarriageAdditionalSeatsSignDto';
  /** Выделенные (зарезервированные) места */
  all_seats: Array<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание в свободной форме */
  description?: Maybe<Scalars['String']['output']>;
  for_whom_additional_seats_sign: CarriageAdditionalSeatSignDto;
  from_station?: Maybe<StationDto>;
  id: Scalars['Int']['output'];
  /** Количество выделенных мест */
  quantity?: Maybe<Scalars['Int']['output']>;
  to_station?: Maybe<StationDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageAllocationDto = {
  __typename: 'CarriageAllocationDto';
  /** Принадлежность */
  appointment: Scalars['String']['output'];
  /** Номер вагона */
  carriage_number: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Места */
  seats: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageClassDto = {
  __typename: 'CarriageClassDto';
  /** Номер вагона */
  carriage_number: Scalars['String']['output'];
  /** Класс */
  class: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Примечание */
  note?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageDto = {
  __typename: 'CarriageDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Вагон заблокирован для изменений */
  is_lock: Scalars['Boolean']['output'];
  item?: Maybe<CarriageUnionDto>;
  /** Вид подвижного состава */
  rolling_stock_type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageGroupCarriageTypeIndicatorsDto = {
  __typename: 'CarriageGroupCarriageTypeIndicatorsDto';
  carriage_type: CarriageTypesForSchemaDto;
  /** Состав по датам */
  carriages_by_date: Array<CarriageGroupCarriagesByDateDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Нормативное количество вагонов */
  fact: Scalars['Float']['output'];
  /** Прогнозное количество вагонов */
  forecast: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageGroupCarriageTypeParamsCountDto = {
  __typename: 'CarriageGroupCarriageTypeParamsCountDto';
  /** Тип вагона */
  carriage_type: Scalars['String']['output'];
  /** Кол-во вагонов */
  quantity: Scalars['Int']['output'];
};

export type CarriageGroupCarriagesByDateDto = {
  __typename: 'CarriageGroupCarriagesByDateDto';
  /** Количество вагонов */
  carriages_quantity: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Дата */
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageGroupCheckCarriagesByDateRequestDto = {
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** С дата */
  date_from: Scalars['String']['input'];
  /** По дата */
  date_to: Scalars['String']['input'];
};

export type CarriageGroupCountDto = {
  __typename: 'CarriageGroupCountDto';
  inner?: Maybe<Array<CarriageGroupInnerCountDto>>;
  item: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
};

export type CarriageGroupDto = {
  __typename: 'CarriageGroupDto';
  branch?: Maybe<BranchDto>;
  carriage_parameters: Array<CarriageParameterDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  decline_history: Array<DeclineHistoryDto>;
  end_at: Scalars['String']['output'];
  gdp: GdpDto;
  gdp_id: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  /** Группа вагнонов заблокирована для изменений */
  is_lock: Scalars['Boolean']['output'];
  /** Ручное формирование маршрута для вывода в схему */
  is_manual_trip_formation_for_schema: Scalars['Boolean']['output'];
  /** Наименование заголовка группы вагонов */
  name: Scalars['String']['output'];
  /** Идентификатор сущности родителя */
  parent_id?: Maybe<Scalars['Int']['output']>;
  passenger_carrier?: Maybe<PassengerCarrierDto>;
  periodicities: Array<PeriodicityDto>;
  railway_administration: RailwayAdministrationDto;
  /** Вид подвижного состава */
  rolling_stock_type: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  /** Статус группы вагонов */
  status: Scalars['String']['output'];
  /** Статус утверждения */
  step_status: Scalars['String']['output'];
  structural_subdivision?: Maybe<CarriageGroupStructuralSubdivisionDto>;
  train_quantities: Array<TrainQuantityDto>;
  turnaround_times: Array<TurnaroundTimeDto>;
  turnovers: Array<TurnoverDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  /** Версия */
  version: Scalars['Int']['output'];
};

export type CarriageGroupIndicatorDto = {
  __typename: 'CarriageGroupIndicatorDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Задан ли средний состав по датам */
  is_calendar_active: Scalars['Boolean']['output'];
  /** Месяц */
  month: Scalars['String']['output'];
  /** Количество отправлений */
  trips_quantity: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageGroupIndicatorResponseDto = {
  __typename: 'CarriageGroupIndicatorResponseDto';
  /** Показатели по типам вагонов */
  carriage_type_indicators: Array<CarriageGroupCarriageTypeIndicatorsDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Даты отправления */
  departure_dates: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Задан ли средний состав по датам */
  is_calendar_active: Scalars['Boolean']['output'];
  /** Месяц */
  month: Scalars['String']['output'];
  /** Количество отправлений */
  trips_quantity: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageGroupIndicatorResponseList = {
  __typename: 'CarriageGroupIndicatorResponseList';
  items: Array<CarriageGroupIndicatorResponseDto>;
  totalCount: Scalars['Float']['output'];
};

export type CarriageGroupIndicatorsByTrainDto = {
  __typename: 'CarriageGroupIndicatorsByTrainDto';
  /** Показатели по поездам */
  items: Array<IndicatorsByTrainSeatsDepartureQuantityDto>;
  /** Потребный парк */
  park_required?: Maybe<Array<ParkRequiredUnionDto>>;
  rolling_stock_type: Scalars['String']['output'];
  /** Схема состава */
  schema?: Maybe<CarriageGroupIndicatorsSchemaDto>;
  /** Показатели по поездам (всего) */
  total: IndicatorsByTrainSeatsDepartureQuantityTotalDto;
};

export type CarriageGroupIndicatorsByTrainRequestDto = {
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Дата с */
  from_date: Scalars['String']['input'];
  /** По прибытию/отправлению */
  is_arrival: Scalars['Boolean']['input'];
  /** Дата по */
  to_date: Scalars['String']['input'];
};

export type CarriageGroupIndicatorsCalculationDto = {
  __typename: 'CarriageGroupIndicatorsCalculationDto';
  carriage_group: CarriageGroupDto;
  /** Маршруты вагонной группы */
  carriage_group_routes: Array<CarriageGroupRouteItemDto>;
  /** Количество типов вагонов */
  carriage_type_params_count: Array<CarriageGroupParkRequiredItem>;
  /** Всего */
  full_distance: Scalars['Float']['output'];
};

export type CarriageGroupIndicatorsFinalCalculationDto = {
  __typename: 'CarriageGroupIndicatorsFinalCalculationDto';
  /** По типу вагонов для схем (строки) */
  items: Array<CarriageGroupIndicatorsFinalCalculationItemDto>;
  /** Потребный парк */
  park_required: IndicatorsFinalCalculationParkRequiredUnionDto;
  /** По типу вагонов для схем (Итоговое количество) */
  total: CarriageGroupIndicatorsFinalCalculationTotalItemDto;
};

export type CarriageGroupIndicatorsFinalCalculationItemDto = {
  __typename: 'CarriageGroupIndicatorsFinalCalculationItemDto';
  /** Средняя вместимость вагона */
  average_capacity?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по потребным схемам по всем вагонам */
  carriage_turnover_req?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по потребным схемам по пассажирским вагонам */
  carriage_turnover_req_passenger?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по нормативным схемам по всем вагонам */
  carriage_turnover_schema?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по нормативным схемам по пассажирским вагонам */
  carriage_turnover_schema_passenger?: Maybe<Scalars['Float']['output']>;
  /** Тип вагона */
  carriage_type: Scalars['String']['output'];
  /** Колличество отправленных вагонов */
  carriages_quantity?: Maybe<Scalars['Float']['output']>;
  /** Количество предложенных в продажу мест */
  seats_for_sale?: Maybe<Scalars['Float']['output']>;
  /** Местооборот по потребным схемам */
  seats_turnover_req?: Maybe<Scalars['Float']['output']>;
  /** Местооборот по нормативным схемам */
  seats_turnover_schema?: Maybe<Scalars['Float']['output']>;
};

export type CarriageGroupIndicatorsFinalCalculationMvpsParkRequiredDto = {
  __typename: 'CarriageGroupIndicatorsFinalCalculationMvpsParkRequiredDto';
  /** Требуемый парк МВПС (строки) */
  items: Array<MvpsParkRequiredDto>;
  /** Итоговое количество */
  total: Scalars['Float']['output'];
};

export type CarriageGroupIndicatorsFinalCalculationNpsParkRequiredDto = {
  __typename: 'CarriageGroupIndicatorsFinalCalculationNpsParkRequiredDto';
  /** Требуемый парк НПС прочие */
  other: Array<IndicatorsByTrainCarriagesDto>;
  /** Требуемый парк НПС для перевозки пасс. */
  passenger: Array<IndicatorsByTrainCarriagesDto>;
  /** Итоговое количество */
  total: Scalars['Float']['output'];
  /** Итоговое количество прочие */
  total_other: Scalars['Float']['output'];
  /** Итоговое количество для перевозки пасс. */
  total_passenger: Scalars['Float']['output'];
};

export type CarriageGroupIndicatorsFinalCalculationRequestDto = {
  from_date: Scalars['String']['input'];
  to_date: Scalars['String']['input'];
};

export type CarriageGroupIndicatorsFinalCalculationTotalItemDto = {
  __typename: 'CarriageGroupIndicatorsFinalCalculationTotalItemDto';
  /** Средняя вместимость вагона */
  average_capacity?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по потребным схемам по всем вагонам */
  carriage_turnover_req?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по потребным схемам по пассажирским вагонам */
  carriage_turnover_req_passenger?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по нормативным схемам по всем вагонам */
  carriage_turnover_schema?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по нормативным схемам по пассажирским вагонам */
  carriage_turnover_schema_passenger?: Maybe<Scalars['Float']['output']>;
  /** Колличество отправленных вагонов */
  carriages_quantity?: Maybe<Scalars['Float']['output']>;
  /** Количество предложенных в продажу мест */
  seats_for_sale?: Maybe<Scalars['Float']['output']>;
  /** Местооборот по потребным схемам */
  seats_turnover_req?: Maybe<Scalars['Float']['output']>;
  /** Местооборот по нормативным схемам */
  seats_turnover_schema?: Maybe<Scalars['Float']['output']>;
};

export type CarriageGroupIndicatorsSchemaDto = {
  __typename: 'CarriageGroupIndicatorsSchemaDto';
  /** Средняя вместимость вагона всео пасс. */
  average_capacity_passenger: Scalars['Float']['output'];
  /** Средняя вместимость вагона всего */
  average_capacity_total?: Maybe<Scalars['Float']['output']>;
  /** Кол-во вагонов всего пасс. */
  carriage_quantity_passenger: Scalars['Float']['output'];
  /** Кол-во вагонов (треб.) всего пасс. */
  carriage_quantity_req_passenger: Scalars['Float']['output'];
  /** Кол-во вагонов (треб.) всего */
  carriage_quantity_req_total: Scalars['Float']['output'];
  /** Кол-во вагонов всего */
  carriage_quantity_total: Scalars['Float']['output'];
  /** Схема состава (строки) */
  items: Array<CarriageGroupIndicatorsSchemaItemDto>;
  /** Кол-во мест в продаже всего пасс. */
  seats_for_sale_passenger: Scalars['Float']['output'];
  /** Кол-во мест в продаже всего */
  seats_for_sale_total?: Maybe<Scalars['Float']['output']>;
  /** Кол-во мест всего пасс. */
  seats_quantity_passenger: Scalars['Float']['output'];
  /** Кол-во мест всего */
  seats_quantity_total?: Maybe<Scalars['Float']['output']>;
};

export type CarriageGroupIndicatorsSchemaItemDto = {
  __typename: 'CarriageGroupIndicatorsSchemaItemDto';
  /** Средняя вместимость вагона (схема) */
  average_capacity: Scalars['Float']['output'];
  /** Кол-во вагонов (схема) */
  carriage_quantity: Scalars['Float']['output'];
  /** Кол-во вагонов (треб.) */
  carriage_quantity_req: Scalars['Float']['output'];
  carriage_type: Scalars['String']['output'];
  seat_type: Scalars['String']['output'];
  /** Кол-во мест в продаже (схема) */
  seats_for_sale: Scalars['Float']['output'];
  /** Кол-во мест всего (схема) */
  seats_quantity: Scalars['Float']['output'];
};

export type CarriageGroupIndicatorsTypeParamsCountDto = {
  __typename: 'CarriageGroupIndicatorsTypeParamsCountDto';
  /** Классы вагонов */
  carriage_classes: Array<Scalars['String']['output']>;
  /** Тип вагона */
  carriage_type: Scalars['String']['output'];
  /** Кол-во вагонов */
  quantity: Scalars['Float']['output'];
  /** Кол-во мест */
  seats_quantity: Scalars['Float']['output'];
};

export type CarriageGroupInnerCountDto = {
  __typename: 'CarriageGroupInnerCountDto';
  item: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
};

export type CarriageGroupList = {
  __typename: 'CarriageGroupList';
  items: Array<CarriageGroupViewDto>;
  totalCount: Scalars['Float']['output'];
};

export type CarriageGroupMutationEntryPoint = {
  __typename: 'CarriageGroupMutationEntryPoint';
  /** создание вагона мвпс */
  addCarriageMvps: Scalars['Boolean']['output'];
  /** создание вагона нпс */
  addCarriageNps?: Maybe<Scalars['Float']['output']>;
  /** добавление периодичности в группу вагонов */
  addPeriodicity: Scalars['Int']['output'];
  /** добавление оборотки в группу вагонов */
  addTurnover: Scalars['Int']['output'];
  /** добавление признака перестоя в оборотку группы вагонов */
  addTurnoverTimeStagnation: Scalars['Boolean']['output'];
  /** Копирование ГВ */
  copy?: Maybe<Scalars['Float']['output']>;
  /** Дублировать вагон */
  copyCarriage: Scalars['Boolean']['output'];
  /** создание группы вагонов */
  createCarriageGroup: Scalars['Float']['output'];
  /** создание пбг */
  createTrailedDirectGroup: Scalars['Float']['output'];
  /** удаление группы вагонов */
  deleteCarriageGroup?: Maybe<Scalars['Boolean']['output']>;
  /** обновление дополнительных инфо параметров */
  deleteCarriageParameters?: Maybe<Scalars['Boolean']['output']>;
  /** удаление периодичности из группы вагонов */
  deletePeriodicity?: Maybe<Scalars['Boolean']['output']>;
  /** удаление пбг */
  deleteTrailedDirectGroup?: Maybe<Scalars['Void']['output']>;
  /** удаление оборотки из группы вагонов */
  deleteTurnover?: Maybe<Scalars['Boolean']['output']>;
  /** удаление периодичности из группы вагонов */
  deleteTurnoverTimeStagnation?: Maybe<Scalars['Boolean']['output']>;
  /** экспорт группы вагонов в схемы */
  exportCarriageGroupToSchemas?: Maybe<Scalars['Void']['output']>;
  /** вывод в эксель списка группы вагонов */
  exportCarriageGroupsList?: Maybe<Scalars['Void']['output']>;
  /** вывод в эксель списка ПБГ */
  exportTrailedDirectGroupsList?: Maybe<Scalars['Void']['output']>;
  revokeCarriageGroup?: Maybe<Scalars['Boolean']['output']>;
  updateAllCarriageGroupIndicators?: Maybe<Scalars['Void']['output']>;
  /** обновление дополнительных инфо параметров */
  updateCarriageAdditionalInfoParameters?: Maybe<Scalars['Boolean']['output']>;
  /** обновление статуса группы вагонов */
  updateCarriageGroup?: Maybe<Scalars['Boolean']['output']>;
  /** обновление вагона мвпс */
  updateCarriageMvps?: Maybe<Scalars['Boolean']['output']>;
  /** обновление вагона нпс */
  updateCarriageNps?: Maybe<Scalars['Boolean']['output']>;
  /** обновление периодичности в группе вагонов */
  updatePeriodicity?: Maybe<Scalars['Boolean']['output']>;
  /** обновление оборотки в группе вагонов */
  updateTurnover?: Maybe<Scalars['Boolean']['output']>;
  /** обновление признака перестоя в оборотку группы вагонов */
  updateTurnoverTimeStagnation?: Maybe<Scalars['Boolean']['output']>;
};


export type CarriageGroupMutationEntryPointAddCarriageMvpsArgs = {
  data: CreateCarriageMvpsDto;
};


export type CarriageGroupMutationEntryPointAddCarriageNpsArgs = {
  data: CreateCarriageNpsDto;
};


export type CarriageGroupMutationEntryPointAddPeriodicityArgs = {
  data: CreatePeriodicityDto;
};


export type CarriageGroupMutationEntryPointAddTurnoverArgs = {
  data: CreateTurnoverDto;
};


export type CarriageGroupMutationEntryPointAddTurnoverTimeStagnationArgs = {
  data: CreateTurnoverTimeStagnationDto;
};


export type CarriageGroupMutationEntryPointCopyArgs = {
  id: Scalars['Float']['input'];
};


export type CarriageGroupMutationEntryPointCopyCarriageArgs = {
  data: CopyCarriageParameterDto;
};


export type CarriageGroupMutationEntryPointCreateCarriageGroupArgs = {
  data: CreateCarriageGroupDto;
};


export type CarriageGroupMutationEntryPointCreateTrailedDirectGroupArgs = {
  data: CreateTrailedDirectGroupDto;
};


export type CarriageGroupMutationEntryPointDeleteCarriageGroupArgs = {
  id: Scalars['Float']['input'];
};


export type CarriageGroupMutationEntryPointDeleteCarriageParametersArgs = {
  data: DeleteCarriageParameter;
};


export type CarriageGroupMutationEntryPointDeletePeriodicityArgs = {
  data: DeletePeriodicityDto;
};


export type CarriageGroupMutationEntryPointDeleteTrailedDirectGroupArgs = {
  id: Scalars['Float']['input'];
};


export type CarriageGroupMutationEntryPointDeleteTurnoverArgs = {
  data: DeleteTurnoverDto;
};


export type CarriageGroupMutationEntryPointDeleteTurnoverTimeStagnationArgs = {
  data: DeleteTurnoverTimeStagnationDto;
};


export type CarriageGroupMutationEntryPointExportCarriageGroupToSchemasArgs = {
  data: ExportCarriageGroupDto;
};


export type CarriageGroupMutationEntryPointExportCarriageGroupsListArgs = {
  where?: InputMaybe<CarriageGroupMutationResolver_ExportCarriageGroupsList_FilterInputType>;
};


export type CarriageGroupMutationEntryPointExportTrailedDirectGroupsListArgs = {
  where?: InputMaybe<CarriageGroupMutationResolver_ExportTrailedDirectGroupsList_FilterInputType>;
};


export type CarriageGroupMutationEntryPointRevokeCarriageGroupArgs = {
  id: Scalars['Float']['input'];
};


export type CarriageGroupMutationEntryPointUpdateCarriageAdditionalInfoParametersArgs = {
  data: UpdateAllCarriageParametersDto;
};


export type CarriageGroupMutationEntryPointUpdateCarriageGroupArgs = {
  data: UpdateCarriageGroupDto;
};


export type CarriageGroupMutationEntryPointUpdateCarriageMvpsArgs = {
  data: UpdateCarriageMvpsDto;
};


export type CarriageGroupMutationEntryPointUpdateCarriageNpsArgs = {
  data: UpdateCarriageNpsDto;
};


export type CarriageGroupMutationEntryPointUpdatePeriodicityArgs = {
  data: UpdatePeriodicityDto;
};


export type CarriageGroupMutationEntryPointUpdateTurnoverArgs = {
  data: UpdateTurnoverDto;
};


export type CarriageGroupMutationEntryPointUpdateTurnoverTimeStagnationArgs = {
  data: UpdateTurnoverTimeStagnationDto;
};

export type CarriageGroupMutationResolver_ExportCarriageGroupsList_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageGroupMutationResolver_ExportCarriageGroupsList_BaseFilterInputType>>;
  branch?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_types?: InputMaybe<String_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  first_departure_date?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  min_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  min_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageGroupMutationResolver_ExportCarriageGroupsList_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier?: InputMaybe<String_PropertyFilterInputType>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  station_affiliation?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  train_statuses?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageGroupMutationResolver_ExportCarriageGroupsList_FilterInputType = {
  and?: InputMaybe<Array<CarriageGroupMutationResolver_ExportCarriageGroupsList_BaseFilterInputType>>;
  branch?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_types?: InputMaybe<String_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  first_departure_date?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  min_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  min_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageGroupMutationResolver_ExportCarriageGroupsList_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier?: InputMaybe<String_PropertyFilterInputType>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  station_affiliation?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  train_statuses?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageGroupMutationResolver_ExportTrailedDirectGroupsList_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageGroupMutationResolver_ExportTrailedDirectGroupsList_BaseFilterInputType>>;
  branch?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_types?: InputMaybe<String_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  first_departure_date?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  min_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  min_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageGroupMutationResolver_ExportTrailedDirectGroupsList_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier?: InputMaybe<String_PropertyFilterInputType>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  station_affiliation?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  train_statuses?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageGroupMutationResolver_ExportTrailedDirectGroupsList_FilterInputType = {
  and?: InputMaybe<Array<CarriageGroupMutationResolver_ExportTrailedDirectGroupsList_BaseFilterInputType>>;
  branch?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_types?: InputMaybe<String_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  first_departure_date?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  min_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  min_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageGroupMutationResolver_ExportTrailedDirectGroupsList_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier?: InputMaybe<String_PropertyFilterInputType>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  station_affiliation?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  train_statuses?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageGroupParkRequiredItem = {
  __typename: 'CarriageGroupParkRequiredItem';
  /** Тип вагона */
  carriage_type: Scalars['String']['output'];
  /** Кол-во вагонов */
  quantity: Scalars['Float']['output'];
};

export type CarriageGroupParkRequiredItemDto = {
  __typename: 'CarriageGroupParkRequiredItemDto';
  branch: Scalars['String']['output'];
  item: Array<CarriageGroupParkRequiredItem>;
  total: Scalars['Float']['output'];
};

export type CarriageGroupParkRequiredResponseDto = {
  __typename: 'CarriageGroupParkRequiredResponseDto';
  park: Array<CarriageGroupParkRequiredItemDto>;
  parkTotal: CarriageGroupParkRequiredItemDto;
  schema: Array<CarriageGroupParkRequiredItemDto>;
  schemaTotal: CarriageGroupParkRequiredItemDto;
};

export type CarriageGroupQueryEntryPoint = {
  __typename: 'CarriageGroupQueryEntryPoint';
  /** Найти группу вагонов по id */
  carriageGroupById: CarriageGroupDto;
  /** Список групп вагонов */
  carriageGroupList: CarriageGroupList;
  /** Проверка ГВ на валидность номеров вагонов для экспорта */
  checkCarriageGroupCarriageNumbers: CheckCarriageGroupCarriageNumbersDto;
  /** Количество гв для дашборда */
  getCarriageGroupFormationTurnoverListInfo: Scalars['Boolean']['output'];
  /** получить данные для графиков обороток */
  getCarriageGroupTurnoverChart: TurnoverChartDto;
  /** Количество гв для дашборда */
  getCount: Array<CarriageGroupCountDto>;
  /** получить даты для добавления перестоя */
  getDatesDataToAddTimeStagnation: TurnoverAddTimeStagnationDatesInfoDto;
  /** получить даты для обновления перестоя */
  getDatesDataToUpdateTimeStagnation: TurnoverUpdateTimeStagnationDatesInfoDto;
  /** Список станций отправления поезда для добавления в оборотку */
  getTurnoverFromStationList: GetTurnoverFromStationListResponseDto;
  /** Список станций прибытия поезда для добавления в оборотку */
  getTurnoverToStationList: GetTurnoverToStationListResponseDto;
  /** найти ПБГ по id */
  trailedDirectGroupById: TrailedDirectGroupResponseDto;
  /** список ПБГ */
  trailedDirectGroupList: TrailedDirectGroupResponseList;
};


export type CarriageGroupQueryEntryPointCarriageGroupByIdArgs = {
  id: Scalars['Float']['input'];
};


export type CarriageGroupQueryEntryPointCarriageGroupListArgs = {
  order_by?: InputMaybe<Array<CarriageGroupQueryResolver_CarriageGroupList_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  search: Scalars['String']['input'];
  where?: InputMaybe<CarriageGroupQueryResolver_CarriageGroupList_FilterInputType>;
};


export type CarriageGroupQueryEntryPointCheckCarriageGroupCarriageNumbersArgs = {
  id: Scalars['Float']['input'];
};


export type CarriageGroupQueryEntryPointGetCarriageGroupFormationTurnoverListInfoArgs = {
  gdp_id: Scalars['Float']['input'];
};


export type CarriageGroupQueryEntryPointGetCarriageGroupTurnoverChartArgs = {
  data: GetTurnoverChartDto;
};


export type CarriageGroupQueryEntryPointGetCountArgs = {
  group_by: Scalars['String']['input'];
  where?: InputMaybe<CarriageGroupQueryResolver_GetCount_FilterInputType>;
};


export type CarriageGroupQueryEntryPointGetDatesDataToAddTimeStagnationArgs = {
  id: Scalars['Float']['input'];
};


export type CarriageGroupQueryEntryPointGetDatesDataToUpdateTimeStagnationArgs = {
  data: TurnoverUpdateTimeStagnationDatesInfoReqDto;
};


export type CarriageGroupQueryEntryPointGetTurnoverFromStationListArgs = {
  data: GetTurnoverFromStationListRequestDto;
};


export type CarriageGroupQueryEntryPointGetTurnoverToStationListArgs = {
  data: GetTurnoverToStationListRequestDto;
};


export type CarriageGroupQueryEntryPointTrailedDirectGroupByIdArgs = {
  id: Scalars['Float']['input'];
};


export type CarriageGroupQueryEntryPointTrailedDirectGroupListArgs = {
  order_by?: InputMaybe<Array<CarriageGroupQueryResolver_TrailedDirectGroupList_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  search: Scalars['String']['input'];
  where?: InputMaybe<CarriageGroupQueryResolver_TrailedDirectGroupList_FilterInputType>;
};

export type CarriageGroupQueryResolver_CarriageGroupList_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageGroupQueryResolver_CarriageGroupList_BaseFilterInputType>>;
  branch?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_types?: InputMaybe<String_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  first_departure_date?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  min_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  min_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageGroupQueryResolver_CarriageGroupList_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier?: InputMaybe<String_PropertyFilterInputType>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  station_affiliation?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  train_statuses?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageGroupQueryResolver_CarriageGroupList_FilterInputType = {
  and?: InputMaybe<Array<CarriageGroupQueryResolver_CarriageGroupList_BaseFilterInputType>>;
  branch?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_types?: InputMaybe<String_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  first_departure_date?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  min_train_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  min_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageGroupQueryResolver_CarriageGroupList_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier?: InputMaybe<String_PropertyFilterInputType>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  station_affiliation?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  train_statuses?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageGroupQueryResolver_CarriageGroupList_SortingInputType = {
  branch?: InputMaybe<SortType>;
  branch_id?: InputMaybe<SortType>;
  carriage_dimension_ids?: InputMaybe<SortType>;
  carriage_types?: InputMaybe<SortType>;
  dimensions?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  first_departure_date?: InputMaybe<SortType>;
  from_stations?: InputMaybe<SortType>;
  from_stations_for_schema?: InputMaybe<SortType>;
  gdp_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  max_train_quantity?: InputMaybe<SortType>;
  max_turnaround_time?: InputMaybe<SortType>;
  min_train_quantity?: InputMaybe<SortType>;
  min_turnaround_time?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  parent_id?: InputMaybe<SortType>;
  passenger_carrier?: InputMaybe<SortType>;
  passenger_carriers_id?: InputMaybe<SortType>;
  periodicity?: InputMaybe<SortType>;
  railway_administration?: InputMaybe<SortType>;
  railway_administration_id?: InputMaybe<SortType>;
  rolling_stock_type?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  station_affiliation?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
  step_status?: InputMaybe<SortType>;
  structural_subdivision?: InputMaybe<SortType>;
  structural_subdivision_id?: InputMaybe<SortType>;
  to_stations?: InputMaybe<SortType>;
  to_stations_for_schema?: InputMaybe<SortType>;
  train_ids?: InputMaybe<SortType>;
  train_numbers?: InputMaybe<SortType>;
  train_statuses?: InputMaybe<SortType>;
  version?: InputMaybe<SortType>;
};

export type CarriageGroupQueryResolver_GetCount_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageGroupQueryResolver_GetCount_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Number_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_manual_trip_formation_for_schema?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageGroupQueryResolver_GetCount_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageGroupQueryResolver_GetCount_FilterInputType = {
  and?: InputMaybe<Array<CarriageGroupQueryResolver_GetCount_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Number_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_manual_trip_formation_for_schema?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageGroupQueryResolver_GetCount_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageGroupQueryResolver_TrailedDirectGroupList_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageGroupQueryResolver_TrailedDirectGroupList_BaseFilterInputType>>;
  branch_id?: InputMaybe<Number_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageGroupQueryResolver_TrailedDirectGroupList_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Number_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Number_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Number_PropertyFilterInputType>;
};

export type CarriageGroupQueryResolver_TrailedDirectGroupList_FilterInputType = {
  and?: InputMaybe<Array<CarriageGroupQueryResolver_TrailedDirectGroupList_BaseFilterInputType>>;
  branch_id?: InputMaybe<Number_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageGroupQueryResolver_TrailedDirectGroupList_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Number_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Number_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Number_PropertyFilterInputType>;
};

export type CarriageGroupQueryResolver_TrailedDirectGroupList_SortingInputType = {
  carriages_total?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  parent_id?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageGroupRouteItemDto = {
  __typename: 'CarriageGroupRouteItemDto';
  /** Расстояние для поезда */
  distance: Scalars['Float']['output'];
  /** Маршрут № */
  route: Scalars['String']['output'];
  /** Расстояние для маршрута */
  route_distance: Scalars['Float']['output'];
  /** Признак группы */
  sign: Scalars['String']['output'];
  station_carriage_group_from: StationDto;
  station_carriage_group_to: StationDto;
  station_train_from: StationDto;
  station_train_to: StationDto;
  /** Номер поезда */
  train_number: Scalars['String']['output'];
};

export type CarriageGroupStructuralSubdivisionDto = MvpsCompanyAffiliationDto | StructuralSubdivisionDto;

export type CarriageGroupTurnoverChartDataDto = {
  __typename: 'CarriageGroupTurnoverChartDataDto';
  /** Номер состава */
  category: Scalars['String']['output'];
  /** Дата отправления */
  from_date: Scalars['String']['output'];
  /** Является ли данная станция пунктом формирования */
  is_formation_point: Scalars['Boolean']['output'];
  /** Является ли данная станция пунктом оборота */
  is_turnover_point: Scalars['Boolean']['output'];
  /** Наименование станции */
  station?: Maybe<Scalars['String']['output']>;
  /** Дата прибытия */
  to_date: Scalars['String']['output'];
  /** Станция отправления поезда */
  train_from_station: Scalars['String']['output'];
  /** Номер поезда */
  train_number: Scalars['String']['output'];
  /** Станция прибытия поезда */
  train_to_station: Scalars['String']['output'];
  /** Время в пути в секундах */
  trip_time: Scalars['Int']['output'];
  /** Станция отправления из оборота ГВ */
  turnover_from_station: Scalars['String']['output'];
  /** Станция прибытия из оборота ГВ */
  turnover_to_station: Scalars['String']['output'];
};

export type CarriageGroupTurnoverChartTrainInfoDto = {
  __typename: 'CarriageGroupTurnoverChartTrainInfoDto';
  /** Филиал */
  branch: Scalars['String']['output'];
  /** Полный путь группы */
  name: Scalars['String']['output'];
  /** Перевозчик */
  passenger_carriers: Scalars['String']['output'];
  /** ЖД администрация */
  railway_administration: Scalars['String']['output'];
  /** Тип подвижного состава */
  rolling_stock_type: Scalars['String']['output'];
  /** Структурное подразделение */
  structural_subdivision: Scalars['String']['output'];
  /** Количество составов */
  train_quantity: Scalars['String']['output'];
  /** Время оборота в минутах */
  turnover_time: Scalars['String']['output'];
};

export type CarriageGroupViewDto = {
  __typename: 'CarriageGroupViewDto';
  branch?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  carriage_dimension_ids?: Maybe<Array<Scalars['Int']['output']>>;
  carriage_types?: Maybe<Array<Scalars['String']['output']>>;
  dimensions?: Maybe<Scalars['String']['output']>;
  /** Дата окончания действия ГВ */
  end_at: Scalars['String']['output'];
  /** Первая дата отправления */
  first_departure_date?: Maybe<Scalars['String']['output']>;
  from_stations?: Maybe<Array<Scalars['String']['output']>>;
  from_stations_for_schema?: Maybe<Array<Scalars['String']['output']>>;
  gdp_id: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  max_train_quantity?: Maybe<Scalars['Float']['output']>;
  max_turnaround_time?: Maybe<Scalars['Float']['output']>;
  min_train_quantity?: Maybe<Scalars['Float']['output']>;
  min_turnaround_time?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<CarriageGroupViewDto>;
  /** Идентификатор ГВ от которой создана данная ГВ */
  parent_id?: Maybe<Scalars['Int']['output']>;
  passenger_carrier?: Maybe<Scalars['String']['output']>;
  passenger_carriers_id?: Maybe<Scalars['Int']['output']>;
  periodicity?: Maybe<Array<Scalars['String']['output']>>;
  railway_administration?: Maybe<Scalars['String']['output']>;
  railway_administration_id?: Maybe<Scalars['Int']['output']>;
  rolling_stock_type?: Maybe<Scalars['String']['output']>;
  /** Дата начала действия ГВ */
  start_at: Scalars['String']['output'];
  /** Станция приписки */
  station_affiliation?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  step_status?: Maybe<Scalars['String']['output']>;
  structural_subdivision?: Maybe<Scalars['String']['output']>;
  structural_subdivision_id?: Maybe<Scalars['Int']['output']>;
  to_stations?: Maybe<Array<Scalars['String']['output']>>;
  to_stations_for_schema?: Maybe<Array<Scalars['String']['output']>>;
  train_ids?: Maybe<Array<Scalars['Int']['output']>>;
  train_numbers?: Maybe<Array<Scalars['String']['output']>>;
  train_statuses?: Maybe<Array<Scalars['String']['output']>>;
  /** Версия */
  version: Scalars['Int']['output'];
};

export type CarriageLocationDto = {
  __typename: 'CarriageLocationDto';
  /** Арендодатель */
  application_lessor_id: Scalars['Int']['output'];
  /** Собственник */
  application_owner_id: Scalars['Int']['output'];
  /** Предприятие приписки */
  application_structural_subdivision_id: Scalars['Int']['output'];
  /** Предприятие управл. */
  application_structural_subdivision_upr_id: Scalars['Int']['output'];
  /** Арендатор */
  application_tenant_id: Scalars['Int']['output'];
  /** Тип вагона */
  carriage_type_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Дата, время прибытия */
  dislocation_arrival_date: Scalars['String']['output'];
  /** Вагон */
  dislocation_carriage_number: Scalars['String']['output'];
  /** Дата, время прицепки */
  dislocation_date_hitching: Scalars['String']['output'];
  /** Дата и время последней операции ГУ-2б по АСОУП */
  dislocation_date_last_operation_GU26: Scalars['String']['output'];
  /** Дата и время последней операции ГУ-45 по АСОУП */
  dislocation_date_last_operation_GU45: Scalars['String']['output'];
  /** Послед. ст. проследования/прибытия */
  dislocation_last_station_id: Scalars['Int']['output'];
  /** Станция отправления */
  dislocation_station_from_id: Scalars['Int']['output'];
  /** Станция прицепки */
  dislocation_station_hitching_id: Scalars['Int']['output'];
  /** Станция назначения */
  dislocation_station_to_id: Scalars['Int']['output'];
  /** Индекс поезда (с АСОУП) */
  dislocation_train_index: Scalars['Int']['output'];
  /** № поезда */
  dislocation_train_number: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Тип вагона */
  state_of_use_carriage_id: Scalars['Int']['output'];
  /** № вагона */
  train_number: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  /** Операция с вагоном по данным АСОУП на 6.00 */
  use_carriage_operation_ACOY: Scalars['String']['output'];
  /** Вагон находится */
  use_carriage_status: Scalars['Int']['output'];
  /** ПО */
  use_end_date: Scalars['String']['output'];
  /** ислокация вагона по данным АСОУ (дорога) */
  use_location_ACOY_railway_id: Scalars['Int']['output'];
  /** Дислокация вагона по данным АСОУ (станц.) */
  use_location_ACOY_station_id: Scalars['Int']['output'];
  /** Местонахождение */
  use_location_id: Scalars['Int']['output'];
  /** С */
  use_start_date: Scalars['String']['output'];
};

export type CarriageLocationListDto = {
  __typename: 'CarriageLocationListDto';
  items: Array<CarriageLocationDto>;
  totalCount: Scalars['Float']['output'];
};

export type CarriageLocationQueryEntryPoint = {
  __typename: 'CarriageLocationQueryEntryPoint';
  /** Местоположение вагонов */
  list: CarriageLocationListDto;
};


export type CarriageLocationQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<CarriageLocationQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<CarriageLocationQueryResolver_List_FilterInputType>;
};

export type CarriageLocationQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageLocationQueryResolver_List_BaseFilterInputType>>;
  application_lessor_id?: InputMaybe<Int_PropertyFilterInputType>;
  application_owner_id?: InputMaybe<Int_PropertyFilterInputType>;
  application_structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  application_structural_subdivision_upr_id?: InputMaybe<Int_PropertyFilterInputType>;
  application_tenant_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_arrival_date?: InputMaybe<String_PropertyFilterInputType>;
  dislocation_carriage_number?: InputMaybe<String_PropertyFilterInputType>;
  dislocation_date_hitching?: InputMaybe<String_PropertyFilterInputType>;
  dislocation_date_last_operation_GU26?: InputMaybe<String_PropertyFilterInputType>;
  dislocation_date_last_operation_GU45?: InputMaybe<String_PropertyFilterInputType>;
  dislocation_last_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_station_from_id?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_station_hitching_id?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_station_to_id?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_train_index?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_train_number?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageLocationQueryResolver_List_BaseFilterInputType>>;
  state_of_use_carriage_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  use_carriage_operation_ACOY?: InputMaybe<String_PropertyFilterInputType>;
  use_carriage_status?: InputMaybe<Int_PropertyFilterInputType>;
  use_end_date?: InputMaybe<String_PropertyFilterInputType>;
  use_location_ACOY_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  use_location_ACOY_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  use_location_id?: InputMaybe<Int_PropertyFilterInputType>;
  use_start_date?: InputMaybe<String_PropertyFilterInputType>;
};

export type CarriageLocationQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<CarriageLocationQueryResolver_List_BaseFilterInputType>>;
  application_lessor_id?: InputMaybe<Int_PropertyFilterInputType>;
  application_owner_id?: InputMaybe<Int_PropertyFilterInputType>;
  application_structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  application_structural_subdivision_upr_id?: InputMaybe<Int_PropertyFilterInputType>;
  application_tenant_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_arrival_date?: InputMaybe<String_PropertyFilterInputType>;
  dislocation_carriage_number?: InputMaybe<String_PropertyFilterInputType>;
  dislocation_date_hitching?: InputMaybe<String_PropertyFilterInputType>;
  dislocation_date_last_operation_GU26?: InputMaybe<String_PropertyFilterInputType>;
  dislocation_date_last_operation_GU45?: InputMaybe<String_PropertyFilterInputType>;
  dislocation_last_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_station_from_id?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_station_hitching_id?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_station_to_id?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_train_index?: InputMaybe<Int_PropertyFilterInputType>;
  dislocation_train_number?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageLocationQueryResolver_List_BaseFilterInputType>>;
  state_of_use_carriage_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  use_carriage_operation_ACOY?: InputMaybe<String_PropertyFilterInputType>;
  use_carriage_status?: InputMaybe<Int_PropertyFilterInputType>;
  use_end_date?: InputMaybe<String_PropertyFilterInputType>;
  use_location_ACOY_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  use_location_ACOY_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  use_location_id?: InputMaybe<Int_PropertyFilterInputType>;
  use_start_date?: InputMaybe<String_PropertyFilterInputType>;
};

export type CarriageLocationQueryResolver_List_SortingInputType = {
  application_lessor_id?: InputMaybe<SortType>;
  application_owner_id?: InputMaybe<SortType>;
  application_structural_subdivision_id?: InputMaybe<SortType>;
  application_structural_subdivision_upr_id?: InputMaybe<SortType>;
  application_tenant_id?: InputMaybe<SortType>;
  carriage_type_id?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  dislocation_arrival_date?: InputMaybe<SortType>;
  dislocation_carriage_number?: InputMaybe<SortType>;
  dislocation_date_hitching?: InputMaybe<SortType>;
  dislocation_date_last_operation_GU26?: InputMaybe<SortType>;
  dislocation_date_last_operation_GU45?: InputMaybe<SortType>;
  dislocation_last_station_id?: InputMaybe<SortType>;
  dislocation_station_from_id?: InputMaybe<SortType>;
  dislocation_station_hitching_id?: InputMaybe<SortType>;
  dislocation_station_to_id?: InputMaybe<SortType>;
  dislocation_train_index?: InputMaybe<SortType>;
  dislocation_train_number?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  state_of_use_carriage_id?: InputMaybe<SortType>;
  train_number?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  use_carriage_operation_ACOY?: InputMaybe<SortType>;
  use_carriage_status?: InputMaybe<SortType>;
  use_end_date?: InputMaybe<SortType>;
  use_location_ACOY_railway_id?: InputMaybe<SortType>;
  use_location_ACOY_station_id?: InputMaybe<SortType>;
  use_location_id?: InputMaybe<SortType>;
  use_start_date?: InputMaybe<SortType>;
};

export type CarriageMvpsDto = {
  __typename: 'CarriageMvpsDto';
  branch?: Maybe<BranchDto>;
  carriage_type?: Maybe<CarriageTypeDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Признак блокировки записи */
  is_lock: Scalars['Boolean']['output'];
  /** Длина состава в миллиметрах */
  lineup_length?: Maybe<Scalars['Float']['output']>;
  mvps_martin_section_type?: Maybe<MvpsMartinSectionTypeDto>;
  passenger_carriers?: Maybe<PassengerCarrierDto>;
  railway_administration?: Maybe<RailwayAdministrationDto>;
  /** Количество мест в вагоне */
  seats_quantity: Scalars['Int']['output'];
  start_at: Scalars['String']['output'];
  structural_subdivision?: Maybe<StructuralSubdivisionDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageNpsDto = {
  __typename: 'CarriageNpsDto';
  carriage_brake_type?: Maybe<NpsCarriageBrakeTypeDto>;
  carriage_dimension?: Maybe<NpsCarriageDimensionDto>;
  carriage_heat_type?: Maybe<NpsCarriageHeatTypeDto>;
  carriage_length?: Maybe<NpsCarriageLengthDto>;
  carriage_model?: Maybe<NpsCarriageModelDto>;
  carriage_type?: Maybe<CarriageTypeDto>;
  carriage_type_asu?: Maybe<CarriageTypeAsuDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Признак наличия кондиционера */
  is_air_conditioner: Scalars['Boolean']['output'];
  /** Признак наличия централизованного электропитания */
  is_centralized_power_supply: Scalars['Boolean']['output'];
  /** Признак наличия ЭЧТК */
  is_eco_toilets: Scalars['Boolean']['output'];
  /** Признак блокировки записи */
  is_lock: Scalars['Boolean']['output'];
  /** Количество мест в вагоне */
  seats_quantity: Scalars['Int']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageNumerationDto = {
  __typename: 'CarriageNumerationDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  direct_from_station?: Maybe<StationDto>;
  /** Позиция для прямого поезда */
  direct_position?: Maybe<Scalars['String']['output']>;
  direct_to_station?: Maybe<StationDto>;
  id: Scalars['Int']['output'];
  reverse_from_station?: Maybe<StationDto>;
  /** Позиция для обратного поезда */
  reverse_position?: Maybe<Scalars['String']['output']>;
  reverse_to_station?: Maybe<StationDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageParameterDto = {
  __typename: 'CarriageParameterDto';
  carriage?: Maybe<CarriageDto>;
  carriage_additional_parameters: Array<CarriageAdditionalParameterDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Статус заполнения всех порядковых номерв в дочерней таблице */
  is_all_additional_parameter_order_numbers_set: Scalars['Boolean']['output'];
  /** Номер вагона с головы */
  number_from_head: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageQuantityMainGroupDto = {
  __typename: 'CarriageQuantityMainGroupDto';
  /** Кол-во вагонов (осн. группа) */
  carriage_quantity: Scalars['Float']['output'];
  /** Типы вагонов */
  carriage_types: Array<CarriageGroupIndicatorsTypeParamsCountDto>;
  /** Кол-во составов (осн. группа) */
  train_quantity: Scalars['Int']['output'];
  /** поездооборот */
  train_turnover: Scalars['Float']['output'];
  /** Кол-во отправлений */
  trips_quantity: Scalars['Float']['output'];
};

export type CarriageSeatAllocationDto = {
  __typename: 'CarriageSeatAllocationDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  /** Тип выделения мест */
  name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageSeatAllocationList = {
  __typename: 'CarriageSeatAllocationList';
  items: Array<CarriageSeatAllocationDto>;
  totalCount: Scalars['Float']['output'];
};

export type CarriageSeatAllocationMutationEntryPoint = {
  __typename: 'CarriageSeatAllocationMutationEntryPoint';
  /** Добавить тип выделения мест */
  create: CarriageSeatAllocationDto;
  /** Обновить тип выделения мест */
  update: CarriageSeatAllocationDto;
};


export type CarriageSeatAllocationMutationEntryPointCreateArgs = {
  data: CreateCarriageSeatAllocationDto;
};


export type CarriageSeatAllocationMutationEntryPointUpdateArgs = {
  data: UpdateCarriageSeatAllocationDto;
};

export type CarriageSeatAllocationQueryEntryPoint = {
  __typename: 'CarriageSeatAllocationQueryEntryPoint';
  /** Тип выделения мест по id */
  byEntityId: CarriageSeatAllocationDto;
  /** Список изменений типа признака мест */
  history: CarriageSeatAllocationList;
  /** Список типов выделений мест */
  list: CarriageSeatAllocationList;
};


export type CarriageSeatAllocationQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type CarriageSeatAllocationQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<CarriageSeatAllocationQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type CarriageSeatAllocationQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<CarriageSeatAllocationQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<CarriageSeatAllocationQueryResolver_List_FilterInputType>;
};

export type CarriageSeatAllocationQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageSeatAllocationQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageSeatAllocationQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageSeatAllocationQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageSeatAllocationQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<CarriageSeatAllocationQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageSeatAllocationQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageSeatAllocationQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageSeatsAllocationDto = {
  __typename: 'CarriageSeatsAllocationDto';
  /** Выделенные (зарезервированные) места */
  all_seats: Array<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание в свободной форме */
  description?: Maybe<Scalars['String']['output']>;
  for_whom_seats_allocation: CarriageSeatAllocationDto;
  from_station?: Maybe<StationDto>;
  id: Scalars['Int']['output'];
  /** Количество выделенных мест */
  quantity?: Maybe<Scalars['Int']['output']>;
  to_station?: Maybe<StationDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageServiceClassDto = {
  __typename: 'CarriageServiceClassDto';
  available_service_classes?: Maybe<Array<AvailableServiceClassDto>>;
  carriage_types_for_schema: CarriageTypesForSchemaDto;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageServiceClassList = {
  __typename: 'CarriageServiceClassList';
  items: Array<CarriageServiceClassDto>;
  totalCount: Scalars['Float']['output'];
};

export type CarriageServiceClassMutationEntryPoint = {
  __typename: 'CarriageServiceClassMutationEntryPoint';
  /** Добавить класс обслуживания */
  create: CarriageServiceClassDto;
  /** Обновить класс обслуживания */
  update: CarriageServiceClassDto;
};


export type CarriageServiceClassMutationEntryPointCreateArgs = {
  data: CreateCarriageServiceClassDto;
};


export type CarriageServiceClassMutationEntryPointUpdateArgs = {
  data: UpdateCarriageServiceClassDto;
};

export type CarriageServiceClassQueryEntryPoint = {
  __typename: 'CarriageServiceClassQueryEntryPoint';
  /** Класс обслуживания */
  byEntityId: CarriageServiceClassDto;
  /** Список изменений класса обслуживания */
  history: CarriageServiceClassList;
  /** Список классов обслуживания */
  list: CarriageServiceClassList;
};


export type CarriageServiceClassQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type CarriageServiceClassQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<CarriageServiceClassQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type CarriageServiceClassQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<CarriageServiceClassQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<CarriageServiceClassQueryResolver_List_FilterInputType>;
};

export type CarriageServiceClassQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageServiceClassQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageServiceClassQueryResolver_List_BaseFilterInputType>>;
  carriage_types_for_schema_id?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageServiceClassQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageServiceClassQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<CarriageServiceClassQueryResolver_List_BaseFilterInputType>>;
  carriage_types_for_schema_id?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageServiceClassQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageServiceClassQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageTrainInfoDto = {
  __typename: 'CarriageTrainInfoDto';
  available_service_classes: Array<AvailableServiceClassDto>;
  /** Добполнительные параметры вагона */
  carriage_additional_parameters: Array<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Примечание в свободной форме */
  notes?: Maybe<Scalars['String']['output']>;
  /** Порядковый/условный номер */
  order_number?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageTypeAsuDimensionSeatsCountDto = {
  __typename: 'CarriageTypeAsuDimensionSeatsCountDto';
  carriage_dimension: NpsCarriageDimensionDto;
  carriage_type_asu: CarriageTypeAsuDto;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Стандартное количество мест */
  default_seats_count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageTypeAsuDimensionSeatsCountDtoList = {
  __typename: 'CarriageTypeAsuDimensionSeatsCountDtoList';
  items: Array<CarriageTypeAsuDimensionSeatsCountDto>;
  totalCount: Scalars['Float']['output'];
};

export type CarriageTypeAsuDimensionSeatsCountMutationEntryPoint = {
  __typename: 'CarriageTypeAsuDimensionSeatsCountMutationEntryPoint';
  /** Добавить тип вагона для схем */
  create: CarriageTypeAsuDimensionSeatsCountDto;
  /** Обновить тип вагона для схем */
  update?: Maybe<CarriageTypeAsuDimensionSeatsCountDto>;
};


export type CarriageTypeAsuDimensionSeatsCountMutationEntryPointCreateArgs = {
  data: CreateCarriageTypeAsuDimensionSeatsCountDto;
};


export type CarriageTypeAsuDimensionSeatsCountMutationEntryPointUpdateArgs = {
  data: UpdateCarriageTypeAsuDimensionSeatsCountDto;
};

export type CarriageTypeAsuDimensionSeatsCountQueryEntryPoint = {
  __typename: 'CarriageTypeAsuDimensionSeatsCountQueryEntryPoint';
  /** Тип вагона АСУПВ, габарит и количество мест по id */
  byId: CarriageTypeAsuDimensionSeatsCountDto;
  /** Тип вагона АСУПВ, габарит и количество мест по id типа вагона АСУПВ и габарита */
  byTypeAsuDimensionId: CarriageTypeAsuDimensionSeatsCountDto;
  /** Список соответствий типов вагонов АСУПВ, габарита и количества мест */
  list: CarriageTypeAsuDimensionSeatsCountDtoList;
};


export type CarriageTypeAsuDimensionSeatsCountQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type CarriageTypeAsuDimensionSeatsCountQueryEntryPointByTypeAsuDimensionIdArgs = {
  data: ByTypeAsuDimensionIdQueryDataDto;
};


export type CarriageTypeAsuDimensionSeatsCountQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<CarriageTypeAsuDimensionSeatsCountQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CarriageTypeAsuDimensionSeatsCountQueryResolver_List_FilterInputType>;
};

export type CarriageTypeAsuDimensionSeatsCountQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageTypeAsuDimensionSeatsCountQueryResolver_List_BaseFilterInputType>>;
  carriage_dimension_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_type_asu_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  default_seats_count?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageTypeAsuDimensionSeatsCountQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageTypeAsuDimensionSeatsCountQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<CarriageTypeAsuDimensionSeatsCountQueryResolver_List_BaseFilterInputType>>;
  carriage_dimension_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_type_asu_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  default_seats_count?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageTypeAsuDimensionSeatsCountQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageTypeAsuDimensionSeatsCountQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  default_seats_count?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageTypeAsuDto = {
  __typename: 'CarriageTypeAsuDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  /** Полное название */
  full_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  /** Краткое название */
  short_name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageTypeAsuDtoList = {
  __typename: 'CarriageTypeAsuDtoList';
  items: Array<CarriageTypeAsuDto>;
  totalCount: Scalars['Float']['output'];
};

export type CarriageTypeAsuMutationEntryPoint = {
  __typename: 'CarriageTypeAsuMutationEntryPoint';
  /** Добавить тип вагона по АСУ ПВ */
  create: CarriageTypeAsuDto;
  /** Обновить тип вагона по АСУ ПВ */
  update: CarriageTypeAsuDto;
};


export type CarriageTypeAsuMutationEntryPointCreateArgs = {
  data: CreateCarriageTypeAsuDto;
};


export type CarriageTypeAsuMutationEntryPointUpdateArgs = {
  data: UpdateCarriageTypeAsuDto;
};

export type CarriageTypeAsuQueryEntryPoint = {
  __typename: 'CarriageTypeAsuQueryEntryPoint';
  /** Тип вагона по АСУ ПВ по id */
  byEntityId: CarriageTypeAsuDto;
  /** Список изменений типа вагона по АСУ ПВ */
  history: CarriageTypeAsuDtoList;
  /** Список типов вагонов по АСУ ПВ */
  list: CarriageTypeAsuDtoList;
};


export type CarriageTypeAsuQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type CarriageTypeAsuQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<CarriageTypeAsuQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type CarriageTypeAsuQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<CarriageTypeAsuQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<CarriageTypeAsuQueryResolver_List_FilterInputType>;
};

export type CarriageTypeAsuQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  full_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageTypeAsuQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageTypeAsuQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageTypeAsuQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageTypeAsuQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<CarriageTypeAsuQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageTypeAsuQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageTypeAsuQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  full_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageTypeDto = {
  __typename: 'CarriageTypeDto';
  carriage_types_for_schema?: Maybe<CarriageTypesForSchemaDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  regulatory_sector: MnemonicDto;
  rolling_stock_type: MnemonicDto;
  seat_type: MnemonicDto;
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageTypeList = {
  __typename: 'CarriageTypeList';
  items: Array<CarriageTypeDto>;
  totalCount: Scalars['Float']['output'];
};

export type CarriageTypeMutationEntryPoint = {
  __typename: 'CarriageTypeMutationEntryPoint';
  /** Добавить тип вагона */
  create: CarriageTypeDto;
  /** Обновить тип вагона */
  update: CarriageTypeDto;
};


export type CarriageTypeMutationEntryPointCreateArgs = {
  data: CreateCarriageTypeDto;
};


export type CarriageTypeMutationEntryPointUpdateArgs = {
  data: UpdateCarriageTypeDto;
};

export type CarriageTypeQueryEntryPoint = {
  __typename: 'CarriageTypeQueryEntryPoint';
  /** Тип вагона по id */
  byEntityId: CarriageTypeDto;
  /** Список изменений типа вагона */
  history: CarriageTypeList;
  /** Список типов вагонов */
  list: CarriageTypeList;
};


export type CarriageTypeQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type CarriageTypeQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<CarriageTypeQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type CarriageTypeQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<CarriageTypeQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<CarriageTypeQueryResolver_List_FilterInputType>;
};

export type CarriageTypeQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageTypeQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageTypeQueryResolver_List_BaseFilterInputType>>;
  carriage_types_for_schema_id?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageTypeQueryResolver_List_BaseFilterInputType>>;
  regulatory_sector_mnemonic_id?: InputMaybe<Number_PropertyFilterInputType>;
  rolling_stock_type_mnemonic_id?: InputMaybe<Number_PropertyFilterInputType>;
  seat_type_mnemonic_id?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageTypeQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<CarriageTypeQueryResolver_List_BaseFilterInputType>>;
  carriage_types_for_schema_id?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageTypeQueryResolver_List_BaseFilterInputType>>;
  regulatory_sector_mnemonic_id?: InputMaybe<Number_PropertyFilterInputType>;
  rolling_stock_type_mnemonic_id?: InputMaybe<Number_PropertyFilterInputType>;
  seat_type_mnemonic_id?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageTypeQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageTypesForSchemaDto = {
  __typename: 'CarriageTypesForSchemaDto';
  carriage_type_asu?: Maybe<CarriageTypeAsuDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Описание */
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Название */
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CarriageTypesForSchemaDtoList = {
  __typename: 'CarriageTypesForSchemaDtoList';
  items: Array<CarriageTypesForSchemaDto>;
  totalCount: Scalars['Float']['output'];
};

export type CarriageTypesForSchemaMutationEntryPoint = {
  __typename: 'CarriageTypesForSchemaMutationEntryPoint';
  /** Добавить тип вагона для схем */
  create: Scalars['Float']['output'];
  /** Обновить тип вагона для схем */
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type CarriageTypesForSchemaMutationEntryPointCreateArgs = {
  data: CreateCarriageTypesForSchemaDto;
};


export type CarriageTypesForSchemaMutationEntryPointUpdateArgs = {
  data: UpdateCarriageTypesForSchemaDto;
};

export type CarriageTypesForSchemaQueryEntryPoint = {
  __typename: 'CarriageTypesForSchemaQueryEntryPoint';
  /** Тип вагона для схемы по id */
  byId: CarriageTypesForSchemaDto;
  /** Список типов вагонов для схемы */
  list: CarriageTypesForSchemaDtoList;
};


export type CarriageTypesForSchemaQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type CarriageTypesForSchemaQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<CarriageTypesForSchemaQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CarriageTypesForSchemaQueryResolver_List_FilterInputType>;
};

export type CarriageTypesForSchemaQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<CarriageTypesForSchemaQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageTypesForSchemaQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageTypesForSchemaQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<CarriageTypesForSchemaQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CarriageTypesForSchemaQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CarriageTypesForSchemaQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CarriageUnionDto = CarriageMvpsDto | CarriageNpsDto;

export type ChangeIsMarkedToDeleteDto = {
  __typename: 'ChangeIsMarkedToDeleteDto';
  /** Ошибки */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Результат */
  is_success: Scalars['Boolean']['output'];
};

export type ChangeIsMarkedToDeleteRequestDto = {
  /** Идентификаторы поездов */
  train_ids: Array<Scalars['Int']['input']>;
};

export type ChangeTableBlockOrderNumber = {
  /** Какой порядковый номер установить */
  order_number_to_set: Scalars['Int']['input'];
  /** Идентификатор блока в таблице схемы */
  table_block_id: Scalars['Int']['input'];
  /** Идентификатор схемы */
  train_schema_id: Scalars['Int']['input'];
};

export type ChangeTableBlockQuantityDto = {
  /** Идентификатор блока для изменения количества составов */
  table_block_id: Scalars['Float']['input'];
  /** Количество составов */
  train_quantity: Scalars['Float']['input'];
};

export type CheckCarriageGroupCarriageNumbersDto = {
  __typename: 'CheckCarriageGroupCarriageNumbersDto';
  /** Текст ошибки */
  error_message?: Maybe<Array<Scalars['String']['output']>>;
  /** Связана ли ошибка с валидацией номеров вагонов */
  is_error_belongs_to_carriage_numbers_validation: Scalars['Boolean']['output'];
  /** Прошла ли ГВ валидацию */
  is_valid: Scalars['Boolean']['output'];
};

export type CheckCreateVersionPossibilityDto = {
  /** Идентификатор текущего ГДП */
  current_gdp_id: Scalars['Int']['input'];
  /** Идентификатор ГДП */
  gdp_id: Scalars['Int']['input'];
  /** Создать ли копии для всех поездов */
  is_copy_all_trains: Scalars['Boolean']['input'];
  /** Дата начала действия */
  start_at: Scalars['String']['input'];
  /** Идентификаторы поездов */
  train_ids: Array<Scalars['Int']['input']>;
};

export type CheckCreateVersionPossibilityResponseDto = {
  __typename: 'CheckCreateVersionPossibilityResponseDto';
  /** Создание версии только ли для потерянных поездов */
  is_create_version_for_missed_trains: Scalars['Boolean']['output'];
  /** Возможно ли создание версии */
  is_create_version_possible: Scalars['Boolean']['output'];
  /** Ошибка */
  message?: Maybe<Scalars['String']['output']>;
};

export type CheckIsSpreadPossibleToAllSchemasRequestDto = {
  /** asd */
  block: Scalars['String']['input'];
  trainIds: Array<Scalars['Int']['input']>;
  trainSchemaId: Scalars['Int']['input'];
};

export type ClassifiersMutationEntryPoint = {
  __typename: 'ClassifiersMutationEntryPoint';
  /** Классы обслуживания */
  availableServiceClass: AvailableServiceClassMutationEntryPoint;
  /** Филиал */
  branch: BranchMutationEntryPoint;
  /** Тип признака мест */
  carriageAdditionalSeatSign: CarriageAdditionalSeatSignMutationEntryPoint;
  /** Тип выделения мест */
  carriageSeatAllocation: CarriageSeatAllocationMutationEntryPoint;
  /** Классы обслуживания вагонов */
  carriageServiceClass: CarriageServiceClassMutationEntryPoint;
  /** Тип вагона для внесения в схему */
  carriageType: CarriageTypeMutationEntryPoint;
  /** Тип вагона по АСУ ПВ */
  carriageTypeAsu: CarriageTypeAsuMutationEntryPoint;
  /** Соответствие типа вагона АСУПВ, габарита и стандартного количества мест */
  carriageTypeAsuDimensionSeatsCount: CarriageTypeAsuDimensionSeatsCountMutationEntryPoint;
  /** Типы вагонов для указания в схеме поезда */
  carriageTypesForSchema: CarriageTypesForSchemaMutationEntryPoint;
  /** Условные номера вагонов */
  conditionalCarriageNumber: ConditionalCarriageNumberMutationEntryPoint;
  /** Типы вагонов для интеграции с ЦСУ (nmrvag) */
  csuCarriageType: CsuCarriageTypeMutationEntryPoint;
  /** График движения поездов */
  gdp: GdpMutationEntryPoint;
  /** Коэффициент индексации к тарифам на использование услуг инфраструктуры */
  infrastructureCoefficientIndexing: InfrastructureCoefficientIndexingMutationEntryPoint;
  /** Стоимость технического обслуживания локомотивов */
  locomotivePriceTechnicalService: LocomotivePriceTechnicalServiceMutationEntryPoint;
  /** Серии локомотивов */
  locomotiveSeries: LocomotiveSeriesMutationEntryPoint;
  /** Эмпирические параметры локомотивного обслуживания */
  locomotiveServiceEmpiricalParameter: LocomotiveServiceEmpiricalParameterMutationEntryPoint;
  /** Стоимость аренды локомотивных бригад */
  locomotiveTeamPriceRent: LocomotiveTeamPriceRentMutationEntryPoint;
  /** Максимальная скорость поезда */
  maxTrainSpeed: MaxTrainSpeedMutationEntryPoint;
  /** Мнемоника */
  mnemonic: MnemonicMutationEntryPoint;
  /** Предприятие собственности МВПС */
  mvpsCompanyAffiliation: MvpsCompanyAffiliationMutationEntryPoint;
  /** Вид секций МВПС «Ласточка» */
  mvpsMartinSectionType: MvpsMartinSectionTypeMutationEntryPoint;
  /** Комплектации видов секций МВПС «Ласточка» */
  mvpsMartinSectionTypeEquipment: MvpsMartinSectionTypeEquipmentMutationEntryPoint;
  /** Ставки за управление и эксплуатацию, техобслуживание и ремонт МВПС */
  mvpsRateManagementExploitationMaintenanceRepair: MvpsRateManagementExploitationMaintenanceRepairMutationEntryPoint;
  /** Типы вагонов, не предназначенных для перевозки пассажиров, для указания в схеме поезда */
  nonPassengerCarriageType: NonPassengerCarriageTypeMutationEntryPoint;
  /** Тип тормоза */
  npsCarriageBrakeType: NpsCarriageBrakeTypeMutationEntryPoint;
  /** Габарит подвижного состава */
  npsCarriageDimension: NpsCarriageDimensionMutationEntryPoint;
  /** Вид отопления */
  npsCarriageHeatType: NpsCarriageHeatTypeMutationEntryPoint;
  /** Длина вагона */
  npsCarriageLength: NpsCarriageLengthMutationEntryPoint;
  /** Модель вагона */
  npsCarriageModel: NpsCarriageModelMutationEntryPoint;
  /** Пассажирские перевозчики */
  passengerCarrier: PassengerCarrierMutationEntryPoint;
  /** Сезонность */
  periodicitySeason: PeriodicitySeasonMutationEntryPoint;
  /** Железная дорога */
  railway: RailwayMutationEntryPoint;
  /** ЖД администрация */
  railwayAdministration: RailwayAdministrationMutationEntryPoint;
  /** Маршруты для контроля наличия свободных мест по направлениям */
  routesControlAvailabilitySeatsDirection: RoutesControlAvailabilitySeatsDirectionMutationEntryPoint;
  /** Станция */
  station: StationMutationEntryPoint;
  /** Структурное подразделение */
  structuralSubdivision: StructuralSubdivisionMutationEntryPoint;
  /** Региональные дирекции тяги */
  tractionDirectorate: TractionDirectorateMutationEntryPoint;
  /** Фирменность поезда */
  trainBrand: TrainBrandMutationEntryPoint;
  /** Подкатегории поездов */
  trainCategory: TrainCategoryMutationEntryPoint;
  /** Скоростные характеристики */
  trainSubCategoriesDetailsSpeed: TrainSubCategoriesDetailsSpeedMutationEntryPoint;
  /** Подкатегории поездов */
  trainSubCategory: TrainSubCategoryMutationEntryPoint;
  /** Эксплуатационные показатели перевозок */
  transportationPerformanceIndicator: TransportationPerformanceIndicatorMutationEntryPoint;
};

export type ClassifiersQueryEntryPoint = {
  __typename: 'ClassifiersQueryEntryPoint';
  /** Доступный класс обслуживания */
  availableServiceClass: AvailableServiceClassQueryEntryPoint;
  /** Филиал АО «ФПК» */
  branch: BranchQueryEntryPoint;
  /** Тип признака мест */
  carriageAdditionalSeatSign: CarriageAdditionalSeatSignQueryEntryPoint;
  /** Тип выделения мест */
  carriageSeatAllocation: CarriageSeatAllocationQueryEntryPoint;
  /** Класс обслуживания */
  carriageServiceClass: CarriageServiceClassQueryEntryPoint;
  /** Тип вагона для внесения в схему */
  carriageType: CarriageTypeQueryEntryPoint;
  /** Тип вагона по АСУ ПВ */
  carriageTypeAsu: CarriageTypeAsuQueryEntryPoint;
  /** Соответствие типа вагона АСУПВ, габарита и стандартного количества мест */
  carriageTypeAsuDimensionSeatsCount: CarriageTypeAsuDimensionSeatsCountQueryEntryPoint;
  /** Типы вагонов для указания в схеме поезда */
  carriageTypesForSchema: CarriageTypesForSchemaQueryEntryPoint;
  /** Условные номера вагонов */
  conditionalCarriageNumber: ConditionalCarriageNumberQueryEntryPoint;
  /** Типы вагонов для интеграции с ЦСУ (nmrvag) */
  csuCarriageType: CsuCarriageTypeQueryEntryPoint;
  /** Пассажирские перевозчики */
  csuCarrier: CsuCarrierQueryEntryPoint;
  /** График движения поездов */
  gdp: GdpQueryEntryPoint;
  /** Тарифы на услуги по использованию инфраструктуры регулируемой организации (Приложение 23) */
  infrastructureApplication23: InfrastructureApplication23QueryEntryPoint;
  /** Тарифы на услуги по использованию инфраструктуры регулируемой организации (Приложение 24) */
  infrastructureApplication24: InfrastructureApplication24QueryEntryPoint;
  /** Тарифы на услуги по использованию инфраструктуры регулируемой организации (Приложение 25) */
  infrastructureApplication25: InfrastructureApplication25QueryEntryPoint;
  /** Тарифы на услуги по использованию инфраструктуры регулируемой организации (Приложение 26) */
  infrastructureApplication26: InfrastructureApplication26QueryEntryPoint;
  /** Размеры уменьшения платы за услуги по использованию инфраструктуры регулируемой организацией (Приложение 27) */
  infrastructureApplication27: InfrastructureApplication27QueryEntryPoint;
  /** Коэффициент индексации к тарифам на использование услуг инфраструктуры */
  infrastructureCoefficientIndexing: InfrastructureCoefficientIndexingQueryEntryPoint;
  /** Стоимость технического обслуживания локомотивов */
  locomotivePriceTechnicalService: LocomotivePriceTechnicalServiceQueryEntryPoint;
  /** Серии локомотивов */
  locomotiveSeries: LocomotiveSeriesQueryEntryPoint;
  /** Род службы локомотивов */
  locomotiveSeriesType: LocomotiveSeriesTypeQueryEntryPoint;
  /** Эмпирические параметры локомотивного обслуживания */
  locomotiveServiceEmpiricalParameter: LocomotiveServiceEmpiricalParameterQueryEntryPoint;
  /** Стоимость аренды локомотивных бригад */
  locomotiveTeamPriceRent: LocomotiveTeamPriceRentQueryEntryPoint;
  /** Вид тяги */
  locomotiveTractionType: LocomotiveTractionTypeQueryEntryPoint;
  /** Тип тока */
  locomotiveTypeCurrent: LocomotiveTypeCurrentQueryEntryPoint;
  /** Максимальная скорость поезда */
  maxTrainSpeed: MaxTrainSpeedQueryEntryPoint;
  /** Мнемоника */
  mnemonic: MnemonicQueryEntryPoint;
  /** Предприятие собственности МВПС */
  mvpsCompanyAffiliation: MvpsCompanyAffiliationQueryEntryPoint;
  /** Вид секций МВПС «Ласточка» */
  mvpsMartinSectionType: MvpsMartinSectionTypeQueryEntryPoint;
  /** Комплектации видов секций МВПС «Ласточка» */
  mvpsMartinSectionTypeEquipment: MvpsMartinSectionTypeEquipmentQueryEntryPoint;
  /** Ставки за управление и эксплуатацию, техобслуживание и ремонт МВПС */
  mvpsRateManagementExploitationMaintenanceRepair: MvpsRateManagementExploitationMaintenanceRepairQueryEntryPoint;
  /** Типы вагонов, не предназначенных для перевозки пассажиров, для указания в схеме поезда */
  nonPassengerCarriageType: NonPassengerCarriageTypeQueryEntryPoint;
  /** Тип тормоза */
  npsCarriageBrakeType: NpsCarriageBrakeTypeQueryEntryPoint;
  /** Габарит подвижного состава */
  npsCarriageDimension: NpsCarriageDimensionQueryEntryPoint;
  /** Вид отопления */
  npsCarriageHeatType: NpsCarriageHeatTypeQueryEntryPoint;
  /** Длина вагона */
  npsCarriageLength: NpsCarriageLengthQueryEntryPoint;
  /** Модель вагона */
  npsCarriageModel: NpsCarriageModelQueryEntryPoint;
  /** Пассажирские перевозчики */
  passengerCarrier: PassengerCarrierQueryEntryPoint;
  /** Сезонность */
  periodicitySeason: PeriodicitySeasonQueryEntryPoint;
  /** Железная дорога */
  railway: RailwayQueryEntryPoint;
  /** ЖД администрации */
  railwayAdministration: RailwayAdministrationQueryEntryPoint;
  /** Маршруты для контроля наличия свободных мест по направлениям */
  routesControlAvailabilitySeatsDirection: RoutesControlAvailabilitySeatsDirectionQueryEntryPoint;
  /** Станция */
  station: StationQueryEntryPoint;
  /** Структурное подразделение */
  structuralSubdivision: StructuralSubdivisionQueryEntryPoint;
  /** Серии локомотивов */
  tractionDirectorate: TractionDirectorateQueryEntryPoint;
  /** Фирменность поезда */
  trainBrand: TrainBrandQueryEntryPoint;
  /** Категория поезда */
  trainCategory: TrainCategoryQueryEntryPoint;
  /** Скоростные характеристики */
  trainSubCategoriesDetailsSpeed: TrainSubCategoriesDetailsSpeedQueryEntryPoint;
  /** Подкатегория поезда */
  trainSubCategory: TrainSubCategoryQueryEntryPoint;
  /** Эксплуатационные показатели перевозок */
  transportationPerformanceIndicator: TransportationPerformanceIndicatorQueryEntryPoint;
};

export type CmsMutationEntryPoint = {
  __typename: 'CmsMutationEntryPoint';
  /** Создание инструкции */
  education_create: EducationDto;
  /** Удаление инструкции */
  education_delete?: Maybe<Scalars['Void']['output']>;
  /** Обновление инструкции */
  education_update: EducationDto;
  /** Создание вопроса/ответа */
  faq_create: FaqDto;
  /** Удаление вопроса/ответа */
  faq_delete?: Maybe<Scalars['Void']['output']>;
  /** Обновление вопроса/ответа */
  faq_update: FaqDto;
  /** Создание новости */
  news_create: NewsDto;
  /** Удаление новости */
  news_delete?: Maybe<Scalars['Void']['output']>;
  /** Обновление новости */
  news_update: NewsDto;
};


export type CmsMutationEntryPointEducation_CreateArgs = {
  data: EducationCreateDto;
};


export type CmsMutationEntryPointEducation_DeleteArgs = {
  data: Scalars['Float']['input'];
};


export type CmsMutationEntryPointEducation_UpdateArgs = {
  data: EducationUpdateDto;
};


export type CmsMutationEntryPointFaq_CreateArgs = {
  data: FaqCreateDto;
};


export type CmsMutationEntryPointFaq_DeleteArgs = {
  data: Scalars['Float']['input'];
};


export type CmsMutationEntryPointFaq_UpdateArgs = {
  data: FaqUpdateDto;
};


export type CmsMutationEntryPointNews_CreateArgs = {
  data: NewsCreateDto;
};


export type CmsMutationEntryPointNews_DeleteArgs = {
  data: Scalars['Float']['input'];
};


export type CmsMutationEntryPointNews_UpdateArgs = {
  data: NewsUpdateDto;
};

export type CmsQueryEntryPoint = {
  __typename: 'CmsQueryEntryPoint';
  /** Список инструкций */
  education_list: EducationList;
  /** Список вопросов/ответов */
  faq_list: FaqList;
  /** Список новостей */
  news_list: NewsList;
};


export type CmsQueryEntryPointEducation_ListArgs = {
  order_by?: InputMaybe<Array<CmsQueryResolver_EducationList_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CmsQueryResolver_EducationList_FilterInputType>;
};


export type CmsQueryEntryPointFaq_ListArgs = {
  order_by?: InputMaybe<Array<CmsQueryResolver_FaqList_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CmsQueryResolver_FaqList_FilterInputType>;
};


export type CmsQueryEntryPointNews_ListArgs = {
  order_by?: InputMaybe<Array<CmsQueryResolver_NewsList_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CmsQueryResolver_NewsList_FilterInputType>;
};

export type CmsQueryResolver_EducationList_BaseFilterInputType = {
  and?: InputMaybe<Array<CmsQueryResolver_EducationList_BaseFilterInputType>>;
  content?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CmsQueryResolver_EducationList_BaseFilterInputType>>;
  title?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CmsQueryResolver_EducationList_FilterInputType = {
  and?: InputMaybe<Array<CmsQueryResolver_EducationList_BaseFilterInputType>>;
  content?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CmsQueryResolver_EducationList_BaseFilterInputType>>;
  title?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CmsQueryResolver_EducationList_SortingInputType = {
  content?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  title?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CmsQueryResolver_FaqList_BaseFilterInputType = {
  and?: InputMaybe<Array<CmsQueryResolver_FaqList_BaseFilterInputType>>;
  content?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CmsQueryResolver_FaqList_BaseFilterInputType>>;
  order?: InputMaybe<Number_PropertyFilterInputType>;
  title?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CmsQueryResolver_FaqList_FilterInputType = {
  and?: InputMaybe<Array<CmsQueryResolver_FaqList_BaseFilterInputType>>;
  content?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CmsQueryResolver_FaqList_BaseFilterInputType>>;
  order?: InputMaybe<Number_PropertyFilterInputType>;
  title?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CmsQueryResolver_FaqList_SortingInputType = {
  content?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  order?: InputMaybe<SortType>;
  title?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CmsQueryResolver_NewsList_BaseFilterInputType = {
  and?: InputMaybe<Array<CmsQueryResolver_NewsList_BaseFilterInputType>>;
  content?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CmsQueryResolver_NewsList_BaseFilterInputType>>;
  title?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CmsQueryResolver_NewsList_FilterInputType = {
  and?: InputMaybe<Array<CmsQueryResolver_NewsList_BaseFilterInputType>>;
  content?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CmsQueryResolver_NewsList_BaseFilterInputType>>;
  title?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CmsQueryResolver_NewsList_SortingInputType = {
  content?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  title?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CompositionSchemaDto = {
  __typename: 'CompositionSchemaDto';
  /** id группы вагонов */
  carriage_group_id: Scalars['Float']['output'];
  /** Всего (все ваг) */
  carriages_total: CompositionSchemaItemTotalDto;
  /** Строки таблицы по типам вагонов */
  items: Array<CarriageGroupIndicatorsSchemaItemDto>;
  /** Всего (пасс ваг) */
  passenger_carriages_total: CompositionSchemaItemTotalDto;
  /** Маршруты вагонной группы */
  route: Array<EmphasizedStationItemDto>;
  /** Признак группы */
  sign: Scalars['String']['output'];
  /** Номера поездов */
  train_numbers: Array<EmphasizedTrainItemDto>;
};

export type CompositionSchemaItemTotalDto = {
  __typename: 'CompositionSchemaItemTotalDto';
  /** Средняя вместимость вагона (схема) */
  average_capacity?: Maybe<Scalars['Float']['output']>;
  /** Кол-во вагонов (схема) */
  carriage_quantity?: Maybe<Scalars['Float']['output']>;
  /** Кол-во вагонов (треб.) */
  carriage_quantity_req?: Maybe<Scalars['Float']['output']>;
  /** Кол-во мест в продаже (схема) */
  seats_for_sale?: Maybe<Scalars['Float']['output']>;
  /** Кол-во мест всего (схема) */
  seats_quantity?: Maybe<Scalars['Float']['output']>;
};

export type ConditionalCarriageNumberDto = {
  __typename: 'ConditionalCarriageNumberDto';
  /** Условный номер вагона */
  conditional_carriage_number: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type ConditionalCarriageNumberList = {
  __typename: 'ConditionalCarriageNumberList';
  items: Array<ConditionalCarriageNumberDto>;
  totalCount: Scalars['Float']['output'];
};

export type ConditionalCarriageNumberMutationEntryPoint = {
  __typename: 'ConditionalCarriageNumberMutationEntryPoint';
  /** Добавить условный номер вагона */
  create: Scalars['Float']['output'];
  /** Обновление условного номера вагона */
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type ConditionalCarriageNumberMutationEntryPointCreateArgs = {
  data: CreateConditionalCarriageNumberDto;
};


export type ConditionalCarriageNumberMutationEntryPointUpdateArgs = {
  data: UpdateConditionalCarriageNumberDto;
};

export type ConditionalCarriageNumberQueryEntryPoint = {
  __typename: 'ConditionalCarriageNumberQueryEntryPoint';
  /** Номер вагона по id */
  byId: ConditionalCarriageNumberDto;
  /** Список номеров вагонов */
  list: ConditionalCarriageNumberList;
};


export type ConditionalCarriageNumberQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type ConditionalCarriageNumberQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<ConditionalCarriageNumberQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<ConditionalCarriageNumberQueryResolver_List_FilterInputType>;
};

export type ConditionalCarriageNumberQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<ConditionalCarriageNumberQueryResolver_List_BaseFilterInputType>>;
  conditional_carriage_number?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ConditionalCarriageNumberQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type ConditionalCarriageNumberQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<ConditionalCarriageNumberQueryResolver_List_BaseFilterInputType>>;
  conditional_carriage_number?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ConditionalCarriageNumberQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type ConditionalCarriageNumberQueryResolver_List_SortingInputType = {
  conditional_carriage_number?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type ConfigurationMutationEntryPoint = {
  __typename: 'ConfigurationMutationEntryPoint';
  /** Обновление фича-флага */
  feature_flag_update?: Maybe<Scalars['Void']['output']>;
  /** Создание фича-флага пользователя */
  feature_flag_user_create?: Maybe<Scalars['Void']['output']>;
  /** Удаление фича-флага пользователя */
  feature_flag_user_delete?: Maybe<Scalars['Void']['output']>;
  /** Обновление фича-флага пользователя */
  feature_flag_user_update?: Maybe<Scalars['Void']['output']>;
  /** Обновление конфигурации пользователя */
  user_configuration_update?: Maybe<UsersConfigDto>;
};


export type ConfigurationMutationEntryPointFeature_Flag_UpdateArgs = {
  data: FeatureFlagsRequestDto;
};


export type ConfigurationMutationEntryPointFeature_Flag_User_CreateArgs = {
  data: FeatureFlagsUserCreateDto;
};


export type ConfigurationMutationEntryPointFeature_Flag_User_DeleteArgs = {
  data: Scalars['Float']['input'];
};


export type ConfigurationMutationEntryPointFeature_Flag_User_UpdateArgs = {
  data: FeatureFlagsUserUpdateDto;
};


export type ConfigurationMutationEntryPointUser_Configuration_UpdateArgs = {
  data: Scalars['String']['input'];
};

export type ConfigurationQueryEntryPoint = {
  __typename: 'ConfigurationQueryEntryPoint';
  /** Список фичи-флагов */
  feature_flag_list: FeatureFlagList;
  /** Пользовательские фичи-флаги */
  feature_flag_user_list: FeatureFlagUserList;
  /** Получить конфигурацию пользователя */
  user_configuration?: Maybe<UsersConfigDto>;
};


export type ConfigurationQueryEntryPointFeature_Flag_ListArgs = {
  order_by?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagList_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<ConfigurationQueryResolver_FeatureFlagList_FilterInputType>;
};


export type ConfigurationQueryEntryPointFeature_Flag_User_ListArgs = {
  order_by?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagUserList_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<ConfigurationQueryResolver_FeatureFlagUserList_FilterInputType>;
};

export type ConfigurationQueryResolver_FeatureFlagList_BaseFilterInputType = {
  and?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagList_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagList_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  value?: InputMaybe<String_PropertyFilterInputType>;
};

export type ConfigurationQueryResolver_FeatureFlagList_FilterInputType = {
  and?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagList_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagList_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  value?: InputMaybe<String_PropertyFilterInputType>;
};

export type ConfigurationQueryResolver_FeatureFlagList_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  value?: InputMaybe<SortType>;
};

export type ConfigurationQueryResolver_FeatureFlagUserList_BaseFilterInputType = {
  and?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagUserList_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagUserList_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  user_id?: InputMaybe<Number_PropertyFilterInputType>;
  value?: InputMaybe<String_PropertyFilterInputType>;
};

export type ConfigurationQueryResolver_FeatureFlagUserList_FilterInputType = {
  and?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagUserList_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagUserList_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  user_id?: InputMaybe<Number_PropertyFilterInputType>;
  value?: InputMaybe<String_PropertyFilterInputType>;
};

export type ConfigurationQueryResolver_FeatureFlagUserList_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  user_id?: InputMaybe<SortType>;
  value?: InputMaybe<SortType>;
};

export type ControlAvailabilitySeatsDto = {
  __typename: 'ControlAvailabilitySeatsDto';
  /** Тип состава */
  composition_type?: Maybe<Scalars['String']['output']>;
  csuCarrier?: Maybe<CsuCarrierDto>;
  /** Время отправления в секундах */
  departure_time: Scalars['Int']['output'];
  /** Номер поезда для отображения */
  display_train_number: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Наличие остановки по отправлению */
  is_from_transit: Scalars['Boolean']['output'];
  /** Наличие остановки по прибытию */
  is_to_transit: Scalars['Boolean']['output'];
  /** Перевозчик */
  passenger_carrier?: Maybe<Scalars['String']['output']>;
  passenger_carrier_russian_railway?: Maybe<PassengerCarrierDto>;
  /** ID топового направления */
  rcasd_id: Scalars['Int']['output'];
  route: RoutesControlAvailabilitySeatsDirectionsDto;
  routeStationFrom?: Maybe<StationDto>;
  routeStationTo?: Maybe<StationDto>;
  /** Места */
  seats?: Maybe<Array<SeatsDto>>;
  /** Наличие в АСУ МС */
  sync_train_status: Scalars['String']['output'];
  trainStationFrom?: Maybe<StationDto>;
  trainStationTo?: Maybe<StationDto>;
  /** ID поезда */
  train_id?: Maybe<Scalars['String']['output']>;
  /** Номер поезда */
  train_number: Scalars['String']['output'];
};

export type ControlAvailabilitySeatsListDto = {
  __typename: 'ControlAvailabilitySeatsListDto';
  items: Array<ControlAvailabilitySeatsDto>;
  totalCount: Scalars['Float']['output'];
};

export type ControlAvailabilitySeatsMutationEntryPoint = {
  __typename: 'ControlAvailabilitySeatsMutationEntryPoint';
  /** Экспорт в эксель */
  exportToExcel?: Maybe<Scalars['Void']['output']>;
};


export type ControlAvailabilitySeatsMutationEntryPointExportToExcelArgs = {
  where?: InputMaybe<ControlAvailabilitySeatsMutationResolver_ExportToExcel_FilterInputType>;
};

export type ControlAvailabilitySeatsMutationResolver_ExportToExcel_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlAvailabilitySeatsMutationResolver_ExportToExcel_BaseFilterInputType>>;
  csuCarrierId?: InputMaybe<Int_PropertyFilterInputType>;
  endDate?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlAvailabilitySeatsMutationResolver_ExportToExcel_BaseFilterInputType>>;
  passengerCarrierId?: InputMaybe<Int_PropertyFilterInputType>;
  routeId?: InputMaybe<Int_PropertyFilterInputType>;
  routeStationId?: InputMaybe<Int_PropertyFilterInputType>;
  startDate?: InputMaybe<String_PropertyFilterInputType>;
  startOfDay?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlAvailabilitySeatsMutationResolver_ExportToExcel_FilterInputType = {
  and?: InputMaybe<Array<ControlAvailabilitySeatsMutationResolver_ExportToExcel_BaseFilterInputType>>;
  csuCarrierId?: InputMaybe<Int_PropertyFilterInputType>;
  endDate?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlAvailabilitySeatsMutationResolver_ExportToExcel_BaseFilterInputType>>;
  passengerCarrierId?: InputMaybe<Int_PropertyFilterInputType>;
  routeId?: InputMaybe<Int_PropertyFilterInputType>;
  routeStationId?: InputMaybe<Int_PropertyFilterInputType>;
  startDate?: InputMaybe<String_PropertyFilterInputType>;
  startOfDay?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlAvailabilitySeatsQueryEntryPoint = {
  __typename: 'ControlAvailabilitySeatsQueryEntryPoint';
  /** Контроль наличия свободных мест по направлениям */
  list: ControlAvailabilitySeatsListDto;
};


export type ControlAvailabilitySeatsQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<ControlAvailabilitySeatsQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlAvailabilitySeatsQueryResolver_List_FilterInputType>;
};

export type ControlAvailabilitySeatsQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlAvailabilitySeatsQueryResolver_List_BaseFilterInputType>>;
  csuCarrierId?: InputMaybe<Int_PropertyFilterInputType>;
  endDate?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlAvailabilitySeatsQueryResolver_List_BaseFilterInputType>>;
  passengerCarrierId?: InputMaybe<Int_PropertyFilterInputType>;
  routeId?: InputMaybe<Int_PropertyFilterInputType>;
  routeStationId?: InputMaybe<Int_PropertyFilterInputType>;
  startDate?: InputMaybe<String_PropertyFilterInputType>;
  startOfDay?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlAvailabilitySeatsQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<ControlAvailabilitySeatsQueryResolver_List_BaseFilterInputType>>;
  csuCarrierId?: InputMaybe<Int_PropertyFilterInputType>;
  endDate?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlAvailabilitySeatsQueryResolver_List_BaseFilterInputType>>;
  passengerCarrierId?: InputMaybe<Int_PropertyFilterInputType>;
  routeId?: InputMaybe<Int_PropertyFilterInputType>;
  routeStationId?: InputMaybe<Int_PropertyFilterInputType>;
  startDate?: InputMaybe<String_PropertyFilterInputType>;
  startOfDay?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlAvailabilitySeatsQueryResolver_List_SortingInputType = {
  composition_type?: InputMaybe<SortType>;
  departure_time?: InputMaybe<SortType>;
  display_train_number?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_from_transit?: InputMaybe<SortType>;
  is_to_transit?: InputMaybe<SortType>;
  passenger_carrier?: InputMaybe<SortType>;
  rcasd_id?: InputMaybe<SortType>;
  sync_train_status?: InputMaybe<SortType>;
  train_id?: InputMaybe<SortType>;
  train_number?: InputMaybe<SortType>;
};

export type ControlSchemaCarriageNmrvagDto = {
  __typename: 'ControlSchemaCarriageNmrvagDto';
  carriage_type: Scalars['String']['output'];
  cs_carriage_group_id: Scalars['Float']['output'];
  dates: Array<ControlSchemaDateNmrvagDto>;
};

export type ControlSchemaCompositionDto = {
  __typename: 'ControlSchemaCompositionDto';
  /** % - Использование вместимости */
  capacity: Scalars['Int']['output'];
  /** Количество вагонов фактическое */
  count_carriage: Scalars['Int']['output'];
  /** Дата */
  date: Scalars['String']['output'];
};

export type ControlSchemaDateNmrvagDto = {
  __typename: 'ControlSchemaDateNmrvagDto';
  carriage_quantity: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  diff?: Maybe<Scalars['Int']['output']>;
};

export type ControlSchemaDates = {
  __typename: 'ControlSchemaDates';
  capacity: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  diff?: Maybe<Scalars['Int']['output']>;
  passengers_turnover: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  seats_turnover: Scalars['Float']['output'];
};

export type ControlSchemaDto = {
  __typename: 'ControlSchemaDto';
  items: Array<ControlSchemaTrainDto>;
  totalCount: Scalars['Float']['output'];
};

export type ControlSchemaGroupNmrvagDto = {
  __typename: 'ControlSchemaGroupNmrvagDto';
  /** филиал */
  branch?: Maybe<BranchDto>;
  carriages: Array<ControlSchemaCarriageNmrvagDto>;
  carrier: Scalars['String']['output'];
  dates: Array<ControlSchemaTrainDateNmrvagDto>;
  id: Scalars['Float']['output'];
  /** перевозчик */
  passenger_carrier_russian_railway?: Maybe<PassengerCarrierDto>;
  schema_carriage_quantity?: Maybe<Scalars['Int']['output']>;
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
};

export type ControlSchemaIndicatorBranchDto = {
  __typename: 'ControlSchemaIndicatorBranchDto';
  /** Фактическое */
  actual: Scalars['Int']['output'];
  /** Филиал */
  branch?: Maybe<HaulierDto>;
  /** Процент */
  percentage?: Maybe<Scalars['String']['output']>;
  /** Планируемое */
  plan: Scalars['Int']['output'];
  /** +/- к плану */
  tolerance?: Maybe<Scalars['Int']['output']>;
};

export type ControlSchemaIndicatorsDto = {
  __typename: 'ControlSchemaIndicatorsDto';
  /** Фактическое */
  actual: Scalars['Int']['output'];
  /** Дата */
  name: Scalars['String']['output'];
  /** Норма */
  norm?: Maybe<Scalars['Int']['output']>;
  /** Планируемое */
  plan: Scalars['Int']['output'];
};

export type ControlSchemaMutationEntryPoint = {
  __typename: 'ControlSchemaMutationEntryPoint';
  /** Расчёт предварительно сохранённых поездов (моки) */
  calculateMockPreSave?: Maybe<Scalars['Void']['output']>;
  /** Экспорт в эксель */
  exportToExcel?: Maybe<Scalars['Void']['output']>;
  /** Экспорт в эксель по филиалам */
  exportToExcelByBranch?: Maybe<Scalars['Void']['output']>;
  /** Запрос расчёта пополнения */
  replenishmentCalculation?: Maybe<Scalars['Void']['output']>;
  /** расчёт по филиалам */
  schemaControlByBranchCalculations?: Maybe<Scalars['Void']['output']>;
  /** Редактирование поезда */
  updateTrain?: Maybe<Scalars['Void']['output']>;
};


export type ControlSchemaMutationEntryPointCalculateMockPreSaveArgs = {
  data: Scalars['Float']['input'];
};


export type ControlSchemaMutationEntryPointExportToExcelArgs = {
  date: Scalars['String']['input'];
  where?: InputMaybe<ControlSchemaMutationResolver_ExportToExcel_FilterInputType>;
};


export type ControlSchemaMutationEntryPointExportToExcelByBranchArgs = {
  data: ExportControlSchemaByBranchDto;
};


export type ControlSchemaMutationEntryPointReplenishmentCalculationArgs = {
  payload: ReplenishmentRequestDto;
};


export type ControlSchemaMutationEntryPointSchemaControlByBranchCalculationsArgs = {
  date: Scalars['String']['input'];
};


export type ControlSchemaMutationEntryPointUpdateTrainArgs = {
  payload: UpdateSchemaControlTrainNmrvagDataDto;
};

export type ControlSchemaMutationResolver_ExportToExcel_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlSchemaMutationResolver_ExportToExcel_BaseFilterInputType>>;
  branches?: InputMaybe<Int_PropertyFilterInputType>;
  carriers?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaMutationResolver_ExportToExcel_BaseFilterInputType>>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlSchemaMutationResolver_ExportToExcel_FilterInputType = {
  and?: InputMaybe<Array<ControlSchemaMutationResolver_ExportToExcel_BaseFilterInputType>>;
  branches?: InputMaybe<Int_PropertyFilterInputType>;
  carriers?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaMutationResolver_ExportToExcel_BaseFilterInputType>>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlSchemaPreSavedDates = {
  __typename: 'ControlSchemaPreSavedDates';
  capacity: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  diff?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Float']['output'];
};

export type ControlSchemaQueryEntryPoint = {
  __typename: 'ControlSchemaQueryEntryPoint';
  /** Список предварительно рассчитанных поездов */
  byTrainsPreSaved: SchemaControlTrainPreSavedList;
  /** Изменение ёмкости */
  capacity: CapacityDto;
  /** Контроль схем - показатели по филиалам */
  indicators_by_branch: Array<ControlSchemaTotalIndicatorsDto>;
  /** Контроль схем */
  list: ControlSchemaDto;
  /** Список поездов */
  listTrains: SchemaControlTrainList;
  /** Актуальный список поездов нмрваг */
  listTrainsNmrvag: TrainNmrvagListDto;
  /** расчёт пополнения */
  replenishmentResponse: ReplenishmentDto;
  /** Показатели по филиалам */
  schemaControlByBranch: Array<SchemaControlByBranchDto>;
  /** Показатели по поездам */
  schemaControlByTrains: SchemaControlList;
  /** Показатели по поездам */
  schemaControlByTrainsCalculated: SchemaControlCalculatedList;
  /** Список nmrvag */
  schemaControlTrainNmrvagList: SchemaControlTrainNmrvagList;
  /** Список поездов с нормативом схемы */
  trainsListWithSchemaCarriages: SchemaControlTrainNmrvagListDto;
  /** Актуальный список перевозчиков нмрваг */
  uniqueCarriersList: Array<Scalars['Int']['output']>;
};


export type ControlSchemaQueryEntryPointByTrainsPreSavedArgs = {
  compareDate?: InputMaybe<Scalars['String']['input']>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_ByTrainsPreSaved_FilterInputType>;
};


export type ControlSchemaQueryEntryPointCapacityArgs = {
  data: CapacityRequestDto;
};


export type ControlSchemaQueryEntryPointIndicators_By_BranchArgs = {
  key: TypeIndicators;
};


export type ControlSchemaQueryEntryPointListArgs = {
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_List_FilterInputType>;
};


export type ControlSchemaQueryEntryPointListTrainsArgs = {
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_ListTrains_FilterInputType>;
};


export type ControlSchemaQueryEntryPointListTrainsNmrvagArgs = {
  date: Scalars['String']['input'];
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_ListTrainsNmrvag_FilterInputType>;
};


export type ControlSchemaQueryEntryPointReplenishmentResponseArgs = {
  key: Scalars['String']['input'];
};


export type ControlSchemaQueryEntryPointSchemaControlByBranchArgs = {
  compareDate?: InputMaybe<Scalars['String']['input']>;
  order_by?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByBranch_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_SchemaControlByBranch_FilterInputType>;
};


export type ControlSchemaQueryEntryPointSchemaControlByTrainsArgs = {
  compareDate?: InputMaybe<Scalars['String']['input']>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_SchemaControlByTrains_FilterInputType>;
};


export type ControlSchemaQueryEntryPointSchemaControlByTrainsCalculatedArgs = {
  compareDate?: InputMaybe<Scalars['String']['input']>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_SchemaControlByTrainsCalculated_FilterInputType>;
};


export type ControlSchemaQueryEntryPointSchemaControlTrainNmrvagListArgs = {
  compareDate?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<ControlSchemaQueryResolver_SchemaControlTrainNmrvagList_FilterInputType>;
};


export type ControlSchemaQueryEntryPointTrainsListWithSchemaCarriagesArgs = {
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_TrainsListWithSchemaCarriages_FilterInputType>;
};


export type ControlSchemaQueryEntryPointUniqueCarriersListArgs = {
  date: Scalars['String']['input'];
};

export type ControlSchemaQueryResolver_ByTrainsPreSaved_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_ByTrainsPreSaved_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_ByTrainsPreSaved_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_ByTrainsPreSaved_FilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_ByTrainsPreSaved_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_ByTrainsPreSaved_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_ListTrainsNmrvag_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_ListTrainsNmrvag_BaseFilterInputType>>;
  branches?: InputMaybe<Int_PropertyFilterInputType>;
  carriers?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_ListTrainsNmrvag_BaseFilterInputType>>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_ListTrainsNmrvag_FilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_ListTrainsNmrvag_BaseFilterInputType>>;
  branches?: InputMaybe<Int_PropertyFilterInputType>;
  carriers?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_ListTrainsNmrvag_BaseFilterInputType>>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_ListTrains_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_ListTrains_BaseFilterInputType>>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Number_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_ListTrains_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_ListTrains_FilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_ListTrains_BaseFilterInputType>>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Number_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_ListTrains_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_List_BaseFilterInputType>>;
  carriage_group_ids?: InputMaybe<Int_PropertyFilterInputType>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  haulier_id?: InputMaybe<Int_PropertyFilterInputType>;
  haulier_type?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_List_BaseFilterInputType>>;
  train_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_List_BaseFilterInputType>>;
  carriage_group_ids?: InputMaybe<Int_PropertyFilterInputType>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  haulier_id?: InputMaybe<Int_PropertyFilterInputType>;
  haulier_type?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_List_BaseFilterInputType>>;
  train_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_SchemaControlByBranch_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByBranch_BaseFilterInputType>>;
  carriages_fact?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_plan?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_turnover_fact?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_turnover_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_turnover_plan?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_turnover_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  indicators_fact?: InputMaybe<Number_PropertyFilterInputType>;
  indicators_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  indicators_plan?: InputMaybe<Number_PropertyFilterInputType>;
  indicators_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByBranch_BaseFilterInputType>>;
  seats_turnover_fact?: InputMaybe<Number_PropertyFilterInputType>;
  seats_turnover_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  seats_turnover_plan?: InputMaybe<Number_PropertyFilterInputType>;
  seats_turnover_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
  trains_fact?: InputMaybe<Number_PropertyFilterInputType>;
  trains_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  trains_plan?: InputMaybe<Number_PropertyFilterInputType>;
  trains_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
  trains_turnover_fact?: InputMaybe<Number_PropertyFilterInputType>;
  trains_turnover_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  trains_turnover_plan?: InputMaybe<Number_PropertyFilterInputType>;
  trains_turnover_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_SchemaControlByBranch_FilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByBranch_BaseFilterInputType>>;
  carriages_fact?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_plan?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_turnover_fact?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_turnover_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_turnover_plan?: InputMaybe<Number_PropertyFilterInputType>;
  carriages_turnover_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  indicators_fact?: InputMaybe<Number_PropertyFilterInputType>;
  indicators_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  indicators_plan?: InputMaybe<Number_PropertyFilterInputType>;
  indicators_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByBranch_BaseFilterInputType>>;
  seats_turnover_fact?: InputMaybe<Number_PropertyFilterInputType>;
  seats_turnover_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  seats_turnover_plan?: InputMaybe<Number_PropertyFilterInputType>;
  seats_turnover_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
  trains_fact?: InputMaybe<Number_PropertyFilterInputType>;
  trains_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  trains_plan?: InputMaybe<Number_PropertyFilterInputType>;
  trains_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
  trains_turnover_fact?: InputMaybe<Number_PropertyFilterInputType>;
  trains_turnover_percentage?: InputMaybe<Number_PropertyFilterInputType>;
  trains_turnover_plan?: InputMaybe<Number_PropertyFilterInputType>;
  trains_turnover_tolerance?: InputMaybe<Number_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_SchemaControlByBranch_SortingInputType = {
  branch_id?: InputMaybe<SortType>;
};

export type ControlSchemaQueryResolver_SchemaControlByTrainsCalculated_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByTrainsCalculated_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByTrainsCalculated_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_SchemaControlByTrainsCalculated_FilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByTrainsCalculated_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByTrainsCalculated_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_SchemaControlByTrains_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByTrains_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_type?: InputMaybe<String_PropertyFilterInputType>;
  carriages_quantity_fact?: InputMaybe<Int_PropertyFilterInputType>;
  carriages_quantity_plan?: InputMaybe<Int_PropertyFilterInputType>;
  carriages_turnover_fact?: InputMaybe<Int_PropertyFilterInputType>;
  carriages_turnover_plan?: InputMaybe<Int_PropertyFilterInputType>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  display_train_number?: InputMaybe<String_PropertyFilterInputType>;
  distance?: InputMaybe<Number_PropertyFilterInputType>;
  indicators_fact?: InputMaybe<Float_PropertyFilterInputType>;
  indicators_plan?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByTrains_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  seats_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  seats_quantity_fact?: InputMaybe<Int_PropertyFilterInputType>;
  seats_quantity_plan?: InputMaybe<Int_PropertyFilterInputType>;
  seats_turnover_fact?: InputMaybe<Int_PropertyFilterInputType>;
  seats_turnover_plan?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  trains_turnover_fact?: InputMaybe<Int_PropertyFilterInputType>;
  trains_turnover_plan?: InputMaybe<Int_PropertyFilterInputType>;
  trips_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_SchemaControlByTrains_FilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByTrains_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_type?: InputMaybe<String_PropertyFilterInputType>;
  carriages_quantity_fact?: InputMaybe<Int_PropertyFilterInputType>;
  carriages_quantity_plan?: InputMaybe<Int_PropertyFilterInputType>;
  carriages_turnover_fact?: InputMaybe<Int_PropertyFilterInputType>;
  carriages_turnover_plan?: InputMaybe<Int_PropertyFilterInputType>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  display_train_number?: InputMaybe<String_PropertyFilterInputType>;
  distance?: InputMaybe<Number_PropertyFilterInputType>;
  indicators_fact?: InputMaybe<Float_PropertyFilterInputType>;
  indicators_plan?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByTrains_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  seats_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  seats_quantity_fact?: InputMaybe<Int_PropertyFilterInputType>;
  seats_quantity_plan?: InputMaybe<Int_PropertyFilterInputType>;
  seats_turnover_fact?: InputMaybe<Int_PropertyFilterInputType>;
  seats_turnover_plan?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  trains_turnover_fact?: InputMaybe<Int_PropertyFilterInputType>;
  trains_turnover_plan?: InputMaybe<Int_PropertyFilterInputType>;
  trips_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_SchemaControlTrainNmrvagList_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlTrainNmrvagList_BaseFilterInputType>>;
  branches?: InputMaybe<Int_PropertyFilterInputType>;
  carriers?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlTrainNmrvagList_BaseFilterInputType>>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_SchemaControlTrainNmrvagList_FilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlTrainNmrvagList_BaseFilterInputType>>;
  branches?: InputMaybe<Int_PropertyFilterInputType>;
  carriers?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlTrainNmrvagList_BaseFilterInputType>>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_TrainsListWithSchemaCarriages_BaseFilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_TrainsListWithSchemaCarriages_BaseFilterInputType>>;
  branches?: InputMaybe<Int_PropertyFilterInputType>;
  carriers?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_TrainsListWithSchemaCarriages_BaseFilterInputType>>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlSchemaQueryResolver_TrainsListWithSchemaCarriages_FilterInputType = {
  and?: InputMaybe<Array<ControlSchemaQueryResolver_TrainsListWithSchemaCarriages_BaseFilterInputType>>;
  branches?: InputMaybe<Int_PropertyFilterInputType>;
  carriers?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<ControlSchemaQueryResolver_TrainsListWithSchemaCarriages_BaseFilterInputType>>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
};

export type ControlSchemaTotalIndicatorsDto = {
  __typename: 'ControlSchemaTotalIndicatorsDto';
  /** Показатели по филиалам */
  branches: Array<ControlSchemaIndicatorBranchDto>;
  /** Название показателя */
  name: Scalars['String']['output'];
};

export type ControlSchemaTrainDateNmrvagDto = {
  __typename: 'ControlSchemaTrainDateNmrvagDto';
  capacity?: Maybe<Scalars['Float']['output']>;
  carriage_quantity?: Maybe<Scalars['Float']['output']>;
  date: Scalars['String']['output'];
  diff?: Maybe<Scalars['Int']['output']>;
  seats_available?: Maybe<Scalars['Int']['output']>;
};

export type ControlSchemaTrainDto = {
  __typename: 'ControlSchemaTrainDto';
  /** id Группы вагонов */
  carriage_group_id?: Maybe<Scalars['Float']['output']>;
  /** id групп вагонов, в которых есть поезд или поезда из основной группы текущего поезда */
  carriage_group_ids?: Maybe<Array<Scalars['Float']['output']>>;
  /** Тип вагона */
  carriage_type?: Maybe<Scalars['String']['output']>;
  /** Составность поездов */
  composition?: Maybe<Array<ControlSchemaCompositionDto>>;
  /** Тип состава */
  composition_type?: Maybe<Scalars['String']['output']>;
  control_schema_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** id группы */
  group_id?: Maybe<Scalars['Int']['output']>;
  /** Филиал */
  haulier_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Показатели перевозок */
  indicators?: Maybe<Array<ControlSchemaIndicatorsDto>>;
  /** Порядковый номер в обороте */
  order_number?: Maybe<Scalars['Float']['output']>;
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция отправления из оборота группы */
  station_group_from?: Maybe<StationDto>;
  /** Станция назначения из оборота группы */
  station_group_to?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
  /** № поезда */
  train_id: Scalars['Int']['output'];
  /** № поезда */
  train_number: Scalars['String']['output'];
  /** Количество составов */
  train_quantities?: Maybe<Scalars['String']['output']>;
  /** Тип группы */
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type ControlSchemaTrainNmrvagDto = {
  __typename: 'ControlSchemaTrainNmrvagDto';
  carriage_groups: Array<ControlSchemaGroupNmrvagDto>;
  date_sync: Scalars['String']['output'];
  dates: Array<ControlSchemaTrainDateNmrvagDto>;
  id: Scalars['Float']['output'];
  is_s3960_loaded: Scalars['Boolean']['output'];
  schema_carriage_quantity?: Maybe<Scalars['Int']['output']>;
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
  train_number: Scalars['String']['output'];
};

export type CopyCarriageParameterDto = {
  /** Идентификатор ГВ параметра вагона */
  carriage_group_id: Scalars['Float']['input'];
  /** Идентификатор параметра вагона */
  carriage_parameter_id: Scalars['Float']['input'];
};

export type CopyMetaDto = {
  __typename: 'CopyMetaDto';
  /** Id поезда в прямом направлении */
  direct_train_id: Scalars['Int']['output'];
  /** Номер поезда в прямом направлении */
  direct_train_number: Scalars['String']['output'];
  /** end_at из ГДП */
  gdp_end_at?: Maybe<Scalars['String']['output']>;
  /** start_at из ГДП */
  gdp_start_at?: Maybe<Scalars['String']['output']>;
  /** Первая строка из gvc файла, если расписание экспортировано */
  gvc_name?: Maybe<Scalars['String']['output']>;
  /** Id поезда в обратном направлении */
  reverse_train_id?: Maybe<Scalars['Int']['output']>;
  /** Номер поезда в обратном направлении */
  reverse_train_number?: Maybe<Scalars['String']['output']>;
  /** Дата создания */
  schedule_crate_date: Scalars['String']['output'];
};

export type CopyScheduleDto = {
  /** Идентификатор поезда, расписание которого нужно скопировать */
  trainFromId: Scalars['Int']['input'];
  /** Идентификатор поезда, принимающего расписание */
  trainToId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAvailableServiceClassDto = {
  /** Класс обслуживания */
  service_class: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateBranchDto = {
  /** Полное название */
  name: Scalars['String']['input'];
  /** Наименование в nmrvag (ЦСУ) */
  name_nmrvag: Scalars['String']['input'];
  /** Принадлежность ЖД дорог */
  railways_ids: Array<Scalars['Int']['input']>;
  /** Краткое название */
  short_name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Код в nmrvag (ЦСУ) */
  vladr: Scalars['String']['input'];
};

export type CreateCudTrainSchemaDto = {
  /** Информация для добавление в блоке станции пограничного и таможенного контроля */
  border_control?: InputMaybe<Array<CreateTrainSchemaNoteForStationDto>>;
  /** Информация для добавление в блоке нумерация вагонов в пути следования */
  carriage_numerations?: InputMaybe<Array<CreateCarriageNumerationDto>>;
  /** Информация для добавление в блоке ЭЧТК */
  eco_toilets?: InputMaybe<Array<CreateTrainSchemaNoteForStationDto>>;
  /** Информация для добавление в блоке установленная схема поезда по станциям */
  established_train_schema_railways?: InputMaybe<Array<CreateEstablishedTrainSchemaRailwayDto>>;
  /** Информация для добавление в блоке установленная схема поезда по станциям */
  established_train_schema_stations?: InputMaybe<Array<CreateEstablishedTrainSchemaStationDto>>;
  /** Информация для добавление в блоке станции снабжения топливом */
  fuel_supply?: InputMaybe<Array<CreateTrainSchemaNoteForStationDto>>;
  /** Информация для добавление в блоке смена локомотива без смены локомотивной команды */
  locomotive_change?: InputMaybe<Array<CreateTrainSchemaNoteForStationDto>>;
  /** Информация для добавление в блоке смена локомотивной команды */
  locomotive_team_change?: InputMaybe<Array<CreateTrainSchemaNoteForStationDto>>;
  /** Информация для добавление в блоке станции выполнения маневровых работ водой */
  maneuvering_work?: InputMaybe<Array<CreateTrainSchemaNoteForStationDto>>;
  /** Информация для добавление в блоке максимальная длина поезда по жд */
  max_train_length_railways?: InputMaybe<Array<CreateMaxTrainLengthRailwayDto>>;
  /** Информация для добавление в блоке максимальная длина поезда по станциям */
  max_train_length_stations?: InputMaybe<Array<CreateMaxTrainLengthStationDto>>;
  /** Информация для добавление в блоке смена направления движения поезда */
  train_change_directions?: InputMaybe<Array<CreateTrainSchemaNoteForStationDto>>;
  /** Информация для добавление в блоке станции сбора ТБО и шлака */
  waste_collection?: InputMaybe<Array<CreateTrainSchemaNoteForStationDto>>;
  /** Информация для добавление в блоке станции снабжения водой */
  water_supply?: InputMaybe<Array<CreateTrainSchemaNoteForStationDto>>;
};

export type CreateCarriageAdditionalSeatSignDto = {
  /** Тип класса */
  name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateCarriageGroupCarriageTypeIndicatorsDto = {
  /** Идентификатор типа вагонов */
  carriage_type_id: Scalars['Int']['input'];
  dates: Array<CreateCarriageTypeDatesDto>;
};

export type CreateCarriageGroupDto = {
  /** Идентификатор филиала */
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор графика движения поездов */
  gdp_id: Scalars['Int']['input'];
  /** Наименование группы вагонов */
  name: Scalars['String']['input'];
  /** Идентификатор перевозчика */
  passenger_carriers_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор ж/д администрации */
  railway_administration_id: Scalars['Int']['input'];
  /** Типа подвижного состава */
  rolling_stock_type: Scalars['String']['input'];
  /** Идентификатор предприятия приписки */
  structural_subdivision_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCarriageMvpsDto = {
  /** Идентификатор филиала приписки */
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Длина состава в миллиметрах */
  lineup_length?: InputMaybe<Scalars['Float']['input']>;
  /** Идентификатор вида секций МВПС */
  mvps_section_type_id: Scalars['Int']['input'];
  /** Идентификатор перевозчика */
  passenger_carriers_russian_railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор ЖД администрации */
  railway_administration_id: Scalars['Int']['input'];
  /** Массив идентификаторов вагонов и мест в них */
  rows: Array<CreateCarriageMvpsItemDto>;
  /** Идентификатор структурного подразделения филиала приписки */
  structural_subdivision_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCarriageMvpsItemDto = {
  /** Идентификатор типа вагона */
  carriage_type_id: Scalars['Int']['input'];
  /** Количество мест в вагоне */
  seats_quantity: Scalars['Int']['input'];
};

export type CreateCarriageNpsDto = {
  /** Идентификатор филиала приписки */
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор типа тормозов */
  carriage_brake_type_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор габаритов подвижного состава */
  carriage_dimension_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Идентификатор вида отопления */
  carriage_heat_type_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор длины вагона */
  carriage_length_id: Scalars['Int']['input'];
  /** Идентификатор модели вагона */
  carriage_model_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор типа вагона в АСУ ПВ */
  carriage_type_asu_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор типа вагона */
  carriage_type_id: Scalars['Int']['input'];
  /** Признак наличия кондиционера */
  is_air_conditioner: Scalars['Boolean']['input'];
  /** Признак наличия централизованного электропитания */
  is_centralized_power_supply: Scalars['Boolean']['input'];
  /** Признак наличия ЭЧТК */
  is_eco_toilets: Scalars['Boolean']['input'];
  /** Идентификатор перевозчика */
  passenger_carriers_russian_railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор ЖД администрации */
  railway_administration_id: Scalars['Int']['input'];
  /** № вагона с головы относительно которого производиться добавление нового вагона */
  relative_number_from_head?: InputMaybe<Scalars['Int']['input']>;
  /** Количество мест в вагоне */
  seats_quantity: Scalars['Int']['input'];
  /** Идентификатор структурного подразделения филиала приписки */
  structural_subdivision_id?: InputMaybe<Scalars['Int']['input']>;
  /** Расположение выше или ниже относительного порядкового номера вагона: true - вставить выше, false - вставить ниже */
  up?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCarriageNumerationDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции отправления для прямого поезда */
  direct_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Позиция для прямого поезда */
  direct_position?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции прибытия для прямого поезда */
  direct_to_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции отправления для обратного поезда */
  reverse_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Позиция для обратного поезда */
  reverse_position?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции прибытия для обратного поезда */
  reverse_to_station_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCarriageSeatAllocationDto = {
  /** Тип выделения мест */
  name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateCarriageServiceClassDto = {
  /** Доступные классы сервиса */
  available_service_classes_ids: Array<Scalars['Int']['input']>;
  /** id типа вагона */
  carriage_types_for_schema_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateCarriageTypeAsuDimensionSeatsCountDto = {
  /** carriage_dimension_id - Идентификатор габарита вагона */
  carriage_dimension_id: Scalars['Int']['input'];
  /** carriage_type_asu_id - Идентификатор типа вагона АСУПВ */
  carriage_type_asu_id: Scalars['Int']['input'];
  /** Стандартное количество мест */
  default_seats_count: Scalars['Int']['input'];
};

export type CreateCarriageTypeAsuDto = {
  /** Полное название */
  full_name: Scalars['String']['input'];
  /** Краткое название */
  short_name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateCarriageTypeDatesDto = {
  /** Количество вагонов */
  carriages_quantity: Scalars['Int']['input'];
  /** Дата */
  date: Scalars['String']['input'];
};

export type CreateCarriageTypeDto = {
  /** Id типа вагона для внесения в схему */
  carriage_types_for_schema_id: Scalars['Int']['input'];
  /** Id мнемоники сектора регулирования */
  regulatory_sector_mnemonic_id: Scalars['Int']['input'];
  /** Id мнемоники вида подвижного состава */
  rolling_stock_type_mnemonic_id: Scalars['Int']['input'];
  /** Id мнемоники типа вагона по местам для отображения в схеме */
  seat_type_mnemonic_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateCarriageTypesForSchemaDto = {
  /** Тип вагона */
  carriage_type_asu_id?: InputMaybe<Scalars['Int']['input']>;
  /** Описание */
  description: Scalars['String']['input'];
  /** Название */
  name: Scalars['String']['input'];
};

export type CreateConditionalCarriageNumberDto = {
  /** Условный номер вагона */
  conditional_carriage_number: Scalars['Int']['input'];
};

export type CreateCsuCarriageTypeDto = {
  /** Наименование */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  name: Scalars['String']['input'];
  /** Роли пользователя */
  subtypes: Array<Scalars['Int']['input']>;
  /** Тип вагонов ЦСУ */
  type: Scalars['String']['input'];
};

export type CreateDivisionDto = {
  name: Scalars['String']['input'];
};

export type CreateEstablishedTrainSchemaRailwayDto = {
  /** Примечание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор железной дороги для прямого направления */
  direct_railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор железной дороги для обратного направления */
  reverse_railway_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateEstablishedTrainSchemaStationDto = {
  /** Примечание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции отправления для прямого направления */
  direct_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции прибытия для прямого направления */
  direct_to_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции отправления для обратного направления */
  reverse_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции прибытия для обратного направления */
  reverse_to_station_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateGdpDto = {
  /** Действует по */
  end_at: Scalars['String']['input'];
  /** Действует с */
  start_at: Scalars['String']['input'];
};

export type CreateInfrastructureCoefficientIndexingDto = {
  /** Коэффициент */
  coefficient: Scalars['Float']['input'];
  /** Действует с */
  start_at: Scalars['DateTime']['input'];
};

export type CreateLocomotivePriceTechnicalServiceDto = {
  /** ID серии локомотивов */
  locomotives_series_id: Scalars['Int']['input'];
  /** Стоимость обслуживания */
  maintenance_cost?: InputMaybe<Scalars['Float']['input']>;
  /** ID рода службы локомотива */
  series_type_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** ID дирекции тяги */
  traction_directorates_id: Scalars['Int']['input'];
};

export type CreateLocomotiveSeriesDto = {
  /** Индекс */
  index: Scalars['String']['input'];
  /** Id типа тяги */
  locomotive_traction_type_id?: InputMaybe<Scalars['Int']['input']>;
  /** Цена аренды */
  price_rent?: InputMaybe<Scalars['Float']['input']>;
  /** Количество секций */
  section_quantity: Scalars['Int']['input'];
  /** Серия */
  series: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateLocomotiveServiceEmpiricalParameterDto = {
  /** ID эмпирического параметра локомотивного обслуживания */
  mnemonic_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Единица измерения эмпирического параметра локомотивного обслуживания */
  value: Scalars['Float']['input'];
};

export type CreateLocomotiveTeamPriceRentDto = {
  /** Стоимость аренды лок. бригады электровоза при работе в 1 лицо */
  price_electric_locomotive_one_person: Scalars['Float']['input'];
  /** Стоимость аренды лок. бригады электровоза при работе в 2 лица */
  price_electric_locomotive_two_person: Scalars['Float']['input'];
  /** Стоимость аренды лок. бригады тепловоза при работе в 1 лицо */
  price_warm_locomotive_one_person: Scalars['Float']['input'];
  /** Стоимость аренды лок. бригады тепловоза при работе в 2 лица */
  price_warm_locomotive_two_person: Scalars['Float']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** ID Дирекции тяги */
  traction_directorates_id: Scalars['Int']['input'];
};

export type CreateMaxTrainLengthRailwayDto = {
  /** Примечание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор железной дороги для прямого направления */
  direct_railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор железной дороги для обратного направления */
  reverse_railway_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMaxTrainLengthStationDto = {
  /** Примечание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции отправления для прямого направления */
  direct_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции прибытия для прямого направления */
  direct_to_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции отправления для обратного направления */
  reverse_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции прибытия для обратного направления */
  reverse_to_station_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMaxTrainSpeedDto = {
  /** Максимальная скорость поезда */
  max_train_speed: Scalars['Float']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateMvpsCompanyAffiliationDto = {
  /** Наименование */
  mvps_owner: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateMvpsMartinSectionTypeDto = {
  /** Количество вагонов в одной секции */
  carriage_quantity_in_section: Scalars['Float']['input'];
  /** ID комплектации МВПС */
  mvps_martin_section_type_equipment_id: Scalars['Int']['input'];
  /** Ставка аренды руб. */
  price: Scalars['Float']['input'];
  /** Серия */
  series: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateMvpsMartinSectionTypeEquipmentDto = {
  /** Комплектация */
  equipment: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateMvpsRateManagementExploitationMaintenanceRepairDto = {
  /** ID типа ставки */
  mnemonic_id: Scalars['Int']['input'];
  /** Ставка аренды, руб. */
  price: Scalars['Float']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateNonPassengerCarriageTypeDto = {
  /** Идентификатор типа вагона */
  carriage_types_for_schema_id: Scalars['Int']['input'];
  /** Массив идентификаторов условных номеров вагонов */
  conditional_carriage_number_ids: Array<Scalars['Int']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateNpsCarriageBrakeTypeDto = {
  /** Тормоз */
  brake_type: Scalars['String']['input'];
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateNpsCarriageDimensionDto = {
  /** Габарит */
  carriage_dimension: Scalars['String']['input'];
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateNpsCarriageHeatTypeDto = {
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Вид отопления */
  heat_type: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateNpsCarriageLengthDto = {
  /** Длина вагонов в АСУ ПВ(мм) */
  carriage_length_asu_ms: Scalars['Float']['input'];
  /** Длина вагона в схеме поезда(м) */
  carriage_length_in_train_schema: Scalars['Float']['input'];
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateNpsCarriageModelDto = {
  /** Модель */
  carriage_model: Scalars['String']['input'];
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateOtherTrainsDto = {
  /** Идентификатор станции отправления */
  from_station_id: Scalars['Int']['input'];
  /** Идентификатор станции назначения */
  to_station_id: Scalars['Int']['input'];
  /** Идентификатор поезда */
  train_id: Scalars['Int']['input'];
};

export type CreatePassengerCarrierDto = {
  /** Код пассажирского перевозчика */
  code: Scalars['Int']['input'];
  /** Код государства (GOS ЦСУ) */
  gos: Scalars['Int']['input'];
  /** MNKODP (ЦСУ) */
  mnkodp: Scalars['String']['input'];
  /** Название */
  name: Scalars['String']['input'];
  /** Краткое название */
  short_name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreatePeriodicityDto = {
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Дата и время начала курсирования */
  from_date: Scalars['String']['input'];
  /** Массив элементов выбранной периодичности */
  metadata: Array<Scalars['String']['input']>;
  /** Периодичность */
  periodicity: Scalars['String']['input'];
  /** Дата и время окончания курсирования */
  to_date: Scalars['String']['input'];
};

export type CreatePeriodicitySeasonDto = {
  /** Сезонность */
  periodicity_season: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateRailwayAdministrationDto = {
  /** Код */
  code: Scalars['Float']['input'];
  /** Флаг СНГ или Дальнее зарубежье */
  international_mnemonic?: InputMaybe<Scalars['String']['input']>;
  /** Название */
  name: Scalars['String']['input'];
  /** Краткое название */
  short_name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateRailwayDto = {
  /** Код железной дороги */
  code: Scalars['String']['input'];
  /** Наименование железной дороги */
  name: Scalars['String']['input'];
  /** Идентификатор ЖД администрации */
  railway_administration_id: Scalars['Float']['input'];
  /** Сокращённое наименование железной дороги */
  short_name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Таймзона железной дороги относительно МСК времени */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoutesControlAvailabilitySeatsDirectionsDto = {
  /** Назначение направления */
  arrival_direction_id: Scalars['Int']['input'];
  /** Назначение станции */
  arrival_stations_ids: Array<Scalars['Int']['input']>;
  /** Отправление направления */
  departure_direction_id: Scalars['Int']['input'];
  /** Отправление станция */
  departure_stations_ids: Array<Scalars['Int']['input']>;
};

export type CreateRuleDto = {
  disabled: Scalars['Boolean']['input'];
  /** Метод */
  method: Scalars['String']['input'];
  /** Id модуля */
  module_id: Scalars['Float']['input'];
};

export type CreateStationDto = {
  /** Комментарий */
  comment: Scalars['String']['input'];
  /** Код станции ЕСР */
  esr_code?: InputMaybe<Scalars['String']['input']>;
  /** Экспресс код станции */
  express_code: Scalars['String']['input'];
  /** Название станции */
  full_name: Scalars['String']['input'];
  /** Возможность посадки/высадки пассажиров */
  is_board_or_disembark?: InputMaybe<Scalars['Boolean']['input']>;
  /** Осуществление пограничного и таможенного контроля */
  is_border_control?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена локомотива */
  is_change_locomotive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена локомотивной бригады без смены локомотива */
  is_change_locomotive_team?: InputMaybe<Scalars['Boolean']['input']>;
  /** Флаг города для топовых направлений */
  is_city?: InputMaybe<Scalars['Boolean']['input']>;
  /** Обслуживание экологически чистых туалетных комплексов (ЭЧТК) */
  is_eco_toilets?: InputMaybe<Scalars['Boolean']['input']>;
  /** Наличие электрических колонок 380В */
  is_electric_speakers_380V?: InputMaybe<Scalars['Boolean']['input']>;
  /** Наличие электрических колонок 3000В */
  is_electric_speakers_3000V?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена рода тока по станции (постоянный/переменный) */
  is_electricity_type?: InputMaybe<Scalars['Boolean']['input']>;
  /** Снабжение топливом */
  is_fuel_supply?: InputMaybe<Scalars['Boolean']['input']>;
  /** станция разрешённая для маневровой работы */
  is_maneuver_work?: InputMaybe<Scalars['Boolean']['input']>;
  /** Флаг "Вокзал не пренадлежит РЖД" */
  is_not_terminal_rgd?: InputMaybe<Scalars['Boolean']['input']>;
  /** Является ли станция маршрутообразующей */
  is_route_forming?: InputMaybe<Scalars['Boolean']['input']>;
  /** Обслуживание не по маршруту поезда */
  is_service_not_train_route?: InputMaybe<Scalars['Boolean']['input']>;
  /** Флаг "Южное направление" */
  is_southbound?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена вида тяги по станции (электровозная/тепловозная) */
  is_traction_type?: InputMaybe<Scalars['Boolean']['input']>;
  /** Сбор твёрдых бытовых отходов (ТБО) и шлака */
  is_waste_collection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Снабжение водой */
  is_water_supply?: InputMaybe<Scalars['Boolean']['input']>;
  /** Наименование станции для схемы */
  name_for_schema?: InputMaybe<Scalars['String']['input']>;
  /** ID железной дороги */
  railway_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateStructuralSubdivisionDto = {
  /** Идентификатор филиала */
  branch_id: Scalars['Int']['input'];
  /** Краткое наименование */
  short_name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Идентификатор станции */
  station_id: Scalars['Int']['input'];
};

export type CreateTractionDirectorateDto = {
  /** Флаг участия в расчетах ЛО */
  is_not_in_calculation: Scalars['Boolean']['input'];
  /** Название региональной дирекции тяги */
  name: Scalars['String']['input'];
  /** ID железной дороги */
  railway_id: Scalars['Int']['input'];
  /** Краткое наименование региональной дирекции тяги */
  short_name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateTrailedDirectGroupDto = {
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Идентификатор первого фрагмента графика оборота группы при следовании в прямом направлении */
  direct_turnover_from_id: Scalars['Int']['input'];
  /** Идентификатор последнего фрагмента графика оборота группы при следовании в прямом направлении */
  direct_turnover_to_id: Scalars['Int']['input'];
  /** Идентификатор графика движения поездов */
  gdp_id: Scalars['Int']['input'];
  /** Идентификатор первого фрагмента графика оборота группы при следовании в обратном направлении */
  reverse_turnover_from_id: Scalars['Int']['input'];
  /** Идентификатор последнего фрагмента графика оборота группы при следовании в обратном направлении */
  reverse_turnover_to_id: Scalars['Int']['input'];
  /** Вид подвижного состава */
  rolling_stock_type: Scalars['String']['input'];
};

export type CreateTrainBrandDto = {
  /** Цвет наименования */
  background_color: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Наименование */
  train_brand: Scalars['String']['input'];
};

export type CreateTrainCategoryDto = {
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Категория поезда */
  train_category: Scalars['String']['input'];
};

export type CreateTrainDto = {
  /** direct trains */
  direct: CreateTrainSingleDto;
  /** reverse trains */
  reverse?: InputMaybe<CreateTrainSingleDto>;
};

export type CreateTrainScheduleDto = {
  /** Массив идентификатов поездов для которых создаётся расписание */
  train_ids: Array<Scalars['Int']['input']>;
  /** Фрагменты расписания */
  train_schedule_fragments: Array<CreateTrainScheduleFragmentDto>;
};

export type CreateTrainScheduleFragmentDto = {
  /** Время прибытия поезда прямого направления на станцию */
  direct_arrival?: InputMaybe<Scalars['Float']['input']>;
  /** Время отправления поезда прямого направления на станцию */
  direct_departure?: InputMaybe<Scalars['Float']['input']>;
  /** Время стоянки поезда прямого направления на станцию */
  direct_parking?: InputMaybe<Scalars['Float']['input']>;
  /** Номер поезда на данной станции в прямом направлении */
  direct_train_number: Scalars['String']['input'];
  /** Данные из таблицы расстояние между станциями */
  distance: Scalars['Float']['input'];
  /** Признак технической стоянки туда */
  is_direct_schedule_technical_parking: Scalars['Boolean']['input'];
  /** Признак технической стоянки обратно */
  is_reverse_schedule_technical_parking: Scalars['Boolean']['input'];
  /** Порядковый номер фрагмента расписания */
  order_number: Scalars['Int']['input'];
  /** Время прибытия поезда обратного направления на станцию */
  reverse_arrival?: InputMaybe<Scalars['Float']['input']>;
  /** Время отправления поезда обратного направления на станцию */
  reverse_departure?: InputMaybe<Scalars['Float']['input']>;
  /** Время стоянки поезда обратного направления на станции */
  reverse_parking?: InputMaybe<Scalars['Float']['input']>;
  /** Номер поезда на данной станции в обратном направлении */
  reverse_train_number?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции */
  station_id: Scalars['Float']['input'];
};

export type CreateTrainSchemaDto = {
  /** Идентификаторы поездов */
  train_ids: Array<Scalars['Int']['input']>;
};

export type CreateTrainSchemaNoteForStationDto = {
  /** Примечание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Направление */
  direction: Scalars['String']['input'];
  /** Идентификатор станции */
  for_station_id: Scalars['Int']['input'];
};

export type CreateTrainSingleDto = {
  /** Дата и время прибытия */
  arrival_time?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор филиала */
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  /** Дата и время отправления */
  departure_time?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции отправления */
  from_station_id: Scalars['Int']['input'];
  /** Идентификатор графика движения поездов */
  gdp_id: Scalars['Int']['input'];
  /** Индивидуальное наименование */
  individual_name: Scalars['String']['input'];
  /** Является ли поезд "Дневным" */
  is_daytime?: InputMaybe<Scalars['Boolean']['input']>;
  /** дополнительный признак, который отображает несёт ли АО «ФПК» расходы на оплату услуг инфраструктуры */
  is_excluded_from_calculation_infrastructure_cost: Scalars['Boolean']['input'];
  /** Выводится ли в форму запроса */
  is_included_in_request_form?: Scalars['Boolean']['input'];
  /** Является ли поезд главным */
  is_main: Scalars['Boolean']['input'];
  /** Выводить периодичность отдельно по каждой схеме в форме запроса */
  is_periodicity_separate_request_form?: Scalars['Boolean']['input'];
  /** Идентификатор максимальной скорости поезда */
  max_train_speed_id?: InputMaybe<Scalars['Int']['input']>;
  /** Примечание */
  note?: InputMaybe<Scalars['String']['input']>;
  other_trains?: InputMaybe<Array<CreateOtherTrainsDto>>;
  /** Примечание к иным поездам */
  other_trains_note?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор перевозчика */
  passenger_carrier_russian_railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор периодичности */
  periodicity?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор сезонности */
  periodicity_season_id: Scalars['Int']['input'];
  /** Идентификатор ж/д администрации */
  railway_administration_id: Scalars['Int']['input'];
  /** Станции переприцепки */
  stations_recoupling?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции назначения */
  to_station_id: Scalars['Int']['input'];
  /** Идентификатор фирменности */
  train_brand_id: Scalars['Int']['input'];
  /** Номер поезда */
  train_number: Scalars['String']['input'];
  /** Идентификатор подкатегории поезда */
  train_sub_category_id: Scalars['Int']['input'];
};

export type CreateTrainSubCategoriesDetailsSpeedDto = {
  /** Название подкатегории */
  name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Номера поездов */
  train_numbers_range: Scalars['String']['input'];
  /** Идентификатор категории */
  train_sub_category_id: Scalars['Int']['input'];
};

export type CreateTrainSubCategoryDto = {
  /** Цвет названия подкатегории */
  background_color: Scalars['String']['input'];
  /** Краткое название подкатегории */
  short_train_sub_category: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Идентификатор категории */
  train_category_id: Scalars['Int']['input'];
  /** Номера поездов */
  train_numbers_range: Scalars['String']['input'];
  /** Название подкатегории */
  train_sub_category: Scalars['String']['input'];
};

export type CreateTransportationPerformanceIndicatorDto = {
  /** Наименование */
  name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Единица измерения */
  unit: Scalars['String']['input'];
  /** Единица измерения(кратко) */
  unit_short: Scalars['String']['input'];
};

export type CreateTurnoverDto = {
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Признак группы */
  group_sign: Scalars['String']['input'];
  /** Расположение */
  position?: InputMaybe<Scalars['String']['input']>;
  /** Порядковый номер оборотки в группе вагонов относительно которой производиться добавление новой оборотки */
  relative_order_number?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции отправления */
  station_from_id: Scalars['Int']['input'];
  /** Идентификатор станции назначения */
  station_to_id: Scalars['Int']['input'];
  /** Идентификатор поезда */
  train_id: Scalars['Int']['input'];
  /** Идентификаторы схем */
  train_schema_ids: Array<Scalars['Int']['input']>;
  /** Расположение выше или ниже относительного порядкового номера оборотки: true - вставить выше, false - вставить ниже */
  up: Scalars['Boolean']['input'];
};

export type CreateTurnoverTimeStagnationDto = {
  /** Массив дат прибытия на станцию отцепки для временного признака перестоя */
  arrival_dates: Array<Scalars['String']['input']>;
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Является ли признак перестоя переменным */
  is_time_stagnation_variable: Scalars['Boolean']['input'];
  /** Время перестоя группы в часах */
  time_in_stagnation: Scalars['Float']['input'];
  /** Идентификатор периодичности */
  turnover_id: Scalars['Int']['input'];
};

export type CreateUserDto = {
  /** Id филиала */
  branch_id?: InputMaybe<Scalars['Float']['input']>;
  /** Активность */
  disabled: Scalars['Boolean']['input'];
  /** Id филиала */
  division_id?: InputMaybe<Scalars['Float']['input']>;
  /** электронный почтовый адрес (e-mail) */
  email: Scalars['String']['input'];
  /** Дата окончания действия */
  expiration_date: Scalars['String']['input'];
  /** Польное имя сотрудника */
  full_name: Scalars['String']['input'];
  /** Должность */
  job_position: Scalars['String']['input'];
  /** Пароль */
  password: Scalars['String']['input'];
  /** Табельный номер сотрудника */
  personal_number?: InputMaybe<Scalars['Float']['input']>;
  /** Номер телефона */
  phone_number: Scalars['String']['input'];
  /** Роли пользователя */
  role_ids: Array<Scalars['Float']['input']>;
  /** Персональные правила пользователя */
  rule_ids: Array<Scalars['Float']['input']>;
  /** Логин */
  user_name: Scalars['String']['input'];
};

export type CreateVersionBranchDto = {
  /** Entity_id сущности */
  entity_id: Scalars['Int']['input'];
  /** Полное название */
  name: Scalars['String']['input'];
  /** Наименование в nmrvag (ЦСУ) */
  name_nmrvag: Scalars['String']['input'];
  /** Принадлежность ЖД дорог */
  railways_ids: Array<Scalars['Int']['input']>;
  /** Краткое название */
  short_name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Код в nmrvag (ЦСУ) */
  vladr: Scalars['String']['input'];
};

export type CreateVersionDto = {
  /** Идентификатор текущего ГДП */
  current_gdp_id: Scalars['Int']['input'];
  /** Идентификатор ГДП */
  gdp_id: Scalars['Int']['input'];
  /** Создать ли копии для всех поездов */
  is_copy_all_trains: Scalars['Boolean']['input'];
  /** Создание версии недостающей пары поездов */
  is_create_version_for_missed_trains: Scalars['Boolean']['input'];
  /** Дата начала действия */
  start_at: Scalars['String']['input'];
  /** Идентификаторы поездов */
  train_ids: Array<Scalars['Int']['input']>;
};

export type CreateVersionPassengerCarrierDto = {
  /** Код пассажирского перевозчика */
  code: Scalars['Int']['input'];
  /** Entity_id сущности */
  entity_id: Scalars['Int']['input'];
  /** Код государства (GOS ЦСУ) */
  gos: Scalars['Int']['input'];
  /** MNKODP (ЦСУ) */
  mnkodp: Scalars['String']['input'];
  /** Название */
  name: Scalars['String']['input'];
  /** Краткое название */
  short_name: Scalars['String']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type CreateVersionResponseDto = {
  __typename: 'CreateVersionResponseDto';
  /** Ошибка */
  error_message?: Maybe<Scalars['String']['output']>;
  /** Массив идентификаторов созданных поездов */
  train_ids: Array<Scalars['Int']['output']>;
};

export type CruisingOrderDto = {
  __typename: 'CruisingOrderDto';
  /** Строка таблицы */
  items: Array<CruisingOrderItemDto>;
  /** Маршруты вагонной группы */
  route: Array<EmphasizedStationItemDto>;
  /** Признак группы */
  sign: Scalars['String']['output'];
  /** Номера поездов */
  train_numbers: Array<EmphasizedTrainItemDto>;
};

export type CruisingOrderItemDto = {
  __typename: 'CruisingOrderItemDto';
  /** Расстояние для поезда */
  distance: Scalars['Float']['output'];
  station_carriage_group_from: StationDto;
  station_carriage_group_to: StationDto;
  station_train_from: StationDto;
  station_train_to: StationDto;
  /** № поезда */
  train_number: Scalars['String']['output'];
};

export type CsuCarriageTypeDto = {
  __typename: 'CsuCarriageTypeDto';
  /** комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Наименование */
  name: Scalars['String']['output'];
  /** Подтипы вагонов ЦСУ */
  subtypes: Array<Scalars['Int']['output']>;
  /** Тип вагонов ЦСУ */
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CsuCarriageTypeList = {
  __typename: 'CsuCarriageTypeList';
  items: Array<CsuCarriageTypeDto>;
  totalCount: Scalars['Float']['output'];
};

export type CsuCarriageTypeMutationEntryPoint = {
  __typename: 'CsuCarriageTypeMutationEntryPoint';
  /** Добавить тип вагона */
  create: CsuCarriageTypeDto;
  /** Обновить тип вагона */
  update: CsuCarriageTypeDto;
};


export type CsuCarriageTypeMutationEntryPointCreateArgs = {
  data: CreateCsuCarriageTypeDto;
};


export type CsuCarriageTypeMutationEntryPointUpdateArgs = {
  data: UpdateCsuCarriageTypeDto;
};

export type CsuCarriageTypeQueryEntryPoint = {
  __typename: 'CsuCarriageTypeQueryEntryPoint';
  /** Список типов вагонов */
  list: CsuCarriageTypeList;
};


export type CsuCarriageTypeQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<CsuCarriageTypeQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CsuCarriageTypeQueryResolver_List_FilterInputType>;
};

export type CsuCarriageTypeQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<CsuCarriageTypeQueryResolver_List_BaseFilterInputType>>;
  comment?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CsuCarriageTypeQueryResolver_List_BaseFilterInputType>>;
  subtypes?: InputMaybe<Int_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CsuCarriageTypeQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<CsuCarriageTypeQueryResolver_List_BaseFilterInputType>>;
  comment?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CsuCarriageTypeQueryResolver_List_BaseFilterInputType>>;
  subtypes?: InputMaybe<Int_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CsuCarriageTypeQueryResolver_List_SortingInputType = {
  comment?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  subtypes?: InputMaybe<SortType>;
  type?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type CsuCarrierDto = {
  __typename: 'CsuCarrierDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Название */
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type CsuCarrierList = {
  __typename: 'CsuCarrierList';
  items: Array<CsuCarrierDto>;
  totalCount: Scalars['Float']['output'];
};

export type CsuCarrierQueryEntryPoint = {
  __typename: 'CsuCarrierQueryEntryPoint';
  /** Список пассажирских перевозчиков из цсу */
  list: CsuCarrierList;
};


export type CsuCarrierQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<CsuCarrierQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<CsuCarrierQueryResolver_List_FilterInputType>;
};

export type CsuCarrierQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<CsuCarrierQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CsuCarrierQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CsuCarrierQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<CsuCarrierQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CsuCarrierQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type CsuCarrierQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type DashboardDataDto = {
  /** идентификатор ГДП */
  gdp_id: Scalars['Int']['input'];
  /** статус поездов */
  status: Scalars['String']['input'];
};

export type DashboardDto = {
  __typename: 'DashboardDto';
  /** Третий блок дашборда - Филиал АО ФПК */
  branches_trains: BranchesTrainsDto;
  /** Дата формирования дашборда */
  created_at: Scalars['String']['output'];
  /** Первый блок дашборда - поезда АО ФПК */
  fpk_trains: FpkTrainsDto;
  gdp: GdpDto;
  /** Второй блок дашборда - Другие поезда */
  other_trains: RestTotalTrainsDto;
  /** Статус данных в дашборде */
  status: Scalars['String']['output'];
};

export type Date_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  in_arr?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notbetween?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  notin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DatesRequestDto = {
  from_date: Scalars['String']['input'];
  to_date: Scalars['String']['input'];
};

export type DeclineCarriageGroupRequestDto = {
  /** Комментарий отклонения ГВ из схемы */
  comment: Scalars['String']['input'];
  table_block_id: Scalars['Int']['input'];
  train_schema_id: Scalars['Int']['input'];
};

export type DeclineHistoryDto = {
  __typename: 'DeclineHistoryDto';
  /** Комментарий отклонения */
  comment: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  user: UserDto;
};

export type DeleteCudTrainSchemaDto = {
  border_control_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  carriage_numeration_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  eco_toilet_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  established_train_schema_railway_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  established_train_schema_station_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  fuel_supply_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  locomotive_change_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  locomotive_team_change_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  maneuvering_work_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  max_train_length_railway_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  max_train_length_station_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  train_change_direction_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  waste_collection_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  water_supply_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DeleteCarriageParameter = {
  /** Id группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Id параметров вагона */
  id: Scalars['Int']['input'];
};

export type DeletePeriodicityDto = {
  carriage_group_id: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type DeleteTrainSchemaDto = {
  /** Идентификатор схемы */
  id: Scalars['Int']['input'];
  /** Идентификаторы поездов */
  train_ids: Array<Scalars['Int']['input']>;
};

export type DeleteTurnoverDto = {
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Идентификатор оборотки */
  id: Scalars['Int']['input'];
};

export type DeleteTurnoverTimeStagnationDto = {
  carriage_group_id: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  /** Идентификатор периодичности */
  turnover_id: Scalars['Int']['input'];
};

export type DeleteUserDto = {
  id: Scalars['Float']['input'];
};

export type DirectCarriageDto = {
  __typename: 'DirectCarriageDto';
  /** Номера вагонов */
  carriage_numbers: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  direct_carriages_info: Array<DirectCarriageInfoDto>;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type DirectCarriageInfoDto = {
  __typename: 'DirectCarriageInfoDto';
  /** Массив дат прибытий на станцию */
  arrival_dates: Array<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Массив дат отправлений со станции */
  departure_dates: Array<Scalars['String']['output']>;
  from_station: StationDto;
  id: Scalars['Int']['output'];
  /** Массив дат прибытий на станцию, в которые поезд не ходит или выходят за рамки текущего ГДП */
  missed_arrival_dates: Array<Scalars['String']['output']>;
  /** Массив дат отправлений со станции, в которые поезд не ходит или выходят за рамки текущего ГДП */
  missed_departure_dates: Array<Scalars['String']['output']>;
  /** Расположение группы по отправлению */
  position_from_station: Scalars['String']['output'];
  /** Расположение группы по прибытию */
  position_to_station: Scalars['String']['output'];
  to_station: StationDto;
  train: TrainDto;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type DivisionDto = {
  __typename: 'DivisionDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: DivisionGroupDto;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type DivisionGroupDto = {
  __typename: 'DivisionGroupDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rules: Array<RuleDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type DivisionList = {
  __typename: 'DivisionList';
  items: Array<DivisionDto>;
  totalCount: Scalars['Float']['output'];
};

export type EcoToiletDto = {
  __typename: 'EcoToiletDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  /** Направление */
  direction: Scalars['String']['output'];
  for_station: StationDto;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type EditTrainNumberDto = {
  /** Новый номер поезда */
  new_train_number: Scalars['String']['input'];
  /** Идентификатор поезда */
  train_id: Scalars['Int']['input'];
};

export type EducationCreateDto = {
  content?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type EducationDto = {
  __typename: 'EducationDto';
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type EducationList = {
  __typename: 'EducationList';
  items: Array<EducationDto>;
  totalCount: Scalars['Float']['output'];
};

export type EducationUpdateDto = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type EmphasizedStationItemDto = {
  __typename: 'EmphasizedStationItemDto';
  /** Выделение строки */
  is_emphasized: Scalars['Boolean']['output'];
  station: StationDto;
  station_id: Scalars['Float']['output'];
};

export type EmphasizedTrainItemDto = {
  __typename: 'EmphasizedTrainItemDto';
  /** Выделение строки */
  is_emphasized: Scalars['Boolean']['output'];
  train: TrainDto;
  train_id: Scalars['Float']['output'];
};

export type EstablishedTrainSchemaRailwayDto = {
  __typename: 'EstablishedTrainSchemaRailwayDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: Maybe<Scalars['Int']['output']>;
  direct_railway?: Maybe<RailwayDto>;
  id: Scalars['Int']['output'];
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: Maybe<Scalars['Int']['output']>;
  reverse_railway?: Maybe<RailwayDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type EstablishedTrainSchemaStationDto = {
  __typename: 'EstablishedTrainSchemaStationDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: Maybe<Scalars['Int']['output']>;
  direct_from_station?: Maybe<StationDto>;
  direct_to_station?: Maybe<StationDto>;
  id: Scalars['Int']['output'];
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: Maybe<Scalars['Int']['output']>;
  reverse_from_station?: Maybe<StationDto>;
  reverse_to_station?: Maybe<StationDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type EstablishedTrainSchemaUnion = EstablishedTrainSchemaRailwayDto | EstablishedTrainSchemaStationDto;

export type ExportCarriageGroupDto = {
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Флаг, нужно ли автоматически схлопывать блоки системно */
  is_collapse_automatically: Scalars['Boolean']['input'];
};

export type ExportControlSchemaByBranchDto = {
  date: Scalars['String']['input'];
};

export type ExportLogDto = {
  __typename: 'ExportLogDto';
  create_by: UserDto;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** fileDto из filestorage */
  file_info: Scalars['String']['output'];
  /** Значения фильтров при выгрузке */
  filters?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Название выгрузки */
  name: Scalars['String']['output'];
  /** Id запроса */
  request_id: Scalars['String']['output'];
  /** Статус выгрузки из мнемоник */
  status: Scalars['String']['output'];
  /** Тип выгрузки */
  type: Scalars['String']['output'];
};

export type ExportLogList = {
  __typename: 'ExportLogList';
  items: Array<ExportLogDto>;
  totalCount: Scalars['Float']['output'];
};

export type ExportScheduleDto = {
  /** Только стоянки */
  is_only_parking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Идентификаторы поездов, для которых необъходимо выгрузить расписание */
  train_ids: Array<Scalars['Int']['input']>;
};

export type ExportSchemasDto = {
  /** Идентификаторы схемы, которую необъходимо выгрузить схему */
  schema_id: Array<Scalars['Int']['input']>;
  /** Идентификаторы поездов, для которых необъходимо выгрузить схему */
  train_ids: Array<Scalars['Int']['input']>;
};

export type ExportTrainIndicatorsListDto = {
  /** по времени отправляния или прибытия */
  by_departures?: InputMaybe<Scalars['Boolean']['input']>;
  /** Окончание периода */
  end_at: Scalars['String']['input'];
  /** Флаг итоговой выгрузки */
  is_final_upload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Начало периода */
  start_at: Scalars['String']['input'];
};

export type ExportTrainListDto = {
  /** Включая ведомость стоянок */
  is_including_parking_list?: InputMaybe<Scalars['Boolean']['input']>;
  /** List № */
  list: Scalars['Int']['input'];
};

export type FaqCreateDto = {
  content?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type FaqDto = {
  __typename: 'FaqDto';
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  order?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type FaqList = {
  __typename: 'FaqList';
  items: Array<FaqDto>;
  totalCount: Scalars['Float']['output'];
};

export type FaqUpdateDto = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type FeatureFlagList = {
  __typename: 'FeatureFlagList';
  items: Array<FeatureFlagsDto>;
  totalCount: Scalars['Float']['output'];
};

export type FeatureFlagUserList = {
  __typename: 'FeatureFlagUserList';
  items: Array<FeatureFlagsUserDto>;
  totalCount: Scalars['Float']['output'];
};

export type FeatureFlagsDto = {
  __typename: 'FeatureFlagsDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type FeatureFlagsRequestDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  value: Scalars['String']['input'];
};

export type FeatureFlagsUserCreateDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  user_id: Scalars['Float']['input'];
  value: Scalars['String']['input'];
};

export type FeatureFlagsUserDto = {
  __typename: 'FeatureFlagsUserDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  user_id: Scalars['Float']['output'];
  value: Scalars['String']['output'];
};

export type FeatureFlagsUserUpdateDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  value: Scalars['String']['input'];
};

export type FileDto = {
  __typename: 'FileDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Описание файла */
  description?: Maybe<Scalars['String']['output']>;
  /** ссылка для скачивания файла */
  download_link: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Ссылка */
  link?: Maybe<Scalars['String']['output']>;
  /** Дополнительные данные */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Тип контента */
  mime_type: Scalars['String']['output'];
  /** Имя файла */
  name: Scalars['String']['output'];
  queue_info?: Maybe<QueueInfoDto>;
  /** Размер файла */
  size: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type FileList = {
  __typename: 'FileList';
  items: Array<FileDto>;
  totalCount: Scalars['Float']['output'];
};

export type FilestorageMutationEntryPoint = {
  __typename: 'FilestorageMutationEntryPoint';
  /** Удаление файла */
  delete?: Maybe<Scalars['Void']['output']>;
  /** Удаление из очереди */
  removeFromQueue?: Maybe<Scalars['Void']['output']>;
};


export type FilestorageMutationEntryPointDeleteArgs = {
  id: Scalars['Float']['input'];
};


export type FilestorageMutationEntryPointRemoveFromQueueArgs = {
  id: Scalars['String']['input'];
};

export type FilestorageQueryEntryPoint = {
  __typename: 'FilestorageQueryEntryPoint';
  /** Получение данных о файле по id */
  byId: FileDto;
  /** Список файлов в очереди */
  getActiveCount: JobList;
  /** список файлов по bucket_id */
  listByBucketId: FileList;
};


export type FilestorageQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type FilestorageQueryEntryPointListByBucketIdArgs = {
  order_by?: InputMaybe<Array<FilestorageQueryResolver_ListByBucketId_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<FilestorageQueryResolver_ListByBucketId_FilterInputType>;
};

export type FilestorageQueryResolver_ListByBucketId_BaseFilterInputType = {
  and?: InputMaybe<Array<FilestorageQueryResolver_ListByBucketId_BaseFilterInputType>>;
  bucket_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<FilestorageQueryResolver_ListByBucketId_BaseFilterInputType>>;
};

export type FilestorageQueryResolver_ListByBucketId_FilterInputType = {
  and?: InputMaybe<Array<FilestorageQueryResolver_ListByBucketId_BaseFilterInputType>>;
  bucket_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<FilestorageQueryResolver_ListByBucketId_BaseFilterInputType>>;
};

export type FilestorageQueryResolver_ListByBucketId_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  download_link?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  link?: InputMaybe<SortType>;
  metadata?: InputMaybe<SortType>;
  mime_type?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  size?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type FinalCalculationsTotalBranchDto = {
  __typename: 'FinalCalculationsTotalBranchDto';
  /** По структурным подразделениям */
  items: Array<FinalCalculationsTotalSubdivisionDto>;
  /** Наименование филиала */
  name: Scalars['String']['output'];
  /** По филиалу */
  total: FinalCalculationsTotalRowDto;
};

export type FinalCalculationsTotalDto = {
  __typename: 'FinalCalculationsTotalDto';
  /** По филиалу */
  items: Array<FinalCalculationsTotalBranchDto>;
  /** ИТОГО по выбранным филиалам */
  total: FinalCalculationsTotalRowDto;
};

export type FinalCalculationsTotalRowDto = {
  __typename: 'FinalCalculationsTotalRowDto';
  /** Сред. состав дерег */
  average_composition_dereg: Scalars['Float']['output'];
  /** Сред. состав прочее */
  average_composition_other: Scalars['Float']['output'];
  /** Сред. состав рег */
  average_composition_reg: Scalars['Float']['output'];
  /** Сред. состав всего */
  average_composition_total: Scalars['Float']['output'];
  /** Сред. состав всего пасс */
  average_composition_total_passenger: Scalars['Float']['output'];
  /** Ваг-км, тыс дерег */
  carriage_distance_dereg: Scalars['Float']['output'];
  /** Ваг-км, тыс прочее */
  carriage_distance_other: Scalars['Float']['output'];
  /** Ваг-км, тыс рег */
  carriage_distance_reg: Scalars['Float']['output'];
  /** Ваг-км, тыс всего */
  carriage_distance_total: Scalars['Float']['output'];
  /** Ваг-км, тыс всего пасс */
  carriage_distance_total_passenger: Scalars['Float']['output'];
  /** Место-км, млн дерег */
  seats_distance_dereg: Scalars['Float']['output'];
  /** Место-км, млн рег */
  seats_distance_reg: Scalars['Float']['output'];
  /** Место-км, млн всего */
  seats_distance_total: Scalars['Float']['output'];
  /** Поездо-км, тыс */
  train_distance: Scalars['Float']['output'];
  /** Кол-во отправлений поездов */
  train_quantity: Scalars['Float']['output'];
};

export type FinalCalculationsTotalSubdivisionDto = {
  __typename: 'FinalCalculationsTotalSubdivisionDto';
  /** Наименование структурного подразделения */
  name: Scalars['String']['output'];
  total: FinalCalculationsTotalRowDto;
};

export type Float_PropertyFilterInputType = {
  /** Ср состав факт */
  between?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Ср состав факт */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Ср состав факт */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Ср состав факт */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Ср состав факт */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Ср состав факт */
  in_arr?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Ср состав факт */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Ср состав факт */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Ср состав факт */
  lte?: InputMaybe<Scalars['Float']['input']>;
  /** Ср состав факт */
  neq?: InputMaybe<Scalars['Float']['input']>;
  /** Ср состав факт */
  notbetween?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Ср состав факт */
  notin?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Ср состав факт */
  notlike?: InputMaybe<Scalars['String']['input']>;
  /** Ср состав факт */
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FpkTrainsDto = {
  __typename: 'FpkTrainsDto';
  /** Поезда АО ФПК круглогодичные */
  season_train_every_year: TotalTrainDto;
  /** Поезда АО ФПК другие */
  season_train_other: TotalTrainDto;
  /** Поезда АО ФПК сезонные */
  season_train_season: TotalTrainDto;
  /** Все пары поездов АО ФПК */
  total_trains: TotalTrainDto;
};

export type FuelSupplyDto = {
  __typename: 'FuelSupplyDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  /** Направление */
  direction: Scalars['String']['output'];
  for_station: StationDto;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type GdpList = {
  __typename: 'GDPList';
  items: Array<GdpDto>;
  totalCount: Scalars['Float']['output'];
};

export type GdpMutationEntryPoint = {
  __typename: 'GDPMutationEntryPoint';
  /** Создание графика движения поездов */
  create: Scalars['Float']['output'];
  /** Обновление графика движения поездов */
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type GdpMutationEntryPointCreateArgs = {
  data: CreateGdpDto;
};


export type GdpMutationEntryPointUpdateArgs = {
  data: UpdateGdpDto;
};

export type GdpQueryEntryPoint = {
  __typename: 'GDPQueryEntryPoint';
  /** График движения поездов по id */
  byId: GdpDto;
  /** Список графиков движения поездов */
  list: GdpList;
  /** Рабочий график движения поездов (current | next) */
  workingGDP?: Maybe<GdpDto>;
};


export type GdpQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type GdpQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<GdpQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<GdpQueryResolver_List_FilterInputType>;
};


export type GdpQueryEntryPointWorkingGdpArgs = {
  data: WorkingGdpDto;
};

export type GdpQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<GdpQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<GdpQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type GdpQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<GdpQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<GdpQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type GdpQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type GdpDto = {
  __typename: 'GdpDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Действует по */
  end_at: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  /** Действует с */
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type GenerateLocomotiveAreasForTrainDto = {
  /** Id схем для обновления */
  schema_id?: InputMaybe<Scalars['Int']['input']>;
  /** Id поезда для создания зон локомотивного обслуживания */
  train_id: Scalars['Int']['input'];
};

export type GenerateLocomotiveAreasForTrainsPairDto = {
  /** Id прямого поездов для создания зон локомотивного обслуживания */
  direct_train: GenerateLocomotiveAreasForTrainDto;
  /** Флаг формирования с учетом основной группы вагонов */
  is_main_group_check: Scalars['Boolean']['input'];
  /** Id обратного позда для создания зон локомотивного обслуживания */
  reverse_train?: InputMaybe<GenerateLocomotiveAreasForTrainDto>;
};

export type GetRailwayListFromTrainScheduleDto = {
  /** Идентификатор поезда */
  train_id: Scalars['Int']['input'];
};

export type GetRelatedTrainsDto = {
  /** Id поезда */
  train_id: Scalars['Int']['input'];
};

export type GetStationListFromTrainScheduleDto = {
  /** Блок для фильтрации станций с наличием стоянки */
  check_train_parking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Блок для фильтрации от станции */
  from_station_id?: InputMaybe<Scalars['Float']['input']>;
  /** Блок для фильтрации */
  search_value?: InputMaybe<Scalars['String']['input']>;
  /** Блок для фильтрации до станции */
  to_station_id?: InputMaybe<Scalars['Float']['input']>;
  /** Идентификатор поезда */
  train_id: Scalars['Int']['input'];
};

export type GetTrainScheduleStencilDto = {
  /** Идентификатор расписания второго поезда */
  compared_schedule_id: Scalars['Int']['input'];
  /** Номер второго поезда */
  compared_train_number: Scalars['String']['input'];
  /** Идентификатор расписания первого поезда */
  initial_schedule_id: Scalars['Int']['input'];
  /** Номер первого поезда */
  initial_train_number: Scalars['String']['input'];
};

export type GetTurnoverChartDto = {
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** С какой даты */
  from_date: Scalars['String']['input'];
  /** По какую дату */
  to_date: Scalars['String']['input'];
};

export type GetTurnoverFromStationListRequestDto = {
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Идентификатор поезда */
  train_id: Scalars['Int']['input'];
  /** Порядковый номер текущей оборотки, которая добавляется */
  turnover_order_number: Scalars['Int']['input'];
};

export type GetTurnoverFromStationListResponseDto = {
  __typename: 'GetTurnoverFromStationListResponseDto';
  /** Станции прицепки. Если добавляется первая оборотка, то в массиве может быть несколько станций, иначе 1 станция в массив будет приходить. Если для текущего поезда нет станции прицепки по отношению к предыдущей оборотке, то будет null */
  stations?: Maybe<Array<StationDto>>;
};

export type GetTurnoverToStationListRequestDto = {
  /** Идентификатор станции отправления */
  from_station_id: Scalars['Int']['input'];
  /** Идентификатор поезда */
  train_id: Scalars['Int']['input'];
};

export type GetTurnoverToStationListResponseDto = {
  __typename: 'GetTurnoverToStationListResponseDto';
  /** Станции отцепки */
  stations?: Maybe<Array<StationDto>>;
};

export type HaulierDto = {
  __typename: 'HaulierDto';
  entity_id: Scalars['Int']['output'];
  short_name: Scalars['String']['output'];
};

export type HttpRequestDto = {
  /** axios config */
  config?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Url */
  url: Scalars['String']['input'];
};

export type IndicatorsByTrainCarriageTypesDto = {
  __typename: 'IndicatorsByTrainCarriageTypesDto';
  /** Показатели по типу вагонов */
  carriage_departures: Array<IndicatorsByTrainCarriagesDto>;
  /** Показатели по типу вагонов */
  carriages_total: Scalars['Float']['output'];
  /** Показатели по типу вагонов */
  passenger_carriages_total: Scalars['Float']['output'];
};

export type IndicatorsByTrainCarriageTypesOmitTotalDto = {
  __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto';
  /** Показатели по типу вагонов */
  carriage_departures: Array<IndicatorsByTrainCarriagesDto>;
  /** Показатели по типу вагонов */
  passenger_carriages_total: Scalars['Float']['output'];
};

export type IndicatorsByTrainCarriagesDto = {
  __typename: 'IndicatorsByTrainCarriagesDto';
  carriage_type: Scalars['String']['output'];
  /** Количество отправлений */
  departures_quantity?: Maybe<Scalars['Float']['output']>;
  seat_type: Scalars['String']['output'];
};

export type IndicatorsByTrainSeatsDepartureQuantityDto = {
  __typename: 'IndicatorsByTrainSeatsDepartureQuantityDto';
  /** Кол-во отпр. вагонов (схема) */
  carriage_departures_quantity: IndicatorsByTrainCarriageTypesDto;
  /** Вагоноборот пасс ваг (треб.) */
  carriage_required_turnovers: IndicatorsByTrainCarriageTypesDto;
  /** Вагонооборот (схема) */
  carriage_schema_turnovers: IndicatorsByTrainCarriageTypesDto;
  /** Кол-во отпр.мест (схема) */
  seats_departures_quantity: IndicatorsByTrainCarriageTypesDto;
  /** Местооборот (треб.) */
  seats_required_turnovers: IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto;
  /** Местооборот (схема) */
  seats_schema_turnovers: IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto;
  /** Информация о поезде */
  train_info: IndicatorsByTrainTrainInfoDto;
};

export type IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto = {
  __typename: 'IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto';
  /** Показатели по типу вагонов */
  carriage_departures: Array<IndicatorsByTrainCarriagesDto>;
  /** Показатели по типу вагонов */
  passenger_carriages_total: Scalars['Float']['output'];
};

export type IndicatorsByTrainSeatsDepartureQuantityTotalDto = {
  __typename: 'IndicatorsByTrainSeatsDepartureQuantityTotalDto';
  /** Кол-во отпр. вагонов (схема) */
  carriage_departures_quantity: IndicatorsByTrainCarriageTypesDto;
  /** Вагоноборот пасс ваг (треб.) */
  carriage_required_turnovers: IndicatorsByTrainCarriageTypesDto;
  /** Вагонооборот (схема) */
  carriage_schema_turnovers: IndicatorsByTrainCarriageTypesDto;
  /** Кол-во отпр.мест (схема) */
  seats_departures_quantity: IndicatorsByTrainCarriageTypesDto;
  /** Местооборот (треб.) */
  seats_required_turnovers: IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto;
  /** Местооборот (схема) */
  seats_schema_turnovers: IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto;
  /** Информация о поезде (всего) */
  train_info: IndicatorsByTrainSeatsDepartureQuantityTotalTrainInfoDto;
};

export type IndicatorsByTrainSeatsDepartureQuantityTotalTrainInfoDto = {
  __typename: 'IndicatorsByTrainSeatsDepartureQuantityTotalTrainInfoDto';
  /** Кол-во отправлений */
  departures_quantity: Scalars['Float']['output'];
  /** Маршрут следования */
  distance: Scalars['Float']['output'];
};

export type IndicatorsByTrainTrainInfoDto = {
  __typename: 'IndicatorsByTrainTrainInfoDto';
  /** Кол-во отправлений */
  departures_quantity: Scalars['Float']['output'];
  /** Маршрут следования */
  distance: Scalars['Float']['output'];
  /** Номер поезда */
  train_number: Scalars['String']['output'];
};

export type IndicatorsCarriageGroupList = {
  __typename: 'IndicatorsCarriageGroupList';
  items: Array<IndicatorsCarriageGroupViewDto>;
  totalCount: Scalars['Float']['output'];
};

export type IndicatorsCarriageGroupViewDto = {
  __typename: 'IndicatorsCarriageGroupViewDto';
  branch?: Maybe<BranchDto>;
  /** Идентификатор филиала */
  branch_id?: Maybe<Scalars['Int']['output']>;
  /** Идентификаторы габаритов вагонов */
  carriage_dimension_ids?: Maybe<Array<Scalars['Int']['output']>>;
  /** Габариты вагонов */
  dimensions?: Maybe<Scalars['String']['output']>;
  /** Дата окончания действия ГВ */
  end_at: Scalars['String']['output'];
  /** Станции отправления из обороток */
  from_stations?: Maybe<Array<Scalars['String']['output']>>;
  /** Станции отправления из обороток */
  from_stations_for_schema?: Maybe<Array<Scalars['String']['output']>>;
  /** Идентификатор графика движения поездов */
  gdp_id: Scalars['Int']['output'];
  /** Идентификатор группы вагонов */
  id: Scalars['Int']['output'];
  /** Максимальное время оборота */
  max_turnaround_time?: Maybe<Scalars['Float']['output']>;
  /** Наименование группы вагонов */
  name: Scalars['String']['output'];
  passenger_carrier?: Maybe<PassengerCarrierDto>;
  /** Идентификатор перевозчика */
  passenger_carriers_id?: Maybe<Scalars['Int']['output']>;
  /** Периодичности группы вагонов */
  periodicity?: Maybe<Array<Scalars['String']['output']>>;
  railway_administration: RailwayAdministrationDto;
  /** Идентификатор ж/д администрации */
  railway_administration_id: Scalars['Int']['output'];
  /** Идентификаторы секторов регулирования */
  regulatory_sector_ids?: Maybe<Array<Scalars['Int']['output']>>;
  /** НПС/МВПС */
  rolling_stock_type: Scalars['String']['output'];
  /** Дата начала действия ГВ */
  start_at: Scalars['String']['output'];
  /** Статус принятия в схему */
  status: Scalars['String']['output'];
  /** Статус согласования */
  step_status: Scalars['String']['output'];
  /** Идентификатор структурного подразделения */
  structural_subdivision_id?: Maybe<Scalars['Int']['output']>;
  /** Станции прибытия из обороток */
  to_stations?: Maybe<Array<Scalars['String']['output']>>;
  /** Станции прибытия из обороток */
  to_stations_for_schema?: Maybe<Array<Scalars['String']['output']>>;
  /** Идентификаторы поездов */
  train_ids?: Maybe<Array<Scalars['Int']['output']>>;
  /** Номера поездов */
  train_numbers?: Maybe<Array<Scalars['String']['output']>>;
  /** Версия */
  version: Scalars['Int']['output'];
};

export type IndicatorsCarriageGroupViewInfoDto = {
  __typename: 'IndicatorsCarriageGroupViewInfoDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type IndicatorsFinalCalculationParkRequiredUnionDto = CarriageGroupIndicatorsFinalCalculationMvpsParkRequiredDto | CarriageGroupIndicatorsFinalCalculationNpsParkRequiredDto;

export type IndicatorsMutationEntryPoint = {
  __typename: 'IndicatorsMutationEntryPoint';
  /** Добавление среднего состава по датам */
  addCarriagesByDate: Scalars['Boolean']['output'];
  /** Запрос итоговых показателей по гв */
  carriage_groups_final_calculations?: Maybe<Scalars['Void']['output']>;
  /** Экспорт итогового расчёта по гв */
  export_carriage_group_final_calculations?: Maybe<Scalars['Void']['output']>;
  /** Экспорт итогового расчёта */
  export_final_calculations?: Maybe<Scalars['Void']['output']>;
  /** Экспорт расчёта индикаторов инфраструктуры */
  export_infrastructure_indicators?: Maybe<Scalars['Void']['output']>;
  /** Экспорт расчёта мвпс */
  export_mvps_calculations?: Maybe<Scalars['Void']['output']>;
  /** Экспорт требуемого парка */
  export_park_required?: Maybe<Scalars['Void']['output']>;
  /** Экспорт итоговых показателей по поездам для групп */
  export_train_by_groups_final_indicators?: Maybe<Scalars['Void']['output']>;
  /** Экспорт итогового расчёта по поездам */
  export_train_final_calculations?: Maybe<Scalars['Void']['output']>;
  /** Экспорт итоговых показателей по поездам */
  export_train_final_indicators?: Maybe<Scalars['Void']['output']>;
  /** Обновление среднего состава для списка гв */
  indicators_recalculation?: Maybe<Scalars['Void']['output']>;
  /** Запрос расчёта инфраструктуры */
  infrastructure_calculations?: Maybe<Scalars['Void']['output']>;
  /** Запрос расчёта инфраструктуры по филиалам */
  infrastructure_calculations_by_branch?: Maybe<Scalars['Void']['output']>;
  /** Запрос расчёта мвпс по филиалам */
  mvps_calculations_by_branch_request?: Maybe<Scalars['Void']['output']>;
  /** запрос расчёта мвпс */
  mvps_calculations_request?: Maybe<Scalars['Void']['output']>;
  /** Редактирование прогноза */
  updateForecastIndicator: Scalars['Boolean']['output'];
};


export type IndicatorsMutationEntryPointAddCarriagesByDateArgs = {
  data: AddCarriagesByDateDto;
};


export type IndicatorsMutationEntryPointCarriage_Groups_Final_CalculationsArgs = {
  data: CarriageGroupIndicatorsFinalCalculationRequestDto;
  where?: InputMaybe<IndicatorsMutationResolver_CarriageGroupsFinalCalculations_FilterInputType>;
};


export type IndicatorsMutationEntryPointExport_Carriage_Group_Final_CalculationsArgs = {
  data: CarriageGroupIndicatorsFinalCalculationRequestDto;
  where?: InputMaybe<IndicatorsMutationResolver_ExportCarriageGroupFinalCalculations_FilterInputType>;
};


export type IndicatorsMutationEntryPointExport_Final_CalculationsArgs = {
  data: CarriageGroupIndicatorsFinalCalculationRequestDto;
  where?: InputMaybe<IndicatorsMutationResolver_ExportIndicatorsFinalCalculations_FilterInputType>;
};


export type IndicatorsMutationEntryPointExport_Infrastructure_IndicatorsArgs = {
  where?: InputMaybe<IndicatorsMutationResolver_ExportInfrastructureIndicatorsCalculations_FilterInputType>;
};


export type IndicatorsMutationEntryPointExport_Mvps_CalculationsArgs = {
  where?: InputMaybe<IndicatorsMutationResolver_ExportMvpsCalculations_FilterInputType>;
};


export type IndicatorsMutationEntryPointExport_Park_RequiredArgs = {
  where?: InputMaybe<IndicatorsMutationResolver_ExportParkRequired_FilterInputType>;
};


export type IndicatorsMutationEntryPointExport_Train_By_Groups_Final_IndicatorsArgs = {
  where?: InputMaybe<IndicatorsMutationResolver_ExportTrainByGroupsFinalIndicators_FilterInputType>;
};


export type IndicatorsMutationEntryPointExport_Train_Final_CalculationsArgs = {
  data: TrainIndicatorsFinalCalculationsRequestDto;
  where?: InputMaybe<IndicatorsMutationResolver_ExportTrainFinalCalculations_FilterInputType>;
};


export type IndicatorsMutationEntryPointExport_Train_Final_IndicatorsArgs = {
  where?: InputMaybe<IndicatorsMutationResolver_ExportTrainFinalIndicators_FilterInputType>;
};


export type IndicatorsMutationEntryPointInfrastructure_CalculationsArgs = {
  where?: InputMaybe<IndicatorsMutationResolver_InfrastructureCalculations_FilterInputType>;
};


export type IndicatorsMutationEntryPointInfrastructure_Calculations_By_BranchArgs = {
  where?: InputMaybe<IndicatorsMutationResolver_InfrastructureCalculationsByBranch_FilterInputType>;
};


export type IndicatorsMutationEntryPointMvps_Calculations_By_Branch_RequestArgs = {
  order_by?: InputMaybe<Array<IndicatorsMutationResolver_MvpsCalculationsByBranchRequest_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<IndicatorsMutationResolver_MvpsCalculationsByBranchRequest_FilterInputType>;
};


export type IndicatorsMutationEntryPointMvps_Calculations_RequestArgs = {
  order_by?: InputMaybe<Array<IndicatorsMutationResolver_MvpsCalculationsRequest_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<IndicatorsMutationResolver_MvpsCalculationsRequest_FilterInputType>;
};


export type IndicatorsMutationEntryPointUpdateForecastIndicatorArgs = {
  data: UpdateForecastIndicatorDto;
};

export type IndicatorsMutationResolver_CarriageGroupsFinalCalculations_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_CarriageGroupsFinalCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_CarriageGroupsFinalCalculations_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_CarriageGroupsFinalCalculations_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_CarriageGroupsFinalCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_CarriageGroupsFinalCalculations_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportCarriageGroupFinalCalculations_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportCarriageGroupFinalCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportCarriageGroupFinalCalculations_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportCarriageGroupFinalCalculations_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportCarriageGroupFinalCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportCarriageGroupFinalCalculations_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportIndicatorsFinalCalculations_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportIndicatorsFinalCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportIndicatorsFinalCalculations_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportIndicatorsFinalCalculations_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportIndicatorsFinalCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportIndicatorsFinalCalculations_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportInfrastructureIndicatorsCalculations_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportInfrastructureIndicatorsCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  from_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportInfrastructureIndicatorsCalculations_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  to_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportInfrastructureIndicatorsCalculations_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportInfrastructureIndicatorsCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  from_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportInfrastructureIndicatorsCalculations_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  to_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportMvpsCalculations_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportMvpsCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportMvpsCalculations_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  stations?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportMvpsCalculations_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportMvpsCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportMvpsCalculations_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  stations?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportParkRequired_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportParkRequired_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportParkRequired_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  stations?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportParkRequired_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportParkRequired_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportParkRequired_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  stations?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportTrainByGroupsFinalIndicators_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainByGroupsFinalIndicators_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainByGroupsFinalIndicators_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  stations?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportTrainByGroupsFinalIndicators_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainByGroupsFinalIndicators_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainByGroupsFinalIndicators_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  stations?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportTrainFinalCalculations_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainFinalCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainFinalCalculations_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportTrainFinalCalculations_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainFinalCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainFinalCalculations_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportTrainFinalIndicators_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainFinalIndicators_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  from_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainFinalIndicators_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  to_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_ExportTrainFinalIndicators_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainFinalIndicators_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  from_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_ExportTrainFinalIndicators_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  to_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_InfrastructureCalculationsByBranch_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_InfrastructureCalculationsByBranch_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  from_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_InfrastructureCalculationsByBranch_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  to_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_InfrastructureCalculationsByBranch_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_InfrastructureCalculationsByBranch_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  from_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_InfrastructureCalculationsByBranch_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  to_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_InfrastructureCalculations_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_InfrastructureCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  from_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_InfrastructureCalculations_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  to_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_InfrastructureCalculations_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_InfrastructureCalculations_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  from_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_InfrastructureCalculations_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  to_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_MvpsCalculationsByBranchRequest_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_MvpsCalculationsByBranchRequest_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_MvpsCalculationsByBranchRequest_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  stations?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_MvpsCalculationsByBranchRequest_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_MvpsCalculationsByBranchRequest_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_MvpsCalculationsByBranchRequest_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  stations?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_MvpsCalculationsByBranchRequest_SortingInputType = {
  branch_id?: InputMaybe<SortType>;
  carriage_dimension_ids?: InputMaybe<SortType>;
  dimensions?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  from_stations?: InputMaybe<SortType>;
  from_stations_for_schema?: InputMaybe<SortType>;
  gdp_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  max_turnaround_time?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  passenger_carriers_id?: InputMaybe<SortType>;
  periodicity?: InputMaybe<SortType>;
  railway_administration_id?: InputMaybe<SortType>;
  regulatory_sector_ids?: InputMaybe<SortType>;
  rolling_stock_type?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
  step_status?: InputMaybe<SortType>;
  structural_subdivision_id?: InputMaybe<SortType>;
  to_stations?: InputMaybe<SortType>;
  to_stations_for_schema?: InputMaybe<SortType>;
  train_ids?: InputMaybe<SortType>;
  train_numbers?: InputMaybe<SortType>;
  version?: InputMaybe<SortType>;
};

export type IndicatorsMutationResolver_MvpsCalculationsRequest_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_MvpsCalculationsRequest_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_MvpsCalculationsRequest_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  stations?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_MvpsCalculationsRequest_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsMutationResolver_MvpsCalculationsRequest_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  from_date?: InputMaybe<String_PropertyFilterInputType>;
  is_arrival?: InputMaybe<Boolean_PropertyFilterInputType>;
  max_train_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsMutationResolver_MvpsCalculationsRequest_BaseFilterInputType>>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  stations?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_date?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsMutationResolver_MvpsCalculationsRequest_SortingInputType = {
  branch_id?: InputMaybe<SortType>;
  carriage_dimension_ids?: InputMaybe<SortType>;
  dimensions?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  from_stations?: InputMaybe<SortType>;
  from_stations_for_schema?: InputMaybe<SortType>;
  gdp_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  max_turnaround_time?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  passenger_carriers_id?: InputMaybe<SortType>;
  periodicity?: InputMaybe<SortType>;
  railway_administration_id?: InputMaybe<SortType>;
  regulatory_sector_ids?: InputMaybe<SortType>;
  rolling_stock_type?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
  step_status?: InputMaybe<SortType>;
  structural_subdivision_id?: InputMaybe<SortType>;
  to_stations?: InputMaybe<SortType>;
  to_stations_for_schema?: InputMaybe<SortType>;
  train_ids?: InputMaybe<SortType>;
  train_numbers?: InputMaybe<SortType>;
  version?: InputMaybe<SortType>;
};

export type IndicatorsQueryEntryPoint = {
  __typename: 'IndicatorsQueryEntryPoint';
  /** Итоговый расчёт по гв */
  carriage_group_final_calculation: CarriageGroupIndicatorsFinalCalculationDto;
  /** Показатели для группы вагонов */
  carriage_group_indicators: CarriageGroupIndicatorsCalculationDto;
  /** расчёт итоговых показателей по гв */
  carriage_groups_final_calculations_response: FinalCalculationsTotalDto;
  /** Есть ли показатели по датам в заданный период */
  check_carriages_by_date: Scalars['Boolean']['output'];
  /** Показатели для группы вагонов по поездам */
  indicators_by_train: CarriageGroupIndicatorsByTrainDto;
  /** Показатели по месяцам */
  indicators_monthly: CarriageGroupIndicatorResponseList;
  /** расчёт инфраструктуры по филиалу */
  infrastructure_calculations_by_branch_response: InfrastructureCalculationByBranchDto;
  /** расчёт инфраструктуры */
  infrastructure_calculations_response: InfrastructureCalculationDto;
  /** Список групп */
  list_groups: IndicatorsCarriageGroupList;
  /** Список показателей поездов */
  list_trains: IndicatorsTrainList;
  /** расчёт мвпс по филиалам */
  mvps_calculations_by_branch_response: MvpsCalculationByBranchDto;
  /** расчёт мвпс */
  mvps_calculations_response: MvpsCalculationsList;
  /** Требуемый парк */
  parkRequired: CarriageGroupParkRequiredResponseDto;
  /** Итоговый расчёт по поездам */
  train_final_calculation: TrainIndicatorsFinalCalculationsDto;
  /** Показатели для заголовка поезда по основной группе */
  train_header_indicators: TrainHeaderIndicatorsDto;
  /** Показатели для поезда */
  train_indicators_for_schema: TrainIndicatorsDto;
  /** Показатели для поезда */
  train_indicators_total: Array<TrainPerformanceIndicatorsSchemaTotalDto>;
  /** Информация о последнем обновлении */
  update_info: IndicatorsCarriageGroupViewInfoDto;
};


export type IndicatorsQueryEntryPointCarriage_Group_Final_CalculationArgs = {
  data: CarriageGroupIndicatorsFinalCalculationRequestDto;
  where?: InputMaybe<IndicatorsQueryResolver_CarriageGroupFinalCalculation_FilterInputType>;
};


export type IndicatorsQueryEntryPointCarriage_Group_IndicatorsArgs = {
  carriage_group_id: Scalars['Float']['input'];
};


export type IndicatorsQueryEntryPointCarriage_Groups_Final_Calculations_ResponseArgs = {
  key: Scalars['String']['input'];
};


export type IndicatorsQueryEntryPointCheck_Carriages_By_DateArgs = {
  data: CarriageGroupCheckCarriagesByDateRequestDto;
};


export type IndicatorsQueryEntryPointIndicators_By_TrainArgs = {
  data: CarriageGroupIndicatorsByTrainRequestDto;
};


export type IndicatorsQueryEntryPointIndicators_MonthlyArgs = {
  carriage_group_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<IndicatorsQueryResolver_IndicatorsMonthly_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<IndicatorsQueryResolver_IndicatorsMonthly_FilterInputType>;
};


export type IndicatorsQueryEntryPointInfrastructure_Calculations_By_Branch_ResponseArgs = {
  key: Scalars['String']['input'];
};


export type IndicatorsQueryEntryPointInfrastructure_Calculations_ResponseArgs = {
  key: Scalars['String']['input'];
};


export type IndicatorsQueryEntryPointList_GroupsArgs = {
  order_by?: InputMaybe<Array<IndicatorsQueryResolver_ListView_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<IndicatorsQueryResolver_ListView_FilterInputType>;
};


export type IndicatorsQueryEntryPointList_TrainsArgs = {
  order_by?: InputMaybe<Array<IndicatorsQueryResolver_ListTrains_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<IndicatorsQueryResolver_ListTrains_FilterInputType>;
};


export type IndicatorsQueryEntryPointMvps_Calculations_By_Branch_ResponseArgs = {
  key: Scalars['String']['input'];
};


export type IndicatorsQueryEntryPointMvps_Calculations_ResponseArgs = {
  key: Scalars['String']['input'];
};


export type IndicatorsQueryEntryPointParkRequiredArgs = {
  data: DatesRequestDto;
  where?: InputMaybe<IndicatorsQueryResolver_ParkRequired_FilterInputType>;
};


export type IndicatorsQueryEntryPointTrain_Final_CalculationArgs = {
  data: TrainIndicatorsFinalCalculationsRequestDto;
  where?: InputMaybe<IndicatorsQueryResolver_TrainFinalCalculation_FilterInputType>;
};


export type IndicatorsQueryEntryPointTrain_Header_IndicatorsArgs = {
  data: TrainHeaderIndicatorsRequestDto;
};


export type IndicatorsQueryEntryPointTrain_Indicators_For_SchemaArgs = {
  data: TrainIndicatorsRequestDto;
};


export type IndicatorsQueryEntryPointTrain_Indicators_TotalArgs = {
  data: TrainIndicatorsTotalRequestDto;
};


export type IndicatorsQueryEntryPointUpdate_InfoArgs = {
  id: Scalars['Float']['input'];
};

export type IndicatorsQueryResolver_CarriageGroupFinalCalculation_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_CarriageGroupFinalCalculation_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_CarriageGroupFinalCalculation_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsQueryResolver_CarriageGroupFinalCalculation_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_CarriageGroupFinalCalculation_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_CarriageGroupFinalCalculation_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsQueryResolver_IndicatorsMonthly_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_IndicatorsMonthly_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_calendar_active?: InputMaybe<Boolean_PropertyFilterInputType>;
  month?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_IndicatorsMonthly_BaseFilterInputType>>;
  trips_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsQueryResolver_IndicatorsMonthly_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_IndicatorsMonthly_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_calendar_active?: InputMaybe<Boolean_PropertyFilterInputType>;
  month?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_IndicatorsMonthly_BaseFilterInputType>>;
  trips_quantity?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsQueryResolver_IndicatorsMonthly_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_calendar_active?: InputMaybe<SortType>;
  month?: InputMaybe<SortType>;
  trips_quantity?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type IndicatorsQueryResolver_ListTrains_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_ListTrains_BaseFilterInputType>>;
  branch?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_ListTrains_BaseFilterInputType>>;
  passenger_carrier_russian_railway?: InputMaybe<String_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsQueryResolver_ListTrains_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_ListTrains_BaseFilterInputType>>;
  branch?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_ListTrains_BaseFilterInputType>>;
  passenger_carrier_russian_railway?: InputMaybe<String_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsQueryResolver_ListTrains_SortingInputType = {
  branch?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  from_station?: InputMaybe<SortType>;
  from_station_for_schema?: InputMaybe<SortType>;
  passenger_carrier_russian_railway?: InputMaybe<SortType>;
  railway_administration?: InputMaybe<SortType>;
  rolling_stock_types?: InputMaybe<SortType>;
  route_duration?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
  to_station?: InputMaybe<SortType>;
  to_station_for_schema?: InputMaybe<SortType>;
  train_id?: InputMaybe<SortType>;
  train_number?: InputMaybe<SortType>;
  version?: InputMaybe<SortType>;
};

export type IndicatorsQueryResolver_ListView_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_ListView_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_ListView_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsQueryResolver_ListView_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_ListView_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_ListView_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsQueryResolver_ListView_SortingInputType = {
  branch_id?: InputMaybe<SortType>;
  carriage_dimension_ids?: InputMaybe<SortType>;
  dimensions?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  from_stations?: InputMaybe<SortType>;
  from_stations_for_schema?: InputMaybe<SortType>;
  gdp_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  max_turnaround_time?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  passenger_carriers_id?: InputMaybe<SortType>;
  periodicity?: InputMaybe<SortType>;
  railway_administration_id?: InputMaybe<SortType>;
  regulatory_sector_ids?: InputMaybe<SortType>;
  rolling_stock_type?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
  step_status?: InputMaybe<SortType>;
  structural_subdivision_id?: InputMaybe<SortType>;
  to_stations?: InputMaybe<SortType>;
  to_stations_for_schema?: InputMaybe<SortType>;
  train_ids?: InputMaybe<SortType>;
  train_numbers?: InputMaybe<SortType>;
  version?: InputMaybe<SortType>;
};

export type IndicatorsQueryResolver_ParkRequired_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_ParkRequired_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_ParkRequired_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsQueryResolver_ParkRequired_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_ParkRequired_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_ParkRequired_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsQueryResolver_TrainFinalCalculation_BaseFilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_TrainFinalCalculation_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_TrainFinalCalculation_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsQueryResolver_TrainFinalCalculation_FilterInputType = {
  and?: InputMaybe<Array<IndicatorsQueryResolver_TrainFinalCalculation_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  carriage_dimension_ids?: InputMaybe<Int_PropertyFilterInputType>;
  dimensions?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  from_stations?: InputMaybe<String_PropertyFilterInputType>;
  from_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_turnaround_time?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IndicatorsQueryResolver_TrainFinalCalculation_BaseFilterInputType>>;
  passenger_carriers_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  regulatory_sector_ids?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  step_status?: InputMaybe<String_PropertyFilterInputType>;
  structural_subdivision_id?: InputMaybe<Int_PropertyFilterInputType>;
  to_stations?: InputMaybe<String_PropertyFilterInputType>;
  to_stations_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  train_ids?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type IndicatorsTrainDto = {
  __typename: 'IndicatorsTrainDto';
  branch?: Maybe<Scalars['String']['output']>;
  end_at: Scalars['String']['output'];
  /** Станция отправления */
  from_station: Scalars['String']['output'];
  /** Станция отправления наименование для схем */
  from_station_for_schema?: Maybe<Scalars['String']['output']>;
  passenger_carrier_russian_railway?: Maybe<Scalars['String']['output']>;
  railway_administration?: Maybe<Scalars['String']['output']>;
  /** Тип подвижного состава */
  rolling_stock_types: Array<Scalars['String']['output']>;
  /** Длительность пути (мин) */
  route_duration: Scalars['Float']['output'];
  start_at: Scalars['String']['output'];
  /** Статус согласования */
  status: Scalars['String']['output'];
  /** Станция назначения */
  to_station: Scalars['String']['output'];
  /** Станция назначения наименование для схем */
  to_station_for_schema?: Maybe<Scalars['String']['output']>;
  /** Идентификатор поезда */
  train_id: Scalars['Float']['output'];
  /** Номер поезда */
  train_number: Scalars['String']['output'];
  /** Версия */
  version: Scalars['Int']['output'];
};

export type IndicatorsTrainList = {
  __typename: 'IndicatorsTrainList';
  items: Array<IndicatorsTrainDto>;
  totalCount: Scalars['Float']['output'];
};

export type InfrastructureApplication23Dto = {
  __typename: 'InfrastructureApplication23Dto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Расстояние по */
  distance_end: Scalars['Float']['output'];
  /** Расстояние с */
  distance_start: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 15 до 30 И1 руб. на поезд */
  express_v_91_140_m_15_30_i1: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 15 до 30 И2 руб. на вагон */
  express_v_91_140_m_15_30_i2: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 15 до 30 И3 руб. на вагон */
  express_v_91_140_m_15_30_i3: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 70 И1 руб. на поезд */
  express_v_91_140_m_30_70_i1: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 70 И2 руб. на вагон */
  express_v_91_140_m_30_70_i2: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 70 И3 руб. на вагон */
  express_v_91_140_m_30_70_i3: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 140 км/ч, массы тары вагона свыше 15 до 70 И1 руб. на поезд */
  express_v_140_etc_m_15_70_i1: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 140 км/ч, массы тары вагона свыше 15 до 70 И2 руб. на вагон */
  express_v_140_etc_m_15_70_i2: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 140 км/ч, массы тары вагона свыше 15 до 70 И3 руб. на вагон */
  express_v_140_etc_m_15_70_i3: Scalars['Float']['output'];
  /** Скорый И1 руб. на поезд */
  fast_i1: Scalars['Float']['output'];
  /** Скорый И2 руб. на вагон */
  fast_i2: Scalars['Float']['output'];
  /** Скорый И3 руб. на вагон */
  fast_i3: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  /** Пассажирский И1 руб. на поезд */
  passenger_i1: Scalars['Float']['output'];
  /** Пассажирский И2 руб. на вагон */
  passenger_i2: Scalars['Float']['output'];
  /** Пассажирский И3 руб. на вагон */
  passenger_i3: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type InfrastructureApplication23List = {
  __typename: 'InfrastructureApplication23List';
  items: Array<InfrastructureApplication23Dto>;
  totalCount: Scalars['Float']['output'];
};

export type InfrastructureApplication23QueryEntryPoint = {
  __typename: 'InfrastructureApplication23QueryEntryPoint';
  /** Список тарифов на услуги по использованию инфраструктуры регулируемой организации (Приложение 23) */
  list: InfrastructureApplication23List;
};


export type InfrastructureApplication23QueryEntryPointListArgs = {
  data: QueryInfrastructureApplication23DataDto;
  order_by?: InputMaybe<Array<InfrastructureApplication23QueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<InfrastructureApplication23QueryResolver_List_FilterInputType>;
};

export type InfrastructureApplication23QueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<InfrastructureApplication23QueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  distance_end?: InputMaybe<Number_PropertyFilterInputType>;
  distance_start?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_15_30_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_15_30_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_15_30_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_30_70_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_30_70_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_30_70_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_140_etc_m_15_70_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_140_etc_m_15_70_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_140_etc_m_15_70_i3?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i1?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i2?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i3?: InputMaybe<Number_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureApplication23QueryResolver_List_BaseFilterInputType>>;
  passenger_i1?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i2?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i3?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureApplication23QueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<InfrastructureApplication23QueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  distance_end?: InputMaybe<Number_PropertyFilterInputType>;
  distance_start?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_15_30_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_15_30_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_15_30_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_30_70_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_30_70_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_91_140_m_30_70_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_140_etc_m_15_70_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_140_etc_m_15_70_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v_140_etc_m_15_70_i3?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i1?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i2?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i3?: InputMaybe<Number_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureApplication23QueryResolver_List_BaseFilterInputType>>;
  passenger_i1?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i2?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i3?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureApplication23QueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  distance_end?: InputMaybe<SortType>;
  distance_start?: InputMaybe<SortType>;
  express_v_91_140_m_15_30_i1?: InputMaybe<SortType>;
  express_v_91_140_m_15_30_i2?: InputMaybe<SortType>;
  express_v_91_140_m_15_30_i3?: InputMaybe<SortType>;
  express_v_91_140_m_30_70_i1?: InputMaybe<SortType>;
  express_v_91_140_m_30_70_i2?: InputMaybe<SortType>;
  express_v_91_140_m_30_70_i3?: InputMaybe<SortType>;
  express_v_140_etc_m_15_70_i1?: InputMaybe<SortType>;
  express_v_140_etc_m_15_70_i2?: InputMaybe<SortType>;
  express_v_140_etc_m_15_70_i3?: InputMaybe<SortType>;
  fast_i1?: InputMaybe<SortType>;
  fast_i2?: InputMaybe<SortType>;
  fast_i3?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  passenger_i1?: InputMaybe<SortType>;
  passenger_i2?: InputMaybe<SortType>;
  passenger_i3?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type InfrastructureApplication24Dto = {
  __typename: 'InfrastructureApplication24Dto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Расстояние по */
  distance_end: Scalars['Float']['output'];
  /** Расстояние с */
  distance_start: Scalars['Float']['output'];
  /** Скоростной И1 руб. на поезд */
  express_i1: Scalars['Float']['output'];
  /** Скоростной И2 руб. на вагон */
  express_i2: Scalars['Float']['output'];
  /** Скоростной И3 руб. на вагон */
  express_i3: Scalars['Float']['output'];
  /** Скорый И1 руб. на поезд */
  fast_i1: Scalars['Float']['output'];
  /** Скорый И2 руб. на вагон */
  fast_i2: Scalars['Float']['output'];
  /** Скорый И3 руб. на вагон */
  fast_i3: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  /** Пассажирский И1 руб. на поезд */
  passenger_i1: Scalars['Float']['output'];
  /** Пассажирский И2 руб. на вагон */
  passenger_i2: Scalars['Float']['output'];
  /** Пассажирский И3 руб. на вагон */
  passenger_i3: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type InfrastructureApplication24List = {
  __typename: 'InfrastructureApplication24List';
  items: Array<InfrastructureApplication24Dto>;
  totalCount: Scalars['Float']['output'];
};

export type InfrastructureApplication24QueryEntryPoint = {
  __typename: 'InfrastructureApplication24QueryEntryPoint';
  /** Список тарифов на услуги по использованию инфраструктуры регулируемой организации (Приложение 24) */
  list: InfrastructureApplication24List;
};


export type InfrastructureApplication24QueryEntryPointListArgs = {
  data: QueryInfrastructureApplication24DataDto;
  order_by?: InputMaybe<Array<InfrastructureApplication24QueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<InfrastructureApplication24QueryResolver_List_FilterInputType>;
};

export type InfrastructureApplication24QueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<InfrastructureApplication24QueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  distance_end?: InputMaybe<Number_PropertyFilterInputType>;
  distance_start?: InputMaybe<Number_PropertyFilterInputType>;
  express_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_i3?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i1?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i2?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i3?: InputMaybe<Number_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureApplication24QueryResolver_List_BaseFilterInputType>>;
  passenger_i1?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i2?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i3?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureApplication24QueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<InfrastructureApplication24QueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  distance_end?: InputMaybe<Number_PropertyFilterInputType>;
  distance_start?: InputMaybe<Number_PropertyFilterInputType>;
  express_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_i3?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i1?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i2?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i3?: InputMaybe<Number_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureApplication24QueryResolver_List_BaseFilterInputType>>;
  passenger_i1?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i2?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i3?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureApplication24QueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  distance_end?: InputMaybe<SortType>;
  distance_start?: InputMaybe<SortType>;
  express_i1?: InputMaybe<SortType>;
  express_i2?: InputMaybe<SortType>;
  express_i3?: InputMaybe<SortType>;
  fast_i1?: InputMaybe<SortType>;
  fast_i2?: InputMaybe<SortType>;
  fast_i3?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  passenger_i1?: InputMaybe<SortType>;
  passenger_i2?: InputMaybe<SortType>;
  passenger_i3?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type InfrastructureApplication25Dto = {
  __typename: 'InfrastructureApplication25Dto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Расстояние по */
  distance_end: Scalars['Float']['output'];
  /** Расстояние с */
  distance_start: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость до 140 км/ч, И1 руб. на поезд */
  express_v1_91_140_v2_0_140_m1_30_75_i1: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость до 140 км/ч, И2 руб. на вагон */
  express_v1_91_140_v2_0_140_m1_30_75_i2: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость до 140 км/ч, И3 руб. на вагон */
  express_v1_91_140_v2_0_140_m1_30_75_i3: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость от 140 до 160 км/ч, масса поезда от 150 до 325 т, И1 руб. на поезд */
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i1: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость от 140 до 160 км/ч, масса поезда от 150 до 325 т, И2 руб. на вагон */
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i2: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость от 140 до 160 км/ч, масса поезда от 150 до 325 т, И3 руб. на вагон */
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i3: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость от 140 до 160 км/ч, масса поезда от 325 до 650 т, И1 руб. на поезд */
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i1: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость от 140 до 160 км/ч, масса поезда от 325 до 650 т, И2 руб. на вагон */
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i2: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость от 140 до 160 км/ч, масса поезда от 325 до 650 т, И3 руб. на вагон */
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i3: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость свыше 160 км/ч, И1 руб. на поезд */
  express_v1_140_etc_v2_160_etc_m1_30_75_i1: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость свыше 160 км/ч, И2 руб. на вагон */
  express_v1_140_etc_v2_160_etc_m1_30_75_i2: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость свыше 160 км/ч, И3 руб. на вагон */
  express_v1_140_etc_v2_160_etc_m1_30_75_i3: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость свыше 160 км/ч, И1 руб. на поезд */
  express_v91_140_etc_v2_160_etc_m1_30_75_i1: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость свыше 160 км/ч, И2 руб. на вагон */
  express_v91_140_etc_v2_160_etc_m1_30_75_i2: Scalars['Float']['output'];
  /** Скоростной с маршрутной скоростью свыше 91 до 140 км/ч, массы тары вагона свыше 30 до 75, конструкционная скорость свыше 160 км/ч, И3 руб. на вагон */
  express_v91_140_etc_v2_160_etc_m1_30_75_i3: Scalars['Float']['output'];
  /** Скорый И1 руб. на поезд */
  fast_i1: Scalars['Float']['output'];
  /** Скорый И2 руб. на вагон */
  fast_i2: Scalars['Float']['output'];
  /** Скорый И3 руб. на вагон */
  fast_i3: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  /** Пассажирский И1 руб. на поезд */
  passenger_i1: Scalars['Float']['output'];
  /** Пассажирский И2 руб. на вагон */
  passenger_i2: Scalars['Float']['output'];
  /** Пассажирский И3 руб. на вагон */
  passenger_i3: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type InfrastructureApplication25List = {
  __typename: 'InfrastructureApplication25List';
  items: Array<InfrastructureApplication25Dto>;
  totalCount: Scalars['Float']['output'];
};

export type InfrastructureApplication25QueryEntryPoint = {
  __typename: 'InfrastructureApplication25QueryEntryPoint';
  /** Список тарифов на услуги по использованию инфраструктуры регулируемой организации (Приложение 25) */
  list: InfrastructureApplication25List;
};


export type InfrastructureApplication25QueryEntryPointListArgs = {
  data: QueryInfrastructureApplication25DataDto;
  order_by?: InputMaybe<Array<InfrastructureApplication25QueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<InfrastructureApplication25QueryResolver_List_FilterInputType>;
};

export type InfrastructureApplication25QueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<InfrastructureApplication25QueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  distance_end?: InputMaybe<Number_PropertyFilterInputType>;
  distance_start?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_0_140_m1_30_75_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_0_140_m1_30_75_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_0_140_m1_30_75_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_140_etc_v2_160_etc_m1_30_75_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_140_etc_v2_160_etc_m1_30_75_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_140_etc_v2_160_etc_m1_30_75_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v91_140_etc_v2_160_etc_m1_30_75_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v91_140_etc_v2_160_etc_m1_30_75_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v91_140_etc_v2_160_etc_m1_30_75_i3?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i1?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i2?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i3?: InputMaybe<Number_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureApplication25QueryResolver_List_BaseFilterInputType>>;
  passenger_i1?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i2?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i3?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureApplication25QueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<InfrastructureApplication25QueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  distance_end?: InputMaybe<Number_PropertyFilterInputType>;
  distance_start?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_0_140_m1_30_75_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_0_140_m1_30_75_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_0_140_m1_30_75_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_140_etc_v2_160_etc_m1_30_75_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_140_etc_v2_160_etc_m1_30_75_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v1_140_etc_v2_160_etc_m1_30_75_i3?: InputMaybe<Number_PropertyFilterInputType>;
  express_v91_140_etc_v2_160_etc_m1_30_75_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_v91_140_etc_v2_160_etc_m1_30_75_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_v91_140_etc_v2_160_etc_m1_30_75_i3?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i1?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i2?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i3?: InputMaybe<Number_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureApplication25QueryResolver_List_BaseFilterInputType>>;
  passenger_i1?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i2?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i3?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureApplication25QueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  distance_end?: InputMaybe<SortType>;
  distance_start?: InputMaybe<SortType>;
  express_v1_91_140_v2_0_140_m1_30_75_i1?: InputMaybe<SortType>;
  express_v1_91_140_v2_0_140_m1_30_75_i2?: InputMaybe<SortType>;
  express_v1_91_140_v2_0_140_m1_30_75_i3?: InputMaybe<SortType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i1?: InputMaybe<SortType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i2?: InputMaybe<SortType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i3?: InputMaybe<SortType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i1?: InputMaybe<SortType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i2?: InputMaybe<SortType>;
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i3?: InputMaybe<SortType>;
  express_v1_140_etc_v2_160_etc_m1_30_75_i1?: InputMaybe<SortType>;
  express_v1_140_etc_v2_160_etc_m1_30_75_i2?: InputMaybe<SortType>;
  express_v1_140_etc_v2_160_etc_m1_30_75_i3?: InputMaybe<SortType>;
  express_v91_140_etc_v2_160_etc_m1_30_75_i1?: InputMaybe<SortType>;
  express_v91_140_etc_v2_160_etc_m1_30_75_i2?: InputMaybe<SortType>;
  express_v91_140_etc_v2_160_etc_m1_30_75_i3?: InputMaybe<SortType>;
  fast_i1?: InputMaybe<SortType>;
  fast_i2?: InputMaybe<SortType>;
  fast_i3?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  passenger_i1?: InputMaybe<SortType>;
  passenger_i2?: InputMaybe<SortType>;
  passenger_i3?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type InfrastructureApplication26Dto = {
  __typename: 'InfrastructureApplication26Dto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Расстояние по */
  distance_end: Scalars['Float']['output'];
  /** Расстояние с */
  distance_start: Scalars['Float']['output'];
  /** Скоростной И1 руб. на поезд */
  express_i1: Scalars['Float']['output'];
  /** Скоростной И2 руб. на вагон */
  express_i2: Scalars['Float']['output'];
  /** Скоростной И3 руб. на вагон */
  express_i3: Scalars['Float']['output'];
  /** Скорый И1 руб. на поезд */
  fast_i1: Scalars['Float']['output'];
  /** Скорый И2 руб. на вагон */
  fast_i2: Scalars['Float']['output'];
  /** Скорый И3 руб. на вагон */
  fast_i3: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  /** Пассажирский И1 руб. на поезд */
  passenger_i1: Scalars['Float']['output'];
  /** Пассажирский И2 руб. на вагон */
  passenger_i2: Scalars['Float']['output'];
  /** Пассажирский И3 руб. на вагон */
  passenger_i3: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type InfrastructureApplication26List = {
  __typename: 'InfrastructureApplication26List';
  items: Array<InfrastructureApplication26Dto>;
  totalCount: Scalars['Float']['output'];
};

export type InfrastructureApplication26QueryEntryPoint = {
  __typename: 'InfrastructureApplication26QueryEntryPoint';
  /** Список тарифов на услуги по использованию инфраструктуры регулируемой организации (Приложение 26) */
  list: InfrastructureApplication26List;
};


export type InfrastructureApplication26QueryEntryPointListArgs = {
  data: QueryInfrastructureApplication26DataDto;
  order_by?: InputMaybe<Array<InfrastructureApplication26QueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<InfrastructureApplication26QueryResolver_List_FilterInputType>;
};

export type InfrastructureApplication26QueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<InfrastructureApplication26QueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  distance_end?: InputMaybe<Number_PropertyFilterInputType>;
  distance_start?: InputMaybe<Number_PropertyFilterInputType>;
  express_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_i3?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i1?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i2?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i3?: InputMaybe<Number_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureApplication26QueryResolver_List_BaseFilterInputType>>;
  passenger_i1?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i2?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i3?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureApplication26QueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<InfrastructureApplication26QueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  distance_end?: InputMaybe<Number_PropertyFilterInputType>;
  distance_start?: InputMaybe<Number_PropertyFilterInputType>;
  express_i1?: InputMaybe<Number_PropertyFilterInputType>;
  express_i2?: InputMaybe<Number_PropertyFilterInputType>;
  express_i3?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i1?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i2?: InputMaybe<Number_PropertyFilterInputType>;
  fast_i3?: InputMaybe<Number_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureApplication26QueryResolver_List_BaseFilterInputType>>;
  passenger_i1?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i2?: InputMaybe<Number_PropertyFilterInputType>;
  passenger_i3?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureApplication26QueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  distance_end?: InputMaybe<SortType>;
  distance_start?: InputMaybe<SortType>;
  express_i1?: InputMaybe<SortType>;
  express_i2?: InputMaybe<SortType>;
  express_i3?: InputMaybe<SortType>;
  fast_i1?: InputMaybe<SortType>;
  fast_i2?: InputMaybe<SortType>;
  fast_i3?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  passenger_i1?: InputMaybe<SortType>;
  passenger_i2?: InputMaybe<SortType>;
  passenger_i3?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type InfrastructureApplication27Dto = {
  __typename: 'InfrastructureApplication27Dto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  mnemonic: MnemonicDto;
  /** Размер, руб./1 вагон */
  price: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type InfrastructureApplication27List = {
  __typename: 'InfrastructureApplication27List';
  items: Array<InfrastructureApplication27Dto>;
  totalCount: Scalars['Float']['output'];
};

export type InfrastructureApplication27QueryEntryPoint = {
  __typename: 'InfrastructureApplication27QueryEntryPoint';
  /** Список размеров уменьшения платы за услуги по использованию инфраструктуры регулируемой организацией (Приложение 27) */
  list: InfrastructureApplication27List;
};


export type InfrastructureApplication27QueryEntryPointListArgs = {
  data: QueryInfrastructureApplication27DataDto;
  order_by?: InputMaybe<Array<InfrastructureApplication27QueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<InfrastructureApplication27QueryResolver_List_FilterInputType>;
};

export type InfrastructureApplication27QueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<InfrastructureApplication27QueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureApplication27QueryResolver_List_BaseFilterInputType>>;
  price?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureApplication27QueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<InfrastructureApplication27QueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureApplication27QueryResolver_List_BaseFilterInputType>>;
  price?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureApplication27QueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  price?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type InfrastructureCalculationByBranchDto = {
  __typename: 'InfrastructureCalculationByBranchDto';
  items: Array<InfrastructureCalculationByBranchRowDto>;
  /** всего по администрациям */
  total: InfrastructureCalculationByBranchRowDto;
};

export type InfrastructureCalculationByBranchRowDto = {
  __typename: 'InfrastructureCalculationByBranchRowDto';
  /** Пробег вагонов - пасс - итог */
  carriagesDistancePassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - всего */
  carriagesDistanceTotal?: Maybe<Scalars['Float']['output']>;
  /** Поездо-км */
  distance?: Maybe<Scalars['Float']['output']>;
  /** всего по  */
  name: Scalars['String']['output'];
  /** всего с учётом ндс */
  totalWithNds?: Maybe<Scalars['Float']['output']>;
  /** Количество рейсов  */
  tripsQuantity?: Maybe<Scalars['Float']['output']>;
};

export type InfrastructureCalculationCategoryDto = {
  __typename: 'InfrastructureCalculationCategoryDto';
  /** Категория */
  category: Scalars['String']['output'];
  /** итого по категории */
  total?: Maybe<InfrastructureCalculationTotalDto>;
  /** итого по внутригосударственным */
  totalCountry: InfrastructureCalculationTotalDto;
  /** Поезда */
  trains?: Maybe<Array<InfrastructureCalculationTrainDto>>;
};

export type InfrastructureCalculationDto = {
  __typename: 'InfrastructureCalculationDto';
  /** Категории */
  categories: Array<InfrastructureCalculationCategoryDto>;
  /** всего по категориям */
  total: InfrastructureCalculationTotalDto;
};

export type InfrastructureCalculationRowDto = {
  __typename: 'InfrastructureCalculationRowDto';
  /** Количество вагонов - другое - багаж - Всего */
  carriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - другое - багаж - всего */
  carriagesDistanceBaggage?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - другое - прочие */
  carriagesDistanceOther?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - другое - итог */
  carriagesDistanceOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - дерег - К */
  carriagesDistancePassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - дерег - СВ */
  carriagesDistancePassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - рег - О */
  carriagesDistancePassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - рег - П */
  carriagesDistancePassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - итог */
  carriagesDistancePassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - другое - багаж - почта России */
  carriagesDistancePostal?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - всего */
  carriagesDistanceTotal?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - другое - прочие */
  carriagesOther?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - другое - итог */
  carriagesOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - пассажирских - дерег - К */
  carriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - пассажирских - дерег - СВ */
  carriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - пассажирских - рег - О */
  carriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - пассажирских - рег - П */
  carriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - пассажирских - итог */
  carriagesPassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - другое - багаж - почта россии */
  carriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - всего */
  carriagesTotal?: Maybe<Scalars['Float']['output']>;
  /** Расстояние следования по территории РЖД */
  countryDistance: Scalars['Float']['output'];
  /** Поездо-км */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Проследовало в поезде / прицепки / отцепки */
  groupSign?: Maybe<Scalars['String']['output']>;
  /** ндс */
  nds?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  другое - багаж - всего */
  s1CarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  другое - прочие */
  s1CarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  другое - итог  */
  s1CarriagesOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 - всего без учёта ндс */
  s1CarriagesOtherTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - дерег - К */
  s1CarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - дерег - СВ */
  s1CarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - рег - О */
  s1CarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - рег - П */
  s1CarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - итог */
  s1CarriagesPassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  другое - багаж - почта */
  s1CarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - багаж - всего */
  s2CarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - прочие */
  s2CarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - итог  */
  s2CarriagesOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 - всего без учёта ндс */
  s2CarriagesOtherTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - дерег - К */
  s2CarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - дерег - СВ */
  s2CarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - рег - О */
  s2CarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - рег - П */
  s2CarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - итог */
  s2CarriagesPassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - багаж - почта */
  s2CarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  другое - багаж - всего */
  s3CarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  другое - прочие */
  s3CarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 - всего без учёта ндс */
  s3CarriagesOtherTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - дерег - К */
  s3CarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - дерег - СВ */
  s3CarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - рег - О */
  s3CarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - рег - П */
  s3CarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  другое - багаж - почта */
  s3CarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** Станция отправления */
  stationFrom: Scalars['String']['output'];
  /** Станция назначения */
  stationTo: Scalars['String']['output'];
  /** Итого - другое - багаж - всего */
  totalCarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** итого - другое - прочие */
  totalCarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** итого - другое - итог */
  totalCarriagesOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - дерег - К */
  totalCarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - дерег - св */
  totalCarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - рег - О */
  totalCarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - рег - П */
  totalCarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - итог */
  totalCarriagesPassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Итого - другое - багаж - почта */
  totalCarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** итого - всего без учёта ндс */
  totalCarriagesTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** всего с учётом ндс */
  totalWithNds?: Maybe<Scalars['Float']['output']>;
  /** Количество рейсов  */
  tripsQuantity?: Maybe<Scalars['Float']['output']>;
};

export type InfrastructureCalculationTotalDto = {
  __typename: 'InfrastructureCalculationTotalDto';
  /** Пробег вагонов - другое - багаж - всего */
  carriagesDistanceBaggage?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - другое - прочие */
  carriagesDistanceOther?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - другое - итог */
  carriagesDistanceOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - дерег - К */
  carriagesDistancePassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - дерег - СВ */
  carriagesDistancePassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - рег - О */
  carriagesDistancePassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - рег - П */
  carriagesDistancePassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - итог */
  carriagesDistancePassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - другое - багаж - почта России */
  carriagesDistancePostal?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - всего */
  carriagesDistanceTotal?: Maybe<Scalars['Float']['output']>;
  /** Поездо-км */
  distance?: Maybe<Scalars['Float']['output']>;
  /** ндс */
  nds?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  другое - багаж - всего */
  s1CarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  другое - прочие */
  s1CarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  другое - итог  */
  s1CarriagesOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 - всего без учёта ндс */
  s1CarriagesOtherTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - дерег - К */
  s1CarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - дерег - СВ */
  s1CarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - рег - О */
  s1CarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - рег - П */
  s1CarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - итог */
  s1CarriagesPassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  другое - багаж - почта */
  s1CarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - багаж - всего */
  s2CarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - прочие */
  s2CarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - итог  */
  s2CarriagesOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 - всего без учёта ндс */
  s2CarriagesOtherTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - дерег - К */
  s2CarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - дерег - СВ */
  s2CarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - рег - О */
  s2CarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - рег - П */
  s2CarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - итог */
  s2CarriagesPassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - багаж - почта */
  s2CarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  другое - багаж - всего */
  s3CarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  другое - прочие */
  s3CarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 - всего без учёта ндс */
  s3CarriagesOtherTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - дерег - К */
  s3CarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - дерег - СВ */
  s3CarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - рег - О */
  s3CarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - рег - П */
  s3CarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  другое - багаж - почта */
  s3CarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** Итого - другое - багаж - всего */
  totalCarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** итого - другое - прочие */
  totalCarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** итого - другое - итог */
  totalCarriagesOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - дерег - К */
  totalCarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - дерег - св */
  totalCarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - рег - О */
  totalCarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - рег - П */
  totalCarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - итог */
  totalCarriagesPassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Итого - другое - багаж - почта */
  totalCarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** итого - всего без учёта ндс */
  totalCarriagesTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** всего с учётом ндс */
  totalWithNds?: Maybe<Scalars['Float']['output']>;
  /** Количество рейсов  */
  tripsQuantity?: Maybe<Scalars['Float']['output']>;
};

export type InfrastructureCalculationTrainDto = {
  __typename: 'InfrastructureCalculationTrainDto';
  /** Количество вагонов - другое - багаж - Всего */
  carriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - другое - багаж - всего */
  carriagesDistanceBaggage?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - другое - прочие */
  carriagesDistanceOther?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - другое - итог */
  carriagesDistanceOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - дерег - К */
  carriagesDistancePassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - дерег - СВ */
  carriagesDistancePassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - рег - О */
  carriagesDistancePassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - рег - П */
  carriagesDistancePassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - пасс - итог */
  carriagesDistancePassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - другое - багаж - почта России */
  carriagesDistancePostal?: Maybe<Scalars['Float']['output']>;
  /** Пробег вагонов - всего */
  carriagesDistanceTotal?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - другое - прочие */
  carriagesOther?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - другое - итог */
  carriagesOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - пассажирских - дерег - К */
  carriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - пассажирских - дерег - СВ */
  carriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - пассажирских - рег - О */
  carriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - пассажирских - рег - П */
  carriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - пассажирских - итог */
  carriagesPassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - другое - багаж - почта россии */
  carriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** Количество вагонов - всего */
  carriagesTotal?: Maybe<Scalars['Float']['output']>;
  /** Расстояние следования по территории РЖД */
  countryDistance: Scalars['Float']['output'];
  /** Поездо-км */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Проследовало в поезде / прицепки / отцепки */
  groupSign?: Maybe<Scalars['String']['output']>;
  /** ндс */
  nds?: Maybe<Scalars['Float']['output']>;
  /** группы */
  rows?: Maybe<Array<InfrastructureCalculationRowDto>>;
  /** Схема И1 -  другое - багаж - всего */
  s1CarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  другое - прочие */
  s1CarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  другое - итог  */
  s1CarriagesOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 - всего без учёта ндс */
  s1CarriagesOtherTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - дерег - К */
  s1CarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - дерег - СВ */
  s1CarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - рег - О */
  s1CarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - рег - П */
  s1CarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  пасс - итог */
  s1CarriagesPassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И1 -  другое - багаж - почта */
  s1CarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - багаж - всего */
  s2CarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - прочие */
  s2CarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - итог  */
  s2CarriagesOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 - всего без учёта ндс */
  s2CarriagesOtherTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - дерег - К */
  s2CarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - дерег - СВ */
  s2CarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - рег - О */
  s2CarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - рег - П */
  s2CarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  пасс - итог */
  s2CarriagesPassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Схема И2 -  другое - багаж - почта */
  s2CarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  другое - багаж - всего */
  s3CarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  другое - прочие */
  s3CarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 - всего без учёта ндс */
  s3CarriagesOtherTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - дерег - К */
  s3CarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - дерег - СВ */
  s3CarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - рег - О */
  s3CarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  пасс - рег - П */
  s3CarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Схема И3 -  другое - багаж - почта */
  s3CarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** Станция отправления */
  stationFrom: Scalars['String']['output'];
  /** Станция назначения */
  stationTo: Scalars['String']['output'];
  /** Итого - другое - багаж - всего */
  totalCarriagesBaggage?: Maybe<Scalars['Float']['output']>;
  /** итого - другое - прочие */
  totalCarriagesOther?: Maybe<Scalars['Float']['output']>;
  /** итого - другое - итог */
  totalCarriagesOtherTotal?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - дерег - К */
  totalCarriagesPassengerDeregK?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - дерег - св */
  totalCarriagesPassengerDeregSv?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - рег - О */
  totalCarriagesPassengerRegO?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - рег - П */
  totalCarriagesPassengerRegP?: Maybe<Scalars['Float']['output']>;
  /** Итого - пасс - итог */
  totalCarriagesPassengerTotal?: Maybe<Scalars['Float']['output']>;
  /** Итого - другое - багаж - почта */
  totalCarriagesPostal?: Maybe<Scalars['Float']['output']>;
  /** итого - всего без учёта ндс */
  totalCarriagesTotalWithoutNds?: Maybe<Scalars['Float']['output']>;
  /** всего с учётом ндс */
  totalWithNds?: Maybe<Scalars['Float']['output']>;
  /** номер поезда */
  trainNumber: Scalars['String']['output'];
  /** Количество рейсов  */
  tripsQuantity?: Maybe<Scalars['Float']['output']>;
};

export type InfrastructureCoefficientIndexingDto = {
  __typename: 'InfrastructureCoefficientIndexingDto';
  /** Коэффициент */
  coefficient: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Действует по */
  end_at: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Действует с */
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type InfrastructureCoefficientIndexingList = {
  __typename: 'InfrastructureCoefficientIndexingList';
  items: Array<InfrastructureCoefficientIndexingDto>;
  totalCount: Scalars['Float']['output'];
};

export type InfrastructureCoefficientIndexingMutationEntryPoint = {
  __typename: 'InfrastructureCoefficientIndexingMutationEntryPoint';
  /** Создание коэффициента индексации к тарифам на использование услуг инфраструктуры */
  create: Scalars['Float']['output'];
  /** Обновление коэффициента индексации к тарифам на использование услуг инфраструктуры */
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type InfrastructureCoefficientIndexingMutationEntryPointCreateArgs = {
  data: CreateInfrastructureCoefficientIndexingDto;
};


export type InfrastructureCoefficientIndexingMutationEntryPointUpdateArgs = {
  data: UpdateInfrastructureCoefficientIndexingDto;
};

export type InfrastructureCoefficientIndexingQueryEntryPoint = {
  __typename: 'InfrastructureCoefficientIndexingQueryEntryPoint';
  /** Коэффициент индексации к тарифам на использование услуг инфраструктуры по id */
  byId: InfrastructureCoefficientIndexingDto;
  /** Коэффициенты индексации к тарифам на использование услуг инфраструктуры по периоду */
  byRange: InfrastructureCoefficientIndexingList;
  /** Список коэффициентов индексации к тарифам на использование услуг инфраструктуры */
  list: InfrastructureCoefficientIndexingList;
};


export type InfrastructureCoefficientIndexingQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type InfrastructureCoefficientIndexingQueryEntryPointByRangeArgs = {
  range: RangeInputDto;
};


export type InfrastructureCoefficientIndexingQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<InfrastructureCoefficientIndexingQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<InfrastructureCoefficientIndexingQueryResolver_List_FilterInputType>;
};

export type InfrastructureCoefficientIndexingQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<InfrastructureCoefficientIndexingQueryResolver_List_BaseFilterInputType>>;
  coefficient?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureCoefficientIndexingQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureCoefficientIndexingQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<InfrastructureCoefficientIndexingQueryResolver_List_BaseFilterInputType>>;
  coefficient?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructureCoefficientIndexingQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type InfrastructureCoefficientIndexingQueryResolver_List_SortingInputType = {
  coefficient?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type Int_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['Int']['input']>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  in_arr?: InputMaybe<Array<Scalars['Int']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notbetween?: InputMaybe<Array<Scalars['Int']['input']>>;
  notin?: InputMaybe<Array<Scalars['Int']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntoTrainInfoDto = {
  __typename: 'IntoTrainInfoDto';
  /** Фирменные пары поездов АО ФПК */
  brand_trains_pair: TrainPairsDashboardDto;
  /** Пары поездов АО ФПК - Дневные */
  daytime_trains_pair: TrainPairsDashboardDto;
  /** Скоростные пары поездов АО ФПК */
  fast_trains_pair: TrainPairsDashboardDto;
  /** Международные пары поездов АО ФПК */
  international_trains_pair: TrainPairsDashboardDto;
  /** Внетренние пары поездов АО ФПК */
  interstate_trains_pair: TrainPairsDashboardDto;
  /** Пары поездов АО ФПК - КРИ */
  kri_trains_pair: TrainPairsDashboardDto;
  /** Пары поездов АО ФПК - МВПС */
  mvps_trains_pair: TrainPairsDashboardDto;
  /** Пары поездов АО ФПК - Южное направление */
  southbound_trains_pair: TrainPairsDashboardDto;
  /** Пары поездов АО ФПК - Тпр */
  tpr_trains_pair: TrainPairsDashboardDto;
  /** Пары поездов АО ФПК - ВР/КБ */
  vr_kb_trains_pair: TrainPairsDashboardDto;
};

export type JobDataDto = {
  __typename: 'JobDataDto';
  fileId: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['Float']['output'];
};

export type JobDto = {
  __typename: 'JobDto';
  data: JobDataDto;
  failedReason?: Maybe<Scalars['Float']['output']>;
  finishedOn?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  opts: JobOptsDto;
};

export type JobList = {
  __typename: 'JobList';
  items: Array<JobDto>;
  totalCount: Scalars['Float']['output'];
};

export type JobOptsDto = {
  __typename: 'JobOptsDto';
  attempts: Scalars['Float']['output'];
  timestamp: Scalars['Float']['output'];
};

export type JournalQueryEntryPoint = {
  __typename: 'JournalQueryEntryPoint';
  /** Журнал действий по id */
  action_log_by_id: ActionLogList;
  /** Журнал действий */
  action_logs: ActionLogList;
  /** Журнал выгрузок */
  export_logs: ExportLogList;
  /** Журнал аудита действий текущего пользователя */
  me_action_audit: UserActionAuditList;
  /** Журнал аудита действий пользователей */
  user_action_audit: UserActionAuditList;
};


export type JournalQueryEntryPointAction_Log_By_IdArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<JournalQueryResolver_ActionLogById_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<JournalQueryResolver_ActionLogById_FilterInputType>;
};


export type JournalQueryEntryPointAction_LogsArgs = {
  order_by?: InputMaybe<Array<JournalQueryResolver_ActionLogs_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<JournalQueryResolver_ActionLogs_FilterInputType>;
};


export type JournalQueryEntryPointExport_LogsArgs = {
  order_by?: InputMaybe<Array<JournalQueryResolver_ExportLogs_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<JournalQueryResolver_ExportLogs_FilterInputType>;
};


export type JournalQueryEntryPointMe_Action_AuditArgs = {
  order_by?: InputMaybe<Array<JournalQueryResolver_MeActionAudit_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<JournalQueryResolver_MeActionAudit_FilterInputType>;
};


export type JournalQueryEntryPointUser_Action_AuditArgs = {
  order_by?: InputMaybe<Array<JournalQueryResolver_UserActionAudit_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<JournalQueryResolver_UserActionAudit_FilterInputType>;
};

export type JournalQueryResolver_ActionLogById_BaseFilterInputType = {
  action?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<JournalQueryResolver_ActionLogById_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Number_PropertyFilterInputType>;
  entity_type?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  meta?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<JournalQueryResolver_ActionLogById_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_type?: InputMaybe<String_PropertyFilterInputType>;
  payload?: InputMaybe<String_PropertyFilterInputType>;
};

export type JournalQueryResolver_ActionLogById_FilterInputType = {
  action?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<JournalQueryResolver_ActionLogById_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Number_PropertyFilterInputType>;
  entity_type?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  meta?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<JournalQueryResolver_ActionLogById_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_type?: InputMaybe<String_PropertyFilterInputType>;
  payload?: InputMaybe<String_PropertyFilterInputType>;
};

export type JournalQueryResolver_ActionLogById_SortingInputType = {
  action?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  entity_type?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  meta?: InputMaybe<SortType>;
  parent_id?: InputMaybe<SortType>;
  parent_type?: InputMaybe<SortType>;
  payload?: InputMaybe<SortType>;
};

export type JournalQueryResolver_ActionLogs_BaseFilterInputType = {
  action?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<JournalQueryResolver_ActionLogs_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Number_PropertyFilterInputType>;
  entity_type?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  meta?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<JournalQueryResolver_ActionLogs_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_type?: InputMaybe<String_PropertyFilterInputType>;
  payload?: InputMaybe<String_PropertyFilterInputType>;
};

export type JournalQueryResolver_ActionLogs_FilterInputType = {
  action?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<JournalQueryResolver_ActionLogs_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Number_PropertyFilterInputType>;
  entity_type?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  meta?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<JournalQueryResolver_ActionLogs_BaseFilterInputType>>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_type?: InputMaybe<String_PropertyFilterInputType>;
  payload?: InputMaybe<String_PropertyFilterInputType>;
};

export type JournalQueryResolver_ActionLogs_SortingInputType = {
  action?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  entity_type?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  meta?: InputMaybe<SortType>;
  parent_id?: InputMaybe<SortType>;
  parent_type?: InputMaybe<SortType>;
  payload?: InputMaybe<SortType>;
};

export type JournalQueryResolver_ExportLogs_BaseFilterInputType = {
  and?: InputMaybe<Array<JournalQueryResolver_ExportLogs_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  file_info?: InputMaybe<String_PropertyFilterInputType>;
  filters?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<JournalQueryResolver_ExportLogs_BaseFilterInputType>>;
  request_id?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
};

export type JournalQueryResolver_ExportLogs_FilterInputType = {
  and?: InputMaybe<Array<JournalQueryResolver_ExportLogs_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  file_info?: InputMaybe<String_PropertyFilterInputType>;
  filters?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<JournalQueryResolver_ExportLogs_BaseFilterInputType>>;
  request_id?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
};

export type JournalQueryResolver_ExportLogs_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  file_info?: InputMaybe<SortType>;
  filters?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  request_id?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
  type?: InputMaybe<SortType>;
};

export type JournalQueryResolver_MeActionAudit_BaseFilterInputType = {
  action?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<JournalQueryResolver_MeActionAudit_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<JournalQueryResolver_MeActionAudit_BaseFilterInputType>>;
  target?: InputMaybe<String_PropertyFilterInputType>;
  target_id?: InputMaybe<Number_PropertyFilterInputType>;
  typename?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
};

export type JournalQueryResolver_MeActionAudit_FilterInputType = {
  action?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<JournalQueryResolver_MeActionAudit_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<JournalQueryResolver_MeActionAudit_BaseFilterInputType>>;
  target?: InputMaybe<String_PropertyFilterInputType>;
  target_id?: InputMaybe<Number_PropertyFilterInputType>;
  typename?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
};

export type JournalQueryResolver_MeActionAudit_SortingInputType = {
  action?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  target?: InputMaybe<SortType>;
  target_id?: InputMaybe<SortType>;
  typename?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type JournalQueryResolver_UserActionAudit_BaseFilterInputType = {
  action?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<JournalQueryResolver_UserActionAudit_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<JournalQueryResolver_UserActionAudit_BaseFilterInputType>>;
  target?: InputMaybe<String_PropertyFilterInputType>;
  target_id?: InputMaybe<Number_PropertyFilterInputType>;
  typename?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type JournalQueryResolver_UserActionAudit_FilterInputType = {
  action?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<JournalQueryResolver_UserActionAudit_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<JournalQueryResolver_UserActionAudit_BaseFilterInputType>>;
  target?: InputMaybe<String_PropertyFilterInputType>;
  target_id?: InputMaybe<Number_PropertyFilterInputType>;
  typename?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type JournalQueryResolver_UserActionAudit_SortingInputType = {
  action?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  target?: InputMaybe<SortType>;
  target_id?: InputMaybe<SortType>;
  typename?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type JournalSyncDto = {
  __typename: 'JournalSyncDto';
  /** Дата синхронизации */
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Наименование */
  name: Scalars['String']['output'];
  /** Статус */
  status: Scalars['String']['output'];
  /** Массив обновлённых записей */
  updatedEntities?: Maybe<Array<JournalUpdatedEntitiesDto>>;
};

export type JournalSyncList = {
  __typename: 'JournalSyncList';
  items: Array<JournalSyncDto>;
  totalCount: Scalars['Float']['output'];
};

export type JournalUpdatedEntitiesDto = {
  __typename: 'JournalUpdatedEntitiesDto';
  /** Описание операции */
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Наименование */
  name: Scalars['String']['output'];
};

export type LatestVersionDataDto = {
  __typename: 'LatestVersionDataDto';
  /** Окончание временного интервала */
  end_at?: Maybe<Scalars['String']['output']>;
  /** Флаг для вывода кнопки создания новой версии */
  is_available_to_create_version: Scalars['Boolean']['output'];
  /** флаг последней версии для записи - true - последняя, false - есть новые версии */
  is_latest: Scalars['Boolean']['output'];
  /** Начало временного интервала */
  start_at: Scalars['String']['output'];
};

export type LockTrainDto = {
  /** Статус */
  lock: Scalars['Boolean']['input'];
  /** идентификатор поезда */
  train_id: Scalars['Int']['input'];
};

export type LocomotiveAreaDto = {
  __typename: 'LocomotiveAreaDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Расстояние между станцией отправления и станцией прибытия */
  distance: Scalars['Float']['output'];
  fragments: Array<TrainScheduleFragmentDto>;
  from_station: StationDto;
  /** Идентификатор станции отправления */
  from_station_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Флаг формирования с учетом основной группы вагонов */
  is_main_group_check: Scalars['Boolean']['output'];
  /** Валидность участков локомотивного обслуживания */
  is_valid: Scalars['Boolean']['output'];
  locomotive_series?: Maybe<LocomotiveSeriesDto>;
  /** Идентификатор серии локомотива */
  locomotive_series_id?: Maybe<Scalars['Int']['output']>;
  /** Порядковый номер */
  order_number: Scalars['Int']['output'];
  /** Бригады локомотивного обслуживания */
  team_areas: Array<LocomotiveTeamAreaDto>;
  to_station: StationDto;
  /** Идентификатор станции прибытия */
  to_station_id: Scalars['Int']['output'];
  traction_directorate?: Maybe<TractionDirectorateDto>;
  /** Идентификатор дирекции тяги */
  traction_directorate_id?: Maybe<Scalars['Int']['output']>;
  /** Номер поезда */
  train_number?: Maybe<Scalars['String']['output']>;
  /** Стоимость пути в копейках */
  trip_cost?: Maybe<Scalars['Float']['output']>;
  /** Время в пути в секундах */
  trip_time: Scalars['Float']['output'];
  /** Виды тока */
  types_current: Array<TypeCurrentDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type LocomotiveChangeDto = {
  __typename: 'LocomotiveChangeDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  /** Направление */
  direction: Scalars['String']['output'];
  for_station: StationDto;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type LocomotiveFinalCalculationsByDirectoratesDto = {
  __typename: 'LocomotiveFinalCalculationsByDirectoratesDto';
  /** Дирекции */
  items: Array<LocomotiveFinalCalculationsByDirectoratesItemDto>;
  /** Итог по дирекциям */
  total: LocomotiveFinalCalculationsByDirectoratesItemDto;
};

export type LocomotiveFinalCalculationsByDirectoratesRequestDto = {
  /** Начало периода */
  from_date: Scalars['String']['input'];
  /** по времени отправления или прибытия */
  is_arrival?: InputMaybe<Scalars['Boolean']['input']>;
  /** Окончание периода */
  to_date: Scalars['String']['input'];
};

export type LocomotivePriceTechnicalServiceDto = {
  __typename: 'LocomotivePriceTechnicalServiceDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  locomotive_series: LocomotiveSeriesDto;
  /** Стоимость обслуживания */
  maintenance_cost?: Maybe<Scalars['Float']['output']>;
  series_type: LocomotiveSeriesTypeDto;
  start_at: Scalars['String']['output'];
  traction_directorate: TractionDirectorateDto;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type LocomotivePriceTechnicalServiceList = {
  __typename: 'LocomotivePriceTechnicalServiceList';
  items: Array<LocomotivePriceTechnicalServiceDto>;
  totalCount: Scalars['Float']['output'];
};

export type LocomotivePriceTechnicalServiceMutationEntryPoint = {
  __typename: 'LocomotivePriceTechnicalServiceMutationEntryPoint';
  /** Создание стоимости технического обслуживания локомотивов */
  create: LocomotivePriceTechnicalServiceDto;
  /** Обновление стоимости технического обслуживания локомотивов */
  update: LocomotivePriceTechnicalServiceDto;
};


export type LocomotivePriceTechnicalServiceMutationEntryPointCreateArgs = {
  data: CreateLocomotivePriceTechnicalServiceDto;
};


export type LocomotivePriceTechnicalServiceMutationEntryPointUpdateArgs = {
  data: UpdateLocomotivePriceTechnicalServiceDto;
};

export type LocomotivePriceTechnicalServiceQueryEntryPoint = {
  __typename: 'LocomotivePriceTechnicalServiceQueryEntryPoint';
  /** Стоимость технического обслуживания локомотивов по id */
  byEntityId: LocomotivePriceTechnicalServiceDto;
  /** Список стоимости технического обслуживания локомотивов */
  history: LocomotivePriceTechnicalServiceList;
  /** Список стоимостей технического обслуживания локомотивов */
  list: LocomotivePriceTechnicalServiceList;
};


export type LocomotivePriceTechnicalServiceQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type LocomotivePriceTechnicalServiceQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<LocomotivePriceTechnicalServiceQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type LocomotivePriceTechnicalServiceQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<LocomotivePriceTechnicalServiceQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  range: RangeInputDto;
  search: Scalars['String']['input'];
  where?: InputMaybe<LocomotivePriceTechnicalServiceQueryResolver_List_FilterInputType>;
};

export type LocomotivePriceTechnicalServiceQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  maintenance_cost?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type LocomotivePriceTechnicalServiceQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<LocomotivePriceTechnicalServiceQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotives_series_id?: InputMaybe<Number_PropertyFilterInputType>;
  maintenance_cost?: InputMaybe<Number_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotivePriceTechnicalServiceQueryResolver_List_BaseFilterInputType>>;
  series_type_id?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  traction_directorates_id?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type LocomotivePriceTechnicalServiceQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<LocomotivePriceTechnicalServiceQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotives_series_id?: InputMaybe<Number_PropertyFilterInputType>;
  maintenance_cost?: InputMaybe<Number_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotivePriceTechnicalServiceQueryResolver_List_BaseFilterInputType>>;
  series_type_id?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  traction_directorates_id?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type LocomotivePriceTechnicalServiceQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  maintenance_cost?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type LocomotiveSeriesDto = {
  __typename: 'LocomotiveSeriesDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Индекс */
  index?: Maybe<Scalars['String']['output']>;
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  locomotive_traction_type: LocomotiveTractionTypeDto;
  /** Идентификатор дирекции тяги */
  locomotive_traction_type_id?: Maybe<Scalars['Int']['output']>;
  /** Цена аренды */
  price_rent: Scalars['Float']['output'];
  /** Количество секций */
  section_quantity: Scalars['Int']['output'];
  /** Серия */
  series: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type LocomotiveSeriesList = {
  __typename: 'LocomotiveSeriesList';
  items: Array<LocomotiveSeriesDto>;
  totalCount: Scalars['Float']['output'];
};

export type LocomotiveSeriesMutationEntryPoint = {
  __typename: 'LocomotiveSeriesMutationEntryPoint';
  /** Создание серии локомотивов */
  create: LocomotiveSeriesDto;
  /** Обновление серии локомотива */
  update: LocomotiveSeriesDto;
};


export type LocomotiveSeriesMutationEntryPointCreateArgs = {
  data: CreateLocomotiveSeriesDto;
};


export type LocomotiveSeriesMutationEntryPointUpdateArgs = {
  data: UpdateLocomotiveSeriesDto;
};

export type LocomotiveSeriesQueryEntryPoint = {
  __typename: 'LocomotiveSeriesQueryEntryPoint';
  /** Серий локомотивов по id */
  byEntityId: LocomotiveSeriesDto;
  /** Список изменений типа признака мест */
  history: LocomotiveSeriesList;
  /** Список серий локомотивов */
  list: LocomotiveSeriesList;
};


export type LocomotiveSeriesQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type LocomotiveSeriesQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<LocomotiveSeriesQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type LocomotiveSeriesQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<LocomotiveSeriesQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  range: RangeInputDto;
  where?: InputMaybe<LocomotiveSeriesQueryResolver_List_FilterInputType>;
};

export type LocomotiveSeriesQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  index?: InputMaybe<SortType>;
  locomotive_traction_type_id?: InputMaybe<SortType>;
  price_rent?: InputMaybe<SortType>;
  section_quantity?: InputMaybe<SortType>;
  series?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type LocomotiveSeriesQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<LocomotiveSeriesQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  index?: InputMaybe<String_PropertyFilterInputType>;
  locomotive_traction_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveSeriesQueryResolver_List_BaseFilterInputType>>;
  price_rent?: InputMaybe<Number_PropertyFilterInputType>;
  section_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  series?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type LocomotiveSeriesQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<LocomotiveSeriesQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  index?: InputMaybe<String_PropertyFilterInputType>;
  locomotive_traction_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveSeriesQueryResolver_List_BaseFilterInputType>>;
  price_rent?: InputMaybe<Number_PropertyFilterInputType>;
  section_quantity?: InputMaybe<Int_PropertyFilterInputType>;
  series?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type LocomotiveSeriesQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  index?: InputMaybe<SortType>;
  locomotive_traction_type_id?: InputMaybe<SortType>;
  price_rent?: InputMaybe<SortType>;
  section_quantity?: InputMaybe<SortType>;
  series?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type LocomotiveSeriesTypeDto = {
  __typename: 'LocomotiveSeriesTypeDto';
  /** Идентификатор типа локомотива */
  id: Scalars['Int']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

export type LocomotiveSeriesTypeList = {
  __typename: 'LocomotiveSeriesTypeList';
  items: Array<LocomotiveSeriesTypeDto>;
  totalCount: Scalars['Float']['output'];
};

export type LocomotiveSeriesTypeQueryEntryPoint = {
  __typename: 'LocomotiveSeriesTypeQueryEntryPoint';
  /** Род службы локомотивов по id */
  byId: LocomotiveSeriesTypeDto;
  /** Список родов службы локомотивов */
  list: LocomotiveSeriesTypeList;
};


export type LocomotiveSeriesTypeQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type LocomotiveSeriesTypeQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<LocomotiveSeriesTypeQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<LocomotiveSeriesTypeQueryResolver_List_FilterInputType>;
};

export type LocomotiveSeriesTypeQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<LocomotiveSeriesTypeQueryResolver_List_BaseFilterInputType>>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveSeriesTypeQueryResolver_List_BaseFilterInputType>>;
};

export type LocomotiveSeriesTypeQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<LocomotiveSeriesTypeQueryResolver_List_BaseFilterInputType>>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveSeriesTypeQueryResolver_List_BaseFilterInputType>>;
};

export type LocomotiveSeriesTypeQueryResolver_List_SortingInputType = {
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
};

export type LocomotiveServiceDto = {
  __typename: 'LocomotiveServiceDto';
  branch?: Maybe<BranchDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  from_station: StationDto;
  gdp: GdpDto;
  id: Scalars['Int']['output'];
  locomotive_traction_types: Array<LocomotiveTractionTypeDto>;
  passenger_carrier?: Maybe<PassengerCarrierDto>;
  railway_administration: RailwayAdministrationDto;
  start_at: Scalars['String']['output'];
  /** Статус поезда */
  status: Scalars['String']['output'];
  to_station: StationDto;
  total_costs: TotalCostsDto;
  traction_directorate_teams: Array<TractionDirectorateDto>;
  traction_directorates: Array<TractionDirectorateDto>;
  /** Номер поезда */
  train_number: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  /** Версия */
  version: Scalars['Int']['output'];
};

export type LocomotiveServiceEmpiricalParameterDto = {
  __typename: 'LocomotiveServiceEmpiricalParameterDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  mnemonic: MnemonicDto;
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  /** Единица измерения эмпирического параметра локомотивного обслуживания */
  value: Scalars['Float']['output'];
};

export type LocomotiveServiceEmpiricalParameterList = {
  __typename: 'LocomotiveServiceEmpiricalParameterList';
  items: Array<LocomotiveServiceEmpiricalParameterDto>;
  totalCount: Scalars['Float']['output'];
};

export type LocomotiveServiceEmpiricalParameterMutationEntryPoint = {
  __typename: 'LocomotiveServiceEmpiricalParameterMutationEntryPoint';
  /** Создание эмпирических параметров локомотивного обслуживания */
  create: LocomotiveServiceEmpiricalParameterDto;
  /** Обновление эмпирических параметров локомотивного обслуживания */
  update: LocomotiveServiceEmpiricalParameterDto;
};


export type LocomotiveServiceEmpiricalParameterMutationEntryPointCreateArgs = {
  data: CreateLocomotiveServiceEmpiricalParameterDto;
};


export type LocomotiveServiceEmpiricalParameterMutationEntryPointUpdateArgs = {
  data: UpdateLocomotiveServiceEmpiricalParameterDto;
};

export type LocomotiveServiceEmpiricalParameterQueryEntryPoint = {
  __typename: 'LocomotiveServiceEmpiricalParameterQueryEntryPoint';
  /** Эмпирические параметры локомотивного обслуживания по id */
  byEntityId: LocomotiveServiceEmpiricalParameterDto;
  /** Список изменений эмпирических параметров локомотивного обслуживания */
  history: LocomotiveServiceEmpiricalParameterList;
  /** Список эмпирических параметров локомотивного обслуживания */
  list: LocomotiveServiceEmpiricalParameterList;
};


export type LocomotiveServiceEmpiricalParameterQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type LocomotiveServiceEmpiricalParameterQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<LocomotiveServiceEmpiricalParameterQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type LocomotiveServiceEmpiricalParameterQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<LocomotiveServiceEmpiricalParameterQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  range: RangeInputDto;
  where?: InputMaybe<LocomotiveServiceEmpiricalParameterQueryResolver_List_FilterInputType>;
};

export type LocomotiveServiceEmpiricalParameterQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  value?: InputMaybe<SortType>;
};

export type LocomotiveServiceEmpiricalParameterQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<LocomotiveServiceEmpiricalParameterQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  mnemonic_id?: InputMaybe<Number_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveServiceEmpiricalParameterQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  value?: InputMaybe<Number_PropertyFilterInputType>;
};

export type LocomotiveServiceEmpiricalParameterQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<LocomotiveServiceEmpiricalParameterQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  mnemonic_id?: InputMaybe<Number_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveServiceEmpiricalParameterQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  value?: InputMaybe<Number_PropertyFilterInputType>;
};

export type LocomotiveServiceEmpiricalParameterQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  value?: InputMaybe<SortType>;
};

export type LocomotiveServiceList = {
  __typename: 'LocomotiveServiceList';
  items: Array<LocomotiveServiceDto>;
  totalCount: Scalars['Float']['output'];
};

export type LocomotiveTeamAreaDto = {
  __typename: 'LocomotiveTeamAreaDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Расстояние между станцией отправления и станцией прибытия */
  distance: Scalars['Float']['output'];
  from_station: StationDto;
  /** Идентификатор станции отправления */
  from_station_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Идентификатор локомотивного обслуживания */
  locomotive_area_id: Scalars['Int']['output'];
  /** Кол-во работников */
  persons_quantity?: Maybe<Scalars['Int']['output']>;
  to_station: StationDto;
  /** Идентификатор станции прибытия */
  to_station_id: Scalars['Int']['output'];
  traction_directorate?: Maybe<TractionDirectorateDto>;
  /** Идентификатор дирекции тяги */
  traction_directorate_id?: Maybe<Scalars['Int']['output']>;
  /** Стоимость пути в копейках */
  trip_cost?: Maybe<Scalars['Float']['output']>;
  /** Время в пути в секундах */
  trip_time: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type LocomotiveTeamChangeDto = {
  __typename: 'LocomotiveTeamChangeDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  /** Направление */
  direction: Scalars['String']['output'];
  for_station: StationDto;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type LocomotiveTeamPriceRentDto = {
  __typename: 'LocomotiveTeamPriceRentDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  /** Стоимость аренды лок. бригады электровоза при работе в 1 лицо */
  price_electric_locomotive_one_person: Scalars['Float']['output'];
  /** Стоимость аренды лок. бригады электровоза при работе в 2 лица */
  price_electric_locomotive_two_person: Scalars['Float']['output'];
  /** Стоимость аренды лок. бригады тепловоза при работе в 1 лицо */
  price_warm_locomotive_one_person: Scalars['Float']['output'];
  /** Стоимость аренды лок. бригады тепловоза при работе в 2 лица */
  price_warm_locomotive_two_person: Scalars['Float']['output'];
  start_at: Scalars['String']['output'];
  traction_directorate: TractionDirectorateDto;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type LocomotiveTeamPriceRentList = {
  __typename: 'LocomotiveTeamPriceRentList';
  items: Array<LocomotiveTeamPriceRentDto>;
  totalCount: Scalars['Float']['output'];
};

export type LocomotiveTeamPriceRentMutationEntryPoint = {
  __typename: 'LocomotiveTeamPriceRentMutationEntryPoint';
  /** Создание стоимости аренды локомотивной бригады */
  create: LocomotiveTeamPriceRentDto;
  /** Обновление стоимости аренды локомотивной бригады */
  update: LocomotiveTeamPriceRentDto;
};


export type LocomotiveTeamPriceRentMutationEntryPointCreateArgs = {
  data: CreateLocomotiveTeamPriceRentDto;
};


export type LocomotiveTeamPriceRentMutationEntryPointUpdateArgs = {
  data: UpdateLocomotiveTeamPriceRentDto;
};

export type LocomotiveTeamPriceRentQueryEntryPoint = {
  __typename: 'LocomotiveTeamPriceRentQueryEntryPoint';
  /** Стоимость аренды локомотивной бригады по id */
  byEntityId: LocomotiveTeamPriceRentDto;
  /** Список изменений типа признака мест */
  history: LocomotiveTeamPriceRentList;
  /** Список стоимости аренды локомотивных бригад */
  list: LocomotiveTeamPriceRentList;
};


export type LocomotiveTeamPriceRentQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type LocomotiveTeamPriceRentQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<LocomotiveTeamPriceRentQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type LocomotiveTeamPriceRentQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<LocomotiveTeamPriceRentQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  range: RangeInputDto;
  where?: InputMaybe<LocomotiveTeamPriceRentQueryResolver_List_FilterInputType>;
};

export type LocomotiveTeamPriceRentQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  price_electric_locomotive_one_person?: InputMaybe<SortType>;
  price_electric_locomotive_two_person?: InputMaybe<SortType>;
  price_warm_locomotive_one_person?: InputMaybe<SortType>;
  price_warm_locomotive_two_person?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type LocomotiveTeamPriceRentQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<LocomotiveTeamPriceRentQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveTeamPriceRentQueryResolver_List_BaseFilterInputType>>;
  price_electric_locomotive_one_person?: InputMaybe<Number_PropertyFilterInputType>;
  price_electric_locomotive_two_person?: InputMaybe<Number_PropertyFilterInputType>;
  price_warm_locomotive_one_person?: InputMaybe<Number_PropertyFilterInputType>;
  price_warm_locomotive_two_person?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  traction_directorates_id?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type LocomotiveTeamPriceRentQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<LocomotiveTeamPriceRentQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveTeamPriceRentQueryResolver_List_BaseFilterInputType>>;
  price_electric_locomotive_one_person?: InputMaybe<Number_PropertyFilterInputType>;
  price_electric_locomotive_two_person?: InputMaybe<Number_PropertyFilterInputType>;
  price_warm_locomotive_one_person?: InputMaybe<Number_PropertyFilterInputType>;
  price_warm_locomotive_two_person?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  traction_directorates_id?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type LocomotiveTeamPriceRentQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  price_electric_locomotive_one_person?: InputMaybe<SortType>;
  price_electric_locomotive_two_person?: InputMaybe<SortType>;
  price_warm_locomotive_one_person?: InputMaybe<SortType>;
  price_warm_locomotive_two_person?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type LocomotiveTotalCalculationsPeriodRequestDto = {
  /** Конечные дата и время */
  end_date: Scalars['String']['input'];
  /** Начальные дата и время */
  start_date: Scalars['String']['input'];
};

export type LocomotiveTractionTypeDto = {
  __typename: 'LocomotiveTractionTypeDto';
  /** Идентификатор */
  id: Scalars['Int']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Краткое наименование */
  short_name: Scalars['String']['output'];
};

export type LocomotiveTractionTypeList = {
  __typename: 'LocomotiveTractionTypeList';
  items: Array<LocomotiveTractionTypeDto>;
  totalCount: Scalars['Float']['output'];
};

export type LocomotiveTractionTypeQueryEntryPoint = {
  __typename: 'LocomotiveTractionTypeQueryEntryPoint';
  /** Вид тяги по id */
  byId: LocomotiveTractionTypeDto;
  /** Список видов тяги */
  list: LocomotiveTractionTypeList;
};


export type LocomotiveTractionTypeQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type LocomotiveTractionTypeQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<LocomotiveTractionTypeQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<LocomotiveTractionTypeQueryResolver_List_FilterInputType>;
};

export type LocomotiveTractionTypeQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<LocomotiveTractionTypeQueryResolver_List_BaseFilterInputType>>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveTractionTypeQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
};

export type LocomotiveTractionTypeQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<LocomotiveTractionTypeQueryResolver_List_BaseFilterInputType>>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveTractionTypeQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
};

export type LocomotiveTractionTypeQueryResolver_List_SortingInputType = {
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
};

export type LocomotiveTypeCurrentDto = {
  __typename: 'LocomotiveTypeCurrentDto';
  /** Идентификатор */
  id: Scalars['Int']['output'];
  /** Наименование типа тока */
  name: Scalars['String']['output'];
};

export type LocomotiveTypeCurrentList = {
  __typename: 'LocomotiveTypeCurrentList';
  items: Array<LocomotiveTypeCurrentDto>;
  totalCount: Scalars['Float']['output'];
};

export type LocomotiveTypeCurrentQueryEntryPoint = {
  __typename: 'LocomotiveTypeCurrentQueryEntryPoint';
  /** Тип тока по id */
  byId: LocomotiveTypeCurrentDto;
  /** Список типов тока */
  list: LocomotiveTypeCurrentList;
};


export type LocomotiveTypeCurrentQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type LocomotiveTypeCurrentQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<LocomotiveTypeCurrentQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<LocomotiveTypeCurrentQueryResolver_List_FilterInputType>;
};

export type LocomotiveTypeCurrentQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<LocomotiveTypeCurrentQueryResolver_List_BaseFilterInputType>>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveTypeCurrentQueryResolver_List_BaseFilterInputType>>;
};

export type LocomotiveTypeCurrentQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<LocomotiveTypeCurrentQueryResolver_List_BaseFilterInputType>>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocomotiveTypeCurrentQueryResolver_List_BaseFilterInputType>>;
};

export type LocomotiveTypeCurrentQueryResolver_List_SortingInputType = {
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
};

export type LocomotivesAreasCalculationsDto = {
  __typename: 'LocomotivesAreasCalculationsDto';
  /** Идентификатор маппера схемы и поезда */
  id: Scalars['Int']['output'];
  /** Тотал за период */
  period_total: LocomotivesAreasTripTotalDto;
  /** Идентификатор схемы */
  train_schema_id: Scalars['Int']['output'];
  /** Тотал за рейс */
  trip_total: LocomotivesAreasTripTotalDto;
};

export type LocomotivesAreasTotalCostDto = {
  __typename: 'LocomotivesAreasTotalCostDto';
  traction_directorate: TractionDirectorateDto;
  /** Идентификатор дирекции тяги */
  traction_directorate_id: Scalars['Int']['output'];
  /** Стоимость пути в копейках */
  trip_cost: Scalars['String']['output'];
};

export type LocomotivesAreasTripTotalDto = {
  __typename: 'LocomotivesAreasTripTotalDto';
  /** Стоимость локомотивного обслуживания по дирекциям тяги */
  locomotive_areas_total_cost: Array<LocomotivesAreasTotalCostDto>;
  /** Суммарная стоимость локомотивного обслуживания */
  locomotive_areas_trip_total_cost: Scalars['String']['output'];
  /** Стоимость бригад локомотивного обслуживания по дирекциям тяги */
  locomotive_team_areas_total_cost: Array<LocomotivesAreasTotalCostDto>;
  /** Суммарная стоимость бригад локомотивного обслуживания */
  locomotive_team_areas_trip_total_cost: Scalars['String']['output'];
  /** Суммарная стоимость по дирекциям тяги */
  overall_total_cost: Array<LocomotivesAreasTotalCostDto>;
  /** Суммарная стоимость в копейках */
  overall_trip_total_cost: Scalars['String']['output'];
};

export type LuxuryCarriageDto = {
  __typename: 'LuxuryCarriageDto';
  /** Вагоны без признака фирменности */
  carriages_non_branded?: Maybe<Scalars['String']['output']>;
  /** Вагоны с сервисными услугами */
  carriages_with_service?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type ManeuveringWorkDto = {
  __typename: 'ManeuveringWorkDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  /** Направление */
  direction: Scalars['String']['output'];
  for_station: StationDto;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type MaxTrainLengthRailwayDto = {
  __typename: 'MaxTrainLengthRailwayDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: Maybe<Scalars['Int']['output']>;
  direct_railway?: Maybe<RailwayDto>;
  id: Scalars['Int']['output'];
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: Maybe<Scalars['Int']['output']>;
  reverse_railway?: Maybe<RailwayDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type MaxTrainLengthStationDto = {
  __typename: 'MaxTrainLengthStationDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: Maybe<Scalars['Int']['output']>;
  direct_from_station?: Maybe<StationDto>;
  direct_to_station?: Maybe<StationDto>;
  id: Scalars['Int']['output'];
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: Maybe<Scalars['Int']['output']>;
  reverse_from_station?: Maybe<StationDto>;
  reverse_to_station?: Maybe<StationDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type MaxTrainLengthUnion = MaxTrainLengthRailwayDto | MaxTrainLengthStationDto;

export type MaxTrainSpeedDto = {
  __typename: 'MaxTrainSpeedDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  /** Максимальная скорость поезда */
  max_train_speed: Scalars['Float']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type MaxTrainSpeedList = {
  __typename: 'MaxTrainSpeedList';
  items: Array<MaxTrainSpeedDto>;
  totalCount: Scalars['Float']['output'];
};

export type MaxTrainSpeedMutationEntryPoint = {
  __typename: 'MaxTrainSpeedMutationEntryPoint';
  /** Добавить максимальную скорость поезда */
  create: MaxTrainSpeedDto;
  /** Обновить максимальную скорость поезда */
  update: MaxTrainSpeedDto;
};


export type MaxTrainSpeedMutationEntryPointCreateArgs = {
  data: CreateMaxTrainSpeedDto;
};


export type MaxTrainSpeedMutationEntryPointUpdateArgs = {
  data: UpdateMaxTrainSpeedDto;
};

export type MaxTrainSpeedQueryEntryPoint = {
  __typename: 'MaxTrainSpeedQueryEntryPoint';
  /** Максимальная скорость поезда по entity_id */
  byEntityId: MaxTrainSpeedDto;
  /** Список изменений максимальных скоростей */
  history: MaxTrainSpeedList;
  /** Список максимальных скоростей поезда */
  list: MaxTrainSpeedList;
};


export type MaxTrainSpeedQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type MaxTrainSpeedQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<MaxTrainSpeedQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type MaxTrainSpeedQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<MaxTrainSpeedQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<MaxTrainSpeedQueryResolver_List_FilterInputType>;
};

export type MaxTrainSpeedQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  max_train_speed?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type MaxTrainSpeedQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<MaxTrainSpeedQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_train_speed?: InputMaybe<Number_PropertyFilterInputType>;
  or?: InputMaybe<Array<MaxTrainSpeedQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MaxTrainSpeedQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<MaxTrainSpeedQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  max_train_speed?: InputMaybe<Number_PropertyFilterInputType>;
  or?: InputMaybe<Array<MaxTrainSpeedQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MaxTrainSpeedQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  max_train_speed?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type MergeTableBlocksDto = {
  /** Идентификатор блока в схеме, который необходимо слить (который перетягивается) */
  from_table_block_id: Scalars['Int']['input'];
  /** Идентификатор блока в схеме, c которым необходимо слить (на который перетягивается другой блок) */
  to_table_block_id: Scalars['Int']['input'];
  /** Идентификатор схемы */
  train_schema_id: Scalars['Int']['input'];
};

export type MnemonicDto = {
  __typename: 'MnemonicDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Групповой признак */
  group_name: Scalars['String']['output'];
  /** Значение группового признака */
  group_name_rus: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Мнемоника */
  mnemonic: Scalars['String']['output'];
  /** Значение мнемоники */
  mnemonic_rus: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type MnemonicList = {
  __typename: 'MnemonicList';
  items: Array<MnemonicDto>;
  totalCount: Scalars['Float']['output'];
};

export type MnemonicMutationEntryPoint = {
  __typename: 'MnemonicMutationEntryPoint';
  /** Обновить русские обозначения мнемоники */
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type MnemonicMutationEntryPointUpdateArgs = {
  data: UpdateMnemonicDto;
};

export type MnemonicQueryEntryPoint = {
  __typename: 'MnemonicQueryEntryPoint';
  /** Список мнемоник */
  list: MnemonicList;
};


export type MnemonicQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<MnemonicQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<MnemonicQueryResolver_List_FilterInputType>;
};

export type MnemonicQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<MnemonicQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  group_name?: InputMaybe<String_PropertyFilterInputType>;
  group_name_rus?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  mnemonic_rus?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<MnemonicQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MnemonicQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<MnemonicQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  group_name?: InputMaybe<String_PropertyFilterInputType>;
  group_name_rus?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  mnemonic_rus?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<MnemonicQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MnemonicQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  group_name?: InputMaybe<SortType>;
  group_name_rus?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  mnemonic?: InputMaybe<SortType>;
  mnemonic_rus?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type ModuleDto = {
  __typename: 'ModuleDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type ModuleList = {
  __typename: 'ModuleList';
  items: Array<ModuleDto>;
  totalCount: Scalars['Float']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  /** Аутентификация */
  authentication: AuthenticationMutationEntryPoint;
  /** группа вагонов мутация */
  carriageGroups: CarriageGroupMutationEntryPoint;
  /** Классификаторы */
  classifiers: ClassifiersMutationEntryPoint;
  /** Новостная панель */
  cms: CmsMutationEntryPoint;
  /** Конфигурации */
  configuration: ConfigurationMutationEntryPoint;
  /** Хранилище файлов мутация */
  filestorage: FilestorageMutationEntryPoint;
  /** Показатели */
  indicators: IndicatorsMutationEntryPoint;
  /** Уведомление пользовавтеля */
  notification: NotificationMutationEntryPoint;
  /** Контроль доступа */
  rbac: RbacMutationEntryPoint;
  /** Планировщик */
  scheduler: SchedulerMutationEntryPoint;
  /** Синхронизация с внешними источниками */
  sync: MutationEntryPoint;
  /** Контроль параметров перевозок */
  tpc: TpcMutationEntryPoint;
  /** Поезда */
  train: TrainMutationEntryPoint;
  /** Расписания */
  train_schedules: TrainSchedulesMutationEntryPoint;
  /** Схема поезда */
  train_schemas: TrainSchemaMutationEntryPoint;
  /** Пользователи */
  users: UsersMutationEntryPoint;
};

export type MutationEntryPoint = {
  __typename: 'MutationEntryPoint';
  /** Запрос */
  http: Scalars['JSONObject']['output'];
  /** Синхронизация классификаторов */
  runSyncClassifiers: Scalars['Boolean']['output'];
  /** Синхронизация контроля наличия свободных мест */
  runSyncSeatsAvailability: Scalars['Boolean']['output'];
};


export type MutationEntryPointHttpArgs = {
  data: HttpRequestDto;
};


export type MutationEntryPointRunSyncClassifiersArgs = {
  date: Scalars['String']['input'];
};


export type MutationEntryPointRunSyncSeatsAvailabilityArgs = {
  data: SyncSeatsAvailabilityDto;
};

export type MvpsCalculationByBranchDto = {
  __typename: 'MvpsCalculationByBranchDto';
  /** Филиал */
  items_by_branch: Array<MvpsCalculationByBranchItemDto>;
  /** Итого по филиалам */
  total_by_branch: MvpsCalculationByBranchItemDto;
};

export type MvpsCalculationByBranchItemDto = {
  __typename: 'MvpsCalculationByBranchItemDto';
  /** Филиал */
  branch: Scalars['String']['output'];
  /** Управление и эксплуатация, тыс. руб */
  control_total?: Maybe<Scalars['Float']['output']>;
  /** Пробег, ваг-км */
  distance: Scalars['Float']['output'];
  /** Аренда, тыс. руб */
  rent_total: Scalars['Float']['output'];
  /** Поездо-час */
  route_duration?: Maybe<Scalars['Float']['output']>;
  /** ТО, ТР, тыс. руб */
  to_tr_total: Scalars['Float']['output'];
  /** ИТОГО РАСХОДЫ, тыс. руб */
  total: Scalars['Float']['output'];
};

export type MvpsCalculationDto = {
  __typename: 'MvpsCalculationDto';
  /** филиал */
  branch: Scalars['String']['output'];
  /** идентификатор группы */
  carriage_group_id: Scalars['Float']['output'];
  /** составность , ваг. */
  carriages_quantity: Scalars['Float']['output'];
  /** приписка */
  company_affiliation: Scalars['String']['output'];
  /** ИТОГО управление, тыс. руб */
  control_total?: Maybe<Scalars['Float']['output']>;
  /** тип секции, комплектация */
  mvps_section_type: Scalars['String']['output'];
  /** перевозчик */
  passenger_carrier_russian_railway: Scalars['String']['output'];
  /** ж/д администрация */
  railway_administration: Scalars['String']['output'];
  /** ИТОГО аренда,тыс. руб */
  rent_total: Scalars['Float']['output'];
  /** Строки расчёта */
  rows: Array<MvpsCalculationRowDto>;
  /** ИТОГО ТО, ТР, тыс. руб */
  to_tr_total: Scalars['Float']['output'];
  /** ИТОГО СТОИМОСТЬ */
  total: Scalars['Float']['output'];
  /** составов, ед */
  train_quantity: Scalars['Float']['output'];
};

export type MvpsCalculationRowDto = {
  __typename: 'MvpsCalculationRowDto';
  /** управление, тыс. руб */
  control?: Maybe<Scalars['Float']['output']>;
  /** пробег, ваг-км */
  distance: Scalars['Float']['output'];
  /** поездо-час */
  route_duration?: Maybe<Scalars['Float']['output']>;
  /** Сообщение */
  stations: Array<Scalars['String']['output']>;
  /** ТО, ТР, тыс. руб */
  to_tr: Scalars['Float']['output'];
  /** № поезда */
  train_number: Scalars['String']['output'];
};

export type MvpsCalculationsList = {
  __typename: 'MvpsCalculationsList';
  items: Array<MvpsCalculationDto>;
  totalCount: Scalars['Float']['output'];
};

export type MvpsCompanyAffiliationDto = {
  __typename: 'MvpsCompanyAffiliationDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  /** Наименование */
  mvps_owner: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type MvpsCompanyAffiliationDtoList = {
  __typename: 'MvpsCompanyAffiliationDtoList';
  items: Array<MvpsCompanyAffiliationDto>;
  totalCount: Scalars['Float']['output'];
};

export type MvpsCompanyAffiliationMutationEntryPoint = {
  __typename: 'MvpsCompanyAffiliationMutationEntryPoint';
  /** Добавить предприятие собственности МВПС */
  create: MvpsCompanyAffiliationDto;
  /** Обновить предприятие собственности МВПС */
  update: MvpsCompanyAffiliationDto;
};


export type MvpsCompanyAffiliationMutationEntryPointCreateArgs = {
  data: CreateMvpsCompanyAffiliationDto;
};


export type MvpsCompanyAffiliationMutationEntryPointUpdateArgs = {
  data: UpdateMvpsCompanyAffiliationDto;
};

export type MvpsCompanyAffiliationQueryEntryPoint = {
  __typename: 'MvpsCompanyAffiliationQueryEntryPoint';
  /** Предприятие собственности МВПС по entity_id */
  byEntityId: MvpsCompanyAffiliationDto;
  /** Список изменений редприятий собственности МВПС */
  history: MvpsCompanyAffiliationDtoList;
  /** Список предприятий собственности МВПС */
  list: MvpsCompanyAffiliationDtoList;
};


export type MvpsCompanyAffiliationQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type MvpsCompanyAffiliationQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<MvpsCompanyAffiliationQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type MvpsCompanyAffiliationQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<MvpsCompanyAffiliationQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<MvpsCompanyAffiliationQueryResolver_List_FilterInputType>;
};

export type MvpsCompanyAffiliationQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  mvps_owner?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type MvpsCompanyAffiliationQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<MvpsCompanyAffiliationQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  mvps_owner?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<MvpsCompanyAffiliationQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MvpsCompanyAffiliationQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<MvpsCompanyAffiliationQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  mvps_owner?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<MvpsCompanyAffiliationQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MvpsCompanyAffiliationQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  mvps_owner?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type MvpsMartinSectionTypeDto = {
  __typename: 'MvpsMartinSectionTypeDto';
  /** Количество вагонов в одной секции */
  carriage_quantity_in_section: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  mvpsMartinSectionTypeEquipmentDto: MvpsMartinSectionTypeEquipmentDto;
  /** ID комплектации МВПС */
  mvps_martin_section_type_equipment_id: Scalars['Int']['output'];
  /** Ставка аренды руб. */
  price: Scalars['Float']['output'];
  /** Серия */
  series: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type MvpsMartinSectionTypeDtoList = {
  __typename: 'MvpsMartinSectionTypeDtoList';
  items: Array<MvpsMartinSectionTypeDto>;
  totalCount: Scalars['Float']['output'];
};

export type MvpsMartinSectionTypeEquipmentDto = {
  __typename: 'MvpsMartinSectionTypeEquipmentDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  /** Комплектация */
  equipment: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type MvpsMartinSectionTypeEquipmentList = {
  __typename: 'MvpsMartinSectionTypeEquipmentList';
  items: Array<MvpsMartinSectionTypeEquipmentDto>;
  totalCount: Scalars['Float']['output'];
};

export type MvpsMartinSectionTypeEquipmentMutationEntryPoint = {
  __typename: 'MvpsMartinSectionTypeEquipmentMutationEntryPoint';
  /** Создание комплектации МВПС */
  create: MvpsMartinSectionTypeEquipmentDto;
  /** Обновление комплектации МВПС */
  update: MvpsMartinSectionTypeEquipmentDto;
};


export type MvpsMartinSectionTypeEquipmentMutationEntryPointCreateArgs = {
  data: CreateMvpsMartinSectionTypeEquipmentDto;
};


export type MvpsMartinSectionTypeEquipmentMutationEntryPointUpdateArgs = {
  data: UpdateMvpsMartinSectionTypeEquipmentDto;
};

export type MvpsMartinSectionTypeEquipmentQueryEntryPoint = {
  __typename: 'MvpsMartinSectionTypeEquipmentQueryEntryPoint';
  /** Комплектация МВПС по entity_id */
  byEntityId: MvpsMartinSectionTypeEquipmentDto;
  /** Список изменений комплектаций МВПС */
  history: MvpsMartinSectionTypeEquipmentList;
  /** Список комплектаций МВПС */
  list: MvpsMartinSectionTypeEquipmentList;
};


export type MvpsMartinSectionTypeEquipmentQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type MvpsMartinSectionTypeEquipmentQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<MvpsMartinSectionTypeEquipmentQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type MvpsMartinSectionTypeEquipmentQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<MvpsMartinSectionTypeEquipmentQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  range: RangeInputDto;
  where?: InputMaybe<MvpsMartinSectionTypeEquipmentQueryResolver_List_FilterInputType>;
};

export type MvpsMartinSectionTypeEquipmentQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  equipment?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type MvpsMartinSectionTypeEquipmentQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<MvpsMartinSectionTypeEquipmentQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  equipment?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<MvpsMartinSectionTypeEquipmentQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MvpsMartinSectionTypeEquipmentQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<MvpsMartinSectionTypeEquipmentQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  equipment?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<MvpsMartinSectionTypeEquipmentQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MvpsMartinSectionTypeEquipmentQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  equipment?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type MvpsMartinSectionTypeMutationEntryPoint = {
  __typename: 'MvpsMartinSectionTypeMutationEntryPoint';
  /** Добавить вид секции МВПС «Ласточка» */
  create: MvpsMartinSectionTypeDto;
  /** Обновить вид секции МВПС «Ласточка» */
  update: MvpsMartinSectionTypeDto;
};


export type MvpsMartinSectionTypeMutationEntryPointCreateArgs = {
  data: CreateMvpsMartinSectionTypeDto;
};


export type MvpsMartinSectionTypeMutationEntryPointUpdateArgs = {
  data: UpdateMvpsMartinSectionTypeDto;
};

export type MvpsMartinSectionTypeQueryEntryPoint = {
  __typename: 'MvpsMartinSectionTypeQueryEntryPoint';
  /** Вид секции МВПС «Ласточка» по entity_id */
  byEntityId: MvpsMartinSectionTypeDto;
  /** Список изменений редприятий собственности МВПС */
  history: MvpsMartinSectionTypeDtoList;
  /** Список видов секций МВПС «Ласточка» */
  list: MvpsMartinSectionTypeDtoList;
};


export type MvpsMartinSectionTypeQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type MvpsMartinSectionTypeQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<MvpsMartinSectionTypeQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type MvpsMartinSectionTypeQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<MvpsMartinSectionTypeQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<MvpsMartinSectionTypeQueryResolver_List_FilterInputType>;
};

export type MvpsMartinSectionTypeQueryResolver_History_SortingInputType = {
  carriage_quantity_in_section?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  mvps_martin_section_type_equipment_id?: InputMaybe<SortType>;
  price?: InputMaybe<SortType>;
  series?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type MvpsMartinSectionTypeQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<MvpsMartinSectionTypeQueryResolver_List_BaseFilterInputType>>;
  carriage_quantity_in_section?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  mvps_martin_section_type_equipment_id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<MvpsMartinSectionTypeQueryResolver_List_BaseFilterInputType>>;
  price?: InputMaybe<Number_PropertyFilterInputType>;
  series?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MvpsMartinSectionTypeQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<MvpsMartinSectionTypeQueryResolver_List_BaseFilterInputType>>;
  carriage_quantity_in_section?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  mvps_martin_section_type_equipment_id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<MvpsMartinSectionTypeQueryResolver_List_BaseFilterInputType>>;
  price?: InputMaybe<Number_PropertyFilterInputType>;
  series?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MvpsMartinSectionTypeQueryResolver_List_SortingInputType = {
  carriage_quantity_in_section?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  mvps_martin_section_type_equipment_id?: InputMaybe<SortType>;
  price?: InputMaybe<SortType>;
  series?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type MvpsParkRequiredDto = {
  __typename: 'MvpsParkRequiredDto';
  /** Количество вагонов в группе */
  carriage_quantity: Scalars['Int']['output'];
  carriage_type: Scalars['String']['output'];
  /** Количество отправлений */
  departures_quantity?: Maybe<Scalars['Float']['output']>;
  equipment: Scalars['String']['output'];
  seat_type: Scalars['String']['output'];
};

export type MvpsRateManagementExploitationMaintenanceRepairDto = {
  __typename: 'MvpsRateManagementExploitationMaintenanceRepairDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  mnemonic: MnemonicDto;
  /** ID типа ставки */
  mnemonic_id: Scalars['Int']['output'];
  /** Ставка аренды, руб. */
  price: Scalars['Float']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type MvpsRateManagementExploitationMaintenanceRepairList = {
  __typename: 'MvpsRateManagementExploitationMaintenanceRepairList';
  items: Array<MvpsRateManagementExploitationMaintenanceRepairDto>;
  totalCount: Scalars['Float']['output'];
};

export type MvpsRateManagementExploitationMaintenanceRepairMutationEntryPoint = {
  __typename: 'MvpsRateManagementExploitationMaintenanceRepairMutationEntryPoint';
  /** Создание ставки за управление и эксплуатацию, техобслуживание и ремонт МВПС */
  create: MvpsRateManagementExploitationMaintenanceRepairDto;
  /** Обновление ставки за управление и эксплуатацию, техобслуживание и ремонт МВПС */
  update?: Maybe<MvpsRateManagementExploitationMaintenanceRepairDto>;
};


export type MvpsRateManagementExploitationMaintenanceRepairMutationEntryPointCreateArgs = {
  data: CreateMvpsRateManagementExploitationMaintenanceRepairDto;
};


export type MvpsRateManagementExploitationMaintenanceRepairMutationEntryPointUpdateArgs = {
  data: UpdateMvpsRateManagementExploitationMaintenanceRepairDto;
};

export type MvpsRateManagementExploitationMaintenanceRepairQueryEntryPoint = {
  __typename: 'MvpsRateManagementExploitationMaintenanceRepairQueryEntryPoint';
  /** Ставка за управление и эксплуатацию, техобслуживание и ремонт МВПС по entity_id */
  byEntityId: MvpsRateManagementExploitationMaintenanceRepairDto;
  /** Список изменений ставки за управление и эксплуатацию, техобслуживание и ремонт МВПС */
  history: MvpsRateManagementExploitationMaintenanceRepairList;
  /** Список ставок за управление и эксплуатацию, техобслуживание и ремонт МВПС */
  list: MvpsRateManagementExploitationMaintenanceRepairList;
};


export type MvpsRateManagementExploitationMaintenanceRepairQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type MvpsRateManagementExploitationMaintenanceRepairQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<MvpsRateManagementExploitationMaintenanceRepairQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type MvpsRateManagementExploitationMaintenanceRepairQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  range: RangeInputDto;
  where?: InputMaybe<MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_FilterInputType>;
};

export type MvpsRateManagementExploitationMaintenanceRepairQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  mnemonic_id?: InputMaybe<SortType>;
  price?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  mnemonic_id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_BaseFilterInputType>>;
  price?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  mnemonic_id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_BaseFilterInputType>>;
  price?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  mnemonic_id?: InputMaybe<SortType>;
  price?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NewTrainDto = {
  __typename: 'NewTrainDto';
  /** Идентификаторы активных подразделений */
  active_subdivision_ids: Array<Scalars['Int']['output']>;
  /** Время прибытия */
  arrival_time?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<BranchDto>;
  /** Идентификатор филиала */
  branch_id?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<TrainCategoryDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Идентификаторы отклонивших подразделений */
  decline_subdivision_ids: Array<Scalars['Int']['output']>;
  /** Время отправления */
  departure_time?: Maybe<Scalars['String']['output']>;
  end_at: Scalars['String']['output'];
  /** Идентификатор поезда как сущности */
  entity_id: Scalars['Int']['output'];
  /** Идентификатор первой дороги на территории РЖД */
  from_rzd_railway_id?: Maybe<Scalars['Float']['output']>;
  /** Идентификатор первой станции на территории РЖД */
  from_rzd_station_id?: Maybe<Scalars['Float']['output']>;
  from_station: StationDto;
  /** Идентификатор станции отправления */
  from_station_id: Scalars['Int']['output'];
  gdp: GdpDto;
  /** Идентификатор гдп */
  gdp_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Индивидуальное наименование */
  individual_name: Scalars['String']['output'];
  /** Принадлежность к зарубежью - мнемоника */
  international_mnemonic?: Maybe<Scalars['String']['output']>;
  /** Основная группа для согласования */
  is_carriage_group_approval: Scalars['Boolean']['output'];
  /** Является ли поезд "Дневным" */
  is_daytime: Scalars['Boolean']['output'];
  /** Является ли поезд прямым */
  is_direct: Scalars['Boolean']['output'];
  /** дополнительный признак, который отображает несёт ли АО «ФПК» расходы на оплату услуг инфраструктуры */
  is_excluded_from_calculation_infrastructure_cost: Scalars['Boolean']['output'];
  /** Выводится ли в форму запроса */
  is_included_in_request_form: Scalars['Boolean']['output'];
  /** Является ли поезд межгосударственным */
  is_international: Scalars['Boolean']['output'];
  /** Является ли данный поезд последней версией в текущем ГДП */
  is_latest_version: Scalars['Boolean']['output'];
  /** Поезд редактируется */
  is_lock: Scalars['Boolean']['output'];
  /** Блокировка по статусу связанного поезда */
  is_lock_by_status: Scalars['Boolean']['output'];
  /** Является ли локомотивка актуальной */
  is_locomotive_actual: Scalars['Boolean']['output'];
  /** Является ли поезд главным */
  is_main: Scalars['Boolean']['output'];
  /** Помечен ли поезд к удалению */
  is_marked_to_delete: Scalars['Boolean']['output'];
  /** Выводится ли периодичность поездв в форме запроса отдельно по каждой схеме */
  is_periodicity_separate_request_form: Scalars['Boolean']['output'];
  /** Расписание для согласования */
  is_schedule_approval: Scalars['Boolean']['output'];
  /** Схема для согласования */
  is_schema_approval: Scalars['Boolean']['output'];
  /** Является ли поездом "Южного направления" */
  is_southbound: Scalars['Boolean']['output'];
  /** ТОЛЬКО ДЛЯ byId запросов */
  last_version: RangeDto;
  /** Пользовать заблокировавший поезд */
  lock_user?: Maybe<UserDto>;
  /** Идентификатор пользователя, заблокировавшего поезд */
  lock_user_id?: Maybe<Scalars['Int']['output']>;
  /** locomotive_areas_union_id */
  locomotive_areas_union_id?: Maybe<Scalars['String']['output']>;
  locomotives_areas_calculations: Array<LocomotivesAreasCalculationsDto>;
  locomotives_service: Array<TrainLocomotiveAreaDto>;
  locomotives_service_union: LocomotiveServiceDto;
  max_train_speed?: Maybe<MaxTrainSpeedDto>;
  /** Идентификатор максимальной скорости поезда */
  max_train_speed_id?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  note?: Maybe<Scalars['String']['output']>;
  other_trains: Array<OtherTrainsDto>;
  /** Примечание к иным поездам */
  other_trains_note?: Maybe<Scalars['String']['output']>;
  /** Парный поезд */
  pair_train?: Maybe<NewTrainDto>;
  /** Идентификатор пары */
  pair_train_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<NewTrainDto>;
  /** Идентификатор родительского поезда */
  parent_id?: Maybe<Scalars['Int']['output']>;
  passenger_carrier?: Maybe<PassengerCarrierDto>;
  /** Идентификатор пассажирского перевозчика в дальнем следовани */
  passenger_carrier_russian_railway_id?: Maybe<Scalars['Int']['output']>;
  /** Периодичность */
  periodicity?: Maybe<Scalars['String']['output']>;
  periodicity_season?: Maybe<PeriodicitySeasonDto>;
  /** Идентификатор сезонности */
  periodicity_season_id?: Maybe<Scalars['Int']['output']>;
  railway_administration: RailwayAdministrationDto;
  /** Идентификатор жд администрации */
  railway_administration_id: Scalars['Int']['output'];
  /** Типы подвижного состава */
  rolling_stock_types: Array<Scalars['String']['output']>;
  /** Длительность пути (мин) */
  route_duration: Scalars['Float']['output'];
  /** Маршрутная скорость, км/ч */
  route_speed?: Maybe<Scalars['Float']['output']>;
  schedule?: Maybe<TrainScheduleDto>;
  schemas?: Maybe<Array<TrainSchemaDto>>;
  start_at: Scalars['String']['output'];
  /** Станции переприцепки */
  stations_recoupling?: Maybe<Scalars['String']['output']>;
  /** Статус согласования */
  status: Scalars['String']['output'];
  sub_category?: Maybe<TrainSubCategoryDto>;
  /** Идентификатор последней дороги на территории РЖД */
  to_rzd_railway_id?: Maybe<Scalars['Float']['output']>;
  /** Идентификатор последней станции на территории РЖД */
  to_rzd_station_id?: Maybe<Scalars['Float']['output']>;
  to_station: StationDto;
  /** Идентификатор станции прибытия */
  to_station_id: Scalars['Int']['output'];
  train_brand: TrainBrandDto;
  /** Идентификатор бренда поезда */
  train_brand_id: Scalars['Int']['output'];
  /** Идентификатор категории поезда */
  train_category_id: Scalars['Int']['output'];
  /** Номер поезда */
  train_number: Scalars['String']['output'];
  /** Идентификатор расписания */
  train_schedule_id?: Maybe<Scalars['Int']['output']>;
  /** Идентификатор подкатегории поезда */
  train_sub_category_id: Scalars['Int']['output'];
  /** Связь поездов и схем */
  train_train_schemas?: Maybe<Array<TrainTrainSchemaDto>>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  /** Версия */
  version: Scalars['Int']['output'];
};


export type NewTrainDtoLocomotives_Areas_CalculationsArgs = {
  period: LocomotiveTotalCalculationsPeriodRequestDto;
};

export type NewTrainList = {
  __typename: 'NewTrainList';
  items: Array<NewTrainDto>;
  totalCount: Scalars['Float']['output'];
};

export type NewsCreateDto = {
  content?: InputMaybe<Scalars['String']['input']>;
  send_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type NewsDto = {
  __typename: 'NewsDto';
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type NewsList = {
  __typename: 'NewsList';
  items: Array<NewsDto>;
  totalCount: Scalars['Float']['output'];
};

export type NewsUpdateDto = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type NonPassengerCarriageTypeDto = {
  __typename: 'NonPassengerCarriageTypeDto';
  carriage_types_for_schema: CarriageTypesForSchemaDto;
  conditional_carriage_numbers: Array<ConditionalCarriageNumberDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type NonPassengerCarriageTypeList = {
  __typename: 'NonPassengerCarriageTypeList';
  items: Array<NonPassengerCarriageTypeDto>;
  totalCount: Scalars['Float']['output'];
};

export type NonPassengerCarriageTypeMutationEntryPoint = {
  __typename: 'NonPassengerCarriageTypeMutationEntryPoint';
  /** Добавить модель вагона */
  create: NonPassengerCarriageTypeDto;
  /** Обновить модель вагона */
  update?: Maybe<NonPassengerCarriageTypeDto>;
};


export type NonPassengerCarriageTypeMutationEntryPointCreateArgs = {
  data: CreateNonPassengerCarriageTypeDto;
};


export type NonPassengerCarriageTypeMutationEntryPointUpdateArgs = {
  data: UpdateNonPassengerCarriageTypeDto;
};

export type NonPassengerCarriageTypeQueryEntryPoint = {
  __typename: 'NonPassengerCarriageTypeQueryEntryPoint';
  /** Модель вагона по entity_id */
  byEntityId: NonPassengerCarriageTypeDto;
  /** Список изменений моделей вагонов не предназначенных для перевозки пассажиров */
  history: NonPassengerCarriageTypeList;
  /** Список моделей вагонов */
  list: NonPassengerCarriageTypeList;
};


export type NonPassengerCarriageTypeQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type NonPassengerCarriageTypeQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<NonPassengerCarriageTypeQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type NonPassengerCarriageTypeQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<NonPassengerCarriageTypeQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<NonPassengerCarriageTypeQueryResolver_List_FilterInputType>;
};

export type NonPassengerCarriageTypeQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NonPassengerCarriageTypeQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<NonPassengerCarriageTypeQueryResolver_List_BaseFilterInputType>>;
  carriage_types_for_schema_id?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NonPassengerCarriageTypeQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NonPassengerCarriageTypeQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<NonPassengerCarriageTypeQueryResolver_List_BaseFilterInputType>>;
  carriage_types_for_schema_id?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NonPassengerCarriageTypeQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NonPassengerCarriageTypeQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NotificationMutationEntryPoint = {
  __typename: 'NotificationMutationEntryPoint';
  /** Удаление сообщений текущего пользователя */
  clear_messages_user?: Maybe<Scalars['Void']['output']>;
};

export type NotificationQueryEntryPoint = {
  __typename: 'NotificationQueryEntryPoint';
  /** Получить список сообщений пользователя */
  messages_user: UserMessageListDto;
  /** Получить количество непросмотренных сообщений пользователя */
  not_viewed_user_messages_count: Scalars['Float']['output'];
};


export type NotificationQueryEntryPointMessages_UserArgs = {
  paginate?: InputMaybe<PaginatorArgsDto>;
};

export type NpsCarriageBrakeTypeDto = {
  __typename: 'NpsCarriageBrakeTypeDto';
  /** Тормоз */
  brake_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type NpsCarriageBrakeTypeList = {
  __typename: 'NpsCarriageBrakeTypeList';
  items: Array<NpsCarriageBrakeTypeDto>;
  totalCount: Scalars['Float']['output'];
};

export type NpsCarriageBrakeTypeMutationEntryPoint = {
  __typename: 'NpsCarriageBrakeTypeMutationEntryPoint';
  /** Добавить тип тормоза */
  create: NpsCarriageBrakeTypeDto;
  /** Обновить тип тормоза */
  update: NpsCarriageBrakeTypeDto;
};


export type NpsCarriageBrakeTypeMutationEntryPointCreateArgs = {
  data: CreateNpsCarriageBrakeTypeDto;
};


export type NpsCarriageBrakeTypeMutationEntryPointUpdateArgs = {
  data: UpdateNpsCarriageBrakeTypeDto;
};

export type NpsCarriageBrakeTypeQueryEntryPoint = {
  __typename: 'NpsCarriageBrakeTypeQueryEntryPoint';
  /** Тип тормоза по id */
  byEntityId: NpsCarriageBrakeTypeDto;
  /** Список изменений станции */
  history: NpsCarriageBrakeTypeList;
  /** Список типов тормозов */
  list: NpsCarriageBrakeTypeList;
};


export type NpsCarriageBrakeTypeQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type NpsCarriageBrakeTypeQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<NpsCarriageBrakeTypeQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type NpsCarriageBrakeTypeQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<NpsCarriageBrakeTypeQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<NpsCarriageBrakeTypeQueryResolver_List_FilterInputType>;
};

export type NpsCarriageBrakeTypeQueryResolver_History_SortingInputType = {
  brake_type?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NpsCarriageBrakeTypeQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<NpsCarriageBrakeTypeQueryResolver_List_BaseFilterInputType>>;
  brake_type?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NpsCarriageBrakeTypeQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NpsCarriageBrakeTypeQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<NpsCarriageBrakeTypeQueryResolver_List_BaseFilterInputType>>;
  brake_type?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NpsCarriageBrakeTypeQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NpsCarriageBrakeTypeQueryResolver_List_SortingInputType = {
  brake_type?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NpsCarriageDimensionDto = {
  __typename: 'NpsCarriageDimensionDto';
  /** Габарит */
  carriage_dimension: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type NpsCarriageDimensionList = {
  __typename: 'NpsCarriageDimensionList';
  items: Array<NpsCarriageDimensionDto>;
  totalCount: Scalars['Float']['output'];
};

export type NpsCarriageDimensionMutationEntryPoint = {
  __typename: 'NpsCarriageDimensionMutationEntryPoint';
  /** Добавить габарит подвижного состава */
  create: NpsCarriageDimensionDto;
  /** Обновить габарит подвижного состава */
  update: NpsCarriageDimensionDto;
};


export type NpsCarriageDimensionMutationEntryPointCreateArgs = {
  data: CreateNpsCarriageDimensionDto;
};


export type NpsCarriageDimensionMutationEntryPointUpdateArgs = {
  data: UpdateNpsCarriageDimensionDto;
};

export type NpsCarriageDimensionQueryEntryPoint = {
  __typename: 'NpsCarriageDimensionQueryEntryPoint';
  /** Габарит подвижного состава по id */
  byEntityId: NpsCarriageDimensionDto;
  /** Список изменений станции */
  history: NpsCarriageDimensionList;
  /** Список габаритов подвижного состава */
  list: NpsCarriageDimensionList;
};


export type NpsCarriageDimensionQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type NpsCarriageDimensionQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<NpsCarriageDimensionQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type NpsCarriageDimensionQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<NpsCarriageDimensionQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<NpsCarriageDimensionQueryResolver_List_FilterInputType>;
};

export type NpsCarriageDimensionQueryResolver_History_SortingInputType = {
  carriage_dimension?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NpsCarriageDimensionQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<NpsCarriageDimensionQueryResolver_List_BaseFilterInputType>>;
  carriage_dimension?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NpsCarriageDimensionQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NpsCarriageDimensionQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<NpsCarriageDimensionQueryResolver_List_BaseFilterInputType>>;
  carriage_dimension?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NpsCarriageDimensionQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NpsCarriageDimensionQueryResolver_List_SortingInputType = {
  carriage_dimension?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NpsCarriageHeatTypeDto = {
  __typename: 'NpsCarriageHeatTypeDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  /** Вид отопления */
  heat_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type NpsCarriageHeatTypeList = {
  __typename: 'NpsCarriageHeatTypeList';
  items: Array<NpsCarriageHeatTypeDto>;
  totalCount: Scalars['Float']['output'];
};

export type NpsCarriageHeatTypeMutationEntryPoint = {
  __typename: 'NpsCarriageHeatTypeMutationEntryPoint';
  /** Добавить вид отопления */
  create: NpsCarriageHeatTypeDto;
  /** Обновить вид отопления */
  update: NpsCarriageHeatTypeDto;
};


export type NpsCarriageHeatTypeMutationEntryPointCreateArgs = {
  data: CreateNpsCarriageHeatTypeDto;
};


export type NpsCarriageHeatTypeMutationEntryPointUpdateArgs = {
  data: UpdateNpsCarriageHeatTypeDto;
};

export type NpsCarriageHeatTypeQueryEntryPoint = {
  __typename: 'NpsCarriageHeatTypeQueryEntryPoint';
  /** Вид отопления по id */
  byEntityId: NpsCarriageHeatTypeDto;
  /** Список изменений станции */
  history: NpsCarriageHeatTypeList;
  /** Список видов отопления */
  list: NpsCarriageHeatTypeList;
};


export type NpsCarriageHeatTypeQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type NpsCarriageHeatTypeQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<NpsCarriageHeatTypeQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type NpsCarriageHeatTypeQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<NpsCarriageHeatTypeQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<NpsCarriageHeatTypeQueryResolver_List_FilterInputType>;
};

export type NpsCarriageHeatTypeQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  heat_type?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NpsCarriageHeatTypeQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<NpsCarriageHeatTypeQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  heat_type?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NpsCarriageHeatTypeQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NpsCarriageHeatTypeQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<NpsCarriageHeatTypeQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  heat_type?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NpsCarriageHeatTypeQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NpsCarriageHeatTypeQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  heat_type?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NpsCarriageLengthDto = {
  __typename: 'NpsCarriageLengthDto';
  /** Длина вагонов в АСУ ПВ(мм) */
  carriage_length_asu_ms: Scalars['Float']['output'];
  /** Длина вагона в схеме поезда(м) */
  carriage_length_in_train_schema: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type NpsCarriageLengthList = {
  __typename: 'NpsCarriageLengthList';
  items: Array<NpsCarriageLengthDto>;
  totalCount: Scalars['Float']['output'];
};

export type NpsCarriageLengthMutationEntryPoint = {
  __typename: 'NpsCarriageLengthMutationEntryPoint';
  /** Добавить длину вагона */
  create: NpsCarriageLengthDto;
  /** Обновить длину вагона */
  update: NpsCarriageLengthDto;
};


export type NpsCarriageLengthMutationEntryPointCreateArgs = {
  data: CreateNpsCarriageLengthDto;
};


export type NpsCarriageLengthMutationEntryPointUpdateArgs = {
  data: UpdateNpsCarriageLengthDto;
};

export type NpsCarriageLengthQueryEntryPoint = {
  __typename: 'NpsCarriageLengthQueryEntryPoint';
  /** Длина вагона по id */
  byEntityId: NpsCarriageLengthDto;
  /** Список изменений станции */
  history: NpsCarriageLengthList;
  /** Список длин вагонов */
  list: NpsCarriageLengthList;
};


export type NpsCarriageLengthQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type NpsCarriageLengthQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<NpsCarriageLengthQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type NpsCarriageLengthQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<NpsCarriageLengthQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<NpsCarriageLengthQueryResolver_List_FilterInputType>;
};

export type NpsCarriageLengthQueryResolver_History_SortingInputType = {
  carriage_length_asu_ms?: InputMaybe<SortType>;
  carriage_length_in_train_schema?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NpsCarriageLengthQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<NpsCarriageLengthQueryResolver_List_BaseFilterInputType>>;
  carriage_length_asu_ms?: InputMaybe<Number_PropertyFilterInputType>;
  carriage_length_in_train_schema?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NpsCarriageLengthQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NpsCarriageLengthQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<NpsCarriageLengthQueryResolver_List_BaseFilterInputType>>;
  carriage_length_asu_ms?: InputMaybe<Number_PropertyFilterInputType>;
  carriage_length_in_train_schema?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NpsCarriageLengthQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NpsCarriageLengthQueryResolver_List_SortingInputType = {
  carriage_length_asu_ms?: InputMaybe<SortType>;
  carriage_length_in_train_schema?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NpsCarriageModelDto = {
  __typename: 'NpsCarriageModelDto';
  /** Модель */
  carriage_model: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type NpsCarriageModelList = {
  __typename: 'NpsCarriageModelList';
  items: Array<NpsCarriageModelDto>;
  totalCount: Scalars['Float']['output'];
};

export type NpsCarriageModelMutationEntryPoint = {
  __typename: 'NpsCarriageModelMutationEntryPoint';
  /** Добавить модель вагона */
  create: NpsCarriageModelDto;
  /** Обновить модель вагона */
  update: NpsCarriageModelDto;
};


export type NpsCarriageModelMutationEntryPointCreateArgs = {
  data: CreateNpsCarriageModelDto;
};


export type NpsCarriageModelMutationEntryPointUpdateArgs = {
  data: UpdateNpsCarriageModelDto;
};

export type NpsCarriageModelQueryEntryPoint = {
  __typename: 'NpsCarriageModelQueryEntryPoint';
  /** Модель вагона по id */
  byEntityId: NpsCarriageModelDto;
  /** Список изменений станции */
  history: NpsCarriageModelList;
  /** Список моделей вагонов */
  list: NpsCarriageModelList;
};


export type NpsCarriageModelQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type NpsCarriageModelQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<NpsCarriageModelQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type NpsCarriageModelQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<NpsCarriageModelQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<NpsCarriageModelQueryResolver_List_FilterInputType>;
};

export type NpsCarriageModelQueryResolver_History_SortingInputType = {
  carriage_model?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NpsCarriageModelQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<NpsCarriageModelQueryResolver_List_BaseFilterInputType>>;
  carriage_model?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NpsCarriageModelQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NpsCarriageModelQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<NpsCarriageModelQueryResolver_List_BaseFilterInputType>>;
  carriage_model?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<NpsCarriageModelQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type NpsCarriageModelQueryResolver_List_SortingInputType = {
  carriage_model?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type NpsParkRequiredDto = {
  __typename: 'NpsParkRequiredDto';
  carriage_type: Scalars['String']['output'];
  /** Количество отправлений */
  departures_quantity?: Maybe<Scalars['Float']['output']>;
  seat_type: Scalars['String']['output'];
};

export type Number_PropertyFilterInputType = {
  /** Количество отправлений */
  between?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Количество отправлений */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Количество отправлений */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Количество отправлений */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Количество отправлений */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Количество отправлений */
  in_arr?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Количество отправлений */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Количество отправлений */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Количество отправлений */
  lte?: InputMaybe<Scalars['Float']['input']>;
  /** Количество отправлений */
  neq?: InputMaybe<Scalars['Float']['input']>;
  /** Количество отправлений */
  notbetween?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Количество отправлений */
  notin?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Количество отправлений */
  notlike?: InputMaybe<Scalars['String']['input']>;
  /** Количество отправлений */
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptionalCarriageDto = {
  __typename: 'OptionalCarriageDto';
  /** Номера вагонов */
  carriage_numbers: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type OtherCarriageDto = {
  __typename: 'OtherCarriageDto';
  /** Номера вагонов */
  carriage_numbers: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  other_carriages_info: Array<OtherCarriageInfoDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type OtherCarriageInfoDto = {
  __typename: 'OtherCarriageInfoDto';
  /** Массив дат прибытий на станцию */
  arrival_dates: Array<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Массив дат отправлений со станции */
  departure_dates: Array<Scalars['String']['output']>;
  from_station: StationDto;
  id: Scalars['Int']['output'];
  /** Массив дат прибытий на станцию, в которые поезд не ходит или выходят за рамки текущего ГДП */
  missed_arrival_dates: Array<Scalars['String']['output']>;
  /** Массив дат отправлений со станции, в которые поезд не ходит или выходят за рамки текущего ГДП */
  missed_departure_dates: Array<Scalars['String']['output']>;
  /** Расположение группы по отправлению */
  position_from_station: Scalars['String']['output'];
  /** Расположение группы по прибытию */
  position_to_station: Scalars['String']['output'];
  to_station: StationDto;
  train: TrainDto;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type OtherTrainsDto = {
  __typename: 'OtherTrainsDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  from_station?: Maybe<StationDto>;
  /** Идентификатор станции отправления */
  from_station_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Поезд */
  other_train: TrainDto;
  /** Идентификатор поезда */
  other_train_id: Scalars['Int']['output'];
  to_station?: Maybe<StationDto>;
  /** Идентификатор станции назначения */
  to_station_id: Scalars['Int']['output'];
  /** Идентификатор поезда */
  train_id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type PaginatorArgsDto = {
  page?: Scalars['Int']['input'];
  per_page?: Scalars['Int']['input'];
};

export type ParkRequiredUnionDto = MvpsParkRequiredDto | NpsParkRequiredDto;

export type PassengerCarrierDto = {
  __typename: 'PassengerCarrierDto';
  /** Код пассажирского перевозчика */
  code: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  /** Код государства (GOS ЦСУ) */
  gos: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Является ли данная запись последней актуальной */
  is_latest: Scalars['Boolean']['output'];
  /** Является ли данная запись заблокированной */
  is_lock: Scalars['Boolean']['output'];
  /** ТОЛЬКО ДЛЯ getByEntityId */
  last_version: RangeDto;
  /** MNKODP (ЦСУ) */
  mnkodp: Scalars['String']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Краткое название */
  short_name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type PassengerCarrierList = {
  __typename: 'PassengerCarrierList';
  items: Array<PassengerCarrierDto>;
  totalCount: Scalars['Float']['output'];
};

export type PassengerCarrierMutationEntryPoint = {
  __typename: 'PassengerCarrierMutationEntryPoint';
  /** Создание пассажирского перевозчика */
  create: PassengerCarrierDto;
  /** Обновить пассажирского перевозчика */
  createVersion: PassengerCarrierDto;
  /** Удалить пассажирского перевозчика */
  delete: Scalars['Boolean']['output'];
  /** Обновить пассажирского перевозчика */
  update: PassengerCarrierDto;
  /** Обновить сущность пассажирского перевозчика */
  updateEntity: Scalars['Boolean']['output'];
};


export type PassengerCarrierMutationEntryPointCreateArgs = {
  data: CreatePassengerCarrierDto;
};


export type PassengerCarrierMutationEntryPointCreateVersionArgs = {
  data: CreateVersionPassengerCarrierDto;
};


export type PassengerCarrierMutationEntryPointDeleteArgs = {
  id: Scalars['Float']['input'];
};


export type PassengerCarrierMutationEntryPointUpdateArgs = {
  data: UpdatePassengerCarrierDto;
};


export type PassengerCarrierMutationEntryPointUpdateEntityArgs = {
  data: UpdatePassengerCarrierEntityDto;
};

export type PassengerCarrierQueryEntryPoint = {
  __typename: 'PassengerCarrierQueryEntryPoint';
  /** Пассажирский перевозчик по id */
  byEntityId: PassengerCarrierDto;
  /** Список изменений пассажирских перевозчиков */
  history: PassengerCarrierList;
  /** Список пассажирских перевозчиков */
  list: PassengerCarrierList;
};


export type PassengerCarrierQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type PassengerCarrierQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<PassengerCarrierQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type PassengerCarrierQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<PassengerCarrierQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<PassengerCarrierQueryResolver_List_FilterInputType>;
};

export type PassengerCarrierQueryResolver_History_SortingInputType = {
  code?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  gos?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_latest?: InputMaybe<SortType>;
  is_lock?: InputMaybe<SortType>;
  mnkodp?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type PassengerCarrierQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<PassengerCarrierQueryResolver_List_BaseFilterInputType>>;
  code?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  gos?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_latest?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  mnkodp?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<PassengerCarrierQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type PassengerCarrierQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<PassengerCarrierQueryResolver_List_BaseFilterInputType>>;
  code?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  gos?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_latest?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  mnkodp?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<PassengerCarrierQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type PassengerCarrierQueryResolver_List_SortingInputType = {
  code?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  gos?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_latest?: InputMaybe<SortType>;
  is_lock?: InputMaybe<SortType>;
  mnkodp?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type PeriodicityDto = {
  __typename: 'PeriodicityDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Дата и время начала курсирования */
  from_date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Массив элементов выбранной периодичности */
  metadata?: Maybe<Array<Scalars['String']['output']>>;
  /** Периодичность оборотки */
  periodicity: Scalars['String']['output'];
  /** Дата и время окончания курсирования */
  to_date: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type PeriodicityInfoDto = {
  __typename: 'PeriodicityInfoDto';
  /** Массив дат прибытий */
  arrival_dates: Array<Scalars['String']['output']>;
  /** Массив дат прибытий, который выходит за рамки ГДП */
  arrival_dates_out_of_gdp: Array<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Массив дат отправлений */
  departure_dates: Array<Scalars['String']['output']>;
  /** Массив дат отправлений, который выходит за рамки ГДП */
  departure_dates_out_of_gdp: Array<Scalars['String']['output']>;
  from_station: StationDto;
  id: Scalars['Int']['output'];
  to_station: StationDto;
  train: TrainDto;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type PeriodicitySeasonDto = {
  __typename: 'PeriodicitySeasonDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  /** Сезонность */
  periodicity_season: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type PeriodicitySeasonList = {
  __typename: 'PeriodicitySeasonList';
  items: Array<PeriodicitySeasonDto>;
  totalCount: Scalars['Float']['output'];
};

export type PeriodicitySeasonMutationEntryPoint = {
  __typename: 'PeriodicitySeasonMutationEntryPoint';
  /** Добавить сезонность */
  create: PeriodicitySeasonDto;
  /** Обновить сезонность */
  update: PeriodicitySeasonDto;
};


export type PeriodicitySeasonMutationEntryPointCreateArgs = {
  data: CreatePeriodicitySeasonDto;
};


export type PeriodicitySeasonMutationEntryPointUpdateArgs = {
  data: UpdatePeriodicitySeasonDto;
};

export type PeriodicitySeasonQueryEntryPoint = {
  __typename: 'PeriodicitySeasonQueryEntryPoint';
  /** Сезонность по id */
  byEntityId: PeriodicitySeasonDto;
  /** Список изменений сезонности */
  history: PeriodicitySeasonList;
  /** Список сезонностей */
  list: PeriodicitySeasonList;
};


export type PeriodicitySeasonQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type PeriodicitySeasonQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<PeriodicitySeasonQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type PeriodicitySeasonQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<PeriodicitySeasonQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<PeriodicitySeasonQueryResolver_List_FilterInputType>;
};

export type PeriodicitySeasonQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  periodicity_season?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type PeriodicitySeasonQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<PeriodicitySeasonQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<PeriodicitySeasonQueryResolver_List_BaseFilterInputType>>;
  periodicity_season?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type PeriodicitySeasonQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<PeriodicitySeasonQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<PeriodicitySeasonQueryResolver_List_BaseFilterInputType>>;
  periodicity_season?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type PeriodicitySeasonQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  periodicity_season?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type Query = {
  __typename: 'Query';
  /** группа вагонов запрос */
  carriageGroups: CarriageGroupQueryEntryPoint;
  /** Классификаторы */
  classifiers: ClassifiersQueryEntryPoint;
  /** Новостная панель */
  cms: CmsQueryEntryPoint;
  /** Конфигурации */
  configuration: ConfigurationQueryEntryPoint;
  /** Хранилище файлов */
  filestorage: FilestorageQueryEntryPoint;
  /** Показатели */
  indicators: IndicatorsQueryEntryPoint;
  /** Журнал */
  journal: JournalQueryEntryPoint;
  /** Уведомление пользовавтеля */
  notification: NotificationQueryEntryPoint;
  /** Контроль доступа */
  rbac: RbacQueryEntryPoint;
  /** Планировщик */
  scheduler: SchedulerQueryEntryPoint;
  /** Синзронизации с внешними источниками */
  sync: QueryEntryPoint;
  /** Контроль параметров перевозок */
  tpc: TpcQueryEntryPoint;
  /** Поезда */
  train: TrainQueryEntryPoint;
  /** Расписания */
  train_schedules: TrainSchedulesQueryEntryPoint;
  /** Схема поезда */
  train_schemas: TrainSchemaQueryEntryPoint;
  /** Пользователи */
  users: UsersQueryEntryPoint;
};

export type QueryEntryPoint = {
  __typename: 'QueryEntryPoint';
  /** Журнал синхронизации */
  journal: JournalSyncList;
};


export type QueryEntryPointJournalArgs = {
  order_by?: InputMaybe<Array<SyncQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<SyncQueryResolver_List_FilterInputType>;
};

export type QueryInfrastructureApplication23DataDto = {
  /** Расстояние */
  distance?: InputMaybe<Scalars['Int']['input']>;
  /** Id коэффициента расчета */
  infrastructure_coefficients_indexing_id?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryInfrastructureApplication24DataDto = {
  /** Расстояние */
  distance?: InputMaybe<Scalars['Int']['input']>;
  /** Id коэффициента расчета */
  infrastructure_coefficients_indexing_id?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryInfrastructureApplication25DataDto = {
  /** Расстояние */
  distance?: InputMaybe<Scalars['Int']['input']>;
  /** Id коэффициента расчета */
  infrastructure_coefficients_indexing_id?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryInfrastructureApplication26DataDto = {
  /** Расстояние */
  distance?: InputMaybe<Scalars['Int']['input']>;
  /** Id коэффициента расчета */
  infrastructure_coefficients_indexing_id?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryInfrastructureApplication27DataDto = {
  /** Id коэффициента расчета */
  infrastructure_coefficients_indexing_id?: InputMaybe<Scalars['Int']['input']>;
};

export type QueueFilterDto = {
  status: Array<Scalars['String']['input']>;
};

export type QueueInfoDto = {
  __typename: 'QueueInfoDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Идентификатор файла */
  file_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Идентификатор процесса */
  job_id: Scalars['String']['output'];
  /** Дополнительные данные */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Статус */
  status: Scalars['String']['output'];
  /** Тип файла */
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type QueueJobDataDto = {
  __typename: 'QueueJobDataDto';
  fileId: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['Float']['output'];
};

export type QueueJobDto = {
  __typename: 'QueueJobDto';
  attemptsMade?: Maybe<Scalars['Float']['output']>;
  data: QueueJobDataDto;
  delay?: Maybe<Scalars['Float']['output']>;
  finishedOn?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  processedOn?: Maybe<Scalars['Float']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type QueuesListDto = {
  __typename: 'QueuesListDto';
  items: Array<QueueJobDto>;
  totalCount: Scalars['Float']['output'];
};

export type QueuesMutationEntryPoint = {
  __typename: 'QueuesMutationEntryPoint';
  /** Очистить очередь */
  clearQueues?: Maybe<Scalars['Boolean']['output']>;
};


export type QueuesMutationEntryPointClearQueuesArgs = {
  data: QueueFilterDto;
};

export type QueuesQueryEntryPoint = {
  __typename: 'QueuesQueryEntryPoint';
  /** Список задач в очереди */
  list: QueuesListDto;
};


export type QueuesQueryEntryPointListArgs = {
  queue: Scalars['String']['input'];
};

export type RailwayAdministrationDto = {
  __typename: 'RailwayAdministrationDto';
  /** Код ЖД администрации */
  code: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Флаг СНГ или Дальнее зарубежье */
  international_mnemonic?: Maybe<Scalars['String']['output']>;
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  /** Полное наименование ЖД администрации */
  name: Scalars['String']['output'];
  /** Краткое наименование ЖД администрации */
  short_name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type RailwayAdministrationList = {
  __typename: 'RailwayAdministrationList';
  items: Array<RailwayAdministrationDto>;
  totalCount: Scalars['Float']['output'];
};

export type RailwayAdministrationMutationEntryPoint = {
  __typename: 'RailwayAdministrationMutationEntryPoint';
  /** Создание ЖД администрации */
  create: RailwayAdministrationDto;
  /** Обновить ЖД администрацию */
  update: RailwayAdministrationDto;
};


export type RailwayAdministrationMutationEntryPointCreateArgs = {
  data: CreateRailwayAdministrationDto;
};


export type RailwayAdministrationMutationEntryPointUpdateArgs = {
  data: UpdateRailwayAdministrationDto;
};

export type RailwayAdministrationQueryEntryPoint = {
  __typename: 'RailwayAdministrationQueryEntryPoint';
  /** ЖД администрация по id */
  byEntityId: RailwayAdministrationDto;
  /** Список изменений администрации железной дороги */
  history: RailwayAdministrationList;
  /** Список ЖД администраций */
  list: RailwayAdministrationList;
};


export type RailwayAdministrationQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type RailwayAdministrationQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<RailwayAdministrationQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type RailwayAdministrationQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<RailwayAdministrationQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<RailwayAdministrationQueryResolver_List_FilterInputType>;
};

export type RailwayAdministrationQueryResolver_History_SortingInputType = {
  code?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  international_mnemonic?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type RailwayAdministrationQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<RailwayAdministrationQueryResolver_List_BaseFilterInputType>>;
  code?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RailwayAdministrationQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RailwayAdministrationQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<RailwayAdministrationQueryResolver_List_BaseFilterInputType>>;
  code?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RailwayAdministrationQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RailwayAdministrationQueryResolver_List_SortingInputType = {
  code?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  international_mnemonic?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type RailwayDto = {
  __typename: 'RailwayDto';
  /** Код железной дороги */
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  /** Наименование железной дороги */
  name: Scalars['String']['output'];
  railway_administration: RailwayAdministrationDto;
  /** Сокращённое наименование железной дороги */
  short_name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  /** Таймзона железной дороги относительно МСК времени */
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type RailwayList = {
  __typename: 'RailwayList';
  items: Array<RailwayDto>;
  totalCount: Scalars['Float']['output'];
};

export type RailwayMutationEntryPoint = {
  __typename: 'RailwayMutationEntryPoint';
  /** Создание железной дороги */
  create: RailwayDto;
  /** Обновление железной дороги */
  update: RailwayDto;
};


export type RailwayMutationEntryPointCreateArgs = {
  data: CreateRailwayDto;
};


export type RailwayMutationEntryPointUpdateArgs = {
  data: UpdateRailwayDto;
};

export type RailwayQueryEntryPoint = {
  __typename: 'RailwayQueryEntryPoint';
  /** Железныая дорога по entity_id */
  byEntityId: RailwayDto;
  /** Список изменений железной дороги */
  history: RailwayList;
  /** Список железных дорог */
  list: RailwayList;
};


export type RailwayQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type RailwayQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<RailwayQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type RailwayQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<RailwayQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<RailwayQueryResolver_List_FilterInputType>;
};

export type RailwayQueryResolver_History_SortingInputType = {
  code?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  timezone?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type RailwayQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<RailwayQueryResolver_List_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RailwayQueryResolver_List_BaseFilterInputType>>;
  railway_administration_id?: InputMaybe<Number_PropertyFilterInputType>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  timezone?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RailwayQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<RailwayQueryResolver_List_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RailwayQueryResolver_List_BaseFilterInputType>>;
  railway_administration_id?: InputMaybe<Number_PropertyFilterInputType>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  timezone?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RailwayQueryResolver_List_SortingInputType = {
  code?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  timezone?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type RailwayResponseDto = {
  __typename: 'RailwayResponseDto';
  /** Код железной дороги */
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Наименование железной дороги */
  name: Scalars['String']['output'];
  /** Сокращённое наименование железной дороги */
  short_name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type RangeDto = {
  __typename: 'RangeDto';
  /** Окончание временного интервала */
  end_at?: Maybe<Scalars['String']['output']>;
  /** Начало временного интервала */
  start_at: Scalars['String']['output'];
};

export type RangeInputDto = {
  /** Окончание временного интервала */
  end_at?: InputMaybe<Scalars['String']['input']>;
  /** Начало временного интервала */
  start_at: Scalars['String']['input'];
};

export type RbacMutationEntryPoint = {
  __typename: 'RbacMutationEntryPoint';
  /** Создание подразделения */
  create_division: DivisionDto;
  /** Создание правила */
  create_rule: Scalars['Float']['output'];
  /** Обновление ролей и правил в кэше у текущего пользователя */
  update_cache_roles: DivisionDto;
  /** Обновление подразделения */
  update_division: DivisionDto;
  /** Обновление роли */
  update_role: Scalars['Boolean']['output'];
  /** Обновление правила */
  update_rule: Scalars['Boolean']['output'];
};


export type RbacMutationEntryPointCreate_DivisionArgs = {
  data: CreateDivisionDto;
};


export type RbacMutationEntryPointCreate_RuleArgs = {
  data: CreateRuleDto;
};


export type RbacMutationEntryPointUpdate_DivisionArgs = {
  data: UpdateDivisionDto;
};


export type RbacMutationEntryPointUpdate_RoleArgs = {
  data: UpdateRoleDto;
};


export type RbacMutationEntryPointUpdate_RuleArgs = {
  data: UpdateRuleDto;
};

export type RbacQueryEntryPoint = {
  __typename: 'RbacQueryEntryPoint';
  /** Получить список подразделений */
  divisions: DivisionList;
  /** Получить список модулей */
  modules: ModuleList;
  /** Получить роль по id */
  role: RoleDto;
  /** Получить список ролей */
  roles: RoleList;
  /** Получить список правил */
  rules: RuleList;
};


export type RbacQueryEntryPointDivisionsArgs = {
  order_by?: InputMaybe<Array<RbacQueryResolver_Division_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<RbacQueryResolver_Division_FilterInputType>;
};


export type RbacQueryEntryPointModulesArgs = {
  order_by?: InputMaybe<Array<RbacQueryResolver_Modules_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<RbacQueryResolver_Modules_FilterInputType>;
};


export type RbacQueryEntryPointRoleArgs = {
  id: Scalars['Float']['input'];
};


export type RbacQueryEntryPointRolesArgs = {
  order_by?: InputMaybe<Array<RbacQueryResolver_Roles_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<RbacQueryResolver_Roles_FilterInputType>;
};


export type RbacQueryEntryPointRulesArgs = {
  order_by?: InputMaybe<Array<RbacQueryResolver_Rules_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<RbacQueryResolver_Rules_FilterInputType>;
};

export type RbacQueryResolver_Division_BaseFilterInputType = {
  and?: InputMaybe<Array<RbacQueryResolver_Division_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  disabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RbacQueryResolver_Division_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RbacQueryResolver_Division_FilterInputType = {
  and?: InputMaybe<Array<RbacQueryResolver_Division_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  disabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RbacQueryResolver_Division_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RbacQueryResolver_Division_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  disabled?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type RbacQueryResolver_Modules_BaseFilterInputType = {
  and?: InputMaybe<Array<RbacQueryResolver_Modules_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RbacQueryResolver_Modules_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RbacQueryResolver_Modules_FilterInputType = {
  and?: InputMaybe<Array<RbacQueryResolver_Modules_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RbacQueryResolver_Modules_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RbacQueryResolver_Modules_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type RbacQueryResolver_Roles_BaseFilterInputType = {
  and?: InputMaybe<Array<RbacQueryResolver_Roles_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  disabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  method?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RbacQueryResolver_Roles_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RbacQueryResolver_Roles_FilterInputType = {
  and?: InputMaybe<Array<RbacQueryResolver_Roles_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  disabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  method?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RbacQueryResolver_Roles_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RbacQueryResolver_Roles_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_fpk?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type RbacQueryResolver_Rules_BaseFilterInputType = {
  and?: InputMaybe<Array<RbacQueryResolver_Rules_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  disabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  method?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RbacQueryResolver_Rules_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RbacQueryResolver_Rules_FilterInputType = {
  and?: InputMaybe<Array<RbacQueryResolver_Rules_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  disabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  method?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RbacQueryResolver_Rules_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RbacQueryResolver_Rules_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  disabled?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  method?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type RefreshTokenRequestDto = {
  refreshToken: Scalars['String']['input'];
};

export type RefreshTokenResponseDto = {
  __typename: 'RefreshTokenResponseDto';
  /** Таймстемп аксес токена */
  accessTokenExpTimestamp: Scalars['Float']['output'];
};

export type RelatedTrainsDto = {
  __typename: 'RelatedTrainsDto';
  /** Филиал */
  branch?: Maybe<Scalars['String']['output']>;
  /** Станция отправления */
  from_station?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Уровень вложенности связи поезда */
  level: Scalars['Int']['output'];
  /** Пара */
  pair_train?: Maybe<RelatedTrainsDto>;
  /** Идентификатор парного поезда */
  pair_train_id?: Maybe<Scalars['Int']['output']>;
  /** Статус поезда */
  status: Scalars['String']['output'];
  /** Станция прибытия */
  to_station?: Maybe<Scalars['String']['output']>;
  /** Номер поезда */
  train_number: Scalars['String']['output'];
};

export type RelatedTrainsDtoList = {
  __typename: 'RelatedTrainsDtoList';
  items: Array<RelatedTrainsDto>;
  totalCount: Scalars['Float']['output'];
};

export type ReplenishmentCarriageDto = {
  __typename: 'ReplenishmentCarriageDto';
  /** количество вагонов */
  quantity: Scalars['Float']['output'];
  /** тип вагона */
  type: Scalars['String']['output'];
};

export type ReplenishmentDateDto = {
  __typename: 'ReplenishmentDateDto';
  /** информация по отправленным вагонам */
  carriages: Array<ReplenishmentCarriageDto>;
  /** дата отправления */
  date: Scalars['String']['output'];
  /** информация по дате сравнения */
  diff: Array<ReplenishmentCarriageDto>;
};

export type ReplenishmentDto = {
  __typename: 'ReplenishmentDto';
  /** Прирост доступной емкости */
  available_capacity_increase: Scalars['Float']['output'];
  /** филиал */
  branch?: Maybe<BranchDto>;
  /** вагоны */
  carriages_quantity: Scalars['Float']['output'];
  /** дата сравнения */
  compare_date: Scalars['String']['output'];
  /** дата синхронизации */
  date_sync: Scalars['String']['output'];
  /** информация по поездам */
  items: Array<ReplenishmentTrainDto>;
  /** прицепные вагоны */
  trailed_carriages_quantity: Scalars['Float']['output'];
  /** отправлено поездов */
  trains_quantity: Scalars['Float']['output'];
};

export type ReplenishmentRequestDto = {
  /** идентификатор филиала */
  branch_id: Scalars['Float']['input'];
  /** Дата сравнения */
  compare_date: Scalars['String']['input'];
};

export type ReplenishmentTrainDto = {
  __typename: 'ReplenishmentTrainDto';
  /** информация по датам */
  dates: Array<ReplenishmentDateDto>;
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
  /** номер поезда */
  train_number: Scalars['String']['output'];
  /** версия поезда */
  version: Scalars['Float']['output'];
};

export type RestTotalTrainsDto = {
  __typename: 'RestTotalTrainsDto';
  /** Пары поездов Дальнего зарубежья */
  far_abroad_trains_pair: RestTrainDto;
  /** Пары поездов РЖД других перевозчиков */
  other_trains_pair: RestTrainDto;
  /** Пары поездов СНГ */
  sng_trains_pair: RestTrainDto;
  /** Пары поездов других ЖД администраци и перевозчиков */
  total_trains_pair: RestTrainDto;
};

export type RestTrainDto = {
  __typename: 'RestTrainDto';
  /** Наименование ключа для фильтра для отображения */
  entity_rus_name: Scalars['String']['output'];
  /** ID поездов - главных в паре */
  main_train_ids: Array<Scalars['Int']['output']>;
  /** Количество пар поездов */
  pairs_count: Scalars['Int']['output'];
  /** Массив пар поездов по ЖД администрациям или перевозчикам */
  trains_pair_array: Array<TrainPairsDashboardDto>;
};

export type RoleDto = {
  __typename: 'RoleDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  is_fpk: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rules: Array<RuleDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type RoleList = {
  __typename: 'RoleList';
  items: Array<RoleDto>;
  totalCount: Scalars['Float']['output'];
};

export type RoutesControlAvailabilitySeatsDirectionMutationEntryPoint = {
  __typename: 'RoutesControlAvailabilitySeatsDirectionMutationEntryPoint';
  /** Создание маршрутов для контроля наличия свободных мест по направлениям */
  create: RoutesControlAvailabilitySeatsDirectionsDto;
  /** Обновление маршрутов для контроля наличия свободных мест по направлениям */
  update?: Maybe<RoutesControlAvailabilitySeatsDirectionsDto>;
};


export type RoutesControlAvailabilitySeatsDirectionMutationEntryPointCreateArgs = {
  data: CreateRoutesControlAvailabilitySeatsDirectionsDto;
};


export type RoutesControlAvailabilitySeatsDirectionMutationEntryPointUpdateArgs = {
  data: UpdateRoutesControlAvailabilitySeatsDirectionsDto;
};

export type RoutesControlAvailabilitySeatsDirectionQueryEntryPoint = {
  __typename: 'RoutesControlAvailabilitySeatsDirectionQueryEntryPoint';
  /** Маршруты для контроля наличия свободных мест по направлениям по id */
  byId: RoutesControlAvailabilitySeatsDirectionsDto;
  /** Список маршрутов для контроля наличия свободных мест по направлениям */
  list: RoutesControlAvailabilitySeatsDirectionsList;
  /** Список направлений(Станций) */
  uniqueRoutes: UniqueRoutesDtoList;
};


export type RoutesControlAvailabilitySeatsDirectionQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type RoutesControlAvailabilitySeatsDirectionQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<RoutesControlAvailabilitySeatsDirectionQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  where?: InputMaybe<RoutesControlAvailabilitySeatsDirectionQueryResolver_List_FilterInputType>;
};


export type RoutesControlAvailabilitySeatsDirectionQueryEntryPointUniqueRoutesArgs = {
  paginate: PaginatorArgsDto;
  where?: InputMaybe<RoutesControlAvailabilitySeatsDirectionQueryResolver_UniqueRoutes_FilterInputType>;
};

export type RoutesControlAvailabilitySeatsDirectionQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<RoutesControlAvailabilitySeatsDirectionQueryResolver_List_BaseFilterInputType>>;
  arrival_direction_id?: InputMaybe<Int_PropertyFilterInputType>;
  arrival_stations_ids?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  departure_direction_id?: InputMaybe<Int_PropertyFilterInputType>;
  departure_stations_ids?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<RoutesControlAvailabilitySeatsDirectionQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RoutesControlAvailabilitySeatsDirectionQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<RoutesControlAvailabilitySeatsDirectionQueryResolver_List_BaseFilterInputType>>;
  arrival_direction_id?: InputMaybe<Int_PropertyFilterInputType>;
  arrival_stations_ids?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  departure_direction_id?: InputMaybe<Int_PropertyFilterInputType>;
  departure_stations_ids?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<RoutesControlAvailabilitySeatsDirectionQueryResolver_List_BaseFilterInputType>>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type RoutesControlAvailabilitySeatsDirectionQueryResolver_List_SortingInputType = {
  arrival_direction_id?: InputMaybe<SortType>;
  arrival_stations_ids?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  departure_direction_id?: InputMaybe<SortType>;
  departure_stations_ids?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_lock?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type RoutesControlAvailabilitySeatsDirectionQueryResolver_UniqueRoutes_BaseFilterInputType = {
  and?: InputMaybe<Array<RoutesControlAvailabilitySeatsDirectionQueryResolver_UniqueRoutes_BaseFilterInputType>>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RoutesControlAvailabilitySeatsDirectionQueryResolver_UniqueRoutes_BaseFilterInputType>>;
};

export type RoutesControlAvailabilitySeatsDirectionQueryResolver_UniqueRoutes_FilterInputType = {
  and?: InputMaybe<Array<RoutesControlAvailabilitySeatsDirectionQueryResolver_UniqueRoutes_BaseFilterInputType>>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RoutesControlAvailabilitySeatsDirectionQueryResolver_UniqueRoutes_BaseFilterInputType>>;
};

export type RoutesControlAvailabilitySeatsDirectionsDto = {
  __typename: 'RoutesControlAvailabilitySeatsDirectionsDto';
  arrival_direction?: Maybe<StationDto>;
  /** Назначение направления */
  arrival_direction_id: Scalars['Int']['output'];
  arrival_stations?: Maybe<Array<StationDto>>;
  /** Назначение станции */
  arrival_stations_ids: Array<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  departure_direction?: Maybe<StationDto>;
  /** Отправление направления */
  departure_direction_id: Scalars['Int']['output'];
  departure_stations?: Maybe<Array<StationDto>>;
  /** Отправление станции */
  departure_stations_ids: Array<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Блокировка направления */
  is_lock: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type RoutesControlAvailabilitySeatsDirectionsList = {
  __typename: 'RoutesControlAvailabilitySeatsDirectionsList';
  items: Array<RoutesControlAvailabilitySeatsDirectionsDto>;
  totalCount: Scalars['Float']['output'];
};

export type RuleDto = {
  __typename: 'RuleDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  method: Scalars['String']['output'];
  module: ModuleDto;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type RuleList = {
  __typename: 'RuleList';
  items: Array<RuleDto>;
  totalCount: Scalars['Float']['output'];
};

export type SchedulerJobDto = {
  __typename: 'SchedulerJobDto';
  command: Scalars['String']['output'];
  /** Отключен */
  disable: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** Наименование */
  name: Scalars['String']['output'];
  /** Время синхронизации */
  time: Scalars['String']['output'];
};

export type SchedulerJobList = {
  __typename: 'SchedulerJobList';
  items: Array<SchedulerJobDto>;
  totalCount: Scalars['Float']['output'];
};

export type SchedulerJobMutationEntryPoint = {
  __typename: 'SchedulerJobMutationEntryPoint';
  /** Запуск задач */
  manualStart: Scalars['Boolean']['output'];
  /** Изменить статус задачи */
  updateDisableJob: Scalars['Boolean']['output'];
  /** Изменить время задачи */
  updateTimeJob: Scalars['Boolean']['output'];
};


export type SchedulerJobMutationEntryPointManualStartArgs = {
  command: Scalars['String']['input'];
};


export type SchedulerJobMutationEntryPointUpdateDisableJobArgs = {
  data: UpdateDisableSchedulerJobDto;
};


export type SchedulerJobMutationEntryPointUpdateTimeJobArgs = {
  data: UpdateTimeSchedulerJobDto;
};

export type SchedulerJobQueryEntryPoint = {
  __typename: 'SchedulerJobQueryEntryPoint';
  /** Список запланированных задач */
  list: SchedulerJobList;
};


export type SchedulerJobQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<SchedulerQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<SchedulerQueryResolver_List_FilterInputType>;
};

export type SchedulerMutationEntryPoint = {
  __typename: 'SchedulerMutationEntryPoint';
  /** Очереди */
  queues: QueuesMutationEntryPoint;
  /** Планировщик */
  scheduler: SchedulerJobMutationEntryPoint;
};

export type SchedulerQueryEntryPoint = {
  __typename: 'SchedulerQueryEntryPoint';
  /** Очереди */
  queues: QueuesQueryEntryPoint;
  /** Планировщик */
  scheduler: SchedulerJobQueryEntryPoint;
};

export type SchedulerQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<SchedulerQueryResolver_List_BaseFilterInputType>>;
  command?: InputMaybe<String_PropertyFilterInputType>;
  disable?: InputMaybe<Boolean_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<SchedulerQueryResolver_List_BaseFilterInputType>>;
  time?: InputMaybe<String_PropertyFilterInputType>;
};

export type SchedulerQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<SchedulerQueryResolver_List_BaseFilterInputType>>;
  command?: InputMaybe<String_PropertyFilterInputType>;
  disable?: InputMaybe<Boolean_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<SchedulerQueryResolver_List_BaseFilterInputType>>;
  time?: InputMaybe<String_PropertyFilterInputType>;
};

export type SchedulerQueryResolver_List_SortingInputType = {
  command?: InputMaybe<SortType>;
  disable?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  time?: InputMaybe<SortType>;
};

export type SchemaControlByBranchDto = {
  __typename: 'SchemaControlByBranchDto';
  branch?: Maybe<BranchDto>;
  /** Отправлено вагонов факт */
  carriages_fact: Scalars['Float']['output'];
  /** Отправлено вагонов % */
  carriages_percentage: Scalars['Float']['output'];
  /** Отправлено вагонов план */
  carriages_plan: Scalars['Float']['output'];
  /** Отправлено вагонов +/- */
  carriages_tolerance: Scalars['Float']['output'];
  /** Вагонооборот факт */
  carriages_turnover_fact: Scalars['Float']['output'];
  /** Вагонооборот % */
  carriages_turnover_percentage: Scalars['Float']['output'];
  /** Вагонооборот план */
  carriages_turnover_plan: Scalars['Float']['output'];
  /** Вагонооборот +/- */
  carriages_turnover_tolerance: Scalars['Float']['output'];
  /** Месяц */
  date: Scalars['String']['output'];
  /** Средний состав факт */
  indicators_fact: Scalars['Float']['output'];
  /** Средний состав % */
  indicators_percentage: Scalars['Float']['output'];
  /** Средний состав план */
  indicators_plan: Scalars['Float']['output'];
  /** Средний состав +/- */
  indicators_tolerance: Scalars['Float']['output'];
  /** Местоооборот факт */
  seats_turnover_fact: Scalars['Float']['output'];
  /** Местоооборот % */
  seats_turnover_percentage: Scalars['Float']['output'];
  /** Местоооборот план */
  seats_turnover_plan: Scalars['Float']['output'];
  /** Местоооборот +/- */
  seats_turnover_tolerance: Scalars['Float']['output'];
  /** Отправлено поездов факт */
  trains_fact: Scalars['Float']['output'];
  /** Отправлено поездов % */
  trains_percentage: Scalars['Float']['output'];
  /** Отправлено поездов план */
  trains_plan: Scalars['Float']['output'];
  /** Отправлено поездов +/- */
  trains_tolerance: Scalars['Float']['output'];
  /** Поездооборот факт */
  trains_turnover_fact: Scalars['Float']['output'];
  /** Поездооборот % */
  trains_turnover_percentage: Scalars['Float']['output'];
  /** Поездооборот план */
  trains_turnover_plan: Scalars['Float']['output'];
  /** Поездооборот +/- */
  trains_turnover_tolerance: Scalars['Float']['output'];
};

export type SchemaControlByTrainCarriageDto = {
  __typename: 'SchemaControlByTrainCarriageDto';
  carriage_quantity?: Maybe<Scalars['Int']['output']>;
  carriage_type: Scalars['String']['output'];
  carriages_quantity_fact?: Maybe<Scalars['Int']['output']>;
  carriages_quantity_plan?: Maybe<Scalars['Int']['output']>;
  carriages_turnover_fact?: Maybe<Scalars['Int']['output']>;
  carriages_turnover_plan?: Maybe<Scalars['Int']['output']>;
  dates?: Maybe<Array<SchemaControlByTrainDateDto>>;
  indicators_fact?: Maybe<Scalars['Float']['output']>;
  indicators_plan?: Maybe<Scalars['Float']['output']>;
  seats_quantity_fact?: Maybe<Scalars['Int']['output']>;
  seats_quantity_plan?: Maybe<Scalars['Int']['output']>;
  seats_turnover_fact?: Maybe<Scalars['Int']['output']>;
  seats_turnover_plan?: Maybe<Scalars['Int']['output']>;
  trains_quantity_fact?: Maybe<Scalars['Int']['output']>;
  trains_quantity_plan?: Maybe<Scalars['Int']['output']>;
  trains_turnover_fact?: Maybe<Scalars['Int']['output']>;
  trains_turnover_plan?: Maybe<Scalars['Int']['output']>;
};

export type SchemaControlByTrainCarriageGroupBlockDto = {
  __typename: 'SchemaControlByTrainCarriageGroupBlockDto';
  branch?: Maybe<BranchDto>;
  carriage_quantity?: Maybe<Scalars['Int']['output']>;
  carriages_quantity_fact?: Maybe<Scalars['Int']['output']>;
  carriages_quantity_plan?: Maybe<Scalars['Int']['output']>;
  carriages_turnover_fact?: Maybe<Scalars['Int']['output']>;
  carriages_turnover_plan?: Maybe<Scalars['Int']['output']>;
  dates?: Maybe<Array<SchemaControlByTrainDateDto>>;
  groups: Array<SchemaControlByTrainCarriageGroupDto>;
  indicators_fact?: Maybe<Scalars['Float']['output']>;
  indicators_plan?: Maybe<Scalars['Float']['output']>;
  passenger_carrier_russian_railway?: Maybe<PassengerCarrierDto>;
  railway_administration?: Maybe<RailwayAdministrationDto>;
  seats_quantity_fact?: Maybe<Scalars['Int']['output']>;
  seats_quantity_plan?: Maybe<Scalars['Int']['output']>;
  seats_turnover_fact?: Maybe<Scalars['Int']['output']>;
  seats_turnover_plan?: Maybe<Scalars['Int']['output']>;
  trains_quantity_fact?: Maybe<Scalars['Int']['output']>;
  trains_quantity_plan?: Maybe<Scalars['Int']['output']>;
  trains_turnover_fact?: Maybe<Scalars['Int']['output']>;
  trains_turnover_plan?: Maybe<Scalars['Int']['output']>;
};

export type SchemaControlByTrainCarriageGroupDto = {
  __typename: 'SchemaControlByTrainCarriageGroupDto';
  branch?: Maybe<BranchDto>;
  carriage_group_id?: Maybe<Scalars['Int']['output']>;
  carriage_quantity?: Maybe<Scalars['Int']['output']>;
  carriages: Array<SchemaControlByTrainCarriageDto>;
  carriages_quantity_fact?: Maybe<Scalars['Int']['output']>;
  carriages_quantity_plan?: Maybe<Scalars['Int']['output']>;
  carriages_turnover_fact?: Maybe<Scalars['Int']['output']>;
  carriages_turnover_plan?: Maybe<Scalars['Int']['output']>;
  dates?: Maybe<Array<SchemaControlByTrainDateDto>>;
  indicators_fact?: Maybe<Scalars['Float']['output']>;
  indicators_plan?: Maybe<Scalars['Float']['output']>;
  passenger_carrier_russian_railway?: Maybe<PassengerCarrierDto>;
  railway_administration?: Maybe<RailwayAdministrationDto>;
  schema_number: Array<Scalars['Int']['output']>;
  seats_quantity_fact?: Maybe<Scalars['Int']['output']>;
  seats_quantity_plan?: Maybe<Scalars['Int']['output']>;
  seats_turnover_fact?: Maybe<Scalars['Int']['output']>;
  seats_turnover_plan?: Maybe<Scalars['Int']['output']>;
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
  trains_quantity_fact?: Maybe<Scalars['Int']['output']>;
  trains_quantity_plan?: Maybe<Scalars['Int']['output']>;
  trains_turnover_fact?: Maybe<Scalars['Int']['output']>;
  trains_turnover_plan?: Maybe<Scalars['Int']['output']>;
};

export type SchemaControlByTrainDateDto = {
  __typename: 'SchemaControlByTrainDateDto';
  capacity: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  diff?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Float']['output'];
};

export type SchemaControlByTrainDto = {
  __typename: 'SchemaControlByTrainDto';
  branch?: Maybe<BranchDto>;
  carriage_group_id?: Maybe<Scalars['Int']['output']>;
  /** Кол. вагонов */
  carriage_quantity?: Maybe<Scalars['Int']['output']>;
  carriage_type: Scalars['String']['output'];
  /** Кол вагонов факт */
  carriages_quantity_fact?: Maybe<Scalars['Int']['output']>;
  /** Кол вагонов план */
  carriages_quantity_plan?: Maybe<Scalars['Int']['output']>;
  /** Вагонооборот факт */
  carriages_turnover_fact?: Maybe<Scalars['Int']['output']>;
  /** Вагонооборот план */
  carriages_turnover_plan?: Maybe<Scalars['Int']['output']>;
  dates: Array<ControlSchemaDates>;
  display_train_number: Scalars['String']['output'];
  distance: Scalars['Float']['output'];
  /** Ср состав факт */
  indicators_fact?: Maybe<Scalars['Float']['output']>;
  /** Ср состав план */
  indicators_plan?: Maybe<Scalars['Int']['output']>;
  passenger_carrier_russian_railway?: Maybe<BranchDto>;
  railway_administration?: Maybe<BranchDto>;
  /** Кол мест */
  seats_quantity?: Maybe<Scalars['Int']['output']>;
  /** Кол мест факт */
  seats_quantity_fact?: Maybe<Scalars['Int']['output']>;
  /** Кол мест план */
  seats_quantity_plan?: Maybe<Scalars['Int']['output']>;
  /** Местооборот факт */
  seats_turnover_fact?: Maybe<Scalars['Int']['output']>;
  /** Местооборот план */
  seats_turnover_plan?: Maybe<Scalars['Int']['output']>;
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
  train_id?: Maybe<Scalars['Int']['output']>;
  train_number: Scalars['String']['output'];
  /** Количество составов */
  train_quantity?: Maybe<Scalars['Int']['output']>;
  /** Поездооборот факт */
  trains_turnover_fact?: Maybe<Scalars['Int']['output']>;
  /** Поездооборот план */
  trains_turnover_plan?: Maybe<Scalars['Int']['output']>;
  trips_quantity?: Maybe<Scalars['Int']['output']>;
  /** Тип записи */
  type: Scalars['String']['output'];
};

export type SchemaControlByTrainInTurnoverWithDto = {
  __typename: 'SchemaControlByTrainInTurnoverWithDto';
  branch?: Maybe<BranchDto>;
  carriage_quantity?: Maybe<Scalars['Int']['output']>;
  carriages_quantity_fact?: Maybe<Scalars['Int']['output']>;
  carriages_quantity_plan?: Maybe<Scalars['Int']['output']>;
  carriages_turnover_fact?: Maybe<Scalars['Int']['output']>;
  carriages_turnover_plan?: Maybe<Scalars['Int']['output']>;
  dates?: Maybe<Array<SchemaControlByTrainDateDto>>;
  display_train_number: Scalars['String']['output'];
  indicators_fact?: Maybe<Scalars['Float']['output']>;
  indicators_plan?: Maybe<Scalars['Float']['output']>;
  passenger_carrier_russian_railway?: Maybe<PassengerCarrierDto>;
  railway_administration?: Maybe<RailwayAdministrationDto>;
  seats_quantity_fact?: Maybe<Scalars['Int']['output']>;
  seats_quantity_plan?: Maybe<Scalars['Int']['output']>;
  seats_turnover_fact?: Maybe<Scalars['Int']['output']>;
  seats_turnover_plan?: Maybe<Scalars['Int']['output']>;
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
  trains_quantity_fact?: Maybe<Scalars['Int']['output']>;
  trains_quantity_plan?: Maybe<Scalars['Int']['output']>;
  trains_turnover_fact?: Maybe<Scalars['Int']['output']>;
  trains_turnover_plan?: Maybe<Scalars['Int']['output']>;
  version: Scalars['Int']['output'];
};

export type SchemaControlCalculatedList = {
  __typename: 'SchemaControlCalculatedList';
  items: Array<SchemaControlDto>;
  totalCount: Scalars['Float']['output'];
};

export type SchemaControlDto = {
  __typename: 'SchemaControlDto';
  branch?: Maybe<BranchDto>;
  carriage_quantity?: Maybe<Scalars['Int']['output']>;
  carriages_quantity_fact?: Maybe<Scalars['Int']['output']>;
  carriages_quantity_plan?: Maybe<Scalars['Int']['output']>;
  carriages_turnover_fact?: Maybe<Scalars['Int']['output']>;
  carriages_turnover_plan?: Maybe<Scalars['Int']['output']>;
  dates?: Maybe<Array<SchemaControlByTrainDateDto>>;
  in_turnover_with_data?: Maybe<Array<SchemaControlByTrainInTurnoverWithDto>>;
  indicators_fact?: Maybe<Scalars['Float']['output']>;
  indicators_plan?: Maybe<Scalars['Float']['output']>;
  main_group_data?: Maybe<SchemaControlByTrainCarriageGroupBlockDto>;
  not_asu_ms_data?: Maybe<SchemaControlByTrainCarriageGroupBlockDto>;
  passenger_carrier_russian_railway?: Maybe<PassengerCarrierDto>;
  railway_administration?: Maybe<RailwayAdministrationDto>;
  seats_quantity_fact?: Maybe<Scalars['Int']['output']>;
  seats_quantity_plan?: Maybe<Scalars['Int']['output']>;
  seats_turnover_fact?: Maybe<Scalars['Int']['output']>;
  seats_turnover_plan?: Maybe<Scalars['Int']['output']>;
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
  trailed_group_data?: Maybe<SchemaControlByTrainCarriageGroupBlockDto>;
  train_id?: Maybe<Scalars['Int']['output']>;
  train_number: Scalars['String']['output'];
  train_quantity?: Maybe<Scalars['Int']['output']>;
  trains_quantity_fact?: Maybe<Scalars['Int']['output']>;
  trains_quantity_plan?: Maybe<Scalars['Int']['output']>;
  trains_turnover_fact?: Maybe<Scalars['Int']['output']>;
  trains_turnover_plan?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type SchemaControlList = {
  __typename: 'SchemaControlList';
  items: Array<SchemaControlByTrainDto>;
  totalCount: Scalars['Float']['output'];
};

export type SchemaControlTrainDto = {
  __typename: 'SchemaControlTrainDto';
  end_at: Scalars['String']['output'];
  id?: Maybe<Scalars['Float']['output']>;
  start_at: Scalars['String']['output'];
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
  train_number: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type SchemaControlTrainList = {
  __typename: 'SchemaControlTrainList';
  items: Array<SchemaControlTrainDto>;
  totalCount: Scalars['Float']['output'];
};

export type SchemaControlTrainNmrvagDto = {
  __typename: 'SchemaControlTrainNmrvagDto';
  /** филиал */
  branch?: Maybe<BranchDto>;
  date_sync: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  is_s3960_loaded: Scalars['Boolean']['output'];
  schema_carriage_quantity?: Maybe<Scalars['Int']['output']>;
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
  train_number: Scalars['String']['output'];
};

export type SchemaControlTrainNmrvagList = {
  __typename: 'SchemaControlTrainNmrvagList';
  items: Array<ControlSchemaTrainNmrvagDto>;
  totalCount: Scalars['Float']['output'];
};

export type SchemaControlTrainNmrvagListDto = {
  __typename: 'SchemaControlTrainNmrvagListDto';
  items: Array<SchemaControlTrainNmrvagDto>;
  totalCount: Scalars['Float']['output'];
};

export type SchemaControlTrainPreSavedDto = {
  __typename: 'SchemaControlTrainPreSavedDto';
  /** филиал */
  branch?: Maybe<BranchDto>;
  /** Кол. вагонов */
  carriage_quantity?: Maybe<Scalars['Int']['output']>;
  /** Кол вагонов факт */
  carriages_quantity_fact?: Maybe<Scalars['Int']['output']>;
  /** Кол вагонов план */
  carriages_quantity_plan?: Maybe<Scalars['Int']['output']>;
  /** Вагонооборот факт */
  carriages_turnover_fact?: Maybe<Scalars['Int']['output']>;
  /** Вагонооборот план */
  carriages_turnover_plan?: Maybe<Scalars['Int']['output']>;
  dates: Array<ControlSchemaPreSavedDates>;
  /** Ср состав факт */
  indicators_fact?: Maybe<Scalars['Float']['output']>;
  /** Ср состав план */
  indicators_plan?: Maybe<Scalars['Int']['output']>;
  /** Кол мест факт */
  seats_quantity_fact?: Maybe<Scalars['Int']['output']>;
  /** Кол мест план */
  seats_quantity_plan?: Maybe<Scalars['Int']['output']>;
  /** Местооборот факт */
  seats_turnover_fact?: Maybe<Scalars['Int']['output']>;
  /** Местооборот план */
  seats_turnover_plan?: Maybe<Scalars['Int']['output']>;
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
  train?: Maybe<TrainDto>;
  train_number: Scalars['String']['output'];
  /** Количество составов */
  train_quantity?: Maybe<Scalars['Int']['output']>;
  /** Отправлено поездов факт */
  trains_quantity_fact?: Maybe<Scalars['Int']['output']>;
  /** Отправлено поездов план */
  trains_quantity_plan?: Maybe<Scalars['Int']['output']>;
  /** Поездооборот факт */
  trains_turnover_fact?: Maybe<Scalars['Int']['output']>;
  /** Поездооборот план */
  trains_turnover_plan?: Maybe<Scalars['Int']['output']>;
};

export type SchemaControlTrainPreSavedList = {
  __typename: 'SchemaControlTrainPreSavedList';
  items: Array<SchemaControlTrainPreSavedDto>;
  totalCount: Scalars['Float']['output'];
};

export type SeatsDto = {
  __typename: 'SeatsDto';
  /** Свободные места */
  count?: Maybe<Scalars['Int']['output']>;
  /** Дата YYYY-MM-DD */
  date?: Maybe<Scalars['String']['output']>;
  /** макс стоимость билета */
  max_price?: Maybe<Scalars['Float']['output']>;
  /** мин стоимость билета */
  min_price?: Maybe<Scalars['Float']['output']>;
};

export type SessionInformationDto = {
  __typename: 'SessionInformationDto';
  browser: Scalars['String']['output'];
  date: Scalars['String']['output'];
  ip: Scalars['String']['output'];
  os: Scalars['String']['output'];
  sid: Scalars['String']['output'];
};

export type SessionInformationList = {
  __typename: 'SessionInformationList';
  items: Array<SessionInformationDto>;
  totalCount: Scalars['Float']['output'];
};

export type SignInRequestDto = {
  /** Авторизация производится через лдап или нет */
  isLdapAuth: Scalars['Boolean']['input'];
  /** Пароль пользователя */
  password: Scalars['String']['input'];
  /** Логин пользователя */
  user_name: Scalars['String']['input'];
};

export type SortType =
  | 'ASC'
  | 'ASC_NULLS_FIRST'
  | 'ASC_NULLS_LAST'
  | 'DESC'
  | 'DESC_NULLS_FIRST'
  | 'DESC_NULLS_LAST';

export type SpreadBlockToAllSchemasRequestDto = {
  /** asd */
  block: Scalars['String']['input'];
  trainIds: Array<Scalars['Int']['input']>;
  trainSchemaId: Scalars['Int']['input'];
};

export type StationDto = {
  __typename: 'StationDto';
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  /** Код станции ЕСР */
  esr_code?: Maybe<Scalars['String']['output']>;
  /** Код станции Экспресс  */
  express_code: Scalars['String']['output'];
  /** Полное наименование станции */
  full_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Идентификатор внешнего объекта ЦСУ */
  id_external?: Maybe<Scalars['Int']['output']>;
  /** Возможность посадки/высадки пассажиров */
  is_board_or_disembark: Scalars['Boolean']['output'];
  /** Осуществление пограничного и таможенного контроля */
  is_border_control: Scalars['Boolean']['output'];
  /** Смена локомотива */
  is_change_locomotive: Scalars['Boolean']['output'];
  /** Смена локомотивной бригады без смены локомотива */
  is_change_locomotive_team: Scalars['Boolean']['output'];
  /** Флаг города для топовых направлений */
  is_city: Scalars['Boolean']['output'];
  /** Обслуживание экологически чистых туалетных комплексов (ЭЧТК) */
  is_eco_toilets: Scalars['Boolean']['output'];
  /** Наличие электрических колонок 380В */
  is_electric_speakers_380V: Scalars['Boolean']['output'];
  /** Наличие электрических колонок 3000В */
  is_electric_speakers_3000V: Scalars['Boolean']['output'];
  /** Смена рода тока по станции (постоянный/переменный) */
  is_electricity_type: Scalars['Boolean']['output'];
  /** Снабжение топливом */
  is_fuel_supply: Scalars['Boolean']['output'];
  /** станция разрешённая для маневровой работы */
  is_maneuver_work: Scalars['Boolean']['output'];
  /** Флаг "Вокзал не принадлежит РЖД" */
  is_not_terminal_rgd: Scalars['Boolean']['output'];
  /** Является ли станция маршрутообразующей */
  is_route_forming: Scalars['Boolean']['output'];
  /** Обслуживание не по маршруту поезда */
  is_service_not_train_route: Scalars['Boolean']['output'];
  /** Флаг "Южное направление" */
  is_southbound: Scalars['Boolean']['output'];
  /** Смена вида тяги по станции (электровозная/тепловозная) */
  is_traction_type: Scalars['Boolean']['output'];
  /** Сбор твёрдых бытовых отходов (ТБО) и шлака */
  is_waste_collection: Scalars['Boolean']['output'];
  /** Снабжение водой */
  is_water_supply: Scalars['Boolean']['output'];
  last_version: LatestVersionDataDto;
  /** Наименование станции для схемы */
  name_for_schema?: Maybe<Scalars['String']['output']>;
  railway: RailwayDto;
  /** ID railway */
  railway_id: Scalars['Int']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type StationDtoList = {
  __typename: 'StationDtoList';
  items: Array<StationDto>;
  totalCount: Scalars['Float']['output'];
};

export type StationMutationEntryPoint = {
  __typename: 'StationMutationEntryPoint';
  /** Создание станции */
  create: StationDto;
  /** Обновление станции */
  update: StationDto;
  /** Обновление версии станции */
  updateNameForSchema: StationDto;
  /** Обновление версии станции */
  updateVersion: StationDto;
};


export type StationMutationEntryPointCreateArgs = {
  data: CreateStationDto;
};


export type StationMutationEntryPointUpdateArgs = {
  data: UpdateStationDto;
};


export type StationMutationEntryPointUpdateNameForSchemaArgs = {
  data: UpdateStationNameDto;
};


export type StationMutationEntryPointUpdateVersionArgs = {
  data: UpdateStationVersionDto;
};

export type StationQueryEntryPoint = {
  __typename: 'StationQueryEntryPoint';
  /** Станция по entity_id */
  byEntityId: StationDto;
  /** Список изменений станции */
  history: StationDtoList;
  /** Список станций */
  list: StationDtoList;
};


export type StationQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type StationQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<StationQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type StationQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<StationQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<StationQueryResolver_List_FilterInputType>;
};

export type StationQueryResolver_History_SortingInputType = {
  comment?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  esr_code?: InputMaybe<SortType>;
  express_code?: InputMaybe<SortType>;
  full_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  id_external?: InputMaybe<SortType>;
  is_board_or_disembark?: InputMaybe<SortType>;
  is_border_control?: InputMaybe<SortType>;
  is_change_locomotive?: InputMaybe<SortType>;
  is_change_locomotive_team?: InputMaybe<SortType>;
  is_city?: InputMaybe<SortType>;
  is_eco_toilets?: InputMaybe<SortType>;
  is_electric_speakers_380V?: InputMaybe<SortType>;
  is_electric_speakers_3000V?: InputMaybe<SortType>;
  is_electricity_type?: InputMaybe<SortType>;
  is_fuel_supply?: InputMaybe<SortType>;
  is_maneuver_work?: InputMaybe<SortType>;
  is_not_terminal_rgd?: InputMaybe<SortType>;
  is_route_forming?: InputMaybe<SortType>;
  is_service_not_train_route?: InputMaybe<SortType>;
  is_southbound?: InputMaybe<SortType>;
  is_traction_type?: InputMaybe<SortType>;
  is_waste_collection?: InputMaybe<SortType>;
  is_water_supply?: InputMaybe<SortType>;
  name_for_schema?: InputMaybe<SortType>;
  railway_id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type StationQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<StationQueryResolver_List_BaseFilterInputType>>;
  comment?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  esr_code?: InputMaybe<String_PropertyFilterInputType>;
  express_code?: InputMaybe<String_PropertyFilterInputType>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  id_external?: InputMaybe<Int_PropertyFilterInputType>;
  is_board_or_disembark?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_border_control?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_change_locomotive?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_change_locomotive_team?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_city?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_eco_toilets?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_electric_speakers_380V?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_electric_speakers_3000V?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_electricity_type?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_fuel_supply?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_maneuver_work?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_not_terminal_rgd?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_route_forming?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_service_not_train_route?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_traction_type?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_waste_collection?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_water_supply?: InputMaybe<Boolean_PropertyFilterInputType>;
  name_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<StationQueryResolver_List_BaseFilterInputType>>;
  railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StationQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<StationQueryResolver_List_BaseFilterInputType>>;
  comment?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  esr_code?: InputMaybe<String_PropertyFilterInputType>;
  express_code?: InputMaybe<String_PropertyFilterInputType>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  id_external?: InputMaybe<Int_PropertyFilterInputType>;
  is_board_or_disembark?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_border_control?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_change_locomotive?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_change_locomotive_team?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_city?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_eco_toilets?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_electric_speakers_380V?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_electric_speakers_3000V?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_electricity_type?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_fuel_supply?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_maneuver_work?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_not_terminal_rgd?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_route_forming?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_service_not_train_route?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_traction_type?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_waste_collection?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_water_supply?: InputMaybe<Boolean_PropertyFilterInputType>;
  name_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<StationQueryResolver_List_BaseFilterInputType>>;
  railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StationQueryResolver_List_SortingInputType = {
  comment?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  esr_code?: InputMaybe<SortType>;
  express_code?: InputMaybe<SortType>;
  full_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  id_external?: InputMaybe<SortType>;
  is_board_or_disembark?: InputMaybe<SortType>;
  is_border_control?: InputMaybe<SortType>;
  is_change_locomotive?: InputMaybe<SortType>;
  is_change_locomotive_team?: InputMaybe<SortType>;
  is_city?: InputMaybe<SortType>;
  is_eco_toilets?: InputMaybe<SortType>;
  is_electric_speakers_380V?: InputMaybe<SortType>;
  is_electric_speakers_3000V?: InputMaybe<SortType>;
  is_electricity_type?: InputMaybe<SortType>;
  is_fuel_supply?: InputMaybe<SortType>;
  is_maneuver_work?: InputMaybe<SortType>;
  is_not_terminal_rgd?: InputMaybe<SortType>;
  is_route_forming?: InputMaybe<SortType>;
  is_service_not_train_route?: InputMaybe<SortType>;
  is_southbound?: InputMaybe<SortType>;
  is_traction_type?: InputMaybe<SortType>;
  is_waste_collection?: InputMaybe<SortType>;
  is_water_supply?: InputMaybe<SortType>;
  name_for_schema?: InputMaybe<SortType>;
  railway_id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type StationResponseDto = {
  __typename: 'StationResponseDto';
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  /** Код станции ЕСР */
  esr_code?: Maybe<Scalars['String']['output']>;
  /** Код станции Экспресс  */
  express_code: Scalars['String']['output'];
  /** Полное наименование станции */
  full_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Возможность посадки/высадки пассажиров */
  is_board_or_disembark: Scalars['Boolean']['output'];
  /** Осуществление пограничного и таможенного контроля */
  is_border_control: Scalars['Boolean']['output'];
  /** Смена локомотива */
  is_change_locomotive: Scalars['Boolean']['output'];
  /** Смена локомотивной бригады без смены локомотива */
  is_change_locomotive_team: Scalars['Boolean']['output'];
  /** Обслуживание экологически чистых туалетных комплексов (ЭЧТК) */
  is_eco_toilets: Scalars['Boolean']['output'];
  /** Наличие электрических колонок 380В */
  is_electric_speakers_380V: Scalars['Boolean']['output'];
  /** Наличие электрических колонок 3000В */
  is_electric_speakers_3000V: Scalars['Boolean']['output'];
  /** Смена рода тока по станции (постоянный/переменный) */
  is_electricity_type: Scalars['Boolean']['output'];
  /** Снабжение топливом */
  is_fuel_supply: Scalars['Boolean']['output'];
  /** станция разрешённая для маневровой работы */
  is_maneuver_work: Scalars['Boolean']['output'];
  /** Является ли станция маршрутообразующей */
  is_route_forming: Scalars['Boolean']['output'];
  /** Обслуживание не по маршруту поезда */
  is_service_not_train_route: Scalars['Boolean']['output'];
  /** Смена вида тяги по станции (электровозная/тепловозная) */
  is_traction_type: Scalars['Boolean']['output'];
  /** Сбор твёрдых бытовых отходов (ТБО) и шлака */
  is_waste_collection: Scalars['Boolean']['output'];
  /** Снабжение водой */
  is_water_supply: Scalars['Boolean']['output'];
  /** ЖД */
  railway?: Maybe<RailwayResponseDto>;
  /** ID railway */
  railway_id: Scalars['Int']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type String_PropertyFilterInputType = {
  /** Наименование */
  between?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Наименование */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  gte?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Наименование */
  in_arr?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Наименование */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  notbetween?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Наименование */
  notin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Наименование */
  notlike?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StructuralSubdivisionByBranchDto = {
  __typename: 'StructuralSubdivisionByBranchDto';
  /** распределение по филиалам */
  items: Array<StructuralSubdivisionByBranchItemDto>;
  /** название */
  name: Scalars['String']['output'];
};

export type StructuralSubdivisionByBranchItemDto = {
  __typename: 'StructuralSubdivisionByBranchItemDto';
  /** филиал */
  branch: Scalars['String']['output'];
  /** количество */
  quantity: Scalars['Float']['output'];
};

export type StructuralSubdivisionDto = {
  __typename: 'StructuralSubdivisionDto';
  branch: BranchDto;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  /** Краткое наименование структурного подразделения */
  short_name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  station: StationDto;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type StructuralSubdivisionList = {
  __typename: 'StructuralSubdivisionList';
  items: Array<StructuralSubdivisionDto>;
  totalCount: Scalars['Float']['output'];
};

export type StructuralSubdivisionMutationEntryPoint = {
  __typename: 'StructuralSubdivisionMutationEntryPoint';
  /** Создание структурного подразделения */
  create: StructuralSubdivisionDto;
  /** Обновление структурного подразделения */
  update: StructuralSubdivisionDto;
};


export type StructuralSubdivisionMutationEntryPointCreateArgs = {
  data: CreateStructuralSubdivisionDto;
};


export type StructuralSubdivisionMutationEntryPointUpdateArgs = {
  data: UpdateStructuralSubdivisionDto;
};

export type StructuralSubdivisionQueryEntryPoint = {
  __typename: 'StructuralSubdivisionQueryEntryPoint';
  /** Структурное подразделение по id */
  byEntityId?: Maybe<StructuralSubdivisionDto>;
  /** Количество предприятий по филиалам */
  countSubdivisionsByBranch: Array<StructuralSubdivisionByBranchDto>;
  /** Список изменений структурного подразделения */
  history: StructuralSubdivisionList;
  /** Список структурных подразделений */
  list: StructuralSubdivisionList;
};


export type StructuralSubdivisionQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type StructuralSubdivisionQueryEntryPointCountSubdivisionsByBranchArgs = {
  where?: InputMaybe<StructuralSubdivisionQueryResolver_CountSubdivisionsByBranch_FilterInputType>;
};


export type StructuralSubdivisionQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<StructuralSubdivisionQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type StructuralSubdivisionQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<StructuralSubdivisionQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<StructuralSubdivisionQueryResolver_List_FilterInputType>;
};

export type StructuralSubdivisionQueryResolver_CountSubdivisionsByBranch_BaseFilterInputType = {
  and?: InputMaybe<Array<StructuralSubdivisionQueryResolver_CountSubdivisionsByBranch_BaseFilterInputType>>;
  branch_id?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<StructuralSubdivisionQueryResolver_CountSubdivisionsByBranch_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  station_id?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StructuralSubdivisionQueryResolver_CountSubdivisionsByBranch_FilterInputType = {
  and?: InputMaybe<Array<StructuralSubdivisionQueryResolver_CountSubdivisionsByBranch_BaseFilterInputType>>;
  branch_id?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<StructuralSubdivisionQueryResolver_CountSubdivisionsByBranch_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  station_id?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StructuralSubdivisionQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type StructuralSubdivisionQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<StructuralSubdivisionQueryResolver_List_BaseFilterInputType>>;
  branch_id?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<StructuralSubdivisionQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  station_id?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StructuralSubdivisionQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<StructuralSubdivisionQueryResolver_List_BaseFilterInputType>>;
  branch_id?: InputMaybe<Number_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<StructuralSubdivisionQueryResolver_List_BaseFilterInputType>>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  station_id?: InputMaybe<Number_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StructuralSubdivisionQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type SubdivisionsDto = {
  __typename: 'SubdivisionsDto';
  /** Количество */
  count: Scalars['Int']['output'];
  /** Наименование ключа для фильтра для отображения */
  entity_rus_name: Scalars['String']['output'];
  /** ID */
  ids: Array<Scalars['Int']['output']>;
  /** Количество предприятий ЛВЧ */
  lvch_count: Scalars['Float']['output'];
  /** Количество предприятий ЛВЧД */
  lvchd_count: Scalars['Float']['output'];
};

export type Subscription = {
  __typename: 'Subscription';
  notification__user: UserMessageDto;
};

export type SyncQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<SyncQueryResolver_List_BaseFilterInputType>>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<SyncQueryResolver_List_BaseFilterInputType>>;
  status?: InputMaybe<String_PropertyFilterInputType>;
};

export type SyncQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<SyncQueryResolver_List_BaseFilterInputType>>;
  date?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<SyncQueryResolver_List_BaseFilterInputType>>;
  status?: InputMaybe<String_PropertyFilterInputType>;
};

export type SyncQueryResolver_List_SortingInputType = {
  date?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
};

export type SyncSeatsAvailabilityDto = {
  /** Дата */
  from_date: Scalars['String']['input'];
  /** id направления */
  rcasd_id: Scalars['Float']['input'];
  /** Дата */
  to_date: Scalars['String']['input'];
};

export type TableBlockDto = {
  __typename: 'TableBlockDto';
  /** Приписка */
  affiliation: Scalars['String']['output'];
  /** УКВ */
  air_conditioner: Scalars['String']['output'];
  /** Тормоза */
  break: Scalars['String']['output'];
  carriage_group: CarriageGroupDto;
  /** Идентификатор ГВ, к которой относятся данные вагоны */
  carriage_group_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** ЭЧТК */
  eco_toilet: Scalars['String']['output'];
  /** Отопление */
  heat: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Трафарет для строки В общем обороте с формата ID/ID, ID, ID/ID */
  in_common_circulation_with: Scalars['String']['output'];
  /** В общем обороте с */
  in_common_circulation_with_trains?: Maybe<Array<TrainDto>>;
  /** Принята ли группа в схеме */
  is_accepted: Scalars['Boolean']['output'];
  /** Составной ли блок из двух блоков */
  is_collapsed: Scalars['Boolean']['output'];
  /** Составной ли блок из двух блоков системно */
  is_collapsed_automatically: Scalars['Boolean']['output'];
  /** Составной ли блок из двух блоков вручную */
  is_collapsed_manually: Scalars['Boolean']['output'];
  /** Исключен ли данный блок из отображения в выгрузке схемы в excel */
  is_excluded_from_export: Scalars['Boolean']['output'];
  /** Исключен ли данный блок из расчётов итоговых показателей таблицы схемы */
  is_excluded_from_table_calculations: Scalars['Boolean']['output'];
  /** Относится ли этот блок к гв с признаком О */
  is_main_group: Scalars['Boolean']['output'];
  /** Порядковый номер */
  order_number: Scalars['Int']['output'];
  table_block_rows: Array<TableBlockRowDto>;
  /** Количество составов */
  train_quantity: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TableBlockRowDto = {
  __typename: 'TableBlockRowDto';
  /** Номер вагона */
  carriage_number: Scalars['String']['output'];
  /** Тип вагона по местам для отображения в схеме */
  carriage_seat_type: Scalars['String']['output'];
  /** Тип вагона */
  carriage_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Порядковый номер */
  order_number: Scalars['Int']['output'];
  /** Количество мест выделенных */
  seats_allocated?: Maybe<Scalars['Int']['output']>;
  /** Количество мест */
  seats_quantity?: Maybe<Scalars['Int']['output']>;
  stations: Array<StationDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TableDto = {
  __typename: 'TableDto';
  /** Общих мест всего выделено */
  common_allocated_total?: Maybe<Scalars['Int']['output']>;
  /** Общих мест всего */
  common_total?: Maybe<Scalars['Int']['output']>;
  /** Купе мест всего выделено */
  coupe_allocated_total?: Maybe<Scalars['Int']['output']>;
  /** Купе мест всего */
  coupe_total?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Для какого направления */
  direction: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Отсортированы ли блоки вручную */
  is_manually_sorted: Scalars['Boolean']['output'];
  /** Плацкарт мест всего выделено */
  second_class_allocated_total?: Maybe<Scalars['Int']['output']>;
  /** Плацкарт мест всего */
  second_class_total?: Maybe<Scalars['Int']['output']>;
  /** СВ мест выделено всего */
  sv_allocated_total?: Maybe<Scalars['Int']['output']>;
  /** СВ мест всего */
  sv_total?: Maybe<Scalars['Int']['output']>;
  table_blocks: Array<TableBlockDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TokenResponseDto = {
  __typename: 'TokenResponseDto';
  /** Таймстемп аксес токена */
  accessTokenExpTimestamp: Scalars['Float']['output'];
  /** Рефреш токен */
  refreshToken: Scalars['String']['output'];
};

export type TotalCostsDto = {
  __typename: 'TotalCostsDto';
  /** Стоимость локомотива за рейс */
  total_locomotive_cost: Scalars['String']['output'];
  /** Стоимость услуг лок бригады за рейс */
  total_locomotive_team_cost: Scalars['String']['output'];
};

export type TotalTrainDto = {
  __typename: 'TotalTrainDto';
  /** Наименование ключа для фильтра для отображения */
  entity_rus_name: Scalars['String']['output'];
  /** Внутренние данные для всего и сезонностей */
  into_train_info: IntoTrainInfoDto;
  /** ID поездов - главных в паре */
  main_train_ids: Array<Scalars['Int']['output']>;
  /** Количество пар поездов */
  pairs_count: Scalars['Int']['output'];
};

export type TpcMutationEntryPoint = {
  __typename: 'TpcMutationEntryPoint';
  /** Контроль наличия свободных мест по направлениям */
  control_availability_seats: ControlAvailabilitySeatsMutationEntryPoint;
  /** Контроль схем */
  control_schema: ControlSchemaMutationEntryPoint;
};

export type TpcQueryEntryPoint = {
  __typename: 'TpcQueryEntryPoint';
  /** Местоположение вагонов */
  carriage_location: CarriageLocationQueryEntryPoint;
  /** Контроль наличия свободных мест по направлениям */
  control_availability_seats: ControlAvailabilitySeatsQueryEntryPoint;
  /** Контроль схем */
  control_schema: ControlSchemaQueryEntryPoint;
};

export type TractionDirectorateDto = {
  __typename: 'TractionDirectorateDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Флаг участия в расчетах ЛО */
  is_not_in_calculation: Scalars['Boolean']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  /** Название региональной дирекции тяги */
  name: Scalars['String']['output'];
  railway: RailwayDto;
  /** Краткое наименование региональной дирекции тяги */
  short_name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TractionDirectorateList = {
  __typename: 'TractionDirectorateList';
  items: Array<TractionDirectorateDto>;
  totalCount: Scalars['Float']['output'];
};

export type TractionDirectorateMutationEntryPoint = {
  __typename: 'TractionDirectorateMutationEntryPoint';
  /** Создание региональной дирекции тяги */
  create: TractionDirectorateDto;
  /** Обновление региональной дирекции тяги */
  update: TractionDirectorateDto;
};


export type TractionDirectorateMutationEntryPointCreateArgs = {
  data: CreateTractionDirectorateDto;
};


export type TractionDirectorateMutationEntryPointUpdateArgs = {
  data: UpdateTractionDirectorateDto;
};

export type TractionDirectorateQueryEntryPoint = {
  __typename: 'TractionDirectorateQueryEntryPoint';
  /** Региональная дирекция тяги по id */
  byEntityId: TractionDirectorateDto;
  /** Список изменений региональных дирекций тяги */
  history: TractionDirectorateList;
  /** Список региональных дирекций тяги */
  list: TractionDirectorateList;
};


export type TractionDirectorateQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type TractionDirectorateQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<TractionDirectorateQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type TractionDirectorateQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<TractionDirectorateQueryResolver_List_SortingInputType>>;
  paginate: PaginatorArgsDto;
  range: RangeInputDto;
  where?: InputMaybe<TractionDirectorateQueryResolver_List_FilterInputType>;
};

export type TractionDirectorateQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_not_in_calculation?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TractionDirectorateQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<TractionDirectorateQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_not_in_calculation?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TractionDirectorateQueryResolver_List_BaseFilterInputType>>;
  railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TractionDirectorateQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<TractionDirectorateQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_not_in_calculation?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TractionDirectorateQueryResolver_List_BaseFilterInputType>>;
  railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  short_name?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TractionDirectorateQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_not_in_calculation?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  short_name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TrailedCarriageDto = {
  __typename: 'TrailedCarriageDto';
  /** Номера вагонов */
  carriage_numbers: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  trailed_carriages_info: Array<TrailedCarriageInfoDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrailedCarriageInfoDto = {
  __typename: 'TrailedCarriageInfoDto';
  /** Массив дат прибытий на станцию */
  arrival_dates: Array<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Массив дат отправлений со станции */
  departure_dates: Array<Scalars['String']['output']>;
  from_station: StationDto;
  id: Scalars['Int']['output'];
  /** Массив дат прибытий на станцию, в которые поезд не ходит или выходят за рамки текущего ГДП */
  missed_arrival_dates: Array<Scalars['String']['output']>;
  /** Массив дат отправлений со станции, в которые поезд не ходит или выходят за рамки текущего ГДП */
  missed_departure_dates: Array<Scalars['String']['output']>;
  /** Расположение группы по отправлению */
  position_from_station: Scalars['String']['output'];
  /** Расположение группы по прибытию */
  position_to_station: Scalars['String']['output'];
  to_station: StationDto;
  train: TrainDto;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrailedDirectGroupDto = {
  __typename: 'TrailedDirectGroupDto';
  carriage_group: CarriageGroupDto;
  /** Идентификатор ГВ */
  carriage_group_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  direct_turnover_from: TurnoverDto;
  direct_turnover_to: TurnoverDto;
  id: Scalars['Int']['output'];
  /** Идентификатор сущности родителя */
  parent_id?: Maybe<Scalars['Int']['output']>;
  reverse_turnover_from: TurnoverDto;
  reverse_turnover_to: TurnoverDto;
  /** Вид подвижного состава */
  rolling_stock_type: Scalars['String']['output'];
  /** Идентификатор станции назначения (отцепки) группы */
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrailedDirectGroupListItemFragmentDto = {
  __typename: 'TrailedDirectGroupListItemFragmentDto';
  /** Станция отправления */
  station_from: StationResponseDto;
  /** Станции переприцепки */
  station_recouple: Array<Scalars['String']['output']>;
  /** Станция назначения */
  station_to: StationResponseDto;
  /** Время в пути */
  time_total: Scalars['Float']['output'];
  /** Номера поездов курсирования */
  train_numbers: Array<Scalars['String']['output']>;
};

export type TrailedDirectGroupListItemResponseDto = {
  __typename: 'TrailedDirectGroupListItemResponseDto';
  /** Группа вагонов */
  carriage_group: CarriageGroupDto;
  /** Состав группы */
  carriage_type_params_count: Array<CarriageGroupCarriageTypeParamsCountDto>;
  /** Количество вагонов */
  carriages_total: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** ПБГ прямого направления */
  direct: TrailedDirectGroupListItemFragmentDto;
  id: Scalars['Int']['output'];
  /** Идентификатор родительской сущности */
  parent_id?: Maybe<Scalars['Int']['output']>;
  /** ПБГ обратного направления */
  reverse: TrailedDirectGroupListItemFragmentDto;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrailedDirectGroupPeriodicityInfoDto = {
  __typename: 'TrailedDirectGroupPeriodicityInfoDto';
  arrival_dates: Array<Scalars['String']['output']>;
  departure_dates: Array<Scalars['String']['output']>;
  from_station: Scalars['String']['output'];
  is_direct: Scalars['Boolean']['output'];
  to_station: Scalars['String']['output'];
  /** Номер поезда */
  train_number: Scalars['String']['output'];
};

export type TrailedDirectGroupResponseDto = {
  __typename: 'TrailedDirectGroupResponseDto';
  /** Идентификатор ГВ */
  carriage_group_id: Scalars['Int']['output'];
  /** ГДП */
  gdp?: Maybe<GdpDto>;
  /** Идентификатор родительской сущности */
  parent_id?: Maybe<Scalars['Int']['output']>;
  /** Вид подвижного состава */
  rolling_stock_type: Scalars['String']['output'];
  route_details: TrailedDirectGroupRouteDetailsDto;
  schedule: TrailedDirectGroupScheduleDto;
  schema: TrailedDirectGroupSchemaDto;
  /** Идентификатор станции назначения (отцепки) группы */
  status: Scalars['String']['output'];
};

export type TrailedDirectGroupResponseList = {
  __typename: 'TrailedDirectGroupResponseList';
  items: Array<TrailedDirectGroupListItemResponseDto>;
  totalCount: Scalars['Float']['output'];
};

export type TrailedDirectGroupRouteDetailsDto = {
  __typename: 'TrailedDirectGroupRouteDetailsDto';
  direct: Array<TrailedDirectGroupRouteDetailsItemDto>;
  reverse: Array<TrailedDirectGroupRouteDetailsItemDto>;
};

export type TrailedDirectGroupRouteDetailsItemDto = {
  __typename: 'TrailedDirectGroupRouteDetailsItemDto';
  position: Scalars['String']['output'];
  station_from: Scalars['String']['output'];
  station_to: Scalars['String']['output'];
  train_id: Scalars['Int']['output'];
  train_number: Scalars['String']['output'];
};

export type TrailedDirectGroupScheduleDto = {
  __typename: 'TrailedDirectGroupScheduleDto';
  /** Время в пути для прямого направления */
  direct_time_total: Scalars['Float']['output'];
  /** Время в пути для обратного направления */
  reverse_time_total: Scalars['Float']['output'];
  /** Массив строк расписания */
  schedule_fragments: Array<TrailedDirectGroupScheduleFragmentDto>;
};

export type TrailedDirectGroupScheduleFragmentDto = {
  __typename: 'TrailedDirectGroupScheduleFragmentDto';
  /** Прибытие */
  direct_arrival?: Maybe<Scalars['Float']['output']>;
  /** Отправление */
  direct_departure?: Maybe<Scalars['Float']['output']>;
  /** Стоянка */
  direct_parking?: Maybe<Scalars['Float']['output']>;
  /** Номер поезда */
  direct_train_id?: Maybe<Scalars['Int']['output']>;
  /** Номер поезда из шапки для группировки блоков */
  direct_train_number?: Maybe<Scalars['String']['output']>;
  /** Номер поезда для смены внутри сгруппированного блока */
  direct_train_number_from_schedule?: Maybe<Scalars['String']['output']>;
  /** Маршрут следования поезда из шапки для группировки блоков */
  direct_train_stations?: Maybe<Scalars['String']['output']>;
  /** Дистанция */
  distance: Scalars['Float']['output'];
  is_direct_schedule_technical_parking?: Maybe<Scalars['Boolean']['output']>;
  is_reverse_schedule_technical_parking?: Maybe<Scalars['Boolean']['output']>;
  /** Порядковый номер */
  order_number: Scalars['Int']['output'];
  /** Прибытие */
  reverse_arrival?: Maybe<Scalars['Float']['output']>;
  /** Отправление */
  reverse_departure?: Maybe<Scalars['Float']['output']>;
  /** Стоянка */
  reverse_parking?: Maybe<Scalars['Float']['output']>;
  /** Номер поезда */
  reverse_train_id?: Maybe<Scalars['Int']['output']>;
  /** Номер поезда из шапки для группировки блоков */
  reverse_train_number?: Maybe<Scalars['String']['output']>;
  /** Номер поезда для смены внутри сгруппированного блока */
  reverse_train_number_from_schedule?: Maybe<Scalars['String']['output']>;
  /** Маршрут следования поезда из шапки для группировки блоков */
  reverse_train_stations?: Maybe<Scalars['String']['output']>;
  /** Станция */
  station: StationResponseDto;
};

export type TrailedDirectGroupSchemaAdditionalInfoDto = {
  __typename: 'TrailedDirectGroupSchemaAdditionalInfoDto';
  /** УКВ */
  air_conditioner?: Maybe<Scalars['String']['output']>;
  /** Тормоза */
  brake_types?: Maybe<Array<Scalars['String']['output']>>;
  /** ЭЧТК */
  eco_toilets?: Maybe<Scalars['String']['output']>;
  /** Отопление */
  heating_types?: Maybe<Array<Scalars['String']['output']>>;
  /** Приписка */
  structural_subdivision: Scalars['String']['output'];
  /** Количество составов */
  train_quantity?: Maybe<Scalars['Int']['output']>;
};

export type TrailedDirectGroupSchemaCarriageDto = {
  __typename: 'TrailedDirectGroupSchemaCarriageDto';
  /** Номер вагона */
  carriage_number: Scalars['String']['output'];
  /** Тип вагона */
  carriage_type: Scalars['String']['output'];
  /** Мест общих выделено */
  seats_common_allocated: Scalars['Int']['output'];
  /** Мест общих */
  seats_common_total: Scalars['Int']['output'];
  /** Мест купе выделено */
  seats_coupe_allocated: Scalars['Int']['output'];
  /** Мест купе */
  seats_coupe_total: Scalars['Int']['output'];
  /** Мест плацкартных выделено */
  seats_second_class_allocated: Scalars['Int']['output'];
  /** Мест плацкартных */
  seats_second_class_total: Scalars['Int']['output'];
  /** Мест СВ выделено */
  seats_sv_allocated: Scalars['Int']['output'];
  /** Мест СВ */
  seats_sv_total: Scalars['Int']['output'];
  /** Пункты обращения вагона */
  turnover_points: Array<Scalars['String']['output']>;
};

export type TrailedDirectGroupSchemaDto = {
  __typename: 'TrailedDirectGroupSchemaDto';
  /** Дополнительная информация */
  additional_info: TrailedDirectGroupSchemaAdditionalInfoDto;
  /** Параметры вагонов */
  parameters: Array<TrailedDirectGroupSchemaCarriageDto>;
  /** Периодичность */
  periodicity_info: Array<TrailedDirectGroupPeriodicityInfoDto>;
  /** Итого */
  summary: TrailedDirectGroupSchemaSummaryDto;
};

export type TrailedDirectGroupSchemaSummaryDto = {
  __typename: 'TrailedDirectGroupSchemaSummaryDto';
  /** Количество общих мест выделено */
  seats_common_allocated: Scalars['Int']['output'];
  /** Количество общих мест */
  seats_common_total: Scalars['Int']['output'];
  /** Количество купейных мест выделено */
  seats_coupe_allocated: Scalars['Int']['output'];
  /** Количество купейных мест */
  seats_coupe_total: Scalars['Int']['output'];
  /** Количество плацкартных мест выделено */
  seats_second_class_allocated: Scalars['Int']['output'];
  /** Количество плацкартных мест */
  seats_second_class_total: Scalars['Int']['output'];
  /** Итоговое количество выделенных мест */
  seats_summary_allocated: Scalars['Int']['output'];
  /** Итоговое количество мест */
  seats_summary_total: Scalars['Int']['output'];
  /** Количество мест СВ выделено */
  seats_sv_allocated: Scalars['Int']['output'];
  /** Количество мест СВ */
  seats_sv_total: Scalars['Int']['output'];
};

export type TrainBrandDto = {
  __typename: 'TrainBrandDto';
  /** Цвет наименования */
  background_color: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  start_at: Scalars['String']['output'];
  /** Наименование */
  train_brand: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainBrandList = {
  __typename: 'TrainBrandList';
  items: Array<TrainBrandDto>;
  totalCount: Scalars['Float']['output'];
};

export type TrainBrandMutationEntryPoint = {
  __typename: 'TrainBrandMutationEntryPoint';
  /** Добавить фирменность поезда */
  create: TrainBrandDto;
  /** Обновить фирменность поезда */
  update: TrainBrandDto;
  /** Обновить цвет фирменноси поезда */
  updateColor: TrainBrandList;
};


export type TrainBrandMutationEntryPointCreateArgs = {
  data: CreateTrainBrandDto;
};


export type TrainBrandMutationEntryPointUpdateArgs = {
  data: UpdateTrainBrandDto;
};


export type TrainBrandMutationEntryPointUpdateColorArgs = {
  data: UpdateColorTrainBrandDto;
};

export type TrainBrandQueryEntryPoint = {
  __typename: 'TrainBrandQueryEntryPoint';
  /** Фирменность поезда по id */
  byEntityId: TrainBrandDto;
  /** Список изменений фирмености поезда */
  history: TrainBrandList;
  /** Список фирменность поезда */
  list: TrainBrandList;
};


export type TrainBrandQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type TrainBrandQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<TrainBrandQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type TrainBrandQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<TrainBrandQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<TrainBrandQueryResolver_List_FilterInputType>;
};

export type TrainBrandQueryResolver_History_SortingInputType = {
  background_color?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  train_brand?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TrainBrandQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<TrainBrandQueryResolver_List_BaseFilterInputType>>;
  background_color?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainBrandQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  train_brand?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainBrandQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<TrainBrandQueryResolver_List_BaseFilterInputType>>;
  background_color?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainBrandQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  train_brand?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainBrandQueryResolver_List_SortingInputType = {
  background_color?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  train_brand?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TrainCategoryDto = {
  __typename: 'TrainCategoryDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  start_at: Scalars['String']['output'];
  /** Категория поезда */
  train_category: Scalars['String']['output'];
  train_sub_categories: Array<TrainSubCategoryDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainCategoryList = {
  __typename: 'TrainCategoryList';
  items: Array<TrainCategoryDto>;
  totalCount: Scalars['Float']['output'];
};

export type TrainCategoryMutationEntryPoint = {
  __typename: 'TrainCategoryMutationEntryPoint';
  /** Создать категорию поезда */
  create: TrainCategoryDto;
  /**  Обновить категорию поезда */
  update: TrainCategoryDto;
};


export type TrainCategoryMutationEntryPointCreateArgs = {
  data: CreateTrainCategoryDto;
};


export type TrainCategoryMutationEntryPointUpdateArgs = {
  data: UpdateTrainCategoryDto;
};

export type TrainCategoryQueryEntryPoint = {
  __typename: 'TrainCategoryQueryEntryPoint';
  /** Категория поезда по id */
  byEntityId: TrainCategoryDto;
  /** Список изменений категории поезда */
  history: TrainCategoryList;
  /** Список категорий поездов */
  list: TrainCategoryList;
};


export type TrainCategoryQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type TrainCategoryQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<TrainCategoryQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type TrainCategoryQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<TrainCategoryQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<TrainCategoryQueryResolver_List_FilterInputType>;
};

export type TrainCategoryQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  train_category?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TrainCategoryQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<TrainCategoryQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainCategoryQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  train_category?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainCategoryQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<TrainCategoryQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainCategoryQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  train_category?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainCategoryQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  train_category?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TrainChangeDirectionDto = {
  __typename: 'TrainChangeDirectionDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  /** Направление */
  direction: Scalars['String']['output'];
  for_station: StationDto;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainCountDto = {
  __typename: 'TrainCountDto';
  item: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
};

export type TrainDto = {
  __typename: 'TrainDto';
  /** Идентификаторы активных подразделений */
  active_subdivision_ids: Array<Scalars['Int']['output']>;
  /** Время прибытия */
  arrival_time?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<BranchDto>;
  /** Идентификатор филиала */
  branch_id?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<TrainCategoryDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Идентификаторы отклонивших подразделений */
  decline_subdivision_ids: Array<Scalars['Int']['output']>;
  /** Время отправления */
  departure_time?: Maybe<Scalars['String']['output']>;
  end_at: Scalars['String']['output'];
  /** Идентификатор поезда как сущности */
  entity_id: Scalars['Int']['output'];
  /** Идентификатор первой дороги на территории РЖД */
  from_rzd_railway_id?: Maybe<Scalars['Float']['output']>;
  /** Идентификатор первой станции на территории РЖД */
  from_rzd_station_id?: Maybe<Scalars['Float']['output']>;
  from_station: StationDto;
  /** Идентификатор станции отправления */
  from_station_id: Scalars['Int']['output'];
  gdp: GdpDto;
  /** Идентификатор гдп */
  gdp_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Индивидуальное наименование */
  individual_name: Scalars['String']['output'];
  /** Принадлежность к зарубежью - мнемоника */
  international_mnemonic?: Maybe<Scalars['String']['output']>;
  /** Основная группа для согласования */
  is_carriage_group_approval: Scalars['Boolean']['output'];
  /** Является ли поезд "Дневным" */
  is_daytime: Scalars['Boolean']['output'];
  /** Является ли поезд прямым */
  is_direct: Scalars['Boolean']['output'];
  /** дополнительный признак, который отображает несёт ли АО «ФПК» расходы на оплату услуг инфраструктуры */
  is_excluded_from_calculation_infrastructure_cost: Scalars['Boolean']['output'];
  /** Выводится ли в форму запроса */
  is_included_in_request_form: Scalars['Boolean']['output'];
  /** Является ли поезд межгосударственным */
  is_international: Scalars['Boolean']['output'];
  /** Является ли данный поезд последней версией в текущем ГДП */
  is_latest_version: Scalars['Boolean']['output'];
  /** Поезд редактируется */
  is_lock: Scalars['Boolean']['output'];
  /** Блокировка по статусу связанного поезда */
  is_lock_by_status: Scalars['Boolean']['output'];
  /** Является ли локомотивка актуальной */
  is_locomotive_actual: Scalars['Boolean']['output'];
  /** Является ли поезд главным */
  is_main: Scalars['Boolean']['output'];
  /** Помечен ли поезд к удалению */
  is_marked_to_delete: Scalars['Boolean']['output'];
  /** Выводится ли периодичность поездв в форме запроса отдельно по каждой схеме */
  is_periodicity_separate_request_form: Scalars['Boolean']['output'];
  /** Расписание для согласования */
  is_schedule_approval: Scalars['Boolean']['output'];
  /** Схема для согласования */
  is_schema_approval: Scalars['Boolean']['output'];
  /** Является ли поездом "Южного направления" */
  is_southbound: Scalars['Boolean']['output'];
  /** ТОЛЬКО ДЛЯ byId запросов */
  last_version: RangeDto;
  /** Пользовать заблокировавший поезд */
  lock_user?: Maybe<UserDto>;
  /** Идентификатор пользователя, заблокировавшего поезд */
  lock_user_id?: Maybe<Scalars['Int']['output']>;
  /** locomotive_areas_union_id */
  locomotive_areas_union_id?: Maybe<Scalars['String']['output']>;
  locomotives_areas_calculations: Array<LocomotivesAreasCalculationsDto>;
  locomotives_service: Array<TrainLocomotiveAreaDto>;
  locomotives_service_union: LocomotiveServiceDto;
  max_train_speed?: Maybe<MaxTrainSpeedDto>;
  /** Идентификатор максимальной скорости поезда */
  max_train_speed_id?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  note?: Maybe<Scalars['String']['output']>;
  other_trains: Array<OtherTrainsDto>;
  /** Примечание к иным поездам */
  other_trains_note?: Maybe<Scalars['String']['output']>;
  /** Идентификатор пары */
  pair_train_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<NewTrainDto>;
  /** Идентификатор родительского поезда */
  parent_id?: Maybe<Scalars['Int']['output']>;
  passenger_carrier?: Maybe<PassengerCarrierDto>;
  /** Идентификатор пассажирского перевозчика в дальнем следовани */
  passenger_carrier_russian_railway_id?: Maybe<Scalars['Int']['output']>;
  /** Периодичность */
  periodicity?: Maybe<Scalars['String']['output']>;
  periodicity_season?: Maybe<PeriodicitySeasonDto>;
  /** Идентификатор сезонности */
  periodicity_season_id?: Maybe<Scalars['Int']['output']>;
  railway_administration: RailwayAdministrationDto;
  /** Идентификатор жд администрации */
  railway_administration_id: Scalars['Int']['output'];
  /** Типы подвижного состава */
  rolling_stock_types: Array<Scalars['String']['output']>;
  /** Длительность пути (мин) */
  route_duration: Scalars['Float']['output'];
  /** Маршрутная скорость, км/ч */
  route_speed?: Maybe<Scalars['Float']['output']>;
  schedule?: Maybe<TrainScheduleDto>;
  schemas?: Maybe<Array<TrainSchemaDto>>;
  start_at: Scalars['String']['output'];
  /** Станции переприцепки */
  stations_recoupling?: Maybe<Scalars['String']['output']>;
  /** Статус согласования */
  status: Scalars['String']['output'];
  sub_category?: Maybe<TrainSubCategoryDto>;
  /** Идентификатор последней дороги на территории РЖД */
  to_rzd_railway_id?: Maybe<Scalars['Float']['output']>;
  /** Идентификатор последней станции на территории РЖД */
  to_rzd_station_id?: Maybe<Scalars['Float']['output']>;
  to_station: StationDto;
  /** Идентификатор станции прибытия */
  to_station_id: Scalars['Int']['output'];
  train_brand: TrainBrandDto;
  /** Идентификатор бренда поезда */
  train_brand_id: Scalars['Int']['output'];
  /** Идентификатор категории поезда */
  train_category_id: Scalars['Int']['output'];
  /** Номер поезда */
  train_number: Scalars['String']['output'];
  /** Идентификатор расписания */
  train_schedule_id?: Maybe<Scalars['Int']['output']>;
  /** Идентификатор подкатегории поезда */
  train_sub_category_id: Scalars['Int']['output'];
  /** Связь поездов и схем */
  train_train_schemas?: Maybe<Array<TrainTrainSchemaDto>>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  /** Версия */
  version: Scalars['Int']['output'];
};


export type TrainDtoLocomotives_Areas_CalculationsArgs = {
  period: LocomotiveTotalCalculationsPeriodRequestDto;
};

export type TrainHeaderIndicatorsDto = {
  __typename: 'TrainHeaderIndicatorsDto';
  /** Средняя вместимость вагонов */
  average_capacity: Scalars['Float']['output'];
  /** Количество отправленных вагонов всего */
  carriage_quantity: Scalars['Float']['output'];
  /** Кол-во отправленных вагонов, пассажирских */
  carriage_quantity_passenger: Scalars['Float']['output'];
  /** Вагонооборот по всем типам  */
  carriage_turnover: Scalars['Float']['output'];
  /** Вагонооборот по пассажирским */
  carriage_turnover_passenger: Scalars['Float']['output'];
  /** Предложено мест */
  seats_for_sale: Scalars['Float']['output'];
  /** Местооборот */
  seats_turnover: Scalars['Float']['output'];
  /** Количество отправленных поездов */
  train_quantity: Scalars['Float']['output'];
  /** Поездооборот */
  train_turnover: Scalars['Float']['output'];
};

export type TrainHeaderIndicatorsRequestDto = {
  /** Период курсирования (начало) */
  from: Scalars['String']['input'];
  /** Период курсирования (конец) */
  to: Scalars['String']['input'];
  /** Идентификаторы поездов */
  trainIds: Array<Scalars['Int']['input']>;
};

export type TrainIndicatorsCarriagesCountDto = {
  __typename: 'TrainIndicatorsCarriagesCountDto';
  /** Номер вагона */
  carriage_number: Scalars['String']['output'];
  /** Класс вагона */
  carriage_service_class: Array<Scalars['String']['output']>;
  /** Тип вагона */
  carriage_type: Scalars['String']['output'];
  /** Кол-во мест */
  seats_quantity?: Maybe<Scalars['Float']['output']>;
};

export type TrainIndicatorsCarriagesDistributionDto = {
  __typename: 'TrainIndicatorsCarriagesDistributionDto';
  /** Распределение по вагонам */
  carriages_distribution: Array<TrainIndicatorsCarriagesCountDto>;
  /** Мест всего */
  seats_quantity: Scalars['Float']['output'];
  /** Мест купейных */
  seats_quantity_k: Scalars['Float']['output'];
  /** Мест ОБЩ */
  seats_quantity_o: Scalars['Float']['output'];
  /** Мест плацкартных */
  seats_quantity_pl: Scalars['Float']['output'];
  /** Мест СВ */
  seats_quantity_sv: Scalars['Float']['output'];
};

export type TrainIndicatorsDto = {
  __typename: 'TrainIndicatorsDto';
  /** Количество вагонов (осн. группа) */
  carriage_quantity: CarriageQuantityMainGroupDto;
  carriages_distribution: TrainIndicatorsCarriagesDistributionDto;
  /** Схема состава */
  composition_schema: Array<CompositionSchemaDto>;
  /** Порядок курсирования вагонных групп */
  cruising_order: Array<CruisingOrderDto>;
  /** Заголовок карточки */
  header: TrainIndicatorsHeaderDto;
  /** Потребный парк */
  park_required?: Maybe<Array<ParkRequiredUnionDto>>;
  rolling_stock_type: Scalars['String']['output'];
  /** Показатели работы поезда */
  train_performance_indicators: TrainPerformanceIndicators;
};

export type TrainIndicatorsFinalCalculationItemDto = {
  __typename: 'TrainIndicatorsFinalCalculationItemDto';
  /** Средняя вместимость вагона */
  average_capacity?: Maybe<Scalars['Float']['output']>;
  /** Средний состав поезда по всем ваг */
  average_train_quantity?: Maybe<Scalars['Float']['output']>;
  /** Средний состав поезда по пасс. вагонам */
  average_train_quantity_passenger?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по потребным схемам по всем вагонам */
  carriage_turnover_req?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по потребным схемам по пассажирским вагонам */
  carriage_turnover_req_passenger?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по нормативным схемам по всем вагонам */
  carriage_turnover_schema?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по нормативным схемам по пассажирским вагонам */
  carriage_turnover_schema_passenger?: Maybe<Scalars['Float']['output']>;
  /** Тип вагона */
  carriage_type: Scalars['String']['output'];
  /** Колличество отправленных вагонов */
  carriages_quantity?: Maybe<Scalars['Float']['output']>;
  /** Количество предложенных в продажу мест */
  seats_for_sale?: Maybe<Scalars['Float']['output']>;
  /** Местооборот по потребным схемам */
  seats_turnover_req?: Maybe<Scalars['Float']['output']>;
  /** Местооборот по нормативным схемам */
  seats_turnover_schema?: Maybe<Scalars['Float']['output']>;
};

export type TrainIndicatorsFinalCalculationTotalItemDto = {
  __typename: 'TrainIndicatorsFinalCalculationTotalItemDto';
  /** Средняя вместимость вагона */
  average_capacity?: Maybe<Scalars['Float']['output']>;
  /** Средний состав поезда по всем ваг */
  average_train_quantity?: Maybe<Scalars['Float']['output']>;
  /** Средний состав поезда по пасс. вагонам */
  average_train_quantity_passenger?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по потребным схемам по всем вагонам */
  carriage_turnover_req?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по потребным схемам по пассажирским вагонам */
  carriage_turnover_req_passenger?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по нормативным схемам по всем вагонам */
  carriage_turnover_schema?: Maybe<Scalars['Float']['output']>;
  /** Вагонооборот по нормативным схемам по пассажирским вагонам */
  carriage_turnover_schema_passenger?: Maybe<Scalars['Float']['output']>;
  /** Колличество отправленных вагонов */
  carriages_quantity?: Maybe<Scalars['Float']['output']>;
  /** Количество предложенных в продажу мест */
  seats_for_sale?: Maybe<Scalars['Float']['output']>;
  /** Местооборот по потребным схемам */
  seats_turnover_req?: Maybe<Scalars['Float']['output']>;
  /** Местооборот по нормативным схемам */
  seats_turnover_schema?: Maybe<Scalars['Float']['output']>;
};

export type TrainIndicatorsFinalCalculationsDto = {
  __typename: 'TrainIndicatorsFinalCalculationsDto';
  /** По типу вагонов для схем (строки) */
  items: Array<TrainIndicatorsFinalCalculationItemDto>;
  park_required: IndicatorsFinalCalculationParkRequiredUnionDto;
  /** По типу вагонов для схем (Итоговое количество) */
  total: TrainIndicatorsFinalCalculationTotalItemDto;
  /** Количество поездов */
  train_quantity: Scalars['Float']['output'];
  /** Поездооборот */
  train_turnover: Scalars['Float']['output'];
};

export type TrainIndicatorsFinalCalculationsRequestDto = {
  from_date: Scalars['String']['input'];
  is_arrival: Scalars['Boolean']['input'];
  to_date: Scalars['String']['input'];
};

export type TrainIndicatorsHeaderDto = {
  __typename: 'TrainIndicatorsHeaderDto';
  /** Маршрут */
  distance: Scalars['Float']['output'];
  /** Тип подвижного состава */
  rolling_stock_type: Scalars['String']['output'];
  structural_subdivision?: Maybe<TrainIndicatorsStructuralSubdivisionDto>;
  /** Предприятие */
  structural_subdivision_id?: Maybe<Scalars['Int']['output']>;
  train: TrainDto;
  /** Количество составов */
  train_quantity?: Maybe<Scalars['Int']['output']>;
  train_schema_ids: Array<Scalars['Int']['output']>;
  /** Количество рейсов */
  trips_quantity: Scalars['Int']['output'];
};

export type TrainIndicatorsRequestDto = {
  /** Дата начала */
  from_date: Scalars['String']['input'];
  /** По прибытию/отправлению */
  is_arrival?: InputMaybe<Scalars['Boolean']['input']>;
  /** Идентификатор схемы */
  schema_id: Scalars['Int']['input'];
  /** Дата окончания */
  to_date: Scalars['String']['input'];
  /** Идентификатор поезда */
  train_id: Scalars['Int']['input'];
};

export type TrainIndicatorsStructuralSubdivisionDto = MvpsCompanyAffiliationDto | StructuralSubdivisionDto;

export type TrainIndicatorsTotalRequestDto = {
  /** Дата начала */
  from_date: Scalars['String']['input'];
  /** По прибытию/отправлению */
  is_arrival?: InputMaybe<Scalars['Boolean']['input']>;
  /** Дата окончания */
  to_date: Scalars['String']['input'];
  /** Идентификатор поезда */
  train_id: Scalars['Int']['input'];
};

export type TrainList = {
  __typename: 'TrainList';
  items: Array<TrainDto>;
  totalCount: Scalars['Float']['output'];
};

export type TrainListRequestFormDto = {
  __typename: 'TrainListRequestFormDto';
  /** Время прибытия - действующее расписание */
  arrival_time_current: Scalars['String']['output'];
  /** Время прибытия - новое расписание */
  arrival_time_new: Scalars['String']['output'];
  /** Владелец подвижного состава */
  branch: Scalars['String']['output'];
  /** Время отправления - действующее расписание */
  departure_time_current: Scalars['String']['output'];
  /** Время отправления - новое расписание */
  departure_time_new: Scalars['String']['output'];
  /** Кол-во вагонов (максимальная схема туда/обратно, в том числе по участкам) */
  max_carriage_quantity: Scalars['String']['output'];
  /** Допускаемая скорость */
  max_train_speed: Scalars['String']['output'];
  /** Примечания (резюме изменений) */
  notes: Scalars['String']['output'];
  /** №№ п/п */
  order_number: Scalars['String']['output'];
  /** Периодичность назначения */
  periodicity_dates: Scalars['String']['output'];
  /** Маршрут следования */
  route: Scalars['String']['output'];
  /** Время в пути - действующее расписание */
  route_duration_current: Scalars['String']['output'];
  /** Время в пути - новое расписание */
  route_duration_new: Scalars['String']['output'];
  /** Вид сообщения */
  service_type: Scalars['String']['output'];
  /** Особые условия */
  special_conditions: Scalars['String']['output'];
  /** Пункт формирования */
  station_group_from: Scalars['String']['output'];
  /** Станция отправления */
  station_train_from: Scalars['String']['output'];
  /** Станция назначения */
  station_train_to: Scalars['String']['output'];
  /** Станции дополнительной экипировки */
  stations_eco_toilets: Scalars['String']['output'];
  /** Станции переприцепки вагонов */
  stations_recoupling: Scalars['String']['output'];
  /** Категория поезда */
  train_category: Scalars['String']['output'];
  /** № поезда */
  train_number: Scalars['String']['output'];
};

export type TrainLocomotiveAreaDto = {
  __typename: 'TrainLocomotiveAreaDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  locomotive_area: LocomotiveAreaDto;
  /** Id локомотивного обслуживания */
  locomotive_area_id: Scalars['Int']['output'];
  /** Участки локомотивного обслуживания */
  locomotive_areas: Array<LocomotiveAreaDto>;
  locomotive_series?: Maybe<LocomotiveSeriesDto>;
  /** id серии локомотива */
  locomotive_series_id?: Maybe<Scalars['Int']['output']>;
  traction_directorate?: Maybe<TractionDirectorateDto>;
  /** id дирекции тяги */
  traction_directorate_id?: Maybe<Scalars['Int']['output']>;
  traction_directorate_teams?: Maybe<TractionDirectorateDto>;
  /** Лист id дирекций тяги локомотивных бригад */
  traction_directorate_teams_ids?: Maybe<Array<Scalars['Int']['output']>>;
  train_schema: TrainSchemaDto;
  /** Идентификатор схемы */
  train_schema_id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainMutationEntryPoint = {
  __typename: 'TrainMutationEntryPoint';
  /** Актуализация почтово-багажных поездов */
  actualizePostalBaggageTrains?: Maybe<Scalars['Void']['output']>;
  /** Согласование подразделением */
  approveBySubdivision: Scalars['Void']['output'];
  /** Изменение признака пометки поезда к удалению */
  changeIsMarkedToDelete: ChangeIsMarkedToDeleteDto;
  /** Копирование расписания */
  copySchedule: Scalars['Void']['output'];
  /** Создание пары поездов */
  create: Scalars['Float']['output'];
  /** Создание версии */
  createVersion: CreateVersionResponseDto;
  /** Из УТВМС в согласование */
  declineApproved: UpdateStatusResponseDto;
  /** Отклонение подразделением */
  declineBySubdivision: Scalars['Void']['output'];
  /** Удаление пары */
  delete?: Maybe<Scalars['Void']['output']>;
  /** Изменение номера поезда */
  editTrainNumber?: Maybe<Scalars['Void']['output']>;
  /** Вывод в эксель списка показателей локомотивного обслуживания по сериям */
  exportLococmotiveTractionDirectoratesIndicators?: Maybe<Scalars['Void']['output']>;
  /** Вывод в эксель списка показателей локомотивного обслуживания по сериям */
  exportLocomotiveSeriesIndicators?: Maybe<Scalars['Void']['output']>;
  /** вывод в эксель формы запроса и ведомости стоянок с кодами станций */
  exportRequestFormWithStationCodes?: Maybe<Scalars['Void']['output']>;
  /** Вывод в эксель списка показателей локомотивного обслуживания */
  exportTrainIndicatorsList?: Maybe<Scalars['Void']['output']>;
  /** вывод в эксель списка поездов */
  exportTrainList?: Maybe<Scalars['Void']['output']>;
  /** Блокировка - режим редактирования */
  lock: Scalars['Void']['output'];
  /** Запрос итогового расчёта ло по дирекциям */
  locomotive_final_calculations_by_directorates_request?: Maybe<Scalars['Void']['output']>;
  /** На согласование */
  toApproval: UpdateStatusResponseDto;
  /** Утверждение */
  toApproved: UpdateStatusResponseDto;
  /** В планирование */
  toPlanning: UpdateStatusResponseDto;
  /** Редактирование пары поездов */
  update?: Maybe<Scalars['Void']['output']>;
};


export type TrainMutationEntryPointApproveBySubdivisionArgs = {
  train_id: Scalars['Float']['input'];
};


export type TrainMutationEntryPointChangeIsMarkedToDeleteArgs = {
  data: ChangeIsMarkedToDeleteRequestDto;
};


export type TrainMutationEntryPointCopyScheduleArgs = {
  data: CopyScheduleDto;
};


export type TrainMutationEntryPointCreateArgs = {
  data: CreateTrainDto;
};


export type TrainMutationEntryPointCreateVersionArgs = {
  data: CreateVersionDto;
};


export type TrainMutationEntryPointDeclineApprovedArgs = {
  data: UpdateTrainStatusDto;
};


export type TrainMutationEntryPointDeclineBySubdivisionArgs = {
  train_id: Scalars['Float']['input'];
};


export type TrainMutationEntryPointDeleteArgs = {
  id: Scalars['Float']['input'];
};


export type TrainMutationEntryPointEditTrainNumberArgs = {
  data: EditTrainNumberDto;
};


export type TrainMutationEntryPointExportLococmotiveTractionDirectoratesIndicatorsArgs = {
  data: ExportTrainIndicatorsListDto;
  where?: InputMaybe<TrainMutationResolver_ExportLococmotiveTractionDirectoratesIndicators_FilterInputType>;
};


export type TrainMutationEntryPointExportLocomotiveSeriesIndicatorsArgs = {
  data: ExportTrainIndicatorsListDto;
  where?: InputMaybe<TrainMutationResolver_ExportLocomotiveSeriesIndicators_FilterInputType>;
};


export type TrainMutationEntryPointExportRequestFormWithStationCodesArgs = {
  where?: InputMaybe<TrainMutationResolver_ExportRequestFormWithStationCodes_FilterInputType>;
};


export type TrainMutationEntryPointExportTrainIndicatorsListArgs = {
  data: ExportTrainIndicatorsListDto;
  where?: InputMaybe<TrainMutationResolver_ExportTrainIndicatorsList_FilterInputType>;
};


export type TrainMutationEntryPointExportTrainListArgs = {
  data: ExportTrainListDto;
  where?: InputMaybe<TrainMutationResolver_ExportTrainList_FilterInputType>;
};


export type TrainMutationEntryPointLockArgs = {
  data: LockTrainDto;
};


export type TrainMutationEntryPointLocomotive_Final_Calculations_By_Directorates_RequestArgs = {
  data: LocomotiveFinalCalculationsByDirectoratesRequestDto;
  where?: InputMaybe<TrainMutationResolver_LocomotiveFinalCalculationsByDirectorates_FilterInputType>;
};


export type TrainMutationEntryPointToApprovalArgs = {
  data: UpdateTrainStatusDto;
};


export type TrainMutationEntryPointToApprovedArgs = {
  data: UpdateTrainStatusDto;
};


export type TrainMutationEntryPointToPlanningArgs = {
  data: UpdateTrainStatusDto;
};


export type TrainMutationEntryPointUpdateArgs = {
  data: UpdateTrainDto;
};

export type TrainMutationResolver_ExportLococmotiveTractionDirectoratesIndicators_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_ExportLococmotiveTractionDirectoratesIndicators_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_ExportLococmotiveTractionDirectoratesIndicators_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainMutationResolver_ExportLococmotiveTractionDirectoratesIndicators_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_ExportLococmotiveTractionDirectoratesIndicators_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_ExportLococmotiveTractionDirectoratesIndicators_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainMutationResolver_ExportLocomotiveSeriesIndicators_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_ExportLocomotiveSeriesIndicators_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_ExportLocomotiveSeriesIndicators_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainMutationResolver_ExportLocomotiveSeriesIndicators_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_ExportLocomotiveSeriesIndicators_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_ExportLocomotiveSeriesIndicators_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainMutationResolver_ExportRequestFormWithStationCodes_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_ExportRequestFormWithStationCodes_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_ExportRequestFormWithStationCodes_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainMutationResolver_ExportRequestFormWithStationCodes_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_ExportRequestFormWithStationCodes_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_ExportRequestFormWithStationCodes_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainMutationResolver_ExportTrainIndicatorsList_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_ExportTrainIndicatorsList_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_ExportTrainIndicatorsList_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainMutationResolver_ExportTrainIndicatorsList_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_ExportTrainIndicatorsList_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_ExportTrainIndicatorsList_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainMutationResolver_ExportTrainList_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_ExportTrainList_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_ExportTrainList_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainMutationResolver_ExportTrainList_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_ExportTrainList_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_ExportTrainList_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainMutationResolver_LocomotiveFinalCalculationsByDirectorates_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_LocomotiveFinalCalculationsByDirectorates_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_LocomotiveFinalCalculationsByDirectorates_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainMutationResolver_LocomotiveFinalCalculationsByDirectorates_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainMutationResolver_LocomotiveFinalCalculationsByDirectorates_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainMutationResolver_LocomotiveFinalCalculationsByDirectorates_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainNmrvagFilterDto = {
  __typename: 'TrainNmrvagFilterDto';
  id: Scalars['Float']['output'];
  /** Станция отправления */
  station_from?: Maybe<StationDto>;
  /** Станция назначения */
  station_to?: Maybe<StationDto>;
  train_number: Scalars['String']['output'];
};

export type TrainNmrvagListDto = {
  __typename: 'TrainNmrvagListDto';
  items: Array<TrainNmrvagFilterDto>;
  totalCount: Scalars['Float']['output'];
};

export type TrainPairsDashboardDto = {
  __typename: 'TrainPairsDashboardDto';
  /** Наименование ключа для фильтра для отображения */
  entity_rus_name: Scalars['String']['output'];
  /** ID поездов - главных в паре */
  main_train_ids: Array<Scalars['Int']['output']>;
  /** Количество пар поездов */
  pairs_count: Scalars['Int']['output'];
};

export type TrainPerformanceIndicators = {
  __typename: 'TrainPerformanceIndicators';
  /** Колонки таблицы показателей по поезду */
  items: Array<TrainPerformanceIndicatorsSchemaItemDto>;
  /** Колонки таблицы показателей схемы */
  total: Array<TrainPerformanceIndicatorsSchemaTotal>;
};

export type TrainPerformanceIndicatorsSchemaItemDto = {
  __typename: 'TrainPerformanceIndicatorsSchemaItemDto';
  /** Средний состав  ЭКСПРЕСС (схема) */
  average_composition_express?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Средний состав ЭКСПРЕСС (прогноз) */
  average_composition_express_forecast?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Средний состав ИНФРАСТР (прогноз) */
  average_composition_infrastructure_forecast?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Маршрут группы весь */
  carriage_group_distance?: Maybe<Scalars['Float']['output']>;
  /** Маршрут группы в поезде */
  carriage_group_in_train_distance?: Maybe<Scalars['Float']['output']>;
  /** Оборот группы в поезде */
  carriage_group_in_train_turnover?: Maybe<Scalars['Float']['output']>;
  /** Оборот группы весь */
  carriage_group_turnover?: Maybe<Scalars['Float']['output']>;
  /** Отправлено вагонов (схема) */
  carriages_sent?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (схема) по маршруту группы */
  carriages_turnover_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (треб) по маршруту группы */
  carriages_turnover_req_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (треб) при следовании в поезде ИНФРАСТРУКТУРА */
  carriages_turnover_req_train_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (схема) при следовании в поезде ИНФРАСТРУКТУРА */
  carriages_turnover_train_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Количество отправлений */
  departures_quantity?: Maybe<Scalars['Int']['output']>;
  /** Маршруты вагонной группы */
  route: Array<EmphasizedStationItemDto>;
  /** Предложено мест (схема) */
  seats_proposed?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (схема) по маршруту группы */
  seats_turnover_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (треб) по маршруту группы */
  seats_turnover_req_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (треб) при следовании в поезде */
  seats_turnover_req_train_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (схема) при следовании в поезде */
  seats_turnover_train_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Признак группы */
  sign: Scalars['String']['output'];
  /** Номера поездов */
  train_numbers: Array<EmphasizedTrainItemDto>;
  /** Идентификаторы обороток */
  turnover_ids: Array<Scalars['Int']['output']>;
};

export type TrainPerformanceIndicatorsSchemaTotal = {
  __typename: 'TrainPerformanceIndicatorsSchemaTotal';
  /** Средний состав  ЭКСПРЕСС (схема) */
  average_composition_express?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Средний состав ЭКСПРЕСС (прогноз) */
  average_composition_express_forecast?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Средний состав ИНФРАСТР (прогноз) */
  average_composition_infrastructure_forecast?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Маршрут группы весь */
  carriage_group_distance?: Maybe<Scalars['Float']['output']>;
  /** Маршрут группы в поезде */
  carriage_group_in_train_distance?: Maybe<Scalars['Float']['output']>;
  /** Оборот группы в поезде */
  carriage_group_in_train_turnover?: Maybe<Scalars['Float']['output']>;
  /** Оборот группы весь */
  carriage_group_turnover?: Maybe<Scalars['Float']['output']>;
  /** Отправлено вагонов (схема) */
  carriages_sent?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (схема) по маршруту группы */
  carriages_turnover_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (треб) по маршруту группы */
  carriages_turnover_req_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (треб) при следовании в поезде ИНФРАСТРУКТУРА */
  carriages_turnover_req_train_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (схема) при следовании в поезде ИНФРАСТРУКТУРА */
  carriages_turnover_train_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Количество отправлений */
  departures_quantity?: Maybe<Scalars['Int']['output']>;
  /** Предложено мест (схема) */
  seats_proposed?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (схема) по маршруту группы */
  seats_turnover_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (треб) по маршруту группы */
  seats_turnover_req_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (треб) при следовании в поезде */
  seats_turnover_req_train_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (схема) при следовании в поезде */
  seats_turnover_train_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Заголовок колонки */
  title: Scalars['String']['output'];
  /** Количество поездов */
  train_quantity?: Maybe<Scalars['Int']['output']>;
  /** Поездооборот */
  train_turnover?: Maybe<Scalars['Float']['output']>;
};

export type TrainPerformanceIndicatorsSchemaTotalDto = {
  __typename: 'TrainPerformanceIndicatorsSchemaTotalDto';
  /** Средний состав  ЭКСПРЕСС (схема) */
  average_composition_express?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Средний состав ЭКСПРЕСС (прогноз) */
  average_composition_express_forecast?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Средний состав ИНФРАСТР (прогноз) */
  average_composition_infrastructure_forecast?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Маршрут группы весь */
  carriage_group_distance?: Maybe<Scalars['Float']['output']>;
  /** Маршрут группы в поезде */
  carriage_group_in_train_distance?: Maybe<Scalars['Float']['output']>;
  /** Оборот группы в поезде */
  carriage_group_in_train_turnover?: Maybe<Scalars['Float']['output']>;
  /** Оборот группы весь */
  carriage_group_turnover?: Maybe<Scalars['Float']['output']>;
  /** Отправлено вагонов (схема) */
  carriages_sent?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (схема) по маршруту группы */
  carriages_turnover_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (треб) по маршруту группы */
  carriages_turnover_req_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (треб) при следовании в поезде ИНФРАСТРУКТУРА */
  carriages_turnover_req_train_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Вагонооборот (схема) при следовании в поезде ИНФРАСТРУКТУРА */
  carriages_turnover_train_route?: Maybe<IndicatorsByTrainCarriageTypesDto>;
  /** Количество отправлений */
  departures_quantity?: Maybe<Scalars['Int']['output']>;
  /** Предложено мест (схема) */
  seats_proposed?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (схема) по маршруту группы */
  seats_turnover_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (треб) по маршруту группы */
  seats_turnover_req_carriage_group_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (треб) при следовании в поезде */
  seats_turnover_req_train_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Местооборот (схема) при следовании в поезде */
  seats_turnover_train_route?: Maybe<IndicatorsByTrainCarriageTypesOmitTotalDto>;
  /** Заголовок колонки */
  title: Scalars['String']['output'];
  /** Количество поездов */
  train_quantity?: Maybe<Scalars['Int']['output']>;
  /** Поездооборот */
  train_turnover?: Maybe<Scalars['Float']['output']>;
};

export type TrainQuantityDto = {
  __typename: 'TrainQuantityDto';
  /** даты прибытия на станцию отцепки группы */
  arrival_dates_with_time_stagnation: Array<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Даты отправления со станции прицепки группы */
  departure_dates: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Количество составов */
  quantity: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainQueryEntryPoint = {
  __typename: 'TrainQueryEntryPoint';
  /** Поезд по id */
  byId: TrainDto;
  /** Проверка возможности создания версии поездов */
  checkCreateVersionPossibility: CheckCreateVersionPossibilityResponseDto;
  /** Проверка возможности копирование расписания */
  checkScheduleCopyPossibility: Scalars['Boolean']['output'];
  /** Количество поездов для дашборда */
  getCount: Array<TrainCountDto>;
  /** Количество пар поездов для дашборда */
  getCountPairs: Array<TrainCountDto>;
  /** Количество пар поездов для дашборда по одному фильтру */
  getCountPairsSingle: Scalars['Float']['output'];
  /** Получение дашборда */
  getDashboard: DashboardDto;
  /** Получениесообщения о связанных поездах по id */
  getRelatedTrains: RelatedTrainsDtoList;
  /** Получение списка поездов заблокированных пользователем */
  getUserBlockedTrains: Array<TrainDto>;
  /** Список поездов */
  list: TrainList;
  /** Вывод информации о показателях (локомотивки) */
  listIndicators: CalculateIndicatorsTableList;
  /** Список сервисов локомотива (для списка на фронте) */
  locomotiveServiceList: LocomotiveServiceList;
  /** Итоговый расчёт ло по дирекциям */
  locomotive_final_calculations_by_directorates_response: LocomotiveFinalCalculationsByDirectoratesDto;
  /** Новый список поездов */
  newList: NewTrainList;
  /** Пара по id поезда */
  pair: TrainsPairDto;
  /** Форма запроса */
  trainListRequestForm: Array<TrainListRequestFormDto>;
};


export type TrainQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type TrainQueryEntryPointCheckCreateVersionPossibilityArgs = {
  data: CheckCreateVersionPossibilityDto;
};


export type TrainQueryEntryPointCheckScheduleCopyPossibilityArgs = {
  data: CopyScheduleDto;
};


export type TrainQueryEntryPointGetCountArgs = {
  group_by: Scalars['String']['input'];
  where?: InputMaybe<TrainQueryResolver_GetCount_FilterInputType>;
};


export type TrainQueryEntryPointGetCountPairsArgs = {
  group_by: Scalars['String']['input'];
  where?: InputMaybe<TrainQueryResolver_GetCountPairs_FilterInputType>;
};


export type TrainQueryEntryPointGetCountPairsSingleArgs = {
  where?: InputMaybe<TrainQueryResolver_GetCountPairsSingle_FilterInputType>;
};


export type TrainQueryEntryPointGetDashboardArgs = {
  data: DashboardDataDto;
};


export type TrainQueryEntryPointGetRelatedTrainsArgs = {
  data: GetRelatedTrainsDto;
};


export type TrainQueryEntryPointGetUserBlockedTrainsArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type TrainQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<TrainQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<TrainQueryResolver_List_FilterInputType>;
};


export type TrainQueryEntryPointListIndicatorsArgs = {
  data: ExportTrainIndicatorsListDto;
  order_by?: InputMaybe<Array<TrainQueryResolver_ListIndicators_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<TrainQueryResolver_ListIndicators_FilterInputType>;
};


export type TrainQueryEntryPointLocomotiveServiceListArgs = {
  order_by?: InputMaybe<Array<TrainQueryResolver_LocomotiveServiceList_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<TrainQueryResolver_LocomotiveServiceList_FilterInputType>;
};


export type TrainQueryEntryPointLocomotive_Final_Calculations_By_Directorates_ResponseArgs = {
  key: Scalars['String']['input'];
};


export type TrainQueryEntryPointNewListArgs = {
  is_including_expired_versions: Scalars['Boolean']['input'];
  order_by?: InputMaybe<Array<TrainQueryResolver_NewList_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<TrainQueryResolver_NewList_FilterInputType>;
};


export type TrainQueryEntryPointPairArgs = {
  id: Scalars['Float']['input'];
};


export type TrainQueryEntryPointTrainListRequestFormArgs = {
  where?: InputMaybe<TrainQueryResolver_TrainListRequestForm_FilterInputType>;
};

export type TrainQueryResolver_GetCountPairsSingle_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_GetCountPairsSingle_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_GetCountPairsSingle_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_GetCountPairsSingle_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_GetCountPairsSingle_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_GetCountPairsSingle_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_GetCountPairs_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_GetCountPairs_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_GetCountPairs_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_GetCountPairs_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_GetCountPairs_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_GetCountPairs_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_GetCount_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_GetCount_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_GetCount_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_GetCount_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_GetCount_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_GetCount_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_ListIndicators_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_ListIndicators_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_ListIndicators_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_ListIndicators_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_ListIndicators_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_ListIndicators_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_ListIndicators_SortingInputType = {
  active_subdivision_ids?: InputMaybe<SortType>;
  arrival_time?: InputMaybe<SortType>;
  branch_id?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  decline_subdivision_ids?: InputMaybe<SortType>;
  departure_time?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  from_rzd_railway_id?: InputMaybe<SortType>;
  from_rzd_station_id?: InputMaybe<SortType>;
  from_station_id?: InputMaybe<SortType>;
  gdp_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  individual_name?: InputMaybe<SortType>;
  international_mnemonic?: InputMaybe<SortType>;
  is_carriage_group_approval?: InputMaybe<SortType>;
  is_daytime?: InputMaybe<SortType>;
  is_direct?: InputMaybe<SortType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<SortType>;
  is_included_in_request_form?: InputMaybe<SortType>;
  is_international?: InputMaybe<SortType>;
  is_latest_version?: InputMaybe<SortType>;
  is_lock?: InputMaybe<SortType>;
  is_lock_by_status?: InputMaybe<SortType>;
  is_locomotive_actual?: InputMaybe<SortType>;
  is_main?: InputMaybe<SortType>;
  is_marked_to_delete?: InputMaybe<SortType>;
  is_periodicity_separate_request_form?: InputMaybe<SortType>;
  is_schedule_approval?: InputMaybe<SortType>;
  is_schema_approval?: InputMaybe<SortType>;
  is_southbound?: InputMaybe<SortType>;
  lock_user_id?: InputMaybe<SortType>;
  locomotive_areas_union_id?: InputMaybe<SortType>;
  max_train_speed_id?: InputMaybe<SortType>;
  note?: InputMaybe<SortType>;
  other_trains_note?: InputMaybe<SortType>;
  pair_train_id?: InputMaybe<SortType>;
  parent_id?: InputMaybe<SortType>;
  passenger_carrier_russian_railway_id?: InputMaybe<SortType>;
  periodicity?: InputMaybe<SortType>;
  periodicity_season_id?: InputMaybe<SortType>;
  railway_administration_id?: InputMaybe<SortType>;
  rolling_stock_types?: InputMaybe<SortType>;
  route_duration?: InputMaybe<SortType>;
  route_speed?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  stations_recoupling?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
  to_rzd_railway_id?: InputMaybe<SortType>;
  to_rzd_station_id?: InputMaybe<SortType>;
  to_station_id?: InputMaybe<SortType>;
  train_brand_id?: InputMaybe<SortType>;
  train_category_id?: InputMaybe<SortType>;
  train_number?: InputMaybe<SortType>;
  train_schedule_id?: InputMaybe<SortType>;
  train_sub_category_id?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  version?: InputMaybe<SortType>;
};

export type TrainQueryResolver_List_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_List_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_List_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_List_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_List_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_List_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_List_SortingInputType = {
  from_station?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  individual_name?: InputMaybe<SortType>;
  route_duration?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  to_station?: InputMaybe<SortType>;
  train_number?: InputMaybe<SortType>;
};

export type TrainQueryResolver_LocomotiveServiceList_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_LocomotiveServiceList_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_LocomotiveServiceList_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_LocomotiveServiceList_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_LocomotiveServiceList_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_LocomotiveServiceList_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_LocomotiveServiceList_SortingInputType = {
  from_station?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  individual_name?: InputMaybe<SortType>;
  route_duration?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  to_station?: InputMaybe<SortType>;
  train_number?: InputMaybe<SortType>;
};

export type TrainQueryResolver_NewList_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_NewList_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_NewList_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_NewList_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_NewList_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_NewList_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_NewList_SortingInputType = {
  from_station?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  individual_name?: InputMaybe<SortType>;
  route_duration?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  to_station?: InputMaybe<SortType>;
  train_number?: InputMaybe<SortType>;
};

export type TrainQueryResolver_TrainListRequestForm_BaseFilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_TrainListRequestForm_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_TrainListRequestForm_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainQueryResolver_TrainListRequestForm_FilterInputType = {
  active_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainQueryResolver_TrainListRequestForm_BaseFilterInputType>>;
  arrival_time?: InputMaybe<String_PropertyFilterInputType>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  decline_subdivision_ids?: InputMaybe<Int_PropertyFilterInputType>;
  departure_time?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  from_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  from_station?: InputMaybe<String_PropertyFilterInputType>;
  from_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  from_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  gdp_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  individual_name?: InputMaybe<String_PropertyFilterInputType>;
  international_mnemonic?: InputMaybe<String_PropertyFilterInputType>;
  is_carriage_group_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_daytime?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_excluded_from_calculation_infrastructure_cost?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_included_in_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_international?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_latest_version?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock_by_status?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_locomotive_actual?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_marked_to_delete?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_periodicity_separate_request_form?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schedule_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_schema_approval?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_southbound?: InputMaybe<Boolean_PropertyFilterInputType>;
  lock_user_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_locomotive_series_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_area_traction_directorate_id?: InputMaybe<Int_PropertyFilterInputType>;
  locomotive_areas_union_id?: InputMaybe<String_PropertyFilterInputType>;
  max_train_speed_id?: InputMaybe<Int_PropertyFilterInputType>;
  note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainQueryResolver_TrainListRequestForm_BaseFilterInputType>>;
  other_trains_note?: InputMaybe<String_PropertyFilterInputType>;
  pair_train_id?: InputMaybe<Int_PropertyFilterInputType>;
  parent_id?: InputMaybe<Int_PropertyFilterInputType>;
  passenger_carrier_russian_railway_id?: InputMaybe<Int_PropertyFilterInputType>;
  periodicity?: InputMaybe<String_PropertyFilterInputType>;
  periodicity_season_id?: InputMaybe<Int_PropertyFilterInputType>;
  railway_administration_id?: InputMaybe<Int_PropertyFilterInputType>;
  rolling_stock_types?: InputMaybe<String_PropertyFilterInputType>;
  route_duration?: InputMaybe<Number_PropertyFilterInputType>;
  route_speed?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  stations_recoupling?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary_traction_directorate_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_directorate_teams_ids?: InputMaybe<Int_PropertyFilterInputType>;
  summary_traction_type_ids?: InputMaybe<Int_PropertyFilterInputType>;
  to_rzd_railway_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_rzd_station_id?: InputMaybe<Number_PropertyFilterInputType>;
  to_station?: InputMaybe<String_PropertyFilterInputType>;
  to_station_for_schema?: InputMaybe<String_PropertyFilterInputType>;
  to_station_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_brand_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_id?: InputMaybe<Number_PropertyFilterInputType>;
  train_number?: InputMaybe<String_PropertyFilterInputType>;
  train_schedule_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  version?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainScheduleDto = {
  __typename: 'TrainScheduleDto';
  /** Мета информация по скопированному расписанию */
  copy_meta?: Maybe<CopyMetaDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Маршрутная скорость в пути в прямом направлении */
  direct_speed?: Maybe<Scalars['Float']['output']>;
  /** Время в пути в прямом направлении */
  direct_time?: Maybe<Scalars['Float']['output']>;
  end_at?: Maybe<Scalars['String']['output']>;
  /** Первая строка из gvc файла, если расписание экспортировано */
  gvc_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Расписание редактируется */
  is_lock: Scalars['Boolean']['output'];
  /** Маршрутная скорость в пути в обратном направлении */
  reverse_speed?: Maybe<Scalars['Float']['output']>;
  /** Время в пути в обратном направлении */
  reverse_time?: Maybe<Scalars['Float']['output']>;
  start_at?: Maybe<Scalars['String']['output']>;
  /** Статус поезда */
  status: Scalars['String']['output'];
  /** Фрагменты расписания */
  train_schedule_fragments: Array<TrainScheduleFragmentDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainScheduleFragmentDto = {
  __typename: 'TrainScheduleFragmentDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Время прибытия поезда прямого направления на станцию */
  direct_arrival?: Maybe<Scalars['Float']['output']>;
  /** Время отправления поезда прямого направления на станцию */
  direct_departure?: Maybe<Scalars['Float']['output']>;
  /** Время стоянки поезда прямого направления на станцию */
  direct_parking?: Maybe<Scalars['Float']['output']>;
  /** Время до станции от начала маршрута в прямом направлении в минутах */
  direct_time_to_station: Scalars['Float']['output'];
  /** Номер поезда на данной станции в прямом направлении */
  direct_train_number: Scalars['String']['output'];
  /** Данные из таблицы расстояние между станциями */
  distance: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  /** Признак технической стоянки туда */
  is_direct_schedule_technical_parking: Scalars['Boolean']['output'];
  /** Признак технической стоянки обратно */
  is_reverse_schedule_technical_parking: Scalars['Boolean']['output'];
  /** Порядковый номер фрагмента расписания */
  order_number: Scalars['Int']['output'];
  /** Время прибытия поезда обратного направления на станцию */
  reverse_arrival?: Maybe<Scalars['Float']['output']>;
  /** Время отправления поезда обратного направления на станцию */
  reverse_departure?: Maybe<Scalars['Float']['output']>;
  /** Время стоянки поезда обратного направления на станции */
  reverse_parking?: Maybe<Scalars['Float']['output']>;
  /** Время до станции от начала маршрута в обратном направлении в минутах */
  reverse_time_to_station?: Maybe<Scalars['Float']['output']>;
  /** Номер поезда на данной станции в обратном направлении */
  reverse_train_number?: Maybe<Scalars['String']['output']>;
  station: StationDto;
  /** Идентификатор расписания */
  train_schedule_id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainScheduleStencilDto = {
  __typename: 'TrainScheduleStencilDto';
  /** Расписание второго поезда */
  compared_schedule: TrainScheduleStencilSingleDto;
  /** Расписание первого поезда */
  initial_schedule: TrainScheduleStencilSingleDto;
  /** Массив фрагментов трафарета между двумя расписаниями */
  stencil: Array<TrainScheduleToStencilFragment>;
};

export type TrainScheduleStencilSingleDto = {
  __typename: 'TrainScheduleStencilSingleDto';
  /** Номер поезда */
  direct_train_number: Scalars['String']['output'];
  /** Статус прямого поезда */
  direct_train_status: Scalars['String']['output'];
  /** ГДП start_at end_at */
  gdpRange: RangeDto;
  /** Номер поезда */
  reverse_train_number?: Maybe<Scalars['String']['output']>;
  /** Статус обратного поезда */
  reverse_train_status?: Maybe<Scalars['String']['output']>;
  /** Действует с */
  start_at: Scalars['String']['output'];
  /** Фрагменты исходного расписания */
  train_schedule_to_stencil_fragments: Array<TrainScheduleToStencilFragment>;
  /** Версия поезда */
  train_version: Scalars['Int']['output'];
};

export type TrainScheduleToStencilFragment = {
  __typename: 'TrainScheduleToStencilFragment';
  /** Прямое отправление */
  direct_arrival?: Maybe<Scalars['Float']['output']>;
  /** Прямое прибытие */
  direct_departure?: Maybe<Scalars['Float']['output']>;
  /** Время стоянки в прямом направлении */
  direct_parking?: Maybe<Scalars['Float']['output']>;
  /** Является ли станция стоянкой */
  is_station_for_parking: Scalars['Boolean']['output'];
  /** Обратное прибытие */
  reverse_arrival?: Maybe<Scalars['Float']['output']>;
  /** Обратное отправление */
  reverse_departure?: Maybe<Scalars['Float']['output']>;
  /** Время стоянки в обратном направлении */
  reverse_parking?: Maybe<Scalars['Float']['output']>;
  station: StationDto;
  /** Прямое прибытие */
  station_name?: Maybe<Scalars['String']['output']>;
};

export type TrainSchedulesMutationEntryPoint = {
  __typename: 'TrainSchedulesMutationEntryPoint';
  /** Создание расписания */
  createTrainSchedule: Scalars['Float']['output'];
  /** Удаление расписания */
  deleteTrainSchedule?: Maybe<Scalars['Void']['output']>;
  /** Вывод в эксель расписания поезда */
  exportSchedule?: Maybe<Scalars['Void']['output']>;
  /** Генерация данных по участкам локомотивного обслуживания */
  generateLocomotiveAreasForTrains?: Maybe<Scalars['Void']['output']>;
  /** Импорт расписания из файла */
  import?: Maybe<Scalars['Void']['output']>;
  /** Редактирование заголовка поезда */
  updateTrainSchedule?: Maybe<Scalars['Void']['output']>;
  /** Обновление данных по участкам локомотивного обслуживания */
  update_locomotive_areas_for_trains_pair?: Maybe<Scalars['Void']['output']>;
};


export type TrainSchedulesMutationEntryPointCreateTrainScheduleArgs = {
  data: CreateTrainScheduleDto;
};


export type TrainSchedulesMutationEntryPointDeleteTrainScheduleArgs = {
  id: Scalars['Float']['input'];
};


export type TrainSchedulesMutationEntryPointExportScheduleArgs = {
  data: ExportScheduleDto;
};


export type TrainSchedulesMutationEntryPointGenerateLocomotiveAreasForTrainsArgs = {
  data: GenerateLocomotiveAreasForTrainsPairDto;
};


export type TrainSchedulesMutationEntryPointImportArgs = {
  data: UploadScheduleDto;
};


export type TrainSchedulesMutationEntryPointUpdateTrainScheduleArgs = {
  data: UpdateTrainScheduleDto;
};


export type TrainSchedulesMutationEntryPointUpdate_Locomotive_Areas_For_Trains_PairArgs = {
  data: UpdateLocomotiveAreasDto;
};

export type TrainSchedulesQueryEntryPoint = {
  __typename: 'TrainSchedulesQueryEntryPoint';
  /** Расписание по id */
  byId: TrainScheduleDto;
  /** Сравнение трафаретов */
  getScheduleStencil: TrainScheduleStencilDto;
  /** Список расписаний */
  list: Array<TrainScheduleDto>;
  /** Контроль занятости нитки */
  threadOccupancyControl: Scalars['Boolean']['output'];
};


export type TrainSchedulesQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type TrainSchedulesQueryEntryPointGetScheduleStencilArgs = {
  data: GetTrainScheduleStencilDto;
};


export type TrainSchedulesQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<TrainSchedulesQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<TrainSchedulesQueryResolver_List_FilterInputType>;
};


export type TrainSchedulesQueryEntryPointThreadOccupancyControlArgs = {
  train_id: Scalars['Float']['input'];
};

export type TrainSchedulesQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<TrainSchedulesQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  direct_speed?: InputMaybe<Number_PropertyFilterInputType>;
  direct_time?: InputMaybe<Number_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  gvc_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainSchedulesQueryResolver_List_BaseFilterInputType>>;
  reverse_speed?: InputMaybe<Number_PropertyFilterInputType>;
  reverse_time?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainSchedulesQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<TrainSchedulesQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  direct_speed?: InputMaybe<Number_PropertyFilterInputType>;
  direct_time?: InputMaybe<Number_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  gvc_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainSchedulesQueryResolver_List_BaseFilterInputType>>;
  reverse_speed?: InputMaybe<Number_PropertyFilterInputType>;
  reverse_time?: InputMaybe<Number_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainSchedulesQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  direct_speed?: InputMaybe<SortType>;
  direct_time?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  gvc_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_lock?: InputMaybe<SortType>;
  reverse_speed?: InputMaybe<SortType>;
  reverse_time?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TrainSchemaDto = {
  __typename: 'TrainSchemaDto';
  /** Примечание для блока выделение мест */
  allocation_note?: Maybe<Scalars['String']['output']>;
  border_control?: Maybe<Array<BorderControlDto>>;
  carriage_allocations?: Maybe<Array<CarriageAllocationDto>>;
  carriage_classes?: Maybe<Array<CarriageClassDto>>;
  carriage_numerations?: Maybe<Array<CarriageNumerationDto>>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  direct_carriages?: Maybe<Array<DirectCarriageDto>>;
  /** Примечание для блока беспересадочные вагоны */
  direct_carriages_note?: Maybe<Scalars['String']['output']>;
  eco_toilets?: Maybe<Array<EcoToiletDto>>;
  end_at?: Maybe<Scalars['String']['output']>;
  established_train_schema?: Maybe<Array<EstablishedTrainSchemaUnion>>;
  fuel_supply?: Maybe<Array<FuelSupplyDto>>;
  id: Scalars['Int']['output'];
  /** Построена ли схема относительно реально главного поезда */
  is_build_due_to_main_train: Scalars['Boolean']['output'];
  /** Установленная схема поезда по станциям ли */
  is_by_stations_established_train_schema: Scalars['Boolean']['output'];
  /** Максимально допустимая длина поезда по станциям ли */
  is_by_stations_max_train_length: Scalars['Boolean']['output'];
  /** Заблокирована ли схема */
  is_lock: Scalars['Boolean']['output'];
  /** Импортирована ли основная группа прямого поезда */
  is_main_group_exported_direct: Scalars['Boolean']['output'];
  /** Импортирована ли основная группа обратного поезда */
  is_main_group_exported_reverse: Scalars['Boolean']['output'];
  locomotive_change?: Maybe<Array<LocomotiveChangeDto>>;
  locomotive_team_change?: Maybe<Array<LocomotiveTeamChangeDto>>;
  luxury_carriages?: Maybe<Array<LuxuryCarriageDto>>;
  /** Примечание для вагонов без признака фирменности */
  luxury_carriages_non_branded_note?: Maybe<Scalars['String']['output']>;
  /** Примечание для вагонов с сервисными услугами */
  luxury_carriages_note?: Maybe<Scalars['String']['output']>;
  maneuvering_work?: Maybe<Array<ManeuveringWorkDto>>;
  max_train_length?: Maybe<Array<MaxTrainLengthUnion>>;
  optional_carriages?: Maybe<Array<OptionalCarriageDto>>;
  /** Примечание для блока факультативные вагоны */
  optional_carriages_note?: Maybe<Scalars['String']['output']>;
  other_carriages?: Maybe<Array<OtherCarriageDto>>;
  /** Примечание для блока прочие вагоны */
  other_carriages_note?: Maybe<Scalars['String']['output']>;
  periodicity?: Maybe<Array<PeriodicityInfoDto>>;
  /** Тип подвижного состава для текущей схемы */
  rolling_stock_type?: Maybe<Scalars['String']['output']>;
  /** Примечание для блока классы вагонов */
  service_class_note?: Maybe<Scalars['String']['output']>;
  start_at?: Maybe<Scalars['String']['output']>;
  /** Статус */
  status: Scalars['String']['output'];
  tables?: Maybe<Array<TableDto>>;
  trailed_carriages?: Maybe<Array<TrailedCarriageDto>>;
  /** Примечание для блока прицепные вагоны */
  trailed_carriages_note?: Maybe<Scalars['String']['output']>;
  /** Примечание для блока фирменность поезда */
  train_brand_note?: Maybe<Scalars['String']['output']>;
  train_change_directions?: Maybe<Array<TrainChangeDirectionDto>>;
  /** Номер схемы */
  train_schema_number: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  /** Переменный трафарет */
  variable_stencil_info?: Maybe<Scalars['String']['output']>;
  /** Примечание для блока переменный трафарет */
  variable_stencil_note?: Maybe<Scalars['String']['output']>;
  waste_collection?: Maybe<Array<WasteCollectionDto>>;
  water_supply?: Maybe<Array<WaterSupplyDto>>;
};

export type TrainSchemaList = {
  __typename: 'TrainSchemaList';
  items: Array<TrainSchemaDto>;
  totalCount: Scalars['Float']['output'];
};

export type TrainSchemaMutationEntryPoint = {
  __typename: 'TrainSchemaMutationEntryPoint';
  /** Отклонить группу в схеме */
  approveCarriageGroup?: Maybe<Scalars['Void']['output']>;
  /** Изменение порядкового номера блока в схеме */
  changeTableBlockOrderNumber: Scalars['Boolean']['output'];
  /** Изменить количество составов в блоке схемы */
  changeTableBlockTrainQuantity: Scalars['Boolean']['output'];
  /** Изменить участие блока в расчётах показателей таблицы схемы */
  changeTableBlockUsageInTableCalculations: Scalars['Boolean']['output'];
  /** Изменение значения флага для отображения/не отображения блока в выгрузке */
  changeTableBlockVisibilityInExport: Scalars['Boolean']['output'];
  /** Создать схему */
  create: Array<Scalars['Float']['output']>;
  /** Отклонить группу в схеме */
  declineCarriageGroup?: Maybe<Scalars['Void']['output']>;
  /** Удалить схему */
  delete?: Maybe<Scalars['Void']['output']>;
  /** вывод в docs схемы поезда */
  exportSchema?: Maybe<Scalars['Void']['output']>;
  /** Ручное объединение блоков */
  mergeTableBlocks: Scalars['Boolean']['output'];
  /** Развернуть строки с вагонами внутри блока */
  reverseTableBlockRows: Scalars['Boolean']['output'];
  /** Развернуть схему в рамках пары поездов */
  reverseTrainSchemaBetweenTrainPair: Scalars['Boolean']['output'];
  /** Распространить на все схемы */
  spreadBlockToAllSchemas?: Maybe<Scalars['Void']['output']>;
  /** Обновить схему */
  update?: Maybe<Scalars['Void']['output']>;
};


export type TrainSchemaMutationEntryPointApproveCarriageGroupArgs = {
  data: ApproveCarriageGroupRequestDto;
};


export type TrainSchemaMutationEntryPointChangeTableBlockOrderNumberArgs = {
  data: ChangeTableBlockOrderNumber;
};


export type TrainSchemaMutationEntryPointChangeTableBlockTrainQuantityArgs = {
  data: ChangeTableBlockQuantityDto;
};


export type TrainSchemaMutationEntryPointChangeTableBlockUsageInTableCalculationsArgs = {
  table_block_id: Scalars['Float']['input'];
};


export type TrainSchemaMutationEntryPointChangeTableBlockVisibilityInExportArgs = {
  table_block_id: Scalars['Float']['input'];
};


export type TrainSchemaMutationEntryPointCreateArgs = {
  data: CreateTrainSchemaDto;
};


export type TrainSchemaMutationEntryPointDeclineCarriageGroupArgs = {
  data: DeclineCarriageGroupRequestDto;
};


export type TrainSchemaMutationEntryPointDeleteArgs = {
  data: DeleteTrainSchemaDto;
};


export type TrainSchemaMutationEntryPointExportSchemaArgs = {
  data: ExportSchemasDto;
};


export type TrainSchemaMutationEntryPointMergeTableBlocksArgs = {
  data: MergeTableBlocksDto;
};


export type TrainSchemaMutationEntryPointReverseTableBlockRowsArgs = {
  table_block_id: Scalars['Float']['input'];
};


export type TrainSchemaMutationEntryPointReverseTrainSchemaBetweenTrainPairArgs = {
  train_schema_id: Scalars['Float']['input'];
};


export type TrainSchemaMutationEntryPointSpreadBlockToAllSchemasArgs = {
  data: SpreadBlockToAllSchemasRequestDto;
};


export type TrainSchemaMutationEntryPointUpdateArgs = {
  data: UpdateTrainSchemaDto;
};

export type TrainSchemaNoteForStationDto = {
  __typename: 'TrainSchemaNoteForStationDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  /** Направление */
  direction: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainSchemaQueryEntryPoint = {
  __typename: 'TrainSchemaQueryEntryPoint';
  /** Схема по id */
  byId: TrainSchemaDto;
  /** Схема по id */
  checkIsSpreadPossibleToAllSchemas: Scalars['Boolean']['output'];
  /** Проверка дат отправления и прибытия для схемы */
  checkTrainSchemaDates: Scalars['Boolean']['output'];
  /** Список железных дорог из расписания поезда */
  getRailwayListFromTrainSchedule: Array<TrainSchemaRailwayDto>;
  /** Список станций из расписания поезда */
  getStationListFromTrainSchedule: Array<TrainSchemaStationDto>;
  /** Список схем */
  list: TrainSchemaList;
};


export type TrainSchemaQueryEntryPointByIdArgs = {
  id: Scalars['Float']['input'];
};


export type TrainSchemaQueryEntryPointCheckIsSpreadPossibleToAllSchemasArgs = {
  data: CheckIsSpreadPossibleToAllSchemasRequestDto;
};


export type TrainSchemaQueryEntryPointCheckTrainSchemaDatesArgs = {
  train_schema_id: Scalars['Float']['input'];
};


export type TrainSchemaQueryEntryPointGetRailwayListFromTrainScheduleArgs = {
  data: GetRailwayListFromTrainScheduleDto;
};


export type TrainSchemaQueryEntryPointGetStationListFromTrainScheduleArgs = {
  data: GetStationListFromTrainScheduleDto;
};


export type TrainSchemaQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<TrainSchemaQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<TrainSchemaQueryResolver_List_FilterInputType>;
};

export type TrainSchemaQueryResolver_List_BaseFilterInputType = {
  allocation_note?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainSchemaQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  direct_carriages_note?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_build_due_to_main_train?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_by_stations_established_train_schema?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_by_stations_max_train_length?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main_group_exported_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main_group_exported_reverse?: InputMaybe<Boolean_PropertyFilterInputType>;
  luxury_carriages_non_branded_note?: InputMaybe<String_PropertyFilterInputType>;
  luxury_carriages_note?: InputMaybe<String_PropertyFilterInputType>;
  optional_carriages_note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainSchemaQueryResolver_List_BaseFilterInputType>>;
  other_carriages_note?: InputMaybe<String_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  service_class_note?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  trailed_carriages_note?: InputMaybe<String_PropertyFilterInputType>;
  train_brand_note?: InputMaybe<String_PropertyFilterInputType>;
  train_schema_number?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  variable_stencil_info?: InputMaybe<String_PropertyFilterInputType>;
  variable_stencil_note?: InputMaybe<String_PropertyFilterInputType>;
};

export type TrainSchemaQueryResolver_List_FilterInputType = {
  allocation_note?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<TrainSchemaQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  direct_carriages_note?: InputMaybe<String_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_build_due_to_main_train?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_by_stations_established_train_schema?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_by_stations_max_train_length?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_lock?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main_group_exported_direct?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_main_group_exported_reverse?: InputMaybe<Boolean_PropertyFilterInputType>;
  luxury_carriages_non_branded_note?: InputMaybe<String_PropertyFilterInputType>;
  luxury_carriages_note?: InputMaybe<String_PropertyFilterInputType>;
  optional_carriages_note?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainSchemaQueryResolver_List_BaseFilterInputType>>;
  other_carriages_note?: InputMaybe<String_PropertyFilterInputType>;
  rolling_stock_type?: InputMaybe<String_PropertyFilterInputType>;
  service_class_note?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  trailed_carriages_note?: InputMaybe<String_PropertyFilterInputType>;
  train_brand_note?: InputMaybe<String_PropertyFilterInputType>;
  train_schema_number?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
  variable_stencil_info?: InputMaybe<String_PropertyFilterInputType>;
  variable_stencil_note?: InputMaybe<String_PropertyFilterInputType>;
};

export type TrainSchemaQueryResolver_List_SortingInputType = {
  allocation_note?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  direct_carriages_note?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_build_due_to_main_train?: InputMaybe<SortType>;
  is_by_stations_established_train_schema?: InputMaybe<SortType>;
  is_by_stations_max_train_length?: InputMaybe<SortType>;
  is_lock?: InputMaybe<SortType>;
  is_main_group_exported_direct?: InputMaybe<SortType>;
  is_main_group_exported_reverse?: InputMaybe<SortType>;
  luxury_carriages_non_branded_note?: InputMaybe<SortType>;
  luxury_carriages_note?: InputMaybe<SortType>;
  optional_carriages_note?: InputMaybe<SortType>;
  other_carriages_note?: InputMaybe<SortType>;
  rolling_stock_type?: InputMaybe<SortType>;
  service_class_note?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
  trailed_carriages_note?: InputMaybe<SortType>;
  train_brand_note?: InputMaybe<SortType>;
  train_schema_number?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  variable_stencil_info?: InputMaybe<SortType>;
  variable_stencil_note?: InputMaybe<SortType>;
};

export type TrainSchemaRailwayDto = {
  __typename: 'TrainSchemaRailwayDto';
  /** Код железной дороги */
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Наименование железной дороги */
  name: Scalars['String']['output'];
  /** Сокращённое наименование железной дороги */
  short_name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainSchemaStationDto = {
  __typename: 'TrainSchemaStationDto';
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  /** Код станции ЕСР */
  esr_code?: Maybe<Scalars['String']['output']>;
  /** Код станции Экспресс  */
  express_code: Scalars['String']['output'];
  /** Полное наименование станции */
  full_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Возможность посадки/высадки пассажиров */
  is_board_or_disembark: Scalars['Boolean']['output'];
  /** Осуществление пограничного и таможенного контроля */
  is_border_control: Scalars['Boolean']['output'];
  /** Смена локомотива */
  is_change_locomotive: Scalars['Boolean']['output'];
  /** Смена локомотивной бригады без смены локомотива */
  is_change_locomotive_team: Scalars['Boolean']['output'];
  /** Обслуживание экологически чистых туалетных комплексов (ЭЧТК) */
  is_eco_toilets: Scalars['Boolean']['output'];
  /** Наличие электрических колонок 380В */
  is_electric_speakers_380V: Scalars['Boolean']['output'];
  /** Наличие электрических колонок 3000В */
  is_electric_speakers_3000V: Scalars['Boolean']['output'];
  /** Смена рода тока по станции (постоянный/переменный) */
  is_electricity_type: Scalars['Boolean']['output'];
  /** Снабжение топливом */
  is_fuel_supply: Scalars['Boolean']['output'];
  /** станция разрешённая для маневровой работы */
  is_maneuver_work: Scalars['Boolean']['output'];
  /** Является ли станция маршрутообразующей */
  is_route_forming: Scalars['Boolean']['output'];
  /** Обслуживание не по маршруту поезда */
  is_service_not_train_route: Scalars['Boolean']['output'];
  /** Смена вида тяги по станции (электровозная/тепловозная) */
  is_traction_type: Scalars['Boolean']['output'];
  /** Сбор твёрдых бытовых отходов (ТБО) и шлака */
  is_waste_collection: Scalars['Boolean']['output'];
  /** Снабжение водой */
  is_water_supply: Scalars['Boolean']['output'];
  /** Наименование станции для схемы */
  name_for_schema?: Maybe<Scalars['String']['output']>;
  /** Направление наличия стоянки во фрагементе расписания */
  parking_direction?: Maybe<Scalars['String']['output']>;
  /** ID railway */
  railway_id: Scalars['Int']['output'];
  start_at: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainSubCategoriesDetailsSpeedDto = {
  __typename: 'TrainSubCategoriesDetailsSpeedDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  /** Название подкатегории */
  name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  /** Номера поездов */
  train_numbers: Scalars['String']['output'];
  train_sub_category: TrainSubCategoryDto;
  /** Идентификатор категории поезда */
  train_sub_category_id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainSubCategoriesDetailsSpeedList = {
  __typename: 'TrainSubCategoriesDetailsSpeedList';
  items: Array<TrainSubCategoriesDetailsSpeedDto>;
  totalCount: Scalars['Float']['output'];
};

export type TrainSubCategoriesDetailsSpeedMutationEntryPoint = {
  __typename: 'TrainSubCategoriesDetailsSpeedMutationEntryPoint';
  /** Добавить подкатегорию */
  create: TrainSubCategoriesDetailsSpeedDto;
  /** Обновить подкатегорию */
  update: TrainSubCategoriesDetailsSpeedDto;
};


export type TrainSubCategoriesDetailsSpeedMutationEntryPointCreateArgs = {
  data: CreateTrainSubCategoriesDetailsSpeedDto;
};


export type TrainSubCategoriesDetailsSpeedMutationEntryPointUpdateArgs = {
  data: UpdateTrainSubCategoriesDetailsSpeedDto;
};

export type TrainSubCategoriesDetailsSpeedQueryEntryPoint = {
  __typename: 'TrainSubCategoriesDetailsSpeedQueryEntryPoint';
  /** Подкатегория по byEntityId */
  byEntityId: TrainSubCategoriesDetailsSpeedDto;
  /** Подкатегория по номеру */
  byTrainNumber?: Maybe<TrainSubCategoriesDetailsSpeedList>;
  /** Список изменений категории поезда */
  history: TrainSubCategoriesDetailsSpeedList;
  /** Список подкатегорий */
  list: TrainSubCategoriesDetailsSpeedList;
};


export type TrainSubCategoriesDetailsSpeedQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type TrainSubCategoriesDetailsSpeedQueryEntryPointByTrainNumberArgs = {
  range: RangeInputDto;
  trainNumber: Scalars['String']['input'];
};


export type TrainSubCategoriesDetailsSpeedQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<TrainSubCategoriesDetailsSpeedQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type TrainSubCategoriesDetailsSpeedQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<TrainSubCategoriesDetailsSpeedQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<TrainSubCategoriesDetailsSpeedQueryResolver_List_FilterInputType>;
};

export type TrainSubCategoriesDetailsSpeedQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  train_numbers?: InputMaybe<SortType>;
  train_sub_category_id?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TrainSubCategoriesDetailsSpeedQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<TrainSubCategoriesDetailsSpeedQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainSubCategoriesDetailsSpeedQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainSubCategoriesDetailsSpeedQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<TrainSubCategoriesDetailsSpeedQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainSubCategoriesDetailsSpeedQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  train_sub_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainSubCategoriesDetailsSpeedQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  train_numbers?: InputMaybe<SortType>;
  train_sub_category_id?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TrainSubCategoryDto = {
  __typename: 'TrainSubCategoryDto';
  /** Цвет названия подкатегории */
  background_color: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  /** Короткое азвание подкатегории */
  short_train_sub_category: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  /** Идентификатор категории поезда */
  train_category_id: Scalars['Int']['output'];
  /** Номера поездов */
  train_numbers: Scalars['String']['output'];
  train_sub_categories_details_speed?: Maybe<Array<TrainSubCategoriesDetailsSpeedDto>>;
  /** Название подкатегории */
  train_sub_category: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainSubCategoryList = {
  __typename: 'TrainSubCategoryList';
  items: Array<TrainSubCategoryDto>;
  totalCount: Scalars['Float']['output'];
};

export type TrainSubCategoryMutationEntryPoint = {
  __typename: 'TrainSubCategoryMutationEntryPoint';
  /** Добавить подкатегорию */
  create: TrainSubCategoryDto;
  /** Обновить подкатегорию */
  update: TrainSubCategoryDto;
  /** Обновить подкатегорию */
  updateColor: TrainSubCategoryList;
};


export type TrainSubCategoryMutationEntryPointCreateArgs = {
  data: CreateTrainSubCategoryDto;
};


export type TrainSubCategoryMutationEntryPointUpdateArgs = {
  data: UpdateTrainSubCategoryDto;
};


export type TrainSubCategoryMutationEntryPointUpdateColorArgs = {
  data: UpdateColorTrainSubCategoryDto;
};

export type TrainSubCategoryQueryEntryPoint = {
  __typename: 'TrainSubCategoryQueryEntryPoint';
  /** Подкатегория по byEntityId */
  byEntityId: TrainSubCategoryDto;
  /** Подкатегория по номеру */
  byTrainNumber?: Maybe<TrainSubCategoryList>;
  /** Список изменений категории поезда */
  history: TrainSubCategoryList;
  /** Список подкатегорий */
  list: TrainSubCategoryList;
};


export type TrainSubCategoryQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type TrainSubCategoryQueryEntryPointByTrainNumberArgs = {
  range: RangeInputDto;
  trainNumber: Scalars['String']['input'];
};


export type TrainSubCategoryQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<TrainSubCategoryQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type TrainSubCategoryQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<TrainSubCategoryQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<TrainSubCategoryQueryResolver_List_FilterInputType>;
};

export type TrainSubCategoryQueryResolver_History_SortingInputType = {
  background_color?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  short_train_sub_category?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  train_category_id?: InputMaybe<SortType>;
  train_numbers?: InputMaybe<SortType>;
  train_sub_category?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TrainSubCategoryQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<TrainSubCategoryQueryResolver_List_BaseFilterInputType>>;
  background_color?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainSubCategoryQueryResolver_List_BaseFilterInputType>>;
  short_train_sub_category?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  train_sub_category?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainSubCategoryQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<TrainSubCategoryQueryResolver_List_BaseFilterInputType>>;
  background_color?: InputMaybe<String_PropertyFilterInputType>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<TrainSubCategoryQueryResolver_List_BaseFilterInputType>>;
  short_train_sub_category?: InputMaybe<String_PropertyFilterInputType>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  train_category_id?: InputMaybe<Int_PropertyFilterInputType>;
  train_numbers?: InputMaybe<String_PropertyFilterInputType>;
  train_sub_category?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TrainSubCategoryQueryResolver_List_SortingInputType = {
  background_color?: InputMaybe<SortType>;
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  short_train_sub_category?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  train_category_id?: InputMaybe<SortType>;
  train_numbers?: InputMaybe<SortType>;
  train_sub_category?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TrainTrainSchemaDto = {
  __typename: 'TrainTrainSchemaDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Идентификатор схемы */
  schema_id: Scalars['Int']['output'];
  /** Идентификатор поезда */
  train_id: Scalars['Int']['output'];
  train_locomotive_areas?: Maybe<Array<TrainLocomotiveAreaDto>>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TrainsPairDto = {
  __typename: 'TrainsPairDto';
  /** Поезд прямого направления */
  direct: TrainDto;
  /** Поезд обратного направления */
  reverse?: Maybe<TrainDto>;
};

export type TransportationPerformanceIndicatorDto = {
  __typename: 'TransportationPerformanceIndicatorDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  end_at: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** ТОЛЬКО ДЛЯ byEntityId */
  last_version: RangeDto;
  /** Наименование */
  name: Scalars['String']['output'];
  start_at: Scalars['String']['output'];
  /** Единица измерения */
  unit: Scalars['String']['output'];
  /** Единица измерения(кратко) */
  unit_short: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TransportationPerformanceIndicatorDtoList = {
  __typename: 'TransportationPerformanceIndicatorDtoList';
  items: Array<TransportationPerformanceIndicatorDto>;
  totalCount: Scalars['Float']['output'];
};

export type TransportationPerformanceIndicatorMutationEntryPoint = {
  __typename: 'TransportationPerformanceIndicatorMutationEntryPoint';
  /** Добавить эксплуатационный показатель перевозок */
  create: TransportationPerformanceIndicatorDto;
  /** Обновить эксплуатационный показатель перевозок */
  update: TransportationPerformanceIndicatorDto;
};


export type TransportationPerformanceIndicatorMutationEntryPointCreateArgs = {
  data: CreateTransportationPerformanceIndicatorDto;
};


export type TransportationPerformanceIndicatorMutationEntryPointUpdateArgs = {
  data: UpdateTransportationPerformanceIndicatorDto;
};

export type TransportationPerformanceIndicatorQueryEntryPoint = {
  __typename: 'TransportationPerformanceIndicatorQueryEntryPoint';
  /** Эксплуатационный показатель перевозок по id */
  byEntityId: TransportationPerformanceIndicatorDto;
  /** Список изменений эксплуатационных показателей перевозоки */
  history: TransportationPerformanceIndicatorDtoList;
  /** Список эксплуатационных показателей перевозок */
  list: TransportationPerformanceIndicatorDtoList;
};


export type TransportationPerformanceIndicatorQueryEntryPointByEntityIdArgs = {
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
};


export type TransportationPerformanceIndicatorQueryEntryPointHistoryArgs = {
  entity_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<TransportationPerformanceIndicatorQueryResolver_History_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
};


export type TransportationPerformanceIndicatorQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<TransportationPerformanceIndicatorQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  range: RangeInputDto;
  where?: InputMaybe<TransportationPerformanceIndicatorQueryResolver_List_FilterInputType>;
};

export type TransportationPerformanceIndicatorQueryResolver_History_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  unit?: InputMaybe<SortType>;
  unit_short?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TransportationPerformanceIndicatorQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<TransportationPerformanceIndicatorQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TransportationPerformanceIndicatorQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  unit?: InputMaybe<String_PropertyFilterInputType>;
  unit_short?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TransportationPerformanceIndicatorQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<TransportationPerformanceIndicatorQueryResolver_List_BaseFilterInputType>>;
  created_at?: InputMaybe<Date_PropertyFilterInputType>;
  created_by?: InputMaybe<Int_PropertyFilterInputType>;
  end_at?: InputMaybe<String_PropertyFilterInputType>;
  entity_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TransportationPerformanceIndicatorQueryResolver_List_BaseFilterInputType>>;
  start_at?: InputMaybe<String_PropertyFilterInputType>;
  unit?: InputMaybe<String_PropertyFilterInputType>;
  unit_short?: InputMaybe<String_PropertyFilterInputType>;
  updated_at?: InputMaybe<Date_PropertyFilterInputType>;
  updated_by?: InputMaybe<Int_PropertyFilterInputType>;
};

export type TransportationPerformanceIndicatorQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  end_at?: InputMaybe<SortType>;
  entity_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  start_at?: InputMaybe<SortType>;
  unit?: InputMaybe<SortType>;
  unit_short?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
};

export type TurnaroundTimeDto = {
  __typename: 'TurnaroundTimeDto';
  /** даты прибытия на станцию отцепки группы */
  arrival_dates_with_time_stagnation: Array<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Даты отправления со станции прицепки группы */
  departure_dates: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Количество составов */
  turn_around_time: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TurnoverAddTimeStagnationDatesInfoDto = {
  __typename: 'TurnoverAddTimeStagnationDatesInfoDto';
  /** Массив доступных дат для выбора */
  available_dates_to_select: Array<Scalars['String']['output']>;
};

export type TurnoverChartDto = {
  __typename: 'TurnoverChartDto';
  /** Массив данных для построения графика */
  items: Array<CarriageGroupTurnoverChartDataDto>;
  /** Массив данных для построения графика */
  train_info: CarriageGroupTurnoverChartTrainInfoDto;
};

export type TurnoverDto = {
  __typename: 'TurnoverDto';
  /** Идентификаторы принятых схем поезда */
  accepted_train_schemas_ids?: Maybe<Array<Scalars['Int']['output']>>;
  /** Перечень дат прибытия на станцию отцепки группы */
  arrival_dates: Array<Scalars['String']['output']>;
  /** Массив дат с простоями */
  arrival_dates_with_time_stagnation: Array<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Перечень дат отправления со станции прицепки группы */
  departure_dates: Array<Scalars['String']['output']>;
  /** Признак группы */
  group_sign: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Признак прицепной беспересадочной группы вагонов: true - беспересадочная, false - нет */
  is_pbg: Scalars['Boolean']['output'];
  /** Признак принятой схемы */
  is_schemas_accepted: Scalars['Boolean']['output'];
  /** Признак начальной позиции для продажи прямых билетов: true - начальная позиция, false - не начальная */
  is_start_position_for_sale_direct_tickets: Scalars['Boolean']['output'];
  /** Переменная показывающая что у оборотки есть простой */
  is_time_stagnation_variable: Scalars['Boolean']['output'];
  /** Признак прицепной беспересадочной группы вагонов: true - беспересадочная, false - нет */
  is_turnover_station_for_schema: Scalars['Boolean']['output'];
  /** Порядковый номер оборотки в группе */
  order_number: Scalars['Int']['output'];
  /** Позиция группы вагонов */
  position: Scalars['String']['output'];
  schemas: Array<TrainSchemaDto>;
  /** Количество мест в группе вагонов доступных к продаже */
  seats_for_sale?: Maybe<Scalars['Int']['output']>;
  /** Общее количество мест в группе вагонов */
  seats_total?: Maybe<Scalars['Int']['output']>;
  station_from: StationDto;
  station_to: StationDto;
  train: TrainDto;
  turnover_time_stagnations: Array<TurnoverTimeStagnationDto>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TurnoverTimeStagnationDto = {
  __typename: 'TurnoverTimeStagnationDto';
  /** Массив дат прибытия */
  arrival_dates: Array<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Время простоя группы */
  time_in_stagnation: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TurnoverUpdateTimeStagnationDatesInfoDto = {
  __typename: 'TurnoverUpdateTimeStagnationDatesInfoDto';
  /** Массив доступных дат для выбора */
  available_dates_to_select: Array<Scalars['String']['output']>;
  /** Массив выбранных дат */
  selected_dates: Array<Scalars['String']['output']>;
};

export type TurnoverUpdateTimeStagnationDatesInfoReqDto = {
  /** Идентификатор перестоя */
  time_stagnation_id: Scalars['Int']['input'];
  /** Идентификатор оборотки */
  turnover_id: Scalars['Int']['input'];
};

export type TypeCurrentDto = {
  __typename: 'TypeCurrentDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Расстояние между станцией отправления и станцией прибытия */
  distance: Scalars['Int']['output'];
  from_station: StationDto;
  id: Scalars['Int']['output'];
  locomotive_type_current?: Maybe<LocomotiveTypeCurrentDto>;
  to_station: StationDto;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TypeIndicators =
  | 'ALL'
  | 'MESTOBOROT'
  | 'OTPR_POEZDOV'
  | 'OTPR_VAGONOV'
  | 'POEZDOOBOROT'
  | 'SRED_SOSTAV'
  | 'VAGONOOBOROT';

export type UniqueRoutesDto = {
  __typename: 'UniqueRoutesDto';
  city?: Maybe<StationDto>;
  /** Массив идентификаторов записей топовых направлений */
  top_routes_ids?: Maybe<Array<Scalars['Int']['output']>>;
};

export type UniqueRoutesDtoList = {
  __typename: 'UniqueRoutesDtoList';
  items: Array<UniqueRoutesDto>;
  totalCount: Scalars['Float']['output'];
};

export type UpdateAllCarriageParametersDto = {
  /** признаки мест в вагоне поезда */
  carriage_additional_seats_signs?: InputMaybe<Array<UpdateCarriageAdditionalSeatsSignViaAdditionalParametersDto>>;
  /** id группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** id вагона */
  carriage_id: Scalars['Int']['input'];
  /** данные по выделению мест в вагоне */
  carriage_seats_allocations?: InputMaybe<Array<UpdateSeatsAllocationViaAdditionalParametersDto>>;
  /** данные по по поезду */
  carriage_train_info: UpdateCarriageTrainInfoViaAdditionalParametersDto;
  /** id доп параметров вагона */
  id: Scalars['Int']['input'];
  /** Распространить на все параметры вагона */
  is_spread_to_all_parameters: Scalars['Boolean']['input'];
};

export type UpdateAvailableServiceClassDto = {
  /** Идентификатор класса обслуживания */
  entity_id: Scalars['Int']['input'];
  /** Класс обслуживания */
  service_class?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateBranchDto = {
  /** Идентификатор сущности для обновления */
  id: Scalars['Int']['input'];
  /** Полное название */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Наименование в nmrvag (ЦСУ) */
  name_nmrvag?: InputMaybe<Scalars['String']['input']>;
  /** Краткое название */
  short_name?: InputMaybe<Scalars['String']['input']>;
  /** Код в nmrvag (ЦСУ) */
  vladr?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCudTrainSchemaDto = {
  /** Информация для обновления в блоке станции пограничного и таможенного контроля */
  border_control?: InputMaybe<Array<UpdateTrainSchemaNoteForStationDto>>;
  /** Информация для обновления в блоке нумерация вагонов в пути следования */
  carriage_numerations?: InputMaybe<Array<UpdateCarriageNumerationDto>>;
  /** Информация для обновления в блоке беспересадочные вагоны */
  direct_carriages?: InputMaybe<Array<UpdateDirectTrailedOtherCarriageDto>>;
  /** Информация для обновления в блоке ЭЧТК */
  eco_toilets?: InputMaybe<Array<UpdateTrainSchemaNoteForStationDto>>;
  /** Информация для обновления в блоке установленная схема поезда по станциям */
  established_train_schema_railways?: InputMaybe<Array<UpdateEstablishedTrainSchemaRailwayDto>>;
  /** Информация для обновления в блоке установленная схема поезда по станциям */
  established_train_schema_stations?: InputMaybe<Array<UpdateEstablishedTrainSchemaStationDto>>;
  /** Информация для обновления в блоке станции снабжения топливом */
  fuel_supply?: InputMaybe<Array<UpdateTrainSchemaNoteForStationDto>>;
  /** Информация для обновления в блоке смена локомотива без смены локомотивной команды */
  locomotive_change?: InputMaybe<Array<UpdateTrainSchemaNoteForStationDto>>;
  /** Информация для обновления в блоке смена локомотивной команды */
  locomotive_team_change?: InputMaybe<Array<UpdateTrainSchemaNoteForStationDto>>;
  /** Информация для обновления в блоке станции выполнения маневровых работ водой */
  maneuvering_work?: InputMaybe<Array<UpdateTrainSchemaNoteForStationDto>>;
  /** Информация для обновления в блоке максимальная длина поезда по жд */
  max_train_length_railways?: InputMaybe<Array<UpdateMaxTrainLengthRailwayDto>>;
  /** Информация для обновления в блоке максимальная длина поезда по станциям */
  max_train_length_stations?: InputMaybe<Array<UpdateMaxTrainLengthStationDto>>;
  /** Информация для обновления в блоке прочие вагоны */
  other_carriages?: InputMaybe<Array<UpdateDirectTrailedOtherCarriageDto>>;
  /** Информация для обновления в блоке прицепные вагоны */
  trailed_carriages?: InputMaybe<Array<UpdateDirectTrailedOtherCarriageDto>>;
  /** Информация для обновления в блоке смена направления движения поезда */
  train_change_directions?: InputMaybe<Array<UpdateTrainSchemaNoteForStationDto>>;
  /** Информация для обновления в блоке станции сбора ТБО и шлака */
  waste_collection?: InputMaybe<Array<UpdateTrainSchemaNoteForStationDto>>;
  /** Информация для обновления в блоке станции снабжения водой */
  water_supply?: InputMaybe<Array<UpdateTrainSchemaNoteForStationDto>>;
};

export type UpdateCarriageAdditionalSeatSignDto = {
  /** Идентификатор типа */
  entity_id: Scalars['Int']['input'];
  /** Тип класса */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateCarriageAdditionalSeatsSignViaAdditionalParametersDto = {
  /** Выделенные (зарезервированные) места */
  all_seats: Scalars['String']['input'];
  /** Примечание в свободной форме */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Id Тип признака мест */
  for_whom_additional_seats_sign_id: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Количество выделенных мест */
  quantity: Scalars['Int']['input'];
};

export type UpdateCarriageGroupDto = {
  /** Идентификатор филиала */
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор графика движения поездов */
  gdp_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор группы вагонов */
  id: Scalars['Int']['input'];
  /** Признак ручного формирования маршрута ГВ для вывода в схему */
  is_manual_trip_formation_for_schema: Scalars['Boolean']['input'];
  /** Наименование группы вагонов */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор перевозчика */
  passenger_carriers_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор ж/д администрации */
  railway_administration_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор предприятия приписки */
  structural_subdivision_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCarriageMvpsDto = {
  /** Идентификатор филиала приписки */
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Идентификатор типа вагона */
  carriage_type_id: Scalars['Int']['input'];
  /** Идентификатор вагона мвпс */
  id: Scalars['Int']['input'];
  /** Длина состава в миллиметрах */
  lineup_length?: InputMaybe<Scalars['Float']['input']>;
  /** Идентификатор вида секций МВПС */
  mvps_section_type_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор перевозчика */
  passenger_carriers_russian_railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор ЖД администрации */
  railway_administration_id?: InputMaybe<Scalars['Int']['input']>;
  /** Массив идентификаторов вагонов и мест в них */
  rows?: InputMaybe<Array<CreateCarriageMvpsItemDto>>;
  /** Количество мест */
  seats_quantity: Scalars['Int']['input'];
  /** Идентификатор структурного подразделения филиала приписки */
  structural_subdivision_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCarriageNpsDto = {
  /** Идентификатор филиала приписки */
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор типа тормозов */
  carriage_brake_type_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор габаритов подвижного состава */
  carriage_dimension_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Идентификатор вида отопления */
  carriage_heat_type_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор длины вагона */
  carriage_length_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор модели вагона */
  carriage_model_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор типа вагона в АСУ ПВ */
  carriage_type_asu_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор типа вагона */
  carriage_type_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор вагона нпс */
  id: Scalars['Int']['input'];
  /** Признак наличия кондиционера */
  is_air_conditioner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Признак наличия централизованного электропитания */
  is_centralized_power_supply?: InputMaybe<Scalars['Boolean']['input']>;
  /** Признак наличия ЭЧТК */
  is_eco_toilets?: InputMaybe<Scalars['Boolean']['input']>;
  /** Идентификатор перевозчика */
  passenger_carriers_russian_railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор ЖД администрации */
  railway_administration_id?: InputMaybe<Scalars['Int']['input']>;
  /** Количество мест в вагоне */
  seats_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор структурного подразделения филиала приписки */
  structural_subdivision_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCarriageNumerationDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции отправления для прямого поезда */
  direct_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Позиция для прямого поезда */
  direct_position?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции прибытия для прямого поезда */
  direct_to_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор сущности */
  id: Scalars['Int']['input'];
  /** Идентификатор станции отправления для обратного поезда */
  reverse_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Позиция для обратного поезда */
  reverse_position?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции прибытия для обратного поезда */
  reverse_to_station_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCarriageSeatAllocationDto = {
  /** Идентификатор типа */
  entity_id: Scalars['Int']['input'];
  /** Тип выделения мест */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateCarriageServiceClassDto = {
  /** Доступные классы сервиса */
  available_service_classes_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** id типа вагона */
  carriage_types_for_schema_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор филиала */
  entity_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateCarriageTrainInfoViaAdditionalParametersDto = {
  /** id класса обслуживания */
  available_service_class_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Добполнительные параметры вагона */
  carriage_additional_parameters: Array<Scalars['String']['input']>;
  /** Примечание в свободной форме */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Порядковый/условный номер */
  order_number: Scalars['String']['input'];
};

export type UpdateCarriageTypeAsuDimensionSeatsCountDto = {
  /** carriage_dimension_id - Идентификатор габарита вагона */
  carriage_dimension_id?: InputMaybe<Scalars['Int']['input']>;
  /** carriage_type_asu_id - Идентификатор типа вагона АСУПВ */
  carriage_type_asu_id?: InputMaybe<Scalars['Int']['input']>;
  /** Стандартное количество мест */
  default_seats_count?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор */
  id: Scalars['Int']['input'];
};

export type UpdateCarriageTypeAsuDto = {
  /** Идентификатор */
  entity_id: Scalars['Int']['input'];
  /** Полное название */
  full_name?: InputMaybe<Scalars['String']['input']>;
  /** Краткое название */
  short_name?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateCarriageTypeDto = {
  /** Id типа вагона для внесения в схему */
  carriage_types_for_schema_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор типа вагона */
  entity_id: Scalars['Int']['input'];
  /** Id мнемоники сектора регулирования */
  regulatory_sector_mnemonic_id?: InputMaybe<Scalars['Int']['input']>;
  /** Id мнемоники вида подвижного состава */
  rolling_stock_type_mnemonic_id?: InputMaybe<Scalars['Int']['input']>;
  /** Id мнемоники типа вагона по местам для отображения в схеме */
  seat_type_mnemonic_id?: InputMaybe<Scalars['Int']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateCarriageTypesForSchemaDto = {
  /** Тип вагона */
  carriage_type_asu_id?: InputMaybe<Scalars['Int']['input']>;
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор */
  id: Scalars['Int']['input'];
  /** Название */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateColorTrainBrandDto = {
  /** Цвет фона */
  background_color: Scalars['String']['input'];
  /** Идентификатор */
  entity_id: Scalars['Int']['input'];
};

export type UpdateColorTrainSubCategoryDto = {
  /** Цвет названия подкатегории */
  background_color: Scalars['String']['input'];
  /** Идентификатор */
  entity_id: Scalars['Int']['input'];
};

export type UpdateConditionalCarriageNumberDto = {
  /** Условный номер вагона */
  conditional_carriage_number?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор */
  id: Scalars['Int']['input'];
};

export type UpdateCsuCarriageTypeDto = {
  /** Наименование */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор типа вагона */
  id: Scalars['Int']['input'];
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Роли пользователя */
  subtypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Тип вагонов ЦСУ */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDirectTrailedOtherCarriageDto = {
  /** Описание */
  description: Scalars['String']['input'];
  /** Идентификатор сущности */
  id: Scalars['Int']['input'];
};

export type UpdateDisableSchedulerJobDto = {
  /** Отключен */
  disable: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export type UpdateDivisionDto = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEstablishedTrainSchemaRailwayDto = {
  /** Примечание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор железной дороги для прямого направления */
  direct_railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор сущности */
  id: Scalars['Int']['input'];
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор железной дороги для обратного направления */
  reverse_railway_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateEstablishedTrainSchemaStationDto = {
  /** Примечание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции отправления для прямого направления */
  direct_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции прибытия для прямого направления */
  direct_to_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор сущности */
  id: Scalars['Int']['input'];
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции отправления для обратного направления */
  reverse_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции прибытия для обратного направления */
  reverse_to_station_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateForecastIndicatorDto = {
  /** Идентификатор типа вагона */
  carriage_type_indicator_id: Scalars['Int']['input'];
  /** Прогнозное значение */
  forecast: Scalars['Float']['input'];
};

export type UpdateGdpDto = {
  /** Действует по */
  end_at?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор графика движения поездов */
  id: Scalars['Int']['input'];
  /** Действует с */
  start_at?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInfrastructureCoefficientIndexingDto = {
  /** Коэффициент */
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  /** Идентификатор коэффициента индексации к тарифам на использование услуг инфраструктуры */
  id: Scalars['Int']['input'];
  /** Действует с */
  start_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateLocomotiveAreasDto = {
  direct: UpdateTrainLocomotiveAreasDto;
  reverse?: InputMaybe<UpdateTrainLocomotiveAreasDto>;
};

export type UpdateLocomotivePriceTechnicalServiceDto = {
  /** Идентификатор стоимости технического обслуживания локомотивов */
  entity_id: Scalars['Int']['input'];
  /** ID серии локомотивов */
  locomotives_series_id?: InputMaybe<Scalars['Int']['input']>;
  /** Стоимость обслуживания */
  maintenance_cost?: InputMaybe<Scalars['Float']['input']>;
  /** ID рода службы локомотива */
  series_type_id?: InputMaybe<Scalars['Int']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** ID дирекции тяги */
  traction_directorates_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLocomotiveSeriesDto = {
  /** Идентификатор серии локомотивов */
  entity_id: Scalars['Int']['input'];
  /** Индекс */
  index?: InputMaybe<Scalars['String']['input']>;
  /** Id типа тяги */
  locomotive_traction_type_id?: InputMaybe<Scalars['Int']['input']>;
  /** Цена аренды */
  price_rent?: InputMaybe<Scalars['Float']['input']>;
  /** Количество секций */
  section_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Серия */
  series?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateLocomotiveServiceEmpiricalParameterDto = {
  /** Идентификатор эмпирического параметра локомотивного обслуживания */
  entity_id: Scalars['Int']['input'];
  /** ID эмпирического параметра локомотивного обслуживания */
  mnemonic_id?: InputMaybe<Scalars['Int']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Единица измерения эмпирического параметра локомотивного обслуживания */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateLocomotiveTeamPriceRentDto = {
  /** Идентификатор стоимости аренды локомотивных бригад */
  entity_id: Scalars['Int']['input'];
  /** Стоимость аренды лок. бригады электровоза при работе в 1 лицо */
  price_electric_locomotive_one_person?: InputMaybe<Scalars['Float']['input']>;
  /** Стоимость аренды лок. бригады электровоза при работе в 2 лица */
  price_electric_locomotive_two_person?: InputMaybe<Scalars['Float']['input']>;
  /** Стоимость аренды лок. бригады тепловоза при работе в 1 лицо */
  price_warm_locomotive_one_person?: InputMaybe<Scalars['Float']['input']>;
  /** Стоимость аренды лок. бригады тепловоза при работе в 2 лица */
  price_warm_locomotive_two_person?: InputMaybe<Scalars['Float']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** ID Дирекции тяги */
  traction_directorates_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMaxTrainLengthRailwayDto = {
  /** Примечание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор железной дороги для прямого направления */
  direct_railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор сущности */
  id: Scalars['Int']['input'];
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор железной дороги для обратного направления */
  reverse_railway_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMaxTrainLengthStationDto = {
  /** Примечание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Количество вагонов для прямого поезда */
  direct_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции отправления для прямого направления */
  direct_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции прибытия для прямого направления */
  direct_to_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор сущности */
  id: Scalars['Int']['input'];
  /** Количество вагонов для обратного поезда */
  reverse_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции отправления для обратного направления */
  reverse_from_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции прибытия для обратного направления */
  reverse_to_station_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMaxTrainSpeedDto = {
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Максимальная скорость поезда */
  max_train_speed?: InputMaybe<Scalars['Float']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateMnemonicDto = {
  /** Значение группового признака */
  group_name_rus?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор */
  id: Scalars['Float']['input'];
  /** Значение мнемоники */
  mnemonic_rus?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMvpsCompanyAffiliationDto = {
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Наименование */
  mvps_owner?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateMvpsMartinSectionTypeDto = {
  /** Количество вагонов в одной секции */
  carriage_quantity_in_section?: InputMaybe<Scalars['Float']['input']>;
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** ID комплектации МВПС */
  mvps_martin_section_type_equipment_id?: InputMaybe<Scalars['Int']['input']>;
  /** Ставка аренды руб. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Серия */
  series?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateMvpsMartinSectionTypeEquipmentDto = {
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Комплектация */
  equipment?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateMvpsRateManagementExploitationMaintenanceRepairDto = {
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** ID типа ставки */
  mnemonic_id?: InputMaybe<Scalars['Int']['input']>;
  /** Ставка аренды, руб. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateNonPassengerCarriageTypeDto = {
  /** Идентификатор типа вагона */
  carriage_types_for_schema_id?: InputMaybe<Scalars['Int']['input']>;
  /** Массив идентификаторов условных номеров вагонов */
  conditional_carriage_number_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateNpsCarriageBrakeTypeDto = {
  /** Тормоз */
  brake_type?: InputMaybe<Scalars['String']['input']>;
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateNpsCarriageDimensionDto = {
  /** Габарит */
  carriage_dimension?: InputMaybe<Scalars['String']['input']>;
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateNpsCarriageHeatTypeDto = {
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Вид отопления */
  heat_type?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateNpsCarriageLengthDto = {
  /** Длина вагонов в АСУ ПВ(мм) */
  carriage_length_asu_ms?: InputMaybe<Scalars['Float']['input']>;
  /** Длина вагона в схеме поезда(м) */
  carriage_length_in_train_schema?: InputMaybe<Scalars['Float']['input']>;
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Идентификатор */
  id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateNpsCarriageModelDto = {
  /** Модель */
  carriage_model?: InputMaybe<Scalars['String']['input']>;
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdatePassengerCarrierDto = {
  /** Код пассажирского перевозчика */
  code?: InputMaybe<Scalars['Int']['input']>;
  /** Код государства (GOS ЦСУ) */
  gos?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор */
  id: Scalars['Int']['input'];
  /** MNKODP (ЦСУ) */
  mnkodp?: InputMaybe<Scalars['String']['input']>;
  /** Название */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Краткое название */
  short_name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePassengerCarrierEntityDto = {
  /** Код пассажирского перевозчика */
  code?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор */
  entity_id: Scalars['Int']['input'];
  /** Код государства (GOS ЦСУ) */
  gos?: InputMaybe<Scalars['Int']['input']>;
  is_lock: Scalars['Boolean']['input'];
  /** MNKODP (ЦСУ) */
  mnkodp?: InputMaybe<Scalars['String']['input']>;
  /** Название */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Краткое название */
  short_name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePeriodicityDto = {
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Дата и время начала курсирования */
  from_date: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  /** Массив элементов выбранной периодичности */
  metadata: Array<Scalars['String']['input']>;
  /** Периодичность */
  periodicity: Scalars['String']['input'];
  /** Дата и время окончания курсирования */
  to_date: Scalars['String']['input'];
};

export type UpdatePeriodicitySeasonDto = {
  /** Идентификатор */
  entity_id: Scalars['Int']['input'];
  /** Сезонность */
  periodicity_season?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateRailwayAdministrationDto = {
  /** Код */
  code?: InputMaybe<Scalars['Float']['input']>;
  /** Идентификатор */
  entity_id: Scalars['Int']['input'];
  /** Флаг СНГ или Дальнее зарубежье */
  international_mnemonic?: InputMaybe<Scalars['String']['input']>;
  /** Название */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Краткое название */
  short_name?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateRailwayDto = {
  /** Код железной дороги */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Наименование железной дороги */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор ЖД администрации */
  railway_administration_id?: InputMaybe<Scalars['Float']['input']>;
  /** Сокращённое наименование железной дороги */
  short_name?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Таймзона железной дороги относительно МСК времени */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoleDto = {
  id: Scalars['Float']['input'];
  is_fpk?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ruleIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type UpdateRoutesControlAvailabilitySeatsDirectionsDto = {
  /** Назначение направления */
  arrival_direction_id?: InputMaybe<Scalars['Int']['input']>;
  /** Назначение станции */
  arrival_stations_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Отправление направления */
  departure_direction_id?: InputMaybe<Scalars['Int']['input']>;
  /** Отправление станция */
  departure_stations_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Идентификатор */
  id: Scalars['Int']['input'];
  /** Блокировка направления */
  is_lock?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRuleDto = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Float']['input'];
  /** Метод */
  method?: InputMaybe<Scalars['String']['input']>;
  /** Id модуля */
  module_id?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSchemaControlTrainNmrvagDataDto = {
  data?: InputMaybe<Array<UpdateSchemaControlTrainNmrvagDto>>;
};

export type UpdateSchemaControlTrainNmrvagDto = {
  /** Идентификатор сущности для обновления */
  id: Scalars['Int']['input'];
  schema_carriage_quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSeatsAllocationViaAdditionalParametersDto = {
  /** Все места выделенные под признак */
  all_seats: Scalars['String']['input'];
  /** Примечание в свободной форме */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Id Тип признака мест */
  for_whom_seats_allocation_id: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Количество выделенных под признак мест */
  quantity: Scalars['Int']['input'];
};

export type UpdateStationDto = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Идентификатор записи версии станции */
  id: Scalars['Int']['input'];
  /** Возможность посадки/высадки пассажиров */
  is_board_or_disembark?: InputMaybe<Scalars['Boolean']['input']>;
  /** Осуществление пограничного и таможенного контроля */
  is_border_control?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена локомотива */
  is_change_locomotive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена локомотивной бригады без смены локомотива */
  is_change_locomotive_team?: InputMaybe<Scalars['Boolean']['input']>;
  /** Обслуживание экологически чистых туалетных комплексов (ЭЧТК) */
  is_eco_toilets?: InputMaybe<Scalars['Boolean']['input']>;
  /** Наличие электрических колонок 380В */
  is_electric_speakers_380V?: InputMaybe<Scalars['Boolean']['input']>;
  /** Наличие электрических колонок 3000В */
  is_electric_speakers_3000V?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена рода тока по станции (постоянный/переменный) */
  is_electricity_type?: InputMaybe<Scalars['Boolean']['input']>;
  /** Снабжение топливом */
  is_fuel_supply?: InputMaybe<Scalars['Boolean']['input']>;
  /** станция разрешённая для маневровой работы */
  is_maneuver_work?: InputMaybe<Scalars['Boolean']['input']>;
  /** Флаг "Вокзал не пренадлежит РЖД" */
  is_not_terminal_rgd?: InputMaybe<Scalars['Boolean']['input']>;
  /** Является ли станция маршрутообразующей */
  is_route_forming?: InputMaybe<Scalars['Boolean']['input']>;
  /** Обслуживание не по маршруту поезда */
  is_service_not_train_route?: InputMaybe<Scalars['Boolean']['input']>;
  /** Флаг "Южное направление" */
  is_southbound?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена вида тяги по станции (электровозная/тепловозная) */
  is_traction_type?: InputMaybe<Scalars['Boolean']['input']>;
  /** Сбор твёрдых бытовых отходов (ТБО) и шлака */
  is_waste_collection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Снабжение водой */
  is_water_supply?: InputMaybe<Scalars['Boolean']['input']>;
  /** Наименование станции для схемы */
  name_for_schema?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateStationNameDto = {
  id: Scalars['Int']['input'];
  name_for_schema?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStationVersionDto = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции */
  entity_id: Scalars['Int']['input'];
  /** Идентификатор записи версии станции */
  id: Scalars['Int']['input'];
  /** Возможность посадки/высадки пассажиров */
  is_board_or_disembark?: InputMaybe<Scalars['Boolean']['input']>;
  /** Осуществление пограничного и таможенного контроля */
  is_border_control?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена локомотива */
  is_change_locomotive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена локомотивной бригады без смены локомотива */
  is_change_locomotive_team?: InputMaybe<Scalars['Boolean']['input']>;
  /** Обслуживание экологически чистых туалетных комплексов (ЭЧТК) */
  is_eco_toilets?: InputMaybe<Scalars['Boolean']['input']>;
  /** Наличие электрических колонок 380В */
  is_electric_speakers_380V?: InputMaybe<Scalars['Boolean']['input']>;
  /** Наличие электрических колонок 3000В */
  is_electric_speakers_3000V?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена рода тока по станции (постоянный/переменный) */
  is_electricity_type?: InputMaybe<Scalars['Boolean']['input']>;
  /** Снабжение топливом */
  is_fuel_supply?: InputMaybe<Scalars['Boolean']['input']>;
  /** станция разрешённая для маневровой работы */
  is_maneuver_work?: InputMaybe<Scalars['Boolean']['input']>;
  /** Флаг "Вокзал не пренадлежит РЖД" */
  is_not_terminal_rgd?: InputMaybe<Scalars['Boolean']['input']>;
  /** Является ли станция маршрутообразующей */
  is_route_forming?: InputMaybe<Scalars['Boolean']['input']>;
  /** Обслуживание не по маршруту поезда */
  is_service_not_train_route?: InputMaybe<Scalars['Boolean']['input']>;
  /** Флаг "Южное направление" */
  is_southbound?: InputMaybe<Scalars['Boolean']['input']>;
  /** Смена вида тяги по станции (электровозная/тепловозная) */
  is_traction_type?: InputMaybe<Scalars['Boolean']['input']>;
  /** Сбор твёрдых бытовых отходов (ТБО) и шлака */
  is_waste_collection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Снабжение водой */
  is_water_supply?: InputMaybe<Scalars['Boolean']['input']>;
  /** Наименование станции для схемы */
  name_for_schema?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStatusResponseDto = {
  __typename: 'UpdateStatusResponseDto';
  /** Присвоенный поезду статус */
  status: Scalars['String']['output'];
};

export type UpdateStructuralSubdivisionDto = {
  /** Идентификатор филиала */
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор структурного подразделения */
  entity_id: Scalars['Int']['input'];
  /** Краткое наименование */
  short_name?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Идентификатор станции */
  station_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTimeSchedulerJobDto = {
  id: Scalars['Int']['input'];
  /** Время синхронизации */
  time: Scalars['String']['input'];
};

export type UpdateTractionDirectorateDto = {
  /** Идентификатор региональной дирекции тяги */
  entity_id: Scalars['Int']['input'];
  /** Флаг участия в расчетах ЛО */
  is_not_in_calculation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Название региональной дирекции тяги */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID железной дороги */
  railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Краткое наименование региональной дирекции тяги */
  short_name?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
};

export type UpdateTrainBrandDto = {
  /** Цвет наименования */
  background_color?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор */
  entity_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Наименование */
  train_brand?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrainCategoryDto = {
  /** Идентификатор категории поезда */
  entity_id: Scalars['Int']['input'];
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Категория поезда */
  train_category?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrainDto = {
  /** direct trains */
  direct: UpdateTrainSingleDto;
  /** reverse trains */
  reverse?: InputMaybe<UpdateTrainSingleReverseDto>;
};

export type UpdateTrainLocomotiveAreaDto = {
  /** Идентификатор секции локомотивного обслуживания */
  id: Scalars['Int']['input'];
  /** Идентификатор серии локомотива поезда */
  locomotive_series_id?: InputMaybe<Scalars['Int']['input']>;
  /** Бригады локомотивного обслуживания */
  team_areas: Array<UpdateTrainLocomotiveTeamAreaDto>;
  /** Идентификатор дирекции тяги */
  traction_directorate_id?: InputMaybe<Scalars['Int']['input']>;
  /** Стоимость (только для паровозов) */
  trip_cost?: InputMaybe<Scalars['Int']['input']>;
  /** Типы тока */
  types_current: Array<UpdateTypesCurrentDto>;
};

export type UpdateTrainLocomotiveAreasDto = {
  /** Идентификатор поезда */
  id: Scalars['Int']['input'];
  /** Бригады локомотивного обслуживания */
  locomotive_areas: Array<UpdateTrainLocomotiveAreaDto>;
  /** Идентификатор схемы поезда */
  schema_id: Scalars['Int']['input'];
  /** Идентификатор расписания поезда */
  train_schedule_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTrainLocomotiveTeamAreaDto = {
  /** Идентификатор секции бригады локомотивного обслуживания */
  id: Scalars['Int']['input'];
  /** Кол-во лиц в бригаде */
  persons_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор дирекции тяги */
  traction_directorate_id?: InputMaybe<Scalars['Int']['input']>;
  /** Стоимость (только для паровозов) */
  trip_cost?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTrainScheduleDto = {
  /** Фрагменты расписания */
  train_schedule_fragments: Array<CreateTrainScheduleFragmentDto>;
  train_schedule_id: Scalars['Int']['input'];
};

export type UpdateTrainSchemaDto = {
  /** Примечание для блока выделение мест */
  allocation_note?: InputMaybe<Scalars['String']['input']>;
  /** Информация для создания */
  create_data?: InputMaybe<CreateCudTrainSchemaDto>;
  /** Информация для удаления */
  delete_data?: InputMaybe<DeleteCudTrainSchemaDto>;
  /** Примечание для блока беспересадочные вагоны */
  direct_carriages_note?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор схемы */
  id: Scalars['Int']['input'];
  /** Установленная схема поезда по станциям ли */
  is_by_stations_established_train_schema?: InputMaybe<Scalars['Boolean']['input']>;
  /** Максимально допустимая длина поезда по станциям ли */
  is_by_stations_max_train_length?: InputMaybe<Scalars['Boolean']['input']>;
  /** Примечание для вагонов без признака фирменности */
  luxury_carriages_non_branded_note?: InputMaybe<Scalars['String']['input']>;
  /** Примечание для вагонов с сервисными услугами */
  luxury_carriages_note?: InputMaybe<Scalars['String']['input']>;
  /** Примечание для блока факультативные вагоны */
  optional_carriages_note?: InputMaybe<Scalars['String']['input']>;
  /** Примечание для блока прочие вагоны */
  other_carriages_note?: InputMaybe<Scalars['String']['input']>;
  /** Примечание для блока классы вагонов */
  service_class_note?: InputMaybe<Scalars['String']['input']>;
  /** Примечание для блока прицепные вагоны */
  trailed_carriages_note?: InputMaybe<Scalars['String']['input']>;
  /** Примечание для блока фирменность поезда */
  train_brand_note?: InputMaybe<Scalars['String']['input']>;
  /** Информация для обновления */
  update_data?: InputMaybe<UpdateCudTrainSchemaDto>;
  /** Переменный трафарет */
  variable_stencil_info?: InputMaybe<Scalars['String']['input']>;
  /** Примечание для блока переменный трафарет */
  variable_stencil_note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrainSchemaNoteForStationDto = {
  /** Примечание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Направление */
  direction?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции */
  for_station_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор сущности */
  id: Scalars['Int']['input'];
};

export type UpdateTrainSingleDto = {
  /** Дата и время прибытия */
  arrival_time?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор филиала */
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  /** Дата и время отправления */
  departure_time?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции отправления */
  from_station_id: Scalars['Int']['input'];
  /** Идентификатор графика движения поездов */
  gdp_id: Scalars['Int']['input'];
  /** Идентификатор поезда */
  id: Scalars['Int']['input'];
  /** Индивидуальное наименование */
  individual_name: Scalars['String']['input'];
  /** Является ли поезд "Дневным" */
  is_daytime?: InputMaybe<Scalars['Boolean']['input']>;
  /** дополнительный признак, который отображает несёт ли АО «ФПК» расходы на оплату услуг инфраструктуры */
  is_excluded_from_calculation_infrastructure_cost: Scalars['Boolean']['input'];
  /** Выводится ли в форму запроса */
  is_included_in_request_form?: Scalars['Boolean']['input'];
  /** Является ли поезд главным */
  is_main: Scalars['Boolean']['input'];
  /** Выводить периодичность отдельно по каждой схеме в форме запроса */
  is_periodicity_separate_request_form?: Scalars['Boolean']['input'];
  /** Идентификатор максимальной скорости поезда */
  max_train_speed_id?: InputMaybe<Scalars['Int']['input']>;
  /** Примечание */
  note?: InputMaybe<Scalars['String']['input']>;
  other_trains?: InputMaybe<Array<CreateOtherTrainsDto>>;
  /** Примечание к иным поездам */
  other_trains_note?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор перевозчика */
  passenger_carrier_russian_railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор периодичности */
  periodicity?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор сезонности */
  periodicity_season_id: Scalars['Int']['input'];
  /** Идентификатор ж/д администрации */
  railway_administration_id: Scalars['Int']['input'];
  /** Станции переприцепки */
  stations_recoupling?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции назначения */
  to_station_id: Scalars['Int']['input'];
  /** Идентификатор фирменности */
  train_brand_id: Scalars['Int']['input'];
  /** Номер поезда */
  train_number: Scalars['String']['input'];
  /** Идентификатор подкатегории поезда */
  train_sub_category_id: Scalars['Int']['input'];
};

export type UpdateTrainSingleReverseDto = {
  /** Дата и время прибытия */
  arrival_time?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор филиала */
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  /** Дата и время отправления */
  departure_time?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции отправления */
  from_station_id: Scalars['Int']['input'];
  /** Идентификатор графика движения поездов */
  gdp_id: Scalars['Int']['input'];
  /** Идентификатор поезда */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Индивидуальное наименование */
  individual_name: Scalars['String']['input'];
  /** Является ли поезд "Дневным" */
  is_daytime?: InputMaybe<Scalars['Boolean']['input']>;
  /** дополнительный признак, который отображает несёт ли АО «ФПК» расходы на оплату услуг инфраструктуры */
  is_excluded_from_calculation_infrastructure_cost: Scalars['Boolean']['input'];
  /** Выводится ли в форму запроса */
  is_included_in_request_form?: Scalars['Boolean']['input'];
  /** Является ли поезд главным */
  is_main: Scalars['Boolean']['input'];
  /** Выводить периодичность отдельно по каждой схеме в форме запроса */
  is_periodicity_separate_request_form?: Scalars['Boolean']['input'];
  /** Идентификатор максимальной скорости поезда */
  max_train_speed_id?: InputMaybe<Scalars['Int']['input']>;
  /** Примечание */
  note?: InputMaybe<Scalars['String']['input']>;
  other_trains?: InputMaybe<Array<CreateOtherTrainsDto>>;
  /** Примечание к иным поездам */
  other_trains_note?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор перевозчика */
  passenger_carrier_russian_railway_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор периодичности */
  periodicity?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор сезонности */
  periodicity_season_id: Scalars['Int']['input'];
  /** Идентификатор ж/д администрации */
  railway_administration_id: Scalars['Int']['input'];
  /** Станции переприцепки */
  stations_recoupling?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции назначения */
  to_station_id: Scalars['Int']['input'];
  /** Идентификатор фирменности */
  train_brand_id: Scalars['Int']['input'];
  /** Номер поезда */
  train_number: Scalars['String']['input'];
  /** Идентификатор подкатегории поезда */
  train_sub_category_id: Scalars['Int']['input'];
};

export type UpdateTrainStatusDto = {
  /** пропускает проверки и позволяет обновить статус */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  /** идентификатор поезда */
  train_id: Scalars['Int']['input'];
};

export type UpdateTrainSubCategoriesDetailsSpeedDto = {
  /** Идентификатор подкатегории поезда */
  entity_id: Scalars['Int']['input'];
  /** Название подкатегории */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Номера поездов */
  train_numbers_range?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор категории */
  train_sub_category_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTrainSubCategoryDto = {
  /** Идентификатор подкатегории поезда */
  entity_id: Scalars['Int']['input'];
  /** Краткое название подкатегории */
  short_train_sub_category?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Идентификатор категории */
  train_category_id?: InputMaybe<Scalars['Int']['input']>;
  /** Номера поездов */
  train_numbers_range?: InputMaybe<Scalars['String']['input']>;
  /** Название подкатегории */
  train_sub_category?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTransportationPerformanceIndicatorDto = {
  /** Идентификатор */
  entity_id: Scalars['Int']['input'];
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Начало действия */
  start_at: Scalars['String']['input'];
  /** Единица измерения */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Единица измерения(кратко) */
  unit_short?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTurnoverDto = {
  /** Идентификатор группы вагонов */
  carriage_group_id: Scalars['Int']['input'];
  /** Признак группы */
  group_sign?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор оборотки */
  id: Scalars['Int']['input'];
  /** Признак прицепной беспересадочной группы вагонов */
  is_pbg: Scalars['Boolean']['input'];
  /** Признак начальной позиции для продажи прямых билетов */
  is_start_position_for_sale_direct_tickets: Scalars['Boolean']['input'];
  /** Является ли признак перестоя переменным */
  is_time_stagnation_variable: Scalars['Boolean']['input'];
  /** Признак станции оборота ГВ для вывода в схему */
  is_turnover_station_for_schema: Scalars['Boolean']['input'];
  /** Расположение */
  position?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор станции отправления */
  station_from_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор станции назначения */
  station_to_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор поезда */
  train_id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификаторы схем */
  train_schema_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateTurnoverTimeStagnationDto = {
  /** Массив дат прибытия на станцию отцепки для временного признака перестоя */
  arrival_dates?: InputMaybe<Array<Scalars['String']['input']>>;
  carriage_group_id: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  /** Является ли признак перестоя переменным */
  is_time_stagnation_variable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Время перестоя группы в часах */
  time_in_stagnation?: InputMaybe<Scalars['Float']['input']>;
  turnover_id: Scalars['Int']['input'];
};

export type UpdateTypesCurrentDto = {
  /** Идентификатор станции отправления */
  from_station_id: Scalars['Int']['input'];
  /** Идентификатор типа тока на участке */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор классификатора типа тока */
  locomotive_type_current_id: Scalars['Int']['input'];
  /** Идентификатор станции прибытия */
  to_station_id: Scalars['Int']['input'];
};

export type UpdateUserDto = {
  /** Id филиала */
  branch_id?: InputMaybe<Scalars['Float']['input']>;
  /** Активность */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id филиала */
  division_id?: InputMaybe<Scalars['Float']['input']>;
  /** электронный почтовый адрес (e-mail) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Дата окончания действия */
  expiration_date?: InputMaybe<Scalars['String']['input']>;
  /** Польное имя сотрудника */
  full_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  /** Должность */
  job_position?: InputMaybe<Scalars['String']['input']>;
  /** Пароль */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Табельный номер сотрудника */
  personal_number?: InputMaybe<Scalars['Float']['input']>;
  /** Номер телефона */
  phone_number?: InputMaybe<Scalars['String']['input']>;
  /** Роли пользователя */
  role_ids?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Персональные правила пользователя */
  rule_ids?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Логин */
  user_name?: InputMaybe<Scalars['String']['input']>;
};

export type UploadScheduleDto = {
  file_link: Scalars['String']['input'];
  train_ids: Array<Scalars['Int']['input']>;
};

export type UserActionAuditDto = {
  __typename: 'UserActionAuditDto';
  /** Действие над сущностью */
  action: Scalars['String']['output'];
  create_by: UserDto;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Объект */
  target: Scalars['String']['output'];
  /** Id сущности */
  target_id: Scalars['Float']['output'];
  /** Предмет */
  typename: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type UserActionAuditList = {
  __typename: 'UserActionAuditList';
  items: Array<UserActionAuditDto>;
  totalCount: Scalars['Float']['output'];
};

export type UserDto = {
  __typename: 'UserDto';
  branch?: Maybe<BranchDto>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Активность */
  disabled: Scalars['Boolean']['output'];
  division?: Maybe<DivisionDto>;
  /** электронный почтовый адрес (e-mail) */
  email: Scalars['String']['output'];
  /** Дата окончания действия */
  expiration_date: Scalars['String']['output'];
  /** Польное имя сотрудника */
  full_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Учётная запись из LDAP */
  is_ldap: Scalars['Boolean']['output'];
  /** Необходимость очистки кэша браузера */
  is_need_to_clear_cache: Scalars['Boolean']['output'];
  /** Должность */
  job_position: Scalars['String']['output'];
  /** Табельный номер сотрудника */
  personal_number?: Maybe<Scalars['Float']['output']>;
  /** Номер телефона */
  phone_number?: Maybe<Scalars['String']['output']>;
  roles: Array<RoleDto>;
  rules?: Maybe<Array<RuleDto>>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  /** Логин */
  user_name: Scalars['String']['output'];
};

export type UserList = {
  __typename: 'UserList';
  items: Array<UserDto>;
  totalCount: Scalars['Float']['output'];
};

export type UserMessageDto = {
  __typename: 'UserMessageDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  payload: UserMessagePayloadDto;
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  viewed: Scalars['Boolean']['output'];
};

export type UserMessageListDto = {
  __typename: 'UserMessageListDto';
  items: Array<UserMessageDto>;
  totalCount: Scalars['Float']['output'];
};

export type UserMessagePayloadDataDto = {
  __typename: 'UserMessagePayloadDataDto';
  args?: Maybe<Scalars['JSONObject']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UserMessagePayloadDto = {
  __typename: 'UserMessagePayloadDto';
  data: UserMessagePayloadDataDto;
  type: Scalars['String']['output'];
};

export type UsersConfigDto = {
  __typename: 'UsersConfigDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  user_id: Scalars['Int']['output'];
};

export type UsersMutationEntryPoint = {
  __typename: 'UsersMutationEntryPoint';
  /** Завершение очистки кэша */
  clear_cache_success?: Maybe<Scalars['Boolean']['output']>;
  /** Создание нового пользователя */
  create: Scalars['Float']['output'];
  /** Удаление пользователя */
  delete?: Maybe<Scalars['Boolean']['output']>;
  /** Завершение сессии пользователя */
  terminate_session_for_me?: Maybe<Scalars['Void']['output']>;
  /** Завершение сессий пользователя(админом) */
  terminate_session_user?: Maybe<Scalars['Void']['output']>;
  /** Изменение пользователя */
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type UsersMutationEntryPointCreateArgs = {
  data: CreateUserDto;
};


export type UsersMutationEntryPointDeleteArgs = {
  data: DeleteUserDto;
};


export type UsersMutationEntryPointTerminate_Session_For_MeArgs = {
  sid: Scalars['String']['input'];
};


export type UsersMutationEntryPointTerminate_Session_UserArgs = {
  sid: Scalars['String']['input'];
  user_id: Scalars['Float']['input'];
};


export type UsersMutationEntryPointUpdateArgs = {
  data: UpdateUserDto;
};

export type UsersQueryEntryPoint = {
  __typename: 'UsersQueryEntryPoint';
  /** Получить пользователя по id */
  by_id?: Maybe<UserDto>;
  /** Список пользователей */
  list: UserList;
  /** Получить текущего пользователя */
  me: UserDto;
  /** Получить текущего пользователя */
  me_sessions: SessionInformationList;
  /** Получить системные данные другого пользователя */
  sessions_list: SessionInformationList;
};


export type UsersQueryEntryPointBy_IdArgs = {
  id: Scalars['Float']['input'];
};


export type UsersQueryEntryPointListArgs = {
  order_by?: InputMaybe<Array<UsersQueryResolver_List_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<UsersQueryResolver_List_FilterInputType>;
};


export type UsersQueryEntryPointSessions_ListArgs = {
  id: Scalars['Float']['input'];
};

export type UsersQueryResolver_List_BaseFilterInputType = {
  and?: InputMaybe<Array<UsersQueryResolver_List_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  disabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  is_need_to_clear_cache?: InputMaybe<Boolean_PropertyFilterInputType>;
  job_position?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<UsersQueryResolver_List_BaseFilterInputType>>;
  personal_number?: InputMaybe<Number_PropertyFilterInputType>;
  phone_number?: InputMaybe<String_PropertyFilterInputType>;
  role_id?: InputMaybe<Int_PropertyFilterInputType>;
  user_name?: InputMaybe<String_PropertyFilterInputType>;
};

export type UsersQueryResolver_List_FilterInputType = {
  and?: InputMaybe<Array<UsersQueryResolver_List_BaseFilterInputType>>;
  branch_id?: InputMaybe<Int_PropertyFilterInputType>;
  disabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  is_need_to_clear_cache?: InputMaybe<Boolean_PropertyFilterInputType>;
  job_position?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<UsersQueryResolver_List_BaseFilterInputType>>;
  personal_number?: InputMaybe<Number_PropertyFilterInputType>;
  phone_number?: InputMaybe<String_PropertyFilterInputType>;
  role_id?: InputMaybe<Int_PropertyFilterInputType>;
  user_name?: InputMaybe<String_PropertyFilterInputType>;
};

export type UsersQueryResolver_List_SortingInputType = {
  created_at?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  disabled?: InputMaybe<SortType>;
  email?: InputMaybe<SortType>;
  expiration_date?: InputMaybe<SortType>;
  full_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_ldap?: InputMaybe<SortType>;
  is_need_to_clear_cache?: InputMaybe<SortType>;
  job_position?: InputMaybe<SortType>;
  personal_number?: InputMaybe<SortType>;
  phone_number?: InputMaybe<SortType>;
  updated_at?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  user_name?: InputMaybe<SortType>;
};

export type WasteCollectionDto = {
  __typename: 'WasteCollectionDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  /** Направление */
  direction: Scalars['String']['output'];
  for_station: StationDto;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type WaterSupplyDto = {
  __typename: 'WaterSupplyDto';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  description?: Maybe<Scalars['String']['output']>;
  /** Направление */
  direction: Scalars['String']['output'];
  for_station: StationDto;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type WorkingGdpDto = {
  /** Вариант ГДП: текущий или следующий (current | next) */
  variant: Scalars['String']['input'];
};

export type LocomotiveFinalCalculationsByDirectoratesItemDto = {
  __typename: 'locomotiveFinalCalculationsByDirectoratesItemDto';
  /** Стоимость за расход топлива, тыс. руб */
  gas_price: Scalars['Float']['output'];
  /** Итого стоимость локомотивов, руб */
  locomotive_cost: Scalars['Float']['output'];
  /** Стоимость аренды локомотивов, тыс. руб */
  locomotive_rent_cost: Scalars['Float']['output'];
  /** Стоимость обслуживания и ремонта, тыс. руб */
  locomotive_tech_service_price: Scalars['Float']['output'];
  /** Дирекция тяги */
  name: Scalars['String']['output'];
  /** Стоимость за расход электроэнергии, тыс. руб */
  power_price: Scalars['Float']['output'];
  /** Итого стоимость бригад, руб */
  team_cost: Scalars['Float']['output'];
  /** ИТОГО суммарно за период, руб. */
  total_cost: Scalars['Float']['output'];
};

export type BorderControlBaseFragmentFragment = { __typename: 'BorderControlDto', id: number, direction: string, description?: string | null };

export type BorderControlFragmentFragment = { __typename: 'BorderControlDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null } };

export type CarriageBaseFragmentFragment = { __typename: 'CarriageDto', id: number, rolling_stock_type: string, is_lock: boolean };

export type CarriageAdditionalParameterBaseFragmentFragment = { __typename: 'CarriageAdditionalParameterDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null };

export type CarriageAdditionalSeatsSignBaseFragmentFragment = { __typename: 'CarriageAdditionalSeatsSignDto', id: number, all_seats: Array<number>, quantity?: number | null, description?: string | null };

export type CarriageGroupBaseFragmentFragment = { __typename: 'CarriageGroupDto', id: number, status: string, step_status: string, is_lock: boolean, is_manual_trip_formation_for_schema: boolean, name: string, rolling_stock_type: string, parent_id?: number | null, version: number, start_at: string, end_at: string };

export type CarriageGroupViewFragmentFragment = { __typename: 'CarriageGroupViewDto', id?: number | null, name?: string | null, branch_id?: number | null, passenger_carriers_id?: number | null, railway_administration_id?: number | null, structural_subdivision_id?: number | null, rolling_stock_type?: string | null, step_status?: string | null, status?: string | null, train_numbers?: Array<string> | null, train_statuses?: Array<string> | null, from_stations?: Array<string> | null, to_stations?: Array<string> | null, branch?: string | null, passenger_carrier?: string | null, railway_administration?: string | null, structural_subdivision?: string | null, min_train_quantity?: number | null, max_train_quantity?: number | null, min_turnaround_time?: number | null, max_turnaround_time?: number | null, carriage_dimension_ids?: Array<number> | null, train_ids?: Array<number> | null, dimensions?: string | null, carriage_types?: Array<string> | null, periodicity?: Array<string> | null, parent_id?: number | null, station_affiliation?: string | null, first_departure_date?: string | null, version: number, start_at: string, end_at: string };

export type CarriageGroupTurnoverChartItemBaseFragmentFragment = { __typename: 'CarriageGroupTurnoverChartDataDto', category: string, from_date: string, to_date: string, train_number: string, station?: string | null, train_from_station: string, train_to_station: string, turnover_from_station: string, turnover_to_station: string, is_formation_point: boolean, is_turnover_point: boolean, trip_time: number };

export type CarriageGroupTurnoverTrainInfoBaseFragmentFragment = { __typename: 'CarriageGroupTurnoverChartTrainInfoDto', branch: string, name: string, rolling_stock_type: string, structural_subdivision: string, train_quantity: string, turnover_time: string, passenger_carriers: string, railway_administration: string };

export type CarriageMvpsBaseFragmentFragment = { __typename: 'CarriageMvpsDto', id: number, start_at: string, end_at: string, seats_quantity: number, is_lock: boolean, lineup_length?: number | null };

export type CarriageNpsBaseFragmentFragment = { __typename: 'CarriageNpsDto', id: number, created_by?: number | null, updated_by?: number | null, created_at: string, updated_at: string, start_at: string, end_at: string, is_eco_toilets: boolean, is_air_conditioner: boolean, is_centralized_power_supply: boolean, seats_quantity: number, is_lock: boolean };

export type CarriageParameterBaseFragmentFragment = { __typename: 'CarriageParameterDto', id: number, is_all_additional_parameter_order_numbers_set: boolean, number_from_head: number };

export type CarriageSeatsAllocationBaseFragmentFragment = { __typename: 'CarriageSeatsAllocationDto', id: number, all_seats: Array<number>, quantity?: number | null, description?: string | null };

export type DeclineHistoryBaseFragmentFragment = { __typename: 'DeclineHistoryDto', id: number, created_at: string, comment: string };

export type TrailedDirectGroupRouteDetailBaseFragmentFragment = { __typename: 'TrailedDirectGroupRouteDetailsItemDto', train_id: number, train_number: string, station_from: string, station_to: string, position: string };

export type TrailedDirectGroupBaseFragmentFragment = { __typename: 'TrailedDirectGroupResponseDto', status: string, rolling_stock_type: string, carriage_group_id: number, parent_id?: number | null };

export type TrailedDirectGroupItemBaseFragmentFragment = { __typename: 'TrailedDirectGroupListItemResponseDto', id: number, carriages_total: number };

export type TrailedDirectGroupItemFragmentFragment = { __typename: 'TrailedDirectGroupListItemFragmentDto', station_recouple: Array<string>, train_numbers: Array<string>, time_total: number, station_from: { __typename: 'StationResponseDto', entity_id: number, full_name: string }, station_to: { __typename: 'StationResponseDto', entity_id: number, full_name: string } };

export type TrailedDirectGroupScheduleBaseFragmentFragment = { __typename: 'TrailedDirectGroupScheduleDto', direct_time_total: number, reverse_time_total: number };

export type TrailedDirectGroupScheduleFragmentBaseFragmentFragment = { __typename: 'TrailedDirectGroupScheduleFragmentDto', order_number: number, direct_train_number?: string | null, reverse_train_number?: string | null, direct_train_id?: number | null, reverse_train_id?: number | null, direct_arrival?: number | null, reverse_arrival?: number | null, direct_parking?: number | null, reverse_parking?: number | null, is_direct_schedule_technical_parking?: boolean | null, is_reverse_schedule_technical_parking?: boolean | null, direct_departure?: number | null, reverse_departure?: number | null, distance: number, reverse_train_number_from_schedule?: string | null, direct_train_number_from_schedule?: string | null, direct_train_stations?: string | null, reverse_train_stations?: string | null };

export type TrailedDirectGroupSchemaAdditionalInfoBaseFragmentFragment = { __typename: 'TrailedDirectGroupSchemaAdditionalInfoDto', train_quantity?: number | null, structural_subdivision: string, brake_types?: Array<string> | null, heating_types?: Array<string> | null, eco_toilets?: string | null, air_conditioner?: string | null };

export type TrailedDirectGroupSchemaParametersBaseFragmentFragment = { __typename: 'TrailedDirectGroupSchemaCarriageDto', carriage_number: string, carriage_type: string, turnover_points: Array<string>, seats_sv_total: number, seats_sv_allocated: number, seats_coupe_total: number, seats_coupe_allocated: number, seats_second_class_total: number, seats_second_class_allocated: number, seats_common_total: number, seats_common_allocated: number };

export type TrailedDirectGroupSchemaPeriodicityInfoBaseFragmentFragment = { __typename: 'TrailedDirectGroupPeriodicityInfoDto', train_number: string, departure_dates: Array<string>, arrival_dates: Array<string>, from_station: string, to_station: string, is_direct: boolean };

export type TrailedDirectGroupSchemaSummaryBaseFragmentFragment = { __typename: 'TrailedDirectGroupSchemaSummaryDto', seats_sv_total: number, seats_sv_allocated: number, seats_coupe_total: number, seats_coupe_allocated: number, seats_second_class_total: number, seats_second_class_allocated: number, seats_common_total: number, seats_common_allocated: number, seats_summary_total: number, seats_summary_allocated: number };

export type TrailedDirectGroupStationBaseFragmentFragment = { __typename: 'StationResponseDto', id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, railway_id: number, is_waste_collection: boolean, is_water_supply: boolean, is_traction_type: boolean, is_maneuver_work: boolean };

export type TrailedDirectGroupViewFragmentFragment = { __typename: 'TrailedDirectGroupListItemResponseDto', carriages_total: number, parent_id?: number | null, id: number, direct: { __typename: 'TrailedDirectGroupListItemFragmentDto', station_recouple: Array<string>, train_numbers: Array<string>, time_total: number, station_from: { __typename: 'StationResponseDto', entity_id: number, full_name: string }, station_to: { __typename: 'StationResponseDto', entity_id: number, full_name: string } }, reverse: { __typename: 'TrailedDirectGroupListItemFragmentDto', station_recouple: Array<string>, train_numbers: Array<string>, time_total: number, station_from: { __typename: 'StationResponseDto', entity_id: number, full_name: string }, station_to: { __typename: 'StationResponseDto', entity_id: number, full_name: string } }, carriage_group: { __typename: 'CarriageGroupDto', id: number, status: string, rolling_stock_type: string, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, code: number }, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, periodicities: Array<{ __typename: 'PeriodicityDto', id: number, periodicity: string }> }, carriage_type_params_count: Array<{ __typename: 'CarriageGroupCarriageTypeParamsCountDto', carriage_type: string, quantity: number }> };

export type TurnaroundTimeBaseFragmentFragment = { __typename: 'TurnaroundTimeDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, turn_around_time: number, departure_dates: Array<string>, arrival_dates_with_time_stagnation: Array<string> };

export type TurnoverBaseFragmentFragment = { __typename: 'TurnoverDto', id: number, accepted_train_schemas_ids?: Array<number> | null, arrival_dates: Array<string>, arrival_dates_with_time_stagnation: Array<string>, departure_dates: Array<string>, group_sign: string, is_pbg: boolean, is_schemas_accepted: boolean, is_start_position_for_sale_direct_tickets: boolean, is_time_stagnation_variable: boolean, is_turnover_station_for_schema: boolean, order_number: number, position: string, seats_for_sale?: number | null, seats_total?: number | null };

export type TurnoverTimeStagnationBaseFragmentFragment = { __typename: 'TurnoverTimeStagnationDto', id: number, created_at: string, created_by?: number | null, updated_at: string, updated_by?: number | null, time_in_stagnation: number, arrival_dates: Array<string> };

export type CarriageNumerationBaseFragmentFragment = { __typename: 'CarriageNumerationDto', id: number, direct_position?: string | null, reverse_position?: string | null, description?: string | null };

export type CarriageNumerationFragmentFragment = { __typename: 'CarriageNumerationDto', id: number, direct_position?: string | null, reverse_position?: string | null, description?: string | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null };

export type CarriageServiceClassBaseFragmentFragment = { __typename: 'CarriageServiceClassDto', id: number, entity_id: number, start_at: string, end_at: string };

export type CarriageTrainInfoBaseFragmentFragment = { __typename: 'CarriageTrainInfoDto', id: number, order_number?: string | null, notes?: string | null, carriage_additional_parameters: Array<string> };

export type AvailableServiceClassBaseFragmentFragment = { __typename: 'AvailableServiceClassDto', id: number, entity_id: number, start_at: string, end_at: string, service_class: string };

export type BranchBaseFragmentFragment = { __typename: 'BranchDto', start_at: string, end_at: string, entity_id: number, name: string, short_name: string, name_nmrvag: string, vladr: string };

export type BranchShortFragmentFragment = { __typename: 'BranchDto', entity_id: number, name: string, short_name: string };

export type CarriageAdditionalSeatSignBaseFragmentFragment = { __typename: 'CarriageAdditionalSeatSignDto', entity_id: number, id: number, start_at: string, end_at: string, name: string };

export type CarriageAllocationBaseFragmentFragment = { __typename: 'CarriageAllocationDto', id: number, carriage_number: string, seats: string, appointment: string, description?: string | null };

export type CarriageClassesBaseFragmentFragment = { __typename: 'CarriageClassDto', id: number, carriage_number: string, class: string, note?: string | null };

export type CarriageSeatAllocationBaseFragmentFragment = { __typename: 'CarriageSeatAllocationDto', id: number, entity_id: number, start_at: string, end_at: string, name: string };

export type CarriageSeatAllocationShortFragmentFragment = { __typename: 'CarriageSeatAllocationDto', entity_id: number, start_at: string, name: string };

export type CarriageTypeBaseFragmentFragment = { __typename: 'CarriageTypeDto', entity_id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string, regulatory_sector: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, seat_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, rolling_stock_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string } };

export type CarriageTypeAsuBaseFragmentFragment = { __typename: 'CarriageTypeAsuDto', entity_id: number, start_at: string, end_at: string, short_name: string, full_name: string };

export type CarriageTypeAsuDimensionSeatsCountShortFragmentFragment = { __typename: 'CarriageTypeAsuDimensionSeatsCountDto', id: number, default_seats_count: number };

export type CarriageTypeCsuBaseFragmentFragment = { __typename: 'CsuCarriageTypeDto', id: number, name: string, subtypes: Array<number>, type: string };

export type CarriageTypesForSchemaBaseFragmentFragment = { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string, carriage_type_asu?: { __typename: 'CarriageTypeAsuDto', id: number, entity_id: number, full_name: string, short_name: string } | null };

export type CarriageTypesForSchemaShortFragmentFragment = { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string };

export type ConditionalCarriageNumbersBaseFragmentFragment = { __typename: 'ConditionalCarriageNumberDto', id: number, conditional_carriage_number: number };

export type GdpBaseFragmentFragment = { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string };

export type GdpShortFragmentFragment = { __typename: 'GdpDto', id: number, start_at: string, end_at: string };

export type InfrastructureApplication23BaseFragmentFragment = { __typename: 'InfrastructureApplication23Dto', id: number, distance_end: number, distance_start: number, express_v_91_140_m_15_30_i1: number, express_v_91_140_m_15_30_i2: number, express_v_91_140_m_15_30_i3: number, express_v_91_140_m_30_70_i1: number, express_v_91_140_m_30_70_i2: number, express_v_91_140_m_30_70_i3: number, express_v_140_etc_m_15_70_i1: number, express_v_140_etc_m_15_70_i2: number, express_v_140_etc_m_15_70_i3: number, fast_i1: number, fast_i2: number, fast_i3: number, passenger_i1: number, passenger_i2: number, passenger_i3: number };

export type InfrastructureApplication24BaseFragmentFragment = { __typename: 'InfrastructureApplication24Dto', id: number, distance_end: number, distance_start: number, express_i1: number, express_i2: number, express_i3: number, fast_i1: number, fast_i2: number, fast_i3: number, passenger_i1: number, passenger_i2: number, passenger_i3: number };

export type InfrastructureApplication25BaseFragmentFragment = { __typename: 'InfrastructureApplication25Dto', id: number, distance_end: number, distance_start: number, fast_i1: number, fast_i2: number, fast_i3: number, passenger_i1: number, passenger_i2: number, passenger_i3: number, express_v1_140_etc_v2_160_etc_m1_30_75_i1: number, express_v1_140_etc_v2_160_etc_m1_30_75_i2: number, express_v1_140_etc_v2_160_etc_m1_30_75_i3: number, express_v1_91_140_v2_0_140_m1_30_75_i1: number, express_v1_91_140_v2_0_140_m1_30_75_i2: number, express_v1_91_140_v2_0_140_m1_30_75_i3: number, express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i1: number, express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i2: number, express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i3: number, express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i1: number, express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i2: number, express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i3: number, express_v91_140_etc_v2_160_etc_m1_30_75_i1: number, express_v91_140_etc_v2_160_etc_m1_30_75_i2: number, express_v91_140_etc_v2_160_etc_m1_30_75_i3: number };

export type InfrastructureApplication26BaseFragmentFragment = { __typename: 'InfrastructureApplication26Dto', id: number, distance_end: number, distance_start: number, express_i1: number, express_i2: number, express_i3: number, fast_i1: number, fast_i2: number, fast_i3: number, passenger_i1: number, passenger_i2: number, passenger_i3: number };

export type InfrastructureApplication27ShortFragmentFragment = { __typename: 'InfrastructureApplication27Dto', id: number, price: number };

export type InfrastructureCoefficientIndexingBaseFragmentFragment = { __typename: 'InfrastructureCoefficientIndexingDto', id: number, start_at: string, end_at: string, coefficient: number };

export type InfrastructureCoefficientIndexingShortFragmentFragment = { __typename: 'InfrastructureCoefficientIndexingDto', id: number, coefficient: number };

export type LocomotivePriceTechnicalServiceBaseFragmentFragment = { __typename: 'LocomotivePriceTechnicalServiceDto', entity_id: number, maintenance_cost?: number | null, series_type: { __typename: 'LocomotiveSeriesTypeDto', id: number, name: string }, locomotive_series: { __typename: 'LocomotiveSeriesDto', id: number, entity_id: number, series: string, index?: string | null, section_quantity: number, price_rent: number, locomotive_traction_type_id?: number | null, start_at: string }, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } };

export type LocomotiveSeriesBaseFragmentFragment = { __typename: 'LocomotiveSeriesDto', id: number, entity_id: number, series: string, index?: string | null, section_quantity: number, price_rent: number, locomotive_traction_type_id?: number | null, start_at: string };

export type LocomotiveSeriesShortFragmentFragment = { __typename: 'LocomotiveSeriesDto', entity_id: number, series: string, index?: string | null, start_at: string };

export type LocomotiveSeriesTypeBaseFragmentFragment = { __typename: 'LocomotiveSeriesTypeDto', id: number, name: string };

export type LocomotiveSeriesTypeShortFragmentFragment = { __typename: 'LocomotiveSeriesTypeDto', id: number, name: string };

export type LocomotiveServiceEmpiricalParameterBaseFragmentFragment = { __typename: 'LocomotiveServiceEmpiricalParameterDto', entity_id: number, value: number };

export type LocomotiveTeamPriceRentBaseFragmentFragment = { __typename: 'LocomotiveTeamPriceRentDto', entity_id: number, price_electric_locomotive_one_person: number, price_electric_locomotive_two_person: number, price_warm_locomotive_one_person: number, price_warm_locomotive_two_person: number };

export type LocomotiveTractionTypeBaseFragmentFragment = { __typename: 'LocomotiveTractionTypeDto', id: number, name: string, short_name: string };

export type LocomotiveTypeCurrentBaseFragmentFragment = { __typename: 'LocomotiveTypeCurrentDto', id: number, name: string };

export type LocomotiveTypeCurrentShortFragmentFragment = { __typename: 'LocomotiveTypeCurrentDto', id: number, name: string };

export type MaxTrainSpeedBaseFragmentFragment = { __typename: 'MaxTrainSpeedDto', id: number, entity_id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string, max_train_speed: number };

export type MaxTrainSpeedShortFragmentFragment = { __typename: 'MaxTrainSpeedDto', id: number, entity_id: number, max_train_speed: number };

export type MnemonicBaseFragmentFragment = { __typename: 'MnemonicDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string };

export type MnemonicShortFragmentFragment = { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string };

export type MvpsCompanyAffiliationBaseFragmentFragment = { __typename: 'MvpsCompanyAffiliationDto', entity_id: number, id: number, mvps_owner: string, start_at: string, end_at: string };

export type MvpsCompanyAffiliationShortFragmentFragment = { __typename: 'MvpsCompanyAffiliationDto', entity_id: number, mvps_owner: string, start_at: string };

export type MvpsMartinSectionTypeEquipmentShortFragmentFragment = { __typename: 'MvpsMartinSectionTypeEquipmentDto', entity_id: number, equipment: string };

export type MvpsMartinSectionTypeBaseFragmentFragment = { __typename: 'MvpsMartinSectionTypeDto', id: number, entity_id: number, start_at: string, end_at: string, series: string, mvps_martin_section_type_equipment_id: number, carriage_quantity_in_section: number, price: number };

export type MvpsMartinSectionTypeShortFragmentFragment = { __typename: 'MvpsMartinSectionTypeDto', id: number, series: string, carriage_quantity_in_section: number };

export type MvpsRateManagementExploitationMaintenanceRepairBaseFragmentFragment = { __typename: 'MvpsRateManagementExploitationMaintenanceRepairDto', entity_id: number, price: number, start_at: string, end_at: string };

export type MvpsRateManagementExploitationMaintenanceRepairShortFragmentFragment = { __typename: 'MvpsRateManagementExploitationMaintenanceRepairDto', entity_id: number, price: number };

export type NonPassengerCarriageTypeBaseFragmentFragment = { __typename: 'NonPassengerCarriageTypeDto', entity_id: number, created_at: string, updated_at: string, start_at: string };

export type NpsCarriageBrakeTypeBaseFragmentFragment = { __typename: 'NpsCarriageBrakeTypeDto', id: number, entity_id: number, start_at: string, end_at: string, brake_type: string, description?: string | null };

export type NpsCarriageDimensionBaseFragmentFragment = { __typename: 'NpsCarriageDimensionDto', id: number, entity_id: number, start_at: string, end_at: string, carriage_dimension: string, description?: string | null };

export type NpsCarriageDimensionShortFragmentFragment = { __typename: 'NpsCarriageDimensionDto', entity_id: number, start_at: string, end_at: string, carriage_dimension: string };

export type NpsCarriageHeatTypeBaseFragmentFragment = { __typename: 'NpsCarriageHeatTypeDto', id: number, entity_id: number, start_at: string, end_at: string, heat_type: string, description?: string | null };

export type NpsCarriageLengthBaseFragmentFragment = { __typename: 'NpsCarriageLengthDto', id: number, entity_id: number, start_at: string, end_at: string, carriage_length_asu_ms: number, carriage_length_in_train_schema: number, description?: string | null };

export type NpsCarriageModelBaseFragmentFragment = { __typename: 'NpsCarriageModelDto', entity_id: number, id: number, start_at: string, end_at: string, carriage_model: string, description?: string | null };

export type PassengerCarrierBaseFragmentFragment = { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string, code: number, mnkodp: string, gos: number, is_lock: boolean };

export type PassengerCarrierShortFragmentFragment = { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string };

export type PeriodicitySeasonBaseFragmentFragment = { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string };

export type RailwayBaseFragmentFragment = { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null };

export type RailwayShortFragmentFragment = { __typename: 'RailwayDto', entity_id: number, code: string, name: string, short_name: string };

export type RailwayAdministrationBaseFragmentFragment = { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null };

export type RailwayAdministrationShortFragmentFragment = { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, code: number };

export type StationBaseFragmentFragment = { __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null };

export type StationShortFragmentFragment = { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string };

export type StationShortFragmentWithOperationsFragment = { __typename: 'StationDto', is_change_locomotive: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_traction_type: boolean, is_electric_speakers_3000V: boolean, is_board_or_disembark: boolean, is_electricity_type: boolean, is_electric_speakers_380V: boolean, is_eco_toilets: boolean, is_border_control: boolean, is_fuel_supply: boolean, is_southbound: boolean, is_change_locomotive_team: boolean, is_maneuver_work: boolean, entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string };

export type StructuralSubdivisionBaseFragmentFragment = { __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string };

export type TractionDirectorateBaseFragmentFragment = { __typename: 'TractionDirectorateDto', id: number, entity_id: number, start_at: string, end_at: string, name: string, short_name: string, is_not_in_calculation: boolean };

export type TractionDirectorateShortFragmentFragment = { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string };

export type TrainBrandBaseFragmentFragment = { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string };

export type TrainCategoryBaseFragmentFragment = { __typename: 'TrainCategoryDto', entity_id: number, created_at: string, updated_at: string, train_category: string, start_at: string, end_at: string };

export type TrainNumberAutocompleteFragmentFragment = { __typename: 'TrainDto', id: number, train_number: string, version: number, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, schedule?: { __typename: 'TrainScheduleDto', id: number } | null };

export type TrainSubCategoryBaseFragmentFragment = { __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, short_train_sub_category: string, created_at: string, updated_at: string, background_color: string, start_at: string, end_at: string, train_numbers: string };

export type TrainSubCategoryShortFragmentFragment = { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string, background_color: string, train_category_id: number };

export type TrainSubCategoryShortSpeedFragmentFragment = { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string };

export type TransportationPerformanceIndicatorsBaseFragmentFragment = { __typename: 'TransportationPerformanceIndicatorDto', entity_id: number, name: string, unit: string, unit_short: string };

export type EducationFragmentFragment = { __typename: 'EducationDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null };

export type FaqFragmentFragment = { __typename: 'FaqDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null };

export type NewsFragmentFragment = { __typename: 'NewsDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null };

export type NewsFragmentShortFragment = { __typename: 'NewsDto', id: number, title: string, created_at: string, updated_at: string };

export type FeatureFlagFragmentFragment = { __typename: 'FeatureFlagsDto', id: number, name: string, value: string, description?: string | null };

export type DirectCarriagesBaseFragmentFragment = { __typename: 'DirectCarriageDto', id: number, carriage_numbers: string, description?: string | null };

export type DirectCarriagesFragmentFragment = { __typename: 'DirectCarriageDto', id: number, carriage_numbers: string, description?: string | null, direct_carriages_info: Array<{ __typename: 'DirectCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> };

export type DirectCarriagesInfoBaseFragmentFragment = { __typename: 'DirectCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string> };

export type DirectCarriagesInfoFragmentFragment = { __typename: 'DirectCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } };

export type EcoToiletsBaseFragmentFragment = { __typename: 'EcoToiletDto', id: number, direction: string, description?: string | null };

export type EcoToiletsFragmentFragment = { __typename: 'EcoToiletDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } };

export type EstablishedTrainSchemaRailwayFragmentFragment = { __typename: 'EstablishedTrainSchemaRailwayDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null };

export type EstablishedTrainSchemaStationFragmentFragment = { __typename: 'EstablishedTrainSchemaStationDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null };

export type FuelSupplyBaseFragmentFragment = { __typename: 'FuelSupplyDto', id: number, direction: string, description?: string | null };

export type FuelSupplyFragmentFragment = { __typename: 'FuelSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } };

export type CarriageDistributionMainGroupBaseFragmentFragment = { __typename: 'TrainIndicatorsCarriagesDistributionDto', seats_quantity: number, seats_quantity_k: number, seats_quantity_o: number, seats_quantity_pl: number, seats_quantity_sv: number };

export type CarriageDistributionBaseFragmentFragment = { __typename: 'TrainIndicatorsCarriagesCountDto', carriage_number: string, carriage_service_class: Array<string>, carriage_type: string, seats_quantity?: number | null };

export type CarriageGroupIndicatorsSchemaItemBaseFragmentFragment = { __typename: 'CarriageGroupIndicatorsSchemaItemDto', seat_type: string, carriage_type: string, carriage_quantity: number, seats_quantity: number, seats_for_sale: number, average_capacity: number, carriage_quantity_req: number };

export type CarriageTypesBaseFragmentFragment = { __typename: 'CarriageGroupIndicatorsTypeParamsCountDto', carriage_type: string, quantity: number, seats_quantity: number, carriage_classes: Array<string> };

export type CarriageQuantityMainGroupBaseFragmentFragment = { __typename: 'CarriageQuantityMainGroupDto', trips_quantity: number, carriage_quantity: number, train_quantity: number, train_turnover: number };

export type CompositionSchemaBaseFragmentFragment = { __typename: 'CompositionSchemaDto', sign: string, carriage_group_id: number };

export type CompositionSchemaItemTotalBaseFragmentFragment = { __typename: 'CompositionSchemaItemTotalDto', carriage_quantity?: number | null, seats_quantity?: number | null, seats_for_sale?: number | null, average_capacity?: number | null, carriage_quantity_req?: number | null };

export type CruisingOrderBaseFragmentFragment = { __typename: 'CruisingOrderDto', sign: string };

export type CruisingOrderItemBaseFragmentFragment = { __typename: 'CruisingOrderItemDto', train_number: string, distance: number };

export type IndicatorsByTrainCarriageTypesBaseFragmentFragment = { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number };

export type IndicatorsByTrainCarriageTypesOmitTotalBaseFragmentFragment = { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number };

export type IndicatorsByTrainCarriagesBaseFragmentFragment = { __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null };

export type IndicatorsTrainBaseFragmentFragment = { __typename: 'IndicatorsTrainDto', train_id: number, train_number: string, from_station: string, to_station: string, status: string, start_at: string, end_at: string, route_duration: number, railway_administration?: string | null, passenger_carrier_russian_railway?: string | null, branch?: string | null, version: number };

export type IndicatorsTrainShortFragmentFragment = { __typename: 'IndicatorsTrainDto', train_id: number, train_number: string, from_station: string, to_station: string, status: string, start_at: string, end_at: string };

export type MvpsParkRequiredBaseFragmentFragment = { __typename: 'MvpsParkRequiredDto', carriage_type: string, seat_type: string, departures_quantity?: number | null, equipment: string, carriage_quantity: number };

export type NpsParkRequiredBaseFragmentFragment = { __typename: 'NpsParkRequiredDto', seat_type: string, departures_quantity?: number | null, carriage_type: string };

export type TrainHeadIndicatorsBaseFragmentFragment = { __typename: 'TrainHeaderIndicatorsDto', train_quantity: number, train_turnover: number, carriage_quantity: number, carriage_quantity_passenger: number, average_capacity: number, seats_for_sale: number, carriage_turnover: number, carriage_turnover_passenger: number, seats_turnover: number };

export type TrainIndicatorsHeaderBaseFragmentFragment = { __typename: 'TrainIndicatorsHeaderDto', train_quantity?: number | null, structural_subdivision_id?: number | null, rolling_stock_type: string, trips_quantity: number, train_schema_ids: Array<number>, distance: number };

export type TrainPerformanceIndicatorsSchemaItemBaseFragmentFragment = { __typename: 'TrainPerformanceIndicatorsSchemaItemDto', turnover_ids: Array<number>, sign: string, carriage_group_turnover?: number | null, carriage_group_in_train_turnover?: number | null, carriage_group_distance?: number | null, carriage_group_in_train_distance?: number | null, departures_quantity?: number | null };

export type TrainPerformanceIndicatorsSchemaTotalBaseFragmentFragment = { __typename: 'TrainPerformanceIndicatorsSchemaTotal', departures_quantity?: number | null, carriage_group_in_train_distance?: number | null, carriage_group_distance?: number | null, carriage_group_in_train_turnover?: number | null, carriage_group_turnover?: number | null, title: string, train_quantity?: number | null, train_turnover?: number | null };

export type TrainPerformanceIndicatorsTotalBaseFragmentFragment = { __typename: 'TrainPerformanceIndicatorsSchemaTotalDto', departures_quantity?: number | null, carriage_group_in_train_distance?: number | null, carriage_group_distance?: number | null, carriage_group_in_train_turnover?: number | null, carriage_group_turnover?: number | null, title: string, train_quantity?: number | null, train_turnover?: number | null };

export type JournalMeActionFragmentFragment = { __typename: 'UserActionAuditDto', id: number, created_at: string, action: string, target: string };

export type JournalUsersActionFragmentFragment = { __typename: 'UserActionAuditDto', id: number, created_at: string, action: string, target: string };

export type LatestVersionFragmentFragment = { __typename: 'LatestVersionDataDto', end_at?: string | null, is_latest: boolean, start_at: string };

export type LocomotiveAreaBaseFragmentFragment = { __typename: 'LocomotiveAreaDto', id: number, locomotive_series_id?: number | null, traction_directorate_id?: number | null, from_station_id: number, to_station_id: number, distance: number, trip_time: number, trip_cost?: number | null, is_valid: boolean, order_number: number, is_main_group_check: boolean };

export type LocomotiveChangeBaseFragmentFragment = { __typename: 'LocomotiveChangeDto', id: number, direction: string, description?: string | null };

export type LocomotiveChangeFragmentFragment = { __typename: 'LocomotiveChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } };

export type LocomotiveServiceBaseFragmentFragment = { __typename: 'LocomotiveServiceDto', id: number, start_at: string, end_at: string, train_number: string };

export type LocomotiveTeamAreaBaseFragmentFragment = { __typename: 'LocomotiveTeamAreaDto', id: number, traction_directorate_id?: number | null, persons_quantity?: number | null, from_station_id: number, to_station_id: number, distance: number, trip_time: number, trip_cost?: number | null };

export type LocomotiveTeamChangeBaseFragmentFragment = { __typename: 'LocomotiveTeamChangeDto', id: number, direction: string, description?: string | null };

export type LocomotiveTeamChangeFragmentFragment = { __typename: 'LocomotiveTeamChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } };

export type TotalCostsBaseFragmentFragment = { __typename: 'TotalCostsDto', total_locomotive_cost: string, total_locomotive_team_cost: string };

export type LuxuryCarriagesBaseFragmentFragment = { __typename: 'LuxuryCarriageDto', id: number, carriages_with_service?: string | null, carriages_non_branded?: string | null };

export type ManeuveringWorkBaseFragmentFragment = { __typename: 'ManeuveringWorkDto', id: number, direction: string, description?: string | null };

export type ManeuveringWorkFragmentFragment = { __typename: 'ManeuveringWorkDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } };

export type MaxTrainLengthRailwayBaseFragmentFragment = { __typename: 'MaxTrainLengthRailwayDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null };

export type MaxTrainLengthRailwayFragmentFragment = { __typename: 'MaxTrainLengthRailwayDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null };

export type MaxTrainLengthStationBaseFragmentFragment = { __typename: 'MaxTrainLengthStationDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null };

export type MaxTrainLengthStationFragmentFragment = { __typename: 'MaxTrainLengthStationDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null };

export type NewTrainBaseFragmentFragment = { __typename: 'NewTrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, start_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, is_included_in_request_form: boolean, is_periodicity_separate_request_form: boolean };

export type NewTrainShortFragmentFragment = { __typename: 'NewTrainDto', id: number, train_number: string };

export type OptionalCarriageBaseFragmentFragment = { __typename: 'OptionalCarriageDto', id: number, carriage_numbers: string };

export type OtherCarriageBaseFragmentFragment = { __typename: 'OtherCarriageDto', id: number, carriage_numbers: string, description?: string | null };

export type OtherCarriageFragmentFragment = { __typename: 'OtherCarriageDto', id: number, carriage_numbers: string, description?: string | null, other_carriages_info: Array<{ __typename: 'OtherCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> };

export type OtherCarriageInfoBaseFragmentFragment = { __typename: 'OtherCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string> };

export type OtherCarriageInfoFragmentFragment = { __typename: 'OtherCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } };

export type PeriodicityBaseFragmentFragment = { __typename: 'PeriodicityDto', id: number, from_date: string, metadata?: Array<string> | null, periodicity: string, to_date: string };

export type PeriodicityInfoBaseFragmentFragment = { __typename: 'PeriodicityInfoDto', id: number, departure_dates: Array<string>, arrival_dates: Array<string>, departure_dates_out_of_gdp: Array<string>, arrival_dates_out_of_gdp: Array<string> };

export type RangeShortFragmentFragment = { __typename: 'RangeDto', end_at?: string | null, start_at: string };

export type DivisionFragmentFragment = { __typename: 'DivisionDto', id: number, name: string, disabled: boolean };

export type DivisionGroupFragmentFragment = { __typename: 'DivisionGroupDto', id: number, name: string };

export type ModuleShortFragmentFragment = { __typename: 'ModuleDto', id: number, name: string, description?: string | null };

export type RoleBaseFragmentFragment = { __typename: 'RoleDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, name: string, is_fpk: boolean };

export type RoleShortFragmentFragment = { __typename: 'RoleDto', id: number, name: string, is_fpk: boolean };

export type RuleShortFragmentFragment = { __typename: 'RuleDto', id: number, method: string, description?: string | null };

export type RuleWithModuleFragmentFragment = { __typename: 'RuleDto', id: number, method: string, description?: string | null, disabled: boolean, module: { __typename: 'ModuleDto', name: string, description?: string | null } };

export type SchedulerJobFragmentFragment = { __typename: 'SchedulerJobDto', disable: boolean, id: number, name: string, time: string, command: string };

export type TableBaseFragmentFragment = { __typename: 'TableDto', id: number, second_class_total?: number | null, second_class_allocated_total?: number | null, common_total?: number | null, common_allocated_total?: number | null, direction: string, sv_total?: number | null, sv_allocated_total?: number | null, coupe_total?: number | null, coupe_allocated_total?: number | null };

export type InCommonCirculationWithTrainsShortFragmentFragment = { __typename: 'TableBlockDto', in_common_circulation_with_trains?: Array<{ __typename: 'TrainDto', id: number, train_number: string }> | null };

export type TableBlockBaseFragmentFragment = { __typename: 'TableBlockDto', id: number, in_common_circulation_with: string, heat: string, carriage_group_id: number, train_quantity: number, affiliation: string, break: string, eco_toilet: string, air_conditioner: string, is_accepted: boolean, is_collapsed: boolean, is_excluded_from_export: boolean, is_main_group: boolean, is_excluded_from_table_calculations: boolean, in_common_circulation_with_trains?: Array<{ __typename: 'TrainDto', id: number, train_number: string }> | null };

export type TableBlockRowBaseFragmentFragment = { __typename: 'TableBlockRowDto', id: number, seats_allocated?: number | null, carriage_number: string, carriage_type: string, carriage_seat_type: string, seats_quantity?: number | null };

export type TrailedCarriageBaseFragmentFragment = { __typename: 'TrailedCarriageDto', id: number, carriage_numbers: string, description?: string | null };

export type TrailedCarriageFragmentFragment = { __typename: 'TrailedCarriageDto', id: number, carriage_numbers: string, description?: string | null, trailed_carriages_info: Array<{ __typename: 'TrailedCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> };

export type TrailedCarriageInfoBaseFragmentFragment = { __typename: 'TrailedCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string> };

export type TrailedCarriageInfoFragmentFragment = { __typename: 'TrailedCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } };

export type TrainBaseFragmentFragment = { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean };

export type TrainShortFragmentFragment = { __typename: 'TrainDto', id: number, train_number: string };

export type TrainChangeDirectionBaseFragmentFragment = { __typename: 'TrainChangeDirectionDto', id: number, direction: string, description?: string | null };

export type TrainChangeDirectionFragmentFragment = { __typename: 'TrainChangeDirectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } };

export type TrainQuantityBaseFragmentFragment = { __typename: 'TrainQuantityDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, quantity: number, departure_dates: Array<string>, arrival_dates_with_time_stagnation: Array<string> };

export type CopyMetaBaseFragmentFragment = { __typename: 'CopyMetaDto', direct_train_id: number, reverse_train_id?: number | null, direct_train_number: string, reverse_train_number?: string | null, schedule_crate_date: string, gvc_name?: string | null, gdp_start_at?: string | null, gdp_end_at?: string | null };

export type TrainScheduleBaseFragmentFragment = { __typename: 'TrainScheduleDto', id: number, direct_time?: number | null, reverse_time?: number | null, status: string, is_lock: boolean, gvc_name?: string | null };

export type TrainScheduleFragmentBaseFragmentFragment = { __typename: 'TrainScheduleFragmentDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, order_number: number, direct_train_number: string, direct_departure?: number | null, direct_arrival?: number | null, direct_parking?: number | null, direct_time_to_station: number, is_direct_schedule_technical_parking: boolean, reverse_train_number?: string | null, reverse_departure?: number | null, reverse_arrival?: number | null, reverse_parking?: number | null, reverse_time_to_station?: number | null, is_reverse_schedule_technical_parking: boolean, distance: number, train_schedule_id: number };

export type TrainScheduleToStencilFragmentFragment = { __typename: 'TrainScheduleToStencilFragment', direct_arrival?: number | null, direct_parking?: number | null, direct_departure?: number | null, reverse_arrival?: number | null, reverse_parking?: number | null, reverse_departure?: number | null, station_name?: string | null, is_station_for_parking: boolean };

export type TrainScheduleStencilSingleBaseFragmentFragment = { __typename: 'TrainScheduleStencilSingleDto', direct_train_number: string, reverse_train_number?: string | null, direct_train_status: string, reverse_train_status?: string | null, train_version: number, start_at: string };

export type TrainScheduleStencilSingleFragmentFragment = { __typename: 'TrainScheduleStencilSingleDto', direct_train_number: string, reverse_train_number?: string | null, direct_train_status: string, reverse_train_status?: string | null, train_version: number, start_at: string, train_schedule_to_stencil_fragments: Array<{ __typename: 'TrainScheduleToStencilFragment', direct_arrival?: number | null, direct_parking?: number | null, direct_departure?: number | null, reverse_arrival?: number | null, reverse_parking?: number | null, reverse_departure?: number | null, station_name?: string | null, is_station_for_parking: boolean, station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> };

export type TrainSchemaBaseFragmentFragment = { __typename: 'TrainSchemaDto', id: number, train_schema_number: number, is_main_group_exported_direct: boolean, is_main_group_exported_reverse: boolean, status: string, is_lock: boolean, train_brand_note?: string | null, allocation_note?: string | null, variable_stencil_info?: string | null, variable_stencil_note?: string | null, luxury_carriages_note?: string | null, luxury_carriages_non_branded_note?: string | null, service_class_note?: string | null, optional_carriages_note?: string | null, is_by_stations_max_train_length: boolean, is_by_stations_established_train_schema: boolean, direct_carriages_note?: string | null, trailed_carriages_note?: string | null, other_carriages_note?: string | null, is_build_due_to_main_train: boolean };

export type TrainSchemaShortFragmentFragment = { __typename: 'TrainSchemaDto', id: number, train_schema_number: number };

export type TrainSubCategoriesDetailsSpeedBaseFragmentFragment = { __typename: 'TrainSubCategoriesDetailsSpeedDto', entity_id: number, created_at: string, updated_at: string, name: string, train_numbers: string, start_at: string, end_at: string };

export type SessionFragmentFragment = { __typename: 'SessionInformationDto', sid: string, browser: string, ip: string, os: string, date: string };

export type UserBaseFragmentFragment = { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null, user_name: string, email: string, job_position: string, expiration_date: string, phone_number?: string | null, disabled: boolean, is_ldap: boolean, is_need_to_clear_cache: boolean };

export type UserShortFragmentFragment = { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null };

export type WasteCollectionBaseFragmentFragment = { __typename: 'WasteCollectionDto', id: number, direction: string, description?: string | null };

export type WasteCollectionFragmentFragment = { __typename: 'WasteCollectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } };

export type WaterSupplyBaseFragmentFragment = { __typename: 'WaterSupplyDto', id: number, direction: string, description?: string | null };

export type WaterSupplyFragmentFragment = { __typename: 'WaterSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } };

export type AvailableServiceClassCreateMutationVariables = Exact<{
  data: CreateAvailableServiceClassDto;
}>;


export type AvailableServiceClassCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', availableServiceClass: { __typename: 'AvailableServiceClassMutationEntryPoint', create: { __typename: 'AvailableServiceClassDto', entity_id: number, service_class: string } } } };

export type AvailableServiceClassListFieldQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<AvailableServiceClassQueryResolver_List_SortingInputType> | AvailableServiceClassQueryResolver_List_SortingInputType>;
  where?: InputMaybe<AvailableServiceClassQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type AvailableServiceClassListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', availableServiceClass: { __typename: 'AvailableServiceClassQueryEntryPoint', list: { __typename: 'AvailableServiceClassList', totalCount: number, items: Array<{ __typename: 'AvailableServiceClassDto', id: number, entity_id: number, start_at: string, end_at: string, service_class: string }> } } } };

export type BranchListFieldQueryVariables = Exact<{
  where?: InputMaybe<BranchQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type BranchListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', branch: { __typename: 'BranchQueryEntryPoint', list: { __typename: 'BranchList', items: Array<{ __typename: 'BranchDto', entity_id: number, name: string, short_name: string }> } } } };

export type CarriageAdditionalSeatSignListFieldQueryVariables = Exact<{
  range: RangeInputDto;
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageAdditionalSeatSignQueryResolver_List_SortingInputType> | CarriageAdditionalSeatSignQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CarriageAdditionalSeatSignQueryResolver_List_FilterInputType>;
}>;


export type CarriageAdditionalSeatSignListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageAdditionalSeatSign: { __typename: 'CarriageAdditionalSeatSignQueryEntryPoint', list: { __typename: 'CarriageAdditionalSeatSignList', items: Array<{ __typename: 'CarriageAdditionalSeatSignDto', entity_id: number, id: number, start_at: string, end_at: string, name: string }> } } } };

export type NpsCarriageDimensionListFieldQueryVariables = Exact<{
  where?: InputMaybe<NpsCarriageDimensionQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type NpsCarriageDimensionListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageDimension: { __typename: 'NpsCarriageDimensionQueryEntryPoint', list: { __typename: 'NpsCarriageDimensionList', items: Array<{ __typename: 'NpsCarriageDimensionDto', entity_id: number, start_at: string, end_at: string, carriage_dimension: string }> } } } };

export type CarriageSeatAllocationListFieldQueryVariables = Exact<{
  where?: InputMaybe<CarriageSeatAllocationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type CarriageSeatAllocationListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageSeatAllocation: { __typename: 'CarriageSeatAllocationQueryEntryPoint', list: { __typename: 'CarriageSeatAllocationList', items: Array<{ __typename: 'CarriageSeatAllocationDto', entity_id: number, start_at: string, name: string }> } } } };

export type CarriageTypeListFieldQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageTypeQueryResolver_List_SortingInputType> | CarriageTypeQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CarriageTypeQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type CarriageTypeListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageType: { __typename: 'CarriageTypeQueryEntryPoint', list: { __typename: 'CarriageTypeList', totalCount: number, items: Array<{ __typename: 'CarriageTypeDto', entity_id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string, carriage_types_for_schema?: { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string, carriage_type_asu?: { __typename: 'CarriageTypeAsuDto', entity_id: number, short_name: string, full_name: string } | null } | null, regulatory_sector: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, seat_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, rolling_stock_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string } }> } } } };

export type CarriageTypeAsuListFieldQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageTypeAsuQueryResolver_List_SortingInputType> | CarriageTypeAsuQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CarriageTypeAsuQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type CarriageTypeAsuListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageTypeAsu: { __typename: 'CarriageTypeAsuQueryEntryPoint', list: { __typename: 'CarriageTypeAsuDtoList', items: Array<{ __typename: 'CarriageTypeAsuDto', entity_id: number, start_at: string, end_at: string, short_name: string, full_name: string }> } } } };

export type CarriageTypesForSchemaListFieldQueryVariables = Exact<{
  where?: InputMaybe<CarriageTypesForSchemaQueryResolver_List_FilterInputType>;
}>;


export type CarriageTypesForSchemaListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageTypesForSchema: { __typename: 'CarriageTypesForSchemaQueryEntryPoint', list: { __typename: 'CarriageTypesForSchemaDtoList', items: Array<{ __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string }> } } } };

export type CreateConditionalCarriageNumberMutationVariables = Exact<{
  input: CreateConditionalCarriageNumberDto;
}>;


export type CreateConditionalCarriageNumberMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', conditionalCarriageNumber: { __typename: 'ConditionalCarriageNumberMutationEntryPoint', create: number } } };

export type NonPassengerCarriageTypeNumbersListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<ConditionalCarriageNumberQueryResolver_List_SortingInputType> | ConditionalCarriageNumberQueryResolver_List_SortingInputType>;
  where?: InputMaybe<ConditionalCarriageNumberQueryResolver_List_FilterInputType>;
}>;


export type NonPassengerCarriageTypeNumbersListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', conditionalCarriageNumber: { __typename: 'ConditionalCarriageNumberQueryEntryPoint', list: { __typename: 'ConditionalCarriageNumberList', items: Array<{ __typename: 'ConditionalCarriageNumberDto', id: number, conditional_carriage_number: number }> } } } };

export type CsuCarrierListFieldQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CsuCarrierQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type CsuCarrierListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', csuCarrier: { __typename: 'CsuCarrierQueryEntryPoint', list: { __typename: 'CsuCarrierList', items: Array<{ __typename: 'CsuCarrierDto', id: number, name: string }> } } } };

export type InfrastructureCoefficientIndexingListFieldQueryVariables = Exact<{
  where?: InputMaybe<InfrastructureCoefficientIndexingQueryResolver_List_FilterInputType>;
}>;


export type InfrastructureCoefficientIndexingListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', infrastructureCoefficientIndexing: { __typename: 'InfrastructureCoefficientIndexingQueryEntryPoint', list: { __typename: 'InfrastructureCoefficientIndexingList', items: Array<{ __typename: 'InfrastructureCoefficientIndexingDto', id: number, coefficient: number }> } } } };

export type LocomotiveSeriesModelListFieldQueryVariables = Exact<{
  where?: InputMaybe<LocomotiveSeriesQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type LocomotiveSeriesModelListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveSeries: { __typename: 'LocomotiveSeriesQueryEntryPoint', list: { __typename: 'LocomotiveSeriesList', items: Array<{ __typename: 'LocomotiveSeriesDto', entity_id: number, series: string, index?: string | null, start_at: string }> } } } };

export type LocomotiveSeriesTypeModelListFieldQueryVariables = Exact<{
  where?: InputMaybe<LocomotiveSeriesTypeQueryResolver_List_FilterInputType>;
}>;


export type LocomotiveSeriesTypeModelListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveSeriesType: { __typename: 'LocomotiveSeriesTypeQueryEntryPoint', list: { __typename: 'LocomotiveSeriesTypeList', items: Array<{ __typename: 'LocomotiveSeriesTypeDto', id: number, name: string }> } } } };

export type LocomotiveTractionTypeListFieldQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotiveTractionTypeQueryResolver_List_SortingInputType> | LocomotiveTractionTypeQueryResolver_List_SortingInputType>;
  where?: InputMaybe<LocomotiveTractionTypeQueryResolver_List_FilterInputType>;
}>;


export type LocomotiveTractionTypeListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveTractionType: { __typename: 'LocomotiveTractionTypeQueryEntryPoint', list: { __typename: 'LocomotiveTractionTypeList', items: Array<{ __typename: 'LocomotiveTractionTypeDto', id: number, name: string, short_name: string }> } } } };

export type LocomotiveTypeCurrentListFieldQueryVariables = Exact<{
  where?: InputMaybe<LocomotiveTypeCurrentQueryResolver_List_FilterInputType>;
}>;


export type LocomotiveTypeCurrentListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveTypeCurrent: { __typename: 'LocomotiveTypeCurrentQueryEntryPoint', list: { __typename: 'LocomotiveTypeCurrentList', items: Array<{ __typename: 'LocomotiveTypeCurrentDto', id: number, name: string }> } } } };

export type MaxTrainSpeedListFieldQueryVariables = Exact<{
  range: RangeInputDto;
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<MaxTrainSpeedQueryResolver_List_SortingInputType> | MaxTrainSpeedQueryResolver_List_SortingInputType>;
  where?: InputMaybe<MaxTrainSpeedQueryResolver_List_FilterInputType>;
}>;


export type MaxTrainSpeedListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', maxTrainSpeed: { __typename: 'MaxTrainSpeedQueryEntryPoint', list: { __typename: 'MaxTrainSpeedList', items: Array<{ __typename: 'MaxTrainSpeedDto', id: number, entity_id: number, max_train_speed: number }> } } } };

export type MvpsCompanyAffiliationListFieldQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<MvpsCompanyAffiliationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type MvpsCompanyAffiliationListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsCompanyAffiliation: { __typename: 'MvpsCompanyAffiliationQueryEntryPoint', list: { __typename: 'MvpsCompanyAffiliationDtoList', items: Array<{ __typename: 'MvpsCompanyAffiliationDto', entity_id: number, mvps_owner: string, start_at: string }> } } } };

export type MvpsMartinSectionTypeListFieldQueryVariables = Exact<{
  where?: InputMaybe<MvpsMartinSectionTypeQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type MvpsMartinSectionTypeListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsMartinSectionType: { __typename: 'MvpsMartinSectionTypeQueryEntryPoint', list: { __typename: 'MvpsMartinSectionTypeDtoList', items: Array<{ __typename: 'MvpsMartinSectionTypeDto', id: number, entity_id: number, start_at: string, end_at: string, series: string, mvps_martin_section_type_equipment_id: number, carriage_quantity_in_section: number, price: number, mvpsMartinSectionTypeEquipmentDto: { __typename: 'MvpsMartinSectionTypeEquipmentDto', entity_id: number, equipment: string } }> } } } };

export type MvpsMartinSectionTypeEquipmentListFieldQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<MvpsMartinSectionTypeEquipmentQueryResolver_List_SortingInputType> | MvpsMartinSectionTypeEquipmentQueryResolver_List_SortingInputType>;
  where?: InputMaybe<MvpsMartinSectionTypeEquipmentQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type MvpsMartinSectionTypeEquipmentListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsMartinSectionTypeEquipment: { __typename: 'MvpsMartinSectionTypeEquipmentQueryEntryPoint', list: { __typename: 'MvpsMartinSectionTypeEquipmentList', totalCount: number, items: Array<{ __typename: 'MvpsMartinSectionTypeEquipmentDto', entity_id: number, equipment: string }> } } } };

export type MvpsRateManagementExploitationMaintenanceRepairListFieldQueryVariables = Exact<{
  where?: InputMaybe<MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type MvpsRateManagementExploitationMaintenanceRepairListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsRateManagementExploitationMaintenanceRepair: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairQueryEntryPoint', list: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairList', items: Array<{ __typename: 'MvpsRateManagementExploitationMaintenanceRepairDto', entity_id: number, price: number }> } } } };

export type NpsCarriageBrakeTypeListFieldQueryVariables = Exact<{
  where?: InputMaybe<NpsCarriageBrakeTypeQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type NpsCarriageBrakeTypeListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageBrakeType: { __typename: 'NpsCarriageBrakeTypeQueryEntryPoint', list: { __typename: 'NpsCarriageBrakeTypeList', items: Array<{ __typename: 'NpsCarriageBrakeTypeDto', id: number, entity_id: number, start_at: string, end_at: string, brake_type: string, description?: string | null }> } } } };

export type NpsCarriageHeatTypeListFieldQueryVariables = Exact<{
  where?: InputMaybe<NpsCarriageHeatTypeQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type NpsCarriageHeatTypeListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageHeatType: { __typename: 'NpsCarriageHeatTypeQueryEntryPoint', list: { __typename: 'NpsCarriageHeatTypeList', items: Array<{ __typename: 'NpsCarriageHeatTypeDto', id: number, entity_id: number, start_at: string, end_at: string, heat_type: string, description?: string | null }> } } } };

export type NpsCarriageLengthListFieldQueryVariables = Exact<{
  where?: InputMaybe<NpsCarriageLengthQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type NpsCarriageLengthListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageLength: { __typename: 'NpsCarriageLengthQueryEntryPoint', list: { __typename: 'NpsCarriageLengthList', items: Array<{ __typename: 'NpsCarriageLengthDto', id: number, entity_id: number, start_at: string, end_at: string, carriage_length_asu_ms: number, carriage_length_in_train_schema: number, description?: string | null }> } } } };

export type NpsCarriageModelListFieldQueryVariables = Exact<{
  where?: InputMaybe<NpsCarriageModelQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type NpsCarriageModelListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageModel: { __typename: 'NpsCarriageModelQueryEntryPoint', list: { __typename: 'NpsCarriageModelList', items: Array<{ __typename: 'NpsCarriageModelDto', entity_id: number, id: number, start_at: string, end_at: string, carriage_model: string, description?: string | null }> } } } };

export type PassengerCarrierListFieldQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<PassengerCarrierQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type PassengerCarrierListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', passengerCarrier: { __typename: 'PassengerCarrierQueryEntryPoint', list: { __typename: 'PassengerCarrierList', items: Array<{ __typename: 'PassengerCarrierDto', code: number, entity_id: number, short_name: string, name: string }> } } } };

export type NmrvagUniqueCarriersListQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type NmrvagUniqueCarriersListQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_schema: { __typename: 'ControlSchemaQueryEntryPoint', uniqueCarriersList: Array<number> } } };

export type PeriodicitySeasonListFieldQueryVariables = Exact<{
  range: RangeInputDto;
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<PeriodicitySeasonQueryResolver_List_SortingInputType> | PeriodicitySeasonQueryResolver_List_SortingInputType>;
  where?: InputMaybe<PeriodicitySeasonQueryResolver_List_FilterInputType>;
}>;


export type PeriodicitySeasonListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', periodicitySeason: { __typename: 'PeriodicitySeasonQueryEntryPoint', list: { __typename: 'PeriodicitySeasonList', items: Array<{ __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string }> } } } };

export type RailwaysListFieldQueryVariables = Exact<{
  range: RangeInputDto;
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RailwayQueryResolver_List_SortingInputType> | RailwayQueryResolver_List_SortingInputType>;
  where?: InputMaybe<RailwayQueryResolver_List_FilterInputType>;
}>;


export type RailwaysListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', railway: { __typename: 'RailwayQueryEntryPoint', list: { __typename: 'RailwayList', items: Array<{ __typename: 'RailwayDto', entity_id: number, code: string, name: string, short_name: string }> } } } };

export type RailwayAdministrationListFieldQueryVariables = Exact<{
  where?: InputMaybe<RailwayAdministrationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type RailwayAdministrationListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', railwayAdministration: { __typename: 'RailwayAdministrationQueryEntryPoint', list: { __typename: 'RailwayAdministrationList', items: Array<{ __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }> } } } };

export type RolesListFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesListFieldQuery = { __typename: 'Query', rbac: { __typename: 'RbacQueryEntryPoint', roles: { __typename: 'RoleList', items: Array<{ __typename: 'RoleDto', id: number, name: string, is_fpk: boolean }> } } };

export type UniqueRoutesListFieldQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
}>;


export type UniqueRoutesListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', routesControlAvailabilitySeatsDirection: { __typename: 'RoutesControlAvailabilitySeatsDirectionQueryEntryPoint', uniqueRoutes: { __typename: 'UniqueRoutesDtoList', totalCount: number, items: Array<{ __typename: 'UniqueRoutesDto', top_routes_ids?: Array<number> | null, city?: { __typename: 'StationDto', id: number, full_name: string } | null }> } } } };

export type StationListFieldQueryVariables = Exact<{
  where?: InputMaybe<StationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type StationListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', station: { __typename: 'StationQueryEntryPoint', list: { __typename: 'StationDtoList', items: Array<{ __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }> } } } };

export type StructuralSubdivisionListFieldQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<StructuralSubdivisionQueryResolver_List_SortingInputType> | StructuralSubdivisionQueryResolver_List_SortingInputType>;
  where?: InputMaybe<StructuralSubdivisionQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type StructuralSubdivisionListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', structuralSubdivision: { __typename: 'StructuralSubdivisionQueryEntryPoint', list: { __typename: 'StructuralSubdivisionList', items: Array<{ __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string, station: { __typename: 'StationDto', entity_id: number, full_name: string } }> } } } };

export type TractionDirectorateListFieldQueryVariables = Exact<{
  where?: InputMaybe<TractionDirectorateQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type TractionDirectorateListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', tractionDirectorate: { __typename: 'TractionDirectorateQueryEntryPoint', list: { __typename: 'TractionDirectorateList', items: Array<{ __typename: 'TractionDirectorateDto', id: number, entity_id: number, start_at: string, end_at: string, name: string, short_name: string, is_not_in_calculation: boolean }> } } } };

export type TrainBrandListFieldQueryVariables = Exact<{
  where?: InputMaybe<TrainBrandQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type TrainBrandListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainBrand: { __typename: 'TrainBrandQueryEntryPoint', list: { __typename: 'TrainBrandList', items: Array<{ __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }> } } } };

export type TrainCategoryListFieldQueryVariables = Exact<{
  range: RangeInputDto;
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainCategoryQueryResolver_List_SortingInputType> | TrainCategoryQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TrainCategoryQueryResolver_List_FilterInputType>;
}>;


export type TrainCategoryListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainCategory: { __typename: 'TrainCategoryQueryEntryPoint', list: { __typename: 'TrainCategoryList', items: Array<{ __typename: 'TrainCategoryDto', entity_id: number, train_category: string }> } } } };

export type TrainSubCategoryListFieldQueryVariables = Exact<{
  range: RangeInputDto;
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainSubCategoryQueryResolver_List_SortingInputType> | TrainSubCategoryQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TrainSubCategoryQueryResolver_List_FilterInputType>;
}>;


export type TrainSubCategoryListFieldQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainSubCategory: { __typename: 'TrainSubCategoryQueryEntryPoint', list: { __typename: 'TrainSubCategoryList', items: Array<{ __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string, background_color: string, train_category_id: number }> } } } };

export type ControlSchemaNmrvagTrainsListFieldQueryVariables = Exact<{
  date: Scalars['String']['input'];
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_ListTrainsNmrvag_FilterInputType>;
}>;


export type ControlSchemaNmrvagTrainsListFieldQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_schema: { __typename: 'ControlSchemaQueryEntryPoint', listTrainsNmrvag: { __typename: 'TrainNmrvagListDto', items: Array<{ __typename: 'TrainNmrvagFilterDto', id: number, train_number: string, station_from?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> } } } };

export type ControlSchemaTrainsListFieldQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_ListTrains_FilterInputType>;
}>;


export type ControlSchemaTrainsListFieldQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_schema: { __typename: 'ControlSchemaQueryEntryPoint', listTrains: { __typename: 'SchemaControlTrainList', items: Array<{ __typename: 'SchemaControlTrainDto', id?: number | null, train_number: string, version?: number | null, station_from?: { __typename: 'StationDto', entity_id: number, id: number, full_name: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, id: number, full_name: string } | null }> } } } };

export type IndicatorsTrainsListFieldQueryVariables = Exact<{
  where?: InputMaybe<IndicatorsQueryResolver_ListTrains_FilterInputType>;
  orderBy?: InputMaybe<Array<IndicatorsQueryResolver_ListTrains_SortingInputType> | IndicatorsQueryResolver_ListTrains_SortingInputType>;
}>;


export type IndicatorsTrainsListFieldQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', list_trains: { __typename: 'IndicatorsTrainList', items: Array<{ __typename: 'IndicatorsTrainDto', train_id: number, train_number: string, from_station: string, to_station: string, status: string, start_at: string, end_at: string }> } } };

export type UserListFieldQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<UsersQueryResolver_List_SortingInputType> | UsersQueryResolver_List_SortingInputType>;
  where?: InputMaybe<UsersQueryResolver_List_FilterInputType>;
}>;


export type UserListFieldQuery = { __typename: 'Query', users: { __typename: 'UsersQueryEntryPoint', list: { __typename: 'UserList', items: Array<{ __typename: 'UserDto', id: number, full_name: string, branch?: { __typename: 'BranchDto', entity_id: number, short_name: string } | null }> } } };

export type GdpListViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GdpListViewQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', gdp: { __typename: 'GDPQueryEntryPoint', list: { __typename: 'GDPList', items: Array<{ __typename: 'GdpDto', id: number, start_at: string, end_at: string }> } } } };

export type CarriageGroupIndicatorsMonthlyQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<IndicatorsQueryResolver_IndicatorsMonthly_SortingInputType> | IndicatorsQueryResolver_IndicatorsMonthly_SortingInputType>;
  where?: InputMaybe<IndicatorsQueryResolver_IndicatorsMonthly_FilterInputType>;
  carriageGroupId: Scalars['Float']['input'];
}>;


export type CarriageGroupIndicatorsMonthlyQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', indicators_monthly: { __typename: 'CarriageGroupIndicatorResponseList', totalCount: number, items: Array<{ __typename: 'CarriageGroupIndicatorResponseDto', id: number, month: string, trips_quantity: number, is_calendar_active: boolean, departure_dates: Array<string>, carriage_type_indicators: Array<{ __typename: 'CarriageGroupCarriageTypeIndicatorsDto', id: number, fact: number, forecast: number, carriages_by_date: Array<{ __typename: 'CarriageGroupCarriagesByDateDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, date: string, carriages_quantity: number }>, carriage_type: { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string } }> }> } } };

export type NotificationsUserQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
}>;


export type NotificationsUserQuery = { __typename: 'Query', notification: { __typename: 'NotificationQueryEntryPoint', messages_user: { __typename: 'UserMessageListDto', totalCount: number, items: Array<{ __typename: 'UserMessageDto', created_at: string, viewed: boolean, type: string, payload: { __typename: 'UserMessagePayloadDto', type: string, data: { __typename: 'UserMessagePayloadDataDto', args?: any | null, entity?: string | null, message?: string | null } } }> } } };

export type NotificationsUserClearAllMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationsUserClearAllMutation = { __typename: 'Mutation', notification: { __typename: 'NotificationMutationEntryPoint', clear_messages_user?: any | null } };

export type CheckBoxMessageTextTrainSubCategoryQueryVariables = Exact<{
  range: RangeInputDto;
  where?: InputMaybe<TrainCategoryQueryResolver_List_FilterInputType>;
}>;


export type CheckBoxMessageTextTrainSubCategoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainCategory: { __typename: 'TrainCategoryQueryEntryPoint', list: { __typename: 'TrainCategoryList', items: Array<{ __typename: 'TrainCategoryDto', train_category: string, train_sub_categories: Array<{ __typename: 'TrainSubCategoryDto', train_sub_category: string, train_numbers: string }> }> } } } };

export type StationListByTrainIdForTrainViewQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type StationListByTrainIdForTrainViewQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', byId: { __typename: 'TrainDto', id: number, schedule?: { __typename: 'TrainScheduleDto', id: number, train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', id: number, station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> } | null } } };

export type StationsListForTrainViewQueryVariables = Exact<{
  where?: InputMaybe<StationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type StationsListForTrainViewQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', station: { __typename: 'StationQueryEntryPoint', list: { __typename: 'StationDtoList', items: Array<{ __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }> } } } };

export type TrainSubCategoryByTrainNumberForTrainViewQueryVariables = Exact<{
  trainNumber: Scalars['String']['input'];
  range: RangeInputDto;
}>;


export type TrainSubCategoryByTrainNumberForTrainViewQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainSubCategory: { __typename: 'TrainSubCategoryQueryEntryPoint', byTrainNumber?: { __typename: 'TrainSubCategoryList', items: Array<{ __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, train_category_id: number }> } | null } } };

export type TrainPairByIdForTrainViewQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrainPairByIdForTrainViewQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, schedule?: { __typename: 'TrainScheduleDto', id: number } | null, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number }> | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string, background_color: string, train_category_id: number } | null, max_train_speed?: { __typename: 'MaxTrainSpeedDto', id: number, entity_id: number, max_train_speed: number } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, short_name: string, name: string } | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, other_trains: Array<{ __typename: 'OtherTrainsDto', id: number, from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, other_train: { __typename: 'TrainDto', id: number, train_number: string, status: string } }>, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string } }, reverse?: { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string, background_color: string, train_category_id: number } | null, max_train_speed?: { __typename: 'MaxTrainSpeedDto', id: number, entity_id: number, max_train_speed: number } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, short_name: string, name: string } | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, other_trains: Array<{ __typename: 'OtherTrainsDto', id: number, from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, other_train: { __typename: 'TrainDto', id: number, train_number: string, status: string } }>, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string } } | null } } };

export type TrainsPairByIdForTrainViewFragment = { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string, background_color: string, train_category_id: number } | null, max_train_speed?: { __typename: 'MaxTrainSpeedDto', id: number, entity_id: number, max_train_speed: number } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, short_name: string, name: string } | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, other_trains: Array<{ __typename: 'OtherTrainsDto', id: number, from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, other_train: { __typename: 'TrainDto', id: number, train_number: string, status: string } }>, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string } };

export type DivisionCreateMutationVariables = Exact<{
  data: CreateDivisionDto;
}>;


export type DivisionCreateMutation = { __typename: 'Mutation', rbac: { __typename: 'RbacMutationEntryPoint', create_division: { __typename: 'DivisionDto', id: number, name: string, disabled: boolean, group: { __typename: 'DivisionGroupDto', id: number, name: string } } } };

export type DivisionsQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RbacQueryResolver_Division_SortingInputType> | RbacQueryResolver_Division_SortingInputType>;
  where?: InputMaybe<RbacQueryResolver_Division_FilterInputType>;
}>;


export type DivisionsQuery = { __typename: 'Query', rbac: { __typename: 'RbacQueryEntryPoint', divisions: { __typename: 'DivisionList', totalCount: number, items: Array<{ __typename: 'DivisionDto', id: number, name: string, disabled: boolean, group: { __typename: 'DivisionGroupDto', id: number, name: string } }> } } };

export type DivisionUpdateMutationVariables = Exact<{
  data: UpdateDivisionDto;
}>;


export type DivisionUpdateMutation = { __typename: 'Mutation', rbac: { __typename: 'RbacMutationEntryPoint', update_division: { __typename: 'DivisionDto', id: number, name: string, disabled: boolean } } };

export type FeatureFlagsUpdateMutationVariables = Exact<{
  data: FeatureFlagsRequestDto;
}>;


export type FeatureFlagsUpdateMutation = { __typename: 'Mutation', configuration: { __typename: 'ConfigurationMutationEntryPoint', feature_flag_update?: any | null } };

export type FeatureFlagsQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagList_SortingInputType> | ConfigurationQueryResolver_FeatureFlagList_SortingInputType>;
  where?: InputMaybe<ConfigurationQueryResolver_FeatureFlagList_FilterInputType>;
}>;


export type FeatureFlagsQuery = { __typename: 'Query', configuration: { __typename: 'ConfigurationQueryEntryPoint', feature_flag_list: { __typename: 'FeatureFlagList', totalCount: number, items: Array<{ __typename: 'FeatureFlagsDto', id: number, name: string, value: string, description?: string | null }> } } };

export type AdminHelpEducationCreateMutationVariables = Exact<{
  data: EducationCreateDto;
}>;


export type AdminHelpEducationCreateMutation = { __typename: 'Mutation', cms: { __typename: 'CmsMutationEntryPoint', education_create: { __typename: 'EducationDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null } } };

export type AdminHelpEducationDeleteMutationVariables = Exact<{
  data: Scalars['Float']['input'];
}>;


export type AdminHelpEducationDeleteMutation = { __typename: 'Mutation', cms: { __typename: 'CmsMutationEntryPoint', education_delete?: any | null } };

export type AdminHelpEducationListQueryVariables = Exact<{
  order_by?: InputMaybe<Array<CmsQueryResolver_EducationList_SortingInputType> | CmsQueryResolver_EducationList_SortingInputType>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CmsQueryResolver_EducationList_FilterInputType>;
}>;


export type AdminHelpEducationListQuery = { __typename: 'Query', cms: { __typename: 'CmsQueryEntryPoint', education_list: { __typename: 'EducationList', totalCount: number, items: Array<{ __typename: 'EducationDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null }> } } };

export type AdminHelpEducationUpdateMutationVariables = Exact<{
  data: EducationUpdateDto;
}>;


export type AdminHelpEducationUpdateMutation = { __typename: 'Mutation', cms: { __typename: 'CmsMutationEntryPoint', education_update: { __typename: 'EducationDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null } } };

export type AdminHelpFaqCreateMutationVariables = Exact<{
  data: FaqCreateDto;
}>;


export type AdminHelpFaqCreateMutation = { __typename: 'Mutation', cms: { __typename: 'CmsMutationEntryPoint', faq_create: { __typename: 'FaqDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null } } };

export type AdminHelpFaqDeleteMutationVariables = Exact<{
  data: Scalars['Float']['input'];
}>;


export type AdminHelpFaqDeleteMutation = { __typename: 'Mutation', cms: { __typename: 'CmsMutationEntryPoint', faq_delete?: any | null } };

export type AdminHelpFaqListQueryVariables = Exact<{
  order_by?: InputMaybe<Array<CmsQueryResolver_FaqList_SortingInputType> | CmsQueryResolver_FaqList_SortingInputType>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CmsQueryResolver_FaqList_FilterInputType>;
}>;


export type AdminHelpFaqListQuery = { __typename: 'Query', cms: { __typename: 'CmsQueryEntryPoint', faq_list: { __typename: 'FaqList', totalCount: number, items: Array<{ __typename: 'FaqDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null }> } } };

export type AdminHelpFaqUpdateMutationVariables = Exact<{
  data: FaqUpdateDto;
}>;


export type AdminHelpFaqUpdateMutation = { __typename: 'Mutation', cms: { __typename: 'CmsMutationEntryPoint', faq_update: { __typename: 'FaqDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null } } };

export type ManualFileListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<FilestorageQueryResolver_ListByBucketId_FilterInputType>;
}>;


export type ManualFileListQuery = { __typename: 'Query', filestorage: { __typename: 'FilestorageQueryEntryPoint', listByBucketId: { __typename: 'FileList', totalCount: number, items: Array<{ __typename: 'FileDto', id: number, name: string, description?: string | null, download_link: string }> } } };

export type ManualFileDeleteMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type ManualFileDeleteMutation = { __typename: 'Mutation', filestorage: { __typename: 'FilestorageMutationEntryPoint', delete?: any | null } };

export type UsersJournalActionAuditQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<JournalQueryResolver_UserActionAudit_FilterInputType>;
  orderBy?: InputMaybe<Array<JournalQueryResolver_UserActionAudit_SortingInputType> | JournalQueryResolver_UserActionAudit_SortingInputType>;
}>;


export type UsersJournalActionAuditQuery = { __typename: 'Query', journal: { __typename: 'JournalQueryEntryPoint', user_action_audit: { __typename: 'UserActionAuditList', totalCount: number, items: Array<{ __typename: 'UserActionAuditDto', id: number, created_at: string, action: string, target: string, create_by: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null, user_name: string, email: string, job_position: string, expiration_date: string, phone_number?: string | null, disabled: boolean, is_ldap: boolean, is_need_to_clear_cache: boolean } }> } } };

export type AdminNewsCreateMutationVariables = Exact<{
  data: NewsCreateDto;
}>;


export type AdminNewsCreateMutation = { __typename: 'Mutation', cms: { __typename: 'CmsMutationEntryPoint', news_create: { __typename: 'NewsDto', id: number, title: string, created_at: string, updated_at: string } } };

export type AdminNewsDeleteMutationVariables = Exact<{
  data: Scalars['Float']['input'];
}>;


export type AdminNewsDeleteMutation = { __typename: 'Mutation', cms: { __typename: 'CmsMutationEntryPoint', news_delete?: any | null } };

export type AdminNewsDetailsQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CmsQueryResolver_NewsList_FilterInputType>;
}>;


export type AdminNewsDetailsQuery = { __typename: 'Query', cms: { __typename: 'CmsQueryEntryPoint', news_list: { __typename: 'NewsList', totalCount: number, items: Array<{ __typename: 'NewsDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null }> } } };

export type AdminNewsListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  order_by?: InputMaybe<Array<CmsQueryResolver_NewsList_SortingInputType> | CmsQueryResolver_NewsList_SortingInputType>;
}>;


export type AdminNewsListQuery = { __typename: 'Query', cms: { __typename: 'CmsQueryEntryPoint', news_list: { __typename: 'NewsList', totalCount: number, items: Array<{ __typename: 'NewsDto', id: number, title: string, created_at: string, updated_at: string }> } } };

export type AdminNewsUpdateMutationVariables = Exact<{
  data: NewsUpdateDto;
}>;


export type AdminNewsUpdateMutation = { __typename: 'Mutation', cms: { __typename: 'CmsMutationEntryPoint', news_update: { __typename: 'NewsDto', id: number, title: string, created_at: string, updated_at: string } } };

export type AdminRolesListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RbacQueryResolver_Roles_SortingInputType> | RbacQueryResolver_Roles_SortingInputType>;
  where?: InputMaybe<RbacQueryResolver_Roles_FilterInputType>;
}>;


export type AdminRolesListQuery = { __typename: 'Query', rbac: { __typename: 'RbacQueryEntryPoint', roles: { __typename: 'RoleList', totalCount: number, items: Array<{ __typename: 'RoleDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, name: string, is_fpk: boolean }> } } };

export type ModulesAndRulesListQueryVariables = Exact<{ [key: string]: never; }>;


export type ModulesAndRulesListQuery = { __typename: 'Query', rbac: { __typename: 'RbacQueryEntryPoint', rules: { __typename: 'RuleList', items: Array<{ __typename: 'RuleDto', id: number, method: string, description?: string | null, module: { __typename: 'ModuleDto', id: number, name: string, description?: string | null } }> } } };

export type RoleUpdateMutationVariables = Exact<{
  data: UpdateRoleDto;
}>;


export type RoleUpdateMutation = { __typename: 'Mutation', rbac: { __typename: 'RbacMutationEntryPoint', update_role: boolean } };

export type RulesByRoleListQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type RulesByRoleListQuery = { __typename: 'Query', rbac: { __typename: 'RbacQueryEntryPoint', role: { __typename: 'RoleDto', id: number, name: string, is_fpk: boolean, rules: Array<{ __typename: 'RuleDto', id: number, method: string, description?: string | null, module: { __typename: 'ModuleDto', id: number, name: string, description?: string | null } }> } } };

export type SchedulersQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<SchedulerQueryResolver_List_SortingInputType> | SchedulerQueryResolver_List_SortingInputType>;
  where?: InputMaybe<SchedulerQueryResolver_List_FilterInputType>;
}>;


export type SchedulersQuery = { __typename: 'Query', scheduler: { __typename: 'SchedulerQueryEntryPoint', scheduler: { __typename: 'SchedulerJobQueryEntryPoint', list: { __typename: 'SchedulerJobList', totalCount: number, items: Array<{ __typename: 'SchedulerJobDto', disable: boolean, id: number, name: string, time: string, command: string }> } } } };

export type SchedulerManualStartMutationVariables = Exact<{
  command: Scalars['String']['input'];
}>;


export type SchedulerManualStartMutation = { __typename: 'Mutation', scheduler: { __typename: 'SchedulerMutationEntryPoint', scheduler: { __typename: 'SchedulerJobMutationEntryPoint', manualStart: boolean } } };

export type SchedulerUpdateDisabledJobMutationVariables = Exact<{
  data: UpdateDisableSchedulerJobDto;
}>;


export type SchedulerUpdateDisabledJobMutation = { __typename: 'Mutation', scheduler: { __typename: 'SchedulerMutationEntryPoint', scheduler: { __typename: 'SchedulerJobMutationEntryPoint', updateDisableJob: boolean } } };

export type SchedulerUpdateTimeJobMutationVariables = Exact<{
  data: UpdateTimeSchedulerJobDto;
}>;


export type SchedulerUpdateTimeJobMutation = { __typename: 'Mutation', scheduler: { __typename: 'SchedulerMutationEntryPoint', scheduler: { __typename: 'SchedulerJobMutationEntryPoint', updateTimeJob: boolean } } };

export type CreateFeatureFlagsUserMutationVariables = Exact<{
  data: FeatureFlagsUserCreateDto;
}>;


export type CreateFeatureFlagsUserMutation = { __typename: 'Mutation', configuration: { __typename: 'ConfigurationMutationEntryPoint', feature_flag_user_create?: any | null } };

export type DeleteFeatureFlagsUserMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteFeatureFlagsUserMutation = { __typename: 'Mutation', configuration: { __typename: 'ConfigurationMutationEntryPoint', feature_flag_user_delete?: any | null } };

export type FeatureFlagsUserListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<ConfigurationQueryResolver_FeatureFlagUserList_SortingInputType> | ConfigurationQueryResolver_FeatureFlagUserList_SortingInputType>;
  where?: InputMaybe<ConfigurationQueryResolver_FeatureFlagUserList_FilterInputType>;
}>;


export type FeatureFlagsUserListQuery = { __typename: 'Query', configuration: { __typename: 'ConfigurationQueryEntryPoint', feature_flag_user_list: { __typename: 'FeatureFlagUserList', items: Array<{ __typename: 'FeatureFlagsUserDto', id: number, value: string, name: string, description?: string | null, user_id: number }> } } };

export type RolesListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RbacQueryResolver_Roles_SortingInputType> | RbacQueryResolver_Roles_SortingInputType>;
  where?: InputMaybe<RbacQueryResolver_Roles_FilterInputType>;
}>;


export type RolesListQuery = { __typename: 'Query', rbac: { __typename: 'RbacQueryEntryPoint', roles: { __typename: 'RoleList', totalCount: number, items: Array<{ __typename: 'RoleDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, name: string, is_fpk: boolean }> } } };

export type RuleList__UserEditQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RbacQueryResolver_Rules_SortingInputType> | RbacQueryResolver_Rules_SortingInputType>;
  where?: InputMaybe<RbacQueryResolver_Rules_FilterInputType>;
}>;


export type RuleList__UserEditQuery = { __typename: 'Query', rbac: { __typename: 'RbacQueryEntryPoint', rules: { __typename: 'RuleList', items: Array<{ __typename: 'RuleDto', id: number, method: string, description?: string | null, disabled: boolean, module: { __typename: 'ModuleDto', name: string, description?: string | null } }> } } };

export type UserSessionQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type UserSessionQuery = { __typename: 'Query', users: { __typename: 'UsersQueryEntryPoint', sessions_list: { __typename: 'SessionInformationList', totalCount: number, items: Array<{ __typename: 'SessionInformationDto', sid: string, browser: string, ip: string, os: string, date: string }> } } };

export type TerminateSessionUserMutationVariables = Exact<{
  user_id: Scalars['Float']['input'];
  sid: Scalars['String']['input'];
}>;


export type TerminateSessionUserMutation = { __typename: 'Mutation', users: { __typename: 'UsersMutationEntryPoint', terminate_session_user?: any | null } };

export type UpdateFeatureFlagsUserMutationVariables = Exact<{
  data: FeatureFlagsUserUpdateDto;
}>;


export type UpdateFeatureFlagsUserMutation = { __typename: 'Mutation', configuration: { __typename: 'ConfigurationMutationEntryPoint', feature_flag_user_update?: any | null } };

export type UserEditByIdQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type UserEditByIdQuery = { __typename: 'Query', users: { __typename: 'UsersQueryEntryPoint', by_id?: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null, user_name: string, email: string, job_position: string, expiration_date: string, phone_number?: string | null, disabled: boolean, is_ldap: boolean, is_need_to_clear_cache: boolean, branch?: { __typename: 'BranchDto', start_at: string, end_at: string, entity_id: number, name: string, short_name: string, name_nmrvag: string, vladr: string } | null, roles: Array<{ __typename: 'RoleDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, name: string, is_fpk: boolean }>, division?: { __typename: 'DivisionDto', id: number, name: string, disabled: boolean } | null, rules?: Array<{ __typename: 'RuleDto', id: number, method: string, description?: string | null, disabled: boolean, module: { __typename: 'ModuleDto', name: string, description?: string | null } }> | null } | null } };

export type UserClearCacheMutationVariables = Exact<{ [key: string]: never; }>;


export type UserClearCacheMutation = { __typename: 'Mutation', users: { __typename: 'UsersMutationEntryPoint', clear_cache_success?: boolean | null } };

export type CreateUserMutationVariables = Exact<{
  data: CreateUserDto;
}>;


export type CreateUserMutation = { __typename: 'Mutation', users: { __typename: 'UsersMutationEntryPoint', create: number } };

export type UserListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<UsersQueryResolver_List_SortingInputType> | UsersQueryResolver_List_SortingInputType>;
  where?: InputMaybe<UsersQueryResolver_List_FilterInputType>;
}>;


export type UserListQuery = { __typename: 'Query', users: { __typename: 'UsersQueryEntryPoint', list: { __typename: 'UserList', totalCount: number, items: Array<{ __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null, user_name: string, email: string, job_position: string, expiration_date: string, phone_number?: string | null, disabled: boolean, is_ldap: boolean, is_need_to_clear_cache: boolean, branch?: { __typename: 'BranchDto', start_at: string, end_at: string, entity_id: number, name: string, short_name: string, name_nmrvag: string, vladr: string } | null, roles: Array<{ __typename: 'RoleDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, name: string, is_fpk: boolean }>, division?: { __typename: 'DivisionDto', id: number, name: string, disabled: boolean } | null }> } } };

export type LockoutUserMutationVariables = Exact<{
  data: UpdateUserDto;
}>;


export type LockoutUserMutation = { __typename: 'Mutation', users: { __typename: 'UsersMutationEntryPoint', update?: boolean | null } };

export type UpdateUserMutationVariables = Exact<{
  data: UpdateUserDto;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', users: { __typename: 'UsersMutationEntryPoint', update?: boolean | null } };

export type CarriageGroupFullnessQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CarriageGroupFullnessQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', carriageGroupById: { __typename: 'CarriageGroupDto', id: number, turnovers: Array<{ __typename: 'TurnoverDto', id: number }>, periodicities: Array<{ __typename: 'PeriodicityDto', id: number }>, carriage_parameters: Array<{ __typename: 'CarriageParameterDto', id: number }> } } };

export type GetCarriageGroupTrainInfoQueryVariables = Exact<{
  data: GetTurnoverChartDto;
}>;


export type GetCarriageGroupTrainInfoQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', getCarriageGroupTurnoverChart: { __typename: 'TurnoverChartDto', train_info: { __typename: 'CarriageGroupTurnoverChartTrainInfoDto', branch: string, name: string, rolling_stock_type: string, structural_subdivision: string, train_quantity: string, turnover_time: string, passenger_carriers: string, railway_administration: string } } } };

export type CarriageGroupHeaderAndFullnessQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CarriageGroupHeaderAndFullnessQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', carriageGroupById: { __typename: 'CarriageGroupDto', id: number, gdp: { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string }, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, structural_subdivision?: { __typename: 'MvpsCompanyAffiliationDto', entity_id: number, id: number, mvps_owner: string, start_at: string, end_at: string } | { __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, turnovers: Array<{ __typename: 'TurnoverDto', departure_dates: Array<string> }>, periodicities: Array<{ __typename: 'PeriodicityDto', id: number }>, carriage_parameters: Array<{ __typename: 'CarriageParameterDto', id: number }> } } };

export type GetCarriageGroupTurnoverChartQueryVariables = Exact<{
  data: GetTurnoverChartDto;
}>;


export type GetCarriageGroupTurnoverChartQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', getCarriageGroupTurnoverChart: { __typename: 'TurnoverChartDto', items: Array<{ __typename: 'CarriageGroupTurnoverChartDataDto', category: string, from_date: string, to_date: string, train_number: string, station?: string | null, train_from_station: string, train_to_station: string, turnover_from_station: string, turnover_to_station: string, is_formation_point: boolean, is_turnover_point: boolean, trip_time: number }>, train_info: { __typename: 'CarriageGroupTurnoverChartTrainInfoDto', branch: string, name: string, rolling_stock_type: string, structural_subdivision: string, train_quantity: string, turnover_time: string, passenger_carriers: string, railway_administration: string } } } };

export type CreateCarriageGroupMutationVariables = Exact<{
  data: CreateCarriageGroupDto;
}>;


export type CreateCarriageGroupMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', createCarriageGroup: number } };

export type AddCarriageMvpsMutationVariables = Exact<{
  data: CreateCarriageMvpsDto;
}>;


export type AddCarriageMvpsMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', addCarriageMvps: boolean } };

export type AddCarriageNpsMutationVariables = Exact<{
  data: CreateCarriageNpsDto;
}>;


export type AddCarriageNpsMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', addCarriageNps?: number | null } };

export type AddPeriodicityMutationVariables = Exact<{
  data: CreatePeriodicityDto;
}>;


export type AddPeriodicityMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', addPeriodicity: number } };

export type AddTurnoverMutationVariables = Exact<{
  data: CreateTurnoverDto;
}>;


export type AddTurnoverMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', addTurnover: number } };

export type AddTurnoverTimeStagnationMutationVariables = Exact<{
  data: CreateTurnoverTimeStagnationDto;
}>;


export type AddTurnoverTimeStagnationMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', addTurnoverTimeStagnation: boolean } };

export type CarriageGroupByIdQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CarriageGroupByIdQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', carriageGroupById: { __typename: 'CarriageGroupDto', id: number, status: string, step_status: string, is_lock: boolean, is_manual_trip_formation_for_schema: boolean, name: string, rolling_stock_type: string, parent_id?: number | null, version: number, start_at: string, end_at: string, gdp: { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string }, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, periodicities: Array<{ __typename: 'PeriodicityDto', id: number, from_date: string, metadata?: Array<string> | null, periodicity: string, to_date: string }>, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, turnovers: Array<{ __typename: 'TurnoverDto', id: number, accepted_train_schemas_ids?: Array<number> | null, arrival_dates: Array<string>, arrival_dates_with_time_stagnation: Array<string>, departure_dates: Array<string>, group_sign: string, is_pbg: boolean, is_schemas_accepted: boolean, is_start_position_for_sale_direct_tickets: boolean, is_time_stagnation_variable: boolean, is_turnover_station_for_schema: boolean, order_number: number, position: string, seats_for_sale?: number | null, seats_total?: number | null, station_from: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, station_to: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, train: { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number } | null, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number }> | null }, schemas: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number }>, turnover_time_stagnations: Array<{ __typename: 'TurnoverTimeStagnationDto', id: number, created_at: string, created_by?: number | null, updated_at: string, updated_by?: number | null, time_in_stagnation: number, arrival_dates: Array<string> }> }>, decline_history: Array<{ __typename: 'DeclineHistoryDto', id: number, created_at: string, comment: string, user: { __typename: 'UserDto', user_name: string } }>, carriage_parameters: Array<{ __typename: 'CarriageParameterDto', id: number, is_all_additional_parameter_order_numbers_set: boolean, number_from_head: number, carriage?: { __typename: 'CarriageDto', id: number, rolling_stock_type: string, is_lock: boolean, item?: { __typename: 'CarriageMvpsDto', id: number, start_at: string, end_at: string, seats_quantity: number, is_lock: boolean, lineup_length?: number | null, carriage_type?: { __typename: 'CarriageTypeDto', entity_id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string, seat_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, carriage_types_for_schema?: { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string, carriage_type_asu?: { __typename: 'CarriageTypeAsuDto', id: number, entity_id: number, full_name: string, short_name: string } | null } | null, regulatory_sector: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, rolling_stock_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string } } | null, mvps_martin_section_type?: { __typename: 'MvpsMartinSectionTypeDto', id: number, entity_id: number, start_at: string, end_at: string, series: string, mvps_martin_section_type_equipment_id: number, carriage_quantity_in_section: number, price: number } | null } | { __typename: 'CarriageNpsDto', id: number, created_by?: number | null, updated_by?: number | null, created_at: string, updated_at: string, start_at: string, end_at: string, is_eco_toilets: boolean, is_air_conditioner: boolean, is_centralized_power_supply: boolean, seats_quantity: number, is_lock: boolean, carriage_type?: { __typename: 'CarriageTypeDto', entity_id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string, carriage_types_for_schema?: { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string, carriage_type_asu?: { __typename: 'CarriageTypeAsuDto', id: number, entity_id: number, full_name: string, short_name: string } | null } | null, regulatory_sector: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, seat_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, rolling_stock_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string } } | null, carriage_dimension?: { __typename: 'NpsCarriageDimensionDto', id: number, entity_id: number, start_at: string, end_at: string, carriage_dimension: string, description?: string | null } | null, carriage_model?: { __typename: 'NpsCarriageModelDto', entity_id: number, id: number, start_at: string, end_at: string, carriage_model: string, description?: string | null } | null, carriage_brake_type?: { __typename: 'NpsCarriageBrakeTypeDto', id: number, entity_id: number, start_at: string, end_at: string, brake_type: string, description?: string | null } | null, carriage_heat_type?: { __typename: 'NpsCarriageHeatTypeDto', id: number, entity_id: number, start_at: string, end_at: string, heat_type: string, description?: string | null } | null, carriage_length?: { __typename: 'NpsCarriageLengthDto', id: number, entity_id: number, start_at: string, end_at: string, carriage_length_asu_ms: number, carriage_length_in_train_schema: number, description?: string | null } | null, carriage_type_asu?: { __typename: 'CarriageTypeAsuDto', entity_id: number, start_at: string, end_at: string, short_name: string, full_name: string } | null } | null } | null, carriage_additional_parameters: Array<{ __typename: 'CarriageAdditionalParameterDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, carriage_train_info?: { __typename: 'CarriageTrainInfoDto', id: number, order_number?: string | null, notes?: string | null, carriage_additional_parameters: Array<string>, available_service_classes: Array<{ __typename: 'AvailableServiceClassDto', id: number, entity_id: number, start_at: string, end_at: string, service_class: string }> } | null, train: { __typename: 'TrainDto', id: number, train_number: string, sub_category?: { __typename: 'TrainSubCategoryDto', train_category_id: number } | null }, carriage_seats_allocations: Array<{ __typename: 'CarriageSeatsAllocationDto', id: number, all_seats: Array<number>, quantity?: number | null, description?: string | null, for_whom_seats_allocation: { __typename: 'CarriageSeatAllocationDto', entity_id: number, name: string } }>, carriage_additional_seats_signs: Array<{ __typename: 'CarriageAdditionalSeatsSignDto', id: number, all_seats: Array<number>, quantity?: number | null, description?: string | null, for_whom_additional_seats_sign: { __typename: 'CarriageAdditionalSeatSignDto', entity_id: number, name: string } }>, turnover: { __typename: 'TurnoverDto', station_from: { __typename: 'StationDto', entity_id: number, full_name: string }, station_to: { __typename: 'StationDto', entity_id: number, full_name: string } } }> }>, structural_subdivision?: { __typename: 'MvpsCompanyAffiliationDto', entity_id: number, mvps_owner: string, start_at: string } | { __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string, station: { __typename: 'StationDto', entity_id: number, full_name: string } } | null, train_quantities: Array<{ __typename: 'TrainQuantityDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, quantity: number, departure_dates: Array<string>, arrival_dates_with_time_stagnation: Array<string> }>, turnaround_times: Array<{ __typename: 'TurnaroundTimeDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, turn_around_time: number, departure_dates: Array<string>, arrival_dates_with_time_stagnation: Array<string> }> } }, indicators: { __typename: 'IndicatorsQueryEntryPoint', indicators_monthly: { __typename: 'CarriageGroupIndicatorResponseList', totalCount: number } } };

export type CarriageGroupHeaderQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CarriageGroupHeaderQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', carriageGroupById: { __typename: 'CarriageGroupDto', id: number, gdp: { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string }, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, structural_subdivision?: { __typename: 'MvpsCompanyAffiliationDto', entity_id: number, id: number, mvps_owner: string, start_at: string, end_at: string } | { __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, turnovers: Array<{ __typename: 'TurnoverDto', departure_dates: Array<string> }> } } };

export type CarriageGroupTurnoversTimeStagnationQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CarriageGroupTurnoversTimeStagnationQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', carriageGroupById: { __typename: 'CarriageGroupDto', id: number, turnovers: Array<{ __typename: 'TurnoverDto', id: number, accepted_train_schemas_ids?: Array<number> | null, arrival_dates: Array<string>, arrival_dates_with_time_stagnation: Array<string>, departure_dates: Array<string>, group_sign: string, is_pbg: boolean, is_schemas_accepted: boolean, is_start_position_for_sale_direct_tickets: boolean, is_time_stagnation_variable: boolean, is_turnover_station_for_schema: boolean, order_number: number, position: string, seats_for_sale?: number | null, seats_total?: number | null, turnover_time_stagnations: Array<{ __typename: 'TurnoverTimeStagnationDto', id: number, created_at: string, created_by?: number | null, updated_at: string, updated_by?: number | null, time_in_stagnation: number, arrival_dates: Array<string> }> }> } } };

export type CheckCarriageGroupCarriageNumbersQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CheckCarriageGroupCarriageNumbersQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', checkCarriageGroupCarriageNumbers: { __typename: 'CheckCarriageGroupCarriageNumbersDto', error_message?: Array<string> | null, is_error_belongs_to_carriage_numbers_validation: boolean, is_valid: boolean } } };

export type CheckCarriagesByDateQueryVariables = Exact<{
  data: CarriageGroupCheckCarriagesByDateRequestDto;
}>;


export type CheckCarriagesByDateQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', check_carriages_by_date: boolean } };

export type CopyCarriageMutationVariables = Exact<{
  data: CopyCarriageParameterDto;
}>;


export type CopyCarriageMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', copyCarriage: boolean } };

export type GetDatesDataToAddTimeStagnationQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type GetDatesDataToAddTimeStagnationQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', getDatesDataToAddTimeStagnation: { __typename: 'TurnoverAddTimeStagnationDatesInfoDto', available_dates_to_select: Array<string> } } };

export type GetDatesDataToUpdateTimeStagnationQueryVariables = Exact<{
  data: TurnoverUpdateTimeStagnationDatesInfoReqDto;
}>;


export type GetDatesDataToUpdateTimeStagnationQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', getDatesDataToUpdateTimeStagnation: { __typename: 'TurnoverUpdateTimeStagnationDatesInfoDto', available_dates_to_select: Array<string>, selected_dates: Array<string> } } };

export type DeleteCarriageParametersMutationVariables = Exact<{
  data: DeleteCarriageParameter;
}>;


export type DeleteCarriageParametersMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', deleteCarriageParameters?: boolean | null } };

export type DeletePeriodicityMutationVariables = Exact<{
  data: DeletePeriodicityDto;
}>;


export type DeletePeriodicityMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', deletePeriodicity?: boolean | null } };

export type DeleteTurnoverMutationVariables = Exact<{
  data: DeleteTurnoverDto;
}>;


export type DeleteTurnoverMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', deleteTurnover?: boolean | null } };

export type DeleteTurnoverTimeStagnationMutationVariables = Exact<{
  data: DeleteTurnoverTimeStagnationDto;
}>;


export type DeleteTurnoverTimeStagnationMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', deleteTurnoverTimeStagnation?: boolean | null } };

export type ExportCarriageGroupToSchemasMutationVariables = Exact<{
  data: ExportCarriageGroupDto;
}>;


export type ExportCarriageGroupToSchemasMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', exportCarriageGroupToSchemas?: any | null } };

export type CarriageSeatsCountByCarriageDimensionAndTypeAsuQueryVariables = Exact<{
  data: ByTypeAsuDimensionIdQueryDataDto;
}>;


export type CarriageSeatsCountByCarriageDimensionAndTypeAsuQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageTypeAsuDimensionSeatsCount: { __typename: 'CarriageTypeAsuDimensionSeatsCountQueryEntryPoint', byTypeAsuDimensionId: { __typename: 'CarriageTypeAsuDimensionSeatsCountDto', id: number, default_seats_count: number } } } };

export type GetTurnoverFromStationListQueryVariables = Exact<{
  data: GetTurnoverFromStationListRequestDto;
}>;


export type GetTurnoverFromStationListQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', getTurnoverFromStationList: { __typename: 'GetTurnoverFromStationListResponseDto', stations?: Array<{ __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }> | null } } };

export type GetTurnoverToStationListQueryVariables = Exact<{
  data: GetTurnoverToStationListRequestDto;
}>;


export type GetTurnoverToStationListQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', getTurnoverToStationList: { __typename: 'GetTurnoverToStationListResponseDto', stations?: Array<{ __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null }> | null } } };

export type TrainListForTurnoverQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainQueryResolver_List_SortingInputType> | TrainQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TrainQueryResolver_List_FilterInputType>;
}>;


export type TrainListForTurnoverQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', list: { __typename: 'TrainList', items: Array<{ __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number } | null, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number }> | null, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> } } };

export type UpdateCarriageAdditionalInfoParametersMutationVariables = Exact<{
  data: UpdateAllCarriageParametersDto;
}>;


export type UpdateCarriageAdditionalInfoParametersMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', updateCarriageAdditionalInfoParameters?: boolean | null } };

export type UpdateCarriageGroupMutationVariables = Exact<{
  data: UpdateCarriageGroupDto;
}>;


export type UpdateCarriageGroupMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', updateCarriageGroup?: boolean | null } };

export type UpdateCarriageMvpsMutationVariables = Exact<{
  data: UpdateCarriageMvpsDto;
}>;


export type UpdateCarriageMvpsMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', updateCarriageMvps?: boolean | null } };

export type UpdateCarriageNpsMutationVariables = Exact<{
  data: UpdateCarriageNpsDto;
}>;


export type UpdateCarriageNpsMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', updateCarriageNps?: boolean | null } };

export type UpdatePeriodicityMutationVariables = Exact<{
  data: UpdatePeriodicityDto;
}>;


export type UpdatePeriodicityMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', updatePeriodicity?: boolean | null } };

export type UpdateTurnoverMutationVariables = Exact<{
  data: UpdateTurnoverDto;
}>;


export type UpdateTurnoverMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', updateTurnover?: boolean | null } };

export type UpdateTurnoverTimeStagnationMutationVariables = Exact<{
  data: UpdateTurnoverTimeStagnationDto;
}>;


export type UpdateTurnoverTimeStagnationMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', updateTurnoverTimeStagnation?: boolean | null } };

export type CopyCarriageGroupMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CopyCarriageGroupMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', copy?: number | null } };

export type DeleteCarriageGroupMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteCarriageGroupMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', deleteCarriageGroup?: boolean | null } };

export type CarriageGroupListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageGroupQueryResolver_CarriageGroupList_SortingInputType> | CarriageGroupQueryResolver_CarriageGroupList_SortingInputType>;
  where?: InputMaybe<CarriageGroupQueryResolver_CarriageGroupList_FilterInputType>;
  search: Scalars['String']['input'];
}>;


export type CarriageGroupListQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', carriageGroupList: { __typename: 'CarriageGroupList', totalCount: number, items: Array<{ __typename: 'CarriageGroupViewDto', id?: number | null, name?: string | null, branch_id?: number | null, passenger_carriers_id?: number | null, railway_administration_id?: number | null, structural_subdivision_id?: number | null, rolling_stock_type?: string | null, step_status?: string | null, status?: string | null, train_numbers?: Array<string> | null, train_statuses?: Array<string> | null, from_stations?: Array<string> | null, to_stations?: Array<string> | null, branch?: string | null, passenger_carrier?: string | null, railway_administration?: string | null, structural_subdivision?: string | null, min_train_quantity?: number | null, max_train_quantity?: number | null, min_turnaround_time?: number | null, max_turnaround_time?: number | null, carriage_dimension_ids?: Array<number> | null, train_ids?: Array<number> | null, dimensions?: string | null, carriage_types?: Array<string> | null, periodicity?: Array<string> | null, parent_id?: number | null, station_affiliation?: string | null, first_departure_date?: string | null, version: number, start_at: string, end_at: string, parent?: { __typename: 'CarriageGroupViewDto', name?: string | null } | null }> } } };

export type RevokeCarriageGroupMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type RevokeCarriageGroupMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', revokeCarriageGroup?: boolean | null } };

export type ExportCarriageGroupListMutationVariables = Exact<{
  where: CarriageGroupMutationResolver_ExportCarriageGroupsList_FilterInputType;
}>;


export type ExportCarriageGroupListMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', exportCarriageGroupsList?: any | null } };

export type ChangeCapacityQueryVariables = Exact<{
  data: CapacityRequestDto;
}>;


export type ChangeCapacityQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_schema: { __typename: 'ControlSchemaQueryEntryPoint', capacity: { __typename: 'CapacityDto', compare: { __typename: 'CapacityCompareDto', items: Array<{ __typename: 'CapacityRowCompareDto', seats_turnover_current: number, seats_turnover_current_dereg: number, seats_turnover_current_reg: number, seats_turnover_compare: number, seats_turnover_compare_dereg: number, seats_turnover_compare_reg: number, seats_quantity_current: number, seats_quantity_current_dereg: number, seats_quantity_current_reg: number, seats_quantity_compare: number, seats_quantity_compare_dereg: number, seats_quantity_compare_reg: number, carriages_turnover_current: number, carriages_turnover_current_dereg: number, carriages_turnover_current_reg: number, carriages_turnover_compare: number, carriages_turnover_compare_dereg: number, carriages_turnover_compare_reg: number, carriages_quantity_current: number, carriages_quantity_current_dereg: number, carriages_quantity_current_reg: number, carriages_quantity_compare: number, carriages_quantity_compare_dereg: number, carriages_quantity_compare_reg: number, trains_turnover_current: number, trains_turnover_current_dereg: number, trains_turnover_current_reg: number, trains_turnover_compare: number, trains_turnover_compare_dereg: number, trains_turnover_compare_reg: number, trains_quantity_current: number, trains_quantity_current_dereg: number, trains_quantity_current_reg: number, trains_quantity_compare: number, trains_quantity_compare_dereg: number, trains_quantity_compare_reg: number, seats_turnover_tolerance: number, seats_turnover_tolerance_dereg: number, seats_turnover_tolerance_reg: number, seats_quantity_tolerance: number, seats_quantity_tolerance_dereg: number, seats_quantity_tolerance_reg: number, carriages_turnover_tolerance: number, carriages_turnover_tolerance_dereg: number, carriages_turnover_tolerance_reg: number, carriages_quantity_tolerance: number, carriages_quantity_tolerance_dereg: number, carriages_quantity_tolerance_reg: number, trains_turnover_tolerance: number, trains_turnover_tolerance_dereg: number, trains_turnover_tolerance_reg: number, trains_quantity_tolerance: number, trains_quantity_tolerance_dereg: number, trains_quantity_tolerance_reg: number, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null }>, total: { __typename: 'CapacityCompareTotalDto', seats_turnover_current: number, seats_turnover_current_dereg: number, seats_turnover_current_reg: number, seats_turnover_compare: number, seats_turnover_compare_dereg: number, seats_turnover_compare_reg: number, seats_quantity_current: number, seats_quantity_current_dereg: number, seats_quantity_current_reg: number, seats_quantity_compare: number, seats_quantity_compare_dereg: number, seats_quantity_compare_reg: number, carriages_turnover_current: number, carriages_turnover_current_dereg: number, carriages_turnover_current_reg: number, carriages_turnover_compare: number, carriages_turnover_compare_dereg: number, carriages_turnover_compare_reg: number, carriages_quantity_current: number, carriages_quantity_current_dereg: number, carriages_quantity_current_reg: number, carriages_quantity_compare: number, carriages_quantity_compare_dereg: number, carriages_quantity_compare_reg: number, trains_turnover_current: number, trains_turnover_current_dereg: number, trains_turnover_current_reg: number, trains_turnover_compare: number, trains_turnover_compare_dereg: number, trains_turnover_compare_reg: number, trains_quantity_current: number, trains_quantity_current_dereg: number, trains_quantity_current_reg: number, trains_quantity_compare: number, trains_quantity_compare_dereg: number, trains_quantity_compare_reg: number, seats_turnover_tolerance: number, seats_turnover_tolerance_dereg: number, seats_turnover_tolerance_reg: number, seats_quantity_tolerance: number, seats_quantity_tolerance_dereg: number, seats_quantity_tolerance_reg: number, carriages_turnover_tolerance: number, carriages_turnover_tolerance_dereg: number, carriages_turnover_tolerance_reg: number, carriages_quantity_tolerance: number, carriages_quantity_tolerance_dereg: number, carriages_quantity_tolerance_reg: number, trains_turnover_tolerance: number, trains_turnover_tolerance_dereg: number, trains_turnover_tolerance_reg: number, trains_quantity_tolerance: number, trains_quantity_tolerance_dereg: number, trains_quantity_tolerance_reg: number } }, current: { __typename: 'CapacityCurrentDto', items: Array<{ __typename: 'CapacityRowCurrentDto', seats_turnover_current: number, seats_turnover_current_dereg: number, seats_turnover_current_reg: number, seats_turnover_compare: number, seats_turnover_compare_dereg: number, seats_turnover_compare_reg: number, seats_quantity_current: number, seats_quantity_current_dereg: number, seats_quantity_current_reg: number, seats_quantity_compare: number, seats_quantity_compare_dereg: number, seats_quantity_compare_reg: number, carriages_turnover_current: number, carriages_turnover_current_dereg: number, carriages_turnover_current_reg: number, carriages_turnover_compare: number, carriages_turnover_compare_dereg: number, carriages_turnover_compare_reg: number, carriages_quantity_current: number, carriages_quantity_current_dereg: number, carriages_quantity_current_reg: number, carriages_quantity_compare: number, carriages_quantity_compare_dereg: number, carriages_quantity_compare_reg: number, trains_turnover_current: number, trains_turnover_current_dereg: number, trains_turnover_current_reg: number, trains_turnover_compare: number, trains_turnover_compare_dereg: number, trains_turnover_compare_reg: number, trains_quantity_current: number, trains_quantity_current_dereg: number, trains_quantity_current_reg: number, trains_quantity_compare: number, trains_quantity_compare_dereg: number, trains_quantity_compare_reg: number, seats_turnover_plan: number, seats_turnover_plan_dereg: number, seats_turnover_plan_reg: number, seats_turnover_percentage: number, seats_turnover_percentage_dereg: number, seats_turnover_percentage_reg: number, seats_quantity_plan: number, seats_quantity_plan_dereg: number, seats_quantity_plan_reg: number, seats_quantity_percentage: number, seats_quantity_percentage_dereg: number, seats_quantity_percentage_reg: number, carriages_turnover_plan: number, carriages_turnover_plan_dereg: number, carriages_turnover_plan_reg: number, carriages_turnover_percentage: number, carriages_turnover_percentage_dereg: number, carriages_turnover_percentage_reg: number, carriages_quantity_plan: number, carriages_quantity_plan_dereg: number, carriages_quantity_plan_reg: number, carriages_quantity_percentage: number, carriages_quantity_percentage_dereg: number, carriages_quantity_percentage_reg: number, trains_turnover_plan: number, trains_turnover_plan_dereg: number, trains_turnover_plan_reg: number, trains_turnover_percentage: number, trains_turnover_percentage_dereg: number, trains_turnover_percentage_reg: number, trains_quantity_plan: number, trains_quantity_plan_dereg: number, trains_quantity_plan_reg: number, trains_quantity_percentage: number, trains_quantity_percentage_dereg: number, trains_quantity_percentage_reg: number, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null }>, total: { __typename: 'CapacityCurrentTotalDto', seats_turnover_current: number, seats_turnover_current_dereg: number, seats_turnover_current_reg: number, seats_turnover_compare: number, seats_turnover_compare_dereg: number, seats_turnover_compare_reg: number, seats_quantity_current: number, seats_quantity_current_dereg: number, seats_quantity_current_reg: number, seats_quantity_compare: number, seats_quantity_compare_dereg: number, seats_quantity_compare_reg: number, carriages_turnover_current: number, carriages_turnover_current_dereg: number, carriages_turnover_current_reg: number, carriages_turnover_compare: number, carriages_turnover_compare_dereg: number, carriages_turnover_compare_reg: number, carriages_quantity_current: number, carriages_quantity_current_dereg: number, carriages_quantity_current_reg: number, carriages_quantity_compare: number, carriages_quantity_compare_dereg: number, carriages_quantity_compare_reg: number, trains_turnover_current: number, trains_turnover_current_dereg: number, trains_turnover_current_reg: number, trains_turnover_compare: number, trains_turnover_compare_dereg: number, trains_turnover_compare_reg: number, trains_quantity_current: number, trains_quantity_current_dereg: number, trains_quantity_current_reg: number, trains_quantity_compare: number, trains_quantity_compare_dereg: number, trains_quantity_compare_reg: number, seats_turnover_plan: number, seats_turnover_plan_dereg: number, seats_turnover_plan_reg: number, seats_turnover_percentage: number, seats_turnover_percentage_dereg: number, seats_turnover_percentage_reg: number, seats_quantity_plan: number, seats_quantity_plan_dereg: number, seats_quantity_plan_reg: number, seats_quantity_percentage: number, seats_quantity_percentage_dereg: number, seats_quantity_percentage_reg: number, carriages_turnover_plan: number, carriages_turnover_plan_dereg: number, carriages_turnover_plan_reg: number, carriages_turnover_percentage: number, carriages_turnover_percentage_dereg: number, carriages_turnover_percentage_reg: number, carriages_quantity_plan: number, carriages_quantity_plan_dereg: number, carriages_quantity_plan_reg: number, carriages_quantity_percentage: number, carriages_quantity_percentage_dereg: number, carriages_quantity_percentage_reg: number, trains_turnover_plan: number, trains_turnover_plan_dereg: number, trains_turnover_plan_reg: number, trains_turnover_percentage: number, trains_turnover_percentage_dereg: number, trains_turnover_percentage_reg: number, trains_quantity_plan: number, trains_quantity_plan_dereg: number, trains_quantity_plan_reg: number, trains_quantity_percentage: number, trains_quantity_percentage_dereg: number, trains_quantity_percentage_reg: number } } } } } };

export type ControlSchemaCompareTableDataFragmentFragment = { __typename: 'CapacityRowCompareDto', seats_turnover_current: number, seats_turnover_current_dereg: number, seats_turnover_current_reg: number, seats_turnover_compare: number, seats_turnover_compare_dereg: number, seats_turnover_compare_reg: number, seats_quantity_current: number, seats_quantity_current_dereg: number, seats_quantity_current_reg: number, seats_quantity_compare: number, seats_quantity_compare_dereg: number, seats_quantity_compare_reg: number, carriages_turnover_current: number, carriages_turnover_current_dereg: number, carriages_turnover_current_reg: number, carriages_turnover_compare: number, carriages_turnover_compare_dereg: number, carriages_turnover_compare_reg: number, carriages_quantity_current: number, carriages_quantity_current_dereg: number, carriages_quantity_current_reg: number, carriages_quantity_compare: number, carriages_quantity_compare_dereg: number, carriages_quantity_compare_reg: number, trains_turnover_current: number, trains_turnover_current_dereg: number, trains_turnover_current_reg: number, trains_turnover_compare: number, trains_turnover_compare_dereg: number, trains_turnover_compare_reg: number, trains_quantity_current: number, trains_quantity_current_dereg: number, trains_quantity_current_reg: number, trains_quantity_compare: number, trains_quantity_compare_dereg: number, trains_quantity_compare_reg: number, seats_turnover_tolerance: number, seats_turnover_tolerance_dereg: number, seats_turnover_tolerance_reg: number, seats_quantity_tolerance: number, seats_quantity_tolerance_dereg: number, seats_quantity_tolerance_reg: number, carriages_turnover_tolerance: number, carriages_turnover_tolerance_dereg: number, carriages_turnover_tolerance_reg: number, carriages_quantity_tolerance: number, carriages_quantity_tolerance_dereg: number, carriages_quantity_tolerance_reg: number, trains_turnover_tolerance: number, trains_turnover_tolerance_dereg: number, trains_turnover_tolerance_reg: number, trains_quantity_tolerance: number, trains_quantity_tolerance_dereg: number, trains_quantity_tolerance_reg: number };

export type ControlSchemaCompareTableTotalFragmentFragment = { __typename: 'CapacityCompareTotalDto', seats_turnover_current: number, seats_turnover_current_dereg: number, seats_turnover_current_reg: number, seats_turnover_compare: number, seats_turnover_compare_dereg: number, seats_turnover_compare_reg: number, seats_quantity_current: number, seats_quantity_current_dereg: number, seats_quantity_current_reg: number, seats_quantity_compare: number, seats_quantity_compare_dereg: number, seats_quantity_compare_reg: number, carriages_turnover_current: number, carriages_turnover_current_dereg: number, carriages_turnover_current_reg: number, carriages_turnover_compare: number, carriages_turnover_compare_dereg: number, carriages_turnover_compare_reg: number, carriages_quantity_current: number, carriages_quantity_current_dereg: number, carriages_quantity_current_reg: number, carriages_quantity_compare: number, carriages_quantity_compare_dereg: number, carriages_quantity_compare_reg: number, trains_turnover_current: number, trains_turnover_current_dereg: number, trains_turnover_current_reg: number, trains_turnover_compare: number, trains_turnover_compare_dereg: number, trains_turnover_compare_reg: number, trains_quantity_current: number, trains_quantity_current_dereg: number, trains_quantity_current_reg: number, trains_quantity_compare: number, trains_quantity_compare_dereg: number, trains_quantity_compare_reg: number, seats_turnover_tolerance: number, seats_turnover_tolerance_dereg: number, seats_turnover_tolerance_reg: number, seats_quantity_tolerance: number, seats_quantity_tolerance_dereg: number, seats_quantity_tolerance_reg: number, carriages_turnover_tolerance: number, carriages_turnover_tolerance_dereg: number, carriages_turnover_tolerance_reg: number, carriages_quantity_tolerance: number, carriages_quantity_tolerance_dereg: number, carriages_quantity_tolerance_reg: number, trains_turnover_tolerance: number, trains_turnover_tolerance_dereg: number, trains_turnover_tolerance_reg: number, trains_quantity_tolerance: number, trains_quantity_tolerance_dereg: number, trains_quantity_tolerance_reg: number };

export type ControlSchemaCurrentTableDataFragmentFragment = { __typename: 'CapacityRowCurrentDto', seats_turnover_current: number, seats_turnover_current_dereg: number, seats_turnover_current_reg: number, seats_turnover_compare: number, seats_turnover_compare_dereg: number, seats_turnover_compare_reg: number, seats_quantity_current: number, seats_quantity_current_dereg: number, seats_quantity_current_reg: number, seats_quantity_compare: number, seats_quantity_compare_dereg: number, seats_quantity_compare_reg: number, carriages_turnover_current: number, carriages_turnover_current_dereg: number, carriages_turnover_current_reg: number, carriages_turnover_compare: number, carriages_turnover_compare_dereg: number, carriages_turnover_compare_reg: number, carriages_quantity_current: number, carriages_quantity_current_dereg: number, carriages_quantity_current_reg: number, carriages_quantity_compare: number, carriages_quantity_compare_dereg: number, carriages_quantity_compare_reg: number, trains_turnover_current: number, trains_turnover_current_dereg: number, trains_turnover_current_reg: number, trains_turnover_compare: number, trains_turnover_compare_dereg: number, trains_turnover_compare_reg: number, trains_quantity_current: number, trains_quantity_current_dereg: number, trains_quantity_current_reg: number, trains_quantity_compare: number, trains_quantity_compare_dereg: number, trains_quantity_compare_reg: number, seats_turnover_plan: number, seats_turnover_plan_dereg: number, seats_turnover_plan_reg: number, seats_turnover_percentage: number, seats_turnover_percentage_dereg: number, seats_turnover_percentage_reg: number, seats_quantity_plan: number, seats_quantity_plan_dereg: number, seats_quantity_plan_reg: number, seats_quantity_percentage: number, seats_quantity_percentage_dereg: number, seats_quantity_percentage_reg: number, carriages_turnover_plan: number, carriages_turnover_plan_dereg: number, carriages_turnover_plan_reg: number, carriages_turnover_percentage: number, carriages_turnover_percentage_dereg: number, carriages_turnover_percentage_reg: number, carriages_quantity_plan: number, carriages_quantity_plan_dereg: number, carriages_quantity_plan_reg: number, carriages_quantity_percentage: number, carriages_quantity_percentage_dereg: number, carriages_quantity_percentage_reg: number, trains_turnover_plan: number, trains_turnover_plan_dereg: number, trains_turnover_plan_reg: number, trains_turnover_percentage: number, trains_turnover_percentage_dereg: number, trains_turnover_percentage_reg: number, trains_quantity_plan: number, trains_quantity_plan_dereg: number, trains_quantity_plan_reg: number, trains_quantity_percentage: number, trains_quantity_percentage_dereg: number, trains_quantity_percentage_reg: number };

export type ControlSchemaCurrentTableTotalFragmentFragment = { __typename: 'CapacityCurrentTotalDto', seats_turnover_current: number, seats_turnover_current_dereg: number, seats_turnover_current_reg: number, seats_turnover_compare: number, seats_turnover_compare_dereg: number, seats_turnover_compare_reg: number, seats_quantity_current: number, seats_quantity_current_dereg: number, seats_quantity_current_reg: number, seats_quantity_compare: number, seats_quantity_compare_dereg: number, seats_quantity_compare_reg: number, carriages_turnover_current: number, carriages_turnover_current_dereg: number, carriages_turnover_current_reg: number, carriages_turnover_compare: number, carriages_turnover_compare_dereg: number, carriages_turnover_compare_reg: number, carriages_quantity_current: number, carriages_quantity_current_dereg: number, carriages_quantity_current_reg: number, carriages_quantity_compare: number, carriages_quantity_compare_dereg: number, carriages_quantity_compare_reg: number, trains_turnover_current: number, trains_turnover_current_dereg: number, trains_turnover_current_reg: number, trains_turnover_compare: number, trains_turnover_compare_dereg: number, trains_turnover_compare_reg: number, trains_quantity_current: number, trains_quantity_current_dereg: number, trains_quantity_current_reg: number, trains_quantity_compare: number, trains_quantity_compare_dereg: number, trains_quantity_compare_reg: number, seats_turnover_plan: number, seats_turnover_plan_dereg: number, seats_turnover_plan_reg: number, seats_turnover_percentage: number, seats_turnover_percentage_dereg: number, seats_turnover_percentage_reg: number, seats_quantity_plan: number, seats_quantity_plan_dereg: number, seats_quantity_plan_reg: number, seats_quantity_percentage: number, seats_quantity_percentage_dereg: number, seats_quantity_percentage_reg: number, carriages_turnover_plan: number, carriages_turnover_plan_dereg: number, carriages_turnover_plan_reg: number, carriages_turnover_percentage: number, carriages_turnover_percentage_dereg: number, carriages_turnover_percentage_reg: number, carriages_quantity_plan: number, carriages_quantity_plan_dereg: number, carriages_quantity_plan_reg: number, carriages_quantity_percentage: number, carriages_quantity_percentage_dereg: number, carriages_quantity_percentage_reg: number, trains_turnover_plan: number, trains_turnover_plan_dereg: number, trains_turnover_plan_reg: number, trains_turnover_percentage: number, trains_turnover_percentage_dereg: number, trains_turnover_percentage_reg: number, trains_quantity_plan: number, trains_quantity_plan_dereg: number, trains_quantity_plan_reg: number, trains_quantity_percentage: number, trains_quantity_percentage_dereg: number, trains_quantity_percentage_reg: number };

export type ControlAvailabilitySeatsListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<ControlAvailabilitySeatsQueryResolver_List_SortingInputType> | ControlAvailabilitySeatsQueryResolver_List_SortingInputType>;
  where?: InputMaybe<ControlAvailabilitySeatsQueryResolver_List_FilterInputType>;
}>;


export type ControlAvailabilitySeatsListQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_availability_seats: { __typename: 'ControlAvailabilitySeatsQueryEntryPoint', list: { __typename: 'ControlAvailabilitySeatsListDto', totalCount: number, items: Array<{ __typename: 'ControlAvailabilitySeatsDto', id: number, rcasd_id: number, train_id?: string | null, display_train_number: string, train_number: string, departure_time: number, composition_type?: string | null, sync_train_status: string, is_from_transit: boolean, is_to_transit: boolean, route: { __typename: 'RoutesControlAvailabilitySeatsDirectionsDto', id: number, arrival_direction?: { __typename: 'StationDto', full_name: string } | null, departure_direction?: { __typename: 'StationDto', full_name: string } | null }, passenger_carrier_russian_railway?: { __typename: 'PassengerCarrierDto', short_name: string } | null, csuCarrier?: { __typename: 'CsuCarrierDto', name: string } | null, trainStationTo?: { __typename: 'StationDto', entity_id: number, full_name: string } | null, trainStationFrom?: { __typename: 'StationDto', entity_id: number, full_name: string } | null, routeStationTo?: { __typename: 'StationDto', entity_id: number, full_name: string } | null, routeStationFrom?: { __typename: 'StationDto', entity_id: number, full_name: string } | null, seats?: Array<{ __typename: 'SeatsDto', count?: number | null, date?: string | null, max_price?: number | null, min_price?: number | null }> | null }> } } } };

export type ExportControlAvailabilitySeatsMutationVariables = Exact<{
  where?: InputMaybe<ControlAvailabilitySeatsMutationResolver_ExportToExcel_FilterInputType>;
}>;


export type ExportControlAvailabilitySeatsMutation = { __typename: 'Mutation', tpc: { __typename: 'TpcMutationEntryPoint', control_availability_seats: { __typename: 'ControlAvailabilitySeatsMutationEntryPoint', exportToExcel?: any | null } } };

export type SyncJournalQueryVariables = Exact<{
  where?: InputMaybe<SyncQueryResolver_List_FilterInputType>;
  orderBy?: InputMaybe<Array<SyncQueryResolver_List_SortingInputType> | SyncQueryResolver_List_SortingInputType>;
}>;


export type SyncJournalQuery = { __typename: 'Query', sync: { __typename: 'QueryEntryPoint', journal: { __typename: 'JournalSyncList', items: Array<{ __typename: 'JournalSyncDto', date: string }> } } };

export type SyncSeatsAvailabilityMutationVariables = Exact<{
  data: SyncSeatsAvailabilityDto;
}>;


export type SyncSeatsAvailabilityMutation = { __typename: 'Mutation', sync: { __typename: 'MutationEntryPoint', runSyncSeatsAvailability: boolean } };

export type ControlSchemaFilterBranchListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<BranchQueryResolver_List_SortingInputType> | BranchQueryResolver_List_SortingInputType>;
  where?: InputMaybe<BranchQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type ControlSchemaFilterBranchListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', branch: { __typename: 'BranchQueryEntryPoint', list: { __typename: 'BranchList', totalCount: number, items: Array<{ __typename: 'BranchDto', entity_id: number, short_name: string }> } } } };

export type ControlSchemaFilterPassengerCarrierListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<PassengerCarrierQueryResolver_List_SortingInputType> | PassengerCarrierQueryResolver_List_SortingInputType>;
  where?: InputMaybe<PassengerCarrierQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type ControlSchemaFilterPassengerCarrierListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', passengerCarrier: { __typename: 'PassengerCarrierQueryEntryPoint', list: { __typename: 'PassengerCarrierList', items: Array<{ __typename: 'PassengerCarrierDto', entity_id: number, short_name: string }> } } } };

export type ControlSchemaFilterRailwayAdministrationListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RailwayAdministrationQueryResolver_List_SortingInputType> | RailwayAdministrationQueryResolver_List_SortingInputType>;
  where?: InputMaybe<RailwayAdministrationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type ControlSchemaFilterRailwayAdministrationListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', railwayAdministration: { __typename: 'RailwayAdministrationQueryEntryPoint', list: { __typename: 'RailwayAdministrationList', items: Array<{ __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, name: string }> } } } };

export type ExportControlSchemaMutationVariables = Exact<{
  date: Scalars['String']['input'];
  where?: InputMaybe<ControlSchemaMutationResolver_ExportToExcel_FilterInputType>;
}>;


export type ExportControlSchemaMutation = { __typename: 'Mutation', tpc: { __typename: 'TpcMutationEntryPoint', control_schema: { __typename: 'ControlSchemaMutationEntryPoint', exportToExcel?: any | null } } };

export type ExportControlSchemaByBranchMutationVariables = Exact<{
  data: ExportControlSchemaByBranchDto;
}>;


export type ExportControlSchemaByBranchMutation = { __typename: 'Mutation', tpc: { __typename: 'TpcMutationEntryPoint', control_schema: { __typename: 'ControlSchemaMutationEntryPoint', exportToExcelByBranch?: any | null } } };

export type IndicatorsByBranchListQueryVariables = Exact<{
  key: TypeIndicators;
}>;


export type IndicatorsByBranchListQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_schema: { __typename: 'ControlSchemaQueryEntryPoint', indicators_by_branch: Array<{ __typename: 'ControlSchemaTotalIndicatorsDto', name: string, branches: Array<{ __typename: 'ControlSchemaIndicatorBranchDto', tolerance?: number | null, plan: number, percentage?: string | null, actual: number, branch?: { __typename: 'HaulierDto', entity_id: number, short_name: string } | null }> }> } } };

export type SchemaControlByBranchQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_SchemaControlByBranch_FilterInputType>;
  orderBy?: InputMaybe<Array<ControlSchemaQueryResolver_SchemaControlByBranch_SortingInputType> | ControlSchemaQueryResolver_SchemaControlByBranch_SortingInputType>;
  compareDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SchemaControlByBranchQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_schema: { __typename: 'ControlSchemaQueryEntryPoint', schemaControlByBranch: Array<{ __typename: 'SchemaControlByBranchDto', carriages_fact: number, carriages_percentage: number, carriages_plan: number, carriages_tolerance: number, carriages_turnover_fact: number, carriages_turnover_percentage: number, carriages_turnover_plan: number, carriages_turnover_tolerance: number, indicators_fact: number, indicators_percentage: number, indicators_plan: number, indicators_tolerance: number, seats_turnover_fact: number, seats_turnover_percentage: number, seats_turnover_plan: number, seats_turnover_tolerance: number, trains_fact: number, trains_percentage: number, trains_plan: number, trains_tolerance: number, trains_turnover_fact: number, trains_turnover_percentage: number, trains_turnover_plan: number, trains_turnover_tolerance: number, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null }> } } };

export type ControlSchemaListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_SchemaControlByTrainsCalculated_FilterInputType>;
  compareDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type ControlSchemaListQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_schema: { __typename: 'ControlSchemaQueryEntryPoint', schemaControlByTrainsCalculated: { __typename: 'SchemaControlCalculatedList', totalCount: number, items: Array<{ __typename: 'SchemaControlDto', train_id?: number | null, train_number: string, train_quantity?: number | null, trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, carriage_quantity?: number | null, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, indicators_fact?: number | null, indicators_plan?: number | null, version?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, short_name: string, name: string } | null, passenger_carrier_russian_railway?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, name: string, short_name: string } | null, railway_administration?: { __typename: 'RailwayAdministrationDto', code: number, entity_id: number, name: string, short_name: string } | null, station_from?: { __typename: 'StationDto', entity_id: number, express_code: string, full_name: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, express_code: string, full_name: string } | null, dates?: Array<{ __typename: 'SchemaControlByTrainDateDto', capacity: number, date: string, diff?: number | null, quantity: number }> | null, main_group_data?: { __typename: 'SchemaControlByTrainCarriageGroupBlockDto', trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, carriage_quantity?: number | null, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, indicators_fact?: number | null, indicators_plan?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, passenger_carrier_russian_railway?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, name: string, short_name: string } | null, railway_administration?: { __typename: 'RailwayAdministrationDto', code: number, entity_id: number, name: string, short_name: string } | null, dates?: Array<{ __typename: 'SchemaControlByTrainDateDto', capacity: number, date: string, diff?: number | null, quantity: number }> | null, groups: Array<{ __typename: 'SchemaControlByTrainCarriageGroupDto', trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, carriage_quantity?: number | null, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, indicators_fact?: number | null, indicators_plan?: number | null, carriage_group_id?: number | null, schema_number: Array<number>, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, passenger_carrier_russian_railway?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, name: string, short_name: string } | null, railway_administration?: { __typename: 'RailwayAdministrationDto', code: number, entity_id: number, name: string, short_name: string } | null, station_from?: { __typename: 'StationDto', entity_id: number, express_code: string, full_name: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, express_code: string, full_name: string } | null, dates?: Array<{ __typename: 'SchemaControlByTrainDateDto', capacity: number, date: string, diff?: number | null, quantity: number }> | null, carriages: Array<{ __typename: 'SchemaControlByTrainCarriageDto', trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, carriage_quantity?: number | null, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, carriage_type: string, indicators_fact?: number | null, indicators_plan?: number | null, dates?: Array<{ __typename: 'SchemaControlByTrainDateDto', capacity: number, date: string, diff?: number | null, quantity: number }> | null }> }> } | null, in_turnover_with_data?: Array<{ __typename: 'SchemaControlByTrainInTurnoverWithDto', display_train_number: string, trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, carriage_quantity?: number | null, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, indicators_fact?: number | null, indicators_plan?: number | null, branch?: { __typename: 'BranchDto', name: string, short_name: string, entity_id: number } | null, passenger_carrier_russian_railway?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, name: string, short_name: string } | null, railway_administration?: { __typename: 'RailwayAdministrationDto', entity_id: number, name: string, short_name: string, code: number } | null, station_from?: { __typename: 'StationDto', entity_id: number, express_code: string, full_name: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, express_code: string, full_name: string } | null, dates?: Array<{ __typename: 'SchemaControlByTrainDateDto', capacity: number, date: string, diff?: number | null, quantity: number }> | null }> | null, not_asu_ms_data?: { __typename: 'SchemaControlByTrainCarriageGroupBlockDto', trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, carriage_quantity?: number | null, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, indicators_fact?: number | null, indicators_plan?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, passenger_carrier_russian_railway?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, name: string, short_name: string } | null, railway_administration?: { __typename: 'RailwayAdministrationDto', code: number, entity_id: number, name: string, short_name: string } | null, dates?: Array<{ __typename: 'SchemaControlByTrainDateDto', capacity: number, date: string, diff?: number | null, quantity: number }> | null, groups: Array<{ __typename: 'SchemaControlByTrainCarriageGroupDto', carriage_quantity?: number | null, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, indicators_fact?: number | null, indicators_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, carriages: Array<{ __typename: 'SchemaControlByTrainCarriageDto', carriage_quantity?: number | null, carriage_type: string, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, indicators_fact?: number | null, indicators_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, dates?: Array<{ __typename: 'SchemaControlByTrainDateDto', capacity: number, date: string, diff?: number | null, quantity: number }> | null }>, dates?: Array<{ __typename: 'SchemaControlByTrainDateDto', capacity: number, date: string, diff?: number | null, quantity: number }> | null, passenger_carrier_russian_railway?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, name: string, short_name: string } | null, railway_administration?: { __typename: 'RailwayAdministrationDto', code: number, entity_id: number, name: string, short_name: string } | null, station_from?: { __typename: 'StationDto', entity_id: number, express_code: string, full_name: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, express_code: string, full_name: string } | null }> } | null, trailed_group_data?: { __typename: 'SchemaControlByTrainCarriageGroupBlockDto', trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, carriage_quantity?: number | null, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, indicators_fact?: number | null, indicators_plan?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, passenger_carrier_russian_railway?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, short_name: string } | null, railway_administration?: { __typename: 'RailwayAdministrationDto', code: number, entity_id: number, name: string, short_name: string } | null, dates?: Array<{ __typename: 'SchemaControlByTrainDateDto', capacity: number, date: string, diff?: number | null, quantity: number }> | null, groups: Array<{ __typename: 'SchemaControlByTrainCarriageGroupDto', trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, carriage_quantity?: number | null, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, indicators_fact?: number | null, indicators_plan?: number | null, carriage_group_id?: number | null, schema_number: Array<number>, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, passenger_carrier_russian_railway?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, name: string, short_name: string } | null, railway_administration?: { __typename: 'RailwayAdministrationDto', code: number, entity_id: number, name: string, short_name: string } | null, station_from?: { __typename: 'StationDto', entity_id: number, express_code: string, full_name: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, express_code: string, full_name: string } | null, carriages: Array<{ __typename: 'SchemaControlByTrainCarriageDto', trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, carriage_quantity?: number | null, carriage_type: string, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, indicators_fact?: number | null, indicators_plan?: number | null, dates?: Array<{ __typename: 'SchemaControlByTrainDateDto', capacity: number, date: string, diff?: number | null, quantity: number }> | null }>, dates?: Array<{ __typename: 'SchemaControlByTrainDateDto', capacity: number, date: string, diff?: number | null, quantity: number }> | null }> } | null }> } } } };

export type ControlSchemaByTrainsPreSavedQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_ByTrainsPreSaved_FilterInputType>;
  compareDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type ControlSchemaByTrainsPreSavedQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_schema: { __typename: 'ControlSchemaQueryEntryPoint', byTrainsPreSaved: { __typename: 'SchemaControlTrainPreSavedList', totalCount: number, items: Array<{ __typename: 'SchemaControlTrainPreSavedDto', train_number: string, train_quantity?: number | null, trains_quantity_fact?: number | null, trains_quantity_plan?: number | null, trains_turnover_fact?: number | null, trains_turnover_plan?: number | null, seats_quantity_fact?: number | null, seats_quantity_plan?: number | null, seats_turnover_fact?: number | null, seats_turnover_plan?: number | null, carriage_quantity?: number | null, carriages_quantity_fact?: number | null, carriages_quantity_plan?: number | null, carriages_turnover_fact?: number | null, carriages_turnover_plan?: number | null, indicators_fact?: number | null, indicators_plan?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, station_from?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, dates: Array<{ __typename: 'ControlSchemaPreSavedDates', capacity: number, date: string, diff?: number | null, quantity: number }>, train?: { __typename: 'TrainDto', id: number, version: number, railway_administration: { __typename: 'RailwayAdministrationDto', short_name: string }, passenger_carrier?: { __typename: 'PassengerCarrierDto', short_name: string } | null } | null }> } } } };

export type UpdateTrainNmrvagDataMutationVariables = Exact<{
  payload: UpdateSchemaControlTrainNmrvagDataDto;
}>;


export type UpdateTrainNmrvagDataMutation = { __typename: 'Mutation', tpc: { __typename: 'TpcMutationEntryPoint', control_schema: { __typename: 'ControlSchemaMutationEntryPoint', updateTrain?: any | null } } };

export type ControlSchemaTrainDateNmrvagFragmentFragment = { __typename: 'ControlSchemaTrainDateNmrvagDto', date: string, carriage_quantity?: number | null, capacity?: number | null, seats_available?: number | null, diff?: number | null };

export type SchemaControlTrainNmrvagListQueryVariables = Exact<{
  date: Scalars['String']['input'];
  where?: InputMaybe<ControlSchemaQueryResolver_SchemaControlTrainNmrvagList_FilterInputType>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  compareDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SchemaControlTrainNmrvagListQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_schema: { __typename: 'ControlSchemaQueryEntryPoint', schemaControlTrainNmrvagList: { __typename: 'SchemaControlTrainNmrvagList', totalCount: number, items: Array<{ __typename: 'ControlSchemaTrainNmrvagDto', id: number, date_sync: string, train_number: string, schema_carriage_quantity?: number | null, is_s3960_loaded: boolean, dates: Array<{ __typename: 'ControlSchemaTrainDateNmrvagDto', date: string, carriage_quantity?: number | null, capacity?: number | null, seats_available?: number | null, diff?: number | null }>, station_from?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, carriage_groups: Array<{ __typename: 'ControlSchemaGroupNmrvagDto', id: number, schema_carriage_quantity?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, passenger_carrier_russian_railway?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, station_from?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, dates: Array<{ __typename: 'ControlSchemaTrainDateNmrvagDto', date: string, carriage_quantity?: number | null, capacity?: number | null, seats_available?: number | null, diff?: number | null }>, carriages: Array<{ __typename: 'ControlSchemaCarriageNmrvagDto', carriage_type: string, dates: Array<{ __typename: 'ControlSchemaDateNmrvagDto', carriage_quantity: number, date: string, diff?: number | null }> }> }> }> } } } };

export type TrainsListWithSchemaCarriagesQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  where?: InputMaybe<ControlSchemaQueryResolver_TrainsListWithSchemaCarriages_FilterInputType>;
}>;


export type TrainsListWithSchemaCarriagesQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_schema: { __typename: 'ControlSchemaQueryEntryPoint', trainsListWithSchemaCarriages: { __typename: 'SchemaControlTrainNmrvagListDto', totalCount: number, items: Array<{ __typename: 'SchemaControlTrainNmrvagDto', id: number, train_number: string, schema_carriage_quantity?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, station_from?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> } } } };

export type ReplenishmentCalculationRequestMutationVariables = Exact<{
  payload: ReplenishmentRequestDto;
}>;


export type ReplenishmentCalculationRequestMutation = { __typename: 'Mutation', tpc: { __typename: 'TpcMutationEntryPoint', control_schema: { __typename: 'ControlSchemaMutationEntryPoint', replenishmentCalculation?: any | null } } };

export type ReplenishmentCalculationResponseQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type ReplenishmentCalculationResponseQuery = { __typename: 'Query', tpc: { __typename: 'TpcQueryEntryPoint', control_schema: { __typename: 'ControlSchemaQueryEntryPoint', replenishmentResponse: { __typename: 'ReplenishmentDto', date_sync: string, compare_date: string, trains_quantity: number, carriages_quantity: number, trailed_carriages_quantity: number, available_capacity_increase: number, items: Array<{ __typename: 'ReplenishmentTrainDto', train_number: string, version: number, dates: Array<{ __typename: 'ReplenishmentDateDto', date: string, carriages: Array<{ __typename: 'ReplenishmentCarriageDto', type: string, quantity: number }>, diff: Array<{ __typename: 'ReplenishmentCarriageDto', type: string, quantity: number }> }>, station_from?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, station_to?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }>, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null } } } };

export type BranchCreateMutationVariables = Exact<{
  data: CreateBranchDto;
}>;


export type BranchCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', branch: { __typename: 'BranchMutationEntryPoint', create: { __typename: 'BranchDto', entity_id: number } } } };

export type BranchCreateVersionMutationVariables = Exact<{
  data: CreateVersionBranchDto;
}>;


export type BranchCreateVersionMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', branch: { __typename: 'BranchMutationEntryPoint', createVersion: { __typename: 'BranchDto', entity_id: number } } } };

export type BranchDeleteMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type BranchDeleteMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', branch: { __typename: 'BranchMutationEntryPoint', delete: boolean } } };

export type BranchHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<BranchQueryResolver_History_SortingInputType> | BranchQueryResolver_History_SortingInputType>;
}>;


export type BranchHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', branch: { __typename: 'BranchQueryEntryPoint', history: { __typename: 'BranchList', totalCount: number, items: Array<{ __typename: 'BranchDto', id: number, is_latest: boolean, start_at: string, end_at: string, entity_id: number, name: string, short_name: string, name_nmrvag: string, vladr: string, railways: Array<{ __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null }> }> } } } };

export type BranchListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<BranchQueryResolver_List_SortingInputType> | BranchQueryResolver_List_SortingInputType>;
  where?: InputMaybe<BranchQueryResolver_List_FilterInputType>;
  data: BranchArgsDto;
}>;


export type BranchListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', branch: { __typename: 'BranchQueryEntryPoint', list: { __typename: 'BranchList', totalCount: number, items: Array<{ __typename: 'BranchDto', id: number, is_latest: boolean, start_at: string, end_at: string, entity_id: number, name: string, short_name: string, name_nmrvag: string, vladr: string, railways: Array<{ __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null }> }> } } } };

export type BranchRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type BranchRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', branch: { __typename: 'BranchQueryEntryPoint', byEntityId: { __typename: 'BranchDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type BranchUpdateMutationVariables = Exact<{
  data: UpdateBranchDto;
}>;


export type BranchUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', branch: { __typename: 'BranchMutationEntryPoint', update: { __typename: 'BranchDto', entity_id: number } } } };

export type CarriageAdditionalSeatSignCreateMutationVariables = Exact<{
  data: CreateCarriageAdditionalSeatSignDto;
}>;


export type CarriageAdditionalSeatSignCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageAdditionalSeatSign: { __typename: 'CarriageAdditionalSeatSignMutationEntryPoint', create: { __typename: 'CarriageAdditionalSeatSignDto', entity_id: number } } } };

export type CarriageAdditionalSeatSignHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageAdditionalSeatSignQueryResolver_History_SortingInputType> | CarriageAdditionalSeatSignQueryResolver_History_SortingInputType>;
}>;


export type CarriageAdditionalSeatSignHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageAdditionalSeatSign: { __typename: 'CarriageAdditionalSeatSignQueryEntryPoint', history: { __typename: 'CarriageAdditionalSeatSignList', totalCount: number, items: Array<{ __typename: 'CarriageAdditionalSeatSignDto', start_at: string, end_at: string, entity_id: number, id: number, name: string }> } } } };

export type CarriageAdditionalSeatSignListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageAdditionalSeatSignQueryResolver_List_SortingInputType> | CarriageAdditionalSeatSignQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CarriageAdditionalSeatSignQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type CarriageAdditionalSeatSignListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageAdditionalSeatSign: { __typename: 'CarriageAdditionalSeatSignQueryEntryPoint', list: { __typename: 'CarriageAdditionalSeatSignList', totalCount: number, items: Array<{ __typename: 'CarriageAdditionalSeatSignDto', entity_id: number, id: number, start_at: string, end_at: string, name: string }> } } } };

export type CarriageAdditionalSeatSignRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type CarriageAdditionalSeatSignRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageAdditionalSeatSign: { __typename: 'CarriageAdditionalSeatSignQueryEntryPoint', byEntityId: { __typename: 'CarriageAdditionalSeatSignDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type CarriageAdditionalSeatSignUpdateMutationVariables = Exact<{
  data: UpdateCarriageAdditionalSeatSignDto;
}>;


export type CarriageAdditionalSeatSignUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageAdditionalSeatSign: { __typename: 'CarriageAdditionalSeatSignMutationEntryPoint', update: { __typename: 'CarriageAdditionalSeatSignDto', entity_id: number } } } };

export type NpsCarriageBrakeTypeCreateMutationVariables = Exact<{
  data: CreateNpsCarriageBrakeTypeDto;
}>;


export type NpsCarriageBrakeTypeCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', npsCarriageBrakeType: { __typename: 'NpsCarriageBrakeTypeMutationEntryPoint', create: { __typename: 'NpsCarriageBrakeTypeDto', id: number, entity_id: number, start_at: string, end_at: string, brake_type: string, description?: string | null } } } };

export type NpsCarriageBrakeTypeHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NpsCarriageBrakeTypeQueryResolver_History_SortingInputType> | NpsCarriageBrakeTypeQueryResolver_History_SortingInputType>;
}>;


export type NpsCarriageBrakeTypeHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageBrakeType: { __typename: 'NpsCarriageBrakeTypeQueryEntryPoint', history: { __typename: 'NpsCarriageBrakeTypeList', totalCount: number, items: Array<{ __typename: 'NpsCarriageBrakeTypeDto', id: number, entity_id: number, start_at: string, end_at: string, brake_type: string, description?: string | null }> } } } };

export type NpsCarriageBrakeTypeListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NpsCarriageBrakeTypeQueryResolver_List_SortingInputType> | NpsCarriageBrakeTypeQueryResolver_List_SortingInputType>;
  where?: InputMaybe<NpsCarriageBrakeTypeQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type NpsCarriageBrakeTypeListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageBrakeType: { __typename: 'NpsCarriageBrakeTypeQueryEntryPoint', list: { __typename: 'NpsCarriageBrakeTypeList', totalCount: number, items: Array<{ __typename: 'NpsCarriageBrakeTypeDto', id: number, entity_id: number, start_at: string, end_at: string, brake_type: string, description?: string | null }> } } } };

export type NpsCarriageBrakeTypeRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type NpsCarriageBrakeTypeRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageBrakeType: { __typename: 'NpsCarriageBrakeTypeQueryEntryPoint', byEntityId: { __typename: 'NpsCarriageBrakeTypeDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type NpsCarriageBrakeTypeUpdateMutationVariables = Exact<{
  data: UpdateNpsCarriageBrakeTypeDto;
}>;


export type NpsCarriageBrakeTypeUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', npsCarriageBrakeType: { __typename: 'NpsCarriageBrakeTypeMutationEntryPoint', update: { __typename: 'NpsCarriageBrakeTypeDto', id: number, entity_id: number, start_at: string, end_at: string, brake_type: string, description?: string | null } } } };

export type NpsCarriageDimensionCreateMutationVariables = Exact<{
  data: CreateNpsCarriageDimensionDto;
}>;


export type NpsCarriageDimensionCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', npsCarriageDimension: { __typename: 'NpsCarriageDimensionMutationEntryPoint', create: { __typename: 'NpsCarriageDimensionDto', entity_id: number } } } };

export type NpsCarriageDimensionHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NpsCarriageDimensionQueryResolver_History_SortingInputType> | NpsCarriageDimensionQueryResolver_History_SortingInputType>;
}>;


export type NpsCarriageDimensionHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageDimension: { __typename: 'NpsCarriageDimensionQueryEntryPoint', history: { __typename: 'NpsCarriageDimensionList', totalCount: number, items: Array<{ __typename: 'NpsCarriageDimensionDto', id: number, entity_id: number, start_at: string, end_at: string, carriage_dimension: string, description?: string | null }> } } } };

export type NpsCarriageDimensionListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NpsCarriageDimensionQueryResolver_List_SortingInputType> | NpsCarriageDimensionQueryResolver_List_SortingInputType>;
  where?: InputMaybe<NpsCarriageDimensionQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type NpsCarriageDimensionListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageDimension: { __typename: 'NpsCarriageDimensionQueryEntryPoint', list: { __typename: 'NpsCarriageDimensionList', totalCount: number, items: Array<{ __typename: 'NpsCarriageDimensionDto', id: number, entity_id: number, start_at: string, end_at: string, carriage_dimension: string, description?: string | null }> } } } };

export type NpsCarriageDimensionRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type NpsCarriageDimensionRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageDimension: { __typename: 'NpsCarriageDimensionQueryEntryPoint', byEntityId: { __typename: 'NpsCarriageDimensionDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type NpsCarriageDimensionUpdateMutationVariables = Exact<{
  data: UpdateNpsCarriageDimensionDto;
}>;


export type NpsCarriageDimensionUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', npsCarriageDimension: { __typename: 'NpsCarriageDimensionMutationEntryPoint', update: { __typename: 'NpsCarriageDimensionDto', entity_id: number } } } };

export type NpsCarriageHeatTypeCreateMutationVariables = Exact<{
  data: CreateNpsCarriageHeatTypeDto;
}>;


export type NpsCarriageHeatTypeCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', npsCarriageHeatType: { __typename: 'NpsCarriageHeatTypeMutationEntryPoint', create: { __typename: 'NpsCarriageHeatTypeDto', entity_id: number } } } };

export type NpsCarriageHeatTypeHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NpsCarriageHeatTypeQueryResolver_History_SortingInputType> | NpsCarriageHeatTypeQueryResolver_History_SortingInputType>;
}>;


export type NpsCarriageHeatTypeHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageHeatType: { __typename: 'NpsCarriageHeatTypeQueryEntryPoint', history: { __typename: 'NpsCarriageHeatTypeList', totalCount: number, items: Array<{ __typename: 'NpsCarriageHeatTypeDto', id: number, entity_id: number, start_at: string, end_at: string, heat_type: string, description?: string | null }> } } } };

export type NpsCarriageHeatTypeListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NpsCarriageHeatTypeQueryResolver_List_SortingInputType> | NpsCarriageHeatTypeQueryResolver_List_SortingInputType>;
  where?: InputMaybe<NpsCarriageHeatTypeQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type NpsCarriageHeatTypeListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageHeatType: { __typename: 'NpsCarriageHeatTypeQueryEntryPoint', list: { __typename: 'NpsCarriageHeatTypeList', totalCount: number, items: Array<{ __typename: 'NpsCarriageHeatTypeDto', id: number, entity_id: number, start_at: string, end_at: string, heat_type: string, description?: string | null }> } } } };

export type NpsCarriageHeatTypeRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type NpsCarriageHeatTypeRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageHeatType: { __typename: 'NpsCarriageHeatTypeQueryEntryPoint', byEntityId: { __typename: 'NpsCarriageHeatTypeDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type NpsCarriageHeatTypeUpdateMutationVariables = Exact<{
  data: UpdateNpsCarriageHeatTypeDto;
}>;


export type NpsCarriageHeatTypeUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', npsCarriageHeatType: { __typename: 'NpsCarriageHeatTypeMutationEntryPoint', update: { __typename: 'NpsCarriageHeatTypeDto', entity_id: number } } } };

export type NpsCarriageLengthCreateMutationVariables = Exact<{
  data: CreateNpsCarriageLengthDto;
}>;


export type NpsCarriageLengthCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', npsCarriageLength: { __typename: 'NpsCarriageLengthMutationEntryPoint', create: { __typename: 'NpsCarriageLengthDto', id: number } } } };

export type NpsCarriageLengthHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NpsCarriageLengthQueryResolver_History_SortingInputType> | NpsCarriageLengthQueryResolver_History_SortingInputType>;
}>;


export type NpsCarriageLengthHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageLength: { __typename: 'NpsCarriageLengthQueryEntryPoint', history: { __typename: 'NpsCarriageLengthList', totalCount: number, items: Array<{ __typename: 'NpsCarriageLengthDto', id: number, entity_id: number, start_at: string, end_at: string, carriage_length_asu_ms: number, carriage_length_in_train_schema: number, description?: string | null }> } } } };

export type NpsCarriageLengthListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NpsCarriageLengthQueryResolver_List_SortingInputType> | NpsCarriageLengthQueryResolver_List_SortingInputType>;
  where?: InputMaybe<NpsCarriageLengthQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type NpsCarriageLengthListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageLength: { __typename: 'NpsCarriageLengthQueryEntryPoint', list: { __typename: 'NpsCarriageLengthList', totalCount: number, items: Array<{ __typename: 'NpsCarriageLengthDto', id: number, entity_id: number, start_at: string, end_at: string, carriage_length_asu_ms: number, carriage_length_in_train_schema: number, description?: string | null }> } } } };

export type NpsCarriageLengthRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type NpsCarriageLengthRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageLength: { __typename: 'NpsCarriageLengthQueryEntryPoint', byEntityId: { __typename: 'NpsCarriageLengthDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type NpsCarriageLengthUpdateMutationVariables = Exact<{
  data: UpdateNpsCarriageLengthDto;
}>;


export type NpsCarriageLengthUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', npsCarriageLength: { __typename: 'NpsCarriageLengthMutationEntryPoint', update: { __typename: 'NpsCarriageLengthDto', id: number } } } };

export type NpsCarriageModelCreateMutationVariables = Exact<{
  data: CreateNpsCarriageModelDto;
}>;


export type NpsCarriageModelCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', npsCarriageModel: { __typename: 'NpsCarriageModelMutationEntryPoint', create: { __typename: 'NpsCarriageModelDto', id: number } } } };

export type NpsCarriageModelHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NpsCarriageModelQueryResolver_History_SortingInputType> | NpsCarriageModelQueryResolver_History_SortingInputType>;
}>;


export type NpsCarriageModelHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageModel: { __typename: 'NpsCarriageModelQueryEntryPoint', history: { __typename: 'NpsCarriageModelList', totalCount: number, items: Array<{ __typename: 'NpsCarriageModelDto', entity_id: number, id: number, start_at: string, end_at: string, carriage_model: string, description?: string | null }> } } } };

export type NpsCarriageModelListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NpsCarriageModelQueryResolver_List_SortingInputType> | NpsCarriageModelQueryResolver_List_SortingInputType>;
  where?: InputMaybe<NpsCarriageModelQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type NpsCarriageModelListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageModel: { __typename: 'NpsCarriageModelQueryEntryPoint', list: { __typename: 'NpsCarriageModelList', totalCount: number, items: Array<{ __typename: 'NpsCarriageModelDto', entity_id: number, id: number, start_at: string, end_at: string, carriage_model: string, description?: string | null }> } } } };

export type NpsCarriageModelRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type NpsCarriageModelRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageModel: { __typename: 'NpsCarriageModelQueryEntryPoint', byEntityId: { __typename: 'NpsCarriageModelDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type NpsCarriageModelUpdateMutationVariables = Exact<{
  data: UpdateNpsCarriageModelDto;
}>;


export type NpsCarriageModelUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', npsCarriageModel: { __typename: 'NpsCarriageModelMutationEntryPoint', update: { __typename: 'NpsCarriageModelDto', id: number } } } };

export type CarriageSeatAllocationCreateMutationVariables = Exact<{
  data: CreateCarriageSeatAllocationDto;
}>;


export type CarriageSeatAllocationCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageSeatAllocation: { __typename: 'CarriageSeatAllocationMutationEntryPoint', create: { __typename: 'CarriageSeatAllocationDto', entity_id: number } } } };

export type CarriageSeatAllocationHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageSeatAllocationQueryResolver_History_SortingInputType> | CarriageSeatAllocationQueryResolver_History_SortingInputType>;
}>;


export type CarriageSeatAllocationHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageSeatAllocation: { __typename: 'CarriageSeatAllocationQueryEntryPoint', history: { __typename: 'CarriageSeatAllocationList', totalCount: number, items: Array<{ __typename: 'CarriageSeatAllocationDto', id: number, entity_id: number, start_at: string, end_at: string, name: string }> } } } };

export type CarriageSeatAllocationListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageSeatAllocationQueryResolver_List_SortingInputType> | CarriageSeatAllocationQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CarriageSeatAllocationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type CarriageSeatAllocationListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageSeatAllocation: { __typename: 'CarriageSeatAllocationQueryEntryPoint', list: { __typename: 'CarriageSeatAllocationList', totalCount: number, items: Array<{ __typename: 'CarriageSeatAllocationDto', id: number, entity_id: number, start_at: string, end_at: string, name: string }> } } } };

export type CarriageSeatAllocationRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type CarriageSeatAllocationRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageSeatAllocation: { __typename: 'CarriageSeatAllocationQueryEntryPoint', byEntityId: { __typename: 'CarriageSeatAllocationDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type CarriageSeatAllocationUpdateMutationVariables = Exact<{
  data: UpdateCarriageSeatAllocationDto;
}>;


export type CarriageSeatAllocationUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageSeatAllocation: { __typename: 'CarriageSeatAllocationMutationEntryPoint', update: { __typename: 'CarriageSeatAllocationDto', entity_id: number } } } };

export type CarriageServiceClassCreateMutationVariables = Exact<{
  data: CreateCarriageServiceClassDto;
}>;


export type CarriageServiceClassCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageServiceClass: { __typename: 'CarriageServiceClassMutationEntryPoint', create: { __typename: 'CarriageServiceClassDto', entity_id: number } } } };

export type CarriageServiceClassHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageServiceClassQueryResolver_History_SortingInputType> | CarriageServiceClassQueryResolver_History_SortingInputType>;
}>;


export type CarriageServiceClassHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageServiceClass: { __typename: 'CarriageServiceClassQueryEntryPoint', history: { __typename: 'CarriageServiceClassList', totalCount: number, items: Array<{ __typename: 'CarriageServiceClassDto', id: number, entity_id: number, start_at: string, end_at: string, available_service_classes?: Array<{ __typename: 'AvailableServiceClassDto', id: number, entity_id: number, start_at: string, end_at: string, service_class: string }> | null, carriage_types_for_schema: { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string, carriage_type_asu?: { __typename: 'CarriageTypeAsuDto', id: number, entity_id: number, full_name: string, short_name: string } | null } }> } } } };

export type CarriageServiceClassListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageServiceClassQueryResolver_List_SortingInputType> | CarriageServiceClassQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CarriageServiceClassQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type CarriageServiceClassListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageServiceClass: { __typename: 'CarriageServiceClassQueryEntryPoint', list: { __typename: 'CarriageServiceClassList', totalCount: number, items: Array<{ __typename: 'CarriageServiceClassDto', id: number, entity_id: number, start_at: string, end_at: string, available_service_classes?: Array<{ __typename: 'AvailableServiceClassDto', id: number, entity_id: number, start_at: string, end_at: string, service_class: string }> | null, carriage_types_for_schema: { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string, carriage_type_asu?: { __typename: 'CarriageTypeAsuDto', id: number, entity_id: number, full_name: string, short_name: string } | null } }> } } } };

export type CarriageServiceClassRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type CarriageServiceClassRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageServiceClass: { __typename: 'CarriageServiceClassQueryEntryPoint', byEntityId: { __typename: 'CarriageServiceClassDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type CarriageServiceClassUpdateMutationVariables = Exact<{
  data: UpdateCarriageServiceClassDto;
}>;


export type CarriageServiceClassUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageServiceClass: { __typename: 'CarriageServiceClassMutationEntryPoint', update: { __typename: 'CarriageServiceClassDto', entity_id: number } } } };

export type CarriageTypeAsuDimensionSeatsCountCreateMutationVariables = Exact<{
  data: CreateCarriageTypeAsuDimensionSeatsCountDto;
}>;


export type CarriageTypeAsuDimensionSeatsCountCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageTypeAsuDimensionSeatsCount: { __typename: 'CarriageTypeAsuDimensionSeatsCountMutationEntryPoint', create: { __typename: 'CarriageTypeAsuDimensionSeatsCountDto', id: number } } } };

export type CarriageTypeAsuDimensionSeatsCountListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageTypeAsuDimensionSeatsCountQueryResolver_List_SortingInputType> | CarriageTypeAsuDimensionSeatsCountQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CarriageTypeAsuDimensionSeatsCountQueryResolver_List_FilterInputType>;
}>;


export type CarriageTypeAsuDimensionSeatsCountListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageTypeAsuDimensionSeatsCount: { __typename: 'CarriageTypeAsuDimensionSeatsCountQueryEntryPoint', list: { __typename: 'CarriageTypeAsuDimensionSeatsCountDtoList', totalCount: number, items: Array<{ __typename: 'CarriageTypeAsuDimensionSeatsCountDto', id: number, default_seats_count: number, carriage_dimension: { __typename: 'NpsCarriageDimensionDto', entity_id: number, start_at: string, end_at: string, carriage_dimension: string }, carriage_type_asu: { __typename: 'CarriageTypeAsuDto', entity_id: number, start_at: string, end_at: string, short_name: string, full_name: string } }> } } } };

export type CarriageTypeAsuDimensionSeatsCountUpdateMutationVariables = Exact<{
  data: UpdateCarriageTypeAsuDimensionSeatsCountDto;
}>;


export type CarriageTypeAsuDimensionSeatsCountUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageTypeAsuDimensionSeatsCount: { __typename: 'CarriageTypeAsuDimensionSeatsCountMutationEntryPoint', update?: { __typename: 'CarriageTypeAsuDimensionSeatsCountDto', id: number } | null } } };

export type CarriageTypeCreateMutationVariables = Exact<{
  data: CreateCarriageTypeDto;
}>;


export type CarriageTypeCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageType: { __typename: 'CarriageTypeMutationEntryPoint', create: { __typename: 'CarriageTypeDto', entity_id: number } } } };

export type CarriageTypeHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageTypeQueryResolver_History_SortingInputType> | CarriageTypeQueryResolver_History_SortingInputType>;
}>;


export type CarriageTypeHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageType: { __typename: 'CarriageTypeQueryEntryPoint', history: { __typename: 'CarriageTypeList', totalCount: number, items: Array<{ __typename: 'CarriageTypeDto', entity_id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string, carriage_types_for_schema?: { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string } | null, regulatory_sector: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, seat_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, rolling_stock_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string } }> } } } };

export type CarriageTypeListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageTypeQueryResolver_List_SortingInputType> | CarriageTypeQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CarriageTypeQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type CarriageTypeListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageType: { __typename: 'CarriageTypeQueryEntryPoint', list: { __typename: 'CarriageTypeList', totalCount: number, items: Array<{ __typename: 'CarriageTypeDto', entity_id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string, carriage_types_for_schema?: { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string } | null, regulatory_sector: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, seat_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string }, rolling_stock_type: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string } }> } } } };

export type CarriageTypeRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type CarriageTypeRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageType: { __typename: 'CarriageTypeQueryEntryPoint', byEntityId: { __typename: 'CarriageTypeDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type CarriageTypeUpdateMutationVariables = Exact<{
  data: UpdateCarriageTypeDto;
}>;


export type CarriageTypeUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageType: { __typename: 'CarriageTypeMutationEntryPoint', update: { __typename: 'CarriageTypeDto', entity_id: number } } } };

export type CarriageTypeAsuCreateMutationVariables = Exact<{
  data: CreateCarriageTypeAsuDto;
}>;


export type CarriageTypeAsuCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageTypeAsu: { __typename: 'CarriageTypeAsuMutationEntryPoint', create: { __typename: 'CarriageTypeAsuDto', entity_id: number } } } };

export type CarriageTypeAsuHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageTypeAsuQueryResolver_History_SortingInputType> | CarriageTypeAsuQueryResolver_History_SortingInputType>;
}>;


export type CarriageTypeAsuHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageTypeAsu: { __typename: 'CarriageTypeAsuQueryEntryPoint', history: { __typename: 'CarriageTypeAsuDtoList', totalCount: number, items: Array<{ __typename: 'CarriageTypeAsuDto', entity_id: number, start_at: string, end_at: string, short_name: string, full_name: string }> } } } };

export type CarriageTypeAsuListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageTypeAsuQueryResolver_List_SortingInputType> | CarriageTypeAsuQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CarriageTypeAsuQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type CarriageTypeAsuListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageTypeAsu: { __typename: 'CarriageTypeAsuQueryEntryPoint', list: { __typename: 'CarriageTypeAsuDtoList', totalCount: number, items: Array<{ __typename: 'CarriageTypeAsuDto', entity_id: number, start_at: string, end_at: string, short_name: string, full_name: string }> } } } };

export type CarriageTypeAsuRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type CarriageTypeAsuRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageTypeAsu: { __typename: 'CarriageTypeAsuQueryEntryPoint', byEntityId: { __typename: 'CarriageTypeAsuDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type CarriageTypeAsuUpdateMutationVariables = Exact<{
  data: UpdateCarriageTypeAsuDto;
}>;


export type CarriageTypeAsuUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageTypeAsu: { __typename: 'CarriageTypeAsuMutationEntryPoint', update: { __typename: 'CarriageTypeAsuDto', entity_id: number } } } };

export type CarriageTypeCsuCreateMutationVariables = Exact<{
  data: CreateCsuCarriageTypeDto;
}>;


export type CarriageTypeCsuCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', csuCarriageType: { __typename: 'CsuCarriageTypeMutationEntryPoint', create: { __typename: 'CsuCarriageTypeDto', id: number } } } };

export type CarriageTypeCsuListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CsuCarriageTypeQueryResolver_List_SortingInputType> | CsuCarriageTypeQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CsuCarriageTypeQueryResolver_List_FilterInputType>;
}>;


export type CarriageTypeCsuListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', csuCarriageType: { __typename: 'CsuCarriageTypeQueryEntryPoint', list: { __typename: 'CsuCarriageTypeList', totalCount: number, items: Array<{ __typename: 'CsuCarriageTypeDto', id: number, name: string, subtypes: Array<number>, type: string }> } } } };

export type CarriageTypeCsuUpdateMutationVariables = Exact<{
  data: UpdateCsuCarriageTypeDto;
}>;


export type CarriageTypeCsuUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', csuCarriageType: { __typename: 'CsuCarriageTypeMutationEntryPoint', update: { __typename: 'CsuCarriageTypeDto', id: number } } } };

export type CarriageTypesForSchemaCreateMutationVariables = Exact<{
  data: CreateCarriageTypesForSchemaDto;
}>;


export type CarriageTypesForSchemaCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageTypesForSchema: { __typename: 'CarriageTypesForSchemaMutationEntryPoint', create: number } } };

export type CarriageTypesForSchemaListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageTypesForSchemaQueryResolver_List_SortingInputType> | CarriageTypesForSchemaQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CarriageTypesForSchemaQueryResolver_List_FilterInputType>;
}>;


export type CarriageTypesForSchemaListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageTypesForSchema: { __typename: 'CarriageTypesForSchemaQueryEntryPoint', list: { __typename: 'CarriageTypesForSchemaDtoList', totalCount: number, items: Array<{ __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string, carriage_type_asu?: { __typename: 'CarriageTypeAsuDto', id: number, entity_id: number, full_name: string, short_name: string } | null }> } } } };

export type CarriageTypesForSchemaUpdateMutationVariables = Exact<{
  data: UpdateCarriageTypesForSchemaDto;
}>;


export type CarriageTypesForSchemaUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', carriageTypesForSchema: { __typename: 'CarriageTypesForSchemaMutationEntryPoint', update?: boolean | null } } };

export type GdpCreateMutationVariables = Exact<{
  data: CreateGdpDto;
}>;


export type GdpCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', gdp: { __typename: 'GDPMutationEntryPoint', create: number } } };

export type GdpListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<GdpQueryResolver_List_SortingInputType> | GdpQueryResolver_List_SortingInputType>;
  where?: InputMaybe<GdpQueryResolver_List_FilterInputType>;
}>;


export type GdpListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', gdp: { __typename: 'GDPQueryEntryPoint', list: { __typename: 'GDPList', totalCount: number, items: Array<{ __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string }> } } } };

export type GdpUpdateMutationVariables = Exact<{
  data: UpdateGdpDto;
}>;


export type GdpUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', gdp: { __typename: 'GDPMutationEntryPoint', update?: boolean | null } } };

export type InfrastructureApplication23ListQueryVariables = Exact<{
  data: QueryInfrastructureApplication23DataDto;
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<InfrastructureApplication23QueryResolver_List_SortingInputType> | InfrastructureApplication23QueryResolver_List_SortingInputType>;
  where?: InputMaybe<InfrastructureApplication23QueryResolver_List_FilterInputType>;
}>;


export type InfrastructureApplication23ListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', infrastructureApplication23: { __typename: 'InfrastructureApplication23QueryEntryPoint', list: { __typename: 'InfrastructureApplication23List', totalCount: number, items: Array<{ __typename: 'InfrastructureApplication23Dto', id: number, distance_end: number, distance_start: number, express_v_91_140_m_15_30_i1: number, express_v_91_140_m_15_30_i2: number, express_v_91_140_m_15_30_i3: number, express_v_91_140_m_30_70_i1: number, express_v_91_140_m_30_70_i2: number, express_v_91_140_m_30_70_i3: number, express_v_140_etc_m_15_70_i1: number, express_v_140_etc_m_15_70_i2: number, express_v_140_etc_m_15_70_i3: number, fast_i1: number, fast_i2: number, fast_i3: number, passenger_i1: number, passenger_i2: number, passenger_i3: number }> } } } };

export type InfrastructureApplication24ListQueryVariables = Exact<{
  data: QueryInfrastructureApplication24DataDto;
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<InfrastructureApplication24QueryResolver_List_SortingInputType> | InfrastructureApplication24QueryResolver_List_SortingInputType>;
  where?: InputMaybe<InfrastructureApplication24QueryResolver_List_FilterInputType>;
}>;


export type InfrastructureApplication24ListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', infrastructureApplication24: { __typename: 'InfrastructureApplication24QueryEntryPoint', list: { __typename: 'InfrastructureApplication24List', totalCount: number, items: Array<{ __typename: 'InfrastructureApplication24Dto', id: number, distance_end: number, distance_start: number, express_i1: number, express_i2: number, express_i3: number, fast_i1: number, fast_i2: number, fast_i3: number, passenger_i1: number, passenger_i2: number, passenger_i3: number }> } } } };

export type InfrastructureApplication25ListQueryVariables = Exact<{
  data: QueryInfrastructureApplication25DataDto;
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<InfrastructureApplication25QueryResolver_List_SortingInputType> | InfrastructureApplication25QueryResolver_List_SortingInputType>;
  where?: InputMaybe<InfrastructureApplication25QueryResolver_List_FilterInputType>;
}>;


export type InfrastructureApplication25ListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', infrastructureApplication25: { __typename: 'InfrastructureApplication25QueryEntryPoint', list: { __typename: 'InfrastructureApplication25List', totalCount: number, items: Array<{ __typename: 'InfrastructureApplication25Dto', id: number, distance_end: number, distance_start: number, fast_i1: number, fast_i2: number, fast_i3: number, passenger_i1: number, passenger_i2: number, passenger_i3: number, express_v1_140_etc_v2_160_etc_m1_30_75_i1: number, express_v1_140_etc_v2_160_etc_m1_30_75_i2: number, express_v1_140_etc_v2_160_etc_m1_30_75_i3: number, express_v1_91_140_v2_0_140_m1_30_75_i1: number, express_v1_91_140_v2_0_140_m1_30_75_i2: number, express_v1_91_140_v2_0_140_m1_30_75_i3: number, express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i1: number, express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i2: number, express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i3: number, express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i1: number, express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i2: number, express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i3: number, express_v91_140_etc_v2_160_etc_m1_30_75_i1: number, express_v91_140_etc_v2_160_etc_m1_30_75_i2: number, express_v91_140_etc_v2_160_etc_m1_30_75_i3: number }> } } } };

export type InfrastructureApplication26ListQueryVariables = Exact<{
  data: QueryInfrastructureApplication26DataDto;
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<InfrastructureApplication26QueryResolver_List_SortingInputType> | InfrastructureApplication26QueryResolver_List_SortingInputType>;
  where?: InputMaybe<InfrastructureApplication26QueryResolver_List_FilterInputType>;
}>;


export type InfrastructureApplication26ListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', infrastructureApplication26: { __typename: 'InfrastructureApplication26QueryEntryPoint', list: { __typename: 'InfrastructureApplication26List', totalCount: number, items: Array<{ __typename: 'InfrastructureApplication26Dto', id: number, distance_end: number, distance_start: number, express_i1: number, express_i2: number, express_i3: number, fast_i1: number, fast_i2: number, fast_i3: number, passenger_i1: number, passenger_i2: number, passenger_i3: number }> } } } };

export type InfrastructureApplication27ListQueryVariables = Exact<{
  data: QueryInfrastructureApplication27DataDto;
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<InfrastructureApplication27QueryResolver_List_SortingInputType> | InfrastructureApplication27QueryResolver_List_SortingInputType>;
  where?: InputMaybe<InfrastructureApplication27QueryResolver_List_FilterInputType>;
}>;


export type InfrastructureApplication27ListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', infrastructureApplication27: { __typename: 'InfrastructureApplication27QueryEntryPoint', list: { __typename: 'InfrastructureApplication27List', totalCount: number, items: Array<{ __typename: 'InfrastructureApplication27Dto', id: number, price: number, mnemonic: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string } }> } } } };

export type CreateInfrastructureCoefficientIndexMutationVariables = Exact<{
  input: CreateInfrastructureCoefficientIndexingDto;
}>;


export type CreateInfrastructureCoefficientIndexMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', infrastructureCoefficientIndexing: { __typename: 'InfrastructureCoefficientIndexingMutationEntryPoint', create: number } } };

export type UpdateInfrastructureCoefficientIndexMutationVariables = Exact<{
  input: UpdateInfrastructureCoefficientIndexingDto;
}>;


export type UpdateInfrastructureCoefficientIndexMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', infrastructureCoefficientIndexing: { __typename: 'InfrastructureCoefficientIndexingMutationEntryPoint', update?: boolean | null } } };

export type InfrastructureCoefficientIndexesQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<InfrastructureCoefficientIndexingQueryResolver_List_SortingInputType> | InfrastructureCoefficientIndexingQueryResolver_List_SortingInputType>;
  where?: InputMaybe<InfrastructureCoefficientIndexingQueryResolver_List_FilterInputType>;
}>;


export type InfrastructureCoefficientIndexesQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', infrastructureCoefficientIndexing: { __typename: 'InfrastructureCoefficientIndexingQueryEntryPoint', list: { __typename: 'InfrastructureCoefficientIndexingList', totalCount: number, items: Array<{ __typename: 'InfrastructureCoefficientIndexingDto', id: number, start_at: string, end_at: string, coefficient: number }> } } } };

export type LocomotivePriceTechnicalServiceCreateMutationVariables = Exact<{
  data: CreateLocomotivePriceTechnicalServiceDto;
}>;


export type LocomotivePriceTechnicalServiceCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', locomotivePriceTechnicalService: { __typename: 'LocomotivePriceTechnicalServiceMutationEntryPoint', create: { __typename: 'LocomotivePriceTechnicalServiceDto', entity_id: number } } } };

export type LocomotivePriceTechnicalServiceHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotivePriceTechnicalServiceQueryResolver_History_SortingInputType> | LocomotivePriceTechnicalServiceQueryResolver_History_SortingInputType>;
}>;


export type LocomotivePriceTechnicalServiceHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotivePriceTechnicalService: { __typename: 'LocomotivePriceTechnicalServiceQueryEntryPoint', history: { __typename: 'LocomotivePriceTechnicalServiceList', totalCount: number, items: Array<{ __typename: 'LocomotivePriceTechnicalServiceDto', start_at: string, end_at: string, entity_id: number, maintenance_cost?: number | null, series_type: { __typename: 'LocomotiveSeriesTypeDto', id: number, name: string }, locomotive_series: { __typename: 'LocomotiveSeriesDto', id: number, entity_id: number, series: string, index?: string | null, section_quantity: number, price_rent: number, locomotive_traction_type_id?: number | null, start_at: string }, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }> } } } };

export type LocomotivePriceTechnicalServiceListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotivePriceTechnicalServiceQueryResolver_List_SortingInputType> | LocomotivePriceTechnicalServiceQueryResolver_List_SortingInputType>;
  where?: InputMaybe<LocomotivePriceTechnicalServiceQueryResolver_List_FilterInputType>;
  search: Scalars['String']['input'];
  range: RangeInputDto;
}>;


export type LocomotivePriceTechnicalServiceListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotivePriceTechnicalService: { __typename: 'LocomotivePriceTechnicalServiceQueryEntryPoint', list: { __typename: 'LocomotivePriceTechnicalServiceList', totalCount: number, items: Array<{ __typename: 'LocomotivePriceTechnicalServiceDto', entity_id: number, maintenance_cost?: number | null, series_type: { __typename: 'LocomotiveSeriesTypeDto', id: number, name: string }, locomotive_series: { __typename: 'LocomotiveSeriesDto', id: number, entity_id: number, series: string, index?: string | null, section_quantity: number, price_rent: number, locomotive_traction_type_id?: number | null, start_at: string }, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }> } } } };

export type LocomotivePriceTechnicalServiceRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type LocomotivePriceTechnicalServiceRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotivePriceTechnicalService: { __typename: 'LocomotivePriceTechnicalServiceQueryEntryPoint', byEntityId: { __typename: 'LocomotivePriceTechnicalServiceDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type LocomotivePriceTechnicalServiceUpdateMutationVariables = Exact<{
  data: UpdateLocomotivePriceTechnicalServiceDto;
}>;


export type LocomotivePriceTechnicalServiceUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', locomotivePriceTechnicalService: { __typename: 'LocomotivePriceTechnicalServiceMutationEntryPoint', update: { __typename: 'LocomotivePriceTechnicalServiceDto', entity_id: number } } } };

export type TractionDirectorateFiltersQueryVariables = Exact<{
  range: RangeInputDto;
}>;


export type TractionDirectorateFiltersQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', tractionDirectorate: { __typename: 'TractionDirectorateQueryEntryPoint', list: { __typename: 'TractionDirectorateList', items: Array<{ __typename: 'TractionDirectorateDto', id: number, name: string }> } } } };

export type LocomotiveSeriesCreateMutationVariables = Exact<{
  data: CreateLocomotiveSeriesDto;
}>;


export type LocomotiveSeriesCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', locomotiveSeries: { __typename: 'LocomotiveSeriesMutationEntryPoint', create: { __typename: 'LocomotiveSeriesDto', entity_id: number } } } };

export type LocomotiveSeriesHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotiveSeriesQueryResolver_History_SortingInputType> | LocomotiveSeriesQueryResolver_History_SortingInputType>;
}>;


export type LocomotiveSeriesHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveSeries: { __typename: 'LocomotiveSeriesQueryEntryPoint', history: { __typename: 'LocomotiveSeriesList', totalCount: number, items: Array<{ __typename: 'LocomotiveSeriesDto', start_at: string, end_at: string, id: number, entity_id: number, series: string, index?: string | null, section_quantity: number, price_rent: number, locomotive_traction_type_id?: number | null, locomotive_traction_type: { __typename: 'LocomotiveTractionTypeDto', id: number, name: string, short_name: string } }> } } } };

export type LocomotiveSeriesListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotiveSeriesQueryResolver_List_SortingInputType> | LocomotiveSeriesQueryResolver_List_SortingInputType>;
  where?: InputMaybe<LocomotiveSeriesQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type LocomotiveSeriesListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveSeries: { __typename: 'LocomotiveSeriesQueryEntryPoint', list: { __typename: 'LocomotiveSeriesList', totalCount: number, items: Array<{ __typename: 'LocomotiveSeriesDto', id: number, entity_id: number, series: string, index?: string | null, section_quantity: number, price_rent: number, locomotive_traction_type_id?: number | null, start_at: string, locomotive_traction_type: { __typename: 'LocomotiveTractionTypeDto', id: number, name: string, short_name: string } }> } } } };

export type LocomotiveSeriesRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type LocomotiveSeriesRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveSeries: { __typename: 'LocomotiveSeriesQueryEntryPoint', byEntityId: { __typename: 'LocomotiveSeriesDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type LocomotiveSeriesUpdateMutationVariables = Exact<{
  data: UpdateLocomotiveSeriesDto;
}>;


export type LocomotiveSeriesUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', locomotiveSeries: { __typename: 'LocomotiveSeriesMutationEntryPoint', update: { __typename: 'LocomotiveSeriesDto', entity_id: number } } } };

export type LocomotiveSeriesTypeListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotiveSeriesTypeQueryResolver_List_SortingInputType> | LocomotiveSeriesTypeQueryResolver_List_SortingInputType>;
  where?: InputMaybe<LocomotiveSeriesTypeQueryResolver_List_FilterInputType>;
}>;


export type LocomotiveSeriesTypeListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveSeriesType: { __typename: 'LocomotiveSeriesTypeQueryEntryPoint', list: { __typename: 'LocomotiveSeriesTypeList', totalCount: number, items: Array<{ __typename: 'LocomotiveSeriesTypeDto', id: number, name: string }> } } } };

export type LocomotiveServiceEmpiricalParameterCreateMutationVariables = Exact<{
  data: CreateLocomotiveServiceEmpiricalParameterDto;
}>;


export type LocomotiveServiceEmpiricalParameterCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', locomotiveServiceEmpiricalParameter: { __typename: 'LocomotiveServiceEmpiricalParameterMutationEntryPoint', create: { __typename: 'LocomotiveServiceEmpiricalParameterDto', entity_id: number } } } };

export type LocomotiveServiceEmpiricalParameterHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotiveServiceEmpiricalParameterQueryResolver_History_SortingInputType> | LocomotiveServiceEmpiricalParameterQueryResolver_History_SortingInputType>;
}>;


export type LocomotiveServiceEmpiricalParameterHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveServiceEmpiricalParameter: { __typename: 'LocomotiveServiceEmpiricalParameterQueryEntryPoint', history: { __typename: 'LocomotiveServiceEmpiricalParameterList', totalCount: number, items: Array<{ __typename: 'LocomotiveServiceEmpiricalParameterDto', start_at: string, end_at: string, entity_id: number, value: number, mnemonic: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string } }> } } } };

export type LocomotiveServiceEmpiricalParameterListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotiveServiceEmpiricalParameterQueryResolver_List_SortingInputType> | LocomotiveServiceEmpiricalParameterQueryResolver_List_SortingInputType>;
  where?: InputMaybe<LocomotiveServiceEmpiricalParameterQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type LocomotiveServiceEmpiricalParameterListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveServiceEmpiricalParameter: { __typename: 'LocomotiveServiceEmpiricalParameterQueryEntryPoint', list: { __typename: 'LocomotiveServiceEmpiricalParameterList', totalCount: number, items: Array<{ __typename: 'LocomotiveServiceEmpiricalParameterDto', entity_id: number, value: number, mnemonic: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string } }> } } } };

export type LocomotiveServiceEmpiricalParameterRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type LocomotiveServiceEmpiricalParameterRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveServiceEmpiricalParameter: { __typename: 'LocomotiveServiceEmpiricalParameterQueryEntryPoint', byEntityId: { __typename: 'LocomotiveServiceEmpiricalParameterDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type LocomotiveServiceEmpiricalParameterUpdateMutationVariables = Exact<{
  data: UpdateLocomotiveServiceEmpiricalParameterDto;
}>;


export type LocomotiveServiceEmpiricalParameterUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', locomotiveServiceEmpiricalParameter: { __typename: 'LocomotiveServiceEmpiricalParameterMutationEntryPoint', update: { __typename: 'LocomotiveServiceEmpiricalParameterDto', entity_id: number } } } };

export type LocomotiveTeamPriceRentCreateMutationVariables = Exact<{
  data: CreateLocomotiveTeamPriceRentDto;
}>;


export type LocomotiveTeamPriceRentCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', locomotiveTeamPriceRent: { __typename: 'LocomotiveTeamPriceRentMutationEntryPoint', create: { __typename: 'LocomotiveTeamPriceRentDto', entity_id: number } } } };

export type LocomotiveTeamPriceRentHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotiveTeamPriceRentQueryResolver_History_SortingInputType> | LocomotiveTeamPriceRentQueryResolver_History_SortingInputType>;
}>;


export type LocomotiveTeamPriceRentHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveTeamPriceRent: { __typename: 'LocomotiveTeamPriceRentQueryEntryPoint', history: { __typename: 'LocomotiveTeamPriceRentList', totalCount: number, items: Array<{ __typename: 'LocomotiveTeamPriceRentDto', start_at: string, end_at: string, entity_id: number, price_electric_locomotive_one_person: number, price_electric_locomotive_two_person: number, price_warm_locomotive_one_person: number, price_warm_locomotive_two_person: number, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }> } } } };

export type LocomotiveTeamPriceRentListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotiveTeamPriceRentQueryResolver_List_SortingInputType> | LocomotiveTeamPriceRentQueryResolver_List_SortingInputType>;
  where?: InputMaybe<LocomotiveTeamPriceRentQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type LocomotiveTeamPriceRentListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveTeamPriceRent: { __typename: 'LocomotiveTeamPriceRentQueryEntryPoint', list: { __typename: 'LocomotiveTeamPriceRentList', totalCount: number, items: Array<{ __typename: 'LocomotiveTeamPriceRentDto', entity_id: number, price_electric_locomotive_one_person: number, price_electric_locomotive_two_person: number, price_warm_locomotive_one_person: number, price_warm_locomotive_two_person: number, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }> } } } };

export type LocomotiveTeamPriceRentRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type LocomotiveTeamPriceRentRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveTeamPriceRent: { __typename: 'LocomotiveTeamPriceRentQueryEntryPoint', byEntityId: { __typename: 'LocomotiveTeamPriceRentDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type LocomotiveTeamPriceRentUpdateMutationVariables = Exact<{
  data: UpdateLocomotiveTeamPriceRentDto;
}>;


export type LocomotiveTeamPriceRentUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', locomotiveTeamPriceRent: { __typename: 'LocomotiveTeamPriceRentMutationEntryPoint', update: { __typename: 'LocomotiveTeamPriceRentDto', entity_id: number } } } };

export type LocomotiveTractionTypeListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotiveTractionTypeQueryResolver_List_SortingInputType> | LocomotiveTractionTypeQueryResolver_List_SortingInputType>;
  where?: InputMaybe<LocomotiveTractionTypeQueryResolver_List_FilterInputType>;
}>;


export type LocomotiveTractionTypeListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveTractionType: { __typename: 'LocomotiveTractionTypeQueryEntryPoint', list: { __typename: 'LocomotiveTractionTypeList', totalCount: number, items: Array<{ __typename: 'LocomotiveTractionTypeDto', id: number, name: string, short_name: string }> } } } };

export type LocomotiveTypeCurrentListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<LocomotiveTypeCurrentQueryResolver_List_SortingInputType> | LocomotiveTypeCurrentQueryResolver_List_SortingInputType>;
  where?: InputMaybe<LocomotiveTypeCurrentQueryResolver_List_FilterInputType>;
}>;


export type LocomotiveTypeCurrentListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveTypeCurrent: { __typename: 'LocomotiveTypeCurrentQueryEntryPoint', list: { __typename: 'LocomotiveTypeCurrentList', totalCount: number, items: Array<{ __typename: 'LocomotiveTypeCurrentDto', id: number, name: string }> } } } };

export type MaxTrainSpeedCreateMutationVariables = Exact<{
  data: CreateMaxTrainSpeedDto;
}>;


export type MaxTrainSpeedCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', maxTrainSpeed: { __typename: 'MaxTrainSpeedMutationEntryPoint', create: { __typename: 'MaxTrainSpeedDto', id: number } } } };

export type MaxTrainSpeedHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<MaxTrainSpeedQueryResolver_History_SortingInputType> | MaxTrainSpeedQueryResolver_History_SortingInputType>;
}>;


export type MaxTrainSpeedHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', maxTrainSpeed: { __typename: 'MaxTrainSpeedQueryEntryPoint', history: { __typename: 'MaxTrainSpeedList', totalCount: number, items: Array<{ __typename: 'MaxTrainSpeedDto', id: number, entity_id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string, max_train_speed: number }> } } } };

export type MaxTrainSpeedListQueryVariables = Exact<{
  range: RangeInputDto;
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<MaxTrainSpeedQueryResolver_List_SortingInputType> | MaxTrainSpeedQueryResolver_List_SortingInputType>;
  where?: InputMaybe<MaxTrainSpeedQueryResolver_List_FilterInputType>;
}>;


export type MaxTrainSpeedListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', maxTrainSpeed: { __typename: 'MaxTrainSpeedQueryEntryPoint', list: { __typename: 'MaxTrainSpeedList', totalCount: number, items: Array<{ __typename: 'MaxTrainSpeedDto', id: number, entity_id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string, max_train_speed: number }> } } } };

export type MaxTrainSpeedRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type MaxTrainSpeedRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', maxTrainSpeed: { __typename: 'MaxTrainSpeedQueryEntryPoint', byEntityId: { __typename: 'MaxTrainSpeedDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type MaxTrainSpeedUpdateMutationVariables = Exact<{
  data: UpdateMaxTrainSpeedDto;
}>;


export type MaxTrainSpeedUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', maxTrainSpeed: { __typename: 'MaxTrainSpeedMutationEntryPoint', update: { __typename: 'MaxTrainSpeedDto', id: number } } } };

export type UpdateMnemonicMutationVariables = Exact<{
  data: UpdateMnemonicDto;
}>;


export type UpdateMnemonicMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', mnemonic: { __typename: 'MnemonicMutationEntryPoint', update?: boolean | null } } };

export type CreateMvpsCompanyAffiliationMutationVariables = Exact<{
  input: CreateMvpsCompanyAffiliationDto;
}>;


export type CreateMvpsCompanyAffiliationMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', mvpsCompanyAffiliation: { __typename: 'MvpsCompanyAffiliationMutationEntryPoint', create: { __typename: 'MvpsCompanyAffiliationDto', entity_id: number } } } };

export type MvpsCompanyAffiliationHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<MvpsCompanyAffiliationQueryResolver_History_SortingInputType> | MvpsCompanyAffiliationQueryResolver_History_SortingInputType>;
}>;


export type MvpsCompanyAffiliationHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsCompanyAffiliation: { __typename: 'MvpsCompanyAffiliationQueryEntryPoint', history: { __typename: 'MvpsCompanyAffiliationDtoList', totalCount: number, items: Array<{ __typename: 'MvpsCompanyAffiliationDto', end_at: string, entity_id: number, id: number, mvps_owner: string, start_at: string }> } } } };

export type MvpsCompanyAffiliationRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type MvpsCompanyAffiliationRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsCompanyAffiliation: { __typename: 'MvpsCompanyAffiliationQueryEntryPoint', byEntityId: { __typename: 'MvpsCompanyAffiliationDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdateMvpsCompanyAffiliationMutationVariables = Exact<{
  input: UpdateMvpsCompanyAffiliationDto;
}>;


export type UpdateMvpsCompanyAffiliationMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', mvpsCompanyAffiliation: { __typename: 'MvpsCompanyAffiliationMutationEntryPoint', update: { __typename: 'MvpsCompanyAffiliationDto', entity_id: number } } } };

export type MvpsCompanyAffiliationListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<MvpsCompanyAffiliationQueryResolver_List_SortingInputType> | MvpsCompanyAffiliationQueryResolver_List_SortingInputType>;
  where?: InputMaybe<MvpsCompanyAffiliationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type MvpsCompanyAffiliationListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsCompanyAffiliation: { __typename: 'MvpsCompanyAffiliationQueryEntryPoint', list: { __typename: 'MvpsCompanyAffiliationDtoList', totalCount: number, items: Array<{ __typename: 'MvpsCompanyAffiliationDto', entity_id: number, id: number, mvps_owner: string, start_at: string, end_at: string }> } } } };

export type CreateMvpsMartinSectionTypeMutationVariables = Exact<{
  input: CreateMvpsMartinSectionTypeDto;
}>;


export type CreateMvpsMartinSectionTypeMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', mvpsMartinSectionType: { __typename: 'MvpsMartinSectionTypeMutationEntryPoint', create: { __typename: 'MvpsMartinSectionTypeDto', entity_id: number } } } };

export type MvpsMartinSectionTypesHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<MvpsMartinSectionTypeQueryResolver_History_SortingInputType> | MvpsMartinSectionTypeQueryResolver_History_SortingInputType>;
}>;


export type MvpsMartinSectionTypesHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsMartinSectionType: { __typename: 'MvpsMartinSectionTypeQueryEntryPoint', history: { __typename: 'MvpsMartinSectionTypeDtoList', totalCount: number, items: Array<{ __typename: 'MvpsMartinSectionTypeDto', id: number, entity_id: number, start_at: string, end_at: string, series: string, mvps_martin_section_type_equipment_id: number, carriage_quantity_in_section: number, price: number, mvpsMartinSectionTypeEquipmentDto: { __typename: 'MvpsMartinSectionTypeEquipmentDto', entity_id: number, equipment: string } }> } } } };

export type MvpsMartinSectionTypeRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type MvpsMartinSectionTypeRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsMartinSectionType: { __typename: 'MvpsMartinSectionTypeQueryEntryPoint', byEntityId: { __typename: 'MvpsMartinSectionTypeDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdateMvpsMartinSectionTypeMutationVariables = Exact<{
  input: UpdateMvpsMartinSectionTypeDto;
}>;


export type UpdateMvpsMartinSectionTypeMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', mvpsMartinSectionType: { __typename: 'MvpsMartinSectionTypeMutationEntryPoint', update: { __typename: 'MvpsMartinSectionTypeDto', entity_id: number } } } };

export type MvpsMartinSectionTypesQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<MvpsMartinSectionTypeQueryResolver_List_SortingInputType> | MvpsMartinSectionTypeQueryResolver_List_SortingInputType>;
  where?: InputMaybe<MvpsMartinSectionTypeQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type MvpsMartinSectionTypesQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsMartinSectionType: { __typename: 'MvpsMartinSectionTypeQueryEntryPoint', list: { __typename: 'MvpsMartinSectionTypeDtoList', totalCount: number, items: Array<{ __typename: 'MvpsMartinSectionTypeDto', id: number, entity_id: number, start_at: string, end_at: string, series: string, mvps_martin_section_type_equipment_id: number, carriage_quantity_in_section: number, price: number, mvpsMartinSectionTypeEquipmentDto: { __typename: 'MvpsMartinSectionTypeEquipmentDto', entity_id: number, equipment: string } }> } } } };

export type CreateMvpsMartinSectionTypeEquipmentMutationVariables = Exact<{
  input: CreateMvpsMartinSectionTypeEquipmentDto;
}>;


export type CreateMvpsMartinSectionTypeEquipmentMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', mvpsMartinSectionTypeEquipment: { __typename: 'MvpsMartinSectionTypeEquipmentMutationEntryPoint', create: { __typename: 'MvpsMartinSectionTypeEquipmentDto', id: number } } } };

export type MvpsMartinSectionTypeEquipmentHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<MvpsMartinSectionTypeEquipmentQueryResolver_History_SortingInputType> | MvpsMartinSectionTypeEquipmentQueryResolver_History_SortingInputType>;
}>;


export type MvpsMartinSectionTypeEquipmentHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsMartinSectionTypeEquipment: { __typename: 'MvpsMartinSectionTypeEquipmentQueryEntryPoint', history: { __typename: 'MvpsMartinSectionTypeEquipmentList', totalCount: number, items: Array<{ __typename: 'MvpsMartinSectionTypeEquipmentDto', start_at: string, end_at: string, entity_id: number, equipment: string }> } } } };

export type MvpsMartinSectionTypeEquipmentRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type MvpsMartinSectionTypeEquipmentRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsMartinSectionTypeEquipment: { __typename: 'MvpsMartinSectionTypeEquipmentQueryEntryPoint', byEntityId: { __typename: 'MvpsMartinSectionTypeEquipmentDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdateMvpsMartinSectionTypeEquipmentMutationVariables = Exact<{
  input: UpdateMvpsMartinSectionTypeEquipmentDto;
}>;


export type UpdateMvpsMartinSectionTypeEquipmentMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', mvpsMartinSectionTypeEquipment: { __typename: 'MvpsMartinSectionTypeEquipmentMutationEntryPoint', update: { __typename: 'MvpsMartinSectionTypeEquipmentDto', id: number } } } };

export type MvpsMartinSectionTypeEquipmentListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<MvpsMartinSectionTypeEquipmentQueryResolver_List_SortingInputType> | MvpsMartinSectionTypeEquipmentQueryResolver_List_SortingInputType>;
  where?: InputMaybe<MvpsMartinSectionTypeEquipmentQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type MvpsMartinSectionTypeEquipmentListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsMartinSectionTypeEquipment: { __typename: 'MvpsMartinSectionTypeEquipmentQueryEntryPoint', list: { __typename: 'MvpsMartinSectionTypeEquipmentList', totalCount: number, items: Array<{ __typename: 'MvpsMartinSectionTypeEquipmentDto', entity_id: number, equipment: string }> } } } };

export type CreateMvpsRateManagementExploitationMaintenanceRepairMutationVariables = Exact<{
  input: CreateMvpsRateManagementExploitationMaintenanceRepairDto;
}>;


export type CreateMvpsRateManagementExploitationMaintenanceRepairMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', mvpsRateManagementExploitationMaintenanceRepair: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairMutationEntryPoint', create: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairDto', entity_id: number } } } };

export type MvpsRateManagementExploitationMaintenanceRepairHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<MvpsRateManagementExploitationMaintenanceRepairQueryResolver_History_SortingInputType> | MvpsRateManagementExploitationMaintenanceRepairQueryResolver_History_SortingInputType>;
}>;


export type MvpsRateManagementExploitationMaintenanceRepairHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsRateManagementExploitationMaintenanceRepair: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairQueryEntryPoint', history: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairList', totalCount: number, items: Array<{ __typename: 'MvpsRateManagementExploitationMaintenanceRepairDto', entity_id: number, price: number, start_at: string, end_at: string, mnemonic: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string } }> } } } };

export type MvpsRateManagementExploitationMaintenanceRepairRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type MvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsRateManagementExploitationMaintenanceRepair: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairQueryEntryPoint', byEntityId: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdateMvpsRateManagementExploitationMaintenanceRepairMutationVariables = Exact<{
  input: UpdateMvpsRateManagementExploitationMaintenanceRepairDto;
}>;


export type UpdateMvpsRateManagementExploitationMaintenanceRepairMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', mvpsRateManagementExploitationMaintenanceRepair: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairMutationEntryPoint', update?: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairDto', entity_id: number } | null } } };

export type MvpsRateManagementExploitationMaintenanceRepairListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_SortingInputType> | MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_SortingInputType>;
  where?: InputMaybe<MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type MvpsRateManagementExploitationMaintenanceRepairListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsRateManagementExploitationMaintenanceRepair: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairQueryEntryPoint', list: { __typename: 'MvpsRateManagementExploitationMaintenanceRepairList', totalCount: number, items: Array<{ __typename: 'MvpsRateManagementExploitationMaintenanceRepairDto', entity_id: number, price: number, start_at: string, end_at: string, mnemonic: { __typename: 'MnemonicDto', id: number, group_name: string, group_name_rus: string, mnemonic: string, mnemonic_rus: string } }> } } } };

export type NonPassengerCarriageTypeForSchemaListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageTypesForSchemaQueryResolver_List_SortingInputType> | CarriageTypesForSchemaQueryResolver_List_SortingInputType>;
  where?: InputMaybe<CarriageTypesForSchemaQueryResolver_List_FilterInputType>;
}>;


export type NonPassengerCarriageTypeForSchemaListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', carriageTypesForSchema: { __typename: 'CarriageTypesForSchemaQueryEntryPoint', list: { __typename: 'CarriageTypesForSchemaDtoList', items: Array<{ __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string }> } } } };

export type CreateNonPassengerCarriageTypeMutationVariables = Exact<{
  input: CreateNonPassengerCarriageTypeDto;
}>;


export type CreateNonPassengerCarriageTypeMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', nonPassengerCarriageType: { __typename: 'NonPassengerCarriageTypeMutationEntryPoint', create: { __typename: 'NonPassengerCarriageTypeDto', id: number } } } };

export type NonPassengerCarriageTypeHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NonPassengerCarriageTypeQueryResolver_History_SortingInputType> | NonPassengerCarriageTypeQueryResolver_History_SortingInputType>;
}>;


export type NonPassengerCarriageTypeHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', nonPassengerCarriageType: { __typename: 'NonPassengerCarriageTypeQueryEntryPoint', history: { __typename: 'NonPassengerCarriageTypeList', totalCount: number, items: Array<{ __typename: 'NonPassengerCarriageTypeDto', end_at: string, entity_id: number, created_at: string, updated_at: string, start_at: string, carriage_types_for_schema: { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string }, conditional_carriage_numbers: Array<{ __typename: 'ConditionalCarriageNumberDto', id: number, conditional_carriage_number: number }> }> } } } };

export type NonPassengerCarriageTypeRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type NonPassengerCarriageTypeRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', nonPassengerCarriageType: { __typename: 'NonPassengerCarriageTypeQueryEntryPoint', byEntityId: { __typename: 'NonPassengerCarriageTypeDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdateNonPassengerCarriageTypeMutationVariables = Exact<{
  input: UpdateNonPassengerCarriageTypeDto;
}>;


export type UpdateNonPassengerCarriageTypeMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', nonPassengerCarriageType: { __typename: 'NonPassengerCarriageTypeMutationEntryPoint', update?: { __typename: 'NonPassengerCarriageTypeDto', id: number } | null } } };

export type NonPassengerCarriageTypeQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<NonPassengerCarriageTypeQueryResolver_List_SortingInputType> | NonPassengerCarriageTypeQueryResolver_List_SortingInputType>;
  where?: InputMaybe<NonPassengerCarriageTypeQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type NonPassengerCarriageTypeQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', nonPassengerCarriageType: { __typename: 'NonPassengerCarriageTypeQueryEntryPoint', list: { __typename: 'NonPassengerCarriageTypeList', totalCount: number, items: Array<{ __typename: 'NonPassengerCarriageTypeDto', entity_id: number, created_at: string, updated_at: string, start_at: string, carriage_types_for_schema: { __typename: 'CarriageTypesForSchemaDto', id: number, name: string, description: string }, conditional_carriage_numbers: Array<{ __typename: 'ConditionalCarriageNumberDto', id: number, conditional_carriage_number: number }> }> } } } };

export type CreatePassengerCarrierMutationVariables = Exact<{
  input: CreatePassengerCarrierDto;
}>;


export type CreatePassengerCarrierMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', passengerCarrier: { __typename: 'PassengerCarrierMutationEntryPoint', create: { __typename: 'PassengerCarrierDto', entity_id: number } } } };

export type PassengerCarriersCreateVersionMutationVariables = Exact<{
  data: CreateVersionPassengerCarrierDto;
}>;


export type PassengerCarriersCreateVersionMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', passengerCarrier: { __typename: 'PassengerCarrierMutationEntryPoint', createVersion: { __typename: 'PassengerCarrierDto', entity_id: number } } } };

export type PassengerCarrierDeleteMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type PassengerCarrierDeleteMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', passengerCarrier: { __typename: 'PassengerCarrierMutationEntryPoint', delete: boolean } } };

export type PassengerCarriersHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<PassengerCarrierQueryResolver_History_SortingInputType> | PassengerCarrierQueryResolver_History_SortingInputType>;
}>;


export type PassengerCarriersHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', passengerCarrier: { __typename: 'PassengerCarrierQueryEntryPoint', history: { __typename: 'PassengerCarrierList', totalCount: number, items: Array<{ __typename: 'PassengerCarrierDto', id: number, start_at: string, end_at: string, is_latest: boolean, entity_id: number, short_name: string, name: string, code: number, mnkodp: string, gos: number, is_lock: boolean }> } } } };

export type LockPassengerCarrierMutationVariables = Exact<{
  input: UpdatePassengerCarrierEntityDto;
}>;


export type LockPassengerCarrierMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', passengerCarrier: { __typename: 'PassengerCarrierMutationEntryPoint', updateEntity: boolean } } };

export type PassengerCarrierRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type PassengerCarrierRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', passengerCarrier: { __typename: 'PassengerCarrierQueryEntryPoint', byEntityId: { __typename: 'PassengerCarrierDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdatePassengerCarrierMutationVariables = Exact<{
  input: UpdatePassengerCarrierDto;
}>;


export type UpdatePassengerCarrierMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', passengerCarrier: { __typename: 'PassengerCarrierMutationEntryPoint', update: { __typename: 'PassengerCarrierDto', entity_id: number } } } };

export type PassengerCarriersQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<PassengerCarrierQueryResolver_List_SortingInputType> | PassengerCarrierQueryResolver_List_SortingInputType>;
  where?: InputMaybe<PassengerCarrierQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type PassengerCarriersQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', passengerCarrier: { __typename: 'PassengerCarrierQueryEntryPoint', list: { __typename: 'PassengerCarrierList', totalCount: number, items: Array<{ __typename: 'PassengerCarrierDto', id: number, is_latest: boolean, entity_id: number, short_name: string, name: string, code: number, mnkodp: string, gos: number, is_lock: boolean }> } } } };

export type PeriodicitySeasonCreateMutationVariables = Exact<{
  data: CreatePeriodicitySeasonDto;
}>;


export type PeriodicitySeasonCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', periodicitySeason: { __typename: 'PeriodicitySeasonMutationEntryPoint', create: { __typename: 'PeriodicitySeasonDto', entity_id: number } } } };

export type PeriodicitySeasonHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<PeriodicitySeasonQueryResolver_History_SortingInputType> | PeriodicitySeasonQueryResolver_History_SortingInputType>;
}>;


export type PeriodicitySeasonHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', periodicitySeason: { __typename: 'PeriodicitySeasonQueryEntryPoint', history: { __typename: 'PeriodicitySeasonList', totalCount: number, items: Array<{ __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string }> } } } };

export type PeriodicitySeasonListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<PeriodicitySeasonQueryResolver_List_SortingInputType> | PeriodicitySeasonQueryResolver_List_SortingInputType>;
  where?: InputMaybe<PeriodicitySeasonQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type PeriodicitySeasonListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', periodicitySeason: { __typename: 'PeriodicitySeasonQueryEntryPoint', list: { __typename: 'PeriodicitySeasonList', totalCount: number, items: Array<{ __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string }> } } } };

export type PeriodicitySeasonRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type PeriodicitySeasonRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', periodicitySeason: { __typename: 'PeriodicitySeasonQueryEntryPoint', byEntityId: { __typename: 'PeriodicitySeasonDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type PeriodicitySeasonUpdateMutationVariables = Exact<{
  data: UpdatePeriodicitySeasonDto;
}>;


export type PeriodicitySeasonUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', periodicitySeason: { __typename: 'PeriodicitySeasonMutationEntryPoint', update: { __typename: 'PeriodicitySeasonDto', entity_id: number } } } };

export type CreateRailwayAdministrationMutationVariables = Exact<{
  input: CreateRailwayAdministrationDto;
}>;


export type CreateRailwayAdministrationMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', railwayAdministration: { __typename: 'RailwayAdministrationMutationEntryPoint', create: { __typename: 'RailwayAdministrationDto', id: number } } } };

export type RailwayAdministrationHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RailwayAdministrationQueryResolver_History_SortingInputType> | RailwayAdministrationQueryResolver_History_SortingInputType>;
}>;


export type RailwayAdministrationHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', railwayAdministration: { __typename: 'RailwayAdministrationQueryEntryPoint', history: { __typename: 'RailwayAdministrationList', totalCount: number, items: Array<{ __typename: 'RailwayAdministrationDto', end_at: string, start_at: string, id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }> } } } };

export type RailwayAdministrationRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type RailwayAdministrationRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', railwayAdministration: { __typename: 'RailwayAdministrationQueryEntryPoint', byEntityId: { __typename: 'RailwayAdministrationDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdateRailwayAdministrationMutationVariables = Exact<{
  input: UpdateRailwayAdministrationDto;
}>;


export type UpdateRailwayAdministrationMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', railwayAdministration: { __typename: 'RailwayAdministrationMutationEntryPoint', update: { __typename: 'RailwayAdministrationDto', id: number } } } };

export type RailwayAdministrationQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RailwayAdministrationQueryResolver_List_SortingInputType> | RailwayAdministrationQueryResolver_List_SortingInputType>;
  where?: InputMaybe<RailwayAdministrationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type RailwayAdministrationQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', railwayAdministration: { __typename: 'RailwayAdministrationQueryEntryPoint', list: { __typename: 'RailwayAdministrationList', totalCount: number, items: Array<{ __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }> } } } };

export type RailwayAdministrationListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RailwayAdministrationQueryResolver_List_SortingInputType> | RailwayAdministrationQueryResolver_List_SortingInputType>;
  where?: InputMaybe<RailwayAdministrationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type RailwayAdministrationListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', railwayAdministration: { __typename: 'RailwayAdministrationQueryEntryPoint', list: { __typename: 'RailwayAdministrationList', items: Array<{ __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, name: string, code: number }> } } } };

export type CreateRailwayMutationVariables = Exact<{
  input: CreateRailwayDto;
}>;


export type CreateRailwayMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', railway: { __typename: 'RailwayMutationEntryPoint', create: { __typename: 'RailwayDto', entity_id: number } } } };

export type RailwaysHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RailwayQueryResolver_History_SortingInputType> | RailwayQueryResolver_History_SortingInputType>;
}>;


export type RailwaysHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', railway: { __typename: 'RailwayQueryEntryPoint', history: { __typename: 'RailwayList', totalCount: number, items: Array<{ __typename: 'RailwayDto', start_at: string, end_at: string, id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, name: string } }> } } } };

export type RailwayRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type RailwayRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', railway: { __typename: 'RailwayQueryEntryPoint', byEntityId: { __typename: 'RailwayDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdateRailwayMutationVariables = Exact<{
  input: UpdateRailwayDto;
}>;


export type UpdateRailwayMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', railway: { __typename: 'RailwayMutationEntryPoint', update: { __typename: 'RailwayDto', entity_id: number } } } };

export type RailwaysQueryVariables = Exact<{
  range: RangeInputDto;
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RailwayQueryResolver_List_SortingInputType> | RailwayQueryResolver_List_SortingInputType>;
  where?: InputMaybe<RailwayQueryResolver_List_FilterInputType>;
}>;


export type RailwaysQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', railway: { __typename: 'RailwayQueryEntryPoint', list: { __typename: 'RailwayList', totalCount: number, items: Array<{ __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, name: string } }> } } } };

export type RoutesControlAvailabilitySeatsDirectionsCreateMutationVariables = Exact<{
  data: CreateRoutesControlAvailabilitySeatsDirectionsDto;
}>;


export type RoutesControlAvailabilitySeatsDirectionsCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', routesControlAvailabilitySeatsDirection: { __typename: 'RoutesControlAvailabilitySeatsDirectionMutationEntryPoint', create: { __typename: 'RoutesControlAvailabilitySeatsDirectionsDto', id: number } } } };

export type RoutesControlAvailabilitySeatsDirectionsUpdateMutationVariables = Exact<{
  data: UpdateRoutesControlAvailabilitySeatsDirectionsDto;
}>;


export type RoutesControlAvailabilitySeatsDirectionsUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', routesControlAvailabilitySeatsDirection: { __typename: 'RoutesControlAvailabilitySeatsDirectionMutationEntryPoint', update?: { __typename: 'RoutesControlAvailabilitySeatsDirectionsDto', id: number } | null } } };

export type RoutesControlAvailabilitySeatsDirectionsListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<RoutesControlAvailabilitySeatsDirectionQueryResolver_List_SortingInputType> | RoutesControlAvailabilitySeatsDirectionQueryResolver_List_SortingInputType>;
  where?: InputMaybe<RoutesControlAvailabilitySeatsDirectionQueryResolver_List_FilterInputType>;
}>;


export type RoutesControlAvailabilitySeatsDirectionsListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', routesControlAvailabilitySeatsDirection: { __typename: 'RoutesControlAvailabilitySeatsDirectionQueryEntryPoint', list: { __typename: 'RoutesControlAvailabilitySeatsDirectionsList', totalCount: number, items: Array<{ __typename: 'RoutesControlAvailabilitySeatsDirectionsDto', id: number, is_lock: boolean, arrival_direction?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, arrival_stations?: Array<{ __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }> | null, departure_direction?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, departure_stations?: Array<{ __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }> | null }> } } } };

export type StationCreateMutationVariables = Exact<{
  data: CreateStationDto;
}>;


export type StationCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', station: { __typename: 'StationMutationEntryPoint', create: { __typename: 'StationDto', entity_id: number } } } };

export type StationsHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<StationQueryResolver_History_SortingInputType> | StationQueryResolver_History_SortingInputType>;
}>;


export type StationsHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', station: { __typename: 'StationQueryEntryPoint', history: { __typename: 'StationDtoList', totalCount: number, items: Array<{ __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null, last_version: { __typename: 'LatestVersionDataDto', is_available_to_create_version: boolean, end_at?: string | null, is_latest: boolean, start_at: string }, railway: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } }> } } } };

export type StationsListQueryVariables = Exact<{
  range: RangeInputDto;
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<StationQueryResolver_List_SortingInputType> | StationQueryResolver_List_SortingInputType>;
  where?: InputMaybe<StationQueryResolver_List_FilterInputType>;
}>;


export type StationsListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', station: { __typename: 'StationQueryEntryPoint', list: { __typename: 'StationDtoList', totalCount: number, items: Array<{ __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null, last_version: { __typename: 'LatestVersionDataDto', end_at?: string | null, is_latest: boolean, start_at: string }, railway: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } }> } } } };

export type StationNameForSchemaUpdateMutationVariables = Exact<{
  data: UpdateStationNameDto;
}>;


export type StationNameForSchemaUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', station: { __typename: 'StationMutationEntryPoint', updateNameForSchema: { __typename: 'StationDto', entity_id: number } } } };

export type StationRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type StationRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', station: { __typename: 'StationQueryEntryPoint', byEntityId: { __typename: 'StationDto', last_version: { __typename: 'LatestVersionDataDto', end_at?: string | null, is_latest: boolean, start_at: string } } } } };

export type StationUpdateMutationVariables = Exact<{
  data: UpdateStationDto;
}>;


export type StationUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', station: { __typename: 'StationMutationEntryPoint', update: { __typename: 'StationDto', entity_id: number } } } };

export type StationVersionUpdateMutationVariables = Exact<{
  data: UpdateStationVersionDto;
}>;


export type StationVersionUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', station: { __typename: 'StationMutationEntryPoint', updateVersion: { __typename: 'StationDto', entity_id: number } } } };

export type StructuralSubdivisionBranchListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<BranchQueryResolver_List_SortingInputType> | BranchQueryResolver_List_SortingInputType>;
  where?: InputMaybe<BranchQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type StructuralSubdivisionBranchListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', branch: { __typename: 'BranchQueryEntryPoint', list: { __typename: 'BranchList', totalCount: number, items: Array<{ __typename: 'BranchDto', entity_id: number, name: string }> } } } };

export type CreateStructuralSubdivisionMutationVariables = Exact<{
  input: CreateStructuralSubdivisionDto;
}>;


export type CreateStructuralSubdivisionMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', structuralSubdivision: { __typename: 'StructuralSubdivisionMutationEntryPoint', create: { __typename: 'StructuralSubdivisionDto', entity_id: number } } } };

export type StructuralSubdivisionsHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<StructuralSubdivisionQueryResolver_History_SortingInputType> | StructuralSubdivisionQueryResolver_History_SortingInputType>;
}>;


export type StructuralSubdivisionsHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', structuralSubdivision: { __typename: 'StructuralSubdivisionQueryEntryPoint', history: { __typename: 'StructuralSubdivisionList', totalCount: number, items: Array<{ __typename: 'StructuralSubdivisionDto', start_at: string, end_at: string, entity_id: number, short_name: string, branch: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string }, station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> } } } };

export type StructuralSubdivisionRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type StructuralSubdivisionRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', structuralSubdivision: { __typename: 'StructuralSubdivisionQueryEntryPoint', byEntityId?: { __typename: 'StructuralSubdivisionDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } | null } } };

export type StructuralSubdivisionStationListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<StationQueryResolver_List_SortingInputType> | StationQueryResolver_List_SortingInputType>;
  where?: InputMaybe<StationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type StructuralSubdivisionStationListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', station: { __typename: 'StationQueryEntryPoint', list: { __typename: 'StationDtoList', totalCount: number, items: Array<{ __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }> } } } };

export type UpdateStructuralSubdivisionMutationVariables = Exact<{
  input: UpdateStructuralSubdivisionDto;
}>;


export type UpdateStructuralSubdivisionMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', structuralSubdivision: { __typename: 'StructuralSubdivisionMutationEntryPoint', update: { __typename: 'StructuralSubdivisionDto', entity_id: number } } } };

export type StructuralSubdivisionsQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<StructuralSubdivisionQueryResolver_List_SortingInputType> | StructuralSubdivisionQueryResolver_List_SortingInputType>;
  where?: InputMaybe<StructuralSubdivisionQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type StructuralSubdivisionsQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', structuralSubdivision: { __typename: 'StructuralSubdivisionQueryEntryPoint', list: { __typename: 'StructuralSubdivisionList', totalCount: number, items: Array<{ __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string, branch: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string }, station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> } } } };

export type TractionDirectorateCreateMutationVariables = Exact<{
  data: CreateTractionDirectorateDto;
}>;


export type TractionDirectorateCreateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', tractionDirectorate: { __typename: 'TractionDirectorateMutationEntryPoint', create: { __typename: 'TractionDirectorateDto', entity_id: number } } } };

export type TractionDirectorateHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<TractionDirectorateQueryResolver_History_SortingInputType> | TractionDirectorateQueryResolver_History_SortingInputType>;
}>;


export type TractionDirectorateHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', tractionDirectorate: { __typename: 'TractionDirectorateQueryEntryPoint', history: { __typename: 'TractionDirectorateList', totalCount: number, items: Array<{ __typename: 'TractionDirectorateDto', id: number, entity_id: number, start_at: string, end_at: string, name: string, short_name: string, is_not_in_calculation: boolean, railway: { __typename: 'RailwayDto', entity_id: number, name: string } }> } } } };

export type TractionDirectorateListQueryVariables = Exact<{
  paginate: PaginatorArgsDto;
  orderBy?: InputMaybe<Array<TractionDirectorateQueryResolver_List_SortingInputType> | TractionDirectorateQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TractionDirectorateQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type TractionDirectorateListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', tractionDirectorate: { __typename: 'TractionDirectorateQueryEntryPoint', list: { __typename: 'TractionDirectorateList', totalCount: number, items: Array<{ __typename: 'TractionDirectorateDto', id: number, entity_id: number, start_at: string, end_at: string, name: string, short_name: string, is_not_in_calculation: boolean, railway: { __typename: 'RailwayDto', entity_id: number, name: string } }> } } } };

export type TractionDirectorateRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type TractionDirectorateRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', tractionDirectorate: { __typename: 'TractionDirectorateQueryEntryPoint', byEntityId: { __typename: 'TractionDirectorateDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type TractionDirectorateUpdateMutationVariables = Exact<{
  data: UpdateTractionDirectorateDto;
}>;


export type TractionDirectorateUpdateMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', tractionDirectorate: { __typename: 'TractionDirectorateMutationEntryPoint', update: { __typename: 'TractionDirectorateDto', entity_id: number } } } };

export type CreateTrainBrandMutationVariables = Exact<{
  input: CreateTrainBrandDto;
}>;


export type CreateTrainBrandMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', trainBrand: { __typename: 'TrainBrandMutationEntryPoint', create: { __typename: 'TrainBrandDto', entity_id: number } } } };

export type TrainBrandsHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainBrandQueryResolver_History_SortingInputType> | TrainBrandQueryResolver_History_SortingInputType>;
}>;


export type TrainBrandsHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainBrand: { __typename: 'TrainBrandQueryEntryPoint', history: { __typename: 'TrainBrandList', totalCount: number, items: Array<{ __typename: 'TrainBrandDto', start_at: string, end_at: string, entity_id: number, train_brand: string, background_color: string }> } } } };

export type TrainBrandRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type TrainBrandRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainBrand: { __typename: 'TrainBrandQueryEntryPoint', byEntityId: { __typename: 'TrainBrandDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdateTrainBrandMutationVariables = Exact<{
  input: UpdateTrainBrandDto;
}>;


export type UpdateTrainBrandMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', trainBrand: { __typename: 'TrainBrandMutationEntryPoint', update: { __typename: 'TrainBrandDto', entity_id: number } } } };

export type UpdateTrainBrandColorMutationVariables = Exact<{
  input: UpdateColorTrainBrandDto;
}>;


export type UpdateTrainBrandColorMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', trainBrand: { __typename: 'TrainBrandMutationEntryPoint', updateColor: { __typename: 'TrainBrandList', totalCount: number } } } };

export type TrainBrandsListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainBrandQueryResolver_List_SortingInputType> | TrainBrandQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TrainBrandQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type TrainBrandsListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainBrand: { __typename: 'TrainBrandQueryEntryPoint', list: { __typename: 'TrainBrandList', totalCount: number, items: Array<{ __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }> } } } };

export type CreateTrainCategoryMutationVariables = Exact<{
  input: CreateTrainCategoryDto;
}>;


export type CreateTrainCategoryMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', trainCategory: { __typename: 'TrainCategoryMutationEntryPoint', create: { __typename: 'TrainCategoryDto', entity_id: number, train_category: string } } } };

export type TrainCategoryHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainCategoryQueryResolver_History_SortingInputType> | TrainCategoryQueryResolver_History_SortingInputType>;
}>;


export type TrainCategoryHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainCategory: { __typename: 'TrainCategoryQueryEntryPoint', history: { __typename: 'TrainCategoryList', totalCount: number, items: Array<{ __typename: 'TrainCategoryDto', entity_id: number, created_at: string, updated_at: string, train_category: string, start_at: string, end_at: string }> } } } };

export type TrainCategoryRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type TrainCategoryRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainCategory: { __typename: 'TrainCategoryQueryEntryPoint', byEntityId: { __typename: 'TrainCategoryDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdateTrainCategoryMutationVariables = Exact<{
  input: UpdateTrainCategoryDto;
}>;


export type UpdateTrainCategoryMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', trainCategory: { __typename: 'TrainCategoryMutationEntryPoint', update: { __typename: 'TrainCategoryDto', entity_id: number } } } };

export type TrainCategoryListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainCategoryQueryResolver_List_SortingInputType> | TrainCategoryQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TrainCategoryQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type TrainCategoryListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainCategory: { __typename: 'TrainCategoryQueryEntryPoint', list: { __typename: 'TrainCategoryList', totalCount: number, items: Array<{ __typename: 'TrainCategoryDto', entity_id: number, created_at: string, updated_at: string, train_category: string, start_at: string, end_at: string, train_sub_categories: Array<{ __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, short_train_sub_category: string, created_at: string, updated_at: string, background_color: string, start_at: string, end_at: string, train_numbers: string, train_sub_categories_details_speed?: Array<{ __typename: 'TrainSubCategoriesDetailsSpeedDto', entity_id: number, name: string, train_numbers: string }> | null }> }> } } } };

export type CreateTrainSubCategoryMutationVariables = Exact<{
  input: CreateTrainSubCategoryDto;
}>;


export type CreateTrainSubCategoryMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', trainSubCategory: { __typename: 'TrainSubCategoryMutationEntryPoint', create: { __typename: 'TrainSubCategoryDto', entity_id: number } } } };

export type TrainSubCategoryHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainSubCategoryQueryResolver_History_SortingInputType> | TrainSubCategoryQueryResolver_History_SortingInputType>;
}>;


export type TrainSubCategoryHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainSubCategory: { __typename: 'TrainSubCategoryQueryEntryPoint', history: { __typename: 'TrainSubCategoryList', totalCount: number, items: Array<{ __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, short_train_sub_category: string, created_at: string, updated_at: string, background_color: string, start_at: string, end_at: string, train_numbers: string }> } } } };

export type TrainSubCategoryRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type TrainSubCategoryRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainSubCategory: { __typename: 'TrainSubCategoryQueryEntryPoint', byEntityId: { __typename: 'TrainSubCategoryDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdateTrainSubCategoryMutationVariables = Exact<{
  input: UpdateTrainSubCategoryDto;
}>;


export type UpdateTrainSubCategoryMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', trainSubCategory: { __typename: 'TrainSubCategoryMutationEntryPoint', update: { __typename: 'TrainSubCategoryDto', entity_id: number } } } };

export type UpdateTrainSubCategoryColorMutationVariables = Exact<{
  input: UpdateColorTrainSubCategoryDto;
}>;


export type UpdateTrainSubCategoryColorMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', trainSubCategory: { __typename: 'TrainSubCategoryMutationEntryPoint', updateColor: { __typename: 'TrainSubCategoryList', totalCount: number } } } };

export type TrainSubCategoriesDetailSpeedByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type TrainSubCategoriesDetailSpeedByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainSubCategoriesDetailsSpeed: { __typename: 'TrainSubCategoriesDetailsSpeedQueryEntryPoint', byEntityId: { __typename: 'TrainSubCategoriesDetailsSpeedDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type TrainSubCategoriesDetailsSpeedHistoryListQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainSubCategoriesDetailsSpeedQueryResolver_History_SortingInputType> | TrainSubCategoriesDetailsSpeedQueryResolver_History_SortingInputType>;
}>;


export type TrainSubCategoriesDetailsSpeedHistoryListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainSubCategoriesDetailsSpeed: { __typename: 'TrainSubCategoriesDetailsSpeedQueryEntryPoint', history: { __typename: 'TrainSubCategoriesDetailsSpeedList', totalCount: number, items: Array<{ __typename: 'TrainSubCategoriesDetailsSpeedDto', entity_id: number, created_at: string, updated_at: string, name: string, train_numbers: string, start_at: string, end_at: string, train_sub_category: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string } }> } } } };

export type TrainSubCategoriesDetailsSpeedListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainSubCategoriesDetailsSpeedQueryResolver_List_SortingInputType> | TrainSubCategoriesDetailsSpeedQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TrainSubCategoriesDetailsSpeedQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type TrainSubCategoriesDetailsSpeedListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainSubCategoriesDetailsSpeed: { __typename: 'TrainSubCategoriesDetailsSpeedQueryEntryPoint', list: { __typename: 'TrainSubCategoriesDetailsSpeedList', totalCount: number, items: Array<{ __typename: 'TrainSubCategoriesDetailsSpeedDto', entity_id: number, created_at: string, updated_at: string, name: string, train_numbers: string, start_at: string, end_at: string, train_sub_category: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string } }> } } } };

export type CreateTrainSubSpeedMutationVariables = Exact<{
  data: CreateTrainSubCategoriesDetailsSpeedDto;
}>;


export type CreateTrainSubSpeedMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', trainSubCategoriesDetailsSpeed: { __typename: 'TrainSubCategoriesDetailsSpeedMutationEntryPoint', create: { __typename: 'TrainSubCategoriesDetailsSpeedDto', entity_id: number, created_at: string, updated_at: string, name: string, train_numbers: string, start_at: string, end_at: string, train_sub_category: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string } } } } };

export type UpdateTrainSubSpeedMutationVariables = Exact<{
  data: UpdateTrainSubCategoriesDetailsSpeedDto;
}>;


export type UpdateTrainSubSpeedMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', trainSubCategoriesDetailsSpeed: { __typename: 'TrainSubCategoriesDetailsSpeedMutationEntryPoint', update: { __typename: 'TrainSubCategoriesDetailsSpeedDto', entity_id: number, created_at: string, updated_at: string, name: string, train_numbers: string, start_at: string, end_at: string, train_sub_category: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string } } } } };

export type CreateTransportationPerformanceIndicatorMutationVariables = Exact<{
  input: CreateTransportationPerformanceIndicatorDto;
}>;


export type CreateTransportationPerformanceIndicatorMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', transportationPerformanceIndicator: { __typename: 'TransportationPerformanceIndicatorMutationEntryPoint', create: { __typename: 'TransportationPerformanceIndicatorDto', entity_id: number } } } };

export type TransportationPerformanceIndicatorsHistoryQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TransportationPerformanceIndicatorQueryResolver_History_SortingInputType> | TransportationPerformanceIndicatorQueryResolver_History_SortingInputType>;
}>;


export type TransportationPerformanceIndicatorsHistoryQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', transportationPerformanceIndicator: { __typename: 'TransportationPerformanceIndicatorQueryEntryPoint', history: { __typename: 'TransportationPerformanceIndicatorDtoList', totalCount: number, items: Array<{ __typename: 'TransportationPerformanceIndicatorDto', start_at: string, end_at: string, entity_id: number, name: string, unit: string, unit_short: string }> } } } };

export type TransportationPerformanceIndicatorRangeByIdQueryVariables = Exact<{
  entityId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type TransportationPerformanceIndicatorRangeByIdQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', transportationPerformanceIndicator: { __typename: 'TransportationPerformanceIndicatorQueryEntryPoint', byEntityId: { __typename: 'TransportationPerformanceIndicatorDto', last_version: { __typename: 'RangeDto', end_at?: string | null, start_at: string } } } } };

export type UpdateTransportationPerformanceIndicatorMutationVariables = Exact<{
  input: UpdateTransportationPerformanceIndicatorDto;
}>;


export type UpdateTransportationPerformanceIndicatorMutation = { __typename: 'Mutation', classifiers: { __typename: 'ClassifiersMutationEntryPoint', transportationPerformanceIndicator: { __typename: 'TransportationPerformanceIndicatorMutationEntryPoint', update: { __typename: 'TransportationPerformanceIndicatorDto', entity_id: number } } } };

export type TransportationPerformanceIndicatorsQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TransportationPerformanceIndicatorQueryResolver_List_SortingInputType> | TransportationPerformanceIndicatorQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TransportationPerformanceIndicatorQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type TransportationPerformanceIndicatorsQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', transportationPerformanceIndicator: { __typename: 'TransportationPerformanceIndicatorQueryEntryPoint', list: { __typename: 'TransportationPerformanceIndicatorDtoList', totalCount: number, items: Array<{ __typename: 'TransportationPerformanceIndicatorDto', entity_id: number, name: string, unit: string, unit_short: string }> } } } };

export type HelpEducationListQueryVariables = Exact<{
  order_by?: InputMaybe<Array<CmsQueryResolver_EducationList_SortingInputType> | CmsQueryResolver_EducationList_SortingInputType>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CmsQueryResolver_EducationList_FilterInputType>;
}>;


export type HelpEducationListQuery = { __typename: 'Query', cms: { __typename: 'CmsQueryEntryPoint', education_list: { __typename: 'EducationList', totalCount: number, items: Array<{ __typename: 'EducationDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null }> } } };

export type HelpFaqListQueryVariables = Exact<{
  order_by?: InputMaybe<Array<CmsQueryResolver_FaqList_SortingInputType> | CmsQueryResolver_FaqList_SortingInputType>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CmsQueryResolver_FaqList_FilterInputType>;
}>;


export type HelpFaqListQuery = { __typename: 'Query', cms: { __typename: 'CmsQueryEntryPoint', faq_list: { __typename: 'FaqList', totalCount: number, items: Array<{ __typename: 'FaqDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null }> } } };

export type AddCarriagesByDateMutationVariables = Exact<{
  data: AddCarriagesByDateDto;
}>;


export type AddCarriagesByDateMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', addCarriagesByDate: boolean } };

export type FinalIndicatorsExportCalculationsMutationVariables = Exact<{
  data: CarriageGroupIndicatorsFinalCalculationRequestDto;
  where?: InputMaybe<IndicatorsMutationResolver_ExportIndicatorsFinalCalculations_FilterInputType>;
}>;


export type FinalIndicatorsExportCalculationsMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', export_final_calculations?: any | null } };

export type FinalIndicatorsTrainListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainQueryResolver_List_SortingInputType> | TrainQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TrainQueryResolver_List_FilterInputType>;
}>;


export type FinalIndicatorsTrainListQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', list: { __typename: 'TrainList', items: Array<{ __typename: 'TrainDto', start_at: string, end_at: string, status: string, rolling_stock_types: Array<string>, id: number, train_number: string, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> } } };

export type IndicatorsCarriageGroupListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<IndicatorsQueryResolver_ListView_SortingInputType> | IndicatorsQueryResolver_ListView_SortingInputType>;
  where?: InputMaybe<IndicatorsQueryResolver_ListView_FilterInputType>;
}>;


export type IndicatorsCarriageGroupListQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', list_groups: { __typename: 'IndicatorsCarriageGroupList', totalCount: number, items: Array<{ __typename: 'IndicatorsCarriageGroupViewDto', id: number, name: string, branch_id?: number | null, passenger_carriers_id?: number | null, railway_administration_id: number, structural_subdivision_id?: number | null, rolling_stock_type: string, step_status: string, status: string, train_numbers?: Array<string> | null, from_stations?: Array<string> | null, to_stations?: Array<string> | null, carriage_dimension_ids?: Array<number> | null, train_ids?: Array<number> | null, dimensions?: string | null, periodicity?: Array<string> | null, regulatory_sector_ids?: Array<number> | null, version: number, start_at: string, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string, railways: Array<{ __typename: 'RailwayDto', entity_id: number, name: string, short_name: string, code: string, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, name: string, short_name: string, code: number } }> } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, name: string, short_name: string, code: number } | null, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, name: string, short_name: string, code: number } }> } } };

export type IndicatorsMvpsCompanyAffiliationListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<MvpsCompanyAffiliationQueryResolver_List_SortingInputType> | MvpsCompanyAffiliationQueryResolver_List_SortingInputType>;
  where?: InputMaybe<MvpsCompanyAffiliationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type IndicatorsMvpsCompanyAffiliationListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsCompanyAffiliation: { __typename: 'MvpsCompanyAffiliationQueryEntryPoint', list: { __typename: 'MvpsCompanyAffiliationDtoList', totalCount: number, items: Array<{ __typename: 'MvpsCompanyAffiliationDto', entity_id: number, mvps_owner: string, start_at: string }> } } } };

export type RequiredParkExportNpsCarriageDimensionListQueryVariables = Exact<{
  range: RangeInputDto;
}>;


export type RequiredParkExportNpsCarriageDimensionListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', npsCarriageDimension: { __typename: 'NpsCarriageDimensionQueryEntryPoint', list: { __typename: 'NpsCarriageDimensionList', totalCount: number, items: Array<{ __typename: 'NpsCarriageDimensionDto', entity_id: number, carriage_dimension: string, description?: string | null }> } } } };

export type IndicatorsParkRequiredQueryVariables = Exact<{
  data: DatesRequestDto;
  where?: InputMaybe<IndicatorsQueryResolver_ParkRequired_FilterInputType>;
}>;


export type IndicatorsParkRequiredQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', parkRequired: { __typename: 'CarriageGroupParkRequiredResponseDto', schema: Array<{ __typename: 'CarriageGroupParkRequiredItemDto', branch: string, total: number, item: Array<{ __typename: 'CarriageGroupParkRequiredItem', carriage_type: string, quantity: number }> }>, schemaTotal: { __typename: 'CarriageGroupParkRequiredItemDto', branch: string, total: number, item: Array<{ __typename: 'CarriageGroupParkRequiredItem', carriage_type: string, quantity: number }> }, park: Array<{ __typename: 'CarriageGroupParkRequiredItemDto', branch: string, total: number, item: Array<{ __typename: 'CarriageGroupParkRequiredItem', carriage_type: string, quantity: number }> }>, parkTotal: { __typename: 'CarriageGroupParkRequiredItemDto', branch: string, total: number, item: Array<{ __typename: 'CarriageGroupParkRequiredItem', carriage_type: string, quantity: number }> } } } };

export type IndicatorsStructuralSubdivisionListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<StructuralSubdivisionQueryResolver_List_SortingInputType> | StructuralSubdivisionQueryResolver_List_SortingInputType>;
  where?: InputMaybe<StructuralSubdivisionQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type IndicatorsStructuralSubdivisionListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', structuralSubdivision: { __typename: 'StructuralSubdivisionQueryEntryPoint', list: { __typename: 'StructuralSubdivisionList', totalCount: number, items: Array<{ __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string, branch: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string, railways: Array<{ __typename: 'RailwayDto', entity_id: number, name: string, short_name: string, code: string, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, name: string, short_name: string, code: number } }> }, station: { __typename: 'StationDto', id: number, full_name: string, railway_id: number, express_code: string, esr_code?: string | null, comment?: string | null, is_board_or_disembark: boolean, is_electricity_type: boolean, is_traction_type: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, is_water_supply: boolean, is_fuel_supply: boolean, is_eco_toilets: boolean, is_waste_collection: boolean, is_border_control: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_route_forming: boolean, is_service_not_train_route: boolean, is_maneuver_work: boolean, railway: { __typename: 'RailwayDto', id: number, name: string, short_name: string, code: string, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, name: string, short_name: string, code: number } } } }> } } } };

export type RequiredParkExportMutationVariables = Exact<{
  where: IndicatorsMutationResolver_ExportParkRequired_FilterInputType;
}>;


export type RequiredParkExportMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', export_park_required?: any | null } };

export type UpdateForecastIndicatorMutationVariables = Exact<{
  data: UpdateForecastIndicatorDto;
}>;


export type UpdateForecastIndicatorMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', updateForecastIndicator: boolean } };

export type CarriageGroupIndicatorsQueryVariables = Exact<{
  carriageGroupId: Scalars['Float']['input'];
}>;


export type CarriageGroupIndicatorsQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', carriage_group_indicators: { __typename: 'CarriageGroupIndicatorsCalculationDto', full_distance: number, carriage_group: { __typename: 'CarriageGroupDto', name: string, rolling_stock_type: string, step_status: string, periodicities: Array<{ __typename: 'PeriodicityDto', id: number }>, turnovers: Array<{ __typename: 'TurnoverDto', id: number }>, gdp: { __typename: 'GdpDto', start_at: string, end_at: string }, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, name: string, short_name: string }, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string } | null, branch?: { __typename: 'BranchDto', name: string, short_name: string } | null, structural_subdivision?: { __typename: 'MvpsCompanyAffiliationDto', entity_id: number, mvps_owner: string } | { __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string, station: { __typename: 'StationDto', full_name: string } } | null, train_quantities: Array<{ __typename: 'TrainQuantityDto', quantity: number }>, turnaround_times: Array<{ __typename: 'TurnaroundTimeDto', turn_around_time: number }> }, carriage_group_routes: Array<{ __typename: 'CarriageGroupRouteItemDto', route: string, train_number: string, distance: number, sign: string, route_distance: number, station_train_from: { __typename: 'StationDto', entity_id: number, full_name: string }, station_train_to: { __typename: 'StationDto', entity_id: number, full_name: string }, station_carriage_group_from: { __typename: 'StationDto', entity_id: number, full_name: string }, station_carriage_group_to: { __typename: 'StationDto', entity_id: number, full_name: string } }>, carriage_type_params_count: Array<{ __typename: 'CarriageGroupParkRequiredItem', carriage_type: string, quantity: number }> } } };

export type IndicatorsByTrainQueryVariables = Exact<{
  data: CarriageGroupIndicatorsByTrainRequestDto;
}>;


export type IndicatorsByTrainQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', indicators_by_train: { __typename: 'CarriageGroupIndicatorsByTrainDto', schema?: { __typename: 'CarriageGroupIndicatorsSchemaDto', carriage_quantity_passenger: number, carriage_quantity_total: number, seats_quantity_passenger: number, seats_quantity_total?: number | null, seats_for_sale_passenger: number, seats_for_sale_total?: number | null, average_capacity_passenger: number, average_capacity_total?: number | null, carriage_quantity_req_passenger: number, carriage_quantity_req_total: number, items: Array<{ __typename: 'CarriageGroupIndicatorsSchemaItemDto', seat_type: string, carriage_type: string, carriage_quantity: number, seats_quantity: number, seats_for_sale: number, average_capacity: number, carriage_quantity_req: number }> } | null, park_required?: Array<{ __typename: 'MvpsParkRequiredDto', carriage_type: string, seat_type: string, departures_quantity?: number | null, equipment: string, carriage_quantity: number } | { __typename: 'NpsParkRequiredDto', seat_type: string, departures_quantity?: number | null, carriage_type: string }> | null, items: Array<{ __typename: 'IndicatorsByTrainSeatsDepartureQuantityDto', train_info: { __typename: 'IndicatorsByTrainTrainInfoDto', train_number: string, distance: number, departures_quantity: number }, carriage_departures_quantity: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_departures_quantity: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, carriage_schema_turnovers: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_schema_turnovers: { __typename: 'IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, carriage_required_turnovers: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_required_turnovers: { __typename: 'IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } }>, total: { __typename: 'IndicatorsByTrainSeatsDepartureQuantityTotalDto', train_info: { __typename: 'IndicatorsByTrainSeatsDepartureQuantityTotalTrainInfoDto', distance: number, departures_quantity: number }, carriage_departures_quantity: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_departures_quantity: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, carriage_schema_turnovers: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_schema_turnovers: { __typename: 'IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, carriage_required_turnovers: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_required_turnovers: { __typename: 'IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } } } } };

export type CgFinalCalculationMvpsCompanyAffiliationListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<MvpsCompanyAffiliationQueryResolver_List_SortingInputType> | MvpsCompanyAffiliationQueryResolver_List_SortingInputType>;
  where?: InputMaybe<MvpsCompanyAffiliationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type CgFinalCalculationMvpsCompanyAffiliationListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsCompanyAffiliation: { __typename: 'MvpsCompanyAffiliationQueryEntryPoint', list: { __typename: 'MvpsCompanyAffiliationDtoList', totalCount: number, items: Array<{ __typename: 'MvpsCompanyAffiliationDto', entity_id: number, mvps_owner: string, start_at: string }> } } } };

export type CgFinalCalculationStructuralSubdivisionListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<StructuralSubdivisionQueryResolver_List_SortingInputType> | StructuralSubdivisionQueryResolver_List_SortingInputType>;
  where?: InputMaybe<StructuralSubdivisionQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type CgFinalCalculationStructuralSubdivisionListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', structuralSubdivision: { __typename: 'StructuralSubdivisionQueryEntryPoint', list: { __typename: 'StructuralSubdivisionList', totalCount: number, items: Array<{ __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string, branch: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string, railways: Array<{ __typename: 'RailwayDto', entity_id: number, code: string, name: string, short_name: string, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null } }> }, station: { __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null, railway: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null } } } }> } } } };

export type CarriageGroupFinalCalculationQueryVariables = Exact<{
  data: CarriageGroupIndicatorsFinalCalculationRequestDto;
  where?: InputMaybe<IndicatorsQueryResolver_CarriageGroupFinalCalculation_FilterInputType>;
}>;


export type CarriageGroupFinalCalculationQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', carriage_group_final_calculation: { __typename: 'CarriageGroupIndicatorsFinalCalculationDto', items: Array<{ __typename: 'CarriageGroupIndicatorsFinalCalculationItemDto', carriage_type: string, carriage_turnover_schema?: number | null, carriage_turnover_schema_passenger?: number | null, carriage_turnover_req?: number | null, carriage_turnover_req_passenger?: number | null, carriages_quantity?: number | null, seats_turnover_schema?: number | null, seats_turnover_req?: number | null, seats_for_sale?: number | null, average_capacity?: number | null }>, total: { __typename: 'CarriageGroupIndicatorsFinalCalculationTotalItemDto', carriage_turnover_schema?: number | null, carriage_turnover_schema_passenger?: number | null, carriage_turnover_req?: number | null, carriage_turnover_req_passenger?: number | null, carriages_quantity?: number | null, seats_turnover_schema?: number | null, seats_turnover_req?: number | null, seats_for_sale?: number | null, average_capacity?: number | null }, park_required: { __typename: 'CarriageGroupIndicatorsFinalCalculationMvpsParkRequiredDto', total: number, items: Array<{ __typename: 'MvpsParkRequiredDto', carriage_type: string, seat_type: string, departures_quantity?: number | null, equipment: string, carriage_quantity: number }> } | { __typename: 'CarriageGroupIndicatorsFinalCalculationNpsParkRequiredDto', total: number, total_other: number, total_passenger: number, other: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }>, passenger: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } } } };

export type CarriageGroupIndicatorsFinalCalculationItemBaseFragmentFragment = { __typename: 'CarriageGroupIndicatorsFinalCalculationItemDto', carriage_type: string, carriage_turnover_schema?: number | null, carriage_turnover_schema_passenger?: number | null, carriage_turnover_req?: number | null, carriage_turnover_req_passenger?: number | null, carriages_quantity?: number | null, seats_turnover_schema?: number | null, seats_turnover_req?: number | null, seats_for_sale?: number | null, average_capacity?: number | null };

export type CarriageGroupIndicatorsFinalCalculationTotalItemBaseFragmentFragment = { __typename: 'CarriageGroupIndicatorsFinalCalculationTotalItemDto', carriage_turnover_schema?: number | null, carriage_turnover_schema_passenger?: number | null, carriage_turnover_req?: number | null, carriage_turnover_req_passenger?: number | null, carriages_quantity?: number | null, seats_turnover_schema?: number | null, seats_turnover_req?: number | null, seats_for_sale?: number | null, average_capacity?: number | null };

export type IndicatorsExportCarriageGroupFinalCalculationsMutationVariables = Exact<{
  data: CarriageGroupIndicatorsFinalCalculationRequestDto;
  where?: InputMaybe<IndicatorsMutationResolver_ExportCarriageGroupFinalCalculations_FilterInputType>;
}>;


export type IndicatorsExportCarriageGroupFinalCalculationsMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', export_carriage_group_final_calculations?: any | null } };

export type InfrastructureCalculationsRequestMutationVariables = Exact<{
  where?: InputMaybe<IndicatorsMutationResolver_InfrastructureCalculations_FilterInputType>;
}>;


export type InfrastructureCalculationsRequestMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', infrastructure_calculations?: any | null } };

export type InfrastructureCalculationsResponseQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type InfrastructureCalculationsResponseQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', infrastructure_calculations_response: { __typename: 'InfrastructureCalculationDto', categories: Array<{ __typename: 'InfrastructureCalculationCategoryDto', category: string, trains?: Array<{ __typename: 'InfrastructureCalculationTrainDto', groupSign?: string | null, stationFrom: string, stationTo: string, countryDistance: number, carriagesPassengerDeregSv?: number | null, carriagesPassengerDeregK?: number | null, carriagesPassengerRegP?: number | null, carriagesPassengerRegO?: number | null, carriagesPassengerTotal?: number | null, carriagesPostal?: number | null, carriagesBaggage?: number | null, carriagesOther?: number | null, carriagesOtherTotal?: number | null, carriagesTotal?: number | null, distance?: number | null, tripsQuantity?: number | null, carriagesDistancePassengerDeregSv?: number | null, carriagesDistancePassengerDeregK?: number | null, carriagesDistancePassengerRegP?: number | null, carriagesDistancePassengerRegO?: number | null, carriagesDistancePassengerTotal?: number | null, carriagesDistancePostal?: number | null, carriagesDistanceBaggage?: number | null, carriagesDistanceOther?: number | null, carriagesDistanceOtherTotal?: number | null, carriagesDistanceTotal?: number | null, s1CarriagesPassengerDeregSv?: number | null, s1CarriagesPassengerDeregK?: number | null, s1CarriagesPassengerRegP?: number | null, s1CarriagesPassengerRegO?: number | null, s1CarriagesPassengerTotal?: number | null, s1CarriagesPostal?: number | null, s1CarriagesBaggage?: number | null, s1CarriagesOther?: number | null, s1CarriagesOtherTotal?: number | null, s1CarriagesOtherTotalWithoutNds?: number | null, s2CarriagesPassengerDeregSv?: number | null, s2CarriagesPassengerDeregK?: number | null, s2CarriagesPassengerRegP?: number | null, s2CarriagesPassengerRegO?: number | null, s2CarriagesPassengerTotal?: number | null, s2CarriagesPostal?: number | null, s2CarriagesBaggage?: number | null, s2CarriagesOther?: number | null, s2CarriagesOtherTotal?: number | null, s2CarriagesOtherTotalWithoutNds?: number | null, s3CarriagesPassengerDeregSv?: number | null, s3CarriagesPassengerDeregK?: number | null, s3CarriagesPassengerRegP?: number | null, s3CarriagesPassengerRegO?: number | null, s3CarriagesPostal?: number | null, s3CarriagesBaggage?: number | null, s3CarriagesOther?: number | null, s3CarriagesOtherTotalWithoutNds?: number | null, totalCarriagesPassengerDeregSv?: number | null, totalCarriagesPassengerDeregK?: number | null, totalCarriagesPassengerRegP?: number | null, totalCarriagesPassengerRegO?: number | null, totalCarriagesPassengerTotal?: number | null, totalCarriagesPostal?: number | null, totalCarriagesBaggage?: number | null, totalCarriagesOther?: number | null, totalCarriagesOtherTotal?: number | null, totalCarriagesTotalWithoutNds?: number | null, nds?: number | null, totalWithNds?: number | null, trainNumber: string, rows?: Array<{ __typename: 'InfrastructureCalculationRowDto', groupSign?: string | null, stationFrom: string, stationTo: string, countryDistance: number, carriagesPassengerDeregSv?: number | null, carriagesPassengerDeregK?: number | null, carriagesPassengerRegP?: number | null, carriagesPassengerRegO?: number | null, carriagesPassengerTotal?: number | null, carriagesPostal?: number | null, carriagesBaggage?: number | null, carriagesOther?: number | null, carriagesOtherTotal?: number | null, carriagesTotal?: number | null, distance?: number | null, tripsQuantity?: number | null, carriagesDistancePassengerDeregSv?: number | null, carriagesDistancePassengerDeregK?: number | null, carriagesDistancePassengerRegP?: number | null, carriagesDistancePassengerRegO?: number | null, carriagesDistancePassengerTotal?: number | null, carriagesDistancePostal?: number | null, carriagesDistanceBaggage?: number | null, carriagesDistanceOther?: number | null, carriagesDistanceOtherTotal?: number | null, carriagesDistanceTotal?: number | null, s1CarriagesPassengerDeregSv?: number | null, s1CarriagesPassengerDeregK?: number | null, s1CarriagesPassengerRegP?: number | null, s1CarriagesPassengerRegO?: number | null, s1CarriagesPassengerTotal?: number | null, s1CarriagesPostal?: number | null, s1CarriagesBaggage?: number | null, s1CarriagesOther?: number | null, s1CarriagesOtherTotal?: number | null, s1CarriagesOtherTotalWithoutNds?: number | null, s2CarriagesPassengerDeregSv?: number | null, s2CarriagesPassengerDeregK?: number | null, s2CarriagesPassengerRegP?: number | null, s2CarriagesPassengerRegO?: number | null, s2CarriagesPassengerTotal?: number | null, s2CarriagesPostal?: number | null, s2CarriagesBaggage?: number | null, s2CarriagesOther?: number | null, s2CarriagesOtherTotal?: number | null, s2CarriagesOtherTotalWithoutNds?: number | null, s3CarriagesPassengerDeregSv?: number | null, s3CarriagesPassengerDeregK?: number | null, s3CarriagesPassengerRegP?: number | null, s3CarriagesPassengerRegO?: number | null, s3CarriagesPostal?: number | null, s3CarriagesBaggage?: number | null, s3CarriagesOther?: number | null, s3CarriagesOtherTotalWithoutNds?: number | null, totalCarriagesPassengerDeregSv?: number | null, totalCarriagesPassengerDeregK?: number | null, totalCarriagesPassengerRegP?: number | null, totalCarriagesPassengerRegO?: number | null, totalCarriagesPassengerTotal?: number | null, totalCarriagesPostal?: number | null, totalCarriagesBaggage?: number | null, totalCarriagesOther?: number | null, totalCarriagesOtherTotal?: number | null, totalCarriagesTotalWithoutNds?: number | null, nds?: number | null, totalWithNds?: number | null }> | null }> | null, total?: { __typename: 'InfrastructureCalculationTotalDto', distance?: number | null, tripsQuantity?: number | null, carriagesDistancePassengerDeregSv?: number | null, carriagesDistancePassengerDeregK?: number | null, carriagesDistancePassengerRegP?: number | null, carriagesDistancePassengerRegO?: number | null, carriagesDistancePassengerTotal?: number | null, carriagesDistancePostal?: number | null, carriagesDistanceBaggage?: number | null, carriagesDistanceOther?: number | null, carriagesDistanceOtherTotal?: number | null, carriagesDistanceTotal?: number | null, s1CarriagesPassengerDeregSv?: number | null, s1CarriagesPassengerDeregK?: number | null, s1CarriagesPassengerRegP?: number | null, s1CarriagesPassengerRegO?: number | null, s1CarriagesPassengerTotal?: number | null, s1CarriagesPostal?: number | null, s1CarriagesBaggage?: number | null, s1CarriagesOther?: number | null, s1CarriagesOtherTotal?: number | null, s1CarriagesOtherTotalWithoutNds?: number | null, s2CarriagesPassengerDeregSv?: number | null, s2CarriagesPassengerDeregK?: number | null, s2CarriagesPassengerRegP?: number | null, s2CarriagesPassengerRegO?: number | null, s2CarriagesPassengerTotal?: number | null, s2CarriagesPostal?: number | null, s2CarriagesBaggage?: number | null, s2CarriagesOther?: number | null, s2CarriagesOtherTotal?: number | null, s2CarriagesOtherTotalWithoutNds?: number | null, s3CarriagesPassengerDeregSv?: number | null, s3CarriagesPassengerDeregK?: number | null, s3CarriagesPassengerRegP?: number | null, s3CarriagesPassengerRegO?: number | null, s3CarriagesPostal?: number | null, s3CarriagesBaggage?: number | null, s3CarriagesOther?: number | null, s3CarriagesOtherTotalWithoutNds?: number | null, totalCarriagesPassengerDeregSv?: number | null, totalCarriagesPassengerDeregK?: number | null, totalCarriagesPassengerRegP?: number | null, totalCarriagesPassengerRegO?: number | null, totalCarriagesPassengerTotal?: number | null, totalCarriagesPostal?: number | null, totalCarriagesBaggage?: number | null, totalCarriagesOther?: number | null, totalCarriagesOtherTotal?: number | null, totalCarriagesTotalWithoutNds?: number | null, nds?: number | null, totalWithNds?: number | null } | null, totalCountry: { __typename: 'InfrastructureCalculationTotalDto', distance?: number | null, tripsQuantity?: number | null, carriagesDistancePassengerDeregSv?: number | null, carriagesDistancePassengerDeregK?: number | null, carriagesDistancePassengerRegP?: number | null, carriagesDistancePassengerRegO?: number | null, carriagesDistancePassengerTotal?: number | null, carriagesDistancePostal?: number | null, carriagesDistanceBaggage?: number | null, carriagesDistanceOther?: number | null, carriagesDistanceOtherTotal?: number | null, carriagesDistanceTotal?: number | null, s1CarriagesPassengerDeregSv?: number | null, s1CarriagesPassengerDeregK?: number | null, s1CarriagesPassengerRegP?: number | null, s1CarriagesPassengerRegO?: number | null, s1CarriagesPassengerTotal?: number | null, s1CarriagesPostal?: number | null, s1CarriagesBaggage?: number | null, s1CarriagesOther?: number | null, s1CarriagesOtherTotal?: number | null, s1CarriagesOtherTotalWithoutNds?: number | null, s2CarriagesPassengerDeregSv?: number | null, s2CarriagesPassengerDeregK?: number | null, s2CarriagesPassengerRegP?: number | null, s2CarriagesPassengerRegO?: number | null, s2CarriagesPassengerTotal?: number | null, s2CarriagesPostal?: number | null, s2CarriagesBaggage?: number | null, s2CarriagesOther?: number | null, s2CarriagesOtherTotal?: number | null, s2CarriagesOtherTotalWithoutNds?: number | null, s3CarriagesPassengerDeregSv?: number | null, s3CarriagesPassengerDeregK?: number | null, s3CarriagesPassengerRegP?: number | null, s3CarriagesPassengerRegO?: number | null, s3CarriagesPostal?: number | null, s3CarriagesBaggage?: number | null, s3CarriagesOther?: number | null, s3CarriagesOtherTotalWithoutNds?: number | null, totalCarriagesPassengerDeregSv?: number | null, totalCarriagesPassengerDeregK?: number | null, totalCarriagesPassengerRegP?: number | null, totalCarriagesPassengerRegO?: number | null, totalCarriagesPassengerTotal?: number | null, totalCarriagesPostal?: number | null, totalCarriagesBaggage?: number | null, totalCarriagesOther?: number | null, totalCarriagesOtherTotal?: number | null, totalCarriagesTotalWithoutNds?: number | null, nds?: number | null, totalWithNds?: number | null } }>, total: { __typename: 'InfrastructureCalculationTotalDto', distance?: number | null, tripsQuantity?: number | null, carriagesDistancePassengerDeregSv?: number | null, carriagesDistancePassengerDeregK?: number | null, carriagesDistancePassengerRegP?: number | null, carriagesDistancePassengerRegO?: number | null, carriagesDistancePassengerTotal?: number | null, carriagesDistancePostal?: number | null, carriagesDistanceBaggage?: number | null, carriagesDistanceOther?: number | null, carriagesDistanceOtherTotal?: number | null, carriagesDistanceTotal?: number | null, s1CarriagesPassengerDeregSv?: number | null, s1CarriagesPassengerDeregK?: number | null, s1CarriagesPassengerRegP?: number | null, s1CarriagesPassengerRegO?: number | null, s1CarriagesPassengerTotal?: number | null, s1CarriagesPostal?: number | null, s1CarriagesBaggage?: number | null, s1CarriagesOther?: number | null, s1CarriagesOtherTotal?: number | null, s1CarriagesOtherTotalWithoutNds?: number | null, s2CarriagesPassengerDeregSv?: number | null, s2CarriagesPassengerDeregK?: number | null, s2CarriagesPassengerRegP?: number | null, s2CarriagesPassengerRegO?: number | null, s2CarriagesPassengerTotal?: number | null, s2CarriagesPostal?: number | null, s2CarriagesBaggage?: number | null, s2CarriagesOther?: number | null, s2CarriagesOtherTotal?: number | null, s2CarriagesOtherTotalWithoutNds?: number | null, s3CarriagesPassengerDeregSv?: number | null, s3CarriagesPassengerDeregK?: number | null, s3CarriagesPassengerRegP?: number | null, s3CarriagesPassengerRegO?: number | null, s3CarriagesPostal?: number | null, s3CarriagesBaggage?: number | null, s3CarriagesOther?: number | null, s3CarriagesOtherTotalWithoutNds?: number | null, totalCarriagesPassengerDeregSv?: number | null, totalCarriagesPassengerDeregK?: number | null, totalCarriagesPassengerRegP?: number | null, totalCarriagesPassengerRegO?: number | null, totalCarriagesPassengerTotal?: number | null, totalCarriagesPostal?: number | null, totalCarriagesBaggage?: number | null, totalCarriagesOther?: number | null, totalCarriagesOtherTotal?: number | null, totalCarriagesTotalWithoutNds?: number | null, nds?: number | null, totalWithNds?: number | null } } } };

export type InfrastructureExportIndicatorsMutationVariables = Exact<{
  where?: InputMaybe<IndicatorsMutationResolver_ExportInfrastructureIndicatorsCalculations_FilterInputType>;
}>;


export type InfrastructureExportIndicatorsMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', export_infrastructure_indicators?: any | null } };

export type LocomotiveExportCalculationsMutationVariables = Exact<{
  data: ExportTrainIndicatorsListDto;
  where?: InputMaybe<TrainMutationResolver_ExportTrainIndicatorsList_FilterInputType>;
}>;


export type LocomotiveExportCalculationsMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', exportTrainIndicatorsList?: any | null } };

export type LocomotiveTrainListIndicatorsQueryVariables = Exact<{
  data: ExportTrainIndicatorsListDto;
  where?: InputMaybe<TrainQueryResolver_ListIndicators_FilterInputType>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainQueryResolver_ListIndicators_SortingInputType> | TrainQueryResolver_ListIndicators_SortingInputType>;
}>;


export type LocomotiveTrainListIndicatorsQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', listIndicators: { __typename: 'CalculateIndicatorsTableList', totalCount: number, items: Array<{ __typename: 'CalculateIndicatorsTableForLocomotives', period: { __typename: 'CalculateIndicatorsTableListWithSchemasDto', from_date?: string | null, gas_price?: number | null, locomotive_rent_cost?: number | null, locomotive_team_cost?: number | null, locomotive_tech_service_price?: number | null, power_consumption?: number | null, power_price?: number | null, prep_time?: number | null, trip_cost?: number | null, trip_time?: number | null, gas_consumption?: number | null, to_date?: string | null, trips_from_period: number, schemas: Array<{ __typename: 'CalculateIndicatorsTableDto', gas_price?: number | null, gas_consumption?: number | null, locomotive_rent_cost?: number | null, locomotive_team_cost?: number | null, locomotive_tech_service_price?: number | null, power_consumption?: number | null, power_price?: number | null, prep_time?: number | null, schema_id?: number | null, trip_cost?: number | null, trip_time?: number | null, distance?: number | null, trips_from_period: number, locomotive_areas?: Array<{ __typename: 'CalculateIndicatorsTableAreasDto', distance?: number | null, gas_consumption?: number | null, gas_price?: number | null, locomotive_rent_cost?: number | null, locomotive_team_cost?: number | null, locomotive_tech_service_price?: number | null, power_consumption?: number | null, power_price?: number | null, prep_time?: number | null, section_quantity?: number | null, trip_cost?: number | null, trip_time?: number | null }> | null }> }, current: { __typename: 'CalculateIndicatorsTableListWithSchemasDto', train_number: string, trip_time?: number | null, prep_time?: number | null, trip_cost?: number | null, locomotive_rent_cost?: number | null, locomotive_tech_service_price?: number | null, locomotive_team_cost?: number | null, gas_price?: number | null, gas_consumption?: number | null, power_price?: number | null, power_consumption?: number | null, distance?: number | null, from_date?: string | null, to_date?: string | null, schemas: Array<{ __typename: 'CalculateIndicatorsTableDto', locomotive_areas?: Array<{ __typename: 'CalculateIndicatorsTableAreasDto', section_quantity?: number | null, trip_time?: number | null, prep_time?: number | null, trip_cost?: number | null, locomotive_rent_cost?: number | null, locomotive_tech_service_price?: number | null, locomotive_team_cost?: number | null, gas_price?: number | null, gas_consumption?: number | null, power_price?: number | null, power_consumption?: number | null, distance?: number | null, from_date?: string | null, to_date?: string | null, from_station?: { __typename: 'StationDto', full_name: string } | null, to_station?: { __typename: 'StationDto', full_name: string } | null, locomotive_series?: { __typename: 'LocomotiveSeriesDto', series: string, index?: string | null, section_quantity: number, locomotive_traction_type: { __typename: 'LocomotiveTractionTypeDto', name: string, short_name: string } } | null, traction_directorate?: { __typename: 'TractionDirectorateDto', name: string, short_name: string } | null, traction_directorate_team?: Array<{ __typename: 'TractionDirectorateDto', name: string, short_name: string }> | null }> | null, locomotive_series: Array<{ __typename: 'LocomotiveSeriesDto', series: string, section_quantity: number, locomotive_traction_type_id?: number | null, price_rent: number, locomotive_traction_type: { __typename: 'LocomotiveTractionTypeDto', name: string, short_name: string } }>, traction_directorates: Array<{ __typename: 'TractionDirectorateDto', name: string, short_name: string }>, traction_directorate_teams: Array<{ __typename: 'TractionDirectorateDto', name: string, short_name: string }> }>, from_station?: { __typename: 'StationDto', full_name: string } | null, to_station?: { __typename: 'StationDto', full_name: string } | null, railway_administration?: { __typename: 'RailwayAdministrationDto', name: string, short_name: string, code: number } | null, branch?: { __typename: 'BranchDto', name: string, short_name: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', name: string, short_name: string } | null, locomotive_series: Array<{ __typename: 'LocomotiveSeriesDto', series: string, section_quantity: number, locomotive_traction_type_id?: number | null, price_rent: number, locomotive_traction_type: { __typename: 'LocomotiveTractionTypeDto', name: string, short_name: string } }>, traction_directorates: Array<{ __typename: 'TractionDirectorateDto', name: string, short_name: string }>, traction_directorate_teams: Array<{ __typename: 'TractionDirectorateDto', name: string, short_name: string }> } }> } } };

export type LocomotiveExportSeriesIndicatorsMutationVariables = Exact<{
  data: ExportTrainIndicatorsListDto;
  where?: InputMaybe<TrainMutationResolver_ExportLocomotiveSeriesIndicators_FilterInputType>;
}>;


export type LocomotiveExportSeriesIndicatorsMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', exportLocomotiveSeriesIndicators?: any | null } };

export type LococmotiveTractionDirectoratesIndicatorsMutationVariables = Exact<{
  data: ExportTrainIndicatorsListDto;
  where?: InputMaybe<TrainMutationResolver_ExportLococmotiveTractionDirectoratesIndicators_FilterInputType>;
}>;


export type LococmotiveTractionDirectoratesIndicatorsMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', exportLococmotiveTractionDirectoratesIndicators?: any | null } };

export type MvpsCalculationsRequestMutationVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<IndicatorsMutationResolver_MvpsCalculationsRequest_FilterInputType>;
}>;


export type MvpsCalculationsRequestMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', mvps_calculations_request?: any | null } };

export type MvpsCalculationsResponseQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type MvpsCalculationsResponseQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', mvps_calculations_response: { __typename: 'MvpsCalculationsList', totalCount: number, items: Array<{ __typename: 'MvpsCalculationDto', carriage_group_id: number, branch: string, railway_administration: string, passenger_carrier_russian_railway: string, carriages_quantity: number, train_quantity: number, company_affiliation: string, mvps_section_type: string, rent_total: number, to_tr_total: number, control_total?: number | null, total: number, rows: Array<{ __typename: 'MvpsCalculationRowDto', train_number: string, stations: Array<string>, distance: number, route_duration?: number | null, to_tr: number, control?: number | null }> }> } } };

export type MvpsExportCalculationsMutationVariables = Exact<{
  where?: InputMaybe<IndicatorsMutationResolver_ExportMvpsCalculations_FilterInputType>;
}>;


export type MvpsExportCalculationsMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', export_mvps_calculations?: any | null } };

export type TrainByCarriagesCarriageGroupIndicatorsQueryVariables = Exact<{
  carriageGroupId: Scalars['Float']['input'];
}>;


export type TrainByCarriagesCarriageGroupIndicatorsQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', carriage_group_indicators: { __typename: 'CarriageGroupIndicatorsCalculationDto', full_distance: number, carriage_group: { __typename: 'CarriageGroupDto', name: string, rolling_stock_type: string, step_status: string, gdp: { __typename: 'GdpDto', start_at: string, end_at: string }, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, name: string, short_name: string }, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string } | null, branch?: { __typename: 'BranchDto', name: string, short_name: string } | null, structural_subdivision?: { __typename: 'MvpsCompanyAffiliationDto', entity_id: number, mvps_owner: string } | { __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string, station: { __typename: 'StationDto', full_name: string, express_code: string } } | null, train_quantities: Array<{ __typename: 'TrainQuantityDto', quantity: number }>, turnaround_times: Array<{ __typename: 'TurnaroundTimeDto', turn_around_time: number }> }, carriage_group_routes: Array<{ __typename: 'CarriageGroupRouteItemDto', route: string, train_number: string, distance: number, sign: string, route_distance: number, station_train_from: { __typename: 'StationDto', entity_id: number, full_name: string }, station_train_to: { __typename: 'StationDto', entity_id: number, full_name: string }, station_carriage_group_from: { __typename: 'StationDto', entity_id: number, full_name: string }, station_carriage_group_to: { __typename: 'StationDto', entity_id: number, full_name: string } }>, carriage_type_params_count: Array<{ __typename: 'CarriageGroupParkRequiredItem', carriage_type: string, quantity: number }> } } };

export type TrainByCarriagesIndicatorsByTrainQueryVariables = Exact<{
  data: CarriageGroupIndicatorsByTrainRequestDto;
}>;


export type TrainByCarriagesIndicatorsByTrainQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', indicators_by_train: { __typename: 'CarriageGroupIndicatorsByTrainDto', schema?: { __typename: 'CarriageGroupIndicatorsSchemaDto', carriage_quantity_passenger: number, carriage_quantity_total: number, seats_quantity_passenger: number, seats_quantity_total?: number | null, seats_for_sale_passenger: number, seats_for_sale_total?: number | null, average_capacity_passenger: number, average_capacity_total?: number | null, carriage_quantity_req_passenger: number, carriage_quantity_req_total: number, items: Array<{ __typename: 'CarriageGroupIndicatorsSchemaItemDto', seat_type: string, carriage_type: string, carriage_quantity: number, seats_quantity: number, seats_for_sale: number, average_capacity: number, carriage_quantity_req: number }> } | null, park_required?: Array<{ __typename: 'MvpsParkRequiredDto', carriage_type: string, seat_type: string, departures_quantity?: number | null, equipment: string, carriage_quantity: number } | { __typename: 'NpsParkRequiredDto', seat_type: string, departures_quantity?: number | null, carriage_type: string }> | null, items: Array<{ __typename: 'IndicatorsByTrainSeatsDepartureQuantityDto', train_info: { __typename: 'IndicatorsByTrainTrainInfoDto', train_number: string, distance: number, departures_quantity: number }, carriage_departures_quantity: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_departures_quantity: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, carriage_schema_turnovers: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_schema_turnovers: { __typename: 'IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, carriage_required_turnovers: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_required_turnovers: { __typename: 'IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } }>, total: { __typename: 'IndicatorsByTrainSeatsDepartureQuantityTotalDto', train_info: { __typename: 'IndicatorsByTrainSeatsDepartureQuantityTotalTrainInfoDto', distance: number, departures_quantity: number }, carriage_departures_quantity: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_departures_quantity: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, carriage_schema_turnovers: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_schema_turnovers: { __typename: 'IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, carriage_required_turnovers: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> }, seats_required_turnovers: { __typename: 'IndicatorsByTrainSeatsDepartureQuantitySeatsTurnoverDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } } } } };

export type TrainByCarriagesIndicatorsCarriageGroupListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageGroupQueryResolver_CarriageGroupList_SortingInputType> | CarriageGroupQueryResolver_CarriageGroupList_SortingInputType>;
  where?: InputMaybe<CarriageGroupQueryResolver_CarriageGroupList_FilterInputType>;
  search: Scalars['String']['input'];
}>;


export type TrainByCarriagesIndicatorsCarriageGroupListQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', carriageGroupList: { __typename: 'CarriageGroupList', items: Array<{ __typename: 'CarriageGroupViewDto', id?: number | null }> } } };

export type CarriageGroupFinalIndicatorsExportMutationVariables = Exact<{
  where: IndicatorsMutationResolver_ExportTrainByGroupsFinalIndicators_FilterInputType;
}>;


export type CarriageGroupFinalIndicatorsExportMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', export_train_by_groups_final_indicators?: any | null } };

export type IndicatorsTrainListViewQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<IndicatorsQueryResolver_ListTrains_SortingInputType> | IndicatorsQueryResolver_ListTrains_SortingInputType>;
  where?: InputMaybe<IndicatorsQueryResolver_ListTrains_FilterInputType>;
}>;


export type IndicatorsTrainListViewQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', list_trains: { __typename: 'IndicatorsTrainList', totalCount: number, items: Array<{ __typename: 'IndicatorsTrainDto', train_id: number, train_number: string, from_station: string, to_station: string, status: string, start_at: string, end_at: string, route_duration: number, railway_administration?: string | null, passenger_carrier_russian_railway?: string | null, branch?: string | null, version: number }> } } };

export type TrainExportMutationVariables = Exact<{
  where: IndicatorsMutationResolver_ExportTrainFinalIndicators_FilterInputType;
}>;


export type TrainExportMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', export_train_final_indicators?: any | null } };

export type CarriageDistributionFragmentFragment = { __typename: 'TrainIndicatorsCarriagesDistributionDto', seats_quantity: number, seats_quantity_k: number, seats_quantity_o: number, seats_quantity_pl: number, seats_quantity_sv: number, carriages_distribution: Array<{ __typename: 'TrainIndicatorsCarriagesCountDto', carriage_number: string, carriage_service_class: Array<string>, carriage_type: string, seats_quantity?: number | null }> };

export type CarriageQuantityFragmentFragment = { __typename: 'CarriageQuantityMainGroupDto', trips_quantity: number, carriage_quantity: number, train_quantity: number, train_turnover: number, carriage_types: Array<{ __typename: 'CarriageGroupIndicatorsTypeParamsCountDto', carriage_type: string, quantity: number, seats_quantity: number, carriage_classes: Array<string> }> };

export type CompositionSchemaFragmentFragment = { __typename: 'CompositionSchemaDto', sign: string, carriage_group_id: number, train_numbers: Array<{ __typename: 'EmphasizedTrainItemDto', is_emphasized: boolean, train: { __typename: 'TrainDto', id: number, train_number: string } }>, route: Array<{ __typename: 'EmphasizedStationItemDto', is_emphasized: boolean, station: { __typename: 'StationDto', entity_id: number, full_name: string } }>, items: Array<{ __typename: 'CarriageGroupIndicatorsSchemaItemDto', seat_type: string, carriage_type: string, carriage_quantity: number, seats_quantity: number, seats_for_sale: number, average_capacity: number, carriage_quantity_req: number }>, passenger_carriages_total: { __typename: 'CompositionSchemaItemTotalDto', carriage_quantity?: number | null, seats_quantity?: number | null, seats_for_sale?: number | null, average_capacity?: number | null, carriage_quantity_req?: number | null }, carriages_total: { __typename: 'CompositionSchemaItemTotalDto', carriage_quantity?: number | null, seats_quantity?: number | null, seats_for_sale?: number | null, average_capacity?: number | null, carriage_quantity_req?: number | null } };

export type CruisingOrderFragmentFragment = { __typename: 'CruisingOrderDto', sign: string, train_numbers: Array<{ __typename: 'EmphasizedTrainItemDto', is_emphasized: boolean, train: { __typename: 'TrainDto', id: number, train_number: string } }>, route: Array<{ __typename: 'EmphasizedStationItemDto', is_emphasized: boolean, station: { __typename: 'StationDto', entity_id: number, full_name: string } }>, items: Array<{ __typename: 'CruisingOrderItemDto', train_number: string, distance: number, station_train_from: { __typename: 'StationDto', entity_id: number, full_name: string }, station_train_to: { __typename: 'StationDto', entity_id: number, full_name: string }, station_carriage_group_from: { __typename: 'StationDto', entity_id: number, full_name: string }, station_carriage_group_to: { __typename: 'StationDto', entity_id: number, full_name: string } }> };

export type EmphasizedStationItemFragmentFragment = { __typename: 'EmphasizedStationItemDto', is_emphasized: boolean, station: { __typename: 'StationDto', entity_id: number, full_name: string } };

export type EmphasizedTrainItemFragmentFragment = { __typename: 'EmphasizedTrainItemDto', is_emphasized: boolean, train: { __typename: 'TrainDto', id: number, train_number: string } };

export type IndicatorsByTrainCarriageTypesFragmentFragment = { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> };

export type IndicatorsByTrainCarriageTypesOmitTotalFragmentFragment = { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> };

export type TrainIndicatorsHeaderTrainFragmentFragment = { __typename: 'TrainDto', train_number: string, route_duration: number, individual_name: string, periodicity?: string | null, status: string, version: number, entity_id: number, gdp: { __typename: 'GdpDto', start_at: string, end_at: string }, from_station: { __typename: 'StationDto', entity_id: number, full_name: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string }, branch?: { __typename: 'BranchDto', entity_id: number, name: string } | null, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, name: string, short_name: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string } };

export type TrainIndicatorsHeaderFragmentFragment = { __typename: 'TrainIndicatorsHeaderDto', train_quantity?: number | null, structural_subdivision_id?: number | null, rolling_stock_type: string, trips_quantity: number, train_schema_ids: Array<number>, distance: number, structural_subdivision?: { __typename: 'MvpsCompanyAffiliationDto', entity_id: number, mvps_owner: string } | { __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string, station: { __typename: 'StationDto', full_name: string, express_code: string } } | null, train: { __typename: 'TrainDto', train_number: string, route_duration: number, individual_name: string, periodicity?: string | null, status: string, version: number, entity_id: number, gdp: { __typename: 'GdpDto', start_at: string, end_at: string }, from_station: { __typename: 'StationDto', entity_id: number, full_name: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string }, branch?: { __typename: 'BranchDto', entity_id: number, name: string } | null, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, name: string, short_name: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string } } };

export type TrainPerformanceIndicatorsSchemaItemFragmentFragment = { __typename: 'TrainPerformanceIndicatorsSchemaItemDto', turnover_ids: Array<number>, sign: string, carriage_group_turnover?: number | null, carriage_group_in_train_turnover?: number | null, carriage_group_distance?: number | null, carriage_group_in_train_distance?: number | null, departures_quantity?: number | null, train_numbers: Array<{ __typename: 'EmphasizedTrainItemDto', is_emphasized: boolean, train: { __typename: 'TrainDto', id: number, train_number: string } }>, route: Array<{ __typename: 'EmphasizedStationItemDto', is_emphasized: boolean, station: { __typename: 'StationDto', entity_id: number, full_name: string } }>, seats_proposed?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_req_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_req_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_express_forecast?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_sent?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_infrastructure_forecast?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_req_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_req_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_express?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null };

export type TrainPerformanceIndicatorsSchemaTotalFragmentFragment = { __typename: 'TrainPerformanceIndicatorsSchemaTotal', departures_quantity?: number | null, carriage_group_in_train_distance?: number | null, carriage_group_distance?: number | null, carriage_group_in_train_turnover?: number | null, carriage_group_turnover?: number | null, title: string, train_quantity?: number | null, train_turnover?: number | null, seats_proposed?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_req_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_req_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_express_forecast?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_sent?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_infrastructure_forecast?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_req_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_req_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_express?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null };

export type SchemasListForIndicatorsViewQueryVariables = Exact<{
  trainId: Scalars['Float']['input'];
}>;


export type SchemasListForIndicatorsViewQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', byId: { __typename: 'TrainDto', id: number, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number }> | null, gdp: { __typename: 'GdpDto', start_at: string, end_at: string } } } };

export type TrainIndicatorsForSchemaViewQueryVariables = Exact<{
  trainId: Scalars['Int']['input'];
  schemaId: Scalars['Int']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  isArrival: Scalars['Boolean']['input'];
}>;


export type TrainIndicatorsForSchemaViewQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', train_indicators_for_schema: { __typename: 'TrainIndicatorsDto', train_performance_indicators: { __typename: 'TrainPerformanceIndicators', items: Array<{ __typename: 'TrainPerformanceIndicatorsSchemaItemDto', turnover_ids: Array<number>, sign: string, carriage_group_turnover?: number | null, carriage_group_in_train_turnover?: number | null, carriage_group_distance?: number | null, carriage_group_in_train_distance?: number | null, departures_quantity?: number | null, train_numbers: Array<{ __typename: 'EmphasizedTrainItemDto', is_emphasized: boolean, train: { __typename: 'TrainDto', id: number, train_number: string } }>, route: Array<{ __typename: 'EmphasizedStationItemDto', is_emphasized: boolean, station: { __typename: 'StationDto', entity_id: number, full_name: string } }>, seats_proposed?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_req_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_req_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_express_forecast?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_sent?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_infrastructure_forecast?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_req_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_req_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_express?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null }>, total: Array<{ __typename: 'TrainPerformanceIndicatorsSchemaTotal', departures_quantity?: number | null, carriage_group_in_train_distance?: number | null, carriage_group_distance?: number | null, carriage_group_in_train_turnover?: number | null, carriage_group_turnover?: number | null, title: string, train_quantity?: number | null, train_turnover?: number | null, seats_proposed?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_req_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_req_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_express_forecast?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_sent?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_infrastructure_forecast?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_req_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_req_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_express?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null }> }, park_required?: Array<{ __typename: 'MvpsParkRequiredDto' } | { __typename: 'NpsParkRequiredDto', seat_type: string, departures_quantity?: number | null, carriage_type: string }> | null, composition_schema: Array<{ __typename: 'CompositionSchemaDto', sign: string, carriage_group_id: number, train_numbers: Array<{ __typename: 'EmphasizedTrainItemDto', is_emphasized: boolean, train: { __typename: 'TrainDto', id: number, train_number: string } }>, route: Array<{ __typename: 'EmphasizedStationItemDto', is_emphasized: boolean, station: { __typename: 'StationDto', entity_id: number, full_name: string } }>, items: Array<{ __typename: 'CarriageGroupIndicatorsSchemaItemDto', seat_type: string, carriage_type: string, carriage_quantity: number, seats_quantity: number, seats_for_sale: number, average_capacity: number, carriage_quantity_req: number }>, passenger_carriages_total: { __typename: 'CompositionSchemaItemTotalDto', carriage_quantity?: number | null, seats_quantity?: number | null, seats_for_sale?: number | null, average_capacity?: number | null, carriage_quantity_req?: number | null }, carriages_total: { __typename: 'CompositionSchemaItemTotalDto', carriage_quantity?: number | null, seats_quantity?: number | null, seats_for_sale?: number | null, average_capacity?: number | null, carriage_quantity_req?: number | null } }>, cruising_order: Array<{ __typename: 'CruisingOrderDto', sign: string, train_numbers: Array<{ __typename: 'EmphasizedTrainItemDto', is_emphasized: boolean, train: { __typename: 'TrainDto', id: number, train_number: string } }>, route: Array<{ __typename: 'EmphasizedStationItemDto', is_emphasized: boolean, station: { __typename: 'StationDto', entity_id: number, full_name: string } }>, items: Array<{ __typename: 'CruisingOrderItemDto', train_number: string, distance: number, station_train_from: { __typename: 'StationDto', entity_id: number, full_name: string }, station_train_to: { __typename: 'StationDto', entity_id: number, full_name: string }, station_carriage_group_from: { __typename: 'StationDto', entity_id: number, full_name: string }, station_carriage_group_to: { __typename: 'StationDto', entity_id: number, full_name: string } }> }>, carriage_quantity: { __typename: 'CarriageQuantityMainGroupDto', trips_quantity: number, carriage_quantity: number, train_quantity: number, train_turnover: number, carriage_types: Array<{ __typename: 'CarriageGroupIndicatorsTypeParamsCountDto', carriage_type: string, quantity: number, seats_quantity: number, carriage_classes: Array<string> }> }, header: { __typename: 'TrainIndicatorsHeaderDto', train_quantity?: number | null, structural_subdivision_id?: number | null, rolling_stock_type: string, trips_quantity: number, train_schema_ids: Array<number>, distance: number, structural_subdivision?: { __typename: 'MvpsCompanyAffiliationDto', entity_id: number, mvps_owner: string } | { __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string, station: { __typename: 'StationDto', full_name: string, express_code: string } } | null, train: { __typename: 'TrainDto', train_number: string, route_duration: number, individual_name: string, periodicity?: string | null, status: string, version: number, entity_id: number, gdp: { __typename: 'GdpDto', start_at: string, end_at: string }, from_station: { __typename: 'StationDto', entity_id: number, full_name: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string }, branch?: { __typename: 'BranchDto', entity_id: number, name: string } | null, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, name: string, short_name: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string } } }, carriages_distribution: { __typename: 'TrainIndicatorsCarriagesDistributionDto', seats_quantity: number, seats_quantity_k: number, seats_quantity_o: number, seats_quantity_pl: number, seats_quantity_sv: number, carriages_distribution: Array<{ __typename: 'TrainIndicatorsCarriagesCountDto', carriage_number: string, carriage_service_class: Array<string>, carriage_type: string, seats_quantity?: number | null }> } } } };

export type TrainIndicatorsTotalQueryVariables = Exact<{
  trainId: Scalars['Int']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  isArrival: Scalars['Boolean']['input'];
}>;


export type TrainIndicatorsTotalQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', train_indicators_total: Array<{ __typename: 'TrainPerformanceIndicatorsSchemaTotalDto', departures_quantity?: number | null, carriage_group_in_train_distance?: number | null, carriage_group_distance?: number | null, carriage_group_in_train_turnover?: number | null, carriage_group_turnover?: number | null, title: string, train_quantity?: number | null, train_turnover?: number | null, seats_turnover_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_proposed?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_req_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, seats_turnover_req_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesOmitTotalDto', passenger_carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_express_forecast?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_sent?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_infrastructure_forecast?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_req_carriage_group_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, carriages_turnover_req_train_route?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null, average_composition_express?: { __typename: 'IndicatorsByTrainCarriageTypesDto', passenger_carriages_total: number, carriages_total: number, carriage_departures: Array<{ __typename: 'IndicatorsByTrainCarriagesDto', seat_type: string, carriage_type: string, departures_quantity?: number | null }> } | null }> } };

export type LocomotiveAreaTrainListQueryVariables = Exact<{
  where?: InputMaybe<TrainQueryResolver_LocomotiveServiceList_FilterInputType>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainQueryResolver_LocomotiveServiceList_SortingInputType> | TrainQueryResolver_LocomotiveServiceList_SortingInputType>;
}>;


export type LocomotiveAreaTrainListQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', locomotiveServiceList: { __typename: 'LocomotiveServiceList', totalCount: number, items: Array<{ __typename: 'LocomotiveServiceDto', id: number, train_number: string, start_at: string, end_at: string, version: number, status: string, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, code: number }, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, locomotive_traction_types: Array<{ __typename: 'LocomotiveTractionTypeDto', id: number, name: string, short_name: string }>, traction_directorates: Array<{ __typename: 'TractionDirectorateDto', id: number, entity_id: number, start_at: string, end_at: string, name: string, short_name: string, is_not_in_calculation: boolean }>, traction_directorate_teams: Array<{ __typename: 'TractionDirectorateDto', id: number, entity_id: number, start_at: string, end_at: string, name: string, short_name: string, is_not_in_calculation: boolean }>, gdp: { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string } }> } } };

export type LocomotiveTractionTypeListForLocomotivesViewQueryVariables = Exact<{ [key: string]: never; }>;


export type LocomotiveTractionTypeListForLocomotivesViewQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotiveTractionType: { __typename: 'LocomotiveTractionTypeQueryEntryPoint', list: { __typename: 'LocomotiveTractionTypeList', totalCount: number, items: Array<{ __typename: 'LocomotiveTractionTypeDto', id: number, name: string }> } } } };

export type TractionDirectorateListForLocomotiveAreaListViewQueryVariables = Exact<{
  range: RangeInputDto;
}>;


export type TractionDirectorateListForLocomotiveAreaListViewQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', tractionDirectorate: { __typename: 'TractionDirectorateQueryEntryPoint', list: { __typename: 'TractionDirectorateList', items: Array<{ __typename: 'TractionDirectorateDto', id: number, name: string }> } } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename: 'Mutation', authentication: { __typename: 'AuthenticationMutationEntryPoint', singOut?: any | null } };

export type DashboardInfoQueryVariables = Exact<{
  data: DashboardDataDto;
}>;


export type DashboardInfoQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', getDashboard: { __typename: 'DashboardDto', created_at: string, status: string, gdp: { __typename: 'GdpDto', id: number }, fpk_trains: { __typename: 'FpkTrainsDto', season_train_every_year: { __typename: 'TotalTrainDto', pairs_count: number, main_train_ids: Array<number>, into_train_info: { __typename: 'IntoTrainInfoDto', brand_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, daytime_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, fast_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, international_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, interstate_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, kri_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, mvps_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, southbound_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, tpr_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, vr_kb_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number } } }, season_train_other: { __typename: 'TotalTrainDto', pairs_count: number, main_train_ids: Array<number>, into_train_info: { __typename: 'IntoTrainInfoDto', brand_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, daytime_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, fast_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, international_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, interstate_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, kri_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, mvps_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, southbound_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, tpr_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, vr_kb_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number } } }, season_train_season: { __typename: 'TotalTrainDto', pairs_count: number, main_train_ids: Array<number>, into_train_info: { __typename: 'IntoTrainInfoDto', brand_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, daytime_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, fast_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, international_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, interstate_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, kri_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, mvps_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, southbound_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, tpr_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, vr_kb_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number } } }, total_trains: { __typename: 'TotalTrainDto', pairs_count: number, main_train_ids: Array<number>, into_train_info: { __typename: 'IntoTrainInfoDto', brand_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, daytime_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, fast_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, international_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, interstate_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, kri_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, mvps_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, southbound_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, tpr_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, vr_kb_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number } } } }, other_trains: { __typename: 'RestTotalTrainsDto', total_trains_pair: { __typename: 'RestTrainDto', entity_rus_name: string, main_train_ids: Array<number>, pairs_count: number, trains_pair_array: Array<{ __typename: 'TrainPairsDashboardDto', entity_rus_name: string, main_train_ids: Array<number>, pairs_count: number }> }, far_abroad_trains_pair: { __typename: 'RestTrainDto', main_train_ids: Array<number>, pairs_count: number, trains_pair_array: Array<{ __typename: 'TrainPairsDashboardDto', entity_rus_name: string, main_train_ids: Array<number>, pairs_count: number }> }, other_trains_pair: { __typename: 'RestTrainDto', main_train_ids: Array<number>, pairs_count: number, trains_pair_array: Array<{ __typename: 'TrainPairsDashboardDto', entity_rus_name: string, main_train_ids: Array<number>, pairs_count: number }> }, sng_trains_pair: { __typename: 'RestTrainDto', main_train_ids: Array<number>, entity_rus_name: string, pairs_count: number, trains_pair_array: Array<{ __typename: 'TrainPairsDashboardDto', entity_rus_name: string, main_train_ids: Array<number>, pairs_count: number }> } }, branches_trains: { __typename: 'BranchesTrainsDto', pairs_count: Array<{ __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, entity_rus_name: string, pairs_count: number }>, subdivisions: Array<{ __typename: 'SubdivisionsDto', entity_rus_name: string, ids: Array<number>, count: number, lvch_count: number, lvchd_count: number }> } } } };

export type DashboardTrainFragmentFragment = { __typename: 'NewTrainDto', version: number, parent_id?: number | null, status: string, id: number, train_number: string, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, code: number } };

export type DashboardTrainsListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainQueryResolver_NewList_SortingInputType> | TrainQueryResolver_NewList_SortingInputType>;
  where?: InputMaybe<TrainQueryResolver_NewList_FilterInputType>;
  is_including_expired_versions: Scalars['Boolean']['input'];
}>;


export type DashboardTrainsListQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', newList: { __typename: 'NewTrainList', totalCount: number, items: Array<{ __typename: 'NewTrainDto', version: number, parent_id?: number | null, status: string, id: number, train_number: string, pair_train?: { __typename: 'NewTrainDto', version: number, parent_id?: number | null, status: string, id: number, train_number: string, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, code: number } } | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, code: number } }> } } };

export type FpkTrainTotalTrainFragmentFragment = { __typename: 'TotalTrainDto', pairs_count: number, main_train_ids: Array<number>, into_train_info: { __typename: 'IntoTrainInfoDto', brand_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, daytime_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, fast_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, international_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, interstate_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, kri_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, mvps_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, southbound_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, tpr_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number }, vr_kb_trains_pair: { __typename: 'TrainPairsDashboardDto', main_train_ids: Array<number>, pairs_count: number } } };

export type DashboardStructuralSubdivisionListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<StructuralSubdivisionQueryResolver_List_SortingInputType> | StructuralSubdivisionQueryResolver_List_SortingInputType>;
  where?: InputMaybe<StructuralSubdivisionQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type DashboardStructuralSubdivisionListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', structuralSubdivision: { __typename: 'StructuralSubdivisionQueryEntryPoint', list: { __typename: 'StructuralSubdivisionList', totalCount: number, items: Array<{ __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string, station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> } } } };

export type NewsListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  order_by?: InputMaybe<Array<CmsQueryResolver_NewsList_SortingInputType> | CmsQueryResolver_NewsList_SortingInputType>;
  where?: InputMaybe<CmsQueryResolver_NewsList_FilterInputType>;
}>;


export type NewsListQuery = { __typename: 'Query', cms: { __typename: 'CmsQueryEntryPoint', news_list: { __typename: 'NewsList', totalCount: number, items: Array<{ __typename: 'NewsDto', id: number, title: string, created_at: string, updated_at: string, content?: string | null }> } } };

export type ClearUserConfigurationMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearUserConfigurationMutation = { __typename: 'Mutation', configuration: { __typename: 'ConfigurationMutationEntryPoint', user_configuration_update?: { __typename: 'UsersConfigDto', id: number } | null } };

export type MeJournalActionAuditQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<JournalQueryResolver_MeActionAudit_FilterInputType>;
  orderBy?: InputMaybe<Array<JournalQueryResolver_MeActionAudit_SortingInputType> | JournalQueryResolver_MeActionAudit_SortingInputType>;
}>;


export type MeJournalActionAuditQuery = { __typename: 'Query', journal: { __typename: 'JournalQueryEntryPoint', me_action_audit: { __typename: 'UserActionAuditList', totalCount: number, items: Array<{ __typename: 'UserActionAuditDto', id: number, created_at: string, action: string, target: string }> } } };

export type MeSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type MeSessionQuery = { __typename: 'Query', users: { __typename: 'UsersQueryEntryPoint', me_sessions: { __typename: 'SessionInformationList', totalCount: number, items: Array<{ __typename: 'SessionInformationDto', sid: string, browser: string, ip: string, os: string, date: string }> } } };

export type TerminateSessionForMeMutationVariables = Exact<{
  sid: Scalars['String']['input'];
}>;


export type TerminateSessionForMeMutation = { __typename: 'Mutation', users: { __typename: 'UsersMutationEntryPoint', terminate_session_for_me?: any | null } };

export type SignInMutationVariables = Exact<{
  data: SignInRequestDto;
}>;


export type SignInMutation = { __typename: 'Mutation', authentication: { __typename: 'AuthenticationMutationEntryPoint', signIn: { __typename: 'TokenResponseDto', refreshToken: string, accessTokenExpTimestamp: number } } };

export type InfrastructureCalculationByBranchBaseFragmentFragment = { __typename: 'InfrastructureCalculationByBranchDto', total: { __typename: 'InfrastructureCalculationByBranchRowDto', carriagesDistancePassengerTotal?: number | null, carriagesDistanceTotal?: number | null, distance?: number | null, name: string, totalWithNds?: number | null, tripsQuantity?: number | null }, items: Array<{ __typename: 'InfrastructureCalculationByBranchRowDto', carriagesDistancePassengerTotal?: number | null, carriagesDistanceTotal?: number | null, distance?: number | null, name: string, totalWithNds?: number | null, tripsQuantity?: number | null }> };

export type InfrastructureCalculationByBranchRowBaseFragmentFragment = { __typename: 'InfrastructureCalculationByBranchRowDto', carriagesDistancePassengerTotal?: number | null, carriagesDistanceTotal?: number | null, distance?: number | null, name: string, totalWithNds?: number | null, tripsQuantity?: number | null };

export type InfrastructureCalculationsByBranchRequestMutationVariables = Exact<{
  where?: InputMaybe<IndicatorsMutationResolver_InfrastructureCalculationsByBranch_FilterInputType>;
}>;


export type InfrastructureCalculationsByBranchRequestMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', infrastructure_calculations_by_branch?: any | null } };

export type InfrastructureCalculationsByBranchResponseQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type InfrastructureCalculationsByBranchResponseQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', infrastructure_calculations_by_branch_response: { __typename: 'InfrastructureCalculationByBranchDto', total: { __typename: 'InfrastructureCalculationByBranchRowDto', carriagesDistancePassengerTotal?: number | null, carriagesDistanceTotal?: number | null, distance?: number | null, name: string, totalWithNds?: number | null, tripsQuantity?: number | null }, items: Array<{ __typename: 'InfrastructureCalculationByBranchRowDto', carriagesDistancePassengerTotal?: number | null, carriagesDistanceTotal?: number | null, distance?: number | null, name: string, totalWithNds?: number | null, tripsQuantity?: number | null }> } } };

export type LocomotiveFinalCalculationsByDirectoratesItemBaseFragmentFragment = { __typename: 'locomotiveFinalCalculationsByDirectoratesItemDto', gas_price: number, locomotive_cost: number, locomotive_rent_cost: number, locomotive_tech_service_price: number, name: string, power_price: number, team_cost: number, total_cost: number };

export type LocomotiveFinalCalculationsMutationVariables = Exact<{
  data: LocomotiveFinalCalculationsByDirectoratesRequestDto;
  where?: InputMaybe<TrainMutationResolver_LocomotiveFinalCalculationsByDirectorates_FilterInputType>;
}>;


export type LocomotiveFinalCalculationsMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', locomotive_final_calculations_by_directorates_request?: any | null } };

export type LocomotiveFinalCalculationsResponseQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type LocomotiveFinalCalculationsResponseQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', locomotive_final_calculations_by_directorates_response: { __typename: 'LocomotiveFinalCalculationsByDirectoratesDto', items: Array<{ __typename: 'locomotiveFinalCalculationsByDirectoratesItemDto', gas_price: number, locomotive_cost: number, locomotive_rent_cost: number, locomotive_tech_service_price: number, name: string, power_price: number, team_cost: number, total_cost: number }>, total: { __typename: 'locomotiveFinalCalculationsByDirectoratesItemDto', gas_price: number, locomotive_cost: number, locomotive_rent_cost: number, locomotive_tech_service_price: number, name: string, power_price: number, team_cost: number, total_cost: number } } } };

export type MvpsCalculationByBranchBaseFragmentFragment = { __typename: 'MvpsCalculationByBranchDto', total_by_branch: { __typename: 'MvpsCalculationByBranchItemDto', branch: string, control_total?: number | null, distance: number, rent_total: number, route_duration?: number | null, to_tr_total: number, total: number }, items_by_branch: Array<{ __typename: 'MvpsCalculationByBranchItemDto', branch: string, control_total?: number | null, distance: number, rent_total: number, route_duration?: number | null, to_tr_total: number, total: number }> };

export type MvpsCalculationByBranchItemBaseFragmentFragment = { __typename: 'MvpsCalculationByBranchItemDto', branch: string, control_total?: number | null, distance: number, rent_total: number, route_duration?: number | null, to_tr_total: number, total: number };

export type MvpsCalculationsByBranchRequestMutationVariables = Exact<{
  where?: InputMaybe<IndicatorsMutationResolver_MvpsCalculationsByBranchRequest_FilterInputType>;
  paginate?: InputMaybe<PaginatorArgsDto>;
}>;


export type MvpsCalculationsByBranchRequestMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', mvps_calculations_by_branch_request?: any | null } };

export type MvpsCalculationsByBranchResponseQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type MvpsCalculationsByBranchResponseQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', mvps_calculations_by_branch_response: { __typename: 'MvpsCalculationByBranchDto', total_by_branch: { __typename: 'MvpsCalculationByBranchItemDto', branch: string, control_total?: number | null, distance: number, rent_total: number, route_duration?: number | null, to_tr_total: number, total: number }, items_by_branch: Array<{ __typename: 'MvpsCalculationByBranchItemDto', branch: string, control_total?: number | null, distance: number, rent_total: number, route_duration?: number | null, to_tr_total: number, total: number }> } } };

export type FinalCalculationsTotalRowBaseFragmentFragment = { __typename: 'FinalCalculationsTotalRowDto', average_composition_total: number, average_composition_total_passenger: number, average_composition_dereg: number, average_composition_reg: number, average_composition_other: number, train_quantity: number, train_distance: number, carriage_distance_total: number, carriage_distance_total_passenger: number, carriage_distance_dereg: number, carriage_distance_reg: number, carriage_distance_other: number, seats_distance_total: number, seats_distance_dereg: number, seats_distance_reg: number };

export type TrainFinalCalculationMvpsCompanyAffiliationListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<MvpsCompanyAffiliationQueryResolver_List_SortingInputType> | MvpsCompanyAffiliationQueryResolver_List_SortingInputType>;
  where?: InputMaybe<MvpsCompanyAffiliationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type TrainFinalCalculationMvpsCompanyAffiliationListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mvpsCompanyAffiliation: { __typename: 'MvpsCompanyAffiliationQueryEntryPoint', list: { __typename: 'MvpsCompanyAffiliationDtoList', totalCount: number, items: Array<{ __typename: 'MvpsCompanyAffiliationDto', entity_id: number, mvps_owner: string, start_at: string }> } } } };

export type TrainFinalCalculationStructuralSubdivisionListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<StructuralSubdivisionQueryResolver_List_SortingInputType> | StructuralSubdivisionQueryResolver_List_SortingInputType>;
  where?: InputMaybe<StructuralSubdivisionQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type TrainFinalCalculationStructuralSubdivisionListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', structuralSubdivision: { __typename: 'StructuralSubdivisionQueryEntryPoint', list: { __typename: 'StructuralSubdivisionList', totalCount: number, items: Array<{ __typename: 'StructuralSubdivisionDto', entity_id: number, short_name: string, branch: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string, railways: Array<{ __typename: 'RailwayDto', entity_id: number, code: string, name: string, short_name: string, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null } }> }, station: { __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null, railway: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null } } } }> } } } };

export type CarriageGroupsFinalCalculationsMutationVariables = Exact<{
  data: CarriageGroupIndicatorsFinalCalculationRequestDto;
  where?: InputMaybe<IndicatorsMutationResolver_CarriageGroupsFinalCalculations_FilterInputType>;
}>;


export type CarriageGroupsFinalCalculationsMutation = { __typename: 'Mutation', indicators: { __typename: 'IndicatorsMutationEntryPoint', carriage_groups_final_calculations?: any | null } };

export type CarriageGroupsFinalCalculationsResponseQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type CarriageGroupsFinalCalculationsResponseQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', carriage_groups_final_calculations_response: { __typename: 'FinalCalculationsTotalDto', items: Array<{ __typename: 'FinalCalculationsTotalBranchDto', name: string, items: Array<{ __typename: 'FinalCalculationsTotalSubdivisionDto', name: string, total: { __typename: 'FinalCalculationsTotalRowDto', average_composition_total: number, average_composition_total_passenger: number, average_composition_dereg: number, average_composition_reg: number, average_composition_other: number, train_quantity: number, train_distance: number, carriage_distance_total: number, carriage_distance_total_passenger: number, carriage_distance_dereg: number, carriage_distance_reg: number, carriage_distance_other: number, seats_distance_total: number, seats_distance_dereg: number, seats_distance_reg: number } }>, total: { __typename: 'FinalCalculationsTotalRowDto', average_composition_total: number, average_composition_total_passenger: number, average_composition_dereg: number, average_composition_reg: number, average_composition_other: number, train_quantity: number, train_distance: number, carriage_distance_total: number, carriage_distance_total_passenger: number, carriage_distance_dereg: number, carriage_distance_reg: number, carriage_distance_other: number, seats_distance_total: number, seats_distance_dereg: number, seats_distance_reg: number } }>, total: { __typename: 'FinalCalculationsTotalRowDto', average_composition_total: number, average_composition_total_passenger: number, average_composition_dereg: number, average_composition_reg: number, average_composition_other: number, train_quantity: number, train_distance: number, carriage_distance_total: number, carriage_distance_total_passenger: number, carriage_distance_dereg: number, carriage_distance_reg: number, carriage_distance_other: number, seats_distance_total: number, seats_distance_dereg: number, seats_distance_reg: number } } } };

export type CreateTrailedDirectGroupMutationVariables = Exact<{
  data: CreateTrailedDirectGroupDto;
}>;


export type CreateTrailedDirectGroupMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', createTrailedDirectGroup: number } };

export type CreateTrailedDirectGroupCarriageGroupListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageGroupQueryResolver_CarriageGroupList_SortingInputType> | CarriageGroupQueryResolver_CarriageGroupList_SortingInputType>;
  where?: InputMaybe<CarriageGroupQueryResolver_CarriageGroupList_FilterInputType>;
  search: Scalars['String']['input'];
}>;


export type CreateTrailedDirectGroupCarriageGroupListQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', carriageGroupList: { __typename: 'CarriageGroupList', totalCount: number, items: Array<{ __typename: 'CarriageGroupViewDto', id?: number | null, name?: string | null, status?: string | null }> } } };

export type DeleteTrailedDirectGroupMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteTrailedDirectGroupMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', deleteTrailedDirectGroup?: any | null } };

export type ExportTrailedDirectGroupListMutationVariables = Exact<{
  where: CarriageGroupMutationResolver_ExportTrailedDirectGroupsList_FilterInputType;
}>;


export type ExportTrailedDirectGroupListMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', exportTrailedDirectGroupsList?: any | null } };

export type TrailedDirectGroupCarriageGroupByIdQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrailedDirectGroupCarriageGroupByIdQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', carriageGroupById: { __typename: 'CarriageGroupDto', id: number, status: string, step_status: string, is_lock: boolean, is_manual_trip_formation_for_schema: boolean, name: string, rolling_stock_type: string, parent_id?: number | null, version: number, start_at: string, end_at: string, turnovers: Array<{ __typename: 'TurnoverDto', id: number, accepted_train_schemas_ids?: Array<number> | null, arrival_dates: Array<string>, arrival_dates_with_time_stagnation: Array<string>, departure_dates: Array<string>, group_sign: string, is_pbg: boolean, is_schemas_accepted: boolean, is_start_position_for_sale_direct_tickets: boolean, is_time_stagnation_variable: boolean, is_turnover_station_for_schema: boolean, order_number: number, position: string, seats_for_sale?: number | null, seats_total?: number | null, station_from: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, station_to: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, train: { __typename: 'TrainDto', is_carriage_group_approval: boolean, id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number } | null }, schemas: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number }>, turnover_time_stagnations: Array<{ __typename: 'TurnoverTimeStagnationDto', id: number, created_at: string, created_by?: number | null, updated_at: string, updated_by?: number | null, time_in_stagnation: number, arrival_dates: Array<string> }> }> } } };

export type TrailedDirectGroupByIdQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrailedDirectGroupByIdQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', trailedDirectGroupById: { __typename: 'TrailedDirectGroupResponseDto', status: string, rolling_stock_type: string, carriage_group_id: number, parent_id?: number | null, schedule: { __typename: 'TrailedDirectGroupScheduleDto', direct_time_total: number, reverse_time_total: number }, route_details: { __typename: 'TrailedDirectGroupRouteDetailsDto', direct: Array<{ __typename: 'TrailedDirectGroupRouteDetailsItemDto', train_id: number, train_number: string, station_from: string, station_to: string, position: string }>, reverse: Array<{ __typename: 'TrailedDirectGroupRouteDetailsItemDto', train_id: number, train_number: string, station_from: string, station_to: string, position: string }> }, gdp?: { __typename: 'GdpDto', id: number, start_at: string, end_at: string } | null } } };

export type TrailedDirectGroupDefaultFilterQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrailedDirectGroupDefaultFilterQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', trailedDirectGroupById: { __typename: 'TrailedDirectGroupResponseDto', carriage_group_id: number, rolling_stock_type: string, gdp?: { __typename: 'GdpDto', id: number, start_at: string, end_at: string } | null } } };

export type TrailedDirectGroupListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  where?: InputMaybe<CarriageGroupQueryResolver_TrailedDirectGroupList_FilterInputType>;
  search: Scalars['String']['input'];
  orderBy?: InputMaybe<Array<CarriageGroupQueryResolver_TrailedDirectGroupList_SortingInputType> | CarriageGroupQueryResolver_TrailedDirectGroupList_SortingInputType>;
}>;


export type TrailedDirectGroupListQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', trailedDirectGroupList: { __typename: 'TrailedDirectGroupResponseList', totalCount: number, items: Array<{ __typename: 'TrailedDirectGroupListItemResponseDto', carriages_total: number, parent_id?: number | null, id: number, direct: { __typename: 'TrailedDirectGroupListItemFragmentDto', station_recouple: Array<string>, train_numbers: Array<string>, time_total: number, station_from: { __typename: 'StationResponseDto', entity_id: number, full_name: string }, station_to: { __typename: 'StationResponseDto', entity_id: number, full_name: string } }, reverse: { __typename: 'TrailedDirectGroupListItemFragmentDto', station_recouple: Array<string>, train_numbers: Array<string>, time_total: number, station_from: { __typename: 'StationResponseDto', entity_id: number, full_name: string }, station_to: { __typename: 'StationResponseDto', entity_id: number, full_name: string } }, carriage_group: { __typename: 'CarriageGroupDto', id: number, status: string, rolling_stock_type: string, railway_administration: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, code: number }, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, periodicities: Array<{ __typename: 'PeriodicityDto', id: number, periodicity: string }> }, carriage_type_params_count: Array<{ __typename: 'CarriageGroupCarriageTypeParamsCountDto', carriage_type: string, quantity: number }> }> } } };

export type TrailedDirectGroupsScheduleQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrailedDirectGroupsScheduleQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', trailedDirectGroupById: { __typename: 'TrailedDirectGroupResponseDto', schedule: { __typename: 'TrailedDirectGroupScheduleDto', direct_time_total: number, reverse_time_total: number, schedule_fragments: Array<{ __typename: 'TrailedDirectGroupScheduleFragmentDto', order_number: number, direct_train_number?: string | null, reverse_train_number?: string | null, direct_train_id?: number | null, reverse_train_id?: number | null, direct_arrival?: number | null, reverse_arrival?: number | null, direct_parking?: number | null, reverse_parking?: number | null, is_direct_schedule_technical_parking?: boolean | null, is_reverse_schedule_technical_parking?: boolean | null, direct_departure?: number | null, reverse_departure?: number | null, distance: number, reverse_train_number_from_schedule?: string | null, direct_train_number_from_schedule?: string | null, direct_train_stations?: string | null, reverse_train_stations?: string | null, station: { __typename: 'StationResponseDto', id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, railway_id: number, is_waste_collection: boolean, is_water_supply: boolean, is_traction_type: boolean, is_maneuver_work: boolean, railway?: { __typename: 'RailwayResponseDto', id: number, name: string } | null } }> } } } };

export type TrailedDirectGroupsSchemeQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrailedDirectGroupsSchemeQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', trailedDirectGroupById: { __typename: 'TrailedDirectGroupResponseDto', schema: { __typename: 'TrailedDirectGroupSchemaDto', parameters: Array<{ __typename: 'TrailedDirectGroupSchemaCarriageDto', carriage_number: string, carriage_type: string, turnover_points: Array<string>, seats_sv_total: number, seats_sv_allocated: number, seats_coupe_total: number, seats_coupe_allocated: number, seats_second_class_total: number, seats_second_class_allocated: number, seats_common_total: number, seats_common_allocated: number }>, summary: { __typename: 'TrailedDirectGroupSchemaSummaryDto', seats_sv_total: number, seats_sv_allocated: number, seats_coupe_total: number, seats_coupe_allocated: number, seats_second_class_total: number, seats_second_class_allocated: number, seats_common_total: number, seats_common_allocated: number, seats_summary_total: number, seats_summary_allocated: number }, additional_info: { __typename: 'TrailedDirectGroupSchemaAdditionalInfoDto', train_quantity?: number | null, structural_subdivision: string, brake_types?: Array<string> | null, heating_types?: Array<string> | null, eco_toilets?: string | null, air_conditioner?: string | null }, periodicity_info: Array<{ __typename: 'TrailedDirectGroupPeriodicityInfoDto', train_number: string, departure_dates: Array<string>, arrival_dates: Array<string>, from_station: string, to_station: string, is_direct: boolean }> } } } };

export type ExportTrailedDirectGroupCarriageGroupListMutationVariables = Exact<{
  where: CarriageGroupMutationResolver_ExportCarriageGroupsList_FilterInputType;
}>;


export type ExportTrailedDirectGroupCarriageGroupListMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', exportCarriageGroupsList?: any | null } };

export type TrailedDirectGroupCarriageGroupListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageGroupQueryResolver_CarriageGroupList_SortingInputType> | CarriageGroupQueryResolver_CarriageGroupList_SortingInputType>;
  where?: InputMaybe<CarriageGroupQueryResolver_CarriageGroupList_FilterInputType>;
  search: Scalars['String']['input'];
}>;


export type TrailedDirectGroupCarriageGroupListQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', carriageGroupList: { __typename: 'CarriageGroupList', totalCount: number, items: Array<{ __typename: 'CarriageGroupViewDto', id?: number | null, name?: string | null, branch_id?: number | null, passenger_carriers_id?: number | null, railway_administration_id?: number | null, structural_subdivision_id?: number | null, rolling_stock_type?: string | null, step_status?: string | null, status?: string | null, train_numbers?: Array<string> | null, train_statuses?: Array<string> | null, from_stations?: Array<string> | null, to_stations?: Array<string> | null, branch?: string | null, passenger_carrier?: string | null, railway_administration?: string | null, structural_subdivision?: string | null, min_train_quantity?: number | null, max_train_quantity?: number | null, min_turnaround_time?: number | null, max_turnaround_time?: number | null, carriage_dimension_ids?: Array<number> | null, train_ids?: Array<number> | null, dimensions?: string | null, carriage_types?: Array<string> | null, periodicity?: Array<string> | null, parent_id?: number | null, station_affiliation?: string | null, first_departure_date?: string | null, version: number, start_at: string, end_at: string }> } } };

export type TrainsPairForSchemesCompareHeaderFragmentFragment = { __typename: 'TrainDto', id: number, train_number: string, route_duration: number, departure_time?: string | null, arrival_time?: string | null, individual_name: string, version: number, start_at: string, status: string, periodicity?: string | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string }, periodicity_season?: { __typename: 'PeriodicitySeasonDto', entity_id: number, periodicity_season: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string }, sub_category?: { __typename: 'TrainSubCategoryDto', train_sub_category: string, background_color: string } | null, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, schedule?: { __typename: 'TrainScheduleDto', train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', id: number, direct_time_to_station: number, direct_departure?: number | null, direct_arrival?: number | null, reverse_departure?: number | null, reverse_arrival?: number | null, reverse_time_to_station?: number | null }> } | null };

export type TrainsPairForSchemesCompareHeaderQueryVariables = Exact<{
  trainId: Scalars['Float']['input'];
}>;


export type TrainsPairForSchemesCompareHeaderQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', id: number, train_number: string, route_duration: number, departure_time?: string | null, arrival_time?: string | null, individual_name: string, version: number, start_at: string, status: string, periodicity?: string | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string }, periodicity_season?: { __typename: 'PeriodicitySeasonDto', entity_id: number, periodicity_season: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string }, sub_category?: { __typename: 'TrainSubCategoryDto', train_sub_category: string, background_color: string } | null, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, schedule?: { __typename: 'TrainScheduleDto', train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', id: number, direct_time_to_station: number, direct_departure?: number | null, direct_arrival?: number | null, reverse_departure?: number | null, reverse_arrival?: number | null, reverse_time_to_station?: number | null }> } | null }, reverse?: { __typename: 'TrainDto', id: number, train_number: string, route_duration: number, departure_time?: string | null, arrival_time?: string | null, individual_name: string, version: number, start_at: string, status: string, periodicity?: string | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string }, periodicity_season?: { __typename: 'PeriodicitySeasonDto', entity_id: number, periodicity_season: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string }, sub_category?: { __typename: 'TrainSubCategoryDto', train_sub_category: string, background_color: string } | null, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, schedule?: { __typename: 'TrainScheduleDto', train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', id: number, direct_time_to_station: number, direct_departure?: number | null, direct_arrival?: number | null, reverse_departure?: number | null, reverse_arrival?: number | null, reverse_time_to_station?: number | null }> } | null } | null } } };

export type TrainSchemasListForSchemesCompareHeaderQueryVariables = Exact<{
  train1: Scalars['Int']['input'];
  train2: Scalars['Int']['input'];
}>;


export type TrainSchemasListForSchemesCompareHeaderQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', list: { __typename: 'TrainList', items: Array<{ __typename: 'TrainDto', id: number, train_number: string, route_duration: number, departure_time?: string | null, arrival_time?: string | null, individual_name: string, periodicity?: string | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string }, periodicity_season?: { __typename: 'PeriodicitySeasonDto', entity_id: number, periodicity_season: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string }, sub_category?: { __typename: 'TrainSubCategoryDto', train_sub_category: string, background_color: string } | null, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, schedule?: { __typename: 'TrainScheduleDto', train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', id: number, direct_time_to_station: number, direct_departure?: number | null, direct_arrival?: number | null, reverse_departure?: number | null }> } | null }> } } };

export type TrainsPairForCompareSchemesViewFragmentFragment = { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, periodicity_season?: { __typename: 'PeriodicitySeasonDto', entity_id: number, periodicity_season: string } | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number } | null, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number, is_main_group_exported_direct: boolean, is_main_group_exported_reverse: boolean, status: string, is_lock: boolean, train_brand_note?: string | null, allocation_note?: string | null, variable_stencil_info?: string | null, variable_stencil_note?: string | null, luxury_carriages_note?: string | null, luxury_carriages_non_branded_note?: string | null, service_class_note?: string | null, optional_carriages_note?: string | null, is_by_stations_max_train_length: boolean, is_by_stations_established_train_schema: boolean, direct_carriages_note?: string | null, trailed_carriages_note?: string | null, other_carriages_note?: string | null, is_build_due_to_main_train: boolean, locomotive_change?: Array<{ __typename: 'LocomotiveChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, locomotive_team_change?: Array<{ __typename: 'LocomotiveTeamChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, fuel_supply?: Array<{ __typename: 'FuelSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, border_control?: Array<{ __typename: 'BorderControlDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null } }> | null, eco_toilets?: Array<{ __typename: 'EcoToiletDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, water_supply?: Array<{ __typename: 'WaterSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, waste_collection?: Array<{ __typename: 'WasteCollectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, periodicity?: Array<{ __typename: 'PeriodicityInfoDto', id: number, departure_dates: Array<string>, arrival_dates: Array<string>, departure_dates_out_of_gdp: Array<string>, arrival_dates_out_of_gdp: Array<string>, train: { __typename: 'TrainDto', id: number, train_number: string } }> | null, carriage_numerations?: Array<{ __typename: 'CarriageNumerationDto', id: number, direct_position?: string | null, reverse_position?: string | null, description?: string | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, carriage_allocations?: Array<{ __typename: 'CarriageAllocationDto', id: number, carriage_number: string, seats: string, appointment: string, description?: string | null }> | null, carriage_classes?: Array<{ __typename: 'CarriageClassDto', id: number, carriage_number: string, class: string, note?: string | null }> | null, direct_carriages?: Array<{ __typename: 'DirectCarriageDto', id: number, carriage_numbers: string, description?: string | null, direct_carriages_info: Array<{ __typename: 'DirectCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, established_train_schema?: Array<{ __typename: 'EstablishedTrainSchemaRailwayDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null } | { __typename: 'EstablishedTrainSchemaStationDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, max_train_length?: Array<{ __typename: 'MaxTrainLengthRailwayDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null } | { __typename: 'MaxTrainLengthStationDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, luxury_carriages?: Array<{ __typename: 'LuxuryCarriageDto', id: number, carriages_with_service?: string | null, carriages_non_branded?: string | null }> | null, maneuvering_work?: Array<{ __typename: 'ManeuveringWorkDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, optional_carriages?: Array<{ __typename: 'OptionalCarriageDto', id: number, carriage_numbers: string }> | null, other_carriages?: Array<{ __typename: 'OtherCarriageDto', id: number, carriage_numbers: string, description?: string | null, other_carriages_info: Array<{ __typename: 'OtherCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, trailed_carriages?: Array<{ __typename: 'TrailedCarriageDto', id: number, carriage_numbers: string, description?: string | null, trailed_carriages_info: Array<{ __typename: 'TrailedCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, train_change_directions?: Array<{ __typename: 'TrainChangeDirectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, tables?: Array<{ __typename: 'TableDto', id: number, second_class_total?: number | null, second_class_allocated_total?: number | null, common_total?: number | null, common_allocated_total?: number | null, direction: string, sv_total?: number | null, sv_allocated_total?: number | null, coupe_total?: number | null, coupe_allocated_total?: number | null, table_blocks: Array<{ __typename: 'TableBlockDto', id: number, in_common_circulation_with: string, heat: string, carriage_group_id: number, train_quantity: number, affiliation: string, break: string, eco_toilet: string, air_conditioner: string, is_accepted: boolean, is_collapsed: boolean, is_excluded_from_export: boolean, is_main_group: boolean, is_excluded_from_table_calculations: boolean, table_block_rows: Array<{ __typename: 'TableBlockRowDto', id: number, seats_allocated?: number | null, carriage_number: string, carriage_type: string, carriage_seat_type: string, seats_quantity?: number | null, stations: Array<{ __typename: 'StationDto', full_name: string }> }>, in_common_circulation_with_trains?: Array<{ __typename: 'TrainDto', id: number, train_number: string }> | null }> }> | null }> | null };

export type TrainsPairForCompareSchemesViewQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrainsPairForCompareSchemesViewQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, periodicity_season?: { __typename: 'PeriodicitySeasonDto', entity_id: number, periodicity_season: string } | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number } | null, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number, is_main_group_exported_direct: boolean, is_main_group_exported_reverse: boolean, status: string, is_lock: boolean, train_brand_note?: string | null, allocation_note?: string | null, variable_stencil_info?: string | null, variable_stencil_note?: string | null, luxury_carriages_note?: string | null, luxury_carriages_non_branded_note?: string | null, service_class_note?: string | null, optional_carriages_note?: string | null, is_by_stations_max_train_length: boolean, is_by_stations_established_train_schema: boolean, direct_carriages_note?: string | null, trailed_carriages_note?: string | null, other_carriages_note?: string | null, is_build_due_to_main_train: boolean, locomotive_change?: Array<{ __typename: 'LocomotiveChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, locomotive_team_change?: Array<{ __typename: 'LocomotiveTeamChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, fuel_supply?: Array<{ __typename: 'FuelSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, border_control?: Array<{ __typename: 'BorderControlDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null } }> | null, eco_toilets?: Array<{ __typename: 'EcoToiletDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, water_supply?: Array<{ __typename: 'WaterSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, waste_collection?: Array<{ __typename: 'WasteCollectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, periodicity?: Array<{ __typename: 'PeriodicityInfoDto', id: number, departure_dates: Array<string>, arrival_dates: Array<string>, departure_dates_out_of_gdp: Array<string>, arrival_dates_out_of_gdp: Array<string>, train: { __typename: 'TrainDto', id: number, train_number: string } }> | null, carriage_numerations?: Array<{ __typename: 'CarriageNumerationDto', id: number, direct_position?: string | null, reverse_position?: string | null, description?: string | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, carriage_allocations?: Array<{ __typename: 'CarriageAllocationDto', id: number, carriage_number: string, seats: string, appointment: string, description?: string | null }> | null, carriage_classes?: Array<{ __typename: 'CarriageClassDto', id: number, carriage_number: string, class: string, note?: string | null }> | null, direct_carriages?: Array<{ __typename: 'DirectCarriageDto', id: number, carriage_numbers: string, description?: string | null, direct_carriages_info: Array<{ __typename: 'DirectCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, established_train_schema?: Array<{ __typename: 'EstablishedTrainSchemaRailwayDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null } | { __typename: 'EstablishedTrainSchemaStationDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, max_train_length?: Array<{ __typename: 'MaxTrainLengthRailwayDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null } | { __typename: 'MaxTrainLengthStationDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, luxury_carriages?: Array<{ __typename: 'LuxuryCarriageDto', id: number, carriages_with_service?: string | null, carriages_non_branded?: string | null }> | null, maneuvering_work?: Array<{ __typename: 'ManeuveringWorkDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, optional_carriages?: Array<{ __typename: 'OptionalCarriageDto', id: number, carriage_numbers: string }> | null, other_carriages?: Array<{ __typename: 'OtherCarriageDto', id: number, carriage_numbers: string, description?: string | null, other_carriages_info: Array<{ __typename: 'OtherCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, trailed_carriages?: Array<{ __typename: 'TrailedCarriageDto', id: number, carriage_numbers: string, description?: string | null, trailed_carriages_info: Array<{ __typename: 'TrailedCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, train_change_directions?: Array<{ __typename: 'TrainChangeDirectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, tables?: Array<{ __typename: 'TableDto', id: number, second_class_total?: number | null, second_class_allocated_total?: number | null, common_total?: number | null, common_allocated_total?: number | null, direction: string, sv_total?: number | null, sv_allocated_total?: number | null, coupe_total?: number | null, coupe_allocated_total?: number | null, table_blocks: Array<{ __typename: 'TableBlockDto', id: number, in_common_circulation_with: string, heat: string, carriage_group_id: number, train_quantity: number, affiliation: string, break: string, eco_toilet: string, air_conditioner: string, is_accepted: boolean, is_collapsed: boolean, is_excluded_from_export: boolean, is_main_group: boolean, is_excluded_from_table_calculations: boolean, table_block_rows: Array<{ __typename: 'TableBlockRowDto', id: number, seats_allocated?: number | null, carriage_number: string, carriage_type: string, carriage_seat_type: string, seats_quantity?: number | null, stations: Array<{ __typename: 'StationDto', full_name: string }> }>, in_common_circulation_with_trains?: Array<{ __typename: 'TrainDto', id: number, train_number: string }> | null }> }> | null }> | null }, reverse?: { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, periodicity_season?: { __typename: 'PeriodicitySeasonDto', entity_id: number, periodicity_season: string } | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number } | null, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number, is_main_group_exported_direct: boolean, is_main_group_exported_reverse: boolean, status: string, is_lock: boolean, train_brand_note?: string | null, allocation_note?: string | null, variable_stencil_info?: string | null, variable_stencil_note?: string | null, luxury_carriages_note?: string | null, luxury_carriages_non_branded_note?: string | null, service_class_note?: string | null, optional_carriages_note?: string | null, is_by_stations_max_train_length: boolean, is_by_stations_established_train_schema: boolean, direct_carriages_note?: string | null, trailed_carriages_note?: string | null, other_carriages_note?: string | null, is_build_due_to_main_train: boolean, locomotive_change?: Array<{ __typename: 'LocomotiveChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, locomotive_team_change?: Array<{ __typename: 'LocomotiveTeamChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, fuel_supply?: Array<{ __typename: 'FuelSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, border_control?: Array<{ __typename: 'BorderControlDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null } }> | null, eco_toilets?: Array<{ __typename: 'EcoToiletDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, water_supply?: Array<{ __typename: 'WaterSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, waste_collection?: Array<{ __typename: 'WasteCollectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, periodicity?: Array<{ __typename: 'PeriodicityInfoDto', id: number, departure_dates: Array<string>, arrival_dates: Array<string>, departure_dates_out_of_gdp: Array<string>, arrival_dates_out_of_gdp: Array<string>, train: { __typename: 'TrainDto', id: number, train_number: string } }> | null, carriage_numerations?: Array<{ __typename: 'CarriageNumerationDto', id: number, direct_position?: string | null, reverse_position?: string | null, description?: string | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, carriage_allocations?: Array<{ __typename: 'CarriageAllocationDto', id: number, carriage_number: string, seats: string, appointment: string, description?: string | null }> | null, carriage_classes?: Array<{ __typename: 'CarriageClassDto', id: number, carriage_number: string, class: string, note?: string | null }> | null, direct_carriages?: Array<{ __typename: 'DirectCarriageDto', id: number, carriage_numbers: string, description?: string | null, direct_carriages_info: Array<{ __typename: 'DirectCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, established_train_schema?: Array<{ __typename: 'EstablishedTrainSchemaRailwayDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null } | { __typename: 'EstablishedTrainSchemaStationDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, max_train_length?: Array<{ __typename: 'MaxTrainLengthRailwayDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null } | { __typename: 'MaxTrainLengthStationDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, luxury_carriages?: Array<{ __typename: 'LuxuryCarriageDto', id: number, carriages_with_service?: string | null, carriages_non_branded?: string | null }> | null, maneuvering_work?: Array<{ __typename: 'ManeuveringWorkDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, optional_carriages?: Array<{ __typename: 'OptionalCarriageDto', id: number, carriage_numbers: string }> | null, other_carriages?: Array<{ __typename: 'OtherCarriageDto', id: number, carriage_numbers: string, description?: string | null, other_carriages_info: Array<{ __typename: 'OtherCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, trailed_carriages?: Array<{ __typename: 'TrailedCarriageDto', id: number, carriage_numbers: string, description?: string | null, trailed_carriages_info: Array<{ __typename: 'TrailedCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, train_change_directions?: Array<{ __typename: 'TrainChangeDirectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, tables?: Array<{ __typename: 'TableDto', id: number, second_class_total?: number | null, second_class_allocated_total?: number | null, common_total?: number | null, common_allocated_total?: number | null, direction: string, sv_total?: number | null, sv_allocated_total?: number | null, coupe_total?: number | null, coupe_allocated_total?: number | null, table_blocks: Array<{ __typename: 'TableBlockDto', id: number, in_common_circulation_with: string, heat: string, carriage_group_id: number, train_quantity: number, affiliation: string, break: string, eco_toilet: string, air_conditioner: string, is_accepted: boolean, is_collapsed: boolean, is_excluded_from_export: boolean, is_main_group: boolean, is_excluded_from_table_calculations: boolean, table_block_rows: Array<{ __typename: 'TableBlockRowDto', id: number, seats_allocated?: number | null, carriage_number: string, carriage_type: string, carriage_seat_type: string, seats_quantity?: number | null, stations: Array<{ __typename: 'StationDto', full_name: string }> }>, in_common_circulation_with_trains?: Array<{ __typename: 'TrainDto', id: number, train_number: string }> | null }> }> | null }> | null } | null } } };

export type CreateTrainsPairMutationVariables = Exact<{
  data: CreateTrainDto;
}>;


export type CreateTrainsPairMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', create: number } };

export type TrainSubCategoryByTrainNumberForCreateTrainViewQueryVariables = Exact<{
  trainNumber: Scalars['String']['input'];
  range: RangeInputDto;
}>;


export type TrainSubCategoryByTrainNumberForCreateTrainViewQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainSubCategory: { __typename: 'TrainSubCategoryQueryEntryPoint', byTrainNumber?: { __typename: 'TrainSubCategoryList', items: Array<{ __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, train_category_id: number }> } | null } } };

export type TrainsListOnlyTotalCountForCreateViewQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainQueryResolver_List_SortingInputType> | TrainQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TrainQueryResolver_List_FilterInputType>;
}>;


export type TrainsListOnlyTotalCountForCreateViewQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', list: { __typename: 'TrainList', totalCount: number, items: Array<{ __typename: 'TrainDto', id: number }> } } };

export type TrainsPairForOtherTrainsViewFragmentFragment = { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, other_trains: Array<{ __typename: 'OtherTrainsDto', id: number, from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, other_train: { __typename: 'TrainDto', id: number, train_number: string, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } } }> };

export type TrainsPairForOtherTrainsViewQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrainsPairForOtherTrainsViewQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, other_trains: Array<{ __typename: 'OtherTrainsDto', id: number, from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, other_train: { __typename: 'TrainDto', id: number, train_number: string, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } } }> }, reverse?: { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, other_trains: Array<{ __typename: 'OtherTrainsDto', id: number, from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, other_train: { __typename: 'TrainDto', id: number, train_number: string, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } } }> } | null } } };

export type RelatedTrainsBaseFragmentFragment = { __typename: 'RelatedTrainsDto', id: number, train_number: string, to_station?: string | null, from_station?: string | null, branch?: string | null, status: string, level: number };

export type GetRelatedTrainsDetailQueryVariables = Exact<{
  data: GetRelatedTrainsDto;
}>;


export type GetRelatedTrainsDetailQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', getRelatedTrains: { __typename: 'RelatedTrainsDtoList', totalCount: number, items: Array<{ __typename: 'RelatedTrainsDto', id: number, train_number: string, to_station?: string | null, from_station?: string | null, branch?: string | null, status: string, level: number, pair_train?: { __typename: 'RelatedTrainsDto', id: number, train_number: string } | null }> } } };

export type TrainsInfoForIndicatorsQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrainsInfoForIndicatorsQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', id: number, train_number: string }, reverse?: { __typename: 'TrainDto', id: number, train_number: string } | null } } };

export type TrainHeadIndicatorsQueryVariables = Exact<{
  data: TrainHeaderIndicatorsRequestDto;
}>;


export type TrainHeadIndicatorsQuery = { __typename: 'Query', indicators: { __typename: 'IndicatorsQueryEntryPoint', train_header_indicators: { __typename: 'TrainHeaderIndicatorsDto', train_quantity: number, train_turnover: number, carriage_quantity: number, carriage_quantity_passenger: number, average_capacity: number, seats_for_sale: number, carriage_turnover: number, carriage_turnover_passenger: number, seats_turnover: number } } };

export type ChangeIsMarkedToDeleteMutationVariables = Exact<{
  data: ChangeIsMarkedToDeleteRequestDto;
}>;


export type ChangeIsMarkedToDeleteMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', changeIsMarkedToDelete: { __typename: 'ChangeIsMarkedToDeleteDto', errors?: Array<string> | null, is_success: boolean } } };

export type TrainsPairForTrainViewFragmentFragment = { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, periodicity_season: string } | null, train_brand: { __typename: 'TrainBrandDto', id: number, entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, background_color: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, gdp: { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string }, lock_user?: { __typename: 'UserDto', email: string, phone_number?: string | null, job_position: string, id: number, full_name: string, personal_number?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null } | null, schedule?: { __typename: 'TrainScheduleDto', train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, order_number: number, direct_train_number: string, direct_departure?: number | null, direct_arrival?: number | null, direct_parking?: number | null, direct_time_to_station: number, is_direct_schedule_technical_parking: boolean, reverse_train_number?: string | null, reverse_departure?: number | null, reverse_arrival?: number | null, reverse_parking?: number | null, reverse_time_to_station?: number | null, is_reverse_schedule_technical_parking: boolean, distance: number, train_schedule_id: number }> } | null };

export type TrainsPairForTrainInfoViewQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrainsPairForTrainInfoViewQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, periodicity_season: string } | null, train_brand: { __typename: 'TrainBrandDto', id: number, entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, background_color: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, gdp: { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string }, lock_user?: { __typename: 'UserDto', email: string, phone_number?: string | null, job_position: string, id: number, full_name: string, personal_number?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null } | null, schedule?: { __typename: 'TrainScheduleDto', train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, order_number: number, direct_train_number: string, direct_departure?: number | null, direct_arrival?: number | null, direct_parking?: number | null, direct_time_to_station: number, is_direct_schedule_technical_parking: boolean, reverse_train_number?: string | null, reverse_departure?: number | null, reverse_arrival?: number | null, reverse_parking?: number | null, reverse_time_to_station?: number | null, is_reverse_schedule_technical_parking: boolean, distance: number, train_schedule_id: number }> } | null }, reverse?: { __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, periodicity_season: string } | null, train_brand: { __typename: 'TrainBrandDto', id: number, entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, background_color: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, gdp: { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string }, lock_user?: { __typename: 'UserDto', email: string, phone_number?: string | null, job_position: string, id: number, full_name: string, personal_number?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null } | null, schedule?: { __typename: 'TrainScheduleDto', train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, order_number: number, direct_train_number: string, direct_departure?: number | null, direct_arrival?: number | null, direct_parking?: number | null, direct_time_to_station: number, is_direct_schedule_technical_parking: boolean, reverse_train_number?: string | null, reverse_departure?: number | null, reverse_arrival?: number | null, reverse_parking?: number | null, reverse_time_to_station?: number | null, is_reverse_schedule_technical_parking: boolean, distance: number, train_schedule_id: number }> } | null } | null } } };

export type CommonTrainPairInfoFragmentFragment = { __typename: 'TrainDto', is_marked_to_delete: boolean, id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string } | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string, background_color: string, train_category_id: number } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, max_train_speed?: { __typename: 'MaxTrainSpeedDto', id: number, entity_id: number, max_train_speed: number } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, passenger_carrier?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, short_name: string, name: string } | null, other_trains: Array<{ __typename: 'OtherTrainsDto', id: number, from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, other_train: { __typename: 'TrainDto', id: number, train_number: string, status: string } }>, lock_user?: { __typename: 'UserDto', email: string, phone_number?: string | null, job_position: string, id: number, full_name: string, personal_number?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null } | null, schedule?: { __typename: 'TrainScheduleDto', id: number, train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', direct_arrival?: number | null, direct_departure?: number | null, reverse_arrival?: number | null, reverse_departure?: number | null, direct_time_to_station: number, reverse_time_to_station?: number | null, station: { __typename: 'StationDto', entity_id: number } }> } | null, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number }> | null, parent?: { __typename: 'NewTrainDto', id: number, train_number: string, pair_train?: { __typename: 'NewTrainDto', id: number, train_number: string } | null } | null };

export type CommonTrainPairInfoViewQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CommonTrainPairInfoViewQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', is_marked_to_delete: boolean, id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string } | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string, background_color: string, train_category_id: number } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, max_train_speed?: { __typename: 'MaxTrainSpeedDto', id: number, entity_id: number, max_train_speed: number } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, passenger_carrier?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, short_name: string, name: string } | null, other_trains: Array<{ __typename: 'OtherTrainsDto', id: number, from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, other_train: { __typename: 'TrainDto', id: number, train_number: string, status: string } }>, lock_user?: { __typename: 'UserDto', email: string, phone_number?: string | null, job_position: string, id: number, full_name: string, personal_number?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null } | null, schedule?: { __typename: 'TrainScheduleDto', id: number, train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', direct_arrival?: number | null, direct_departure?: number | null, reverse_arrival?: number | null, reverse_departure?: number | null, direct_time_to_station: number, reverse_time_to_station?: number | null, station: { __typename: 'StationDto', entity_id: number } }> } | null, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number }> | null, parent?: { __typename: 'NewTrainDto', id: number, train_number: string, pair_train?: { __typename: 'NewTrainDto', id: number, train_number: string } | null } | null }, reverse?: { __typename: 'TrainDto', is_marked_to_delete: boolean, id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string } | null, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, short_train_sub_category: string, train_sub_category: string, background_color: string, train_category_id: number } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, max_train_speed?: { __typename: 'MaxTrainSpeedDto', id: number, entity_id: number, max_train_speed: number } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, passenger_carrier?: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, short_name: string, name: string } | null, other_trains: Array<{ __typename: 'OtherTrainsDto', id: number, from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, other_train: { __typename: 'TrainDto', id: number, train_number: string, status: string } }>, lock_user?: { __typename: 'UserDto', email: string, phone_number?: string | null, job_position: string, id: number, full_name: string, personal_number?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null } | null, schedule?: { __typename: 'TrainScheduleDto', id: number, train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', direct_arrival?: number | null, direct_departure?: number | null, reverse_arrival?: number | null, reverse_departure?: number | null, direct_time_to_station: number, reverse_time_to_station?: number | null, station: { __typename: 'StationDto', entity_id: number } }> } | null, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number }> | null, parent?: { __typename: 'NewTrainDto', id: number, train_number: string, pair_train?: { __typename: 'NewTrainDto', id: number, train_number: string } | null } | null } | null } } };

export type TrainNumbersListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainQueryResolver_List_SortingInputType> | TrainQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TrainQueryResolver_List_FilterInputType>;
}>;


export type TrainNumbersListQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', list: { __typename: 'TrainList', items: Array<{ __typename: 'TrainDto', parent_id?: number | null, status: string, id: number, train_number: string, version: number, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, schedule?: { __typename: 'TrainScheduleDto', id: number } | null }> } } };

export type GenerateLocomotiveAreasForTrainsMutationVariables = Exact<{
  data: GenerateLocomotiveAreasForTrainsPairDto;
}>;


export type GenerateLocomotiveAreasForTrainsMutation = { __typename: 'Mutation', train_schedules: { __typename: 'TrainSchedulesMutationEntryPoint', generateLocomotiveAreasForTrains?: any | null } };

export type LocomotiveSeriesListForTrainViewQueryVariables = Exact<{
  where?: InputMaybe<LocomotivePriceTechnicalServiceQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
  search: Scalars['String']['input'];
}>;


export type LocomotiveSeriesListForTrainViewQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', locomotivePriceTechnicalService: { __typename: 'LocomotivePriceTechnicalServiceQueryEntryPoint', list: { __typename: 'LocomotivePriceTechnicalServiceList', items: Array<{ __typename: 'LocomotivePriceTechnicalServiceDto', locomotive_series: { __typename: 'LocomotiveSeriesDto', entity_id: number, series: string, section_quantity: number, locomotive_traction_type_id?: number | null, index?: string | null, locomotive_traction_type: { __typename: 'LocomotiveTractionTypeDto', id: number, name: string } } }> } } } };

export type ElectricityTypeStationListQueryVariables = Exact<{
  data: GetStationListFromTrainScheduleDto;
}>;


export type ElectricityTypeStationListQuery = { __typename: 'Query', train_schemas: { __typename: 'TrainSchemaQueryEntryPoint', getStationListFromTrainSchedule: Array<{ __typename: 'TrainSchemaStationDto', entity_id: number, full_name: string, express_code: string, is_electricity_type: boolean }> } };

export type TotalCalculationsForLocomotiveAreaFragment = { __typename: 'LocomotivesAreasCalculationsDto', id: number, train_schema_id: number, period_total: { __typename: 'LocomotivesAreasTripTotalDto', locomotive_areas_trip_total_cost: string, locomotive_team_areas_trip_total_cost: string, overall_trip_total_cost: string, locomotive_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, locomotive_team_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, overall_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }> }, trip_total: { __typename: 'LocomotivesAreasTripTotalDto', locomotive_areas_trip_total_cost: string, locomotive_team_areas_trip_total_cost: string, overall_trip_total_cost: string, locomotive_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, locomotive_team_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, overall_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }> } };

export type TrainsPairForLocomotiveAreaFragment = { __typename: 'TrainDto', id: number, train_number: string, branch_id?: number | null, status: string, train_schedule_id?: number | null, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number } | null, gdp: { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string }, lock_user?: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null } | null, locomotives_service: Array<{ __typename: 'TrainLocomotiveAreaDto', id: number, train_schema_id: number, train_schema: { __typename: 'TrainSchemaDto', id: number, train_schema_number: number }, locomotive_areas: Array<{ __typename: 'LocomotiveAreaDto', id: number, locomotive_series_id?: number | null, traction_directorate_id?: number | null, from_station_id: number, to_station_id: number, distance: number, trip_time: number, trip_cost?: number | null, is_valid: boolean, order_number: number, is_main_group_check: boolean, types_current: Array<{ __typename: 'TypeCurrentDto', id: number, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, locomotive_type_current?: { __typename: 'LocomotiveTypeCurrentDto', id: number, name: string } | null }>, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, locomotive_series?: { __typename: 'LocomotiveSeriesDto', id: number, entity_id: number, series: string, index?: string | null, section_quantity: number, price_rent: number, locomotive_traction_type_id?: number | null, start_at: string, locomotive_traction_type: { __typename: 'LocomotiveTractionTypeDto', id: number, name: string } } | null, traction_directorate?: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } | null, team_areas: Array<{ __typename: 'LocomotiveTeamAreaDto', id: number, traction_directorate_id?: number | null, persons_quantity?: number | null, from_station_id: number, to_station_id: number, distance: number, trip_time: number, trip_cost?: number | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, traction_directorate?: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } | null }> }> }> };

export type TrainsPairForLocomotiveAreaQueryVariables = Exact<{
  id: Scalars['Float']['input'];
  directPeriodFilter: LocomotiveTotalCalculationsPeriodRequestDto;
  reversePeriodFilter: LocomotiveTotalCalculationsPeriodRequestDto;
}>;


export type TrainsPairForLocomotiveAreaQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', id: number, train_number: string, branch_id?: number | null, status: string, train_schedule_id?: number | null, locomotives_areas_calculations: Array<{ __typename: 'LocomotivesAreasCalculationsDto', id: number, train_schema_id: number, period_total: { __typename: 'LocomotivesAreasTripTotalDto', locomotive_areas_trip_total_cost: string, locomotive_team_areas_trip_total_cost: string, overall_trip_total_cost: string, locomotive_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, locomotive_team_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, overall_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }> }, trip_total: { __typename: 'LocomotivesAreasTripTotalDto', locomotive_areas_trip_total_cost: string, locomotive_team_areas_trip_total_cost: string, overall_trip_total_cost: string, locomotive_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, locomotive_team_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, overall_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }> } }>, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number } | null, gdp: { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string }, lock_user?: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null } | null, locomotives_service: Array<{ __typename: 'TrainLocomotiveAreaDto', id: number, train_schema_id: number, train_schema: { __typename: 'TrainSchemaDto', id: number, train_schema_number: number }, locomotive_areas: Array<{ __typename: 'LocomotiveAreaDto', id: number, locomotive_series_id?: number | null, traction_directorate_id?: number | null, from_station_id: number, to_station_id: number, distance: number, trip_time: number, trip_cost?: number | null, is_valid: boolean, order_number: number, is_main_group_check: boolean, types_current: Array<{ __typename: 'TypeCurrentDto', id: number, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, locomotive_type_current?: { __typename: 'LocomotiveTypeCurrentDto', id: number, name: string } | null }>, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, locomotive_series?: { __typename: 'LocomotiveSeriesDto', id: number, entity_id: number, series: string, index?: string | null, section_quantity: number, price_rent: number, locomotive_traction_type_id?: number | null, start_at: string, locomotive_traction_type: { __typename: 'LocomotiveTractionTypeDto', id: number, name: string } } | null, traction_directorate?: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } | null, team_areas: Array<{ __typename: 'LocomotiveTeamAreaDto', id: number, traction_directorate_id?: number | null, persons_quantity?: number | null, from_station_id: number, to_station_id: number, distance: number, trip_time: number, trip_cost?: number | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, traction_directorate?: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } | null }> }> }> }, reverse?: { __typename: 'TrainDto', id: number, train_number: string, branch_id?: number | null, status: string, train_schedule_id?: number | null, locomotives_areas_calculations: Array<{ __typename: 'LocomotivesAreasCalculationsDto', id: number, train_schema_id: number, period_total: { __typename: 'LocomotivesAreasTripTotalDto', locomotive_areas_trip_total_cost: string, locomotive_team_areas_trip_total_cost: string, overall_trip_total_cost: string, locomotive_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, locomotive_team_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, overall_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }> }, trip_total: { __typename: 'LocomotivesAreasTripTotalDto', locomotive_areas_trip_total_cost: string, locomotive_team_areas_trip_total_cost: string, overall_trip_total_cost: string, locomotive_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, locomotive_team_areas_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }>, overall_total_cost: Array<{ __typename: 'LocomotivesAreasTotalCostDto', traction_directorate_id: number, trip_cost: string, traction_directorate: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } }> } }>, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number } | null, gdp: { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string }, lock_user?: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null } | null, locomotives_service: Array<{ __typename: 'TrainLocomotiveAreaDto', id: number, train_schema_id: number, train_schema: { __typename: 'TrainSchemaDto', id: number, train_schema_number: number }, locomotive_areas: Array<{ __typename: 'LocomotiveAreaDto', id: number, locomotive_series_id?: number | null, traction_directorate_id?: number | null, from_station_id: number, to_station_id: number, distance: number, trip_time: number, trip_cost?: number | null, is_valid: boolean, order_number: number, is_main_group_check: boolean, types_current: Array<{ __typename: 'TypeCurrentDto', id: number, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, locomotive_type_current?: { __typename: 'LocomotiveTypeCurrentDto', id: number, name: string } | null }>, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, locomotive_series?: { __typename: 'LocomotiveSeriesDto', id: number, entity_id: number, series: string, index?: string | null, section_quantity: number, price_rent: number, locomotive_traction_type_id?: number | null, start_at: string, locomotive_traction_type: { __typename: 'LocomotiveTractionTypeDto', id: number, name: string } } | null, traction_directorate?: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } | null, team_areas: Array<{ __typename: 'LocomotiveTeamAreaDto', id: number, traction_directorate_id?: number | null, persons_quantity?: number | null, from_station_id: number, to_station_id: number, distance: number, trip_time: number, trip_cost?: number | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, traction_directorate?: { __typename: 'TractionDirectorateDto', entity_id: number, name: string, short_name: string } | null }> }> }> } | null } } };

export type UpdateLocomotiveAreasForTrainsPairMutationVariables = Exact<{
  data: UpdateLocomotiveAreasDto;
}>;


export type UpdateLocomotiveAreasForTrainsPairMutation = { __typename: 'Mutation', train_schedules: { __typename: 'TrainSchedulesMutationEntryPoint', update_locomotive_areas_for_trains_pair?: any | null } };

export type CheckScheduleCopyPossibilityQueryVariables = Exact<{
  data: CopyScheduleDto;
}>;


export type CheckScheduleCopyPossibilityQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', checkScheduleCopyPossibility: boolean } };

export type CopyScheduleMutationVariables = Exact<{
  data: CopyScheduleDto;
}>;


export type CopyScheduleMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', copySchedule: any } };

export type ExportScheduleMutationVariables = Exact<{
  data: ExportScheduleDto;
}>;


export type ExportScheduleMutation = { __typename: 'Mutation', train_schedules: { __typename: 'TrainSchedulesMutationEntryPoint', exportSchedule?: any | null } };

export type StationsListForScheduleQueryVariables = Exact<{
  where?: InputMaybe<StationQueryResolver_List_FilterInputType>;
  range: RangeInputDto;
}>;


export type StationsListForScheduleQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', station: { __typename: 'StationQueryEntryPoint', list: { __typename: 'StationDtoList', items: Array<{ __typename: 'StationDto', is_change_locomotive: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_traction_type: boolean, is_electric_speakers_3000V: boolean, is_board_or_disembark: boolean, is_electricity_type: boolean, is_electric_speakers_380V: boolean, is_eco_toilets: boolean, is_border_control: boolean, is_fuel_supply: boolean, is_southbound: boolean, is_change_locomotive_team: boolean, is_maneuver_work: boolean, entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string, railway: { __typename: 'RailwayDto', entity_id: number, name: string } }> } } } };

export type ThreadOccupancyControlQueryVariables = Exact<{
  trainId: Scalars['Float']['input'];
}>;


export type ThreadOccupancyControlQuery = { __typename: 'Query', train_schedules: { __typename: 'TrainSchedulesQueryEntryPoint', threadOccupancyControl: boolean } };

export type TrainsPairForScheduleViewQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrainsPairForScheduleViewQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', id: number, train_number: string, branch_id?: number | null, status: string, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, lock_user?: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null } | null, schedule?: { __typename: 'TrainScheduleDto', id: number, direct_time?: number | null, reverse_time?: number | null, status: string, is_lock: boolean, gvc_name?: string | null, copy_meta?: { __typename: 'CopyMetaDto', direct_train_id: number, reverse_train_id?: number | null, direct_train_number: string, reverse_train_number?: string | null, schedule_crate_date: string, gvc_name?: string | null, gdp_start_at?: string | null, gdp_end_at?: string | null } | null, train_schedule_fragments: Array<{ __typename: 'TrainScheduleFragmentDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, order_number: number, direct_train_number: string, direct_departure?: number | null, direct_arrival?: number | null, direct_parking?: number | null, direct_time_to_station: number, is_direct_schedule_technical_parking: boolean, reverse_train_number?: string | null, reverse_departure?: number | null, reverse_arrival?: number | null, reverse_parking?: number | null, reverse_time_to_station?: number | null, is_reverse_schedule_technical_parking: boolean, distance: number, train_schedule_id: number, station: { __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null, railway: { __typename: 'RailwayDto', entity_id: number, code: string, name: string, short_name: string } } }> } | null, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number, is_main_group_exported_direct: boolean, is_main_group_exported_reverse: boolean, status: string, is_lock: boolean, train_brand_note?: string | null, allocation_note?: string | null, variable_stencil_info?: string | null, variable_stencil_note?: string | null, luxury_carriages_note?: string | null, luxury_carriages_non_branded_note?: string | null, service_class_note?: string | null, optional_carriages_note?: string | null, is_by_stations_max_train_length: boolean, is_by_stations_established_train_schema: boolean, direct_carriages_note?: string | null, trailed_carriages_note?: string | null, other_carriages_note?: string | null, is_build_due_to_main_train: boolean, locomotive_change?: Array<{ __typename: 'LocomotiveChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, locomotive_team_change?: Array<{ __typename: 'LocomotiveTeamChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, fuel_supply?: Array<{ __typename: 'FuelSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, border_control?: Array<{ __typename: 'BorderControlDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null } }> | null, eco_toilets?: Array<{ __typename: 'EcoToiletDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, water_supply?: Array<{ __typename: 'WaterSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, waste_collection?: Array<{ __typename: 'WasteCollectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, periodicity?: Array<{ __typename: 'PeriodicityInfoDto', id: number, departure_dates: Array<string>, arrival_dates: Array<string>, departure_dates_out_of_gdp: Array<string>, arrival_dates_out_of_gdp: Array<string>, train: { __typename: 'TrainDto', id: number } }> | null, carriage_numerations?: Array<{ __typename: 'CarriageNumerationDto', id: number, direct_position?: string | null, reverse_position?: string | null, description?: string | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, carriage_allocations?: Array<{ __typename: 'CarriageAllocationDto', id: number, carriage_number: string, seats: string, appointment: string, description?: string | null }> | null, carriage_classes?: Array<{ __typename: 'CarriageClassDto', id: number, carriage_number: string, class: string, note?: string | null }> | null, direct_carriages?: Array<{ __typename: 'DirectCarriageDto', id: number, carriage_numbers: string, description?: string | null, direct_carriages_info: Array<{ __typename: 'DirectCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, established_train_schema?: Array<{ __typename: 'EstablishedTrainSchemaRailwayDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null } | { __typename: 'EstablishedTrainSchemaStationDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, max_train_length?: Array<{ __typename: 'MaxTrainLengthRailwayDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null } | { __typename: 'MaxTrainLengthStationDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, luxury_carriages?: Array<{ __typename: 'LuxuryCarriageDto', id: number, carriages_with_service?: string | null, carriages_non_branded?: string | null }> | null, maneuvering_work?: Array<{ __typename: 'ManeuveringWorkDto', id: number, direction: string, description?: string | null }> | null, optional_carriages?: Array<{ __typename: 'OptionalCarriageDto', id: number, carriage_numbers: string }> | null, other_carriages?: Array<{ __typename: 'OtherCarriageDto', id: number, carriage_numbers: string, description?: string | null, other_carriages_info: Array<{ __typename: 'OtherCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, trailed_carriages?: Array<{ __typename: 'TrailedCarriageDto', id: number, carriage_numbers: string, description?: string | null, trailed_carriages_info: Array<{ __typename: 'TrailedCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, train_change_directions?: Array<{ __typename: 'TrainChangeDirectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null }> | null }, reverse?: { __typename: 'TrainDto', id: number, train_number: string, branch_id?: number | null } | null } } };

export type TrainScheduleCreateMutationVariables = Exact<{
  data: CreateTrainScheduleDto;
}>;


export type TrainScheduleCreateMutation = { __typename: 'Mutation', train_schedules: { __typename: 'TrainSchedulesMutationEntryPoint', createTrainSchedule: number } };

export type TrainScheduleDeleteMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrainScheduleDeleteMutation = { __typename: 'Mutation', train_schedules: { __typename: 'TrainSchedulesMutationEntryPoint', deleteTrainSchedule?: any | null } };

export type TrainScheduleImportMutationVariables = Exact<{
  data: UploadScheduleDto;
}>;


export type TrainScheduleImportMutation = { __typename: 'Mutation', train_schedules: { __typename: 'TrainSchedulesMutationEntryPoint', import?: any | null } };

export type ScheduleStencilQueryVariables = Exact<{
  data: GetTrainScheduleStencilDto;
}>;


export type ScheduleStencilQuery = { __typename: 'Query', train_schedules: { __typename: 'TrainSchedulesQueryEntryPoint', getScheduleStencil: { __typename: 'TrainScheduleStencilDto', initial_schedule: { __typename: 'TrainScheduleStencilSingleDto', direct_train_number: string, reverse_train_number?: string | null, direct_train_status: string, reverse_train_status?: string | null, train_version: number, start_at: string, gdpRange: { __typename: 'RangeDto', start_at: string, end_at?: string | null }, train_schedule_to_stencil_fragments: Array<{ __typename: 'TrainScheduleToStencilFragment', direct_arrival?: number | null, direct_parking?: number | null, direct_departure?: number | null, reverse_arrival?: number | null, reverse_parking?: number | null, reverse_departure?: number | null, station_name?: string | null, is_station_for_parking: boolean, station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> }, compared_schedule: { __typename: 'TrainScheduleStencilSingleDto', direct_train_number: string, reverse_train_number?: string | null, direct_train_status: string, reverse_train_status?: string | null, train_version: number, start_at: string, gdpRange: { __typename: 'RangeDto', start_at: string, end_at?: string | null }, train_schedule_to_stencil_fragments: Array<{ __typename: 'TrainScheduleToStencilFragment', direct_arrival?: number | null, direct_parking?: number | null, direct_departure?: number | null, reverse_arrival?: number | null, reverse_parking?: number | null, reverse_departure?: number | null, station_name?: string | null, is_station_for_parking: boolean, station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> }, stencil: Array<{ __typename: 'TrainScheduleToStencilFragment', direct_arrival?: number | null, direct_parking?: number | null, direct_departure?: number | null, reverse_arrival?: number | null, reverse_parking?: number | null, reverse_departure?: number | null, station_name?: string | null, is_station_for_parking: boolean }> } } };

export type TrainScheduleUpdateMutationVariables = Exact<{
  data: UpdateTrainScheduleDto;
}>;


export type TrainScheduleUpdateMutation = { __typename: 'Mutation', train_schedules: { __typename: 'TrainSchedulesMutationEntryPoint', updateTrainSchedule?: any | null } };

export type ApproveCarriageGroupMutationVariables = Exact<{
  data: ApproveCarriageGroupRequestDto;
}>;


export type ApproveCarriageGroupMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', approveCarriageGroup?: any | null } };

export type ChangeTableBlockOrderNumberMutationVariables = Exact<{
  data: ChangeTableBlockOrderNumber;
}>;


export type ChangeTableBlockOrderNumberMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', changeTableBlockOrderNumber: boolean } };

export type ChangeTableBlockTrainQuantityMutationVariables = Exact<{
  data: ChangeTableBlockQuantityDto;
}>;


export type ChangeTableBlockTrainQuantityMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', changeTableBlockTrainQuantity: boolean } };

export type ChangeTableBlockUsageInTableCalculationsMutationVariables = Exact<{
  table_block_id: Scalars['Float']['input'];
}>;


export type ChangeTableBlockUsageInTableCalculationsMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', changeTableBlockUsageInTableCalculations: boolean } };

export type ChangeTableBlockVisibilityInExportMutationVariables = Exact<{
  tableBlockId: Scalars['Float']['input'];
}>;


export type ChangeTableBlockVisibilityInExportMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', changeTableBlockVisibilityInExport: boolean } };

export type CreateSchemeMutationVariables = Exact<{
  trainIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CreateSchemeMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', create: Array<number> } };

export type DeclineCarriageGroupMutationVariables = Exact<{
  data: DeclineCarriageGroupRequestDto;
}>;


export type DeclineCarriageGroupMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', declineCarriageGroup?: any | null } };

export type DeleteSchemeMutationVariables = Exact<{
  schemaId: Scalars['Int']['input'];
  trainIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type DeleteSchemeMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', delete?: any | null } };

export type ExportSchemaMutationVariables = Exact<{
  data: ExportSchemasDto;
}>;


export type ExportSchemaMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', exportSchema?: any | null } };

export type MergeTableBlocksMutationVariables = Exact<{
  data: MergeTableBlocksDto;
}>;


export type MergeTableBlocksMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', mergeTableBlocks: boolean } };

export type ReverseTableBlockMutationVariables = Exact<{
  blockId: Scalars['Float']['input'];
}>;


export type ReverseTableBlockMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', reverseTableBlockRows: boolean } };

export type ReverseTrainSchemaBetweenTrainPairMutationVariables = Exact<{
  schemaId: Scalars['Float']['input'];
}>;


export type ReverseTrainSchemaBetweenTrainPairMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', reverseTrainSchemaBetweenTrainPair: boolean } };

export type SpreadBlockToAllSchemasMutationVariables = Exact<{
  data: SpreadBlockToAllSchemasRequestDto;
}>;


export type SpreadBlockToAllSchemasMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', spreadBlockToAllSchemas?: any | null } };

export type UpdateTrainSchemaMutationVariables = Exact<{
  data: UpdateTrainSchemaDto;
}>;


export type UpdateTrainSchemaMutation = { __typename: 'Mutation', train_schemas: { __typename: 'TrainSchemaMutationEntryPoint', update?: any | null } };

export type CheckTrainSchemaDatesQueryVariables = Exact<{
  trainSchemaId: Scalars['Float']['input'];
}>;


export type CheckTrainSchemaDatesQuery = { __typename: 'Query', train_schemas: { __typename: 'TrainSchemaQueryEntryPoint', checkTrainSchemaDates: boolean } };

export type CheckIsSpreadPossibleToAllSchemasQueryVariables = Exact<{
  data: CheckIsSpreadPossibleToAllSchemasRequestDto;
}>;


export type CheckIsSpreadPossibleToAllSchemasQuery = { __typename: 'Query', train_schemas: { __typename: 'TrainSchemaQueryEntryPoint', checkIsSpreadPossibleToAllSchemas: boolean } };

export type SchemaByIdForTrainDetailViewQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type SchemaByIdForTrainDetailViewQuery = { __typename: 'Query', train_schemas: { __typename: 'TrainSchemaQueryEntryPoint', byId: { __typename: 'TrainSchemaDto', id: number, train_schema_number: number, is_main_group_exported_direct: boolean, is_main_group_exported_reverse: boolean, status: string, is_lock: boolean, train_brand_note?: string | null, allocation_note?: string | null, variable_stencil_info?: string | null, variable_stencil_note?: string | null, luxury_carriages_note?: string | null, luxury_carriages_non_branded_note?: string | null, service_class_note?: string | null, optional_carriages_note?: string | null, is_by_stations_max_train_length: boolean, is_by_stations_established_train_schema: boolean, direct_carriages_note?: string | null, trailed_carriages_note?: string | null, other_carriages_note?: string | null, is_build_due_to_main_train: boolean, locomotive_change?: Array<{ __typename: 'LocomotiveChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, locomotive_team_change?: Array<{ __typename: 'LocomotiveTeamChangeDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, fuel_supply?: Array<{ __typename: 'FuelSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, border_control?: Array<{ __typename: 'BorderControlDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', id: number, entity_id: number, is_board_or_disembark: boolean, is_border_control: boolean, is_change_locomotive: boolean, is_change_locomotive_team: boolean, comment?: string | null, is_eco_toilets: boolean, is_electric_speakers_380V: boolean, is_electric_speakers_3000V: boolean, is_electricity_type: boolean, esr_code?: string | null, is_city: boolean, is_not_terminal_rgd: boolean, express_code: string, is_fuel_supply: boolean, full_name: string, name_for_schema?: string | null, railway_id: number, is_route_forming: boolean, is_service_not_train_route: boolean, is_traction_type: boolean, is_waste_collection: boolean, is_water_supply: boolean, is_southbound: boolean, end_at: string, is_maneuver_work: boolean, start_at: string, id_external?: number | null } }> | null, eco_toilets?: Array<{ __typename: 'EcoToiletDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, water_supply?: Array<{ __typename: 'WaterSupplyDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, waste_collection?: Array<{ __typename: 'WasteCollectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, periodicity?: Array<{ __typename: 'PeriodicityInfoDto', id: number, departure_dates: Array<string>, arrival_dates: Array<string>, departure_dates_out_of_gdp: Array<string>, arrival_dates_out_of_gdp: Array<string>, train: { __typename: 'TrainDto', id: number, train_number: string } }> | null, carriage_numerations?: Array<{ __typename: 'CarriageNumerationDto', id: number, direct_position?: string | null, reverse_position?: string | null, description?: string | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, carriage_allocations?: Array<{ __typename: 'CarriageAllocationDto', id: number, carriage_number: string, seats: string, appointment: string, description?: string | null }> | null, carriage_classes?: Array<{ __typename: 'CarriageClassDto', id: number, carriage_number: string, class: string, note?: string | null }> | null, direct_carriages?: Array<{ __typename: 'DirectCarriageDto', id: number, carriage_numbers: string, description?: string | null, direct_carriages_info: Array<{ __typename: 'DirectCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, established_train_schema?: Array<{ __typename: 'EstablishedTrainSchemaRailwayDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null } | { __typename: 'EstablishedTrainSchemaStationDto', id: number, direct_carriage_quantity?: number | null, description?: string | null, reverse_carriage_quantity?: number | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, max_train_length?: Array<{ __typename: 'MaxTrainLengthRailwayDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null, reverse_railway?: { __typename: 'RailwayDto', id: number, entity_id: number, code: string, name: string, short_name: string, timezone?: string | null } | null } | { __typename: 'MaxTrainLengthStationDto', id: number, direct_carriage_quantity?: number | null, reverse_carriage_quantity?: number | null, description?: string | null, direct_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_to_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, direct_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null, reverse_from_station?: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } | null }> | null, luxury_carriages?: Array<{ __typename: 'LuxuryCarriageDto', id: number, carriages_with_service?: string | null, carriages_non_branded?: string | null }> | null, maneuvering_work?: Array<{ __typename: 'ManeuveringWorkDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, optional_carriages?: Array<{ __typename: 'OptionalCarriageDto', id: number, carriage_numbers: string }> | null, other_carriages?: Array<{ __typename: 'OtherCarriageDto', id: number, carriage_numbers: string, description?: string | null, other_carriages_info: Array<{ __typename: 'OtherCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, trailed_carriages?: Array<{ __typename: 'TrailedCarriageDto', id: number, carriage_numbers: string, description?: string | null, trailed_carriages_info: Array<{ __typename: 'TrailedCarriageInfoDto', id: number, position_from_station: string, position_to_station: string, departure_dates: Array<string>, arrival_dates: Array<string>, missed_arrival_dates: Array<string>, missed_departure_dates: Array<string>, from_station: { __typename: 'StationDto', id: number, full_name: string }, to_station: { __typename: 'StationDto', id: number, full_name: string }, train: { __typename: 'TrainDto', id: number, train_number: string } }> }> | null, train_change_directions?: Array<{ __typename: 'TrainChangeDirectionDto', id: number, direction: string, description?: string | null, for_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> | null, tables?: Array<{ __typename: 'TableDto', id: number, second_class_total?: number | null, second_class_allocated_total?: number | null, common_total?: number | null, common_allocated_total?: number | null, direction: string, sv_total?: number | null, sv_allocated_total?: number | null, coupe_total?: number | null, coupe_allocated_total?: number | null, table_blocks: Array<{ __typename: 'TableBlockDto', id: number, in_common_circulation_with: string, heat: string, carriage_group_id: number, train_quantity: number, affiliation: string, break: string, eco_toilet: string, air_conditioner: string, is_accepted: boolean, is_collapsed: boolean, is_excluded_from_export: boolean, is_main_group: boolean, is_excluded_from_table_calculations: boolean, carriage_group: { __typename: 'CarriageGroupDto', name: string }, table_block_rows: Array<{ __typename: 'TableBlockRowDto', id: number, seats_allocated?: number | null, carriage_number: string, carriage_type: string, carriage_seat_type: string, seats_quantity?: number | null, stations: Array<{ __typename: 'StationDto', full_name: string }> }>, in_common_circulation_with_trains?: Array<{ __typename: 'TrainDto', id: number, train_number: string }> | null }> }> | null } } };

export type ShortTrainsPairQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type ShortTrainsPairQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', id: number, train_number: string, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number } | null, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number }> | null }, reverse?: { __typename: 'TrainDto', id: number, train_number: string, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number }> | null } | null } } };

export type RailwayListFromTrainScheduleQueryVariables = Exact<{
  trainId: Scalars['Int']['input'];
}>;


export type RailwayListFromTrainScheduleQuery = { __typename: 'Query', train_schemas: { __typename: 'TrainSchemaQueryEntryPoint', getRailwayListFromTrainSchedule: Array<{ __typename: 'TrainSchemaRailwayDto', entity_id: number, name: string, short_name: string, code: string }> } };

export type SchemasListForTrainSelectQueryVariables = Exact<{
  trainId: Scalars['Float']['input'];
}>;


export type SchemasListForTrainSelectQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', byId: { __typename: 'TrainDto', id: number, schemas?: Array<{ __typename: 'TrainSchemaDto', id: number, train_schema_number: number }> | null } } };

export type StationListFromTrainScheduleQueryVariables = Exact<{
  data: GetStationListFromTrainScheduleDto;
}>;


export type StationListFromTrainScheduleQuery = { __typename: 'Query', train_schemas: { __typename: 'TrainSchemaQueryEntryPoint', getStationListFromTrainSchedule: Array<{ __typename: 'TrainSchemaStationDto', entity_id: number, full_name: string, express_code: string, parking_direction?: string | null }> } };

export type TrainSubCategoryByTrainNumberForUpdateTrainViewQueryVariables = Exact<{
  trainNumber: Scalars['String']['input'];
  range: RangeInputDto;
}>;


export type TrainSubCategoryByTrainNumberForUpdateTrainViewQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainSubCategory: { __typename: 'TrainSubCategoryQueryEntryPoint', byTrainNumber?: { __typename: 'TrainSubCategoryList', items: Array<{ __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, train_category_id: number }> } | null } } };

export type TrainsListOnlyTotalCountForUpdateViewQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainQueryResolver_List_SortingInputType> | TrainQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TrainQueryResolver_List_FilterInputType>;
}>;


export type TrainsListOnlyTotalCountForUpdateViewQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', list: { __typename: 'TrainList', totalCount: number, items: Array<{ __typename: 'TrainDto', id: number }> } } };

export type UpdateTrainNumberMutationVariables = Exact<{
  data: EditTrainNumberDto;
}>;


export type UpdateTrainNumberMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', editTrainNumber?: any | null } };

export type UpdateTrainsPairMutationVariables = Exact<{
  data: UpdateTrainDto;
}>;


export type UpdateTrainsPairMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', update?: any | null } };

export type CopyTrainCarriageGroupMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CopyTrainCarriageGroupMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', copy?: number | null } };

export type DeleteTrainCarriageGroupMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteTrainCarriageGroupMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', deleteCarriageGroup?: boolean | null } };

export type TrainCarriageGroupListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<CarriageGroupQueryResolver_CarriageGroupList_SortingInputType> | CarriageGroupQueryResolver_CarriageGroupList_SortingInputType>;
  where?: InputMaybe<CarriageGroupQueryResolver_CarriageGroupList_FilterInputType>;
  search: Scalars['String']['input'];
}>;


export type TrainCarriageGroupListQuery = { __typename: 'Query', carriageGroups: { __typename: 'CarriageGroupQueryEntryPoint', carriageGroupList: { __typename: 'CarriageGroupList', totalCount: number, items: Array<{ __typename: 'CarriageGroupViewDto', id?: number | null, name?: string | null, branch_id?: number | null, passenger_carriers_id?: number | null, railway_administration_id?: number | null, structural_subdivision_id?: number | null, rolling_stock_type?: string | null, step_status?: string | null, status?: string | null, train_numbers?: Array<string> | null, train_statuses?: Array<string> | null, from_stations?: Array<string> | null, to_stations?: Array<string> | null, branch?: string | null, passenger_carrier?: string | null, railway_administration?: string | null, structural_subdivision?: string | null, min_train_quantity?: number | null, max_train_quantity?: number | null, min_turnaround_time?: number | null, max_turnaround_time?: number | null, carriage_dimension_ids?: Array<number> | null, train_ids?: Array<number> | null, dimensions?: string | null, carriage_types?: Array<string> | null, periodicity?: Array<string> | null, parent_id?: number | null, station_affiliation?: string | null, first_departure_date?: string | null, version: number, start_at: string, end_at: string }> } } };

export type TrainDetailDefaultFilterQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrainDetailDefaultFilterQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', id: number, rolling_stock_types: Array<string>, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string } }, reverse?: { __typename: 'TrainDto', id: number } | null } } };

export type TrainExportCarriageGroupListMutationVariables = Exact<{
  where: CarriageGroupMutationResolver_ExportCarriageGroupsList_FilterInputType;
}>;


export type TrainExportCarriageGroupListMutation = { __typename: 'Mutation', carriageGroups: { __typename: 'CarriageGroupMutationEntryPoint', exportCarriageGroupsList?: any | null } };

export type TrainHeadCarriageGroupsQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrainHeadCarriageGroupsQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', pair: { __typename: 'TrainsPairDto', direct: { __typename: 'TrainDto', status: string, rolling_stock_types: Array<string>, gdp: { __typename: 'GdpDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, start_at: string, end_at: string }, lock_user?: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null } | null } } } };

export type TrainLockMutationVariables = Exact<{
  data: LockTrainDto;
}>;


export type TrainLockMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', lock: any } };

export type DeclineApprovedMutationVariables = Exact<{
  data: UpdateTrainStatusDto;
}>;


export type DeclineApprovedMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', declineApproved: { __typename: 'UpdateStatusResponseDto', status: string } } };

export type DeleteTrainMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteTrainMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', delete?: any | null } };

export type ExportTrainListMutationVariables = Exact<{
  where: TrainMutationResolver_ExportTrainList_FilterInputType;
  data: ExportTrainListDto;
}>;


export type ExportTrainListMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', exportTrainList?: any | null } };

export type TrainApproveBySubdivisionMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrainApproveBySubdivisionMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', approveBySubdivision: any } };

export type TrainCreateVersionMutationVariables = Exact<{
  data: CreateVersionDto;
}>;


export type TrainCreateVersionMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', createVersion: { __typename: 'CreateVersionResponseDto', train_ids: Array<number>, error_message?: string | null } } };

export type TrainDeclineBySubdivisionMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TrainDeclineBySubdivisionMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', declineBySubdivision: any } };

export type TrainToApprovalMutationVariables = Exact<{
  data: UpdateTrainStatusDto;
}>;


export type TrainToApprovalMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', toApproval: { __typename: 'UpdateStatusResponseDto', status: string } } };

export type TrainToApprovedMutationVariables = Exact<{
  data: UpdateTrainStatusDto;
}>;


export type TrainToApprovedMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', toApproved: { __typename: 'UpdateStatusResponseDto', status: string } } };

export type TrainToPlanningMutationVariables = Exact<{
  data: UpdateTrainStatusDto;
}>;


export type TrainToPlanningMutation = { __typename: 'Mutation', train: { __typename: 'TrainMutationEntryPoint', toPlanning: { __typename: 'UpdateStatusResponseDto', status: string } } };

export type CheckCreateVersionPossibilityQueryVariables = Exact<{
  data: CheckCreateVersionPossibilityDto;
}>;


export type CheckCreateVersionPossibilityQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', checkCreateVersionPossibility: { __typename: 'CheckCreateVersionPossibilityResponseDto', is_create_version_for_missed_trains: boolean, is_create_version_possible: boolean, message?: string | null } } };

export type DivisionsListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<RbacQueryResolver_Division_SortingInputType> | RbacQueryResolver_Division_SortingInputType>;
  where?: InputMaybe<RbacQueryResolver_Division_FilterInputType>;
}>;


export type DivisionsListQuery = { __typename: 'Query', rbac: { __typename: 'RbacQueryEntryPoint', divisions: { __typename: 'DivisionList', totalCount: number, items: Array<{ __typename: 'DivisionDto', id: number, name: string }> } } };

export type RelatedTrainsFragmentsFragment = { __typename: 'RelatedTrainsDto', id: number, to_station?: string | null, from_station?: string | null, train_number: string, status: string };

export type GetRelatedTrainsQueryVariables = Exact<{
  data: GetRelatedTrainsDto;
}>;


export type GetRelatedTrainsQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', getRelatedTrains: { __typename: 'RelatedTrainsDtoList', totalCount: number, items: Array<{ __typename: 'RelatedTrainsDto', id: number, to_station?: string | null, from_station?: string | null, train_number: string, status: string, pair_train?: { __typename: 'RelatedTrainsDto', id: number, to_station?: string | null, from_station?: string | null, train_number: string, status: string } | null }> } } };

export type NewTrainFragmentFragment = { __typename: 'NewTrainDto', is_marked_to_delete: boolean, id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, start_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, is_included_in_request_form: boolean, is_periodicity_separate_request_form: boolean, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, short_train_sub_category: string, created_at: string, updated_at: string, background_color: string, start_at: string, end_at: string, train_numbers: string } | null, category?: { __typename: 'TrainCategoryDto', entity_id: number, train_category: string } | null, lock_user?: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, short_name: string } | null } | null, parent?: { __typename: 'NewTrainDto', id: number, train_number: string, pair_train?: { __typename: 'NewTrainDto', id: number, train_number: string } | null } | null };

export type NewTrainsListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainQueryResolver_NewList_SortingInputType> | TrainQueryResolver_NewList_SortingInputType>;
  where?: InputMaybe<TrainQueryResolver_NewList_FilterInputType>;
  is_including_expired_versions: Scalars['Boolean']['input'];
}>;


export type NewTrainsListQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', newList: { __typename: 'NewTrainList', totalCount: number, items: Array<{ __typename: 'NewTrainDto', is_latest_version: boolean, is_marked_to_delete: boolean, id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, start_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, is_included_in_request_form: boolean, is_periodicity_separate_request_form: boolean, pair_train?: { __typename: 'NewTrainDto', is_marked_to_delete: boolean, id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, start_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, is_included_in_request_form: boolean, is_periodicity_separate_request_form: boolean, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, short_train_sub_category: string, created_at: string, updated_at: string, background_color: string, start_at: string, end_at: string, train_numbers: string } | null, category?: { __typename: 'TrainCategoryDto', entity_id: number, train_category: string } | null, lock_user?: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, short_name: string } | null } | null, parent?: { __typename: 'NewTrainDto', id: number, train_number: string, pair_train?: { __typename: 'NewTrainDto', id: number, train_number: string } | null } | null } | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, short_train_sub_category: string, created_at: string, updated_at: string, background_color: string, start_at: string, end_at: string, train_numbers: string } | null, category?: { __typename: 'TrainCategoryDto', entity_id: number, train_category: string } | null, lock_user?: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, short_name: string } | null } | null, parent?: { __typename: 'NewTrainDto', id: number, train_number: string, pair_train?: { __typename: 'NewTrainDto', id: number, train_number: string } | null } | null }> } } };

export type RequestFormTrainListFragmentFragment = { __typename: 'NewTrainDto', version: number, parent_id?: number | null, status: string, id: number, train_number: string, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } };

export type RequestFormTrainListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainQueryResolver_NewList_SortingInputType> | TrainQueryResolver_NewList_SortingInputType>;
  where?: InputMaybe<TrainQueryResolver_NewList_FilterInputType>;
  is_including_expired_versions: Scalars['Boolean']['input'];
}>;


export type RequestFormTrainListQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', newList: { __typename: 'NewTrainList', totalCount: number, items: Array<{ __typename: 'NewTrainDto', version: number, parent_id?: number | null, status: string, id: number, train_number: string, pair_train?: { __typename: 'NewTrainDto', version: number, parent_id?: number | null, status: string, id: number, train_number: string, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } } | null, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } }> } } };

export type TrainSubCategoryFiltersQueryVariables = Exact<{
  range: RangeInputDto;
}>;


export type TrainSubCategoryFiltersQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', trainSubCategory: { __typename: 'TrainSubCategoryQueryEntryPoint', list: { __typename: 'TrainSubCategoryList', items: Array<{ __typename: 'TrainSubCategoryDto', id: number, train_sub_category: string, background_color: string }> } } } };

export type TrainVersionsListQueryVariables = Exact<{
  where?: InputMaybe<TrainQueryResolver_NewList_FilterInputType>;
  paginate?: InputMaybe<PaginatorArgsDto>;
  is_including_expired_versions: Scalars['Boolean']['input'];
}>;


export type TrainVersionsListQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', newList: { __typename: 'NewTrainList', totalCount: number, items: Array<{ __typename: 'NewTrainDto', id: number, parent_id?: number | null, version: number, train_number: string, status: string, is_carriage_group_approval: boolean, start_at: string, end_at: string, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, gdp: { __typename: 'GdpDto', id: number, start_at: string, end_at: string }, pair_train?: { __typename: 'NewTrainDto', id: number, train_number: string, is_carriage_group_approval: boolean, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string } } | null, parent?: { __typename: 'NewTrainDto', id: number, train_number: string, pair_train?: { __typename: 'NewTrainDto', id: number, train_number: string } | null } | null }> } } };

export type TrainsListQueryVariables = Exact<{
  paginate?: InputMaybe<PaginatorArgsDto>;
  orderBy?: InputMaybe<Array<TrainQueryResolver_List_SortingInputType> | TrainQueryResolver_List_SortingInputType>;
  where?: InputMaybe<TrainQueryResolver_List_FilterInputType>;
}>;


export type TrainsListQuery = { __typename: 'Query', train: { __typename: 'TrainQueryEntryPoint', list: { __typename: 'TrainList', totalCount: number, items: Array<{ __typename: 'TrainDto', id: number, entity_id: number, is_direct: boolean, arrival_time?: string | null, branch_id?: number | null, created_at: string, departure_time?: string | null, individual_name: string, train_number: string, status: string, is_carriage_group_approval: boolean, is_lock: boolean, is_lock_by_status: boolean, is_main: boolean, is_schedule_approval: boolean, is_schema_approval: boolean, active_subdivision_ids: Array<number>, decline_subdivision_ids: Array<number>, route_duration: number, periodicity?: string | null, parent_id?: number | null, is_excluded_from_calculation_infrastructure_cost: boolean, version: number, start_at: string, route_speed?: number | null, is_daytime: boolean, note?: string | null, stations_recoupling?: string | null, other_trains_note?: string | null, is_included_in_request_form: boolean, is_locomotive_actual: boolean, is_periodicity_separate_request_form: boolean, is_latest_version: boolean, branch?: { __typename: 'BranchDto', entity_id: number, name: string, short_name: string } | null, from_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, passenger_carrier?: { __typename: 'PassengerCarrierDto', entity_id: number, short_name: string, name: string } | null, periodicity_season?: { __typename: 'PeriodicitySeasonDto', id: number, entity_id: number, start_at: string, end_at: string, periodicity_season: string } | null, railway_administration: { __typename: 'RailwayAdministrationDto', id: number, entity_id: number, name: string, short_name: string, code: number, international_mnemonic?: string | null }, to_station: { __typename: 'StationDto', entity_id: number, full_name: string, name_for_schema?: string | null, express_code: string }, train_brand: { __typename: 'TrainBrandDto', entity_id: number, train_brand: string, background_color: string }, sub_category?: { __typename: 'TrainSubCategoryDto', entity_id: number, train_sub_category: string, short_train_sub_category: string, created_at: string, updated_at: string, background_color: string, start_at: string, end_at: string, train_numbers: string } | null, lock_user?: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null, branch?: { __typename: 'BranchDto', entity_id: number, short_name: string } | null } | null }> } } };

export type DefaultFiltersQueryVariables = Exact<{
  rzdId: Scalars['Float']['input'];
  fpkId: Scalars['Float']['input'];
  range: RangeInputDto;
}>;


export type DefaultFiltersQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', railwayAdministration: { __typename: 'RailwayAdministrationQueryEntryPoint', byEntityId: { __typename: 'RailwayAdministrationDto', entity_id: number, short_name: string, code: number } }, passengerCarrier: { __typename: 'PassengerCarrierQueryEntryPoint', byEntityId: { __typename: 'PassengerCarrierDto', code: number, entity_id: number, short_name: string, name: string } } } };

export type UpdateUserConfigurationMutationVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type UpdateUserConfigurationMutation = { __typename: 'Mutation', configuration: { __typename: 'ConfigurationMutationEntryPoint', user_configuration_update?: { __typename: 'UsersConfigDto', id: number, data?: string | null } | null } };

export type UserConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserConfigurationQuery = { __typename: 'Query', configuration: { __typename: 'ConfigurationQueryEntryPoint', user_configuration?: { __typename: 'UsersConfigDto', id: number, data?: string | null } | null } };

export type MnemonicsFullListQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<MnemonicQueryResolver_List_SortingInputType> | MnemonicQueryResolver_List_SortingInputType>;
}>;


export type MnemonicsFullListQuery = { __typename: 'Query', classifiers: { __typename: 'ClassifiersQueryEntryPoint', mnemonic: { __typename: 'MnemonicQueryEntryPoint', list: { __typename: 'MnemonicList', items: Array<{ __typename: 'MnemonicDto', id: number, mnemonic: string, mnemonic_rus: string, group_name: string, group_name_rus: string }> } } } };

export type InitDataQueryVariables = Exact<{ [key: string]: never; }>;


export type InitDataQuery = { __typename: 'Query', users: { __typename: 'UsersQueryEntryPoint', me: { __typename: 'UserDto', id: number, full_name: string, personal_number?: number | null, user_name: string, email: string, job_position: string, expiration_date: string, phone_number?: string | null, disabled: boolean, is_ldap: boolean, is_need_to_clear_cache: boolean, branch?: { __typename: 'BranchDto', start_at: string, end_at: string, entity_id: number, name: string, short_name: string, name_nmrvag: string, vladr: string } | null, division?: { __typename: 'DivisionDto', id: number, name: string, disabled: boolean, group: { __typename: 'DivisionGroupDto', id: number, name: string, rules: Array<{ __typename: 'RuleDto', id: number, method: string, description?: string | null }> } } | null, roles: Array<{ __typename: 'RoleDto', id: number, created_at: string, updated_at: string, created_by?: number | null, updated_by?: number | null, name: string, is_fpk: boolean, rules: Array<{ __typename: 'RuleDto', method: string, disabled: boolean, module: { __typename: 'ModuleDto', name: string } }> }>, rules?: Array<{ __typename: 'RuleDto', method: string, disabled: boolean, module: { __typename: 'ModuleDto', name: string } }> | null } }, configuration: { __typename: 'ConfigurationQueryEntryPoint', feature_flag_list: { __typename: 'FeatureFlagList', items: Array<{ __typename: 'FeatureFlagsDto', id: number, name: string, value: string, description?: string | null }> }, feature_flag_user_list: { __typename: 'FeatureFlagUserList', items: Array<{ __typename: 'FeatureFlagsUserDto', id: number, value: string, user_id: number, name: string, description?: string | null }> } }, classifiers: { __typename: 'ClassifiersQueryEntryPoint', gdp: { __typename: 'GDPQueryEntryPoint', currentGdp?: { __typename: 'GdpDto', id: number, start_at: string, end_at: string } | null, nextGdp?: { __typename: 'GdpDto', id: number, start_at: string, end_at: string } | null, list: { __typename: 'GDPList', items: Array<{ __typename: 'GdpDto', id: number, start_at: string, end_at: string }> } } } };

export type UserNotificationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationCountQuery = { __typename: 'Query', notification: { __typename: 'NotificationQueryEntryPoint', not_viewed_user_messages_count: number } };

export const CarriageBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageBaseFragment on CarriageDto {
  id
  rolling_stock_type
  is_lock
}
    `;
export const CarriageAdditionalParameterBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageAdditionalParameterBaseFragment on CarriageAdditionalParameterDto {
  id
  created_at
  updated_at
  created_by
  updated_by
}
    `;
export const CarriageAdditionalSeatsSignBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageAdditionalSeatsSignBaseFragment on CarriageAdditionalSeatsSignDto {
  id
  all_seats
  quantity
  description
}
    `;
export const CarriageGroupBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageGroupBaseFragment on CarriageGroupDto {
  id
  status
  step_status
  is_lock
  is_manual_trip_formation_for_schema
  name
  rolling_stock_type
  parent_id
  version
  start_at
  end_at
}
    `;
export const CarriageGroupViewFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageGroupViewFragment on CarriageGroupViewDto {
  id
  name
  branch_id
  passenger_carriers_id
  railway_administration_id
  structural_subdivision_id
  rolling_stock_type
  step_status
  status
  train_numbers
  train_statuses
  from_stations
  to_stations
  branch
  passenger_carrier
  railway_administration
  structural_subdivision
  min_train_quantity
  max_train_quantity
  min_turnaround_time
  max_turnaround_time
  carriage_dimension_ids
  train_ids
  dimensions
  carriage_types
  periodicity
  parent_id
  station_affiliation
  first_departure_date
  version
  start_at
  end_at
}
    `;
export const CarriageGroupTurnoverChartItemBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageGroupTurnoverChartItemBaseFragment on CarriageGroupTurnoverChartDataDto {
  category
  from_date
  to_date
  train_number
  station
  train_from_station
  train_to_station
  turnover_from_station
  turnover_to_station
  is_formation_point
  is_turnover_point
  trip_time
}
    `;
export const CarriageGroupTurnoverTrainInfoBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageGroupTurnoverTrainInfoBaseFragment on CarriageGroupTurnoverChartTrainInfoDto {
  branch
  name
  rolling_stock_type
  structural_subdivision
  train_quantity
  turnover_time
  passenger_carriers
  railway_administration
}
    `;
export const CarriageMvpsBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageMvpsBaseFragment on CarriageMvpsDto {
  id
  start_at
  end_at
  seats_quantity
  is_lock
  lineup_length
}
    `;
export const CarriageNpsBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageNpsBaseFragment on CarriageNpsDto {
  id
  created_by
  updated_by
  created_at
  updated_at
  start_at
  end_at
  is_eco_toilets
  is_air_conditioner
  is_centralized_power_supply
  seats_quantity
  is_lock
}
    `;
export const CarriageParameterBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageParameterBaseFragment on CarriageParameterDto {
  id
  is_all_additional_parameter_order_numbers_set
  number_from_head
}
    `;
export const CarriageSeatsAllocationBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageSeatsAllocationBaseFragment on CarriageSeatsAllocationDto {
  id
  all_seats
  quantity
  description
}
    `;
export const DeclineHistoryBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DeclineHistoryBaseFragment on DeclineHistoryDto {
  id
  created_at
  comment
}
    `;
export const TrailedDirectGroupRouteDetailBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupRouteDetailBaseFragment on TrailedDirectGroupRouteDetailsItemDto {
  train_id
  train_number
  station_from
  station_to
  position
}
    `;
export const TrailedDirectGroupBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupBaseFragment on TrailedDirectGroupResponseDto {
  status
  rolling_stock_type
  carriage_group_id
  parent_id
}
    `;
export const TrailedDirectGroupScheduleBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupScheduleBaseFragment on TrailedDirectGroupScheduleDto {
  direct_time_total
  reverse_time_total
}
    `;
export const TrailedDirectGroupScheduleFragmentBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupScheduleFragmentBaseFragment on TrailedDirectGroupScheduleFragmentDto {
  order_number
  direct_train_number
  reverse_train_number
  direct_train_id
  reverse_train_id
  direct_arrival
  reverse_arrival
  direct_parking
  reverse_parking
  is_direct_schedule_technical_parking
  is_reverse_schedule_technical_parking
  direct_departure
  reverse_departure
  distance
  reverse_train_number_from_schedule
  direct_train_number_from_schedule
  direct_train_stations
  reverse_train_stations
}
    `;
export const TrailedDirectGroupSchemaAdditionalInfoBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupSchemaAdditionalInfoBaseFragment on TrailedDirectGroupSchemaAdditionalInfoDto {
  train_quantity
  structural_subdivision
  brake_types
  heating_types
  eco_toilets
  air_conditioner
}
    `;
export const TrailedDirectGroupSchemaParametersBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupSchemaParametersBaseFragment on TrailedDirectGroupSchemaCarriageDto {
  carriage_number
  carriage_type
  turnover_points
  seats_sv_total
  seats_sv_allocated
  seats_coupe_total
  seats_coupe_allocated
  seats_second_class_total
  seats_second_class_allocated
  seats_common_total
  seats_common_allocated
}
    `;
export const TrailedDirectGroupSchemaPeriodicityInfoBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupSchemaPeriodicityInfoBaseFragment on TrailedDirectGroupPeriodicityInfoDto {
  train_number
  departure_dates
  arrival_dates
  from_station
  to_station
  is_direct
}
    `;
export const TrailedDirectGroupSchemaSummaryBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupSchemaSummaryBaseFragment on TrailedDirectGroupSchemaSummaryDto {
  seats_sv_total
  seats_sv_allocated
  seats_coupe_total
  seats_coupe_allocated
  seats_second_class_total
  seats_second_class_allocated
  seats_common_total
  seats_common_allocated
  seats_summary_total
  seats_summary_allocated
}
    `;
export const TrailedDirectGroupStationBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupStationBaseFragment on StationResponseDto {
  id
  is_board_or_disembark
  is_border_control
  is_change_locomotive
  is_change_locomotive_team
  is_eco_toilets
  is_electric_speakers_380V
  is_electric_speakers_3000V
  is_electricity_type
  express_code
  is_fuel_supply
  full_name
  railway_id
  is_waste_collection
  is_water_supply
  is_traction_type
  is_maneuver_work
}
    `;
export const TrailedDirectGroupItemBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupItemBaseFragment on TrailedDirectGroupListItemResponseDto {
  id
  carriages_total
}
    `;
export const TrailedDirectGroupItemFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupItemFragment on TrailedDirectGroupListItemFragmentDto {
  station_from {
    entity_id
    full_name
  }
  station_to {
    entity_id
    full_name
  }
  station_recouple
  train_numbers
  time_total
}
    `;
export const RailwayAdministrationShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RailwayAdministrationShortFragment on RailwayAdministrationDto {
  entity_id
  short_name
  code
}
    `;
export const BranchShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment BranchShortFragment on BranchDto {
  entity_id
  name
  short_name
}
    `;
export const PassengerCarrierShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment PassengerCarrierShortFragment on PassengerCarrierDto {
  entity_id
  short_name
  name
}
    `;
export const TrailedDirectGroupViewFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedDirectGroupViewFragment on TrailedDirectGroupListItemResponseDto {
  ...TrailedDirectGroupItemBaseFragment
  direct {
    ...TrailedDirectGroupItemFragment
  }
  reverse {
    ...TrailedDirectGroupItemFragment
  }
  carriage_group {
    id
    status
    rolling_stock_type
    railway_administration {
      ...RailwayAdministrationShortFragment
    }
    branch {
      ...BranchShortFragment
    }
    passenger_carrier {
      ...PassengerCarrierShortFragment
    }
    periodicities {
      id
      periodicity
    }
  }
  carriage_type_params_count {
    carriage_type
    quantity
  }
  carriages_total
  parent_id
}
    ${TrailedDirectGroupItemBaseFragmentFragmentDoc}
${TrailedDirectGroupItemFragmentFragmentDoc}
${RailwayAdministrationShortFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}`;
export const TurnaroundTimeBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TurnaroundTimeBaseFragment on TurnaroundTimeDto {
  id
  created_at
  updated_at
  created_by
  updated_by
  turn_around_time
  departure_dates
  arrival_dates_with_time_stagnation
}
    `;
export const TurnoverBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TurnoverBaseFragment on TurnoverDto {
  id
  accepted_train_schemas_ids
  arrival_dates
  arrival_dates_with_time_stagnation
  departure_dates
  group_sign
  is_pbg
  is_schemas_accepted
  is_start_position_for_sale_direct_tickets
  is_time_stagnation_variable
  is_turnover_station_for_schema
  order_number
  position
  seats_for_sale
  seats_total
}
    `;
export const TurnoverTimeStagnationBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TurnoverTimeStagnationBaseFragment on TurnoverTimeStagnationDto {
  id
  created_at
  created_by
  updated_at
  updated_by
  time_in_stagnation
  arrival_dates
}
    `;
export const CarriageServiceClassBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageServiceClassBaseFragment on CarriageServiceClassDto {
  id
  entity_id
  start_at
  end_at
}
    `;
export const CarriageTrainInfoBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageTrainInfoBaseFragment on CarriageTrainInfoDto {
  id
  order_number
  notes
  carriage_additional_parameters
}
    `;
export const AvailableServiceClassBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment AvailableServiceClassBaseFragment on AvailableServiceClassDto {
  id
  entity_id
  start_at
  end_at
  service_class
}
    `;
export const BranchBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment BranchBaseFragment on BranchDto {
  start_at
  end_at
  entity_id
  name
  short_name
  name_nmrvag
  vladr
}
    `;
export const CarriageAdditionalSeatSignBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageAdditionalSeatSignBaseFragment on CarriageAdditionalSeatSignDto {
  entity_id
  id
  start_at
  end_at
  name
}
    `;
export const CarriageSeatAllocationBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageSeatAllocationBaseFragment on CarriageSeatAllocationDto {
  id
  entity_id
  start_at
  end_at
  name
}
    `;
export const CarriageSeatAllocationShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageSeatAllocationShortFragment on CarriageSeatAllocationDto {
  entity_id
  start_at
  name
}
    `;
export const MnemonicShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MnemonicShortFragment on MnemonicDto {
  id
  group_name
  group_name_rus
  mnemonic
  mnemonic_rus
}
    `;
export const CarriageTypeBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageTypeBaseFragment on CarriageTypeDto {
  entity_id
  created_at
  updated_at
  created_by
  updated_by
  start_at
  end_at
  regulatory_sector {
    ...MnemonicShortFragment
  }
  seat_type {
    ...MnemonicShortFragment
  }
  rolling_stock_type {
    ...MnemonicShortFragment
  }
}
    ${MnemonicShortFragmentFragmentDoc}`;
export const CarriageTypeAsuBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageTypeAsuBaseFragment on CarriageTypeAsuDto {
  entity_id
  start_at
  end_at
  short_name
  full_name
}
    `;
export const CarriageTypeAsuDimensionSeatsCountShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageTypeAsuDimensionSeatsCountShortFragment on CarriageTypeAsuDimensionSeatsCountDto {
  id
  default_seats_count
}
    `;
export const CarriageTypeCsuBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageTypeCsuBaseFragment on CsuCarriageTypeDto {
  id
  name
  subtypes
  type
}
    `;
export const CarriageTypesForSchemaBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageTypesForSchemaBaseFragment on CarriageTypesForSchemaDto {
  id
  name
  description
  carriage_type_asu {
    id
    entity_id
    full_name
    short_name
  }
}
    `;
export const CarriageTypesForSchemaShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageTypesForSchemaShortFragment on CarriageTypesForSchemaDto {
  id
  name
  description
}
    `;
export const ConditionalCarriageNumbersBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ConditionalCarriageNumbersBaseFragment on ConditionalCarriageNumberDto {
  id
  conditional_carriage_number
}
    `;
export const InfrastructureApplication23BaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment InfrastructureApplication23BaseFragment on InfrastructureApplication23Dto {
  id
  distance_end
  distance_start
  express_v_91_140_m_15_30_i1
  express_v_91_140_m_15_30_i2
  express_v_91_140_m_15_30_i3
  express_v_91_140_m_30_70_i1
  express_v_91_140_m_30_70_i2
  express_v_91_140_m_30_70_i3
  express_v_140_etc_m_15_70_i1
  express_v_140_etc_m_15_70_i2
  express_v_140_etc_m_15_70_i3
  fast_i1
  fast_i2
  fast_i3
  passenger_i1
  passenger_i2
  passenger_i3
}
    `;
export const InfrastructureApplication24BaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment InfrastructureApplication24BaseFragment on InfrastructureApplication24Dto {
  id
  distance_end
  distance_start
  express_i1
  express_i2
  express_i3
  fast_i1
  fast_i2
  fast_i3
  passenger_i1
  passenger_i2
  passenger_i3
}
    `;
export const InfrastructureApplication25BaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment InfrastructureApplication25BaseFragment on InfrastructureApplication25Dto {
  id
  distance_end
  distance_start
  fast_i1
  fast_i2
  fast_i3
  passenger_i1
  passenger_i2
  passenger_i3
  express_v1_140_etc_v2_160_etc_m1_30_75_i1
  express_v1_140_etc_v2_160_etc_m1_30_75_i2
  express_v1_140_etc_v2_160_etc_m1_30_75_i3
  express_v1_91_140_v2_0_140_m1_30_75_i1
  express_v1_91_140_v2_0_140_m1_30_75_i2
  express_v1_91_140_v2_0_140_m1_30_75_i3
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i1
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i2
  express_v1_91_140_v2_140_160_m1_30_75_m2_150_325_i3
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i1
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i2
  express_v1_91_140_v2_140_160_m1_30_75_m2_325_650_i3
  express_v91_140_etc_v2_160_etc_m1_30_75_i1
  express_v91_140_etc_v2_160_etc_m1_30_75_i2
  express_v91_140_etc_v2_160_etc_m1_30_75_i3
}
    `;
export const InfrastructureApplication26BaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment InfrastructureApplication26BaseFragment on InfrastructureApplication26Dto {
  id
  distance_end
  distance_start
  express_i1
  express_i2
  express_i3
  fast_i1
  fast_i2
  fast_i3
  passenger_i1
  passenger_i2
  passenger_i3
}
    `;
export const InfrastructureApplication27ShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment InfrastructureApplication27ShortFragment on InfrastructureApplication27Dto {
  id
  price
}
    `;
export const InfrastructureCoefficientIndexingBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment InfrastructureCoefficientIndexingBaseFragment on InfrastructureCoefficientIndexingDto {
  id
  start_at
  end_at
  coefficient
}
    `;
export const InfrastructureCoefficientIndexingShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment InfrastructureCoefficientIndexingShortFragment on InfrastructureCoefficientIndexingDto {
  id
  coefficient
}
    `;
export const LocomotiveSeriesTypeBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveSeriesTypeBaseFragment on LocomotiveSeriesTypeDto {
  id
  name
}
    `;
export const LocomotiveSeriesBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveSeriesBaseFragment on LocomotiveSeriesDto {
  id
  entity_id
  series
  index
  section_quantity
  price_rent
  locomotive_traction_type_id
  start_at
}
    `;
export const TractionDirectorateShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TractionDirectorateShortFragment on TractionDirectorateDto {
  entity_id
  name
  short_name
}
    `;
export const LocomotivePriceTechnicalServiceBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotivePriceTechnicalServiceBaseFragment on LocomotivePriceTechnicalServiceDto {
  entity_id
  maintenance_cost
  series_type {
    ...LocomotiveSeriesTypeBaseFragment
  }
  locomotive_series {
    ...LocomotiveSeriesBaseFragment
  }
  traction_directorate {
    ...TractionDirectorateShortFragment
  }
}
    ${LocomotiveSeriesTypeBaseFragmentFragmentDoc}
${LocomotiveSeriesBaseFragmentFragmentDoc}
${TractionDirectorateShortFragmentFragmentDoc}`;
export const LocomotiveSeriesShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveSeriesShortFragment on LocomotiveSeriesDto {
  entity_id
  series
  index
  start_at
}
    `;
export const LocomotiveSeriesTypeShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveSeriesTypeShortFragment on LocomotiveSeriesTypeDto {
  id
  name
}
    `;
export const LocomotiveServiceEmpiricalParameterBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveServiceEmpiricalParameterBaseFragment on LocomotiveServiceEmpiricalParameterDto {
  entity_id
  value
}
    `;
export const LocomotiveTeamPriceRentBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveTeamPriceRentBaseFragment on LocomotiveTeamPriceRentDto {
  entity_id
  price_electric_locomotive_one_person
  price_electric_locomotive_two_person
  price_warm_locomotive_one_person
  price_warm_locomotive_two_person
}
    `;
export const LocomotiveTractionTypeBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveTractionTypeBaseFragment on LocomotiveTractionTypeDto {
  id
  name
  short_name
}
    `;
export const LocomotiveTypeCurrentShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveTypeCurrentShortFragment on LocomotiveTypeCurrentDto {
  id
  name
}
    `;
export const MaxTrainSpeedBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MaxTrainSpeedBaseFragment on MaxTrainSpeedDto {
  id
  entity_id
  created_at
  updated_at
  created_by
  updated_by
  start_at
  end_at
  max_train_speed
}
    `;
export const MnemonicBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MnemonicBaseFragment on MnemonicDto {
  id
  created_at
  updated_at
  created_by
  updated_by
  group_name
  group_name_rus
  mnemonic
  mnemonic_rus
}
    `;
export const MvpsCompanyAffiliationBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MvpsCompanyAffiliationBaseFragment on MvpsCompanyAffiliationDto {
  entity_id
  id
  mvps_owner
  start_at
  end_at
}
    `;
export const MvpsCompanyAffiliationShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MvpsCompanyAffiliationShortFragment on MvpsCompanyAffiliationDto {
  entity_id
  mvps_owner
  start_at
}
    `;
export const MvpsMartinSectionTypeEquipmentShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MvpsMartinSectionTypeEquipmentShortFragment on MvpsMartinSectionTypeEquipmentDto {
  entity_id
  equipment
}
    `;
export const MvpsMartinSectionTypeBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MvpsMartinSectionTypeBaseFragment on MvpsMartinSectionTypeDto {
  id
  entity_id
  start_at
  end_at
  series
  mvps_martin_section_type_equipment_id
  carriage_quantity_in_section
  price
}
    `;
export const MvpsMartinSectionTypeShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MvpsMartinSectionTypeShortFragment on MvpsMartinSectionTypeDto {
  id
  series
  carriage_quantity_in_section
}
    `;
export const MvpsRateManagementExploitationMaintenanceRepairBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MvpsRateManagementExploitationMaintenanceRepairBaseFragment on MvpsRateManagementExploitationMaintenanceRepairDto {
  entity_id
  price
  start_at
  end_at
}
    `;
export const MvpsRateManagementExploitationMaintenanceRepairShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MvpsRateManagementExploitationMaintenanceRepairShortFragment on MvpsRateManagementExploitationMaintenanceRepairDto {
  entity_id
  price
}
    `;
export const NonPassengerCarriageTypeBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NonPassengerCarriageTypeBaseFragment on NonPassengerCarriageTypeDto {
  entity_id
  created_at
  updated_at
  start_at
}
    `;
export const NpsCarriageBrakeTypeBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NpsCarriageBrakeTypeBaseFragment on NpsCarriageBrakeTypeDto {
  id
  entity_id
  start_at
  end_at
  brake_type
  description
}
    `;
export const NpsCarriageDimensionBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NpsCarriageDimensionBaseFragment on NpsCarriageDimensionDto {
  id
  entity_id
  start_at
  end_at
  carriage_dimension
  description
}
    `;
export const NpsCarriageDimensionShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NpsCarriageDimensionShortFragment on NpsCarriageDimensionDto {
  entity_id
  start_at
  end_at
  carriage_dimension
}
    `;
export const NpsCarriageHeatTypeBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NpsCarriageHeatTypeBaseFragment on NpsCarriageHeatTypeDto {
  id
  entity_id
  start_at
  end_at
  heat_type
  description
}
    `;
export const NpsCarriageLengthBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NpsCarriageLengthBaseFragment on NpsCarriageLengthDto {
  id
  entity_id
  start_at
  end_at
  carriage_length_asu_ms
  carriage_length_in_train_schema
  description
}
    `;
export const NpsCarriageModelBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NpsCarriageModelBaseFragment on NpsCarriageModelDto {
  entity_id
  id
  start_at
  end_at
  carriage_model
  description
}
    `;
export const PassengerCarrierBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment PassengerCarrierBaseFragment on PassengerCarrierDto {
  entity_id
  short_name
  name
  code
  mnkodp
  gos
  is_lock
}
    `;
export const RailwayShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RailwayShortFragment on RailwayDto {
  entity_id
  code
  name
  short_name
}
    `;
export const StationShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment StationShortFragment on StationDto {
  entity_id
  full_name
  name_for_schema
  express_code
}
    `;
export const StationShortFragmentWithOperationsFragmentDoc = /*#__PURE__*/ gql`
    fragment StationShortFragmentWithOperations on StationDto {
  ...StationShortFragment
  is_change_locomotive
  is_waste_collection
  is_water_supply
  is_traction_type
  is_electric_speakers_3000V
  is_board_or_disembark
  is_electricity_type
  is_electric_speakers_380V
  is_eco_toilets
  is_border_control
  is_fuel_supply
  is_southbound
  is_change_locomotive_team
  is_maneuver_work
}
    ${StationShortFragmentFragmentDoc}`;
export const StructuralSubdivisionBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment StructuralSubdivisionBaseFragment on StructuralSubdivisionDto {
  entity_id
  short_name
}
    `;
export const TractionDirectorateBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TractionDirectorateBaseFragment on TractionDirectorateDto {
  id
  entity_id
  start_at
  end_at
  name
  short_name
  is_not_in_calculation
}
    `;
export const TrainCategoryBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainCategoryBaseFragment on TrainCategoryDto {
  entity_id
  created_at
  updated_at
  train_category
  start_at
  end_at
}
    `;
export const TrainNumberAutocompleteFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainNumberAutocompleteFragment on TrainDto {
  id
  train_number
  from_station {
    id
    full_name
  }
  to_station {
    id
    full_name
  }
  schedule {
    id
  }
  version
}
    `;
export const TrainSubCategoryShortSpeedFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainSubCategoryShortSpeedFragment on TrainSubCategoryDto {
  entity_id
  short_train_sub_category
  train_sub_category
}
    `;
export const TransportationPerformanceIndicatorsBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TransportationPerformanceIndicatorsBaseFragment on TransportationPerformanceIndicatorDto {
  entity_id
  name
  unit
  unit_short
}
    `;
export const EducationFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment EducationFragment on EducationDto {
  id
  title
  created_at
  updated_at
  content
}
    `;
export const FaqFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment FAQFragment on FaqDto {
  id
  title
  created_at
  updated_at
  content
}
    `;
export const NewsFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsFragment on NewsDto {
  id
  title
  created_at
  updated_at
  content
}
    `;
export const NewsFragmentShortFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsFragmentShort on NewsDto {
  id
  title
  created_at
  updated_at
}
    `;
export const FeatureFlagFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment FeatureFlagFragment on FeatureFlagsDto {
  id
  name
  value
  description
}
    `;
export const IndicatorsTrainBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment IndicatorsTrainBaseFragment on IndicatorsTrainDto {
  train_id
  train_number
  from_station
  to_station
  status
  start_at
  end_at
  route_duration
  railway_administration
  passenger_carrier_russian_railway
  branch
  version
}
    `;
export const IndicatorsTrainShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment IndicatorsTrainShortFragment on IndicatorsTrainDto {
  train_id
  train_number
  from_station
  to_station
  status
  start_at
  end_at
}
    `;
export const MvpsParkRequiredBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MvpsParkRequiredBaseFragment on MvpsParkRequiredDto {
  carriage_type
  seat_type
  departures_quantity
  equipment
  carriage_quantity
}
    `;
export const NpsParkRequiredBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NpsParkRequiredBaseFragment on NpsParkRequiredDto {
  seat_type
  departures_quantity
  carriage_type
}
    `;
export const TrainHeadIndicatorsBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainHeadIndicatorsBaseFragment on TrainHeaderIndicatorsDto {
  train_quantity
  train_turnover
  carriage_quantity
  carriage_quantity_passenger
  average_capacity
  seats_for_sale
  carriage_turnover
  carriage_turnover_passenger
  seats_turnover
}
    `;
export const TrainPerformanceIndicatorsTotalBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainPerformanceIndicatorsTotalBaseFragment on TrainPerformanceIndicatorsSchemaTotalDto {
  departures_quantity
  carriage_group_in_train_distance
  carriage_group_distance
  carriage_group_in_train_turnover
  carriage_group_turnover
  title
  train_quantity
  train_turnover
}
    `;
export const JournalMeActionFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment JournalMeActionFragment on UserActionAuditDto {
  id
  created_at
  action
  target
}
    `;
export const JournalUsersActionFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment JournalUsersActionFragment on UserActionAuditDto {
  id
  created_at
  action
  target
}
    `;
export const LatestVersionFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LatestVersionFragment on LatestVersionDataDto {
  end_at
  is_latest
  start_at
}
    `;
export const LocomotiveServiceBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveServiceBaseFragment on LocomotiveServiceDto {
  id
  start_at
  end_at
  train_number
}
    `;
export const TotalCostsBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TotalCostsBaseFragment on TotalCostsDto {
  total_locomotive_cost
  total_locomotive_team_cost
}
    `;
export const PeriodicityBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment PeriodicityBaseFragment on PeriodicityDto {
  id
  from_date
  metadata
  periodicity
  to_date
}
    `;
export const RangeShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RangeShortFragment on RangeDto {
  end_at
  start_at
}
    `;
export const DivisionFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DivisionFragment on DivisionDto {
  id
  name
  disabled
}
    `;
export const DivisionGroupFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DivisionGroupFragment on DivisionGroupDto {
  id
  name
}
    `;
export const ModuleShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ModuleShortFragment on ModuleDto {
  id
  name
  description
}
    `;
export const RoleBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RoleBaseFragment on RoleDto {
  id
  created_at
  updated_at
  created_by
  updated_by
  name
  is_fpk
}
    `;
export const RoleShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RoleShortFragment on RoleDto {
  id
  name
  is_fpk
}
    `;
export const RuleShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RuleShortFragment on RuleDto {
  id
  method
  description
}
    `;
export const RuleWithModuleFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RuleWithModuleFragment on RuleDto {
  id
  method
  description
  disabled
  module {
    name
    description
  }
}
    `;
export const SchedulerJobFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment SchedulerJobFragment on SchedulerJobDto {
  disable
  id
  name
  time
  command
}
    `;
export const TrainShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainShortFragment on TrainDto {
  id
  train_number
}
    `;
export const TrainQuantityBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainQuantityBaseFragment on TrainQuantityDto {
  id
  created_at
  updated_at
  created_by
  updated_by
  quantity
  departure_dates
  arrival_dates_with_time_stagnation
}
    `;
export const CopyMetaBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CopyMetaBaseFragment on CopyMetaDto {
  direct_train_id
  reverse_train_id
  direct_train_number
  reverse_train_number
  schedule_crate_date
  gvc_name
  gdp_start_at
  gdp_end_at
}
    `;
export const TrainScheduleBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainScheduleBaseFragment on TrainScheduleDto {
  id
  direct_time
  reverse_time
  status
  is_lock
  gvc_name
}
    `;
export const TrainScheduleStencilSingleBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainScheduleStencilSingleBaseFragment on TrainScheduleStencilSingleDto {
  direct_train_number
  reverse_train_number
  direct_train_status
  reverse_train_status
  train_version
  start_at
}
    `;
export const TrainScheduleToStencilFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainScheduleToStencilFragment on TrainScheduleToStencilFragment {
  direct_arrival
  direct_parking
  direct_departure
  reverse_arrival
  reverse_parking
  reverse_departure
  station_name
  is_station_for_parking
}
    `;
export const TrainScheduleStencilSingleFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainScheduleStencilSingleFragment on TrainScheduleStencilSingleDto {
  ...TrainScheduleStencilSingleBaseFragment
  train_schedule_to_stencil_fragments {
    ...TrainScheduleToStencilFragment
    station {
      ...StationShortFragment
    }
  }
}
    ${TrainScheduleStencilSingleBaseFragmentFragmentDoc}
${TrainScheduleToStencilFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;
export const TrainSchemaShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainSchemaShortFragment on TrainSchemaDto {
  id
  train_schema_number
}
    `;
export const TrainSubCategoriesDetailsSpeedBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainSubCategoriesDetailsSpeedBaseFragment on TrainSubCategoriesDetailsSpeedDto {
  entity_id
  created_at
  updated_at
  name
  train_numbers
  start_at
  end_at
}
    `;
export const SessionFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment SessionFragment on SessionInformationDto {
  sid
  browser
  ip
  os
  date
}
    `;
export const UserBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment UserBaseFragment on UserDto {
  id
  full_name
  personal_number
  user_name
  email
  job_position
  expiration_date
  phone_number
  disabled
  is_ldap
  is_need_to_clear_cache
}
    `;
export const TrainBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainBaseFragment on TrainDto {
  id
  entity_id
  is_direct
  arrival_time
  branch_id
  created_at
  departure_time
  individual_name
  train_number
  status
  is_carriage_group_approval
  is_lock
  is_lock_by_status
  is_main
  is_schedule_approval
  is_schema_approval
  active_subdivision_ids
  decline_subdivision_ids
  route_duration
  departure_time
  periodicity
  parent_id
  is_excluded_from_calculation_infrastructure_cost
  version
  start_at
  route_speed
  is_daytime
  note
  stations_recoupling
  other_trains_note
  is_included_in_request_form
  is_locomotive_actual
  is_periodicity_separate_request_form
  is_latest_version
}
    `;
export const TrainSubCategoryShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainSubCategoryShortFragment on TrainSubCategoryDto {
  entity_id
  short_train_sub_category
  train_sub_category
  background_color
  train_category_id
}
    `;
export const MaxTrainSpeedShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MaxTrainSpeedShortFragment on MaxTrainSpeedDto {
  id
  entity_id
  max_train_speed
}
    `;
export const RailwayAdministrationBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RailwayAdministrationBaseFragment on RailwayAdministrationDto {
  id
  entity_id
  name
  short_name
  code
  international_mnemonic
}
    `;
export const PeriodicitySeasonBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment PeriodicitySeasonBaseFragment on PeriodicitySeasonDto {
  id
  entity_id
  start_at
  end_at
  periodicity_season
}
    `;
export const TrainBrandBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainBrandBaseFragment on TrainBrandDto {
  entity_id
  train_brand
  background_color
}
    `;
export const TrainsPairByIdForTrainViewFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainsPairByIdForTrainView on TrainDto {
  ...TrainBaseFragment
  branch {
    ...BranchShortFragment
  }
  to_station {
    ...StationShortFragment
  }
  from_station {
    ...StationShortFragment
  }
  sub_category {
    ...TrainSubCategoryShortFragment
  }
  max_train_speed {
    ...MaxTrainSpeedShortFragment
  }
  railway_administration {
    ...RailwayAdministrationBaseFragment
  }
  periodicity_season {
    ...PeriodicitySeasonBaseFragment
  }
  passenger_carrier {
    ...PassengerCarrierShortFragment
    code
  }
  train_brand {
    ...TrainBrandBaseFragment
  }
  other_trains {
    id
    from_station {
      ...StationShortFragment
    }
    to_station {
      ...StationShortFragment
    }
    other_train {
      id
      train_number
      status
    }
  }
  gdp {
    id
    start_at
    end_at
  }
}
    ${TrainBaseFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}
${TrainSubCategoryShortFragmentFragmentDoc}
${MaxTrainSpeedShortFragmentFragmentDoc}
${RailwayAdministrationBaseFragmentFragmentDoc}
${PeriodicitySeasonBaseFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}
${TrainBrandBaseFragmentFragmentDoc}`;
export const ControlSchemaCompareTableDataFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ControlSchemaCompareTableDataFragment on CapacityRowCompareDto {
  seats_turnover_current
  seats_turnover_current_dereg
  seats_turnover_current_reg
  seats_turnover_compare
  seats_turnover_compare_dereg
  seats_turnover_compare_reg
  seats_quantity_current
  seats_quantity_current_dereg
  seats_quantity_current_reg
  seats_quantity_compare
  seats_quantity_compare_dereg
  seats_quantity_compare_reg
  carriages_turnover_current
  carriages_turnover_current_dereg
  carriages_turnover_current_reg
  carriages_turnover_compare
  carriages_turnover_compare_dereg
  carriages_turnover_compare_reg
  carriages_quantity_current
  carriages_quantity_current_dereg
  carriages_quantity_current_reg
  carriages_quantity_compare
  carriages_quantity_compare_dereg
  carriages_quantity_compare_reg
  trains_turnover_current
  trains_turnover_current_dereg
  trains_turnover_current_reg
  trains_turnover_compare
  trains_turnover_compare_dereg
  trains_turnover_compare_reg
  trains_quantity_current
  trains_quantity_current_dereg
  trains_quantity_current_reg
  trains_quantity_compare
  trains_quantity_compare_dereg
  trains_quantity_compare_reg
  seats_turnover_tolerance
  seats_turnover_tolerance_dereg
  seats_turnover_tolerance_reg
  seats_quantity_tolerance
  seats_quantity_tolerance_dereg
  seats_quantity_tolerance_reg
  carriages_turnover_tolerance
  carriages_turnover_tolerance_dereg
  carriages_turnover_tolerance_reg
  carriages_quantity_tolerance
  carriages_quantity_tolerance_dereg
  carriages_quantity_tolerance_reg
  trains_turnover_tolerance
  trains_turnover_tolerance_dereg
  trains_turnover_tolerance_reg
  trains_quantity_tolerance
  trains_quantity_tolerance_dereg
  trains_quantity_tolerance_reg
}
    `;
export const ControlSchemaCompareTableTotalFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ControlSchemaCompareTableTotalFragment on CapacityCompareTotalDto {
  seats_turnover_current
  seats_turnover_current_dereg
  seats_turnover_current_reg
  seats_turnover_compare
  seats_turnover_compare_dereg
  seats_turnover_compare_reg
  seats_quantity_current
  seats_quantity_current_dereg
  seats_quantity_current_reg
  seats_quantity_compare
  seats_quantity_compare_dereg
  seats_quantity_compare_reg
  carriages_turnover_current
  carriages_turnover_current_dereg
  carriages_turnover_current_reg
  carriages_turnover_compare
  carriages_turnover_compare_dereg
  carriages_turnover_compare_reg
  carriages_quantity_current
  carriages_quantity_current_dereg
  carriages_quantity_current_reg
  carriages_quantity_compare
  carriages_quantity_compare_dereg
  carriages_quantity_compare_reg
  trains_turnover_current
  trains_turnover_current_dereg
  trains_turnover_current_reg
  trains_turnover_compare
  trains_turnover_compare_dereg
  trains_turnover_compare_reg
  trains_quantity_current
  trains_quantity_current_dereg
  trains_quantity_current_reg
  trains_quantity_compare
  trains_quantity_compare_dereg
  trains_quantity_compare_reg
  seats_turnover_tolerance
  seats_turnover_tolerance_dereg
  seats_turnover_tolerance_reg
  seats_quantity_tolerance
  seats_quantity_tolerance_dereg
  seats_quantity_tolerance_reg
  carriages_turnover_tolerance
  carriages_turnover_tolerance_dereg
  carriages_turnover_tolerance_reg
  carriages_quantity_tolerance
  carriages_quantity_tolerance_dereg
  carriages_quantity_tolerance_reg
  trains_turnover_tolerance
  trains_turnover_tolerance_dereg
  trains_turnover_tolerance_reg
  trains_quantity_tolerance
  trains_quantity_tolerance_dereg
  trains_quantity_tolerance_reg
}
    `;
export const ControlSchemaCurrentTableDataFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ControlSchemaCurrentTableDataFragment on CapacityRowCurrentDto {
  seats_turnover_current
  seats_turnover_current_dereg
  seats_turnover_current_reg
  seats_turnover_compare
  seats_turnover_compare_dereg
  seats_turnover_compare_reg
  seats_quantity_current
  seats_quantity_current_dereg
  seats_quantity_current_reg
  seats_quantity_compare
  seats_quantity_compare_dereg
  seats_quantity_compare_reg
  carriages_turnover_current
  carriages_turnover_current_dereg
  carriages_turnover_current_reg
  carriages_turnover_compare
  carriages_turnover_compare_dereg
  carriages_turnover_compare_reg
  carriages_quantity_current
  carriages_quantity_current_dereg
  carriages_quantity_current_reg
  carriages_quantity_compare
  carriages_quantity_compare_dereg
  carriages_quantity_compare_reg
  trains_turnover_current
  trains_turnover_current_dereg
  trains_turnover_current_reg
  trains_turnover_compare
  trains_turnover_compare_dereg
  trains_turnover_compare_reg
  trains_quantity_current
  trains_quantity_current_dereg
  trains_quantity_current_reg
  trains_quantity_compare
  trains_quantity_compare_dereg
  trains_quantity_compare_reg
  seats_turnover_plan
  seats_turnover_plan_dereg
  seats_turnover_plan_reg
  seats_turnover_percentage
  seats_turnover_percentage_dereg
  seats_turnover_percentage_reg
  seats_quantity_plan
  seats_quantity_plan_dereg
  seats_quantity_plan_reg
  seats_quantity_percentage
  seats_quantity_percentage_dereg
  seats_quantity_percentage_reg
  carriages_turnover_plan
  carriages_turnover_plan_dereg
  carriages_turnover_plan_reg
  carriages_turnover_percentage
  carriages_turnover_percentage_dereg
  carriages_turnover_percentage_reg
  carriages_quantity_plan
  carriages_quantity_plan_dereg
  carriages_quantity_plan_reg
  carriages_quantity_percentage
  carriages_quantity_percentage_dereg
  carriages_quantity_percentage_reg
  trains_turnover_plan
  trains_turnover_plan_dereg
  trains_turnover_plan_reg
  trains_turnover_percentage
  trains_turnover_percentage_dereg
  trains_turnover_percentage_reg
  trains_quantity_plan
  trains_quantity_plan_dereg
  trains_quantity_plan_reg
  trains_quantity_percentage
  trains_quantity_percentage_dereg
  trains_quantity_percentage_reg
}
    `;
export const ControlSchemaCurrentTableTotalFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ControlSchemaCurrentTableTotalFragment on CapacityCurrentTotalDto {
  seats_turnover_current
  seats_turnover_current_dereg
  seats_turnover_current_reg
  seats_turnover_compare
  seats_turnover_compare_dereg
  seats_turnover_compare_reg
  seats_quantity_current
  seats_quantity_current_dereg
  seats_quantity_current_reg
  seats_quantity_compare
  seats_quantity_compare_dereg
  seats_quantity_compare_reg
  carriages_turnover_current
  carriages_turnover_current_dereg
  carriages_turnover_current_reg
  carriages_turnover_compare
  carriages_turnover_compare_dereg
  carriages_turnover_compare_reg
  carriages_quantity_current
  carriages_quantity_current_dereg
  carriages_quantity_current_reg
  carriages_quantity_compare
  carriages_quantity_compare_dereg
  carriages_quantity_compare_reg
  trains_turnover_current
  trains_turnover_current_dereg
  trains_turnover_current_reg
  trains_turnover_compare
  trains_turnover_compare_dereg
  trains_turnover_compare_reg
  trains_quantity_current
  trains_quantity_current_dereg
  trains_quantity_current_reg
  trains_quantity_compare
  trains_quantity_compare_dereg
  trains_quantity_compare_reg
  seats_turnover_plan
  seats_turnover_plan_dereg
  seats_turnover_plan_reg
  seats_turnover_percentage
  seats_turnover_percentage_dereg
  seats_turnover_percentage_reg
  seats_quantity_plan
  seats_quantity_plan_dereg
  seats_quantity_plan_reg
  seats_quantity_percentage
  seats_quantity_percentage_dereg
  seats_quantity_percentage_reg
  carriages_turnover_plan
  carriages_turnover_plan_dereg
  carriages_turnover_plan_reg
  carriages_turnover_percentage
  carriages_turnover_percentage_dereg
  carriages_turnover_percentage_reg
  carriages_quantity_plan
  carriages_quantity_plan_dereg
  carriages_quantity_plan_reg
  carriages_quantity_percentage
  carriages_quantity_percentage_dereg
  carriages_quantity_percentage_reg
  trains_turnover_plan
  trains_turnover_plan_dereg
  trains_turnover_plan_reg
  trains_turnover_percentage
  trains_turnover_percentage_dereg
  trains_turnover_percentage_reg
  trains_quantity_plan
  trains_quantity_plan_dereg
  trains_quantity_plan_reg
  trains_quantity_percentage
  trains_quantity_percentage_dereg
  trains_quantity_percentage_reg
}
    `;
export const ControlSchemaTrainDateNmrvagFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ControlSchemaTrainDateNmrvagFragment on ControlSchemaTrainDateNmrvagDto {
  date
  carriage_quantity
  capacity
  seats_available
  diff
}
    `;
export const CarriageGroupIndicatorsFinalCalculationItemBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageGroupIndicatorsFinalCalculationItemBaseFragment on CarriageGroupIndicatorsFinalCalculationItemDto {
  carriage_type
  carriage_turnover_schema
  carriage_turnover_schema_passenger
  carriage_turnover_req
  carriage_turnover_req_passenger
  carriages_quantity
  seats_turnover_schema
  seats_turnover_req
  seats_for_sale
  average_capacity
}
    `;
export const CarriageGroupIndicatorsFinalCalculationTotalItemBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageGroupIndicatorsFinalCalculationTotalItemBaseFragment on CarriageGroupIndicatorsFinalCalculationTotalItemDto {
  carriage_turnover_schema
  carriage_turnover_schema_passenger
  carriage_turnover_req
  carriage_turnover_req_passenger
  carriages_quantity
  seats_turnover_schema
  seats_turnover_req
  seats_for_sale
  average_capacity
}
    `;
export const CarriageDistributionBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageDistributionBaseFragment on TrainIndicatorsCarriagesCountDto {
  carriage_number
  carriage_service_class
  carriage_type
  seats_quantity
}
    `;
export const CarriageDistributionMainGroupBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageDistributionMainGroupBaseFragment on TrainIndicatorsCarriagesDistributionDto {
  seats_quantity
  seats_quantity_k
  seats_quantity_o
  seats_quantity_pl
  seats_quantity_sv
}
    `;
export const CarriageDistributionFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageDistributionFragment on TrainIndicatorsCarriagesDistributionDto {
  carriages_distribution {
    ...CarriageDistributionBaseFragment
  }
  ...CarriageDistributionMainGroupBaseFragment
}
    ${CarriageDistributionBaseFragmentFragmentDoc}
${CarriageDistributionMainGroupBaseFragmentFragmentDoc}`;
export const CarriageTypesBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageTypesBaseFragment on CarriageGroupIndicatorsTypeParamsCountDto {
  carriage_type
  quantity
  seats_quantity
  carriage_classes
}
    `;
export const CarriageQuantityMainGroupBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageQuantityMainGroupBaseFragment on CarriageQuantityMainGroupDto {
  trips_quantity
  carriage_quantity
  train_quantity
  train_turnover
}
    `;
export const CarriageQuantityFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageQuantityFragment on CarriageQuantityMainGroupDto {
  carriage_types {
    ...CarriageTypesBaseFragment
  }
  ...CarriageQuantityMainGroupBaseFragment
}
    ${CarriageTypesBaseFragmentFragmentDoc}
${CarriageQuantityMainGroupBaseFragmentFragmentDoc}`;
export const CompositionSchemaBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CompositionSchemaBaseFragment on CompositionSchemaDto {
  sign
  carriage_group_id
}
    `;
export const EmphasizedTrainItemFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment EmphasizedTrainItemFragment on EmphasizedTrainItemDto {
  train {
    id
    train_number
  }
  is_emphasized
}
    `;
export const EmphasizedStationItemFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment EmphasizedStationItemFragment on EmphasizedStationItemDto {
  station {
    entity_id
    full_name
  }
  is_emphasized
}
    `;
export const CarriageGroupIndicatorsSchemaItemBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageGroupIndicatorsSchemaItemBaseFragment on CarriageGroupIndicatorsSchemaItemDto {
  seat_type
  carriage_type
  carriage_quantity
  seats_quantity
  seats_for_sale
  average_capacity
  carriage_quantity_req
}
    `;
export const CompositionSchemaItemTotalBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CompositionSchemaItemTotalBaseFragment on CompositionSchemaItemTotalDto {
  carriage_quantity
  seats_quantity
  seats_for_sale
  average_capacity
  carriage_quantity_req
}
    `;
export const CompositionSchemaFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CompositionSchemaFragment on CompositionSchemaDto {
  ...CompositionSchemaBaseFragment
  train_numbers {
    ...EmphasizedTrainItemFragment
  }
  route {
    ...EmphasizedStationItemFragment
  }
  items {
    ...CarriageGroupIndicatorsSchemaItemBaseFragment
  }
  passenger_carriages_total {
    ...CompositionSchemaItemTotalBaseFragment
  }
  carriages_total {
    ...CompositionSchemaItemTotalBaseFragment
  }
}
    ${CompositionSchemaBaseFragmentFragmentDoc}
${EmphasizedTrainItemFragmentFragmentDoc}
${EmphasizedStationItemFragmentFragmentDoc}
${CarriageGroupIndicatorsSchemaItemBaseFragmentFragmentDoc}
${CompositionSchemaItemTotalBaseFragmentFragmentDoc}`;
export const CruisingOrderItemBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CruisingOrderItemBaseFragment on CruisingOrderItemDto {
  train_number
  distance
}
    `;
export const CruisingOrderBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CruisingOrderBaseFragment on CruisingOrderDto {
  sign
}
    `;
export const CruisingOrderFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CruisingOrderFragment on CruisingOrderDto {
  train_numbers {
    ...EmphasizedTrainItemFragment
  }
  route {
    ...EmphasizedStationItemFragment
  }
  items {
    station_train_from {
      entity_id
      full_name
    }
    station_train_to {
      entity_id
      full_name
    }
    station_carriage_group_from {
      entity_id
      full_name
    }
    station_carriage_group_to {
      entity_id
      full_name
    }
    ...CruisingOrderItemBaseFragment
  }
  ...CruisingOrderBaseFragment
}
    ${EmphasizedTrainItemFragmentFragmentDoc}
${EmphasizedStationItemFragmentFragmentDoc}
${CruisingOrderItemBaseFragmentFragmentDoc}
${CruisingOrderBaseFragmentFragmentDoc}`;
export const TrainIndicatorsHeaderTrainFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainIndicatorsHeaderTrainFragment on TrainDto {
  train_number
  route_duration
  individual_name
  periodicity
  gdp {
    start_at
    end_at
  }
  from_station {
    entity_id
    full_name
  }
  to_station {
    entity_id
    full_name
  }
  branch {
    entity_id
    name
  }
  sub_category {
    entity_id
    short_train_sub_category
  }
  passenger_carrier {
    entity_id
    name
    short_name
  }
  railway_administration {
    entity_id
    short_name
  }
  status
  version
  entity_id
}
    `;
export const TrainIndicatorsHeaderBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainIndicatorsHeaderBaseFragment on TrainIndicatorsHeaderDto {
  train_quantity
  structural_subdivision_id
  rolling_stock_type
  trips_quantity
  train_schema_ids
  distance
}
    `;
export const TrainIndicatorsHeaderFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainIndicatorsHeaderFragment on TrainIndicatorsHeaderDto {
  structural_subdivision {
    ... on MvpsCompanyAffiliationDto {
      entity_id
      mvps_owner
    }
    ... on StructuralSubdivisionDto {
      entity_id
      short_name
      station {
        full_name
        express_code
      }
    }
  }
  train {
    ...TrainIndicatorsHeaderTrainFragment
  }
  ...TrainIndicatorsHeaderBaseFragment
}
    ${TrainIndicatorsHeaderTrainFragmentFragmentDoc}
${TrainIndicatorsHeaderBaseFragmentFragmentDoc}`;
export const IndicatorsByTrainCarriageTypesOmitTotalBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment IndicatorsByTrainCarriageTypesOmitTotalBaseFragment on IndicatorsByTrainCarriageTypesOmitTotalDto {
  passenger_carriages_total
}
    `;
export const IndicatorsByTrainCarriagesBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment IndicatorsByTrainCarriagesBaseFragment on IndicatorsByTrainCarriagesDto {
  seat_type
  carriage_type
  departures_quantity
}
    `;
export const IndicatorsByTrainCarriageTypesOmitTotalFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment IndicatorsByTrainCarriageTypesOmitTotalFragment on IndicatorsByTrainCarriageTypesOmitTotalDto {
  ...IndicatorsByTrainCarriageTypesOmitTotalBaseFragment
  carriage_departures {
    ...IndicatorsByTrainCarriagesBaseFragment
  }
}
    ${IndicatorsByTrainCarriageTypesOmitTotalBaseFragmentFragmentDoc}
${IndicatorsByTrainCarriagesBaseFragmentFragmentDoc}`;
export const IndicatorsByTrainCarriageTypesBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment IndicatorsByTrainCarriageTypesBaseFragment on IndicatorsByTrainCarriageTypesDto {
  passenger_carriages_total
  carriages_total
}
    `;
export const IndicatorsByTrainCarriageTypesFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment IndicatorsByTrainCarriageTypesFragment on IndicatorsByTrainCarriageTypesDto {
  ...IndicatorsByTrainCarriageTypesBaseFragment
  carriage_departures {
    ...IndicatorsByTrainCarriagesBaseFragment
  }
}
    ${IndicatorsByTrainCarriageTypesBaseFragmentFragmentDoc}
${IndicatorsByTrainCarriagesBaseFragmentFragmentDoc}`;
export const TrainPerformanceIndicatorsSchemaItemBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainPerformanceIndicatorsSchemaItemBaseFragment on TrainPerformanceIndicatorsSchemaItemDto {
  turnover_ids
  sign
  carriage_group_turnover
  carriage_group_in_train_turnover
  carriage_group_distance
  carriage_group_in_train_distance
  departures_quantity
}
    `;
export const TrainPerformanceIndicatorsSchemaItemFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainPerformanceIndicatorsSchemaItemFragment on TrainPerformanceIndicatorsSchemaItemDto {
  train_numbers {
    ...EmphasizedTrainItemFragment
  }
  route {
    ...EmphasizedStationItemFragment
  }
  seats_proposed {
    ...IndicatorsByTrainCarriageTypesOmitTotalFragment
  }
  seats_turnover_req_carriage_group_route {
    ...IndicatorsByTrainCarriageTypesOmitTotalFragment
  }
  seats_turnover_carriage_group_route {
    ...IndicatorsByTrainCarriageTypesOmitTotalFragment
  }
  seats_turnover_train_route {
    ...IndicatorsByTrainCarriageTypesOmitTotalFragment
  }
  seats_turnover_req_train_route {
    ...IndicatorsByTrainCarriageTypesOmitTotalFragment
  }
  carriages_turnover_carriage_group_route {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  carriages_turnover_train_route {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  average_composition_express_forecast {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  carriages_sent {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  average_composition_infrastructure_forecast {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  carriages_turnover_req_carriage_group_route {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  carriages_turnover_req_train_route {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  average_composition_express {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  ...TrainPerformanceIndicatorsSchemaItemBaseFragment
}
    ${EmphasizedTrainItemFragmentFragmentDoc}
${EmphasizedStationItemFragmentFragmentDoc}
${IndicatorsByTrainCarriageTypesOmitTotalFragmentFragmentDoc}
${IndicatorsByTrainCarriageTypesFragmentFragmentDoc}
${TrainPerformanceIndicatorsSchemaItemBaseFragmentFragmentDoc}`;
export const TrainPerformanceIndicatorsSchemaTotalBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainPerformanceIndicatorsSchemaTotalBaseFragment on TrainPerformanceIndicatorsSchemaTotal {
  departures_quantity
  carriage_group_in_train_distance
  carriage_group_distance
  carriage_group_in_train_turnover
  carriage_group_turnover
  title
  train_quantity
  train_turnover
}
    `;
export const TrainPerformanceIndicatorsSchemaTotalFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainPerformanceIndicatorsSchemaTotalFragment on TrainPerformanceIndicatorsSchemaTotal {
  seats_proposed {
    ...IndicatorsByTrainCarriageTypesOmitTotalFragment
  }
  seats_turnover_req_carriage_group_route {
    ...IndicatorsByTrainCarriageTypesOmitTotalFragment
  }
  seats_turnover_carriage_group_route {
    ...IndicatorsByTrainCarriageTypesOmitTotalFragment
  }
  seats_turnover_train_route {
    ...IndicatorsByTrainCarriageTypesOmitTotalFragment
  }
  seats_turnover_req_train_route {
    ...IndicatorsByTrainCarriageTypesOmitTotalFragment
  }
  carriages_turnover_carriage_group_route {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  carriages_turnover_train_route {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  average_composition_express_forecast {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  carriages_sent {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  average_composition_infrastructure_forecast {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  carriages_turnover_req_carriage_group_route {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  carriages_turnover_req_train_route {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  average_composition_express {
    ...IndicatorsByTrainCarriageTypesFragment
  }
  ...TrainPerformanceIndicatorsSchemaTotalBaseFragment
}
    ${IndicatorsByTrainCarriageTypesOmitTotalFragmentFragmentDoc}
${IndicatorsByTrainCarriageTypesFragmentFragmentDoc}
${TrainPerformanceIndicatorsSchemaTotalBaseFragmentFragmentDoc}`;
export const NewTrainShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NewTrainShortFragment on NewTrainDto {
  id
  train_number
}
    `;
export const DashboardTrainFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DashboardTrainFragment on NewTrainDto {
  version
  parent_id
  status
  ...NewTrainShortFragment
  branch {
    ...BranchShortFragment
  }
  from_station {
    ...StationShortFragment
  }
  to_station {
    ...StationShortFragment
  }
  passenger_carrier {
    ...PassengerCarrierShortFragment
  }
  railway_administration {
    ...RailwayAdministrationShortFragment
  }
}
    ${NewTrainShortFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}
${RailwayAdministrationShortFragmentFragmentDoc}`;
export const FpkTrainTotalTrainFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment FpkTrainTotalTrainFragment on TotalTrainDto {
  pairs_count
  main_train_ids
  into_train_info {
    brand_trains_pair {
      main_train_ids
      pairs_count
    }
    daytime_trains_pair {
      main_train_ids
      pairs_count
    }
    fast_trains_pair {
      main_train_ids
      pairs_count
    }
    international_trains_pair {
      main_train_ids
      pairs_count
    }
    interstate_trains_pair {
      main_train_ids
      pairs_count
    }
    kri_trains_pair {
      main_train_ids
      pairs_count
    }
    mvps_trains_pair {
      main_train_ids
      pairs_count
    }
    southbound_trains_pair {
      main_train_ids
      pairs_count
    }
    tpr_trains_pair {
      main_train_ids
      pairs_count
    }
    vr_kb_trains_pair {
      main_train_ids
      pairs_count
    }
  }
}
    `;
export const InfrastructureCalculationByBranchRowBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment InfrastructureCalculationByBranchRowBaseFragment on InfrastructureCalculationByBranchRowDto {
  carriagesDistancePassengerTotal
  carriagesDistanceTotal
  distance
  name
  totalWithNds
  tripsQuantity
}
    `;
export const InfrastructureCalculationByBranchBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment InfrastructureCalculationByBranchBaseFragment on InfrastructureCalculationByBranchDto {
  total {
    ...InfrastructureCalculationByBranchRowBaseFragment
  }
  items {
    ...InfrastructureCalculationByBranchRowBaseFragment
  }
}
    ${InfrastructureCalculationByBranchRowBaseFragmentFragmentDoc}`;
export const LocomotiveFinalCalculationsByDirectoratesItemBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveFinalCalculationsByDirectoratesItemBaseFragment on locomotiveFinalCalculationsByDirectoratesItemDto {
  gas_price
  locomotive_cost
  locomotive_rent_cost
  locomotive_tech_service_price
  name
  power_price
  team_cost
  total_cost
}
    `;
export const MvpsCalculationByBranchItemBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MvpsCalculationByBranchItemBaseFragment on MvpsCalculationByBranchItemDto {
  branch
  control_total
  distance
  rent_total
  route_duration
  to_tr_total
  total
}
    `;
export const MvpsCalculationByBranchBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MvpsCalculationByBranchBaseFragment on MvpsCalculationByBranchDto {
  total_by_branch {
    ...MvpsCalculationByBranchItemBaseFragment
  }
  items_by_branch {
    ...MvpsCalculationByBranchItemBaseFragment
  }
}
    ${MvpsCalculationByBranchItemBaseFragmentFragmentDoc}`;
export const FinalCalculationsTotalRowBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment FinalCalculationsTotalRowBaseFragment on FinalCalculationsTotalRowDto {
  average_composition_total
  average_composition_total_passenger
  average_composition_dereg
  average_composition_reg
  average_composition_other
  train_quantity
  train_distance
  carriage_distance_total
  carriage_distance_total_passenger
  carriage_distance_dereg
  carriage_distance_reg
  carriage_distance_other
  seats_distance_total
  seats_distance_dereg
  seats_distance_reg
}
    `;
export const TrainsPairForSchemesCompareHeaderFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainsPairForSchemesCompareHeaderFragment on TrainDto {
  id
  train_number
  route_duration
  departure_time
  arrival_time
  departure_time
  individual_name
  version
  start_at
  status
  train_brand {
    entity_id
    train_brand
  }
  periodicity_season {
    entity_id
    periodicity_season
  }
  from_station {
    entity_id
    full_name
  }
  to_station {
    entity_id
    full_name
  }
  sub_category {
    train_sub_category
    background_color
  }
  gdp {
    id
    start_at
    end_at
  }
  periodicity
  schedule {
    train_schedule_fragments {
      id
      direct_time_to_station
      direct_departure
      direct_arrival
      reverse_departure
      reverse_arrival
      reverse_time_to_station
    }
  }
}
    `;
export const GdpShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment GdpShortFragment on GdpDto {
  id
  start_at
  end_at
}
    `;
export const TrainSchemaBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainSchemaBaseFragment on TrainSchemaDto {
  id
  train_schema_number
  is_main_group_exported_direct
  is_main_group_exported_reverse
  status
  is_lock
  train_brand_note
  allocation_note
  variable_stencil_info
  variable_stencil_note
  luxury_carriages_note
  luxury_carriages_non_branded_note
  service_class_note
  optional_carriages_note
  is_by_stations_max_train_length
  is_by_stations_established_train_schema
  direct_carriages_note
  trailed_carriages_note
  other_carriages_note
  is_build_due_to_main_train
}
    `;
export const LocomotiveChangeBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveChangeBaseFragment on LocomotiveChangeDto {
  id
  direction
  description
}
    `;
export const LocomotiveChangeFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveChangeFragment on LocomotiveChangeDto {
  ...LocomotiveChangeBaseFragment
  for_station {
    ...StationShortFragment
  }
}
    ${LocomotiveChangeBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;
export const LocomotiveTeamChangeBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveTeamChangeBaseFragment on LocomotiveTeamChangeDto {
  id
  direction
  description
}
    `;
export const LocomotiveTeamChangeFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveTeamChangeFragment on LocomotiveTeamChangeDto {
  ...LocomotiveTeamChangeBaseFragment
  for_station {
    ...StationShortFragment
  }
}
    ${LocomotiveTeamChangeBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;
export const FuelSupplyBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment FuelSupplyBaseFragment on FuelSupplyDto {
  id
  direction
  description
}
    `;
export const FuelSupplyFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment FuelSupplyFragment on FuelSupplyDto {
  ...FuelSupplyBaseFragment
  for_station {
    ...StationShortFragment
  }
}
    ${FuelSupplyBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;
export const BorderControlBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment BorderControlBaseFragment on BorderControlDto {
  id
  direction
  description
}
    `;
export const StationBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment StationBaseFragment on StationDto {
  id
  entity_id
  is_board_or_disembark
  is_border_control
  is_change_locomotive
  is_change_locomotive_team
  comment
  is_eco_toilets
  is_electric_speakers_380V
  is_electric_speakers_3000V
  is_electricity_type
  esr_code
  is_city
  is_not_terminal_rgd
  express_code
  is_fuel_supply
  full_name
  name_for_schema
  railway_id
  is_route_forming
  is_service_not_train_route
  is_traction_type
  is_waste_collection
  is_water_supply
  is_southbound
  end_at
  is_maneuver_work
  start_at
  id_external
}
    `;
export const BorderControlFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment BorderControlFragment on BorderControlDto {
  ...BorderControlBaseFragment
  for_station {
    ...StationBaseFragment
  }
}
    ${BorderControlBaseFragmentFragmentDoc}
${StationBaseFragmentFragmentDoc}`;
export const EcoToiletsBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment EcoToiletsBaseFragment on EcoToiletDto {
  id
  direction
  description
}
    `;
export const EcoToiletsFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment EcoToiletsFragment on EcoToiletDto {
  ...EcoToiletsBaseFragment
  for_station {
    ...StationShortFragment
  }
}
    ${EcoToiletsBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;
export const WaterSupplyBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment WaterSupplyBaseFragment on WaterSupplyDto {
  id
  direction
  description
}
    `;
export const WaterSupplyFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment WaterSupplyFragment on WaterSupplyDto {
  ...WaterSupplyBaseFragment
  for_station {
    ...StationShortFragment
  }
}
    ${WaterSupplyBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;
export const WasteCollectionBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment WasteCollectionBaseFragment on WasteCollectionDto {
  id
  direction
  description
}
    `;
export const WasteCollectionFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment WasteCollectionFragment on WasteCollectionDto {
  ...WasteCollectionBaseFragment
  for_station {
    ...StationShortFragment
  }
}
    ${WasteCollectionBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;
export const PeriodicityInfoBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment PeriodicityInfoBaseFragment on PeriodicityInfoDto {
  id
  departure_dates
  arrival_dates
  departure_dates_out_of_gdp
  arrival_dates_out_of_gdp
}
    `;
export const CarriageNumerationBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageNumerationBaseFragment on CarriageNumerationDto {
  id
  direct_position
  reverse_position
  description
}
    `;
export const CarriageNumerationFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageNumerationFragment on CarriageNumerationDto {
  ...CarriageNumerationBaseFragment
  reverse_to_station {
    ...StationShortFragment
  }
  reverse_from_station {
    ...StationShortFragment
  }
  direct_from_station {
    ...StationShortFragment
  }
  direct_to_station {
    ...StationShortFragment
  }
}
    ${CarriageNumerationBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;
export const CarriageAllocationBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageAllocationBaseFragment on CarriageAllocationDto {
  id
  carriage_number
  seats
  appointment
  description
}
    `;
export const CarriageClassesBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CarriageClassesBaseFragment on CarriageClassDto {
  id
  carriage_number
  class
  note
}
    `;
export const DirectCarriagesBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DirectCarriagesBaseFragment on DirectCarriageDto {
  id
  carriage_numbers
  description
}
    `;
export const DirectCarriagesInfoBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DirectCarriagesInfoBaseFragment on DirectCarriageInfoDto {
  id
  position_from_station
  position_to_station
  departure_dates
  arrival_dates
  missed_arrival_dates
  missed_departure_dates
}
    `;
export const DirectCarriagesInfoFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DirectCarriagesInfoFragment on DirectCarriageInfoDto {
  ...DirectCarriagesInfoBaseFragment
  from_station {
    id
    full_name
  }
  to_station {
    id
    full_name
  }
  train {
    id
    train_number
  }
}
    ${DirectCarriagesInfoBaseFragmentFragmentDoc}`;
export const DirectCarriagesFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DirectCarriagesFragment on DirectCarriageDto {
  ...DirectCarriagesBaseFragment
  direct_carriages_info {
    ...DirectCarriagesInfoFragment
  }
}
    ${DirectCarriagesBaseFragmentFragmentDoc}
${DirectCarriagesInfoFragmentFragmentDoc}`;
export const EstablishedTrainSchemaStationFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment EstablishedTrainSchemaStationFragment on EstablishedTrainSchemaStationDto {
  id
  direct_carriage_quantity
  description
  direct_from_station {
    ...StationShortFragment
  }
  direct_to_station {
    ...StationShortFragment
  }
  reverse_carriage_quantity
  reverse_from_station {
    ...StationShortFragment
  }
  reverse_to_station {
    ...StationShortFragment
  }
}
    ${StationShortFragmentFragmentDoc}`;
export const RailwayBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RailwayBaseFragment on RailwayDto {
  id
  entity_id
  code
  name
  short_name
  timezone
}
    `;
export const EstablishedTrainSchemaRailwayFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment EstablishedTrainSchemaRailwayFragment on EstablishedTrainSchemaRailwayDto {
  id
  direct_carriage_quantity
  description
  direct_railway {
    ...RailwayBaseFragment
  }
  reverse_carriage_quantity
  reverse_railway {
    ...RailwayBaseFragment
  }
}
    ${RailwayBaseFragmentFragmentDoc}`;
export const MaxTrainLengthRailwayBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MaxTrainLengthRailwayBaseFragment on MaxTrainLengthRailwayDto {
  id
  direct_carriage_quantity
  reverse_carriage_quantity
  description
}
    `;
export const MaxTrainLengthRailwayFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MaxTrainLengthRailwayFragment on MaxTrainLengthRailwayDto {
  direct_railway {
    ...RailwayBaseFragment
  }
  reverse_railway {
    ...RailwayBaseFragment
  }
  ...MaxTrainLengthRailwayBaseFragment
}
    ${RailwayBaseFragmentFragmentDoc}
${MaxTrainLengthRailwayBaseFragmentFragmentDoc}`;
export const MaxTrainLengthStationBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MaxTrainLengthStationBaseFragment on MaxTrainLengthStationDto {
  id
  direct_carriage_quantity
  reverse_carriage_quantity
  description
}
    `;
export const MaxTrainLengthStationFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MaxTrainLengthStationFragment on MaxTrainLengthStationDto {
  direct_to_station {
    ...StationShortFragment
  }
  reverse_to_station {
    ...StationShortFragment
  }
  direct_from_station {
    ...StationShortFragment
  }
  reverse_from_station {
    ...StationShortFragment
  }
  ...MaxTrainLengthStationBaseFragment
}
    ${StationShortFragmentFragmentDoc}
${MaxTrainLengthStationBaseFragmentFragmentDoc}`;
export const LuxuryCarriagesBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LuxuryCarriagesBaseFragment on LuxuryCarriageDto {
  id
  carriages_with_service
  carriages_non_branded
}
    `;
export const ManeuveringWorkBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ManeuveringWorkBaseFragment on ManeuveringWorkDto {
  id
  direction
  description
}
    `;
export const ManeuveringWorkFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ManeuveringWorkFragment on ManeuveringWorkDto {
  ...ManeuveringWorkBaseFragment
  for_station {
    ...StationShortFragment
  }
}
    ${ManeuveringWorkBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;
export const OptionalCarriageBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment OptionalCarriageBaseFragment on OptionalCarriageDto {
  id
  carriage_numbers
}
    `;
export const OtherCarriageBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment OtherCarriageBaseFragment on OtherCarriageDto {
  id
  carriage_numbers
  description
}
    `;
export const OtherCarriageInfoBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment OtherCarriageInfoBaseFragment on OtherCarriageInfoDto {
  id
  position_from_station
  position_to_station
  departure_dates
  arrival_dates
  missed_arrival_dates
  missed_departure_dates
}
    `;
export const OtherCarriageInfoFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment OtherCarriageInfoFragment on OtherCarriageInfoDto {
  ...OtherCarriageInfoBaseFragment
  from_station {
    id
    full_name
  }
  to_station {
    id
    full_name
  }
  train {
    id
    train_number
  }
}
    ${OtherCarriageInfoBaseFragmentFragmentDoc}`;
export const OtherCarriageFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment OtherCarriageFragment on OtherCarriageDto {
  ...OtherCarriageBaseFragment
  other_carriages_info {
    ...OtherCarriageInfoFragment
  }
}
    ${OtherCarriageBaseFragmentFragmentDoc}
${OtherCarriageInfoFragmentFragmentDoc}`;
export const TrailedCarriageBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedCarriageBaseFragment on TrailedCarriageDto {
  id
  carriage_numbers
  description
}
    `;
export const TrailedCarriageInfoBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedCarriageInfoBaseFragment on TrailedCarriageInfoDto {
  id
  position_from_station
  position_to_station
  departure_dates
  arrival_dates
  missed_arrival_dates
  missed_departure_dates
}
    `;
export const TrailedCarriageInfoFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedCarriageInfoFragment on TrailedCarriageInfoDto {
  ...TrailedCarriageInfoBaseFragment
  from_station {
    id
    full_name
  }
  to_station {
    id
    full_name
  }
  train {
    id
    train_number
  }
}
    ${TrailedCarriageInfoBaseFragmentFragmentDoc}`;
export const TrailedCarriageFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrailedCarriageFragment on TrailedCarriageDto {
  ...TrailedCarriageBaseFragment
  trailed_carriages_info {
    ...TrailedCarriageInfoFragment
  }
}
    ${TrailedCarriageBaseFragmentFragmentDoc}
${TrailedCarriageInfoFragmentFragmentDoc}`;
export const TrainChangeDirectionBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainChangeDirectionBaseFragment on TrainChangeDirectionDto {
  id
  direction
  description
}
    `;
export const TrainChangeDirectionFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainChangeDirectionFragment on TrainChangeDirectionDto {
  for_station {
    ...StationShortFragment
  }
  ...TrainChangeDirectionBaseFragment
}
    ${StationShortFragmentFragmentDoc}
${TrainChangeDirectionBaseFragmentFragmentDoc}`;
export const TableBlockRowBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TableBlockRowBaseFragment on TableBlockRowDto {
  id
  seats_allocated
  carriage_number
  carriage_type
  carriage_seat_type
  seats_quantity
}
    `;
export const InCommonCirculationWithTrainsShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment InCommonCirculationWithTrainsShortFragment on TableBlockDto {
  in_common_circulation_with_trains {
    id
    train_number
  }
}
    `;
export const TableBlockBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TableBlockBaseFragment on TableBlockDto {
  id
  in_common_circulation_with
  ...InCommonCirculationWithTrainsShortFragment
  heat
  carriage_group_id
  train_quantity
  affiliation
  break
  eco_toilet
  air_conditioner
  is_accepted
  is_collapsed
  is_excluded_from_export
  is_main_group
  is_excluded_from_table_calculations
}
    ${InCommonCirculationWithTrainsShortFragmentFragmentDoc}`;
export const TableBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TableBaseFragment on TableDto {
  id
  second_class_total
  second_class_allocated_total
  common_total
  common_allocated_total
  direction
  sv_total
  sv_allocated_total
  coupe_total
  coupe_allocated_total
}
    `;
export const TrainsPairForCompareSchemesViewFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainsPairForCompareSchemesViewFragment on TrainDto {
  ...TrainBaseFragment
  from_station {
    ...StationShortFragment
  }
  to_station {
    ...StationShortFragment
  }
  periodicity_season {
    entity_id
    periodicity_season
  }
  train_brand {
    entity_id
    train_brand
    background_color
  }
  sub_category {
    entity_id
  }
  gdp {
    ...GdpShortFragment
  }
  schemas {
    ...TrainSchemaBaseFragment
    locomotive_change {
      ...LocomotiveChangeFragment
    }
    locomotive_team_change {
      ...LocomotiveTeamChangeFragment
    }
    fuel_supply {
      ...FuelSupplyFragment
    }
    border_control {
      ...BorderControlFragment
    }
    eco_toilets {
      ...EcoToiletsFragment
    }
    water_supply {
      ...WaterSupplyFragment
    }
    waste_collection {
      ...WasteCollectionFragment
    }
    periodicity {
      ...PeriodicityInfoBaseFragment
      train {
        id
        train_number
      }
    }
    carriage_numerations {
      ...CarriageNumerationFragment
    }
    carriage_allocations {
      ...CarriageAllocationBaseFragment
    }
    carriage_classes {
      ...CarriageClassesBaseFragment
    }
    direct_carriages {
      ...DirectCarriagesFragment
    }
    established_train_schema {
      ... on EstablishedTrainSchemaStationDto {
        ...EstablishedTrainSchemaStationFragment
      }
      ... on EstablishedTrainSchemaRailwayDto {
        ...EstablishedTrainSchemaRailwayFragment
      }
    }
    max_train_length {
      ... on MaxTrainLengthRailwayDto {
        ...MaxTrainLengthRailwayFragment
      }
      ... on MaxTrainLengthStationDto {
        ...MaxTrainLengthStationFragment
      }
    }
    luxury_carriages {
      ...LuxuryCarriagesBaseFragment
    }
    maneuvering_work {
      ...ManeuveringWorkFragment
    }
    optional_carriages {
      ...OptionalCarriageBaseFragment
    }
    other_carriages {
      ...OtherCarriageFragment
    }
    trailed_carriages {
      ...TrailedCarriageFragment
    }
    train_change_directions {
      ...TrainChangeDirectionFragment
    }
    tables {
      table_blocks {
        table_block_rows {
          ...TableBlockRowBaseFragment
          stations {
            full_name
          }
        }
        ...TableBlockBaseFragment
      }
      ...TableBaseFragment
    }
  }
}
    ${TrainBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}
${GdpShortFragmentFragmentDoc}
${TrainSchemaBaseFragmentFragmentDoc}
${LocomotiveChangeFragmentFragmentDoc}
${LocomotiveTeamChangeFragmentFragmentDoc}
${FuelSupplyFragmentFragmentDoc}
${BorderControlFragmentFragmentDoc}
${EcoToiletsFragmentFragmentDoc}
${WaterSupplyFragmentFragmentDoc}
${WasteCollectionFragmentFragmentDoc}
${PeriodicityInfoBaseFragmentFragmentDoc}
${CarriageNumerationFragmentFragmentDoc}
${CarriageAllocationBaseFragmentFragmentDoc}
${CarriageClassesBaseFragmentFragmentDoc}
${DirectCarriagesFragmentFragmentDoc}
${EstablishedTrainSchemaStationFragmentFragmentDoc}
${EstablishedTrainSchemaRailwayFragmentFragmentDoc}
${MaxTrainLengthRailwayFragmentFragmentDoc}
${MaxTrainLengthStationFragmentFragmentDoc}
${LuxuryCarriagesBaseFragmentFragmentDoc}
${ManeuveringWorkFragmentFragmentDoc}
${OptionalCarriageBaseFragmentFragmentDoc}
${OtherCarriageFragmentFragmentDoc}
${TrailedCarriageFragmentFragmentDoc}
${TrainChangeDirectionFragmentFragmentDoc}
${TableBlockRowBaseFragmentFragmentDoc}
${TableBlockBaseFragmentFragmentDoc}
${TableBaseFragmentFragmentDoc}`;
export const TrainsPairForOtherTrainsViewFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainsPairForOtherTrainsViewFragment on TrainDto {
  ...TrainBaseFragment
  other_trains {
    id
    from_station {
      ...StationShortFragment
    }
    to_station {
      ...StationShortFragment
    }
    other_train {
      id
      train_number
      from_station {
        ...StationShortFragment
      }
      to_station {
        ...StationShortFragment
      }
    }
  }
}
    ${TrainBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;
export const RelatedTrainsBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RelatedTrainsBaseFragment on RelatedTrainsDto {
  id
  train_number
  to_station
  from_station
  branch
  status
  level
}
    `;
export const GdpBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment GdpBaseFragment on GdpDto {
  id
  created_at
  updated_at
  created_by
  updated_by
  start_at
  end_at
}
    `;
export const UserShortFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment UserShortFragment on UserDto {
  id
  full_name
  personal_number
}
    `;
export const TrainScheduleFragmentBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainScheduleFragmentBaseFragment on TrainScheduleFragmentDto {
  id
  created_at
  updated_at
  created_by
  updated_by
  order_number
  direct_train_number
  direct_departure
  direct_arrival
  direct_parking
  direct_time_to_station
  is_direct_schedule_technical_parking
  reverse_train_number
  reverse_departure
  reverse_arrival
  reverse_parking
  reverse_time_to_station
  is_reverse_schedule_technical_parking
  distance
  train_schedule_id
}
    `;
export const TrainsPairForTrainViewFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainsPairForTrainViewFragment on TrainDto {
  ...TrainBaseFragment
  periodicity_season {
    id
    entity_id
    periodicity_season
  }
  train_brand {
    id
    entity_id
    train_brand
    background_color
  }
  sub_category {
    entity_id
    train_sub_category
    background_color
  }
  from_station {
    ...StationShortFragment
  }
  to_station {
    ...StationShortFragment
  }
  gdp {
    ...GdpBaseFragment
  }
  lock_user {
    ...UserShortFragment
    email
    phone_number
    job_position
    branch {
      ...BranchShortFragment
    }
  }
  schedule {
    train_schedule_fragments {
      ...TrainScheduleFragmentBaseFragment
    }
  }
}
    ${TrainBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}
${GdpBaseFragmentFragmentDoc}
${UserShortFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${TrainScheduleFragmentBaseFragmentFragmentDoc}`;
export const CommonTrainPairInfoFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment CommonTrainPairInfoFragment on TrainDto {
  ...TrainBaseFragment
  branch {
    ...BranchShortFragment
  }
  periodicity_season {
    ...PeriodicitySeasonBaseFragment
  }
  train_brand {
    ...TrainBrandBaseFragment
  }
  sub_category {
    ...TrainSubCategoryShortFragment
  }
  from_station {
    ...StationShortFragment
  }
  to_station {
    ...StationShortFragment
  }
  gdp {
    ...GdpShortFragment
  }
  max_train_speed {
    ...MaxTrainSpeedShortFragment
  }
  railway_administration {
    ...RailwayAdministrationBaseFragment
  }
  passenger_carrier {
    ...PassengerCarrierShortFragment
    code
  }
  other_trains {
    id
    from_station {
      ...StationShortFragment
    }
    to_station {
      ...StationShortFragment
    }
    other_train {
      id
      train_number
      status
    }
  }
  lock_user {
    ...UserShortFragment
    email
    phone_number
    job_position
    branch {
      ...BranchShortFragment
    }
  }
  schedule {
    id
    train_schedule_fragments {
      direct_arrival
      direct_departure
      reverse_arrival
      reverse_departure
      direct_time_to_station
      reverse_time_to_station
      station {
        entity_id
      }
    }
  }
  schemas {
    id
    train_schema_number
  }
  parent {
    id
    train_number
    pair_train {
      id
      train_number
    }
  }
  is_marked_to_delete
}
    ${TrainBaseFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${PeriodicitySeasonBaseFragmentFragmentDoc}
${TrainBrandBaseFragmentFragmentDoc}
${TrainSubCategoryShortFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}
${GdpShortFragmentFragmentDoc}
${MaxTrainSpeedShortFragmentFragmentDoc}
${RailwayAdministrationBaseFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}
${UserShortFragmentFragmentDoc}`;
export const TotalCalculationsForLocomotiveAreaFragmentDoc = /*#__PURE__*/ gql`
    fragment TotalCalculationsForLocomotiveArea on LocomotivesAreasCalculationsDto {
  id
  train_schema_id
  period_total {
    locomotive_areas_total_cost {
      traction_directorate_id
      traction_directorate {
        ...TractionDirectorateShortFragment
      }
      trip_cost
    }
    locomotive_areas_trip_total_cost
    locomotive_team_areas_total_cost {
      traction_directorate_id
      traction_directorate {
        ...TractionDirectorateShortFragment
      }
      trip_cost
    }
    locomotive_team_areas_trip_total_cost
    overall_total_cost {
      traction_directorate_id
      traction_directorate {
        ...TractionDirectorateShortFragment
      }
      trip_cost
    }
    overall_trip_total_cost
  }
  trip_total {
    locomotive_areas_total_cost {
      traction_directorate_id
      traction_directorate {
        ...TractionDirectorateShortFragment
      }
      trip_cost
    }
    locomotive_areas_trip_total_cost
    locomotive_team_areas_total_cost {
      traction_directorate_id
      traction_directorate {
        ...TractionDirectorateShortFragment
      }
      trip_cost
    }
    locomotive_team_areas_trip_total_cost
    overall_total_cost {
      traction_directorate_id
      traction_directorate {
        ...TractionDirectorateShortFragment
      }
      trip_cost
    }
    overall_trip_total_cost
  }
}
    ${TractionDirectorateShortFragmentFragmentDoc}`;
export const LocomotiveAreaBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveAreaBaseFragment on LocomotiveAreaDto {
  id
  locomotive_series_id
  traction_directorate_id
  from_station_id
  to_station_id
  distance
  trip_time
  trip_cost
  is_valid
  order_number
  is_main_group_check
}
    `;
export const LocomotiveTypeCurrentBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveTypeCurrentBaseFragment on LocomotiveTypeCurrentDto {
  id
  name
}
    `;
export const LocomotiveTeamAreaBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment LocomotiveTeamAreaBaseFragment on LocomotiveTeamAreaDto {
  id
  traction_directorate_id
  persons_quantity
  from_station_id
  to_station_id
  distance
  trip_time
  trip_cost
}
    `;
export const TrainsPairForLocomotiveAreaFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainsPairForLocomotiveArea on TrainDto {
  id
  train_number
  branch_id
  status
  sub_category {
    entity_id
  }
  train_schedule_id
  gdp {
    ...GdpBaseFragment
  }
  lock_user {
    ...UserShortFragment
  }
  locomotives_service {
    id
    train_schema_id
    train_schema {
      id
      train_schema_number
    }
    locomotive_areas {
      ...LocomotiveAreaBaseFragment
      types_current {
        id
        from_station {
          ...StationShortFragment
        }
        to_station {
          ...StationShortFragment
        }
        locomotive_type_current {
          ...LocomotiveTypeCurrentBaseFragment
        }
      }
      from_station {
        ...StationShortFragment
      }
      to_station {
        ...StationShortFragment
      }
      locomotive_series {
        ...LocomotiveSeriesBaseFragment
        locomotive_traction_type {
          id
          name
        }
      }
      traction_directorate {
        ...TractionDirectorateShortFragment
      }
      team_areas {
        ...LocomotiveTeamAreaBaseFragment
        from_station {
          ...StationShortFragment
        }
        to_station {
          ...StationShortFragment
        }
        traction_directorate {
          ...TractionDirectorateShortFragment
        }
      }
    }
  }
}
    ${GdpBaseFragmentFragmentDoc}
${UserShortFragmentFragmentDoc}
${LocomotiveAreaBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}
${LocomotiveTypeCurrentBaseFragmentFragmentDoc}
${LocomotiveSeriesBaseFragmentFragmentDoc}
${TractionDirectorateShortFragmentFragmentDoc}
${LocomotiveTeamAreaBaseFragmentFragmentDoc}`;
export const RelatedTrainsFragmentsFragmentDoc = /*#__PURE__*/ gql`
    fragment RelatedTrainsFragments on RelatedTrainsDto {
  id
  to_station
  from_station
  train_number
  status
}
    `;
export const NewTrainBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NewTrainBaseFragment on NewTrainDto {
  id
  entity_id
  is_direct
  arrival_time
  branch_id
  created_at
  start_at
  departure_time
  individual_name
  train_number
  status
  is_carriage_group_approval
  is_lock
  is_lock_by_status
  is_main
  is_schedule_approval
  is_schema_approval
  active_subdivision_ids
  decline_subdivision_ids
  route_duration
  departure_time
  periodicity
  parent_id
  is_excluded_from_calculation_infrastructure_cost
  version
  is_included_in_request_form
  is_periodicity_separate_request_form
}
    `;
export const TrainSubCategoryBaseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainSubCategoryBaseFragment on TrainSubCategoryDto {
  entity_id
  train_sub_category
  short_train_sub_category
  created_at
  updated_at
  background_color
  start_at
  end_at
  train_numbers
}
    `;
export const NewTrainFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NewTrainFragment on NewTrainDto {
  ...NewTrainBaseFragment
  branch {
    ...BranchShortFragment
  }
  from_station {
    ...StationShortFragment
  }
  passenger_carrier {
    ...PassengerCarrierShortFragment
  }
  periodicity_season {
    ...PeriodicitySeasonBaseFragment
  }
  railway_administration {
    ...RailwayAdministrationBaseFragment
  }
  to_station {
    ...StationShortFragment
  }
  train_brand {
    ...TrainBrandBaseFragment
  }
  sub_category {
    ...TrainSubCategoryBaseFragment
  }
  category {
    entity_id
    train_category
  }
  lock_user {
    ...UserShortFragment
    branch {
      entity_id
      short_name
    }
  }
  parent {
    id
    train_number
    pair_train {
      id
      train_number
    }
  }
  is_marked_to_delete
}
    ${NewTrainBaseFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}
${PeriodicitySeasonBaseFragmentFragmentDoc}
${RailwayAdministrationBaseFragmentFragmentDoc}
${TrainBrandBaseFragmentFragmentDoc}
${TrainSubCategoryBaseFragmentFragmentDoc}
${UserShortFragmentFragmentDoc}`;
export const RequestFormTrainListFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RequestFormTrainListFragment on NewTrainDto {
  version
  parent_id
  status
  ...NewTrainShortFragment
  branch {
    ...BranchShortFragment
  }
  from_station {
    ...StationShortFragment
  }
  to_station {
    ...StationShortFragment
  }
}
    ${NewTrainShortFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;
export const AvailableServiceClassCreateDocument = /*#__PURE__*/ gql`
    mutation availableServiceClassCreate($data: CreateAvailableServiceClassDto!) {
  classifiers {
    availableServiceClass {
      create(data: $data) {
        entity_id
        service_class
      }
    }
  }
}
    `;
export type AvailableServiceClassCreateMutationFn = Apollo.MutationFunction<AvailableServiceClassCreateMutation, AvailableServiceClassCreateMutationVariables>;

/**
 * __useAvailableServiceClassCreateMutation__
 *
 * To run a mutation, you first call `useAvailableServiceClassCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAvailableServiceClassCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [availableServiceClassCreateMutation, { data, loading, error }] = useAvailableServiceClassCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAvailableServiceClassCreateMutation(baseOptions?: Apollo.MutationHookOptions<AvailableServiceClassCreateMutation, AvailableServiceClassCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AvailableServiceClassCreateMutation, AvailableServiceClassCreateMutationVariables>(AvailableServiceClassCreateDocument, options);
      }
export type AvailableServiceClassCreateMutationHookResult = ReturnType<typeof useAvailableServiceClassCreateMutation>;
export type AvailableServiceClassCreateMutationResult = Apollo.MutationResult<AvailableServiceClassCreateMutation>;
export type AvailableServiceClassCreateMutationOptions = Apollo.BaseMutationOptions<AvailableServiceClassCreateMutation, AvailableServiceClassCreateMutationVariables>;
export const AvailableServiceClassListFieldDocument = /*#__PURE__*/ gql`
    query availableServiceClassListField($paginate: PaginatorArgsDto, $orderBy: [AvailableServiceClassQueryResolver_List_SortingInputType!], $where: AvailableServiceClassQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    availableServiceClass {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...AvailableServiceClassBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${AvailableServiceClassBaseFragmentFragmentDoc}`;

/**
 * __useAvailableServiceClassListFieldQuery__
 *
 * To run a query within a React component, call `useAvailableServiceClassListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableServiceClassListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableServiceClassListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useAvailableServiceClassListFieldQuery(baseOptions: Apollo.QueryHookOptions<AvailableServiceClassListFieldQuery, AvailableServiceClassListFieldQueryVariables> & ({ variables: AvailableServiceClassListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableServiceClassListFieldQuery, AvailableServiceClassListFieldQueryVariables>(AvailableServiceClassListFieldDocument, options);
      }
export function useAvailableServiceClassListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableServiceClassListFieldQuery, AvailableServiceClassListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableServiceClassListFieldQuery, AvailableServiceClassListFieldQueryVariables>(AvailableServiceClassListFieldDocument, options);
        }
export function useAvailableServiceClassListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableServiceClassListFieldQuery, AvailableServiceClassListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableServiceClassListFieldQuery, AvailableServiceClassListFieldQueryVariables>(AvailableServiceClassListFieldDocument, options);
        }
export type AvailableServiceClassListFieldQueryHookResult = ReturnType<typeof useAvailableServiceClassListFieldQuery>;
export type AvailableServiceClassListFieldLazyQueryHookResult = ReturnType<typeof useAvailableServiceClassListFieldLazyQuery>;
export type AvailableServiceClassListFieldSuspenseQueryHookResult = ReturnType<typeof useAvailableServiceClassListFieldSuspenseQuery>;
export type AvailableServiceClassListFieldQueryResult = Apollo.QueryResult<AvailableServiceClassListFieldQuery, AvailableServiceClassListFieldQueryVariables>;
export const BranchListFieldDocument = /*#__PURE__*/ gql`
    query branchListField($where: BranchQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    branch {
      list(
        paginate: {per_page: 100, page: 0}
        where: $where
        data: {range: $range}
        order_by: [{entity_id: ASC}]
      ) {
        items {
          ...BranchShortFragment
        }
      }
    }
  }
}
    ${BranchShortFragmentFragmentDoc}`;

/**
 * __useBranchListFieldQuery__
 *
 * To run a query within a React component, call `useBranchListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useBranchListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBranchListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useBranchListFieldQuery(baseOptions: Apollo.QueryHookOptions<BranchListFieldQuery, BranchListFieldQueryVariables> & ({ variables: BranchListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BranchListFieldQuery, BranchListFieldQueryVariables>(BranchListFieldDocument, options);
      }
export function useBranchListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BranchListFieldQuery, BranchListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BranchListFieldQuery, BranchListFieldQueryVariables>(BranchListFieldDocument, options);
        }
export function useBranchListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BranchListFieldQuery, BranchListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BranchListFieldQuery, BranchListFieldQueryVariables>(BranchListFieldDocument, options);
        }
export type BranchListFieldQueryHookResult = ReturnType<typeof useBranchListFieldQuery>;
export type BranchListFieldLazyQueryHookResult = ReturnType<typeof useBranchListFieldLazyQuery>;
export type BranchListFieldSuspenseQueryHookResult = ReturnType<typeof useBranchListFieldSuspenseQuery>;
export type BranchListFieldQueryResult = Apollo.QueryResult<BranchListFieldQuery, BranchListFieldQueryVariables>;
export const CarriageAdditionalSeatSignListFieldDocument = /*#__PURE__*/ gql`
    query carriageAdditionalSeatSignListField($range: RangeInputDto!, $paginate: PaginatorArgsDto, $orderBy: [CarriageAdditionalSeatSignQueryResolver_List_SortingInputType!], $where: CarriageAdditionalSeatSignQueryResolver_List_FilterInputType) {
  classifiers {
    carriageAdditionalSeatSign {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...CarriageAdditionalSeatSignBaseFragment
        }
      }
    }
  }
}
    ${CarriageAdditionalSeatSignBaseFragmentFragmentDoc}`;

/**
 * __useCarriageAdditionalSeatSignListFieldQuery__
 *
 * To run a query within a React component, call `useCarriageAdditionalSeatSignListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageAdditionalSeatSignListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageAdditionalSeatSignListFieldQuery({
 *   variables: {
 *      range: // value for 'range'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCarriageAdditionalSeatSignListFieldQuery(baseOptions: Apollo.QueryHookOptions<CarriageAdditionalSeatSignListFieldQuery, CarriageAdditionalSeatSignListFieldQueryVariables> & ({ variables: CarriageAdditionalSeatSignListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageAdditionalSeatSignListFieldQuery, CarriageAdditionalSeatSignListFieldQueryVariables>(CarriageAdditionalSeatSignListFieldDocument, options);
      }
export function useCarriageAdditionalSeatSignListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageAdditionalSeatSignListFieldQuery, CarriageAdditionalSeatSignListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageAdditionalSeatSignListFieldQuery, CarriageAdditionalSeatSignListFieldQueryVariables>(CarriageAdditionalSeatSignListFieldDocument, options);
        }
export function useCarriageAdditionalSeatSignListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageAdditionalSeatSignListFieldQuery, CarriageAdditionalSeatSignListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageAdditionalSeatSignListFieldQuery, CarriageAdditionalSeatSignListFieldQueryVariables>(CarriageAdditionalSeatSignListFieldDocument, options);
        }
export type CarriageAdditionalSeatSignListFieldQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignListFieldQuery>;
export type CarriageAdditionalSeatSignListFieldLazyQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignListFieldLazyQuery>;
export type CarriageAdditionalSeatSignListFieldSuspenseQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignListFieldSuspenseQuery>;
export type CarriageAdditionalSeatSignListFieldQueryResult = Apollo.QueryResult<CarriageAdditionalSeatSignListFieldQuery, CarriageAdditionalSeatSignListFieldQueryVariables>;
export const NpsCarriageDimensionListFieldDocument = /*#__PURE__*/ gql`
    query npsCarriageDimensionListField($where: NpsCarriageDimensionQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    npsCarriageDimension {
      list(paginate: {per_page: 20, page: 0}, where: $where, range: $range) {
        items {
          ...NpsCarriageDimensionShortFragment
        }
      }
    }
  }
}
    ${NpsCarriageDimensionShortFragmentFragmentDoc}`;

/**
 * __useNpsCarriageDimensionListFieldQuery__
 *
 * To run a query within a React component, call `useNpsCarriageDimensionListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageDimensionListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageDimensionListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageDimensionListFieldQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageDimensionListFieldQuery, NpsCarriageDimensionListFieldQueryVariables> & ({ variables: NpsCarriageDimensionListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageDimensionListFieldQuery, NpsCarriageDimensionListFieldQueryVariables>(NpsCarriageDimensionListFieldDocument, options);
      }
export function useNpsCarriageDimensionListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageDimensionListFieldQuery, NpsCarriageDimensionListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageDimensionListFieldQuery, NpsCarriageDimensionListFieldQueryVariables>(NpsCarriageDimensionListFieldDocument, options);
        }
export function useNpsCarriageDimensionListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageDimensionListFieldQuery, NpsCarriageDimensionListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageDimensionListFieldQuery, NpsCarriageDimensionListFieldQueryVariables>(NpsCarriageDimensionListFieldDocument, options);
        }
export type NpsCarriageDimensionListFieldQueryHookResult = ReturnType<typeof useNpsCarriageDimensionListFieldQuery>;
export type NpsCarriageDimensionListFieldLazyQueryHookResult = ReturnType<typeof useNpsCarriageDimensionListFieldLazyQuery>;
export type NpsCarriageDimensionListFieldSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageDimensionListFieldSuspenseQuery>;
export type NpsCarriageDimensionListFieldQueryResult = Apollo.QueryResult<NpsCarriageDimensionListFieldQuery, NpsCarriageDimensionListFieldQueryVariables>;
export const CarriageSeatAllocationListFieldDocument = /*#__PURE__*/ gql`
    query carriageSeatAllocationListField($where: CarriageSeatAllocationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    carriageSeatAllocation {
      list(paginate: {per_page: 20, page: 0}, where: $where, range: $range) {
        items {
          ...CarriageSeatAllocationShortFragment
        }
      }
    }
  }
}
    ${CarriageSeatAllocationShortFragmentFragmentDoc}`;

/**
 * __useCarriageSeatAllocationListFieldQuery__
 *
 * To run a query within a React component, call `useCarriageSeatAllocationListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageSeatAllocationListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageSeatAllocationListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageSeatAllocationListFieldQuery(baseOptions: Apollo.QueryHookOptions<CarriageSeatAllocationListFieldQuery, CarriageSeatAllocationListFieldQueryVariables> & ({ variables: CarriageSeatAllocationListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageSeatAllocationListFieldQuery, CarriageSeatAllocationListFieldQueryVariables>(CarriageSeatAllocationListFieldDocument, options);
      }
export function useCarriageSeatAllocationListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageSeatAllocationListFieldQuery, CarriageSeatAllocationListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageSeatAllocationListFieldQuery, CarriageSeatAllocationListFieldQueryVariables>(CarriageSeatAllocationListFieldDocument, options);
        }
export function useCarriageSeatAllocationListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageSeatAllocationListFieldQuery, CarriageSeatAllocationListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageSeatAllocationListFieldQuery, CarriageSeatAllocationListFieldQueryVariables>(CarriageSeatAllocationListFieldDocument, options);
        }
export type CarriageSeatAllocationListFieldQueryHookResult = ReturnType<typeof useCarriageSeatAllocationListFieldQuery>;
export type CarriageSeatAllocationListFieldLazyQueryHookResult = ReturnType<typeof useCarriageSeatAllocationListFieldLazyQuery>;
export type CarriageSeatAllocationListFieldSuspenseQueryHookResult = ReturnType<typeof useCarriageSeatAllocationListFieldSuspenseQuery>;
export type CarriageSeatAllocationListFieldQueryResult = Apollo.QueryResult<CarriageSeatAllocationListFieldQuery, CarriageSeatAllocationListFieldQueryVariables>;
export const CarriageTypeListFieldDocument = /*#__PURE__*/ gql`
    query carriageTypeListField($paginate: PaginatorArgsDto, $orderBy: [CarriageTypeQueryResolver_List_SortingInputType!], $where: CarriageTypeQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    carriageType {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...CarriageTypeBaseFragment
          carriage_types_for_schema {
            ...CarriageTypesForSchemaShortFragment
            carriage_type_asu {
              entity_id
              short_name
              full_name
            }
          }
        }
        totalCount
      }
    }
  }
}
    ${CarriageTypeBaseFragmentFragmentDoc}
${CarriageTypesForSchemaShortFragmentFragmentDoc}`;

/**
 * __useCarriageTypeListFieldQuery__
 *
 * To run a query within a React component, call `useCarriageTypeListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypeListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageTypeListFieldQuery(baseOptions: Apollo.QueryHookOptions<CarriageTypeListFieldQuery, CarriageTypeListFieldQueryVariables> & ({ variables: CarriageTypeListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypeListFieldQuery, CarriageTypeListFieldQueryVariables>(CarriageTypeListFieldDocument, options);
      }
export function useCarriageTypeListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypeListFieldQuery, CarriageTypeListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypeListFieldQuery, CarriageTypeListFieldQueryVariables>(CarriageTypeListFieldDocument, options);
        }
export function useCarriageTypeListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypeListFieldQuery, CarriageTypeListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypeListFieldQuery, CarriageTypeListFieldQueryVariables>(CarriageTypeListFieldDocument, options);
        }
export type CarriageTypeListFieldQueryHookResult = ReturnType<typeof useCarriageTypeListFieldQuery>;
export type CarriageTypeListFieldLazyQueryHookResult = ReturnType<typeof useCarriageTypeListFieldLazyQuery>;
export type CarriageTypeListFieldSuspenseQueryHookResult = ReturnType<typeof useCarriageTypeListFieldSuspenseQuery>;
export type CarriageTypeListFieldQueryResult = Apollo.QueryResult<CarriageTypeListFieldQuery, CarriageTypeListFieldQueryVariables>;
export const CarriageTypeAsuListFieldDocument = /*#__PURE__*/ gql`
    query carriageTypeAsuListField($paginate: PaginatorArgsDto, $orderBy: [CarriageTypeAsuQueryResolver_List_SortingInputType!], $where: CarriageTypeAsuQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    carriageTypeAsu {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...CarriageTypeAsuBaseFragment
        }
      }
    }
  }
}
    ${CarriageTypeAsuBaseFragmentFragmentDoc}`;

/**
 * __useCarriageTypeAsuListFieldQuery__
 *
 * To run a query within a React component, call `useCarriageTypeAsuListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeAsuListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypeAsuListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageTypeAsuListFieldQuery(baseOptions: Apollo.QueryHookOptions<CarriageTypeAsuListFieldQuery, CarriageTypeAsuListFieldQueryVariables> & ({ variables: CarriageTypeAsuListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypeAsuListFieldQuery, CarriageTypeAsuListFieldQueryVariables>(CarriageTypeAsuListFieldDocument, options);
      }
export function useCarriageTypeAsuListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypeAsuListFieldQuery, CarriageTypeAsuListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypeAsuListFieldQuery, CarriageTypeAsuListFieldQueryVariables>(CarriageTypeAsuListFieldDocument, options);
        }
export function useCarriageTypeAsuListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypeAsuListFieldQuery, CarriageTypeAsuListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypeAsuListFieldQuery, CarriageTypeAsuListFieldQueryVariables>(CarriageTypeAsuListFieldDocument, options);
        }
export type CarriageTypeAsuListFieldQueryHookResult = ReturnType<typeof useCarriageTypeAsuListFieldQuery>;
export type CarriageTypeAsuListFieldLazyQueryHookResult = ReturnType<typeof useCarriageTypeAsuListFieldLazyQuery>;
export type CarriageTypeAsuListFieldSuspenseQueryHookResult = ReturnType<typeof useCarriageTypeAsuListFieldSuspenseQuery>;
export type CarriageTypeAsuListFieldQueryResult = Apollo.QueryResult<CarriageTypeAsuListFieldQuery, CarriageTypeAsuListFieldQueryVariables>;
export const CarriageTypesForSchemaListFieldDocument = /*#__PURE__*/ gql`
    query carriageTypesForSchemaListField($where: CarriageTypesForSchemaQueryResolver_List_FilterInputType) {
  classifiers {
    carriageTypesForSchema {
      list(paginate: {per_page: 20, page: 0}, where: $where) {
        items {
          ...CarriageTypesForSchemaShortFragment
        }
      }
    }
  }
}
    ${CarriageTypesForSchemaShortFragmentFragmentDoc}`;

/**
 * __useCarriageTypesForSchemaListFieldQuery__
 *
 * To run a query within a React component, call `useCarriageTypesForSchemaListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypesForSchemaListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypesForSchemaListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCarriageTypesForSchemaListFieldQuery(baseOptions?: Apollo.QueryHookOptions<CarriageTypesForSchemaListFieldQuery, CarriageTypesForSchemaListFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypesForSchemaListFieldQuery, CarriageTypesForSchemaListFieldQueryVariables>(CarriageTypesForSchemaListFieldDocument, options);
      }
export function useCarriageTypesForSchemaListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypesForSchemaListFieldQuery, CarriageTypesForSchemaListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypesForSchemaListFieldQuery, CarriageTypesForSchemaListFieldQueryVariables>(CarriageTypesForSchemaListFieldDocument, options);
        }
export function useCarriageTypesForSchemaListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypesForSchemaListFieldQuery, CarriageTypesForSchemaListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypesForSchemaListFieldQuery, CarriageTypesForSchemaListFieldQueryVariables>(CarriageTypesForSchemaListFieldDocument, options);
        }
export type CarriageTypesForSchemaListFieldQueryHookResult = ReturnType<typeof useCarriageTypesForSchemaListFieldQuery>;
export type CarriageTypesForSchemaListFieldLazyQueryHookResult = ReturnType<typeof useCarriageTypesForSchemaListFieldLazyQuery>;
export type CarriageTypesForSchemaListFieldSuspenseQueryHookResult = ReturnType<typeof useCarriageTypesForSchemaListFieldSuspenseQuery>;
export type CarriageTypesForSchemaListFieldQueryResult = Apollo.QueryResult<CarriageTypesForSchemaListFieldQuery, CarriageTypesForSchemaListFieldQueryVariables>;
export const CreateConditionalCarriageNumberDocument = /*#__PURE__*/ gql`
    mutation createConditionalCarriageNumber($input: CreateConditionalCarriageNumberDto!) {
  classifiers {
    conditionalCarriageNumber {
      create(data: $input)
    }
  }
}
    `;
export type CreateConditionalCarriageNumberMutationFn = Apollo.MutationFunction<CreateConditionalCarriageNumberMutation, CreateConditionalCarriageNumberMutationVariables>;

/**
 * __useCreateConditionalCarriageNumberMutation__
 *
 * To run a mutation, you first call `useCreateConditionalCarriageNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConditionalCarriageNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConditionalCarriageNumberMutation, { data, loading, error }] = useCreateConditionalCarriageNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConditionalCarriageNumberMutation(baseOptions?: Apollo.MutationHookOptions<CreateConditionalCarriageNumberMutation, CreateConditionalCarriageNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConditionalCarriageNumberMutation, CreateConditionalCarriageNumberMutationVariables>(CreateConditionalCarriageNumberDocument, options);
      }
export type CreateConditionalCarriageNumberMutationHookResult = ReturnType<typeof useCreateConditionalCarriageNumberMutation>;
export type CreateConditionalCarriageNumberMutationResult = Apollo.MutationResult<CreateConditionalCarriageNumberMutation>;
export type CreateConditionalCarriageNumberMutationOptions = Apollo.BaseMutationOptions<CreateConditionalCarriageNumberMutation, CreateConditionalCarriageNumberMutationVariables>;
export const NonPassengerCarriageTypeNumbersListDocument = /*#__PURE__*/ gql`
    query nonPassengerCarriageTypeNumbersList($paginate: PaginatorArgsDto, $orderBy: [ConditionalCarriageNumberQueryResolver_List_SortingInputType!], $where: ConditionalCarriageNumberQueryResolver_List_FilterInputType) {
  classifiers {
    conditionalCarriageNumber {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        items {
          ...ConditionalCarriageNumbersBaseFragment
        }
      }
    }
  }
}
    ${ConditionalCarriageNumbersBaseFragmentFragmentDoc}`;

/**
 * __useNonPassengerCarriageTypeNumbersListQuery__
 *
 * To run a query within a React component, call `useNonPassengerCarriageTypeNumbersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonPassengerCarriageTypeNumbersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonPassengerCarriageTypeNumbersListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNonPassengerCarriageTypeNumbersListQuery(baseOptions?: Apollo.QueryHookOptions<NonPassengerCarriageTypeNumbersListQuery, NonPassengerCarriageTypeNumbersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonPassengerCarriageTypeNumbersListQuery, NonPassengerCarriageTypeNumbersListQueryVariables>(NonPassengerCarriageTypeNumbersListDocument, options);
      }
export function useNonPassengerCarriageTypeNumbersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonPassengerCarriageTypeNumbersListQuery, NonPassengerCarriageTypeNumbersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonPassengerCarriageTypeNumbersListQuery, NonPassengerCarriageTypeNumbersListQueryVariables>(NonPassengerCarriageTypeNumbersListDocument, options);
        }
export function useNonPassengerCarriageTypeNumbersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NonPassengerCarriageTypeNumbersListQuery, NonPassengerCarriageTypeNumbersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonPassengerCarriageTypeNumbersListQuery, NonPassengerCarriageTypeNumbersListQueryVariables>(NonPassengerCarriageTypeNumbersListDocument, options);
        }
export type NonPassengerCarriageTypeNumbersListQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeNumbersListQuery>;
export type NonPassengerCarriageTypeNumbersListLazyQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeNumbersListLazyQuery>;
export type NonPassengerCarriageTypeNumbersListSuspenseQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeNumbersListSuspenseQuery>;
export type NonPassengerCarriageTypeNumbersListQueryResult = Apollo.QueryResult<NonPassengerCarriageTypeNumbersListQuery, NonPassengerCarriageTypeNumbersListQueryVariables>;
export const CsuCarrierListFieldDocument = /*#__PURE__*/ gql`
    query csuCarrierListField($paginate: PaginatorArgsDto, $where: CsuCarrierQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    csuCarrier {
      list(paginate: $paginate, where: $where, range: $range, order_by: [{id: ASC}]) {
        items {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useCsuCarrierListFieldQuery__
 *
 * To run a query within a React component, call `useCsuCarrierListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsuCarrierListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsuCarrierListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCsuCarrierListFieldQuery(baseOptions: Apollo.QueryHookOptions<CsuCarrierListFieldQuery, CsuCarrierListFieldQueryVariables> & ({ variables: CsuCarrierListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CsuCarrierListFieldQuery, CsuCarrierListFieldQueryVariables>(CsuCarrierListFieldDocument, options);
      }
export function useCsuCarrierListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CsuCarrierListFieldQuery, CsuCarrierListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CsuCarrierListFieldQuery, CsuCarrierListFieldQueryVariables>(CsuCarrierListFieldDocument, options);
        }
export function useCsuCarrierListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CsuCarrierListFieldQuery, CsuCarrierListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CsuCarrierListFieldQuery, CsuCarrierListFieldQueryVariables>(CsuCarrierListFieldDocument, options);
        }
export type CsuCarrierListFieldQueryHookResult = ReturnType<typeof useCsuCarrierListFieldQuery>;
export type CsuCarrierListFieldLazyQueryHookResult = ReturnType<typeof useCsuCarrierListFieldLazyQuery>;
export type CsuCarrierListFieldSuspenseQueryHookResult = ReturnType<typeof useCsuCarrierListFieldSuspenseQuery>;
export type CsuCarrierListFieldQueryResult = Apollo.QueryResult<CsuCarrierListFieldQuery, CsuCarrierListFieldQueryVariables>;
export const InfrastructureCoefficientIndexingListFieldDocument = /*#__PURE__*/ gql`
    query infrastructureCoefficientIndexingListField($where: InfrastructureCoefficientIndexingQueryResolver_List_FilterInputType) {
  classifiers {
    infrastructureCoefficientIndexing {
      list(paginate: {per_page: 20, page: 0}, where: $where) {
        items {
          ...InfrastructureCoefficientIndexingShortFragment
        }
      }
    }
  }
}
    ${InfrastructureCoefficientIndexingShortFragmentFragmentDoc}`;

/**
 * __useInfrastructureCoefficientIndexingListFieldQuery__
 *
 * To run a query within a React component, call `useInfrastructureCoefficientIndexingListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureCoefficientIndexingListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureCoefficientIndexingListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInfrastructureCoefficientIndexingListFieldQuery(baseOptions?: Apollo.QueryHookOptions<InfrastructureCoefficientIndexingListFieldQuery, InfrastructureCoefficientIndexingListFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureCoefficientIndexingListFieldQuery, InfrastructureCoefficientIndexingListFieldQueryVariables>(InfrastructureCoefficientIndexingListFieldDocument, options);
      }
export function useInfrastructureCoefficientIndexingListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureCoefficientIndexingListFieldQuery, InfrastructureCoefficientIndexingListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureCoefficientIndexingListFieldQuery, InfrastructureCoefficientIndexingListFieldQueryVariables>(InfrastructureCoefficientIndexingListFieldDocument, options);
        }
export function useInfrastructureCoefficientIndexingListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfrastructureCoefficientIndexingListFieldQuery, InfrastructureCoefficientIndexingListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureCoefficientIndexingListFieldQuery, InfrastructureCoefficientIndexingListFieldQueryVariables>(InfrastructureCoefficientIndexingListFieldDocument, options);
        }
export type InfrastructureCoefficientIndexingListFieldQueryHookResult = ReturnType<typeof useInfrastructureCoefficientIndexingListFieldQuery>;
export type InfrastructureCoefficientIndexingListFieldLazyQueryHookResult = ReturnType<typeof useInfrastructureCoefficientIndexingListFieldLazyQuery>;
export type InfrastructureCoefficientIndexingListFieldSuspenseQueryHookResult = ReturnType<typeof useInfrastructureCoefficientIndexingListFieldSuspenseQuery>;
export type InfrastructureCoefficientIndexingListFieldQueryResult = Apollo.QueryResult<InfrastructureCoefficientIndexingListFieldQuery, InfrastructureCoefficientIndexingListFieldQueryVariables>;
export const LocomotiveSeriesModelListFieldDocument = /*#__PURE__*/ gql`
    query locomotiveSeriesModelListField($where: LocomotiveSeriesQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    locomotiveSeries {
      list(paginate: {per_page: 20, page: 0}, where: $where, range: $range) {
        items {
          ...LocomotiveSeriesShortFragment
        }
      }
    }
  }
}
    ${LocomotiveSeriesShortFragmentFragmentDoc}`;

/**
 * __useLocomotiveSeriesModelListFieldQuery__
 *
 * To run a query within a React component, call `useLocomotiveSeriesModelListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveSeriesModelListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveSeriesModelListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useLocomotiveSeriesModelListFieldQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveSeriesModelListFieldQuery, LocomotiveSeriesModelListFieldQueryVariables> & ({ variables: LocomotiveSeriesModelListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveSeriesModelListFieldQuery, LocomotiveSeriesModelListFieldQueryVariables>(LocomotiveSeriesModelListFieldDocument, options);
      }
export function useLocomotiveSeriesModelListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveSeriesModelListFieldQuery, LocomotiveSeriesModelListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveSeriesModelListFieldQuery, LocomotiveSeriesModelListFieldQueryVariables>(LocomotiveSeriesModelListFieldDocument, options);
        }
export function useLocomotiveSeriesModelListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveSeriesModelListFieldQuery, LocomotiveSeriesModelListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveSeriesModelListFieldQuery, LocomotiveSeriesModelListFieldQueryVariables>(LocomotiveSeriesModelListFieldDocument, options);
        }
export type LocomotiveSeriesModelListFieldQueryHookResult = ReturnType<typeof useLocomotiveSeriesModelListFieldQuery>;
export type LocomotiveSeriesModelListFieldLazyQueryHookResult = ReturnType<typeof useLocomotiveSeriesModelListFieldLazyQuery>;
export type LocomotiveSeriesModelListFieldSuspenseQueryHookResult = ReturnType<typeof useLocomotiveSeriesModelListFieldSuspenseQuery>;
export type LocomotiveSeriesModelListFieldQueryResult = Apollo.QueryResult<LocomotiveSeriesModelListFieldQuery, LocomotiveSeriesModelListFieldQueryVariables>;
export const LocomotiveSeriesTypeModelListFieldDocument = /*#__PURE__*/ gql`
    query locomotiveSeriesTypeModelListField($where: LocomotiveSeriesTypeQueryResolver_List_FilterInputType) {
  classifiers {
    locomotiveSeriesType {
      list(paginate: {per_page: 20, page: 0}, where: $where) {
        items {
          ...LocomotiveSeriesTypeShortFragment
        }
      }
    }
  }
}
    ${LocomotiveSeriesTypeShortFragmentFragmentDoc}`;

/**
 * __useLocomotiveSeriesTypeModelListFieldQuery__
 *
 * To run a query within a React component, call `useLocomotiveSeriesTypeModelListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveSeriesTypeModelListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveSeriesTypeModelListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLocomotiveSeriesTypeModelListFieldQuery(baseOptions?: Apollo.QueryHookOptions<LocomotiveSeriesTypeModelListFieldQuery, LocomotiveSeriesTypeModelListFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveSeriesTypeModelListFieldQuery, LocomotiveSeriesTypeModelListFieldQueryVariables>(LocomotiveSeriesTypeModelListFieldDocument, options);
      }
export function useLocomotiveSeriesTypeModelListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveSeriesTypeModelListFieldQuery, LocomotiveSeriesTypeModelListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveSeriesTypeModelListFieldQuery, LocomotiveSeriesTypeModelListFieldQueryVariables>(LocomotiveSeriesTypeModelListFieldDocument, options);
        }
export function useLocomotiveSeriesTypeModelListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveSeriesTypeModelListFieldQuery, LocomotiveSeriesTypeModelListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveSeriesTypeModelListFieldQuery, LocomotiveSeriesTypeModelListFieldQueryVariables>(LocomotiveSeriesTypeModelListFieldDocument, options);
        }
export type LocomotiveSeriesTypeModelListFieldQueryHookResult = ReturnType<typeof useLocomotiveSeriesTypeModelListFieldQuery>;
export type LocomotiveSeriesTypeModelListFieldLazyQueryHookResult = ReturnType<typeof useLocomotiveSeriesTypeModelListFieldLazyQuery>;
export type LocomotiveSeriesTypeModelListFieldSuspenseQueryHookResult = ReturnType<typeof useLocomotiveSeriesTypeModelListFieldSuspenseQuery>;
export type LocomotiveSeriesTypeModelListFieldQueryResult = Apollo.QueryResult<LocomotiveSeriesTypeModelListFieldQuery, LocomotiveSeriesTypeModelListFieldQueryVariables>;
export const LocomotiveTractionTypeListFieldDocument = /*#__PURE__*/ gql`
    query locomotiveTractionTypeListField($paginate: PaginatorArgsDto!, $orderBy: [LocomotiveTractionTypeQueryResolver_List_SortingInputType!], $where: LocomotiveTractionTypeQueryResolver_List_FilterInputType) {
  classifiers {
    locomotiveTractionType {
      list(where: $where, paginate: $paginate, order_by: $orderBy) {
        items {
          ...LocomotiveTractionTypeBaseFragment
        }
      }
    }
  }
}
    ${LocomotiveTractionTypeBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveTractionTypeListFieldQuery__
 *
 * To run a query within a React component, call `useLocomotiveTractionTypeListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveTractionTypeListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveTractionTypeListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLocomotiveTractionTypeListFieldQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveTractionTypeListFieldQuery, LocomotiveTractionTypeListFieldQueryVariables> & ({ variables: LocomotiveTractionTypeListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveTractionTypeListFieldQuery, LocomotiveTractionTypeListFieldQueryVariables>(LocomotiveTractionTypeListFieldDocument, options);
      }
export function useLocomotiveTractionTypeListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveTractionTypeListFieldQuery, LocomotiveTractionTypeListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveTractionTypeListFieldQuery, LocomotiveTractionTypeListFieldQueryVariables>(LocomotiveTractionTypeListFieldDocument, options);
        }
export function useLocomotiveTractionTypeListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveTractionTypeListFieldQuery, LocomotiveTractionTypeListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveTractionTypeListFieldQuery, LocomotiveTractionTypeListFieldQueryVariables>(LocomotiveTractionTypeListFieldDocument, options);
        }
export type LocomotiveTractionTypeListFieldQueryHookResult = ReturnType<typeof useLocomotiveTractionTypeListFieldQuery>;
export type LocomotiveTractionTypeListFieldLazyQueryHookResult = ReturnType<typeof useLocomotiveTractionTypeListFieldLazyQuery>;
export type LocomotiveTractionTypeListFieldSuspenseQueryHookResult = ReturnType<typeof useLocomotiveTractionTypeListFieldSuspenseQuery>;
export type LocomotiveTractionTypeListFieldQueryResult = Apollo.QueryResult<LocomotiveTractionTypeListFieldQuery, LocomotiveTractionTypeListFieldQueryVariables>;
export const LocomotiveTypeCurrentListFieldDocument = /*#__PURE__*/ gql`
    query locomotiveTypeCurrentListField($where: LocomotiveTypeCurrentQueryResolver_List_FilterInputType) {
  classifiers {
    locomotiveTypeCurrent {
      list(paginate: {per_page: 20, page: 0}, where: $where) {
        items {
          ...LocomotiveTypeCurrentShortFragment
        }
      }
    }
  }
}
    ${LocomotiveTypeCurrentShortFragmentFragmentDoc}`;

/**
 * __useLocomotiveTypeCurrentListFieldQuery__
 *
 * To run a query within a React component, call `useLocomotiveTypeCurrentListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveTypeCurrentListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveTypeCurrentListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLocomotiveTypeCurrentListFieldQuery(baseOptions?: Apollo.QueryHookOptions<LocomotiveTypeCurrentListFieldQuery, LocomotiveTypeCurrentListFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveTypeCurrentListFieldQuery, LocomotiveTypeCurrentListFieldQueryVariables>(LocomotiveTypeCurrentListFieldDocument, options);
      }
export function useLocomotiveTypeCurrentListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveTypeCurrentListFieldQuery, LocomotiveTypeCurrentListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveTypeCurrentListFieldQuery, LocomotiveTypeCurrentListFieldQueryVariables>(LocomotiveTypeCurrentListFieldDocument, options);
        }
export function useLocomotiveTypeCurrentListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveTypeCurrentListFieldQuery, LocomotiveTypeCurrentListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveTypeCurrentListFieldQuery, LocomotiveTypeCurrentListFieldQueryVariables>(LocomotiveTypeCurrentListFieldDocument, options);
        }
export type LocomotiveTypeCurrentListFieldQueryHookResult = ReturnType<typeof useLocomotiveTypeCurrentListFieldQuery>;
export type LocomotiveTypeCurrentListFieldLazyQueryHookResult = ReturnType<typeof useLocomotiveTypeCurrentListFieldLazyQuery>;
export type LocomotiveTypeCurrentListFieldSuspenseQueryHookResult = ReturnType<typeof useLocomotiveTypeCurrentListFieldSuspenseQuery>;
export type LocomotiveTypeCurrentListFieldQueryResult = Apollo.QueryResult<LocomotiveTypeCurrentListFieldQuery, LocomotiveTypeCurrentListFieldQueryVariables>;
export const MaxTrainSpeedListFieldDocument = /*#__PURE__*/ gql`
    query maxTrainSpeedListField($range: RangeInputDto!, $paginate: PaginatorArgsDto, $orderBy: [MaxTrainSpeedQueryResolver_List_SortingInputType!], $where: MaxTrainSpeedQueryResolver_List_FilterInputType) {
  classifiers {
    maxTrainSpeed {
      list(range: $range, where: $where, paginate: $paginate, order_by: $orderBy) {
        items {
          ...MaxTrainSpeedShortFragment
        }
      }
    }
  }
}
    ${MaxTrainSpeedShortFragmentFragmentDoc}`;

/**
 * __useMaxTrainSpeedListFieldQuery__
 *
 * To run a query within a React component, call `useMaxTrainSpeedListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaxTrainSpeedListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaxTrainSpeedListFieldQuery({
 *   variables: {
 *      range: // value for 'range'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMaxTrainSpeedListFieldQuery(baseOptions: Apollo.QueryHookOptions<MaxTrainSpeedListFieldQuery, MaxTrainSpeedListFieldQueryVariables> & ({ variables: MaxTrainSpeedListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaxTrainSpeedListFieldQuery, MaxTrainSpeedListFieldQueryVariables>(MaxTrainSpeedListFieldDocument, options);
      }
export function useMaxTrainSpeedListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaxTrainSpeedListFieldQuery, MaxTrainSpeedListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaxTrainSpeedListFieldQuery, MaxTrainSpeedListFieldQueryVariables>(MaxTrainSpeedListFieldDocument, options);
        }
export function useMaxTrainSpeedListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaxTrainSpeedListFieldQuery, MaxTrainSpeedListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaxTrainSpeedListFieldQuery, MaxTrainSpeedListFieldQueryVariables>(MaxTrainSpeedListFieldDocument, options);
        }
export type MaxTrainSpeedListFieldQueryHookResult = ReturnType<typeof useMaxTrainSpeedListFieldQuery>;
export type MaxTrainSpeedListFieldLazyQueryHookResult = ReturnType<typeof useMaxTrainSpeedListFieldLazyQuery>;
export type MaxTrainSpeedListFieldSuspenseQueryHookResult = ReturnType<typeof useMaxTrainSpeedListFieldSuspenseQuery>;
export type MaxTrainSpeedListFieldQueryResult = Apollo.QueryResult<MaxTrainSpeedListFieldQuery, MaxTrainSpeedListFieldQueryVariables>;
export const MvpsCompanyAffiliationListFieldDocument = /*#__PURE__*/ gql`
    query mvpsCompanyAffiliationListField($paginate: PaginatorArgsDto, $where: MvpsCompanyAffiliationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    mvpsCompanyAffiliation {
      list(paginate: $paginate, where: $where, range: $range) {
        items {
          ...MvpsCompanyAffiliationShortFragment
        }
      }
    }
  }
}
    ${MvpsCompanyAffiliationShortFragmentFragmentDoc}`;

/**
 * __useMvpsCompanyAffiliationListFieldQuery__
 *
 * To run a query within a React component, call `useMvpsCompanyAffiliationListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsCompanyAffiliationListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsCompanyAffiliationListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsCompanyAffiliationListFieldQuery(baseOptions: Apollo.QueryHookOptions<MvpsCompanyAffiliationListFieldQuery, MvpsCompanyAffiliationListFieldQueryVariables> & ({ variables: MvpsCompanyAffiliationListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsCompanyAffiliationListFieldQuery, MvpsCompanyAffiliationListFieldQueryVariables>(MvpsCompanyAffiliationListFieldDocument, options);
      }
export function useMvpsCompanyAffiliationListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsCompanyAffiliationListFieldQuery, MvpsCompanyAffiliationListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsCompanyAffiliationListFieldQuery, MvpsCompanyAffiliationListFieldQueryVariables>(MvpsCompanyAffiliationListFieldDocument, options);
        }
export function useMvpsCompanyAffiliationListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsCompanyAffiliationListFieldQuery, MvpsCompanyAffiliationListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsCompanyAffiliationListFieldQuery, MvpsCompanyAffiliationListFieldQueryVariables>(MvpsCompanyAffiliationListFieldDocument, options);
        }
export type MvpsCompanyAffiliationListFieldQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationListFieldQuery>;
export type MvpsCompanyAffiliationListFieldLazyQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationListFieldLazyQuery>;
export type MvpsCompanyAffiliationListFieldSuspenseQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationListFieldSuspenseQuery>;
export type MvpsCompanyAffiliationListFieldQueryResult = Apollo.QueryResult<MvpsCompanyAffiliationListFieldQuery, MvpsCompanyAffiliationListFieldQueryVariables>;
export const MvpsMartinSectionTypeListFieldDocument = /*#__PURE__*/ gql`
    query mvpsMartinSectionTypeListField($where: MvpsMartinSectionTypeQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    mvpsMartinSectionType {
      list(paginate: {per_page: 20, page: 0}, where: $where, range: $range) {
        items {
          ...MvpsMartinSectionTypeBaseFragment
          mvpsMartinSectionTypeEquipmentDto {
            ...MvpsMartinSectionTypeEquipmentShortFragment
          }
        }
      }
    }
  }
}
    ${MvpsMartinSectionTypeBaseFragmentFragmentDoc}
${MvpsMartinSectionTypeEquipmentShortFragmentFragmentDoc}`;

/**
 * __useMvpsMartinSectionTypeListFieldQuery__
 *
 * To run a query within a React component, call `useMvpsMartinSectionTypeListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsMartinSectionTypeListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsMartinSectionTypeListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsMartinSectionTypeListFieldQuery(baseOptions: Apollo.QueryHookOptions<MvpsMartinSectionTypeListFieldQuery, MvpsMartinSectionTypeListFieldQueryVariables> & ({ variables: MvpsMartinSectionTypeListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsMartinSectionTypeListFieldQuery, MvpsMartinSectionTypeListFieldQueryVariables>(MvpsMartinSectionTypeListFieldDocument, options);
      }
export function useMvpsMartinSectionTypeListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsMartinSectionTypeListFieldQuery, MvpsMartinSectionTypeListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsMartinSectionTypeListFieldQuery, MvpsMartinSectionTypeListFieldQueryVariables>(MvpsMartinSectionTypeListFieldDocument, options);
        }
export function useMvpsMartinSectionTypeListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsMartinSectionTypeListFieldQuery, MvpsMartinSectionTypeListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsMartinSectionTypeListFieldQuery, MvpsMartinSectionTypeListFieldQueryVariables>(MvpsMartinSectionTypeListFieldDocument, options);
        }
export type MvpsMartinSectionTypeListFieldQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeListFieldQuery>;
export type MvpsMartinSectionTypeListFieldLazyQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeListFieldLazyQuery>;
export type MvpsMartinSectionTypeListFieldSuspenseQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeListFieldSuspenseQuery>;
export type MvpsMartinSectionTypeListFieldQueryResult = Apollo.QueryResult<MvpsMartinSectionTypeListFieldQuery, MvpsMartinSectionTypeListFieldQueryVariables>;
export const MvpsMartinSectionTypeEquipmentListFieldDocument = /*#__PURE__*/ gql`
    query mvpsMartinSectionTypeEquipmentListField($paginate: PaginatorArgsDto!, $orderBy: [MvpsMartinSectionTypeEquipmentQueryResolver_List_SortingInputType!], $where: MvpsMartinSectionTypeEquipmentQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    mvpsMartinSectionTypeEquipment {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...MvpsMartinSectionTypeEquipmentShortFragment
        }
      }
    }
  }
}
    ${MvpsMartinSectionTypeEquipmentShortFragmentFragmentDoc}`;

/**
 * __useMvpsMartinSectionTypeEquipmentListFieldQuery__
 *
 * To run a query within a React component, call `useMvpsMartinSectionTypeEquipmentListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsMartinSectionTypeEquipmentListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsMartinSectionTypeEquipmentListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsMartinSectionTypeEquipmentListFieldQuery(baseOptions: Apollo.QueryHookOptions<MvpsMartinSectionTypeEquipmentListFieldQuery, MvpsMartinSectionTypeEquipmentListFieldQueryVariables> & ({ variables: MvpsMartinSectionTypeEquipmentListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsMartinSectionTypeEquipmentListFieldQuery, MvpsMartinSectionTypeEquipmentListFieldQueryVariables>(MvpsMartinSectionTypeEquipmentListFieldDocument, options);
      }
export function useMvpsMartinSectionTypeEquipmentListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsMartinSectionTypeEquipmentListFieldQuery, MvpsMartinSectionTypeEquipmentListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsMartinSectionTypeEquipmentListFieldQuery, MvpsMartinSectionTypeEquipmentListFieldQueryVariables>(MvpsMartinSectionTypeEquipmentListFieldDocument, options);
        }
export function useMvpsMartinSectionTypeEquipmentListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsMartinSectionTypeEquipmentListFieldQuery, MvpsMartinSectionTypeEquipmentListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsMartinSectionTypeEquipmentListFieldQuery, MvpsMartinSectionTypeEquipmentListFieldQueryVariables>(MvpsMartinSectionTypeEquipmentListFieldDocument, options);
        }
export type MvpsMartinSectionTypeEquipmentListFieldQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentListFieldQuery>;
export type MvpsMartinSectionTypeEquipmentListFieldLazyQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentListFieldLazyQuery>;
export type MvpsMartinSectionTypeEquipmentListFieldSuspenseQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentListFieldSuspenseQuery>;
export type MvpsMartinSectionTypeEquipmentListFieldQueryResult = Apollo.QueryResult<MvpsMartinSectionTypeEquipmentListFieldQuery, MvpsMartinSectionTypeEquipmentListFieldQueryVariables>;
export const MvpsRateManagementExploitationMaintenanceRepairListFieldDocument = /*#__PURE__*/ gql`
    query mvpsRateManagementExploitationMaintenanceRepairListField($where: MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    mvpsRateManagementExploitationMaintenanceRepair {
      list(paginate: {per_page: 20, page: 0}, where: $where, range: $range) {
        items {
          ...MvpsRateManagementExploitationMaintenanceRepairShortFragment
        }
      }
    }
  }
}
    ${MvpsRateManagementExploitationMaintenanceRepairShortFragmentFragmentDoc}`;

/**
 * __useMvpsRateManagementExploitationMaintenanceRepairListFieldQuery__
 *
 * To run a query within a React component, call `useMvpsRateManagementExploitationMaintenanceRepairListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsRateManagementExploitationMaintenanceRepairListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsRateManagementExploitationMaintenanceRepairListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsRateManagementExploitationMaintenanceRepairListFieldQuery(baseOptions: Apollo.QueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairListFieldQuery, MvpsRateManagementExploitationMaintenanceRepairListFieldQueryVariables> & ({ variables: MvpsRateManagementExploitationMaintenanceRepairListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsRateManagementExploitationMaintenanceRepairListFieldQuery, MvpsRateManagementExploitationMaintenanceRepairListFieldQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairListFieldDocument, options);
      }
export function useMvpsRateManagementExploitationMaintenanceRepairListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairListFieldQuery, MvpsRateManagementExploitationMaintenanceRepairListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsRateManagementExploitationMaintenanceRepairListFieldQuery, MvpsRateManagementExploitationMaintenanceRepairListFieldQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairListFieldDocument, options);
        }
export function useMvpsRateManagementExploitationMaintenanceRepairListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairListFieldQuery, MvpsRateManagementExploitationMaintenanceRepairListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsRateManagementExploitationMaintenanceRepairListFieldQuery, MvpsRateManagementExploitationMaintenanceRepairListFieldQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairListFieldDocument, options);
        }
export type MvpsRateManagementExploitationMaintenanceRepairListFieldQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairListFieldQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairListFieldLazyQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairListFieldLazyQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairListFieldSuspenseQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairListFieldSuspenseQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairListFieldQueryResult = Apollo.QueryResult<MvpsRateManagementExploitationMaintenanceRepairListFieldQuery, MvpsRateManagementExploitationMaintenanceRepairListFieldQueryVariables>;
export const NpsCarriageBrakeTypeListFieldDocument = /*#__PURE__*/ gql`
    query npsCarriageBrakeTypeListField($where: NpsCarriageBrakeTypeQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    npsCarriageBrakeType {
      list(paginate: {per_page: 100, page: 0}, where: $where, range: $range) {
        items {
          ...NpsCarriageBrakeTypeBaseFragment
        }
      }
    }
  }
}
    ${NpsCarriageBrakeTypeBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageBrakeTypeListFieldQuery__
 *
 * To run a query within a React component, call `useNpsCarriageBrakeTypeListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageBrakeTypeListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageBrakeTypeListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageBrakeTypeListFieldQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageBrakeTypeListFieldQuery, NpsCarriageBrakeTypeListFieldQueryVariables> & ({ variables: NpsCarriageBrakeTypeListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageBrakeTypeListFieldQuery, NpsCarriageBrakeTypeListFieldQueryVariables>(NpsCarriageBrakeTypeListFieldDocument, options);
      }
export function useNpsCarriageBrakeTypeListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageBrakeTypeListFieldQuery, NpsCarriageBrakeTypeListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageBrakeTypeListFieldQuery, NpsCarriageBrakeTypeListFieldQueryVariables>(NpsCarriageBrakeTypeListFieldDocument, options);
        }
export function useNpsCarriageBrakeTypeListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageBrakeTypeListFieldQuery, NpsCarriageBrakeTypeListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageBrakeTypeListFieldQuery, NpsCarriageBrakeTypeListFieldQueryVariables>(NpsCarriageBrakeTypeListFieldDocument, options);
        }
export type NpsCarriageBrakeTypeListFieldQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeListFieldQuery>;
export type NpsCarriageBrakeTypeListFieldLazyQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeListFieldLazyQuery>;
export type NpsCarriageBrakeTypeListFieldSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeListFieldSuspenseQuery>;
export type NpsCarriageBrakeTypeListFieldQueryResult = Apollo.QueryResult<NpsCarriageBrakeTypeListFieldQuery, NpsCarriageBrakeTypeListFieldQueryVariables>;
export const NpsCarriageHeatTypeListFieldDocument = /*#__PURE__*/ gql`
    query npsCarriageHeatTypeListField($where: NpsCarriageHeatTypeQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    npsCarriageHeatType {
      list(paginate: {per_page: 100, page: 0}, where: $where, range: $range) {
        items {
          ...NpsCarriageHeatTypeBaseFragment
        }
      }
    }
  }
}
    ${NpsCarriageHeatTypeBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageHeatTypeListFieldQuery__
 *
 * To run a query within a React component, call `useNpsCarriageHeatTypeListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageHeatTypeListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageHeatTypeListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageHeatTypeListFieldQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageHeatTypeListFieldQuery, NpsCarriageHeatTypeListFieldQueryVariables> & ({ variables: NpsCarriageHeatTypeListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageHeatTypeListFieldQuery, NpsCarriageHeatTypeListFieldQueryVariables>(NpsCarriageHeatTypeListFieldDocument, options);
      }
export function useNpsCarriageHeatTypeListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageHeatTypeListFieldQuery, NpsCarriageHeatTypeListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageHeatTypeListFieldQuery, NpsCarriageHeatTypeListFieldQueryVariables>(NpsCarriageHeatTypeListFieldDocument, options);
        }
export function useNpsCarriageHeatTypeListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageHeatTypeListFieldQuery, NpsCarriageHeatTypeListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageHeatTypeListFieldQuery, NpsCarriageHeatTypeListFieldQueryVariables>(NpsCarriageHeatTypeListFieldDocument, options);
        }
export type NpsCarriageHeatTypeListFieldQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeListFieldQuery>;
export type NpsCarriageHeatTypeListFieldLazyQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeListFieldLazyQuery>;
export type NpsCarriageHeatTypeListFieldSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeListFieldSuspenseQuery>;
export type NpsCarriageHeatTypeListFieldQueryResult = Apollo.QueryResult<NpsCarriageHeatTypeListFieldQuery, NpsCarriageHeatTypeListFieldQueryVariables>;
export const NpsCarriageLengthListFieldDocument = /*#__PURE__*/ gql`
    query npsCarriageLengthListField($where: NpsCarriageLengthQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    npsCarriageLength {
      list(paginate: {per_page: 100, page: 0}, where: $where, range: $range) {
        items {
          ...NpsCarriageLengthBaseFragment
        }
      }
    }
  }
}
    ${NpsCarriageLengthBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageLengthListFieldQuery__
 *
 * To run a query within a React component, call `useNpsCarriageLengthListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageLengthListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageLengthListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageLengthListFieldQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageLengthListFieldQuery, NpsCarriageLengthListFieldQueryVariables> & ({ variables: NpsCarriageLengthListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageLengthListFieldQuery, NpsCarriageLengthListFieldQueryVariables>(NpsCarriageLengthListFieldDocument, options);
      }
export function useNpsCarriageLengthListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageLengthListFieldQuery, NpsCarriageLengthListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageLengthListFieldQuery, NpsCarriageLengthListFieldQueryVariables>(NpsCarriageLengthListFieldDocument, options);
        }
export function useNpsCarriageLengthListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageLengthListFieldQuery, NpsCarriageLengthListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageLengthListFieldQuery, NpsCarriageLengthListFieldQueryVariables>(NpsCarriageLengthListFieldDocument, options);
        }
export type NpsCarriageLengthListFieldQueryHookResult = ReturnType<typeof useNpsCarriageLengthListFieldQuery>;
export type NpsCarriageLengthListFieldLazyQueryHookResult = ReturnType<typeof useNpsCarriageLengthListFieldLazyQuery>;
export type NpsCarriageLengthListFieldSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageLengthListFieldSuspenseQuery>;
export type NpsCarriageLengthListFieldQueryResult = Apollo.QueryResult<NpsCarriageLengthListFieldQuery, NpsCarriageLengthListFieldQueryVariables>;
export const NpsCarriageModelListFieldDocument = /*#__PURE__*/ gql`
    query npsCarriageModelListField($where: NpsCarriageModelQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    npsCarriageModel {
      list(paginate: {per_page: 100, page: 0}, where: $where, range: $range) {
        items {
          ...NpsCarriageModelBaseFragment
        }
      }
    }
  }
}
    ${NpsCarriageModelBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageModelListFieldQuery__
 *
 * To run a query within a React component, call `useNpsCarriageModelListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageModelListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageModelListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageModelListFieldQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageModelListFieldQuery, NpsCarriageModelListFieldQueryVariables> & ({ variables: NpsCarriageModelListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageModelListFieldQuery, NpsCarriageModelListFieldQueryVariables>(NpsCarriageModelListFieldDocument, options);
      }
export function useNpsCarriageModelListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageModelListFieldQuery, NpsCarriageModelListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageModelListFieldQuery, NpsCarriageModelListFieldQueryVariables>(NpsCarriageModelListFieldDocument, options);
        }
export function useNpsCarriageModelListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageModelListFieldQuery, NpsCarriageModelListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageModelListFieldQuery, NpsCarriageModelListFieldQueryVariables>(NpsCarriageModelListFieldDocument, options);
        }
export type NpsCarriageModelListFieldQueryHookResult = ReturnType<typeof useNpsCarriageModelListFieldQuery>;
export type NpsCarriageModelListFieldLazyQueryHookResult = ReturnType<typeof useNpsCarriageModelListFieldLazyQuery>;
export type NpsCarriageModelListFieldSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageModelListFieldSuspenseQuery>;
export type NpsCarriageModelListFieldQueryResult = Apollo.QueryResult<NpsCarriageModelListFieldQuery, NpsCarriageModelListFieldQueryVariables>;
export const PassengerCarrierListFieldDocument = /*#__PURE__*/ gql`
    query passengerCarrierListField($paginate: PaginatorArgsDto, $where: PassengerCarrierQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    passengerCarrier {
      list(
        paginate: $paginate
        where: $where
        range: $range
        order_by: [{entity_id: ASC}]
      ) {
        items {
          ...PassengerCarrierShortFragment
          code
        }
      }
    }
  }
}
    ${PassengerCarrierShortFragmentFragmentDoc}`;

/**
 * __usePassengerCarrierListFieldQuery__
 *
 * To run a query within a React component, call `usePassengerCarrierListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePassengerCarrierListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePassengerCarrierListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function usePassengerCarrierListFieldQuery(baseOptions: Apollo.QueryHookOptions<PassengerCarrierListFieldQuery, PassengerCarrierListFieldQueryVariables> & ({ variables: PassengerCarrierListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PassengerCarrierListFieldQuery, PassengerCarrierListFieldQueryVariables>(PassengerCarrierListFieldDocument, options);
      }
export function usePassengerCarrierListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PassengerCarrierListFieldQuery, PassengerCarrierListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PassengerCarrierListFieldQuery, PassengerCarrierListFieldQueryVariables>(PassengerCarrierListFieldDocument, options);
        }
export function usePassengerCarrierListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PassengerCarrierListFieldQuery, PassengerCarrierListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PassengerCarrierListFieldQuery, PassengerCarrierListFieldQueryVariables>(PassengerCarrierListFieldDocument, options);
        }
export type PassengerCarrierListFieldQueryHookResult = ReturnType<typeof usePassengerCarrierListFieldQuery>;
export type PassengerCarrierListFieldLazyQueryHookResult = ReturnType<typeof usePassengerCarrierListFieldLazyQuery>;
export type PassengerCarrierListFieldSuspenseQueryHookResult = ReturnType<typeof usePassengerCarrierListFieldSuspenseQuery>;
export type PassengerCarrierListFieldQueryResult = Apollo.QueryResult<PassengerCarrierListFieldQuery, PassengerCarrierListFieldQueryVariables>;
export const NmrvagUniqueCarriersListDocument = /*#__PURE__*/ gql`
    query nmrvagUniqueCarriersList($date: String!) {
  tpc {
    control_schema {
      uniqueCarriersList(date: $date)
    }
  }
}
    `;

/**
 * __useNmrvagUniqueCarriersListQuery__
 *
 * To run a query within a React component, call `useNmrvagUniqueCarriersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNmrvagUniqueCarriersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNmrvagUniqueCarriersListQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useNmrvagUniqueCarriersListQuery(baseOptions: Apollo.QueryHookOptions<NmrvagUniqueCarriersListQuery, NmrvagUniqueCarriersListQueryVariables> & ({ variables: NmrvagUniqueCarriersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NmrvagUniqueCarriersListQuery, NmrvagUniqueCarriersListQueryVariables>(NmrvagUniqueCarriersListDocument, options);
      }
export function useNmrvagUniqueCarriersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NmrvagUniqueCarriersListQuery, NmrvagUniqueCarriersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NmrvagUniqueCarriersListQuery, NmrvagUniqueCarriersListQueryVariables>(NmrvagUniqueCarriersListDocument, options);
        }
export function useNmrvagUniqueCarriersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NmrvagUniqueCarriersListQuery, NmrvagUniqueCarriersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NmrvagUniqueCarriersListQuery, NmrvagUniqueCarriersListQueryVariables>(NmrvagUniqueCarriersListDocument, options);
        }
export type NmrvagUniqueCarriersListQueryHookResult = ReturnType<typeof useNmrvagUniqueCarriersListQuery>;
export type NmrvagUniqueCarriersListLazyQueryHookResult = ReturnType<typeof useNmrvagUniqueCarriersListLazyQuery>;
export type NmrvagUniqueCarriersListSuspenseQueryHookResult = ReturnType<typeof useNmrvagUniqueCarriersListSuspenseQuery>;
export type NmrvagUniqueCarriersListQueryResult = Apollo.QueryResult<NmrvagUniqueCarriersListQuery, NmrvagUniqueCarriersListQueryVariables>;
export const PeriodicitySeasonListFieldDocument = /*#__PURE__*/ gql`
    query periodicitySeasonListField($range: RangeInputDto!, $paginate: PaginatorArgsDto, $orderBy: [PeriodicitySeasonQueryResolver_List_SortingInputType!], $where: PeriodicitySeasonQueryResolver_List_FilterInputType) {
  classifiers {
    periodicitySeason {
      list(range: $range, where: $where, paginate: $paginate, order_by: $orderBy) {
        items {
          ...PeriodicitySeasonBaseFragment
        }
      }
    }
  }
}
    ${PeriodicitySeasonBaseFragmentFragmentDoc}`;

/**
 * __usePeriodicitySeasonListFieldQuery__
 *
 * To run a query within a React component, call `usePeriodicitySeasonListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodicitySeasonListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodicitySeasonListFieldQuery({
 *   variables: {
 *      range: // value for 'range'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePeriodicitySeasonListFieldQuery(baseOptions: Apollo.QueryHookOptions<PeriodicitySeasonListFieldQuery, PeriodicitySeasonListFieldQueryVariables> & ({ variables: PeriodicitySeasonListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeriodicitySeasonListFieldQuery, PeriodicitySeasonListFieldQueryVariables>(PeriodicitySeasonListFieldDocument, options);
      }
export function usePeriodicitySeasonListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeriodicitySeasonListFieldQuery, PeriodicitySeasonListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeriodicitySeasonListFieldQuery, PeriodicitySeasonListFieldQueryVariables>(PeriodicitySeasonListFieldDocument, options);
        }
export function usePeriodicitySeasonListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PeriodicitySeasonListFieldQuery, PeriodicitySeasonListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeriodicitySeasonListFieldQuery, PeriodicitySeasonListFieldQueryVariables>(PeriodicitySeasonListFieldDocument, options);
        }
export type PeriodicitySeasonListFieldQueryHookResult = ReturnType<typeof usePeriodicitySeasonListFieldQuery>;
export type PeriodicitySeasonListFieldLazyQueryHookResult = ReturnType<typeof usePeriodicitySeasonListFieldLazyQuery>;
export type PeriodicitySeasonListFieldSuspenseQueryHookResult = ReturnType<typeof usePeriodicitySeasonListFieldSuspenseQuery>;
export type PeriodicitySeasonListFieldQueryResult = Apollo.QueryResult<PeriodicitySeasonListFieldQuery, PeriodicitySeasonListFieldQueryVariables>;
export const RailwaysListFieldDocument = /*#__PURE__*/ gql`
    query railwaysListField($range: RangeInputDto!, $paginate: PaginatorArgsDto, $orderBy: [RailwayQueryResolver_List_SortingInputType!], $where: RailwayQueryResolver_List_FilterInputType) {
  classifiers {
    railway {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...RailwayShortFragment
        }
      }
    }
  }
}
    ${RailwayShortFragmentFragmentDoc}`;

/**
 * __useRailwaysListFieldQuery__
 *
 * To run a query within a React component, call `useRailwaysListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useRailwaysListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRailwaysListFieldQuery({
 *   variables: {
 *      range: // value for 'range'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRailwaysListFieldQuery(baseOptions: Apollo.QueryHookOptions<RailwaysListFieldQuery, RailwaysListFieldQueryVariables> & ({ variables: RailwaysListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RailwaysListFieldQuery, RailwaysListFieldQueryVariables>(RailwaysListFieldDocument, options);
      }
export function useRailwaysListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RailwaysListFieldQuery, RailwaysListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RailwaysListFieldQuery, RailwaysListFieldQueryVariables>(RailwaysListFieldDocument, options);
        }
export function useRailwaysListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RailwaysListFieldQuery, RailwaysListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RailwaysListFieldQuery, RailwaysListFieldQueryVariables>(RailwaysListFieldDocument, options);
        }
export type RailwaysListFieldQueryHookResult = ReturnType<typeof useRailwaysListFieldQuery>;
export type RailwaysListFieldLazyQueryHookResult = ReturnType<typeof useRailwaysListFieldLazyQuery>;
export type RailwaysListFieldSuspenseQueryHookResult = ReturnType<typeof useRailwaysListFieldSuspenseQuery>;
export type RailwaysListFieldQueryResult = Apollo.QueryResult<RailwaysListFieldQuery, RailwaysListFieldQueryVariables>;
export const RailwayAdministrationListFieldDocument = /*#__PURE__*/ gql`
    query railwayAdministrationListField($where: RailwayAdministrationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    railwayAdministration {
      list(
        paginate: {per_page: 100, page: 0}
        order_by: [{entity_id: ASC}]
        where: $where
        range: $range
      ) {
        items {
          ...RailwayAdministrationBaseFragment
        }
      }
    }
  }
}
    ${RailwayAdministrationBaseFragmentFragmentDoc}`;

/**
 * __useRailwayAdministrationListFieldQuery__
 *
 * To run a query within a React component, call `useRailwayAdministrationListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useRailwayAdministrationListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRailwayAdministrationListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useRailwayAdministrationListFieldQuery(baseOptions: Apollo.QueryHookOptions<RailwayAdministrationListFieldQuery, RailwayAdministrationListFieldQueryVariables> & ({ variables: RailwayAdministrationListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RailwayAdministrationListFieldQuery, RailwayAdministrationListFieldQueryVariables>(RailwayAdministrationListFieldDocument, options);
      }
export function useRailwayAdministrationListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RailwayAdministrationListFieldQuery, RailwayAdministrationListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RailwayAdministrationListFieldQuery, RailwayAdministrationListFieldQueryVariables>(RailwayAdministrationListFieldDocument, options);
        }
export function useRailwayAdministrationListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RailwayAdministrationListFieldQuery, RailwayAdministrationListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RailwayAdministrationListFieldQuery, RailwayAdministrationListFieldQueryVariables>(RailwayAdministrationListFieldDocument, options);
        }
export type RailwayAdministrationListFieldQueryHookResult = ReturnType<typeof useRailwayAdministrationListFieldQuery>;
export type RailwayAdministrationListFieldLazyQueryHookResult = ReturnType<typeof useRailwayAdministrationListFieldLazyQuery>;
export type RailwayAdministrationListFieldSuspenseQueryHookResult = ReturnType<typeof useRailwayAdministrationListFieldSuspenseQuery>;
export type RailwayAdministrationListFieldQueryResult = Apollo.QueryResult<RailwayAdministrationListFieldQuery, RailwayAdministrationListFieldQueryVariables>;
export const RolesListFieldDocument = /*#__PURE__*/ gql`
    query rolesListField {
  rbac {
    roles {
      items {
        ...RoleShortFragment
      }
    }
  }
}
    ${RoleShortFragmentFragmentDoc}`;

/**
 * __useRolesListFieldQuery__
 *
 * To run a query within a React component, call `useRolesListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesListFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesListFieldQuery(baseOptions?: Apollo.QueryHookOptions<RolesListFieldQuery, RolesListFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesListFieldQuery, RolesListFieldQueryVariables>(RolesListFieldDocument, options);
      }
export function useRolesListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesListFieldQuery, RolesListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesListFieldQuery, RolesListFieldQueryVariables>(RolesListFieldDocument, options);
        }
export function useRolesListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RolesListFieldQuery, RolesListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RolesListFieldQuery, RolesListFieldQueryVariables>(RolesListFieldDocument, options);
        }
export type RolesListFieldQueryHookResult = ReturnType<typeof useRolesListFieldQuery>;
export type RolesListFieldLazyQueryHookResult = ReturnType<typeof useRolesListFieldLazyQuery>;
export type RolesListFieldSuspenseQueryHookResult = ReturnType<typeof useRolesListFieldSuspenseQuery>;
export type RolesListFieldQueryResult = Apollo.QueryResult<RolesListFieldQuery, RolesListFieldQueryVariables>;
export const UniqueRoutesListFieldDocument = /*#__PURE__*/ gql`
    query UniqueRoutesListField($paginate: PaginatorArgsDto!) {
  classifiers {
    routesControlAvailabilitySeatsDirection {
      uniqueRoutes(paginate: $paginate) {
        totalCount
        items {
          city {
            id
            full_name
          }
          top_routes_ids
        }
      }
    }
  }
}
    `;

/**
 * __useUniqueRoutesListFieldQuery__
 *
 * To run a query within a React component, call `useUniqueRoutesListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniqueRoutesListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniqueRoutesListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useUniqueRoutesListFieldQuery(baseOptions: Apollo.QueryHookOptions<UniqueRoutesListFieldQuery, UniqueRoutesListFieldQueryVariables> & ({ variables: UniqueRoutesListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniqueRoutesListFieldQuery, UniqueRoutesListFieldQueryVariables>(UniqueRoutesListFieldDocument, options);
      }
export function useUniqueRoutesListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniqueRoutesListFieldQuery, UniqueRoutesListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniqueRoutesListFieldQuery, UniqueRoutesListFieldQueryVariables>(UniqueRoutesListFieldDocument, options);
        }
export function useUniqueRoutesListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UniqueRoutesListFieldQuery, UniqueRoutesListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniqueRoutesListFieldQuery, UniqueRoutesListFieldQueryVariables>(UniqueRoutesListFieldDocument, options);
        }
export type UniqueRoutesListFieldQueryHookResult = ReturnType<typeof useUniqueRoutesListFieldQuery>;
export type UniqueRoutesListFieldLazyQueryHookResult = ReturnType<typeof useUniqueRoutesListFieldLazyQuery>;
export type UniqueRoutesListFieldSuspenseQueryHookResult = ReturnType<typeof useUniqueRoutesListFieldSuspenseQuery>;
export type UniqueRoutesListFieldQueryResult = Apollo.QueryResult<UniqueRoutesListFieldQuery, UniqueRoutesListFieldQueryVariables>;
export const StationListFieldDocument = /*#__PURE__*/ gql`
    query stationListField($where: StationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    station {
      list(
        paginate: {per_page: 100, page: 0}
        order_by: []
        where: $where
        range: $range
      ) {
        items {
          ...StationShortFragment
        }
      }
    }
  }
}
    ${StationShortFragmentFragmentDoc}`;

/**
 * __useStationListFieldQuery__
 *
 * To run a query within a React component, call `useStationListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useStationListFieldQuery(baseOptions: Apollo.QueryHookOptions<StationListFieldQuery, StationListFieldQueryVariables> & ({ variables: StationListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StationListFieldQuery, StationListFieldQueryVariables>(StationListFieldDocument, options);
      }
export function useStationListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StationListFieldQuery, StationListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StationListFieldQuery, StationListFieldQueryVariables>(StationListFieldDocument, options);
        }
export function useStationListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StationListFieldQuery, StationListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StationListFieldQuery, StationListFieldQueryVariables>(StationListFieldDocument, options);
        }
export type StationListFieldQueryHookResult = ReturnType<typeof useStationListFieldQuery>;
export type StationListFieldLazyQueryHookResult = ReturnType<typeof useStationListFieldLazyQuery>;
export type StationListFieldSuspenseQueryHookResult = ReturnType<typeof useStationListFieldSuspenseQuery>;
export type StationListFieldQueryResult = Apollo.QueryResult<StationListFieldQuery, StationListFieldQueryVariables>;
export const StructuralSubdivisionListFieldDocument = /*#__PURE__*/ gql`
    query structuralSubdivisionListField($paginate: PaginatorArgsDto, $orderBy: [StructuralSubdivisionQueryResolver_List_SortingInputType!], $where: StructuralSubdivisionQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    structuralSubdivision {
      list(range: $range, where: $where, paginate: $paginate, order_by: $orderBy) {
        items {
          ...StructuralSubdivisionBaseFragment
          station {
            entity_id
            full_name
          }
        }
      }
    }
  }
}
    ${StructuralSubdivisionBaseFragmentFragmentDoc}`;

/**
 * __useStructuralSubdivisionListFieldQuery__
 *
 * To run a query within a React component, call `useStructuralSubdivisionListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuralSubdivisionListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuralSubdivisionListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useStructuralSubdivisionListFieldQuery(baseOptions: Apollo.QueryHookOptions<StructuralSubdivisionListFieldQuery, StructuralSubdivisionListFieldQueryVariables> & ({ variables: StructuralSubdivisionListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuralSubdivisionListFieldQuery, StructuralSubdivisionListFieldQueryVariables>(StructuralSubdivisionListFieldDocument, options);
      }
export function useStructuralSubdivisionListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuralSubdivisionListFieldQuery, StructuralSubdivisionListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuralSubdivisionListFieldQuery, StructuralSubdivisionListFieldQueryVariables>(StructuralSubdivisionListFieldDocument, options);
        }
export function useStructuralSubdivisionListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructuralSubdivisionListFieldQuery, StructuralSubdivisionListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructuralSubdivisionListFieldQuery, StructuralSubdivisionListFieldQueryVariables>(StructuralSubdivisionListFieldDocument, options);
        }
export type StructuralSubdivisionListFieldQueryHookResult = ReturnType<typeof useStructuralSubdivisionListFieldQuery>;
export type StructuralSubdivisionListFieldLazyQueryHookResult = ReturnType<typeof useStructuralSubdivisionListFieldLazyQuery>;
export type StructuralSubdivisionListFieldSuspenseQueryHookResult = ReturnType<typeof useStructuralSubdivisionListFieldSuspenseQuery>;
export type StructuralSubdivisionListFieldQueryResult = Apollo.QueryResult<StructuralSubdivisionListFieldQuery, StructuralSubdivisionListFieldQueryVariables>;
export const TractionDirectorateListFieldDocument = /*#__PURE__*/ gql`
    query tractionDirectorateListField($where: TractionDirectorateQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    tractionDirectorate {
      list(paginate: {per_page: 100, page: 0}, where: $where, range: $range) {
        items {
          ...TractionDirectorateBaseFragment
        }
      }
    }
  }
}
    ${TractionDirectorateBaseFragmentFragmentDoc}`;

/**
 * __useTractionDirectorateListFieldQuery__
 *
 * To run a query within a React component, call `useTractionDirectorateListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTractionDirectorateListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTractionDirectorateListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTractionDirectorateListFieldQuery(baseOptions: Apollo.QueryHookOptions<TractionDirectorateListFieldQuery, TractionDirectorateListFieldQueryVariables> & ({ variables: TractionDirectorateListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TractionDirectorateListFieldQuery, TractionDirectorateListFieldQueryVariables>(TractionDirectorateListFieldDocument, options);
      }
export function useTractionDirectorateListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TractionDirectorateListFieldQuery, TractionDirectorateListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TractionDirectorateListFieldQuery, TractionDirectorateListFieldQueryVariables>(TractionDirectorateListFieldDocument, options);
        }
export function useTractionDirectorateListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TractionDirectorateListFieldQuery, TractionDirectorateListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TractionDirectorateListFieldQuery, TractionDirectorateListFieldQueryVariables>(TractionDirectorateListFieldDocument, options);
        }
export type TractionDirectorateListFieldQueryHookResult = ReturnType<typeof useTractionDirectorateListFieldQuery>;
export type TractionDirectorateListFieldLazyQueryHookResult = ReturnType<typeof useTractionDirectorateListFieldLazyQuery>;
export type TractionDirectorateListFieldSuspenseQueryHookResult = ReturnType<typeof useTractionDirectorateListFieldSuspenseQuery>;
export type TractionDirectorateListFieldQueryResult = Apollo.QueryResult<TractionDirectorateListFieldQuery, TractionDirectorateListFieldQueryVariables>;
export const TrainBrandListFieldDocument = /*#__PURE__*/ gql`
    query trainBrandListField($where: TrainBrandQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    trainBrand {
      list(paginate: {per_page: 100, page: 0}, where: $where, range: $range) {
        items {
          ...TrainBrandBaseFragment
        }
      }
    }
  }
}
    ${TrainBrandBaseFragmentFragmentDoc}`;

/**
 * __useTrainBrandListFieldQuery__
 *
 * To run a query within a React component, call `useTrainBrandListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainBrandListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainBrandListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainBrandListFieldQuery(baseOptions: Apollo.QueryHookOptions<TrainBrandListFieldQuery, TrainBrandListFieldQueryVariables> & ({ variables: TrainBrandListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainBrandListFieldQuery, TrainBrandListFieldQueryVariables>(TrainBrandListFieldDocument, options);
      }
export function useTrainBrandListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainBrandListFieldQuery, TrainBrandListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainBrandListFieldQuery, TrainBrandListFieldQueryVariables>(TrainBrandListFieldDocument, options);
        }
export function useTrainBrandListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainBrandListFieldQuery, TrainBrandListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainBrandListFieldQuery, TrainBrandListFieldQueryVariables>(TrainBrandListFieldDocument, options);
        }
export type TrainBrandListFieldQueryHookResult = ReturnType<typeof useTrainBrandListFieldQuery>;
export type TrainBrandListFieldLazyQueryHookResult = ReturnType<typeof useTrainBrandListFieldLazyQuery>;
export type TrainBrandListFieldSuspenseQueryHookResult = ReturnType<typeof useTrainBrandListFieldSuspenseQuery>;
export type TrainBrandListFieldQueryResult = Apollo.QueryResult<TrainBrandListFieldQuery, TrainBrandListFieldQueryVariables>;
export const TrainCategoryListFieldDocument = /*#__PURE__*/ gql`
    query trainCategoryListField($range: RangeInputDto!, $paginate: PaginatorArgsDto, $orderBy: [TrainCategoryQueryResolver_List_SortingInputType!], $where: TrainCategoryQueryResolver_List_FilterInputType) {
  classifiers {
    trainCategory {
      list(range: $range, where: $where, paginate: $paginate, order_by: $orderBy) {
        items {
          entity_id
          train_category
        }
      }
    }
  }
}
    `;

/**
 * __useTrainCategoryListFieldQuery__
 *
 * To run a query within a React component, call `useTrainCategoryListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainCategoryListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainCategoryListFieldQuery({
 *   variables: {
 *      range: // value for 'range'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrainCategoryListFieldQuery(baseOptions: Apollo.QueryHookOptions<TrainCategoryListFieldQuery, TrainCategoryListFieldQueryVariables> & ({ variables: TrainCategoryListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainCategoryListFieldQuery, TrainCategoryListFieldQueryVariables>(TrainCategoryListFieldDocument, options);
      }
export function useTrainCategoryListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainCategoryListFieldQuery, TrainCategoryListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainCategoryListFieldQuery, TrainCategoryListFieldQueryVariables>(TrainCategoryListFieldDocument, options);
        }
export function useTrainCategoryListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainCategoryListFieldQuery, TrainCategoryListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainCategoryListFieldQuery, TrainCategoryListFieldQueryVariables>(TrainCategoryListFieldDocument, options);
        }
export type TrainCategoryListFieldQueryHookResult = ReturnType<typeof useTrainCategoryListFieldQuery>;
export type TrainCategoryListFieldLazyQueryHookResult = ReturnType<typeof useTrainCategoryListFieldLazyQuery>;
export type TrainCategoryListFieldSuspenseQueryHookResult = ReturnType<typeof useTrainCategoryListFieldSuspenseQuery>;
export type TrainCategoryListFieldQueryResult = Apollo.QueryResult<TrainCategoryListFieldQuery, TrainCategoryListFieldQueryVariables>;
export const TrainSubCategoryListFieldDocument = /*#__PURE__*/ gql`
    query trainSubCategoryListField($range: RangeInputDto!, $paginate: PaginatorArgsDto, $orderBy: [TrainSubCategoryQueryResolver_List_SortingInputType!], $where: TrainSubCategoryQueryResolver_List_FilterInputType) {
  classifiers {
    trainSubCategory {
      list(range: $range, where: $where, paginate: $paginate, order_by: $orderBy) {
        items {
          ...TrainSubCategoryShortFragment
        }
      }
    }
  }
}
    ${TrainSubCategoryShortFragmentFragmentDoc}`;

/**
 * __useTrainSubCategoryListFieldQuery__
 *
 * To run a query within a React component, call `useTrainSubCategoryListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainSubCategoryListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainSubCategoryListFieldQuery({
 *   variables: {
 *      range: // value for 'range'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrainSubCategoryListFieldQuery(baseOptions: Apollo.QueryHookOptions<TrainSubCategoryListFieldQuery, TrainSubCategoryListFieldQueryVariables> & ({ variables: TrainSubCategoryListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainSubCategoryListFieldQuery, TrainSubCategoryListFieldQueryVariables>(TrainSubCategoryListFieldDocument, options);
      }
export function useTrainSubCategoryListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainSubCategoryListFieldQuery, TrainSubCategoryListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainSubCategoryListFieldQuery, TrainSubCategoryListFieldQueryVariables>(TrainSubCategoryListFieldDocument, options);
        }
export function useTrainSubCategoryListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainSubCategoryListFieldQuery, TrainSubCategoryListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainSubCategoryListFieldQuery, TrainSubCategoryListFieldQueryVariables>(TrainSubCategoryListFieldDocument, options);
        }
export type TrainSubCategoryListFieldQueryHookResult = ReturnType<typeof useTrainSubCategoryListFieldQuery>;
export type TrainSubCategoryListFieldLazyQueryHookResult = ReturnType<typeof useTrainSubCategoryListFieldLazyQuery>;
export type TrainSubCategoryListFieldSuspenseQueryHookResult = ReturnType<typeof useTrainSubCategoryListFieldSuspenseQuery>;
export type TrainSubCategoryListFieldQueryResult = Apollo.QueryResult<TrainSubCategoryListFieldQuery, TrainSubCategoryListFieldQueryVariables>;
export const ControlSchemaNmrvagTrainsListFieldDocument = /*#__PURE__*/ gql`
    query controlSchemaNmrvagTrainsListField($date: String!, $paginate: PaginatorArgsDto!, $where: ControlSchemaQueryResolver_ListTrainsNmrvag_FilterInputType) {
  tpc {
    control_schema {
      listTrainsNmrvag(date: $date, paginate: $paginate, where: $where) {
        items {
          id
          train_number
          station_from {
            ...StationShortFragment
          }
          station_to {
            ...StationShortFragment
          }
        }
      }
    }
  }
}
    ${StationShortFragmentFragmentDoc}`;

/**
 * __useControlSchemaNmrvagTrainsListFieldQuery__
 *
 * To run a query within a React component, call `useControlSchemaNmrvagTrainsListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlSchemaNmrvagTrainsListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlSchemaNmrvagTrainsListFieldQuery({
 *   variables: {
 *      date: // value for 'date'
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useControlSchemaNmrvagTrainsListFieldQuery(baseOptions: Apollo.QueryHookOptions<ControlSchemaNmrvagTrainsListFieldQuery, ControlSchemaNmrvagTrainsListFieldQueryVariables> & ({ variables: ControlSchemaNmrvagTrainsListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlSchemaNmrvagTrainsListFieldQuery, ControlSchemaNmrvagTrainsListFieldQueryVariables>(ControlSchemaNmrvagTrainsListFieldDocument, options);
      }
export function useControlSchemaNmrvagTrainsListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlSchemaNmrvagTrainsListFieldQuery, ControlSchemaNmrvagTrainsListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlSchemaNmrvagTrainsListFieldQuery, ControlSchemaNmrvagTrainsListFieldQueryVariables>(ControlSchemaNmrvagTrainsListFieldDocument, options);
        }
export function useControlSchemaNmrvagTrainsListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ControlSchemaNmrvagTrainsListFieldQuery, ControlSchemaNmrvagTrainsListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlSchemaNmrvagTrainsListFieldQuery, ControlSchemaNmrvagTrainsListFieldQueryVariables>(ControlSchemaNmrvagTrainsListFieldDocument, options);
        }
export type ControlSchemaNmrvagTrainsListFieldQueryHookResult = ReturnType<typeof useControlSchemaNmrvagTrainsListFieldQuery>;
export type ControlSchemaNmrvagTrainsListFieldLazyQueryHookResult = ReturnType<typeof useControlSchemaNmrvagTrainsListFieldLazyQuery>;
export type ControlSchemaNmrvagTrainsListFieldSuspenseQueryHookResult = ReturnType<typeof useControlSchemaNmrvagTrainsListFieldSuspenseQuery>;
export type ControlSchemaNmrvagTrainsListFieldQueryResult = Apollo.QueryResult<ControlSchemaNmrvagTrainsListFieldQuery, ControlSchemaNmrvagTrainsListFieldQueryVariables>;
export const ControlSchemaTrainsListFieldDocument = /*#__PURE__*/ gql`
    query controlSchemaTrainsListField($paginate: PaginatorArgsDto!, $where: ControlSchemaQueryResolver_ListTrains_FilterInputType) {
  tpc {
    control_schema {
      listTrains(paginate: $paginate, where: $where) {
        items {
          id
          train_number
          version
          station_from {
            entity_id
            id
            full_name
          }
          station_to {
            entity_id
            id
            full_name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useControlSchemaTrainsListFieldQuery__
 *
 * To run a query within a React component, call `useControlSchemaTrainsListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlSchemaTrainsListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlSchemaTrainsListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useControlSchemaTrainsListFieldQuery(baseOptions: Apollo.QueryHookOptions<ControlSchemaTrainsListFieldQuery, ControlSchemaTrainsListFieldQueryVariables> & ({ variables: ControlSchemaTrainsListFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlSchemaTrainsListFieldQuery, ControlSchemaTrainsListFieldQueryVariables>(ControlSchemaTrainsListFieldDocument, options);
      }
export function useControlSchemaTrainsListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlSchemaTrainsListFieldQuery, ControlSchemaTrainsListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlSchemaTrainsListFieldQuery, ControlSchemaTrainsListFieldQueryVariables>(ControlSchemaTrainsListFieldDocument, options);
        }
export function useControlSchemaTrainsListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ControlSchemaTrainsListFieldQuery, ControlSchemaTrainsListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlSchemaTrainsListFieldQuery, ControlSchemaTrainsListFieldQueryVariables>(ControlSchemaTrainsListFieldDocument, options);
        }
export type ControlSchemaTrainsListFieldQueryHookResult = ReturnType<typeof useControlSchemaTrainsListFieldQuery>;
export type ControlSchemaTrainsListFieldLazyQueryHookResult = ReturnType<typeof useControlSchemaTrainsListFieldLazyQuery>;
export type ControlSchemaTrainsListFieldSuspenseQueryHookResult = ReturnType<typeof useControlSchemaTrainsListFieldSuspenseQuery>;
export type ControlSchemaTrainsListFieldQueryResult = Apollo.QueryResult<ControlSchemaTrainsListFieldQuery, ControlSchemaTrainsListFieldQueryVariables>;
export const IndicatorsTrainsListFieldDocument = /*#__PURE__*/ gql`
    query indicatorsTrainsListField($where: IndicatorsQueryResolver_ListTrains_FilterInputType, $orderBy: [IndicatorsQueryResolver_ListTrains_SortingInputType!]) {
  indicators {
    list_trains(
      paginate: {page: 0, per_page: 20}
      where: $where
      order_by: $orderBy
    ) {
      items {
        ...IndicatorsTrainShortFragment
      }
    }
  }
}
    ${IndicatorsTrainShortFragmentFragmentDoc}`;

/**
 * __useIndicatorsTrainsListFieldQuery__
 *
 * To run a query within a React component, call `useIndicatorsTrainsListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorsTrainsListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorsTrainsListFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useIndicatorsTrainsListFieldQuery(baseOptions?: Apollo.QueryHookOptions<IndicatorsTrainsListFieldQuery, IndicatorsTrainsListFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorsTrainsListFieldQuery, IndicatorsTrainsListFieldQueryVariables>(IndicatorsTrainsListFieldDocument, options);
      }
export function useIndicatorsTrainsListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorsTrainsListFieldQuery, IndicatorsTrainsListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorsTrainsListFieldQuery, IndicatorsTrainsListFieldQueryVariables>(IndicatorsTrainsListFieldDocument, options);
        }
export function useIndicatorsTrainsListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndicatorsTrainsListFieldQuery, IndicatorsTrainsListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndicatorsTrainsListFieldQuery, IndicatorsTrainsListFieldQueryVariables>(IndicatorsTrainsListFieldDocument, options);
        }
export type IndicatorsTrainsListFieldQueryHookResult = ReturnType<typeof useIndicatorsTrainsListFieldQuery>;
export type IndicatorsTrainsListFieldLazyQueryHookResult = ReturnType<typeof useIndicatorsTrainsListFieldLazyQuery>;
export type IndicatorsTrainsListFieldSuspenseQueryHookResult = ReturnType<typeof useIndicatorsTrainsListFieldSuspenseQuery>;
export type IndicatorsTrainsListFieldQueryResult = Apollo.QueryResult<IndicatorsTrainsListFieldQuery, IndicatorsTrainsListFieldQueryVariables>;
export const UserListFieldDocument = /*#__PURE__*/ gql`
    query userListField($paginate: PaginatorArgsDto, $orderBy: [UsersQueryResolver_List_SortingInputType!], $where: UsersQueryResolver_List_FilterInputType) {
  users {
    list(paginate: $paginate, order_by: $orderBy, where: $where) {
      items {
        id
        full_name
        branch {
          entity_id
          short_name
        }
      }
    }
  }
}
    `;

/**
 * __useUserListFieldQuery__
 *
 * To run a query within a React component, call `useUserListFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListFieldQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserListFieldQuery(baseOptions?: Apollo.QueryHookOptions<UserListFieldQuery, UserListFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListFieldQuery, UserListFieldQueryVariables>(UserListFieldDocument, options);
      }
export function useUserListFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListFieldQuery, UserListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListFieldQuery, UserListFieldQueryVariables>(UserListFieldDocument, options);
        }
export function useUserListFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserListFieldQuery, UserListFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserListFieldQuery, UserListFieldQueryVariables>(UserListFieldDocument, options);
        }
export type UserListFieldQueryHookResult = ReturnType<typeof useUserListFieldQuery>;
export type UserListFieldLazyQueryHookResult = ReturnType<typeof useUserListFieldLazyQuery>;
export type UserListFieldSuspenseQueryHookResult = ReturnType<typeof useUserListFieldSuspenseQuery>;
export type UserListFieldQueryResult = Apollo.QueryResult<UserListFieldQuery, UserListFieldQueryVariables>;
export const GdpListViewDocument = /*#__PURE__*/ gql`
    query gdpListView {
  classifiers {
    gdp {
      list(paginate: {per_page: 20, page: 0}) {
        items {
          ...GdpShortFragment
        }
      }
    }
  }
}
    ${GdpShortFragmentFragmentDoc}`;

/**
 * __useGdpListViewQuery__
 *
 * To run a query within a React component, call `useGdpListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGdpListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGdpListViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGdpListViewQuery(baseOptions?: Apollo.QueryHookOptions<GdpListViewQuery, GdpListViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GdpListViewQuery, GdpListViewQueryVariables>(GdpListViewDocument, options);
      }
export function useGdpListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GdpListViewQuery, GdpListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GdpListViewQuery, GdpListViewQueryVariables>(GdpListViewDocument, options);
        }
export function useGdpListViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GdpListViewQuery, GdpListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GdpListViewQuery, GdpListViewQueryVariables>(GdpListViewDocument, options);
        }
export type GdpListViewQueryHookResult = ReturnType<typeof useGdpListViewQuery>;
export type GdpListViewLazyQueryHookResult = ReturnType<typeof useGdpListViewLazyQuery>;
export type GdpListViewSuspenseQueryHookResult = ReturnType<typeof useGdpListViewSuspenseQuery>;
export type GdpListViewQueryResult = Apollo.QueryResult<GdpListViewQuery, GdpListViewQueryVariables>;
export const CarriageGroupIndicatorsMonthlyDocument = /*#__PURE__*/ gql`
    query carriageGroupIndicatorsMonthly($paginate: PaginatorArgsDto, $orderBy: [IndicatorsQueryResolver_IndicatorsMonthly_SortingInputType!], $where: IndicatorsQueryResolver_IndicatorsMonthly_FilterInputType, $carriageGroupId: Float!) {
  indicators {
    indicators_monthly(
      paginate: $paginate
      order_by: $orderBy
      where: $where
      carriage_group_id: $carriageGroupId
    ) {
      totalCount
      items {
        id
        month
        trips_quantity
        is_calendar_active
        departure_dates
        carriage_type_indicators {
          id
          fact
          forecast
          carriages_by_date {
            id
            created_at
            updated_at
            created_by
            updated_by
            date
            carriages_quantity
          }
          carriage_type {
            id
            name
            description
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCarriageGroupIndicatorsMonthlyQuery__
 *
 * To run a query within a React component, call `useCarriageGroupIndicatorsMonthlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupIndicatorsMonthlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageGroupIndicatorsMonthlyQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      carriageGroupId: // value for 'carriageGroupId'
 *   },
 * });
 */
export function useCarriageGroupIndicatorsMonthlyQuery(baseOptions: Apollo.QueryHookOptions<CarriageGroupIndicatorsMonthlyQuery, CarriageGroupIndicatorsMonthlyQueryVariables> & ({ variables: CarriageGroupIndicatorsMonthlyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageGroupIndicatorsMonthlyQuery, CarriageGroupIndicatorsMonthlyQueryVariables>(CarriageGroupIndicatorsMonthlyDocument, options);
      }
export function useCarriageGroupIndicatorsMonthlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageGroupIndicatorsMonthlyQuery, CarriageGroupIndicatorsMonthlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageGroupIndicatorsMonthlyQuery, CarriageGroupIndicatorsMonthlyQueryVariables>(CarriageGroupIndicatorsMonthlyDocument, options);
        }
export function useCarriageGroupIndicatorsMonthlySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageGroupIndicatorsMonthlyQuery, CarriageGroupIndicatorsMonthlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageGroupIndicatorsMonthlyQuery, CarriageGroupIndicatorsMonthlyQueryVariables>(CarriageGroupIndicatorsMonthlyDocument, options);
        }
export type CarriageGroupIndicatorsMonthlyQueryHookResult = ReturnType<typeof useCarriageGroupIndicatorsMonthlyQuery>;
export type CarriageGroupIndicatorsMonthlyLazyQueryHookResult = ReturnType<typeof useCarriageGroupIndicatorsMonthlyLazyQuery>;
export type CarriageGroupIndicatorsMonthlySuspenseQueryHookResult = ReturnType<typeof useCarriageGroupIndicatorsMonthlySuspenseQuery>;
export type CarriageGroupIndicatorsMonthlyQueryResult = Apollo.QueryResult<CarriageGroupIndicatorsMonthlyQuery, CarriageGroupIndicatorsMonthlyQueryVariables>;
export const NotificationsUserDocument = /*#__PURE__*/ gql`
    query notificationsUser($paginate: PaginatorArgsDto) {
  notification {
    messages_user(paginate: $paginate) {
      totalCount
      items {
        created_at
        viewed
        type
        payload {
          type
          data {
            args
            entity
            message
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationsUserQuery__
 *
 * To run a query within a React component, call `useNotificationsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsUserQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useNotificationsUserQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsUserQuery, NotificationsUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsUserQuery, NotificationsUserQueryVariables>(NotificationsUserDocument, options);
      }
export function useNotificationsUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsUserQuery, NotificationsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsUserQuery, NotificationsUserQueryVariables>(NotificationsUserDocument, options);
        }
export function useNotificationsUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationsUserQuery, NotificationsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsUserQuery, NotificationsUserQueryVariables>(NotificationsUserDocument, options);
        }
export type NotificationsUserQueryHookResult = ReturnType<typeof useNotificationsUserQuery>;
export type NotificationsUserLazyQueryHookResult = ReturnType<typeof useNotificationsUserLazyQuery>;
export type NotificationsUserSuspenseQueryHookResult = ReturnType<typeof useNotificationsUserSuspenseQuery>;
export type NotificationsUserQueryResult = Apollo.QueryResult<NotificationsUserQuery, NotificationsUserQueryVariables>;
export const NotificationsUserClearAllDocument = /*#__PURE__*/ gql`
    mutation notificationsUserClearAll {
  notification {
    clear_messages_user
  }
}
    `;
export type NotificationsUserClearAllMutationFn = Apollo.MutationFunction<NotificationsUserClearAllMutation, NotificationsUserClearAllMutationVariables>;

/**
 * __useNotificationsUserClearAllMutation__
 *
 * To run a mutation, you first call `useNotificationsUserClearAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsUserClearAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsUserClearAllMutation, { data, loading, error }] = useNotificationsUserClearAllMutation({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsUserClearAllMutation(baseOptions?: Apollo.MutationHookOptions<NotificationsUserClearAllMutation, NotificationsUserClearAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationsUserClearAllMutation, NotificationsUserClearAllMutationVariables>(NotificationsUserClearAllDocument, options);
      }
export type NotificationsUserClearAllMutationHookResult = ReturnType<typeof useNotificationsUserClearAllMutation>;
export type NotificationsUserClearAllMutationResult = Apollo.MutationResult<NotificationsUserClearAllMutation>;
export type NotificationsUserClearAllMutationOptions = Apollo.BaseMutationOptions<NotificationsUserClearAllMutation, NotificationsUserClearAllMutationVariables>;
export const CheckBoxMessageTextTrainSubCategoryDocument = /*#__PURE__*/ gql`
    query checkBoxMessageTextTrainSubCategory($range: RangeInputDto!, $where: TrainCategoryQueryResolver_List_FilterInputType) {
  classifiers {
    trainCategory {
      list(range: $range, where: $where) {
        items {
          train_category
          train_sub_categories {
            train_sub_category
            train_numbers
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCheckBoxMessageTextTrainSubCategoryQuery__
 *
 * To run a query within a React component, call `useCheckBoxMessageTextTrainSubCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckBoxMessageTextTrainSubCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckBoxMessageTextTrainSubCategoryQuery({
 *   variables: {
 *      range: // value for 'range'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCheckBoxMessageTextTrainSubCategoryQuery(baseOptions: Apollo.QueryHookOptions<CheckBoxMessageTextTrainSubCategoryQuery, CheckBoxMessageTextTrainSubCategoryQueryVariables> & ({ variables: CheckBoxMessageTextTrainSubCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckBoxMessageTextTrainSubCategoryQuery, CheckBoxMessageTextTrainSubCategoryQueryVariables>(CheckBoxMessageTextTrainSubCategoryDocument, options);
      }
export function useCheckBoxMessageTextTrainSubCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckBoxMessageTextTrainSubCategoryQuery, CheckBoxMessageTextTrainSubCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckBoxMessageTextTrainSubCategoryQuery, CheckBoxMessageTextTrainSubCategoryQueryVariables>(CheckBoxMessageTextTrainSubCategoryDocument, options);
        }
export function useCheckBoxMessageTextTrainSubCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckBoxMessageTextTrainSubCategoryQuery, CheckBoxMessageTextTrainSubCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckBoxMessageTextTrainSubCategoryQuery, CheckBoxMessageTextTrainSubCategoryQueryVariables>(CheckBoxMessageTextTrainSubCategoryDocument, options);
        }
export type CheckBoxMessageTextTrainSubCategoryQueryHookResult = ReturnType<typeof useCheckBoxMessageTextTrainSubCategoryQuery>;
export type CheckBoxMessageTextTrainSubCategoryLazyQueryHookResult = ReturnType<typeof useCheckBoxMessageTextTrainSubCategoryLazyQuery>;
export type CheckBoxMessageTextTrainSubCategorySuspenseQueryHookResult = ReturnType<typeof useCheckBoxMessageTextTrainSubCategorySuspenseQuery>;
export type CheckBoxMessageTextTrainSubCategoryQueryResult = Apollo.QueryResult<CheckBoxMessageTextTrainSubCategoryQuery, CheckBoxMessageTextTrainSubCategoryQueryVariables>;
export const StationListByTrainIdForTrainViewDocument = /*#__PURE__*/ gql`
    query stationListByTrainIdForTrainView($id: Float!) {
  train {
    byId(id: $id) {
      id
      schedule {
        id
        train_schedule_fragments {
          id
          station {
            ...StationShortFragment
          }
        }
      }
    }
  }
}
    ${StationShortFragmentFragmentDoc}`;

/**
 * __useStationListByTrainIdForTrainViewQuery__
 *
 * To run a query within a React component, call `useStationListByTrainIdForTrainViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationListByTrainIdForTrainViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationListByTrainIdForTrainViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStationListByTrainIdForTrainViewQuery(baseOptions: Apollo.QueryHookOptions<StationListByTrainIdForTrainViewQuery, StationListByTrainIdForTrainViewQueryVariables> & ({ variables: StationListByTrainIdForTrainViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StationListByTrainIdForTrainViewQuery, StationListByTrainIdForTrainViewQueryVariables>(StationListByTrainIdForTrainViewDocument, options);
      }
export function useStationListByTrainIdForTrainViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StationListByTrainIdForTrainViewQuery, StationListByTrainIdForTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StationListByTrainIdForTrainViewQuery, StationListByTrainIdForTrainViewQueryVariables>(StationListByTrainIdForTrainViewDocument, options);
        }
export function useStationListByTrainIdForTrainViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StationListByTrainIdForTrainViewQuery, StationListByTrainIdForTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StationListByTrainIdForTrainViewQuery, StationListByTrainIdForTrainViewQueryVariables>(StationListByTrainIdForTrainViewDocument, options);
        }
export type StationListByTrainIdForTrainViewQueryHookResult = ReturnType<typeof useStationListByTrainIdForTrainViewQuery>;
export type StationListByTrainIdForTrainViewLazyQueryHookResult = ReturnType<typeof useStationListByTrainIdForTrainViewLazyQuery>;
export type StationListByTrainIdForTrainViewSuspenseQueryHookResult = ReturnType<typeof useStationListByTrainIdForTrainViewSuspenseQuery>;
export type StationListByTrainIdForTrainViewQueryResult = Apollo.QueryResult<StationListByTrainIdForTrainViewQuery, StationListByTrainIdForTrainViewQueryVariables>;
export const StationsListForTrainViewDocument = /*#__PURE__*/ gql`
    query stationsListForTrainView($where: StationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    station {
      list(
        paginate: {per_page: 20, page: 0}
        order_by: []
        where: $where
        range: $range
      ) {
        items {
          ...StationShortFragment
        }
      }
    }
  }
}
    ${StationShortFragmentFragmentDoc}`;

/**
 * __useStationsListForTrainViewQuery__
 *
 * To run a query within a React component, call `useStationsListForTrainViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationsListForTrainViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationsListForTrainViewQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useStationsListForTrainViewQuery(baseOptions: Apollo.QueryHookOptions<StationsListForTrainViewQuery, StationsListForTrainViewQueryVariables> & ({ variables: StationsListForTrainViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StationsListForTrainViewQuery, StationsListForTrainViewQueryVariables>(StationsListForTrainViewDocument, options);
      }
export function useStationsListForTrainViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StationsListForTrainViewQuery, StationsListForTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StationsListForTrainViewQuery, StationsListForTrainViewQueryVariables>(StationsListForTrainViewDocument, options);
        }
export function useStationsListForTrainViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StationsListForTrainViewQuery, StationsListForTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StationsListForTrainViewQuery, StationsListForTrainViewQueryVariables>(StationsListForTrainViewDocument, options);
        }
export type StationsListForTrainViewQueryHookResult = ReturnType<typeof useStationsListForTrainViewQuery>;
export type StationsListForTrainViewLazyQueryHookResult = ReturnType<typeof useStationsListForTrainViewLazyQuery>;
export type StationsListForTrainViewSuspenseQueryHookResult = ReturnType<typeof useStationsListForTrainViewSuspenseQuery>;
export type StationsListForTrainViewQueryResult = Apollo.QueryResult<StationsListForTrainViewQuery, StationsListForTrainViewQueryVariables>;
export const TrainSubCategoryByTrainNumberForTrainViewDocument = /*#__PURE__*/ gql`
    query trainSubCategoryByTrainNumberForTrainView($trainNumber: String!, $range: RangeInputDto!) {
  classifiers {
    trainSubCategory {
      byTrainNumber(trainNumber: $trainNumber, range: $range) {
        items {
          entity_id
          train_sub_category
          train_category_id
        }
      }
    }
  }
}
    `;

/**
 * __useTrainSubCategoryByTrainNumberForTrainViewQuery__
 *
 * To run a query within a React component, call `useTrainSubCategoryByTrainNumberForTrainViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainSubCategoryByTrainNumberForTrainViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainSubCategoryByTrainNumberForTrainViewQuery({
 *   variables: {
 *      trainNumber: // value for 'trainNumber'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainSubCategoryByTrainNumberForTrainViewQuery(baseOptions: Apollo.QueryHookOptions<TrainSubCategoryByTrainNumberForTrainViewQuery, TrainSubCategoryByTrainNumberForTrainViewQueryVariables> & ({ variables: TrainSubCategoryByTrainNumberForTrainViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainSubCategoryByTrainNumberForTrainViewQuery, TrainSubCategoryByTrainNumberForTrainViewQueryVariables>(TrainSubCategoryByTrainNumberForTrainViewDocument, options);
      }
export function useTrainSubCategoryByTrainNumberForTrainViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainSubCategoryByTrainNumberForTrainViewQuery, TrainSubCategoryByTrainNumberForTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainSubCategoryByTrainNumberForTrainViewQuery, TrainSubCategoryByTrainNumberForTrainViewQueryVariables>(TrainSubCategoryByTrainNumberForTrainViewDocument, options);
        }
export function useTrainSubCategoryByTrainNumberForTrainViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainSubCategoryByTrainNumberForTrainViewQuery, TrainSubCategoryByTrainNumberForTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainSubCategoryByTrainNumberForTrainViewQuery, TrainSubCategoryByTrainNumberForTrainViewQueryVariables>(TrainSubCategoryByTrainNumberForTrainViewDocument, options);
        }
export type TrainSubCategoryByTrainNumberForTrainViewQueryHookResult = ReturnType<typeof useTrainSubCategoryByTrainNumberForTrainViewQuery>;
export type TrainSubCategoryByTrainNumberForTrainViewLazyQueryHookResult = ReturnType<typeof useTrainSubCategoryByTrainNumberForTrainViewLazyQuery>;
export type TrainSubCategoryByTrainNumberForTrainViewSuspenseQueryHookResult = ReturnType<typeof useTrainSubCategoryByTrainNumberForTrainViewSuspenseQuery>;
export type TrainSubCategoryByTrainNumberForTrainViewQueryResult = Apollo.QueryResult<TrainSubCategoryByTrainNumberForTrainViewQuery, TrainSubCategoryByTrainNumberForTrainViewQueryVariables>;
export const TrainPairByIdForTrainViewDocument = /*#__PURE__*/ gql`
    query trainPairByIdForTrainView($id: Float!) {
  train {
    pair(id: $id) {
      direct {
        ...TrainsPairByIdForTrainView
        schedule {
          id
        }
        schemas {
          id
        }
      }
      reverse {
        ...TrainsPairByIdForTrainView
      }
    }
  }
}
    ${TrainsPairByIdForTrainViewFragmentDoc}`;

/**
 * __useTrainPairByIdForTrainViewQuery__
 *
 * To run a query within a React component, call `useTrainPairByIdForTrainViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainPairByIdForTrainViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainPairByIdForTrainViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainPairByIdForTrainViewQuery(baseOptions: Apollo.QueryHookOptions<TrainPairByIdForTrainViewQuery, TrainPairByIdForTrainViewQueryVariables> & ({ variables: TrainPairByIdForTrainViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainPairByIdForTrainViewQuery, TrainPairByIdForTrainViewQueryVariables>(TrainPairByIdForTrainViewDocument, options);
      }
export function useTrainPairByIdForTrainViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainPairByIdForTrainViewQuery, TrainPairByIdForTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainPairByIdForTrainViewQuery, TrainPairByIdForTrainViewQueryVariables>(TrainPairByIdForTrainViewDocument, options);
        }
export function useTrainPairByIdForTrainViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainPairByIdForTrainViewQuery, TrainPairByIdForTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainPairByIdForTrainViewQuery, TrainPairByIdForTrainViewQueryVariables>(TrainPairByIdForTrainViewDocument, options);
        }
export type TrainPairByIdForTrainViewQueryHookResult = ReturnType<typeof useTrainPairByIdForTrainViewQuery>;
export type TrainPairByIdForTrainViewLazyQueryHookResult = ReturnType<typeof useTrainPairByIdForTrainViewLazyQuery>;
export type TrainPairByIdForTrainViewSuspenseQueryHookResult = ReturnType<typeof useTrainPairByIdForTrainViewSuspenseQuery>;
export type TrainPairByIdForTrainViewQueryResult = Apollo.QueryResult<TrainPairByIdForTrainViewQuery, TrainPairByIdForTrainViewQueryVariables>;
export const DivisionCreateDocument = /*#__PURE__*/ gql`
    mutation divisionCreate($data: CreateDivisionDto!) {
  rbac {
    create_division(data: $data) {
      ...DivisionFragment
      group {
        ...DivisionGroupFragment
      }
    }
  }
}
    ${DivisionFragmentFragmentDoc}
${DivisionGroupFragmentFragmentDoc}`;
export type DivisionCreateMutationFn = Apollo.MutationFunction<DivisionCreateMutation, DivisionCreateMutationVariables>;

/**
 * __useDivisionCreateMutation__
 *
 * To run a mutation, you first call `useDivisionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDivisionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [divisionCreateMutation, { data, loading, error }] = useDivisionCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDivisionCreateMutation(baseOptions?: Apollo.MutationHookOptions<DivisionCreateMutation, DivisionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DivisionCreateMutation, DivisionCreateMutationVariables>(DivisionCreateDocument, options);
      }
export type DivisionCreateMutationHookResult = ReturnType<typeof useDivisionCreateMutation>;
export type DivisionCreateMutationResult = Apollo.MutationResult<DivisionCreateMutation>;
export type DivisionCreateMutationOptions = Apollo.BaseMutationOptions<DivisionCreateMutation, DivisionCreateMutationVariables>;
export const DivisionsDocument = /*#__PURE__*/ gql`
    query divisions($paginate: PaginatorArgsDto, $orderBy: [RbacQueryResolver_Division_SortingInputType!], $where: RbacQueryResolver_Division_FilterInputType) {
  rbac {
    divisions(paginate: $paginate, order_by: $orderBy, where: $where) {
      totalCount
      items {
        ...DivisionFragment
        group {
          ...DivisionGroupFragment
        }
      }
    }
  }
}
    ${DivisionFragmentFragmentDoc}
${DivisionGroupFragmentFragmentDoc}`;

/**
 * __useDivisionsQuery__
 *
 * To run a query within a React component, call `useDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDivisionsQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDivisionsQuery(baseOptions?: Apollo.QueryHookOptions<DivisionsQuery, DivisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DivisionsQuery, DivisionsQueryVariables>(DivisionsDocument, options);
      }
export function useDivisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DivisionsQuery, DivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DivisionsQuery, DivisionsQueryVariables>(DivisionsDocument, options);
        }
export function useDivisionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DivisionsQuery, DivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DivisionsQuery, DivisionsQueryVariables>(DivisionsDocument, options);
        }
export type DivisionsQueryHookResult = ReturnType<typeof useDivisionsQuery>;
export type DivisionsLazyQueryHookResult = ReturnType<typeof useDivisionsLazyQuery>;
export type DivisionsSuspenseQueryHookResult = ReturnType<typeof useDivisionsSuspenseQuery>;
export type DivisionsQueryResult = Apollo.QueryResult<DivisionsQuery, DivisionsQueryVariables>;
export const DivisionUpdateDocument = /*#__PURE__*/ gql`
    mutation divisionUpdate($data: UpdateDivisionDto!) {
  rbac {
    update_division(data: $data) {
      ...DivisionFragment
    }
  }
}
    ${DivisionFragmentFragmentDoc}`;
export type DivisionUpdateMutationFn = Apollo.MutationFunction<DivisionUpdateMutation, DivisionUpdateMutationVariables>;

/**
 * __useDivisionUpdateMutation__
 *
 * To run a mutation, you first call `useDivisionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDivisionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [divisionUpdateMutation, { data, loading, error }] = useDivisionUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDivisionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DivisionUpdateMutation, DivisionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DivisionUpdateMutation, DivisionUpdateMutationVariables>(DivisionUpdateDocument, options);
      }
export type DivisionUpdateMutationHookResult = ReturnType<typeof useDivisionUpdateMutation>;
export type DivisionUpdateMutationResult = Apollo.MutationResult<DivisionUpdateMutation>;
export type DivisionUpdateMutationOptions = Apollo.BaseMutationOptions<DivisionUpdateMutation, DivisionUpdateMutationVariables>;
export const FeatureFlagsUpdateDocument = /*#__PURE__*/ gql`
    mutation featureFlagsUpdate($data: FeatureFlagsRequestDto!) {
  configuration {
    feature_flag_update(data: $data)
  }
}
    `;
export type FeatureFlagsUpdateMutationFn = Apollo.MutationFunction<FeatureFlagsUpdateMutation, FeatureFlagsUpdateMutationVariables>;

/**
 * __useFeatureFlagsUpdateMutation__
 *
 * To run a mutation, you first call `useFeatureFlagsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureFlagsUpdateMutation, { data, loading, error }] = useFeatureFlagsUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFeatureFlagsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FeatureFlagsUpdateMutation, FeatureFlagsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureFlagsUpdateMutation, FeatureFlagsUpdateMutationVariables>(FeatureFlagsUpdateDocument, options);
      }
export type FeatureFlagsUpdateMutationHookResult = ReturnType<typeof useFeatureFlagsUpdateMutation>;
export type FeatureFlagsUpdateMutationResult = Apollo.MutationResult<FeatureFlagsUpdateMutation>;
export type FeatureFlagsUpdateMutationOptions = Apollo.BaseMutationOptions<FeatureFlagsUpdateMutation, FeatureFlagsUpdateMutationVariables>;
export const FeatureFlagsDocument = /*#__PURE__*/ gql`
    query featureFlags($paginate: PaginatorArgsDto, $orderBy: [ConfigurationQueryResolver_FeatureFlagList_SortingInputType!], $where: ConfigurationQueryResolver_FeatureFlagList_FilterInputType) {
  configuration {
    feature_flag_list(paginate: $paginate, order_by: $orderBy, where: $where) {
      totalCount
      items {
        ...FeatureFlagFragment
      }
    }
  }
}
    ${FeatureFlagFragmentFragmentDoc}`;

/**
 * __useFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
      }
export function useFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
        }
export function useFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
        }
export type FeatureFlagsQueryHookResult = ReturnType<typeof useFeatureFlagsQuery>;
export type FeatureFlagsLazyQueryHookResult = ReturnType<typeof useFeatureFlagsLazyQuery>;
export type FeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useFeatureFlagsSuspenseQuery>;
export type FeatureFlagsQueryResult = Apollo.QueryResult<FeatureFlagsQuery, FeatureFlagsQueryVariables>;
export const AdminHelpEducationCreateDocument = /*#__PURE__*/ gql`
    mutation adminHelpEducationCreate($data: EducationCreateDto!) {
  cms {
    education_create(data: $data) {
      ...EducationFragment
    }
  }
}
    ${EducationFragmentFragmentDoc}`;
export type AdminHelpEducationCreateMutationFn = Apollo.MutationFunction<AdminHelpEducationCreateMutation, AdminHelpEducationCreateMutationVariables>;

/**
 * __useAdminHelpEducationCreateMutation__
 *
 * To run a mutation, you first call `useAdminHelpEducationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminHelpEducationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminHelpEducationCreateMutation, { data, loading, error }] = useAdminHelpEducationCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminHelpEducationCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminHelpEducationCreateMutation, AdminHelpEducationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminHelpEducationCreateMutation, AdminHelpEducationCreateMutationVariables>(AdminHelpEducationCreateDocument, options);
      }
export type AdminHelpEducationCreateMutationHookResult = ReturnType<typeof useAdminHelpEducationCreateMutation>;
export type AdminHelpEducationCreateMutationResult = Apollo.MutationResult<AdminHelpEducationCreateMutation>;
export type AdminHelpEducationCreateMutationOptions = Apollo.BaseMutationOptions<AdminHelpEducationCreateMutation, AdminHelpEducationCreateMutationVariables>;
export const AdminHelpEducationDeleteDocument = /*#__PURE__*/ gql`
    mutation adminHelpEducationDelete($data: Float!) {
  cms {
    education_delete(data: $data)
  }
}
    `;
export type AdminHelpEducationDeleteMutationFn = Apollo.MutationFunction<AdminHelpEducationDeleteMutation, AdminHelpEducationDeleteMutationVariables>;

/**
 * __useAdminHelpEducationDeleteMutation__
 *
 * To run a mutation, you first call `useAdminHelpEducationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminHelpEducationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminHelpEducationDeleteMutation, { data, loading, error }] = useAdminHelpEducationDeleteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminHelpEducationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminHelpEducationDeleteMutation, AdminHelpEducationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminHelpEducationDeleteMutation, AdminHelpEducationDeleteMutationVariables>(AdminHelpEducationDeleteDocument, options);
      }
export type AdminHelpEducationDeleteMutationHookResult = ReturnType<typeof useAdminHelpEducationDeleteMutation>;
export type AdminHelpEducationDeleteMutationResult = Apollo.MutationResult<AdminHelpEducationDeleteMutation>;
export type AdminHelpEducationDeleteMutationOptions = Apollo.BaseMutationOptions<AdminHelpEducationDeleteMutation, AdminHelpEducationDeleteMutationVariables>;
export const AdminHelpEducationListDocument = /*#__PURE__*/ gql`
    query adminHelpEducationList($order_by: [CmsQueryResolver_EducationList_SortingInputType!], $paginate: PaginatorArgsDto, $where: CmsQueryResolver_EducationList_FilterInputType) {
  cms {
    education_list(order_by: $order_by, paginate: $paginate, where: $where) {
      items {
        ...EducationFragment
      }
      totalCount
    }
  }
}
    ${EducationFragmentFragmentDoc}`;

/**
 * __useAdminHelpEducationListQuery__
 *
 * To run a query within a React component, call `useAdminHelpEducationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminHelpEducationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminHelpEducationListQuery({
 *   variables: {
 *      order_by: // value for 'order_by'
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminHelpEducationListQuery(baseOptions?: Apollo.QueryHookOptions<AdminHelpEducationListQuery, AdminHelpEducationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminHelpEducationListQuery, AdminHelpEducationListQueryVariables>(AdminHelpEducationListDocument, options);
      }
export function useAdminHelpEducationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminHelpEducationListQuery, AdminHelpEducationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminHelpEducationListQuery, AdminHelpEducationListQueryVariables>(AdminHelpEducationListDocument, options);
        }
export function useAdminHelpEducationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminHelpEducationListQuery, AdminHelpEducationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminHelpEducationListQuery, AdminHelpEducationListQueryVariables>(AdminHelpEducationListDocument, options);
        }
export type AdminHelpEducationListQueryHookResult = ReturnType<typeof useAdminHelpEducationListQuery>;
export type AdminHelpEducationListLazyQueryHookResult = ReturnType<typeof useAdminHelpEducationListLazyQuery>;
export type AdminHelpEducationListSuspenseQueryHookResult = ReturnType<typeof useAdminHelpEducationListSuspenseQuery>;
export type AdminHelpEducationListQueryResult = Apollo.QueryResult<AdminHelpEducationListQuery, AdminHelpEducationListQueryVariables>;
export const AdminHelpEducationUpdateDocument = /*#__PURE__*/ gql`
    mutation adminHelpEducationUpdate($data: EducationUpdateDto!) {
  cms {
    education_update(data: $data) {
      ...EducationFragment
    }
  }
}
    ${EducationFragmentFragmentDoc}`;
export type AdminHelpEducationUpdateMutationFn = Apollo.MutationFunction<AdminHelpEducationUpdateMutation, AdminHelpEducationUpdateMutationVariables>;

/**
 * __useAdminHelpEducationUpdateMutation__
 *
 * To run a mutation, you first call `useAdminHelpEducationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminHelpEducationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminHelpEducationUpdateMutation, { data, loading, error }] = useAdminHelpEducationUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminHelpEducationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminHelpEducationUpdateMutation, AdminHelpEducationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminHelpEducationUpdateMutation, AdminHelpEducationUpdateMutationVariables>(AdminHelpEducationUpdateDocument, options);
      }
export type AdminHelpEducationUpdateMutationHookResult = ReturnType<typeof useAdminHelpEducationUpdateMutation>;
export type AdminHelpEducationUpdateMutationResult = Apollo.MutationResult<AdminHelpEducationUpdateMutation>;
export type AdminHelpEducationUpdateMutationOptions = Apollo.BaseMutationOptions<AdminHelpEducationUpdateMutation, AdminHelpEducationUpdateMutationVariables>;
export const AdminHelpFaqCreateDocument = /*#__PURE__*/ gql`
    mutation adminHelpFaqCreate($data: FaqCreateDto!) {
  cms {
    faq_create(data: $data) {
      ...FAQFragment
    }
  }
}
    ${FaqFragmentFragmentDoc}`;
export type AdminHelpFaqCreateMutationFn = Apollo.MutationFunction<AdminHelpFaqCreateMutation, AdminHelpFaqCreateMutationVariables>;

/**
 * __useAdminHelpFaqCreateMutation__
 *
 * To run a mutation, you first call `useAdminHelpFaqCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminHelpFaqCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminHelpFaqCreateMutation, { data, loading, error }] = useAdminHelpFaqCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminHelpFaqCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminHelpFaqCreateMutation, AdminHelpFaqCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminHelpFaqCreateMutation, AdminHelpFaqCreateMutationVariables>(AdminHelpFaqCreateDocument, options);
      }
export type AdminHelpFaqCreateMutationHookResult = ReturnType<typeof useAdminHelpFaqCreateMutation>;
export type AdminHelpFaqCreateMutationResult = Apollo.MutationResult<AdminHelpFaqCreateMutation>;
export type AdminHelpFaqCreateMutationOptions = Apollo.BaseMutationOptions<AdminHelpFaqCreateMutation, AdminHelpFaqCreateMutationVariables>;
export const AdminHelpFaqDeleteDocument = /*#__PURE__*/ gql`
    mutation adminHelpFaqDelete($data: Float!) {
  cms {
    faq_delete(data: $data)
  }
}
    `;
export type AdminHelpFaqDeleteMutationFn = Apollo.MutationFunction<AdminHelpFaqDeleteMutation, AdminHelpFaqDeleteMutationVariables>;

/**
 * __useAdminHelpFaqDeleteMutation__
 *
 * To run a mutation, you first call `useAdminHelpFaqDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminHelpFaqDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminHelpFaqDeleteMutation, { data, loading, error }] = useAdminHelpFaqDeleteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminHelpFaqDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminHelpFaqDeleteMutation, AdminHelpFaqDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminHelpFaqDeleteMutation, AdminHelpFaqDeleteMutationVariables>(AdminHelpFaqDeleteDocument, options);
      }
export type AdminHelpFaqDeleteMutationHookResult = ReturnType<typeof useAdminHelpFaqDeleteMutation>;
export type AdminHelpFaqDeleteMutationResult = Apollo.MutationResult<AdminHelpFaqDeleteMutation>;
export type AdminHelpFaqDeleteMutationOptions = Apollo.BaseMutationOptions<AdminHelpFaqDeleteMutation, AdminHelpFaqDeleteMutationVariables>;
export const AdminHelpFaqListDocument = /*#__PURE__*/ gql`
    query adminHelpFAQList($order_by: [CmsQueryResolver_FaqList_SortingInputType!], $paginate: PaginatorArgsDto, $where: CmsQueryResolver_FaqList_FilterInputType) {
  cms {
    faq_list(order_by: $order_by, paginate: $paginate, where: $where) {
      items {
        ...FAQFragment
      }
      totalCount
    }
  }
}
    ${FaqFragmentFragmentDoc}`;

/**
 * __useAdminHelpFaqListQuery__
 *
 * To run a query within a React component, call `useAdminHelpFaqListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminHelpFaqListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminHelpFaqListQuery({
 *   variables: {
 *      order_by: // value for 'order_by'
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminHelpFaqListQuery(baseOptions?: Apollo.QueryHookOptions<AdminHelpFaqListQuery, AdminHelpFaqListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminHelpFaqListQuery, AdminHelpFaqListQueryVariables>(AdminHelpFaqListDocument, options);
      }
export function useAdminHelpFaqListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminHelpFaqListQuery, AdminHelpFaqListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminHelpFaqListQuery, AdminHelpFaqListQueryVariables>(AdminHelpFaqListDocument, options);
        }
export function useAdminHelpFaqListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminHelpFaqListQuery, AdminHelpFaqListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminHelpFaqListQuery, AdminHelpFaqListQueryVariables>(AdminHelpFaqListDocument, options);
        }
export type AdminHelpFaqListQueryHookResult = ReturnType<typeof useAdminHelpFaqListQuery>;
export type AdminHelpFaqListLazyQueryHookResult = ReturnType<typeof useAdminHelpFaqListLazyQuery>;
export type AdminHelpFaqListSuspenseQueryHookResult = ReturnType<typeof useAdminHelpFaqListSuspenseQuery>;
export type AdminHelpFaqListQueryResult = Apollo.QueryResult<AdminHelpFaqListQuery, AdminHelpFaqListQueryVariables>;
export const AdminHelpFaqUpdateDocument = /*#__PURE__*/ gql`
    mutation adminHelpFaqUpdate($data: FaqUpdateDto!) {
  cms {
    faq_update(data: $data) {
      ...FAQFragment
    }
  }
}
    ${FaqFragmentFragmentDoc}`;
export type AdminHelpFaqUpdateMutationFn = Apollo.MutationFunction<AdminHelpFaqUpdateMutation, AdminHelpFaqUpdateMutationVariables>;

/**
 * __useAdminHelpFaqUpdateMutation__
 *
 * To run a mutation, you first call `useAdminHelpFaqUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminHelpFaqUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminHelpFaqUpdateMutation, { data, loading, error }] = useAdminHelpFaqUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminHelpFaqUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminHelpFaqUpdateMutation, AdminHelpFaqUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminHelpFaqUpdateMutation, AdminHelpFaqUpdateMutationVariables>(AdminHelpFaqUpdateDocument, options);
      }
export type AdminHelpFaqUpdateMutationHookResult = ReturnType<typeof useAdminHelpFaqUpdateMutation>;
export type AdminHelpFaqUpdateMutationResult = Apollo.MutationResult<AdminHelpFaqUpdateMutation>;
export type AdminHelpFaqUpdateMutationOptions = Apollo.BaseMutationOptions<AdminHelpFaqUpdateMutation, AdminHelpFaqUpdateMutationVariables>;
export const ManualFileListDocument = /*#__PURE__*/ gql`
    query manualFileList($paginate: PaginatorArgsDto, $where: FilestorageQueryResolver_ListByBucketId_FilterInputType) {
  filestorage {
    listByBucketId(paginate: $paginate, where: $where) {
      totalCount
      items {
        id
        name
        description
        download_link
      }
    }
  }
}
    `;

/**
 * __useManualFileListQuery__
 *
 * To run a query within a React component, call `useManualFileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualFileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualFileListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useManualFileListQuery(baseOptions?: Apollo.QueryHookOptions<ManualFileListQuery, ManualFileListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManualFileListQuery, ManualFileListQueryVariables>(ManualFileListDocument, options);
      }
export function useManualFileListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManualFileListQuery, ManualFileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManualFileListQuery, ManualFileListQueryVariables>(ManualFileListDocument, options);
        }
export function useManualFileListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManualFileListQuery, ManualFileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManualFileListQuery, ManualFileListQueryVariables>(ManualFileListDocument, options);
        }
export type ManualFileListQueryHookResult = ReturnType<typeof useManualFileListQuery>;
export type ManualFileListLazyQueryHookResult = ReturnType<typeof useManualFileListLazyQuery>;
export type ManualFileListSuspenseQueryHookResult = ReturnType<typeof useManualFileListSuspenseQuery>;
export type ManualFileListQueryResult = Apollo.QueryResult<ManualFileListQuery, ManualFileListQueryVariables>;
export const ManualFileDeleteDocument = /*#__PURE__*/ gql`
    mutation manualFileDelete($id: Float!) {
  filestorage {
    delete(id: $id)
  }
}
    `;
export type ManualFileDeleteMutationFn = Apollo.MutationFunction<ManualFileDeleteMutation, ManualFileDeleteMutationVariables>;

/**
 * __useManualFileDeleteMutation__
 *
 * To run a mutation, you first call `useManualFileDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManualFileDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manualFileDeleteMutation, { data, loading, error }] = useManualFileDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManualFileDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ManualFileDeleteMutation, ManualFileDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManualFileDeleteMutation, ManualFileDeleteMutationVariables>(ManualFileDeleteDocument, options);
      }
export type ManualFileDeleteMutationHookResult = ReturnType<typeof useManualFileDeleteMutation>;
export type ManualFileDeleteMutationResult = Apollo.MutationResult<ManualFileDeleteMutation>;
export type ManualFileDeleteMutationOptions = Apollo.BaseMutationOptions<ManualFileDeleteMutation, ManualFileDeleteMutationVariables>;
export const UsersJournalActionAuditDocument = /*#__PURE__*/ gql`
    query usersJournalActionAudit($paginate: PaginatorArgsDto, $where: JournalQueryResolver_UserActionAudit_FilterInputType, $orderBy: [JournalQueryResolver_UserActionAudit_SortingInputType!]) {
  journal {
    user_action_audit(paginate: $paginate, where: $where, order_by: $orderBy) {
      items {
        ...JournalUsersActionFragment
        create_by {
          ...UserBaseFragment
        }
      }
      totalCount
    }
  }
}
    ${JournalUsersActionFragmentFragmentDoc}
${UserBaseFragmentFragmentDoc}`;

/**
 * __useUsersJournalActionAuditQuery__
 *
 * To run a query within a React component, call `useUsersJournalActionAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersJournalActionAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersJournalActionAuditQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUsersJournalActionAuditQuery(baseOptions?: Apollo.QueryHookOptions<UsersJournalActionAuditQuery, UsersJournalActionAuditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersJournalActionAuditQuery, UsersJournalActionAuditQueryVariables>(UsersJournalActionAuditDocument, options);
      }
export function useUsersJournalActionAuditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersJournalActionAuditQuery, UsersJournalActionAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersJournalActionAuditQuery, UsersJournalActionAuditQueryVariables>(UsersJournalActionAuditDocument, options);
        }
export function useUsersJournalActionAuditSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersJournalActionAuditQuery, UsersJournalActionAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersJournalActionAuditQuery, UsersJournalActionAuditQueryVariables>(UsersJournalActionAuditDocument, options);
        }
export type UsersJournalActionAuditQueryHookResult = ReturnType<typeof useUsersJournalActionAuditQuery>;
export type UsersJournalActionAuditLazyQueryHookResult = ReturnType<typeof useUsersJournalActionAuditLazyQuery>;
export type UsersJournalActionAuditSuspenseQueryHookResult = ReturnType<typeof useUsersJournalActionAuditSuspenseQuery>;
export type UsersJournalActionAuditQueryResult = Apollo.QueryResult<UsersJournalActionAuditQuery, UsersJournalActionAuditQueryVariables>;
export const AdminNewsCreateDocument = /*#__PURE__*/ gql`
    mutation adminNewsCreate($data: NewsCreateDto!) {
  cms {
    news_create(data: $data) {
      ...NewsFragmentShort
    }
  }
}
    ${NewsFragmentShortFragmentDoc}`;
export type AdminNewsCreateMutationFn = Apollo.MutationFunction<AdminNewsCreateMutation, AdminNewsCreateMutationVariables>;

/**
 * __useAdminNewsCreateMutation__
 *
 * To run a mutation, you first call `useAdminNewsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminNewsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminNewsCreateMutation, { data, loading, error }] = useAdminNewsCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminNewsCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminNewsCreateMutation, AdminNewsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminNewsCreateMutation, AdminNewsCreateMutationVariables>(AdminNewsCreateDocument, options);
      }
export type AdminNewsCreateMutationHookResult = ReturnType<typeof useAdminNewsCreateMutation>;
export type AdminNewsCreateMutationResult = Apollo.MutationResult<AdminNewsCreateMutation>;
export type AdminNewsCreateMutationOptions = Apollo.BaseMutationOptions<AdminNewsCreateMutation, AdminNewsCreateMutationVariables>;
export const AdminNewsDeleteDocument = /*#__PURE__*/ gql`
    mutation adminNewsDelete($data: Float!) {
  cms {
    news_delete(data: $data)
  }
}
    `;
export type AdminNewsDeleteMutationFn = Apollo.MutationFunction<AdminNewsDeleteMutation, AdminNewsDeleteMutationVariables>;

/**
 * __useAdminNewsDeleteMutation__
 *
 * To run a mutation, you first call `useAdminNewsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminNewsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminNewsDeleteMutation, { data, loading, error }] = useAdminNewsDeleteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminNewsDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminNewsDeleteMutation, AdminNewsDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminNewsDeleteMutation, AdminNewsDeleteMutationVariables>(AdminNewsDeleteDocument, options);
      }
export type AdminNewsDeleteMutationHookResult = ReturnType<typeof useAdminNewsDeleteMutation>;
export type AdminNewsDeleteMutationResult = Apollo.MutationResult<AdminNewsDeleteMutation>;
export type AdminNewsDeleteMutationOptions = Apollo.BaseMutationOptions<AdminNewsDeleteMutation, AdminNewsDeleteMutationVariables>;
export const AdminNewsDetailsDocument = /*#__PURE__*/ gql`
    query adminNewsDetails($paginate: PaginatorArgsDto, $where: CmsQueryResolver_NewsList_FilterInputType) {
  cms {
    news_list(paginate: $paginate, where: $where) {
      items {
        ...NewsFragment
      }
      totalCount
    }
  }
}
    ${NewsFragmentFragmentDoc}`;

/**
 * __useAdminNewsDetailsQuery__
 *
 * To run a query within a React component, call `useAdminNewsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminNewsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminNewsDetailsQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminNewsDetailsQuery(baseOptions?: Apollo.QueryHookOptions<AdminNewsDetailsQuery, AdminNewsDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminNewsDetailsQuery, AdminNewsDetailsQueryVariables>(AdminNewsDetailsDocument, options);
      }
export function useAdminNewsDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminNewsDetailsQuery, AdminNewsDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminNewsDetailsQuery, AdminNewsDetailsQueryVariables>(AdminNewsDetailsDocument, options);
        }
export function useAdminNewsDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminNewsDetailsQuery, AdminNewsDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminNewsDetailsQuery, AdminNewsDetailsQueryVariables>(AdminNewsDetailsDocument, options);
        }
export type AdminNewsDetailsQueryHookResult = ReturnType<typeof useAdminNewsDetailsQuery>;
export type AdminNewsDetailsLazyQueryHookResult = ReturnType<typeof useAdminNewsDetailsLazyQuery>;
export type AdminNewsDetailsSuspenseQueryHookResult = ReturnType<typeof useAdminNewsDetailsSuspenseQuery>;
export type AdminNewsDetailsQueryResult = Apollo.QueryResult<AdminNewsDetailsQuery, AdminNewsDetailsQueryVariables>;
export const AdminNewsListDocument = /*#__PURE__*/ gql`
    query adminNewsList($paginate: PaginatorArgsDto, $order_by: [CmsQueryResolver_NewsList_SortingInputType!]) {
  cms {
    news_list(paginate: $paginate, order_by: $order_by) {
      items {
        ...NewsFragmentShort
      }
      totalCount
    }
  }
}
    ${NewsFragmentShortFragmentDoc}`;

/**
 * __useAdminNewsListQuery__
 *
 * To run a query within a React component, call `useAdminNewsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminNewsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminNewsListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useAdminNewsListQuery(baseOptions?: Apollo.QueryHookOptions<AdminNewsListQuery, AdminNewsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminNewsListQuery, AdminNewsListQueryVariables>(AdminNewsListDocument, options);
      }
export function useAdminNewsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminNewsListQuery, AdminNewsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminNewsListQuery, AdminNewsListQueryVariables>(AdminNewsListDocument, options);
        }
export function useAdminNewsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminNewsListQuery, AdminNewsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminNewsListQuery, AdminNewsListQueryVariables>(AdminNewsListDocument, options);
        }
export type AdminNewsListQueryHookResult = ReturnType<typeof useAdminNewsListQuery>;
export type AdminNewsListLazyQueryHookResult = ReturnType<typeof useAdminNewsListLazyQuery>;
export type AdminNewsListSuspenseQueryHookResult = ReturnType<typeof useAdminNewsListSuspenseQuery>;
export type AdminNewsListQueryResult = Apollo.QueryResult<AdminNewsListQuery, AdminNewsListQueryVariables>;
export const AdminNewsUpdateDocument = /*#__PURE__*/ gql`
    mutation adminNewsUpdate($data: NewsUpdateDto!) {
  cms {
    news_update(data: $data) {
      ...NewsFragmentShort
    }
  }
}
    ${NewsFragmentShortFragmentDoc}`;
export type AdminNewsUpdateMutationFn = Apollo.MutationFunction<AdminNewsUpdateMutation, AdminNewsUpdateMutationVariables>;

/**
 * __useAdminNewsUpdateMutation__
 *
 * To run a mutation, you first call `useAdminNewsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminNewsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminNewsUpdateMutation, { data, loading, error }] = useAdminNewsUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminNewsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminNewsUpdateMutation, AdminNewsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminNewsUpdateMutation, AdminNewsUpdateMutationVariables>(AdminNewsUpdateDocument, options);
      }
export type AdminNewsUpdateMutationHookResult = ReturnType<typeof useAdminNewsUpdateMutation>;
export type AdminNewsUpdateMutationResult = Apollo.MutationResult<AdminNewsUpdateMutation>;
export type AdminNewsUpdateMutationOptions = Apollo.BaseMutationOptions<AdminNewsUpdateMutation, AdminNewsUpdateMutationVariables>;
export const AdminRolesListDocument = /*#__PURE__*/ gql`
    query adminRolesList($paginate: PaginatorArgsDto, $orderBy: [RbacQueryResolver_Roles_SortingInputType!], $where: RbacQueryResolver_Roles_FilterInputType) {
  rbac {
    roles(paginate: $paginate, order_by: $orderBy, where: $where) {
      totalCount
      items {
        ...RoleBaseFragment
      }
    }
  }
}
    ${RoleBaseFragmentFragmentDoc}`;

/**
 * __useAdminRolesListQuery__
 *
 * To run a query within a React component, call `useAdminRolesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRolesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRolesListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminRolesListQuery(baseOptions?: Apollo.QueryHookOptions<AdminRolesListQuery, AdminRolesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRolesListQuery, AdminRolesListQueryVariables>(AdminRolesListDocument, options);
      }
export function useAdminRolesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRolesListQuery, AdminRolesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRolesListQuery, AdminRolesListQueryVariables>(AdminRolesListDocument, options);
        }
export function useAdminRolesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminRolesListQuery, AdminRolesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminRolesListQuery, AdminRolesListQueryVariables>(AdminRolesListDocument, options);
        }
export type AdminRolesListQueryHookResult = ReturnType<typeof useAdminRolesListQuery>;
export type AdminRolesListLazyQueryHookResult = ReturnType<typeof useAdminRolesListLazyQuery>;
export type AdminRolesListSuspenseQueryHookResult = ReturnType<typeof useAdminRolesListSuspenseQuery>;
export type AdminRolesListQueryResult = Apollo.QueryResult<AdminRolesListQuery, AdminRolesListQueryVariables>;
export const ModulesAndRulesListDocument = /*#__PURE__*/ gql`
    query modulesAndRulesList {
  rbac {
    rules {
      items {
        ...RuleShortFragment
        module {
          ...ModuleShortFragment
        }
      }
    }
  }
}
    ${RuleShortFragmentFragmentDoc}
${ModuleShortFragmentFragmentDoc}`;

/**
 * __useModulesAndRulesListQuery__
 *
 * To run a query within a React component, call `useModulesAndRulesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useModulesAndRulesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModulesAndRulesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useModulesAndRulesListQuery(baseOptions?: Apollo.QueryHookOptions<ModulesAndRulesListQuery, ModulesAndRulesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModulesAndRulesListQuery, ModulesAndRulesListQueryVariables>(ModulesAndRulesListDocument, options);
      }
export function useModulesAndRulesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModulesAndRulesListQuery, ModulesAndRulesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModulesAndRulesListQuery, ModulesAndRulesListQueryVariables>(ModulesAndRulesListDocument, options);
        }
export function useModulesAndRulesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModulesAndRulesListQuery, ModulesAndRulesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModulesAndRulesListQuery, ModulesAndRulesListQueryVariables>(ModulesAndRulesListDocument, options);
        }
export type ModulesAndRulesListQueryHookResult = ReturnType<typeof useModulesAndRulesListQuery>;
export type ModulesAndRulesListLazyQueryHookResult = ReturnType<typeof useModulesAndRulesListLazyQuery>;
export type ModulesAndRulesListSuspenseQueryHookResult = ReturnType<typeof useModulesAndRulesListSuspenseQuery>;
export type ModulesAndRulesListQueryResult = Apollo.QueryResult<ModulesAndRulesListQuery, ModulesAndRulesListQueryVariables>;
export const RoleUpdateDocument = /*#__PURE__*/ gql`
    mutation roleUpdate($data: UpdateRoleDto!) {
  rbac {
    update_role(data: $data)
  }
}
    `;
export type RoleUpdateMutationFn = Apollo.MutationFunction<RoleUpdateMutation, RoleUpdateMutationVariables>;

/**
 * __useRoleUpdateMutation__
 *
 * To run a mutation, you first call `useRoleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roleUpdateMutation, { data, loading, error }] = useRoleUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRoleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RoleUpdateMutation, RoleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoleUpdateMutation, RoleUpdateMutationVariables>(RoleUpdateDocument, options);
      }
export type RoleUpdateMutationHookResult = ReturnType<typeof useRoleUpdateMutation>;
export type RoleUpdateMutationResult = Apollo.MutationResult<RoleUpdateMutation>;
export type RoleUpdateMutationOptions = Apollo.BaseMutationOptions<RoleUpdateMutation, RoleUpdateMutationVariables>;
export const RulesByRoleListDocument = /*#__PURE__*/ gql`
    query rulesByRoleList($id: Float!) {
  rbac {
    role(id: $id) {
      ...RoleShortFragment
      rules {
        ...RuleShortFragment
        module {
          ...ModuleShortFragment
        }
      }
    }
  }
}
    ${RoleShortFragmentFragmentDoc}
${RuleShortFragmentFragmentDoc}
${ModuleShortFragmentFragmentDoc}`;

/**
 * __useRulesByRoleListQuery__
 *
 * To run a query within a React component, call `useRulesByRoleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRulesByRoleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRulesByRoleListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRulesByRoleListQuery(baseOptions: Apollo.QueryHookOptions<RulesByRoleListQuery, RulesByRoleListQueryVariables> & ({ variables: RulesByRoleListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RulesByRoleListQuery, RulesByRoleListQueryVariables>(RulesByRoleListDocument, options);
      }
export function useRulesByRoleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RulesByRoleListQuery, RulesByRoleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RulesByRoleListQuery, RulesByRoleListQueryVariables>(RulesByRoleListDocument, options);
        }
export function useRulesByRoleListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RulesByRoleListQuery, RulesByRoleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RulesByRoleListQuery, RulesByRoleListQueryVariables>(RulesByRoleListDocument, options);
        }
export type RulesByRoleListQueryHookResult = ReturnType<typeof useRulesByRoleListQuery>;
export type RulesByRoleListLazyQueryHookResult = ReturnType<typeof useRulesByRoleListLazyQuery>;
export type RulesByRoleListSuspenseQueryHookResult = ReturnType<typeof useRulesByRoleListSuspenseQuery>;
export type RulesByRoleListQueryResult = Apollo.QueryResult<RulesByRoleListQuery, RulesByRoleListQueryVariables>;
export const SchedulersDocument = /*#__PURE__*/ gql`
    query schedulers($paginate: PaginatorArgsDto, $orderBy: [SchedulerQueryResolver_List_SortingInputType!], $where: SchedulerQueryResolver_List_FilterInputType) {
  scheduler {
    scheduler {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        totalCount
        items {
          ...SchedulerJobFragment
        }
      }
    }
  }
}
    ${SchedulerJobFragmentFragmentDoc}`;

/**
 * __useSchedulersQuery__
 *
 * To run a query within a React component, call `useSchedulersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulersQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSchedulersQuery(baseOptions?: Apollo.QueryHookOptions<SchedulersQuery, SchedulersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulersQuery, SchedulersQueryVariables>(SchedulersDocument, options);
      }
export function useSchedulersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulersQuery, SchedulersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulersQuery, SchedulersQueryVariables>(SchedulersDocument, options);
        }
export function useSchedulersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchedulersQuery, SchedulersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulersQuery, SchedulersQueryVariables>(SchedulersDocument, options);
        }
export type SchedulersQueryHookResult = ReturnType<typeof useSchedulersQuery>;
export type SchedulersLazyQueryHookResult = ReturnType<typeof useSchedulersLazyQuery>;
export type SchedulersSuspenseQueryHookResult = ReturnType<typeof useSchedulersSuspenseQuery>;
export type SchedulersQueryResult = Apollo.QueryResult<SchedulersQuery, SchedulersQueryVariables>;
export const SchedulerManualStartDocument = /*#__PURE__*/ gql`
    mutation schedulerManualStart($command: String!) {
  scheduler {
    scheduler {
      manualStart(command: $command)
    }
  }
}
    `;
export type SchedulerManualStartMutationFn = Apollo.MutationFunction<SchedulerManualStartMutation, SchedulerManualStartMutationVariables>;

/**
 * __useSchedulerManualStartMutation__
 *
 * To run a mutation, you first call `useSchedulerManualStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulerManualStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulerManualStartMutation, { data, loading, error }] = useSchedulerManualStartMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useSchedulerManualStartMutation(baseOptions?: Apollo.MutationHookOptions<SchedulerManualStartMutation, SchedulerManualStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchedulerManualStartMutation, SchedulerManualStartMutationVariables>(SchedulerManualStartDocument, options);
      }
export type SchedulerManualStartMutationHookResult = ReturnType<typeof useSchedulerManualStartMutation>;
export type SchedulerManualStartMutationResult = Apollo.MutationResult<SchedulerManualStartMutation>;
export type SchedulerManualStartMutationOptions = Apollo.BaseMutationOptions<SchedulerManualStartMutation, SchedulerManualStartMutationVariables>;
export const SchedulerUpdateDisabledJobDocument = /*#__PURE__*/ gql`
    mutation schedulerUpdateDisabledJob($data: UpdateDisableSchedulerJobDto!) {
  scheduler {
    scheduler {
      updateDisableJob(data: $data)
    }
  }
}
    `;
export type SchedulerUpdateDisabledJobMutationFn = Apollo.MutationFunction<SchedulerUpdateDisabledJobMutation, SchedulerUpdateDisabledJobMutationVariables>;

/**
 * __useSchedulerUpdateDisabledJobMutation__
 *
 * To run a mutation, you first call `useSchedulerUpdateDisabledJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulerUpdateDisabledJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulerUpdateDisabledJobMutation, { data, loading, error }] = useSchedulerUpdateDisabledJobMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSchedulerUpdateDisabledJobMutation(baseOptions?: Apollo.MutationHookOptions<SchedulerUpdateDisabledJobMutation, SchedulerUpdateDisabledJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchedulerUpdateDisabledJobMutation, SchedulerUpdateDisabledJobMutationVariables>(SchedulerUpdateDisabledJobDocument, options);
      }
export type SchedulerUpdateDisabledJobMutationHookResult = ReturnType<typeof useSchedulerUpdateDisabledJobMutation>;
export type SchedulerUpdateDisabledJobMutationResult = Apollo.MutationResult<SchedulerUpdateDisabledJobMutation>;
export type SchedulerUpdateDisabledJobMutationOptions = Apollo.BaseMutationOptions<SchedulerUpdateDisabledJobMutation, SchedulerUpdateDisabledJobMutationVariables>;
export const SchedulerUpdateTimeJobDocument = /*#__PURE__*/ gql`
    mutation schedulerUpdateTimeJob($data: UpdateTimeSchedulerJobDto!) {
  scheduler {
    scheduler {
      updateTimeJob(data: $data)
    }
  }
}
    `;
export type SchedulerUpdateTimeJobMutationFn = Apollo.MutationFunction<SchedulerUpdateTimeJobMutation, SchedulerUpdateTimeJobMutationVariables>;

/**
 * __useSchedulerUpdateTimeJobMutation__
 *
 * To run a mutation, you first call `useSchedulerUpdateTimeJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulerUpdateTimeJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulerUpdateTimeJobMutation, { data, loading, error }] = useSchedulerUpdateTimeJobMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSchedulerUpdateTimeJobMutation(baseOptions?: Apollo.MutationHookOptions<SchedulerUpdateTimeJobMutation, SchedulerUpdateTimeJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchedulerUpdateTimeJobMutation, SchedulerUpdateTimeJobMutationVariables>(SchedulerUpdateTimeJobDocument, options);
      }
export type SchedulerUpdateTimeJobMutationHookResult = ReturnType<typeof useSchedulerUpdateTimeJobMutation>;
export type SchedulerUpdateTimeJobMutationResult = Apollo.MutationResult<SchedulerUpdateTimeJobMutation>;
export type SchedulerUpdateTimeJobMutationOptions = Apollo.BaseMutationOptions<SchedulerUpdateTimeJobMutation, SchedulerUpdateTimeJobMutationVariables>;
export const CreateFeatureFlagsUserDocument = /*#__PURE__*/ gql`
    mutation createFeatureFlagsUser($data: FeatureFlagsUserCreateDto!) {
  configuration {
    feature_flag_user_create(data: $data)
  }
}
    `;
export type CreateFeatureFlagsUserMutationFn = Apollo.MutationFunction<CreateFeatureFlagsUserMutation, CreateFeatureFlagsUserMutationVariables>;

/**
 * __useCreateFeatureFlagsUserMutation__
 *
 * To run a mutation, you first call `useCreateFeatureFlagsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureFlagsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureFlagsUserMutation, { data, loading, error }] = useCreateFeatureFlagsUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFeatureFlagsUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeatureFlagsUserMutation, CreateFeatureFlagsUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeatureFlagsUserMutation, CreateFeatureFlagsUserMutationVariables>(CreateFeatureFlagsUserDocument, options);
      }
export type CreateFeatureFlagsUserMutationHookResult = ReturnType<typeof useCreateFeatureFlagsUserMutation>;
export type CreateFeatureFlagsUserMutationResult = Apollo.MutationResult<CreateFeatureFlagsUserMutation>;
export type CreateFeatureFlagsUserMutationOptions = Apollo.BaseMutationOptions<CreateFeatureFlagsUserMutation, CreateFeatureFlagsUserMutationVariables>;
export const DeleteFeatureFlagsUserDocument = /*#__PURE__*/ gql`
    mutation deleteFeatureFlagsUser($id: Float!) {
  configuration {
    feature_flag_user_delete(data: $id)
  }
}
    `;
export type DeleteFeatureFlagsUserMutationFn = Apollo.MutationFunction<DeleteFeatureFlagsUserMutation, DeleteFeatureFlagsUserMutationVariables>;

/**
 * __useDeleteFeatureFlagsUserMutation__
 *
 * To run a mutation, you first call `useDeleteFeatureFlagsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeatureFlagsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeatureFlagsUserMutation, { data, loading, error }] = useDeleteFeatureFlagsUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeatureFlagsUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeatureFlagsUserMutation, DeleteFeatureFlagsUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeatureFlagsUserMutation, DeleteFeatureFlagsUserMutationVariables>(DeleteFeatureFlagsUserDocument, options);
      }
export type DeleteFeatureFlagsUserMutationHookResult = ReturnType<typeof useDeleteFeatureFlagsUserMutation>;
export type DeleteFeatureFlagsUserMutationResult = Apollo.MutationResult<DeleteFeatureFlagsUserMutation>;
export type DeleteFeatureFlagsUserMutationOptions = Apollo.BaseMutationOptions<DeleteFeatureFlagsUserMutation, DeleteFeatureFlagsUserMutationVariables>;
export const FeatureFlagsUserListDocument = /*#__PURE__*/ gql`
    query featureFlagsUserList($paginate: PaginatorArgsDto, $orderBy: [ConfigurationQueryResolver_FeatureFlagUserList_SortingInputType!], $where: ConfigurationQueryResolver_FeatureFlagUserList_FilterInputType) {
  configuration {
    feature_flag_user_list(paginate: $paginate, where: $where, order_by: $orderBy) {
      items {
        id
        value
        name
        description
        user_id
      }
    }
  }
}
    `;

/**
 * __useFeatureFlagsUserListQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsUserListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFeatureFlagsUserListQuery(baseOptions?: Apollo.QueryHookOptions<FeatureFlagsUserListQuery, FeatureFlagsUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlagsUserListQuery, FeatureFlagsUserListQueryVariables>(FeatureFlagsUserListDocument, options);
      }
export function useFeatureFlagsUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagsUserListQuery, FeatureFlagsUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlagsUserListQuery, FeatureFlagsUserListQueryVariables>(FeatureFlagsUserListDocument, options);
        }
export function useFeatureFlagsUserListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeatureFlagsUserListQuery, FeatureFlagsUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeatureFlagsUserListQuery, FeatureFlagsUserListQueryVariables>(FeatureFlagsUserListDocument, options);
        }
export type FeatureFlagsUserListQueryHookResult = ReturnType<typeof useFeatureFlagsUserListQuery>;
export type FeatureFlagsUserListLazyQueryHookResult = ReturnType<typeof useFeatureFlagsUserListLazyQuery>;
export type FeatureFlagsUserListSuspenseQueryHookResult = ReturnType<typeof useFeatureFlagsUserListSuspenseQuery>;
export type FeatureFlagsUserListQueryResult = Apollo.QueryResult<FeatureFlagsUserListQuery, FeatureFlagsUserListQueryVariables>;
export const RolesListDocument = /*#__PURE__*/ gql`
    query rolesList($paginate: PaginatorArgsDto, $orderBy: [RbacQueryResolver_Roles_SortingInputType!], $where: RbacQueryResolver_Roles_FilterInputType) {
  rbac {
    roles(paginate: $paginate, order_by: $orderBy, where: $where) {
      totalCount
      items {
        ...RoleBaseFragment
      }
    }
  }
}
    ${RoleBaseFragmentFragmentDoc}`;

/**
 * __useRolesListQuery__
 *
 * To run a query within a React component, call `useRolesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRolesListQuery(baseOptions?: Apollo.QueryHookOptions<RolesListQuery, RolesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesListQuery, RolesListQueryVariables>(RolesListDocument, options);
      }
export function useRolesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesListQuery, RolesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesListQuery, RolesListQueryVariables>(RolesListDocument, options);
        }
export function useRolesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RolesListQuery, RolesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RolesListQuery, RolesListQueryVariables>(RolesListDocument, options);
        }
export type RolesListQueryHookResult = ReturnType<typeof useRolesListQuery>;
export type RolesListLazyQueryHookResult = ReturnType<typeof useRolesListLazyQuery>;
export type RolesListSuspenseQueryHookResult = ReturnType<typeof useRolesListSuspenseQuery>;
export type RolesListQueryResult = Apollo.QueryResult<RolesListQuery, RolesListQueryVariables>;
export const RuleList__UserEditDocument = /*#__PURE__*/ gql`
    query ruleList__userEdit($paginate: PaginatorArgsDto, $orderBy: [RbacQueryResolver_Rules_SortingInputType!], $where: RbacQueryResolver_Rules_FilterInputType) {
  rbac {
    rules(paginate: $paginate, order_by: $orderBy, where: $where) {
      items {
        ...RuleWithModuleFragment
      }
    }
  }
}
    ${RuleWithModuleFragmentFragmentDoc}`;

/**
 * __useRuleList__UserEditQuery__
 *
 * To run a query within a React component, call `useRuleList__UserEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleList__UserEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleList__UserEditQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRuleList__UserEditQuery(baseOptions?: Apollo.QueryHookOptions<RuleList__UserEditQuery, RuleList__UserEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleList__UserEditQuery, RuleList__UserEditQueryVariables>(RuleList__UserEditDocument, options);
      }
export function useRuleList__UserEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleList__UserEditQuery, RuleList__UserEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleList__UserEditQuery, RuleList__UserEditQueryVariables>(RuleList__UserEditDocument, options);
        }
export function useRuleList__UserEditSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RuleList__UserEditQuery, RuleList__UserEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleList__UserEditQuery, RuleList__UserEditQueryVariables>(RuleList__UserEditDocument, options);
        }
export type RuleList__UserEditQueryHookResult = ReturnType<typeof useRuleList__UserEditQuery>;
export type RuleList__UserEditLazyQueryHookResult = ReturnType<typeof useRuleList__UserEditLazyQuery>;
export type RuleList__UserEditSuspenseQueryHookResult = ReturnType<typeof useRuleList__UserEditSuspenseQuery>;
export type RuleList__UserEditQueryResult = Apollo.QueryResult<RuleList__UserEditQuery, RuleList__UserEditQueryVariables>;
export const UserSessionDocument = /*#__PURE__*/ gql`
    query userSession($id: Float!) {
  users {
    sessions_list(id: $id) {
      items {
        ...SessionFragment
      }
      totalCount
    }
  }
}
    ${SessionFragmentFragmentDoc}`;

/**
 * __useUserSessionQuery__
 *
 * To run a query within a React component, call `useUserSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserSessionQuery(baseOptions: Apollo.QueryHookOptions<UserSessionQuery, UserSessionQueryVariables> & ({ variables: UserSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSessionQuery, UserSessionQueryVariables>(UserSessionDocument, options);
      }
export function useUserSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSessionQuery, UserSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSessionQuery, UserSessionQueryVariables>(UserSessionDocument, options);
        }
export function useUserSessionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserSessionQuery, UserSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSessionQuery, UserSessionQueryVariables>(UserSessionDocument, options);
        }
export type UserSessionQueryHookResult = ReturnType<typeof useUserSessionQuery>;
export type UserSessionLazyQueryHookResult = ReturnType<typeof useUserSessionLazyQuery>;
export type UserSessionSuspenseQueryHookResult = ReturnType<typeof useUserSessionSuspenseQuery>;
export type UserSessionQueryResult = Apollo.QueryResult<UserSessionQuery, UserSessionQueryVariables>;
export const TerminateSessionUserDocument = /*#__PURE__*/ gql`
    mutation terminateSessionUser($user_id: Float!, $sid: String!) {
  users {
    terminate_session_user(user_id: $user_id, sid: $sid)
  }
}
    `;
export type TerminateSessionUserMutationFn = Apollo.MutationFunction<TerminateSessionUserMutation, TerminateSessionUserMutationVariables>;

/**
 * __useTerminateSessionUserMutation__
 *
 * To run a mutation, you first call `useTerminateSessionUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateSessionUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateSessionUserMutation, { data, loading, error }] = useTerminateSessionUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      sid: // value for 'sid'
 *   },
 * });
 */
export function useTerminateSessionUserMutation(baseOptions?: Apollo.MutationHookOptions<TerminateSessionUserMutation, TerminateSessionUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TerminateSessionUserMutation, TerminateSessionUserMutationVariables>(TerminateSessionUserDocument, options);
      }
export type TerminateSessionUserMutationHookResult = ReturnType<typeof useTerminateSessionUserMutation>;
export type TerminateSessionUserMutationResult = Apollo.MutationResult<TerminateSessionUserMutation>;
export type TerminateSessionUserMutationOptions = Apollo.BaseMutationOptions<TerminateSessionUserMutation, TerminateSessionUserMutationVariables>;
export const UpdateFeatureFlagsUserDocument = /*#__PURE__*/ gql`
    mutation updateFeatureFlagsUser($data: FeatureFlagsUserUpdateDto!) {
  configuration {
    feature_flag_user_update(data: $data)
  }
}
    `;
export type UpdateFeatureFlagsUserMutationFn = Apollo.MutationFunction<UpdateFeatureFlagsUserMutation, UpdateFeatureFlagsUserMutationVariables>;

/**
 * __useUpdateFeatureFlagsUserMutation__
 *
 * To run a mutation, you first call `useUpdateFeatureFlagsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeatureFlagsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeatureFlagsUserMutation, { data, loading, error }] = useUpdateFeatureFlagsUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFeatureFlagsUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeatureFlagsUserMutation, UpdateFeatureFlagsUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeatureFlagsUserMutation, UpdateFeatureFlagsUserMutationVariables>(UpdateFeatureFlagsUserDocument, options);
      }
export type UpdateFeatureFlagsUserMutationHookResult = ReturnType<typeof useUpdateFeatureFlagsUserMutation>;
export type UpdateFeatureFlagsUserMutationResult = Apollo.MutationResult<UpdateFeatureFlagsUserMutation>;
export type UpdateFeatureFlagsUserMutationOptions = Apollo.BaseMutationOptions<UpdateFeatureFlagsUserMutation, UpdateFeatureFlagsUserMutationVariables>;
export const UserEditByIdDocument = /*#__PURE__*/ gql`
    query userEditById($id: Float!) {
  users {
    by_id(id: $id) {
      ...UserBaseFragment
      branch {
        ...BranchBaseFragment
      }
      roles {
        ...RoleBaseFragment
      }
      division {
        ...DivisionFragment
      }
      rules {
        ...RuleWithModuleFragment
      }
    }
  }
}
    ${UserBaseFragmentFragmentDoc}
${BranchBaseFragmentFragmentDoc}
${RoleBaseFragmentFragmentDoc}
${DivisionFragmentFragmentDoc}
${RuleWithModuleFragmentFragmentDoc}`;

/**
 * __useUserEditByIdQuery__
 *
 * To run a query within a React component, call `useUserEditByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEditByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEditByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserEditByIdQuery(baseOptions: Apollo.QueryHookOptions<UserEditByIdQuery, UserEditByIdQueryVariables> & ({ variables: UserEditByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEditByIdQuery, UserEditByIdQueryVariables>(UserEditByIdDocument, options);
      }
export function useUserEditByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEditByIdQuery, UserEditByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEditByIdQuery, UserEditByIdQueryVariables>(UserEditByIdDocument, options);
        }
export function useUserEditByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserEditByIdQuery, UserEditByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserEditByIdQuery, UserEditByIdQueryVariables>(UserEditByIdDocument, options);
        }
export type UserEditByIdQueryHookResult = ReturnType<typeof useUserEditByIdQuery>;
export type UserEditByIdLazyQueryHookResult = ReturnType<typeof useUserEditByIdLazyQuery>;
export type UserEditByIdSuspenseQueryHookResult = ReturnType<typeof useUserEditByIdSuspenseQuery>;
export type UserEditByIdQueryResult = Apollo.QueryResult<UserEditByIdQuery, UserEditByIdQueryVariables>;
export const UserClearCacheDocument = /*#__PURE__*/ gql`
    mutation userClearCache {
  users {
    clear_cache_success
  }
}
    `;
export type UserClearCacheMutationFn = Apollo.MutationFunction<UserClearCacheMutation, UserClearCacheMutationVariables>;

/**
 * __useUserClearCacheMutation__
 *
 * To run a mutation, you first call `useUserClearCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserClearCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userClearCacheMutation, { data, loading, error }] = useUserClearCacheMutation({
 *   variables: {
 *   },
 * });
 */
export function useUserClearCacheMutation(baseOptions?: Apollo.MutationHookOptions<UserClearCacheMutation, UserClearCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserClearCacheMutation, UserClearCacheMutationVariables>(UserClearCacheDocument, options);
      }
export type UserClearCacheMutationHookResult = ReturnType<typeof useUserClearCacheMutation>;
export type UserClearCacheMutationResult = Apollo.MutationResult<UserClearCacheMutation>;
export type UserClearCacheMutationOptions = Apollo.BaseMutationOptions<UserClearCacheMutation, UserClearCacheMutationVariables>;
export const CreateUserDocument = /*#__PURE__*/ gql`
    mutation createUser($data: CreateUserDto!) {
  users {
    create(data: $data)
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UserListDocument = /*#__PURE__*/ gql`
    query userList($paginate: PaginatorArgsDto, $orderBy: [UsersQueryResolver_List_SortingInputType!], $where: UsersQueryResolver_List_FilterInputType) {
  users {
    list(paginate: $paginate, order_by: $orderBy, where: $where) {
      totalCount
      items {
        ...UserBaseFragment
        branch {
          ...BranchBaseFragment
        }
        roles {
          ...RoleBaseFragment
        }
        division {
          ...DivisionFragment
        }
      }
    }
  }
}
    ${UserBaseFragmentFragmentDoc}
${BranchBaseFragmentFragmentDoc}
${RoleBaseFragmentFragmentDoc}
${DivisionFragmentFragmentDoc}`;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserListQuery(baseOptions?: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
      }
export function useUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export function useUserListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<typeof useUserListLazyQuery>;
export type UserListSuspenseQueryHookResult = ReturnType<typeof useUserListSuspenseQuery>;
export type UserListQueryResult = Apollo.QueryResult<UserListQuery, UserListQueryVariables>;
export const LockoutUserDocument = /*#__PURE__*/ gql`
    mutation lockoutUser($data: UpdateUserDto!) {
  users {
    update(data: $data)
  }
}
    `;
export type LockoutUserMutationFn = Apollo.MutationFunction<LockoutUserMutation, LockoutUserMutationVariables>;

/**
 * __useLockoutUserMutation__
 *
 * To run a mutation, you first call `useLockoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockoutUserMutation, { data, loading, error }] = useLockoutUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLockoutUserMutation(baseOptions?: Apollo.MutationHookOptions<LockoutUserMutation, LockoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockoutUserMutation, LockoutUserMutationVariables>(LockoutUserDocument, options);
      }
export type LockoutUserMutationHookResult = ReturnType<typeof useLockoutUserMutation>;
export type LockoutUserMutationResult = Apollo.MutationResult<LockoutUserMutation>;
export type LockoutUserMutationOptions = Apollo.BaseMutationOptions<LockoutUserMutation, LockoutUserMutationVariables>;
export const UpdateUserDocument = /*#__PURE__*/ gql`
    mutation updateUser($data: UpdateUserDto!) {
  users {
    update(data: $data)
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const CarriageGroupFullnessDocument = /*#__PURE__*/ gql`
    query carriageGroupFullness($id: Float!) {
  carriageGroups {
    carriageGroupById(id: $id) {
      id
      turnovers {
        id
      }
      periodicities {
        id
      }
      carriage_parameters {
        id
      }
    }
  }
}
    `;

/**
 * __useCarriageGroupFullnessQuery__
 *
 * To run a query within a React component, call `useCarriageGroupFullnessQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupFullnessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageGroupFullnessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCarriageGroupFullnessQuery(baseOptions: Apollo.QueryHookOptions<CarriageGroupFullnessQuery, CarriageGroupFullnessQueryVariables> & ({ variables: CarriageGroupFullnessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageGroupFullnessQuery, CarriageGroupFullnessQueryVariables>(CarriageGroupFullnessDocument, options);
      }
export function useCarriageGroupFullnessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageGroupFullnessQuery, CarriageGroupFullnessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageGroupFullnessQuery, CarriageGroupFullnessQueryVariables>(CarriageGroupFullnessDocument, options);
        }
export function useCarriageGroupFullnessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageGroupFullnessQuery, CarriageGroupFullnessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageGroupFullnessQuery, CarriageGroupFullnessQueryVariables>(CarriageGroupFullnessDocument, options);
        }
export type CarriageGroupFullnessQueryHookResult = ReturnType<typeof useCarriageGroupFullnessQuery>;
export type CarriageGroupFullnessLazyQueryHookResult = ReturnType<typeof useCarriageGroupFullnessLazyQuery>;
export type CarriageGroupFullnessSuspenseQueryHookResult = ReturnType<typeof useCarriageGroupFullnessSuspenseQuery>;
export type CarriageGroupFullnessQueryResult = Apollo.QueryResult<CarriageGroupFullnessQuery, CarriageGroupFullnessQueryVariables>;
export const GetCarriageGroupTrainInfoDocument = /*#__PURE__*/ gql`
    query getCarriageGroupTrainInfo($data: GetTurnoverChartDto!) {
  carriageGroups {
    getCarriageGroupTurnoverChart(data: $data) {
      train_info {
        ...CarriageGroupTurnoverTrainInfoBaseFragment
      }
    }
  }
}
    ${CarriageGroupTurnoverTrainInfoBaseFragmentFragmentDoc}`;

/**
 * __useGetCarriageGroupTrainInfoQuery__
 *
 * To run a query within a React component, call `useGetCarriageGroupTrainInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarriageGroupTrainInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarriageGroupTrainInfoQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCarriageGroupTrainInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCarriageGroupTrainInfoQuery, GetCarriageGroupTrainInfoQueryVariables> & ({ variables: GetCarriageGroupTrainInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarriageGroupTrainInfoQuery, GetCarriageGroupTrainInfoQueryVariables>(GetCarriageGroupTrainInfoDocument, options);
      }
export function useGetCarriageGroupTrainInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarriageGroupTrainInfoQuery, GetCarriageGroupTrainInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarriageGroupTrainInfoQuery, GetCarriageGroupTrainInfoQueryVariables>(GetCarriageGroupTrainInfoDocument, options);
        }
export function useGetCarriageGroupTrainInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCarriageGroupTrainInfoQuery, GetCarriageGroupTrainInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCarriageGroupTrainInfoQuery, GetCarriageGroupTrainInfoQueryVariables>(GetCarriageGroupTrainInfoDocument, options);
        }
export type GetCarriageGroupTrainInfoQueryHookResult = ReturnType<typeof useGetCarriageGroupTrainInfoQuery>;
export type GetCarriageGroupTrainInfoLazyQueryHookResult = ReturnType<typeof useGetCarriageGroupTrainInfoLazyQuery>;
export type GetCarriageGroupTrainInfoSuspenseQueryHookResult = ReturnType<typeof useGetCarriageGroupTrainInfoSuspenseQuery>;
export type GetCarriageGroupTrainInfoQueryResult = Apollo.QueryResult<GetCarriageGroupTrainInfoQuery, GetCarriageGroupTrainInfoQueryVariables>;
export const CarriageGroupHeaderAndFullnessDocument = /*#__PURE__*/ gql`
    query carriageGroupHeaderAndFullness($id: Float!) {
  carriageGroups {
    carriageGroupById(id: $id) {
      id
      gdp {
        ...GdpBaseFragment
      }
      branch {
        ...BranchShortFragment
      }
      railway_administration {
        ...RailwayAdministrationBaseFragment
      }
      structural_subdivision {
        ... on MvpsCompanyAffiliationDto {
          ...MvpsCompanyAffiliationBaseFragment
        }
        ... on StructuralSubdivisionDto {
          ...StructuralSubdivisionBaseFragment
        }
      }
      passenger_carrier {
        ...PassengerCarrierShortFragment
      }
      turnovers {
        departure_dates
      }
      periodicities {
        id
      }
      carriage_parameters {
        id
      }
    }
  }
}
    ${GdpBaseFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${RailwayAdministrationBaseFragmentFragmentDoc}
${MvpsCompanyAffiliationBaseFragmentFragmentDoc}
${StructuralSubdivisionBaseFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}`;

/**
 * __useCarriageGroupHeaderAndFullnessQuery__
 *
 * To run a query within a React component, call `useCarriageGroupHeaderAndFullnessQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupHeaderAndFullnessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageGroupHeaderAndFullnessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCarriageGroupHeaderAndFullnessQuery(baseOptions: Apollo.QueryHookOptions<CarriageGroupHeaderAndFullnessQuery, CarriageGroupHeaderAndFullnessQueryVariables> & ({ variables: CarriageGroupHeaderAndFullnessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageGroupHeaderAndFullnessQuery, CarriageGroupHeaderAndFullnessQueryVariables>(CarriageGroupHeaderAndFullnessDocument, options);
      }
export function useCarriageGroupHeaderAndFullnessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageGroupHeaderAndFullnessQuery, CarriageGroupHeaderAndFullnessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageGroupHeaderAndFullnessQuery, CarriageGroupHeaderAndFullnessQueryVariables>(CarriageGroupHeaderAndFullnessDocument, options);
        }
export function useCarriageGroupHeaderAndFullnessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageGroupHeaderAndFullnessQuery, CarriageGroupHeaderAndFullnessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageGroupHeaderAndFullnessQuery, CarriageGroupHeaderAndFullnessQueryVariables>(CarriageGroupHeaderAndFullnessDocument, options);
        }
export type CarriageGroupHeaderAndFullnessQueryHookResult = ReturnType<typeof useCarriageGroupHeaderAndFullnessQuery>;
export type CarriageGroupHeaderAndFullnessLazyQueryHookResult = ReturnType<typeof useCarriageGroupHeaderAndFullnessLazyQuery>;
export type CarriageGroupHeaderAndFullnessSuspenseQueryHookResult = ReturnType<typeof useCarriageGroupHeaderAndFullnessSuspenseQuery>;
export type CarriageGroupHeaderAndFullnessQueryResult = Apollo.QueryResult<CarriageGroupHeaderAndFullnessQuery, CarriageGroupHeaderAndFullnessQueryVariables>;
export const GetCarriageGroupTurnoverChartDocument = /*#__PURE__*/ gql`
    query getCarriageGroupTurnoverChart($data: GetTurnoverChartDto!) {
  carriageGroups {
    getCarriageGroupTurnoverChart(data: $data) {
      items {
        ...CarriageGroupTurnoverChartItemBaseFragment
      }
      train_info {
        ...CarriageGroupTurnoverTrainInfoBaseFragment
      }
    }
  }
}
    ${CarriageGroupTurnoverChartItemBaseFragmentFragmentDoc}
${CarriageGroupTurnoverTrainInfoBaseFragmentFragmentDoc}`;

/**
 * __useGetCarriageGroupTurnoverChartQuery__
 *
 * To run a query within a React component, call `useGetCarriageGroupTurnoverChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarriageGroupTurnoverChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarriageGroupTurnoverChartQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCarriageGroupTurnoverChartQuery(baseOptions: Apollo.QueryHookOptions<GetCarriageGroupTurnoverChartQuery, GetCarriageGroupTurnoverChartQueryVariables> & ({ variables: GetCarriageGroupTurnoverChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarriageGroupTurnoverChartQuery, GetCarriageGroupTurnoverChartQueryVariables>(GetCarriageGroupTurnoverChartDocument, options);
      }
export function useGetCarriageGroupTurnoverChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarriageGroupTurnoverChartQuery, GetCarriageGroupTurnoverChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarriageGroupTurnoverChartQuery, GetCarriageGroupTurnoverChartQueryVariables>(GetCarriageGroupTurnoverChartDocument, options);
        }
export function useGetCarriageGroupTurnoverChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCarriageGroupTurnoverChartQuery, GetCarriageGroupTurnoverChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCarriageGroupTurnoverChartQuery, GetCarriageGroupTurnoverChartQueryVariables>(GetCarriageGroupTurnoverChartDocument, options);
        }
export type GetCarriageGroupTurnoverChartQueryHookResult = ReturnType<typeof useGetCarriageGroupTurnoverChartQuery>;
export type GetCarriageGroupTurnoverChartLazyQueryHookResult = ReturnType<typeof useGetCarriageGroupTurnoverChartLazyQuery>;
export type GetCarriageGroupTurnoverChartSuspenseQueryHookResult = ReturnType<typeof useGetCarriageGroupTurnoverChartSuspenseQuery>;
export type GetCarriageGroupTurnoverChartQueryResult = Apollo.QueryResult<GetCarriageGroupTurnoverChartQuery, GetCarriageGroupTurnoverChartQueryVariables>;
export const CreateCarriageGroupDocument = /*#__PURE__*/ gql`
    mutation createCarriageGroup($data: CreateCarriageGroupDto!) {
  carriageGroups {
    createCarriageGroup(data: $data)
  }
}
    `;
export type CreateCarriageGroupMutationFn = Apollo.MutationFunction<CreateCarriageGroupMutation, CreateCarriageGroupMutationVariables>;

/**
 * __useCreateCarriageGroupMutation__
 *
 * To run a mutation, you first call `useCreateCarriageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarriageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarriageGroupMutation, { data, loading, error }] = useCreateCarriageGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCarriageGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarriageGroupMutation, CreateCarriageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarriageGroupMutation, CreateCarriageGroupMutationVariables>(CreateCarriageGroupDocument, options);
      }
export type CreateCarriageGroupMutationHookResult = ReturnType<typeof useCreateCarriageGroupMutation>;
export type CreateCarriageGroupMutationResult = Apollo.MutationResult<CreateCarriageGroupMutation>;
export type CreateCarriageGroupMutationOptions = Apollo.BaseMutationOptions<CreateCarriageGroupMutation, CreateCarriageGroupMutationVariables>;
export const AddCarriageMvpsDocument = /*#__PURE__*/ gql`
    mutation addCarriageMvps($data: CreateCarriageMvpsDto!) {
  carriageGroups {
    addCarriageMvps(data: $data)
  }
}
    `;
export type AddCarriageMvpsMutationFn = Apollo.MutationFunction<AddCarriageMvpsMutation, AddCarriageMvpsMutationVariables>;

/**
 * __useAddCarriageMvpsMutation__
 *
 * To run a mutation, you first call `useAddCarriageMvpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCarriageMvpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCarriageMvpsMutation, { data, loading, error }] = useAddCarriageMvpsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddCarriageMvpsMutation(baseOptions?: Apollo.MutationHookOptions<AddCarriageMvpsMutation, AddCarriageMvpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCarriageMvpsMutation, AddCarriageMvpsMutationVariables>(AddCarriageMvpsDocument, options);
      }
export type AddCarriageMvpsMutationHookResult = ReturnType<typeof useAddCarriageMvpsMutation>;
export type AddCarriageMvpsMutationResult = Apollo.MutationResult<AddCarriageMvpsMutation>;
export type AddCarriageMvpsMutationOptions = Apollo.BaseMutationOptions<AddCarriageMvpsMutation, AddCarriageMvpsMutationVariables>;
export const AddCarriageNpsDocument = /*#__PURE__*/ gql`
    mutation addCarriageNps($data: CreateCarriageNpsDto!) {
  carriageGroups {
    addCarriageNps(data: $data)
  }
}
    `;
export type AddCarriageNpsMutationFn = Apollo.MutationFunction<AddCarriageNpsMutation, AddCarriageNpsMutationVariables>;

/**
 * __useAddCarriageNpsMutation__
 *
 * To run a mutation, you first call `useAddCarriageNpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCarriageNpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCarriageNpsMutation, { data, loading, error }] = useAddCarriageNpsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddCarriageNpsMutation(baseOptions?: Apollo.MutationHookOptions<AddCarriageNpsMutation, AddCarriageNpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCarriageNpsMutation, AddCarriageNpsMutationVariables>(AddCarriageNpsDocument, options);
      }
export type AddCarriageNpsMutationHookResult = ReturnType<typeof useAddCarriageNpsMutation>;
export type AddCarriageNpsMutationResult = Apollo.MutationResult<AddCarriageNpsMutation>;
export type AddCarriageNpsMutationOptions = Apollo.BaseMutationOptions<AddCarriageNpsMutation, AddCarriageNpsMutationVariables>;
export const AddPeriodicityDocument = /*#__PURE__*/ gql`
    mutation addPeriodicity($data: CreatePeriodicityDto!) {
  carriageGroups {
    addPeriodicity(data: $data)
  }
}
    `;
export type AddPeriodicityMutationFn = Apollo.MutationFunction<AddPeriodicityMutation, AddPeriodicityMutationVariables>;

/**
 * __useAddPeriodicityMutation__
 *
 * To run a mutation, you first call `useAddPeriodicityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPeriodicityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPeriodicityMutation, { data, loading, error }] = useAddPeriodicityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddPeriodicityMutation(baseOptions?: Apollo.MutationHookOptions<AddPeriodicityMutation, AddPeriodicityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPeriodicityMutation, AddPeriodicityMutationVariables>(AddPeriodicityDocument, options);
      }
export type AddPeriodicityMutationHookResult = ReturnType<typeof useAddPeriodicityMutation>;
export type AddPeriodicityMutationResult = Apollo.MutationResult<AddPeriodicityMutation>;
export type AddPeriodicityMutationOptions = Apollo.BaseMutationOptions<AddPeriodicityMutation, AddPeriodicityMutationVariables>;
export const AddTurnoverDocument = /*#__PURE__*/ gql`
    mutation addTurnover($data: CreateTurnoverDto!) {
  carriageGroups {
    addTurnover(data: $data)
  }
}
    `;
export type AddTurnoverMutationFn = Apollo.MutationFunction<AddTurnoverMutation, AddTurnoverMutationVariables>;

/**
 * __useAddTurnoverMutation__
 *
 * To run a mutation, you first call `useAddTurnoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTurnoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTurnoverMutation, { data, loading, error }] = useAddTurnoverMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddTurnoverMutation(baseOptions?: Apollo.MutationHookOptions<AddTurnoverMutation, AddTurnoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTurnoverMutation, AddTurnoverMutationVariables>(AddTurnoverDocument, options);
      }
export type AddTurnoverMutationHookResult = ReturnType<typeof useAddTurnoverMutation>;
export type AddTurnoverMutationResult = Apollo.MutationResult<AddTurnoverMutation>;
export type AddTurnoverMutationOptions = Apollo.BaseMutationOptions<AddTurnoverMutation, AddTurnoverMutationVariables>;
export const AddTurnoverTimeStagnationDocument = /*#__PURE__*/ gql`
    mutation addTurnoverTimeStagnation($data: CreateTurnoverTimeStagnationDto!) {
  carriageGroups {
    addTurnoverTimeStagnation(data: $data)
  }
}
    `;
export type AddTurnoverTimeStagnationMutationFn = Apollo.MutationFunction<AddTurnoverTimeStagnationMutation, AddTurnoverTimeStagnationMutationVariables>;

/**
 * __useAddTurnoverTimeStagnationMutation__
 *
 * To run a mutation, you first call `useAddTurnoverTimeStagnationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTurnoverTimeStagnationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTurnoverTimeStagnationMutation, { data, loading, error }] = useAddTurnoverTimeStagnationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddTurnoverTimeStagnationMutation(baseOptions?: Apollo.MutationHookOptions<AddTurnoverTimeStagnationMutation, AddTurnoverTimeStagnationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTurnoverTimeStagnationMutation, AddTurnoverTimeStagnationMutationVariables>(AddTurnoverTimeStagnationDocument, options);
      }
export type AddTurnoverTimeStagnationMutationHookResult = ReturnType<typeof useAddTurnoverTimeStagnationMutation>;
export type AddTurnoverTimeStagnationMutationResult = Apollo.MutationResult<AddTurnoverTimeStagnationMutation>;
export type AddTurnoverTimeStagnationMutationOptions = Apollo.BaseMutationOptions<AddTurnoverTimeStagnationMutation, AddTurnoverTimeStagnationMutationVariables>;
export const CarriageGroupByIdDocument = /*#__PURE__*/ gql`
    query carriageGroupById($id: Float!) {
  carriageGroups {
    carriageGroupById(id: $id) {
      id
      ...CarriageGroupBaseFragment
      gdp {
        ...GdpBaseFragment
      }
      branch {
        ...BranchShortFragment
      }
      periodicities {
        ...PeriodicityBaseFragment
      }
      railway_administration {
        ...RailwayAdministrationBaseFragment
      }
      passenger_carrier {
        ...PassengerCarrierShortFragment
      }
      turnovers {
        ...TurnoverBaseFragment
        station_from {
          ...StationShortFragment
        }
        station_to {
          ...StationShortFragment
        }
        train {
          ...TrainBaseFragment
          sub_category {
            entity_id
          }
          to_station {
            ...StationShortFragment
          }
          from_station {
            ...StationShortFragment
          }
          schemas {
            ...TrainSchemaShortFragment
          }
        }
        schemas {
          ...TrainSchemaShortFragment
        }
        turnover_time_stagnations {
          ...TurnoverTimeStagnationBaseFragment
        }
      }
      decline_history {
        ...DeclineHistoryBaseFragment
        user {
          user_name
        }
      }
      carriage_parameters {
        ...CarriageParameterBaseFragment
        carriage {
          ...CarriageBaseFragment
          item {
            ... on CarriageMvpsDto {
              ...CarriageMvpsBaseFragment
              carriage_type {
                ...CarriageTypeBaseFragment
                seat_type {
                  ...MnemonicShortFragment
                }
                carriage_types_for_schema {
                  ...CarriageTypesForSchemaBaseFragment
                }
              }
              mvps_martin_section_type {
                ...MvpsMartinSectionTypeBaseFragment
              }
            }
            ... on CarriageNpsDto {
              ...CarriageNpsBaseFragment
              carriage_type {
                ...CarriageTypeBaseFragment
                carriage_types_for_schema {
                  ...CarriageTypesForSchemaBaseFragment
                }
              }
              carriage_dimension {
                ...NpsCarriageDimensionBaseFragment
              }
              carriage_model {
                ...NpsCarriageModelBaseFragment
              }
              carriage_brake_type {
                ...NpsCarriageBrakeTypeBaseFragment
              }
              carriage_heat_type {
                ...NpsCarriageHeatTypeBaseFragment
              }
              carriage_length {
                ...NpsCarriageLengthBaseFragment
              }
              carriage_type_asu {
                ...CarriageTypeAsuBaseFragment
              }
            }
          }
        }
        carriage_additional_parameters {
          ...CarriageAdditionalParameterBaseFragment
          carriage_train_info {
            ...CarriageTrainInfoBaseFragment
            available_service_classes {
              ...AvailableServiceClassBaseFragment
            }
          }
          train {
            ...TrainShortFragment
            sub_category {
              train_category_id
            }
          }
          carriage_seats_allocations {
            ...CarriageSeatsAllocationBaseFragment
            for_whom_seats_allocation {
              entity_id
              name
            }
          }
          carriage_additional_seats_signs {
            ...CarriageAdditionalSeatsSignBaseFragment
            for_whom_additional_seats_sign {
              entity_id
              name
            }
          }
          turnover {
            station_from {
              entity_id
              full_name
            }
            station_to {
              entity_id
              full_name
            }
          }
        }
      }
      structural_subdivision {
        ... on MvpsCompanyAffiliationDto {
          ...MvpsCompanyAffiliationShortFragment
        }
        ... on StructuralSubdivisionDto {
          ...StructuralSubdivisionBaseFragment
          station {
            entity_id
            full_name
          }
        }
      }
      train_quantities {
        ...TrainQuantityBaseFragment
      }
      turnaround_times {
        ...TurnaroundTimeBaseFragment
      }
    }
  }
  indicators {
    indicators_monthly(carriage_group_id: $id) {
      totalCount
    }
  }
}
    ${CarriageGroupBaseFragmentFragmentDoc}
${GdpBaseFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${PeriodicityBaseFragmentFragmentDoc}
${RailwayAdministrationBaseFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}
${TurnoverBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}
${TrainBaseFragmentFragmentDoc}
${TrainSchemaShortFragmentFragmentDoc}
${TurnoverTimeStagnationBaseFragmentFragmentDoc}
${DeclineHistoryBaseFragmentFragmentDoc}
${CarriageParameterBaseFragmentFragmentDoc}
${CarriageBaseFragmentFragmentDoc}
${CarriageMvpsBaseFragmentFragmentDoc}
${CarriageTypeBaseFragmentFragmentDoc}
${MnemonicShortFragmentFragmentDoc}
${CarriageTypesForSchemaBaseFragmentFragmentDoc}
${MvpsMartinSectionTypeBaseFragmentFragmentDoc}
${CarriageNpsBaseFragmentFragmentDoc}
${NpsCarriageDimensionBaseFragmentFragmentDoc}
${NpsCarriageModelBaseFragmentFragmentDoc}
${NpsCarriageBrakeTypeBaseFragmentFragmentDoc}
${NpsCarriageHeatTypeBaseFragmentFragmentDoc}
${NpsCarriageLengthBaseFragmentFragmentDoc}
${CarriageTypeAsuBaseFragmentFragmentDoc}
${CarriageAdditionalParameterBaseFragmentFragmentDoc}
${CarriageTrainInfoBaseFragmentFragmentDoc}
${AvailableServiceClassBaseFragmentFragmentDoc}
${TrainShortFragmentFragmentDoc}
${CarriageSeatsAllocationBaseFragmentFragmentDoc}
${CarriageAdditionalSeatsSignBaseFragmentFragmentDoc}
${MvpsCompanyAffiliationShortFragmentFragmentDoc}
${StructuralSubdivisionBaseFragmentFragmentDoc}
${TrainQuantityBaseFragmentFragmentDoc}
${TurnaroundTimeBaseFragmentFragmentDoc}`;

/**
 * __useCarriageGroupByIdQuery__
 *
 * To run a query within a React component, call `useCarriageGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCarriageGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<CarriageGroupByIdQuery, CarriageGroupByIdQueryVariables> & ({ variables: CarriageGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageGroupByIdQuery, CarriageGroupByIdQueryVariables>(CarriageGroupByIdDocument, options);
      }
export function useCarriageGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageGroupByIdQuery, CarriageGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageGroupByIdQuery, CarriageGroupByIdQueryVariables>(CarriageGroupByIdDocument, options);
        }
export function useCarriageGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageGroupByIdQuery, CarriageGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageGroupByIdQuery, CarriageGroupByIdQueryVariables>(CarriageGroupByIdDocument, options);
        }
export type CarriageGroupByIdQueryHookResult = ReturnType<typeof useCarriageGroupByIdQuery>;
export type CarriageGroupByIdLazyQueryHookResult = ReturnType<typeof useCarriageGroupByIdLazyQuery>;
export type CarriageGroupByIdSuspenseQueryHookResult = ReturnType<typeof useCarriageGroupByIdSuspenseQuery>;
export type CarriageGroupByIdQueryResult = Apollo.QueryResult<CarriageGroupByIdQuery, CarriageGroupByIdQueryVariables>;
export const CarriageGroupHeaderDocument = /*#__PURE__*/ gql`
    query carriageGroupHeader($id: Float!) {
  carriageGroups {
    carriageGroupById(id: $id) {
      id
      gdp {
        ...GdpBaseFragment
      }
      branch {
        ...BranchShortFragment
      }
      railway_administration {
        ...RailwayAdministrationBaseFragment
      }
      structural_subdivision {
        ... on MvpsCompanyAffiliationDto {
          ...MvpsCompanyAffiliationBaseFragment
        }
        ... on StructuralSubdivisionDto {
          ...StructuralSubdivisionBaseFragment
        }
      }
      passenger_carrier {
        ...PassengerCarrierShortFragment
      }
      turnovers {
        departure_dates
      }
    }
  }
}
    ${GdpBaseFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${RailwayAdministrationBaseFragmentFragmentDoc}
${MvpsCompanyAffiliationBaseFragmentFragmentDoc}
${StructuralSubdivisionBaseFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}`;

/**
 * __useCarriageGroupHeaderQuery__
 *
 * To run a query within a React component, call `useCarriageGroupHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageGroupHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCarriageGroupHeaderQuery(baseOptions: Apollo.QueryHookOptions<CarriageGroupHeaderQuery, CarriageGroupHeaderQueryVariables> & ({ variables: CarriageGroupHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageGroupHeaderQuery, CarriageGroupHeaderQueryVariables>(CarriageGroupHeaderDocument, options);
      }
export function useCarriageGroupHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageGroupHeaderQuery, CarriageGroupHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageGroupHeaderQuery, CarriageGroupHeaderQueryVariables>(CarriageGroupHeaderDocument, options);
        }
export function useCarriageGroupHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageGroupHeaderQuery, CarriageGroupHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageGroupHeaderQuery, CarriageGroupHeaderQueryVariables>(CarriageGroupHeaderDocument, options);
        }
export type CarriageGroupHeaderQueryHookResult = ReturnType<typeof useCarriageGroupHeaderQuery>;
export type CarriageGroupHeaderLazyQueryHookResult = ReturnType<typeof useCarriageGroupHeaderLazyQuery>;
export type CarriageGroupHeaderSuspenseQueryHookResult = ReturnType<typeof useCarriageGroupHeaderSuspenseQuery>;
export type CarriageGroupHeaderQueryResult = Apollo.QueryResult<CarriageGroupHeaderQuery, CarriageGroupHeaderQueryVariables>;
export const CarriageGroupTurnoversTimeStagnationDocument = /*#__PURE__*/ gql`
    query carriageGroupTurnoversTimeStagnation($id: Float!) {
  carriageGroups {
    carriageGroupById(id: $id) {
      id
      turnovers {
        ...TurnoverBaseFragment
        turnover_time_stagnations {
          ...TurnoverTimeStagnationBaseFragment
        }
      }
    }
  }
}
    ${TurnoverBaseFragmentFragmentDoc}
${TurnoverTimeStagnationBaseFragmentFragmentDoc}`;

/**
 * __useCarriageGroupTurnoversTimeStagnationQuery__
 *
 * To run a query within a React component, call `useCarriageGroupTurnoversTimeStagnationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupTurnoversTimeStagnationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageGroupTurnoversTimeStagnationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCarriageGroupTurnoversTimeStagnationQuery(baseOptions: Apollo.QueryHookOptions<CarriageGroupTurnoversTimeStagnationQuery, CarriageGroupTurnoversTimeStagnationQueryVariables> & ({ variables: CarriageGroupTurnoversTimeStagnationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageGroupTurnoversTimeStagnationQuery, CarriageGroupTurnoversTimeStagnationQueryVariables>(CarriageGroupTurnoversTimeStagnationDocument, options);
      }
export function useCarriageGroupTurnoversTimeStagnationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageGroupTurnoversTimeStagnationQuery, CarriageGroupTurnoversTimeStagnationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageGroupTurnoversTimeStagnationQuery, CarriageGroupTurnoversTimeStagnationQueryVariables>(CarriageGroupTurnoversTimeStagnationDocument, options);
        }
export function useCarriageGroupTurnoversTimeStagnationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageGroupTurnoversTimeStagnationQuery, CarriageGroupTurnoversTimeStagnationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageGroupTurnoversTimeStagnationQuery, CarriageGroupTurnoversTimeStagnationQueryVariables>(CarriageGroupTurnoversTimeStagnationDocument, options);
        }
export type CarriageGroupTurnoversTimeStagnationQueryHookResult = ReturnType<typeof useCarriageGroupTurnoversTimeStagnationQuery>;
export type CarriageGroupTurnoversTimeStagnationLazyQueryHookResult = ReturnType<typeof useCarriageGroupTurnoversTimeStagnationLazyQuery>;
export type CarriageGroupTurnoversTimeStagnationSuspenseQueryHookResult = ReturnType<typeof useCarriageGroupTurnoversTimeStagnationSuspenseQuery>;
export type CarriageGroupTurnoversTimeStagnationQueryResult = Apollo.QueryResult<CarriageGroupTurnoversTimeStagnationQuery, CarriageGroupTurnoversTimeStagnationQueryVariables>;
export const CheckCarriageGroupCarriageNumbersDocument = /*#__PURE__*/ gql`
    query checkCarriageGroupCarriageNumbers($id: Float!) {
  carriageGroups {
    checkCarriageGroupCarriageNumbers(id: $id) {
      error_message
      is_error_belongs_to_carriage_numbers_validation
      is_valid
    }
  }
}
    `;

/**
 * __useCheckCarriageGroupCarriageNumbersQuery__
 *
 * To run a query within a React component, call `useCheckCarriageGroupCarriageNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCarriageGroupCarriageNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCarriageGroupCarriageNumbersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckCarriageGroupCarriageNumbersQuery(baseOptions: Apollo.QueryHookOptions<CheckCarriageGroupCarriageNumbersQuery, CheckCarriageGroupCarriageNumbersQueryVariables> & ({ variables: CheckCarriageGroupCarriageNumbersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCarriageGroupCarriageNumbersQuery, CheckCarriageGroupCarriageNumbersQueryVariables>(CheckCarriageGroupCarriageNumbersDocument, options);
      }
export function useCheckCarriageGroupCarriageNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCarriageGroupCarriageNumbersQuery, CheckCarriageGroupCarriageNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCarriageGroupCarriageNumbersQuery, CheckCarriageGroupCarriageNumbersQueryVariables>(CheckCarriageGroupCarriageNumbersDocument, options);
        }
export function useCheckCarriageGroupCarriageNumbersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckCarriageGroupCarriageNumbersQuery, CheckCarriageGroupCarriageNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckCarriageGroupCarriageNumbersQuery, CheckCarriageGroupCarriageNumbersQueryVariables>(CheckCarriageGroupCarriageNumbersDocument, options);
        }
export type CheckCarriageGroupCarriageNumbersQueryHookResult = ReturnType<typeof useCheckCarriageGroupCarriageNumbersQuery>;
export type CheckCarriageGroupCarriageNumbersLazyQueryHookResult = ReturnType<typeof useCheckCarriageGroupCarriageNumbersLazyQuery>;
export type CheckCarriageGroupCarriageNumbersSuspenseQueryHookResult = ReturnType<typeof useCheckCarriageGroupCarriageNumbersSuspenseQuery>;
export type CheckCarriageGroupCarriageNumbersQueryResult = Apollo.QueryResult<CheckCarriageGroupCarriageNumbersQuery, CheckCarriageGroupCarriageNumbersQueryVariables>;
export const CheckCarriagesByDateDocument = /*#__PURE__*/ gql`
    query checkCarriagesByDate($data: CarriageGroupCheckCarriagesByDateRequestDto!) {
  indicators {
    check_carriages_by_date(data: $data)
  }
}
    `;

/**
 * __useCheckCarriagesByDateQuery__
 *
 * To run a query within a React component, call `useCheckCarriagesByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCarriagesByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCarriagesByDateQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckCarriagesByDateQuery(baseOptions: Apollo.QueryHookOptions<CheckCarriagesByDateQuery, CheckCarriagesByDateQueryVariables> & ({ variables: CheckCarriagesByDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCarriagesByDateQuery, CheckCarriagesByDateQueryVariables>(CheckCarriagesByDateDocument, options);
      }
export function useCheckCarriagesByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCarriagesByDateQuery, CheckCarriagesByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCarriagesByDateQuery, CheckCarriagesByDateQueryVariables>(CheckCarriagesByDateDocument, options);
        }
export function useCheckCarriagesByDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckCarriagesByDateQuery, CheckCarriagesByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckCarriagesByDateQuery, CheckCarriagesByDateQueryVariables>(CheckCarriagesByDateDocument, options);
        }
export type CheckCarriagesByDateQueryHookResult = ReturnType<typeof useCheckCarriagesByDateQuery>;
export type CheckCarriagesByDateLazyQueryHookResult = ReturnType<typeof useCheckCarriagesByDateLazyQuery>;
export type CheckCarriagesByDateSuspenseQueryHookResult = ReturnType<typeof useCheckCarriagesByDateSuspenseQuery>;
export type CheckCarriagesByDateQueryResult = Apollo.QueryResult<CheckCarriagesByDateQuery, CheckCarriagesByDateQueryVariables>;
export const CopyCarriageDocument = /*#__PURE__*/ gql`
    mutation copyCarriage($data: CopyCarriageParameterDto!) {
  carriageGroups {
    copyCarriage(data: $data)
  }
}
    `;
export type CopyCarriageMutationFn = Apollo.MutationFunction<CopyCarriageMutation, CopyCarriageMutationVariables>;

/**
 * __useCopyCarriageMutation__
 *
 * To run a mutation, you first call `useCopyCarriageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCarriageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCarriageMutation, { data, loading, error }] = useCopyCarriageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCopyCarriageMutation(baseOptions?: Apollo.MutationHookOptions<CopyCarriageMutation, CopyCarriageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyCarriageMutation, CopyCarriageMutationVariables>(CopyCarriageDocument, options);
      }
export type CopyCarriageMutationHookResult = ReturnType<typeof useCopyCarriageMutation>;
export type CopyCarriageMutationResult = Apollo.MutationResult<CopyCarriageMutation>;
export type CopyCarriageMutationOptions = Apollo.BaseMutationOptions<CopyCarriageMutation, CopyCarriageMutationVariables>;
export const GetDatesDataToAddTimeStagnationDocument = /*#__PURE__*/ gql`
    query getDatesDataToAddTimeStagnation($id: Float!) {
  carriageGroups {
    getDatesDataToAddTimeStagnation(id: $id) {
      available_dates_to_select
    }
  }
}
    `;

/**
 * __useGetDatesDataToAddTimeStagnationQuery__
 *
 * To run a query within a React component, call `useGetDatesDataToAddTimeStagnationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatesDataToAddTimeStagnationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatesDataToAddTimeStagnationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDatesDataToAddTimeStagnationQuery(baseOptions: Apollo.QueryHookOptions<GetDatesDataToAddTimeStagnationQuery, GetDatesDataToAddTimeStagnationQueryVariables> & ({ variables: GetDatesDataToAddTimeStagnationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatesDataToAddTimeStagnationQuery, GetDatesDataToAddTimeStagnationQueryVariables>(GetDatesDataToAddTimeStagnationDocument, options);
      }
export function useGetDatesDataToAddTimeStagnationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatesDataToAddTimeStagnationQuery, GetDatesDataToAddTimeStagnationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatesDataToAddTimeStagnationQuery, GetDatesDataToAddTimeStagnationQueryVariables>(GetDatesDataToAddTimeStagnationDocument, options);
        }
export function useGetDatesDataToAddTimeStagnationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatesDataToAddTimeStagnationQuery, GetDatesDataToAddTimeStagnationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatesDataToAddTimeStagnationQuery, GetDatesDataToAddTimeStagnationQueryVariables>(GetDatesDataToAddTimeStagnationDocument, options);
        }
export type GetDatesDataToAddTimeStagnationQueryHookResult = ReturnType<typeof useGetDatesDataToAddTimeStagnationQuery>;
export type GetDatesDataToAddTimeStagnationLazyQueryHookResult = ReturnType<typeof useGetDatesDataToAddTimeStagnationLazyQuery>;
export type GetDatesDataToAddTimeStagnationSuspenseQueryHookResult = ReturnType<typeof useGetDatesDataToAddTimeStagnationSuspenseQuery>;
export type GetDatesDataToAddTimeStagnationQueryResult = Apollo.QueryResult<GetDatesDataToAddTimeStagnationQuery, GetDatesDataToAddTimeStagnationQueryVariables>;
export const GetDatesDataToUpdateTimeStagnationDocument = /*#__PURE__*/ gql`
    query getDatesDataToUpdateTimeStagnation($data: TurnoverUpdateTimeStagnationDatesInfoReqDto!) {
  carriageGroups {
    getDatesDataToUpdateTimeStagnation(data: $data) {
      available_dates_to_select
      selected_dates
    }
  }
}
    `;

/**
 * __useGetDatesDataToUpdateTimeStagnationQuery__
 *
 * To run a query within a React component, call `useGetDatesDataToUpdateTimeStagnationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatesDataToUpdateTimeStagnationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatesDataToUpdateTimeStagnationQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetDatesDataToUpdateTimeStagnationQuery(baseOptions: Apollo.QueryHookOptions<GetDatesDataToUpdateTimeStagnationQuery, GetDatesDataToUpdateTimeStagnationQueryVariables> & ({ variables: GetDatesDataToUpdateTimeStagnationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatesDataToUpdateTimeStagnationQuery, GetDatesDataToUpdateTimeStagnationQueryVariables>(GetDatesDataToUpdateTimeStagnationDocument, options);
      }
export function useGetDatesDataToUpdateTimeStagnationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatesDataToUpdateTimeStagnationQuery, GetDatesDataToUpdateTimeStagnationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatesDataToUpdateTimeStagnationQuery, GetDatesDataToUpdateTimeStagnationQueryVariables>(GetDatesDataToUpdateTimeStagnationDocument, options);
        }
export function useGetDatesDataToUpdateTimeStagnationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatesDataToUpdateTimeStagnationQuery, GetDatesDataToUpdateTimeStagnationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatesDataToUpdateTimeStagnationQuery, GetDatesDataToUpdateTimeStagnationQueryVariables>(GetDatesDataToUpdateTimeStagnationDocument, options);
        }
export type GetDatesDataToUpdateTimeStagnationQueryHookResult = ReturnType<typeof useGetDatesDataToUpdateTimeStagnationQuery>;
export type GetDatesDataToUpdateTimeStagnationLazyQueryHookResult = ReturnType<typeof useGetDatesDataToUpdateTimeStagnationLazyQuery>;
export type GetDatesDataToUpdateTimeStagnationSuspenseQueryHookResult = ReturnType<typeof useGetDatesDataToUpdateTimeStagnationSuspenseQuery>;
export type GetDatesDataToUpdateTimeStagnationQueryResult = Apollo.QueryResult<GetDatesDataToUpdateTimeStagnationQuery, GetDatesDataToUpdateTimeStagnationQueryVariables>;
export const DeleteCarriageParametersDocument = /*#__PURE__*/ gql`
    mutation deleteCarriageParameters($data: DeleteCarriageParameter!) {
  carriageGroups {
    deleteCarriageParameters(data: $data)
  }
}
    `;
export type DeleteCarriageParametersMutationFn = Apollo.MutationFunction<DeleteCarriageParametersMutation, DeleteCarriageParametersMutationVariables>;

/**
 * __useDeleteCarriageParametersMutation__
 *
 * To run a mutation, you first call `useDeleteCarriageParametersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarriageParametersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarriageParametersMutation, { data, loading, error }] = useDeleteCarriageParametersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteCarriageParametersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarriageParametersMutation, DeleteCarriageParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCarriageParametersMutation, DeleteCarriageParametersMutationVariables>(DeleteCarriageParametersDocument, options);
      }
export type DeleteCarriageParametersMutationHookResult = ReturnType<typeof useDeleteCarriageParametersMutation>;
export type DeleteCarriageParametersMutationResult = Apollo.MutationResult<DeleteCarriageParametersMutation>;
export type DeleteCarriageParametersMutationOptions = Apollo.BaseMutationOptions<DeleteCarriageParametersMutation, DeleteCarriageParametersMutationVariables>;
export const DeletePeriodicityDocument = /*#__PURE__*/ gql`
    mutation deletePeriodicity($data: DeletePeriodicityDto!) {
  carriageGroups {
    deletePeriodicity(data: $data)
  }
}
    `;
export type DeletePeriodicityMutationFn = Apollo.MutationFunction<DeletePeriodicityMutation, DeletePeriodicityMutationVariables>;

/**
 * __useDeletePeriodicityMutation__
 *
 * To run a mutation, you first call `useDeletePeriodicityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePeriodicityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePeriodicityMutation, { data, loading, error }] = useDeletePeriodicityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePeriodicityMutation(baseOptions?: Apollo.MutationHookOptions<DeletePeriodicityMutation, DeletePeriodicityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePeriodicityMutation, DeletePeriodicityMutationVariables>(DeletePeriodicityDocument, options);
      }
export type DeletePeriodicityMutationHookResult = ReturnType<typeof useDeletePeriodicityMutation>;
export type DeletePeriodicityMutationResult = Apollo.MutationResult<DeletePeriodicityMutation>;
export type DeletePeriodicityMutationOptions = Apollo.BaseMutationOptions<DeletePeriodicityMutation, DeletePeriodicityMutationVariables>;
export const DeleteTurnoverDocument = /*#__PURE__*/ gql`
    mutation deleteTurnover($data: DeleteTurnoverDto!) {
  carriageGroups {
    deleteTurnover(data: $data)
  }
}
    `;
export type DeleteTurnoverMutationFn = Apollo.MutationFunction<DeleteTurnoverMutation, DeleteTurnoverMutationVariables>;

/**
 * __useDeleteTurnoverMutation__
 *
 * To run a mutation, you first call `useDeleteTurnoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTurnoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTurnoverMutation, { data, loading, error }] = useDeleteTurnoverMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteTurnoverMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTurnoverMutation, DeleteTurnoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTurnoverMutation, DeleteTurnoverMutationVariables>(DeleteTurnoverDocument, options);
      }
export type DeleteTurnoverMutationHookResult = ReturnType<typeof useDeleteTurnoverMutation>;
export type DeleteTurnoverMutationResult = Apollo.MutationResult<DeleteTurnoverMutation>;
export type DeleteTurnoverMutationOptions = Apollo.BaseMutationOptions<DeleteTurnoverMutation, DeleteTurnoverMutationVariables>;
export const DeleteTurnoverTimeStagnationDocument = /*#__PURE__*/ gql`
    mutation deleteTurnoverTimeStagnation($data: DeleteTurnoverTimeStagnationDto!) {
  carriageGroups {
    deleteTurnoverTimeStagnation(data: $data)
  }
}
    `;
export type DeleteTurnoverTimeStagnationMutationFn = Apollo.MutationFunction<DeleteTurnoverTimeStagnationMutation, DeleteTurnoverTimeStagnationMutationVariables>;

/**
 * __useDeleteTurnoverTimeStagnationMutation__
 *
 * To run a mutation, you first call `useDeleteTurnoverTimeStagnationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTurnoverTimeStagnationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTurnoverTimeStagnationMutation, { data, loading, error }] = useDeleteTurnoverTimeStagnationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteTurnoverTimeStagnationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTurnoverTimeStagnationMutation, DeleteTurnoverTimeStagnationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTurnoverTimeStagnationMutation, DeleteTurnoverTimeStagnationMutationVariables>(DeleteTurnoverTimeStagnationDocument, options);
      }
export type DeleteTurnoverTimeStagnationMutationHookResult = ReturnType<typeof useDeleteTurnoverTimeStagnationMutation>;
export type DeleteTurnoverTimeStagnationMutationResult = Apollo.MutationResult<DeleteTurnoverTimeStagnationMutation>;
export type DeleteTurnoverTimeStagnationMutationOptions = Apollo.BaseMutationOptions<DeleteTurnoverTimeStagnationMutation, DeleteTurnoverTimeStagnationMutationVariables>;
export const ExportCarriageGroupToSchemasDocument = /*#__PURE__*/ gql`
    mutation exportCarriageGroupToSchemas($data: ExportCarriageGroupDto!) {
  carriageGroups {
    exportCarriageGroupToSchemas(data: $data)
  }
}
    `;
export type ExportCarriageGroupToSchemasMutationFn = Apollo.MutationFunction<ExportCarriageGroupToSchemasMutation, ExportCarriageGroupToSchemasMutationVariables>;

/**
 * __useExportCarriageGroupToSchemasMutation__
 *
 * To run a mutation, you first call `useExportCarriageGroupToSchemasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCarriageGroupToSchemasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCarriageGroupToSchemasMutation, { data, loading, error }] = useExportCarriageGroupToSchemasMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExportCarriageGroupToSchemasMutation(baseOptions?: Apollo.MutationHookOptions<ExportCarriageGroupToSchemasMutation, ExportCarriageGroupToSchemasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportCarriageGroupToSchemasMutation, ExportCarriageGroupToSchemasMutationVariables>(ExportCarriageGroupToSchemasDocument, options);
      }
export type ExportCarriageGroupToSchemasMutationHookResult = ReturnType<typeof useExportCarriageGroupToSchemasMutation>;
export type ExportCarriageGroupToSchemasMutationResult = Apollo.MutationResult<ExportCarriageGroupToSchemasMutation>;
export type ExportCarriageGroupToSchemasMutationOptions = Apollo.BaseMutationOptions<ExportCarriageGroupToSchemasMutation, ExportCarriageGroupToSchemasMutationVariables>;
export const CarriageSeatsCountByCarriageDimensionAndTypeAsuDocument = /*#__PURE__*/ gql`
    query carriageSeatsCountByCarriageDimensionAndTypeAsu($data: ByTypeAsuDimensionIdQueryDataDto!) {
  classifiers {
    carriageTypeAsuDimensionSeatsCount {
      byTypeAsuDimensionId(data: $data) {
        ...CarriageTypeAsuDimensionSeatsCountShortFragment
      }
    }
  }
}
    ${CarriageTypeAsuDimensionSeatsCountShortFragmentFragmentDoc}`;

/**
 * __useCarriageSeatsCountByCarriageDimensionAndTypeAsuQuery__
 *
 * To run a query within a React component, call `useCarriageSeatsCountByCarriageDimensionAndTypeAsuQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageSeatsCountByCarriageDimensionAndTypeAsuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageSeatsCountByCarriageDimensionAndTypeAsuQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageSeatsCountByCarriageDimensionAndTypeAsuQuery(baseOptions: Apollo.QueryHookOptions<CarriageSeatsCountByCarriageDimensionAndTypeAsuQuery, CarriageSeatsCountByCarriageDimensionAndTypeAsuQueryVariables> & ({ variables: CarriageSeatsCountByCarriageDimensionAndTypeAsuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageSeatsCountByCarriageDimensionAndTypeAsuQuery, CarriageSeatsCountByCarriageDimensionAndTypeAsuQueryVariables>(CarriageSeatsCountByCarriageDimensionAndTypeAsuDocument, options);
      }
export function useCarriageSeatsCountByCarriageDimensionAndTypeAsuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageSeatsCountByCarriageDimensionAndTypeAsuQuery, CarriageSeatsCountByCarriageDimensionAndTypeAsuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageSeatsCountByCarriageDimensionAndTypeAsuQuery, CarriageSeatsCountByCarriageDimensionAndTypeAsuQueryVariables>(CarriageSeatsCountByCarriageDimensionAndTypeAsuDocument, options);
        }
export function useCarriageSeatsCountByCarriageDimensionAndTypeAsuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageSeatsCountByCarriageDimensionAndTypeAsuQuery, CarriageSeatsCountByCarriageDimensionAndTypeAsuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageSeatsCountByCarriageDimensionAndTypeAsuQuery, CarriageSeatsCountByCarriageDimensionAndTypeAsuQueryVariables>(CarriageSeatsCountByCarriageDimensionAndTypeAsuDocument, options);
        }
export type CarriageSeatsCountByCarriageDimensionAndTypeAsuQueryHookResult = ReturnType<typeof useCarriageSeatsCountByCarriageDimensionAndTypeAsuQuery>;
export type CarriageSeatsCountByCarriageDimensionAndTypeAsuLazyQueryHookResult = ReturnType<typeof useCarriageSeatsCountByCarriageDimensionAndTypeAsuLazyQuery>;
export type CarriageSeatsCountByCarriageDimensionAndTypeAsuSuspenseQueryHookResult = ReturnType<typeof useCarriageSeatsCountByCarriageDimensionAndTypeAsuSuspenseQuery>;
export type CarriageSeatsCountByCarriageDimensionAndTypeAsuQueryResult = Apollo.QueryResult<CarriageSeatsCountByCarriageDimensionAndTypeAsuQuery, CarriageSeatsCountByCarriageDimensionAndTypeAsuQueryVariables>;
export const GetTurnoverFromStationListDocument = /*#__PURE__*/ gql`
    query getTurnoverFromStationList($data: GetTurnoverFromStationListRequestDto!) {
  carriageGroups {
    getTurnoverFromStationList(data: $data) {
      stations {
        ...StationShortFragment
      }
    }
  }
}
    ${StationShortFragmentFragmentDoc}`;

/**
 * __useGetTurnoverFromStationListQuery__
 *
 * To run a query within a React component, call `useGetTurnoverFromStationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTurnoverFromStationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTurnoverFromStationListQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTurnoverFromStationListQuery(baseOptions: Apollo.QueryHookOptions<GetTurnoverFromStationListQuery, GetTurnoverFromStationListQueryVariables> & ({ variables: GetTurnoverFromStationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTurnoverFromStationListQuery, GetTurnoverFromStationListQueryVariables>(GetTurnoverFromStationListDocument, options);
      }
export function useGetTurnoverFromStationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTurnoverFromStationListQuery, GetTurnoverFromStationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTurnoverFromStationListQuery, GetTurnoverFromStationListQueryVariables>(GetTurnoverFromStationListDocument, options);
        }
export function useGetTurnoverFromStationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTurnoverFromStationListQuery, GetTurnoverFromStationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTurnoverFromStationListQuery, GetTurnoverFromStationListQueryVariables>(GetTurnoverFromStationListDocument, options);
        }
export type GetTurnoverFromStationListQueryHookResult = ReturnType<typeof useGetTurnoverFromStationListQuery>;
export type GetTurnoverFromStationListLazyQueryHookResult = ReturnType<typeof useGetTurnoverFromStationListLazyQuery>;
export type GetTurnoverFromStationListSuspenseQueryHookResult = ReturnType<typeof useGetTurnoverFromStationListSuspenseQuery>;
export type GetTurnoverFromStationListQueryResult = Apollo.QueryResult<GetTurnoverFromStationListQuery, GetTurnoverFromStationListQueryVariables>;
export const GetTurnoverToStationListDocument = /*#__PURE__*/ gql`
    query getTurnoverToStationList($data: GetTurnoverToStationListRequestDto!) {
  carriageGroups {
    getTurnoverToStationList(data: $data) {
      stations {
        ...StationBaseFragment
      }
    }
  }
}
    ${StationBaseFragmentFragmentDoc}`;

/**
 * __useGetTurnoverToStationListQuery__
 *
 * To run a query within a React component, call `useGetTurnoverToStationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTurnoverToStationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTurnoverToStationListQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTurnoverToStationListQuery(baseOptions: Apollo.QueryHookOptions<GetTurnoverToStationListQuery, GetTurnoverToStationListQueryVariables> & ({ variables: GetTurnoverToStationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTurnoverToStationListQuery, GetTurnoverToStationListQueryVariables>(GetTurnoverToStationListDocument, options);
      }
export function useGetTurnoverToStationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTurnoverToStationListQuery, GetTurnoverToStationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTurnoverToStationListQuery, GetTurnoverToStationListQueryVariables>(GetTurnoverToStationListDocument, options);
        }
export function useGetTurnoverToStationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTurnoverToStationListQuery, GetTurnoverToStationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTurnoverToStationListQuery, GetTurnoverToStationListQueryVariables>(GetTurnoverToStationListDocument, options);
        }
export type GetTurnoverToStationListQueryHookResult = ReturnType<typeof useGetTurnoverToStationListQuery>;
export type GetTurnoverToStationListLazyQueryHookResult = ReturnType<typeof useGetTurnoverToStationListLazyQuery>;
export type GetTurnoverToStationListSuspenseQueryHookResult = ReturnType<typeof useGetTurnoverToStationListSuspenseQuery>;
export type GetTurnoverToStationListQueryResult = Apollo.QueryResult<GetTurnoverToStationListQuery, GetTurnoverToStationListQueryVariables>;
export const TrainListForTurnoverDocument = /*#__PURE__*/ gql`
    query trainListForTurnover($paginate: PaginatorArgsDto, $orderBy: [TrainQueryResolver_List_SortingInputType!], $where: TrainQueryResolver_List_FilterInputType) {
  train {
    list(paginate: $paginate, order_by: $orderBy, where: $where) {
      items {
        ...TrainBaseFragment
        sub_category {
          entity_id
        }
        schemas {
          id
          train_schema_number
        }
        to_station {
          ...StationShortFragment
        }
        from_station {
          ...StationShortFragment
        }
      }
    }
  }
}
    ${TrainBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;

/**
 * __useTrainListForTurnoverQuery__
 *
 * To run a query within a React component, call `useTrainListForTurnoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainListForTurnoverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainListForTurnoverQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrainListForTurnoverQuery(baseOptions?: Apollo.QueryHookOptions<TrainListForTurnoverQuery, TrainListForTurnoverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainListForTurnoverQuery, TrainListForTurnoverQueryVariables>(TrainListForTurnoverDocument, options);
      }
export function useTrainListForTurnoverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainListForTurnoverQuery, TrainListForTurnoverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainListForTurnoverQuery, TrainListForTurnoverQueryVariables>(TrainListForTurnoverDocument, options);
        }
export function useTrainListForTurnoverSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainListForTurnoverQuery, TrainListForTurnoverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainListForTurnoverQuery, TrainListForTurnoverQueryVariables>(TrainListForTurnoverDocument, options);
        }
export type TrainListForTurnoverQueryHookResult = ReturnType<typeof useTrainListForTurnoverQuery>;
export type TrainListForTurnoverLazyQueryHookResult = ReturnType<typeof useTrainListForTurnoverLazyQuery>;
export type TrainListForTurnoverSuspenseQueryHookResult = ReturnType<typeof useTrainListForTurnoverSuspenseQuery>;
export type TrainListForTurnoverQueryResult = Apollo.QueryResult<TrainListForTurnoverQuery, TrainListForTurnoverQueryVariables>;
export const UpdateCarriageAdditionalInfoParametersDocument = /*#__PURE__*/ gql`
    mutation updateCarriageAdditionalInfoParameters($data: UpdateAllCarriageParametersDto!) {
  carriageGroups {
    updateCarriageAdditionalInfoParameters(data: $data)
  }
}
    `;
export type UpdateCarriageAdditionalInfoParametersMutationFn = Apollo.MutationFunction<UpdateCarriageAdditionalInfoParametersMutation, UpdateCarriageAdditionalInfoParametersMutationVariables>;

/**
 * __useUpdateCarriageAdditionalInfoParametersMutation__
 *
 * To run a mutation, you first call `useUpdateCarriageAdditionalInfoParametersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarriageAdditionalInfoParametersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarriageAdditionalInfoParametersMutation, { data, loading, error }] = useUpdateCarriageAdditionalInfoParametersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCarriageAdditionalInfoParametersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarriageAdditionalInfoParametersMutation, UpdateCarriageAdditionalInfoParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarriageAdditionalInfoParametersMutation, UpdateCarriageAdditionalInfoParametersMutationVariables>(UpdateCarriageAdditionalInfoParametersDocument, options);
      }
export type UpdateCarriageAdditionalInfoParametersMutationHookResult = ReturnType<typeof useUpdateCarriageAdditionalInfoParametersMutation>;
export type UpdateCarriageAdditionalInfoParametersMutationResult = Apollo.MutationResult<UpdateCarriageAdditionalInfoParametersMutation>;
export type UpdateCarriageAdditionalInfoParametersMutationOptions = Apollo.BaseMutationOptions<UpdateCarriageAdditionalInfoParametersMutation, UpdateCarriageAdditionalInfoParametersMutationVariables>;
export const UpdateCarriageGroupDocument = /*#__PURE__*/ gql`
    mutation updateCarriageGroup($data: UpdateCarriageGroupDto!) {
  carriageGroups {
    updateCarriageGroup(data: $data)
  }
}
    `;
export type UpdateCarriageGroupMutationFn = Apollo.MutationFunction<UpdateCarriageGroupMutation, UpdateCarriageGroupMutationVariables>;

/**
 * __useUpdateCarriageGroupMutation__
 *
 * To run a mutation, you first call `useUpdateCarriageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarriageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarriageGroupMutation, { data, loading, error }] = useUpdateCarriageGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCarriageGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarriageGroupMutation, UpdateCarriageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarriageGroupMutation, UpdateCarriageGroupMutationVariables>(UpdateCarriageGroupDocument, options);
      }
export type UpdateCarriageGroupMutationHookResult = ReturnType<typeof useUpdateCarriageGroupMutation>;
export type UpdateCarriageGroupMutationResult = Apollo.MutationResult<UpdateCarriageGroupMutation>;
export type UpdateCarriageGroupMutationOptions = Apollo.BaseMutationOptions<UpdateCarriageGroupMutation, UpdateCarriageGroupMutationVariables>;
export const UpdateCarriageMvpsDocument = /*#__PURE__*/ gql`
    mutation updateCarriageMvps($data: UpdateCarriageMvpsDto!) {
  carriageGroups {
    updateCarriageMvps(data: $data)
  }
}
    `;
export type UpdateCarriageMvpsMutationFn = Apollo.MutationFunction<UpdateCarriageMvpsMutation, UpdateCarriageMvpsMutationVariables>;

/**
 * __useUpdateCarriageMvpsMutation__
 *
 * To run a mutation, you first call `useUpdateCarriageMvpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarriageMvpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarriageMvpsMutation, { data, loading, error }] = useUpdateCarriageMvpsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCarriageMvpsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarriageMvpsMutation, UpdateCarriageMvpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarriageMvpsMutation, UpdateCarriageMvpsMutationVariables>(UpdateCarriageMvpsDocument, options);
      }
export type UpdateCarriageMvpsMutationHookResult = ReturnType<typeof useUpdateCarriageMvpsMutation>;
export type UpdateCarriageMvpsMutationResult = Apollo.MutationResult<UpdateCarriageMvpsMutation>;
export type UpdateCarriageMvpsMutationOptions = Apollo.BaseMutationOptions<UpdateCarriageMvpsMutation, UpdateCarriageMvpsMutationVariables>;
export const UpdateCarriageNpsDocument = /*#__PURE__*/ gql`
    mutation updateCarriageNps($data: UpdateCarriageNpsDto!) {
  carriageGroups {
    updateCarriageNps(data: $data)
  }
}
    `;
export type UpdateCarriageNpsMutationFn = Apollo.MutationFunction<UpdateCarriageNpsMutation, UpdateCarriageNpsMutationVariables>;

/**
 * __useUpdateCarriageNpsMutation__
 *
 * To run a mutation, you first call `useUpdateCarriageNpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarriageNpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarriageNpsMutation, { data, loading, error }] = useUpdateCarriageNpsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCarriageNpsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarriageNpsMutation, UpdateCarriageNpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarriageNpsMutation, UpdateCarriageNpsMutationVariables>(UpdateCarriageNpsDocument, options);
      }
export type UpdateCarriageNpsMutationHookResult = ReturnType<typeof useUpdateCarriageNpsMutation>;
export type UpdateCarriageNpsMutationResult = Apollo.MutationResult<UpdateCarriageNpsMutation>;
export type UpdateCarriageNpsMutationOptions = Apollo.BaseMutationOptions<UpdateCarriageNpsMutation, UpdateCarriageNpsMutationVariables>;
export const UpdatePeriodicityDocument = /*#__PURE__*/ gql`
    mutation updatePeriodicity($data: UpdatePeriodicityDto!) {
  carriageGroups {
    updatePeriodicity(data: $data)
  }
}
    `;
export type UpdatePeriodicityMutationFn = Apollo.MutationFunction<UpdatePeriodicityMutation, UpdatePeriodicityMutationVariables>;

/**
 * __useUpdatePeriodicityMutation__
 *
 * To run a mutation, you first call `useUpdatePeriodicityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePeriodicityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePeriodicityMutation, { data, loading, error }] = useUpdatePeriodicityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePeriodicityMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePeriodicityMutation, UpdatePeriodicityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePeriodicityMutation, UpdatePeriodicityMutationVariables>(UpdatePeriodicityDocument, options);
      }
export type UpdatePeriodicityMutationHookResult = ReturnType<typeof useUpdatePeriodicityMutation>;
export type UpdatePeriodicityMutationResult = Apollo.MutationResult<UpdatePeriodicityMutation>;
export type UpdatePeriodicityMutationOptions = Apollo.BaseMutationOptions<UpdatePeriodicityMutation, UpdatePeriodicityMutationVariables>;
export const UpdateTurnoverDocument = /*#__PURE__*/ gql`
    mutation updateTurnover($data: UpdateTurnoverDto!) {
  carriageGroups {
    updateTurnover(data: $data)
  }
}
    `;
export type UpdateTurnoverMutationFn = Apollo.MutationFunction<UpdateTurnoverMutation, UpdateTurnoverMutationVariables>;

/**
 * __useUpdateTurnoverMutation__
 *
 * To run a mutation, you first call `useUpdateTurnoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTurnoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTurnoverMutation, { data, loading, error }] = useUpdateTurnoverMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTurnoverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTurnoverMutation, UpdateTurnoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTurnoverMutation, UpdateTurnoverMutationVariables>(UpdateTurnoverDocument, options);
      }
export type UpdateTurnoverMutationHookResult = ReturnType<typeof useUpdateTurnoverMutation>;
export type UpdateTurnoverMutationResult = Apollo.MutationResult<UpdateTurnoverMutation>;
export type UpdateTurnoverMutationOptions = Apollo.BaseMutationOptions<UpdateTurnoverMutation, UpdateTurnoverMutationVariables>;
export const UpdateTurnoverTimeStagnationDocument = /*#__PURE__*/ gql`
    mutation updateTurnoverTimeStagnation($data: UpdateTurnoverTimeStagnationDto!) {
  carriageGroups {
    updateTurnoverTimeStagnation(data: $data)
  }
}
    `;
export type UpdateTurnoverTimeStagnationMutationFn = Apollo.MutationFunction<UpdateTurnoverTimeStagnationMutation, UpdateTurnoverTimeStagnationMutationVariables>;

/**
 * __useUpdateTurnoverTimeStagnationMutation__
 *
 * To run a mutation, you first call `useUpdateTurnoverTimeStagnationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTurnoverTimeStagnationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTurnoverTimeStagnationMutation, { data, loading, error }] = useUpdateTurnoverTimeStagnationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTurnoverTimeStagnationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTurnoverTimeStagnationMutation, UpdateTurnoverTimeStagnationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTurnoverTimeStagnationMutation, UpdateTurnoverTimeStagnationMutationVariables>(UpdateTurnoverTimeStagnationDocument, options);
      }
export type UpdateTurnoverTimeStagnationMutationHookResult = ReturnType<typeof useUpdateTurnoverTimeStagnationMutation>;
export type UpdateTurnoverTimeStagnationMutationResult = Apollo.MutationResult<UpdateTurnoverTimeStagnationMutation>;
export type UpdateTurnoverTimeStagnationMutationOptions = Apollo.BaseMutationOptions<UpdateTurnoverTimeStagnationMutation, UpdateTurnoverTimeStagnationMutationVariables>;
export const CopyCarriageGroupDocument = /*#__PURE__*/ gql`
    mutation copyCarriageGroup($id: Float!) {
  carriageGroups {
    copy(id: $id)
  }
}
    `;
export type CopyCarriageGroupMutationFn = Apollo.MutationFunction<CopyCarriageGroupMutation, CopyCarriageGroupMutationVariables>;

/**
 * __useCopyCarriageGroupMutation__
 *
 * To run a mutation, you first call `useCopyCarriageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCarriageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCarriageGroupMutation, { data, loading, error }] = useCopyCarriageGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCopyCarriageGroupMutation(baseOptions?: Apollo.MutationHookOptions<CopyCarriageGroupMutation, CopyCarriageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyCarriageGroupMutation, CopyCarriageGroupMutationVariables>(CopyCarriageGroupDocument, options);
      }
export type CopyCarriageGroupMutationHookResult = ReturnType<typeof useCopyCarriageGroupMutation>;
export type CopyCarriageGroupMutationResult = Apollo.MutationResult<CopyCarriageGroupMutation>;
export type CopyCarriageGroupMutationOptions = Apollo.BaseMutationOptions<CopyCarriageGroupMutation, CopyCarriageGroupMutationVariables>;
export const DeleteCarriageGroupDocument = /*#__PURE__*/ gql`
    mutation deleteCarriageGroup($id: Float!) {
  carriageGroups {
    deleteCarriageGroup(id: $id)
  }
}
    `;
export type DeleteCarriageGroupMutationFn = Apollo.MutationFunction<DeleteCarriageGroupMutation, DeleteCarriageGroupMutationVariables>;

/**
 * __useDeleteCarriageGroupMutation__
 *
 * To run a mutation, you first call `useDeleteCarriageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarriageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarriageGroupMutation, { data, loading, error }] = useDeleteCarriageGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCarriageGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarriageGroupMutation, DeleteCarriageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCarriageGroupMutation, DeleteCarriageGroupMutationVariables>(DeleteCarriageGroupDocument, options);
      }
export type DeleteCarriageGroupMutationHookResult = ReturnType<typeof useDeleteCarriageGroupMutation>;
export type DeleteCarriageGroupMutationResult = Apollo.MutationResult<DeleteCarriageGroupMutation>;
export type DeleteCarriageGroupMutationOptions = Apollo.BaseMutationOptions<DeleteCarriageGroupMutation, DeleteCarriageGroupMutationVariables>;
export const CarriageGroupListDocument = /*#__PURE__*/ gql`
    query carriageGroupList($paginate: PaginatorArgsDto, $orderBy: [CarriageGroupQueryResolver_CarriageGroupList_SortingInputType!], $where: CarriageGroupQueryResolver_CarriageGroupList_FilterInputType, $search: String!) {
  carriageGroups {
    carriageGroupList(
      paginate: $paginate
      order_by: $orderBy
      where: $where
      search: $search
    ) {
      totalCount
      items {
        ...CarriageGroupViewFragment
        parent {
          name
        }
      }
    }
  }
}
    ${CarriageGroupViewFragmentFragmentDoc}`;

/**
 * __useCarriageGroupListQuery__
 *
 * To run a query within a React component, call `useCarriageGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageGroupListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCarriageGroupListQuery(baseOptions: Apollo.QueryHookOptions<CarriageGroupListQuery, CarriageGroupListQueryVariables> & ({ variables: CarriageGroupListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageGroupListQuery, CarriageGroupListQueryVariables>(CarriageGroupListDocument, options);
      }
export function useCarriageGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageGroupListQuery, CarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageGroupListQuery, CarriageGroupListQueryVariables>(CarriageGroupListDocument, options);
        }
export function useCarriageGroupListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageGroupListQuery, CarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageGroupListQuery, CarriageGroupListQueryVariables>(CarriageGroupListDocument, options);
        }
export type CarriageGroupListQueryHookResult = ReturnType<typeof useCarriageGroupListQuery>;
export type CarriageGroupListLazyQueryHookResult = ReturnType<typeof useCarriageGroupListLazyQuery>;
export type CarriageGroupListSuspenseQueryHookResult = ReturnType<typeof useCarriageGroupListSuspenseQuery>;
export type CarriageGroupListQueryResult = Apollo.QueryResult<CarriageGroupListQuery, CarriageGroupListQueryVariables>;
export const RevokeCarriageGroupDocument = /*#__PURE__*/ gql`
    mutation revokeCarriageGroup($id: Float!) {
  carriageGroups {
    revokeCarriageGroup(id: $id)
  }
}
    `;
export type RevokeCarriageGroupMutationFn = Apollo.MutationFunction<RevokeCarriageGroupMutation, RevokeCarriageGroupMutationVariables>;

/**
 * __useRevokeCarriageGroupMutation__
 *
 * To run a mutation, you first call `useRevokeCarriageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCarriageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeCarriageGroupMutation, { data, loading, error }] = useRevokeCarriageGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeCarriageGroupMutation(baseOptions?: Apollo.MutationHookOptions<RevokeCarriageGroupMutation, RevokeCarriageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeCarriageGroupMutation, RevokeCarriageGroupMutationVariables>(RevokeCarriageGroupDocument, options);
      }
export type RevokeCarriageGroupMutationHookResult = ReturnType<typeof useRevokeCarriageGroupMutation>;
export type RevokeCarriageGroupMutationResult = Apollo.MutationResult<RevokeCarriageGroupMutation>;
export type RevokeCarriageGroupMutationOptions = Apollo.BaseMutationOptions<RevokeCarriageGroupMutation, RevokeCarriageGroupMutationVariables>;
export const ExportCarriageGroupListDocument = /*#__PURE__*/ gql`
    mutation exportCarriageGroupList($where: CarriageGroupMutationResolver_ExportCarriageGroupsList_FilterInputType!) {
  carriageGroups {
    exportCarriageGroupsList(where: $where)
  }
}
    `;
export type ExportCarriageGroupListMutationFn = Apollo.MutationFunction<ExportCarriageGroupListMutation, ExportCarriageGroupListMutationVariables>;

/**
 * __useExportCarriageGroupListMutation__
 *
 * To run a mutation, you first call `useExportCarriageGroupListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCarriageGroupListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCarriageGroupListMutation, { data, loading, error }] = useExportCarriageGroupListMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExportCarriageGroupListMutation(baseOptions?: Apollo.MutationHookOptions<ExportCarriageGroupListMutation, ExportCarriageGroupListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportCarriageGroupListMutation, ExportCarriageGroupListMutationVariables>(ExportCarriageGroupListDocument, options);
      }
export type ExportCarriageGroupListMutationHookResult = ReturnType<typeof useExportCarriageGroupListMutation>;
export type ExportCarriageGroupListMutationResult = Apollo.MutationResult<ExportCarriageGroupListMutation>;
export type ExportCarriageGroupListMutationOptions = Apollo.BaseMutationOptions<ExportCarriageGroupListMutation, ExportCarriageGroupListMutationVariables>;
export const ChangeCapacityDocument = /*#__PURE__*/ gql`
    query changeCapacity($data: CapacityRequestDto!) {
  tpc {
    control_schema {
      capacity(data: $data) {
        compare {
          items {
            ...ControlSchemaCompareTableDataFragment
            branch {
              ...BranchShortFragment
            }
          }
          total {
            ...ControlSchemaCompareTableTotalFragment
          }
        }
        current {
          items {
            ...ControlSchemaCurrentTableDataFragment
            branch {
              ...BranchShortFragment
            }
          }
          total {
            ...ControlSchemaCurrentTableTotalFragment
          }
        }
      }
    }
  }
}
    ${ControlSchemaCompareTableDataFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${ControlSchemaCompareTableTotalFragmentFragmentDoc}
${ControlSchemaCurrentTableDataFragmentFragmentDoc}
${ControlSchemaCurrentTableTotalFragmentFragmentDoc}`;

/**
 * __useChangeCapacityQuery__
 *
 * To run a query within a React component, call `useChangeCapacityQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeCapacityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeCapacityQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChangeCapacityQuery(baseOptions: Apollo.QueryHookOptions<ChangeCapacityQuery, ChangeCapacityQueryVariables> & ({ variables: ChangeCapacityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangeCapacityQuery, ChangeCapacityQueryVariables>(ChangeCapacityDocument, options);
      }
export function useChangeCapacityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangeCapacityQuery, ChangeCapacityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangeCapacityQuery, ChangeCapacityQueryVariables>(ChangeCapacityDocument, options);
        }
export function useChangeCapacitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChangeCapacityQuery, ChangeCapacityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChangeCapacityQuery, ChangeCapacityQueryVariables>(ChangeCapacityDocument, options);
        }
export type ChangeCapacityQueryHookResult = ReturnType<typeof useChangeCapacityQuery>;
export type ChangeCapacityLazyQueryHookResult = ReturnType<typeof useChangeCapacityLazyQuery>;
export type ChangeCapacitySuspenseQueryHookResult = ReturnType<typeof useChangeCapacitySuspenseQuery>;
export type ChangeCapacityQueryResult = Apollo.QueryResult<ChangeCapacityQuery, ChangeCapacityQueryVariables>;
export const ControlAvailabilitySeatsListDocument = /*#__PURE__*/ gql`
    query controlAvailabilitySeatsList($paginate: PaginatorArgsDto!, $orderBy: [ControlAvailabilitySeatsQueryResolver_List_SortingInputType!], $where: ControlAvailabilitySeatsQueryResolver_List_FilterInputType) {
  tpc {
    control_availability_seats {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        totalCount
        items {
          id
          rcasd_id
          route {
            id
            arrival_direction {
              full_name
            }
            departure_direction {
              full_name
            }
          }
          train_id
          display_train_number
          train_number
          departure_time
          passenger_carrier_russian_railway {
            short_name
          }
          csuCarrier {
            name
          }
          trainStationTo {
            entity_id
            full_name
          }
          trainStationFrom {
            entity_id
            full_name
          }
          routeStationTo {
            entity_id
            full_name
          }
          routeStationFrom {
            entity_id
            full_name
          }
          composition_type
          sync_train_status
          is_from_transit
          is_to_transit
          seats {
            count
            date
            max_price
            min_price
          }
        }
      }
    }
  }
}
    `;

/**
 * __useControlAvailabilitySeatsListQuery__
 *
 * To run a query within a React component, call `useControlAvailabilitySeatsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlAvailabilitySeatsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlAvailabilitySeatsListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useControlAvailabilitySeatsListQuery(baseOptions: Apollo.QueryHookOptions<ControlAvailabilitySeatsListQuery, ControlAvailabilitySeatsListQueryVariables> & ({ variables: ControlAvailabilitySeatsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlAvailabilitySeatsListQuery, ControlAvailabilitySeatsListQueryVariables>(ControlAvailabilitySeatsListDocument, options);
      }
export function useControlAvailabilitySeatsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlAvailabilitySeatsListQuery, ControlAvailabilitySeatsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlAvailabilitySeatsListQuery, ControlAvailabilitySeatsListQueryVariables>(ControlAvailabilitySeatsListDocument, options);
        }
export function useControlAvailabilitySeatsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ControlAvailabilitySeatsListQuery, ControlAvailabilitySeatsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlAvailabilitySeatsListQuery, ControlAvailabilitySeatsListQueryVariables>(ControlAvailabilitySeatsListDocument, options);
        }
export type ControlAvailabilitySeatsListQueryHookResult = ReturnType<typeof useControlAvailabilitySeatsListQuery>;
export type ControlAvailabilitySeatsListLazyQueryHookResult = ReturnType<typeof useControlAvailabilitySeatsListLazyQuery>;
export type ControlAvailabilitySeatsListSuspenseQueryHookResult = ReturnType<typeof useControlAvailabilitySeatsListSuspenseQuery>;
export type ControlAvailabilitySeatsListQueryResult = Apollo.QueryResult<ControlAvailabilitySeatsListQuery, ControlAvailabilitySeatsListQueryVariables>;
export const ExportControlAvailabilitySeatsDocument = /*#__PURE__*/ gql`
    mutation exportControlAvailabilitySeats($where: ControlAvailabilitySeatsMutationResolver_ExportToExcel_FilterInputType) {
  tpc {
    control_availability_seats {
      exportToExcel(where: $where)
    }
  }
}
    `;
export type ExportControlAvailabilitySeatsMutationFn = Apollo.MutationFunction<ExportControlAvailabilitySeatsMutation, ExportControlAvailabilitySeatsMutationVariables>;

/**
 * __useExportControlAvailabilitySeatsMutation__
 *
 * To run a mutation, you first call `useExportControlAvailabilitySeatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportControlAvailabilitySeatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportControlAvailabilitySeatsMutation, { data, loading, error }] = useExportControlAvailabilitySeatsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExportControlAvailabilitySeatsMutation(baseOptions?: Apollo.MutationHookOptions<ExportControlAvailabilitySeatsMutation, ExportControlAvailabilitySeatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportControlAvailabilitySeatsMutation, ExportControlAvailabilitySeatsMutationVariables>(ExportControlAvailabilitySeatsDocument, options);
      }
export type ExportControlAvailabilitySeatsMutationHookResult = ReturnType<typeof useExportControlAvailabilitySeatsMutation>;
export type ExportControlAvailabilitySeatsMutationResult = Apollo.MutationResult<ExportControlAvailabilitySeatsMutation>;
export type ExportControlAvailabilitySeatsMutationOptions = Apollo.BaseMutationOptions<ExportControlAvailabilitySeatsMutation, ExportControlAvailabilitySeatsMutationVariables>;
export const SyncJournalDocument = /*#__PURE__*/ gql`
    query SyncJournal($where: SyncQueryResolver_List_FilterInputType, $orderBy: [SyncQueryResolver_List_SortingInputType!]) {
  sync {
    journal(where: $where, order_by: $orderBy) {
      items {
        date
      }
    }
  }
}
    `;

/**
 * __useSyncJournalQuery__
 *
 * To run a query within a React component, call `useSyncJournalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncJournalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncJournalQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSyncJournalQuery(baseOptions?: Apollo.QueryHookOptions<SyncJournalQuery, SyncJournalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncJournalQuery, SyncJournalQueryVariables>(SyncJournalDocument, options);
      }
export function useSyncJournalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncJournalQuery, SyncJournalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncJournalQuery, SyncJournalQueryVariables>(SyncJournalDocument, options);
        }
export function useSyncJournalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SyncJournalQuery, SyncJournalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SyncJournalQuery, SyncJournalQueryVariables>(SyncJournalDocument, options);
        }
export type SyncJournalQueryHookResult = ReturnType<typeof useSyncJournalQuery>;
export type SyncJournalLazyQueryHookResult = ReturnType<typeof useSyncJournalLazyQuery>;
export type SyncJournalSuspenseQueryHookResult = ReturnType<typeof useSyncJournalSuspenseQuery>;
export type SyncJournalQueryResult = Apollo.QueryResult<SyncJournalQuery, SyncJournalQueryVariables>;
export const SyncSeatsAvailabilityDocument = /*#__PURE__*/ gql`
    mutation syncSeatsAvailability($data: SyncSeatsAvailabilityDto!) {
  sync {
    runSyncSeatsAvailability(data: $data)
  }
}
    `;
export type SyncSeatsAvailabilityMutationFn = Apollo.MutationFunction<SyncSeatsAvailabilityMutation, SyncSeatsAvailabilityMutationVariables>;

/**
 * __useSyncSeatsAvailabilityMutation__
 *
 * To run a mutation, you first call `useSyncSeatsAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncSeatsAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncSeatsAvailabilityMutation, { data, loading, error }] = useSyncSeatsAvailabilityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSyncSeatsAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<SyncSeatsAvailabilityMutation, SyncSeatsAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncSeatsAvailabilityMutation, SyncSeatsAvailabilityMutationVariables>(SyncSeatsAvailabilityDocument, options);
      }
export type SyncSeatsAvailabilityMutationHookResult = ReturnType<typeof useSyncSeatsAvailabilityMutation>;
export type SyncSeatsAvailabilityMutationResult = Apollo.MutationResult<SyncSeatsAvailabilityMutation>;
export type SyncSeatsAvailabilityMutationOptions = Apollo.BaseMutationOptions<SyncSeatsAvailabilityMutation, SyncSeatsAvailabilityMutationVariables>;
export const ControlSchemaFilterBranchListDocument = /*#__PURE__*/ gql`
    query controlSchemaFilterBranchList($paginate: PaginatorArgsDto, $orderBy: [BranchQueryResolver_List_SortingInputType!], $where: BranchQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    branch {
      list(
        paginate: $paginate
        order_by: $orderBy
        where: $where
        data: {range: $range}
      ) {
        items {
          entity_id
          short_name
        }
        totalCount
      }
    }
  }
}
    `;

/**
 * __useControlSchemaFilterBranchListQuery__
 *
 * To run a query within a React component, call `useControlSchemaFilterBranchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlSchemaFilterBranchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlSchemaFilterBranchListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useControlSchemaFilterBranchListQuery(baseOptions: Apollo.QueryHookOptions<ControlSchemaFilterBranchListQuery, ControlSchemaFilterBranchListQueryVariables> & ({ variables: ControlSchemaFilterBranchListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlSchemaFilterBranchListQuery, ControlSchemaFilterBranchListQueryVariables>(ControlSchemaFilterBranchListDocument, options);
      }
export function useControlSchemaFilterBranchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlSchemaFilterBranchListQuery, ControlSchemaFilterBranchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlSchemaFilterBranchListQuery, ControlSchemaFilterBranchListQueryVariables>(ControlSchemaFilterBranchListDocument, options);
        }
export function useControlSchemaFilterBranchListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ControlSchemaFilterBranchListQuery, ControlSchemaFilterBranchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlSchemaFilterBranchListQuery, ControlSchemaFilterBranchListQueryVariables>(ControlSchemaFilterBranchListDocument, options);
        }
export type ControlSchemaFilterBranchListQueryHookResult = ReturnType<typeof useControlSchemaFilterBranchListQuery>;
export type ControlSchemaFilterBranchListLazyQueryHookResult = ReturnType<typeof useControlSchemaFilterBranchListLazyQuery>;
export type ControlSchemaFilterBranchListSuspenseQueryHookResult = ReturnType<typeof useControlSchemaFilterBranchListSuspenseQuery>;
export type ControlSchemaFilterBranchListQueryResult = Apollo.QueryResult<ControlSchemaFilterBranchListQuery, ControlSchemaFilterBranchListQueryVariables>;
export const ControlSchemaFilterPassengerCarrierListDocument = /*#__PURE__*/ gql`
    query controlSchemaFilterPassengerCarrierList($paginate: PaginatorArgsDto, $orderBy: [PassengerCarrierQueryResolver_List_SortingInputType!], $where: PassengerCarrierQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    passengerCarrier {
      list(paginate: $paginate, where: $where, order_by: $orderBy, range: $range) {
        items {
          entity_id
          short_name
        }
      }
    }
  }
}
    `;

/**
 * __useControlSchemaFilterPassengerCarrierListQuery__
 *
 * To run a query within a React component, call `useControlSchemaFilterPassengerCarrierListQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlSchemaFilterPassengerCarrierListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlSchemaFilterPassengerCarrierListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useControlSchemaFilterPassengerCarrierListQuery(baseOptions: Apollo.QueryHookOptions<ControlSchemaFilterPassengerCarrierListQuery, ControlSchemaFilterPassengerCarrierListQueryVariables> & ({ variables: ControlSchemaFilterPassengerCarrierListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlSchemaFilterPassengerCarrierListQuery, ControlSchemaFilterPassengerCarrierListQueryVariables>(ControlSchemaFilterPassengerCarrierListDocument, options);
      }
export function useControlSchemaFilterPassengerCarrierListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlSchemaFilterPassengerCarrierListQuery, ControlSchemaFilterPassengerCarrierListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlSchemaFilterPassengerCarrierListQuery, ControlSchemaFilterPassengerCarrierListQueryVariables>(ControlSchemaFilterPassengerCarrierListDocument, options);
        }
export function useControlSchemaFilterPassengerCarrierListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ControlSchemaFilterPassengerCarrierListQuery, ControlSchemaFilterPassengerCarrierListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlSchemaFilterPassengerCarrierListQuery, ControlSchemaFilterPassengerCarrierListQueryVariables>(ControlSchemaFilterPassengerCarrierListDocument, options);
        }
export type ControlSchemaFilterPassengerCarrierListQueryHookResult = ReturnType<typeof useControlSchemaFilterPassengerCarrierListQuery>;
export type ControlSchemaFilterPassengerCarrierListLazyQueryHookResult = ReturnType<typeof useControlSchemaFilterPassengerCarrierListLazyQuery>;
export type ControlSchemaFilterPassengerCarrierListSuspenseQueryHookResult = ReturnType<typeof useControlSchemaFilterPassengerCarrierListSuspenseQuery>;
export type ControlSchemaFilterPassengerCarrierListQueryResult = Apollo.QueryResult<ControlSchemaFilterPassengerCarrierListQuery, ControlSchemaFilterPassengerCarrierListQueryVariables>;
export const ControlSchemaFilterRailwayAdministrationListDocument = /*#__PURE__*/ gql`
    query controlSchemaFilterRailwayAdministrationList($paginate: PaginatorArgsDto, $orderBy: [RailwayAdministrationQueryResolver_List_SortingInputType!], $where: RailwayAdministrationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    railwayAdministration {
      list(range: $range, paginate: $paginate, order_by: $orderBy, where: $where) {
        items {
          entity_id
          short_name
          name
        }
      }
    }
  }
}
    `;

/**
 * __useControlSchemaFilterRailwayAdministrationListQuery__
 *
 * To run a query within a React component, call `useControlSchemaFilterRailwayAdministrationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlSchemaFilterRailwayAdministrationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlSchemaFilterRailwayAdministrationListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useControlSchemaFilterRailwayAdministrationListQuery(baseOptions: Apollo.QueryHookOptions<ControlSchemaFilterRailwayAdministrationListQuery, ControlSchemaFilterRailwayAdministrationListQueryVariables> & ({ variables: ControlSchemaFilterRailwayAdministrationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlSchemaFilterRailwayAdministrationListQuery, ControlSchemaFilterRailwayAdministrationListQueryVariables>(ControlSchemaFilterRailwayAdministrationListDocument, options);
      }
export function useControlSchemaFilterRailwayAdministrationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlSchemaFilterRailwayAdministrationListQuery, ControlSchemaFilterRailwayAdministrationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlSchemaFilterRailwayAdministrationListQuery, ControlSchemaFilterRailwayAdministrationListQueryVariables>(ControlSchemaFilterRailwayAdministrationListDocument, options);
        }
export function useControlSchemaFilterRailwayAdministrationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ControlSchemaFilterRailwayAdministrationListQuery, ControlSchemaFilterRailwayAdministrationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlSchemaFilterRailwayAdministrationListQuery, ControlSchemaFilterRailwayAdministrationListQueryVariables>(ControlSchemaFilterRailwayAdministrationListDocument, options);
        }
export type ControlSchemaFilterRailwayAdministrationListQueryHookResult = ReturnType<typeof useControlSchemaFilterRailwayAdministrationListQuery>;
export type ControlSchemaFilterRailwayAdministrationListLazyQueryHookResult = ReturnType<typeof useControlSchemaFilterRailwayAdministrationListLazyQuery>;
export type ControlSchemaFilterRailwayAdministrationListSuspenseQueryHookResult = ReturnType<typeof useControlSchemaFilterRailwayAdministrationListSuspenseQuery>;
export type ControlSchemaFilterRailwayAdministrationListQueryResult = Apollo.QueryResult<ControlSchemaFilterRailwayAdministrationListQuery, ControlSchemaFilterRailwayAdministrationListQueryVariables>;
export const ExportControlSchemaDocument = /*#__PURE__*/ gql`
    mutation exportControlSchema($date: String!, $where: ControlSchemaMutationResolver_ExportToExcel_FilterInputType) {
  tpc {
    control_schema {
      exportToExcel(date: $date, where: $where)
    }
  }
}
    `;
export type ExportControlSchemaMutationFn = Apollo.MutationFunction<ExportControlSchemaMutation, ExportControlSchemaMutationVariables>;

/**
 * __useExportControlSchemaMutation__
 *
 * To run a mutation, you first call `useExportControlSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportControlSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportControlSchemaMutation, { data, loading, error }] = useExportControlSchemaMutation({
 *   variables: {
 *      date: // value for 'date'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExportControlSchemaMutation(baseOptions?: Apollo.MutationHookOptions<ExportControlSchemaMutation, ExportControlSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportControlSchemaMutation, ExportControlSchemaMutationVariables>(ExportControlSchemaDocument, options);
      }
export type ExportControlSchemaMutationHookResult = ReturnType<typeof useExportControlSchemaMutation>;
export type ExportControlSchemaMutationResult = Apollo.MutationResult<ExportControlSchemaMutation>;
export type ExportControlSchemaMutationOptions = Apollo.BaseMutationOptions<ExportControlSchemaMutation, ExportControlSchemaMutationVariables>;
export const ExportControlSchemaByBranchDocument = /*#__PURE__*/ gql`
    mutation exportControlSchemaByBranch($data: ExportControlSchemaByBranchDto!) {
  tpc {
    control_schema {
      exportToExcelByBranch(data: $data)
    }
  }
}
    `;
export type ExportControlSchemaByBranchMutationFn = Apollo.MutationFunction<ExportControlSchemaByBranchMutation, ExportControlSchemaByBranchMutationVariables>;

/**
 * __useExportControlSchemaByBranchMutation__
 *
 * To run a mutation, you first call `useExportControlSchemaByBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportControlSchemaByBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportControlSchemaByBranchMutation, { data, loading, error }] = useExportControlSchemaByBranchMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExportControlSchemaByBranchMutation(baseOptions?: Apollo.MutationHookOptions<ExportControlSchemaByBranchMutation, ExportControlSchemaByBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportControlSchemaByBranchMutation, ExportControlSchemaByBranchMutationVariables>(ExportControlSchemaByBranchDocument, options);
      }
export type ExportControlSchemaByBranchMutationHookResult = ReturnType<typeof useExportControlSchemaByBranchMutation>;
export type ExportControlSchemaByBranchMutationResult = Apollo.MutationResult<ExportControlSchemaByBranchMutation>;
export type ExportControlSchemaByBranchMutationOptions = Apollo.BaseMutationOptions<ExportControlSchemaByBranchMutation, ExportControlSchemaByBranchMutationVariables>;
export const IndicatorsByBranchListDocument = /*#__PURE__*/ gql`
    query indicatorsByBranchList($key: TypeIndicators!) {
  tpc {
    control_schema {
      indicators_by_branch(key: $key) {
        name
        branches {
          tolerance
          plan
          percentage
          branch {
            entity_id
            short_name
          }
          actual
        }
      }
    }
  }
}
    `;

/**
 * __useIndicatorsByBranchListQuery__
 *
 * To run a query within a React component, call `useIndicatorsByBranchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorsByBranchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorsByBranchListQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useIndicatorsByBranchListQuery(baseOptions: Apollo.QueryHookOptions<IndicatorsByBranchListQuery, IndicatorsByBranchListQueryVariables> & ({ variables: IndicatorsByBranchListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorsByBranchListQuery, IndicatorsByBranchListQueryVariables>(IndicatorsByBranchListDocument, options);
      }
export function useIndicatorsByBranchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorsByBranchListQuery, IndicatorsByBranchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorsByBranchListQuery, IndicatorsByBranchListQueryVariables>(IndicatorsByBranchListDocument, options);
        }
export function useIndicatorsByBranchListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndicatorsByBranchListQuery, IndicatorsByBranchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndicatorsByBranchListQuery, IndicatorsByBranchListQueryVariables>(IndicatorsByBranchListDocument, options);
        }
export type IndicatorsByBranchListQueryHookResult = ReturnType<typeof useIndicatorsByBranchListQuery>;
export type IndicatorsByBranchListLazyQueryHookResult = ReturnType<typeof useIndicatorsByBranchListLazyQuery>;
export type IndicatorsByBranchListSuspenseQueryHookResult = ReturnType<typeof useIndicatorsByBranchListSuspenseQuery>;
export type IndicatorsByBranchListQueryResult = Apollo.QueryResult<IndicatorsByBranchListQuery, IndicatorsByBranchListQueryVariables>;
export const SchemaControlByBranchDocument = /*#__PURE__*/ gql`
    query schemaControlByBranch($paginate: PaginatorArgsDto!, $where: ControlSchemaQueryResolver_SchemaControlByBranch_FilterInputType, $orderBy: [ControlSchemaQueryResolver_SchemaControlByBranch_SortingInputType!], $compareDate: String) {
  tpc {
    control_schema {
      schemaControlByBranch(
        paginate: $paginate
        where: $where
        order_by: $orderBy
        compareDate: $compareDate
      ) {
        branch {
          ...BranchShortFragment
        }
        carriages_fact
        carriages_percentage
        carriages_plan
        carriages_tolerance
        carriages_turnover_fact
        carriages_turnover_percentage
        carriages_turnover_plan
        carriages_turnover_tolerance
        indicators_fact
        indicators_percentage
        indicators_plan
        indicators_tolerance
        seats_turnover_fact
        seats_turnover_percentage
        seats_turnover_plan
        seats_turnover_tolerance
        trains_fact
        trains_percentage
        trains_plan
        trains_tolerance
        trains_turnover_fact
        trains_turnover_percentage
        trains_turnover_plan
        trains_turnover_tolerance
      }
    }
  }
}
    ${BranchShortFragmentFragmentDoc}`;

/**
 * __useSchemaControlByBranchQuery__
 *
 * To run a query within a React component, call `useSchemaControlByBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaControlByBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaControlByBranchQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      compareDate: // value for 'compareDate'
 *   },
 * });
 */
export function useSchemaControlByBranchQuery(baseOptions: Apollo.QueryHookOptions<SchemaControlByBranchQuery, SchemaControlByBranchQueryVariables> & ({ variables: SchemaControlByBranchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaControlByBranchQuery, SchemaControlByBranchQueryVariables>(SchemaControlByBranchDocument, options);
      }
export function useSchemaControlByBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaControlByBranchQuery, SchemaControlByBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaControlByBranchQuery, SchemaControlByBranchQueryVariables>(SchemaControlByBranchDocument, options);
        }
export function useSchemaControlByBranchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchemaControlByBranchQuery, SchemaControlByBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemaControlByBranchQuery, SchemaControlByBranchQueryVariables>(SchemaControlByBranchDocument, options);
        }
export type SchemaControlByBranchQueryHookResult = ReturnType<typeof useSchemaControlByBranchQuery>;
export type SchemaControlByBranchLazyQueryHookResult = ReturnType<typeof useSchemaControlByBranchLazyQuery>;
export type SchemaControlByBranchSuspenseQueryHookResult = ReturnType<typeof useSchemaControlByBranchSuspenseQuery>;
export type SchemaControlByBranchQueryResult = Apollo.QueryResult<SchemaControlByBranchQuery, SchemaControlByBranchQueryVariables>;
export const ControlSchemaListDocument = /*#__PURE__*/ gql`
    query controlSchemaList($paginate: PaginatorArgsDto!, $where: ControlSchemaQueryResolver_SchemaControlByTrainsCalculated_FilterInputType, $compareDate: String) {
  tpc {
    control_schema {
      schemaControlByTrainsCalculated(
        paginate: $paginate
        where: $where
        compareDate: $compareDate
      ) {
        totalCount
        items {
          branch {
            entity_id
            short_name
            name
          }
          passenger_carrier_russian_railway {
            code
            entity_id
            name
            short_name
          }
          railway_administration {
            code
            entity_id
            name
            short_name
          }
          station_from {
            entity_id
            express_code
            full_name
          }
          station_to {
            entity_id
            express_code
            full_name
          }
          dates {
            capacity
            date
            diff
            quantity
          }
          main_group_data {
            branch {
              entity_id
              name
              short_name
            }
            passenger_carrier_russian_railway {
              code
              entity_id
              name
              short_name
            }
            railway_administration {
              code
              entity_id
              name
              short_name
            }
            dates {
              capacity
              date
              diff
              quantity
            }
            groups {
              branch {
                entity_id
                name
                short_name
              }
              passenger_carrier_russian_railway {
                code
                entity_id
                name
                short_name
              }
              railway_administration {
                code
                entity_id
                name
                short_name
              }
              station_from {
                entity_id
                express_code
                full_name
              }
              station_to {
                entity_id
                express_code
                full_name
              }
              dates {
                capacity
                date
                diff
                quantity
              }
              carriages {
                dates {
                  capacity
                  date
                  diff
                  quantity
                }
                trains_quantity_fact
                trains_quantity_plan
                trains_turnover_fact
                trains_turnover_plan
                seats_quantity_fact
                seats_quantity_plan
                seats_turnover_fact
                seats_turnover_plan
                carriage_quantity
                carriages_quantity_fact
                carriages_quantity_plan
                carriages_turnover_fact
                carriages_turnover_plan
                carriage_type
                indicators_fact
                indicators_plan
              }
              trains_quantity_fact
              trains_quantity_plan
              trains_turnover_fact
              trains_turnover_plan
              seats_quantity_fact
              seats_quantity_plan
              seats_turnover_fact
              seats_turnover_plan
              carriage_quantity
              carriages_quantity_fact
              carriages_quantity_plan
              carriages_turnover_fact
              carriages_turnover_plan
              indicators_fact
              indicators_plan
              carriage_group_id
              schema_number
            }
            trains_quantity_fact
            trains_quantity_plan
            trains_turnover_fact
            trains_turnover_plan
            seats_quantity_fact
            seats_quantity_plan
            seats_turnover_fact
            seats_turnover_plan
            carriage_quantity
            carriages_quantity_fact
            carriages_quantity_plan
            carriages_turnover_fact
            carriages_turnover_plan
            indicators_fact
            indicators_plan
          }
          in_turnover_with_data {
            branch {
              name
              short_name
              entity_id
            }
            passenger_carrier_russian_railway {
              code
              entity_id
              name
              short_name
            }
            railway_administration {
              entity_id
              name
              short_name
              code
            }
            station_from {
              entity_id
              express_code
              full_name
            }
            station_to {
              entity_id
              express_code
              full_name
            }
            dates {
              capacity
              date
              diff
              quantity
            }
            display_train_number
            trains_quantity_fact
            trains_quantity_plan
            trains_turnover_fact
            trains_turnover_plan
            seats_quantity_fact
            seats_quantity_plan
            seats_turnover_fact
            seats_turnover_plan
            carriage_quantity
            carriages_quantity_fact
            carriages_quantity_plan
            carriages_turnover_fact
            carriages_turnover_plan
            indicators_fact
            indicators_plan
          }
          not_asu_ms_data {
            branch {
              entity_id
              name
              short_name
            }
            passenger_carrier_russian_railway {
              code
              entity_id
              name
              short_name
            }
            railway_administration {
              code
              entity_id
              name
              short_name
            }
            dates {
              capacity
              date
              diff
              quantity
            }
            groups {
              branch {
                entity_id
                name
                short_name
              }
              carriage_quantity
              carriages {
                carriage_quantity
                carriage_type
                carriages_quantity_fact
                carriages_quantity_plan
                carriages_turnover_fact
                carriages_turnover_plan
                dates {
                  capacity
                  date
                  diff
                  quantity
                }
                indicators_fact
                indicators_plan
                seats_quantity_fact
                seats_quantity_plan
                seats_turnover_fact
                seats_turnover_plan
                trains_quantity_fact
                trains_quantity_plan
                trains_turnover_fact
                trains_turnover_plan
              }
              carriages_quantity_fact
              carriages_quantity_plan
              carriages_turnover_fact
              carriages_turnover_plan
              dates {
                capacity
                date
                diff
                quantity
              }
              indicators_fact
              indicators_plan
              passenger_carrier_russian_railway {
                code
                entity_id
                name
                short_name
              }
              railway_administration {
                code
                entity_id
                name
                short_name
              }
              seats_quantity_fact
              seats_quantity_plan
              seats_turnover_fact
              seats_turnover_plan
              station_from {
                entity_id
                express_code
                full_name
              }
              station_to {
                entity_id
                express_code
                full_name
              }
              trains_quantity_fact
              trains_quantity_plan
              trains_turnover_fact
              trains_turnover_plan
            }
            trains_quantity_fact
            trains_quantity_plan
            trains_turnover_fact
            trains_turnover_plan
            seats_quantity_fact
            seats_quantity_plan
            seats_turnover_fact
            seats_turnover_plan
            carriage_quantity
            carriages_quantity_fact
            carriages_quantity_plan
            carriages_turnover_fact
            carriages_turnover_plan
            indicators_fact
            indicators_plan
          }
          trailed_group_data {
            branch {
              entity_id
              name
              short_name
            }
            passenger_carrier_russian_railway {
              code
              entity_id
              short_name
            }
            railway_administration {
              code
              entity_id
              name
              short_name
            }
            dates {
              capacity
              date
              diff
              quantity
            }
            groups {
              branch {
                entity_id
                name
                short_name
              }
              passenger_carrier_russian_railway {
                code
                entity_id
                name
                short_name
              }
              railway_administration {
                code
                entity_id
                name
                short_name
              }
              station_from {
                entity_id
                express_code
                full_name
              }
              station_to {
                entity_id
                express_code
                full_name
              }
              carriages {
                dates {
                  capacity
                  date
                  diff
                  quantity
                }
                trains_quantity_fact
                trains_quantity_plan
                trains_turnover_fact
                trains_turnover_plan
                seats_quantity_fact
                seats_quantity_plan
                seats_turnover_fact
                seats_turnover_plan
                carriage_quantity
                carriage_type
                carriages_quantity_fact
                carriages_quantity_plan
                carriages_turnover_fact
                carriages_turnover_plan
                indicators_fact
                indicators_plan
              }
              dates {
                capacity
                date
                diff
                quantity
              }
              trains_quantity_fact
              trains_quantity_plan
              trains_turnover_fact
              trains_turnover_plan
              seats_quantity_fact
              seats_quantity_plan
              seats_turnover_fact
              seats_turnover_plan
              carriage_quantity
              carriages_quantity_fact
              carriages_quantity_plan
              carriages_turnover_fact
              carriages_turnover_plan
              indicators_fact
              indicators_plan
              carriage_group_id
              schema_number
            }
            trains_quantity_fact
            trains_quantity_plan
            trains_turnover_fact
            trains_turnover_plan
            seats_quantity_fact
            seats_quantity_plan
            seats_turnover_fact
            seats_turnover_plan
            carriage_quantity
            carriages_quantity_fact
            carriages_quantity_plan
            carriages_turnover_fact
            carriages_turnover_plan
            indicators_fact
            indicators_plan
          }
          train_id
          train_number
          train_quantity
          trains_quantity_fact
          trains_quantity_plan
          trains_turnover_fact
          trains_turnover_plan
          seats_quantity_fact
          seats_quantity_plan
          seats_turnover_fact
          seats_turnover_plan
          carriage_quantity
          carriages_quantity_fact
          carriages_quantity_plan
          carriages_turnover_fact
          carriages_turnover_plan
          indicators_fact
          indicators_plan
          version
        }
      }
    }
  }
}
    `;

/**
 * __useControlSchemaListQuery__
 *
 * To run a query within a React component, call `useControlSchemaListQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlSchemaListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlSchemaListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      compareDate: // value for 'compareDate'
 *   },
 * });
 */
export function useControlSchemaListQuery(baseOptions: Apollo.QueryHookOptions<ControlSchemaListQuery, ControlSchemaListQueryVariables> & ({ variables: ControlSchemaListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlSchemaListQuery, ControlSchemaListQueryVariables>(ControlSchemaListDocument, options);
      }
export function useControlSchemaListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlSchemaListQuery, ControlSchemaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlSchemaListQuery, ControlSchemaListQueryVariables>(ControlSchemaListDocument, options);
        }
export function useControlSchemaListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ControlSchemaListQuery, ControlSchemaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlSchemaListQuery, ControlSchemaListQueryVariables>(ControlSchemaListDocument, options);
        }
export type ControlSchemaListQueryHookResult = ReturnType<typeof useControlSchemaListQuery>;
export type ControlSchemaListLazyQueryHookResult = ReturnType<typeof useControlSchemaListLazyQuery>;
export type ControlSchemaListSuspenseQueryHookResult = ReturnType<typeof useControlSchemaListSuspenseQuery>;
export type ControlSchemaListQueryResult = Apollo.QueryResult<ControlSchemaListQuery, ControlSchemaListQueryVariables>;
export const ControlSchemaByTrainsPreSavedDocument = /*#__PURE__*/ gql`
    query controlSchemaByTrainsPreSaved($paginate: PaginatorArgsDto!, $where: ControlSchemaQueryResolver_ByTrainsPreSaved_FilterInputType, $compareDate: String) {
  tpc {
    control_schema {
      byTrainsPreSaved(paginate: $paginate, where: $where, compareDate: $compareDate) {
        totalCount
        items {
          branch {
            ...BranchShortFragment
          }
          station_from {
            ...StationShortFragment
          }
          station_to {
            ...StationShortFragment
          }
          dates {
            capacity
            date
            diff
            quantity
          }
          train {
            id
            version
            railway_administration {
              short_name
            }
            passenger_carrier {
              short_name
            }
          }
          train_number
          train_quantity
          trains_quantity_fact
          trains_quantity_plan
          trains_turnover_fact
          trains_turnover_plan
          seats_quantity_fact
          seats_quantity_plan
          seats_turnover_fact
          seats_turnover_plan
          carriage_quantity
          carriages_quantity_fact
          carriages_quantity_plan
          carriages_turnover_fact
          carriages_turnover_plan
          indicators_fact
          indicators_plan
        }
      }
    }
  }
}
    ${BranchShortFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;

/**
 * __useControlSchemaByTrainsPreSavedQuery__
 *
 * To run a query within a React component, call `useControlSchemaByTrainsPreSavedQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlSchemaByTrainsPreSavedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlSchemaByTrainsPreSavedQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      compareDate: // value for 'compareDate'
 *   },
 * });
 */
export function useControlSchemaByTrainsPreSavedQuery(baseOptions: Apollo.QueryHookOptions<ControlSchemaByTrainsPreSavedQuery, ControlSchemaByTrainsPreSavedQueryVariables> & ({ variables: ControlSchemaByTrainsPreSavedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlSchemaByTrainsPreSavedQuery, ControlSchemaByTrainsPreSavedQueryVariables>(ControlSchemaByTrainsPreSavedDocument, options);
      }
export function useControlSchemaByTrainsPreSavedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlSchemaByTrainsPreSavedQuery, ControlSchemaByTrainsPreSavedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlSchemaByTrainsPreSavedQuery, ControlSchemaByTrainsPreSavedQueryVariables>(ControlSchemaByTrainsPreSavedDocument, options);
        }
export function useControlSchemaByTrainsPreSavedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ControlSchemaByTrainsPreSavedQuery, ControlSchemaByTrainsPreSavedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlSchemaByTrainsPreSavedQuery, ControlSchemaByTrainsPreSavedQueryVariables>(ControlSchemaByTrainsPreSavedDocument, options);
        }
export type ControlSchemaByTrainsPreSavedQueryHookResult = ReturnType<typeof useControlSchemaByTrainsPreSavedQuery>;
export type ControlSchemaByTrainsPreSavedLazyQueryHookResult = ReturnType<typeof useControlSchemaByTrainsPreSavedLazyQuery>;
export type ControlSchemaByTrainsPreSavedSuspenseQueryHookResult = ReturnType<typeof useControlSchemaByTrainsPreSavedSuspenseQuery>;
export type ControlSchemaByTrainsPreSavedQueryResult = Apollo.QueryResult<ControlSchemaByTrainsPreSavedQuery, ControlSchemaByTrainsPreSavedQueryVariables>;
export const UpdateTrainNmrvagDataDocument = /*#__PURE__*/ gql`
    mutation updateTrainNmrvagData($payload: UpdateSchemaControlTrainNmrvagDataDto!) {
  tpc {
    control_schema {
      updateTrain(payload: $payload)
    }
  }
}
    `;
export type UpdateTrainNmrvagDataMutationFn = Apollo.MutationFunction<UpdateTrainNmrvagDataMutation, UpdateTrainNmrvagDataMutationVariables>;

/**
 * __useUpdateTrainNmrvagDataMutation__
 *
 * To run a mutation, you first call `useUpdateTrainNmrvagDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainNmrvagDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainNmrvagDataMutation, { data, loading, error }] = useUpdateTrainNmrvagDataMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateTrainNmrvagDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainNmrvagDataMutation, UpdateTrainNmrvagDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainNmrvagDataMutation, UpdateTrainNmrvagDataMutationVariables>(UpdateTrainNmrvagDataDocument, options);
      }
export type UpdateTrainNmrvagDataMutationHookResult = ReturnType<typeof useUpdateTrainNmrvagDataMutation>;
export type UpdateTrainNmrvagDataMutationResult = Apollo.MutationResult<UpdateTrainNmrvagDataMutation>;
export type UpdateTrainNmrvagDataMutationOptions = Apollo.BaseMutationOptions<UpdateTrainNmrvagDataMutation, UpdateTrainNmrvagDataMutationVariables>;
export const SchemaControlTrainNmrvagListDocument = /*#__PURE__*/ gql`
    query schemaControlTrainNmrvagList($date: String!, $where: ControlSchemaQueryResolver_SchemaControlTrainNmrvagList_FilterInputType, $paginate: PaginatorArgsDto, $compareDate: String) {
  tpc {
    control_schema {
      schemaControlTrainNmrvagList(
        date: $date
        where: $where
        paginate: $paginate
        compareDate: $compareDate
      ) {
        totalCount
        items {
          id
          date_sync
          train_number
          schema_carriage_quantity
          is_s3960_loaded
          dates {
            ...ControlSchemaTrainDateNmrvagFragment
          }
          station_from {
            ...StationShortFragment
          }
          station_to {
            ...StationShortFragment
          }
          carriage_groups {
            id
            schema_carriage_quantity
            branch {
              ...BranchShortFragment
            }
            passenger_carrier_russian_railway {
              ...PassengerCarrierShortFragment
            }
            station_from {
              ...StationShortFragment
            }
            station_to {
              ...StationShortFragment
            }
            dates {
              ...ControlSchemaTrainDateNmrvagFragment
            }
            carriages {
              carriage_type
              dates {
                carriage_quantity
                date
                diff
              }
            }
          }
        }
      }
    }
  }
}
    ${ControlSchemaTrainDateNmrvagFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}`;

/**
 * __useSchemaControlTrainNmrvagListQuery__
 *
 * To run a query within a React component, call `useSchemaControlTrainNmrvagListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaControlTrainNmrvagListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaControlTrainNmrvagListQuery({
 *   variables: {
 *      date: // value for 'date'
 *      where: // value for 'where'
 *      paginate: // value for 'paginate'
 *      compareDate: // value for 'compareDate'
 *   },
 * });
 */
export function useSchemaControlTrainNmrvagListQuery(baseOptions: Apollo.QueryHookOptions<SchemaControlTrainNmrvagListQuery, SchemaControlTrainNmrvagListQueryVariables> & ({ variables: SchemaControlTrainNmrvagListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaControlTrainNmrvagListQuery, SchemaControlTrainNmrvagListQueryVariables>(SchemaControlTrainNmrvagListDocument, options);
      }
export function useSchemaControlTrainNmrvagListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaControlTrainNmrvagListQuery, SchemaControlTrainNmrvagListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaControlTrainNmrvagListQuery, SchemaControlTrainNmrvagListQueryVariables>(SchemaControlTrainNmrvagListDocument, options);
        }
export function useSchemaControlTrainNmrvagListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchemaControlTrainNmrvagListQuery, SchemaControlTrainNmrvagListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemaControlTrainNmrvagListQuery, SchemaControlTrainNmrvagListQueryVariables>(SchemaControlTrainNmrvagListDocument, options);
        }
export type SchemaControlTrainNmrvagListQueryHookResult = ReturnType<typeof useSchemaControlTrainNmrvagListQuery>;
export type SchemaControlTrainNmrvagListLazyQueryHookResult = ReturnType<typeof useSchemaControlTrainNmrvagListLazyQuery>;
export type SchemaControlTrainNmrvagListSuspenseQueryHookResult = ReturnType<typeof useSchemaControlTrainNmrvagListSuspenseQuery>;
export type SchemaControlTrainNmrvagListQueryResult = Apollo.QueryResult<SchemaControlTrainNmrvagListQuery, SchemaControlTrainNmrvagListQueryVariables>;
export const TrainsListWithSchemaCarriagesDocument = /*#__PURE__*/ gql`
    query trainsListWithSchemaCarriages($paginate: PaginatorArgsDto!, $where: ControlSchemaQueryResolver_TrainsListWithSchemaCarriages_FilterInputType) {
  tpc {
    control_schema {
      trainsListWithSchemaCarriages(paginate: $paginate, where: $where) {
        totalCount
        items {
          id
          train_number
          branch {
            ...BranchShortFragment
          }
          schema_carriage_quantity
          station_from {
            ...StationShortFragment
          }
          station_to {
            ...StationShortFragment
          }
        }
      }
    }
  }
}
    ${BranchShortFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;

/**
 * __useTrainsListWithSchemaCarriagesQuery__
 *
 * To run a query within a React component, call `useTrainsListWithSchemaCarriagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainsListWithSchemaCarriagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainsListWithSchemaCarriagesQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrainsListWithSchemaCarriagesQuery(baseOptions: Apollo.QueryHookOptions<TrainsListWithSchemaCarriagesQuery, TrainsListWithSchemaCarriagesQueryVariables> & ({ variables: TrainsListWithSchemaCarriagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainsListWithSchemaCarriagesQuery, TrainsListWithSchemaCarriagesQueryVariables>(TrainsListWithSchemaCarriagesDocument, options);
      }
export function useTrainsListWithSchemaCarriagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainsListWithSchemaCarriagesQuery, TrainsListWithSchemaCarriagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainsListWithSchemaCarriagesQuery, TrainsListWithSchemaCarriagesQueryVariables>(TrainsListWithSchemaCarriagesDocument, options);
        }
export function useTrainsListWithSchemaCarriagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainsListWithSchemaCarriagesQuery, TrainsListWithSchemaCarriagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainsListWithSchemaCarriagesQuery, TrainsListWithSchemaCarriagesQueryVariables>(TrainsListWithSchemaCarriagesDocument, options);
        }
export type TrainsListWithSchemaCarriagesQueryHookResult = ReturnType<typeof useTrainsListWithSchemaCarriagesQuery>;
export type TrainsListWithSchemaCarriagesLazyQueryHookResult = ReturnType<typeof useTrainsListWithSchemaCarriagesLazyQuery>;
export type TrainsListWithSchemaCarriagesSuspenseQueryHookResult = ReturnType<typeof useTrainsListWithSchemaCarriagesSuspenseQuery>;
export type TrainsListWithSchemaCarriagesQueryResult = Apollo.QueryResult<TrainsListWithSchemaCarriagesQuery, TrainsListWithSchemaCarriagesQueryVariables>;
export const ReplenishmentCalculationRequestDocument = /*#__PURE__*/ gql`
    mutation replenishmentCalculationRequest($payload: ReplenishmentRequestDto!) {
  tpc {
    control_schema {
      replenishmentCalculation(payload: $payload)
    }
  }
}
    `;
export type ReplenishmentCalculationRequestMutationFn = Apollo.MutationFunction<ReplenishmentCalculationRequestMutation, ReplenishmentCalculationRequestMutationVariables>;

/**
 * __useReplenishmentCalculationRequestMutation__
 *
 * To run a mutation, you first call `useReplenishmentCalculationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplenishmentCalculationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replenishmentCalculationRequestMutation, { data, loading, error }] = useReplenishmentCalculationRequestMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useReplenishmentCalculationRequestMutation(baseOptions?: Apollo.MutationHookOptions<ReplenishmentCalculationRequestMutation, ReplenishmentCalculationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplenishmentCalculationRequestMutation, ReplenishmentCalculationRequestMutationVariables>(ReplenishmentCalculationRequestDocument, options);
      }
export type ReplenishmentCalculationRequestMutationHookResult = ReturnType<typeof useReplenishmentCalculationRequestMutation>;
export type ReplenishmentCalculationRequestMutationResult = Apollo.MutationResult<ReplenishmentCalculationRequestMutation>;
export type ReplenishmentCalculationRequestMutationOptions = Apollo.BaseMutationOptions<ReplenishmentCalculationRequestMutation, ReplenishmentCalculationRequestMutationVariables>;
export const ReplenishmentCalculationResponseDocument = /*#__PURE__*/ gql`
    query replenishmentCalculationResponse($key: String!) {
  tpc {
    control_schema {
      replenishmentResponse(key: $key) {
        items {
          dates {
            carriages {
              type
              quantity
            }
            date
            diff {
              type
              quantity
            }
          }
          station_from {
            ...StationShortFragment
          }
          station_to {
            ...StationShortFragment
          }
          train_number
          version
        }
        branch {
          ...BranchShortFragment
        }
        date_sync
        compare_date
        trains_quantity
        carriages_quantity
        trailed_carriages_quantity
        available_capacity_increase
      }
    }
  }
}
    ${StationShortFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}`;

/**
 * __useReplenishmentCalculationResponseQuery__
 *
 * To run a query within a React component, call `useReplenishmentCalculationResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useReplenishmentCalculationResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReplenishmentCalculationResponseQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useReplenishmentCalculationResponseQuery(baseOptions: Apollo.QueryHookOptions<ReplenishmentCalculationResponseQuery, ReplenishmentCalculationResponseQueryVariables> & ({ variables: ReplenishmentCalculationResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReplenishmentCalculationResponseQuery, ReplenishmentCalculationResponseQueryVariables>(ReplenishmentCalculationResponseDocument, options);
      }
export function useReplenishmentCalculationResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReplenishmentCalculationResponseQuery, ReplenishmentCalculationResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReplenishmentCalculationResponseQuery, ReplenishmentCalculationResponseQueryVariables>(ReplenishmentCalculationResponseDocument, options);
        }
export function useReplenishmentCalculationResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReplenishmentCalculationResponseQuery, ReplenishmentCalculationResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReplenishmentCalculationResponseQuery, ReplenishmentCalculationResponseQueryVariables>(ReplenishmentCalculationResponseDocument, options);
        }
export type ReplenishmentCalculationResponseQueryHookResult = ReturnType<typeof useReplenishmentCalculationResponseQuery>;
export type ReplenishmentCalculationResponseLazyQueryHookResult = ReturnType<typeof useReplenishmentCalculationResponseLazyQuery>;
export type ReplenishmentCalculationResponseSuspenseQueryHookResult = ReturnType<typeof useReplenishmentCalculationResponseSuspenseQuery>;
export type ReplenishmentCalculationResponseQueryResult = Apollo.QueryResult<ReplenishmentCalculationResponseQuery, ReplenishmentCalculationResponseQueryVariables>;
export const BranchCreateDocument = /*#__PURE__*/ gql`
    mutation branchCreate($data: CreateBranchDto!) {
  classifiers {
    branch {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type BranchCreateMutationFn = Apollo.MutationFunction<BranchCreateMutation, BranchCreateMutationVariables>;

/**
 * __useBranchCreateMutation__
 *
 * To run a mutation, you first call `useBranchCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBranchCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [branchCreateMutation, { data, loading, error }] = useBranchCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBranchCreateMutation(baseOptions?: Apollo.MutationHookOptions<BranchCreateMutation, BranchCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BranchCreateMutation, BranchCreateMutationVariables>(BranchCreateDocument, options);
      }
export type BranchCreateMutationHookResult = ReturnType<typeof useBranchCreateMutation>;
export type BranchCreateMutationResult = Apollo.MutationResult<BranchCreateMutation>;
export type BranchCreateMutationOptions = Apollo.BaseMutationOptions<BranchCreateMutation, BranchCreateMutationVariables>;
export const BranchCreateVersionDocument = /*#__PURE__*/ gql`
    mutation branchCreateVersion($data: CreateVersionBranchDto!) {
  classifiers {
    branch {
      createVersion(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type BranchCreateVersionMutationFn = Apollo.MutationFunction<BranchCreateVersionMutation, BranchCreateVersionMutationVariables>;

/**
 * __useBranchCreateVersionMutation__
 *
 * To run a mutation, you first call `useBranchCreateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBranchCreateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [branchCreateVersionMutation, { data, loading, error }] = useBranchCreateVersionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBranchCreateVersionMutation(baseOptions?: Apollo.MutationHookOptions<BranchCreateVersionMutation, BranchCreateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BranchCreateVersionMutation, BranchCreateVersionMutationVariables>(BranchCreateVersionDocument, options);
      }
export type BranchCreateVersionMutationHookResult = ReturnType<typeof useBranchCreateVersionMutation>;
export type BranchCreateVersionMutationResult = Apollo.MutationResult<BranchCreateVersionMutation>;
export type BranchCreateVersionMutationOptions = Apollo.BaseMutationOptions<BranchCreateVersionMutation, BranchCreateVersionMutationVariables>;
export const BranchDeleteDocument = /*#__PURE__*/ gql`
    mutation branchDelete($id: Float!) {
  classifiers {
    branch {
      delete(id: $id)
    }
  }
}
    `;
export type BranchDeleteMutationFn = Apollo.MutationFunction<BranchDeleteMutation, BranchDeleteMutationVariables>;

/**
 * __useBranchDeleteMutation__
 *
 * To run a mutation, you first call `useBranchDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBranchDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [branchDeleteMutation, { data, loading, error }] = useBranchDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBranchDeleteMutation(baseOptions?: Apollo.MutationHookOptions<BranchDeleteMutation, BranchDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BranchDeleteMutation, BranchDeleteMutationVariables>(BranchDeleteDocument, options);
      }
export type BranchDeleteMutationHookResult = ReturnType<typeof useBranchDeleteMutation>;
export type BranchDeleteMutationResult = Apollo.MutationResult<BranchDeleteMutation>;
export type BranchDeleteMutationOptions = Apollo.BaseMutationOptions<BranchDeleteMutation, BranchDeleteMutationVariables>;
export const BranchHistoryDocument = /*#__PURE__*/ gql`
    query branchHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [BranchQueryResolver_History_SortingInputType!]) {
  classifiers {
    branch {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          id
          is_latest
          ...BranchBaseFragment
          railways {
            ...RailwayBaseFragment
          }
        }
        totalCount
      }
    }
  }
}
    ${BranchBaseFragmentFragmentDoc}
${RailwayBaseFragmentFragmentDoc}`;

/**
 * __useBranchHistoryQuery__
 *
 * To run a query within a React component, call `useBranchHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBranchHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBranchHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useBranchHistoryQuery(baseOptions: Apollo.QueryHookOptions<BranchHistoryQuery, BranchHistoryQueryVariables> & ({ variables: BranchHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BranchHistoryQuery, BranchHistoryQueryVariables>(BranchHistoryDocument, options);
      }
export function useBranchHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BranchHistoryQuery, BranchHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BranchHistoryQuery, BranchHistoryQueryVariables>(BranchHistoryDocument, options);
        }
export function useBranchHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BranchHistoryQuery, BranchHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BranchHistoryQuery, BranchHistoryQueryVariables>(BranchHistoryDocument, options);
        }
export type BranchHistoryQueryHookResult = ReturnType<typeof useBranchHistoryQuery>;
export type BranchHistoryLazyQueryHookResult = ReturnType<typeof useBranchHistoryLazyQuery>;
export type BranchHistorySuspenseQueryHookResult = ReturnType<typeof useBranchHistorySuspenseQuery>;
export type BranchHistoryQueryResult = Apollo.QueryResult<BranchHistoryQuery, BranchHistoryQueryVariables>;
export const BranchListDocument = /*#__PURE__*/ gql`
    query branchList($paginate: PaginatorArgsDto, $orderBy: [BranchQueryResolver_List_SortingInputType!], $where: BranchQueryResolver_List_FilterInputType, $data: BranchArgsDto!) {
  classifiers {
    branch {
      list(paginate: $paginate, order_by: $orderBy, where: $where, data: $data) {
        items {
          id
          is_latest
          ...BranchBaseFragment
          railways {
            ...RailwayBaseFragment
          }
        }
        totalCount
      }
    }
  }
}
    ${BranchBaseFragmentFragmentDoc}
${RailwayBaseFragmentFragmentDoc}`;

/**
 * __useBranchListQuery__
 *
 * To run a query within a React component, call `useBranchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBranchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBranchListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBranchListQuery(baseOptions: Apollo.QueryHookOptions<BranchListQuery, BranchListQueryVariables> & ({ variables: BranchListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BranchListQuery, BranchListQueryVariables>(BranchListDocument, options);
      }
export function useBranchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BranchListQuery, BranchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BranchListQuery, BranchListQueryVariables>(BranchListDocument, options);
        }
export function useBranchListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BranchListQuery, BranchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BranchListQuery, BranchListQueryVariables>(BranchListDocument, options);
        }
export type BranchListQueryHookResult = ReturnType<typeof useBranchListQuery>;
export type BranchListLazyQueryHookResult = ReturnType<typeof useBranchListLazyQuery>;
export type BranchListSuspenseQueryHookResult = ReturnType<typeof useBranchListSuspenseQuery>;
export type BranchListQueryResult = Apollo.QueryResult<BranchListQuery, BranchListQueryVariables>;
export const BranchRangeByIdDocument = /*#__PURE__*/ gql`
    query branchRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    branch {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useBranchRangeByIdQuery__
 *
 * To run a query within a React component, call `useBranchRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBranchRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBranchRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useBranchRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<BranchRangeByIdQuery, BranchRangeByIdQueryVariables> & ({ variables: BranchRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BranchRangeByIdQuery, BranchRangeByIdQueryVariables>(BranchRangeByIdDocument, options);
      }
export function useBranchRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BranchRangeByIdQuery, BranchRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BranchRangeByIdQuery, BranchRangeByIdQueryVariables>(BranchRangeByIdDocument, options);
        }
export function useBranchRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BranchRangeByIdQuery, BranchRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BranchRangeByIdQuery, BranchRangeByIdQueryVariables>(BranchRangeByIdDocument, options);
        }
export type BranchRangeByIdQueryHookResult = ReturnType<typeof useBranchRangeByIdQuery>;
export type BranchRangeByIdLazyQueryHookResult = ReturnType<typeof useBranchRangeByIdLazyQuery>;
export type BranchRangeByIdSuspenseQueryHookResult = ReturnType<typeof useBranchRangeByIdSuspenseQuery>;
export type BranchRangeByIdQueryResult = Apollo.QueryResult<BranchRangeByIdQuery, BranchRangeByIdQueryVariables>;
export const BranchUpdateDocument = /*#__PURE__*/ gql`
    mutation branchUpdate($data: UpdateBranchDto!) {
  classifiers {
    branch {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type BranchUpdateMutationFn = Apollo.MutationFunction<BranchUpdateMutation, BranchUpdateMutationVariables>;

/**
 * __useBranchUpdateMutation__
 *
 * To run a mutation, you first call `useBranchUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBranchUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [branchUpdateMutation, { data, loading, error }] = useBranchUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBranchUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BranchUpdateMutation, BranchUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BranchUpdateMutation, BranchUpdateMutationVariables>(BranchUpdateDocument, options);
      }
export type BranchUpdateMutationHookResult = ReturnType<typeof useBranchUpdateMutation>;
export type BranchUpdateMutationResult = Apollo.MutationResult<BranchUpdateMutation>;
export type BranchUpdateMutationOptions = Apollo.BaseMutationOptions<BranchUpdateMutation, BranchUpdateMutationVariables>;
export const CarriageAdditionalSeatSignCreateDocument = /*#__PURE__*/ gql`
    mutation carriageAdditionalSeatSignCreate($data: CreateCarriageAdditionalSeatSignDto!) {
  classifiers {
    carriageAdditionalSeatSign {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type CarriageAdditionalSeatSignCreateMutationFn = Apollo.MutationFunction<CarriageAdditionalSeatSignCreateMutation, CarriageAdditionalSeatSignCreateMutationVariables>;

/**
 * __useCarriageAdditionalSeatSignCreateMutation__
 *
 * To run a mutation, you first call `useCarriageAdditionalSeatSignCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageAdditionalSeatSignCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageAdditionalSeatSignCreateMutation, { data, loading, error }] = useCarriageAdditionalSeatSignCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageAdditionalSeatSignCreateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageAdditionalSeatSignCreateMutation, CarriageAdditionalSeatSignCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageAdditionalSeatSignCreateMutation, CarriageAdditionalSeatSignCreateMutationVariables>(CarriageAdditionalSeatSignCreateDocument, options);
      }
export type CarriageAdditionalSeatSignCreateMutationHookResult = ReturnType<typeof useCarriageAdditionalSeatSignCreateMutation>;
export type CarriageAdditionalSeatSignCreateMutationResult = Apollo.MutationResult<CarriageAdditionalSeatSignCreateMutation>;
export type CarriageAdditionalSeatSignCreateMutationOptions = Apollo.BaseMutationOptions<CarriageAdditionalSeatSignCreateMutation, CarriageAdditionalSeatSignCreateMutationVariables>;
export const CarriageAdditionalSeatSignHistoryDocument = /*#__PURE__*/ gql`
    query carriageAdditionalSeatSignHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [CarriageAdditionalSeatSignQueryResolver_History_SortingInputType!]) {
  classifiers {
    carriageAdditionalSeatSign {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          start_at
          end_at
          ...CarriageAdditionalSeatSignBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${CarriageAdditionalSeatSignBaseFragmentFragmentDoc}`;

/**
 * __useCarriageAdditionalSeatSignHistoryQuery__
 *
 * To run a query within a React component, call `useCarriageAdditionalSeatSignHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageAdditionalSeatSignHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageAdditionalSeatSignHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCarriageAdditionalSeatSignHistoryQuery(baseOptions: Apollo.QueryHookOptions<CarriageAdditionalSeatSignHistoryQuery, CarriageAdditionalSeatSignHistoryQueryVariables> & ({ variables: CarriageAdditionalSeatSignHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageAdditionalSeatSignHistoryQuery, CarriageAdditionalSeatSignHistoryQueryVariables>(CarriageAdditionalSeatSignHistoryDocument, options);
      }
export function useCarriageAdditionalSeatSignHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageAdditionalSeatSignHistoryQuery, CarriageAdditionalSeatSignHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageAdditionalSeatSignHistoryQuery, CarriageAdditionalSeatSignHistoryQueryVariables>(CarriageAdditionalSeatSignHistoryDocument, options);
        }
export function useCarriageAdditionalSeatSignHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageAdditionalSeatSignHistoryQuery, CarriageAdditionalSeatSignHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageAdditionalSeatSignHistoryQuery, CarriageAdditionalSeatSignHistoryQueryVariables>(CarriageAdditionalSeatSignHistoryDocument, options);
        }
export type CarriageAdditionalSeatSignHistoryQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignHistoryQuery>;
export type CarriageAdditionalSeatSignHistoryLazyQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignHistoryLazyQuery>;
export type CarriageAdditionalSeatSignHistorySuspenseQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignHistorySuspenseQuery>;
export type CarriageAdditionalSeatSignHistoryQueryResult = Apollo.QueryResult<CarriageAdditionalSeatSignHistoryQuery, CarriageAdditionalSeatSignHistoryQueryVariables>;
export const CarriageAdditionalSeatSignListDocument = /*#__PURE__*/ gql`
    query carriageAdditionalSeatSignList($paginate: PaginatorArgsDto, $orderBy: [CarriageAdditionalSeatSignQueryResolver_List_SortingInputType!], $where: CarriageAdditionalSeatSignQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    carriageAdditionalSeatSign {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...CarriageAdditionalSeatSignBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${CarriageAdditionalSeatSignBaseFragmentFragmentDoc}`;

/**
 * __useCarriageAdditionalSeatSignListQuery__
 *
 * To run a query within a React component, call `useCarriageAdditionalSeatSignListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageAdditionalSeatSignListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageAdditionalSeatSignListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageAdditionalSeatSignListQuery(baseOptions: Apollo.QueryHookOptions<CarriageAdditionalSeatSignListQuery, CarriageAdditionalSeatSignListQueryVariables> & ({ variables: CarriageAdditionalSeatSignListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageAdditionalSeatSignListQuery, CarriageAdditionalSeatSignListQueryVariables>(CarriageAdditionalSeatSignListDocument, options);
      }
export function useCarriageAdditionalSeatSignListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageAdditionalSeatSignListQuery, CarriageAdditionalSeatSignListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageAdditionalSeatSignListQuery, CarriageAdditionalSeatSignListQueryVariables>(CarriageAdditionalSeatSignListDocument, options);
        }
export function useCarriageAdditionalSeatSignListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageAdditionalSeatSignListQuery, CarriageAdditionalSeatSignListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageAdditionalSeatSignListQuery, CarriageAdditionalSeatSignListQueryVariables>(CarriageAdditionalSeatSignListDocument, options);
        }
export type CarriageAdditionalSeatSignListQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignListQuery>;
export type CarriageAdditionalSeatSignListLazyQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignListLazyQuery>;
export type CarriageAdditionalSeatSignListSuspenseQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignListSuspenseQuery>;
export type CarriageAdditionalSeatSignListQueryResult = Apollo.QueryResult<CarriageAdditionalSeatSignListQuery, CarriageAdditionalSeatSignListQueryVariables>;
export const CarriageAdditionalSeatSignRangeByIdDocument = /*#__PURE__*/ gql`
    query carriageAdditionalSeatSignRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    carriageAdditionalSeatSign {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useCarriageAdditionalSeatSignRangeByIdQuery__
 *
 * To run a query within a React component, call `useCarriageAdditionalSeatSignRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageAdditionalSeatSignRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageAdditionalSeatSignRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageAdditionalSeatSignRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<CarriageAdditionalSeatSignRangeByIdQuery, CarriageAdditionalSeatSignRangeByIdQueryVariables> & ({ variables: CarriageAdditionalSeatSignRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageAdditionalSeatSignRangeByIdQuery, CarriageAdditionalSeatSignRangeByIdQueryVariables>(CarriageAdditionalSeatSignRangeByIdDocument, options);
      }
export function useCarriageAdditionalSeatSignRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageAdditionalSeatSignRangeByIdQuery, CarriageAdditionalSeatSignRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageAdditionalSeatSignRangeByIdQuery, CarriageAdditionalSeatSignRangeByIdQueryVariables>(CarriageAdditionalSeatSignRangeByIdDocument, options);
        }
export function useCarriageAdditionalSeatSignRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageAdditionalSeatSignRangeByIdQuery, CarriageAdditionalSeatSignRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageAdditionalSeatSignRangeByIdQuery, CarriageAdditionalSeatSignRangeByIdQueryVariables>(CarriageAdditionalSeatSignRangeByIdDocument, options);
        }
export type CarriageAdditionalSeatSignRangeByIdQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignRangeByIdQuery>;
export type CarriageAdditionalSeatSignRangeByIdLazyQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignRangeByIdLazyQuery>;
export type CarriageAdditionalSeatSignRangeByIdSuspenseQueryHookResult = ReturnType<typeof useCarriageAdditionalSeatSignRangeByIdSuspenseQuery>;
export type CarriageAdditionalSeatSignRangeByIdQueryResult = Apollo.QueryResult<CarriageAdditionalSeatSignRangeByIdQuery, CarriageAdditionalSeatSignRangeByIdQueryVariables>;
export const CarriageAdditionalSeatSignUpdateDocument = /*#__PURE__*/ gql`
    mutation carriageAdditionalSeatSignUpdate($data: UpdateCarriageAdditionalSeatSignDto!) {
  classifiers {
    carriageAdditionalSeatSign {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type CarriageAdditionalSeatSignUpdateMutationFn = Apollo.MutationFunction<CarriageAdditionalSeatSignUpdateMutation, CarriageAdditionalSeatSignUpdateMutationVariables>;

/**
 * __useCarriageAdditionalSeatSignUpdateMutation__
 *
 * To run a mutation, you first call `useCarriageAdditionalSeatSignUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageAdditionalSeatSignUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageAdditionalSeatSignUpdateMutation, { data, loading, error }] = useCarriageAdditionalSeatSignUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageAdditionalSeatSignUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageAdditionalSeatSignUpdateMutation, CarriageAdditionalSeatSignUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageAdditionalSeatSignUpdateMutation, CarriageAdditionalSeatSignUpdateMutationVariables>(CarriageAdditionalSeatSignUpdateDocument, options);
      }
export type CarriageAdditionalSeatSignUpdateMutationHookResult = ReturnType<typeof useCarriageAdditionalSeatSignUpdateMutation>;
export type CarriageAdditionalSeatSignUpdateMutationResult = Apollo.MutationResult<CarriageAdditionalSeatSignUpdateMutation>;
export type CarriageAdditionalSeatSignUpdateMutationOptions = Apollo.BaseMutationOptions<CarriageAdditionalSeatSignUpdateMutation, CarriageAdditionalSeatSignUpdateMutationVariables>;
export const NpsCarriageBrakeTypeCreateDocument = /*#__PURE__*/ gql`
    mutation npsCarriageBrakeTypeCreate($data: CreateNpsCarriageBrakeTypeDto!) {
  classifiers {
    npsCarriageBrakeType {
      create(data: $data) {
        ...NpsCarriageBrakeTypeBaseFragment
      }
    }
  }
}
    ${NpsCarriageBrakeTypeBaseFragmentFragmentDoc}`;
export type NpsCarriageBrakeTypeCreateMutationFn = Apollo.MutationFunction<NpsCarriageBrakeTypeCreateMutation, NpsCarriageBrakeTypeCreateMutationVariables>;

/**
 * __useNpsCarriageBrakeTypeCreateMutation__
 *
 * To run a mutation, you first call `useNpsCarriageBrakeTypeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageBrakeTypeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsCarriageBrakeTypeCreateMutation, { data, loading, error }] = useNpsCarriageBrakeTypeCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNpsCarriageBrakeTypeCreateMutation(baseOptions?: Apollo.MutationHookOptions<NpsCarriageBrakeTypeCreateMutation, NpsCarriageBrakeTypeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsCarriageBrakeTypeCreateMutation, NpsCarriageBrakeTypeCreateMutationVariables>(NpsCarriageBrakeTypeCreateDocument, options);
      }
export type NpsCarriageBrakeTypeCreateMutationHookResult = ReturnType<typeof useNpsCarriageBrakeTypeCreateMutation>;
export type NpsCarriageBrakeTypeCreateMutationResult = Apollo.MutationResult<NpsCarriageBrakeTypeCreateMutation>;
export type NpsCarriageBrakeTypeCreateMutationOptions = Apollo.BaseMutationOptions<NpsCarriageBrakeTypeCreateMutation, NpsCarriageBrakeTypeCreateMutationVariables>;
export const NpsCarriageBrakeTypeHistoryDocument = /*#__PURE__*/ gql`
    query npsCarriageBrakeTypeHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [NpsCarriageBrakeTypeQueryResolver_History_SortingInputType!]) {
  classifiers {
    npsCarriageBrakeType {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          ...NpsCarriageBrakeTypeBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${NpsCarriageBrakeTypeBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageBrakeTypeHistoryQuery__
 *
 * To run a query within a React component, call `useNpsCarriageBrakeTypeHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageBrakeTypeHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageBrakeTypeHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useNpsCarriageBrakeTypeHistoryQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageBrakeTypeHistoryQuery, NpsCarriageBrakeTypeHistoryQueryVariables> & ({ variables: NpsCarriageBrakeTypeHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageBrakeTypeHistoryQuery, NpsCarriageBrakeTypeHistoryQueryVariables>(NpsCarriageBrakeTypeHistoryDocument, options);
      }
export function useNpsCarriageBrakeTypeHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageBrakeTypeHistoryQuery, NpsCarriageBrakeTypeHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageBrakeTypeHistoryQuery, NpsCarriageBrakeTypeHistoryQueryVariables>(NpsCarriageBrakeTypeHistoryDocument, options);
        }
export function useNpsCarriageBrakeTypeHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageBrakeTypeHistoryQuery, NpsCarriageBrakeTypeHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageBrakeTypeHistoryQuery, NpsCarriageBrakeTypeHistoryQueryVariables>(NpsCarriageBrakeTypeHistoryDocument, options);
        }
export type NpsCarriageBrakeTypeHistoryQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeHistoryQuery>;
export type NpsCarriageBrakeTypeHistoryLazyQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeHistoryLazyQuery>;
export type NpsCarriageBrakeTypeHistorySuspenseQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeHistorySuspenseQuery>;
export type NpsCarriageBrakeTypeHistoryQueryResult = Apollo.QueryResult<NpsCarriageBrakeTypeHistoryQuery, NpsCarriageBrakeTypeHistoryQueryVariables>;
export const NpsCarriageBrakeTypeListDocument = /*#__PURE__*/ gql`
    query npsCarriageBrakeTypeList($paginate: PaginatorArgsDto, $orderBy: [NpsCarriageBrakeTypeQueryResolver_List_SortingInputType!], $where: NpsCarriageBrakeTypeQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    npsCarriageBrakeType {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...NpsCarriageBrakeTypeBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${NpsCarriageBrakeTypeBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageBrakeTypeListQuery__
 *
 * To run a query within a React component, call `useNpsCarriageBrakeTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageBrakeTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageBrakeTypeListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageBrakeTypeListQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageBrakeTypeListQuery, NpsCarriageBrakeTypeListQueryVariables> & ({ variables: NpsCarriageBrakeTypeListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageBrakeTypeListQuery, NpsCarriageBrakeTypeListQueryVariables>(NpsCarriageBrakeTypeListDocument, options);
      }
export function useNpsCarriageBrakeTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageBrakeTypeListQuery, NpsCarriageBrakeTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageBrakeTypeListQuery, NpsCarriageBrakeTypeListQueryVariables>(NpsCarriageBrakeTypeListDocument, options);
        }
export function useNpsCarriageBrakeTypeListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageBrakeTypeListQuery, NpsCarriageBrakeTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageBrakeTypeListQuery, NpsCarriageBrakeTypeListQueryVariables>(NpsCarriageBrakeTypeListDocument, options);
        }
export type NpsCarriageBrakeTypeListQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeListQuery>;
export type NpsCarriageBrakeTypeListLazyQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeListLazyQuery>;
export type NpsCarriageBrakeTypeListSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeListSuspenseQuery>;
export type NpsCarriageBrakeTypeListQueryResult = Apollo.QueryResult<NpsCarriageBrakeTypeListQuery, NpsCarriageBrakeTypeListQueryVariables>;
export const NpsCarriageBrakeTypeRangeByIdDocument = /*#__PURE__*/ gql`
    query npsCarriageBrakeTypeRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    npsCarriageBrakeType {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useNpsCarriageBrakeTypeRangeByIdQuery__
 *
 * To run a query within a React component, call `useNpsCarriageBrakeTypeRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageBrakeTypeRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageBrakeTypeRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageBrakeTypeRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageBrakeTypeRangeByIdQuery, NpsCarriageBrakeTypeRangeByIdQueryVariables> & ({ variables: NpsCarriageBrakeTypeRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageBrakeTypeRangeByIdQuery, NpsCarriageBrakeTypeRangeByIdQueryVariables>(NpsCarriageBrakeTypeRangeByIdDocument, options);
      }
export function useNpsCarriageBrakeTypeRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageBrakeTypeRangeByIdQuery, NpsCarriageBrakeTypeRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageBrakeTypeRangeByIdQuery, NpsCarriageBrakeTypeRangeByIdQueryVariables>(NpsCarriageBrakeTypeRangeByIdDocument, options);
        }
export function useNpsCarriageBrakeTypeRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageBrakeTypeRangeByIdQuery, NpsCarriageBrakeTypeRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageBrakeTypeRangeByIdQuery, NpsCarriageBrakeTypeRangeByIdQueryVariables>(NpsCarriageBrakeTypeRangeByIdDocument, options);
        }
export type NpsCarriageBrakeTypeRangeByIdQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeRangeByIdQuery>;
export type NpsCarriageBrakeTypeRangeByIdLazyQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeRangeByIdLazyQuery>;
export type NpsCarriageBrakeTypeRangeByIdSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageBrakeTypeRangeByIdSuspenseQuery>;
export type NpsCarriageBrakeTypeRangeByIdQueryResult = Apollo.QueryResult<NpsCarriageBrakeTypeRangeByIdQuery, NpsCarriageBrakeTypeRangeByIdQueryVariables>;
export const NpsCarriageBrakeTypeUpdateDocument = /*#__PURE__*/ gql`
    mutation npsCarriageBrakeTypeUpdate($data: UpdateNpsCarriageBrakeTypeDto!) {
  classifiers {
    npsCarriageBrakeType {
      update(data: $data) {
        ...NpsCarriageBrakeTypeBaseFragment
      }
    }
  }
}
    ${NpsCarriageBrakeTypeBaseFragmentFragmentDoc}`;
export type NpsCarriageBrakeTypeUpdateMutationFn = Apollo.MutationFunction<NpsCarriageBrakeTypeUpdateMutation, NpsCarriageBrakeTypeUpdateMutationVariables>;

/**
 * __useNpsCarriageBrakeTypeUpdateMutation__
 *
 * To run a mutation, you first call `useNpsCarriageBrakeTypeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageBrakeTypeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsCarriageBrakeTypeUpdateMutation, { data, loading, error }] = useNpsCarriageBrakeTypeUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNpsCarriageBrakeTypeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NpsCarriageBrakeTypeUpdateMutation, NpsCarriageBrakeTypeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsCarriageBrakeTypeUpdateMutation, NpsCarriageBrakeTypeUpdateMutationVariables>(NpsCarriageBrakeTypeUpdateDocument, options);
      }
export type NpsCarriageBrakeTypeUpdateMutationHookResult = ReturnType<typeof useNpsCarriageBrakeTypeUpdateMutation>;
export type NpsCarriageBrakeTypeUpdateMutationResult = Apollo.MutationResult<NpsCarriageBrakeTypeUpdateMutation>;
export type NpsCarriageBrakeTypeUpdateMutationOptions = Apollo.BaseMutationOptions<NpsCarriageBrakeTypeUpdateMutation, NpsCarriageBrakeTypeUpdateMutationVariables>;
export const NpsCarriageDimensionCreateDocument = /*#__PURE__*/ gql`
    mutation npsCarriageDimensionCreate($data: CreateNpsCarriageDimensionDto!) {
  classifiers {
    npsCarriageDimension {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type NpsCarriageDimensionCreateMutationFn = Apollo.MutationFunction<NpsCarriageDimensionCreateMutation, NpsCarriageDimensionCreateMutationVariables>;

/**
 * __useNpsCarriageDimensionCreateMutation__
 *
 * To run a mutation, you first call `useNpsCarriageDimensionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageDimensionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsCarriageDimensionCreateMutation, { data, loading, error }] = useNpsCarriageDimensionCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNpsCarriageDimensionCreateMutation(baseOptions?: Apollo.MutationHookOptions<NpsCarriageDimensionCreateMutation, NpsCarriageDimensionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsCarriageDimensionCreateMutation, NpsCarriageDimensionCreateMutationVariables>(NpsCarriageDimensionCreateDocument, options);
      }
export type NpsCarriageDimensionCreateMutationHookResult = ReturnType<typeof useNpsCarriageDimensionCreateMutation>;
export type NpsCarriageDimensionCreateMutationResult = Apollo.MutationResult<NpsCarriageDimensionCreateMutation>;
export type NpsCarriageDimensionCreateMutationOptions = Apollo.BaseMutationOptions<NpsCarriageDimensionCreateMutation, NpsCarriageDimensionCreateMutationVariables>;
export const NpsCarriageDimensionHistoryDocument = /*#__PURE__*/ gql`
    query npsCarriageDimensionHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [NpsCarriageDimensionQueryResolver_History_SortingInputType!]) {
  classifiers {
    npsCarriageDimension {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          ...NpsCarriageDimensionBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${NpsCarriageDimensionBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageDimensionHistoryQuery__
 *
 * To run a query within a React component, call `useNpsCarriageDimensionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageDimensionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageDimensionHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useNpsCarriageDimensionHistoryQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageDimensionHistoryQuery, NpsCarriageDimensionHistoryQueryVariables> & ({ variables: NpsCarriageDimensionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageDimensionHistoryQuery, NpsCarriageDimensionHistoryQueryVariables>(NpsCarriageDimensionHistoryDocument, options);
      }
export function useNpsCarriageDimensionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageDimensionHistoryQuery, NpsCarriageDimensionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageDimensionHistoryQuery, NpsCarriageDimensionHistoryQueryVariables>(NpsCarriageDimensionHistoryDocument, options);
        }
export function useNpsCarriageDimensionHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageDimensionHistoryQuery, NpsCarriageDimensionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageDimensionHistoryQuery, NpsCarriageDimensionHistoryQueryVariables>(NpsCarriageDimensionHistoryDocument, options);
        }
export type NpsCarriageDimensionHistoryQueryHookResult = ReturnType<typeof useNpsCarriageDimensionHistoryQuery>;
export type NpsCarriageDimensionHistoryLazyQueryHookResult = ReturnType<typeof useNpsCarriageDimensionHistoryLazyQuery>;
export type NpsCarriageDimensionHistorySuspenseQueryHookResult = ReturnType<typeof useNpsCarriageDimensionHistorySuspenseQuery>;
export type NpsCarriageDimensionHistoryQueryResult = Apollo.QueryResult<NpsCarriageDimensionHistoryQuery, NpsCarriageDimensionHistoryQueryVariables>;
export const NpsCarriageDimensionListDocument = /*#__PURE__*/ gql`
    query npsCarriageDimensionList($paginate: PaginatorArgsDto, $orderBy: [NpsCarriageDimensionQueryResolver_List_SortingInputType!], $where: NpsCarriageDimensionQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    npsCarriageDimension {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...NpsCarriageDimensionBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${NpsCarriageDimensionBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageDimensionListQuery__
 *
 * To run a query within a React component, call `useNpsCarriageDimensionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageDimensionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageDimensionListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageDimensionListQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageDimensionListQuery, NpsCarriageDimensionListQueryVariables> & ({ variables: NpsCarriageDimensionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageDimensionListQuery, NpsCarriageDimensionListQueryVariables>(NpsCarriageDimensionListDocument, options);
      }
export function useNpsCarriageDimensionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageDimensionListQuery, NpsCarriageDimensionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageDimensionListQuery, NpsCarriageDimensionListQueryVariables>(NpsCarriageDimensionListDocument, options);
        }
export function useNpsCarriageDimensionListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageDimensionListQuery, NpsCarriageDimensionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageDimensionListQuery, NpsCarriageDimensionListQueryVariables>(NpsCarriageDimensionListDocument, options);
        }
export type NpsCarriageDimensionListQueryHookResult = ReturnType<typeof useNpsCarriageDimensionListQuery>;
export type NpsCarriageDimensionListLazyQueryHookResult = ReturnType<typeof useNpsCarriageDimensionListLazyQuery>;
export type NpsCarriageDimensionListSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageDimensionListSuspenseQuery>;
export type NpsCarriageDimensionListQueryResult = Apollo.QueryResult<NpsCarriageDimensionListQuery, NpsCarriageDimensionListQueryVariables>;
export const NpsCarriageDimensionRangeByIdDocument = /*#__PURE__*/ gql`
    query npsCarriageDimensionRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    npsCarriageDimension {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useNpsCarriageDimensionRangeByIdQuery__
 *
 * To run a query within a React component, call `useNpsCarriageDimensionRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageDimensionRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageDimensionRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageDimensionRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageDimensionRangeByIdQuery, NpsCarriageDimensionRangeByIdQueryVariables> & ({ variables: NpsCarriageDimensionRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageDimensionRangeByIdQuery, NpsCarriageDimensionRangeByIdQueryVariables>(NpsCarriageDimensionRangeByIdDocument, options);
      }
export function useNpsCarriageDimensionRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageDimensionRangeByIdQuery, NpsCarriageDimensionRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageDimensionRangeByIdQuery, NpsCarriageDimensionRangeByIdQueryVariables>(NpsCarriageDimensionRangeByIdDocument, options);
        }
export function useNpsCarriageDimensionRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageDimensionRangeByIdQuery, NpsCarriageDimensionRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageDimensionRangeByIdQuery, NpsCarriageDimensionRangeByIdQueryVariables>(NpsCarriageDimensionRangeByIdDocument, options);
        }
export type NpsCarriageDimensionRangeByIdQueryHookResult = ReturnType<typeof useNpsCarriageDimensionRangeByIdQuery>;
export type NpsCarriageDimensionRangeByIdLazyQueryHookResult = ReturnType<typeof useNpsCarriageDimensionRangeByIdLazyQuery>;
export type NpsCarriageDimensionRangeByIdSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageDimensionRangeByIdSuspenseQuery>;
export type NpsCarriageDimensionRangeByIdQueryResult = Apollo.QueryResult<NpsCarriageDimensionRangeByIdQuery, NpsCarriageDimensionRangeByIdQueryVariables>;
export const NpsCarriageDimensionUpdateDocument = /*#__PURE__*/ gql`
    mutation npsCarriageDimensionUpdate($data: UpdateNpsCarriageDimensionDto!) {
  classifiers {
    npsCarriageDimension {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type NpsCarriageDimensionUpdateMutationFn = Apollo.MutationFunction<NpsCarriageDimensionUpdateMutation, NpsCarriageDimensionUpdateMutationVariables>;

/**
 * __useNpsCarriageDimensionUpdateMutation__
 *
 * To run a mutation, you first call `useNpsCarriageDimensionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageDimensionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsCarriageDimensionUpdateMutation, { data, loading, error }] = useNpsCarriageDimensionUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNpsCarriageDimensionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NpsCarriageDimensionUpdateMutation, NpsCarriageDimensionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsCarriageDimensionUpdateMutation, NpsCarriageDimensionUpdateMutationVariables>(NpsCarriageDimensionUpdateDocument, options);
      }
export type NpsCarriageDimensionUpdateMutationHookResult = ReturnType<typeof useNpsCarriageDimensionUpdateMutation>;
export type NpsCarriageDimensionUpdateMutationResult = Apollo.MutationResult<NpsCarriageDimensionUpdateMutation>;
export type NpsCarriageDimensionUpdateMutationOptions = Apollo.BaseMutationOptions<NpsCarriageDimensionUpdateMutation, NpsCarriageDimensionUpdateMutationVariables>;
export const NpsCarriageHeatTypeCreateDocument = /*#__PURE__*/ gql`
    mutation npsCarriageHeatTypeCreate($data: CreateNpsCarriageHeatTypeDto!) {
  classifiers {
    npsCarriageHeatType {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type NpsCarriageHeatTypeCreateMutationFn = Apollo.MutationFunction<NpsCarriageHeatTypeCreateMutation, NpsCarriageHeatTypeCreateMutationVariables>;

/**
 * __useNpsCarriageHeatTypeCreateMutation__
 *
 * To run a mutation, you first call `useNpsCarriageHeatTypeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageHeatTypeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsCarriageHeatTypeCreateMutation, { data, loading, error }] = useNpsCarriageHeatTypeCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNpsCarriageHeatTypeCreateMutation(baseOptions?: Apollo.MutationHookOptions<NpsCarriageHeatTypeCreateMutation, NpsCarriageHeatTypeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsCarriageHeatTypeCreateMutation, NpsCarriageHeatTypeCreateMutationVariables>(NpsCarriageHeatTypeCreateDocument, options);
      }
export type NpsCarriageHeatTypeCreateMutationHookResult = ReturnType<typeof useNpsCarriageHeatTypeCreateMutation>;
export type NpsCarriageHeatTypeCreateMutationResult = Apollo.MutationResult<NpsCarriageHeatTypeCreateMutation>;
export type NpsCarriageHeatTypeCreateMutationOptions = Apollo.BaseMutationOptions<NpsCarriageHeatTypeCreateMutation, NpsCarriageHeatTypeCreateMutationVariables>;
export const NpsCarriageHeatTypeHistoryDocument = /*#__PURE__*/ gql`
    query npsCarriageHeatTypeHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [NpsCarriageHeatTypeQueryResolver_History_SortingInputType!]) {
  classifiers {
    npsCarriageHeatType {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          ...NpsCarriageHeatTypeBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${NpsCarriageHeatTypeBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageHeatTypeHistoryQuery__
 *
 * To run a query within a React component, call `useNpsCarriageHeatTypeHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageHeatTypeHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageHeatTypeHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useNpsCarriageHeatTypeHistoryQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageHeatTypeHistoryQuery, NpsCarriageHeatTypeHistoryQueryVariables> & ({ variables: NpsCarriageHeatTypeHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageHeatTypeHistoryQuery, NpsCarriageHeatTypeHistoryQueryVariables>(NpsCarriageHeatTypeHistoryDocument, options);
      }
export function useNpsCarriageHeatTypeHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageHeatTypeHistoryQuery, NpsCarriageHeatTypeHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageHeatTypeHistoryQuery, NpsCarriageHeatTypeHistoryQueryVariables>(NpsCarriageHeatTypeHistoryDocument, options);
        }
export function useNpsCarriageHeatTypeHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageHeatTypeHistoryQuery, NpsCarriageHeatTypeHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageHeatTypeHistoryQuery, NpsCarriageHeatTypeHistoryQueryVariables>(NpsCarriageHeatTypeHistoryDocument, options);
        }
export type NpsCarriageHeatTypeHistoryQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeHistoryQuery>;
export type NpsCarriageHeatTypeHistoryLazyQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeHistoryLazyQuery>;
export type NpsCarriageHeatTypeHistorySuspenseQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeHistorySuspenseQuery>;
export type NpsCarriageHeatTypeHistoryQueryResult = Apollo.QueryResult<NpsCarriageHeatTypeHistoryQuery, NpsCarriageHeatTypeHistoryQueryVariables>;
export const NpsCarriageHeatTypeListDocument = /*#__PURE__*/ gql`
    query npsCarriageHeatTypeList($paginate: PaginatorArgsDto, $orderBy: [NpsCarriageHeatTypeQueryResolver_List_SortingInputType!], $where: NpsCarriageHeatTypeQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    npsCarriageHeatType {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...NpsCarriageHeatTypeBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${NpsCarriageHeatTypeBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageHeatTypeListQuery__
 *
 * To run a query within a React component, call `useNpsCarriageHeatTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageHeatTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageHeatTypeListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageHeatTypeListQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageHeatTypeListQuery, NpsCarriageHeatTypeListQueryVariables> & ({ variables: NpsCarriageHeatTypeListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageHeatTypeListQuery, NpsCarriageHeatTypeListQueryVariables>(NpsCarriageHeatTypeListDocument, options);
      }
export function useNpsCarriageHeatTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageHeatTypeListQuery, NpsCarriageHeatTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageHeatTypeListQuery, NpsCarriageHeatTypeListQueryVariables>(NpsCarriageHeatTypeListDocument, options);
        }
export function useNpsCarriageHeatTypeListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageHeatTypeListQuery, NpsCarriageHeatTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageHeatTypeListQuery, NpsCarriageHeatTypeListQueryVariables>(NpsCarriageHeatTypeListDocument, options);
        }
export type NpsCarriageHeatTypeListQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeListQuery>;
export type NpsCarriageHeatTypeListLazyQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeListLazyQuery>;
export type NpsCarriageHeatTypeListSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeListSuspenseQuery>;
export type NpsCarriageHeatTypeListQueryResult = Apollo.QueryResult<NpsCarriageHeatTypeListQuery, NpsCarriageHeatTypeListQueryVariables>;
export const NpsCarriageHeatTypeRangeByIdDocument = /*#__PURE__*/ gql`
    query npsCarriageHeatTypeRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    npsCarriageHeatType {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useNpsCarriageHeatTypeRangeByIdQuery__
 *
 * To run a query within a React component, call `useNpsCarriageHeatTypeRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageHeatTypeRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageHeatTypeRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageHeatTypeRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageHeatTypeRangeByIdQuery, NpsCarriageHeatTypeRangeByIdQueryVariables> & ({ variables: NpsCarriageHeatTypeRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageHeatTypeRangeByIdQuery, NpsCarriageHeatTypeRangeByIdQueryVariables>(NpsCarriageHeatTypeRangeByIdDocument, options);
      }
export function useNpsCarriageHeatTypeRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageHeatTypeRangeByIdQuery, NpsCarriageHeatTypeRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageHeatTypeRangeByIdQuery, NpsCarriageHeatTypeRangeByIdQueryVariables>(NpsCarriageHeatTypeRangeByIdDocument, options);
        }
export function useNpsCarriageHeatTypeRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageHeatTypeRangeByIdQuery, NpsCarriageHeatTypeRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageHeatTypeRangeByIdQuery, NpsCarriageHeatTypeRangeByIdQueryVariables>(NpsCarriageHeatTypeRangeByIdDocument, options);
        }
export type NpsCarriageHeatTypeRangeByIdQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeRangeByIdQuery>;
export type NpsCarriageHeatTypeRangeByIdLazyQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeRangeByIdLazyQuery>;
export type NpsCarriageHeatTypeRangeByIdSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageHeatTypeRangeByIdSuspenseQuery>;
export type NpsCarriageHeatTypeRangeByIdQueryResult = Apollo.QueryResult<NpsCarriageHeatTypeRangeByIdQuery, NpsCarriageHeatTypeRangeByIdQueryVariables>;
export const NpsCarriageHeatTypeUpdateDocument = /*#__PURE__*/ gql`
    mutation npsCarriageHeatTypeUpdate($data: UpdateNpsCarriageHeatTypeDto!) {
  classifiers {
    npsCarriageHeatType {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type NpsCarriageHeatTypeUpdateMutationFn = Apollo.MutationFunction<NpsCarriageHeatTypeUpdateMutation, NpsCarriageHeatTypeUpdateMutationVariables>;

/**
 * __useNpsCarriageHeatTypeUpdateMutation__
 *
 * To run a mutation, you first call `useNpsCarriageHeatTypeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageHeatTypeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsCarriageHeatTypeUpdateMutation, { data, loading, error }] = useNpsCarriageHeatTypeUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNpsCarriageHeatTypeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NpsCarriageHeatTypeUpdateMutation, NpsCarriageHeatTypeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsCarriageHeatTypeUpdateMutation, NpsCarriageHeatTypeUpdateMutationVariables>(NpsCarriageHeatTypeUpdateDocument, options);
      }
export type NpsCarriageHeatTypeUpdateMutationHookResult = ReturnType<typeof useNpsCarriageHeatTypeUpdateMutation>;
export type NpsCarriageHeatTypeUpdateMutationResult = Apollo.MutationResult<NpsCarriageHeatTypeUpdateMutation>;
export type NpsCarriageHeatTypeUpdateMutationOptions = Apollo.BaseMutationOptions<NpsCarriageHeatTypeUpdateMutation, NpsCarriageHeatTypeUpdateMutationVariables>;
export const NpsCarriageLengthCreateDocument = /*#__PURE__*/ gql`
    mutation npsCarriageLengthCreate($data: CreateNpsCarriageLengthDto!) {
  classifiers {
    npsCarriageLength {
      create(data: $data) {
        id
      }
    }
  }
}
    `;
export type NpsCarriageLengthCreateMutationFn = Apollo.MutationFunction<NpsCarriageLengthCreateMutation, NpsCarriageLengthCreateMutationVariables>;

/**
 * __useNpsCarriageLengthCreateMutation__
 *
 * To run a mutation, you first call `useNpsCarriageLengthCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageLengthCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsCarriageLengthCreateMutation, { data, loading, error }] = useNpsCarriageLengthCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNpsCarriageLengthCreateMutation(baseOptions?: Apollo.MutationHookOptions<NpsCarriageLengthCreateMutation, NpsCarriageLengthCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsCarriageLengthCreateMutation, NpsCarriageLengthCreateMutationVariables>(NpsCarriageLengthCreateDocument, options);
      }
export type NpsCarriageLengthCreateMutationHookResult = ReturnType<typeof useNpsCarriageLengthCreateMutation>;
export type NpsCarriageLengthCreateMutationResult = Apollo.MutationResult<NpsCarriageLengthCreateMutation>;
export type NpsCarriageLengthCreateMutationOptions = Apollo.BaseMutationOptions<NpsCarriageLengthCreateMutation, NpsCarriageLengthCreateMutationVariables>;
export const NpsCarriageLengthHistoryDocument = /*#__PURE__*/ gql`
    query npsCarriageLengthHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [NpsCarriageLengthQueryResolver_History_SortingInputType!]) {
  classifiers {
    npsCarriageLength {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          ...NpsCarriageLengthBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${NpsCarriageLengthBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageLengthHistoryQuery__
 *
 * To run a query within a React component, call `useNpsCarriageLengthHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageLengthHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageLengthHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useNpsCarriageLengthHistoryQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageLengthHistoryQuery, NpsCarriageLengthHistoryQueryVariables> & ({ variables: NpsCarriageLengthHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageLengthHistoryQuery, NpsCarriageLengthHistoryQueryVariables>(NpsCarriageLengthHistoryDocument, options);
      }
export function useNpsCarriageLengthHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageLengthHistoryQuery, NpsCarriageLengthHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageLengthHistoryQuery, NpsCarriageLengthHistoryQueryVariables>(NpsCarriageLengthHistoryDocument, options);
        }
export function useNpsCarriageLengthHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageLengthHistoryQuery, NpsCarriageLengthHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageLengthHistoryQuery, NpsCarriageLengthHistoryQueryVariables>(NpsCarriageLengthHistoryDocument, options);
        }
export type NpsCarriageLengthHistoryQueryHookResult = ReturnType<typeof useNpsCarriageLengthHistoryQuery>;
export type NpsCarriageLengthHistoryLazyQueryHookResult = ReturnType<typeof useNpsCarriageLengthHistoryLazyQuery>;
export type NpsCarriageLengthHistorySuspenseQueryHookResult = ReturnType<typeof useNpsCarriageLengthHistorySuspenseQuery>;
export type NpsCarriageLengthHistoryQueryResult = Apollo.QueryResult<NpsCarriageLengthHistoryQuery, NpsCarriageLengthHistoryQueryVariables>;
export const NpsCarriageLengthListDocument = /*#__PURE__*/ gql`
    query npsCarriageLengthList($paginate: PaginatorArgsDto, $orderBy: [NpsCarriageLengthQueryResolver_List_SortingInputType!], $where: NpsCarriageLengthQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    npsCarriageLength {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...NpsCarriageLengthBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${NpsCarriageLengthBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageLengthListQuery__
 *
 * To run a query within a React component, call `useNpsCarriageLengthListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageLengthListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageLengthListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageLengthListQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageLengthListQuery, NpsCarriageLengthListQueryVariables> & ({ variables: NpsCarriageLengthListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageLengthListQuery, NpsCarriageLengthListQueryVariables>(NpsCarriageLengthListDocument, options);
      }
export function useNpsCarriageLengthListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageLengthListQuery, NpsCarriageLengthListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageLengthListQuery, NpsCarriageLengthListQueryVariables>(NpsCarriageLengthListDocument, options);
        }
export function useNpsCarriageLengthListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageLengthListQuery, NpsCarriageLengthListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageLengthListQuery, NpsCarriageLengthListQueryVariables>(NpsCarriageLengthListDocument, options);
        }
export type NpsCarriageLengthListQueryHookResult = ReturnType<typeof useNpsCarriageLengthListQuery>;
export type NpsCarriageLengthListLazyQueryHookResult = ReturnType<typeof useNpsCarriageLengthListLazyQuery>;
export type NpsCarriageLengthListSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageLengthListSuspenseQuery>;
export type NpsCarriageLengthListQueryResult = Apollo.QueryResult<NpsCarriageLengthListQuery, NpsCarriageLengthListQueryVariables>;
export const NpsCarriageLengthRangeByIdDocument = /*#__PURE__*/ gql`
    query npsCarriageLengthRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    npsCarriageLength {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useNpsCarriageLengthRangeByIdQuery__
 *
 * To run a query within a React component, call `useNpsCarriageLengthRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageLengthRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageLengthRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageLengthRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageLengthRangeByIdQuery, NpsCarriageLengthRangeByIdQueryVariables> & ({ variables: NpsCarriageLengthRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageLengthRangeByIdQuery, NpsCarriageLengthRangeByIdQueryVariables>(NpsCarriageLengthRangeByIdDocument, options);
      }
export function useNpsCarriageLengthRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageLengthRangeByIdQuery, NpsCarriageLengthRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageLengthRangeByIdQuery, NpsCarriageLengthRangeByIdQueryVariables>(NpsCarriageLengthRangeByIdDocument, options);
        }
export function useNpsCarriageLengthRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageLengthRangeByIdQuery, NpsCarriageLengthRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageLengthRangeByIdQuery, NpsCarriageLengthRangeByIdQueryVariables>(NpsCarriageLengthRangeByIdDocument, options);
        }
export type NpsCarriageLengthRangeByIdQueryHookResult = ReturnType<typeof useNpsCarriageLengthRangeByIdQuery>;
export type NpsCarriageLengthRangeByIdLazyQueryHookResult = ReturnType<typeof useNpsCarriageLengthRangeByIdLazyQuery>;
export type NpsCarriageLengthRangeByIdSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageLengthRangeByIdSuspenseQuery>;
export type NpsCarriageLengthRangeByIdQueryResult = Apollo.QueryResult<NpsCarriageLengthRangeByIdQuery, NpsCarriageLengthRangeByIdQueryVariables>;
export const NpsCarriageLengthUpdateDocument = /*#__PURE__*/ gql`
    mutation npsCarriageLengthUpdate($data: UpdateNpsCarriageLengthDto!) {
  classifiers {
    npsCarriageLength {
      update(data: $data) {
        id
      }
    }
  }
}
    `;
export type NpsCarriageLengthUpdateMutationFn = Apollo.MutationFunction<NpsCarriageLengthUpdateMutation, NpsCarriageLengthUpdateMutationVariables>;

/**
 * __useNpsCarriageLengthUpdateMutation__
 *
 * To run a mutation, you first call `useNpsCarriageLengthUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageLengthUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsCarriageLengthUpdateMutation, { data, loading, error }] = useNpsCarriageLengthUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNpsCarriageLengthUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NpsCarriageLengthUpdateMutation, NpsCarriageLengthUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsCarriageLengthUpdateMutation, NpsCarriageLengthUpdateMutationVariables>(NpsCarriageLengthUpdateDocument, options);
      }
export type NpsCarriageLengthUpdateMutationHookResult = ReturnType<typeof useNpsCarriageLengthUpdateMutation>;
export type NpsCarriageLengthUpdateMutationResult = Apollo.MutationResult<NpsCarriageLengthUpdateMutation>;
export type NpsCarriageLengthUpdateMutationOptions = Apollo.BaseMutationOptions<NpsCarriageLengthUpdateMutation, NpsCarriageLengthUpdateMutationVariables>;
export const NpsCarriageModelCreateDocument = /*#__PURE__*/ gql`
    mutation npsCarriageModelCreate($data: CreateNpsCarriageModelDto!) {
  classifiers {
    npsCarriageModel {
      create(data: $data) {
        id
      }
    }
  }
}
    `;
export type NpsCarriageModelCreateMutationFn = Apollo.MutationFunction<NpsCarriageModelCreateMutation, NpsCarriageModelCreateMutationVariables>;

/**
 * __useNpsCarriageModelCreateMutation__
 *
 * To run a mutation, you first call `useNpsCarriageModelCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageModelCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsCarriageModelCreateMutation, { data, loading, error }] = useNpsCarriageModelCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNpsCarriageModelCreateMutation(baseOptions?: Apollo.MutationHookOptions<NpsCarriageModelCreateMutation, NpsCarriageModelCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsCarriageModelCreateMutation, NpsCarriageModelCreateMutationVariables>(NpsCarriageModelCreateDocument, options);
      }
export type NpsCarriageModelCreateMutationHookResult = ReturnType<typeof useNpsCarriageModelCreateMutation>;
export type NpsCarriageModelCreateMutationResult = Apollo.MutationResult<NpsCarriageModelCreateMutation>;
export type NpsCarriageModelCreateMutationOptions = Apollo.BaseMutationOptions<NpsCarriageModelCreateMutation, NpsCarriageModelCreateMutationVariables>;
export const NpsCarriageModelHistoryDocument = /*#__PURE__*/ gql`
    query npsCarriageModelHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [NpsCarriageModelQueryResolver_History_SortingInputType!]) {
  classifiers {
    npsCarriageModel {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          ...NpsCarriageModelBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${NpsCarriageModelBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageModelHistoryQuery__
 *
 * To run a query within a React component, call `useNpsCarriageModelHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageModelHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageModelHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useNpsCarriageModelHistoryQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageModelHistoryQuery, NpsCarriageModelHistoryQueryVariables> & ({ variables: NpsCarriageModelHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageModelHistoryQuery, NpsCarriageModelHistoryQueryVariables>(NpsCarriageModelHistoryDocument, options);
      }
export function useNpsCarriageModelHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageModelHistoryQuery, NpsCarriageModelHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageModelHistoryQuery, NpsCarriageModelHistoryQueryVariables>(NpsCarriageModelHistoryDocument, options);
        }
export function useNpsCarriageModelHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageModelHistoryQuery, NpsCarriageModelHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageModelHistoryQuery, NpsCarriageModelHistoryQueryVariables>(NpsCarriageModelHistoryDocument, options);
        }
export type NpsCarriageModelHistoryQueryHookResult = ReturnType<typeof useNpsCarriageModelHistoryQuery>;
export type NpsCarriageModelHistoryLazyQueryHookResult = ReturnType<typeof useNpsCarriageModelHistoryLazyQuery>;
export type NpsCarriageModelHistorySuspenseQueryHookResult = ReturnType<typeof useNpsCarriageModelHistorySuspenseQuery>;
export type NpsCarriageModelHistoryQueryResult = Apollo.QueryResult<NpsCarriageModelHistoryQuery, NpsCarriageModelHistoryQueryVariables>;
export const NpsCarriageModelListDocument = /*#__PURE__*/ gql`
    query npsCarriageModelList($paginate: PaginatorArgsDto, $orderBy: [NpsCarriageModelQueryResolver_List_SortingInputType!], $where: NpsCarriageModelQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    npsCarriageModel {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...NpsCarriageModelBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${NpsCarriageModelBaseFragmentFragmentDoc}`;

/**
 * __useNpsCarriageModelListQuery__
 *
 * To run a query within a React component, call `useNpsCarriageModelListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageModelListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageModelListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageModelListQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageModelListQuery, NpsCarriageModelListQueryVariables> & ({ variables: NpsCarriageModelListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageModelListQuery, NpsCarriageModelListQueryVariables>(NpsCarriageModelListDocument, options);
      }
export function useNpsCarriageModelListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageModelListQuery, NpsCarriageModelListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageModelListQuery, NpsCarriageModelListQueryVariables>(NpsCarriageModelListDocument, options);
        }
export function useNpsCarriageModelListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageModelListQuery, NpsCarriageModelListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageModelListQuery, NpsCarriageModelListQueryVariables>(NpsCarriageModelListDocument, options);
        }
export type NpsCarriageModelListQueryHookResult = ReturnType<typeof useNpsCarriageModelListQuery>;
export type NpsCarriageModelListLazyQueryHookResult = ReturnType<typeof useNpsCarriageModelListLazyQuery>;
export type NpsCarriageModelListSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageModelListSuspenseQuery>;
export type NpsCarriageModelListQueryResult = Apollo.QueryResult<NpsCarriageModelListQuery, NpsCarriageModelListQueryVariables>;
export const NpsCarriageModelRangeByIdDocument = /*#__PURE__*/ gql`
    query npsCarriageModelRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    npsCarriageModel {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useNpsCarriageModelRangeByIdQuery__
 *
 * To run a query within a React component, call `useNpsCarriageModelRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageModelRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsCarriageModelRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNpsCarriageModelRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<NpsCarriageModelRangeByIdQuery, NpsCarriageModelRangeByIdQueryVariables> & ({ variables: NpsCarriageModelRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsCarriageModelRangeByIdQuery, NpsCarriageModelRangeByIdQueryVariables>(NpsCarriageModelRangeByIdDocument, options);
      }
export function useNpsCarriageModelRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsCarriageModelRangeByIdQuery, NpsCarriageModelRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsCarriageModelRangeByIdQuery, NpsCarriageModelRangeByIdQueryVariables>(NpsCarriageModelRangeByIdDocument, options);
        }
export function useNpsCarriageModelRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NpsCarriageModelRangeByIdQuery, NpsCarriageModelRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsCarriageModelRangeByIdQuery, NpsCarriageModelRangeByIdQueryVariables>(NpsCarriageModelRangeByIdDocument, options);
        }
export type NpsCarriageModelRangeByIdQueryHookResult = ReturnType<typeof useNpsCarriageModelRangeByIdQuery>;
export type NpsCarriageModelRangeByIdLazyQueryHookResult = ReturnType<typeof useNpsCarriageModelRangeByIdLazyQuery>;
export type NpsCarriageModelRangeByIdSuspenseQueryHookResult = ReturnType<typeof useNpsCarriageModelRangeByIdSuspenseQuery>;
export type NpsCarriageModelRangeByIdQueryResult = Apollo.QueryResult<NpsCarriageModelRangeByIdQuery, NpsCarriageModelRangeByIdQueryVariables>;
export const NpsCarriageModelUpdateDocument = /*#__PURE__*/ gql`
    mutation npsCarriageModelUpdate($data: UpdateNpsCarriageModelDto!) {
  classifiers {
    npsCarriageModel {
      update(data: $data) {
        id
      }
    }
  }
}
    `;
export type NpsCarriageModelUpdateMutationFn = Apollo.MutationFunction<NpsCarriageModelUpdateMutation, NpsCarriageModelUpdateMutationVariables>;

/**
 * __useNpsCarriageModelUpdateMutation__
 *
 * To run a mutation, you first call `useNpsCarriageModelUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsCarriageModelUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsCarriageModelUpdateMutation, { data, loading, error }] = useNpsCarriageModelUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNpsCarriageModelUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NpsCarriageModelUpdateMutation, NpsCarriageModelUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsCarriageModelUpdateMutation, NpsCarriageModelUpdateMutationVariables>(NpsCarriageModelUpdateDocument, options);
      }
export type NpsCarriageModelUpdateMutationHookResult = ReturnType<typeof useNpsCarriageModelUpdateMutation>;
export type NpsCarriageModelUpdateMutationResult = Apollo.MutationResult<NpsCarriageModelUpdateMutation>;
export type NpsCarriageModelUpdateMutationOptions = Apollo.BaseMutationOptions<NpsCarriageModelUpdateMutation, NpsCarriageModelUpdateMutationVariables>;
export const CarriageSeatAllocationCreateDocument = /*#__PURE__*/ gql`
    mutation carriageSeatAllocationCreate($data: CreateCarriageSeatAllocationDto!) {
  classifiers {
    carriageSeatAllocation {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type CarriageSeatAllocationCreateMutationFn = Apollo.MutationFunction<CarriageSeatAllocationCreateMutation, CarriageSeatAllocationCreateMutationVariables>;

/**
 * __useCarriageSeatAllocationCreateMutation__
 *
 * To run a mutation, you first call `useCarriageSeatAllocationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageSeatAllocationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageSeatAllocationCreateMutation, { data, loading, error }] = useCarriageSeatAllocationCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageSeatAllocationCreateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageSeatAllocationCreateMutation, CarriageSeatAllocationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageSeatAllocationCreateMutation, CarriageSeatAllocationCreateMutationVariables>(CarriageSeatAllocationCreateDocument, options);
      }
export type CarriageSeatAllocationCreateMutationHookResult = ReturnType<typeof useCarriageSeatAllocationCreateMutation>;
export type CarriageSeatAllocationCreateMutationResult = Apollo.MutationResult<CarriageSeatAllocationCreateMutation>;
export type CarriageSeatAllocationCreateMutationOptions = Apollo.BaseMutationOptions<CarriageSeatAllocationCreateMutation, CarriageSeatAllocationCreateMutationVariables>;
export const CarriageSeatAllocationHistoryDocument = /*#__PURE__*/ gql`
    query carriageSeatAllocationHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [CarriageSeatAllocationQueryResolver_History_SortingInputType!]) {
  classifiers {
    carriageSeatAllocation {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          ...CarriageSeatAllocationBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${CarriageSeatAllocationBaseFragmentFragmentDoc}`;

/**
 * __useCarriageSeatAllocationHistoryQuery__
 *
 * To run a query within a React component, call `useCarriageSeatAllocationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageSeatAllocationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageSeatAllocationHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCarriageSeatAllocationHistoryQuery(baseOptions: Apollo.QueryHookOptions<CarriageSeatAllocationHistoryQuery, CarriageSeatAllocationHistoryQueryVariables> & ({ variables: CarriageSeatAllocationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageSeatAllocationHistoryQuery, CarriageSeatAllocationHistoryQueryVariables>(CarriageSeatAllocationHistoryDocument, options);
      }
export function useCarriageSeatAllocationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageSeatAllocationHistoryQuery, CarriageSeatAllocationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageSeatAllocationHistoryQuery, CarriageSeatAllocationHistoryQueryVariables>(CarriageSeatAllocationHistoryDocument, options);
        }
export function useCarriageSeatAllocationHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageSeatAllocationHistoryQuery, CarriageSeatAllocationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageSeatAllocationHistoryQuery, CarriageSeatAllocationHistoryQueryVariables>(CarriageSeatAllocationHistoryDocument, options);
        }
export type CarriageSeatAllocationHistoryQueryHookResult = ReturnType<typeof useCarriageSeatAllocationHistoryQuery>;
export type CarriageSeatAllocationHistoryLazyQueryHookResult = ReturnType<typeof useCarriageSeatAllocationHistoryLazyQuery>;
export type CarriageSeatAllocationHistorySuspenseQueryHookResult = ReturnType<typeof useCarriageSeatAllocationHistorySuspenseQuery>;
export type CarriageSeatAllocationHistoryQueryResult = Apollo.QueryResult<CarriageSeatAllocationHistoryQuery, CarriageSeatAllocationHistoryQueryVariables>;
export const CarriageSeatAllocationListDocument = /*#__PURE__*/ gql`
    query carriageSeatAllocationList($paginate: PaginatorArgsDto, $orderBy: [CarriageSeatAllocationQueryResolver_List_SortingInputType!], $where: CarriageSeatAllocationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    carriageSeatAllocation {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...CarriageSeatAllocationBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${CarriageSeatAllocationBaseFragmentFragmentDoc}`;

/**
 * __useCarriageSeatAllocationListQuery__
 *
 * To run a query within a React component, call `useCarriageSeatAllocationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageSeatAllocationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageSeatAllocationListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageSeatAllocationListQuery(baseOptions: Apollo.QueryHookOptions<CarriageSeatAllocationListQuery, CarriageSeatAllocationListQueryVariables> & ({ variables: CarriageSeatAllocationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageSeatAllocationListQuery, CarriageSeatAllocationListQueryVariables>(CarriageSeatAllocationListDocument, options);
      }
export function useCarriageSeatAllocationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageSeatAllocationListQuery, CarriageSeatAllocationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageSeatAllocationListQuery, CarriageSeatAllocationListQueryVariables>(CarriageSeatAllocationListDocument, options);
        }
export function useCarriageSeatAllocationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageSeatAllocationListQuery, CarriageSeatAllocationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageSeatAllocationListQuery, CarriageSeatAllocationListQueryVariables>(CarriageSeatAllocationListDocument, options);
        }
export type CarriageSeatAllocationListQueryHookResult = ReturnType<typeof useCarriageSeatAllocationListQuery>;
export type CarriageSeatAllocationListLazyQueryHookResult = ReturnType<typeof useCarriageSeatAllocationListLazyQuery>;
export type CarriageSeatAllocationListSuspenseQueryHookResult = ReturnType<typeof useCarriageSeatAllocationListSuspenseQuery>;
export type CarriageSeatAllocationListQueryResult = Apollo.QueryResult<CarriageSeatAllocationListQuery, CarriageSeatAllocationListQueryVariables>;
export const CarriageSeatAllocationRangeByIdDocument = /*#__PURE__*/ gql`
    query carriageSeatAllocationRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    carriageSeatAllocation {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useCarriageSeatAllocationRangeByIdQuery__
 *
 * To run a query within a React component, call `useCarriageSeatAllocationRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageSeatAllocationRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageSeatAllocationRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageSeatAllocationRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<CarriageSeatAllocationRangeByIdQuery, CarriageSeatAllocationRangeByIdQueryVariables> & ({ variables: CarriageSeatAllocationRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageSeatAllocationRangeByIdQuery, CarriageSeatAllocationRangeByIdQueryVariables>(CarriageSeatAllocationRangeByIdDocument, options);
      }
export function useCarriageSeatAllocationRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageSeatAllocationRangeByIdQuery, CarriageSeatAllocationRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageSeatAllocationRangeByIdQuery, CarriageSeatAllocationRangeByIdQueryVariables>(CarriageSeatAllocationRangeByIdDocument, options);
        }
export function useCarriageSeatAllocationRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageSeatAllocationRangeByIdQuery, CarriageSeatAllocationRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageSeatAllocationRangeByIdQuery, CarriageSeatAllocationRangeByIdQueryVariables>(CarriageSeatAllocationRangeByIdDocument, options);
        }
export type CarriageSeatAllocationRangeByIdQueryHookResult = ReturnType<typeof useCarriageSeatAllocationRangeByIdQuery>;
export type CarriageSeatAllocationRangeByIdLazyQueryHookResult = ReturnType<typeof useCarriageSeatAllocationRangeByIdLazyQuery>;
export type CarriageSeatAllocationRangeByIdSuspenseQueryHookResult = ReturnType<typeof useCarriageSeatAllocationRangeByIdSuspenseQuery>;
export type CarriageSeatAllocationRangeByIdQueryResult = Apollo.QueryResult<CarriageSeatAllocationRangeByIdQuery, CarriageSeatAllocationRangeByIdQueryVariables>;
export const CarriageSeatAllocationUpdateDocument = /*#__PURE__*/ gql`
    mutation carriageSeatAllocationUpdate($data: UpdateCarriageSeatAllocationDto!) {
  classifiers {
    carriageSeatAllocation {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type CarriageSeatAllocationUpdateMutationFn = Apollo.MutationFunction<CarriageSeatAllocationUpdateMutation, CarriageSeatAllocationUpdateMutationVariables>;

/**
 * __useCarriageSeatAllocationUpdateMutation__
 *
 * To run a mutation, you first call `useCarriageSeatAllocationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageSeatAllocationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageSeatAllocationUpdateMutation, { data, loading, error }] = useCarriageSeatAllocationUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageSeatAllocationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageSeatAllocationUpdateMutation, CarriageSeatAllocationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageSeatAllocationUpdateMutation, CarriageSeatAllocationUpdateMutationVariables>(CarriageSeatAllocationUpdateDocument, options);
      }
export type CarriageSeatAllocationUpdateMutationHookResult = ReturnType<typeof useCarriageSeatAllocationUpdateMutation>;
export type CarriageSeatAllocationUpdateMutationResult = Apollo.MutationResult<CarriageSeatAllocationUpdateMutation>;
export type CarriageSeatAllocationUpdateMutationOptions = Apollo.BaseMutationOptions<CarriageSeatAllocationUpdateMutation, CarriageSeatAllocationUpdateMutationVariables>;
export const CarriageServiceClassCreateDocument = /*#__PURE__*/ gql`
    mutation carriageServiceClassCreate($data: CreateCarriageServiceClassDto!) {
  classifiers {
    carriageServiceClass {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type CarriageServiceClassCreateMutationFn = Apollo.MutationFunction<CarriageServiceClassCreateMutation, CarriageServiceClassCreateMutationVariables>;

/**
 * __useCarriageServiceClassCreateMutation__
 *
 * To run a mutation, you first call `useCarriageServiceClassCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageServiceClassCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageServiceClassCreateMutation, { data, loading, error }] = useCarriageServiceClassCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageServiceClassCreateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageServiceClassCreateMutation, CarriageServiceClassCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageServiceClassCreateMutation, CarriageServiceClassCreateMutationVariables>(CarriageServiceClassCreateDocument, options);
      }
export type CarriageServiceClassCreateMutationHookResult = ReturnType<typeof useCarriageServiceClassCreateMutation>;
export type CarriageServiceClassCreateMutationResult = Apollo.MutationResult<CarriageServiceClassCreateMutation>;
export type CarriageServiceClassCreateMutationOptions = Apollo.BaseMutationOptions<CarriageServiceClassCreateMutation, CarriageServiceClassCreateMutationVariables>;
export const CarriageServiceClassHistoryDocument = /*#__PURE__*/ gql`
    query carriageServiceClassHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [CarriageServiceClassQueryResolver_History_SortingInputType!]) {
  classifiers {
    carriageServiceClass {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          ...CarriageServiceClassBaseFragment
          available_service_classes {
            ...AvailableServiceClassBaseFragment
          }
          carriage_types_for_schema {
            ...CarriageTypesForSchemaBaseFragment
          }
        }
        totalCount
      }
    }
  }
}
    ${CarriageServiceClassBaseFragmentFragmentDoc}
${AvailableServiceClassBaseFragmentFragmentDoc}
${CarriageTypesForSchemaBaseFragmentFragmentDoc}`;

/**
 * __useCarriageServiceClassHistoryQuery__
 *
 * To run a query within a React component, call `useCarriageServiceClassHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageServiceClassHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageServiceClassHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCarriageServiceClassHistoryQuery(baseOptions: Apollo.QueryHookOptions<CarriageServiceClassHistoryQuery, CarriageServiceClassHistoryQueryVariables> & ({ variables: CarriageServiceClassHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageServiceClassHistoryQuery, CarriageServiceClassHistoryQueryVariables>(CarriageServiceClassHistoryDocument, options);
      }
export function useCarriageServiceClassHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageServiceClassHistoryQuery, CarriageServiceClassHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageServiceClassHistoryQuery, CarriageServiceClassHistoryQueryVariables>(CarriageServiceClassHistoryDocument, options);
        }
export function useCarriageServiceClassHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageServiceClassHistoryQuery, CarriageServiceClassHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageServiceClassHistoryQuery, CarriageServiceClassHistoryQueryVariables>(CarriageServiceClassHistoryDocument, options);
        }
export type CarriageServiceClassHistoryQueryHookResult = ReturnType<typeof useCarriageServiceClassHistoryQuery>;
export type CarriageServiceClassHistoryLazyQueryHookResult = ReturnType<typeof useCarriageServiceClassHistoryLazyQuery>;
export type CarriageServiceClassHistorySuspenseQueryHookResult = ReturnType<typeof useCarriageServiceClassHistorySuspenseQuery>;
export type CarriageServiceClassHistoryQueryResult = Apollo.QueryResult<CarriageServiceClassHistoryQuery, CarriageServiceClassHistoryQueryVariables>;
export const CarriageServiceClassListDocument = /*#__PURE__*/ gql`
    query carriageServiceClassList($paginate: PaginatorArgsDto, $orderBy: [CarriageServiceClassQueryResolver_List_SortingInputType!], $where: CarriageServiceClassQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    carriageServiceClass {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...CarriageServiceClassBaseFragment
          available_service_classes {
            ...AvailableServiceClassBaseFragment
          }
          carriage_types_for_schema {
            ...CarriageTypesForSchemaBaseFragment
          }
        }
        totalCount
      }
    }
  }
}
    ${CarriageServiceClassBaseFragmentFragmentDoc}
${AvailableServiceClassBaseFragmentFragmentDoc}
${CarriageTypesForSchemaBaseFragmentFragmentDoc}`;

/**
 * __useCarriageServiceClassListQuery__
 *
 * To run a query within a React component, call `useCarriageServiceClassListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageServiceClassListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageServiceClassListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageServiceClassListQuery(baseOptions: Apollo.QueryHookOptions<CarriageServiceClassListQuery, CarriageServiceClassListQueryVariables> & ({ variables: CarriageServiceClassListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageServiceClassListQuery, CarriageServiceClassListQueryVariables>(CarriageServiceClassListDocument, options);
      }
export function useCarriageServiceClassListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageServiceClassListQuery, CarriageServiceClassListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageServiceClassListQuery, CarriageServiceClassListQueryVariables>(CarriageServiceClassListDocument, options);
        }
export function useCarriageServiceClassListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageServiceClassListQuery, CarriageServiceClassListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageServiceClassListQuery, CarriageServiceClassListQueryVariables>(CarriageServiceClassListDocument, options);
        }
export type CarriageServiceClassListQueryHookResult = ReturnType<typeof useCarriageServiceClassListQuery>;
export type CarriageServiceClassListLazyQueryHookResult = ReturnType<typeof useCarriageServiceClassListLazyQuery>;
export type CarriageServiceClassListSuspenseQueryHookResult = ReturnType<typeof useCarriageServiceClassListSuspenseQuery>;
export type CarriageServiceClassListQueryResult = Apollo.QueryResult<CarriageServiceClassListQuery, CarriageServiceClassListQueryVariables>;
export const CarriageServiceClassRangeByIdDocument = /*#__PURE__*/ gql`
    query carriageServiceClassRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    carriageServiceClass {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useCarriageServiceClassRangeByIdQuery__
 *
 * To run a query within a React component, call `useCarriageServiceClassRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageServiceClassRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageServiceClassRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageServiceClassRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<CarriageServiceClassRangeByIdQuery, CarriageServiceClassRangeByIdQueryVariables> & ({ variables: CarriageServiceClassRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageServiceClassRangeByIdQuery, CarriageServiceClassRangeByIdQueryVariables>(CarriageServiceClassRangeByIdDocument, options);
      }
export function useCarriageServiceClassRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageServiceClassRangeByIdQuery, CarriageServiceClassRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageServiceClassRangeByIdQuery, CarriageServiceClassRangeByIdQueryVariables>(CarriageServiceClassRangeByIdDocument, options);
        }
export function useCarriageServiceClassRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageServiceClassRangeByIdQuery, CarriageServiceClassRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageServiceClassRangeByIdQuery, CarriageServiceClassRangeByIdQueryVariables>(CarriageServiceClassRangeByIdDocument, options);
        }
export type CarriageServiceClassRangeByIdQueryHookResult = ReturnType<typeof useCarriageServiceClassRangeByIdQuery>;
export type CarriageServiceClassRangeByIdLazyQueryHookResult = ReturnType<typeof useCarriageServiceClassRangeByIdLazyQuery>;
export type CarriageServiceClassRangeByIdSuspenseQueryHookResult = ReturnType<typeof useCarriageServiceClassRangeByIdSuspenseQuery>;
export type CarriageServiceClassRangeByIdQueryResult = Apollo.QueryResult<CarriageServiceClassRangeByIdQuery, CarriageServiceClassRangeByIdQueryVariables>;
export const CarriageServiceClassUpdateDocument = /*#__PURE__*/ gql`
    mutation carriageServiceClassUpdate($data: UpdateCarriageServiceClassDto!) {
  classifiers {
    carriageServiceClass {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type CarriageServiceClassUpdateMutationFn = Apollo.MutationFunction<CarriageServiceClassUpdateMutation, CarriageServiceClassUpdateMutationVariables>;

/**
 * __useCarriageServiceClassUpdateMutation__
 *
 * To run a mutation, you first call `useCarriageServiceClassUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageServiceClassUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageServiceClassUpdateMutation, { data, loading, error }] = useCarriageServiceClassUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageServiceClassUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageServiceClassUpdateMutation, CarriageServiceClassUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageServiceClassUpdateMutation, CarriageServiceClassUpdateMutationVariables>(CarriageServiceClassUpdateDocument, options);
      }
export type CarriageServiceClassUpdateMutationHookResult = ReturnType<typeof useCarriageServiceClassUpdateMutation>;
export type CarriageServiceClassUpdateMutationResult = Apollo.MutationResult<CarriageServiceClassUpdateMutation>;
export type CarriageServiceClassUpdateMutationOptions = Apollo.BaseMutationOptions<CarriageServiceClassUpdateMutation, CarriageServiceClassUpdateMutationVariables>;
export const CarriageTypeAsuDimensionSeatsCountCreateDocument = /*#__PURE__*/ gql`
    mutation carriageTypeAsuDimensionSeatsCountCreate($data: CreateCarriageTypeAsuDimensionSeatsCountDto!) {
  classifiers {
    carriageTypeAsuDimensionSeatsCount {
      create(data: $data) {
        id
      }
    }
  }
}
    `;
export type CarriageTypeAsuDimensionSeatsCountCreateMutationFn = Apollo.MutationFunction<CarriageTypeAsuDimensionSeatsCountCreateMutation, CarriageTypeAsuDimensionSeatsCountCreateMutationVariables>;

/**
 * __useCarriageTypeAsuDimensionSeatsCountCreateMutation__
 *
 * To run a mutation, you first call `useCarriageTypeAsuDimensionSeatsCountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeAsuDimensionSeatsCountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageTypeAsuDimensionSeatsCountCreateMutation, { data, loading, error }] = useCarriageTypeAsuDimensionSeatsCountCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageTypeAsuDimensionSeatsCountCreateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageTypeAsuDimensionSeatsCountCreateMutation, CarriageTypeAsuDimensionSeatsCountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageTypeAsuDimensionSeatsCountCreateMutation, CarriageTypeAsuDimensionSeatsCountCreateMutationVariables>(CarriageTypeAsuDimensionSeatsCountCreateDocument, options);
      }
export type CarriageTypeAsuDimensionSeatsCountCreateMutationHookResult = ReturnType<typeof useCarriageTypeAsuDimensionSeatsCountCreateMutation>;
export type CarriageTypeAsuDimensionSeatsCountCreateMutationResult = Apollo.MutationResult<CarriageTypeAsuDimensionSeatsCountCreateMutation>;
export type CarriageTypeAsuDimensionSeatsCountCreateMutationOptions = Apollo.BaseMutationOptions<CarriageTypeAsuDimensionSeatsCountCreateMutation, CarriageTypeAsuDimensionSeatsCountCreateMutationVariables>;
export const CarriageTypeAsuDimensionSeatsCountListDocument = /*#__PURE__*/ gql`
    query carriageTypeAsuDimensionSeatsCountList($paginate: PaginatorArgsDto, $orderBy: [CarriageTypeAsuDimensionSeatsCountQueryResolver_List_SortingInputType!], $where: CarriageTypeAsuDimensionSeatsCountQueryResolver_List_FilterInputType) {
  classifiers {
    carriageTypeAsuDimensionSeatsCount {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        items {
          ...CarriageTypeAsuDimensionSeatsCountShortFragment
          carriage_dimension {
            ...NpsCarriageDimensionShortFragment
          }
          carriage_type_asu {
            ...CarriageTypeAsuBaseFragment
          }
        }
        totalCount
      }
    }
  }
}
    ${CarriageTypeAsuDimensionSeatsCountShortFragmentFragmentDoc}
${NpsCarriageDimensionShortFragmentFragmentDoc}
${CarriageTypeAsuBaseFragmentFragmentDoc}`;

/**
 * __useCarriageTypeAsuDimensionSeatsCountListQuery__
 *
 * To run a query within a React component, call `useCarriageTypeAsuDimensionSeatsCountListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeAsuDimensionSeatsCountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypeAsuDimensionSeatsCountListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCarriageTypeAsuDimensionSeatsCountListQuery(baseOptions?: Apollo.QueryHookOptions<CarriageTypeAsuDimensionSeatsCountListQuery, CarriageTypeAsuDimensionSeatsCountListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypeAsuDimensionSeatsCountListQuery, CarriageTypeAsuDimensionSeatsCountListQueryVariables>(CarriageTypeAsuDimensionSeatsCountListDocument, options);
      }
export function useCarriageTypeAsuDimensionSeatsCountListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypeAsuDimensionSeatsCountListQuery, CarriageTypeAsuDimensionSeatsCountListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypeAsuDimensionSeatsCountListQuery, CarriageTypeAsuDimensionSeatsCountListQueryVariables>(CarriageTypeAsuDimensionSeatsCountListDocument, options);
        }
export function useCarriageTypeAsuDimensionSeatsCountListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypeAsuDimensionSeatsCountListQuery, CarriageTypeAsuDimensionSeatsCountListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypeAsuDimensionSeatsCountListQuery, CarriageTypeAsuDimensionSeatsCountListQueryVariables>(CarriageTypeAsuDimensionSeatsCountListDocument, options);
        }
export type CarriageTypeAsuDimensionSeatsCountListQueryHookResult = ReturnType<typeof useCarriageTypeAsuDimensionSeatsCountListQuery>;
export type CarriageTypeAsuDimensionSeatsCountListLazyQueryHookResult = ReturnType<typeof useCarriageTypeAsuDimensionSeatsCountListLazyQuery>;
export type CarriageTypeAsuDimensionSeatsCountListSuspenseQueryHookResult = ReturnType<typeof useCarriageTypeAsuDimensionSeatsCountListSuspenseQuery>;
export type CarriageTypeAsuDimensionSeatsCountListQueryResult = Apollo.QueryResult<CarriageTypeAsuDimensionSeatsCountListQuery, CarriageTypeAsuDimensionSeatsCountListQueryVariables>;
export const CarriageTypeAsuDimensionSeatsCountUpdateDocument = /*#__PURE__*/ gql`
    mutation carriageTypeAsuDimensionSeatsCountUpdate($data: UpdateCarriageTypeAsuDimensionSeatsCountDto!) {
  classifiers {
    carriageTypeAsuDimensionSeatsCount {
      update(data: $data) {
        id
      }
    }
  }
}
    `;
export type CarriageTypeAsuDimensionSeatsCountUpdateMutationFn = Apollo.MutationFunction<CarriageTypeAsuDimensionSeatsCountUpdateMutation, CarriageTypeAsuDimensionSeatsCountUpdateMutationVariables>;

/**
 * __useCarriageTypeAsuDimensionSeatsCountUpdateMutation__
 *
 * To run a mutation, you first call `useCarriageTypeAsuDimensionSeatsCountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeAsuDimensionSeatsCountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageTypeAsuDimensionSeatsCountUpdateMutation, { data, loading, error }] = useCarriageTypeAsuDimensionSeatsCountUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageTypeAsuDimensionSeatsCountUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageTypeAsuDimensionSeatsCountUpdateMutation, CarriageTypeAsuDimensionSeatsCountUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageTypeAsuDimensionSeatsCountUpdateMutation, CarriageTypeAsuDimensionSeatsCountUpdateMutationVariables>(CarriageTypeAsuDimensionSeatsCountUpdateDocument, options);
      }
export type CarriageTypeAsuDimensionSeatsCountUpdateMutationHookResult = ReturnType<typeof useCarriageTypeAsuDimensionSeatsCountUpdateMutation>;
export type CarriageTypeAsuDimensionSeatsCountUpdateMutationResult = Apollo.MutationResult<CarriageTypeAsuDimensionSeatsCountUpdateMutation>;
export type CarriageTypeAsuDimensionSeatsCountUpdateMutationOptions = Apollo.BaseMutationOptions<CarriageTypeAsuDimensionSeatsCountUpdateMutation, CarriageTypeAsuDimensionSeatsCountUpdateMutationVariables>;
export const CarriageTypeCreateDocument = /*#__PURE__*/ gql`
    mutation carriageTypeCreate($data: CreateCarriageTypeDto!) {
  classifiers {
    carriageType {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type CarriageTypeCreateMutationFn = Apollo.MutationFunction<CarriageTypeCreateMutation, CarriageTypeCreateMutationVariables>;

/**
 * __useCarriageTypeCreateMutation__
 *
 * To run a mutation, you first call `useCarriageTypeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageTypeCreateMutation, { data, loading, error }] = useCarriageTypeCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageTypeCreateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageTypeCreateMutation, CarriageTypeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageTypeCreateMutation, CarriageTypeCreateMutationVariables>(CarriageTypeCreateDocument, options);
      }
export type CarriageTypeCreateMutationHookResult = ReturnType<typeof useCarriageTypeCreateMutation>;
export type CarriageTypeCreateMutationResult = Apollo.MutationResult<CarriageTypeCreateMutation>;
export type CarriageTypeCreateMutationOptions = Apollo.BaseMutationOptions<CarriageTypeCreateMutation, CarriageTypeCreateMutationVariables>;
export const CarriageTypeHistoryDocument = /*#__PURE__*/ gql`
    query carriageTypeHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [CarriageTypeQueryResolver_History_SortingInputType!]) {
  classifiers {
    carriageType {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          ...CarriageTypeBaseFragment
          carriage_types_for_schema {
            ...CarriageTypesForSchemaShortFragment
          }
        }
        totalCount
      }
    }
  }
}
    ${CarriageTypeBaseFragmentFragmentDoc}
${CarriageTypesForSchemaShortFragmentFragmentDoc}`;

/**
 * __useCarriageTypeHistoryQuery__
 *
 * To run a query within a React component, call `useCarriageTypeHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypeHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCarriageTypeHistoryQuery(baseOptions: Apollo.QueryHookOptions<CarriageTypeHistoryQuery, CarriageTypeHistoryQueryVariables> & ({ variables: CarriageTypeHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypeHistoryQuery, CarriageTypeHistoryQueryVariables>(CarriageTypeHistoryDocument, options);
      }
export function useCarriageTypeHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypeHistoryQuery, CarriageTypeHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypeHistoryQuery, CarriageTypeHistoryQueryVariables>(CarriageTypeHistoryDocument, options);
        }
export function useCarriageTypeHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypeHistoryQuery, CarriageTypeHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypeHistoryQuery, CarriageTypeHistoryQueryVariables>(CarriageTypeHistoryDocument, options);
        }
export type CarriageTypeHistoryQueryHookResult = ReturnType<typeof useCarriageTypeHistoryQuery>;
export type CarriageTypeHistoryLazyQueryHookResult = ReturnType<typeof useCarriageTypeHistoryLazyQuery>;
export type CarriageTypeHistorySuspenseQueryHookResult = ReturnType<typeof useCarriageTypeHistorySuspenseQuery>;
export type CarriageTypeHistoryQueryResult = Apollo.QueryResult<CarriageTypeHistoryQuery, CarriageTypeHistoryQueryVariables>;
export const CarriageTypeListDocument = /*#__PURE__*/ gql`
    query carriageTypeList($paginate: PaginatorArgsDto, $orderBy: [CarriageTypeQueryResolver_List_SortingInputType!], $where: CarriageTypeQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    carriageType {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...CarriageTypeBaseFragment
          carriage_types_for_schema {
            ...CarriageTypesForSchemaShortFragment
          }
        }
        totalCount
      }
    }
  }
}
    ${CarriageTypeBaseFragmentFragmentDoc}
${CarriageTypesForSchemaShortFragmentFragmentDoc}`;

/**
 * __useCarriageTypeListQuery__
 *
 * To run a query within a React component, call `useCarriageTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypeListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageTypeListQuery(baseOptions: Apollo.QueryHookOptions<CarriageTypeListQuery, CarriageTypeListQueryVariables> & ({ variables: CarriageTypeListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypeListQuery, CarriageTypeListQueryVariables>(CarriageTypeListDocument, options);
      }
export function useCarriageTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypeListQuery, CarriageTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypeListQuery, CarriageTypeListQueryVariables>(CarriageTypeListDocument, options);
        }
export function useCarriageTypeListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypeListQuery, CarriageTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypeListQuery, CarriageTypeListQueryVariables>(CarriageTypeListDocument, options);
        }
export type CarriageTypeListQueryHookResult = ReturnType<typeof useCarriageTypeListQuery>;
export type CarriageTypeListLazyQueryHookResult = ReturnType<typeof useCarriageTypeListLazyQuery>;
export type CarriageTypeListSuspenseQueryHookResult = ReturnType<typeof useCarriageTypeListSuspenseQuery>;
export type CarriageTypeListQueryResult = Apollo.QueryResult<CarriageTypeListQuery, CarriageTypeListQueryVariables>;
export const CarriageTypeRangeByIdDocument = /*#__PURE__*/ gql`
    query carriageTypeRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    carriageType {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useCarriageTypeRangeByIdQuery__
 *
 * To run a query within a React component, call `useCarriageTypeRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypeRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageTypeRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<CarriageTypeRangeByIdQuery, CarriageTypeRangeByIdQueryVariables> & ({ variables: CarriageTypeRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypeRangeByIdQuery, CarriageTypeRangeByIdQueryVariables>(CarriageTypeRangeByIdDocument, options);
      }
export function useCarriageTypeRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypeRangeByIdQuery, CarriageTypeRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypeRangeByIdQuery, CarriageTypeRangeByIdQueryVariables>(CarriageTypeRangeByIdDocument, options);
        }
export function useCarriageTypeRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypeRangeByIdQuery, CarriageTypeRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypeRangeByIdQuery, CarriageTypeRangeByIdQueryVariables>(CarriageTypeRangeByIdDocument, options);
        }
export type CarriageTypeRangeByIdQueryHookResult = ReturnType<typeof useCarriageTypeRangeByIdQuery>;
export type CarriageTypeRangeByIdLazyQueryHookResult = ReturnType<typeof useCarriageTypeRangeByIdLazyQuery>;
export type CarriageTypeRangeByIdSuspenseQueryHookResult = ReturnType<typeof useCarriageTypeRangeByIdSuspenseQuery>;
export type CarriageTypeRangeByIdQueryResult = Apollo.QueryResult<CarriageTypeRangeByIdQuery, CarriageTypeRangeByIdQueryVariables>;
export const CarriageTypeUpdateDocument = /*#__PURE__*/ gql`
    mutation carriageTypeUpdate($data: UpdateCarriageTypeDto!) {
  classifiers {
    carriageType {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type CarriageTypeUpdateMutationFn = Apollo.MutationFunction<CarriageTypeUpdateMutation, CarriageTypeUpdateMutationVariables>;

/**
 * __useCarriageTypeUpdateMutation__
 *
 * To run a mutation, you first call `useCarriageTypeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageTypeUpdateMutation, { data, loading, error }] = useCarriageTypeUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageTypeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageTypeUpdateMutation, CarriageTypeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageTypeUpdateMutation, CarriageTypeUpdateMutationVariables>(CarriageTypeUpdateDocument, options);
      }
export type CarriageTypeUpdateMutationHookResult = ReturnType<typeof useCarriageTypeUpdateMutation>;
export type CarriageTypeUpdateMutationResult = Apollo.MutationResult<CarriageTypeUpdateMutation>;
export type CarriageTypeUpdateMutationOptions = Apollo.BaseMutationOptions<CarriageTypeUpdateMutation, CarriageTypeUpdateMutationVariables>;
export const CarriageTypeAsuCreateDocument = /*#__PURE__*/ gql`
    mutation carriageTypeAsuCreate($data: CreateCarriageTypeAsuDto!) {
  classifiers {
    carriageTypeAsu {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type CarriageTypeAsuCreateMutationFn = Apollo.MutationFunction<CarriageTypeAsuCreateMutation, CarriageTypeAsuCreateMutationVariables>;

/**
 * __useCarriageTypeAsuCreateMutation__
 *
 * To run a mutation, you first call `useCarriageTypeAsuCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeAsuCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageTypeAsuCreateMutation, { data, loading, error }] = useCarriageTypeAsuCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageTypeAsuCreateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageTypeAsuCreateMutation, CarriageTypeAsuCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageTypeAsuCreateMutation, CarriageTypeAsuCreateMutationVariables>(CarriageTypeAsuCreateDocument, options);
      }
export type CarriageTypeAsuCreateMutationHookResult = ReturnType<typeof useCarriageTypeAsuCreateMutation>;
export type CarriageTypeAsuCreateMutationResult = Apollo.MutationResult<CarriageTypeAsuCreateMutation>;
export type CarriageTypeAsuCreateMutationOptions = Apollo.BaseMutationOptions<CarriageTypeAsuCreateMutation, CarriageTypeAsuCreateMutationVariables>;
export const CarriageTypeAsuHistoryDocument = /*#__PURE__*/ gql`
    query carriageTypeAsuHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [CarriageTypeAsuQueryResolver_History_SortingInputType!]) {
  classifiers {
    carriageTypeAsu {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          ...CarriageTypeAsuBaseFragment
        }
      }
    }
  }
}
    ${CarriageTypeAsuBaseFragmentFragmentDoc}`;

/**
 * __useCarriageTypeAsuHistoryQuery__
 *
 * To run a query within a React component, call `useCarriageTypeAsuHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeAsuHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypeAsuHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCarriageTypeAsuHistoryQuery(baseOptions: Apollo.QueryHookOptions<CarriageTypeAsuHistoryQuery, CarriageTypeAsuHistoryQueryVariables> & ({ variables: CarriageTypeAsuHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypeAsuHistoryQuery, CarriageTypeAsuHistoryQueryVariables>(CarriageTypeAsuHistoryDocument, options);
      }
export function useCarriageTypeAsuHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypeAsuHistoryQuery, CarriageTypeAsuHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypeAsuHistoryQuery, CarriageTypeAsuHistoryQueryVariables>(CarriageTypeAsuHistoryDocument, options);
        }
export function useCarriageTypeAsuHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypeAsuHistoryQuery, CarriageTypeAsuHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypeAsuHistoryQuery, CarriageTypeAsuHistoryQueryVariables>(CarriageTypeAsuHistoryDocument, options);
        }
export type CarriageTypeAsuHistoryQueryHookResult = ReturnType<typeof useCarriageTypeAsuHistoryQuery>;
export type CarriageTypeAsuHistoryLazyQueryHookResult = ReturnType<typeof useCarriageTypeAsuHistoryLazyQuery>;
export type CarriageTypeAsuHistorySuspenseQueryHookResult = ReturnType<typeof useCarriageTypeAsuHistorySuspenseQuery>;
export type CarriageTypeAsuHistoryQueryResult = Apollo.QueryResult<CarriageTypeAsuHistoryQuery, CarriageTypeAsuHistoryQueryVariables>;
export const CarriageTypeAsuListDocument = /*#__PURE__*/ gql`
    query carriageTypeAsuList($paginate: PaginatorArgsDto, $orderBy: [CarriageTypeAsuQueryResolver_List_SortingInputType!], $where: CarriageTypeAsuQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    carriageTypeAsu {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...CarriageTypeAsuBaseFragment
        }
      }
    }
  }
}
    ${CarriageTypeAsuBaseFragmentFragmentDoc}`;

/**
 * __useCarriageTypeAsuListQuery__
 *
 * To run a query within a React component, call `useCarriageTypeAsuListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeAsuListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypeAsuListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageTypeAsuListQuery(baseOptions: Apollo.QueryHookOptions<CarriageTypeAsuListQuery, CarriageTypeAsuListQueryVariables> & ({ variables: CarriageTypeAsuListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypeAsuListQuery, CarriageTypeAsuListQueryVariables>(CarriageTypeAsuListDocument, options);
      }
export function useCarriageTypeAsuListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypeAsuListQuery, CarriageTypeAsuListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypeAsuListQuery, CarriageTypeAsuListQueryVariables>(CarriageTypeAsuListDocument, options);
        }
export function useCarriageTypeAsuListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypeAsuListQuery, CarriageTypeAsuListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypeAsuListQuery, CarriageTypeAsuListQueryVariables>(CarriageTypeAsuListDocument, options);
        }
export type CarriageTypeAsuListQueryHookResult = ReturnType<typeof useCarriageTypeAsuListQuery>;
export type CarriageTypeAsuListLazyQueryHookResult = ReturnType<typeof useCarriageTypeAsuListLazyQuery>;
export type CarriageTypeAsuListSuspenseQueryHookResult = ReturnType<typeof useCarriageTypeAsuListSuspenseQuery>;
export type CarriageTypeAsuListQueryResult = Apollo.QueryResult<CarriageTypeAsuListQuery, CarriageTypeAsuListQueryVariables>;
export const CarriageTypeAsuRangeByIdDocument = /*#__PURE__*/ gql`
    query carriageTypeAsuRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    carriageTypeAsu {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useCarriageTypeAsuRangeByIdQuery__
 *
 * To run a query within a React component, call `useCarriageTypeAsuRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeAsuRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypeAsuRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCarriageTypeAsuRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<CarriageTypeAsuRangeByIdQuery, CarriageTypeAsuRangeByIdQueryVariables> & ({ variables: CarriageTypeAsuRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypeAsuRangeByIdQuery, CarriageTypeAsuRangeByIdQueryVariables>(CarriageTypeAsuRangeByIdDocument, options);
      }
export function useCarriageTypeAsuRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypeAsuRangeByIdQuery, CarriageTypeAsuRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypeAsuRangeByIdQuery, CarriageTypeAsuRangeByIdQueryVariables>(CarriageTypeAsuRangeByIdDocument, options);
        }
export function useCarriageTypeAsuRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypeAsuRangeByIdQuery, CarriageTypeAsuRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypeAsuRangeByIdQuery, CarriageTypeAsuRangeByIdQueryVariables>(CarriageTypeAsuRangeByIdDocument, options);
        }
export type CarriageTypeAsuRangeByIdQueryHookResult = ReturnType<typeof useCarriageTypeAsuRangeByIdQuery>;
export type CarriageTypeAsuRangeByIdLazyQueryHookResult = ReturnType<typeof useCarriageTypeAsuRangeByIdLazyQuery>;
export type CarriageTypeAsuRangeByIdSuspenseQueryHookResult = ReturnType<typeof useCarriageTypeAsuRangeByIdSuspenseQuery>;
export type CarriageTypeAsuRangeByIdQueryResult = Apollo.QueryResult<CarriageTypeAsuRangeByIdQuery, CarriageTypeAsuRangeByIdQueryVariables>;
export const CarriageTypeAsuUpdateDocument = /*#__PURE__*/ gql`
    mutation carriageTypeAsuUpdate($data: UpdateCarriageTypeAsuDto!) {
  classifiers {
    carriageTypeAsu {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type CarriageTypeAsuUpdateMutationFn = Apollo.MutationFunction<CarriageTypeAsuUpdateMutation, CarriageTypeAsuUpdateMutationVariables>;

/**
 * __useCarriageTypeAsuUpdateMutation__
 *
 * To run a mutation, you first call `useCarriageTypeAsuUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeAsuUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageTypeAsuUpdateMutation, { data, loading, error }] = useCarriageTypeAsuUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageTypeAsuUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageTypeAsuUpdateMutation, CarriageTypeAsuUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageTypeAsuUpdateMutation, CarriageTypeAsuUpdateMutationVariables>(CarriageTypeAsuUpdateDocument, options);
      }
export type CarriageTypeAsuUpdateMutationHookResult = ReturnType<typeof useCarriageTypeAsuUpdateMutation>;
export type CarriageTypeAsuUpdateMutationResult = Apollo.MutationResult<CarriageTypeAsuUpdateMutation>;
export type CarriageTypeAsuUpdateMutationOptions = Apollo.BaseMutationOptions<CarriageTypeAsuUpdateMutation, CarriageTypeAsuUpdateMutationVariables>;
export const CarriageTypeCsuCreateDocument = /*#__PURE__*/ gql`
    mutation carriageTypeCsuCreate($data: CreateCsuCarriageTypeDto!) {
  classifiers {
    csuCarriageType {
      create(data: $data) {
        id
      }
    }
  }
}
    `;
export type CarriageTypeCsuCreateMutationFn = Apollo.MutationFunction<CarriageTypeCsuCreateMutation, CarriageTypeCsuCreateMutationVariables>;

/**
 * __useCarriageTypeCsuCreateMutation__
 *
 * To run a mutation, you first call `useCarriageTypeCsuCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeCsuCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageTypeCsuCreateMutation, { data, loading, error }] = useCarriageTypeCsuCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageTypeCsuCreateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageTypeCsuCreateMutation, CarriageTypeCsuCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageTypeCsuCreateMutation, CarriageTypeCsuCreateMutationVariables>(CarriageTypeCsuCreateDocument, options);
      }
export type CarriageTypeCsuCreateMutationHookResult = ReturnType<typeof useCarriageTypeCsuCreateMutation>;
export type CarriageTypeCsuCreateMutationResult = Apollo.MutationResult<CarriageTypeCsuCreateMutation>;
export type CarriageTypeCsuCreateMutationOptions = Apollo.BaseMutationOptions<CarriageTypeCsuCreateMutation, CarriageTypeCsuCreateMutationVariables>;
export const CarriageTypeCsuListDocument = /*#__PURE__*/ gql`
    query carriageTypeCsuList($paginate: PaginatorArgsDto, $orderBy: [CsuCarriageTypeQueryResolver_List_SortingInputType!], $where: CsuCarriageTypeQueryResolver_List_FilterInputType) {
  classifiers {
    csuCarriageType {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        totalCount
        items {
          ...CarriageTypeCsuBaseFragment
        }
      }
    }
  }
}
    ${CarriageTypeCsuBaseFragmentFragmentDoc}`;

/**
 * __useCarriageTypeCsuListQuery__
 *
 * To run a query within a React component, call `useCarriageTypeCsuListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeCsuListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypeCsuListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCarriageTypeCsuListQuery(baseOptions?: Apollo.QueryHookOptions<CarriageTypeCsuListQuery, CarriageTypeCsuListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypeCsuListQuery, CarriageTypeCsuListQueryVariables>(CarriageTypeCsuListDocument, options);
      }
export function useCarriageTypeCsuListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypeCsuListQuery, CarriageTypeCsuListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypeCsuListQuery, CarriageTypeCsuListQueryVariables>(CarriageTypeCsuListDocument, options);
        }
export function useCarriageTypeCsuListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypeCsuListQuery, CarriageTypeCsuListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypeCsuListQuery, CarriageTypeCsuListQueryVariables>(CarriageTypeCsuListDocument, options);
        }
export type CarriageTypeCsuListQueryHookResult = ReturnType<typeof useCarriageTypeCsuListQuery>;
export type CarriageTypeCsuListLazyQueryHookResult = ReturnType<typeof useCarriageTypeCsuListLazyQuery>;
export type CarriageTypeCsuListSuspenseQueryHookResult = ReturnType<typeof useCarriageTypeCsuListSuspenseQuery>;
export type CarriageTypeCsuListQueryResult = Apollo.QueryResult<CarriageTypeCsuListQuery, CarriageTypeCsuListQueryVariables>;
export const CarriageTypeCsuUpdateDocument = /*#__PURE__*/ gql`
    mutation carriageTypeCsuUpdate($data: UpdateCsuCarriageTypeDto!) {
  classifiers {
    csuCarriageType {
      update(data: $data) {
        id
      }
    }
  }
}
    `;
export type CarriageTypeCsuUpdateMutationFn = Apollo.MutationFunction<CarriageTypeCsuUpdateMutation, CarriageTypeCsuUpdateMutationVariables>;

/**
 * __useCarriageTypeCsuUpdateMutation__
 *
 * To run a mutation, you first call `useCarriageTypeCsuUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypeCsuUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageTypeCsuUpdateMutation, { data, loading, error }] = useCarriageTypeCsuUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageTypeCsuUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageTypeCsuUpdateMutation, CarriageTypeCsuUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageTypeCsuUpdateMutation, CarriageTypeCsuUpdateMutationVariables>(CarriageTypeCsuUpdateDocument, options);
      }
export type CarriageTypeCsuUpdateMutationHookResult = ReturnType<typeof useCarriageTypeCsuUpdateMutation>;
export type CarriageTypeCsuUpdateMutationResult = Apollo.MutationResult<CarriageTypeCsuUpdateMutation>;
export type CarriageTypeCsuUpdateMutationOptions = Apollo.BaseMutationOptions<CarriageTypeCsuUpdateMutation, CarriageTypeCsuUpdateMutationVariables>;
export const CarriageTypesForSchemaCreateDocument = /*#__PURE__*/ gql`
    mutation CarriageTypesForSchemaCreate($data: CreateCarriageTypesForSchemaDto!) {
  classifiers {
    carriageTypesForSchema {
      create(data: $data)
    }
  }
}
    `;
export type CarriageTypesForSchemaCreateMutationFn = Apollo.MutationFunction<CarriageTypesForSchemaCreateMutation, CarriageTypesForSchemaCreateMutationVariables>;

/**
 * __useCarriageTypesForSchemaCreateMutation__
 *
 * To run a mutation, you first call `useCarriageTypesForSchemaCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypesForSchemaCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageTypesForSchemaCreateMutation, { data, loading, error }] = useCarriageTypesForSchemaCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageTypesForSchemaCreateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageTypesForSchemaCreateMutation, CarriageTypesForSchemaCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageTypesForSchemaCreateMutation, CarriageTypesForSchemaCreateMutationVariables>(CarriageTypesForSchemaCreateDocument, options);
      }
export type CarriageTypesForSchemaCreateMutationHookResult = ReturnType<typeof useCarriageTypesForSchemaCreateMutation>;
export type CarriageTypesForSchemaCreateMutationResult = Apollo.MutationResult<CarriageTypesForSchemaCreateMutation>;
export type CarriageTypesForSchemaCreateMutationOptions = Apollo.BaseMutationOptions<CarriageTypesForSchemaCreateMutation, CarriageTypesForSchemaCreateMutationVariables>;
export const CarriageTypesForSchemaListDocument = /*#__PURE__*/ gql`
    query carriageTypesForSchemaList($paginate: PaginatorArgsDto, $orderBy: [CarriageTypesForSchemaQueryResolver_List_SortingInputType!], $where: CarriageTypesForSchemaQueryResolver_List_FilterInputType) {
  classifiers {
    carriageTypesForSchema {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        items {
          ...CarriageTypesForSchemaBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${CarriageTypesForSchemaBaseFragmentFragmentDoc}`;

/**
 * __useCarriageTypesForSchemaListQuery__
 *
 * To run a query within a React component, call `useCarriageTypesForSchemaListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypesForSchemaListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageTypesForSchemaListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCarriageTypesForSchemaListQuery(baseOptions?: Apollo.QueryHookOptions<CarriageTypesForSchemaListQuery, CarriageTypesForSchemaListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageTypesForSchemaListQuery, CarriageTypesForSchemaListQueryVariables>(CarriageTypesForSchemaListDocument, options);
      }
export function useCarriageTypesForSchemaListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageTypesForSchemaListQuery, CarriageTypesForSchemaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageTypesForSchemaListQuery, CarriageTypesForSchemaListQueryVariables>(CarriageTypesForSchemaListDocument, options);
        }
export function useCarriageTypesForSchemaListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageTypesForSchemaListQuery, CarriageTypesForSchemaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageTypesForSchemaListQuery, CarriageTypesForSchemaListQueryVariables>(CarriageTypesForSchemaListDocument, options);
        }
export type CarriageTypesForSchemaListQueryHookResult = ReturnType<typeof useCarriageTypesForSchemaListQuery>;
export type CarriageTypesForSchemaListLazyQueryHookResult = ReturnType<typeof useCarriageTypesForSchemaListLazyQuery>;
export type CarriageTypesForSchemaListSuspenseQueryHookResult = ReturnType<typeof useCarriageTypesForSchemaListSuspenseQuery>;
export type CarriageTypesForSchemaListQueryResult = Apollo.QueryResult<CarriageTypesForSchemaListQuery, CarriageTypesForSchemaListQueryVariables>;
export const CarriageTypesForSchemaUpdateDocument = /*#__PURE__*/ gql`
    mutation CarriageTypesForSchemaUpdate($data: UpdateCarriageTypesForSchemaDto!) {
  classifiers {
    carriageTypesForSchema {
      update(data: $data)
    }
  }
}
    `;
export type CarriageTypesForSchemaUpdateMutationFn = Apollo.MutationFunction<CarriageTypesForSchemaUpdateMutation, CarriageTypesForSchemaUpdateMutationVariables>;

/**
 * __useCarriageTypesForSchemaUpdateMutation__
 *
 * To run a mutation, you first call `useCarriageTypesForSchemaUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageTypesForSchemaUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageTypesForSchemaUpdateMutation, { data, loading, error }] = useCarriageTypesForSchemaUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCarriageTypesForSchemaUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CarriageTypesForSchemaUpdateMutation, CarriageTypesForSchemaUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageTypesForSchemaUpdateMutation, CarriageTypesForSchemaUpdateMutationVariables>(CarriageTypesForSchemaUpdateDocument, options);
      }
export type CarriageTypesForSchemaUpdateMutationHookResult = ReturnType<typeof useCarriageTypesForSchemaUpdateMutation>;
export type CarriageTypesForSchemaUpdateMutationResult = Apollo.MutationResult<CarriageTypesForSchemaUpdateMutation>;
export type CarriageTypesForSchemaUpdateMutationOptions = Apollo.BaseMutationOptions<CarriageTypesForSchemaUpdateMutation, CarriageTypesForSchemaUpdateMutationVariables>;
export const GdpCreateDocument = /*#__PURE__*/ gql`
    mutation gdpCreate($data: CreateGdpDto!) {
  classifiers {
    gdp {
      create(data: $data)
    }
  }
}
    `;
export type GdpCreateMutationFn = Apollo.MutationFunction<GdpCreateMutation, GdpCreateMutationVariables>;

/**
 * __useGdpCreateMutation__
 *
 * To run a mutation, you first call `useGdpCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGdpCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gdpCreateMutation, { data, loading, error }] = useGdpCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGdpCreateMutation(baseOptions?: Apollo.MutationHookOptions<GdpCreateMutation, GdpCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GdpCreateMutation, GdpCreateMutationVariables>(GdpCreateDocument, options);
      }
export type GdpCreateMutationHookResult = ReturnType<typeof useGdpCreateMutation>;
export type GdpCreateMutationResult = Apollo.MutationResult<GdpCreateMutation>;
export type GdpCreateMutationOptions = Apollo.BaseMutationOptions<GdpCreateMutation, GdpCreateMutationVariables>;
export const GdpListDocument = /*#__PURE__*/ gql`
    query gdpList($paginate: PaginatorArgsDto!, $orderBy: [GDPQueryResolver_List_SortingInputType!], $where: GDPQueryResolver_List_FilterInputType) {
  classifiers {
    gdp {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        items {
          ...GdpBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${GdpBaseFragmentFragmentDoc}`;

/**
 * __useGdpListQuery__
 *
 * To run a query within a React component, call `useGdpListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGdpListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGdpListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGdpListQuery(baseOptions: Apollo.QueryHookOptions<GdpListQuery, GdpListQueryVariables> & ({ variables: GdpListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GdpListQuery, GdpListQueryVariables>(GdpListDocument, options);
      }
export function useGdpListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GdpListQuery, GdpListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GdpListQuery, GdpListQueryVariables>(GdpListDocument, options);
        }
export function useGdpListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GdpListQuery, GdpListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GdpListQuery, GdpListQueryVariables>(GdpListDocument, options);
        }
export type GdpListQueryHookResult = ReturnType<typeof useGdpListQuery>;
export type GdpListLazyQueryHookResult = ReturnType<typeof useGdpListLazyQuery>;
export type GdpListSuspenseQueryHookResult = ReturnType<typeof useGdpListSuspenseQuery>;
export type GdpListQueryResult = Apollo.QueryResult<GdpListQuery, GdpListQueryVariables>;
export const GdpUpdateDocument = /*#__PURE__*/ gql`
    mutation gdpUpdate($data: UpdateGdpDto!) {
  classifiers {
    gdp {
      update(data: $data)
    }
  }
}
    `;
export type GdpUpdateMutationFn = Apollo.MutationFunction<GdpUpdateMutation, GdpUpdateMutationVariables>;

/**
 * __useGdpUpdateMutation__
 *
 * To run a mutation, you first call `useGdpUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGdpUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gdpUpdateMutation, { data, loading, error }] = useGdpUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGdpUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GdpUpdateMutation, GdpUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GdpUpdateMutation, GdpUpdateMutationVariables>(GdpUpdateDocument, options);
      }
export type GdpUpdateMutationHookResult = ReturnType<typeof useGdpUpdateMutation>;
export type GdpUpdateMutationResult = Apollo.MutationResult<GdpUpdateMutation>;
export type GdpUpdateMutationOptions = Apollo.BaseMutationOptions<GdpUpdateMutation, GdpUpdateMutationVariables>;
export const InfrastructureApplication23ListDocument = /*#__PURE__*/ gql`
    query infrastructureApplication23List($data: QueryInfrastructureApplication23DataDto!, $paginate: PaginatorArgsDto!, $orderBy: [InfrastructureApplication23QueryResolver_List_SortingInputType!], $where: InfrastructureApplication23QueryResolver_List_FilterInputType) {
  classifiers {
    infrastructureApplication23 {
      list(data: $data, paginate: $paginate, order_by: $orderBy, where: $where) {
        totalCount
        items {
          ...InfrastructureApplication23BaseFragment
        }
      }
    }
  }
}
    ${InfrastructureApplication23BaseFragmentFragmentDoc}`;

/**
 * __useInfrastructureApplication23ListQuery__
 *
 * To run a query within a React component, call `useInfrastructureApplication23ListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureApplication23ListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureApplication23ListQuery({
 *   variables: {
 *      data: // value for 'data'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInfrastructureApplication23ListQuery(baseOptions: Apollo.QueryHookOptions<InfrastructureApplication23ListQuery, InfrastructureApplication23ListQueryVariables> & ({ variables: InfrastructureApplication23ListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureApplication23ListQuery, InfrastructureApplication23ListQueryVariables>(InfrastructureApplication23ListDocument, options);
      }
export function useInfrastructureApplication23ListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureApplication23ListQuery, InfrastructureApplication23ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureApplication23ListQuery, InfrastructureApplication23ListQueryVariables>(InfrastructureApplication23ListDocument, options);
        }
export function useInfrastructureApplication23ListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfrastructureApplication23ListQuery, InfrastructureApplication23ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureApplication23ListQuery, InfrastructureApplication23ListQueryVariables>(InfrastructureApplication23ListDocument, options);
        }
export type InfrastructureApplication23ListQueryHookResult = ReturnType<typeof useInfrastructureApplication23ListQuery>;
export type InfrastructureApplication23ListLazyQueryHookResult = ReturnType<typeof useInfrastructureApplication23ListLazyQuery>;
export type InfrastructureApplication23ListSuspenseQueryHookResult = ReturnType<typeof useInfrastructureApplication23ListSuspenseQuery>;
export type InfrastructureApplication23ListQueryResult = Apollo.QueryResult<InfrastructureApplication23ListQuery, InfrastructureApplication23ListQueryVariables>;
export const InfrastructureApplication24ListDocument = /*#__PURE__*/ gql`
    query infrastructureApplication24List($data: QueryInfrastructureApplication24DataDto!, $paginate: PaginatorArgsDto!, $orderBy: [InfrastructureApplication24QueryResolver_List_SortingInputType!], $where: InfrastructureApplication24QueryResolver_List_FilterInputType) {
  classifiers {
    infrastructureApplication24 {
      list(data: $data, paginate: $paginate, order_by: $orderBy, where: $where) {
        totalCount
        items {
          ...InfrastructureApplication24BaseFragment
        }
      }
    }
  }
}
    ${InfrastructureApplication24BaseFragmentFragmentDoc}`;

/**
 * __useInfrastructureApplication24ListQuery__
 *
 * To run a query within a React component, call `useInfrastructureApplication24ListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureApplication24ListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureApplication24ListQuery({
 *   variables: {
 *      data: // value for 'data'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInfrastructureApplication24ListQuery(baseOptions: Apollo.QueryHookOptions<InfrastructureApplication24ListQuery, InfrastructureApplication24ListQueryVariables> & ({ variables: InfrastructureApplication24ListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureApplication24ListQuery, InfrastructureApplication24ListQueryVariables>(InfrastructureApplication24ListDocument, options);
      }
export function useInfrastructureApplication24ListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureApplication24ListQuery, InfrastructureApplication24ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureApplication24ListQuery, InfrastructureApplication24ListQueryVariables>(InfrastructureApplication24ListDocument, options);
        }
export function useInfrastructureApplication24ListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfrastructureApplication24ListQuery, InfrastructureApplication24ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureApplication24ListQuery, InfrastructureApplication24ListQueryVariables>(InfrastructureApplication24ListDocument, options);
        }
export type InfrastructureApplication24ListQueryHookResult = ReturnType<typeof useInfrastructureApplication24ListQuery>;
export type InfrastructureApplication24ListLazyQueryHookResult = ReturnType<typeof useInfrastructureApplication24ListLazyQuery>;
export type InfrastructureApplication24ListSuspenseQueryHookResult = ReturnType<typeof useInfrastructureApplication24ListSuspenseQuery>;
export type InfrastructureApplication24ListQueryResult = Apollo.QueryResult<InfrastructureApplication24ListQuery, InfrastructureApplication24ListQueryVariables>;
export const InfrastructureApplication25ListDocument = /*#__PURE__*/ gql`
    query infrastructureApplication25List($data: QueryInfrastructureApplication25DataDto!, $paginate: PaginatorArgsDto!, $orderBy: [InfrastructureApplication25QueryResolver_List_SortingInputType!], $where: InfrastructureApplication25QueryResolver_List_FilterInputType) {
  classifiers {
    infrastructureApplication25 {
      list(data: $data, paginate: $paginate, order_by: $orderBy, where: $where) {
        totalCount
        items {
          ...InfrastructureApplication25BaseFragment
        }
      }
    }
  }
}
    ${InfrastructureApplication25BaseFragmentFragmentDoc}`;

/**
 * __useInfrastructureApplication25ListQuery__
 *
 * To run a query within a React component, call `useInfrastructureApplication25ListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureApplication25ListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureApplication25ListQuery({
 *   variables: {
 *      data: // value for 'data'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInfrastructureApplication25ListQuery(baseOptions: Apollo.QueryHookOptions<InfrastructureApplication25ListQuery, InfrastructureApplication25ListQueryVariables> & ({ variables: InfrastructureApplication25ListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureApplication25ListQuery, InfrastructureApplication25ListQueryVariables>(InfrastructureApplication25ListDocument, options);
      }
export function useInfrastructureApplication25ListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureApplication25ListQuery, InfrastructureApplication25ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureApplication25ListQuery, InfrastructureApplication25ListQueryVariables>(InfrastructureApplication25ListDocument, options);
        }
export function useInfrastructureApplication25ListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfrastructureApplication25ListQuery, InfrastructureApplication25ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureApplication25ListQuery, InfrastructureApplication25ListQueryVariables>(InfrastructureApplication25ListDocument, options);
        }
export type InfrastructureApplication25ListQueryHookResult = ReturnType<typeof useInfrastructureApplication25ListQuery>;
export type InfrastructureApplication25ListLazyQueryHookResult = ReturnType<typeof useInfrastructureApplication25ListLazyQuery>;
export type InfrastructureApplication25ListSuspenseQueryHookResult = ReturnType<typeof useInfrastructureApplication25ListSuspenseQuery>;
export type InfrastructureApplication25ListQueryResult = Apollo.QueryResult<InfrastructureApplication25ListQuery, InfrastructureApplication25ListQueryVariables>;
export const InfrastructureApplication26ListDocument = /*#__PURE__*/ gql`
    query infrastructureApplication26List($data: QueryInfrastructureApplication26DataDto!, $paginate: PaginatorArgsDto!, $orderBy: [InfrastructureApplication26QueryResolver_List_SortingInputType!], $where: InfrastructureApplication26QueryResolver_List_FilterInputType) {
  classifiers {
    infrastructureApplication26 {
      list(data: $data, paginate: $paginate, order_by: $orderBy, where: $where) {
        totalCount
        items {
          ...InfrastructureApplication26BaseFragment
        }
      }
    }
  }
}
    ${InfrastructureApplication26BaseFragmentFragmentDoc}`;

/**
 * __useInfrastructureApplication26ListQuery__
 *
 * To run a query within a React component, call `useInfrastructureApplication26ListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureApplication26ListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureApplication26ListQuery({
 *   variables: {
 *      data: // value for 'data'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInfrastructureApplication26ListQuery(baseOptions: Apollo.QueryHookOptions<InfrastructureApplication26ListQuery, InfrastructureApplication26ListQueryVariables> & ({ variables: InfrastructureApplication26ListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureApplication26ListQuery, InfrastructureApplication26ListQueryVariables>(InfrastructureApplication26ListDocument, options);
      }
export function useInfrastructureApplication26ListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureApplication26ListQuery, InfrastructureApplication26ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureApplication26ListQuery, InfrastructureApplication26ListQueryVariables>(InfrastructureApplication26ListDocument, options);
        }
export function useInfrastructureApplication26ListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfrastructureApplication26ListQuery, InfrastructureApplication26ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureApplication26ListQuery, InfrastructureApplication26ListQueryVariables>(InfrastructureApplication26ListDocument, options);
        }
export type InfrastructureApplication26ListQueryHookResult = ReturnType<typeof useInfrastructureApplication26ListQuery>;
export type InfrastructureApplication26ListLazyQueryHookResult = ReturnType<typeof useInfrastructureApplication26ListLazyQuery>;
export type InfrastructureApplication26ListSuspenseQueryHookResult = ReturnType<typeof useInfrastructureApplication26ListSuspenseQuery>;
export type InfrastructureApplication26ListQueryResult = Apollo.QueryResult<InfrastructureApplication26ListQuery, InfrastructureApplication26ListQueryVariables>;
export const InfrastructureApplication27ListDocument = /*#__PURE__*/ gql`
    query infrastructureApplication27List($data: QueryInfrastructureApplication27DataDto!, $paginate: PaginatorArgsDto!, $orderBy: [InfrastructureApplication27QueryResolver_List_SortingInputType!], $where: InfrastructureApplication27QueryResolver_List_FilterInputType) {
  classifiers {
    infrastructureApplication27 {
      list(data: $data, paginate: $paginate, order_by: $orderBy, where: $where) {
        totalCount
        items {
          mnemonic {
            ...MnemonicShortFragment
          }
          ...InfrastructureApplication27ShortFragment
        }
      }
    }
  }
}
    ${MnemonicShortFragmentFragmentDoc}
${InfrastructureApplication27ShortFragmentFragmentDoc}`;

/**
 * __useInfrastructureApplication27ListQuery__
 *
 * To run a query within a React component, call `useInfrastructureApplication27ListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureApplication27ListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureApplication27ListQuery({
 *   variables: {
 *      data: // value for 'data'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInfrastructureApplication27ListQuery(baseOptions: Apollo.QueryHookOptions<InfrastructureApplication27ListQuery, InfrastructureApplication27ListQueryVariables> & ({ variables: InfrastructureApplication27ListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureApplication27ListQuery, InfrastructureApplication27ListQueryVariables>(InfrastructureApplication27ListDocument, options);
      }
export function useInfrastructureApplication27ListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureApplication27ListQuery, InfrastructureApplication27ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureApplication27ListQuery, InfrastructureApplication27ListQueryVariables>(InfrastructureApplication27ListDocument, options);
        }
export function useInfrastructureApplication27ListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfrastructureApplication27ListQuery, InfrastructureApplication27ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureApplication27ListQuery, InfrastructureApplication27ListQueryVariables>(InfrastructureApplication27ListDocument, options);
        }
export type InfrastructureApplication27ListQueryHookResult = ReturnType<typeof useInfrastructureApplication27ListQuery>;
export type InfrastructureApplication27ListLazyQueryHookResult = ReturnType<typeof useInfrastructureApplication27ListLazyQuery>;
export type InfrastructureApplication27ListSuspenseQueryHookResult = ReturnType<typeof useInfrastructureApplication27ListSuspenseQuery>;
export type InfrastructureApplication27ListQueryResult = Apollo.QueryResult<InfrastructureApplication27ListQuery, InfrastructureApplication27ListQueryVariables>;
export const CreateInfrastructureCoefficientIndexDocument = /*#__PURE__*/ gql`
    mutation createInfrastructureCoefficientIndex($input: CreateInfrastructureCoefficientIndexingDto!) {
  classifiers {
    infrastructureCoefficientIndexing {
      create(data: $input)
    }
  }
}
    `;
export type CreateInfrastructureCoefficientIndexMutationFn = Apollo.MutationFunction<CreateInfrastructureCoefficientIndexMutation, CreateInfrastructureCoefficientIndexMutationVariables>;

/**
 * __useCreateInfrastructureCoefficientIndexMutation__
 *
 * To run a mutation, you first call `useCreateInfrastructureCoefficientIndexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInfrastructureCoefficientIndexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInfrastructureCoefficientIndexMutation, { data, loading, error }] = useCreateInfrastructureCoefficientIndexMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInfrastructureCoefficientIndexMutation(baseOptions?: Apollo.MutationHookOptions<CreateInfrastructureCoefficientIndexMutation, CreateInfrastructureCoefficientIndexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInfrastructureCoefficientIndexMutation, CreateInfrastructureCoefficientIndexMutationVariables>(CreateInfrastructureCoefficientIndexDocument, options);
      }
export type CreateInfrastructureCoefficientIndexMutationHookResult = ReturnType<typeof useCreateInfrastructureCoefficientIndexMutation>;
export type CreateInfrastructureCoefficientIndexMutationResult = Apollo.MutationResult<CreateInfrastructureCoefficientIndexMutation>;
export type CreateInfrastructureCoefficientIndexMutationOptions = Apollo.BaseMutationOptions<CreateInfrastructureCoefficientIndexMutation, CreateInfrastructureCoefficientIndexMutationVariables>;
export const UpdateInfrastructureCoefficientIndexDocument = /*#__PURE__*/ gql`
    mutation updateInfrastructureCoefficientIndex($input: UpdateInfrastructureCoefficientIndexingDto!) {
  classifiers {
    infrastructureCoefficientIndexing {
      update(data: $input)
    }
  }
}
    `;
export type UpdateInfrastructureCoefficientIndexMutationFn = Apollo.MutationFunction<UpdateInfrastructureCoefficientIndexMutation, UpdateInfrastructureCoefficientIndexMutationVariables>;

/**
 * __useUpdateInfrastructureCoefficientIndexMutation__
 *
 * To run a mutation, you first call `useUpdateInfrastructureCoefficientIndexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInfrastructureCoefficientIndexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInfrastructureCoefficientIndexMutation, { data, loading, error }] = useUpdateInfrastructureCoefficientIndexMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInfrastructureCoefficientIndexMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInfrastructureCoefficientIndexMutation, UpdateInfrastructureCoefficientIndexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInfrastructureCoefficientIndexMutation, UpdateInfrastructureCoefficientIndexMutationVariables>(UpdateInfrastructureCoefficientIndexDocument, options);
      }
export type UpdateInfrastructureCoefficientIndexMutationHookResult = ReturnType<typeof useUpdateInfrastructureCoefficientIndexMutation>;
export type UpdateInfrastructureCoefficientIndexMutationResult = Apollo.MutationResult<UpdateInfrastructureCoefficientIndexMutation>;
export type UpdateInfrastructureCoefficientIndexMutationOptions = Apollo.BaseMutationOptions<UpdateInfrastructureCoefficientIndexMutation, UpdateInfrastructureCoefficientIndexMutationVariables>;
export const InfrastructureCoefficientIndexesDocument = /*#__PURE__*/ gql`
    query infrastructureCoefficientIndexes($paginate: PaginatorArgsDto!, $orderBy: [InfrastructureCoefficientIndexingQueryResolver_List_SortingInputType!], $where: InfrastructureCoefficientIndexingQueryResolver_List_FilterInputType) {
  classifiers {
    infrastructureCoefficientIndexing {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        totalCount
        items {
          ...InfrastructureCoefficientIndexingBaseFragment
        }
      }
    }
  }
}
    ${InfrastructureCoefficientIndexingBaseFragmentFragmentDoc}`;

/**
 * __useInfrastructureCoefficientIndexesQuery__
 *
 * To run a query within a React component, call `useInfrastructureCoefficientIndexesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureCoefficientIndexesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureCoefficientIndexesQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInfrastructureCoefficientIndexesQuery(baseOptions: Apollo.QueryHookOptions<InfrastructureCoefficientIndexesQuery, InfrastructureCoefficientIndexesQueryVariables> & ({ variables: InfrastructureCoefficientIndexesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureCoefficientIndexesQuery, InfrastructureCoefficientIndexesQueryVariables>(InfrastructureCoefficientIndexesDocument, options);
      }
export function useInfrastructureCoefficientIndexesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureCoefficientIndexesQuery, InfrastructureCoefficientIndexesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureCoefficientIndexesQuery, InfrastructureCoefficientIndexesQueryVariables>(InfrastructureCoefficientIndexesDocument, options);
        }
export function useInfrastructureCoefficientIndexesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfrastructureCoefficientIndexesQuery, InfrastructureCoefficientIndexesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureCoefficientIndexesQuery, InfrastructureCoefficientIndexesQueryVariables>(InfrastructureCoefficientIndexesDocument, options);
        }
export type InfrastructureCoefficientIndexesQueryHookResult = ReturnType<typeof useInfrastructureCoefficientIndexesQuery>;
export type InfrastructureCoefficientIndexesLazyQueryHookResult = ReturnType<typeof useInfrastructureCoefficientIndexesLazyQuery>;
export type InfrastructureCoefficientIndexesSuspenseQueryHookResult = ReturnType<typeof useInfrastructureCoefficientIndexesSuspenseQuery>;
export type InfrastructureCoefficientIndexesQueryResult = Apollo.QueryResult<InfrastructureCoefficientIndexesQuery, InfrastructureCoefficientIndexesQueryVariables>;
export const LocomotivePriceTechnicalServiceCreateDocument = /*#__PURE__*/ gql`
    mutation locomotivePriceTechnicalServiceCreate($data: CreateLocomotivePriceTechnicalServiceDto!) {
  classifiers {
    locomotivePriceTechnicalService {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type LocomotivePriceTechnicalServiceCreateMutationFn = Apollo.MutationFunction<LocomotivePriceTechnicalServiceCreateMutation, LocomotivePriceTechnicalServiceCreateMutationVariables>;

/**
 * __useLocomotivePriceTechnicalServiceCreateMutation__
 *
 * To run a mutation, you first call `useLocomotivePriceTechnicalServiceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocomotivePriceTechnicalServiceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locomotivePriceTechnicalServiceCreateMutation, { data, loading, error }] = useLocomotivePriceTechnicalServiceCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLocomotivePriceTechnicalServiceCreateMutation(baseOptions?: Apollo.MutationHookOptions<LocomotivePriceTechnicalServiceCreateMutation, LocomotivePriceTechnicalServiceCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocomotivePriceTechnicalServiceCreateMutation, LocomotivePriceTechnicalServiceCreateMutationVariables>(LocomotivePriceTechnicalServiceCreateDocument, options);
      }
export type LocomotivePriceTechnicalServiceCreateMutationHookResult = ReturnType<typeof useLocomotivePriceTechnicalServiceCreateMutation>;
export type LocomotivePriceTechnicalServiceCreateMutationResult = Apollo.MutationResult<LocomotivePriceTechnicalServiceCreateMutation>;
export type LocomotivePriceTechnicalServiceCreateMutationOptions = Apollo.BaseMutationOptions<LocomotivePriceTechnicalServiceCreateMutation, LocomotivePriceTechnicalServiceCreateMutationVariables>;
export const LocomotivePriceTechnicalServiceHistoryDocument = /*#__PURE__*/ gql`
    query locomotivePriceTechnicalServiceHistory($entityId: Float!, $paginate: PaginatorArgsDto!, $orderBy: [LocomotivePriceTechnicalServiceQueryResolver_History_SortingInputType!]) {
  classifiers {
    locomotivePriceTechnicalService {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          start_at
          end_at
          ...LocomotivePriceTechnicalServiceBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${LocomotivePriceTechnicalServiceBaseFragmentFragmentDoc}`;

/**
 * __useLocomotivePriceTechnicalServiceHistoryQuery__
 *
 * To run a query within a React component, call `useLocomotivePriceTechnicalServiceHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotivePriceTechnicalServiceHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotivePriceTechnicalServiceHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLocomotivePriceTechnicalServiceHistoryQuery(baseOptions: Apollo.QueryHookOptions<LocomotivePriceTechnicalServiceHistoryQuery, LocomotivePriceTechnicalServiceHistoryQueryVariables> & ({ variables: LocomotivePriceTechnicalServiceHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotivePriceTechnicalServiceHistoryQuery, LocomotivePriceTechnicalServiceHistoryQueryVariables>(LocomotivePriceTechnicalServiceHistoryDocument, options);
      }
export function useLocomotivePriceTechnicalServiceHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotivePriceTechnicalServiceHistoryQuery, LocomotivePriceTechnicalServiceHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotivePriceTechnicalServiceHistoryQuery, LocomotivePriceTechnicalServiceHistoryQueryVariables>(LocomotivePriceTechnicalServiceHistoryDocument, options);
        }
export function useLocomotivePriceTechnicalServiceHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotivePriceTechnicalServiceHistoryQuery, LocomotivePriceTechnicalServiceHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotivePriceTechnicalServiceHistoryQuery, LocomotivePriceTechnicalServiceHistoryQueryVariables>(LocomotivePriceTechnicalServiceHistoryDocument, options);
        }
export type LocomotivePriceTechnicalServiceHistoryQueryHookResult = ReturnType<typeof useLocomotivePriceTechnicalServiceHistoryQuery>;
export type LocomotivePriceTechnicalServiceHistoryLazyQueryHookResult = ReturnType<typeof useLocomotivePriceTechnicalServiceHistoryLazyQuery>;
export type LocomotivePriceTechnicalServiceHistorySuspenseQueryHookResult = ReturnType<typeof useLocomotivePriceTechnicalServiceHistorySuspenseQuery>;
export type LocomotivePriceTechnicalServiceHistoryQueryResult = Apollo.QueryResult<LocomotivePriceTechnicalServiceHistoryQuery, LocomotivePriceTechnicalServiceHistoryQueryVariables>;
export const LocomotivePriceTechnicalServiceListDocument = /*#__PURE__*/ gql`
    query locomotivePriceTechnicalServiceList($paginate: PaginatorArgsDto!, $orderBy: [LocomotivePriceTechnicalServiceQueryResolver_List_SortingInputType!], $where: LocomotivePriceTechnicalServiceQueryResolver_List_FilterInputType, $search: String!, $range: RangeInputDto!) {
  classifiers {
    locomotivePriceTechnicalService {
      list(
        paginate: $paginate
        order_by: $orderBy
        where: $where
        search: $search
        range: $range
      ) {
        items {
          ...LocomotivePriceTechnicalServiceBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${LocomotivePriceTechnicalServiceBaseFragmentFragmentDoc}`;

/**
 * __useLocomotivePriceTechnicalServiceListQuery__
 *
 * To run a query within a React component, call `useLocomotivePriceTechnicalServiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotivePriceTechnicalServiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotivePriceTechnicalServiceListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      search: // value for 'search'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useLocomotivePriceTechnicalServiceListQuery(baseOptions: Apollo.QueryHookOptions<LocomotivePriceTechnicalServiceListQuery, LocomotivePriceTechnicalServiceListQueryVariables> & ({ variables: LocomotivePriceTechnicalServiceListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotivePriceTechnicalServiceListQuery, LocomotivePriceTechnicalServiceListQueryVariables>(LocomotivePriceTechnicalServiceListDocument, options);
      }
export function useLocomotivePriceTechnicalServiceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotivePriceTechnicalServiceListQuery, LocomotivePriceTechnicalServiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotivePriceTechnicalServiceListQuery, LocomotivePriceTechnicalServiceListQueryVariables>(LocomotivePriceTechnicalServiceListDocument, options);
        }
export function useLocomotivePriceTechnicalServiceListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotivePriceTechnicalServiceListQuery, LocomotivePriceTechnicalServiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotivePriceTechnicalServiceListQuery, LocomotivePriceTechnicalServiceListQueryVariables>(LocomotivePriceTechnicalServiceListDocument, options);
        }
export type LocomotivePriceTechnicalServiceListQueryHookResult = ReturnType<typeof useLocomotivePriceTechnicalServiceListQuery>;
export type LocomotivePriceTechnicalServiceListLazyQueryHookResult = ReturnType<typeof useLocomotivePriceTechnicalServiceListLazyQuery>;
export type LocomotivePriceTechnicalServiceListSuspenseQueryHookResult = ReturnType<typeof useLocomotivePriceTechnicalServiceListSuspenseQuery>;
export type LocomotivePriceTechnicalServiceListQueryResult = Apollo.QueryResult<LocomotivePriceTechnicalServiceListQuery, LocomotivePriceTechnicalServiceListQueryVariables>;
export const LocomotivePriceTechnicalServiceRangeByIdDocument = /*#__PURE__*/ gql`
    query locomotivePriceTechnicalServiceRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    locomotivePriceTechnicalService {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useLocomotivePriceTechnicalServiceRangeByIdQuery__
 *
 * To run a query within a React component, call `useLocomotivePriceTechnicalServiceRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotivePriceTechnicalServiceRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotivePriceTechnicalServiceRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useLocomotivePriceTechnicalServiceRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<LocomotivePriceTechnicalServiceRangeByIdQuery, LocomotivePriceTechnicalServiceRangeByIdQueryVariables> & ({ variables: LocomotivePriceTechnicalServiceRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotivePriceTechnicalServiceRangeByIdQuery, LocomotivePriceTechnicalServiceRangeByIdQueryVariables>(LocomotivePriceTechnicalServiceRangeByIdDocument, options);
      }
export function useLocomotivePriceTechnicalServiceRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotivePriceTechnicalServiceRangeByIdQuery, LocomotivePriceTechnicalServiceRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotivePriceTechnicalServiceRangeByIdQuery, LocomotivePriceTechnicalServiceRangeByIdQueryVariables>(LocomotivePriceTechnicalServiceRangeByIdDocument, options);
        }
export function useLocomotivePriceTechnicalServiceRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotivePriceTechnicalServiceRangeByIdQuery, LocomotivePriceTechnicalServiceRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotivePriceTechnicalServiceRangeByIdQuery, LocomotivePriceTechnicalServiceRangeByIdQueryVariables>(LocomotivePriceTechnicalServiceRangeByIdDocument, options);
        }
export type LocomotivePriceTechnicalServiceRangeByIdQueryHookResult = ReturnType<typeof useLocomotivePriceTechnicalServiceRangeByIdQuery>;
export type LocomotivePriceTechnicalServiceRangeByIdLazyQueryHookResult = ReturnType<typeof useLocomotivePriceTechnicalServiceRangeByIdLazyQuery>;
export type LocomotivePriceTechnicalServiceRangeByIdSuspenseQueryHookResult = ReturnType<typeof useLocomotivePriceTechnicalServiceRangeByIdSuspenseQuery>;
export type LocomotivePriceTechnicalServiceRangeByIdQueryResult = Apollo.QueryResult<LocomotivePriceTechnicalServiceRangeByIdQuery, LocomotivePriceTechnicalServiceRangeByIdQueryVariables>;
export const LocomotivePriceTechnicalServiceUpdateDocument = /*#__PURE__*/ gql`
    mutation LocomotivePriceTechnicalServiceUpdate($data: UpdateLocomotivePriceTechnicalServiceDto!) {
  classifiers {
    locomotivePriceTechnicalService {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type LocomotivePriceTechnicalServiceUpdateMutationFn = Apollo.MutationFunction<LocomotivePriceTechnicalServiceUpdateMutation, LocomotivePriceTechnicalServiceUpdateMutationVariables>;

/**
 * __useLocomotivePriceTechnicalServiceUpdateMutation__
 *
 * To run a mutation, you first call `useLocomotivePriceTechnicalServiceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocomotivePriceTechnicalServiceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locomotivePriceTechnicalServiceUpdateMutation, { data, loading, error }] = useLocomotivePriceTechnicalServiceUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLocomotivePriceTechnicalServiceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LocomotivePriceTechnicalServiceUpdateMutation, LocomotivePriceTechnicalServiceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocomotivePriceTechnicalServiceUpdateMutation, LocomotivePriceTechnicalServiceUpdateMutationVariables>(LocomotivePriceTechnicalServiceUpdateDocument, options);
      }
export type LocomotivePriceTechnicalServiceUpdateMutationHookResult = ReturnType<typeof useLocomotivePriceTechnicalServiceUpdateMutation>;
export type LocomotivePriceTechnicalServiceUpdateMutationResult = Apollo.MutationResult<LocomotivePriceTechnicalServiceUpdateMutation>;
export type LocomotivePriceTechnicalServiceUpdateMutationOptions = Apollo.BaseMutationOptions<LocomotivePriceTechnicalServiceUpdateMutation, LocomotivePriceTechnicalServiceUpdateMutationVariables>;
export const TractionDirectorateFiltersDocument = /*#__PURE__*/ gql`
    query tractionDirectorateFilters($range: RangeInputDto!) {
  classifiers {
    tractionDirectorate {
      list(paginate: {per_page: 50, page: 0}, order_by: [], where: {}, range: $range) {
        items {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useTractionDirectorateFiltersQuery__
 *
 * To run a query within a React component, call `useTractionDirectorateFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTractionDirectorateFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTractionDirectorateFiltersQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTractionDirectorateFiltersQuery(baseOptions: Apollo.QueryHookOptions<TractionDirectorateFiltersQuery, TractionDirectorateFiltersQueryVariables> & ({ variables: TractionDirectorateFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TractionDirectorateFiltersQuery, TractionDirectorateFiltersQueryVariables>(TractionDirectorateFiltersDocument, options);
      }
export function useTractionDirectorateFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TractionDirectorateFiltersQuery, TractionDirectorateFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TractionDirectorateFiltersQuery, TractionDirectorateFiltersQueryVariables>(TractionDirectorateFiltersDocument, options);
        }
export function useTractionDirectorateFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TractionDirectorateFiltersQuery, TractionDirectorateFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TractionDirectorateFiltersQuery, TractionDirectorateFiltersQueryVariables>(TractionDirectorateFiltersDocument, options);
        }
export type TractionDirectorateFiltersQueryHookResult = ReturnType<typeof useTractionDirectorateFiltersQuery>;
export type TractionDirectorateFiltersLazyQueryHookResult = ReturnType<typeof useTractionDirectorateFiltersLazyQuery>;
export type TractionDirectorateFiltersSuspenseQueryHookResult = ReturnType<typeof useTractionDirectorateFiltersSuspenseQuery>;
export type TractionDirectorateFiltersQueryResult = Apollo.QueryResult<TractionDirectorateFiltersQuery, TractionDirectorateFiltersQueryVariables>;
export const LocomotiveSeriesCreateDocument = /*#__PURE__*/ gql`
    mutation locomotiveSeriesCreate($data: CreateLocomotiveSeriesDto!) {
  classifiers {
    locomotiveSeries {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type LocomotiveSeriesCreateMutationFn = Apollo.MutationFunction<LocomotiveSeriesCreateMutation, LocomotiveSeriesCreateMutationVariables>;

/**
 * __useLocomotiveSeriesCreateMutation__
 *
 * To run a mutation, you first call `useLocomotiveSeriesCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveSeriesCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locomotiveSeriesCreateMutation, { data, loading, error }] = useLocomotiveSeriesCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLocomotiveSeriesCreateMutation(baseOptions?: Apollo.MutationHookOptions<LocomotiveSeriesCreateMutation, LocomotiveSeriesCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocomotiveSeriesCreateMutation, LocomotiveSeriesCreateMutationVariables>(LocomotiveSeriesCreateDocument, options);
      }
export type LocomotiveSeriesCreateMutationHookResult = ReturnType<typeof useLocomotiveSeriesCreateMutation>;
export type LocomotiveSeriesCreateMutationResult = Apollo.MutationResult<LocomotiveSeriesCreateMutation>;
export type LocomotiveSeriesCreateMutationOptions = Apollo.BaseMutationOptions<LocomotiveSeriesCreateMutation, LocomotiveSeriesCreateMutationVariables>;
export const LocomotiveSeriesHistoryDocument = /*#__PURE__*/ gql`
    query locomotiveSeriesHistory($entityId: Float!, $paginate: PaginatorArgsDto!, $orderBy: [LocomotiveSeriesQueryResolver_History_SortingInputType!]) {
  classifiers {
    locomotiveSeries {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          start_at
          end_at
          ...LocomotiveSeriesBaseFragment
          locomotive_traction_type {
            ...LocomotiveTractionTypeBaseFragment
          }
        }
        totalCount
      }
    }
  }
}
    ${LocomotiveSeriesBaseFragmentFragmentDoc}
${LocomotiveTractionTypeBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveSeriesHistoryQuery__
 *
 * To run a query within a React component, call `useLocomotiveSeriesHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveSeriesHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveSeriesHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLocomotiveSeriesHistoryQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveSeriesHistoryQuery, LocomotiveSeriesHistoryQueryVariables> & ({ variables: LocomotiveSeriesHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveSeriesHistoryQuery, LocomotiveSeriesHistoryQueryVariables>(LocomotiveSeriesHistoryDocument, options);
      }
export function useLocomotiveSeriesHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveSeriesHistoryQuery, LocomotiveSeriesHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveSeriesHistoryQuery, LocomotiveSeriesHistoryQueryVariables>(LocomotiveSeriesHistoryDocument, options);
        }
export function useLocomotiveSeriesHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveSeriesHistoryQuery, LocomotiveSeriesHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveSeriesHistoryQuery, LocomotiveSeriesHistoryQueryVariables>(LocomotiveSeriesHistoryDocument, options);
        }
export type LocomotiveSeriesHistoryQueryHookResult = ReturnType<typeof useLocomotiveSeriesHistoryQuery>;
export type LocomotiveSeriesHistoryLazyQueryHookResult = ReturnType<typeof useLocomotiveSeriesHistoryLazyQuery>;
export type LocomotiveSeriesHistorySuspenseQueryHookResult = ReturnType<typeof useLocomotiveSeriesHistorySuspenseQuery>;
export type LocomotiveSeriesHistoryQueryResult = Apollo.QueryResult<LocomotiveSeriesHistoryQuery, LocomotiveSeriesHistoryQueryVariables>;
export const LocomotiveSeriesListDocument = /*#__PURE__*/ gql`
    query locomotiveSeriesList($paginate: PaginatorArgsDto!, $orderBy: [LocomotiveSeriesQueryResolver_List_SortingInputType!], $where: LocomotiveSeriesQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    locomotiveSeries {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...LocomotiveSeriesBaseFragment
          locomotive_traction_type {
            ...LocomotiveTractionTypeBaseFragment
          }
        }
        totalCount
      }
    }
  }
}
    ${LocomotiveSeriesBaseFragmentFragmentDoc}
${LocomotiveTractionTypeBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveSeriesListQuery__
 *
 * To run a query within a React component, call `useLocomotiveSeriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveSeriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveSeriesListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useLocomotiveSeriesListQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveSeriesListQuery, LocomotiveSeriesListQueryVariables> & ({ variables: LocomotiveSeriesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveSeriesListQuery, LocomotiveSeriesListQueryVariables>(LocomotiveSeriesListDocument, options);
      }
export function useLocomotiveSeriesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveSeriesListQuery, LocomotiveSeriesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveSeriesListQuery, LocomotiveSeriesListQueryVariables>(LocomotiveSeriesListDocument, options);
        }
export function useLocomotiveSeriesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveSeriesListQuery, LocomotiveSeriesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveSeriesListQuery, LocomotiveSeriesListQueryVariables>(LocomotiveSeriesListDocument, options);
        }
export type LocomotiveSeriesListQueryHookResult = ReturnType<typeof useLocomotiveSeriesListQuery>;
export type LocomotiveSeriesListLazyQueryHookResult = ReturnType<typeof useLocomotiveSeriesListLazyQuery>;
export type LocomotiveSeriesListSuspenseQueryHookResult = ReturnType<typeof useLocomotiveSeriesListSuspenseQuery>;
export type LocomotiveSeriesListQueryResult = Apollo.QueryResult<LocomotiveSeriesListQuery, LocomotiveSeriesListQueryVariables>;
export const LocomotiveSeriesRangeByIdDocument = /*#__PURE__*/ gql`
    query locomotiveSeriesRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    locomotiveSeries {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useLocomotiveSeriesRangeByIdQuery__
 *
 * To run a query within a React component, call `useLocomotiveSeriesRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveSeriesRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveSeriesRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useLocomotiveSeriesRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveSeriesRangeByIdQuery, LocomotiveSeriesRangeByIdQueryVariables> & ({ variables: LocomotiveSeriesRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveSeriesRangeByIdQuery, LocomotiveSeriesRangeByIdQueryVariables>(LocomotiveSeriesRangeByIdDocument, options);
      }
export function useLocomotiveSeriesRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveSeriesRangeByIdQuery, LocomotiveSeriesRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveSeriesRangeByIdQuery, LocomotiveSeriesRangeByIdQueryVariables>(LocomotiveSeriesRangeByIdDocument, options);
        }
export function useLocomotiveSeriesRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveSeriesRangeByIdQuery, LocomotiveSeriesRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveSeriesRangeByIdQuery, LocomotiveSeriesRangeByIdQueryVariables>(LocomotiveSeriesRangeByIdDocument, options);
        }
export type LocomotiveSeriesRangeByIdQueryHookResult = ReturnType<typeof useLocomotiveSeriesRangeByIdQuery>;
export type LocomotiveSeriesRangeByIdLazyQueryHookResult = ReturnType<typeof useLocomotiveSeriesRangeByIdLazyQuery>;
export type LocomotiveSeriesRangeByIdSuspenseQueryHookResult = ReturnType<typeof useLocomotiveSeriesRangeByIdSuspenseQuery>;
export type LocomotiveSeriesRangeByIdQueryResult = Apollo.QueryResult<LocomotiveSeriesRangeByIdQuery, LocomotiveSeriesRangeByIdQueryVariables>;
export const LocomotiveSeriesUpdateDocument = /*#__PURE__*/ gql`
    mutation LocomotiveSeriesUpdate($data: UpdateLocomotiveSeriesDto!) {
  classifiers {
    locomotiveSeries {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type LocomotiveSeriesUpdateMutationFn = Apollo.MutationFunction<LocomotiveSeriesUpdateMutation, LocomotiveSeriesUpdateMutationVariables>;

/**
 * __useLocomotiveSeriesUpdateMutation__
 *
 * To run a mutation, you first call `useLocomotiveSeriesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveSeriesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locomotiveSeriesUpdateMutation, { data, loading, error }] = useLocomotiveSeriesUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLocomotiveSeriesUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LocomotiveSeriesUpdateMutation, LocomotiveSeriesUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocomotiveSeriesUpdateMutation, LocomotiveSeriesUpdateMutationVariables>(LocomotiveSeriesUpdateDocument, options);
      }
export type LocomotiveSeriesUpdateMutationHookResult = ReturnType<typeof useLocomotiveSeriesUpdateMutation>;
export type LocomotiveSeriesUpdateMutationResult = Apollo.MutationResult<LocomotiveSeriesUpdateMutation>;
export type LocomotiveSeriesUpdateMutationOptions = Apollo.BaseMutationOptions<LocomotiveSeriesUpdateMutation, LocomotiveSeriesUpdateMutationVariables>;
export const LocomotiveSeriesTypeListDocument = /*#__PURE__*/ gql`
    query locomotiveSeriesTypeList($paginate: PaginatorArgsDto!, $orderBy: [LocomotiveSeriesTypeQueryResolver_List_SortingInputType!], $where: LocomotiveSeriesTypeQueryResolver_List_FilterInputType) {
  classifiers {
    locomotiveSeriesType {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        items {
          ...LocomotiveSeriesTypeBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${LocomotiveSeriesTypeBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveSeriesTypeListQuery__
 *
 * To run a query within a React component, call `useLocomotiveSeriesTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveSeriesTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveSeriesTypeListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLocomotiveSeriesTypeListQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveSeriesTypeListQuery, LocomotiveSeriesTypeListQueryVariables> & ({ variables: LocomotiveSeriesTypeListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveSeriesTypeListQuery, LocomotiveSeriesTypeListQueryVariables>(LocomotiveSeriesTypeListDocument, options);
      }
export function useLocomotiveSeriesTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveSeriesTypeListQuery, LocomotiveSeriesTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveSeriesTypeListQuery, LocomotiveSeriesTypeListQueryVariables>(LocomotiveSeriesTypeListDocument, options);
        }
export function useLocomotiveSeriesTypeListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveSeriesTypeListQuery, LocomotiveSeriesTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveSeriesTypeListQuery, LocomotiveSeriesTypeListQueryVariables>(LocomotiveSeriesTypeListDocument, options);
        }
export type LocomotiveSeriesTypeListQueryHookResult = ReturnType<typeof useLocomotiveSeriesTypeListQuery>;
export type LocomotiveSeriesTypeListLazyQueryHookResult = ReturnType<typeof useLocomotiveSeriesTypeListLazyQuery>;
export type LocomotiveSeriesTypeListSuspenseQueryHookResult = ReturnType<typeof useLocomotiveSeriesTypeListSuspenseQuery>;
export type LocomotiveSeriesTypeListQueryResult = Apollo.QueryResult<LocomotiveSeriesTypeListQuery, LocomotiveSeriesTypeListQueryVariables>;
export const LocomotiveServiceEmpiricalParameterCreateDocument = /*#__PURE__*/ gql`
    mutation locomotiveServiceEmpiricalParameterCreate($data: CreateLocomotiveServiceEmpiricalParameterDto!) {
  classifiers {
    locomotiveServiceEmpiricalParameter {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type LocomotiveServiceEmpiricalParameterCreateMutationFn = Apollo.MutationFunction<LocomotiveServiceEmpiricalParameterCreateMutation, LocomotiveServiceEmpiricalParameterCreateMutationVariables>;

/**
 * __useLocomotiveServiceEmpiricalParameterCreateMutation__
 *
 * To run a mutation, you first call `useLocomotiveServiceEmpiricalParameterCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveServiceEmpiricalParameterCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locomotiveServiceEmpiricalParameterCreateMutation, { data, loading, error }] = useLocomotiveServiceEmpiricalParameterCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLocomotiveServiceEmpiricalParameterCreateMutation(baseOptions?: Apollo.MutationHookOptions<LocomotiveServiceEmpiricalParameterCreateMutation, LocomotiveServiceEmpiricalParameterCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocomotiveServiceEmpiricalParameterCreateMutation, LocomotiveServiceEmpiricalParameterCreateMutationVariables>(LocomotiveServiceEmpiricalParameterCreateDocument, options);
      }
export type LocomotiveServiceEmpiricalParameterCreateMutationHookResult = ReturnType<typeof useLocomotiveServiceEmpiricalParameterCreateMutation>;
export type LocomotiveServiceEmpiricalParameterCreateMutationResult = Apollo.MutationResult<LocomotiveServiceEmpiricalParameterCreateMutation>;
export type LocomotiveServiceEmpiricalParameterCreateMutationOptions = Apollo.BaseMutationOptions<LocomotiveServiceEmpiricalParameterCreateMutation, LocomotiveServiceEmpiricalParameterCreateMutationVariables>;
export const LocomotiveServiceEmpiricalParameterHistoryDocument = /*#__PURE__*/ gql`
    query locomotiveServiceEmpiricalParameterHistory($entityId: Float!, $paginate: PaginatorArgsDto!, $orderBy: [LocomotiveServiceEmpiricalParameterQueryResolver_History_SortingInputType!]) {
  classifiers {
    locomotiveServiceEmpiricalParameter {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          start_at
          end_at
          mnemonic {
            ...MnemonicShortFragment
          }
          ...LocomotiveServiceEmpiricalParameterBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${MnemonicShortFragmentFragmentDoc}
${LocomotiveServiceEmpiricalParameterBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveServiceEmpiricalParameterHistoryQuery__
 *
 * To run a query within a React component, call `useLocomotiveServiceEmpiricalParameterHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveServiceEmpiricalParameterHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveServiceEmpiricalParameterHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLocomotiveServiceEmpiricalParameterHistoryQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveServiceEmpiricalParameterHistoryQuery, LocomotiveServiceEmpiricalParameterHistoryQueryVariables> & ({ variables: LocomotiveServiceEmpiricalParameterHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveServiceEmpiricalParameterHistoryQuery, LocomotiveServiceEmpiricalParameterHistoryQueryVariables>(LocomotiveServiceEmpiricalParameterHistoryDocument, options);
      }
export function useLocomotiveServiceEmpiricalParameterHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveServiceEmpiricalParameterHistoryQuery, LocomotiveServiceEmpiricalParameterHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveServiceEmpiricalParameterHistoryQuery, LocomotiveServiceEmpiricalParameterHistoryQueryVariables>(LocomotiveServiceEmpiricalParameterHistoryDocument, options);
        }
export function useLocomotiveServiceEmpiricalParameterHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveServiceEmpiricalParameterHistoryQuery, LocomotiveServiceEmpiricalParameterHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveServiceEmpiricalParameterHistoryQuery, LocomotiveServiceEmpiricalParameterHistoryQueryVariables>(LocomotiveServiceEmpiricalParameterHistoryDocument, options);
        }
export type LocomotiveServiceEmpiricalParameterHistoryQueryHookResult = ReturnType<typeof useLocomotiveServiceEmpiricalParameterHistoryQuery>;
export type LocomotiveServiceEmpiricalParameterHistoryLazyQueryHookResult = ReturnType<typeof useLocomotiveServiceEmpiricalParameterHistoryLazyQuery>;
export type LocomotiveServiceEmpiricalParameterHistorySuspenseQueryHookResult = ReturnType<typeof useLocomotiveServiceEmpiricalParameterHistorySuspenseQuery>;
export type LocomotiveServiceEmpiricalParameterHistoryQueryResult = Apollo.QueryResult<LocomotiveServiceEmpiricalParameterHistoryQuery, LocomotiveServiceEmpiricalParameterHistoryQueryVariables>;
export const LocomotiveServiceEmpiricalParameterListDocument = /*#__PURE__*/ gql`
    query locomotiveServiceEmpiricalParameterList($paginate: PaginatorArgsDto!, $orderBy: [LocomotiveServiceEmpiricalParameterQueryResolver_List_SortingInputType!], $where: LocomotiveServiceEmpiricalParameterQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    locomotiveServiceEmpiricalParameter {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          mnemonic {
            ...MnemonicShortFragment
          }
          ...LocomotiveServiceEmpiricalParameterBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${MnemonicShortFragmentFragmentDoc}
${LocomotiveServiceEmpiricalParameterBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveServiceEmpiricalParameterListQuery__
 *
 * To run a query within a React component, call `useLocomotiveServiceEmpiricalParameterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveServiceEmpiricalParameterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveServiceEmpiricalParameterListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useLocomotiveServiceEmpiricalParameterListQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveServiceEmpiricalParameterListQuery, LocomotiveServiceEmpiricalParameterListQueryVariables> & ({ variables: LocomotiveServiceEmpiricalParameterListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveServiceEmpiricalParameterListQuery, LocomotiveServiceEmpiricalParameterListQueryVariables>(LocomotiveServiceEmpiricalParameterListDocument, options);
      }
export function useLocomotiveServiceEmpiricalParameterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveServiceEmpiricalParameterListQuery, LocomotiveServiceEmpiricalParameterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveServiceEmpiricalParameterListQuery, LocomotiveServiceEmpiricalParameterListQueryVariables>(LocomotiveServiceEmpiricalParameterListDocument, options);
        }
export function useLocomotiveServiceEmpiricalParameterListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveServiceEmpiricalParameterListQuery, LocomotiveServiceEmpiricalParameterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveServiceEmpiricalParameterListQuery, LocomotiveServiceEmpiricalParameterListQueryVariables>(LocomotiveServiceEmpiricalParameterListDocument, options);
        }
export type LocomotiveServiceEmpiricalParameterListQueryHookResult = ReturnType<typeof useLocomotiveServiceEmpiricalParameterListQuery>;
export type LocomotiveServiceEmpiricalParameterListLazyQueryHookResult = ReturnType<typeof useLocomotiveServiceEmpiricalParameterListLazyQuery>;
export type LocomotiveServiceEmpiricalParameterListSuspenseQueryHookResult = ReturnType<typeof useLocomotiveServiceEmpiricalParameterListSuspenseQuery>;
export type LocomotiveServiceEmpiricalParameterListQueryResult = Apollo.QueryResult<LocomotiveServiceEmpiricalParameterListQuery, LocomotiveServiceEmpiricalParameterListQueryVariables>;
export const LocomotiveServiceEmpiricalParameterRangeByIdDocument = /*#__PURE__*/ gql`
    query locomotiveServiceEmpiricalParameterRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    locomotiveServiceEmpiricalParameter {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useLocomotiveServiceEmpiricalParameterRangeByIdQuery__
 *
 * To run a query within a React component, call `useLocomotiveServiceEmpiricalParameterRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveServiceEmpiricalParameterRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveServiceEmpiricalParameterRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useLocomotiveServiceEmpiricalParameterRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveServiceEmpiricalParameterRangeByIdQuery, LocomotiveServiceEmpiricalParameterRangeByIdQueryVariables> & ({ variables: LocomotiveServiceEmpiricalParameterRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveServiceEmpiricalParameterRangeByIdQuery, LocomotiveServiceEmpiricalParameterRangeByIdQueryVariables>(LocomotiveServiceEmpiricalParameterRangeByIdDocument, options);
      }
export function useLocomotiveServiceEmpiricalParameterRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveServiceEmpiricalParameterRangeByIdQuery, LocomotiveServiceEmpiricalParameterRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveServiceEmpiricalParameterRangeByIdQuery, LocomotiveServiceEmpiricalParameterRangeByIdQueryVariables>(LocomotiveServiceEmpiricalParameterRangeByIdDocument, options);
        }
export function useLocomotiveServiceEmpiricalParameterRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveServiceEmpiricalParameterRangeByIdQuery, LocomotiveServiceEmpiricalParameterRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveServiceEmpiricalParameterRangeByIdQuery, LocomotiveServiceEmpiricalParameterRangeByIdQueryVariables>(LocomotiveServiceEmpiricalParameterRangeByIdDocument, options);
        }
export type LocomotiveServiceEmpiricalParameterRangeByIdQueryHookResult = ReturnType<typeof useLocomotiveServiceEmpiricalParameterRangeByIdQuery>;
export type LocomotiveServiceEmpiricalParameterRangeByIdLazyQueryHookResult = ReturnType<typeof useLocomotiveServiceEmpiricalParameterRangeByIdLazyQuery>;
export type LocomotiveServiceEmpiricalParameterRangeByIdSuspenseQueryHookResult = ReturnType<typeof useLocomotiveServiceEmpiricalParameterRangeByIdSuspenseQuery>;
export type LocomotiveServiceEmpiricalParameterRangeByIdQueryResult = Apollo.QueryResult<LocomotiveServiceEmpiricalParameterRangeByIdQuery, LocomotiveServiceEmpiricalParameterRangeByIdQueryVariables>;
export const LocomotiveServiceEmpiricalParameterUpdateDocument = /*#__PURE__*/ gql`
    mutation locomotiveServiceEmpiricalParameterUpdate($data: UpdateLocomotiveServiceEmpiricalParameterDto!) {
  classifiers {
    locomotiveServiceEmpiricalParameter {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type LocomotiveServiceEmpiricalParameterUpdateMutationFn = Apollo.MutationFunction<LocomotiveServiceEmpiricalParameterUpdateMutation, LocomotiveServiceEmpiricalParameterUpdateMutationVariables>;

/**
 * __useLocomotiveServiceEmpiricalParameterUpdateMutation__
 *
 * To run a mutation, you first call `useLocomotiveServiceEmpiricalParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveServiceEmpiricalParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locomotiveServiceEmpiricalParameterUpdateMutation, { data, loading, error }] = useLocomotiveServiceEmpiricalParameterUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLocomotiveServiceEmpiricalParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LocomotiveServiceEmpiricalParameterUpdateMutation, LocomotiveServiceEmpiricalParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocomotiveServiceEmpiricalParameterUpdateMutation, LocomotiveServiceEmpiricalParameterUpdateMutationVariables>(LocomotiveServiceEmpiricalParameterUpdateDocument, options);
      }
export type LocomotiveServiceEmpiricalParameterUpdateMutationHookResult = ReturnType<typeof useLocomotiveServiceEmpiricalParameterUpdateMutation>;
export type LocomotiveServiceEmpiricalParameterUpdateMutationResult = Apollo.MutationResult<LocomotiveServiceEmpiricalParameterUpdateMutation>;
export type LocomotiveServiceEmpiricalParameterUpdateMutationOptions = Apollo.BaseMutationOptions<LocomotiveServiceEmpiricalParameterUpdateMutation, LocomotiveServiceEmpiricalParameterUpdateMutationVariables>;
export const LocomotiveTeamPriceRentCreateDocument = /*#__PURE__*/ gql`
    mutation locomotiveTeamPriceRentCreate($data: CreateLocomotiveTeamPriceRentDto!) {
  classifiers {
    locomotiveTeamPriceRent {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type LocomotiveTeamPriceRentCreateMutationFn = Apollo.MutationFunction<LocomotiveTeamPriceRentCreateMutation, LocomotiveTeamPriceRentCreateMutationVariables>;

/**
 * __useLocomotiveTeamPriceRentCreateMutation__
 *
 * To run a mutation, you first call `useLocomotiveTeamPriceRentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveTeamPriceRentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locomotiveTeamPriceRentCreateMutation, { data, loading, error }] = useLocomotiveTeamPriceRentCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLocomotiveTeamPriceRentCreateMutation(baseOptions?: Apollo.MutationHookOptions<LocomotiveTeamPriceRentCreateMutation, LocomotiveTeamPriceRentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocomotiveTeamPriceRentCreateMutation, LocomotiveTeamPriceRentCreateMutationVariables>(LocomotiveTeamPriceRentCreateDocument, options);
      }
export type LocomotiveTeamPriceRentCreateMutationHookResult = ReturnType<typeof useLocomotiveTeamPriceRentCreateMutation>;
export type LocomotiveTeamPriceRentCreateMutationResult = Apollo.MutationResult<LocomotiveTeamPriceRentCreateMutation>;
export type LocomotiveTeamPriceRentCreateMutationOptions = Apollo.BaseMutationOptions<LocomotiveTeamPriceRentCreateMutation, LocomotiveTeamPriceRentCreateMutationVariables>;
export const LocomotiveTeamPriceRentHistoryDocument = /*#__PURE__*/ gql`
    query locomotiveTeamPriceRentHistory($entityId: Float!, $paginate: PaginatorArgsDto!, $orderBy: [LocomotiveTeamPriceRentQueryResolver_History_SortingInputType!]) {
  classifiers {
    locomotiveTeamPriceRent {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          start_at
          end_at
          traction_directorate {
            ...TractionDirectorateShortFragment
          }
          ...LocomotiveTeamPriceRentBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${TractionDirectorateShortFragmentFragmentDoc}
${LocomotiveTeamPriceRentBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveTeamPriceRentHistoryQuery__
 *
 * To run a query within a React component, call `useLocomotiveTeamPriceRentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveTeamPriceRentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveTeamPriceRentHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLocomotiveTeamPriceRentHistoryQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveTeamPriceRentHistoryQuery, LocomotiveTeamPriceRentHistoryQueryVariables> & ({ variables: LocomotiveTeamPriceRentHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveTeamPriceRentHistoryQuery, LocomotiveTeamPriceRentHistoryQueryVariables>(LocomotiveTeamPriceRentHistoryDocument, options);
      }
export function useLocomotiveTeamPriceRentHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveTeamPriceRentHistoryQuery, LocomotiveTeamPriceRentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveTeamPriceRentHistoryQuery, LocomotiveTeamPriceRentHistoryQueryVariables>(LocomotiveTeamPriceRentHistoryDocument, options);
        }
export function useLocomotiveTeamPriceRentHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveTeamPriceRentHistoryQuery, LocomotiveTeamPriceRentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveTeamPriceRentHistoryQuery, LocomotiveTeamPriceRentHistoryQueryVariables>(LocomotiveTeamPriceRentHistoryDocument, options);
        }
export type LocomotiveTeamPriceRentHistoryQueryHookResult = ReturnType<typeof useLocomotiveTeamPriceRentHistoryQuery>;
export type LocomotiveTeamPriceRentHistoryLazyQueryHookResult = ReturnType<typeof useLocomotiveTeamPriceRentHistoryLazyQuery>;
export type LocomotiveTeamPriceRentHistorySuspenseQueryHookResult = ReturnType<typeof useLocomotiveTeamPriceRentHistorySuspenseQuery>;
export type LocomotiveTeamPriceRentHistoryQueryResult = Apollo.QueryResult<LocomotiveTeamPriceRentHistoryQuery, LocomotiveTeamPriceRentHistoryQueryVariables>;
export const LocomotiveTeamPriceRentListDocument = /*#__PURE__*/ gql`
    query locomotiveTeamPriceRentList($paginate: PaginatorArgsDto!, $orderBy: [LocomotiveTeamPriceRentQueryResolver_List_SortingInputType!], $where: LocomotiveTeamPriceRentQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    locomotiveTeamPriceRent {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          traction_directorate {
            ...TractionDirectorateShortFragment
          }
          ...LocomotiveTeamPriceRentBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${TractionDirectorateShortFragmentFragmentDoc}
${LocomotiveTeamPriceRentBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveTeamPriceRentListQuery__
 *
 * To run a query within a React component, call `useLocomotiveTeamPriceRentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveTeamPriceRentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveTeamPriceRentListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useLocomotiveTeamPriceRentListQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveTeamPriceRentListQuery, LocomotiveTeamPriceRentListQueryVariables> & ({ variables: LocomotiveTeamPriceRentListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveTeamPriceRentListQuery, LocomotiveTeamPriceRentListQueryVariables>(LocomotiveTeamPriceRentListDocument, options);
      }
export function useLocomotiveTeamPriceRentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveTeamPriceRentListQuery, LocomotiveTeamPriceRentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveTeamPriceRentListQuery, LocomotiveTeamPriceRentListQueryVariables>(LocomotiveTeamPriceRentListDocument, options);
        }
export function useLocomotiveTeamPriceRentListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveTeamPriceRentListQuery, LocomotiveTeamPriceRentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveTeamPriceRentListQuery, LocomotiveTeamPriceRentListQueryVariables>(LocomotiveTeamPriceRentListDocument, options);
        }
export type LocomotiveTeamPriceRentListQueryHookResult = ReturnType<typeof useLocomotiveTeamPriceRentListQuery>;
export type LocomotiveTeamPriceRentListLazyQueryHookResult = ReturnType<typeof useLocomotiveTeamPriceRentListLazyQuery>;
export type LocomotiveTeamPriceRentListSuspenseQueryHookResult = ReturnType<typeof useLocomotiveTeamPriceRentListSuspenseQuery>;
export type LocomotiveTeamPriceRentListQueryResult = Apollo.QueryResult<LocomotiveTeamPriceRentListQuery, LocomotiveTeamPriceRentListQueryVariables>;
export const LocomotiveTeamPriceRentRangeByIdDocument = /*#__PURE__*/ gql`
    query locomotiveTeamPriceRentRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    locomotiveTeamPriceRent {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useLocomotiveTeamPriceRentRangeByIdQuery__
 *
 * To run a query within a React component, call `useLocomotiveTeamPriceRentRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveTeamPriceRentRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveTeamPriceRentRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useLocomotiveTeamPriceRentRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveTeamPriceRentRangeByIdQuery, LocomotiveTeamPriceRentRangeByIdQueryVariables> & ({ variables: LocomotiveTeamPriceRentRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveTeamPriceRentRangeByIdQuery, LocomotiveTeamPriceRentRangeByIdQueryVariables>(LocomotiveTeamPriceRentRangeByIdDocument, options);
      }
export function useLocomotiveTeamPriceRentRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveTeamPriceRentRangeByIdQuery, LocomotiveTeamPriceRentRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveTeamPriceRentRangeByIdQuery, LocomotiveTeamPriceRentRangeByIdQueryVariables>(LocomotiveTeamPriceRentRangeByIdDocument, options);
        }
export function useLocomotiveTeamPriceRentRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveTeamPriceRentRangeByIdQuery, LocomotiveTeamPriceRentRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveTeamPriceRentRangeByIdQuery, LocomotiveTeamPriceRentRangeByIdQueryVariables>(LocomotiveTeamPriceRentRangeByIdDocument, options);
        }
export type LocomotiveTeamPriceRentRangeByIdQueryHookResult = ReturnType<typeof useLocomotiveTeamPriceRentRangeByIdQuery>;
export type LocomotiveTeamPriceRentRangeByIdLazyQueryHookResult = ReturnType<typeof useLocomotiveTeamPriceRentRangeByIdLazyQuery>;
export type LocomotiveTeamPriceRentRangeByIdSuspenseQueryHookResult = ReturnType<typeof useLocomotiveTeamPriceRentRangeByIdSuspenseQuery>;
export type LocomotiveTeamPriceRentRangeByIdQueryResult = Apollo.QueryResult<LocomotiveTeamPriceRentRangeByIdQuery, LocomotiveTeamPriceRentRangeByIdQueryVariables>;
export const LocomotiveTeamPriceRentUpdateDocument = /*#__PURE__*/ gql`
    mutation LocomotiveTeamPriceRentUpdate($data: UpdateLocomotiveTeamPriceRentDto!) {
  classifiers {
    locomotiveTeamPriceRent {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type LocomotiveTeamPriceRentUpdateMutationFn = Apollo.MutationFunction<LocomotiveTeamPriceRentUpdateMutation, LocomotiveTeamPriceRentUpdateMutationVariables>;

/**
 * __useLocomotiveTeamPriceRentUpdateMutation__
 *
 * To run a mutation, you first call `useLocomotiveTeamPriceRentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveTeamPriceRentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locomotiveTeamPriceRentUpdateMutation, { data, loading, error }] = useLocomotiveTeamPriceRentUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLocomotiveTeamPriceRentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LocomotiveTeamPriceRentUpdateMutation, LocomotiveTeamPriceRentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocomotiveTeamPriceRentUpdateMutation, LocomotiveTeamPriceRentUpdateMutationVariables>(LocomotiveTeamPriceRentUpdateDocument, options);
      }
export type LocomotiveTeamPriceRentUpdateMutationHookResult = ReturnType<typeof useLocomotiveTeamPriceRentUpdateMutation>;
export type LocomotiveTeamPriceRentUpdateMutationResult = Apollo.MutationResult<LocomotiveTeamPriceRentUpdateMutation>;
export type LocomotiveTeamPriceRentUpdateMutationOptions = Apollo.BaseMutationOptions<LocomotiveTeamPriceRentUpdateMutation, LocomotiveTeamPriceRentUpdateMutationVariables>;
export const LocomotiveTractionTypeListDocument = /*#__PURE__*/ gql`
    query locomotiveTractionTypeList($paginate: PaginatorArgsDto!, $orderBy: [LocomotiveTractionTypeQueryResolver_List_SortingInputType!], $where: LocomotiveTractionTypeQueryResolver_List_FilterInputType) {
  classifiers {
    locomotiveTractionType {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        items {
          ...LocomotiveTractionTypeBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${LocomotiveTractionTypeBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveTractionTypeListQuery__
 *
 * To run a query within a React component, call `useLocomotiveTractionTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveTractionTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveTractionTypeListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLocomotiveTractionTypeListQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveTractionTypeListQuery, LocomotiveTractionTypeListQueryVariables> & ({ variables: LocomotiveTractionTypeListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveTractionTypeListQuery, LocomotiveTractionTypeListQueryVariables>(LocomotiveTractionTypeListDocument, options);
      }
export function useLocomotiveTractionTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveTractionTypeListQuery, LocomotiveTractionTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveTractionTypeListQuery, LocomotiveTractionTypeListQueryVariables>(LocomotiveTractionTypeListDocument, options);
        }
export function useLocomotiveTractionTypeListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveTractionTypeListQuery, LocomotiveTractionTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveTractionTypeListQuery, LocomotiveTractionTypeListQueryVariables>(LocomotiveTractionTypeListDocument, options);
        }
export type LocomotiveTractionTypeListQueryHookResult = ReturnType<typeof useLocomotiveTractionTypeListQuery>;
export type LocomotiveTractionTypeListLazyQueryHookResult = ReturnType<typeof useLocomotiveTractionTypeListLazyQuery>;
export type LocomotiveTractionTypeListSuspenseQueryHookResult = ReturnType<typeof useLocomotiveTractionTypeListSuspenseQuery>;
export type LocomotiveTractionTypeListQueryResult = Apollo.QueryResult<LocomotiveTractionTypeListQuery, LocomotiveTractionTypeListQueryVariables>;
export const LocomotiveTypeCurrentListDocument = /*#__PURE__*/ gql`
    query locomotiveTypeCurrentList($paginate: PaginatorArgsDto!, $orderBy: [LocomotiveTypeCurrentQueryResolver_List_SortingInputType!], $where: LocomotiveTypeCurrentQueryResolver_List_FilterInputType) {
  classifiers {
    locomotiveTypeCurrent {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        totalCount
        items {
          ...LocomotiveTypeCurrentBaseFragment
        }
      }
    }
  }
}
    ${LocomotiveTypeCurrentBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveTypeCurrentListQuery__
 *
 * To run a query within a React component, call `useLocomotiveTypeCurrentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveTypeCurrentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveTypeCurrentListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLocomotiveTypeCurrentListQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveTypeCurrentListQuery, LocomotiveTypeCurrentListQueryVariables> & ({ variables: LocomotiveTypeCurrentListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveTypeCurrentListQuery, LocomotiveTypeCurrentListQueryVariables>(LocomotiveTypeCurrentListDocument, options);
      }
export function useLocomotiveTypeCurrentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveTypeCurrentListQuery, LocomotiveTypeCurrentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveTypeCurrentListQuery, LocomotiveTypeCurrentListQueryVariables>(LocomotiveTypeCurrentListDocument, options);
        }
export function useLocomotiveTypeCurrentListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveTypeCurrentListQuery, LocomotiveTypeCurrentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveTypeCurrentListQuery, LocomotiveTypeCurrentListQueryVariables>(LocomotiveTypeCurrentListDocument, options);
        }
export type LocomotiveTypeCurrentListQueryHookResult = ReturnType<typeof useLocomotiveTypeCurrentListQuery>;
export type LocomotiveTypeCurrentListLazyQueryHookResult = ReturnType<typeof useLocomotiveTypeCurrentListLazyQuery>;
export type LocomotiveTypeCurrentListSuspenseQueryHookResult = ReturnType<typeof useLocomotiveTypeCurrentListSuspenseQuery>;
export type LocomotiveTypeCurrentListQueryResult = Apollo.QueryResult<LocomotiveTypeCurrentListQuery, LocomotiveTypeCurrentListQueryVariables>;
export const MaxTrainSpeedCreateDocument = /*#__PURE__*/ gql`
    mutation maxTrainSpeedCreate($data: CreateMaxTrainSpeedDto!) {
  classifiers {
    maxTrainSpeed {
      create(data: $data) {
        id
      }
    }
  }
}
    `;
export type MaxTrainSpeedCreateMutationFn = Apollo.MutationFunction<MaxTrainSpeedCreateMutation, MaxTrainSpeedCreateMutationVariables>;

/**
 * __useMaxTrainSpeedCreateMutation__
 *
 * To run a mutation, you first call `useMaxTrainSpeedCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMaxTrainSpeedCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [maxTrainSpeedCreateMutation, { data, loading, error }] = useMaxTrainSpeedCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMaxTrainSpeedCreateMutation(baseOptions?: Apollo.MutationHookOptions<MaxTrainSpeedCreateMutation, MaxTrainSpeedCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MaxTrainSpeedCreateMutation, MaxTrainSpeedCreateMutationVariables>(MaxTrainSpeedCreateDocument, options);
      }
export type MaxTrainSpeedCreateMutationHookResult = ReturnType<typeof useMaxTrainSpeedCreateMutation>;
export type MaxTrainSpeedCreateMutationResult = Apollo.MutationResult<MaxTrainSpeedCreateMutation>;
export type MaxTrainSpeedCreateMutationOptions = Apollo.BaseMutationOptions<MaxTrainSpeedCreateMutation, MaxTrainSpeedCreateMutationVariables>;
export const MaxTrainSpeedHistoryDocument = /*#__PURE__*/ gql`
    query maxTrainSpeedHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [MaxTrainSpeedQueryResolver_History_SortingInputType!]) {
  classifiers {
    maxTrainSpeed {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          ...MaxTrainSpeedBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${MaxTrainSpeedBaseFragmentFragmentDoc}`;

/**
 * __useMaxTrainSpeedHistoryQuery__
 *
 * To run a query within a React component, call `useMaxTrainSpeedHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaxTrainSpeedHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaxTrainSpeedHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMaxTrainSpeedHistoryQuery(baseOptions: Apollo.QueryHookOptions<MaxTrainSpeedHistoryQuery, MaxTrainSpeedHistoryQueryVariables> & ({ variables: MaxTrainSpeedHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaxTrainSpeedHistoryQuery, MaxTrainSpeedHistoryQueryVariables>(MaxTrainSpeedHistoryDocument, options);
      }
export function useMaxTrainSpeedHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaxTrainSpeedHistoryQuery, MaxTrainSpeedHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaxTrainSpeedHistoryQuery, MaxTrainSpeedHistoryQueryVariables>(MaxTrainSpeedHistoryDocument, options);
        }
export function useMaxTrainSpeedHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaxTrainSpeedHistoryQuery, MaxTrainSpeedHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaxTrainSpeedHistoryQuery, MaxTrainSpeedHistoryQueryVariables>(MaxTrainSpeedHistoryDocument, options);
        }
export type MaxTrainSpeedHistoryQueryHookResult = ReturnType<typeof useMaxTrainSpeedHistoryQuery>;
export type MaxTrainSpeedHistoryLazyQueryHookResult = ReturnType<typeof useMaxTrainSpeedHistoryLazyQuery>;
export type MaxTrainSpeedHistorySuspenseQueryHookResult = ReturnType<typeof useMaxTrainSpeedHistorySuspenseQuery>;
export type MaxTrainSpeedHistoryQueryResult = Apollo.QueryResult<MaxTrainSpeedHistoryQuery, MaxTrainSpeedHistoryQueryVariables>;
export const MaxTrainSpeedListDocument = /*#__PURE__*/ gql`
    query maxTrainSpeedList($range: RangeInputDto!, $paginate: PaginatorArgsDto, $orderBy: [MaxTrainSpeedQueryResolver_List_SortingInputType!], $where: MaxTrainSpeedQueryResolver_List_FilterInputType) {
  classifiers {
    maxTrainSpeed {
      list(range: $range, paginate: $paginate, order_by: $orderBy, where: $where) {
        items {
          ...MaxTrainSpeedBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${MaxTrainSpeedBaseFragmentFragmentDoc}`;

/**
 * __useMaxTrainSpeedListQuery__
 *
 * To run a query within a React component, call `useMaxTrainSpeedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaxTrainSpeedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaxTrainSpeedListQuery({
 *   variables: {
 *      range: // value for 'range'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMaxTrainSpeedListQuery(baseOptions: Apollo.QueryHookOptions<MaxTrainSpeedListQuery, MaxTrainSpeedListQueryVariables> & ({ variables: MaxTrainSpeedListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaxTrainSpeedListQuery, MaxTrainSpeedListQueryVariables>(MaxTrainSpeedListDocument, options);
      }
export function useMaxTrainSpeedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaxTrainSpeedListQuery, MaxTrainSpeedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaxTrainSpeedListQuery, MaxTrainSpeedListQueryVariables>(MaxTrainSpeedListDocument, options);
        }
export function useMaxTrainSpeedListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaxTrainSpeedListQuery, MaxTrainSpeedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaxTrainSpeedListQuery, MaxTrainSpeedListQueryVariables>(MaxTrainSpeedListDocument, options);
        }
export type MaxTrainSpeedListQueryHookResult = ReturnType<typeof useMaxTrainSpeedListQuery>;
export type MaxTrainSpeedListLazyQueryHookResult = ReturnType<typeof useMaxTrainSpeedListLazyQuery>;
export type MaxTrainSpeedListSuspenseQueryHookResult = ReturnType<typeof useMaxTrainSpeedListSuspenseQuery>;
export type MaxTrainSpeedListQueryResult = Apollo.QueryResult<MaxTrainSpeedListQuery, MaxTrainSpeedListQueryVariables>;
export const MaxTrainSpeedRangeByIdDocument = /*#__PURE__*/ gql`
    query maxTrainSpeedRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    maxTrainSpeed {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useMaxTrainSpeedRangeByIdQuery__
 *
 * To run a query within a React component, call `useMaxTrainSpeedRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaxTrainSpeedRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaxTrainSpeedRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMaxTrainSpeedRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<MaxTrainSpeedRangeByIdQuery, MaxTrainSpeedRangeByIdQueryVariables> & ({ variables: MaxTrainSpeedRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaxTrainSpeedRangeByIdQuery, MaxTrainSpeedRangeByIdQueryVariables>(MaxTrainSpeedRangeByIdDocument, options);
      }
export function useMaxTrainSpeedRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaxTrainSpeedRangeByIdQuery, MaxTrainSpeedRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaxTrainSpeedRangeByIdQuery, MaxTrainSpeedRangeByIdQueryVariables>(MaxTrainSpeedRangeByIdDocument, options);
        }
export function useMaxTrainSpeedRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaxTrainSpeedRangeByIdQuery, MaxTrainSpeedRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaxTrainSpeedRangeByIdQuery, MaxTrainSpeedRangeByIdQueryVariables>(MaxTrainSpeedRangeByIdDocument, options);
        }
export type MaxTrainSpeedRangeByIdQueryHookResult = ReturnType<typeof useMaxTrainSpeedRangeByIdQuery>;
export type MaxTrainSpeedRangeByIdLazyQueryHookResult = ReturnType<typeof useMaxTrainSpeedRangeByIdLazyQuery>;
export type MaxTrainSpeedRangeByIdSuspenseQueryHookResult = ReturnType<typeof useMaxTrainSpeedRangeByIdSuspenseQuery>;
export type MaxTrainSpeedRangeByIdQueryResult = Apollo.QueryResult<MaxTrainSpeedRangeByIdQuery, MaxTrainSpeedRangeByIdQueryVariables>;
export const MaxTrainSpeedUpdateDocument = /*#__PURE__*/ gql`
    mutation maxTrainSpeedUpdate($data: UpdateMaxTrainSpeedDto!) {
  classifiers {
    maxTrainSpeed {
      update(data: $data) {
        id
      }
    }
  }
}
    `;
export type MaxTrainSpeedUpdateMutationFn = Apollo.MutationFunction<MaxTrainSpeedUpdateMutation, MaxTrainSpeedUpdateMutationVariables>;

/**
 * __useMaxTrainSpeedUpdateMutation__
 *
 * To run a mutation, you first call `useMaxTrainSpeedUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMaxTrainSpeedUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [maxTrainSpeedUpdateMutation, { data, loading, error }] = useMaxTrainSpeedUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMaxTrainSpeedUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MaxTrainSpeedUpdateMutation, MaxTrainSpeedUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MaxTrainSpeedUpdateMutation, MaxTrainSpeedUpdateMutationVariables>(MaxTrainSpeedUpdateDocument, options);
      }
export type MaxTrainSpeedUpdateMutationHookResult = ReturnType<typeof useMaxTrainSpeedUpdateMutation>;
export type MaxTrainSpeedUpdateMutationResult = Apollo.MutationResult<MaxTrainSpeedUpdateMutation>;
export type MaxTrainSpeedUpdateMutationOptions = Apollo.BaseMutationOptions<MaxTrainSpeedUpdateMutation, MaxTrainSpeedUpdateMutationVariables>;
export const UpdateMnemonicDocument = /*#__PURE__*/ gql`
    mutation updateMnemonic($data: UpdateMnemonicDto!) {
  classifiers {
    mnemonic {
      update(data: $data)
    }
  }
}
    `;
export type UpdateMnemonicMutationFn = Apollo.MutationFunction<UpdateMnemonicMutation, UpdateMnemonicMutationVariables>;

/**
 * __useUpdateMnemonicMutation__
 *
 * To run a mutation, you first call `useUpdateMnemonicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMnemonicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMnemonicMutation, { data, loading, error }] = useUpdateMnemonicMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMnemonicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMnemonicMutation, UpdateMnemonicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMnemonicMutation, UpdateMnemonicMutationVariables>(UpdateMnemonicDocument, options);
      }
export type UpdateMnemonicMutationHookResult = ReturnType<typeof useUpdateMnemonicMutation>;
export type UpdateMnemonicMutationResult = Apollo.MutationResult<UpdateMnemonicMutation>;
export type UpdateMnemonicMutationOptions = Apollo.BaseMutationOptions<UpdateMnemonicMutation, UpdateMnemonicMutationVariables>;
export const CreateMvpsCompanyAffiliationDocument = /*#__PURE__*/ gql`
    mutation createMvpsCompanyAffiliation($input: CreateMvpsCompanyAffiliationDto!) {
  classifiers {
    mvpsCompanyAffiliation {
      create(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type CreateMvpsCompanyAffiliationMutationFn = Apollo.MutationFunction<CreateMvpsCompanyAffiliationMutation, CreateMvpsCompanyAffiliationMutationVariables>;

/**
 * __useCreateMvpsCompanyAffiliationMutation__
 *
 * To run a mutation, you first call `useCreateMvpsCompanyAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMvpsCompanyAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMvpsCompanyAffiliationMutation, { data, loading, error }] = useCreateMvpsCompanyAffiliationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMvpsCompanyAffiliationMutation(baseOptions?: Apollo.MutationHookOptions<CreateMvpsCompanyAffiliationMutation, CreateMvpsCompanyAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMvpsCompanyAffiliationMutation, CreateMvpsCompanyAffiliationMutationVariables>(CreateMvpsCompanyAffiliationDocument, options);
      }
export type CreateMvpsCompanyAffiliationMutationHookResult = ReturnType<typeof useCreateMvpsCompanyAffiliationMutation>;
export type CreateMvpsCompanyAffiliationMutationResult = Apollo.MutationResult<CreateMvpsCompanyAffiliationMutation>;
export type CreateMvpsCompanyAffiliationMutationOptions = Apollo.BaseMutationOptions<CreateMvpsCompanyAffiliationMutation, CreateMvpsCompanyAffiliationMutationVariables>;
export const MvpsCompanyAffiliationHistoryDocument = /*#__PURE__*/ gql`
    query mvpsCompanyAffiliationHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [MvpsCompanyAffiliationQueryResolver_History_SortingInputType!]) {
  classifiers {
    mvpsCompanyAffiliation {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          end_at
          ...MvpsCompanyAffiliationBaseFragment
        }
      }
    }
  }
}
    ${MvpsCompanyAffiliationBaseFragmentFragmentDoc}`;

/**
 * __useMvpsCompanyAffiliationHistoryQuery__
 *
 * To run a query within a React component, call `useMvpsCompanyAffiliationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsCompanyAffiliationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsCompanyAffiliationHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMvpsCompanyAffiliationHistoryQuery(baseOptions: Apollo.QueryHookOptions<MvpsCompanyAffiliationHistoryQuery, MvpsCompanyAffiliationHistoryQueryVariables> & ({ variables: MvpsCompanyAffiliationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsCompanyAffiliationHistoryQuery, MvpsCompanyAffiliationHistoryQueryVariables>(MvpsCompanyAffiliationHistoryDocument, options);
      }
export function useMvpsCompanyAffiliationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsCompanyAffiliationHistoryQuery, MvpsCompanyAffiliationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsCompanyAffiliationHistoryQuery, MvpsCompanyAffiliationHistoryQueryVariables>(MvpsCompanyAffiliationHistoryDocument, options);
        }
export function useMvpsCompanyAffiliationHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsCompanyAffiliationHistoryQuery, MvpsCompanyAffiliationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsCompanyAffiliationHistoryQuery, MvpsCompanyAffiliationHistoryQueryVariables>(MvpsCompanyAffiliationHistoryDocument, options);
        }
export type MvpsCompanyAffiliationHistoryQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationHistoryQuery>;
export type MvpsCompanyAffiliationHistoryLazyQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationHistoryLazyQuery>;
export type MvpsCompanyAffiliationHistorySuspenseQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationHistorySuspenseQuery>;
export type MvpsCompanyAffiliationHistoryQueryResult = Apollo.QueryResult<MvpsCompanyAffiliationHistoryQuery, MvpsCompanyAffiliationHistoryQueryVariables>;
export const MvpsCompanyAffiliationRangeByIdDocument = /*#__PURE__*/ gql`
    query mvpsCompanyAffiliationRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    mvpsCompanyAffiliation {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useMvpsCompanyAffiliationRangeByIdQuery__
 *
 * To run a query within a React component, call `useMvpsCompanyAffiliationRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsCompanyAffiliationRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsCompanyAffiliationRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsCompanyAffiliationRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<MvpsCompanyAffiliationRangeByIdQuery, MvpsCompanyAffiliationRangeByIdQueryVariables> & ({ variables: MvpsCompanyAffiliationRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsCompanyAffiliationRangeByIdQuery, MvpsCompanyAffiliationRangeByIdQueryVariables>(MvpsCompanyAffiliationRangeByIdDocument, options);
      }
export function useMvpsCompanyAffiliationRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsCompanyAffiliationRangeByIdQuery, MvpsCompanyAffiliationRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsCompanyAffiliationRangeByIdQuery, MvpsCompanyAffiliationRangeByIdQueryVariables>(MvpsCompanyAffiliationRangeByIdDocument, options);
        }
export function useMvpsCompanyAffiliationRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsCompanyAffiliationRangeByIdQuery, MvpsCompanyAffiliationRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsCompanyAffiliationRangeByIdQuery, MvpsCompanyAffiliationRangeByIdQueryVariables>(MvpsCompanyAffiliationRangeByIdDocument, options);
        }
export type MvpsCompanyAffiliationRangeByIdQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationRangeByIdQuery>;
export type MvpsCompanyAffiliationRangeByIdLazyQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationRangeByIdLazyQuery>;
export type MvpsCompanyAffiliationRangeByIdSuspenseQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationRangeByIdSuspenseQuery>;
export type MvpsCompanyAffiliationRangeByIdQueryResult = Apollo.QueryResult<MvpsCompanyAffiliationRangeByIdQuery, MvpsCompanyAffiliationRangeByIdQueryVariables>;
export const UpdateMvpsCompanyAffiliationDocument = /*#__PURE__*/ gql`
    mutation updateMvpsCompanyAffiliation($input: UpdateMvpsCompanyAffiliationDto!) {
  classifiers {
    mvpsCompanyAffiliation {
      update(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type UpdateMvpsCompanyAffiliationMutationFn = Apollo.MutationFunction<UpdateMvpsCompanyAffiliationMutation, UpdateMvpsCompanyAffiliationMutationVariables>;

/**
 * __useUpdateMvpsCompanyAffiliationMutation__
 *
 * To run a mutation, you first call `useUpdateMvpsCompanyAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMvpsCompanyAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMvpsCompanyAffiliationMutation, { data, loading, error }] = useUpdateMvpsCompanyAffiliationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMvpsCompanyAffiliationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMvpsCompanyAffiliationMutation, UpdateMvpsCompanyAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMvpsCompanyAffiliationMutation, UpdateMvpsCompanyAffiliationMutationVariables>(UpdateMvpsCompanyAffiliationDocument, options);
      }
export type UpdateMvpsCompanyAffiliationMutationHookResult = ReturnType<typeof useUpdateMvpsCompanyAffiliationMutation>;
export type UpdateMvpsCompanyAffiliationMutationResult = Apollo.MutationResult<UpdateMvpsCompanyAffiliationMutation>;
export type UpdateMvpsCompanyAffiliationMutationOptions = Apollo.BaseMutationOptions<UpdateMvpsCompanyAffiliationMutation, UpdateMvpsCompanyAffiliationMutationVariables>;
export const MvpsCompanyAffiliationListDocument = /*#__PURE__*/ gql`
    query mvpsCompanyAffiliationList($paginate: PaginatorArgsDto, $orderBy: [MvpsCompanyAffiliationQueryResolver_List_SortingInputType!], $where: MvpsCompanyAffiliationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    mvpsCompanyAffiliation {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...MvpsCompanyAffiliationBaseFragment
        }
      }
    }
  }
}
    ${MvpsCompanyAffiliationBaseFragmentFragmentDoc}`;

/**
 * __useMvpsCompanyAffiliationListQuery__
 *
 * To run a query within a React component, call `useMvpsCompanyAffiliationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsCompanyAffiliationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsCompanyAffiliationListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsCompanyAffiliationListQuery(baseOptions: Apollo.QueryHookOptions<MvpsCompanyAffiliationListQuery, MvpsCompanyAffiliationListQueryVariables> & ({ variables: MvpsCompanyAffiliationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsCompanyAffiliationListQuery, MvpsCompanyAffiliationListQueryVariables>(MvpsCompanyAffiliationListDocument, options);
      }
export function useMvpsCompanyAffiliationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsCompanyAffiliationListQuery, MvpsCompanyAffiliationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsCompanyAffiliationListQuery, MvpsCompanyAffiliationListQueryVariables>(MvpsCompanyAffiliationListDocument, options);
        }
export function useMvpsCompanyAffiliationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsCompanyAffiliationListQuery, MvpsCompanyAffiliationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsCompanyAffiliationListQuery, MvpsCompanyAffiliationListQueryVariables>(MvpsCompanyAffiliationListDocument, options);
        }
export type MvpsCompanyAffiliationListQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationListQuery>;
export type MvpsCompanyAffiliationListLazyQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationListLazyQuery>;
export type MvpsCompanyAffiliationListSuspenseQueryHookResult = ReturnType<typeof useMvpsCompanyAffiliationListSuspenseQuery>;
export type MvpsCompanyAffiliationListQueryResult = Apollo.QueryResult<MvpsCompanyAffiliationListQuery, MvpsCompanyAffiliationListQueryVariables>;
export const CreateMvpsMartinSectionTypeDocument = /*#__PURE__*/ gql`
    mutation createMvpsMartinSectionType($input: CreateMvpsMartinSectionTypeDto!) {
  classifiers {
    mvpsMartinSectionType {
      create(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type CreateMvpsMartinSectionTypeMutationFn = Apollo.MutationFunction<CreateMvpsMartinSectionTypeMutation, CreateMvpsMartinSectionTypeMutationVariables>;

/**
 * __useCreateMvpsMartinSectionTypeMutation__
 *
 * To run a mutation, you first call `useCreateMvpsMartinSectionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMvpsMartinSectionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMvpsMartinSectionTypeMutation, { data, loading, error }] = useCreateMvpsMartinSectionTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMvpsMartinSectionTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateMvpsMartinSectionTypeMutation, CreateMvpsMartinSectionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMvpsMartinSectionTypeMutation, CreateMvpsMartinSectionTypeMutationVariables>(CreateMvpsMartinSectionTypeDocument, options);
      }
export type CreateMvpsMartinSectionTypeMutationHookResult = ReturnType<typeof useCreateMvpsMartinSectionTypeMutation>;
export type CreateMvpsMartinSectionTypeMutationResult = Apollo.MutationResult<CreateMvpsMartinSectionTypeMutation>;
export type CreateMvpsMartinSectionTypeMutationOptions = Apollo.BaseMutationOptions<CreateMvpsMartinSectionTypeMutation, CreateMvpsMartinSectionTypeMutationVariables>;
export const MvpsMartinSectionTypesHistoryDocument = /*#__PURE__*/ gql`
    query mvpsMartinSectionTypesHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [MvpsMartinSectionTypeQueryResolver_History_SortingInputType!]) {
  classifiers {
    mvpsMartinSectionType {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          ...MvpsMartinSectionTypeBaseFragment
          mvpsMartinSectionTypeEquipmentDto {
            ...MvpsMartinSectionTypeEquipmentShortFragment
          }
        }
      }
    }
  }
}
    ${MvpsMartinSectionTypeBaseFragmentFragmentDoc}
${MvpsMartinSectionTypeEquipmentShortFragmentFragmentDoc}`;

/**
 * __useMvpsMartinSectionTypesHistoryQuery__
 *
 * To run a query within a React component, call `useMvpsMartinSectionTypesHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsMartinSectionTypesHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsMartinSectionTypesHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMvpsMartinSectionTypesHistoryQuery(baseOptions: Apollo.QueryHookOptions<MvpsMartinSectionTypesHistoryQuery, MvpsMartinSectionTypesHistoryQueryVariables> & ({ variables: MvpsMartinSectionTypesHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsMartinSectionTypesHistoryQuery, MvpsMartinSectionTypesHistoryQueryVariables>(MvpsMartinSectionTypesHistoryDocument, options);
      }
export function useMvpsMartinSectionTypesHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsMartinSectionTypesHistoryQuery, MvpsMartinSectionTypesHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsMartinSectionTypesHistoryQuery, MvpsMartinSectionTypesHistoryQueryVariables>(MvpsMartinSectionTypesHistoryDocument, options);
        }
export function useMvpsMartinSectionTypesHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsMartinSectionTypesHistoryQuery, MvpsMartinSectionTypesHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsMartinSectionTypesHistoryQuery, MvpsMartinSectionTypesHistoryQueryVariables>(MvpsMartinSectionTypesHistoryDocument, options);
        }
export type MvpsMartinSectionTypesHistoryQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypesHistoryQuery>;
export type MvpsMartinSectionTypesHistoryLazyQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypesHistoryLazyQuery>;
export type MvpsMartinSectionTypesHistorySuspenseQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypesHistorySuspenseQuery>;
export type MvpsMartinSectionTypesHistoryQueryResult = Apollo.QueryResult<MvpsMartinSectionTypesHistoryQuery, MvpsMartinSectionTypesHistoryQueryVariables>;
export const MvpsMartinSectionTypeRangeByIdDocument = /*#__PURE__*/ gql`
    query mvpsMartinSectionTypeRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    mvpsMartinSectionType {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useMvpsMartinSectionTypeRangeByIdQuery__
 *
 * To run a query within a React component, call `useMvpsMartinSectionTypeRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsMartinSectionTypeRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsMartinSectionTypeRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsMartinSectionTypeRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<MvpsMartinSectionTypeRangeByIdQuery, MvpsMartinSectionTypeRangeByIdQueryVariables> & ({ variables: MvpsMartinSectionTypeRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsMartinSectionTypeRangeByIdQuery, MvpsMartinSectionTypeRangeByIdQueryVariables>(MvpsMartinSectionTypeRangeByIdDocument, options);
      }
export function useMvpsMartinSectionTypeRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsMartinSectionTypeRangeByIdQuery, MvpsMartinSectionTypeRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsMartinSectionTypeRangeByIdQuery, MvpsMartinSectionTypeRangeByIdQueryVariables>(MvpsMartinSectionTypeRangeByIdDocument, options);
        }
export function useMvpsMartinSectionTypeRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsMartinSectionTypeRangeByIdQuery, MvpsMartinSectionTypeRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsMartinSectionTypeRangeByIdQuery, MvpsMartinSectionTypeRangeByIdQueryVariables>(MvpsMartinSectionTypeRangeByIdDocument, options);
        }
export type MvpsMartinSectionTypeRangeByIdQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeRangeByIdQuery>;
export type MvpsMartinSectionTypeRangeByIdLazyQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeRangeByIdLazyQuery>;
export type MvpsMartinSectionTypeRangeByIdSuspenseQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeRangeByIdSuspenseQuery>;
export type MvpsMartinSectionTypeRangeByIdQueryResult = Apollo.QueryResult<MvpsMartinSectionTypeRangeByIdQuery, MvpsMartinSectionTypeRangeByIdQueryVariables>;
export const UpdateMvpsMartinSectionTypeDocument = /*#__PURE__*/ gql`
    mutation updateMvpsMartinSectionType($input: UpdateMvpsMartinSectionTypeDto!) {
  classifiers {
    mvpsMartinSectionType {
      update(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type UpdateMvpsMartinSectionTypeMutationFn = Apollo.MutationFunction<UpdateMvpsMartinSectionTypeMutation, UpdateMvpsMartinSectionTypeMutationVariables>;

/**
 * __useUpdateMvpsMartinSectionTypeMutation__
 *
 * To run a mutation, you first call `useUpdateMvpsMartinSectionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMvpsMartinSectionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMvpsMartinSectionTypeMutation, { data, loading, error }] = useUpdateMvpsMartinSectionTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMvpsMartinSectionTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMvpsMartinSectionTypeMutation, UpdateMvpsMartinSectionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMvpsMartinSectionTypeMutation, UpdateMvpsMartinSectionTypeMutationVariables>(UpdateMvpsMartinSectionTypeDocument, options);
      }
export type UpdateMvpsMartinSectionTypeMutationHookResult = ReturnType<typeof useUpdateMvpsMartinSectionTypeMutation>;
export type UpdateMvpsMartinSectionTypeMutationResult = Apollo.MutationResult<UpdateMvpsMartinSectionTypeMutation>;
export type UpdateMvpsMartinSectionTypeMutationOptions = Apollo.BaseMutationOptions<UpdateMvpsMartinSectionTypeMutation, UpdateMvpsMartinSectionTypeMutationVariables>;
export const MvpsMartinSectionTypesDocument = /*#__PURE__*/ gql`
    query mvpsMartinSectionTypes($paginate: PaginatorArgsDto, $orderBy: [MvpsMartinSectionTypeQueryResolver_List_SortingInputType!], $where: MvpsMartinSectionTypeQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    mvpsMartinSectionType {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...MvpsMartinSectionTypeBaseFragment
          mvpsMartinSectionTypeEquipmentDto {
            ...MvpsMartinSectionTypeEquipmentShortFragment
          }
        }
      }
    }
  }
}
    ${MvpsMartinSectionTypeBaseFragmentFragmentDoc}
${MvpsMartinSectionTypeEquipmentShortFragmentFragmentDoc}`;

/**
 * __useMvpsMartinSectionTypesQuery__
 *
 * To run a query within a React component, call `useMvpsMartinSectionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsMartinSectionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsMartinSectionTypesQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsMartinSectionTypesQuery(baseOptions: Apollo.QueryHookOptions<MvpsMartinSectionTypesQuery, MvpsMartinSectionTypesQueryVariables> & ({ variables: MvpsMartinSectionTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsMartinSectionTypesQuery, MvpsMartinSectionTypesQueryVariables>(MvpsMartinSectionTypesDocument, options);
      }
export function useMvpsMartinSectionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsMartinSectionTypesQuery, MvpsMartinSectionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsMartinSectionTypesQuery, MvpsMartinSectionTypesQueryVariables>(MvpsMartinSectionTypesDocument, options);
        }
export function useMvpsMartinSectionTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsMartinSectionTypesQuery, MvpsMartinSectionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsMartinSectionTypesQuery, MvpsMartinSectionTypesQueryVariables>(MvpsMartinSectionTypesDocument, options);
        }
export type MvpsMartinSectionTypesQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypesQuery>;
export type MvpsMartinSectionTypesLazyQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypesLazyQuery>;
export type MvpsMartinSectionTypesSuspenseQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypesSuspenseQuery>;
export type MvpsMartinSectionTypesQueryResult = Apollo.QueryResult<MvpsMartinSectionTypesQuery, MvpsMartinSectionTypesQueryVariables>;
export const CreateMvpsMartinSectionTypeEquipmentDocument = /*#__PURE__*/ gql`
    mutation createMvpsMartinSectionTypeEquipment($input: CreateMvpsMartinSectionTypeEquipmentDto!) {
  classifiers {
    mvpsMartinSectionTypeEquipment {
      create(data: $input) {
        id
      }
    }
  }
}
    `;
export type CreateMvpsMartinSectionTypeEquipmentMutationFn = Apollo.MutationFunction<CreateMvpsMartinSectionTypeEquipmentMutation, CreateMvpsMartinSectionTypeEquipmentMutationVariables>;

/**
 * __useCreateMvpsMartinSectionTypeEquipmentMutation__
 *
 * To run a mutation, you first call `useCreateMvpsMartinSectionTypeEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMvpsMartinSectionTypeEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMvpsMartinSectionTypeEquipmentMutation, { data, loading, error }] = useCreateMvpsMartinSectionTypeEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMvpsMartinSectionTypeEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMvpsMartinSectionTypeEquipmentMutation, CreateMvpsMartinSectionTypeEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMvpsMartinSectionTypeEquipmentMutation, CreateMvpsMartinSectionTypeEquipmentMutationVariables>(CreateMvpsMartinSectionTypeEquipmentDocument, options);
      }
export type CreateMvpsMartinSectionTypeEquipmentMutationHookResult = ReturnType<typeof useCreateMvpsMartinSectionTypeEquipmentMutation>;
export type CreateMvpsMartinSectionTypeEquipmentMutationResult = Apollo.MutationResult<CreateMvpsMartinSectionTypeEquipmentMutation>;
export type CreateMvpsMartinSectionTypeEquipmentMutationOptions = Apollo.BaseMutationOptions<CreateMvpsMartinSectionTypeEquipmentMutation, CreateMvpsMartinSectionTypeEquipmentMutationVariables>;
export const MvpsMartinSectionTypeEquipmentHistoryDocument = /*#__PURE__*/ gql`
    query mvpsMartinSectionTypeEquipmentHistory($entityId: Float!, $paginate: PaginatorArgsDto!, $orderBy: [MvpsMartinSectionTypeEquipmentQueryResolver_History_SortingInputType!]) {
  classifiers {
    mvpsMartinSectionTypeEquipment {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          start_at
          end_at
          ...MvpsMartinSectionTypeEquipmentShortFragment
        }
      }
    }
  }
}
    ${MvpsMartinSectionTypeEquipmentShortFragmentFragmentDoc}`;

/**
 * __useMvpsMartinSectionTypeEquipmentHistoryQuery__
 *
 * To run a query within a React component, call `useMvpsMartinSectionTypeEquipmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsMartinSectionTypeEquipmentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsMartinSectionTypeEquipmentHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMvpsMartinSectionTypeEquipmentHistoryQuery(baseOptions: Apollo.QueryHookOptions<MvpsMartinSectionTypeEquipmentHistoryQuery, MvpsMartinSectionTypeEquipmentHistoryQueryVariables> & ({ variables: MvpsMartinSectionTypeEquipmentHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsMartinSectionTypeEquipmentHistoryQuery, MvpsMartinSectionTypeEquipmentHistoryQueryVariables>(MvpsMartinSectionTypeEquipmentHistoryDocument, options);
      }
export function useMvpsMartinSectionTypeEquipmentHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsMartinSectionTypeEquipmentHistoryQuery, MvpsMartinSectionTypeEquipmentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsMartinSectionTypeEquipmentHistoryQuery, MvpsMartinSectionTypeEquipmentHistoryQueryVariables>(MvpsMartinSectionTypeEquipmentHistoryDocument, options);
        }
export function useMvpsMartinSectionTypeEquipmentHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsMartinSectionTypeEquipmentHistoryQuery, MvpsMartinSectionTypeEquipmentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsMartinSectionTypeEquipmentHistoryQuery, MvpsMartinSectionTypeEquipmentHistoryQueryVariables>(MvpsMartinSectionTypeEquipmentHistoryDocument, options);
        }
export type MvpsMartinSectionTypeEquipmentHistoryQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentHistoryQuery>;
export type MvpsMartinSectionTypeEquipmentHistoryLazyQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentHistoryLazyQuery>;
export type MvpsMartinSectionTypeEquipmentHistorySuspenseQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentHistorySuspenseQuery>;
export type MvpsMartinSectionTypeEquipmentHistoryQueryResult = Apollo.QueryResult<MvpsMartinSectionTypeEquipmentHistoryQuery, MvpsMartinSectionTypeEquipmentHistoryQueryVariables>;
export const MvpsMartinSectionTypeEquipmentRangeByIdDocument = /*#__PURE__*/ gql`
    query mvpsMartinSectionTypeEquipmentRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    mvpsMartinSectionTypeEquipment {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useMvpsMartinSectionTypeEquipmentRangeByIdQuery__
 *
 * To run a query within a React component, call `useMvpsMartinSectionTypeEquipmentRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsMartinSectionTypeEquipmentRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsMartinSectionTypeEquipmentRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsMartinSectionTypeEquipmentRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<MvpsMartinSectionTypeEquipmentRangeByIdQuery, MvpsMartinSectionTypeEquipmentRangeByIdQueryVariables> & ({ variables: MvpsMartinSectionTypeEquipmentRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsMartinSectionTypeEquipmentRangeByIdQuery, MvpsMartinSectionTypeEquipmentRangeByIdQueryVariables>(MvpsMartinSectionTypeEquipmentRangeByIdDocument, options);
      }
export function useMvpsMartinSectionTypeEquipmentRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsMartinSectionTypeEquipmentRangeByIdQuery, MvpsMartinSectionTypeEquipmentRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsMartinSectionTypeEquipmentRangeByIdQuery, MvpsMartinSectionTypeEquipmentRangeByIdQueryVariables>(MvpsMartinSectionTypeEquipmentRangeByIdDocument, options);
        }
export function useMvpsMartinSectionTypeEquipmentRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsMartinSectionTypeEquipmentRangeByIdQuery, MvpsMartinSectionTypeEquipmentRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsMartinSectionTypeEquipmentRangeByIdQuery, MvpsMartinSectionTypeEquipmentRangeByIdQueryVariables>(MvpsMartinSectionTypeEquipmentRangeByIdDocument, options);
        }
export type MvpsMartinSectionTypeEquipmentRangeByIdQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentRangeByIdQuery>;
export type MvpsMartinSectionTypeEquipmentRangeByIdLazyQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentRangeByIdLazyQuery>;
export type MvpsMartinSectionTypeEquipmentRangeByIdSuspenseQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentRangeByIdSuspenseQuery>;
export type MvpsMartinSectionTypeEquipmentRangeByIdQueryResult = Apollo.QueryResult<MvpsMartinSectionTypeEquipmentRangeByIdQuery, MvpsMartinSectionTypeEquipmentRangeByIdQueryVariables>;
export const UpdateMvpsMartinSectionTypeEquipmentDocument = /*#__PURE__*/ gql`
    mutation updateMvpsMartinSectionTypeEquipment($input: UpdateMvpsMartinSectionTypeEquipmentDto!) {
  classifiers {
    mvpsMartinSectionTypeEquipment {
      update(data: $input) {
        id
      }
    }
  }
}
    `;
export type UpdateMvpsMartinSectionTypeEquipmentMutationFn = Apollo.MutationFunction<UpdateMvpsMartinSectionTypeEquipmentMutation, UpdateMvpsMartinSectionTypeEquipmentMutationVariables>;

/**
 * __useUpdateMvpsMartinSectionTypeEquipmentMutation__
 *
 * To run a mutation, you first call `useUpdateMvpsMartinSectionTypeEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMvpsMartinSectionTypeEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMvpsMartinSectionTypeEquipmentMutation, { data, loading, error }] = useUpdateMvpsMartinSectionTypeEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMvpsMartinSectionTypeEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMvpsMartinSectionTypeEquipmentMutation, UpdateMvpsMartinSectionTypeEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMvpsMartinSectionTypeEquipmentMutation, UpdateMvpsMartinSectionTypeEquipmentMutationVariables>(UpdateMvpsMartinSectionTypeEquipmentDocument, options);
      }
export type UpdateMvpsMartinSectionTypeEquipmentMutationHookResult = ReturnType<typeof useUpdateMvpsMartinSectionTypeEquipmentMutation>;
export type UpdateMvpsMartinSectionTypeEquipmentMutationResult = Apollo.MutationResult<UpdateMvpsMartinSectionTypeEquipmentMutation>;
export type UpdateMvpsMartinSectionTypeEquipmentMutationOptions = Apollo.BaseMutationOptions<UpdateMvpsMartinSectionTypeEquipmentMutation, UpdateMvpsMartinSectionTypeEquipmentMutationVariables>;
export const MvpsMartinSectionTypeEquipmentListDocument = /*#__PURE__*/ gql`
    query mvpsMartinSectionTypeEquipmentList($paginate: PaginatorArgsDto!, $orderBy: [MvpsMartinSectionTypeEquipmentQueryResolver_List_SortingInputType!], $where: MvpsMartinSectionTypeEquipmentQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    mvpsMartinSectionTypeEquipment {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...MvpsMartinSectionTypeEquipmentShortFragment
        }
      }
    }
  }
}
    ${MvpsMartinSectionTypeEquipmentShortFragmentFragmentDoc}`;

/**
 * __useMvpsMartinSectionTypeEquipmentListQuery__
 *
 * To run a query within a React component, call `useMvpsMartinSectionTypeEquipmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsMartinSectionTypeEquipmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsMartinSectionTypeEquipmentListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsMartinSectionTypeEquipmentListQuery(baseOptions: Apollo.QueryHookOptions<MvpsMartinSectionTypeEquipmentListQuery, MvpsMartinSectionTypeEquipmentListQueryVariables> & ({ variables: MvpsMartinSectionTypeEquipmentListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsMartinSectionTypeEquipmentListQuery, MvpsMartinSectionTypeEquipmentListQueryVariables>(MvpsMartinSectionTypeEquipmentListDocument, options);
      }
export function useMvpsMartinSectionTypeEquipmentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsMartinSectionTypeEquipmentListQuery, MvpsMartinSectionTypeEquipmentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsMartinSectionTypeEquipmentListQuery, MvpsMartinSectionTypeEquipmentListQueryVariables>(MvpsMartinSectionTypeEquipmentListDocument, options);
        }
export function useMvpsMartinSectionTypeEquipmentListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsMartinSectionTypeEquipmentListQuery, MvpsMartinSectionTypeEquipmentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsMartinSectionTypeEquipmentListQuery, MvpsMartinSectionTypeEquipmentListQueryVariables>(MvpsMartinSectionTypeEquipmentListDocument, options);
        }
export type MvpsMartinSectionTypeEquipmentListQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentListQuery>;
export type MvpsMartinSectionTypeEquipmentListLazyQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentListLazyQuery>;
export type MvpsMartinSectionTypeEquipmentListSuspenseQueryHookResult = ReturnType<typeof useMvpsMartinSectionTypeEquipmentListSuspenseQuery>;
export type MvpsMartinSectionTypeEquipmentListQueryResult = Apollo.QueryResult<MvpsMartinSectionTypeEquipmentListQuery, MvpsMartinSectionTypeEquipmentListQueryVariables>;
export const CreateMvpsRateManagementExploitationMaintenanceRepairDocument = /*#__PURE__*/ gql`
    mutation createMvpsRateManagementExploitationMaintenanceRepair($input: CreateMvpsRateManagementExploitationMaintenanceRepairDto!) {
  classifiers {
    mvpsRateManagementExploitationMaintenanceRepair {
      create(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type CreateMvpsRateManagementExploitationMaintenanceRepairMutationFn = Apollo.MutationFunction<CreateMvpsRateManagementExploitationMaintenanceRepairMutation, CreateMvpsRateManagementExploitationMaintenanceRepairMutationVariables>;

/**
 * __useCreateMvpsRateManagementExploitationMaintenanceRepairMutation__
 *
 * To run a mutation, you first call `useCreateMvpsRateManagementExploitationMaintenanceRepairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMvpsRateManagementExploitationMaintenanceRepairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMvpsRateManagementExploitationMaintenanceRepairMutation, { data, loading, error }] = useCreateMvpsRateManagementExploitationMaintenanceRepairMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMvpsRateManagementExploitationMaintenanceRepairMutation(baseOptions?: Apollo.MutationHookOptions<CreateMvpsRateManagementExploitationMaintenanceRepairMutation, CreateMvpsRateManagementExploitationMaintenanceRepairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMvpsRateManagementExploitationMaintenanceRepairMutation, CreateMvpsRateManagementExploitationMaintenanceRepairMutationVariables>(CreateMvpsRateManagementExploitationMaintenanceRepairDocument, options);
      }
export type CreateMvpsRateManagementExploitationMaintenanceRepairMutationHookResult = ReturnType<typeof useCreateMvpsRateManagementExploitationMaintenanceRepairMutation>;
export type CreateMvpsRateManagementExploitationMaintenanceRepairMutationResult = Apollo.MutationResult<CreateMvpsRateManagementExploitationMaintenanceRepairMutation>;
export type CreateMvpsRateManagementExploitationMaintenanceRepairMutationOptions = Apollo.BaseMutationOptions<CreateMvpsRateManagementExploitationMaintenanceRepairMutation, CreateMvpsRateManagementExploitationMaintenanceRepairMutationVariables>;
export const MvpsRateManagementExploitationMaintenanceRepairHistoryDocument = /*#__PURE__*/ gql`
    query mvpsRateManagementExploitationMaintenanceRepairHistory($entityId: Float!, $paginate: PaginatorArgsDto!, $orderBy: [MvpsRateManagementExploitationMaintenanceRepairQueryResolver_History_SortingInputType!]) {
  classifiers {
    mvpsRateManagementExploitationMaintenanceRepair {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          ...MvpsRateManagementExploitationMaintenanceRepairBaseFragment
          mnemonic {
            ...MnemonicShortFragment
          }
        }
      }
    }
  }
}
    ${MvpsRateManagementExploitationMaintenanceRepairBaseFragmentFragmentDoc}
${MnemonicShortFragmentFragmentDoc}`;

/**
 * __useMvpsRateManagementExploitationMaintenanceRepairHistoryQuery__
 *
 * To run a query within a React component, call `useMvpsRateManagementExploitationMaintenanceRepairHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsRateManagementExploitationMaintenanceRepairHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsRateManagementExploitationMaintenanceRepairHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMvpsRateManagementExploitationMaintenanceRepairHistoryQuery(baseOptions: Apollo.QueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairHistoryQuery, MvpsRateManagementExploitationMaintenanceRepairHistoryQueryVariables> & ({ variables: MvpsRateManagementExploitationMaintenanceRepairHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsRateManagementExploitationMaintenanceRepairHistoryQuery, MvpsRateManagementExploitationMaintenanceRepairHistoryQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairHistoryDocument, options);
      }
export function useMvpsRateManagementExploitationMaintenanceRepairHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairHistoryQuery, MvpsRateManagementExploitationMaintenanceRepairHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsRateManagementExploitationMaintenanceRepairHistoryQuery, MvpsRateManagementExploitationMaintenanceRepairHistoryQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairHistoryDocument, options);
        }
export function useMvpsRateManagementExploitationMaintenanceRepairHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairHistoryQuery, MvpsRateManagementExploitationMaintenanceRepairHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsRateManagementExploitationMaintenanceRepairHistoryQuery, MvpsRateManagementExploitationMaintenanceRepairHistoryQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairHistoryDocument, options);
        }
export type MvpsRateManagementExploitationMaintenanceRepairHistoryQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairHistoryQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairHistoryLazyQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairHistoryLazyQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairHistorySuspenseQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairHistorySuspenseQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairHistoryQueryResult = Apollo.QueryResult<MvpsRateManagementExploitationMaintenanceRepairHistoryQuery, MvpsRateManagementExploitationMaintenanceRepairHistoryQueryVariables>;
export const MvpsRateManagementExploitationMaintenanceRepairRangeByIdDocument = /*#__PURE__*/ gql`
    query mvpsRateManagementExploitationMaintenanceRepairRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    mvpsRateManagementExploitationMaintenanceRepair {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useMvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery__
 *
 * To run a query within a React component, call `useMvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery, MvpsRateManagementExploitationMaintenanceRepairRangeByIdQueryVariables> & ({ variables: MvpsRateManagementExploitationMaintenanceRepairRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery, MvpsRateManagementExploitationMaintenanceRepairRangeByIdQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairRangeByIdDocument, options);
      }
export function useMvpsRateManagementExploitationMaintenanceRepairRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery, MvpsRateManagementExploitationMaintenanceRepairRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery, MvpsRateManagementExploitationMaintenanceRepairRangeByIdQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairRangeByIdDocument, options);
        }
export function useMvpsRateManagementExploitationMaintenanceRepairRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery, MvpsRateManagementExploitationMaintenanceRepairRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery, MvpsRateManagementExploitationMaintenanceRepairRangeByIdQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairRangeByIdDocument, options);
        }
export type MvpsRateManagementExploitationMaintenanceRepairRangeByIdQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairRangeByIdLazyQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairRangeByIdLazyQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairRangeByIdSuspenseQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairRangeByIdSuspenseQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairRangeByIdQueryResult = Apollo.QueryResult<MvpsRateManagementExploitationMaintenanceRepairRangeByIdQuery, MvpsRateManagementExploitationMaintenanceRepairRangeByIdQueryVariables>;
export const UpdateMvpsRateManagementExploitationMaintenanceRepairDocument = /*#__PURE__*/ gql`
    mutation updateMvpsRateManagementExploitationMaintenanceRepair($input: UpdateMvpsRateManagementExploitationMaintenanceRepairDto!) {
  classifiers {
    mvpsRateManagementExploitationMaintenanceRepair {
      update(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type UpdateMvpsRateManagementExploitationMaintenanceRepairMutationFn = Apollo.MutationFunction<UpdateMvpsRateManagementExploitationMaintenanceRepairMutation, UpdateMvpsRateManagementExploitationMaintenanceRepairMutationVariables>;

/**
 * __useUpdateMvpsRateManagementExploitationMaintenanceRepairMutation__
 *
 * To run a mutation, you first call `useUpdateMvpsRateManagementExploitationMaintenanceRepairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMvpsRateManagementExploitationMaintenanceRepairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMvpsRateManagementExploitationMaintenanceRepairMutation, { data, loading, error }] = useUpdateMvpsRateManagementExploitationMaintenanceRepairMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMvpsRateManagementExploitationMaintenanceRepairMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMvpsRateManagementExploitationMaintenanceRepairMutation, UpdateMvpsRateManagementExploitationMaintenanceRepairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMvpsRateManagementExploitationMaintenanceRepairMutation, UpdateMvpsRateManagementExploitationMaintenanceRepairMutationVariables>(UpdateMvpsRateManagementExploitationMaintenanceRepairDocument, options);
      }
export type UpdateMvpsRateManagementExploitationMaintenanceRepairMutationHookResult = ReturnType<typeof useUpdateMvpsRateManagementExploitationMaintenanceRepairMutation>;
export type UpdateMvpsRateManagementExploitationMaintenanceRepairMutationResult = Apollo.MutationResult<UpdateMvpsRateManagementExploitationMaintenanceRepairMutation>;
export type UpdateMvpsRateManagementExploitationMaintenanceRepairMutationOptions = Apollo.BaseMutationOptions<UpdateMvpsRateManagementExploitationMaintenanceRepairMutation, UpdateMvpsRateManagementExploitationMaintenanceRepairMutationVariables>;
export const MvpsRateManagementExploitationMaintenanceRepairListDocument = /*#__PURE__*/ gql`
    query mvpsRateManagementExploitationMaintenanceRepairList($paginate: PaginatorArgsDto!, $orderBy: [MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_SortingInputType!], $where: MvpsRateManagementExploitationMaintenanceRepairQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    mvpsRateManagementExploitationMaintenanceRepair {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...MvpsRateManagementExploitationMaintenanceRepairBaseFragment
          mnemonic {
            ...MnemonicShortFragment
          }
        }
      }
    }
  }
}
    ${MvpsRateManagementExploitationMaintenanceRepairBaseFragmentFragmentDoc}
${MnemonicShortFragmentFragmentDoc}`;

/**
 * __useMvpsRateManagementExploitationMaintenanceRepairListQuery__
 *
 * To run a query within a React component, call `useMvpsRateManagementExploitationMaintenanceRepairListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsRateManagementExploitationMaintenanceRepairListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsRateManagementExploitationMaintenanceRepairListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMvpsRateManagementExploitationMaintenanceRepairListQuery(baseOptions: Apollo.QueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairListQuery, MvpsRateManagementExploitationMaintenanceRepairListQueryVariables> & ({ variables: MvpsRateManagementExploitationMaintenanceRepairListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsRateManagementExploitationMaintenanceRepairListQuery, MvpsRateManagementExploitationMaintenanceRepairListQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairListDocument, options);
      }
export function useMvpsRateManagementExploitationMaintenanceRepairListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairListQuery, MvpsRateManagementExploitationMaintenanceRepairListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsRateManagementExploitationMaintenanceRepairListQuery, MvpsRateManagementExploitationMaintenanceRepairListQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairListDocument, options);
        }
export function useMvpsRateManagementExploitationMaintenanceRepairListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsRateManagementExploitationMaintenanceRepairListQuery, MvpsRateManagementExploitationMaintenanceRepairListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsRateManagementExploitationMaintenanceRepairListQuery, MvpsRateManagementExploitationMaintenanceRepairListQueryVariables>(MvpsRateManagementExploitationMaintenanceRepairListDocument, options);
        }
export type MvpsRateManagementExploitationMaintenanceRepairListQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairListQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairListLazyQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairListLazyQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairListSuspenseQueryHookResult = ReturnType<typeof useMvpsRateManagementExploitationMaintenanceRepairListSuspenseQuery>;
export type MvpsRateManagementExploitationMaintenanceRepairListQueryResult = Apollo.QueryResult<MvpsRateManagementExploitationMaintenanceRepairListQuery, MvpsRateManagementExploitationMaintenanceRepairListQueryVariables>;
export const NonPassengerCarriageTypeForSchemaListDocument = /*#__PURE__*/ gql`
    query nonPassengerCarriageTypeForSchemaList($paginate: PaginatorArgsDto, $orderBy: [CarriageTypesForSchemaQueryResolver_List_SortingInputType!], $where: CarriageTypesForSchemaQueryResolver_List_FilterInputType) {
  classifiers {
    carriageTypesForSchema {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        items {
          ...CarriageTypesForSchemaShortFragment
        }
      }
    }
  }
}
    ${CarriageTypesForSchemaShortFragmentFragmentDoc}`;

/**
 * __useNonPassengerCarriageTypeForSchemaListQuery__
 *
 * To run a query within a React component, call `useNonPassengerCarriageTypeForSchemaListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonPassengerCarriageTypeForSchemaListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonPassengerCarriageTypeForSchemaListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNonPassengerCarriageTypeForSchemaListQuery(baseOptions?: Apollo.QueryHookOptions<NonPassengerCarriageTypeForSchemaListQuery, NonPassengerCarriageTypeForSchemaListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonPassengerCarriageTypeForSchemaListQuery, NonPassengerCarriageTypeForSchemaListQueryVariables>(NonPassengerCarriageTypeForSchemaListDocument, options);
      }
export function useNonPassengerCarriageTypeForSchemaListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonPassengerCarriageTypeForSchemaListQuery, NonPassengerCarriageTypeForSchemaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonPassengerCarriageTypeForSchemaListQuery, NonPassengerCarriageTypeForSchemaListQueryVariables>(NonPassengerCarriageTypeForSchemaListDocument, options);
        }
export function useNonPassengerCarriageTypeForSchemaListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NonPassengerCarriageTypeForSchemaListQuery, NonPassengerCarriageTypeForSchemaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonPassengerCarriageTypeForSchemaListQuery, NonPassengerCarriageTypeForSchemaListQueryVariables>(NonPassengerCarriageTypeForSchemaListDocument, options);
        }
export type NonPassengerCarriageTypeForSchemaListQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeForSchemaListQuery>;
export type NonPassengerCarriageTypeForSchemaListLazyQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeForSchemaListLazyQuery>;
export type NonPassengerCarriageTypeForSchemaListSuspenseQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeForSchemaListSuspenseQuery>;
export type NonPassengerCarriageTypeForSchemaListQueryResult = Apollo.QueryResult<NonPassengerCarriageTypeForSchemaListQuery, NonPassengerCarriageTypeForSchemaListQueryVariables>;
export const CreateNonPassengerCarriageTypeDocument = /*#__PURE__*/ gql`
    mutation createNonPassengerCarriageType($input: CreateNonPassengerCarriageTypeDto!) {
  classifiers {
    nonPassengerCarriageType {
      create(data: $input) {
        id
      }
    }
  }
}
    `;
export type CreateNonPassengerCarriageTypeMutationFn = Apollo.MutationFunction<CreateNonPassengerCarriageTypeMutation, CreateNonPassengerCarriageTypeMutationVariables>;

/**
 * __useCreateNonPassengerCarriageTypeMutation__
 *
 * To run a mutation, you first call `useCreateNonPassengerCarriageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNonPassengerCarriageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNonPassengerCarriageTypeMutation, { data, loading, error }] = useCreateNonPassengerCarriageTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNonPassengerCarriageTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateNonPassengerCarriageTypeMutation, CreateNonPassengerCarriageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNonPassengerCarriageTypeMutation, CreateNonPassengerCarriageTypeMutationVariables>(CreateNonPassengerCarriageTypeDocument, options);
      }
export type CreateNonPassengerCarriageTypeMutationHookResult = ReturnType<typeof useCreateNonPassengerCarriageTypeMutation>;
export type CreateNonPassengerCarriageTypeMutationResult = Apollo.MutationResult<CreateNonPassengerCarriageTypeMutation>;
export type CreateNonPassengerCarriageTypeMutationOptions = Apollo.BaseMutationOptions<CreateNonPassengerCarriageTypeMutation, CreateNonPassengerCarriageTypeMutationVariables>;
export const NonPassengerCarriageTypeHistoryDocument = /*#__PURE__*/ gql`
    query nonPassengerCarriageTypeHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [NonPassengerCarriageTypeQueryResolver_History_SortingInputType!]) {
  classifiers {
    nonPassengerCarriageType {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          end_at
          ...NonPassengerCarriageTypeBaseFragment
          carriage_types_for_schema {
            ...CarriageTypesForSchemaShortFragment
          }
          conditional_carriage_numbers {
            ...ConditionalCarriageNumbersBaseFragment
          }
        }
      }
    }
  }
}
    ${NonPassengerCarriageTypeBaseFragmentFragmentDoc}
${CarriageTypesForSchemaShortFragmentFragmentDoc}
${ConditionalCarriageNumbersBaseFragmentFragmentDoc}`;

/**
 * __useNonPassengerCarriageTypeHistoryQuery__
 *
 * To run a query within a React component, call `useNonPassengerCarriageTypeHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonPassengerCarriageTypeHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonPassengerCarriageTypeHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useNonPassengerCarriageTypeHistoryQuery(baseOptions: Apollo.QueryHookOptions<NonPassengerCarriageTypeHistoryQuery, NonPassengerCarriageTypeHistoryQueryVariables> & ({ variables: NonPassengerCarriageTypeHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonPassengerCarriageTypeHistoryQuery, NonPassengerCarriageTypeHistoryQueryVariables>(NonPassengerCarriageTypeHistoryDocument, options);
      }
export function useNonPassengerCarriageTypeHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonPassengerCarriageTypeHistoryQuery, NonPassengerCarriageTypeHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonPassengerCarriageTypeHistoryQuery, NonPassengerCarriageTypeHistoryQueryVariables>(NonPassengerCarriageTypeHistoryDocument, options);
        }
export function useNonPassengerCarriageTypeHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NonPassengerCarriageTypeHistoryQuery, NonPassengerCarriageTypeHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonPassengerCarriageTypeHistoryQuery, NonPassengerCarriageTypeHistoryQueryVariables>(NonPassengerCarriageTypeHistoryDocument, options);
        }
export type NonPassengerCarriageTypeHistoryQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeHistoryQuery>;
export type NonPassengerCarriageTypeHistoryLazyQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeHistoryLazyQuery>;
export type NonPassengerCarriageTypeHistorySuspenseQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeHistorySuspenseQuery>;
export type NonPassengerCarriageTypeHistoryQueryResult = Apollo.QueryResult<NonPassengerCarriageTypeHistoryQuery, NonPassengerCarriageTypeHistoryQueryVariables>;
export const NonPassengerCarriageTypeRangeByIdDocument = /*#__PURE__*/ gql`
    query nonPassengerCarriageTypeRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    nonPassengerCarriageType {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useNonPassengerCarriageTypeRangeByIdQuery__
 *
 * To run a query within a React component, call `useNonPassengerCarriageTypeRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonPassengerCarriageTypeRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonPassengerCarriageTypeRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNonPassengerCarriageTypeRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<NonPassengerCarriageTypeRangeByIdQuery, NonPassengerCarriageTypeRangeByIdQueryVariables> & ({ variables: NonPassengerCarriageTypeRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonPassengerCarriageTypeRangeByIdQuery, NonPassengerCarriageTypeRangeByIdQueryVariables>(NonPassengerCarriageTypeRangeByIdDocument, options);
      }
export function useNonPassengerCarriageTypeRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonPassengerCarriageTypeRangeByIdQuery, NonPassengerCarriageTypeRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonPassengerCarriageTypeRangeByIdQuery, NonPassengerCarriageTypeRangeByIdQueryVariables>(NonPassengerCarriageTypeRangeByIdDocument, options);
        }
export function useNonPassengerCarriageTypeRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NonPassengerCarriageTypeRangeByIdQuery, NonPassengerCarriageTypeRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonPassengerCarriageTypeRangeByIdQuery, NonPassengerCarriageTypeRangeByIdQueryVariables>(NonPassengerCarriageTypeRangeByIdDocument, options);
        }
export type NonPassengerCarriageTypeRangeByIdQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeRangeByIdQuery>;
export type NonPassengerCarriageTypeRangeByIdLazyQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeRangeByIdLazyQuery>;
export type NonPassengerCarriageTypeRangeByIdSuspenseQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeRangeByIdSuspenseQuery>;
export type NonPassengerCarriageTypeRangeByIdQueryResult = Apollo.QueryResult<NonPassengerCarriageTypeRangeByIdQuery, NonPassengerCarriageTypeRangeByIdQueryVariables>;
export const UpdateNonPassengerCarriageTypeDocument = /*#__PURE__*/ gql`
    mutation updateNonPassengerCarriageType($input: UpdateNonPassengerCarriageTypeDto!) {
  classifiers {
    nonPassengerCarriageType {
      update(data: $input) {
        id
      }
    }
  }
}
    `;
export type UpdateNonPassengerCarriageTypeMutationFn = Apollo.MutationFunction<UpdateNonPassengerCarriageTypeMutation, UpdateNonPassengerCarriageTypeMutationVariables>;

/**
 * __useUpdateNonPassengerCarriageTypeMutation__
 *
 * To run a mutation, you first call `useUpdateNonPassengerCarriageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNonPassengerCarriageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNonPassengerCarriageTypeMutation, { data, loading, error }] = useUpdateNonPassengerCarriageTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNonPassengerCarriageTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNonPassengerCarriageTypeMutation, UpdateNonPassengerCarriageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNonPassengerCarriageTypeMutation, UpdateNonPassengerCarriageTypeMutationVariables>(UpdateNonPassengerCarriageTypeDocument, options);
      }
export type UpdateNonPassengerCarriageTypeMutationHookResult = ReturnType<typeof useUpdateNonPassengerCarriageTypeMutation>;
export type UpdateNonPassengerCarriageTypeMutationResult = Apollo.MutationResult<UpdateNonPassengerCarriageTypeMutation>;
export type UpdateNonPassengerCarriageTypeMutationOptions = Apollo.BaseMutationOptions<UpdateNonPassengerCarriageTypeMutation, UpdateNonPassengerCarriageTypeMutationVariables>;
export const NonPassengerCarriageTypeDocument = /*#__PURE__*/ gql`
    query nonPassengerCarriageType($paginate: PaginatorArgsDto, $orderBy: [NonPassengerCarriageTypeQueryResolver_List_SortingInputType!], $where: NonPassengerCarriageTypeQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    nonPassengerCarriageType {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...NonPassengerCarriageTypeBaseFragment
          carriage_types_for_schema {
            ...CarriageTypesForSchemaShortFragment
          }
          conditional_carriage_numbers {
            ...ConditionalCarriageNumbersBaseFragment
          }
        }
      }
    }
  }
}
    ${NonPassengerCarriageTypeBaseFragmentFragmentDoc}
${CarriageTypesForSchemaShortFragmentFragmentDoc}
${ConditionalCarriageNumbersBaseFragmentFragmentDoc}`;

/**
 * __useNonPassengerCarriageTypeQuery__
 *
 * To run a query within a React component, call `useNonPassengerCarriageTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonPassengerCarriageTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonPassengerCarriageTypeQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useNonPassengerCarriageTypeQuery(baseOptions: Apollo.QueryHookOptions<NonPassengerCarriageTypeQuery, NonPassengerCarriageTypeQueryVariables> & ({ variables: NonPassengerCarriageTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonPassengerCarriageTypeQuery, NonPassengerCarriageTypeQueryVariables>(NonPassengerCarriageTypeDocument, options);
      }
export function useNonPassengerCarriageTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonPassengerCarriageTypeQuery, NonPassengerCarriageTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonPassengerCarriageTypeQuery, NonPassengerCarriageTypeQueryVariables>(NonPassengerCarriageTypeDocument, options);
        }
export function useNonPassengerCarriageTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NonPassengerCarriageTypeQuery, NonPassengerCarriageTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonPassengerCarriageTypeQuery, NonPassengerCarriageTypeQueryVariables>(NonPassengerCarriageTypeDocument, options);
        }
export type NonPassengerCarriageTypeQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeQuery>;
export type NonPassengerCarriageTypeLazyQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeLazyQuery>;
export type NonPassengerCarriageTypeSuspenseQueryHookResult = ReturnType<typeof useNonPassengerCarriageTypeSuspenseQuery>;
export type NonPassengerCarriageTypeQueryResult = Apollo.QueryResult<NonPassengerCarriageTypeQuery, NonPassengerCarriageTypeQueryVariables>;
export const CreatePassengerCarrierDocument = /*#__PURE__*/ gql`
    mutation createPassengerCarrier($input: CreatePassengerCarrierDto!) {
  classifiers {
    passengerCarrier {
      create(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type CreatePassengerCarrierMutationFn = Apollo.MutationFunction<CreatePassengerCarrierMutation, CreatePassengerCarrierMutationVariables>;

/**
 * __useCreatePassengerCarrierMutation__
 *
 * To run a mutation, you first call `useCreatePassengerCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePassengerCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPassengerCarrierMutation, { data, loading, error }] = useCreatePassengerCarrierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePassengerCarrierMutation(baseOptions?: Apollo.MutationHookOptions<CreatePassengerCarrierMutation, CreatePassengerCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePassengerCarrierMutation, CreatePassengerCarrierMutationVariables>(CreatePassengerCarrierDocument, options);
      }
export type CreatePassengerCarrierMutationHookResult = ReturnType<typeof useCreatePassengerCarrierMutation>;
export type CreatePassengerCarrierMutationResult = Apollo.MutationResult<CreatePassengerCarrierMutation>;
export type CreatePassengerCarrierMutationOptions = Apollo.BaseMutationOptions<CreatePassengerCarrierMutation, CreatePassengerCarrierMutationVariables>;
export const PassengerCarriersCreateVersionDocument = /*#__PURE__*/ gql`
    mutation passengerCarriersCreateVersion($data: CreateVersionPassengerCarrierDto!) {
  classifiers {
    passengerCarrier {
      createVersion(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type PassengerCarriersCreateVersionMutationFn = Apollo.MutationFunction<PassengerCarriersCreateVersionMutation, PassengerCarriersCreateVersionMutationVariables>;

/**
 * __usePassengerCarriersCreateVersionMutation__
 *
 * To run a mutation, you first call `usePassengerCarriersCreateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePassengerCarriersCreateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passengerCarriersCreateVersionMutation, { data, loading, error }] = usePassengerCarriersCreateVersionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePassengerCarriersCreateVersionMutation(baseOptions?: Apollo.MutationHookOptions<PassengerCarriersCreateVersionMutation, PassengerCarriersCreateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PassengerCarriersCreateVersionMutation, PassengerCarriersCreateVersionMutationVariables>(PassengerCarriersCreateVersionDocument, options);
      }
export type PassengerCarriersCreateVersionMutationHookResult = ReturnType<typeof usePassengerCarriersCreateVersionMutation>;
export type PassengerCarriersCreateVersionMutationResult = Apollo.MutationResult<PassengerCarriersCreateVersionMutation>;
export type PassengerCarriersCreateVersionMutationOptions = Apollo.BaseMutationOptions<PassengerCarriersCreateVersionMutation, PassengerCarriersCreateVersionMutationVariables>;
export const PassengerCarrierDeleteDocument = /*#__PURE__*/ gql`
    mutation passengerCarrierDelete($id: Float!) {
  classifiers {
    passengerCarrier {
      delete(id: $id)
    }
  }
}
    `;
export type PassengerCarrierDeleteMutationFn = Apollo.MutationFunction<PassengerCarrierDeleteMutation, PassengerCarrierDeleteMutationVariables>;

/**
 * __usePassengerCarrierDeleteMutation__
 *
 * To run a mutation, you first call `usePassengerCarrierDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePassengerCarrierDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passengerCarrierDeleteMutation, { data, loading, error }] = usePassengerCarrierDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePassengerCarrierDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PassengerCarrierDeleteMutation, PassengerCarrierDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PassengerCarrierDeleteMutation, PassengerCarrierDeleteMutationVariables>(PassengerCarrierDeleteDocument, options);
      }
export type PassengerCarrierDeleteMutationHookResult = ReturnType<typeof usePassengerCarrierDeleteMutation>;
export type PassengerCarrierDeleteMutationResult = Apollo.MutationResult<PassengerCarrierDeleteMutation>;
export type PassengerCarrierDeleteMutationOptions = Apollo.BaseMutationOptions<PassengerCarrierDeleteMutation, PassengerCarrierDeleteMutationVariables>;
export const PassengerCarriersHistoryDocument = /*#__PURE__*/ gql`
    query passengerCarriersHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [PassengerCarrierQueryResolver_History_SortingInputType!]) {
  classifiers {
    passengerCarrier {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          id
          start_at
          end_at
          is_latest
          ...PassengerCarrierBaseFragment
        }
      }
    }
  }
}
    ${PassengerCarrierBaseFragmentFragmentDoc}`;

/**
 * __usePassengerCarriersHistoryQuery__
 *
 * To run a query within a React component, call `usePassengerCarriersHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePassengerCarriersHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePassengerCarriersHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePassengerCarriersHistoryQuery(baseOptions: Apollo.QueryHookOptions<PassengerCarriersHistoryQuery, PassengerCarriersHistoryQueryVariables> & ({ variables: PassengerCarriersHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PassengerCarriersHistoryQuery, PassengerCarriersHistoryQueryVariables>(PassengerCarriersHistoryDocument, options);
      }
export function usePassengerCarriersHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PassengerCarriersHistoryQuery, PassengerCarriersHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PassengerCarriersHistoryQuery, PassengerCarriersHistoryQueryVariables>(PassengerCarriersHistoryDocument, options);
        }
export function usePassengerCarriersHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PassengerCarriersHistoryQuery, PassengerCarriersHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PassengerCarriersHistoryQuery, PassengerCarriersHistoryQueryVariables>(PassengerCarriersHistoryDocument, options);
        }
export type PassengerCarriersHistoryQueryHookResult = ReturnType<typeof usePassengerCarriersHistoryQuery>;
export type PassengerCarriersHistoryLazyQueryHookResult = ReturnType<typeof usePassengerCarriersHistoryLazyQuery>;
export type PassengerCarriersHistorySuspenseQueryHookResult = ReturnType<typeof usePassengerCarriersHistorySuspenseQuery>;
export type PassengerCarriersHistoryQueryResult = Apollo.QueryResult<PassengerCarriersHistoryQuery, PassengerCarriersHistoryQueryVariables>;
export const LockPassengerCarrierDocument = /*#__PURE__*/ gql`
    mutation lockPassengerCarrier($input: UpdatePassengerCarrierEntityDto!) {
  classifiers {
    passengerCarrier {
      updateEntity(data: $input)
    }
  }
}
    `;
export type LockPassengerCarrierMutationFn = Apollo.MutationFunction<LockPassengerCarrierMutation, LockPassengerCarrierMutationVariables>;

/**
 * __useLockPassengerCarrierMutation__
 *
 * To run a mutation, you first call `useLockPassengerCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockPassengerCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockPassengerCarrierMutation, { data, loading, error }] = useLockPassengerCarrierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLockPassengerCarrierMutation(baseOptions?: Apollo.MutationHookOptions<LockPassengerCarrierMutation, LockPassengerCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockPassengerCarrierMutation, LockPassengerCarrierMutationVariables>(LockPassengerCarrierDocument, options);
      }
export type LockPassengerCarrierMutationHookResult = ReturnType<typeof useLockPassengerCarrierMutation>;
export type LockPassengerCarrierMutationResult = Apollo.MutationResult<LockPassengerCarrierMutation>;
export type LockPassengerCarrierMutationOptions = Apollo.BaseMutationOptions<LockPassengerCarrierMutation, LockPassengerCarrierMutationVariables>;
export const PassengerCarrierRangeByIdDocument = /*#__PURE__*/ gql`
    query passengerCarrierRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    passengerCarrier {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __usePassengerCarrierRangeByIdQuery__
 *
 * To run a query within a React component, call `usePassengerCarrierRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePassengerCarrierRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePassengerCarrierRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function usePassengerCarrierRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<PassengerCarrierRangeByIdQuery, PassengerCarrierRangeByIdQueryVariables> & ({ variables: PassengerCarrierRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PassengerCarrierRangeByIdQuery, PassengerCarrierRangeByIdQueryVariables>(PassengerCarrierRangeByIdDocument, options);
      }
export function usePassengerCarrierRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PassengerCarrierRangeByIdQuery, PassengerCarrierRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PassengerCarrierRangeByIdQuery, PassengerCarrierRangeByIdQueryVariables>(PassengerCarrierRangeByIdDocument, options);
        }
export function usePassengerCarrierRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PassengerCarrierRangeByIdQuery, PassengerCarrierRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PassengerCarrierRangeByIdQuery, PassengerCarrierRangeByIdQueryVariables>(PassengerCarrierRangeByIdDocument, options);
        }
export type PassengerCarrierRangeByIdQueryHookResult = ReturnType<typeof usePassengerCarrierRangeByIdQuery>;
export type PassengerCarrierRangeByIdLazyQueryHookResult = ReturnType<typeof usePassengerCarrierRangeByIdLazyQuery>;
export type PassengerCarrierRangeByIdSuspenseQueryHookResult = ReturnType<typeof usePassengerCarrierRangeByIdSuspenseQuery>;
export type PassengerCarrierRangeByIdQueryResult = Apollo.QueryResult<PassengerCarrierRangeByIdQuery, PassengerCarrierRangeByIdQueryVariables>;
export const UpdatePassengerCarrierDocument = /*#__PURE__*/ gql`
    mutation updatePassengerCarrier($input: UpdatePassengerCarrierDto!) {
  classifiers {
    passengerCarrier {
      update(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type UpdatePassengerCarrierMutationFn = Apollo.MutationFunction<UpdatePassengerCarrierMutation, UpdatePassengerCarrierMutationVariables>;

/**
 * __useUpdatePassengerCarrierMutation__
 *
 * To run a mutation, you first call `useUpdatePassengerCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePassengerCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePassengerCarrierMutation, { data, loading, error }] = useUpdatePassengerCarrierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePassengerCarrierMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePassengerCarrierMutation, UpdatePassengerCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePassengerCarrierMutation, UpdatePassengerCarrierMutationVariables>(UpdatePassengerCarrierDocument, options);
      }
export type UpdatePassengerCarrierMutationHookResult = ReturnType<typeof useUpdatePassengerCarrierMutation>;
export type UpdatePassengerCarrierMutationResult = Apollo.MutationResult<UpdatePassengerCarrierMutation>;
export type UpdatePassengerCarrierMutationOptions = Apollo.BaseMutationOptions<UpdatePassengerCarrierMutation, UpdatePassengerCarrierMutationVariables>;
export const PassengerCarriersDocument = /*#__PURE__*/ gql`
    query passengerCarriers($paginate: PaginatorArgsDto, $orderBy: [PassengerCarrierQueryResolver_List_SortingInputType!], $where: PassengerCarrierQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    passengerCarrier {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          id
          is_latest
          ...PassengerCarrierBaseFragment
        }
      }
    }
  }
}
    ${PassengerCarrierBaseFragmentFragmentDoc}`;

/**
 * __usePassengerCarriersQuery__
 *
 * To run a query within a React component, call `usePassengerCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePassengerCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePassengerCarriersQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function usePassengerCarriersQuery(baseOptions: Apollo.QueryHookOptions<PassengerCarriersQuery, PassengerCarriersQueryVariables> & ({ variables: PassengerCarriersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PassengerCarriersQuery, PassengerCarriersQueryVariables>(PassengerCarriersDocument, options);
      }
export function usePassengerCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PassengerCarriersQuery, PassengerCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PassengerCarriersQuery, PassengerCarriersQueryVariables>(PassengerCarriersDocument, options);
        }
export function usePassengerCarriersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PassengerCarriersQuery, PassengerCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PassengerCarriersQuery, PassengerCarriersQueryVariables>(PassengerCarriersDocument, options);
        }
export type PassengerCarriersQueryHookResult = ReturnType<typeof usePassengerCarriersQuery>;
export type PassengerCarriersLazyQueryHookResult = ReturnType<typeof usePassengerCarriersLazyQuery>;
export type PassengerCarriersSuspenseQueryHookResult = ReturnType<typeof usePassengerCarriersSuspenseQuery>;
export type PassengerCarriersQueryResult = Apollo.QueryResult<PassengerCarriersQuery, PassengerCarriersQueryVariables>;
export const PeriodicitySeasonCreateDocument = /*#__PURE__*/ gql`
    mutation periodicitySeasonCreate($data: CreatePeriodicitySeasonDto!) {
  classifiers {
    periodicitySeason {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type PeriodicitySeasonCreateMutationFn = Apollo.MutationFunction<PeriodicitySeasonCreateMutation, PeriodicitySeasonCreateMutationVariables>;

/**
 * __usePeriodicitySeasonCreateMutation__
 *
 * To run a mutation, you first call `usePeriodicitySeasonCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePeriodicitySeasonCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [periodicitySeasonCreateMutation, { data, loading, error }] = usePeriodicitySeasonCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePeriodicitySeasonCreateMutation(baseOptions?: Apollo.MutationHookOptions<PeriodicitySeasonCreateMutation, PeriodicitySeasonCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PeriodicitySeasonCreateMutation, PeriodicitySeasonCreateMutationVariables>(PeriodicitySeasonCreateDocument, options);
      }
export type PeriodicitySeasonCreateMutationHookResult = ReturnType<typeof usePeriodicitySeasonCreateMutation>;
export type PeriodicitySeasonCreateMutationResult = Apollo.MutationResult<PeriodicitySeasonCreateMutation>;
export type PeriodicitySeasonCreateMutationOptions = Apollo.BaseMutationOptions<PeriodicitySeasonCreateMutation, PeriodicitySeasonCreateMutationVariables>;
export const PeriodicitySeasonHistoryDocument = /*#__PURE__*/ gql`
    query periodicitySeasonHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [PeriodicitySeasonQueryResolver_History_SortingInputType!]) {
  classifiers {
    periodicitySeason {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          ...PeriodicitySeasonBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${PeriodicitySeasonBaseFragmentFragmentDoc}`;

/**
 * __usePeriodicitySeasonHistoryQuery__
 *
 * To run a query within a React component, call `usePeriodicitySeasonHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodicitySeasonHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodicitySeasonHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePeriodicitySeasonHistoryQuery(baseOptions: Apollo.QueryHookOptions<PeriodicitySeasonHistoryQuery, PeriodicitySeasonHistoryQueryVariables> & ({ variables: PeriodicitySeasonHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeriodicitySeasonHistoryQuery, PeriodicitySeasonHistoryQueryVariables>(PeriodicitySeasonHistoryDocument, options);
      }
export function usePeriodicitySeasonHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeriodicitySeasonHistoryQuery, PeriodicitySeasonHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeriodicitySeasonHistoryQuery, PeriodicitySeasonHistoryQueryVariables>(PeriodicitySeasonHistoryDocument, options);
        }
export function usePeriodicitySeasonHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PeriodicitySeasonHistoryQuery, PeriodicitySeasonHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeriodicitySeasonHistoryQuery, PeriodicitySeasonHistoryQueryVariables>(PeriodicitySeasonHistoryDocument, options);
        }
export type PeriodicitySeasonHistoryQueryHookResult = ReturnType<typeof usePeriodicitySeasonHistoryQuery>;
export type PeriodicitySeasonHistoryLazyQueryHookResult = ReturnType<typeof usePeriodicitySeasonHistoryLazyQuery>;
export type PeriodicitySeasonHistorySuspenseQueryHookResult = ReturnType<typeof usePeriodicitySeasonHistorySuspenseQuery>;
export type PeriodicitySeasonHistoryQueryResult = Apollo.QueryResult<PeriodicitySeasonHistoryQuery, PeriodicitySeasonHistoryQueryVariables>;
export const PeriodicitySeasonListDocument = /*#__PURE__*/ gql`
    query periodicitySeasonList($paginate: PaginatorArgsDto, $orderBy: [PeriodicitySeasonQueryResolver_List_SortingInputType!], $where: PeriodicitySeasonQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    periodicitySeason {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...PeriodicitySeasonBaseFragment
        }
        totalCount
      }
    }
  }
}
    ${PeriodicitySeasonBaseFragmentFragmentDoc}`;

/**
 * __usePeriodicitySeasonListQuery__
 *
 * To run a query within a React component, call `usePeriodicitySeasonListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodicitySeasonListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodicitySeasonListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function usePeriodicitySeasonListQuery(baseOptions: Apollo.QueryHookOptions<PeriodicitySeasonListQuery, PeriodicitySeasonListQueryVariables> & ({ variables: PeriodicitySeasonListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeriodicitySeasonListQuery, PeriodicitySeasonListQueryVariables>(PeriodicitySeasonListDocument, options);
      }
export function usePeriodicitySeasonListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeriodicitySeasonListQuery, PeriodicitySeasonListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeriodicitySeasonListQuery, PeriodicitySeasonListQueryVariables>(PeriodicitySeasonListDocument, options);
        }
export function usePeriodicitySeasonListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PeriodicitySeasonListQuery, PeriodicitySeasonListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeriodicitySeasonListQuery, PeriodicitySeasonListQueryVariables>(PeriodicitySeasonListDocument, options);
        }
export type PeriodicitySeasonListQueryHookResult = ReturnType<typeof usePeriodicitySeasonListQuery>;
export type PeriodicitySeasonListLazyQueryHookResult = ReturnType<typeof usePeriodicitySeasonListLazyQuery>;
export type PeriodicitySeasonListSuspenseQueryHookResult = ReturnType<typeof usePeriodicitySeasonListSuspenseQuery>;
export type PeriodicitySeasonListQueryResult = Apollo.QueryResult<PeriodicitySeasonListQuery, PeriodicitySeasonListQueryVariables>;
export const PeriodicitySeasonRangeByIdDocument = /*#__PURE__*/ gql`
    query periodicitySeasonRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    periodicitySeason {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __usePeriodicitySeasonRangeByIdQuery__
 *
 * To run a query within a React component, call `usePeriodicitySeasonRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodicitySeasonRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodicitySeasonRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function usePeriodicitySeasonRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<PeriodicitySeasonRangeByIdQuery, PeriodicitySeasonRangeByIdQueryVariables> & ({ variables: PeriodicitySeasonRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeriodicitySeasonRangeByIdQuery, PeriodicitySeasonRangeByIdQueryVariables>(PeriodicitySeasonRangeByIdDocument, options);
      }
export function usePeriodicitySeasonRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeriodicitySeasonRangeByIdQuery, PeriodicitySeasonRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeriodicitySeasonRangeByIdQuery, PeriodicitySeasonRangeByIdQueryVariables>(PeriodicitySeasonRangeByIdDocument, options);
        }
export function usePeriodicitySeasonRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PeriodicitySeasonRangeByIdQuery, PeriodicitySeasonRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeriodicitySeasonRangeByIdQuery, PeriodicitySeasonRangeByIdQueryVariables>(PeriodicitySeasonRangeByIdDocument, options);
        }
export type PeriodicitySeasonRangeByIdQueryHookResult = ReturnType<typeof usePeriodicitySeasonRangeByIdQuery>;
export type PeriodicitySeasonRangeByIdLazyQueryHookResult = ReturnType<typeof usePeriodicitySeasonRangeByIdLazyQuery>;
export type PeriodicitySeasonRangeByIdSuspenseQueryHookResult = ReturnType<typeof usePeriodicitySeasonRangeByIdSuspenseQuery>;
export type PeriodicitySeasonRangeByIdQueryResult = Apollo.QueryResult<PeriodicitySeasonRangeByIdQuery, PeriodicitySeasonRangeByIdQueryVariables>;
export const PeriodicitySeasonUpdateDocument = /*#__PURE__*/ gql`
    mutation periodicitySeasonUpdate($data: UpdatePeriodicitySeasonDto!) {
  classifiers {
    periodicitySeason {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type PeriodicitySeasonUpdateMutationFn = Apollo.MutationFunction<PeriodicitySeasonUpdateMutation, PeriodicitySeasonUpdateMutationVariables>;

/**
 * __usePeriodicitySeasonUpdateMutation__
 *
 * To run a mutation, you first call `usePeriodicitySeasonUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePeriodicitySeasonUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [periodicitySeasonUpdateMutation, { data, loading, error }] = usePeriodicitySeasonUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePeriodicitySeasonUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PeriodicitySeasonUpdateMutation, PeriodicitySeasonUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PeriodicitySeasonUpdateMutation, PeriodicitySeasonUpdateMutationVariables>(PeriodicitySeasonUpdateDocument, options);
      }
export type PeriodicitySeasonUpdateMutationHookResult = ReturnType<typeof usePeriodicitySeasonUpdateMutation>;
export type PeriodicitySeasonUpdateMutationResult = Apollo.MutationResult<PeriodicitySeasonUpdateMutation>;
export type PeriodicitySeasonUpdateMutationOptions = Apollo.BaseMutationOptions<PeriodicitySeasonUpdateMutation, PeriodicitySeasonUpdateMutationVariables>;
export const CreateRailwayAdministrationDocument = /*#__PURE__*/ gql`
    mutation createRailwayAdministration($input: CreateRailwayAdministrationDto!) {
  classifiers {
    railwayAdministration {
      create(data: $input) {
        id
      }
    }
  }
}
    `;
export type CreateRailwayAdministrationMutationFn = Apollo.MutationFunction<CreateRailwayAdministrationMutation, CreateRailwayAdministrationMutationVariables>;

/**
 * __useCreateRailwayAdministrationMutation__
 *
 * To run a mutation, you first call `useCreateRailwayAdministrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRailwayAdministrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRailwayAdministrationMutation, { data, loading, error }] = useCreateRailwayAdministrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRailwayAdministrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRailwayAdministrationMutation, CreateRailwayAdministrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRailwayAdministrationMutation, CreateRailwayAdministrationMutationVariables>(CreateRailwayAdministrationDocument, options);
      }
export type CreateRailwayAdministrationMutationHookResult = ReturnType<typeof useCreateRailwayAdministrationMutation>;
export type CreateRailwayAdministrationMutationResult = Apollo.MutationResult<CreateRailwayAdministrationMutation>;
export type CreateRailwayAdministrationMutationOptions = Apollo.BaseMutationOptions<CreateRailwayAdministrationMutation, CreateRailwayAdministrationMutationVariables>;
export const RailwayAdministrationHistoryDocument = /*#__PURE__*/ gql`
    query railwayAdministrationHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [RailwayAdministrationQueryResolver_History_SortingInputType!]) {
  classifiers {
    railwayAdministration {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          end_at
          start_at
          ...RailwayAdministrationBaseFragment
        }
      }
    }
  }
}
    ${RailwayAdministrationBaseFragmentFragmentDoc}`;

/**
 * __useRailwayAdministrationHistoryQuery__
 *
 * To run a query within a React component, call `useRailwayAdministrationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRailwayAdministrationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRailwayAdministrationHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useRailwayAdministrationHistoryQuery(baseOptions: Apollo.QueryHookOptions<RailwayAdministrationHistoryQuery, RailwayAdministrationHistoryQueryVariables> & ({ variables: RailwayAdministrationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RailwayAdministrationHistoryQuery, RailwayAdministrationHistoryQueryVariables>(RailwayAdministrationHistoryDocument, options);
      }
export function useRailwayAdministrationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RailwayAdministrationHistoryQuery, RailwayAdministrationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RailwayAdministrationHistoryQuery, RailwayAdministrationHistoryQueryVariables>(RailwayAdministrationHistoryDocument, options);
        }
export function useRailwayAdministrationHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RailwayAdministrationHistoryQuery, RailwayAdministrationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RailwayAdministrationHistoryQuery, RailwayAdministrationHistoryQueryVariables>(RailwayAdministrationHistoryDocument, options);
        }
export type RailwayAdministrationHistoryQueryHookResult = ReturnType<typeof useRailwayAdministrationHistoryQuery>;
export type RailwayAdministrationHistoryLazyQueryHookResult = ReturnType<typeof useRailwayAdministrationHistoryLazyQuery>;
export type RailwayAdministrationHistorySuspenseQueryHookResult = ReturnType<typeof useRailwayAdministrationHistorySuspenseQuery>;
export type RailwayAdministrationHistoryQueryResult = Apollo.QueryResult<RailwayAdministrationHistoryQuery, RailwayAdministrationHistoryQueryVariables>;
export const RailwayAdministrationRangeByIdDocument = /*#__PURE__*/ gql`
    query railwayAdministrationRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    railwayAdministration {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useRailwayAdministrationRangeByIdQuery__
 *
 * To run a query within a React component, call `useRailwayAdministrationRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRailwayAdministrationRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRailwayAdministrationRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useRailwayAdministrationRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<RailwayAdministrationRangeByIdQuery, RailwayAdministrationRangeByIdQueryVariables> & ({ variables: RailwayAdministrationRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RailwayAdministrationRangeByIdQuery, RailwayAdministrationRangeByIdQueryVariables>(RailwayAdministrationRangeByIdDocument, options);
      }
export function useRailwayAdministrationRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RailwayAdministrationRangeByIdQuery, RailwayAdministrationRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RailwayAdministrationRangeByIdQuery, RailwayAdministrationRangeByIdQueryVariables>(RailwayAdministrationRangeByIdDocument, options);
        }
export function useRailwayAdministrationRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RailwayAdministrationRangeByIdQuery, RailwayAdministrationRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RailwayAdministrationRangeByIdQuery, RailwayAdministrationRangeByIdQueryVariables>(RailwayAdministrationRangeByIdDocument, options);
        }
export type RailwayAdministrationRangeByIdQueryHookResult = ReturnType<typeof useRailwayAdministrationRangeByIdQuery>;
export type RailwayAdministrationRangeByIdLazyQueryHookResult = ReturnType<typeof useRailwayAdministrationRangeByIdLazyQuery>;
export type RailwayAdministrationRangeByIdSuspenseQueryHookResult = ReturnType<typeof useRailwayAdministrationRangeByIdSuspenseQuery>;
export type RailwayAdministrationRangeByIdQueryResult = Apollo.QueryResult<RailwayAdministrationRangeByIdQuery, RailwayAdministrationRangeByIdQueryVariables>;
export const UpdateRailwayAdministrationDocument = /*#__PURE__*/ gql`
    mutation updateRailwayAdministration($input: UpdateRailwayAdministrationDto!) {
  classifiers {
    railwayAdministration {
      update(data: $input) {
        id
      }
    }
  }
}
    `;
export type UpdateRailwayAdministrationMutationFn = Apollo.MutationFunction<UpdateRailwayAdministrationMutation, UpdateRailwayAdministrationMutationVariables>;

/**
 * __useUpdateRailwayAdministrationMutation__
 *
 * To run a mutation, you first call `useUpdateRailwayAdministrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRailwayAdministrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRailwayAdministrationMutation, { data, loading, error }] = useUpdateRailwayAdministrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRailwayAdministrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRailwayAdministrationMutation, UpdateRailwayAdministrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRailwayAdministrationMutation, UpdateRailwayAdministrationMutationVariables>(UpdateRailwayAdministrationDocument, options);
      }
export type UpdateRailwayAdministrationMutationHookResult = ReturnType<typeof useUpdateRailwayAdministrationMutation>;
export type UpdateRailwayAdministrationMutationResult = Apollo.MutationResult<UpdateRailwayAdministrationMutation>;
export type UpdateRailwayAdministrationMutationOptions = Apollo.BaseMutationOptions<UpdateRailwayAdministrationMutation, UpdateRailwayAdministrationMutationVariables>;
export const RailwayAdministrationDocument = /*#__PURE__*/ gql`
    query railwayAdministration($paginate: PaginatorArgsDto, $orderBy: [RailwayAdministrationQueryResolver_List_SortingInputType!], $where: RailwayAdministrationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    railwayAdministration {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...RailwayAdministrationBaseFragment
        }
      }
    }
  }
}
    ${RailwayAdministrationBaseFragmentFragmentDoc}`;

/**
 * __useRailwayAdministrationQuery__
 *
 * To run a query within a React component, call `useRailwayAdministrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRailwayAdministrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRailwayAdministrationQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useRailwayAdministrationQuery(baseOptions: Apollo.QueryHookOptions<RailwayAdministrationQuery, RailwayAdministrationQueryVariables> & ({ variables: RailwayAdministrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RailwayAdministrationQuery, RailwayAdministrationQueryVariables>(RailwayAdministrationDocument, options);
      }
export function useRailwayAdministrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RailwayAdministrationQuery, RailwayAdministrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RailwayAdministrationQuery, RailwayAdministrationQueryVariables>(RailwayAdministrationDocument, options);
        }
export function useRailwayAdministrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RailwayAdministrationQuery, RailwayAdministrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RailwayAdministrationQuery, RailwayAdministrationQueryVariables>(RailwayAdministrationDocument, options);
        }
export type RailwayAdministrationQueryHookResult = ReturnType<typeof useRailwayAdministrationQuery>;
export type RailwayAdministrationLazyQueryHookResult = ReturnType<typeof useRailwayAdministrationLazyQuery>;
export type RailwayAdministrationSuspenseQueryHookResult = ReturnType<typeof useRailwayAdministrationSuspenseQuery>;
export type RailwayAdministrationQueryResult = Apollo.QueryResult<RailwayAdministrationQuery, RailwayAdministrationQueryVariables>;
export const RailwayAdministrationListDocument = /*#__PURE__*/ gql`
    query railwayAdministrationList($paginate: PaginatorArgsDto, $orderBy: [RailwayAdministrationQueryResolver_List_SortingInputType!], $where: RailwayAdministrationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    railwayAdministration {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          entity_id
          short_name
          name
          code
        }
      }
    }
  }
}
    `;

/**
 * __useRailwayAdministrationListQuery__
 *
 * To run a query within a React component, call `useRailwayAdministrationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRailwayAdministrationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRailwayAdministrationListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useRailwayAdministrationListQuery(baseOptions: Apollo.QueryHookOptions<RailwayAdministrationListQuery, RailwayAdministrationListQueryVariables> & ({ variables: RailwayAdministrationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RailwayAdministrationListQuery, RailwayAdministrationListQueryVariables>(RailwayAdministrationListDocument, options);
      }
export function useRailwayAdministrationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RailwayAdministrationListQuery, RailwayAdministrationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RailwayAdministrationListQuery, RailwayAdministrationListQueryVariables>(RailwayAdministrationListDocument, options);
        }
export function useRailwayAdministrationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RailwayAdministrationListQuery, RailwayAdministrationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RailwayAdministrationListQuery, RailwayAdministrationListQueryVariables>(RailwayAdministrationListDocument, options);
        }
export type RailwayAdministrationListQueryHookResult = ReturnType<typeof useRailwayAdministrationListQuery>;
export type RailwayAdministrationListLazyQueryHookResult = ReturnType<typeof useRailwayAdministrationListLazyQuery>;
export type RailwayAdministrationListSuspenseQueryHookResult = ReturnType<typeof useRailwayAdministrationListSuspenseQuery>;
export type RailwayAdministrationListQueryResult = Apollo.QueryResult<RailwayAdministrationListQuery, RailwayAdministrationListQueryVariables>;
export const CreateRailwayDocument = /*#__PURE__*/ gql`
    mutation createRailway($input: CreateRailwayDto!) {
  classifiers {
    railway {
      create(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type CreateRailwayMutationFn = Apollo.MutationFunction<CreateRailwayMutation, CreateRailwayMutationVariables>;

/**
 * __useCreateRailwayMutation__
 *
 * To run a mutation, you first call `useCreateRailwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRailwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRailwayMutation, { data, loading, error }] = useCreateRailwayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRailwayMutation(baseOptions?: Apollo.MutationHookOptions<CreateRailwayMutation, CreateRailwayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRailwayMutation, CreateRailwayMutationVariables>(CreateRailwayDocument, options);
      }
export type CreateRailwayMutationHookResult = ReturnType<typeof useCreateRailwayMutation>;
export type CreateRailwayMutationResult = Apollo.MutationResult<CreateRailwayMutation>;
export type CreateRailwayMutationOptions = Apollo.BaseMutationOptions<CreateRailwayMutation, CreateRailwayMutationVariables>;
export const RailwaysHistoryDocument = /*#__PURE__*/ gql`
    query railwaysHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [RailwayQueryResolver_History_SortingInputType!]) {
  classifiers {
    railway {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          start_at
          end_at
          ...RailwayBaseFragment
          railway_administration {
            entity_id
            short_name
            name
          }
        }
      }
    }
  }
}
    ${RailwayBaseFragmentFragmentDoc}`;

/**
 * __useRailwaysHistoryQuery__
 *
 * To run a query within a React component, call `useRailwaysHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRailwaysHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRailwaysHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useRailwaysHistoryQuery(baseOptions: Apollo.QueryHookOptions<RailwaysHistoryQuery, RailwaysHistoryQueryVariables> & ({ variables: RailwaysHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RailwaysHistoryQuery, RailwaysHistoryQueryVariables>(RailwaysHistoryDocument, options);
      }
export function useRailwaysHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RailwaysHistoryQuery, RailwaysHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RailwaysHistoryQuery, RailwaysHistoryQueryVariables>(RailwaysHistoryDocument, options);
        }
export function useRailwaysHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RailwaysHistoryQuery, RailwaysHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RailwaysHistoryQuery, RailwaysHistoryQueryVariables>(RailwaysHistoryDocument, options);
        }
export type RailwaysHistoryQueryHookResult = ReturnType<typeof useRailwaysHistoryQuery>;
export type RailwaysHistoryLazyQueryHookResult = ReturnType<typeof useRailwaysHistoryLazyQuery>;
export type RailwaysHistorySuspenseQueryHookResult = ReturnType<typeof useRailwaysHistorySuspenseQuery>;
export type RailwaysHistoryQueryResult = Apollo.QueryResult<RailwaysHistoryQuery, RailwaysHistoryQueryVariables>;
export const RailwayRangeByIdDocument = /*#__PURE__*/ gql`
    query railwayRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    railway {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useRailwayRangeByIdQuery__
 *
 * To run a query within a React component, call `useRailwayRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRailwayRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRailwayRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useRailwayRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<RailwayRangeByIdQuery, RailwayRangeByIdQueryVariables> & ({ variables: RailwayRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RailwayRangeByIdQuery, RailwayRangeByIdQueryVariables>(RailwayRangeByIdDocument, options);
      }
export function useRailwayRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RailwayRangeByIdQuery, RailwayRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RailwayRangeByIdQuery, RailwayRangeByIdQueryVariables>(RailwayRangeByIdDocument, options);
        }
export function useRailwayRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RailwayRangeByIdQuery, RailwayRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RailwayRangeByIdQuery, RailwayRangeByIdQueryVariables>(RailwayRangeByIdDocument, options);
        }
export type RailwayRangeByIdQueryHookResult = ReturnType<typeof useRailwayRangeByIdQuery>;
export type RailwayRangeByIdLazyQueryHookResult = ReturnType<typeof useRailwayRangeByIdLazyQuery>;
export type RailwayRangeByIdSuspenseQueryHookResult = ReturnType<typeof useRailwayRangeByIdSuspenseQuery>;
export type RailwayRangeByIdQueryResult = Apollo.QueryResult<RailwayRangeByIdQuery, RailwayRangeByIdQueryVariables>;
export const UpdateRailwayDocument = /*#__PURE__*/ gql`
    mutation updateRailway($input: UpdateRailwayDto!) {
  classifiers {
    railway {
      update(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type UpdateRailwayMutationFn = Apollo.MutationFunction<UpdateRailwayMutation, UpdateRailwayMutationVariables>;

/**
 * __useUpdateRailwayMutation__
 *
 * To run a mutation, you first call `useUpdateRailwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRailwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRailwayMutation, { data, loading, error }] = useUpdateRailwayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRailwayMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRailwayMutation, UpdateRailwayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRailwayMutation, UpdateRailwayMutationVariables>(UpdateRailwayDocument, options);
      }
export type UpdateRailwayMutationHookResult = ReturnType<typeof useUpdateRailwayMutation>;
export type UpdateRailwayMutationResult = Apollo.MutationResult<UpdateRailwayMutation>;
export type UpdateRailwayMutationOptions = Apollo.BaseMutationOptions<UpdateRailwayMutation, UpdateRailwayMutationVariables>;
export const RailwaysDocument = /*#__PURE__*/ gql`
    query railways($range: RangeInputDto!, $paginate: PaginatorArgsDto, $orderBy: [RailwayQueryResolver_List_SortingInputType!], $where: RailwayQueryResolver_List_FilterInputType) {
  classifiers {
    railway {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...RailwayBaseFragment
          railway_administration {
            entity_id
            short_name
            name
          }
        }
      }
    }
  }
}
    ${RailwayBaseFragmentFragmentDoc}`;

/**
 * __useRailwaysQuery__
 *
 * To run a query within a React component, call `useRailwaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useRailwaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRailwaysQuery({
 *   variables: {
 *      range: // value for 'range'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRailwaysQuery(baseOptions: Apollo.QueryHookOptions<RailwaysQuery, RailwaysQueryVariables> & ({ variables: RailwaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RailwaysQuery, RailwaysQueryVariables>(RailwaysDocument, options);
      }
export function useRailwaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RailwaysQuery, RailwaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RailwaysQuery, RailwaysQueryVariables>(RailwaysDocument, options);
        }
export function useRailwaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RailwaysQuery, RailwaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RailwaysQuery, RailwaysQueryVariables>(RailwaysDocument, options);
        }
export type RailwaysQueryHookResult = ReturnType<typeof useRailwaysQuery>;
export type RailwaysLazyQueryHookResult = ReturnType<typeof useRailwaysLazyQuery>;
export type RailwaysSuspenseQueryHookResult = ReturnType<typeof useRailwaysSuspenseQuery>;
export type RailwaysQueryResult = Apollo.QueryResult<RailwaysQuery, RailwaysQueryVariables>;
export const RoutesControlAvailabilitySeatsDirectionsCreateDocument = /*#__PURE__*/ gql`
    mutation routesControlAvailabilitySeatsDirectionsCreate($data: CreateRoutesControlAvailabilitySeatsDirectionsDto!) {
  classifiers {
    routesControlAvailabilitySeatsDirection {
      create(data: $data) {
        id
      }
    }
  }
}
    `;
export type RoutesControlAvailabilitySeatsDirectionsCreateMutationFn = Apollo.MutationFunction<RoutesControlAvailabilitySeatsDirectionsCreateMutation, RoutesControlAvailabilitySeatsDirectionsCreateMutationVariables>;

/**
 * __useRoutesControlAvailabilitySeatsDirectionsCreateMutation__
 *
 * To run a mutation, you first call `useRoutesControlAvailabilitySeatsDirectionsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoutesControlAvailabilitySeatsDirectionsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routesControlAvailabilitySeatsDirectionsCreateMutation, { data, loading, error }] = useRoutesControlAvailabilitySeatsDirectionsCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRoutesControlAvailabilitySeatsDirectionsCreateMutation(baseOptions?: Apollo.MutationHookOptions<RoutesControlAvailabilitySeatsDirectionsCreateMutation, RoutesControlAvailabilitySeatsDirectionsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoutesControlAvailabilitySeatsDirectionsCreateMutation, RoutesControlAvailabilitySeatsDirectionsCreateMutationVariables>(RoutesControlAvailabilitySeatsDirectionsCreateDocument, options);
      }
export type RoutesControlAvailabilitySeatsDirectionsCreateMutationHookResult = ReturnType<typeof useRoutesControlAvailabilitySeatsDirectionsCreateMutation>;
export type RoutesControlAvailabilitySeatsDirectionsCreateMutationResult = Apollo.MutationResult<RoutesControlAvailabilitySeatsDirectionsCreateMutation>;
export type RoutesControlAvailabilitySeatsDirectionsCreateMutationOptions = Apollo.BaseMutationOptions<RoutesControlAvailabilitySeatsDirectionsCreateMutation, RoutesControlAvailabilitySeatsDirectionsCreateMutationVariables>;
export const RoutesControlAvailabilitySeatsDirectionsUpdateDocument = /*#__PURE__*/ gql`
    mutation routesControlAvailabilitySeatsDirectionsUpdate($data: UpdateRoutesControlAvailabilitySeatsDirectionsDto!) {
  classifiers {
    routesControlAvailabilitySeatsDirection {
      update(data: $data) {
        id
      }
    }
  }
}
    `;
export type RoutesControlAvailabilitySeatsDirectionsUpdateMutationFn = Apollo.MutationFunction<RoutesControlAvailabilitySeatsDirectionsUpdateMutation, RoutesControlAvailabilitySeatsDirectionsUpdateMutationVariables>;

/**
 * __useRoutesControlAvailabilitySeatsDirectionsUpdateMutation__
 *
 * To run a mutation, you first call `useRoutesControlAvailabilitySeatsDirectionsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoutesControlAvailabilitySeatsDirectionsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routesControlAvailabilitySeatsDirectionsUpdateMutation, { data, loading, error }] = useRoutesControlAvailabilitySeatsDirectionsUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRoutesControlAvailabilitySeatsDirectionsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RoutesControlAvailabilitySeatsDirectionsUpdateMutation, RoutesControlAvailabilitySeatsDirectionsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoutesControlAvailabilitySeatsDirectionsUpdateMutation, RoutesControlAvailabilitySeatsDirectionsUpdateMutationVariables>(RoutesControlAvailabilitySeatsDirectionsUpdateDocument, options);
      }
export type RoutesControlAvailabilitySeatsDirectionsUpdateMutationHookResult = ReturnType<typeof useRoutesControlAvailabilitySeatsDirectionsUpdateMutation>;
export type RoutesControlAvailabilitySeatsDirectionsUpdateMutationResult = Apollo.MutationResult<RoutesControlAvailabilitySeatsDirectionsUpdateMutation>;
export type RoutesControlAvailabilitySeatsDirectionsUpdateMutationOptions = Apollo.BaseMutationOptions<RoutesControlAvailabilitySeatsDirectionsUpdateMutation, RoutesControlAvailabilitySeatsDirectionsUpdateMutationVariables>;
export const RoutesControlAvailabilitySeatsDirectionsListDocument = /*#__PURE__*/ gql`
    query RoutesControlAvailabilitySeatsDirectionsList($paginate: PaginatorArgsDto!, $orderBy: [RoutesControlAvailabilitySeatsDirectionQueryResolver_List_SortingInputType!], $where: RoutesControlAvailabilitySeatsDirectionQueryResolver_List_FilterInputType) {
  classifiers {
    routesControlAvailabilitySeatsDirection {
      list(paginate: $paginate, order_by: $orderBy, where: $where) {
        items {
          id
          is_lock
          arrival_direction {
            ...StationShortFragment
          }
          arrival_stations {
            ...StationShortFragment
          }
          departure_direction {
            ...StationShortFragment
          }
          departure_stations {
            ...StationShortFragment
          }
        }
        totalCount
      }
    }
  }
}
    ${StationShortFragmentFragmentDoc}`;

/**
 * __useRoutesControlAvailabilitySeatsDirectionsListQuery__
 *
 * To run a query within a React component, call `useRoutesControlAvailabilitySeatsDirectionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoutesControlAvailabilitySeatsDirectionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutesControlAvailabilitySeatsDirectionsListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRoutesControlAvailabilitySeatsDirectionsListQuery(baseOptions: Apollo.QueryHookOptions<RoutesControlAvailabilitySeatsDirectionsListQuery, RoutesControlAvailabilitySeatsDirectionsListQueryVariables> & ({ variables: RoutesControlAvailabilitySeatsDirectionsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoutesControlAvailabilitySeatsDirectionsListQuery, RoutesControlAvailabilitySeatsDirectionsListQueryVariables>(RoutesControlAvailabilitySeatsDirectionsListDocument, options);
      }
export function useRoutesControlAvailabilitySeatsDirectionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoutesControlAvailabilitySeatsDirectionsListQuery, RoutesControlAvailabilitySeatsDirectionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoutesControlAvailabilitySeatsDirectionsListQuery, RoutesControlAvailabilitySeatsDirectionsListQueryVariables>(RoutesControlAvailabilitySeatsDirectionsListDocument, options);
        }
export function useRoutesControlAvailabilitySeatsDirectionsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RoutesControlAvailabilitySeatsDirectionsListQuery, RoutesControlAvailabilitySeatsDirectionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoutesControlAvailabilitySeatsDirectionsListQuery, RoutesControlAvailabilitySeatsDirectionsListQueryVariables>(RoutesControlAvailabilitySeatsDirectionsListDocument, options);
        }
export type RoutesControlAvailabilitySeatsDirectionsListQueryHookResult = ReturnType<typeof useRoutesControlAvailabilitySeatsDirectionsListQuery>;
export type RoutesControlAvailabilitySeatsDirectionsListLazyQueryHookResult = ReturnType<typeof useRoutesControlAvailabilitySeatsDirectionsListLazyQuery>;
export type RoutesControlAvailabilitySeatsDirectionsListSuspenseQueryHookResult = ReturnType<typeof useRoutesControlAvailabilitySeatsDirectionsListSuspenseQuery>;
export type RoutesControlAvailabilitySeatsDirectionsListQueryResult = Apollo.QueryResult<RoutesControlAvailabilitySeatsDirectionsListQuery, RoutesControlAvailabilitySeatsDirectionsListQueryVariables>;
export const StationCreateDocument = /*#__PURE__*/ gql`
    mutation stationCreate($data: CreateStationDto!) {
  classifiers {
    station {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type StationCreateMutationFn = Apollo.MutationFunction<StationCreateMutation, StationCreateMutationVariables>;

/**
 * __useStationCreateMutation__
 *
 * To run a mutation, you first call `useStationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stationCreateMutation, { data, loading, error }] = useStationCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStationCreateMutation(baseOptions?: Apollo.MutationHookOptions<StationCreateMutation, StationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StationCreateMutation, StationCreateMutationVariables>(StationCreateDocument, options);
      }
export type StationCreateMutationHookResult = ReturnType<typeof useStationCreateMutation>;
export type StationCreateMutationResult = Apollo.MutationResult<StationCreateMutation>;
export type StationCreateMutationOptions = Apollo.BaseMutationOptions<StationCreateMutation, StationCreateMutationVariables>;
export const StationsHistoryDocument = /*#__PURE__*/ gql`
    query stationsHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [StationQueryResolver_History_SortingInputType!]) {
  classifiers {
    station {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          ...StationBaseFragment
          last_version {
            is_available_to_create_version
            ...LatestVersionFragment
          }
          railway {
            ...RailwayBaseFragment
          }
        }
      }
    }
  }
}
    ${StationBaseFragmentFragmentDoc}
${LatestVersionFragmentFragmentDoc}
${RailwayBaseFragmentFragmentDoc}`;

/**
 * __useStationsHistoryQuery__
 *
 * To run a query within a React component, call `useStationsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationsHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useStationsHistoryQuery(baseOptions: Apollo.QueryHookOptions<StationsHistoryQuery, StationsHistoryQueryVariables> & ({ variables: StationsHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StationsHistoryQuery, StationsHistoryQueryVariables>(StationsHistoryDocument, options);
      }
export function useStationsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StationsHistoryQuery, StationsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StationsHistoryQuery, StationsHistoryQueryVariables>(StationsHistoryDocument, options);
        }
export function useStationsHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StationsHistoryQuery, StationsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StationsHistoryQuery, StationsHistoryQueryVariables>(StationsHistoryDocument, options);
        }
export type StationsHistoryQueryHookResult = ReturnType<typeof useStationsHistoryQuery>;
export type StationsHistoryLazyQueryHookResult = ReturnType<typeof useStationsHistoryLazyQuery>;
export type StationsHistorySuspenseQueryHookResult = ReturnType<typeof useStationsHistorySuspenseQuery>;
export type StationsHistoryQueryResult = Apollo.QueryResult<StationsHistoryQuery, StationsHistoryQueryVariables>;
export const StationsListDocument = /*#__PURE__*/ gql`
    query stationsList($range: RangeInputDto!, $paginate: PaginatorArgsDto, $orderBy: [StationQueryResolver_List_SortingInputType!], $where: StationQueryResolver_List_FilterInputType) {
  classifiers {
    station {
      list(range: $range, paginate: $paginate, order_by: $orderBy, where: $where) {
        totalCount
        items {
          ...StationBaseFragment
          last_version {
            ...LatestVersionFragment
          }
          railway {
            ...RailwayBaseFragment
          }
        }
      }
    }
  }
}
    ${StationBaseFragmentFragmentDoc}
${LatestVersionFragmentFragmentDoc}
${RailwayBaseFragmentFragmentDoc}`;

/**
 * __useStationsListQuery__
 *
 * To run a query within a React component, call `useStationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationsListQuery({
 *   variables: {
 *      range: // value for 'range'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useStationsListQuery(baseOptions: Apollo.QueryHookOptions<StationsListQuery, StationsListQueryVariables> & ({ variables: StationsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StationsListQuery, StationsListQueryVariables>(StationsListDocument, options);
      }
export function useStationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StationsListQuery, StationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StationsListQuery, StationsListQueryVariables>(StationsListDocument, options);
        }
export function useStationsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StationsListQuery, StationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StationsListQuery, StationsListQueryVariables>(StationsListDocument, options);
        }
export type StationsListQueryHookResult = ReturnType<typeof useStationsListQuery>;
export type StationsListLazyQueryHookResult = ReturnType<typeof useStationsListLazyQuery>;
export type StationsListSuspenseQueryHookResult = ReturnType<typeof useStationsListSuspenseQuery>;
export type StationsListQueryResult = Apollo.QueryResult<StationsListQuery, StationsListQueryVariables>;
export const StationNameForSchemaUpdateDocument = /*#__PURE__*/ gql`
    mutation stationNameForSchemaUpdate($data: UpdateStationNameDto!) {
  classifiers {
    station {
      updateNameForSchema(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type StationNameForSchemaUpdateMutationFn = Apollo.MutationFunction<StationNameForSchemaUpdateMutation, StationNameForSchemaUpdateMutationVariables>;

/**
 * __useStationNameForSchemaUpdateMutation__
 *
 * To run a mutation, you first call `useStationNameForSchemaUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStationNameForSchemaUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stationNameForSchemaUpdateMutation, { data, loading, error }] = useStationNameForSchemaUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStationNameForSchemaUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StationNameForSchemaUpdateMutation, StationNameForSchemaUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StationNameForSchemaUpdateMutation, StationNameForSchemaUpdateMutationVariables>(StationNameForSchemaUpdateDocument, options);
      }
export type StationNameForSchemaUpdateMutationHookResult = ReturnType<typeof useStationNameForSchemaUpdateMutation>;
export type StationNameForSchemaUpdateMutationResult = Apollo.MutationResult<StationNameForSchemaUpdateMutation>;
export type StationNameForSchemaUpdateMutationOptions = Apollo.BaseMutationOptions<StationNameForSchemaUpdateMutation, StationNameForSchemaUpdateMutationVariables>;
export const StationRangeByIdDocument = /*#__PURE__*/ gql`
    query stationRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    station {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...LatestVersionFragment
        }
      }
    }
  }
}
    ${LatestVersionFragmentFragmentDoc}`;

/**
 * __useStationRangeByIdQuery__
 *
 * To run a query within a React component, call `useStationRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useStationRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<StationRangeByIdQuery, StationRangeByIdQueryVariables> & ({ variables: StationRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StationRangeByIdQuery, StationRangeByIdQueryVariables>(StationRangeByIdDocument, options);
      }
export function useStationRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StationRangeByIdQuery, StationRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StationRangeByIdQuery, StationRangeByIdQueryVariables>(StationRangeByIdDocument, options);
        }
export function useStationRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StationRangeByIdQuery, StationRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StationRangeByIdQuery, StationRangeByIdQueryVariables>(StationRangeByIdDocument, options);
        }
export type StationRangeByIdQueryHookResult = ReturnType<typeof useStationRangeByIdQuery>;
export type StationRangeByIdLazyQueryHookResult = ReturnType<typeof useStationRangeByIdLazyQuery>;
export type StationRangeByIdSuspenseQueryHookResult = ReturnType<typeof useStationRangeByIdSuspenseQuery>;
export type StationRangeByIdQueryResult = Apollo.QueryResult<StationRangeByIdQuery, StationRangeByIdQueryVariables>;
export const StationUpdateDocument = /*#__PURE__*/ gql`
    mutation stationUpdate($data: UpdateStationDto!) {
  classifiers {
    station {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type StationUpdateMutationFn = Apollo.MutationFunction<StationUpdateMutation, StationUpdateMutationVariables>;

/**
 * __useStationUpdateMutation__
 *
 * To run a mutation, you first call `useStationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stationUpdateMutation, { data, loading, error }] = useStationUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StationUpdateMutation, StationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StationUpdateMutation, StationUpdateMutationVariables>(StationUpdateDocument, options);
      }
export type StationUpdateMutationHookResult = ReturnType<typeof useStationUpdateMutation>;
export type StationUpdateMutationResult = Apollo.MutationResult<StationUpdateMutation>;
export type StationUpdateMutationOptions = Apollo.BaseMutationOptions<StationUpdateMutation, StationUpdateMutationVariables>;
export const StationVersionUpdateDocument = /*#__PURE__*/ gql`
    mutation stationVersionUpdate($data: UpdateStationVersionDto!) {
  classifiers {
    station {
      updateVersion(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type StationVersionUpdateMutationFn = Apollo.MutationFunction<StationVersionUpdateMutation, StationVersionUpdateMutationVariables>;

/**
 * __useStationVersionUpdateMutation__
 *
 * To run a mutation, you first call `useStationVersionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStationVersionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stationVersionUpdateMutation, { data, loading, error }] = useStationVersionUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStationVersionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StationVersionUpdateMutation, StationVersionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StationVersionUpdateMutation, StationVersionUpdateMutationVariables>(StationVersionUpdateDocument, options);
      }
export type StationVersionUpdateMutationHookResult = ReturnType<typeof useStationVersionUpdateMutation>;
export type StationVersionUpdateMutationResult = Apollo.MutationResult<StationVersionUpdateMutation>;
export type StationVersionUpdateMutationOptions = Apollo.BaseMutationOptions<StationVersionUpdateMutation, StationVersionUpdateMutationVariables>;
export const StructuralSubdivisionBranchListDocument = /*#__PURE__*/ gql`
    query structuralSubdivisionBranchList($paginate: PaginatorArgsDto, $orderBy: [BranchQueryResolver_List_SortingInputType!], $where: BranchQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    branch {
      list(
        paginate: $paginate
        order_by: $orderBy
        where: $where
        data: {range: $range}
      ) {
        items {
          entity_id
          name
        }
        totalCount
      }
    }
  }
}
    `;

/**
 * __useStructuralSubdivisionBranchListQuery__
 *
 * To run a query within a React component, call `useStructuralSubdivisionBranchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuralSubdivisionBranchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuralSubdivisionBranchListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useStructuralSubdivisionBranchListQuery(baseOptions: Apollo.QueryHookOptions<StructuralSubdivisionBranchListQuery, StructuralSubdivisionBranchListQueryVariables> & ({ variables: StructuralSubdivisionBranchListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuralSubdivisionBranchListQuery, StructuralSubdivisionBranchListQueryVariables>(StructuralSubdivisionBranchListDocument, options);
      }
export function useStructuralSubdivisionBranchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuralSubdivisionBranchListQuery, StructuralSubdivisionBranchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuralSubdivisionBranchListQuery, StructuralSubdivisionBranchListQueryVariables>(StructuralSubdivisionBranchListDocument, options);
        }
export function useStructuralSubdivisionBranchListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructuralSubdivisionBranchListQuery, StructuralSubdivisionBranchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructuralSubdivisionBranchListQuery, StructuralSubdivisionBranchListQueryVariables>(StructuralSubdivisionBranchListDocument, options);
        }
export type StructuralSubdivisionBranchListQueryHookResult = ReturnType<typeof useStructuralSubdivisionBranchListQuery>;
export type StructuralSubdivisionBranchListLazyQueryHookResult = ReturnType<typeof useStructuralSubdivisionBranchListLazyQuery>;
export type StructuralSubdivisionBranchListSuspenseQueryHookResult = ReturnType<typeof useStructuralSubdivisionBranchListSuspenseQuery>;
export type StructuralSubdivisionBranchListQueryResult = Apollo.QueryResult<StructuralSubdivisionBranchListQuery, StructuralSubdivisionBranchListQueryVariables>;
export const CreateStructuralSubdivisionDocument = /*#__PURE__*/ gql`
    mutation createStructuralSubdivision($input: CreateStructuralSubdivisionDto!) {
  classifiers {
    structuralSubdivision {
      create(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type CreateStructuralSubdivisionMutationFn = Apollo.MutationFunction<CreateStructuralSubdivisionMutation, CreateStructuralSubdivisionMutationVariables>;

/**
 * __useCreateStructuralSubdivisionMutation__
 *
 * To run a mutation, you first call `useCreateStructuralSubdivisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStructuralSubdivisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStructuralSubdivisionMutation, { data, loading, error }] = useCreateStructuralSubdivisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStructuralSubdivisionMutation(baseOptions?: Apollo.MutationHookOptions<CreateStructuralSubdivisionMutation, CreateStructuralSubdivisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStructuralSubdivisionMutation, CreateStructuralSubdivisionMutationVariables>(CreateStructuralSubdivisionDocument, options);
      }
export type CreateStructuralSubdivisionMutationHookResult = ReturnType<typeof useCreateStructuralSubdivisionMutation>;
export type CreateStructuralSubdivisionMutationResult = Apollo.MutationResult<CreateStructuralSubdivisionMutation>;
export type CreateStructuralSubdivisionMutationOptions = Apollo.BaseMutationOptions<CreateStructuralSubdivisionMutation, CreateStructuralSubdivisionMutationVariables>;
export const StructuralSubdivisionsHistoryDocument = /*#__PURE__*/ gql`
    query structuralSubdivisionsHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [StructuralSubdivisionQueryResolver_History_SortingInputType!]) {
  classifiers {
    structuralSubdivision {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          start_at
          end_at
          ...StructuralSubdivisionBaseFragment
          branch {
            ...BranchShortFragment
          }
          station {
            ...StationShortFragment
          }
        }
      }
    }
  }
}
    ${StructuralSubdivisionBaseFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;

/**
 * __useStructuralSubdivisionsHistoryQuery__
 *
 * To run a query within a React component, call `useStructuralSubdivisionsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuralSubdivisionsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuralSubdivisionsHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useStructuralSubdivisionsHistoryQuery(baseOptions: Apollo.QueryHookOptions<StructuralSubdivisionsHistoryQuery, StructuralSubdivisionsHistoryQueryVariables> & ({ variables: StructuralSubdivisionsHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuralSubdivisionsHistoryQuery, StructuralSubdivisionsHistoryQueryVariables>(StructuralSubdivisionsHistoryDocument, options);
      }
export function useStructuralSubdivisionsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuralSubdivisionsHistoryQuery, StructuralSubdivisionsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuralSubdivisionsHistoryQuery, StructuralSubdivisionsHistoryQueryVariables>(StructuralSubdivisionsHistoryDocument, options);
        }
export function useStructuralSubdivisionsHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructuralSubdivisionsHistoryQuery, StructuralSubdivisionsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructuralSubdivisionsHistoryQuery, StructuralSubdivisionsHistoryQueryVariables>(StructuralSubdivisionsHistoryDocument, options);
        }
export type StructuralSubdivisionsHistoryQueryHookResult = ReturnType<typeof useStructuralSubdivisionsHistoryQuery>;
export type StructuralSubdivisionsHistoryLazyQueryHookResult = ReturnType<typeof useStructuralSubdivisionsHistoryLazyQuery>;
export type StructuralSubdivisionsHistorySuspenseQueryHookResult = ReturnType<typeof useStructuralSubdivisionsHistorySuspenseQuery>;
export type StructuralSubdivisionsHistoryQueryResult = Apollo.QueryResult<StructuralSubdivisionsHistoryQuery, StructuralSubdivisionsHistoryQueryVariables>;
export const StructuralSubdivisionRangeByIdDocument = /*#__PURE__*/ gql`
    query structuralSubdivisionRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    structuralSubdivision {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useStructuralSubdivisionRangeByIdQuery__
 *
 * To run a query within a React component, call `useStructuralSubdivisionRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuralSubdivisionRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuralSubdivisionRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useStructuralSubdivisionRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<StructuralSubdivisionRangeByIdQuery, StructuralSubdivisionRangeByIdQueryVariables> & ({ variables: StructuralSubdivisionRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuralSubdivisionRangeByIdQuery, StructuralSubdivisionRangeByIdQueryVariables>(StructuralSubdivisionRangeByIdDocument, options);
      }
export function useStructuralSubdivisionRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuralSubdivisionRangeByIdQuery, StructuralSubdivisionRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuralSubdivisionRangeByIdQuery, StructuralSubdivisionRangeByIdQueryVariables>(StructuralSubdivisionRangeByIdDocument, options);
        }
export function useStructuralSubdivisionRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructuralSubdivisionRangeByIdQuery, StructuralSubdivisionRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructuralSubdivisionRangeByIdQuery, StructuralSubdivisionRangeByIdQueryVariables>(StructuralSubdivisionRangeByIdDocument, options);
        }
export type StructuralSubdivisionRangeByIdQueryHookResult = ReturnType<typeof useStructuralSubdivisionRangeByIdQuery>;
export type StructuralSubdivisionRangeByIdLazyQueryHookResult = ReturnType<typeof useStructuralSubdivisionRangeByIdLazyQuery>;
export type StructuralSubdivisionRangeByIdSuspenseQueryHookResult = ReturnType<typeof useStructuralSubdivisionRangeByIdSuspenseQuery>;
export type StructuralSubdivisionRangeByIdQueryResult = Apollo.QueryResult<StructuralSubdivisionRangeByIdQuery, StructuralSubdivisionRangeByIdQueryVariables>;
export const StructuralSubdivisionStationListDocument = /*#__PURE__*/ gql`
    query structuralSubdivisionStationList($paginate: PaginatorArgsDto, $orderBy: [StationQueryResolver_List_SortingInputType!], $where: StationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    station {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...StationShortFragment
        }
      }
    }
  }
}
    ${StationShortFragmentFragmentDoc}`;

/**
 * __useStructuralSubdivisionStationListQuery__
 *
 * To run a query within a React component, call `useStructuralSubdivisionStationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuralSubdivisionStationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuralSubdivisionStationListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useStructuralSubdivisionStationListQuery(baseOptions: Apollo.QueryHookOptions<StructuralSubdivisionStationListQuery, StructuralSubdivisionStationListQueryVariables> & ({ variables: StructuralSubdivisionStationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuralSubdivisionStationListQuery, StructuralSubdivisionStationListQueryVariables>(StructuralSubdivisionStationListDocument, options);
      }
export function useStructuralSubdivisionStationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuralSubdivisionStationListQuery, StructuralSubdivisionStationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuralSubdivisionStationListQuery, StructuralSubdivisionStationListQueryVariables>(StructuralSubdivisionStationListDocument, options);
        }
export function useStructuralSubdivisionStationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructuralSubdivisionStationListQuery, StructuralSubdivisionStationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructuralSubdivisionStationListQuery, StructuralSubdivisionStationListQueryVariables>(StructuralSubdivisionStationListDocument, options);
        }
export type StructuralSubdivisionStationListQueryHookResult = ReturnType<typeof useStructuralSubdivisionStationListQuery>;
export type StructuralSubdivisionStationListLazyQueryHookResult = ReturnType<typeof useStructuralSubdivisionStationListLazyQuery>;
export type StructuralSubdivisionStationListSuspenseQueryHookResult = ReturnType<typeof useStructuralSubdivisionStationListSuspenseQuery>;
export type StructuralSubdivisionStationListQueryResult = Apollo.QueryResult<StructuralSubdivisionStationListQuery, StructuralSubdivisionStationListQueryVariables>;
export const UpdateStructuralSubdivisionDocument = /*#__PURE__*/ gql`
    mutation updateStructuralSubdivision($input: UpdateStructuralSubdivisionDto!) {
  classifiers {
    structuralSubdivision {
      update(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type UpdateStructuralSubdivisionMutationFn = Apollo.MutationFunction<UpdateStructuralSubdivisionMutation, UpdateStructuralSubdivisionMutationVariables>;

/**
 * __useUpdateStructuralSubdivisionMutation__
 *
 * To run a mutation, you first call `useUpdateStructuralSubdivisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStructuralSubdivisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStructuralSubdivisionMutation, { data, loading, error }] = useUpdateStructuralSubdivisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStructuralSubdivisionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStructuralSubdivisionMutation, UpdateStructuralSubdivisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStructuralSubdivisionMutation, UpdateStructuralSubdivisionMutationVariables>(UpdateStructuralSubdivisionDocument, options);
      }
export type UpdateStructuralSubdivisionMutationHookResult = ReturnType<typeof useUpdateStructuralSubdivisionMutation>;
export type UpdateStructuralSubdivisionMutationResult = Apollo.MutationResult<UpdateStructuralSubdivisionMutation>;
export type UpdateStructuralSubdivisionMutationOptions = Apollo.BaseMutationOptions<UpdateStructuralSubdivisionMutation, UpdateStructuralSubdivisionMutationVariables>;
export const StructuralSubdivisionsDocument = /*#__PURE__*/ gql`
    query structuralSubdivisions($paginate: PaginatorArgsDto, $orderBy: [StructuralSubdivisionQueryResolver_List_SortingInputType!], $where: StructuralSubdivisionQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    structuralSubdivision {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...StructuralSubdivisionBaseFragment
          branch {
            ...BranchShortFragment
          }
          station {
            ...StationShortFragment
          }
        }
      }
    }
  }
}
    ${StructuralSubdivisionBaseFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;

/**
 * __useStructuralSubdivisionsQuery__
 *
 * To run a query within a React component, call `useStructuralSubdivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuralSubdivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuralSubdivisionsQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useStructuralSubdivisionsQuery(baseOptions: Apollo.QueryHookOptions<StructuralSubdivisionsQuery, StructuralSubdivisionsQueryVariables> & ({ variables: StructuralSubdivisionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuralSubdivisionsQuery, StructuralSubdivisionsQueryVariables>(StructuralSubdivisionsDocument, options);
      }
export function useStructuralSubdivisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuralSubdivisionsQuery, StructuralSubdivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuralSubdivisionsQuery, StructuralSubdivisionsQueryVariables>(StructuralSubdivisionsDocument, options);
        }
export function useStructuralSubdivisionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructuralSubdivisionsQuery, StructuralSubdivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructuralSubdivisionsQuery, StructuralSubdivisionsQueryVariables>(StructuralSubdivisionsDocument, options);
        }
export type StructuralSubdivisionsQueryHookResult = ReturnType<typeof useStructuralSubdivisionsQuery>;
export type StructuralSubdivisionsLazyQueryHookResult = ReturnType<typeof useStructuralSubdivisionsLazyQuery>;
export type StructuralSubdivisionsSuspenseQueryHookResult = ReturnType<typeof useStructuralSubdivisionsSuspenseQuery>;
export type StructuralSubdivisionsQueryResult = Apollo.QueryResult<StructuralSubdivisionsQuery, StructuralSubdivisionsQueryVariables>;
export const TractionDirectorateCreateDocument = /*#__PURE__*/ gql`
    mutation tractionDirectorateCreate($data: CreateTractionDirectorateDto!) {
  classifiers {
    tractionDirectorate {
      create(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type TractionDirectorateCreateMutationFn = Apollo.MutationFunction<TractionDirectorateCreateMutation, TractionDirectorateCreateMutationVariables>;

/**
 * __useTractionDirectorateCreateMutation__
 *
 * To run a mutation, you first call `useTractionDirectorateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTractionDirectorateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tractionDirectorateCreateMutation, { data, loading, error }] = useTractionDirectorateCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTractionDirectorateCreateMutation(baseOptions?: Apollo.MutationHookOptions<TractionDirectorateCreateMutation, TractionDirectorateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TractionDirectorateCreateMutation, TractionDirectorateCreateMutationVariables>(TractionDirectorateCreateDocument, options);
      }
export type TractionDirectorateCreateMutationHookResult = ReturnType<typeof useTractionDirectorateCreateMutation>;
export type TractionDirectorateCreateMutationResult = Apollo.MutationResult<TractionDirectorateCreateMutation>;
export type TractionDirectorateCreateMutationOptions = Apollo.BaseMutationOptions<TractionDirectorateCreateMutation, TractionDirectorateCreateMutationVariables>;
export const TractionDirectorateHistoryDocument = /*#__PURE__*/ gql`
    query tractionDirectorateHistory($entityId: Float!, $paginate: PaginatorArgsDto!, $orderBy: [TractionDirectorateQueryResolver_History_SortingInputType!]) {
  classifiers {
    tractionDirectorate {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        items {
          ...TractionDirectorateBaseFragment
          railway {
            entity_id
            name
          }
        }
        totalCount
      }
    }
  }
}
    ${TractionDirectorateBaseFragmentFragmentDoc}`;

/**
 * __useTractionDirectorateHistoryQuery__
 *
 * To run a query within a React component, call `useTractionDirectorateHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTractionDirectorateHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTractionDirectorateHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTractionDirectorateHistoryQuery(baseOptions: Apollo.QueryHookOptions<TractionDirectorateHistoryQuery, TractionDirectorateHistoryQueryVariables> & ({ variables: TractionDirectorateHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TractionDirectorateHistoryQuery, TractionDirectorateHistoryQueryVariables>(TractionDirectorateHistoryDocument, options);
      }
export function useTractionDirectorateHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TractionDirectorateHistoryQuery, TractionDirectorateHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TractionDirectorateHistoryQuery, TractionDirectorateHistoryQueryVariables>(TractionDirectorateHistoryDocument, options);
        }
export function useTractionDirectorateHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TractionDirectorateHistoryQuery, TractionDirectorateHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TractionDirectorateHistoryQuery, TractionDirectorateHistoryQueryVariables>(TractionDirectorateHistoryDocument, options);
        }
export type TractionDirectorateHistoryQueryHookResult = ReturnType<typeof useTractionDirectorateHistoryQuery>;
export type TractionDirectorateHistoryLazyQueryHookResult = ReturnType<typeof useTractionDirectorateHistoryLazyQuery>;
export type TractionDirectorateHistorySuspenseQueryHookResult = ReturnType<typeof useTractionDirectorateHistorySuspenseQuery>;
export type TractionDirectorateHistoryQueryResult = Apollo.QueryResult<TractionDirectorateHistoryQuery, TractionDirectorateHistoryQueryVariables>;
export const TractionDirectorateListDocument = /*#__PURE__*/ gql`
    query tractionDirectorateList($paginate: PaginatorArgsDto!, $orderBy: [TractionDirectorateQueryResolver_List_SortingInputType!], $where: TractionDirectorateQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    tractionDirectorate {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        items {
          ...TractionDirectorateBaseFragment
          railway {
            entity_id
            name
          }
        }
        totalCount
      }
    }
  }
}
    ${TractionDirectorateBaseFragmentFragmentDoc}`;

/**
 * __useTractionDirectorateListQuery__
 *
 * To run a query within a React component, call `useTractionDirectorateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTractionDirectorateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTractionDirectorateListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTractionDirectorateListQuery(baseOptions: Apollo.QueryHookOptions<TractionDirectorateListQuery, TractionDirectorateListQueryVariables> & ({ variables: TractionDirectorateListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TractionDirectorateListQuery, TractionDirectorateListQueryVariables>(TractionDirectorateListDocument, options);
      }
export function useTractionDirectorateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TractionDirectorateListQuery, TractionDirectorateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TractionDirectorateListQuery, TractionDirectorateListQueryVariables>(TractionDirectorateListDocument, options);
        }
export function useTractionDirectorateListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TractionDirectorateListQuery, TractionDirectorateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TractionDirectorateListQuery, TractionDirectorateListQueryVariables>(TractionDirectorateListDocument, options);
        }
export type TractionDirectorateListQueryHookResult = ReturnType<typeof useTractionDirectorateListQuery>;
export type TractionDirectorateListLazyQueryHookResult = ReturnType<typeof useTractionDirectorateListLazyQuery>;
export type TractionDirectorateListSuspenseQueryHookResult = ReturnType<typeof useTractionDirectorateListSuspenseQuery>;
export type TractionDirectorateListQueryResult = Apollo.QueryResult<TractionDirectorateListQuery, TractionDirectorateListQueryVariables>;
export const TractionDirectorateRangeByIdDocument = /*#__PURE__*/ gql`
    query tractionDirectorateRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    tractionDirectorate {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useTractionDirectorateRangeByIdQuery__
 *
 * To run a query within a React component, call `useTractionDirectorateRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTractionDirectorateRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTractionDirectorateRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTractionDirectorateRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<TractionDirectorateRangeByIdQuery, TractionDirectorateRangeByIdQueryVariables> & ({ variables: TractionDirectorateRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TractionDirectorateRangeByIdQuery, TractionDirectorateRangeByIdQueryVariables>(TractionDirectorateRangeByIdDocument, options);
      }
export function useTractionDirectorateRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TractionDirectorateRangeByIdQuery, TractionDirectorateRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TractionDirectorateRangeByIdQuery, TractionDirectorateRangeByIdQueryVariables>(TractionDirectorateRangeByIdDocument, options);
        }
export function useTractionDirectorateRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TractionDirectorateRangeByIdQuery, TractionDirectorateRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TractionDirectorateRangeByIdQuery, TractionDirectorateRangeByIdQueryVariables>(TractionDirectorateRangeByIdDocument, options);
        }
export type TractionDirectorateRangeByIdQueryHookResult = ReturnType<typeof useTractionDirectorateRangeByIdQuery>;
export type TractionDirectorateRangeByIdLazyQueryHookResult = ReturnType<typeof useTractionDirectorateRangeByIdLazyQuery>;
export type TractionDirectorateRangeByIdSuspenseQueryHookResult = ReturnType<typeof useTractionDirectorateRangeByIdSuspenseQuery>;
export type TractionDirectorateRangeByIdQueryResult = Apollo.QueryResult<TractionDirectorateRangeByIdQuery, TractionDirectorateRangeByIdQueryVariables>;
export const TractionDirectorateUpdateDocument = /*#__PURE__*/ gql`
    mutation tractionDirectorateUpdate($data: UpdateTractionDirectorateDto!) {
  classifiers {
    tractionDirectorate {
      update(data: $data) {
        entity_id
      }
    }
  }
}
    `;
export type TractionDirectorateUpdateMutationFn = Apollo.MutationFunction<TractionDirectorateUpdateMutation, TractionDirectorateUpdateMutationVariables>;

/**
 * __useTractionDirectorateUpdateMutation__
 *
 * To run a mutation, you first call `useTractionDirectorateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTractionDirectorateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tractionDirectorateUpdateMutation, { data, loading, error }] = useTractionDirectorateUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTractionDirectorateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TractionDirectorateUpdateMutation, TractionDirectorateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TractionDirectorateUpdateMutation, TractionDirectorateUpdateMutationVariables>(TractionDirectorateUpdateDocument, options);
      }
export type TractionDirectorateUpdateMutationHookResult = ReturnType<typeof useTractionDirectorateUpdateMutation>;
export type TractionDirectorateUpdateMutationResult = Apollo.MutationResult<TractionDirectorateUpdateMutation>;
export type TractionDirectorateUpdateMutationOptions = Apollo.BaseMutationOptions<TractionDirectorateUpdateMutation, TractionDirectorateUpdateMutationVariables>;
export const CreateTrainBrandDocument = /*#__PURE__*/ gql`
    mutation createTrainBrand($input: CreateTrainBrandDto!) {
  classifiers {
    trainBrand {
      create(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type CreateTrainBrandMutationFn = Apollo.MutationFunction<CreateTrainBrandMutation, CreateTrainBrandMutationVariables>;

/**
 * __useCreateTrainBrandMutation__
 *
 * To run a mutation, you first call `useCreateTrainBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrainBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrainBrandMutation, { data, loading, error }] = useCreateTrainBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrainBrandMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrainBrandMutation, CreateTrainBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrainBrandMutation, CreateTrainBrandMutationVariables>(CreateTrainBrandDocument, options);
      }
export type CreateTrainBrandMutationHookResult = ReturnType<typeof useCreateTrainBrandMutation>;
export type CreateTrainBrandMutationResult = Apollo.MutationResult<CreateTrainBrandMutation>;
export type CreateTrainBrandMutationOptions = Apollo.BaseMutationOptions<CreateTrainBrandMutation, CreateTrainBrandMutationVariables>;
export const TrainBrandsHistoryDocument = /*#__PURE__*/ gql`
    query trainBrandsHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [TrainBrandQueryResolver_History_SortingInputType!]) {
  classifiers {
    trainBrand {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          start_at
          end_at
          ...TrainBrandBaseFragment
        }
      }
    }
  }
}
    ${TrainBrandBaseFragmentFragmentDoc}`;

/**
 * __useTrainBrandsHistoryQuery__
 *
 * To run a query within a React component, call `useTrainBrandsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainBrandsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainBrandsHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTrainBrandsHistoryQuery(baseOptions: Apollo.QueryHookOptions<TrainBrandsHistoryQuery, TrainBrandsHistoryQueryVariables> & ({ variables: TrainBrandsHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainBrandsHistoryQuery, TrainBrandsHistoryQueryVariables>(TrainBrandsHistoryDocument, options);
      }
export function useTrainBrandsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainBrandsHistoryQuery, TrainBrandsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainBrandsHistoryQuery, TrainBrandsHistoryQueryVariables>(TrainBrandsHistoryDocument, options);
        }
export function useTrainBrandsHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainBrandsHistoryQuery, TrainBrandsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainBrandsHistoryQuery, TrainBrandsHistoryQueryVariables>(TrainBrandsHistoryDocument, options);
        }
export type TrainBrandsHistoryQueryHookResult = ReturnType<typeof useTrainBrandsHistoryQuery>;
export type TrainBrandsHistoryLazyQueryHookResult = ReturnType<typeof useTrainBrandsHistoryLazyQuery>;
export type TrainBrandsHistorySuspenseQueryHookResult = ReturnType<typeof useTrainBrandsHistorySuspenseQuery>;
export type TrainBrandsHistoryQueryResult = Apollo.QueryResult<TrainBrandsHistoryQuery, TrainBrandsHistoryQueryVariables>;
export const TrainBrandRangeByIdDocument = /*#__PURE__*/ gql`
    query trainBrandRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    trainBrand {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useTrainBrandRangeByIdQuery__
 *
 * To run a query within a React component, call `useTrainBrandRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainBrandRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainBrandRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainBrandRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<TrainBrandRangeByIdQuery, TrainBrandRangeByIdQueryVariables> & ({ variables: TrainBrandRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainBrandRangeByIdQuery, TrainBrandRangeByIdQueryVariables>(TrainBrandRangeByIdDocument, options);
      }
export function useTrainBrandRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainBrandRangeByIdQuery, TrainBrandRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainBrandRangeByIdQuery, TrainBrandRangeByIdQueryVariables>(TrainBrandRangeByIdDocument, options);
        }
export function useTrainBrandRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainBrandRangeByIdQuery, TrainBrandRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainBrandRangeByIdQuery, TrainBrandRangeByIdQueryVariables>(TrainBrandRangeByIdDocument, options);
        }
export type TrainBrandRangeByIdQueryHookResult = ReturnType<typeof useTrainBrandRangeByIdQuery>;
export type TrainBrandRangeByIdLazyQueryHookResult = ReturnType<typeof useTrainBrandRangeByIdLazyQuery>;
export type TrainBrandRangeByIdSuspenseQueryHookResult = ReturnType<typeof useTrainBrandRangeByIdSuspenseQuery>;
export type TrainBrandRangeByIdQueryResult = Apollo.QueryResult<TrainBrandRangeByIdQuery, TrainBrandRangeByIdQueryVariables>;
export const UpdateTrainBrandDocument = /*#__PURE__*/ gql`
    mutation updateTrainBrand($input: UpdateTrainBrandDto!) {
  classifiers {
    trainBrand {
      update(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type UpdateTrainBrandMutationFn = Apollo.MutationFunction<UpdateTrainBrandMutation, UpdateTrainBrandMutationVariables>;

/**
 * __useUpdateTrainBrandMutation__
 *
 * To run a mutation, you first call `useUpdateTrainBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainBrandMutation, { data, loading, error }] = useUpdateTrainBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrainBrandMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainBrandMutation, UpdateTrainBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainBrandMutation, UpdateTrainBrandMutationVariables>(UpdateTrainBrandDocument, options);
      }
export type UpdateTrainBrandMutationHookResult = ReturnType<typeof useUpdateTrainBrandMutation>;
export type UpdateTrainBrandMutationResult = Apollo.MutationResult<UpdateTrainBrandMutation>;
export type UpdateTrainBrandMutationOptions = Apollo.BaseMutationOptions<UpdateTrainBrandMutation, UpdateTrainBrandMutationVariables>;
export const UpdateTrainBrandColorDocument = /*#__PURE__*/ gql`
    mutation updateTrainBrandColor($input: UpdateColorTrainBrandDto!) {
  classifiers {
    trainBrand {
      updateColor(data: $input) {
        totalCount
      }
    }
  }
}
    `;
export type UpdateTrainBrandColorMutationFn = Apollo.MutationFunction<UpdateTrainBrandColorMutation, UpdateTrainBrandColorMutationVariables>;

/**
 * __useUpdateTrainBrandColorMutation__
 *
 * To run a mutation, you first call `useUpdateTrainBrandColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainBrandColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainBrandColorMutation, { data, loading, error }] = useUpdateTrainBrandColorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrainBrandColorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainBrandColorMutation, UpdateTrainBrandColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainBrandColorMutation, UpdateTrainBrandColorMutationVariables>(UpdateTrainBrandColorDocument, options);
      }
export type UpdateTrainBrandColorMutationHookResult = ReturnType<typeof useUpdateTrainBrandColorMutation>;
export type UpdateTrainBrandColorMutationResult = Apollo.MutationResult<UpdateTrainBrandColorMutation>;
export type UpdateTrainBrandColorMutationOptions = Apollo.BaseMutationOptions<UpdateTrainBrandColorMutation, UpdateTrainBrandColorMutationVariables>;
export const TrainBrandsListDocument = /*#__PURE__*/ gql`
    query trainBrandsList($paginate: PaginatorArgsDto, $orderBy: [TrainBrandQueryResolver_List_SortingInputType!], $where: TrainBrandQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    trainBrand {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...TrainBrandBaseFragment
        }
      }
    }
  }
}
    ${TrainBrandBaseFragmentFragmentDoc}`;

/**
 * __useTrainBrandsListQuery__
 *
 * To run a query within a React component, call `useTrainBrandsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainBrandsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainBrandsListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainBrandsListQuery(baseOptions: Apollo.QueryHookOptions<TrainBrandsListQuery, TrainBrandsListQueryVariables> & ({ variables: TrainBrandsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainBrandsListQuery, TrainBrandsListQueryVariables>(TrainBrandsListDocument, options);
      }
export function useTrainBrandsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainBrandsListQuery, TrainBrandsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainBrandsListQuery, TrainBrandsListQueryVariables>(TrainBrandsListDocument, options);
        }
export function useTrainBrandsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainBrandsListQuery, TrainBrandsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainBrandsListQuery, TrainBrandsListQueryVariables>(TrainBrandsListDocument, options);
        }
export type TrainBrandsListQueryHookResult = ReturnType<typeof useTrainBrandsListQuery>;
export type TrainBrandsListLazyQueryHookResult = ReturnType<typeof useTrainBrandsListLazyQuery>;
export type TrainBrandsListSuspenseQueryHookResult = ReturnType<typeof useTrainBrandsListSuspenseQuery>;
export type TrainBrandsListQueryResult = Apollo.QueryResult<TrainBrandsListQuery, TrainBrandsListQueryVariables>;
export const CreateTrainCategoryDocument = /*#__PURE__*/ gql`
    mutation createTrainCategory($input: CreateTrainCategoryDto!) {
  classifiers {
    trainCategory {
      create(data: $input) {
        entity_id
        train_category
      }
    }
  }
}
    `;
export type CreateTrainCategoryMutationFn = Apollo.MutationFunction<CreateTrainCategoryMutation, CreateTrainCategoryMutationVariables>;

/**
 * __useCreateTrainCategoryMutation__
 *
 * To run a mutation, you first call `useCreateTrainCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrainCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrainCategoryMutation, { data, loading, error }] = useCreateTrainCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrainCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrainCategoryMutation, CreateTrainCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrainCategoryMutation, CreateTrainCategoryMutationVariables>(CreateTrainCategoryDocument, options);
      }
export type CreateTrainCategoryMutationHookResult = ReturnType<typeof useCreateTrainCategoryMutation>;
export type CreateTrainCategoryMutationResult = Apollo.MutationResult<CreateTrainCategoryMutation>;
export type CreateTrainCategoryMutationOptions = Apollo.BaseMutationOptions<CreateTrainCategoryMutation, CreateTrainCategoryMutationVariables>;
export const TrainCategoryHistoryDocument = /*#__PURE__*/ gql`
    query trainCategoryHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [TrainCategoryQueryResolver_History_SortingInputType!]) {
  classifiers {
    trainCategory {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          ...TrainCategoryBaseFragment
        }
      }
    }
  }
}
    ${TrainCategoryBaseFragmentFragmentDoc}`;

/**
 * __useTrainCategoryHistoryQuery__
 *
 * To run a query within a React component, call `useTrainCategoryHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainCategoryHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainCategoryHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTrainCategoryHistoryQuery(baseOptions: Apollo.QueryHookOptions<TrainCategoryHistoryQuery, TrainCategoryHistoryQueryVariables> & ({ variables: TrainCategoryHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainCategoryHistoryQuery, TrainCategoryHistoryQueryVariables>(TrainCategoryHistoryDocument, options);
      }
export function useTrainCategoryHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainCategoryHistoryQuery, TrainCategoryHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainCategoryHistoryQuery, TrainCategoryHistoryQueryVariables>(TrainCategoryHistoryDocument, options);
        }
export function useTrainCategoryHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainCategoryHistoryQuery, TrainCategoryHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainCategoryHistoryQuery, TrainCategoryHistoryQueryVariables>(TrainCategoryHistoryDocument, options);
        }
export type TrainCategoryHistoryQueryHookResult = ReturnType<typeof useTrainCategoryHistoryQuery>;
export type TrainCategoryHistoryLazyQueryHookResult = ReturnType<typeof useTrainCategoryHistoryLazyQuery>;
export type TrainCategoryHistorySuspenseQueryHookResult = ReturnType<typeof useTrainCategoryHistorySuspenseQuery>;
export type TrainCategoryHistoryQueryResult = Apollo.QueryResult<TrainCategoryHistoryQuery, TrainCategoryHistoryQueryVariables>;
export const TrainCategoryRangeByIdDocument = /*#__PURE__*/ gql`
    query trainCategoryRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    trainCategory {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useTrainCategoryRangeByIdQuery__
 *
 * To run a query within a React component, call `useTrainCategoryRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainCategoryRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainCategoryRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainCategoryRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<TrainCategoryRangeByIdQuery, TrainCategoryRangeByIdQueryVariables> & ({ variables: TrainCategoryRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainCategoryRangeByIdQuery, TrainCategoryRangeByIdQueryVariables>(TrainCategoryRangeByIdDocument, options);
      }
export function useTrainCategoryRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainCategoryRangeByIdQuery, TrainCategoryRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainCategoryRangeByIdQuery, TrainCategoryRangeByIdQueryVariables>(TrainCategoryRangeByIdDocument, options);
        }
export function useTrainCategoryRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainCategoryRangeByIdQuery, TrainCategoryRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainCategoryRangeByIdQuery, TrainCategoryRangeByIdQueryVariables>(TrainCategoryRangeByIdDocument, options);
        }
export type TrainCategoryRangeByIdQueryHookResult = ReturnType<typeof useTrainCategoryRangeByIdQuery>;
export type TrainCategoryRangeByIdLazyQueryHookResult = ReturnType<typeof useTrainCategoryRangeByIdLazyQuery>;
export type TrainCategoryRangeByIdSuspenseQueryHookResult = ReturnType<typeof useTrainCategoryRangeByIdSuspenseQuery>;
export type TrainCategoryRangeByIdQueryResult = Apollo.QueryResult<TrainCategoryRangeByIdQuery, TrainCategoryRangeByIdQueryVariables>;
export const UpdateTrainCategoryDocument = /*#__PURE__*/ gql`
    mutation updateTrainCategory($input: UpdateTrainCategoryDto!) {
  classifiers {
    trainCategory {
      update(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type UpdateTrainCategoryMutationFn = Apollo.MutationFunction<UpdateTrainCategoryMutation, UpdateTrainCategoryMutationVariables>;

/**
 * __useUpdateTrainCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateTrainCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainCategoryMutation, { data, loading, error }] = useUpdateTrainCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrainCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainCategoryMutation, UpdateTrainCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainCategoryMutation, UpdateTrainCategoryMutationVariables>(UpdateTrainCategoryDocument, options);
      }
export type UpdateTrainCategoryMutationHookResult = ReturnType<typeof useUpdateTrainCategoryMutation>;
export type UpdateTrainCategoryMutationResult = Apollo.MutationResult<UpdateTrainCategoryMutation>;
export type UpdateTrainCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateTrainCategoryMutation, UpdateTrainCategoryMutationVariables>;
export const TrainCategoryListDocument = /*#__PURE__*/ gql`
    query trainCategoryList($paginate: PaginatorArgsDto, $orderBy: [TrainCategoryQueryResolver_List_SortingInputType!], $where: TrainCategoryQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    trainCategory {
      list(where: $where, paginate: $paginate, order_by: $orderBy, range: $range) {
        totalCount
        items {
          ...TrainCategoryBaseFragment
          train_sub_categories {
            ...TrainSubCategoryBaseFragment
            train_sub_categories_details_speed {
              entity_id
              name
              train_numbers
            }
          }
        }
      }
    }
  }
}
    ${TrainCategoryBaseFragmentFragmentDoc}
${TrainSubCategoryBaseFragmentFragmentDoc}`;

/**
 * __useTrainCategoryListQuery__
 *
 * To run a query within a React component, call `useTrainCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainCategoryListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainCategoryListQuery(baseOptions: Apollo.QueryHookOptions<TrainCategoryListQuery, TrainCategoryListQueryVariables> & ({ variables: TrainCategoryListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainCategoryListQuery, TrainCategoryListQueryVariables>(TrainCategoryListDocument, options);
      }
export function useTrainCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainCategoryListQuery, TrainCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainCategoryListQuery, TrainCategoryListQueryVariables>(TrainCategoryListDocument, options);
        }
export function useTrainCategoryListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainCategoryListQuery, TrainCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainCategoryListQuery, TrainCategoryListQueryVariables>(TrainCategoryListDocument, options);
        }
export type TrainCategoryListQueryHookResult = ReturnType<typeof useTrainCategoryListQuery>;
export type TrainCategoryListLazyQueryHookResult = ReturnType<typeof useTrainCategoryListLazyQuery>;
export type TrainCategoryListSuspenseQueryHookResult = ReturnType<typeof useTrainCategoryListSuspenseQuery>;
export type TrainCategoryListQueryResult = Apollo.QueryResult<TrainCategoryListQuery, TrainCategoryListQueryVariables>;
export const CreateTrainSubCategoryDocument = /*#__PURE__*/ gql`
    mutation createTrainSubCategory($input: CreateTrainSubCategoryDto!) {
  classifiers {
    trainSubCategory {
      create(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type CreateTrainSubCategoryMutationFn = Apollo.MutationFunction<CreateTrainSubCategoryMutation, CreateTrainSubCategoryMutationVariables>;

/**
 * __useCreateTrainSubCategoryMutation__
 *
 * To run a mutation, you first call `useCreateTrainSubCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrainSubCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrainSubCategoryMutation, { data, loading, error }] = useCreateTrainSubCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrainSubCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrainSubCategoryMutation, CreateTrainSubCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrainSubCategoryMutation, CreateTrainSubCategoryMutationVariables>(CreateTrainSubCategoryDocument, options);
      }
export type CreateTrainSubCategoryMutationHookResult = ReturnType<typeof useCreateTrainSubCategoryMutation>;
export type CreateTrainSubCategoryMutationResult = Apollo.MutationResult<CreateTrainSubCategoryMutation>;
export type CreateTrainSubCategoryMutationOptions = Apollo.BaseMutationOptions<CreateTrainSubCategoryMutation, CreateTrainSubCategoryMutationVariables>;
export const TrainSubCategoryHistoryDocument = /*#__PURE__*/ gql`
    query trainSubCategoryHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [TrainSubCategoryQueryResolver_History_SortingInputType!]) {
  classifiers {
    trainSubCategory {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          ...TrainSubCategoryBaseFragment
        }
      }
    }
  }
}
    ${TrainSubCategoryBaseFragmentFragmentDoc}`;

/**
 * __useTrainSubCategoryHistoryQuery__
 *
 * To run a query within a React component, call `useTrainSubCategoryHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainSubCategoryHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainSubCategoryHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTrainSubCategoryHistoryQuery(baseOptions: Apollo.QueryHookOptions<TrainSubCategoryHistoryQuery, TrainSubCategoryHistoryQueryVariables> & ({ variables: TrainSubCategoryHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainSubCategoryHistoryQuery, TrainSubCategoryHistoryQueryVariables>(TrainSubCategoryHistoryDocument, options);
      }
export function useTrainSubCategoryHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainSubCategoryHistoryQuery, TrainSubCategoryHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainSubCategoryHistoryQuery, TrainSubCategoryHistoryQueryVariables>(TrainSubCategoryHistoryDocument, options);
        }
export function useTrainSubCategoryHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainSubCategoryHistoryQuery, TrainSubCategoryHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainSubCategoryHistoryQuery, TrainSubCategoryHistoryQueryVariables>(TrainSubCategoryHistoryDocument, options);
        }
export type TrainSubCategoryHistoryQueryHookResult = ReturnType<typeof useTrainSubCategoryHistoryQuery>;
export type TrainSubCategoryHistoryLazyQueryHookResult = ReturnType<typeof useTrainSubCategoryHistoryLazyQuery>;
export type TrainSubCategoryHistorySuspenseQueryHookResult = ReturnType<typeof useTrainSubCategoryHistorySuspenseQuery>;
export type TrainSubCategoryHistoryQueryResult = Apollo.QueryResult<TrainSubCategoryHistoryQuery, TrainSubCategoryHistoryQueryVariables>;
export const TrainSubCategoryRangeByIdDocument = /*#__PURE__*/ gql`
    query trainSubCategoryRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    trainSubCategory {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useTrainSubCategoryRangeByIdQuery__
 *
 * To run a query within a React component, call `useTrainSubCategoryRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainSubCategoryRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainSubCategoryRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainSubCategoryRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<TrainSubCategoryRangeByIdQuery, TrainSubCategoryRangeByIdQueryVariables> & ({ variables: TrainSubCategoryRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainSubCategoryRangeByIdQuery, TrainSubCategoryRangeByIdQueryVariables>(TrainSubCategoryRangeByIdDocument, options);
      }
export function useTrainSubCategoryRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainSubCategoryRangeByIdQuery, TrainSubCategoryRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainSubCategoryRangeByIdQuery, TrainSubCategoryRangeByIdQueryVariables>(TrainSubCategoryRangeByIdDocument, options);
        }
export function useTrainSubCategoryRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainSubCategoryRangeByIdQuery, TrainSubCategoryRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainSubCategoryRangeByIdQuery, TrainSubCategoryRangeByIdQueryVariables>(TrainSubCategoryRangeByIdDocument, options);
        }
export type TrainSubCategoryRangeByIdQueryHookResult = ReturnType<typeof useTrainSubCategoryRangeByIdQuery>;
export type TrainSubCategoryRangeByIdLazyQueryHookResult = ReturnType<typeof useTrainSubCategoryRangeByIdLazyQuery>;
export type TrainSubCategoryRangeByIdSuspenseQueryHookResult = ReturnType<typeof useTrainSubCategoryRangeByIdSuspenseQuery>;
export type TrainSubCategoryRangeByIdQueryResult = Apollo.QueryResult<TrainSubCategoryRangeByIdQuery, TrainSubCategoryRangeByIdQueryVariables>;
export const UpdateTrainSubCategoryDocument = /*#__PURE__*/ gql`
    mutation updateTrainSubCategory($input: UpdateTrainSubCategoryDto!) {
  classifiers {
    trainSubCategory {
      update(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type UpdateTrainSubCategoryMutationFn = Apollo.MutationFunction<UpdateTrainSubCategoryMutation, UpdateTrainSubCategoryMutationVariables>;

/**
 * __useUpdateTrainSubCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateTrainSubCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainSubCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainSubCategoryMutation, { data, loading, error }] = useUpdateTrainSubCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrainSubCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainSubCategoryMutation, UpdateTrainSubCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainSubCategoryMutation, UpdateTrainSubCategoryMutationVariables>(UpdateTrainSubCategoryDocument, options);
      }
export type UpdateTrainSubCategoryMutationHookResult = ReturnType<typeof useUpdateTrainSubCategoryMutation>;
export type UpdateTrainSubCategoryMutationResult = Apollo.MutationResult<UpdateTrainSubCategoryMutation>;
export type UpdateTrainSubCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateTrainSubCategoryMutation, UpdateTrainSubCategoryMutationVariables>;
export const UpdateTrainSubCategoryColorDocument = /*#__PURE__*/ gql`
    mutation updateTrainSubCategoryColor($input: UpdateColorTrainSubCategoryDto!) {
  classifiers {
    trainSubCategory {
      updateColor(data: $input) {
        totalCount
      }
    }
  }
}
    `;
export type UpdateTrainSubCategoryColorMutationFn = Apollo.MutationFunction<UpdateTrainSubCategoryColorMutation, UpdateTrainSubCategoryColorMutationVariables>;

/**
 * __useUpdateTrainSubCategoryColorMutation__
 *
 * To run a mutation, you first call `useUpdateTrainSubCategoryColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainSubCategoryColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainSubCategoryColorMutation, { data, loading, error }] = useUpdateTrainSubCategoryColorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrainSubCategoryColorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainSubCategoryColorMutation, UpdateTrainSubCategoryColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainSubCategoryColorMutation, UpdateTrainSubCategoryColorMutationVariables>(UpdateTrainSubCategoryColorDocument, options);
      }
export type UpdateTrainSubCategoryColorMutationHookResult = ReturnType<typeof useUpdateTrainSubCategoryColorMutation>;
export type UpdateTrainSubCategoryColorMutationResult = Apollo.MutationResult<UpdateTrainSubCategoryColorMutation>;
export type UpdateTrainSubCategoryColorMutationOptions = Apollo.BaseMutationOptions<UpdateTrainSubCategoryColorMutation, UpdateTrainSubCategoryColorMutationVariables>;
export const TrainSubCategoriesDetailSpeedByIdDocument = /*#__PURE__*/ gql`
    query trainSubCategoriesDetailSpeedById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    trainSubCategoriesDetailsSpeed {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useTrainSubCategoriesDetailSpeedByIdQuery__
 *
 * To run a query within a React component, call `useTrainSubCategoriesDetailSpeedByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainSubCategoriesDetailSpeedByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainSubCategoriesDetailSpeedByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainSubCategoriesDetailSpeedByIdQuery(baseOptions: Apollo.QueryHookOptions<TrainSubCategoriesDetailSpeedByIdQuery, TrainSubCategoriesDetailSpeedByIdQueryVariables> & ({ variables: TrainSubCategoriesDetailSpeedByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainSubCategoriesDetailSpeedByIdQuery, TrainSubCategoriesDetailSpeedByIdQueryVariables>(TrainSubCategoriesDetailSpeedByIdDocument, options);
      }
export function useTrainSubCategoriesDetailSpeedByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainSubCategoriesDetailSpeedByIdQuery, TrainSubCategoriesDetailSpeedByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainSubCategoriesDetailSpeedByIdQuery, TrainSubCategoriesDetailSpeedByIdQueryVariables>(TrainSubCategoriesDetailSpeedByIdDocument, options);
        }
export function useTrainSubCategoriesDetailSpeedByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainSubCategoriesDetailSpeedByIdQuery, TrainSubCategoriesDetailSpeedByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainSubCategoriesDetailSpeedByIdQuery, TrainSubCategoriesDetailSpeedByIdQueryVariables>(TrainSubCategoriesDetailSpeedByIdDocument, options);
        }
export type TrainSubCategoriesDetailSpeedByIdQueryHookResult = ReturnType<typeof useTrainSubCategoriesDetailSpeedByIdQuery>;
export type TrainSubCategoriesDetailSpeedByIdLazyQueryHookResult = ReturnType<typeof useTrainSubCategoriesDetailSpeedByIdLazyQuery>;
export type TrainSubCategoriesDetailSpeedByIdSuspenseQueryHookResult = ReturnType<typeof useTrainSubCategoriesDetailSpeedByIdSuspenseQuery>;
export type TrainSubCategoriesDetailSpeedByIdQueryResult = Apollo.QueryResult<TrainSubCategoriesDetailSpeedByIdQuery, TrainSubCategoriesDetailSpeedByIdQueryVariables>;
export const TrainSubCategoriesDetailsSpeedHistoryListDocument = /*#__PURE__*/ gql`
    query TrainSubCategoriesDetailsSpeedHistoryList($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [TrainSubCategoriesDetailsSpeedQueryResolver_History_SortingInputType!]) {
  classifiers {
    trainSubCategoriesDetailsSpeed {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          ...TrainSubCategoriesDetailsSpeedBaseFragment
          train_sub_category {
            ...TrainSubCategoryShortSpeedFragment
          }
        }
      }
    }
  }
}
    ${TrainSubCategoriesDetailsSpeedBaseFragmentFragmentDoc}
${TrainSubCategoryShortSpeedFragmentFragmentDoc}`;

/**
 * __useTrainSubCategoriesDetailsSpeedHistoryListQuery__
 *
 * To run a query within a React component, call `useTrainSubCategoriesDetailsSpeedHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainSubCategoriesDetailsSpeedHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainSubCategoriesDetailsSpeedHistoryListQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTrainSubCategoriesDetailsSpeedHistoryListQuery(baseOptions: Apollo.QueryHookOptions<TrainSubCategoriesDetailsSpeedHistoryListQuery, TrainSubCategoriesDetailsSpeedHistoryListQueryVariables> & ({ variables: TrainSubCategoriesDetailsSpeedHistoryListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainSubCategoriesDetailsSpeedHistoryListQuery, TrainSubCategoriesDetailsSpeedHistoryListQueryVariables>(TrainSubCategoriesDetailsSpeedHistoryListDocument, options);
      }
export function useTrainSubCategoriesDetailsSpeedHistoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainSubCategoriesDetailsSpeedHistoryListQuery, TrainSubCategoriesDetailsSpeedHistoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainSubCategoriesDetailsSpeedHistoryListQuery, TrainSubCategoriesDetailsSpeedHistoryListQueryVariables>(TrainSubCategoriesDetailsSpeedHistoryListDocument, options);
        }
export function useTrainSubCategoriesDetailsSpeedHistoryListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainSubCategoriesDetailsSpeedHistoryListQuery, TrainSubCategoriesDetailsSpeedHistoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainSubCategoriesDetailsSpeedHistoryListQuery, TrainSubCategoriesDetailsSpeedHistoryListQueryVariables>(TrainSubCategoriesDetailsSpeedHistoryListDocument, options);
        }
export type TrainSubCategoriesDetailsSpeedHistoryListQueryHookResult = ReturnType<typeof useTrainSubCategoriesDetailsSpeedHistoryListQuery>;
export type TrainSubCategoriesDetailsSpeedHistoryListLazyQueryHookResult = ReturnType<typeof useTrainSubCategoriesDetailsSpeedHistoryListLazyQuery>;
export type TrainSubCategoriesDetailsSpeedHistoryListSuspenseQueryHookResult = ReturnType<typeof useTrainSubCategoriesDetailsSpeedHistoryListSuspenseQuery>;
export type TrainSubCategoriesDetailsSpeedHistoryListQueryResult = Apollo.QueryResult<TrainSubCategoriesDetailsSpeedHistoryListQuery, TrainSubCategoriesDetailsSpeedHistoryListQueryVariables>;
export const TrainSubCategoriesDetailsSpeedListDocument = /*#__PURE__*/ gql`
    query TrainSubCategoriesDetailsSpeedList($paginate: PaginatorArgsDto, $orderBy: [TrainSubCategoriesDetailsSpeedQueryResolver_List_SortingInputType!], $where: TrainSubCategoriesDetailsSpeedQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    trainSubCategoriesDetailsSpeed {
      list(where: $where, paginate: $paginate, order_by: $orderBy, range: $range) {
        totalCount
        items {
          ...TrainSubCategoriesDetailsSpeedBaseFragment
          train_sub_category {
            ...TrainSubCategoryShortSpeedFragment
          }
        }
      }
    }
  }
}
    ${TrainSubCategoriesDetailsSpeedBaseFragmentFragmentDoc}
${TrainSubCategoryShortSpeedFragmentFragmentDoc}`;

/**
 * __useTrainSubCategoriesDetailsSpeedListQuery__
 *
 * To run a query within a React component, call `useTrainSubCategoriesDetailsSpeedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainSubCategoriesDetailsSpeedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainSubCategoriesDetailsSpeedListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainSubCategoriesDetailsSpeedListQuery(baseOptions: Apollo.QueryHookOptions<TrainSubCategoriesDetailsSpeedListQuery, TrainSubCategoriesDetailsSpeedListQueryVariables> & ({ variables: TrainSubCategoriesDetailsSpeedListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainSubCategoriesDetailsSpeedListQuery, TrainSubCategoriesDetailsSpeedListQueryVariables>(TrainSubCategoriesDetailsSpeedListDocument, options);
      }
export function useTrainSubCategoriesDetailsSpeedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainSubCategoriesDetailsSpeedListQuery, TrainSubCategoriesDetailsSpeedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainSubCategoriesDetailsSpeedListQuery, TrainSubCategoriesDetailsSpeedListQueryVariables>(TrainSubCategoriesDetailsSpeedListDocument, options);
        }
export function useTrainSubCategoriesDetailsSpeedListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainSubCategoriesDetailsSpeedListQuery, TrainSubCategoriesDetailsSpeedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainSubCategoriesDetailsSpeedListQuery, TrainSubCategoriesDetailsSpeedListQueryVariables>(TrainSubCategoriesDetailsSpeedListDocument, options);
        }
export type TrainSubCategoriesDetailsSpeedListQueryHookResult = ReturnType<typeof useTrainSubCategoriesDetailsSpeedListQuery>;
export type TrainSubCategoriesDetailsSpeedListLazyQueryHookResult = ReturnType<typeof useTrainSubCategoriesDetailsSpeedListLazyQuery>;
export type TrainSubCategoriesDetailsSpeedListSuspenseQueryHookResult = ReturnType<typeof useTrainSubCategoriesDetailsSpeedListSuspenseQuery>;
export type TrainSubCategoriesDetailsSpeedListQueryResult = Apollo.QueryResult<TrainSubCategoriesDetailsSpeedListQuery, TrainSubCategoriesDetailsSpeedListQueryVariables>;
export const CreateTrainSubSpeedDocument = /*#__PURE__*/ gql`
    mutation createTrainSubSpeed($data: CreateTrainSubCategoriesDetailsSpeedDto!) {
  classifiers {
    trainSubCategoriesDetailsSpeed {
      create(data: $data) {
        ...TrainSubCategoriesDetailsSpeedBaseFragment
        train_sub_category {
          ...TrainSubCategoryShortSpeedFragment
        }
      }
    }
  }
}
    ${TrainSubCategoriesDetailsSpeedBaseFragmentFragmentDoc}
${TrainSubCategoryShortSpeedFragmentFragmentDoc}`;
export type CreateTrainSubSpeedMutationFn = Apollo.MutationFunction<CreateTrainSubSpeedMutation, CreateTrainSubSpeedMutationVariables>;

/**
 * __useCreateTrainSubSpeedMutation__
 *
 * To run a mutation, you first call `useCreateTrainSubSpeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrainSubSpeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrainSubSpeedMutation, { data, loading, error }] = useCreateTrainSubSpeedMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTrainSubSpeedMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrainSubSpeedMutation, CreateTrainSubSpeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrainSubSpeedMutation, CreateTrainSubSpeedMutationVariables>(CreateTrainSubSpeedDocument, options);
      }
export type CreateTrainSubSpeedMutationHookResult = ReturnType<typeof useCreateTrainSubSpeedMutation>;
export type CreateTrainSubSpeedMutationResult = Apollo.MutationResult<CreateTrainSubSpeedMutation>;
export type CreateTrainSubSpeedMutationOptions = Apollo.BaseMutationOptions<CreateTrainSubSpeedMutation, CreateTrainSubSpeedMutationVariables>;
export const UpdateTrainSubSpeedDocument = /*#__PURE__*/ gql`
    mutation updateTrainSubSpeed($data: UpdateTrainSubCategoriesDetailsSpeedDto!) {
  classifiers {
    trainSubCategoriesDetailsSpeed {
      update(data: $data) {
        ...TrainSubCategoriesDetailsSpeedBaseFragment
        train_sub_category {
          ...TrainSubCategoryShortSpeedFragment
        }
      }
    }
  }
}
    ${TrainSubCategoriesDetailsSpeedBaseFragmentFragmentDoc}
${TrainSubCategoryShortSpeedFragmentFragmentDoc}`;
export type UpdateTrainSubSpeedMutationFn = Apollo.MutationFunction<UpdateTrainSubSpeedMutation, UpdateTrainSubSpeedMutationVariables>;

/**
 * __useUpdateTrainSubSpeedMutation__
 *
 * To run a mutation, you first call `useUpdateTrainSubSpeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainSubSpeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainSubSpeedMutation, { data, loading, error }] = useUpdateTrainSubSpeedMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTrainSubSpeedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainSubSpeedMutation, UpdateTrainSubSpeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainSubSpeedMutation, UpdateTrainSubSpeedMutationVariables>(UpdateTrainSubSpeedDocument, options);
      }
export type UpdateTrainSubSpeedMutationHookResult = ReturnType<typeof useUpdateTrainSubSpeedMutation>;
export type UpdateTrainSubSpeedMutationResult = Apollo.MutationResult<UpdateTrainSubSpeedMutation>;
export type UpdateTrainSubSpeedMutationOptions = Apollo.BaseMutationOptions<UpdateTrainSubSpeedMutation, UpdateTrainSubSpeedMutationVariables>;
export const CreateTransportationPerformanceIndicatorDocument = /*#__PURE__*/ gql`
    mutation createTransportationPerformanceIndicator($input: CreateTransportationPerformanceIndicatorDto!) {
  classifiers {
    transportationPerformanceIndicator {
      create(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type CreateTransportationPerformanceIndicatorMutationFn = Apollo.MutationFunction<CreateTransportationPerformanceIndicatorMutation, CreateTransportationPerformanceIndicatorMutationVariables>;

/**
 * __useCreateTransportationPerformanceIndicatorMutation__
 *
 * To run a mutation, you first call `useCreateTransportationPerformanceIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransportationPerformanceIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransportationPerformanceIndicatorMutation, { data, loading, error }] = useCreateTransportationPerformanceIndicatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransportationPerformanceIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransportationPerformanceIndicatorMutation, CreateTransportationPerformanceIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransportationPerformanceIndicatorMutation, CreateTransportationPerformanceIndicatorMutationVariables>(CreateTransportationPerformanceIndicatorDocument, options);
      }
export type CreateTransportationPerformanceIndicatorMutationHookResult = ReturnType<typeof useCreateTransportationPerformanceIndicatorMutation>;
export type CreateTransportationPerformanceIndicatorMutationResult = Apollo.MutationResult<CreateTransportationPerformanceIndicatorMutation>;
export type CreateTransportationPerformanceIndicatorMutationOptions = Apollo.BaseMutationOptions<CreateTransportationPerformanceIndicatorMutation, CreateTransportationPerformanceIndicatorMutationVariables>;
export const TransportationPerformanceIndicatorsHistoryDocument = /*#__PURE__*/ gql`
    query transportationPerformanceIndicatorsHistory($entityId: Float!, $paginate: PaginatorArgsDto, $orderBy: [TransportationPerformanceIndicatorQueryResolver_History_SortingInputType!]) {
  classifiers {
    transportationPerformanceIndicator {
      history(entity_id: $entityId, paginate: $paginate, order_by: $orderBy) {
        totalCount
        items {
          start_at
          end_at
          ...TransportationPerformanceIndicatorsBaseFragment
        }
      }
    }
  }
}
    ${TransportationPerformanceIndicatorsBaseFragmentFragmentDoc}`;

/**
 * __useTransportationPerformanceIndicatorsHistoryQuery__
 *
 * To run a query within a React component, call `useTransportationPerformanceIndicatorsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransportationPerformanceIndicatorsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransportationPerformanceIndicatorsHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTransportationPerformanceIndicatorsHistoryQuery(baseOptions: Apollo.QueryHookOptions<TransportationPerformanceIndicatorsHistoryQuery, TransportationPerformanceIndicatorsHistoryQueryVariables> & ({ variables: TransportationPerformanceIndicatorsHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransportationPerformanceIndicatorsHistoryQuery, TransportationPerformanceIndicatorsHistoryQueryVariables>(TransportationPerformanceIndicatorsHistoryDocument, options);
      }
export function useTransportationPerformanceIndicatorsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransportationPerformanceIndicatorsHistoryQuery, TransportationPerformanceIndicatorsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransportationPerformanceIndicatorsHistoryQuery, TransportationPerformanceIndicatorsHistoryQueryVariables>(TransportationPerformanceIndicatorsHistoryDocument, options);
        }
export function useTransportationPerformanceIndicatorsHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransportationPerformanceIndicatorsHistoryQuery, TransportationPerformanceIndicatorsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransportationPerformanceIndicatorsHistoryQuery, TransportationPerformanceIndicatorsHistoryQueryVariables>(TransportationPerformanceIndicatorsHistoryDocument, options);
        }
export type TransportationPerformanceIndicatorsHistoryQueryHookResult = ReturnType<typeof useTransportationPerformanceIndicatorsHistoryQuery>;
export type TransportationPerformanceIndicatorsHistoryLazyQueryHookResult = ReturnType<typeof useTransportationPerformanceIndicatorsHistoryLazyQuery>;
export type TransportationPerformanceIndicatorsHistorySuspenseQueryHookResult = ReturnType<typeof useTransportationPerformanceIndicatorsHistorySuspenseQuery>;
export type TransportationPerformanceIndicatorsHistoryQueryResult = Apollo.QueryResult<TransportationPerformanceIndicatorsHistoryQuery, TransportationPerformanceIndicatorsHistoryQueryVariables>;
export const TransportationPerformanceIndicatorRangeByIdDocument = /*#__PURE__*/ gql`
    query transportationPerformanceIndicatorRangeById($entityId: Float!, $range: RangeInputDto!) {
  classifiers {
    transportationPerformanceIndicator {
      byEntityId(entityId: $entityId, range: $range) {
        last_version {
          ...RangeShortFragment
        }
      }
    }
  }
}
    ${RangeShortFragmentFragmentDoc}`;

/**
 * __useTransportationPerformanceIndicatorRangeByIdQuery__
 *
 * To run a query within a React component, call `useTransportationPerformanceIndicatorRangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransportationPerformanceIndicatorRangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransportationPerformanceIndicatorRangeByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTransportationPerformanceIndicatorRangeByIdQuery(baseOptions: Apollo.QueryHookOptions<TransportationPerformanceIndicatorRangeByIdQuery, TransportationPerformanceIndicatorRangeByIdQueryVariables> & ({ variables: TransportationPerformanceIndicatorRangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransportationPerformanceIndicatorRangeByIdQuery, TransportationPerformanceIndicatorRangeByIdQueryVariables>(TransportationPerformanceIndicatorRangeByIdDocument, options);
      }
export function useTransportationPerformanceIndicatorRangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransportationPerformanceIndicatorRangeByIdQuery, TransportationPerformanceIndicatorRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransportationPerformanceIndicatorRangeByIdQuery, TransportationPerformanceIndicatorRangeByIdQueryVariables>(TransportationPerformanceIndicatorRangeByIdDocument, options);
        }
export function useTransportationPerformanceIndicatorRangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransportationPerformanceIndicatorRangeByIdQuery, TransportationPerformanceIndicatorRangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransportationPerformanceIndicatorRangeByIdQuery, TransportationPerformanceIndicatorRangeByIdQueryVariables>(TransportationPerformanceIndicatorRangeByIdDocument, options);
        }
export type TransportationPerformanceIndicatorRangeByIdQueryHookResult = ReturnType<typeof useTransportationPerformanceIndicatorRangeByIdQuery>;
export type TransportationPerformanceIndicatorRangeByIdLazyQueryHookResult = ReturnType<typeof useTransportationPerformanceIndicatorRangeByIdLazyQuery>;
export type TransportationPerformanceIndicatorRangeByIdSuspenseQueryHookResult = ReturnType<typeof useTransportationPerformanceIndicatorRangeByIdSuspenseQuery>;
export type TransportationPerformanceIndicatorRangeByIdQueryResult = Apollo.QueryResult<TransportationPerformanceIndicatorRangeByIdQuery, TransportationPerformanceIndicatorRangeByIdQueryVariables>;
export const UpdateTransportationPerformanceIndicatorDocument = /*#__PURE__*/ gql`
    mutation updateTransportationPerformanceIndicator($input: UpdateTransportationPerformanceIndicatorDto!) {
  classifiers {
    transportationPerformanceIndicator {
      update(data: $input) {
        entity_id
      }
    }
  }
}
    `;
export type UpdateTransportationPerformanceIndicatorMutationFn = Apollo.MutationFunction<UpdateTransportationPerformanceIndicatorMutation, UpdateTransportationPerformanceIndicatorMutationVariables>;

/**
 * __useUpdateTransportationPerformanceIndicatorMutation__
 *
 * To run a mutation, you first call `useUpdateTransportationPerformanceIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransportationPerformanceIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransportationPerformanceIndicatorMutation, { data, loading, error }] = useUpdateTransportationPerformanceIndicatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransportationPerformanceIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransportationPerformanceIndicatorMutation, UpdateTransportationPerformanceIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransportationPerformanceIndicatorMutation, UpdateTransportationPerformanceIndicatorMutationVariables>(UpdateTransportationPerformanceIndicatorDocument, options);
      }
export type UpdateTransportationPerformanceIndicatorMutationHookResult = ReturnType<typeof useUpdateTransportationPerformanceIndicatorMutation>;
export type UpdateTransportationPerformanceIndicatorMutationResult = Apollo.MutationResult<UpdateTransportationPerformanceIndicatorMutation>;
export type UpdateTransportationPerformanceIndicatorMutationOptions = Apollo.BaseMutationOptions<UpdateTransportationPerformanceIndicatorMutation, UpdateTransportationPerformanceIndicatorMutationVariables>;
export const TransportationPerformanceIndicatorsDocument = /*#__PURE__*/ gql`
    query transportationPerformanceIndicators($paginate: PaginatorArgsDto, $orderBy: [TransportationPerformanceIndicatorQueryResolver_List_SortingInputType!], $where: TransportationPerformanceIndicatorQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    transportationPerformanceIndicator {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...TransportationPerformanceIndicatorsBaseFragment
        }
      }
    }
  }
}
    ${TransportationPerformanceIndicatorsBaseFragmentFragmentDoc}`;

/**
 * __useTransportationPerformanceIndicatorsQuery__
 *
 * To run a query within a React component, call `useTransportationPerformanceIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransportationPerformanceIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransportationPerformanceIndicatorsQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTransportationPerformanceIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<TransportationPerformanceIndicatorsQuery, TransportationPerformanceIndicatorsQueryVariables> & ({ variables: TransportationPerformanceIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransportationPerformanceIndicatorsQuery, TransportationPerformanceIndicatorsQueryVariables>(TransportationPerformanceIndicatorsDocument, options);
      }
export function useTransportationPerformanceIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransportationPerformanceIndicatorsQuery, TransportationPerformanceIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransportationPerformanceIndicatorsQuery, TransportationPerformanceIndicatorsQueryVariables>(TransportationPerformanceIndicatorsDocument, options);
        }
export function useTransportationPerformanceIndicatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransportationPerformanceIndicatorsQuery, TransportationPerformanceIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransportationPerformanceIndicatorsQuery, TransportationPerformanceIndicatorsQueryVariables>(TransportationPerformanceIndicatorsDocument, options);
        }
export type TransportationPerformanceIndicatorsQueryHookResult = ReturnType<typeof useTransportationPerformanceIndicatorsQuery>;
export type TransportationPerformanceIndicatorsLazyQueryHookResult = ReturnType<typeof useTransportationPerformanceIndicatorsLazyQuery>;
export type TransportationPerformanceIndicatorsSuspenseQueryHookResult = ReturnType<typeof useTransportationPerformanceIndicatorsSuspenseQuery>;
export type TransportationPerformanceIndicatorsQueryResult = Apollo.QueryResult<TransportationPerformanceIndicatorsQuery, TransportationPerformanceIndicatorsQueryVariables>;
export const HelpEducationListDocument = /*#__PURE__*/ gql`
    query helpEducationList($order_by: [CmsQueryResolver_EducationList_SortingInputType!], $paginate: PaginatorArgsDto, $where: CmsQueryResolver_EducationList_FilterInputType) {
  cms {
    education_list(order_by: $order_by, paginate: $paginate, where: $where) {
      items {
        ...EducationFragment
      }
      totalCount
    }
  }
}
    ${EducationFragmentFragmentDoc}`;

/**
 * __useHelpEducationListQuery__
 *
 * To run a query within a React component, call `useHelpEducationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpEducationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpEducationListQuery({
 *   variables: {
 *      order_by: // value for 'order_by'
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useHelpEducationListQuery(baseOptions?: Apollo.QueryHookOptions<HelpEducationListQuery, HelpEducationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HelpEducationListQuery, HelpEducationListQueryVariables>(HelpEducationListDocument, options);
      }
export function useHelpEducationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HelpEducationListQuery, HelpEducationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HelpEducationListQuery, HelpEducationListQueryVariables>(HelpEducationListDocument, options);
        }
export function useHelpEducationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HelpEducationListQuery, HelpEducationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HelpEducationListQuery, HelpEducationListQueryVariables>(HelpEducationListDocument, options);
        }
export type HelpEducationListQueryHookResult = ReturnType<typeof useHelpEducationListQuery>;
export type HelpEducationListLazyQueryHookResult = ReturnType<typeof useHelpEducationListLazyQuery>;
export type HelpEducationListSuspenseQueryHookResult = ReturnType<typeof useHelpEducationListSuspenseQuery>;
export type HelpEducationListQueryResult = Apollo.QueryResult<HelpEducationListQuery, HelpEducationListQueryVariables>;
export const HelpFaqListDocument = /*#__PURE__*/ gql`
    query helpFAQList($order_by: [CmsQueryResolver_FaqList_SortingInputType!], $paginate: PaginatorArgsDto, $where: CmsQueryResolver_FaqList_FilterInputType) {
  cms {
    faq_list(order_by: $order_by, paginate: $paginate, where: $where) {
      items {
        ...FAQFragment
      }
      totalCount
    }
  }
}
    ${FaqFragmentFragmentDoc}`;

/**
 * __useHelpFaqListQuery__
 *
 * To run a query within a React component, call `useHelpFaqListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpFaqListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpFaqListQuery({
 *   variables: {
 *      order_by: // value for 'order_by'
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useHelpFaqListQuery(baseOptions?: Apollo.QueryHookOptions<HelpFaqListQuery, HelpFaqListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HelpFaqListQuery, HelpFaqListQueryVariables>(HelpFaqListDocument, options);
      }
export function useHelpFaqListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HelpFaqListQuery, HelpFaqListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HelpFaqListQuery, HelpFaqListQueryVariables>(HelpFaqListDocument, options);
        }
export function useHelpFaqListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HelpFaqListQuery, HelpFaqListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HelpFaqListQuery, HelpFaqListQueryVariables>(HelpFaqListDocument, options);
        }
export type HelpFaqListQueryHookResult = ReturnType<typeof useHelpFaqListQuery>;
export type HelpFaqListLazyQueryHookResult = ReturnType<typeof useHelpFaqListLazyQuery>;
export type HelpFaqListSuspenseQueryHookResult = ReturnType<typeof useHelpFaqListSuspenseQuery>;
export type HelpFaqListQueryResult = Apollo.QueryResult<HelpFaqListQuery, HelpFaqListQueryVariables>;
export const AddCarriagesByDateDocument = /*#__PURE__*/ gql`
    mutation addCarriagesByDate($data: AddCarriagesByDateDto!) {
  indicators {
    addCarriagesByDate(data: $data)
  }
}
    `;
export type AddCarriagesByDateMutationFn = Apollo.MutationFunction<AddCarriagesByDateMutation, AddCarriagesByDateMutationVariables>;

/**
 * __useAddCarriagesByDateMutation__
 *
 * To run a mutation, you first call `useAddCarriagesByDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCarriagesByDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCarriagesByDateMutation, { data, loading, error }] = useAddCarriagesByDateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddCarriagesByDateMutation(baseOptions?: Apollo.MutationHookOptions<AddCarriagesByDateMutation, AddCarriagesByDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCarriagesByDateMutation, AddCarriagesByDateMutationVariables>(AddCarriagesByDateDocument, options);
      }
export type AddCarriagesByDateMutationHookResult = ReturnType<typeof useAddCarriagesByDateMutation>;
export type AddCarriagesByDateMutationResult = Apollo.MutationResult<AddCarriagesByDateMutation>;
export type AddCarriagesByDateMutationOptions = Apollo.BaseMutationOptions<AddCarriagesByDateMutation, AddCarriagesByDateMutationVariables>;
export const FinalIndicatorsExportCalculationsDocument = /*#__PURE__*/ gql`
    mutation finalIndicatorsExportCalculations($data: CarriageGroupIndicatorsFinalCalculationRequestDto!, $where: IndicatorsMutationResolver_ExportIndicatorsFinalCalculations_FilterInputType) {
  indicators {
    export_final_calculations(data: $data, where: $where)
  }
}
    `;
export type FinalIndicatorsExportCalculationsMutationFn = Apollo.MutationFunction<FinalIndicatorsExportCalculationsMutation, FinalIndicatorsExportCalculationsMutationVariables>;

/**
 * __useFinalIndicatorsExportCalculationsMutation__
 *
 * To run a mutation, you first call `useFinalIndicatorsExportCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalIndicatorsExportCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalIndicatorsExportCalculationsMutation, { data, loading, error }] = useFinalIndicatorsExportCalculationsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFinalIndicatorsExportCalculationsMutation(baseOptions?: Apollo.MutationHookOptions<FinalIndicatorsExportCalculationsMutation, FinalIndicatorsExportCalculationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalIndicatorsExportCalculationsMutation, FinalIndicatorsExportCalculationsMutationVariables>(FinalIndicatorsExportCalculationsDocument, options);
      }
export type FinalIndicatorsExportCalculationsMutationHookResult = ReturnType<typeof useFinalIndicatorsExportCalculationsMutation>;
export type FinalIndicatorsExportCalculationsMutationResult = Apollo.MutationResult<FinalIndicatorsExportCalculationsMutation>;
export type FinalIndicatorsExportCalculationsMutationOptions = Apollo.BaseMutationOptions<FinalIndicatorsExportCalculationsMutation, FinalIndicatorsExportCalculationsMutationVariables>;
export const FinalIndicatorsTrainListDocument = /*#__PURE__*/ gql`
    query finalIndicatorsTrainList($paginate: PaginatorArgsDto, $orderBy: [TrainQueryResolver_List_SortingInputType!], $where: TrainQueryResolver_List_FilterInputType) {
  train {
    list(paginate: $paginate, order_by: $orderBy, where: $where) {
      items {
        ...TrainShortFragment
        from_station {
          ...StationShortFragment
        }
        to_station {
          ...StationShortFragment
        }
        start_at
        end_at
        status
        rolling_stock_types
      }
    }
  }
}
    ${TrainShortFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;

/**
 * __useFinalIndicatorsTrainListQuery__
 *
 * To run a query within a React component, call `useFinalIndicatorsTrainListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinalIndicatorsTrainListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinalIndicatorsTrainListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFinalIndicatorsTrainListQuery(baseOptions?: Apollo.QueryHookOptions<FinalIndicatorsTrainListQuery, FinalIndicatorsTrainListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinalIndicatorsTrainListQuery, FinalIndicatorsTrainListQueryVariables>(FinalIndicatorsTrainListDocument, options);
      }
export function useFinalIndicatorsTrainListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinalIndicatorsTrainListQuery, FinalIndicatorsTrainListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinalIndicatorsTrainListQuery, FinalIndicatorsTrainListQueryVariables>(FinalIndicatorsTrainListDocument, options);
        }
export function useFinalIndicatorsTrainListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FinalIndicatorsTrainListQuery, FinalIndicatorsTrainListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinalIndicatorsTrainListQuery, FinalIndicatorsTrainListQueryVariables>(FinalIndicatorsTrainListDocument, options);
        }
export type FinalIndicatorsTrainListQueryHookResult = ReturnType<typeof useFinalIndicatorsTrainListQuery>;
export type FinalIndicatorsTrainListLazyQueryHookResult = ReturnType<typeof useFinalIndicatorsTrainListLazyQuery>;
export type FinalIndicatorsTrainListSuspenseQueryHookResult = ReturnType<typeof useFinalIndicatorsTrainListSuspenseQuery>;
export type FinalIndicatorsTrainListQueryResult = Apollo.QueryResult<FinalIndicatorsTrainListQuery, FinalIndicatorsTrainListQueryVariables>;
export const IndicatorsCarriageGroupListDocument = /*#__PURE__*/ gql`
    query indicatorsCarriageGroupList($paginate: PaginatorArgsDto, $orderBy: [IndicatorsQueryResolver_ListView_SortingInputType!], $where: IndicatorsQueryResolver_ListView_FilterInputType) {
  indicators {
    list_groups(paginate: $paginate, order_by: $orderBy, where: $where) {
      totalCount
      items {
        id
        name
        branch_id
        passenger_carriers_id
        railway_administration_id
        structural_subdivision_id
        rolling_stock_type
        step_status
        status
        train_numbers
        from_stations
        to_stations
        carriage_dimension_ids
        train_ids
        dimensions
        periodicity
        regulatory_sector_ids
        version
        start_at
        branch {
          entity_id
          name
          short_name
          railways {
            entity_id
            name
            short_name
            code
            railway_administration {
              entity_id
              name
              short_name
              code
            }
          }
        }
        passenger_carrier {
          entity_id
          name
          short_name
          code
        }
        railway_administration {
          entity_id
          name
          short_name
          code
        }
      }
    }
  }
}
    `;

/**
 * __useIndicatorsCarriageGroupListQuery__
 *
 * To run a query within a React component, call `useIndicatorsCarriageGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorsCarriageGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorsCarriageGroupListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useIndicatorsCarriageGroupListQuery(baseOptions?: Apollo.QueryHookOptions<IndicatorsCarriageGroupListQuery, IndicatorsCarriageGroupListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorsCarriageGroupListQuery, IndicatorsCarriageGroupListQueryVariables>(IndicatorsCarriageGroupListDocument, options);
      }
export function useIndicatorsCarriageGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorsCarriageGroupListQuery, IndicatorsCarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorsCarriageGroupListQuery, IndicatorsCarriageGroupListQueryVariables>(IndicatorsCarriageGroupListDocument, options);
        }
export function useIndicatorsCarriageGroupListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndicatorsCarriageGroupListQuery, IndicatorsCarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndicatorsCarriageGroupListQuery, IndicatorsCarriageGroupListQueryVariables>(IndicatorsCarriageGroupListDocument, options);
        }
export type IndicatorsCarriageGroupListQueryHookResult = ReturnType<typeof useIndicatorsCarriageGroupListQuery>;
export type IndicatorsCarriageGroupListLazyQueryHookResult = ReturnType<typeof useIndicatorsCarriageGroupListLazyQuery>;
export type IndicatorsCarriageGroupListSuspenseQueryHookResult = ReturnType<typeof useIndicatorsCarriageGroupListSuspenseQuery>;
export type IndicatorsCarriageGroupListQueryResult = Apollo.QueryResult<IndicatorsCarriageGroupListQuery, IndicatorsCarriageGroupListQueryVariables>;
export const IndicatorsMvpsCompanyAffiliationListDocument = /*#__PURE__*/ gql`
    query indicatorsMvpsCompanyAffiliationList($paginate: PaginatorArgsDto, $orderBy: [MvpsCompanyAffiliationQueryResolver_List_SortingInputType!], $where: MvpsCompanyAffiliationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    mvpsCompanyAffiliation {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...MvpsCompanyAffiliationShortFragment
        }
      }
    }
  }
}
    ${MvpsCompanyAffiliationShortFragmentFragmentDoc}`;

/**
 * __useIndicatorsMvpsCompanyAffiliationListQuery__
 *
 * To run a query within a React component, call `useIndicatorsMvpsCompanyAffiliationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorsMvpsCompanyAffiliationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorsMvpsCompanyAffiliationListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useIndicatorsMvpsCompanyAffiliationListQuery(baseOptions: Apollo.QueryHookOptions<IndicatorsMvpsCompanyAffiliationListQuery, IndicatorsMvpsCompanyAffiliationListQueryVariables> & ({ variables: IndicatorsMvpsCompanyAffiliationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorsMvpsCompanyAffiliationListQuery, IndicatorsMvpsCompanyAffiliationListQueryVariables>(IndicatorsMvpsCompanyAffiliationListDocument, options);
      }
export function useIndicatorsMvpsCompanyAffiliationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorsMvpsCompanyAffiliationListQuery, IndicatorsMvpsCompanyAffiliationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorsMvpsCompanyAffiliationListQuery, IndicatorsMvpsCompanyAffiliationListQueryVariables>(IndicatorsMvpsCompanyAffiliationListDocument, options);
        }
export function useIndicatorsMvpsCompanyAffiliationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndicatorsMvpsCompanyAffiliationListQuery, IndicatorsMvpsCompanyAffiliationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndicatorsMvpsCompanyAffiliationListQuery, IndicatorsMvpsCompanyAffiliationListQueryVariables>(IndicatorsMvpsCompanyAffiliationListDocument, options);
        }
export type IndicatorsMvpsCompanyAffiliationListQueryHookResult = ReturnType<typeof useIndicatorsMvpsCompanyAffiliationListQuery>;
export type IndicatorsMvpsCompanyAffiliationListLazyQueryHookResult = ReturnType<typeof useIndicatorsMvpsCompanyAffiliationListLazyQuery>;
export type IndicatorsMvpsCompanyAffiliationListSuspenseQueryHookResult = ReturnType<typeof useIndicatorsMvpsCompanyAffiliationListSuspenseQuery>;
export type IndicatorsMvpsCompanyAffiliationListQueryResult = Apollo.QueryResult<IndicatorsMvpsCompanyAffiliationListQuery, IndicatorsMvpsCompanyAffiliationListQueryVariables>;
export const RequiredParkExportNpsCarriageDimensionListDocument = /*#__PURE__*/ gql`
    query requiredParkExportNpsCarriageDimensionList($range: RangeInputDto!) {
  classifiers {
    npsCarriageDimension {
      list(paginate: {per_page: 30, page: 0}, order_by: [], where: {}, range: $range) {
        totalCount
        items {
          entity_id
          carriage_dimension
          description
        }
      }
    }
  }
}
    `;

/**
 * __useRequiredParkExportNpsCarriageDimensionListQuery__
 *
 * To run a query within a React component, call `useRequiredParkExportNpsCarriageDimensionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequiredParkExportNpsCarriageDimensionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequiredParkExportNpsCarriageDimensionListQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useRequiredParkExportNpsCarriageDimensionListQuery(baseOptions: Apollo.QueryHookOptions<RequiredParkExportNpsCarriageDimensionListQuery, RequiredParkExportNpsCarriageDimensionListQueryVariables> & ({ variables: RequiredParkExportNpsCarriageDimensionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequiredParkExportNpsCarriageDimensionListQuery, RequiredParkExportNpsCarriageDimensionListQueryVariables>(RequiredParkExportNpsCarriageDimensionListDocument, options);
      }
export function useRequiredParkExportNpsCarriageDimensionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequiredParkExportNpsCarriageDimensionListQuery, RequiredParkExportNpsCarriageDimensionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequiredParkExportNpsCarriageDimensionListQuery, RequiredParkExportNpsCarriageDimensionListQueryVariables>(RequiredParkExportNpsCarriageDimensionListDocument, options);
        }
export function useRequiredParkExportNpsCarriageDimensionListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RequiredParkExportNpsCarriageDimensionListQuery, RequiredParkExportNpsCarriageDimensionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequiredParkExportNpsCarriageDimensionListQuery, RequiredParkExportNpsCarriageDimensionListQueryVariables>(RequiredParkExportNpsCarriageDimensionListDocument, options);
        }
export type RequiredParkExportNpsCarriageDimensionListQueryHookResult = ReturnType<typeof useRequiredParkExportNpsCarriageDimensionListQuery>;
export type RequiredParkExportNpsCarriageDimensionListLazyQueryHookResult = ReturnType<typeof useRequiredParkExportNpsCarriageDimensionListLazyQuery>;
export type RequiredParkExportNpsCarriageDimensionListSuspenseQueryHookResult = ReturnType<typeof useRequiredParkExportNpsCarriageDimensionListSuspenseQuery>;
export type RequiredParkExportNpsCarriageDimensionListQueryResult = Apollo.QueryResult<RequiredParkExportNpsCarriageDimensionListQuery, RequiredParkExportNpsCarriageDimensionListQueryVariables>;
export const IndicatorsParkRequiredDocument = /*#__PURE__*/ gql`
    query indicatorsParkRequired($data: DatesRequestDto!, $where: IndicatorsQueryResolver_ParkRequired_FilterInputType) {
  indicators {
    parkRequired(data: $data, where: $where) {
      schema {
        branch
        item {
          carriage_type
          quantity
        }
        total
      }
      schemaTotal {
        branch
        total
        item {
          carriage_type
          quantity
        }
      }
      park {
        branch
        total
        item {
          carriage_type
          quantity
        }
      }
      parkTotal {
        branch
        total
        item {
          carriage_type
          quantity
        }
      }
    }
  }
}
    `;

/**
 * __useIndicatorsParkRequiredQuery__
 *
 * To run a query within a React component, call `useIndicatorsParkRequiredQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorsParkRequiredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorsParkRequiredQuery({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useIndicatorsParkRequiredQuery(baseOptions: Apollo.QueryHookOptions<IndicatorsParkRequiredQuery, IndicatorsParkRequiredQueryVariables> & ({ variables: IndicatorsParkRequiredQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorsParkRequiredQuery, IndicatorsParkRequiredQueryVariables>(IndicatorsParkRequiredDocument, options);
      }
export function useIndicatorsParkRequiredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorsParkRequiredQuery, IndicatorsParkRequiredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorsParkRequiredQuery, IndicatorsParkRequiredQueryVariables>(IndicatorsParkRequiredDocument, options);
        }
export function useIndicatorsParkRequiredSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndicatorsParkRequiredQuery, IndicatorsParkRequiredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndicatorsParkRequiredQuery, IndicatorsParkRequiredQueryVariables>(IndicatorsParkRequiredDocument, options);
        }
export type IndicatorsParkRequiredQueryHookResult = ReturnType<typeof useIndicatorsParkRequiredQuery>;
export type IndicatorsParkRequiredLazyQueryHookResult = ReturnType<typeof useIndicatorsParkRequiredLazyQuery>;
export type IndicatorsParkRequiredSuspenseQueryHookResult = ReturnType<typeof useIndicatorsParkRequiredSuspenseQuery>;
export type IndicatorsParkRequiredQueryResult = Apollo.QueryResult<IndicatorsParkRequiredQuery, IndicatorsParkRequiredQueryVariables>;
export const IndicatorsStructuralSubdivisionListDocument = /*#__PURE__*/ gql`
    query indicatorsStructuralSubdivisionList($paginate: PaginatorArgsDto, $orderBy: [StructuralSubdivisionQueryResolver_List_SortingInputType!], $where: StructuralSubdivisionQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    structuralSubdivision {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          entity_id
          short_name
          branch {
            entity_id
            name
            short_name
            railways {
              entity_id
              name
              short_name
              code
              railway_administration {
                entity_id
                name
                short_name
                code
              }
            }
          }
          station {
            id
            full_name
            railway_id
            express_code
            esr_code
            comment
            is_board_or_disembark
            is_electricity_type
            is_traction_type
            is_change_locomotive
            is_change_locomotive_team
            is_water_supply
            is_fuel_supply
            is_eco_toilets
            is_waste_collection
            is_border_control
            is_electric_speakers_380V
            is_electric_speakers_3000V
            is_route_forming
            is_service_not_train_route
            is_maneuver_work
            railway {
              id
              name
              short_name
              code
              railway_administration {
                id
                name
                short_name
                code
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useIndicatorsStructuralSubdivisionListQuery__
 *
 * To run a query within a React component, call `useIndicatorsStructuralSubdivisionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorsStructuralSubdivisionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorsStructuralSubdivisionListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useIndicatorsStructuralSubdivisionListQuery(baseOptions: Apollo.QueryHookOptions<IndicatorsStructuralSubdivisionListQuery, IndicatorsStructuralSubdivisionListQueryVariables> & ({ variables: IndicatorsStructuralSubdivisionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorsStructuralSubdivisionListQuery, IndicatorsStructuralSubdivisionListQueryVariables>(IndicatorsStructuralSubdivisionListDocument, options);
      }
export function useIndicatorsStructuralSubdivisionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorsStructuralSubdivisionListQuery, IndicatorsStructuralSubdivisionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorsStructuralSubdivisionListQuery, IndicatorsStructuralSubdivisionListQueryVariables>(IndicatorsStructuralSubdivisionListDocument, options);
        }
export function useIndicatorsStructuralSubdivisionListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndicatorsStructuralSubdivisionListQuery, IndicatorsStructuralSubdivisionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndicatorsStructuralSubdivisionListQuery, IndicatorsStructuralSubdivisionListQueryVariables>(IndicatorsStructuralSubdivisionListDocument, options);
        }
export type IndicatorsStructuralSubdivisionListQueryHookResult = ReturnType<typeof useIndicatorsStructuralSubdivisionListQuery>;
export type IndicatorsStructuralSubdivisionListLazyQueryHookResult = ReturnType<typeof useIndicatorsStructuralSubdivisionListLazyQuery>;
export type IndicatorsStructuralSubdivisionListSuspenseQueryHookResult = ReturnType<typeof useIndicatorsStructuralSubdivisionListSuspenseQuery>;
export type IndicatorsStructuralSubdivisionListQueryResult = Apollo.QueryResult<IndicatorsStructuralSubdivisionListQuery, IndicatorsStructuralSubdivisionListQueryVariables>;
export const RequiredParkExportDocument = /*#__PURE__*/ gql`
    mutation requiredParkExport($where: IndicatorsMutationResolver_ExportParkRequired_FilterInputType!) {
  indicators {
    export_park_required(where: $where)
  }
}
    `;
export type RequiredParkExportMutationFn = Apollo.MutationFunction<RequiredParkExportMutation, RequiredParkExportMutationVariables>;

/**
 * __useRequiredParkExportMutation__
 *
 * To run a mutation, you first call `useRequiredParkExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequiredParkExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requiredParkExportMutation, { data, loading, error }] = useRequiredParkExportMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRequiredParkExportMutation(baseOptions?: Apollo.MutationHookOptions<RequiredParkExportMutation, RequiredParkExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequiredParkExportMutation, RequiredParkExportMutationVariables>(RequiredParkExportDocument, options);
      }
export type RequiredParkExportMutationHookResult = ReturnType<typeof useRequiredParkExportMutation>;
export type RequiredParkExportMutationResult = Apollo.MutationResult<RequiredParkExportMutation>;
export type RequiredParkExportMutationOptions = Apollo.BaseMutationOptions<RequiredParkExportMutation, RequiredParkExportMutationVariables>;
export const UpdateForecastIndicatorDocument = /*#__PURE__*/ gql`
    mutation UpdateForecastIndicator($data: UpdateForecastIndicatorDto!) {
  indicators {
    updateForecastIndicator(data: $data)
  }
}
    `;
export type UpdateForecastIndicatorMutationFn = Apollo.MutationFunction<UpdateForecastIndicatorMutation, UpdateForecastIndicatorMutationVariables>;

/**
 * __useUpdateForecastIndicatorMutation__
 *
 * To run a mutation, you first call `useUpdateForecastIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForecastIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForecastIndicatorMutation, { data, loading, error }] = useUpdateForecastIndicatorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateForecastIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateForecastIndicatorMutation, UpdateForecastIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateForecastIndicatorMutation, UpdateForecastIndicatorMutationVariables>(UpdateForecastIndicatorDocument, options);
      }
export type UpdateForecastIndicatorMutationHookResult = ReturnType<typeof useUpdateForecastIndicatorMutation>;
export type UpdateForecastIndicatorMutationResult = Apollo.MutationResult<UpdateForecastIndicatorMutation>;
export type UpdateForecastIndicatorMutationOptions = Apollo.BaseMutationOptions<UpdateForecastIndicatorMutation, UpdateForecastIndicatorMutationVariables>;
export const CarriageGroupIndicatorsDocument = /*#__PURE__*/ gql`
    query carriageGroupIndicators($carriageGroupId: Float!) {
  indicators {
    carriage_group_indicators(carriage_group_id: $carriageGroupId) {
      carriage_group {
        name
        periodicities {
          id
        }
        turnovers {
          id
        }
        gdp {
          start_at
          end_at
        }
        railway_administration {
          entity_id
          name
          short_name
        }
        passenger_carrier {
          entity_id
          short_name
        }
        branch {
          name
          short_name
        }
        structural_subdivision {
          ... on MvpsCompanyAffiliationDto {
            entity_id
            mvps_owner
          }
          ... on StructuralSubdivisionDto {
            entity_id
            short_name
            station {
              full_name
            }
          }
        }
        rolling_stock_type
        train_quantities {
          quantity
        }
        turnaround_times {
          turn_around_time
        }
        step_status
      }
      carriage_group_routes {
        route
        train_number
        distance
        sign
        route_distance
        station_train_from {
          entity_id
          full_name
        }
        station_train_to {
          entity_id
          full_name
        }
        station_carriage_group_from {
          entity_id
          full_name
        }
        station_carriage_group_to {
          entity_id
          full_name
        }
      }
      full_distance
      carriage_type_params_count {
        carriage_type
        quantity
      }
    }
  }
}
    `;

/**
 * __useCarriageGroupIndicatorsQuery__
 *
 * To run a query within a React component, call `useCarriageGroupIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageGroupIndicatorsQuery({
 *   variables: {
 *      carriageGroupId: // value for 'carriageGroupId'
 *   },
 * });
 */
export function useCarriageGroupIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<CarriageGroupIndicatorsQuery, CarriageGroupIndicatorsQueryVariables> & ({ variables: CarriageGroupIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageGroupIndicatorsQuery, CarriageGroupIndicatorsQueryVariables>(CarriageGroupIndicatorsDocument, options);
      }
export function useCarriageGroupIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageGroupIndicatorsQuery, CarriageGroupIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageGroupIndicatorsQuery, CarriageGroupIndicatorsQueryVariables>(CarriageGroupIndicatorsDocument, options);
        }
export function useCarriageGroupIndicatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageGroupIndicatorsQuery, CarriageGroupIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageGroupIndicatorsQuery, CarriageGroupIndicatorsQueryVariables>(CarriageGroupIndicatorsDocument, options);
        }
export type CarriageGroupIndicatorsQueryHookResult = ReturnType<typeof useCarriageGroupIndicatorsQuery>;
export type CarriageGroupIndicatorsLazyQueryHookResult = ReturnType<typeof useCarriageGroupIndicatorsLazyQuery>;
export type CarriageGroupIndicatorsSuspenseQueryHookResult = ReturnType<typeof useCarriageGroupIndicatorsSuspenseQuery>;
export type CarriageGroupIndicatorsQueryResult = Apollo.QueryResult<CarriageGroupIndicatorsQuery, CarriageGroupIndicatorsQueryVariables>;
export const IndicatorsByTrainDocument = /*#__PURE__*/ gql`
    query indicatorsByTrain($data: CarriageGroupIndicatorsByTrainRequestDto!) {
  indicators {
    indicators_by_train(data: $data) {
      schema {
        items {
          seat_type
          carriage_type
          carriage_quantity
          seats_quantity
          seats_for_sale
          average_capacity
          carriage_quantity_req
        }
        carriage_quantity_passenger
        carriage_quantity_total
        seats_quantity_passenger
        seats_quantity_total
        seats_for_sale_passenger
        seats_for_sale_total
        average_capacity_passenger
        average_capacity_total
        carriage_quantity_req_passenger
        carriage_quantity_req_total
      }
      park_required {
        ... on NpsParkRequiredDto {
          ...NpsParkRequiredBaseFragment
        }
        ... on MvpsParkRequiredDto {
          ...MvpsParkRequiredBaseFragment
        }
      }
      items {
        train_info {
          train_number
          distance
          departures_quantity
        }
        carriage_departures_quantity {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_departures_quantity {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        carriage_schema_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_schema_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
        }
        carriage_required_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_required_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
        }
      }
      total {
        train_info {
          distance
          departures_quantity
        }
        carriage_departures_quantity {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_departures_quantity {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        carriage_schema_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_schema_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
        }
        carriage_required_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_required_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
        }
      }
    }
  }
}
    ${NpsParkRequiredBaseFragmentFragmentDoc}
${MvpsParkRequiredBaseFragmentFragmentDoc}`;

/**
 * __useIndicatorsByTrainQuery__
 *
 * To run a query within a React component, call `useIndicatorsByTrainQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorsByTrainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorsByTrainQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useIndicatorsByTrainQuery(baseOptions: Apollo.QueryHookOptions<IndicatorsByTrainQuery, IndicatorsByTrainQueryVariables> & ({ variables: IndicatorsByTrainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorsByTrainQuery, IndicatorsByTrainQueryVariables>(IndicatorsByTrainDocument, options);
      }
export function useIndicatorsByTrainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorsByTrainQuery, IndicatorsByTrainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorsByTrainQuery, IndicatorsByTrainQueryVariables>(IndicatorsByTrainDocument, options);
        }
export function useIndicatorsByTrainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndicatorsByTrainQuery, IndicatorsByTrainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndicatorsByTrainQuery, IndicatorsByTrainQueryVariables>(IndicatorsByTrainDocument, options);
        }
export type IndicatorsByTrainQueryHookResult = ReturnType<typeof useIndicatorsByTrainQuery>;
export type IndicatorsByTrainLazyQueryHookResult = ReturnType<typeof useIndicatorsByTrainLazyQuery>;
export type IndicatorsByTrainSuspenseQueryHookResult = ReturnType<typeof useIndicatorsByTrainSuspenseQuery>;
export type IndicatorsByTrainQueryResult = Apollo.QueryResult<IndicatorsByTrainQuery, IndicatorsByTrainQueryVariables>;
export const CgFinalCalculationMvpsCompanyAffiliationListDocument = /*#__PURE__*/ gql`
    query CGFinalCalculationMvpsCompanyAffiliationList($paginate: PaginatorArgsDto, $orderBy: [MvpsCompanyAffiliationQueryResolver_List_SortingInputType!], $where: MvpsCompanyAffiliationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    mvpsCompanyAffiliation {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...MvpsCompanyAffiliationShortFragment
        }
      }
    }
  }
}
    ${MvpsCompanyAffiliationShortFragmentFragmentDoc}`;

/**
 * __useCgFinalCalculationMvpsCompanyAffiliationListQuery__
 *
 * To run a query within a React component, call `useCgFinalCalculationMvpsCompanyAffiliationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCgFinalCalculationMvpsCompanyAffiliationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCgFinalCalculationMvpsCompanyAffiliationListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCgFinalCalculationMvpsCompanyAffiliationListQuery(baseOptions: Apollo.QueryHookOptions<CgFinalCalculationMvpsCompanyAffiliationListQuery, CgFinalCalculationMvpsCompanyAffiliationListQueryVariables> & ({ variables: CgFinalCalculationMvpsCompanyAffiliationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CgFinalCalculationMvpsCompanyAffiliationListQuery, CgFinalCalculationMvpsCompanyAffiliationListQueryVariables>(CgFinalCalculationMvpsCompanyAffiliationListDocument, options);
      }
export function useCgFinalCalculationMvpsCompanyAffiliationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CgFinalCalculationMvpsCompanyAffiliationListQuery, CgFinalCalculationMvpsCompanyAffiliationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CgFinalCalculationMvpsCompanyAffiliationListQuery, CgFinalCalculationMvpsCompanyAffiliationListQueryVariables>(CgFinalCalculationMvpsCompanyAffiliationListDocument, options);
        }
export function useCgFinalCalculationMvpsCompanyAffiliationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CgFinalCalculationMvpsCompanyAffiliationListQuery, CgFinalCalculationMvpsCompanyAffiliationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CgFinalCalculationMvpsCompanyAffiliationListQuery, CgFinalCalculationMvpsCompanyAffiliationListQueryVariables>(CgFinalCalculationMvpsCompanyAffiliationListDocument, options);
        }
export type CgFinalCalculationMvpsCompanyAffiliationListQueryHookResult = ReturnType<typeof useCgFinalCalculationMvpsCompanyAffiliationListQuery>;
export type CgFinalCalculationMvpsCompanyAffiliationListLazyQueryHookResult = ReturnType<typeof useCgFinalCalculationMvpsCompanyAffiliationListLazyQuery>;
export type CgFinalCalculationMvpsCompanyAffiliationListSuspenseQueryHookResult = ReturnType<typeof useCgFinalCalculationMvpsCompanyAffiliationListSuspenseQuery>;
export type CgFinalCalculationMvpsCompanyAffiliationListQueryResult = Apollo.QueryResult<CgFinalCalculationMvpsCompanyAffiliationListQuery, CgFinalCalculationMvpsCompanyAffiliationListQueryVariables>;
export const CgFinalCalculationStructuralSubdivisionListDocument = /*#__PURE__*/ gql`
    query CGFinalCalculationStructuralSubdivisionList($paginate: PaginatorArgsDto, $orderBy: [StructuralSubdivisionQueryResolver_List_SortingInputType!], $where: StructuralSubdivisionQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    structuralSubdivision {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...StructuralSubdivisionBaseFragment
          branch {
            ...BranchShortFragment
            railways {
              ...RailwayShortFragment
              railway_administration {
                ...RailwayAdministrationBaseFragment
              }
            }
          }
          station {
            ...StationBaseFragment
            railway {
              ...RailwayBaseFragment
              railway_administration {
                ...RailwayAdministrationBaseFragment
              }
            }
          }
        }
      }
    }
  }
}
    ${StructuralSubdivisionBaseFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${RailwayShortFragmentFragmentDoc}
${RailwayAdministrationBaseFragmentFragmentDoc}
${StationBaseFragmentFragmentDoc}
${RailwayBaseFragmentFragmentDoc}`;

/**
 * __useCgFinalCalculationStructuralSubdivisionListQuery__
 *
 * To run a query within a React component, call `useCgFinalCalculationStructuralSubdivisionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCgFinalCalculationStructuralSubdivisionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCgFinalCalculationStructuralSubdivisionListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCgFinalCalculationStructuralSubdivisionListQuery(baseOptions: Apollo.QueryHookOptions<CgFinalCalculationStructuralSubdivisionListQuery, CgFinalCalculationStructuralSubdivisionListQueryVariables> & ({ variables: CgFinalCalculationStructuralSubdivisionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CgFinalCalculationStructuralSubdivisionListQuery, CgFinalCalculationStructuralSubdivisionListQueryVariables>(CgFinalCalculationStructuralSubdivisionListDocument, options);
      }
export function useCgFinalCalculationStructuralSubdivisionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CgFinalCalculationStructuralSubdivisionListQuery, CgFinalCalculationStructuralSubdivisionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CgFinalCalculationStructuralSubdivisionListQuery, CgFinalCalculationStructuralSubdivisionListQueryVariables>(CgFinalCalculationStructuralSubdivisionListDocument, options);
        }
export function useCgFinalCalculationStructuralSubdivisionListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CgFinalCalculationStructuralSubdivisionListQuery, CgFinalCalculationStructuralSubdivisionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CgFinalCalculationStructuralSubdivisionListQuery, CgFinalCalculationStructuralSubdivisionListQueryVariables>(CgFinalCalculationStructuralSubdivisionListDocument, options);
        }
export type CgFinalCalculationStructuralSubdivisionListQueryHookResult = ReturnType<typeof useCgFinalCalculationStructuralSubdivisionListQuery>;
export type CgFinalCalculationStructuralSubdivisionListLazyQueryHookResult = ReturnType<typeof useCgFinalCalculationStructuralSubdivisionListLazyQuery>;
export type CgFinalCalculationStructuralSubdivisionListSuspenseQueryHookResult = ReturnType<typeof useCgFinalCalculationStructuralSubdivisionListSuspenseQuery>;
export type CgFinalCalculationStructuralSubdivisionListQueryResult = Apollo.QueryResult<CgFinalCalculationStructuralSubdivisionListQuery, CgFinalCalculationStructuralSubdivisionListQueryVariables>;
export const CarriageGroupFinalCalculationDocument = /*#__PURE__*/ gql`
    query carriageGroupFinalCalculation($data: CarriageGroupIndicatorsFinalCalculationRequestDto!, $where: IndicatorsQueryResolver_CarriageGroupFinalCalculation_FilterInputType) {
  indicators {
    carriage_group_final_calculation(data: $data, where: $where) {
      items {
        ...CarriageGroupIndicatorsFinalCalculationItemBaseFragment
      }
      total {
        ...CarriageGroupIndicatorsFinalCalculationTotalItemBaseFragment
      }
      park_required {
        ... on CarriageGroupIndicatorsFinalCalculationNpsParkRequiredDto {
          other {
            ...IndicatorsByTrainCarriagesBaseFragment
          }
          passenger {
            ...IndicatorsByTrainCarriagesBaseFragment
          }
          total
          total_other
          total_passenger
        }
        ... on CarriageGroupIndicatorsFinalCalculationMvpsParkRequiredDto {
          items {
            ...MvpsParkRequiredBaseFragment
          }
          total
        }
      }
    }
  }
}
    ${CarriageGroupIndicatorsFinalCalculationItemBaseFragmentFragmentDoc}
${CarriageGroupIndicatorsFinalCalculationTotalItemBaseFragmentFragmentDoc}
${IndicatorsByTrainCarriagesBaseFragmentFragmentDoc}
${MvpsParkRequiredBaseFragmentFragmentDoc}`;

/**
 * __useCarriageGroupFinalCalculationQuery__
 *
 * To run a query within a React component, call `useCarriageGroupFinalCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupFinalCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageGroupFinalCalculationQuery({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCarriageGroupFinalCalculationQuery(baseOptions: Apollo.QueryHookOptions<CarriageGroupFinalCalculationQuery, CarriageGroupFinalCalculationQueryVariables> & ({ variables: CarriageGroupFinalCalculationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageGroupFinalCalculationQuery, CarriageGroupFinalCalculationQueryVariables>(CarriageGroupFinalCalculationDocument, options);
      }
export function useCarriageGroupFinalCalculationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageGroupFinalCalculationQuery, CarriageGroupFinalCalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageGroupFinalCalculationQuery, CarriageGroupFinalCalculationQueryVariables>(CarriageGroupFinalCalculationDocument, options);
        }
export function useCarriageGroupFinalCalculationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageGroupFinalCalculationQuery, CarriageGroupFinalCalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageGroupFinalCalculationQuery, CarriageGroupFinalCalculationQueryVariables>(CarriageGroupFinalCalculationDocument, options);
        }
export type CarriageGroupFinalCalculationQueryHookResult = ReturnType<typeof useCarriageGroupFinalCalculationQuery>;
export type CarriageGroupFinalCalculationLazyQueryHookResult = ReturnType<typeof useCarriageGroupFinalCalculationLazyQuery>;
export type CarriageGroupFinalCalculationSuspenseQueryHookResult = ReturnType<typeof useCarriageGroupFinalCalculationSuspenseQuery>;
export type CarriageGroupFinalCalculationQueryResult = Apollo.QueryResult<CarriageGroupFinalCalculationQuery, CarriageGroupFinalCalculationQueryVariables>;
export const IndicatorsExportCarriageGroupFinalCalculationsDocument = /*#__PURE__*/ gql`
    mutation indicatorsExportCarriageGroupFinalCalculations($data: CarriageGroupIndicatorsFinalCalculationRequestDto!, $where: IndicatorsMutationResolver_ExportCarriageGroupFinalCalculations_FilterInputType) {
  indicators {
    export_carriage_group_final_calculations(data: $data, where: $where)
  }
}
    `;
export type IndicatorsExportCarriageGroupFinalCalculationsMutationFn = Apollo.MutationFunction<IndicatorsExportCarriageGroupFinalCalculationsMutation, IndicatorsExportCarriageGroupFinalCalculationsMutationVariables>;

/**
 * __useIndicatorsExportCarriageGroupFinalCalculationsMutation__
 *
 * To run a mutation, you first call `useIndicatorsExportCarriageGroupFinalCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndicatorsExportCarriageGroupFinalCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indicatorsExportCarriageGroupFinalCalculationsMutation, { data, loading, error }] = useIndicatorsExportCarriageGroupFinalCalculationsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useIndicatorsExportCarriageGroupFinalCalculationsMutation(baseOptions?: Apollo.MutationHookOptions<IndicatorsExportCarriageGroupFinalCalculationsMutation, IndicatorsExportCarriageGroupFinalCalculationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IndicatorsExportCarriageGroupFinalCalculationsMutation, IndicatorsExportCarriageGroupFinalCalculationsMutationVariables>(IndicatorsExportCarriageGroupFinalCalculationsDocument, options);
      }
export type IndicatorsExportCarriageGroupFinalCalculationsMutationHookResult = ReturnType<typeof useIndicatorsExportCarriageGroupFinalCalculationsMutation>;
export type IndicatorsExportCarriageGroupFinalCalculationsMutationResult = Apollo.MutationResult<IndicatorsExportCarriageGroupFinalCalculationsMutation>;
export type IndicatorsExportCarriageGroupFinalCalculationsMutationOptions = Apollo.BaseMutationOptions<IndicatorsExportCarriageGroupFinalCalculationsMutation, IndicatorsExportCarriageGroupFinalCalculationsMutationVariables>;
export const InfrastructureCalculationsRequestDocument = /*#__PURE__*/ gql`
    mutation infrastructureCalculationsRequest($where: IndicatorsMutationResolver_InfrastructureCalculations_FilterInputType) {
  indicators {
    infrastructure_calculations(where: $where)
  }
}
    `;
export type InfrastructureCalculationsRequestMutationFn = Apollo.MutationFunction<InfrastructureCalculationsRequestMutation, InfrastructureCalculationsRequestMutationVariables>;

/**
 * __useInfrastructureCalculationsRequestMutation__
 *
 * To run a mutation, you first call `useInfrastructureCalculationsRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureCalculationsRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [infrastructureCalculationsRequestMutation, { data, loading, error }] = useInfrastructureCalculationsRequestMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInfrastructureCalculationsRequestMutation(baseOptions?: Apollo.MutationHookOptions<InfrastructureCalculationsRequestMutation, InfrastructureCalculationsRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfrastructureCalculationsRequestMutation, InfrastructureCalculationsRequestMutationVariables>(InfrastructureCalculationsRequestDocument, options);
      }
export type InfrastructureCalculationsRequestMutationHookResult = ReturnType<typeof useInfrastructureCalculationsRequestMutation>;
export type InfrastructureCalculationsRequestMutationResult = Apollo.MutationResult<InfrastructureCalculationsRequestMutation>;
export type InfrastructureCalculationsRequestMutationOptions = Apollo.BaseMutationOptions<InfrastructureCalculationsRequestMutation, InfrastructureCalculationsRequestMutationVariables>;
export const InfrastructureCalculationsResponseDocument = /*#__PURE__*/ gql`
    query infrastructureCalculationsResponse($key: String!) {
  indicators {
    infrastructure_calculations_response(key: $key) {
      categories {
        category
        trains {
          groupSign
          stationFrom
          stationTo
          countryDistance
          carriagesPassengerDeregSv
          carriagesPassengerDeregK
          carriagesPassengerRegP
          carriagesPassengerRegO
          carriagesPassengerTotal
          carriagesPostal
          carriagesBaggage
          carriagesOther
          carriagesOtherTotal
          carriagesTotal
          distance
          tripsQuantity
          carriagesDistancePassengerDeregSv
          carriagesDistancePassengerDeregK
          carriagesDistancePassengerRegP
          carriagesDistancePassengerRegO
          carriagesDistancePassengerTotal
          carriagesDistancePostal
          carriagesDistanceBaggage
          carriagesDistanceOther
          carriagesDistanceOtherTotal
          carriagesDistanceTotal
          s1CarriagesPassengerDeregSv
          s1CarriagesPassengerDeregK
          s1CarriagesPassengerRegP
          s1CarriagesPassengerRegO
          s1CarriagesPassengerTotal
          s1CarriagesPostal
          s1CarriagesBaggage
          s1CarriagesOther
          s1CarriagesOtherTotal
          s1CarriagesOtherTotalWithoutNds
          s2CarriagesPassengerDeregSv
          s2CarriagesPassengerDeregK
          s2CarriagesPassengerRegP
          s2CarriagesPassengerRegO
          s2CarriagesPassengerTotal
          s2CarriagesPostal
          s2CarriagesBaggage
          s2CarriagesOther
          s2CarriagesOtherTotal
          s2CarriagesOtherTotalWithoutNds
          s3CarriagesPassengerDeregSv
          s3CarriagesPassengerDeregK
          s3CarriagesPassengerRegP
          s3CarriagesPassengerRegO
          s3CarriagesPostal
          s3CarriagesBaggage
          s3CarriagesOther
          s3CarriagesOtherTotalWithoutNds
          totalCarriagesPassengerDeregSv
          totalCarriagesPassengerDeregK
          totalCarriagesPassengerRegP
          totalCarriagesPassengerRegO
          totalCarriagesPassengerTotal
          totalCarriagesPostal
          totalCarriagesBaggage
          totalCarriagesOther
          totalCarriagesOtherTotal
          totalCarriagesTotalWithoutNds
          nds
          totalWithNds
          trainNumber
          rows {
            groupSign
            stationFrom
            stationTo
            countryDistance
            carriagesPassengerDeregSv
            carriagesPassengerDeregK
            carriagesPassengerRegP
            carriagesPassengerRegO
            carriagesPassengerTotal
            carriagesPostal
            carriagesBaggage
            carriagesOther
            carriagesOtherTotal
            carriagesTotal
            distance
            tripsQuantity
            carriagesDistancePassengerDeregSv
            carriagesDistancePassengerDeregK
            carriagesDistancePassengerRegP
            carriagesDistancePassengerRegO
            carriagesDistancePassengerTotal
            carriagesDistancePostal
            carriagesDistanceBaggage
            carriagesDistanceOther
            carriagesDistanceOtherTotal
            carriagesDistanceTotal
            s1CarriagesPassengerDeregSv
            s1CarriagesPassengerDeregK
            s1CarriagesPassengerRegP
            s1CarriagesPassengerRegO
            s1CarriagesPassengerTotal
            s1CarriagesPostal
            s1CarriagesBaggage
            s1CarriagesOther
            s1CarriagesOtherTotal
            s1CarriagesOtherTotalWithoutNds
            s2CarriagesPassengerDeregSv
            s2CarriagesPassengerDeregK
            s2CarriagesPassengerRegP
            s2CarriagesPassengerRegO
            s2CarriagesPassengerTotal
            s2CarriagesPostal
            s2CarriagesBaggage
            s2CarriagesOther
            s2CarriagesOtherTotal
            s2CarriagesOtherTotalWithoutNds
            s3CarriagesPassengerDeregSv
            s3CarriagesPassengerDeregK
            s3CarriagesPassengerRegP
            s3CarriagesPassengerRegO
            s3CarriagesPostal
            s3CarriagesBaggage
            s3CarriagesOther
            s3CarriagesOtherTotalWithoutNds
            totalCarriagesPassengerDeregSv
            totalCarriagesPassengerDeregK
            totalCarriagesPassengerRegP
            totalCarriagesPassengerRegO
            totalCarriagesPassengerTotal
            totalCarriagesPostal
            totalCarriagesBaggage
            totalCarriagesOther
            totalCarriagesOtherTotal
            totalCarriagesTotalWithoutNds
            nds
            totalWithNds
          }
        }
        total {
          distance
          tripsQuantity
          carriagesDistancePassengerDeregSv
          carriagesDistancePassengerDeregK
          carriagesDistancePassengerRegP
          carriagesDistancePassengerRegO
          carriagesDistancePassengerTotal
          carriagesDistancePostal
          carriagesDistanceBaggage
          carriagesDistanceOther
          carriagesDistanceOtherTotal
          carriagesDistanceTotal
          s1CarriagesPassengerDeregSv
          s1CarriagesPassengerDeregK
          s1CarriagesPassengerRegP
          s1CarriagesPassengerRegO
          s1CarriagesPassengerTotal
          s1CarriagesPostal
          s1CarriagesBaggage
          s1CarriagesOther
          s1CarriagesOtherTotal
          s1CarriagesOtherTotalWithoutNds
          s2CarriagesPassengerDeregSv
          s2CarriagesPassengerDeregK
          s2CarriagesPassengerRegP
          s2CarriagesPassengerRegO
          s2CarriagesPassengerTotal
          s2CarriagesPostal
          s2CarriagesBaggage
          s2CarriagesOther
          s2CarriagesOtherTotal
          s2CarriagesOtherTotalWithoutNds
          s3CarriagesPassengerDeregSv
          s3CarriagesPassengerDeregK
          s3CarriagesPassengerRegP
          s3CarriagesPassengerRegO
          s3CarriagesPostal
          s3CarriagesBaggage
          s3CarriagesOther
          s3CarriagesOtherTotalWithoutNds
          totalCarriagesPassengerDeregSv
          totalCarriagesPassengerDeregK
          totalCarriagesPassengerRegP
          totalCarriagesPassengerRegO
          totalCarriagesPassengerTotal
          totalCarriagesPostal
          totalCarriagesBaggage
          totalCarriagesOther
          totalCarriagesOtherTotal
          totalCarriagesTotalWithoutNds
          nds
          totalWithNds
        }
        totalCountry {
          distance
          tripsQuantity
          carriagesDistancePassengerDeregSv
          carriagesDistancePassengerDeregK
          carriagesDistancePassengerRegP
          carriagesDistancePassengerRegO
          carriagesDistancePassengerTotal
          carriagesDistancePostal
          carriagesDistanceBaggage
          carriagesDistanceOther
          carriagesDistanceOtherTotal
          carriagesDistanceTotal
          s1CarriagesPassengerDeregSv
          s1CarriagesPassengerDeregK
          s1CarriagesPassengerRegP
          s1CarriagesPassengerRegO
          s1CarriagesPassengerTotal
          s1CarriagesPostal
          s1CarriagesBaggage
          s1CarriagesOther
          s1CarriagesOtherTotal
          s1CarriagesOtherTotalWithoutNds
          s2CarriagesPassengerDeregSv
          s2CarriagesPassengerDeregK
          s2CarriagesPassengerRegP
          s2CarriagesPassengerRegO
          s2CarriagesPassengerTotal
          s2CarriagesPostal
          s2CarriagesBaggage
          s2CarriagesOther
          s2CarriagesOtherTotal
          s2CarriagesOtherTotalWithoutNds
          s3CarriagesPassengerDeregSv
          s3CarriagesPassengerDeregK
          s3CarriagesPassengerRegP
          s3CarriagesPassengerRegO
          s3CarriagesPostal
          s3CarriagesBaggage
          s3CarriagesOther
          s3CarriagesOtherTotalWithoutNds
          totalCarriagesPassengerDeregSv
          totalCarriagesPassengerDeregK
          totalCarriagesPassengerRegP
          totalCarriagesPassengerRegO
          totalCarriagesPassengerTotal
          totalCarriagesPostal
          totalCarriagesBaggage
          totalCarriagesOther
          totalCarriagesOtherTotal
          totalCarriagesTotalWithoutNds
          nds
          totalWithNds
        }
      }
      total {
        distance
        tripsQuantity
        carriagesDistancePassengerDeregSv
        carriagesDistancePassengerDeregK
        carriagesDistancePassengerRegP
        carriagesDistancePassengerRegO
        carriagesDistancePassengerTotal
        carriagesDistancePostal
        carriagesDistanceBaggage
        carriagesDistanceOther
        carriagesDistanceOtherTotal
        carriagesDistanceTotal
        s1CarriagesPassengerDeregSv
        s1CarriagesPassengerDeregK
        s1CarriagesPassengerRegP
        s1CarriagesPassengerRegO
        s1CarriagesPassengerTotal
        s1CarriagesPostal
        s1CarriagesBaggage
        s1CarriagesOther
        s1CarriagesOtherTotal
        s1CarriagesOtherTotalWithoutNds
        s2CarriagesPassengerDeregSv
        s2CarriagesPassengerDeregK
        s2CarriagesPassengerRegP
        s2CarriagesPassengerRegO
        s2CarriagesPassengerTotal
        s2CarriagesPostal
        s2CarriagesBaggage
        s2CarriagesOther
        s2CarriagesOtherTotal
        s2CarriagesOtherTotalWithoutNds
        s3CarriagesPassengerDeregSv
        s3CarriagesPassengerDeregK
        s3CarriagesPassengerRegP
        s3CarriagesPassengerRegO
        s3CarriagesPostal
        s3CarriagesBaggage
        s3CarriagesOther
        s3CarriagesOtherTotalWithoutNds
        totalCarriagesPassengerDeregSv
        totalCarriagesPassengerDeregK
        totalCarriagesPassengerRegP
        totalCarriagesPassengerRegO
        totalCarriagesPassengerTotal
        totalCarriagesPostal
        totalCarriagesBaggage
        totalCarriagesOther
        totalCarriagesOtherTotal
        totalCarriagesTotalWithoutNds
        nds
        totalWithNds
      }
    }
  }
}
    `;

/**
 * __useInfrastructureCalculationsResponseQuery__
 *
 * To run a query within a React component, call `useInfrastructureCalculationsResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureCalculationsResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureCalculationsResponseQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useInfrastructureCalculationsResponseQuery(baseOptions: Apollo.QueryHookOptions<InfrastructureCalculationsResponseQuery, InfrastructureCalculationsResponseQueryVariables> & ({ variables: InfrastructureCalculationsResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureCalculationsResponseQuery, InfrastructureCalculationsResponseQueryVariables>(InfrastructureCalculationsResponseDocument, options);
      }
export function useInfrastructureCalculationsResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureCalculationsResponseQuery, InfrastructureCalculationsResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureCalculationsResponseQuery, InfrastructureCalculationsResponseQueryVariables>(InfrastructureCalculationsResponseDocument, options);
        }
export function useInfrastructureCalculationsResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfrastructureCalculationsResponseQuery, InfrastructureCalculationsResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureCalculationsResponseQuery, InfrastructureCalculationsResponseQueryVariables>(InfrastructureCalculationsResponseDocument, options);
        }
export type InfrastructureCalculationsResponseQueryHookResult = ReturnType<typeof useInfrastructureCalculationsResponseQuery>;
export type InfrastructureCalculationsResponseLazyQueryHookResult = ReturnType<typeof useInfrastructureCalculationsResponseLazyQuery>;
export type InfrastructureCalculationsResponseSuspenseQueryHookResult = ReturnType<typeof useInfrastructureCalculationsResponseSuspenseQuery>;
export type InfrastructureCalculationsResponseQueryResult = Apollo.QueryResult<InfrastructureCalculationsResponseQuery, InfrastructureCalculationsResponseQueryVariables>;
export const InfrastructureExportIndicatorsDocument = /*#__PURE__*/ gql`
    mutation infrastructureExportIndicators($where: IndicatorsMutationResolver_ExportInfrastructureIndicatorsCalculations_FilterInputType) {
  indicators {
    export_infrastructure_indicators(where: $where)
  }
}
    `;
export type InfrastructureExportIndicatorsMutationFn = Apollo.MutationFunction<InfrastructureExportIndicatorsMutation, InfrastructureExportIndicatorsMutationVariables>;

/**
 * __useInfrastructureExportIndicatorsMutation__
 *
 * To run a mutation, you first call `useInfrastructureExportIndicatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureExportIndicatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [infrastructureExportIndicatorsMutation, { data, loading, error }] = useInfrastructureExportIndicatorsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInfrastructureExportIndicatorsMutation(baseOptions?: Apollo.MutationHookOptions<InfrastructureExportIndicatorsMutation, InfrastructureExportIndicatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfrastructureExportIndicatorsMutation, InfrastructureExportIndicatorsMutationVariables>(InfrastructureExportIndicatorsDocument, options);
      }
export type InfrastructureExportIndicatorsMutationHookResult = ReturnType<typeof useInfrastructureExportIndicatorsMutation>;
export type InfrastructureExportIndicatorsMutationResult = Apollo.MutationResult<InfrastructureExportIndicatorsMutation>;
export type InfrastructureExportIndicatorsMutationOptions = Apollo.BaseMutationOptions<InfrastructureExportIndicatorsMutation, InfrastructureExportIndicatorsMutationVariables>;
export const LocomotiveExportCalculationsDocument = /*#__PURE__*/ gql`
    mutation locomotiveExportCalculations($data: ExportTrainIndicatorsListDto!, $where: TrainMutationResolver_ExportTrainIndicatorsList_FilterInputType) {
  train {
    exportTrainIndicatorsList(data: $data, where: $where)
  }
}
    `;
export type LocomotiveExportCalculationsMutationFn = Apollo.MutationFunction<LocomotiveExportCalculationsMutation, LocomotiveExportCalculationsMutationVariables>;

/**
 * __useLocomotiveExportCalculationsMutation__
 *
 * To run a mutation, you first call `useLocomotiveExportCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveExportCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locomotiveExportCalculationsMutation, { data, loading, error }] = useLocomotiveExportCalculationsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLocomotiveExportCalculationsMutation(baseOptions?: Apollo.MutationHookOptions<LocomotiveExportCalculationsMutation, LocomotiveExportCalculationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocomotiveExportCalculationsMutation, LocomotiveExportCalculationsMutationVariables>(LocomotiveExportCalculationsDocument, options);
      }
export type LocomotiveExportCalculationsMutationHookResult = ReturnType<typeof useLocomotiveExportCalculationsMutation>;
export type LocomotiveExportCalculationsMutationResult = Apollo.MutationResult<LocomotiveExportCalculationsMutation>;
export type LocomotiveExportCalculationsMutationOptions = Apollo.BaseMutationOptions<LocomotiveExportCalculationsMutation, LocomotiveExportCalculationsMutationVariables>;
export const LocomotiveTrainListIndicatorsDocument = /*#__PURE__*/ gql`
    query locomotiveTrainListIndicators($data: ExportTrainIndicatorsListDto!, $where: TrainQueryResolver_ListIndicators_FilterInputType, $paginate: PaginatorArgsDto, $orderBy: [TrainQueryResolver_ListIndicators_SortingInputType!]) {
  train {
    listIndicators(
      data: $data
      where: $where
      paginate: $paginate
      order_by: $orderBy
    ) {
      totalCount
      items {
        period {
          from_date
          gas_price
          locomotive_rent_cost
          locomotive_team_cost
          locomotive_tech_service_price
          power_consumption
          power_price
          prep_time
          trip_cost
          trip_time
          gas_consumption
          schemas {
            gas_price
            gas_consumption
            locomotive_areas {
              distance
              gas_consumption
              gas_price
              locomotive_rent_cost
              locomotive_team_cost
              locomotive_tech_service_price
              power_consumption
              power_price
              prep_time
              section_quantity
              trip_cost
              trip_time
            }
            locomotive_rent_cost
            locomotive_team_cost
            locomotive_tech_service_price
            power_consumption
            power_price
            prep_time
            schema_id
            trip_cost
            trip_time
            distance
            trips_from_period
          }
          to_date
          trips_from_period
        }
        current {
          train_number
          trip_time
          prep_time
          trip_cost
          locomotive_rent_cost
          locomotive_tech_service_price
          locomotive_team_cost
          gas_price
          gas_consumption
          power_price
          power_consumption
          distance
          from_date
          to_date
          schemas {
            locomotive_areas {
              from_station {
                full_name
              }
              to_station {
                full_name
              }
              locomotive_series {
                series
                index
                section_quantity
                locomotive_traction_type {
                  name
                  short_name
                }
              }
              section_quantity
              trip_time
              prep_time
              trip_cost
              locomotive_rent_cost
              locomotive_tech_service_price
              locomotive_team_cost
              gas_price
              gas_consumption
              power_price
              power_consumption
              distance
              from_date
              to_date
              traction_directorate {
                name
                short_name
              }
              traction_directorate_team {
                name
                short_name
              }
            }
            locomotive_series {
              series
              section_quantity
              locomotive_traction_type_id
              price_rent
              locomotive_traction_type {
                name
                short_name
              }
            }
            traction_directorates {
              name
              short_name
            }
            traction_directorate_teams {
              name
              short_name
            }
          }
          from_station {
            full_name
          }
          to_station {
            full_name
          }
          railway_administration {
            name
            short_name
            code
          }
          branch {
            name
            short_name
          }
          passenger_carrier {
            name
            short_name
          }
          locomotive_series {
            series
            section_quantity
            locomotive_traction_type_id
            price_rent
            locomotive_traction_type {
              name
              short_name
            }
          }
          traction_directorates {
            name
            short_name
          }
          traction_directorate_teams {
            name
            short_name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLocomotiveTrainListIndicatorsQuery__
 *
 * To run a query within a React component, call `useLocomotiveTrainListIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveTrainListIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveTrainListIndicatorsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLocomotiveTrainListIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveTrainListIndicatorsQuery, LocomotiveTrainListIndicatorsQueryVariables> & ({ variables: LocomotiveTrainListIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveTrainListIndicatorsQuery, LocomotiveTrainListIndicatorsQueryVariables>(LocomotiveTrainListIndicatorsDocument, options);
      }
export function useLocomotiveTrainListIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveTrainListIndicatorsQuery, LocomotiveTrainListIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveTrainListIndicatorsQuery, LocomotiveTrainListIndicatorsQueryVariables>(LocomotiveTrainListIndicatorsDocument, options);
        }
export function useLocomotiveTrainListIndicatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveTrainListIndicatorsQuery, LocomotiveTrainListIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveTrainListIndicatorsQuery, LocomotiveTrainListIndicatorsQueryVariables>(LocomotiveTrainListIndicatorsDocument, options);
        }
export type LocomotiveTrainListIndicatorsQueryHookResult = ReturnType<typeof useLocomotiveTrainListIndicatorsQuery>;
export type LocomotiveTrainListIndicatorsLazyQueryHookResult = ReturnType<typeof useLocomotiveTrainListIndicatorsLazyQuery>;
export type LocomotiveTrainListIndicatorsSuspenseQueryHookResult = ReturnType<typeof useLocomotiveTrainListIndicatorsSuspenseQuery>;
export type LocomotiveTrainListIndicatorsQueryResult = Apollo.QueryResult<LocomotiveTrainListIndicatorsQuery, LocomotiveTrainListIndicatorsQueryVariables>;
export const LocomotiveExportSeriesIndicatorsDocument = /*#__PURE__*/ gql`
    mutation locomotiveExportSeriesIndicators($data: ExportTrainIndicatorsListDto!, $where: TrainMutationResolver_ExportLocomotiveSeriesIndicators_FilterInputType) {
  train {
    exportLocomotiveSeriesIndicators(data: $data, where: $where)
  }
}
    `;
export type LocomotiveExportSeriesIndicatorsMutationFn = Apollo.MutationFunction<LocomotiveExportSeriesIndicatorsMutation, LocomotiveExportSeriesIndicatorsMutationVariables>;

/**
 * __useLocomotiveExportSeriesIndicatorsMutation__
 *
 * To run a mutation, you first call `useLocomotiveExportSeriesIndicatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveExportSeriesIndicatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locomotiveExportSeriesIndicatorsMutation, { data, loading, error }] = useLocomotiveExportSeriesIndicatorsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLocomotiveExportSeriesIndicatorsMutation(baseOptions?: Apollo.MutationHookOptions<LocomotiveExportSeriesIndicatorsMutation, LocomotiveExportSeriesIndicatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocomotiveExportSeriesIndicatorsMutation, LocomotiveExportSeriesIndicatorsMutationVariables>(LocomotiveExportSeriesIndicatorsDocument, options);
      }
export type LocomotiveExportSeriesIndicatorsMutationHookResult = ReturnType<typeof useLocomotiveExportSeriesIndicatorsMutation>;
export type LocomotiveExportSeriesIndicatorsMutationResult = Apollo.MutationResult<LocomotiveExportSeriesIndicatorsMutation>;
export type LocomotiveExportSeriesIndicatorsMutationOptions = Apollo.BaseMutationOptions<LocomotiveExportSeriesIndicatorsMutation, LocomotiveExportSeriesIndicatorsMutationVariables>;
export const LococmotiveTractionDirectoratesIndicatorsDocument = /*#__PURE__*/ gql`
    mutation lococmotiveTractionDirectoratesIndicators($data: ExportTrainIndicatorsListDto!, $where: TrainMutationResolver_ExportLococmotiveTractionDirectoratesIndicators_FilterInputType) {
  train {
    exportLococmotiveTractionDirectoratesIndicators(data: $data, where: $where)
  }
}
    `;
export type LococmotiveTractionDirectoratesIndicatorsMutationFn = Apollo.MutationFunction<LococmotiveTractionDirectoratesIndicatorsMutation, LococmotiveTractionDirectoratesIndicatorsMutationVariables>;

/**
 * __useLococmotiveTractionDirectoratesIndicatorsMutation__
 *
 * To run a mutation, you first call `useLococmotiveTractionDirectoratesIndicatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLococmotiveTractionDirectoratesIndicatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lococmotiveTractionDirectoratesIndicatorsMutation, { data, loading, error }] = useLococmotiveTractionDirectoratesIndicatorsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLococmotiveTractionDirectoratesIndicatorsMutation(baseOptions?: Apollo.MutationHookOptions<LococmotiveTractionDirectoratesIndicatorsMutation, LococmotiveTractionDirectoratesIndicatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LococmotiveTractionDirectoratesIndicatorsMutation, LococmotiveTractionDirectoratesIndicatorsMutationVariables>(LococmotiveTractionDirectoratesIndicatorsDocument, options);
      }
export type LococmotiveTractionDirectoratesIndicatorsMutationHookResult = ReturnType<typeof useLococmotiveTractionDirectoratesIndicatorsMutation>;
export type LococmotiveTractionDirectoratesIndicatorsMutationResult = Apollo.MutationResult<LococmotiveTractionDirectoratesIndicatorsMutation>;
export type LococmotiveTractionDirectoratesIndicatorsMutationOptions = Apollo.BaseMutationOptions<LococmotiveTractionDirectoratesIndicatorsMutation, LococmotiveTractionDirectoratesIndicatorsMutationVariables>;
export const MvpsCalculationsRequestDocument = /*#__PURE__*/ gql`
    mutation mvpsCalculationsRequest($paginate: PaginatorArgsDto, $where: IndicatorsMutationResolver_MvpsCalculationsRequest_FilterInputType) {
  indicators {
    mvps_calculations_request(where: $where, paginate: $paginate)
  }
}
    `;
export type MvpsCalculationsRequestMutationFn = Apollo.MutationFunction<MvpsCalculationsRequestMutation, MvpsCalculationsRequestMutationVariables>;

/**
 * __useMvpsCalculationsRequestMutation__
 *
 * To run a mutation, you first call `useMvpsCalculationsRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMvpsCalculationsRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mvpsCalculationsRequestMutation, { data, loading, error }] = useMvpsCalculationsRequestMutation({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMvpsCalculationsRequestMutation(baseOptions?: Apollo.MutationHookOptions<MvpsCalculationsRequestMutation, MvpsCalculationsRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MvpsCalculationsRequestMutation, MvpsCalculationsRequestMutationVariables>(MvpsCalculationsRequestDocument, options);
      }
export type MvpsCalculationsRequestMutationHookResult = ReturnType<typeof useMvpsCalculationsRequestMutation>;
export type MvpsCalculationsRequestMutationResult = Apollo.MutationResult<MvpsCalculationsRequestMutation>;
export type MvpsCalculationsRequestMutationOptions = Apollo.BaseMutationOptions<MvpsCalculationsRequestMutation, MvpsCalculationsRequestMutationVariables>;
export const MvpsCalculationsResponseDocument = /*#__PURE__*/ gql`
    query mvpsCalculationsResponse($key: String!) {
  indicators {
    mvps_calculations_response(key: $key) {
      items {
        carriage_group_id
        branch
        railway_administration
        passenger_carrier_russian_railway
        carriages_quantity
        train_quantity
        company_affiliation
        mvps_section_type
        rent_total
        to_tr_total
        control_total
        total
        rows {
          train_number
          stations
          distance
          route_duration
          to_tr
          control
        }
      }
      totalCount
    }
  }
}
    `;

/**
 * __useMvpsCalculationsResponseQuery__
 *
 * To run a query within a React component, call `useMvpsCalculationsResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsCalculationsResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsCalculationsResponseQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useMvpsCalculationsResponseQuery(baseOptions: Apollo.QueryHookOptions<MvpsCalculationsResponseQuery, MvpsCalculationsResponseQueryVariables> & ({ variables: MvpsCalculationsResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsCalculationsResponseQuery, MvpsCalculationsResponseQueryVariables>(MvpsCalculationsResponseDocument, options);
      }
export function useMvpsCalculationsResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsCalculationsResponseQuery, MvpsCalculationsResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsCalculationsResponseQuery, MvpsCalculationsResponseQueryVariables>(MvpsCalculationsResponseDocument, options);
        }
export function useMvpsCalculationsResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsCalculationsResponseQuery, MvpsCalculationsResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsCalculationsResponseQuery, MvpsCalculationsResponseQueryVariables>(MvpsCalculationsResponseDocument, options);
        }
export type MvpsCalculationsResponseQueryHookResult = ReturnType<typeof useMvpsCalculationsResponseQuery>;
export type MvpsCalculationsResponseLazyQueryHookResult = ReturnType<typeof useMvpsCalculationsResponseLazyQuery>;
export type MvpsCalculationsResponseSuspenseQueryHookResult = ReturnType<typeof useMvpsCalculationsResponseSuspenseQuery>;
export type MvpsCalculationsResponseQueryResult = Apollo.QueryResult<MvpsCalculationsResponseQuery, MvpsCalculationsResponseQueryVariables>;
export const MvpsExportCalculationsDocument = /*#__PURE__*/ gql`
    mutation mvpsExportCalculations($where: IndicatorsMutationResolver_ExportMvpsCalculations_FilterInputType) {
  indicators {
    export_mvps_calculations(where: $where)
  }
}
    `;
export type MvpsExportCalculationsMutationFn = Apollo.MutationFunction<MvpsExportCalculationsMutation, MvpsExportCalculationsMutationVariables>;

/**
 * __useMvpsExportCalculationsMutation__
 *
 * To run a mutation, you first call `useMvpsExportCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMvpsExportCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mvpsExportCalculationsMutation, { data, loading, error }] = useMvpsExportCalculationsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMvpsExportCalculationsMutation(baseOptions?: Apollo.MutationHookOptions<MvpsExportCalculationsMutation, MvpsExportCalculationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MvpsExportCalculationsMutation, MvpsExportCalculationsMutationVariables>(MvpsExportCalculationsDocument, options);
      }
export type MvpsExportCalculationsMutationHookResult = ReturnType<typeof useMvpsExportCalculationsMutation>;
export type MvpsExportCalculationsMutationResult = Apollo.MutationResult<MvpsExportCalculationsMutation>;
export type MvpsExportCalculationsMutationOptions = Apollo.BaseMutationOptions<MvpsExportCalculationsMutation, MvpsExportCalculationsMutationVariables>;
export const TrainByCarriagesCarriageGroupIndicatorsDocument = /*#__PURE__*/ gql`
    query trainByCarriagesCarriageGroupIndicators($carriageGroupId: Float!) {
  indicators {
    carriage_group_indicators(carriage_group_id: $carriageGroupId) {
      carriage_group {
        name
        gdp {
          start_at
          end_at
        }
        railway_administration {
          entity_id
          name
          short_name
        }
        passenger_carrier {
          entity_id
          short_name
        }
        branch {
          name
          short_name
        }
        structural_subdivision {
          ... on MvpsCompanyAffiliationDto {
            entity_id
            mvps_owner
          }
          ... on StructuralSubdivisionDto {
            entity_id
            short_name
            station {
              full_name
              express_code
            }
          }
        }
        rolling_stock_type
        train_quantities {
          quantity
        }
        turnaround_times {
          turn_around_time
        }
        step_status
      }
      carriage_group_routes {
        route
        train_number
        distance
        sign
        route_distance
        station_train_from {
          entity_id
          full_name
        }
        station_train_to {
          entity_id
          full_name
        }
        station_carriage_group_from {
          entity_id
          full_name
        }
        station_carriage_group_to {
          entity_id
          full_name
        }
      }
      full_distance
      carriage_type_params_count {
        carriage_type
        quantity
      }
    }
  }
}
    `;

/**
 * __useTrainByCarriagesCarriageGroupIndicatorsQuery__
 *
 * To run a query within a React component, call `useTrainByCarriagesCarriageGroupIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainByCarriagesCarriageGroupIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainByCarriagesCarriageGroupIndicatorsQuery({
 *   variables: {
 *      carriageGroupId: // value for 'carriageGroupId'
 *   },
 * });
 */
export function useTrainByCarriagesCarriageGroupIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<TrainByCarriagesCarriageGroupIndicatorsQuery, TrainByCarriagesCarriageGroupIndicatorsQueryVariables> & ({ variables: TrainByCarriagesCarriageGroupIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainByCarriagesCarriageGroupIndicatorsQuery, TrainByCarriagesCarriageGroupIndicatorsQueryVariables>(TrainByCarriagesCarriageGroupIndicatorsDocument, options);
      }
export function useTrainByCarriagesCarriageGroupIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainByCarriagesCarriageGroupIndicatorsQuery, TrainByCarriagesCarriageGroupIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainByCarriagesCarriageGroupIndicatorsQuery, TrainByCarriagesCarriageGroupIndicatorsQueryVariables>(TrainByCarriagesCarriageGroupIndicatorsDocument, options);
        }
export function useTrainByCarriagesCarriageGroupIndicatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainByCarriagesCarriageGroupIndicatorsQuery, TrainByCarriagesCarriageGroupIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainByCarriagesCarriageGroupIndicatorsQuery, TrainByCarriagesCarriageGroupIndicatorsQueryVariables>(TrainByCarriagesCarriageGroupIndicatorsDocument, options);
        }
export type TrainByCarriagesCarriageGroupIndicatorsQueryHookResult = ReturnType<typeof useTrainByCarriagesCarriageGroupIndicatorsQuery>;
export type TrainByCarriagesCarriageGroupIndicatorsLazyQueryHookResult = ReturnType<typeof useTrainByCarriagesCarriageGroupIndicatorsLazyQuery>;
export type TrainByCarriagesCarriageGroupIndicatorsSuspenseQueryHookResult = ReturnType<typeof useTrainByCarriagesCarriageGroupIndicatorsSuspenseQuery>;
export type TrainByCarriagesCarriageGroupIndicatorsQueryResult = Apollo.QueryResult<TrainByCarriagesCarriageGroupIndicatorsQuery, TrainByCarriagesCarriageGroupIndicatorsQueryVariables>;
export const TrainByCarriagesIndicatorsByTrainDocument = /*#__PURE__*/ gql`
    query trainByCarriagesIndicatorsByTrain($data: CarriageGroupIndicatorsByTrainRequestDto!) {
  indicators {
    indicators_by_train(data: $data) {
      schema {
        items {
          seat_type
          carriage_type
          carriage_quantity
          seats_quantity
          seats_for_sale
          average_capacity
          carriage_quantity_req
        }
        carriage_quantity_passenger
        carriage_quantity_total
        seats_quantity_passenger
        seats_quantity_total
        seats_for_sale_passenger
        seats_for_sale_total
        average_capacity_passenger
        average_capacity_total
        carriage_quantity_req_passenger
        carriage_quantity_req_total
      }
      park_required {
        ... on NpsParkRequiredDto {
          ...NpsParkRequiredBaseFragment
        }
        ... on MvpsParkRequiredDto {
          ...MvpsParkRequiredBaseFragment
        }
      }
      items {
        train_info {
          train_number
          distance
          departures_quantity
        }
        carriage_departures_quantity {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_departures_quantity {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        carriage_schema_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_schema_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
        }
        carriage_required_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_required_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
        }
      }
      total {
        train_info {
          distance
          departures_quantity
        }
        carriage_departures_quantity {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_departures_quantity {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        carriage_schema_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_schema_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
        }
        carriage_required_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
          carriages_total
        }
        seats_required_turnovers {
          carriage_departures {
            seat_type
            carriage_type
            departures_quantity
          }
          passenger_carriages_total
        }
      }
    }
  }
}
    ${NpsParkRequiredBaseFragmentFragmentDoc}
${MvpsParkRequiredBaseFragmentFragmentDoc}`;

/**
 * __useTrainByCarriagesIndicatorsByTrainQuery__
 *
 * To run a query within a React component, call `useTrainByCarriagesIndicatorsByTrainQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainByCarriagesIndicatorsByTrainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainByCarriagesIndicatorsByTrainQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTrainByCarriagesIndicatorsByTrainQuery(baseOptions: Apollo.QueryHookOptions<TrainByCarriagesIndicatorsByTrainQuery, TrainByCarriagesIndicatorsByTrainQueryVariables> & ({ variables: TrainByCarriagesIndicatorsByTrainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainByCarriagesIndicatorsByTrainQuery, TrainByCarriagesIndicatorsByTrainQueryVariables>(TrainByCarriagesIndicatorsByTrainDocument, options);
      }
export function useTrainByCarriagesIndicatorsByTrainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainByCarriagesIndicatorsByTrainQuery, TrainByCarriagesIndicatorsByTrainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainByCarriagesIndicatorsByTrainQuery, TrainByCarriagesIndicatorsByTrainQueryVariables>(TrainByCarriagesIndicatorsByTrainDocument, options);
        }
export function useTrainByCarriagesIndicatorsByTrainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainByCarriagesIndicatorsByTrainQuery, TrainByCarriagesIndicatorsByTrainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainByCarriagesIndicatorsByTrainQuery, TrainByCarriagesIndicatorsByTrainQueryVariables>(TrainByCarriagesIndicatorsByTrainDocument, options);
        }
export type TrainByCarriagesIndicatorsByTrainQueryHookResult = ReturnType<typeof useTrainByCarriagesIndicatorsByTrainQuery>;
export type TrainByCarriagesIndicatorsByTrainLazyQueryHookResult = ReturnType<typeof useTrainByCarriagesIndicatorsByTrainLazyQuery>;
export type TrainByCarriagesIndicatorsByTrainSuspenseQueryHookResult = ReturnType<typeof useTrainByCarriagesIndicatorsByTrainSuspenseQuery>;
export type TrainByCarriagesIndicatorsByTrainQueryResult = Apollo.QueryResult<TrainByCarriagesIndicatorsByTrainQuery, TrainByCarriagesIndicatorsByTrainQueryVariables>;
export const TrainByCarriagesIndicatorsCarriageGroupListDocument = /*#__PURE__*/ gql`
    query trainByCarriagesIndicatorsCarriageGroupList($paginate: PaginatorArgsDto, $orderBy: [CarriageGroupQueryResolver_CarriageGroupList_SortingInputType!], $where: CarriageGroupQueryResolver_CarriageGroupList_FilterInputType, $search: String!) {
  carriageGroups {
    carriageGroupList(
      paginate: $paginate
      order_by: $orderBy
      where: $where
      search: $search
    ) {
      items {
        id
      }
    }
  }
}
    `;

/**
 * __useTrainByCarriagesIndicatorsCarriageGroupListQuery__
 *
 * To run a query within a React component, call `useTrainByCarriagesIndicatorsCarriageGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainByCarriagesIndicatorsCarriageGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainByCarriagesIndicatorsCarriageGroupListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTrainByCarriagesIndicatorsCarriageGroupListQuery(baseOptions: Apollo.QueryHookOptions<TrainByCarriagesIndicatorsCarriageGroupListQuery, TrainByCarriagesIndicatorsCarriageGroupListQueryVariables> & ({ variables: TrainByCarriagesIndicatorsCarriageGroupListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainByCarriagesIndicatorsCarriageGroupListQuery, TrainByCarriagesIndicatorsCarriageGroupListQueryVariables>(TrainByCarriagesIndicatorsCarriageGroupListDocument, options);
      }
export function useTrainByCarriagesIndicatorsCarriageGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainByCarriagesIndicatorsCarriageGroupListQuery, TrainByCarriagesIndicatorsCarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainByCarriagesIndicatorsCarriageGroupListQuery, TrainByCarriagesIndicatorsCarriageGroupListQueryVariables>(TrainByCarriagesIndicatorsCarriageGroupListDocument, options);
        }
export function useTrainByCarriagesIndicatorsCarriageGroupListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainByCarriagesIndicatorsCarriageGroupListQuery, TrainByCarriagesIndicatorsCarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainByCarriagesIndicatorsCarriageGroupListQuery, TrainByCarriagesIndicatorsCarriageGroupListQueryVariables>(TrainByCarriagesIndicatorsCarriageGroupListDocument, options);
        }
export type TrainByCarriagesIndicatorsCarriageGroupListQueryHookResult = ReturnType<typeof useTrainByCarriagesIndicatorsCarriageGroupListQuery>;
export type TrainByCarriagesIndicatorsCarriageGroupListLazyQueryHookResult = ReturnType<typeof useTrainByCarriagesIndicatorsCarriageGroupListLazyQuery>;
export type TrainByCarriagesIndicatorsCarriageGroupListSuspenseQueryHookResult = ReturnType<typeof useTrainByCarriagesIndicatorsCarriageGroupListSuspenseQuery>;
export type TrainByCarriagesIndicatorsCarriageGroupListQueryResult = Apollo.QueryResult<TrainByCarriagesIndicatorsCarriageGroupListQuery, TrainByCarriagesIndicatorsCarriageGroupListQueryVariables>;
export const CarriageGroupFinalIndicatorsExportDocument = /*#__PURE__*/ gql`
    mutation carriageGroupFinalIndicatorsExport($where: IndicatorsMutationResolver_ExportTrainByGroupsFinalIndicators_FilterInputType!) {
  indicators {
    export_train_by_groups_final_indicators(where: $where)
  }
}
    `;
export type CarriageGroupFinalIndicatorsExportMutationFn = Apollo.MutationFunction<CarriageGroupFinalIndicatorsExportMutation, CarriageGroupFinalIndicatorsExportMutationVariables>;

/**
 * __useCarriageGroupFinalIndicatorsExportMutation__
 *
 * To run a mutation, you first call `useCarriageGroupFinalIndicatorsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupFinalIndicatorsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageGroupFinalIndicatorsExportMutation, { data, loading, error }] = useCarriageGroupFinalIndicatorsExportMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCarriageGroupFinalIndicatorsExportMutation(baseOptions?: Apollo.MutationHookOptions<CarriageGroupFinalIndicatorsExportMutation, CarriageGroupFinalIndicatorsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageGroupFinalIndicatorsExportMutation, CarriageGroupFinalIndicatorsExportMutationVariables>(CarriageGroupFinalIndicatorsExportDocument, options);
      }
export type CarriageGroupFinalIndicatorsExportMutationHookResult = ReturnType<typeof useCarriageGroupFinalIndicatorsExportMutation>;
export type CarriageGroupFinalIndicatorsExportMutationResult = Apollo.MutationResult<CarriageGroupFinalIndicatorsExportMutation>;
export type CarriageGroupFinalIndicatorsExportMutationOptions = Apollo.BaseMutationOptions<CarriageGroupFinalIndicatorsExportMutation, CarriageGroupFinalIndicatorsExportMutationVariables>;
export const IndicatorsTrainListViewDocument = /*#__PURE__*/ gql`
    query indicatorsTrainListView($paginate: PaginatorArgsDto, $orderBy: [IndicatorsQueryResolver_ListTrains_SortingInputType!], $where: IndicatorsQueryResolver_ListTrains_FilterInputType) {
  indicators {
    list_trains(paginate: $paginate, order_by: $orderBy, where: $where) {
      items {
        ...IndicatorsTrainBaseFragment
      }
      totalCount
    }
  }
}
    ${IndicatorsTrainBaseFragmentFragmentDoc}`;

/**
 * __useIndicatorsTrainListViewQuery__
 *
 * To run a query within a React component, call `useIndicatorsTrainListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorsTrainListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorsTrainListViewQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useIndicatorsTrainListViewQuery(baseOptions?: Apollo.QueryHookOptions<IndicatorsTrainListViewQuery, IndicatorsTrainListViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorsTrainListViewQuery, IndicatorsTrainListViewQueryVariables>(IndicatorsTrainListViewDocument, options);
      }
export function useIndicatorsTrainListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorsTrainListViewQuery, IndicatorsTrainListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorsTrainListViewQuery, IndicatorsTrainListViewQueryVariables>(IndicatorsTrainListViewDocument, options);
        }
export function useIndicatorsTrainListViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndicatorsTrainListViewQuery, IndicatorsTrainListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndicatorsTrainListViewQuery, IndicatorsTrainListViewQueryVariables>(IndicatorsTrainListViewDocument, options);
        }
export type IndicatorsTrainListViewQueryHookResult = ReturnType<typeof useIndicatorsTrainListViewQuery>;
export type IndicatorsTrainListViewLazyQueryHookResult = ReturnType<typeof useIndicatorsTrainListViewLazyQuery>;
export type IndicatorsTrainListViewSuspenseQueryHookResult = ReturnType<typeof useIndicatorsTrainListViewSuspenseQuery>;
export type IndicatorsTrainListViewQueryResult = Apollo.QueryResult<IndicatorsTrainListViewQuery, IndicatorsTrainListViewQueryVariables>;
export const TrainExportDocument = /*#__PURE__*/ gql`
    mutation trainExport($where: IndicatorsMutationResolver_ExportTrainFinalIndicators_FilterInputType!) {
  indicators {
    export_train_final_indicators(where: $where)
  }
}
    `;
export type TrainExportMutationFn = Apollo.MutationFunction<TrainExportMutation, TrainExportMutationVariables>;

/**
 * __useTrainExportMutation__
 *
 * To run a mutation, you first call `useTrainExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainExportMutation, { data, loading, error }] = useTrainExportMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrainExportMutation(baseOptions?: Apollo.MutationHookOptions<TrainExportMutation, TrainExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainExportMutation, TrainExportMutationVariables>(TrainExportDocument, options);
      }
export type TrainExportMutationHookResult = ReturnType<typeof useTrainExportMutation>;
export type TrainExportMutationResult = Apollo.MutationResult<TrainExportMutation>;
export type TrainExportMutationOptions = Apollo.BaseMutationOptions<TrainExportMutation, TrainExportMutationVariables>;
export const SchemasListForIndicatorsViewDocument = /*#__PURE__*/ gql`
    query schemasListForIndicatorsView($trainId: Float!) {
  train {
    byId(id: $trainId) {
      id
      schemas {
        id
        train_schema_number
      }
      gdp {
        start_at
        end_at
      }
    }
  }
}
    `;

/**
 * __useSchemasListForIndicatorsViewQuery__
 *
 * To run a query within a React component, call `useSchemasListForIndicatorsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemasListForIndicatorsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemasListForIndicatorsViewQuery({
 *   variables: {
 *      trainId: // value for 'trainId'
 *   },
 * });
 */
export function useSchemasListForIndicatorsViewQuery(baseOptions: Apollo.QueryHookOptions<SchemasListForIndicatorsViewQuery, SchemasListForIndicatorsViewQueryVariables> & ({ variables: SchemasListForIndicatorsViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemasListForIndicatorsViewQuery, SchemasListForIndicatorsViewQueryVariables>(SchemasListForIndicatorsViewDocument, options);
      }
export function useSchemasListForIndicatorsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemasListForIndicatorsViewQuery, SchemasListForIndicatorsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemasListForIndicatorsViewQuery, SchemasListForIndicatorsViewQueryVariables>(SchemasListForIndicatorsViewDocument, options);
        }
export function useSchemasListForIndicatorsViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchemasListForIndicatorsViewQuery, SchemasListForIndicatorsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemasListForIndicatorsViewQuery, SchemasListForIndicatorsViewQueryVariables>(SchemasListForIndicatorsViewDocument, options);
        }
export type SchemasListForIndicatorsViewQueryHookResult = ReturnType<typeof useSchemasListForIndicatorsViewQuery>;
export type SchemasListForIndicatorsViewLazyQueryHookResult = ReturnType<typeof useSchemasListForIndicatorsViewLazyQuery>;
export type SchemasListForIndicatorsViewSuspenseQueryHookResult = ReturnType<typeof useSchemasListForIndicatorsViewSuspenseQuery>;
export type SchemasListForIndicatorsViewQueryResult = Apollo.QueryResult<SchemasListForIndicatorsViewQuery, SchemasListForIndicatorsViewQueryVariables>;
export const TrainIndicatorsForSchemaViewDocument = /*#__PURE__*/ gql`
    query trainIndicatorsForSchemaView($trainId: Int!, $schemaId: Int!, $fromDate: String!, $toDate: String!, $isArrival: Boolean!) {
  indicators {
    train_indicators_for_schema(
      data: {train_id: $trainId, schema_id: $schemaId, from_date: $fromDate, to_date: $toDate, is_arrival: $isArrival}
    ) {
      train_performance_indicators {
        items {
          ...TrainPerformanceIndicatorsSchemaItemFragment
        }
        total {
          ...TrainPerformanceIndicatorsSchemaTotalFragment
        }
      }
      park_required {
        ...NpsParkRequiredBaseFragment
      }
      composition_schema {
        ...CompositionSchemaFragment
      }
      cruising_order {
        ...CruisingOrderFragment
      }
      carriage_quantity {
        ...CarriageQuantityFragment
      }
      header {
        ...TrainIndicatorsHeaderFragment
      }
      carriages_distribution {
        ...CarriageDistributionFragment
      }
    }
  }
}
    ${TrainPerformanceIndicatorsSchemaItemFragmentFragmentDoc}
${TrainPerformanceIndicatorsSchemaTotalFragmentFragmentDoc}
${NpsParkRequiredBaseFragmentFragmentDoc}
${CompositionSchemaFragmentFragmentDoc}
${CruisingOrderFragmentFragmentDoc}
${CarriageQuantityFragmentFragmentDoc}
${TrainIndicatorsHeaderFragmentFragmentDoc}
${CarriageDistributionFragmentFragmentDoc}`;

/**
 * __useTrainIndicatorsForSchemaViewQuery__
 *
 * To run a query within a React component, call `useTrainIndicatorsForSchemaViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainIndicatorsForSchemaViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainIndicatorsForSchemaViewQuery({
 *   variables: {
 *      trainId: // value for 'trainId'
 *      schemaId: // value for 'schemaId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      isArrival: // value for 'isArrival'
 *   },
 * });
 */
export function useTrainIndicatorsForSchemaViewQuery(baseOptions: Apollo.QueryHookOptions<TrainIndicatorsForSchemaViewQuery, TrainIndicatorsForSchemaViewQueryVariables> & ({ variables: TrainIndicatorsForSchemaViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainIndicatorsForSchemaViewQuery, TrainIndicatorsForSchemaViewQueryVariables>(TrainIndicatorsForSchemaViewDocument, options);
      }
export function useTrainIndicatorsForSchemaViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainIndicatorsForSchemaViewQuery, TrainIndicatorsForSchemaViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainIndicatorsForSchemaViewQuery, TrainIndicatorsForSchemaViewQueryVariables>(TrainIndicatorsForSchemaViewDocument, options);
        }
export function useTrainIndicatorsForSchemaViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainIndicatorsForSchemaViewQuery, TrainIndicatorsForSchemaViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainIndicatorsForSchemaViewQuery, TrainIndicatorsForSchemaViewQueryVariables>(TrainIndicatorsForSchemaViewDocument, options);
        }
export type TrainIndicatorsForSchemaViewQueryHookResult = ReturnType<typeof useTrainIndicatorsForSchemaViewQuery>;
export type TrainIndicatorsForSchemaViewLazyQueryHookResult = ReturnType<typeof useTrainIndicatorsForSchemaViewLazyQuery>;
export type TrainIndicatorsForSchemaViewSuspenseQueryHookResult = ReturnType<typeof useTrainIndicatorsForSchemaViewSuspenseQuery>;
export type TrainIndicatorsForSchemaViewQueryResult = Apollo.QueryResult<TrainIndicatorsForSchemaViewQuery, TrainIndicatorsForSchemaViewQueryVariables>;
export const TrainIndicatorsTotalDocument = /*#__PURE__*/ gql`
    query trainIndicatorsTotal($trainId: Int!, $fromDate: String!, $toDate: String!, $isArrival: Boolean!) {
  indicators {
    train_indicators_total(
      data: {train_id: $trainId, from_date: $fromDate, to_date: $toDate, is_arrival: $isArrival}
    ) {
      seats_turnover_carriage_group_route {
        ...IndicatorsByTrainCarriageTypesOmitTotalFragment
      }
      seats_proposed {
        ...IndicatorsByTrainCarriageTypesOmitTotalFragment
      }
      seats_turnover_req_carriage_group_route {
        ...IndicatorsByTrainCarriageTypesOmitTotalFragment
      }
      seats_turnover_carriage_group_route {
        ...IndicatorsByTrainCarriageTypesOmitTotalFragment
      }
      seats_turnover_train_route {
        ...IndicatorsByTrainCarriageTypesOmitTotalFragment
      }
      seats_turnover_req_train_route {
        ...IndicatorsByTrainCarriageTypesOmitTotalFragment
      }
      carriages_turnover_carriage_group_route {
        ...IndicatorsByTrainCarriageTypesFragment
      }
      carriages_turnover_train_route {
        ...IndicatorsByTrainCarriageTypesFragment
      }
      average_composition_express_forecast {
        ...IndicatorsByTrainCarriageTypesFragment
      }
      carriages_sent {
        ...IndicatorsByTrainCarriageTypesFragment
      }
      average_composition_infrastructure_forecast {
        ...IndicatorsByTrainCarriageTypesFragment
      }
      carriages_turnover_req_carriage_group_route {
        ...IndicatorsByTrainCarriageTypesFragment
      }
      carriages_turnover_req_train_route {
        ...IndicatorsByTrainCarriageTypesFragment
      }
      average_composition_express {
        ...IndicatorsByTrainCarriageTypesFragment
      }
      ...TrainPerformanceIndicatorsTotalBaseFragment
    }
  }
}
    ${IndicatorsByTrainCarriageTypesOmitTotalFragmentFragmentDoc}
${IndicatorsByTrainCarriageTypesFragmentFragmentDoc}
${TrainPerformanceIndicatorsTotalBaseFragmentFragmentDoc}`;

/**
 * __useTrainIndicatorsTotalQuery__
 *
 * To run a query within a React component, call `useTrainIndicatorsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainIndicatorsTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainIndicatorsTotalQuery({
 *   variables: {
 *      trainId: // value for 'trainId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      isArrival: // value for 'isArrival'
 *   },
 * });
 */
export function useTrainIndicatorsTotalQuery(baseOptions: Apollo.QueryHookOptions<TrainIndicatorsTotalQuery, TrainIndicatorsTotalQueryVariables> & ({ variables: TrainIndicatorsTotalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainIndicatorsTotalQuery, TrainIndicatorsTotalQueryVariables>(TrainIndicatorsTotalDocument, options);
      }
export function useTrainIndicatorsTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainIndicatorsTotalQuery, TrainIndicatorsTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainIndicatorsTotalQuery, TrainIndicatorsTotalQueryVariables>(TrainIndicatorsTotalDocument, options);
        }
export function useTrainIndicatorsTotalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainIndicatorsTotalQuery, TrainIndicatorsTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainIndicatorsTotalQuery, TrainIndicatorsTotalQueryVariables>(TrainIndicatorsTotalDocument, options);
        }
export type TrainIndicatorsTotalQueryHookResult = ReturnType<typeof useTrainIndicatorsTotalQuery>;
export type TrainIndicatorsTotalLazyQueryHookResult = ReturnType<typeof useTrainIndicatorsTotalLazyQuery>;
export type TrainIndicatorsTotalSuspenseQueryHookResult = ReturnType<typeof useTrainIndicatorsTotalSuspenseQuery>;
export type TrainIndicatorsTotalQueryResult = Apollo.QueryResult<TrainIndicatorsTotalQuery, TrainIndicatorsTotalQueryVariables>;
export const LocomotiveAreaTrainListDocument = /*#__PURE__*/ gql`
    query locomotiveAreaTrainList($where: TrainQueryResolver_LocomotiveServiceList_FilterInputType, $paginate: PaginatorArgsDto, $orderBy: [TrainQueryResolver_LocomotiveServiceList_SortingInputType!]) {
  train {
    locomotiveServiceList(where: $where, paginate: $paginate, order_by: $orderBy) {
      totalCount
      items {
        id
        train_number
        start_at
        end_at
        version
        status
        from_station {
          ...StationShortFragment
        }
        to_station {
          ...StationShortFragment
        }
        railway_administration {
          ...RailwayAdministrationShortFragment
        }
        branch {
          ...BranchShortFragment
        }
        passenger_carrier {
          ...PassengerCarrierShortFragment
        }
        locomotive_traction_types {
          ...LocomotiveTractionTypeBaseFragment
        }
        traction_directorates {
          ...TractionDirectorateBaseFragment
        }
        traction_directorate_teams {
          ...TractionDirectorateBaseFragment
        }
        gdp {
          ...GdpBaseFragment
        }
      }
    }
  }
}
    ${StationShortFragmentFragmentDoc}
${RailwayAdministrationShortFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}
${LocomotiveTractionTypeBaseFragmentFragmentDoc}
${TractionDirectorateBaseFragmentFragmentDoc}
${GdpBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveAreaTrainListQuery__
 *
 * To run a query within a React component, call `useLocomotiveAreaTrainListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveAreaTrainListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveAreaTrainListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLocomotiveAreaTrainListQuery(baseOptions?: Apollo.QueryHookOptions<LocomotiveAreaTrainListQuery, LocomotiveAreaTrainListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveAreaTrainListQuery, LocomotiveAreaTrainListQueryVariables>(LocomotiveAreaTrainListDocument, options);
      }
export function useLocomotiveAreaTrainListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveAreaTrainListQuery, LocomotiveAreaTrainListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveAreaTrainListQuery, LocomotiveAreaTrainListQueryVariables>(LocomotiveAreaTrainListDocument, options);
        }
export function useLocomotiveAreaTrainListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveAreaTrainListQuery, LocomotiveAreaTrainListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveAreaTrainListQuery, LocomotiveAreaTrainListQueryVariables>(LocomotiveAreaTrainListDocument, options);
        }
export type LocomotiveAreaTrainListQueryHookResult = ReturnType<typeof useLocomotiveAreaTrainListQuery>;
export type LocomotiveAreaTrainListLazyQueryHookResult = ReturnType<typeof useLocomotiveAreaTrainListLazyQuery>;
export type LocomotiveAreaTrainListSuspenseQueryHookResult = ReturnType<typeof useLocomotiveAreaTrainListSuspenseQuery>;
export type LocomotiveAreaTrainListQueryResult = Apollo.QueryResult<LocomotiveAreaTrainListQuery, LocomotiveAreaTrainListQueryVariables>;
export const LocomotiveTractionTypeListForLocomotivesViewDocument = /*#__PURE__*/ gql`
    query locomotiveTractionTypeListForLocomotivesView {
  classifiers {
    locomotiveTractionType {
      list(paginate: {per_page: 50, page: 0}, where: {}, order_by: []) {
        items {
          id
          name
        }
        totalCount
      }
    }
  }
}
    `;

/**
 * __useLocomotiveTractionTypeListForLocomotivesViewQuery__
 *
 * To run a query within a React component, call `useLocomotiveTractionTypeListForLocomotivesViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveTractionTypeListForLocomotivesViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveTractionTypeListForLocomotivesViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocomotiveTractionTypeListForLocomotivesViewQuery(baseOptions?: Apollo.QueryHookOptions<LocomotiveTractionTypeListForLocomotivesViewQuery, LocomotiveTractionTypeListForLocomotivesViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveTractionTypeListForLocomotivesViewQuery, LocomotiveTractionTypeListForLocomotivesViewQueryVariables>(LocomotiveTractionTypeListForLocomotivesViewDocument, options);
      }
export function useLocomotiveTractionTypeListForLocomotivesViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveTractionTypeListForLocomotivesViewQuery, LocomotiveTractionTypeListForLocomotivesViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveTractionTypeListForLocomotivesViewQuery, LocomotiveTractionTypeListForLocomotivesViewQueryVariables>(LocomotiveTractionTypeListForLocomotivesViewDocument, options);
        }
export function useLocomotiveTractionTypeListForLocomotivesViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveTractionTypeListForLocomotivesViewQuery, LocomotiveTractionTypeListForLocomotivesViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveTractionTypeListForLocomotivesViewQuery, LocomotiveTractionTypeListForLocomotivesViewQueryVariables>(LocomotiveTractionTypeListForLocomotivesViewDocument, options);
        }
export type LocomotiveTractionTypeListForLocomotivesViewQueryHookResult = ReturnType<typeof useLocomotiveTractionTypeListForLocomotivesViewQuery>;
export type LocomotiveTractionTypeListForLocomotivesViewLazyQueryHookResult = ReturnType<typeof useLocomotiveTractionTypeListForLocomotivesViewLazyQuery>;
export type LocomotiveTractionTypeListForLocomotivesViewSuspenseQueryHookResult = ReturnType<typeof useLocomotiveTractionTypeListForLocomotivesViewSuspenseQuery>;
export type LocomotiveTractionTypeListForLocomotivesViewQueryResult = Apollo.QueryResult<LocomotiveTractionTypeListForLocomotivesViewQuery, LocomotiveTractionTypeListForLocomotivesViewQueryVariables>;
export const TractionDirectorateListForLocomotiveAreaListViewDocument = /*#__PURE__*/ gql`
    query tractionDirectorateListForLocomotiveAreaListView($range: RangeInputDto!) {
  classifiers {
    tractionDirectorate {
      list(paginate: {per_page: 50, page: 0}, where: {}, order_by: [], range: $range) {
        items {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useTractionDirectorateListForLocomotiveAreaListViewQuery__
 *
 * To run a query within a React component, call `useTractionDirectorateListForLocomotiveAreaListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTractionDirectorateListForLocomotiveAreaListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTractionDirectorateListForLocomotiveAreaListViewQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTractionDirectorateListForLocomotiveAreaListViewQuery(baseOptions: Apollo.QueryHookOptions<TractionDirectorateListForLocomotiveAreaListViewQuery, TractionDirectorateListForLocomotiveAreaListViewQueryVariables> & ({ variables: TractionDirectorateListForLocomotiveAreaListViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TractionDirectorateListForLocomotiveAreaListViewQuery, TractionDirectorateListForLocomotiveAreaListViewQueryVariables>(TractionDirectorateListForLocomotiveAreaListViewDocument, options);
      }
export function useTractionDirectorateListForLocomotiveAreaListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TractionDirectorateListForLocomotiveAreaListViewQuery, TractionDirectorateListForLocomotiveAreaListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TractionDirectorateListForLocomotiveAreaListViewQuery, TractionDirectorateListForLocomotiveAreaListViewQueryVariables>(TractionDirectorateListForLocomotiveAreaListViewDocument, options);
        }
export function useTractionDirectorateListForLocomotiveAreaListViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TractionDirectorateListForLocomotiveAreaListViewQuery, TractionDirectorateListForLocomotiveAreaListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TractionDirectorateListForLocomotiveAreaListViewQuery, TractionDirectorateListForLocomotiveAreaListViewQueryVariables>(TractionDirectorateListForLocomotiveAreaListViewDocument, options);
        }
export type TractionDirectorateListForLocomotiveAreaListViewQueryHookResult = ReturnType<typeof useTractionDirectorateListForLocomotiveAreaListViewQuery>;
export type TractionDirectorateListForLocomotiveAreaListViewLazyQueryHookResult = ReturnType<typeof useTractionDirectorateListForLocomotiveAreaListViewLazyQuery>;
export type TractionDirectorateListForLocomotiveAreaListViewSuspenseQueryHookResult = ReturnType<typeof useTractionDirectorateListForLocomotiveAreaListViewSuspenseQuery>;
export type TractionDirectorateListForLocomotiveAreaListViewQueryResult = Apollo.QueryResult<TractionDirectorateListForLocomotiveAreaListViewQuery, TractionDirectorateListForLocomotiveAreaListViewQueryVariables>;
export const LogoutDocument = /*#__PURE__*/ gql`
    mutation Logout {
  authentication {
    singOut
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const DashboardInfoDocument = /*#__PURE__*/ gql`
    query dashboardInfo($data: DashboardDataDto!) {
  train {
    getDashboard(data: $data) {
      created_at
      gdp {
        id
      }
      status
      fpk_trains {
        season_train_every_year {
          ...FpkTrainTotalTrainFragment
        }
        season_train_other {
          ...FpkTrainTotalTrainFragment
        }
        season_train_season {
          ...FpkTrainTotalTrainFragment
        }
        total_trains {
          ...FpkTrainTotalTrainFragment
        }
      }
      other_trains {
        total_trains_pair {
          entity_rus_name
          main_train_ids
          pairs_count
          trains_pair_array {
            entity_rus_name
            main_train_ids
            pairs_count
          }
        }
        far_abroad_trains_pair {
          main_train_ids
          pairs_count
          trains_pair_array {
            entity_rus_name
            main_train_ids
            pairs_count
          }
        }
        other_trains_pair {
          main_train_ids
          pairs_count
          trains_pair_array {
            entity_rus_name
            main_train_ids
            pairs_count
          }
        }
        sng_trains_pair {
          main_train_ids
          entity_rus_name
          pairs_count
          trains_pair_array {
            entity_rus_name
            main_train_ids
            pairs_count
          }
        }
      }
      branches_trains {
        pairs_count {
          main_train_ids
          entity_rus_name
          pairs_count
        }
        subdivisions {
          entity_rus_name
          ids
          count
          lvch_count
          lvchd_count
        }
      }
    }
  }
}
    ${FpkTrainTotalTrainFragmentFragmentDoc}`;

/**
 * __useDashboardInfoQuery__
 *
 * To run a query within a React component, call `useDashboardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardInfoQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDashboardInfoQuery(baseOptions: Apollo.QueryHookOptions<DashboardInfoQuery, DashboardInfoQueryVariables> & ({ variables: DashboardInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardInfoQuery, DashboardInfoQueryVariables>(DashboardInfoDocument, options);
      }
export function useDashboardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardInfoQuery, DashboardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardInfoQuery, DashboardInfoQueryVariables>(DashboardInfoDocument, options);
        }
export function useDashboardInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardInfoQuery, DashboardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardInfoQuery, DashboardInfoQueryVariables>(DashboardInfoDocument, options);
        }
export type DashboardInfoQueryHookResult = ReturnType<typeof useDashboardInfoQuery>;
export type DashboardInfoLazyQueryHookResult = ReturnType<typeof useDashboardInfoLazyQuery>;
export type DashboardInfoSuspenseQueryHookResult = ReturnType<typeof useDashboardInfoSuspenseQuery>;
export type DashboardInfoQueryResult = Apollo.QueryResult<DashboardInfoQuery, DashboardInfoQueryVariables>;
export const DashboardTrainsListDocument = /*#__PURE__*/ gql`
    query dashboardTrainsList($paginate: PaginatorArgsDto, $orderBy: [TrainQueryResolver_NewList_SortingInputType!], $where: TrainQueryResolver_NewList_FilterInputType, $is_including_expired_versions: Boolean!) {
  train {
    newList(
      paginate: $paginate
      order_by: $orderBy
      where: $where
      is_including_expired_versions: $is_including_expired_versions
    ) {
      totalCount
      items {
        ...DashboardTrainFragment
        pair_train {
          ...DashboardTrainFragment
        }
      }
    }
  }
}
    ${DashboardTrainFragmentFragmentDoc}`;

/**
 * __useDashboardTrainsListQuery__
 *
 * To run a query within a React component, call `useDashboardTrainsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTrainsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTrainsListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      is_including_expired_versions: // value for 'is_including_expired_versions'
 *   },
 * });
 */
export function useDashboardTrainsListQuery(baseOptions: Apollo.QueryHookOptions<DashboardTrainsListQuery, DashboardTrainsListQueryVariables> & ({ variables: DashboardTrainsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTrainsListQuery, DashboardTrainsListQueryVariables>(DashboardTrainsListDocument, options);
      }
export function useDashboardTrainsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTrainsListQuery, DashboardTrainsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTrainsListQuery, DashboardTrainsListQueryVariables>(DashboardTrainsListDocument, options);
        }
export function useDashboardTrainsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardTrainsListQuery, DashboardTrainsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardTrainsListQuery, DashboardTrainsListQueryVariables>(DashboardTrainsListDocument, options);
        }
export type DashboardTrainsListQueryHookResult = ReturnType<typeof useDashboardTrainsListQuery>;
export type DashboardTrainsListLazyQueryHookResult = ReturnType<typeof useDashboardTrainsListLazyQuery>;
export type DashboardTrainsListSuspenseQueryHookResult = ReturnType<typeof useDashboardTrainsListSuspenseQuery>;
export type DashboardTrainsListQueryResult = Apollo.QueryResult<DashboardTrainsListQuery, DashboardTrainsListQueryVariables>;
export const DashboardStructuralSubdivisionListDocument = /*#__PURE__*/ gql`
    query dashboardStructuralSubdivisionList($paginate: PaginatorArgsDto, $orderBy: [StructuralSubdivisionQueryResolver_List_SortingInputType!], $where: StructuralSubdivisionQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    structuralSubdivision {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...StructuralSubdivisionBaseFragment
          station {
            ...StationShortFragment
          }
        }
      }
    }
  }
}
    ${StructuralSubdivisionBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}`;

/**
 * __useDashboardStructuralSubdivisionListQuery__
 *
 * To run a query within a React component, call `useDashboardStructuralSubdivisionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardStructuralSubdivisionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardStructuralSubdivisionListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useDashboardStructuralSubdivisionListQuery(baseOptions: Apollo.QueryHookOptions<DashboardStructuralSubdivisionListQuery, DashboardStructuralSubdivisionListQueryVariables> & ({ variables: DashboardStructuralSubdivisionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardStructuralSubdivisionListQuery, DashboardStructuralSubdivisionListQueryVariables>(DashboardStructuralSubdivisionListDocument, options);
      }
export function useDashboardStructuralSubdivisionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardStructuralSubdivisionListQuery, DashboardStructuralSubdivisionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardStructuralSubdivisionListQuery, DashboardStructuralSubdivisionListQueryVariables>(DashboardStructuralSubdivisionListDocument, options);
        }
export function useDashboardStructuralSubdivisionListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardStructuralSubdivisionListQuery, DashboardStructuralSubdivisionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardStructuralSubdivisionListQuery, DashboardStructuralSubdivisionListQueryVariables>(DashboardStructuralSubdivisionListDocument, options);
        }
export type DashboardStructuralSubdivisionListQueryHookResult = ReturnType<typeof useDashboardStructuralSubdivisionListQuery>;
export type DashboardStructuralSubdivisionListLazyQueryHookResult = ReturnType<typeof useDashboardStructuralSubdivisionListLazyQuery>;
export type DashboardStructuralSubdivisionListSuspenseQueryHookResult = ReturnType<typeof useDashboardStructuralSubdivisionListSuspenseQuery>;
export type DashboardStructuralSubdivisionListQueryResult = Apollo.QueryResult<DashboardStructuralSubdivisionListQuery, DashboardStructuralSubdivisionListQueryVariables>;
export const NewsListDocument = /*#__PURE__*/ gql`
    query newsList($paginate: PaginatorArgsDto, $order_by: [CmsQueryResolver_NewsList_SortingInputType!], $where: CmsQueryResolver_NewsList_FilterInputType) {
  cms {
    news_list(paginate: $paginate, order_by: $order_by, where: $where) {
      items {
        ...NewsFragment
      }
      totalCount
    }
  }
}
    ${NewsFragmentFragmentDoc}`;

/**
 * __useNewsListQuery__
 *
 * To run a query within a React component, call `useNewsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNewsListQuery(baseOptions?: Apollo.QueryHookOptions<NewsListQuery, NewsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsListQuery, NewsListQueryVariables>(NewsListDocument, options);
      }
export function useNewsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsListQuery, NewsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsListQuery, NewsListQueryVariables>(NewsListDocument, options);
        }
export function useNewsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewsListQuery, NewsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsListQuery, NewsListQueryVariables>(NewsListDocument, options);
        }
export type NewsListQueryHookResult = ReturnType<typeof useNewsListQuery>;
export type NewsListLazyQueryHookResult = ReturnType<typeof useNewsListLazyQuery>;
export type NewsListSuspenseQueryHookResult = ReturnType<typeof useNewsListSuspenseQuery>;
export type NewsListQueryResult = Apollo.QueryResult<NewsListQuery, NewsListQueryVariables>;
export const ClearUserConfigurationDocument = /*#__PURE__*/ gql`
    mutation clearUserConfiguration {
  configuration {
    user_configuration_update(data: "") {
      id
    }
    __typename
  }
}
    `;
export type ClearUserConfigurationMutationFn = Apollo.MutationFunction<ClearUserConfigurationMutation, ClearUserConfigurationMutationVariables>;

/**
 * __useClearUserConfigurationMutation__
 *
 * To run a mutation, you first call `useClearUserConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearUserConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearUserConfigurationMutation, { data, loading, error }] = useClearUserConfigurationMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearUserConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<ClearUserConfigurationMutation, ClearUserConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearUserConfigurationMutation, ClearUserConfigurationMutationVariables>(ClearUserConfigurationDocument, options);
      }
export type ClearUserConfigurationMutationHookResult = ReturnType<typeof useClearUserConfigurationMutation>;
export type ClearUserConfigurationMutationResult = Apollo.MutationResult<ClearUserConfigurationMutation>;
export type ClearUserConfigurationMutationOptions = Apollo.BaseMutationOptions<ClearUserConfigurationMutation, ClearUserConfigurationMutationVariables>;
export const MeJournalActionAuditDocument = /*#__PURE__*/ gql`
    query meJournalActionAudit($paginate: PaginatorArgsDto, $where: JournalQueryResolver_MeActionAudit_FilterInputType, $orderBy: [JournalQueryResolver_MeActionAudit_SortingInputType!]) {
  journal {
    me_action_audit(paginate: $paginate, where: $where, order_by: $orderBy) {
      items {
        ...JournalMeActionFragment
      }
      totalCount
    }
  }
}
    ${JournalMeActionFragmentFragmentDoc}`;

/**
 * __useMeJournalActionAuditQuery__
 *
 * To run a query within a React component, call `useMeJournalActionAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeJournalActionAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeJournalActionAuditQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMeJournalActionAuditQuery(baseOptions?: Apollo.QueryHookOptions<MeJournalActionAuditQuery, MeJournalActionAuditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeJournalActionAuditQuery, MeJournalActionAuditQueryVariables>(MeJournalActionAuditDocument, options);
      }
export function useMeJournalActionAuditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeJournalActionAuditQuery, MeJournalActionAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeJournalActionAuditQuery, MeJournalActionAuditQueryVariables>(MeJournalActionAuditDocument, options);
        }
export function useMeJournalActionAuditSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeJournalActionAuditQuery, MeJournalActionAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeJournalActionAuditQuery, MeJournalActionAuditQueryVariables>(MeJournalActionAuditDocument, options);
        }
export type MeJournalActionAuditQueryHookResult = ReturnType<typeof useMeJournalActionAuditQuery>;
export type MeJournalActionAuditLazyQueryHookResult = ReturnType<typeof useMeJournalActionAuditLazyQuery>;
export type MeJournalActionAuditSuspenseQueryHookResult = ReturnType<typeof useMeJournalActionAuditSuspenseQuery>;
export type MeJournalActionAuditQueryResult = Apollo.QueryResult<MeJournalActionAuditQuery, MeJournalActionAuditQueryVariables>;
export const MeSessionDocument = /*#__PURE__*/ gql`
    query meSession {
  users {
    me_sessions {
      items {
        ...SessionFragment
      }
      totalCount
    }
  }
}
    ${SessionFragmentFragmentDoc}`;

/**
 * __useMeSessionQuery__
 *
 * To run a query within a React component, call `useMeSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeSessionQuery(baseOptions?: Apollo.QueryHookOptions<MeSessionQuery, MeSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeSessionQuery, MeSessionQueryVariables>(MeSessionDocument, options);
      }
export function useMeSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeSessionQuery, MeSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeSessionQuery, MeSessionQueryVariables>(MeSessionDocument, options);
        }
export function useMeSessionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeSessionQuery, MeSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeSessionQuery, MeSessionQueryVariables>(MeSessionDocument, options);
        }
export type MeSessionQueryHookResult = ReturnType<typeof useMeSessionQuery>;
export type MeSessionLazyQueryHookResult = ReturnType<typeof useMeSessionLazyQuery>;
export type MeSessionSuspenseQueryHookResult = ReturnType<typeof useMeSessionSuspenseQuery>;
export type MeSessionQueryResult = Apollo.QueryResult<MeSessionQuery, MeSessionQueryVariables>;
export const TerminateSessionForMeDocument = /*#__PURE__*/ gql`
    mutation terminateSessionForMe($sid: String!) {
  users {
    terminate_session_for_me(sid: $sid)
  }
}
    `;
export type TerminateSessionForMeMutationFn = Apollo.MutationFunction<TerminateSessionForMeMutation, TerminateSessionForMeMutationVariables>;

/**
 * __useTerminateSessionForMeMutation__
 *
 * To run a mutation, you first call `useTerminateSessionForMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateSessionForMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateSessionForMeMutation, { data, loading, error }] = useTerminateSessionForMeMutation({
 *   variables: {
 *      sid: // value for 'sid'
 *   },
 * });
 */
export function useTerminateSessionForMeMutation(baseOptions?: Apollo.MutationHookOptions<TerminateSessionForMeMutation, TerminateSessionForMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TerminateSessionForMeMutation, TerminateSessionForMeMutationVariables>(TerminateSessionForMeDocument, options);
      }
export type TerminateSessionForMeMutationHookResult = ReturnType<typeof useTerminateSessionForMeMutation>;
export type TerminateSessionForMeMutationResult = Apollo.MutationResult<TerminateSessionForMeMutation>;
export type TerminateSessionForMeMutationOptions = Apollo.BaseMutationOptions<TerminateSessionForMeMutation, TerminateSessionForMeMutationVariables>;
export const SignInDocument = /*#__PURE__*/ gql`
    mutation SignIn($data: SignInRequestDto!) {
  authentication {
    signIn(data: $data) {
      refreshToken
      accessTokenExpTimestamp
    }
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const InfrastructureCalculationsByBranchRequestDocument = /*#__PURE__*/ gql`
    mutation InfrastructureCalculationsByBranchRequest($where: IndicatorsMutationResolver_InfrastructureCalculationsByBranch_FilterInputType) {
  indicators {
    infrastructure_calculations_by_branch(where: $where)
  }
}
    `;
export type InfrastructureCalculationsByBranchRequestMutationFn = Apollo.MutationFunction<InfrastructureCalculationsByBranchRequestMutation, InfrastructureCalculationsByBranchRequestMutationVariables>;

/**
 * __useInfrastructureCalculationsByBranchRequestMutation__
 *
 * To run a mutation, you first call `useInfrastructureCalculationsByBranchRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureCalculationsByBranchRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [infrastructureCalculationsByBranchRequestMutation, { data, loading, error }] = useInfrastructureCalculationsByBranchRequestMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInfrastructureCalculationsByBranchRequestMutation(baseOptions?: Apollo.MutationHookOptions<InfrastructureCalculationsByBranchRequestMutation, InfrastructureCalculationsByBranchRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfrastructureCalculationsByBranchRequestMutation, InfrastructureCalculationsByBranchRequestMutationVariables>(InfrastructureCalculationsByBranchRequestDocument, options);
      }
export type InfrastructureCalculationsByBranchRequestMutationHookResult = ReturnType<typeof useInfrastructureCalculationsByBranchRequestMutation>;
export type InfrastructureCalculationsByBranchRequestMutationResult = Apollo.MutationResult<InfrastructureCalculationsByBranchRequestMutation>;
export type InfrastructureCalculationsByBranchRequestMutationOptions = Apollo.BaseMutationOptions<InfrastructureCalculationsByBranchRequestMutation, InfrastructureCalculationsByBranchRequestMutationVariables>;
export const InfrastructureCalculationsByBranchResponseDocument = /*#__PURE__*/ gql`
    query InfrastructureCalculationsByBranchResponse($key: String!) {
  indicators {
    infrastructure_calculations_by_branch_response(key: $key) {
      ...InfrastructureCalculationByBranchBaseFragment
    }
  }
}
    ${InfrastructureCalculationByBranchBaseFragmentFragmentDoc}`;

/**
 * __useInfrastructureCalculationsByBranchResponseQuery__
 *
 * To run a query within a React component, call `useInfrastructureCalculationsByBranchResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureCalculationsByBranchResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureCalculationsByBranchResponseQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useInfrastructureCalculationsByBranchResponseQuery(baseOptions: Apollo.QueryHookOptions<InfrastructureCalculationsByBranchResponseQuery, InfrastructureCalculationsByBranchResponseQueryVariables> & ({ variables: InfrastructureCalculationsByBranchResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureCalculationsByBranchResponseQuery, InfrastructureCalculationsByBranchResponseQueryVariables>(InfrastructureCalculationsByBranchResponseDocument, options);
      }
export function useInfrastructureCalculationsByBranchResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureCalculationsByBranchResponseQuery, InfrastructureCalculationsByBranchResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureCalculationsByBranchResponseQuery, InfrastructureCalculationsByBranchResponseQueryVariables>(InfrastructureCalculationsByBranchResponseDocument, options);
        }
export function useInfrastructureCalculationsByBranchResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfrastructureCalculationsByBranchResponseQuery, InfrastructureCalculationsByBranchResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureCalculationsByBranchResponseQuery, InfrastructureCalculationsByBranchResponseQueryVariables>(InfrastructureCalculationsByBranchResponseDocument, options);
        }
export type InfrastructureCalculationsByBranchResponseQueryHookResult = ReturnType<typeof useInfrastructureCalculationsByBranchResponseQuery>;
export type InfrastructureCalculationsByBranchResponseLazyQueryHookResult = ReturnType<typeof useInfrastructureCalculationsByBranchResponseLazyQuery>;
export type InfrastructureCalculationsByBranchResponseSuspenseQueryHookResult = ReturnType<typeof useInfrastructureCalculationsByBranchResponseSuspenseQuery>;
export type InfrastructureCalculationsByBranchResponseQueryResult = Apollo.QueryResult<InfrastructureCalculationsByBranchResponseQuery, InfrastructureCalculationsByBranchResponseQueryVariables>;
export const LocomotiveFinalCalculationsDocument = /*#__PURE__*/ gql`
    mutation LocomotiveFinalCalculations($data: LocomotiveFinalCalculationsByDirectoratesRequestDto!, $where: TrainMutationResolver_LocomotiveFinalCalculationsByDirectorates_FilterInputType) {
  train {
    locomotive_final_calculations_by_directorates_request(
      data: $data
      where: $where
    )
  }
}
    `;
export type LocomotiveFinalCalculationsMutationFn = Apollo.MutationFunction<LocomotiveFinalCalculationsMutation, LocomotiveFinalCalculationsMutationVariables>;

/**
 * __useLocomotiveFinalCalculationsMutation__
 *
 * To run a mutation, you first call `useLocomotiveFinalCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveFinalCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locomotiveFinalCalculationsMutation, { data, loading, error }] = useLocomotiveFinalCalculationsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLocomotiveFinalCalculationsMutation(baseOptions?: Apollo.MutationHookOptions<LocomotiveFinalCalculationsMutation, LocomotiveFinalCalculationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocomotiveFinalCalculationsMutation, LocomotiveFinalCalculationsMutationVariables>(LocomotiveFinalCalculationsDocument, options);
      }
export type LocomotiveFinalCalculationsMutationHookResult = ReturnType<typeof useLocomotiveFinalCalculationsMutation>;
export type LocomotiveFinalCalculationsMutationResult = Apollo.MutationResult<LocomotiveFinalCalculationsMutation>;
export type LocomotiveFinalCalculationsMutationOptions = Apollo.BaseMutationOptions<LocomotiveFinalCalculationsMutation, LocomotiveFinalCalculationsMutationVariables>;
export const LocomotiveFinalCalculationsResponseDocument = /*#__PURE__*/ gql`
    query locomotiveFinalCalculationsResponse($key: String!) {
  train {
    locomotive_final_calculations_by_directorates_response(key: $key) {
      items {
        ...LocomotiveFinalCalculationsByDirectoratesItemBaseFragment
      }
      total {
        ...LocomotiveFinalCalculationsByDirectoratesItemBaseFragment
      }
    }
  }
}
    ${LocomotiveFinalCalculationsByDirectoratesItemBaseFragmentFragmentDoc}`;

/**
 * __useLocomotiveFinalCalculationsResponseQuery__
 *
 * To run a query within a React component, call `useLocomotiveFinalCalculationsResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveFinalCalculationsResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveFinalCalculationsResponseQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useLocomotiveFinalCalculationsResponseQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveFinalCalculationsResponseQuery, LocomotiveFinalCalculationsResponseQueryVariables> & ({ variables: LocomotiveFinalCalculationsResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveFinalCalculationsResponseQuery, LocomotiveFinalCalculationsResponseQueryVariables>(LocomotiveFinalCalculationsResponseDocument, options);
      }
export function useLocomotiveFinalCalculationsResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveFinalCalculationsResponseQuery, LocomotiveFinalCalculationsResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveFinalCalculationsResponseQuery, LocomotiveFinalCalculationsResponseQueryVariables>(LocomotiveFinalCalculationsResponseDocument, options);
        }
export function useLocomotiveFinalCalculationsResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveFinalCalculationsResponseQuery, LocomotiveFinalCalculationsResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveFinalCalculationsResponseQuery, LocomotiveFinalCalculationsResponseQueryVariables>(LocomotiveFinalCalculationsResponseDocument, options);
        }
export type LocomotiveFinalCalculationsResponseQueryHookResult = ReturnType<typeof useLocomotiveFinalCalculationsResponseQuery>;
export type LocomotiveFinalCalculationsResponseLazyQueryHookResult = ReturnType<typeof useLocomotiveFinalCalculationsResponseLazyQuery>;
export type LocomotiveFinalCalculationsResponseSuspenseQueryHookResult = ReturnType<typeof useLocomotiveFinalCalculationsResponseSuspenseQuery>;
export type LocomotiveFinalCalculationsResponseQueryResult = Apollo.QueryResult<LocomotiveFinalCalculationsResponseQuery, LocomotiveFinalCalculationsResponseQueryVariables>;
export const MvpsCalculationsByBranchRequestDocument = /*#__PURE__*/ gql`
    mutation MvpsCalculationsByBranchRequest($where: IndicatorsMutationResolver_MvpsCalculationsByBranchRequest_FilterInputType, $paginate: PaginatorArgsDto) {
  indicators {
    mvps_calculations_by_branch_request(where: $where, paginate: $paginate)
  }
}
    `;
export type MvpsCalculationsByBranchRequestMutationFn = Apollo.MutationFunction<MvpsCalculationsByBranchRequestMutation, MvpsCalculationsByBranchRequestMutationVariables>;

/**
 * __useMvpsCalculationsByBranchRequestMutation__
 *
 * To run a mutation, you first call `useMvpsCalculationsByBranchRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMvpsCalculationsByBranchRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mvpsCalculationsByBranchRequestMutation, { data, loading, error }] = useMvpsCalculationsByBranchRequestMutation({
 *   variables: {
 *      where: // value for 'where'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useMvpsCalculationsByBranchRequestMutation(baseOptions?: Apollo.MutationHookOptions<MvpsCalculationsByBranchRequestMutation, MvpsCalculationsByBranchRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MvpsCalculationsByBranchRequestMutation, MvpsCalculationsByBranchRequestMutationVariables>(MvpsCalculationsByBranchRequestDocument, options);
      }
export type MvpsCalculationsByBranchRequestMutationHookResult = ReturnType<typeof useMvpsCalculationsByBranchRequestMutation>;
export type MvpsCalculationsByBranchRequestMutationResult = Apollo.MutationResult<MvpsCalculationsByBranchRequestMutation>;
export type MvpsCalculationsByBranchRequestMutationOptions = Apollo.BaseMutationOptions<MvpsCalculationsByBranchRequestMutation, MvpsCalculationsByBranchRequestMutationVariables>;
export const MvpsCalculationsByBranchResponseDocument = /*#__PURE__*/ gql`
    query MvpsCalculationsByBranchResponse($key: String!) {
  indicators {
    mvps_calculations_by_branch_response(key: $key) {
      ...MvpsCalculationByBranchBaseFragment
    }
  }
}
    ${MvpsCalculationByBranchBaseFragmentFragmentDoc}`;

/**
 * __useMvpsCalculationsByBranchResponseQuery__
 *
 * To run a query within a React component, call `useMvpsCalculationsByBranchResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvpsCalculationsByBranchResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvpsCalculationsByBranchResponseQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useMvpsCalculationsByBranchResponseQuery(baseOptions: Apollo.QueryHookOptions<MvpsCalculationsByBranchResponseQuery, MvpsCalculationsByBranchResponseQueryVariables> & ({ variables: MvpsCalculationsByBranchResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvpsCalculationsByBranchResponseQuery, MvpsCalculationsByBranchResponseQueryVariables>(MvpsCalculationsByBranchResponseDocument, options);
      }
export function useMvpsCalculationsByBranchResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvpsCalculationsByBranchResponseQuery, MvpsCalculationsByBranchResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvpsCalculationsByBranchResponseQuery, MvpsCalculationsByBranchResponseQueryVariables>(MvpsCalculationsByBranchResponseDocument, options);
        }
export function useMvpsCalculationsByBranchResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvpsCalculationsByBranchResponseQuery, MvpsCalculationsByBranchResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvpsCalculationsByBranchResponseQuery, MvpsCalculationsByBranchResponseQueryVariables>(MvpsCalculationsByBranchResponseDocument, options);
        }
export type MvpsCalculationsByBranchResponseQueryHookResult = ReturnType<typeof useMvpsCalculationsByBranchResponseQuery>;
export type MvpsCalculationsByBranchResponseLazyQueryHookResult = ReturnType<typeof useMvpsCalculationsByBranchResponseLazyQuery>;
export type MvpsCalculationsByBranchResponseSuspenseQueryHookResult = ReturnType<typeof useMvpsCalculationsByBranchResponseSuspenseQuery>;
export type MvpsCalculationsByBranchResponseQueryResult = Apollo.QueryResult<MvpsCalculationsByBranchResponseQuery, MvpsCalculationsByBranchResponseQueryVariables>;
export const TrainFinalCalculationMvpsCompanyAffiliationListDocument = /*#__PURE__*/ gql`
    query trainFinalCalculationMvpsCompanyAffiliationList($paginate: PaginatorArgsDto, $orderBy: [MvpsCompanyAffiliationQueryResolver_List_SortingInputType!], $where: MvpsCompanyAffiliationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    mvpsCompanyAffiliation {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...MvpsCompanyAffiliationShortFragment
        }
      }
    }
  }
}
    ${MvpsCompanyAffiliationShortFragmentFragmentDoc}`;

/**
 * __useTrainFinalCalculationMvpsCompanyAffiliationListQuery__
 *
 * To run a query within a React component, call `useTrainFinalCalculationMvpsCompanyAffiliationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainFinalCalculationMvpsCompanyAffiliationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainFinalCalculationMvpsCompanyAffiliationListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainFinalCalculationMvpsCompanyAffiliationListQuery(baseOptions: Apollo.QueryHookOptions<TrainFinalCalculationMvpsCompanyAffiliationListQuery, TrainFinalCalculationMvpsCompanyAffiliationListQueryVariables> & ({ variables: TrainFinalCalculationMvpsCompanyAffiliationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainFinalCalculationMvpsCompanyAffiliationListQuery, TrainFinalCalculationMvpsCompanyAffiliationListQueryVariables>(TrainFinalCalculationMvpsCompanyAffiliationListDocument, options);
      }
export function useTrainFinalCalculationMvpsCompanyAffiliationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainFinalCalculationMvpsCompanyAffiliationListQuery, TrainFinalCalculationMvpsCompanyAffiliationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainFinalCalculationMvpsCompanyAffiliationListQuery, TrainFinalCalculationMvpsCompanyAffiliationListQueryVariables>(TrainFinalCalculationMvpsCompanyAffiliationListDocument, options);
        }
export function useTrainFinalCalculationMvpsCompanyAffiliationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainFinalCalculationMvpsCompanyAffiliationListQuery, TrainFinalCalculationMvpsCompanyAffiliationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainFinalCalculationMvpsCompanyAffiliationListQuery, TrainFinalCalculationMvpsCompanyAffiliationListQueryVariables>(TrainFinalCalculationMvpsCompanyAffiliationListDocument, options);
        }
export type TrainFinalCalculationMvpsCompanyAffiliationListQueryHookResult = ReturnType<typeof useTrainFinalCalculationMvpsCompanyAffiliationListQuery>;
export type TrainFinalCalculationMvpsCompanyAffiliationListLazyQueryHookResult = ReturnType<typeof useTrainFinalCalculationMvpsCompanyAffiliationListLazyQuery>;
export type TrainFinalCalculationMvpsCompanyAffiliationListSuspenseQueryHookResult = ReturnType<typeof useTrainFinalCalculationMvpsCompanyAffiliationListSuspenseQuery>;
export type TrainFinalCalculationMvpsCompanyAffiliationListQueryResult = Apollo.QueryResult<TrainFinalCalculationMvpsCompanyAffiliationListQuery, TrainFinalCalculationMvpsCompanyAffiliationListQueryVariables>;
export const TrainFinalCalculationStructuralSubdivisionListDocument = /*#__PURE__*/ gql`
    query trainFinalCalculationStructuralSubdivisionList($paginate: PaginatorArgsDto, $orderBy: [StructuralSubdivisionQueryResolver_List_SortingInputType!], $where: StructuralSubdivisionQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    structuralSubdivision {
      list(paginate: $paginate, order_by: $orderBy, where: $where, range: $range) {
        totalCount
        items {
          ...StructuralSubdivisionBaseFragment
          branch {
            ...BranchShortFragment
            railways {
              ...RailwayShortFragment
              railway_administration {
                ...RailwayAdministrationBaseFragment
              }
            }
          }
          station {
            ...StationBaseFragment
            railway {
              ...RailwayBaseFragment
              railway_administration {
                ...RailwayAdministrationBaseFragment
              }
            }
          }
        }
      }
    }
  }
}
    ${StructuralSubdivisionBaseFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${RailwayShortFragmentFragmentDoc}
${RailwayAdministrationBaseFragmentFragmentDoc}
${StationBaseFragmentFragmentDoc}
${RailwayBaseFragmentFragmentDoc}`;

/**
 * __useTrainFinalCalculationStructuralSubdivisionListQuery__
 *
 * To run a query within a React component, call `useTrainFinalCalculationStructuralSubdivisionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainFinalCalculationStructuralSubdivisionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainFinalCalculationStructuralSubdivisionListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainFinalCalculationStructuralSubdivisionListQuery(baseOptions: Apollo.QueryHookOptions<TrainFinalCalculationStructuralSubdivisionListQuery, TrainFinalCalculationStructuralSubdivisionListQueryVariables> & ({ variables: TrainFinalCalculationStructuralSubdivisionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainFinalCalculationStructuralSubdivisionListQuery, TrainFinalCalculationStructuralSubdivisionListQueryVariables>(TrainFinalCalculationStructuralSubdivisionListDocument, options);
      }
export function useTrainFinalCalculationStructuralSubdivisionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainFinalCalculationStructuralSubdivisionListQuery, TrainFinalCalculationStructuralSubdivisionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainFinalCalculationStructuralSubdivisionListQuery, TrainFinalCalculationStructuralSubdivisionListQueryVariables>(TrainFinalCalculationStructuralSubdivisionListDocument, options);
        }
export function useTrainFinalCalculationStructuralSubdivisionListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainFinalCalculationStructuralSubdivisionListQuery, TrainFinalCalculationStructuralSubdivisionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainFinalCalculationStructuralSubdivisionListQuery, TrainFinalCalculationStructuralSubdivisionListQueryVariables>(TrainFinalCalculationStructuralSubdivisionListDocument, options);
        }
export type TrainFinalCalculationStructuralSubdivisionListQueryHookResult = ReturnType<typeof useTrainFinalCalculationStructuralSubdivisionListQuery>;
export type TrainFinalCalculationStructuralSubdivisionListLazyQueryHookResult = ReturnType<typeof useTrainFinalCalculationStructuralSubdivisionListLazyQuery>;
export type TrainFinalCalculationStructuralSubdivisionListSuspenseQueryHookResult = ReturnType<typeof useTrainFinalCalculationStructuralSubdivisionListSuspenseQuery>;
export type TrainFinalCalculationStructuralSubdivisionListQueryResult = Apollo.QueryResult<TrainFinalCalculationStructuralSubdivisionListQuery, TrainFinalCalculationStructuralSubdivisionListQueryVariables>;
export const CarriageGroupsFinalCalculationsDocument = /*#__PURE__*/ gql`
    mutation carriageGroupsFinalCalculations($data: CarriageGroupIndicatorsFinalCalculationRequestDto!, $where: IndicatorsMutationResolver_CarriageGroupsFinalCalculations_FilterInputType) {
  indicators {
    carriage_groups_final_calculations(where: $where, data: $data)
  }
}
    `;
export type CarriageGroupsFinalCalculationsMutationFn = Apollo.MutationFunction<CarriageGroupsFinalCalculationsMutation, CarriageGroupsFinalCalculationsMutationVariables>;

/**
 * __useCarriageGroupsFinalCalculationsMutation__
 *
 * To run a mutation, you first call `useCarriageGroupsFinalCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupsFinalCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carriageGroupsFinalCalculationsMutation, { data, loading, error }] = useCarriageGroupsFinalCalculationsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCarriageGroupsFinalCalculationsMutation(baseOptions?: Apollo.MutationHookOptions<CarriageGroupsFinalCalculationsMutation, CarriageGroupsFinalCalculationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarriageGroupsFinalCalculationsMutation, CarriageGroupsFinalCalculationsMutationVariables>(CarriageGroupsFinalCalculationsDocument, options);
      }
export type CarriageGroupsFinalCalculationsMutationHookResult = ReturnType<typeof useCarriageGroupsFinalCalculationsMutation>;
export type CarriageGroupsFinalCalculationsMutationResult = Apollo.MutationResult<CarriageGroupsFinalCalculationsMutation>;
export type CarriageGroupsFinalCalculationsMutationOptions = Apollo.BaseMutationOptions<CarriageGroupsFinalCalculationsMutation, CarriageGroupsFinalCalculationsMutationVariables>;
export const CarriageGroupsFinalCalculationsResponseDocument = /*#__PURE__*/ gql`
    query carriageGroupsFinalCalculationsResponse($key: String!) {
  indicators {
    carriage_groups_final_calculations_response(key: $key) {
      items {
        items {
          name
          total {
            ...FinalCalculationsTotalRowBaseFragment
          }
        }
        name
        total {
          ...FinalCalculationsTotalRowBaseFragment
        }
      }
      total {
        ...FinalCalculationsTotalRowBaseFragment
      }
    }
  }
}
    ${FinalCalculationsTotalRowBaseFragmentFragmentDoc}`;

/**
 * __useCarriageGroupsFinalCalculationsResponseQuery__
 *
 * To run a query within a React component, call `useCarriageGroupsFinalCalculationsResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriageGroupsFinalCalculationsResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriageGroupsFinalCalculationsResponseQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useCarriageGroupsFinalCalculationsResponseQuery(baseOptions: Apollo.QueryHookOptions<CarriageGroupsFinalCalculationsResponseQuery, CarriageGroupsFinalCalculationsResponseQueryVariables> & ({ variables: CarriageGroupsFinalCalculationsResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriageGroupsFinalCalculationsResponseQuery, CarriageGroupsFinalCalculationsResponseQueryVariables>(CarriageGroupsFinalCalculationsResponseDocument, options);
      }
export function useCarriageGroupsFinalCalculationsResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriageGroupsFinalCalculationsResponseQuery, CarriageGroupsFinalCalculationsResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriageGroupsFinalCalculationsResponseQuery, CarriageGroupsFinalCalculationsResponseQueryVariables>(CarriageGroupsFinalCalculationsResponseDocument, options);
        }
export function useCarriageGroupsFinalCalculationsResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarriageGroupsFinalCalculationsResponseQuery, CarriageGroupsFinalCalculationsResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarriageGroupsFinalCalculationsResponseQuery, CarriageGroupsFinalCalculationsResponseQueryVariables>(CarriageGroupsFinalCalculationsResponseDocument, options);
        }
export type CarriageGroupsFinalCalculationsResponseQueryHookResult = ReturnType<typeof useCarriageGroupsFinalCalculationsResponseQuery>;
export type CarriageGroupsFinalCalculationsResponseLazyQueryHookResult = ReturnType<typeof useCarriageGroupsFinalCalculationsResponseLazyQuery>;
export type CarriageGroupsFinalCalculationsResponseSuspenseQueryHookResult = ReturnType<typeof useCarriageGroupsFinalCalculationsResponseSuspenseQuery>;
export type CarriageGroupsFinalCalculationsResponseQueryResult = Apollo.QueryResult<CarriageGroupsFinalCalculationsResponseQuery, CarriageGroupsFinalCalculationsResponseQueryVariables>;
export const CreateTrailedDirectGroupDocument = /*#__PURE__*/ gql`
    mutation createTrailedDirectGroup($data: CreateTrailedDirectGroupDto!) {
  carriageGroups {
    createTrailedDirectGroup(data: $data)
  }
}
    `;
export type CreateTrailedDirectGroupMutationFn = Apollo.MutationFunction<CreateTrailedDirectGroupMutation, CreateTrailedDirectGroupMutationVariables>;

/**
 * __useCreateTrailedDirectGroupMutation__
 *
 * To run a mutation, you first call `useCreateTrailedDirectGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrailedDirectGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrailedDirectGroupMutation, { data, loading, error }] = useCreateTrailedDirectGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTrailedDirectGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrailedDirectGroupMutation, CreateTrailedDirectGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrailedDirectGroupMutation, CreateTrailedDirectGroupMutationVariables>(CreateTrailedDirectGroupDocument, options);
      }
export type CreateTrailedDirectGroupMutationHookResult = ReturnType<typeof useCreateTrailedDirectGroupMutation>;
export type CreateTrailedDirectGroupMutationResult = Apollo.MutationResult<CreateTrailedDirectGroupMutation>;
export type CreateTrailedDirectGroupMutationOptions = Apollo.BaseMutationOptions<CreateTrailedDirectGroupMutation, CreateTrailedDirectGroupMutationVariables>;
export const CreateTrailedDirectGroupCarriageGroupListDocument = /*#__PURE__*/ gql`
    query createTrailedDirectGroupCarriageGroupList($paginate: PaginatorArgsDto, $orderBy: [CarriageGroupQueryResolver_CarriageGroupList_SortingInputType!], $where: CarriageGroupQueryResolver_CarriageGroupList_FilterInputType, $search: String!) {
  carriageGroups {
    carriageGroupList(
      paginate: $paginate
      order_by: $orderBy
      where: $where
      search: $search
    ) {
      totalCount
      items {
        id
        name
        status
      }
    }
  }
}
    `;

/**
 * __useCreateTrailedDirectGroupCarriageGroupListQuery__
 *
 * To run a query within a React component, call `useCreateTrailedDirectGroupCarriageGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateTrailedDirectGroupCarriageGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateTrailedDirectGroupCarriageGroupListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCreateTrailedDirectGroupCarriageGroupListQuery(baseOptions: Apollo.QueryHookOptions<CreateTrailedDirectGroupCarriageGroupListQuery, CreateTrailedDirectGroupCarriageGroupListQueryVariables> & ({ variables: CreateTrailedDirectGroupCarriageGroupListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateTrailedDirectGroupCarriageGroupListQuery, CreateTrailedDirectGroupCarriageGroupListQueryVariables>(CreateTrailedDirectGroupCarriageGroupListDocument, options);
      }
export function useCreateTrailedDirectGroupCarriageGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateTrailedDirectGroupCarriageGroupListQuery, CreateTrailedDirectGroupCarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateTrailedDirectGroupCarriageGroupListQuery, CreateTrailedDirectGroupCarriageGroupListQueryVariables>(CreateTrailedDirectGroupCarriageGroupListDocument, options);
        }
export function useCreateTrailedDirectGroupCarriageGroupListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateTrailedDirectGroupCarriageGroupListQuery, CreateTrailedDirectGroupCarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateTrailedDirectGroupCarriageGroupListQuery, CreateTrailedDirectGroupCarriageGroupListQueryVariables>(CreateTrailedDirectGroupCarriageGroupListDocument, options);
        }
export type CreateTrailedDirectGroupCarriageGroupListQueryHookResult = ReturnType<typeof useCreateTrailedDirectGroupCarriageGroupListQuery>;
export type CreateTrailedDirectGroupCarriageGroupListLazyQueryHookResult = ReturnType<typeof useCreateTrailedDirectGroupCarriageGroupListLazyQuery>;
export type CreateTrailedDirectGroupCarriageGroupListSuspenseQueryHookResult = ReturnType<typeof useCreateTrailedDirectGroupCarriageGroupListSuspenseQuery>;
export type CreateTrailedDirectGroupCarriageGroupListQueryResult = Apollo.QueryResult<CreateTrailedDirectGroupCarriageGroupListQuery, CreateTrailedDirectGroupCarriageGroupListQueryVariables>;
export const DeleteTrailedDirectGroupDocument = /*#__PURE__*/ gql`
    mutation deleteTrailedDirectGroup($id: Float!) {
  carriageGroups {
    deleteTrailedDirectGroup(id: $id)
  }
}
    `;
export type DeleteTrailedDirectGroupMutationFn = Apollo.MutationFunction<DeleteTrailedDirectGroupMutation, DeleteTrailedDirectGroupMutationVariables>;

/**
 * __useDeleteTrailedDirectGroupMutation__
 *
 * To run a mutation, you first call `useDeleteTrailedDirectGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrailedDirectGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrailedDirectGroupMutation, { data, loading, error }] = useDeleteTrailedDirectGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrailedDirectGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrailedDirectGroupMutation, DeleteTrailedDirectGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrailedDirectGroupMutation, DeleteTrailedDirectGroupMutationVariables>(DeleteTrailedDirectGroupDocument, options);
      }
export type DeleteTrailedDirectGroupMutationHookResult = ReturnType<typeof useDeleteTrailedDirectGroupMutation>;
export type DeleteTrailedDirectGroupMutationResult = Apollo.MutationResult<DeleteTrailedDirectGroupMutation>;
export type DeleteTrailedDirectGroupMutationOptions = Apollo.BaseMutationOptions<DeleteTrailedDirectGroupMutation, DeleteTrailedDirectGroupMutationVariables>;
export const ExportTrailedDirectGroupListDocument = /*#__PURE__*/ gql`
    mutation exportTrailedDirectGroupList($where: CarriageGroupMutationResolver_ExportTrailedDirectGroupsList_FilterInputType!) {
  carriageGroups {
    exportTrailedDirectGroupsList(where: $where)
  }
}
    `;
export type ExportTrailedDirectGroupListMutationFn = Apollo.MutationFunction<ExportTrailedDirectGroupListMutation, ExportTrailedDirectGroupListMutationVariables>;

/**
 * __useExportTrailedDirectGroupListMutation__
 *
 * To run a mutation, you first call `useExportTrailedDirectGroupListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportTrailedDirectGroupListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportTrailedDirectGroupListMutation, { data, loading, error }] = useExportTrailedDirectGroupListMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExportTrailedDirectGroupListMutation(baseOptions?: Apollo.MutationHookOptions<ExportTrailedDirectGroupListMutation, ExportTrailedDirectGroupListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportTrailedDirectGroupListMutation, ExportTrailedDirectGroupListMutationVariables>(ExportTrailedDirectGroupListDocument, options);
      }
export type ExportTrailedDirectGroupListMutationHookResult = ReturnType<typeof useExportTrailedDirectGroupListMutation>;
export type ExportTrailedDirectGroupListMutationResult = Apollo.MutationResult<ExportTrailedDirectGroupListMutation>;
export type ExportTrailedDirectGroupListMutationOptions = Apollo.BaseMutationOptions<ExportTrailedDirectGroupListMutation, ExportTrailedDirectGroupListMutationVariables>;
export const TrailedDirectGroupCarriageGroupByIdDocument = /*#__PURE__*/ gql`
    query trailedDirectGroupCarriageGroupById($id: Float!) {
  carriageGroups {
    carriageGroupById(id: $id) {
      id
      ...CarriageGroupBaseFragment
      turnovers {
        ...TurnoverBaseFragment
        station_from {
          ...StationShortFragment
        }
        station_to {
          ...StationShortFragment
        }
        train {
          ...TrainBaseFragment
          sub_category {
            entity_id
          }
          is_carriage_group_approval
        }
        schemas {
          ...TrainSchemaShortFragment
        }
        turnover_time_stagnations {
          ...TurnoverTimeStagnationBaseFragment
        }
      }
    }
  }
}
    ${CarriageGroupBaseFragmentFragmentDoc}
${TurnoverBaseFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}
${TrainBaseFragmentFragmentDoc}
${TrainSchemaShortFragmentFragmentDoc}
${TurnoverTimeStagnationBaseFragmentFragmentDoc}`;

/**
 * __useTrailedDirectGroupCarriageGroupByIdQuery__
 *
 * To run a query within a React component, call `useTrailedDirectGroupCarriageGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrailedDirectGroupCarriageGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrailedDirectGroupCarriageGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrailedDirectGroupCarriageGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<TrailedDirectGroupCarriageGroupByIdQuery, TrailedDirectGroupCarriageGroupByIdQueryVariables> & ({ variables: TrailedDirectGroupCarriageGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrailedDirectGroupCarriageGroupByIdQuery, TrailedDirectGroupCarriageGroupByIdQueryVariables>(TrailedDirectGroupCarriageGroupByIdDocument, options);
      }
export function useTrailedDirectGroupCarriageGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrailedDirectGroupCarriageGroupByIdQuery, TrailedDirectGroupCarriageGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrailedDirectGroupCarriageGroupByIdQuery, TrailedDirectGroupCarriageGroupByIdQueryVariables>(TrailedDirectGroupCarriageGroupByIdDocument, options);
        }
export function useTrailedDirectGroupCarriageGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrailedDirectGroupCarriageGroupByIdQuery, TrailedDirectGroupCarriageGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrailedDirectGroupCarriageGroupByIdQuery, TrailedDirectGroupCarriageGroupByIdQueryVariables>(TrailedDirectGroupCarriageGroupByIdDocument, options);
        }
export type TrailedDirectGroupCarriageGroupByIdQueryHookResult = ReturnType<typeof useTrailedDirectGroupCarriageGroupByIdQuery>;
export type TrailedDirectGroupCarriageGroupByIdLazyQueryHookResult = ReturnType<typeof useTrailedDirectGroupCarriageGroupByIdLazyQuery>;
export type TrailedDirectGroupCarriageGroupByIdSuspenseQueryHookResult = ReturnType<typeof useTrailedDirectGroupCarriageGroupByIdSuspenseQuery>;
export type TrailedDirectGroupCarriageGroupByIdQueryResult = Apollo.QueryResult<TrailedDirectGroupCarriageGroupByIdQuery, TrailedDirectGroupCarriageGroupByIdQueryVariables>;
export const TrailedDirectGroupByIdDocument = /*#__PURE__*/ gql`
    query trailedDirectGroupById($id: Float!) {
  carriageGroups {
    trailedDirectGroupById(id: $id) {
      ...TrailedDirectGroupBaseFragment
      schedule {
        ...TrailedDirectGroupScheduleBaseFragment
      }
      route_details {
        direct {
          ...TrailedDirectGroupRouteDetailBaseFragment
        }
        reverse {
          ...TrailedDirectGroupRouteDetailBaseFragment
        }
      }
      gdp {
        ...GdpShortFragment
      }
    }
  }
}
    ${TrailedDirectGroupBaseFragmentFragmentDoc}
${TrailedDirectGroupScheduleBaseFragmentFragmentDoc}
${TrailedDirectGroupRouteDetailBaseFragmentFragmentDoc}
${GdpShortFragmentFragmentDoc}`;

/**
 * __useTrailedDirectGroupByIdQuery__
 *
 * To run a query within a React component, call `useTrailedDirectGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrailedDirectGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrailedDirectGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrailedDirectGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<TrailedDirectGroupByIdQuery, TrailedDirectGroupByIdQueryVariables> & ({ variables: TrailedDirectGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrailedDirectGroupByIdQuery, TrailedDirectGroupByIdQueryVariables>(TrailedDirectGroupByIdDocument, options);
      }
export function useTrailedDirectGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrailedDirectGroupByIdQuery, TrailedDirectGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrailedDirectGroupByIdQuery, TrailedDirectGroupByIdQueryVariables>(TrailedDirectGroupByIdDocument, options);
        }
export function useTrailedDirectGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrailedDirectGroupByIdQuery, TrailedDirectGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrailedDirectGroupByIdQuery, TrailedDirectGroupByIdQueryVariables>(TrailedDirectGroupByIdDocument, options);
        }
export type TrailedDirectGroupByIdQueryHookResult = ReturnType<typeof useTrailedDirectGroupByIdQuery>;
export type TrailedDirectGroupByIdLazyQueryHookResult = ReturnType<typeof useTrailedDirectGroupByIdLazyQuery>;
export type TrailedDirectGroupByIdSuspenseQueryHookResult = ReturnType<typeof useTrailedDirectGroupByIdSuspenseQuery>;
export type TrailedDirectGroupByIdQueryResult = Apollo.QueryResult<TrailedDirectGroupByIdQuery, TrailedDirectGroupByIdQueryVariables>;
export const TrailedDirectGroupDefaultFilterDocument = /*#__PURE__*/ gql`
    query trailedDirectGroupDefaultFilter($id: Float!) {
  carriageGroups {
    trailedDirectGroupById(id: $id) {
      carriage_group_id
      gdp {
        ...GdpShortFragment
      }
      rolling_stock_type
    }
  }
}
    ${GdpShortFragmentFragmentDoc}`;

/**
 * __useTrailedDirectGroupDefaultFilterQuery__
 *
 * To run a query within a React component, call `useTrailedDirectGroupDefaultFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrailedDirectGroupDefaultFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrailedDirectGroupDefaultFilterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrailedDirectGroupDefaultFilterQuery(baseOptions: Apollo.QueryHookOptions<TrailedDirectGroupDefaultFilterQuery, TrailedDirectGroupDefaultFilterQueryVariables> & ({ variables: TrailedDirectGroupDefaultFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrailedDirectGroupDefaultFilterQuery, TrailedDirectGroupDefaultFilterQueryVariables>(TrailedDirectGroupDefaultFilterDocument, options);
      }
export function useTrailedDirectGroupDefaultFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrailedDirectGroupDefaultFilterQuery, TrailedDirectGroupDefaultFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrailedDirectGroupDefaultFilterQuery, TrailedDirectGroupDefaultFilterQueryVariables>(TrailedDirectGroupDefaultFilterDocument, options);
        }
export function useTrailedDirectGroupDefaultFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrailedDirectGroupDefaultFilterQuery, TrailedDirectGroupDefaultFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrailedDirectGroupDefaultFilterQuery, TrailedDirectGroupDefaultFilterQueryVariables>(TrailedDirectGroupDefaultFilterDocument, options);
        }
export type TrailedDirectGroupDefaultFilterQueryHookResult = ReturnType<typeof useTrailedDirectGroupDefaultFilterQuery>;
export type TrailedDirectGroupDefaultFilterLazyQueryHookResult = ReturnType<typeof useTrailedDirectGroupDefaultFilterLazyQuery>;
export type TrailedDirectGroupDefaultFilterSuspenseQueryHookResult = ReturnType<typeof useTrailedDirectGroupDefaultFilterSuspenseQuery>;
export type TrailedDirectGroupDefaultFilterQueryResult = Apollo.QueryResult<TrailedDirectGroupDefaultFilterQuery, TrailedDirectGroupDefaultFilterQueryVariables>;
export const TrailedDirectGroupListDocument = /*#__PURE__*/ gql`
    query trailedDirectGroupList($paginate: PaginatorArgsDto, $where: CarriageGroupQueryResolver_TrailedDirectGroupList_FilterInputType, $search: String!, $orderBy: [CarriageGroupQueryResolver_TrailedDirectGroupList_SortingInputType!]) {
  carriageGroups {
    trailedDirectGroupList(
      paginate: $paginate
      where: $where
      search: $search
      order_by: $orderBy
    ) {
      totalCount
      items {
        ...TrailedDirectGroupViewFragment
      }
    }
  }
}
    ${TrailedDirectGroupViewFragmentFragmentDoc}`;

/**
 * __useTrailedDirectGroupListQuery__
 *
 * To run a query within a React component, call `useTrailedDirectGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrailedDirectGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrailedDirectGroupListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTrailedDirectGroupListQuery(baseOptions: Apollo.QueryHookOptions<TrailedDirectGroupListQuery, TrailedDirectGroupListQueryVariables> & ({ variables: TrailedDirectGroupListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrailedDirectGroupListQuery, TrailedDirectGroupListQueryVariables>(TrailedDirectGroupListDocument, options);
      }
export function useTrailedDirectGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrailedDirectGroupListQuery, TrailedDirectGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrailedDirectGroupListQuery, TrailedDirectGroupListQueryVariables>(TrailedDirectGroupListDocument, options);
        }
export function useTrailedDirectGroupListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrailedDirectGroupListQuery, TrailedDirectGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrailedDirectGroupListQuery, TrailedDirectGroupListQueryVariables>(TrailedDirectGroupListDocument, options);
        }
export type TrailedDirectGroupListQueryHookResult = ReturnType<typeof useTrailedDirectGroupListQuery>;
export type TrailedDirectGroupListLazyQueryHookResult = ReturnType<typeof useTrailedDirectGroupListLazyQuery>;
export type TrailedDirectGroupListSuspenseQueryHookResult = ReturnType<typeof useTrailedDirectGroupListSuspenseQuery>;
export type TrailedDirectGroupListQueryResult = Apollo.QueryResult<TrailedDirectGroupListQuery, TrailedDirectGroupListQueryVariables>;
export const TrailedDirectGroupsScheduleDocument = /*#__PURE__*/ gql`
    query trailedDirectGroupsSchedule($id: Float!) {
  carriageGroups {
    trailedDirectGroupById(id: $id) {
      schedule {
        ...TrailedDirectGroupScheduleBaseFragment
        schedule_fragments {
          ...TrailedDirectGroupScheduleFragmentBaseFragment
          station {
            ...TrailedDirectGroupStationBaseFragment
            railway {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${TrailedDirectGroupScheduleBaseFragmentFragmentDoc}
${TrailedDirectGroupScheduleFragmentBaseFragmentFragmentDoc}
${TrailedDirectGroupStationBaseFragmentFragmentDoc}`;

/**
 * __useTrailedDirectGroupsScheduleQuery__
 *
 * To run a query within a React component, call `useTrailedDirectGroupsScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrailedDirectGroupsScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrailedDirectGroupsScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrailedDirectGroupsScheduleQuery(baseOptions: Apollo.QueryHookOptions<TrailedDirectGroupsScheduleQuery, TrailedDirectGroupsScheduleQueryVariables> & ({ variables: TrailedDirectGroupsScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrailedDirectGroupsScheduleQuery, TrailedDirectGroupsScheduleQueryVariables>(TrailedDirectGroupsScheduleDocument, options);
      }
export function useTrailedDirectGroupsScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrailedDirectGroupsScheduleQuery, TrailedDirectGroupsScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrailedDirectGroupsScheduleQuery, TrailedDirectGroupsScheduleQueryVariables>(TrailedDirectGroupsScheduleDocument, options);
        }
export function useTrailedDirectGroupsScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrailedDirectGroupsScheduleQuery, TrailedDirectGroupsScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrailedDirectGroupsScheduleQuery, TrailedDirectGroupsScheduleQueryVariables>(TrailedDirectGroupsScheduleDocument, options);
        }
export type TrailedDirectGroupsScheduleQueryHookResult = ReturnType<typeof useTrailedDirectGroupsScheduleQuery>;
export type TrailedDirectGroupsScheduleLazyQueryHookResult = ReturnType<typeof useTrailedDirectGroupsScheduleLazyQuery>;
export type TrailedDirectGroupsScheduleSuspenseQueryHookResult = ReturnType<typeof useTrailedDirectGroupsScheduleSuspenseQuery>;
export type TrailedDirectGroupsScheduleQueryResult = Apollo.QueryResult<TrailedDirectGroupsScheduleQuery, TrailedDirectGroupsScheduleQueryVariables>;
export const TrailedDirectGroupsSchemeDocument = /*#__PURE__*/ gql`
    query trailedDirectGroupsScheme($id: Float!) {
  carriageGroups {
    trailedDirectGroupById(id: $id) {
      schema {
        parameters {
          ...TrailedDirectGroupSchemaParametersBaseFragment
        }
        summary {
          ...TrailedDirectGroupSchemaSummaryBaseFragment
        }
        additional_info {
          ...TrailedDirectGroupSchemaAdditionalInfoBaseFragment
        }
        periodicity_info {
          ...TrailedDirectGroupSchemaPeriodicityInfoBaseFragment
        }
      }
    }
  }
}
    ${TrailedDirectGroupSchemaParametersBaseFragmentFragmentDoc}
${TrailedDirectGroupSchemaSummaryBaseFragmentFragmentDoc}
${TrailedDirectGroupSchemaAdditionalInfoBaseFragmentFragmentDoc}
${TrailedDirectGroupSchemaPeriodicityInfoBaseFragmentFragmentDoc}`;

/**
 * __useTrailedDirectGroupsSchemeQuery__
 *
 * To run a query within a React component, call `useTrailedDirectGroupsSchemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrailedDirectGroupsSchemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrailedDirectGroupsSchemeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrailedDirectGroupsSchemeQuery(baseOptions: Apollo.QueryHookOptions<TrailedDirectGroupsSchemeQuery, TrailedDirectGroupsSchemeQueryVariables> & ({ variables: TrailedDirectGroupsSchemeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrailedDirectGroupsSchemeQuery, TrailedDirectGroupsSchemeQueryVariables>(TrailedDirectGroupsSchemeDocument, options);
      }
export function useTrailedDirectGroupsSchemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrailedDirectGroupsSchemeQuery, TrailedDirectGroupsSchemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrailedDirectGroupsSchemeQuery, TrailedDirectGroupsSchemeQueryVariables>(TrailedDirectGroupsSchemeDocument, options);
        }
export function useTrailedDirectGroupsSchemeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrailedDirectGroupsSchemeQuery, TrailedDirectGroupsSchemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrailedDirectGroupsSchemeQuery, TrailedDirectGroupsSchemeQueryVariables>(TrailedDirectGroupsSchemeDocument, options);
        }
export type TrailedDirectGroupsSchemeQueryHookResult = ReturnType<typeof useTrailedDirectGroupsSchemeQuery>;
export type TrailedDirectGroupsSchemeLazyQueryHookResult = ReturnType<typeof useTrailedDirectGroupsSchemeLazyQuery>;
export type TrailedDirectGroupsSchemeSuspenseQueryHookResult = ReturnType<typeof useTrailedDirectGroupsSchemeSuspenseQuery>;
export type TrailedDirectGroupsSchemeQueryResult = Apollo.QueryResult<TrailedDirectGroupsSchemeQuery, TrailedDirectGroupsSchemeQueryVariables>;
export const ExportTrailedDirectGroupCarriageGroupListDocument = /*#__PURE__*/ gql`
    mutation exportTrailedDirectGroupCarriageGroupList($where: CarriageGroupMutationResolver_ExportCarriageGroupsList_FilterInputType!) {
  carriageGroups {
    exportCarriageGroupsList(where: $where)
  }
}
    `;
export type ExportTrailedDirectGroupCarriageGroupListMutationFn = Apollo.MutationFunction<ExportTrailedDirectGroupCarriageGroupListMutation, ExportTrailedDirectGroupCarriageGroupListMutationVariables>;

/**
 * __useExportTrailedDirectGroupCarriageGroupListMutation__
 *
 * To run a mutation, you first call `useExportTrailedDirectGroupCarriageGroupListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportTrailedDirectGroupCarriageGroupListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportTrailedDirectGroupCarriageGroupListMutation, { data, loading, error }] = useExportTrailedDirectGroupCarriageGroupListMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExportTrailedDirectGroupCarriageGroupListMutation(baseOptions?: Apollo.MutationHookOptions<ExportTrailedDirectGroupCarriageGroupListMutation, ExportTrailedDirectGroupCarriageGroupListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportTrailedDirectGroupCarriageGroupListMutation, ExportTrailedDirectGroupCarriageGroupListMutationVariables>(ExportTrailedDirectGroupCarriageGroupListDocument, options);
      }
export type ExportTrailedDirectGroupCarriageGroupListMutationHookResult = ReturnType<typeof useExportTrailedDirectGroupCarriageGroupListMutation>;
export type ExportTrailedDirectGroupCarriageGroupListMutationResult = Apollo.MutationResult<ExportTrailedDirectGroupCarriageGroupListMutation>;
export type ExportTrailedDirectGroupCarriageGroupListMutationOptions = Apollo.BaseMutationOptions<ExportTrailedDirectGroupCarriageGroupListMutation, ExportTrailedDirectGroupCarriageGroupListMutationVariables>;
export const TrailedDirectGroupCarriageGroupListDocument = /*#__PURE__*/ gql`
    query trailedDirectGroupCarriageGroupList($paginate: PaginatorArgsDto, $orderBy: [CarriageGroupQueryResolver_CarriageGroupList_SortingInputType!], $where: CarriageGroupQueryResolver_CarriageGroupList_FilterInputType, $search: String!) {
  carriageGroups {
    carriageGroupList(
      paginate: $paginate
      order_by: $orderBy
      where: $where
      search: $search
    ) {
      totalCount
      items {
        ...CarriageGroupViewFragment
      }
    }
  }
}
    ${CarriageGroupViewFragmentFragmentDoc}`;

/**
 * __useTrailedDirectGroupCarriageGroupListQuery__
 *
 * To run a query within a React component, call `useTrailedDirectGroupCarriageGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrailedDirectGroupCarriageGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrailedDirectGroupCarriageGroupListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTrailedDirectGroupCarriageGroupListQuery(baseOptions: Apollo.QueryHookOptions<TrailedDirectGroupCarriageGroupListQuery, TrailedDirectGroupCarriageGroupListQueryVariables> & ({ variables: TrailedDirectGroupCarriageGroupListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrailedDirectGroupCarriageGroupListQuery, TrailedDirectGroupCarriageGroupListQueryVariables>(TrailedDirectGroupCarriageGroupListDocument, options);
      }
export function useTrailedDirectGroupCarriageGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrailedDirectGroupCarriageGroupListQuery, TrailedDirectGroupCarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrailedDirectGroupCarriageGroupListQuery, TrailedDirectGroupCarriageGroupListQueryVariables>(TrailedDirectGroupCarriageGroupListDocument, options);
        }
export function useTrailedDirectGroupCarriageGroupListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrailedDirectGroupCarriageGroupListQuery, TrailedDirectGroupCarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrailedDirectGroupCarriageGroupListQuery, TrailedDirectGroupCarriageGroupListQueryVariables>(TrailedDirectGroupCarriageGroupListDocument, options);
        }
export type TrailedDirectGroupCarriageGroupListQueryHookResult = ReturnType<typeof useTrailedDirectGroupCarriageGroupListQuery>;
export type TrailedDirectGroupCarriageGroupListLazyQueryHookResult = ReturnType<typeof useTrailedDirectGroupCarriageGroupListLazyQuery>;
export type TrailedDirectGroupCarriageGroupListSuspenseQueryHookResult = ReturnType<typeof useTrailedDirectGroupCarriageGroupListSuspenseQuery>;
export type TrailedDirectGroupCarriageGroupListQueryResult = Apollo.QueryResult<TrailedDirectGroupCarriageGroupListQuery, TrailedDirectGroupCarriageGroupListQueryVariables>;
export const TrainsPairForSchemesCompareHeaderDocument = /*#__PURE__*/ gql`
    query trainsPairForSchemesCompareHeader($trainId: Float!) {
  train {
    pair(id: $trainId) {
      direct {
        ...TrainsPairForSchemesCompareHeaderFragment
      }
      reverse {
        ...TrainsPairForSchemesCompareHeaderFragment
      }
    }
  }
}
    ${TrainsPairForSchemesCompareHeaderFragmentFragmentDoc}`;

/**
 * __useTrainsPairForSchemesCompareHeaderQuery__
 *
 * To run a query within a React component, call `useTrainsPairForSchemesCompareHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainsPairForSchemesCompareHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainsPairForSchemesCompareHeaderQuery({
 *   variables: {
 *      trainId: // value for 'trainId'
 *   },
 * });
 */
export function useTrainsPairForSchemesCompareHeaderQuery(baseOptions: Apollo.QueryHookOptions<TrainsPairForSchemesCompareHeaderQuery, TrainsPairForSchemesCompareHeaderQueryVariables> & ({ variables: TrainsPairForSchemesCompareHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainsPairForSchemesCompareHeaderQuery, TrainsPairForSchemesCompareHeaderQueryVariables>(TrainsPairForSchemesCompareHeaderDocument, options);
      }
export function useTrainsPairForSchemesCompareHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainsPairForSchemesCompareHeaderQuery, TrainsPairForSchemesCompareHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainsPairForSchemesCompareHeaderQuery, TrainsPairForSchemesCompareHeaderQueryVariables>(TrainsPairForSchemesCompareHeaderDocument, options);
        }
export function useTrainsPairForSchemesCompareHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainsPairForSchemesCompareHeaderQuery, TrainsPairForSchemesCompareHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainsPairForSchemesCompareHeaderQuery, TrainsPairForSchemesCompareHeaderQueryVariables>(TrainsPairForSchemesCompareHeaderDocument, options);
        }
export type TrainsPairForSchemesCompareHeaderQueryHookResult = ReturnType<typeof useTrainsPairForSchemesCompareHeaderQuery>;
export type TrainsPairForSchemesCompareHeaderLazyQueryHookResult = ReturnType<typeof useTrainsPairForSchemesCompareHeaderLazyQuery>;
export type TrainsPairForSchemesCompareHeaderSuspenseQueryHookResult = ReturnType<typeof useTrainsPairForSchemesCompareHeaderSuspenseQuery>;
export type TrainsPairForSchemesCompareHeaderQueryResult = Apollo.QueryResult<TrainsPairForSchemesCompareHeaderQuery, TrainsPairForSchemesCompareHeaderQueryVariables>;
export const TrainSchemasListForSchemesCompareHeaderDocument = /*#__PURE__*/ gql`
    query trainSchemasListForSchemesCompareHeader($train1: Int!, $train2: Int!) {
  train {
    list(
      paginate: {per_page: 2, page: 0}
      order_by: []
      where: {or: [{id: {eq: $train1}}, {id: {eq: $train2}}]}
    ) {
      items {
        id
        train_number
        route_duration
        departure_time
        arrival_time
        departure_time
        individual_name
        train_brand {
          entity_id
          train_brand
        }
        periodicity_season {
          entity_id
          periodicity_season
        }
        from_station {
          entity_id
          full_name
        }
        to_station {
          entity_id
          full_name
        }
        sub_category {
          train_sub_category
          background_color
        }
        gdp {
          id
          start_at
          end_at
        }
        periodicity
        schedule {
          train_schedule_fragments {
            id
            direct_time_to_station
            direct_departure
            direct_arrival
            reverse_departure
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTrainSchemasListForSchemesCompareHeaderQuery__
 *
 * To run a query within a React component, call `useTrainSchemasListForSchemesCompareHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainSchemasListForSchemesCompareHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainSchemasListForSchemesCompareHeaderQuery({
 *   variables: {
 *      train1: // value for 'train1'
 *      train2: // value for 'train2'
 *   },
 * });
 */
export function useTrainSchemasListForSchemesCompareHeaderQuery(baseOptions: Apollo.QueryHookOptions<TrainSchemasListForSchemesCompareHeaderQuery, TrainSchemasListForSchemesCompareHeaderQueryVariables> & ({ variables: TrainSchemasListForSchemesCompareHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainSchemasListForSchemesCompareHeaderQuery, TrainSchemasListForSchemesCompareHeaderQueryVariables>(TrainSchemasListForSchemesCompareHeaderDocument, options);
      }
export function useTrainSchemasListForSchemesCompareHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainSchemasListForSchemesCompareHeaderQuery, TrainSchemasListForSchemesCompareHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainSchemasListForSchemesCompareHeaderQuery, TrainSchemasListForSchemesCompareHeaderQueryVariables>(TrainSchemasListForSchemesCompareHeaderDocument, options);
        }
export function useTrainSchemasListForSchemesCompareHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainSchemasListForSchemesCompareHeaderQuery, TrainSchemasListForSchemesCompareHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainSchemasListForSchemesCompareHeaderQuery, TrainSchemasListForSchemesCompareHeaderQueryVariables>(TrainSchemasListForSchemesCompareHeaderDocument, options);
        }
export type TrainSchemasListForSchemesCompareHeaderQueryHookResult = ReturnType<typeof useTrainSchemasListForSchemesCompareHeaderQuery>;
export type TrainSchemasListForSchemesCompareHeaderLazyQueryHookResult = ReturnType<typeof useTrainSchemasListForSchemesCompareHeaderLazyQuery>;
export type TrainSchemasListForSchemesCompareHeaderSuspenseQueryHookResult = ReturnType<typeof useTrainSchemasListForSchemesCompareHeaderSuspenseQuery>;
export type TrainSchemasListForSchemesCompareHeaderQueryResult = Apollo.QueryResult<TrainSchemasListForSchemesCompareHeaderQuery, TrainSchemasListForSchemesCompareHeaderQueryVariables>;
export const TrainsPairForCompareSchemesViewDocument = /*#__PURE__*/ gql`
    query trainsPairForCompareSchemesView($id: Float!) {
  train {
    pair(id: $id) {
      direct {
        ...TrainsPairForCompareSchemesViewFragment
      }
      reverse {
        ...TrainsPairForCompareSchemesViewFragment
      }
    }
  }
}
    ${TrainsPairForCompareSchemesViewFragmentFragmentDoc}`;

/**
 * __useTrainsPairForCompareSchemesViewQuery__
 *
 * To run a query within a React component, call `useTrainsPairForCompareSchemesViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainsPairForCompareSchemesViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainsPairForCompareSchemesViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainsPairForCompareSchemesViewQuery(baseOptions: Apollo.QueryHookOptions<TrainsPairForCompareSchemesViewQuery, TrainsPairForCompareSchemesViewQueryVariables> & ({ variables: TrainsPairForCompareSchemesViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainsPairForCompareSchemesViewQuery, TrainsPairForCompareSchemesViewQueryVariables>(TrainsPairForCompareSchemesViewDocument, options);
      }
export function useTrainsPairForCompareSchemesViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainsPairForCompareSchemesViewQuery, TrainsPairForCompareSchemesViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainsPairForCompareSchemesViewQuery, TrainsPairForCompareSchemesViewQueryVariables>(TrainsPairForCompareSchemesViewDocument, options);
        }
export function useTrainsPairForCompareSchemesViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainsPairForCompareSchemesViewQuery, TrainsPairForCompareSchemesViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainsPairForCompareSchemesViewQuery, TrainsPairForCompareSchemesViewQueryVariables>(TrainsPairForCompareSchemesViewDocument, options);
        }
export type TrainsPairForCompareSchemesViewQueryHookResult = ReturnType<typeof useTrainsPairForCompareSchemesViewQuery>;
export type TrainsPairForCompareSchemesViewLazyQueryHookResult = ReturnType<typeof useTrainsPairForCompareSchemesViewLazyQuery>;
export type TrainsPairForCompareSchemesViewSuspenseQueryHookResult = ReturnType<typeof useTrainsPairForCompareSchemesViewSuspenseQuery>;
export type TrainsPairForCompareSchemesViewQueryResult = Apollo.QueryResult<TrainsPairForCompareSchemesViewQuery, TrainsPairForCompareSchemesViewQueryVariables>;
export const CreateTrainsPairDocument = /*#__PURE__*/ gql`
    mutation createTrainsPair($data: CreateTrainDto!) {
  train {
    create(data: $data)
  }
}
    `;
export type CreateTrainsPairMutationFn = Apollo.MutationFunction<CreateTrainsPairMutation, CreateTrainsPairMutationVariables>;

/**
 * __useCreateTrainsPairMutation__
 *
 * To run a mutation, you first call `useCreateTrainsPairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrainsPairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrainsPairMutation, { data, loading, error }] = useCreateTrainsPairMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTrainsPairMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrainsPairMutation, CreateTrainsPairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrainsPairMutation, CreateTrainsPairMutationVariables>(CreateTrainsPairDocument, options);
      }
export type CreateTrainsPairMutationHookResult = ReturnType<typeof useCreateTrainsPairMutation>;
export type CreateTrainsPairMutationResult = Apollo.MutationResult<CreateTrainsPairMutation>;
export type CreateTrainsPairMutationOptions = Apollo.BaseMutationOptions<CreateTrainsPairMutation, CreateTrainsPairMutationVariables>;
export const TrainSubCategoryByTrainNumberForCreateTrainViewDocument = /*#__PURE__*/ gql`
    query trainSubCategoryByTrainNumberForCreateTrainView($trainNumber: String!, $range: RangeInputDto!) {
  classifiers {
    trainSubCategory {
      byTrainNumber(trainNumber: $trainNumber, range: $range) {
        items {
          entity_id
          train_sub_category
          train_category_id
        }
      }
    }
  }
}
    `;

/**
 * __useTrainSubCategoryByTrainNumberForCreateTrainViewQuery__
 *
 * To run a query within a React component, call `useTrainSubCategoryByTrainNumberForCreateTrainViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainSubCategoryByTrainNumberForCreateTrainViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainSubCategoryByTrainNumberForCreateTrainViewQuery({
 *   variables: {
 *      trainNumber: // value for 'trainNumber'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainSubCategoryByTrainNumberForCreateTrainViewQuery(baseOptions: Apollo.QueryHookOptions<TrainSubCategoryByTrainNumberForCreateTrainViewQuery, TrainSubCategoryByTrainNumberForCreateTrainViewQueryVariables> & ({ variables: TrainSubCategoryByTrainNumberForCreateTrainViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainSubCategoryByTrainNumberForCreateTrainViewQuery, TrainSubCategoryByTrainNumberForCreateTrainViewQueryVariables>(TrainSubCategoryByTrainNumberForCreateTrainViewDocument, options);
      }
export function useTrainSubCategoryByTrainNumberForCreateTrainViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainSubCategoryByTrainNumberForCreateTrainViewQuery, TrainSubCategoryByTrainNumberForCreateTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainSubCategoryByTrainNumberForCreateTrainViewQuery, TrainSubCategoryByTrainNumberForCreateTrainViewQueryVariables>(TrainSubCategoryByTrainNumberForCreateTrainViewDocument, options);
        }
export function useTrainSubCategoryByTrainNumberForCreateTrainViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainSubCategoryByTrainNumberForCreateTrainViewQuery, TrainSubCategoryByTrainNumberForCreateTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainSubCategoryByTrainNumberForCreateTrainViewQuery, TrainSubCategoryByTrainNumberForCreateTrainViewQueryVariables>(TrainSubCategoryByTrainNumberForCreateTrainViewDocument, options);
        }
export type TrainSubCategoryByTrainNumberForCreateTrainViewQueryHookResult = ReturnType<typeof useTrainSubCategoryByTrainNumberForCreateTrainViewQuery>;
export type TrainSubCategoryByTrainNumberForCreateTrainViewLazyQueryHookResult = ReturnType<typeof useTrainSubCategoryByTrainNumberForCreateTrainViewLazyQuery>;
export type TrainSubCategoryByTrainNumberForCreateTrainViewSuspenseQueryHookResult = ReturnType<typeof useTrainSubCategoryByTrainNumberForCreateTrainViewSuspenseQuery>;
export type TrainSubCategoryByTrainNumberForCreateTrainViewQueryResult = Apollo.QueryResult<TrainSubCategoryByTrainNumberForCreateTrainViewQuery, TrainSubCategoryByTrainNumberForCreateTrainViewQueryVariables>;
export const TrainsListOnlyTotalCountForCreateViewDocument = /*#__PURE__*/ gql`
    query trainsListOnlyTotalCountForCreateView($paginate: PaginatorArgsDto, $orderBy: [TrainQueryResolver_List_SortingInputType!], $where: TrainQueryResolver_List_FilterInputType) {
  train {
    list(paginate: $paginate, order_by: $orderBy, where: $where) {
      totalCount
      items {
        id
      }
    }
  }
}
    `;

/**
 * __useTrainsListOnlyTotalCountForCreateViewQuery__
 *
 * To run a query within a React component, call `useTrainsListOnlyTotalCountForCreateViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainsListOnlyTotalCountForCreateViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainsListOnlyTotalCountForCreateViewQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrainsListOnlyTotalCountForCreateViewQuery(baseOptions?: Apollo.QueryHookOptions<TrainsListOnlyTotalCountForCreateViewQuery, TrainsListOnlyTotalCountForCreateViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainsListOnlyTotalCountForCreateViewQuery, TrainsListOnlyTotalCountForCreateViewQueryVariables>(TrainsListOnlyTotalCountForCreateViewDocument, options);
      }
export function useTrainsListOnlyTotalCountForCreateViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainsListOnlyTotalCountForCreateViewQuery, TrainsListOnlyTotalCountForCreateViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainsListOnlyTotalCountForCreateViewQuery, TrainsListOnlyTotalCountForCreateViewQueryVariables>(TrainsListOnlyTotalCountForCreateViewDocument, options);
        }
export function useTrainsListOnlyTotalCountForCreateViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainsListOnlyTotalCountForCreateViewQuery, TrainsListOnlyTotalCountForCreateViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainsListOnlyTotalCountForCreateViewQuery, TrainsListOnlyTotalCountForCreateViewQueryVariables>(TrainsListOnlyTotalCountForCreateViewDocument, options);
        }
export type TrainsListOnlyTotalCountForCreateViewQueryHookResult = ReturnType<typeof useTrainsListOnlyTotalCountForCreateViewQuery>;
export type TrainsListOnlyTotalCountForCreateViewLazyQueryHookResult = ReturnType<typeof useTrainsListOnlyTotalCountForCreateViewLazyQuery>;
export type TrainsListOnlyTotalCountForCreateViewSuspenseQueryHookResult = ReturnType<typeof useTrainsListOnlyTotalCountForCreateViewSuspenseQuery>;
export type TrainsListOnlyTotalCountForCreateViewQueryResult = Apollo.QueryResult<TrainsListOnlyTotalCountForCreateViewQuery, TrainsListOnlyTotalCountForCreateViewQueryVariables>;
export const TrainsPairForOtherTrainsViewDocument = /*#__PURE__*/ gql`
    query trainsPairForOtherTrainsView($id: Float!) {
  train {
    pair(id: $id) {
      direct {
        ...TrainsPairForOtherTrainsViewFragment
      }
      reverse {
        ...TrainsPairForOtherTrainsViewFragment
      }
    }
  }
}
    ${TrainsPairForOtherTrainsViewFragmentFragmentDoc}`;

/**
 * __useTrainsPairForOtherTrainsViewQuery__
 *
 * To run a query within a React component, call `useTrainsPairForOtherTrainsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainsPairForOtherTrainsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainsPairForOtherTrainsViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainsPairForOtherTrainsViewQuery(baseOptions: Apollo.QueryHookOptions<TrainsPairForOtherTrainsViewQuery, TrainsPairForOtherTrainsViewQueryVariables> & ({ variables: TrainsPairForOtherTrainsViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainsPairForOtherTrainsViewQuery, TrainsPairForOtherTrainsViewQueryVariables>(TrainsPairForOtherTrainsViewDocument, options);
      }
export function useTrainsPairForOtherTrainsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainsPairForOtherTrainsViewQuery, TrainsPairForOtherTrainsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainsPairForOtherTrainsViewQuery, TrainsPairForOtherTrainsViewQueryVariables>(TrainsPairForOtherTrainsViewDocument, options);
        }
export function useTrainsPairForOtherTrainsViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainsPairForOtherTrainsViewQuery, TrainsPairForOtherTrainsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainsPairForOtherTrainsViewQuery, TrainsPairForOtherTrainsViewQueryVariables>(TrainsPairForOtherTrainsViewDocument, options);
        }
export type TrainsPairForOtherTrainsViewQueryHookResult = ReturnType<typeof useTrainsPairForOtherTrainsViewQuery>;
export type TrainsPairForOtherTrainsViewLazyQueryHookResult = ReturnType<typeof useTrainsPairForOtherTrainsViewLazyQuery>;
export type TrainsPairForOtherTrainsViewSuspenseQueryHookResult = ReturnType<typeof useTrainsPairForOtherTrainsViewSuspenseQuery>;
export type TrainsPairForOtherTrainsViewQueryResult = Apollo.QueryResult<TrainsPairForOtherTrainsViewQuery, TrainsPairForOtherTrainsViewQueryVariables>;
export const GetRelatedTrainsDetailDocument = /*#__PURE__*/ gql`
    query getRelatedTrainsDetail($data: GetRelatedTrainsDto!) {
  train {
    getRelatedTrains(data: $data) {
      totalCount
      items {
        ...RelatedTrainsBaseFragment
        pair_train {
          id
          train_number
        }
      }
    }
  }
}
    ${RelatedTrainsBaseFragmentFragmentDoc}`;

/**
 * __useGetRelatedTrainsDetailQuery__
 *
 * To run a query within a React component, call `useGetRelatedTrainsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedTrainsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedTrainsDetailQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetRelatedTrainsDetailQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedTrainsDetailQuery, GetRelatedTrainsDetailQueryVariables> & ({ variables: GetRelatedTrainsDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedTrainsDetailQuery, GetRelatedTrainsDetailQueryVariables>(GetRelatedTrainsDetailDocument, options);
      }
export function useGetRelatedTrainsDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedTrainsDetailQuery, GetRelatedTrainsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedTrainsDetailQuery, GetRelatedTrainsDetailQueryVariables>(GetRelatedTrainsDetailDocument, options);
        }
export function useGetRelatedTrainsDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRelatedTrainsDetailQuery, GetRelatedTrainsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRelatedTrainsDetailQuery, GetRelatedTrainsDetailQueryVariables>(GetRelatedTrainsDetailDocument, options);
        }
export type GetRelatedTrainsDetailQueryHookResult = ReturnType<typeof useGetRelatedTrainsDetailQuery>;
export type GetRelatedTrainsDetailLazyQueryHookResult = ReturnType<typeof useGetRelatedTrainsDetailLazyQuery>;
export type GetRelatedTrainsDetailSuspenseQueryHookResult = ReturnType<typeof useGetRelatedTrainsDetailSuspenseQuery>;
export type GetRelatedTrainsDetailQueryResult = Apollo.QueryResult<GetRelatedTrainsDetailQuery, GetRelatedTrainsDetailQueryVariables>;
export const TrainsInfoForIndicatorsDocument = /*#__PURE__*/ gql`
    query TrainsInfoForIndicators($id: Float!) {
  train {
    pair(id: $id) {
      direct {
        id
        train_number
      }
      reverse {
        id
        train_number
      }
    }
  }
}
    `;

/**
 * __useTrainsInfoForIndicatorsQuery__
 *
 * To run a query within a React component, call `useTrainsInfoForIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainsInfoForIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainsInfoForIndicatorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainsInfoForIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<TrainsInfoForIndicatorsQuery, TrainsInfoForIndicatorsQueryVariables> & ({ variables: TrainsInfoForIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainsInfoForIndicatorsQuery, TrainsInfoForIndicatorsQueryVariables>(TrainsInfoForIndicatorsDocument, options);
      }
export function useTrainsInfoForIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainsInfoForIndicatorsQuery, TrainsInfoForIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainsInfoForIndicatorsQuery, TrainsInfoForIndicatorsQueryVariables>(TrainsInfoForIndicatorsDocument, options);
        }
export function useTrainsInfoForIndicatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainsInfoForIndicatorsQuery, TrainsInfoForIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainsInfoForIndicatorsQuery, TrainsInfoForIndicatorsQueryVariables>(TrainsInfoForIndicatorsDocument, options);
        }
export type TrainsInfoForIndicatorsQueryHookResult = ReturnType<typeof useTrainsInfoForIndicatorsQuery>;
export type TrainsInfoForIndicatorsLazyQueryHookResult = ReturnType<typeof useTrainsInfoForIndicatorsLazyQuery>;
export type TrainsInfoForIndicatorsSuspenseQueryHookResult = ReturnType<typeof useTrainsInfoForIndicatorsSuspenseQuery>;
export type TrainsInfoForIndicatorsQueryResult = Apollo.QueryResult<TrainsInfoForIndicatorsQuery, TrainsInfoForIndicatorsQueryVariables>;
export const TrainHeadIndicatorsDocument = /*#__PURE__*/ gql`
    query TrainHeadIndicators($data: TrainHeaderIndicatorsRequestDto!) {
  indicators {
    train_header_indicators(data: $data) {
      ...TrainHeadIndicatorsBaseFragment
    }
  }
}
    ${TrainHeadIndicatorsBaseFragmentFragmentDoc}`;

/**
 * __useTrainHeadIndicatorsQuery__
 *
 * To run a query within a React component, call `useTrainHeadIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainHeadIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainHeadIndicatorsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTrainHeadIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<TrainHeadIndicatorsQuery, TrainHeadIndicatorsQueryVariables> & ({ variables: TrainHeadIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainHeadIndicatorsQuery, TrainHeadIndicatorsQueryVariables>(TrainHeadIndicatorsDocument, options);
      }
export function useTrainHeadIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainHeadIndicatorsQuery, TrainHeadIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainHeadIndicatorsQuery, TrainHeadIndicatorsQueryVariables>(TrainHeadIndicatorsDocument, options);
        }
export function useTrainHeadIndicatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainHeadIndicatorsQuery, TrainHeadIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainHeadIndicatorsQuery, TrainHeadIndicatorsQueryVariables>(TrainHeadIndicatorsDocument, options);
        }
export type TrainHeadIndicatorsQueryHookResult = ReturnType<typeof useTrainHeadIndicatorsQuery>;
export type TrainHeadIndicatorsLazyQueryHookResult = ReturnType<typeof useTrainHeadIndicatorsLazyQuery>;
export type TrainHeadIndicatorsSuspenseQueryHookResult = ReturnType<typeof useTrainHeadIndicatorsSuspenseQuery>;
export type TrainHeadIndicatorsQueryResult = Apollo.QueryResult<TrainHeadIndicatorsQuery, TrainHeadIndicatorsQueryVariables>;
export const ChangeIsMarkedToDeleteDocument = /*#__PURE__*/ gql`
    mutation changeIsMarkedToDelete($data: ChangeIsMarkedToDeleteRequestDto!) {
  train {
    changeIsMarkedToDelete(data: $data) {
      errors
      is_success
    }
  }
}
    `;
export type ChangeIsMarkedToDeleteMutationFn = Apollo.MutationFunction<ChangeIsMarkedToDeleteMutation, ChangeIsMarkedToDeleteMutationVariables>;

/**
 * __useChangeIsMarkedToDeleteMutation__
 *
 * To run a mutation, you first call `useChangeIsMarkedToDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeIsMarkedToDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeIsMarkedToDeleteMutation, { data, loading, error }] = useChangeIsMarkedToDeleteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChangeIsMarkedToDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ChangeIsMarkedToDeleteMutation, ChangeIsMarkedToDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeIsMarkedToDeleteMutation, ChangeIsMarkedToDeleteMutationVariables>(ChangeIsMarkedToDeleteDocument, options);
      }
export type ChangeIsMarkedToDeleteMutationHookResult = ReturnType<typeof useChangeIsMarkedToDeleteMutation>;
export type ChangeIsMarkedToDeleteMutationResult = Apollo.MutationResult<ChangeIsMarkedToDeleteMutation>;
export type ChangeIsMarkedToDeleteMutationOptions = Apollo.BaseMutationOptions<ChangeIsMarkedToDeleteMutation, ChangeIsMarkedToDeleteMutationVariables>;
export const TrainsPairForTrainInfoViewDocument = /*#__PURE__*/ gql`
    query trainsPairForTrainInfoView($id: Float!) {
  train {
    pair(id: $id) {
      direct {
        ...TrainsPairForTrainViewFragment
      }
      reverse {
        ...TrainsPairForTrainViewFragment
      }
    }
  }
}
    ${TrainsPairForTrainViewFragmentFragmentDoc}`;

/**
 * __useTrainsPairForTrainInfoViewQuery__
 *
 * To run a query within a React component, call `useTrainsPairForTrainInfoViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainsPairForTrainInfoViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainsPairForTrainInfoViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainsPairForTrainInfoViewQuery(baseOptions: Apollo.QueryHookOptions<TrainsPairForTrainInfoViewQuery, TrainsPairForTrainInfoViewQueryVariables> & ({ variables: TrainsPairForTrainInfoViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainsPairForTrainInfoViewQuery, TrainsPairForTrainInfoViewQueryVariables>(TrainsPairForTrainInfoViewDocument, options);
      }
export function useTrainsPairForTrainInfoViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainsPairForTrainInfoViewQuery, TrainsPairForTrainInfoViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainsPairForTrainInfoViewQuery, TrainsPairForTrainInfoViewQueryVariables>(TrainsPairForTrainInfoViewDocument, options);
        }
export function useTrainsPairForTrainInfoViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainsPairForTrainInfoViewQuery, TrainsPairForTrainInfoViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainsPairForTrainInfoViewQuery, TrainsPairForTrainInfoViewQueryVariables>(TrainsPairForTrainInfoViewDocument, options);
        }
export type TrainsPairForTrainInfoViewQueryHookResult = ReturnType<typeof useTrainsPairForTrainInfoViewQuery>;
export type TrainsPairForTrainInfoViewLazyQueryHookResult = ReturnType<typeof useTrainsPairForTrainInfoViewLazyQuery>;
export type TrainsPairForTrainInfoViewSuspenseQueryHookResult = ReturnType<typeof useTrainsPairForTrainInfoViewSuspenseQuery>;
export type TrainsPairForTrainInfoViewQueryResult = Apollo.QueryResult<TrainsPairForTrainInfoViewQuery, TrainsPairForTrainInfoViewQueryVariables>;
export const CommonTrainPairInfoViewDocument = /*#__PURE__*/ gql`
    query commonTrainPairInfoView($id: Float!) {
  train {
    pair(id: $id) {
      direct {
        ...CommonTrainPairInfoFragment
      }
      reverse {
        ...CommonTrainPairInfoFragment
      }
    }
  }
}
    ${CommonTrainPairInfoFragmentFragmentDoc}`;

/**
 * __useCommonTrainPairInfoViewQuery__
 *
 * To run a query within a React component, call `useCommonTrainPairInfoViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonTrainPairInfoViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonTrainPairInfoViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommonTrainPairInfoViewQuery(baseOptions: Apollo.QueryHookOptions<CommonTrainPairInfoViewQuery, CommonTrainPairInfoViewQueryVariables> & ({ variables: CommonTrainPairInfoViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommonTrainPairInfoViewQuery, CommonTrainPairInfoViewQueryVariables>(CommonTrainPairInfoViewDocument, options);
      }
export function useCommonTrainPairInfoViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommonTrainPairInfoViewQuery, CommonTrainPairInfoViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommonTrainPairInfoViewQuery, CommonTrainPairInfoViewQueryVariables>(CommonTrainPairInfoViewDocument, options);
        }
export function useCommonTrainPairInfoViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommonTrainPairInfoViewQuery, CommonTrainPairInfoViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommonTrainPairInfoViewQuery, CommonTrainPairInfoViewQueryVariables>(CommonTrainPairInfoViewDocument, options);
        }
export type CommonTrainPairInfoViewQueryHookResult = ReturnType<typeof useCommonTrainPairInfoViewQuery>;
export type CommonTrainPairInfoViewLazyQueryHookResult = ReturnType<typeof useCommonTrainPairInfoViewLazyQuery>;
export type CommonTrainPairInfoViewSuspenseQueryHookResult = ReturnType<typeof useCommonTrainPairInfoViewSuspenseQuery>;
export type CommonTrainPairInfoViewQueryResult = Apollo.QueryResult<CommonTrainPairInfoViewQuery, CommonTrainPairInfoViewQueryVariables>;
export const TrainNumbersListDocument = /*#__PURE__*/ gql`
    query trainNumbersList($paginate: PaginatorArgsDto, $orderBy: [TrainQueryResolver_List_SortingInputType!], $where: TrainQueryResolver_List_FilterInputType) {
  train {
    list(paginate: $paginate, order_by: $orderBy, where: $where) {
      items {
        ...TrainNumberAutocompleteFragment
        parent_id
        status
      }
    }
  }
}
    ${TrainNumberAutocompleteFragmentFragmentDoc}`;

/**
 * __useTrainNumbersListQuery__
 *
 * To run a query within a React component, call `useTrainNumbersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainNumbersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainNumbersListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrainNumbersListQuery(baseOptions?: Apollo.QueryHookOptions<TrainNumbersListQuery, TrainNumbersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainNumbersListQuery, TrainNumbersListQueryVariables>(TrainNumbersListDocument, options);
      }
export function useTrainNumbersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainNumbersListQuery, TrainNumbersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainNumbersListQuery, TrainNumbersListQueryVariables>(TrainNumbersListDocument, options);
        }
export function useTrainNumbersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainNumbersListQuery, TrainNumbersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainNumbersListQuery, TrainNumbersListQueryVariables>(TrainNumbersListDocument, options);
        }
export type TrainNumbersListQueryHookResult = ReturnType<typeof useTrainNumbersListQuery>;
export type TrainNumbersListLazyQueryHookResult = ReturnType<typeof useTrainNumbersListLazyQuery>;
export type TrainNumbersListSuspenseQueryHookResult = ReturnType<typeof useTrainNumbersListSuspenseQuery>;
export type TrainNumbersListQueryResult = Apollo.QueryResult<TrainNumbersListQuery, TrainNumbersListQueryVariables>;
export const GenerateLocomotiveAreasForTrainsDocument = /*#__PURE__*/ gql`
    mutation generateLocomotiveAreasForTrains($data: GenerateLocomotiveAreasForTrainsPairDto!) {
  train_schedules {
    generateLocomotiveAreasForTrains(data: $data)
  }
}
    `;
export type GenerateLocomotiveAreasForTrainsMutationFn = Apollo.MutationFunction<GenerateLocomotiveAreasForTrainsMutation, GenerateLocomotiveAreasForTrainsMutationVariables>;

/**
 * __useGenerateLocomotiveAreasForTrainsMutation__
 *
 * To run a mutation, you first call `useGenerateLocomotiveAreasForTrainsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLocomotiveAreasForTrainsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLocomotiveAreasForTrainsMutation, { data, loading, error }] = useGenerateLocomotiveAreasForTrainsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGenerateLocomotiveAreasForTrainsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateLocomotiveAreasForTrainsMutation, GenerateLocomotiveAreasForTrainsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateLocomotiveAreasForTrainsMutation, GenerateLocomotiveAreasForTrainsMutationVariables>(GenerateLocomotiveAreasForTrainsDocument, options);
      }
export type GenerateLocomotiveAreasForTrainsMutationHookResult = ReturnType<typeof useGenerateLocomotiveAreasForTrainsMutation>;
export type GenerateLocomotiveAreasForTrainsMutationResult = Apollo.MutationResult<GenerateLocomotiveAreasForTrainsMutation>;
export type GenerateLocomotiveAreasForTrainsMutationOptions = Apollo.BaseMutationOptions<GenerateLocomotiveAreasForTrainsMutation, GenerateLocomotiveAreasForTrainsMutationVariables>;
export const LocomotiveSeriesListForTrainViewDocument = /*#__PURE__*/ gql`
    query locomotiveSeriesListForTrainView($where: LocomotivePriceTechnicalServiceQueryResolver_List_FilterInputType, $range: RangeInputDto!, $search: String!) {
  classifiers {
    locomotivePriceTechnicalService {
      list(
        paginate: {per_page: 20, page: 0}
        order_by: []
        where: $where
        range: $range
        search: $search
      ) {
        items {
          locomotive_series {
            entity_id
            series
            section_quantity
            locomotive_traction_type_id
            index
            locomotive_traction_type {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLocomotiveSeriesListForTrainViewQuery__
 *
 * To run a query within a React component, call `useLocomotiveSeriesListForTrainViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocomotiveSeriesListForTrainViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocomotiveSeriesListForTrainViewQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useLocomotiveSeriesListForTrainViewQuery(baseOptions: Apollo.QueryHookOptions<LocomotiveSeriesListForTrainViewQuery, LocomotiveSeriesListForTrainViewQueryVariables> & ({ variables: LocomotiveSeriesListForTrainViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocomotiveSeriesListForTrainViewQuery, LocomotiveSeriesListForTrainViewQueryVariables>(LocomotiveSeriesListForTrainViewDocument, options);
      }
export function useLocomotiveSeriesListForTrainViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocomotiveSeriesListForTrainViewQuery, LocomotiveSeriesListForTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocomotiveSeriesListForTrainViewQuery, LocomotiveSeriesListForTrainViewQueryVariables>(LocomotiveSeriesListForTrainViewDocument, options);
        }
export function useLocomotiveSeriesListForTrainViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocomotiveSeriesListForTrainViewQuery, LocomotiveSeriesListForTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocomotiveSeriesListForTrainViewQuery, LocomotiveSeriesListForTrainViewQueryVariables>(LocomotiveSeriesListForTrainViewDocument, options);
        }
export type LocomotiveSeriesListForTrainViewQueryHookResult = ReturnType<typeof useLocomotiveSeriesListForTrainViewQuery>;
export type LocomotiveSeriesListForTrainViewLazyQueryHookResult = ReturnType<typeof useLocomotiveSeriesListForTrainViewLazyQuery>;
export type LocomotiveSeriesListForTrainViewSuspenseQueryHookResult = ReturnType<typeof useLocomotiveSeriesListForTrainViewSuspenseQuery>;
export type LocomotiveSeriesListForTrainViewQueryResult = Apollo.QueryResult<LocomotiveSeriesListForTrainViewQuery, LocomotiveSeriesListForTrainViewQueryVariables>;
export const ElectricityTypeStationListDocument = /*#__PURE__*/ gql`
    query electricityTypeStationList($data: GetStationListFromTrainScheduleDto!) {
  train_schemas {
    getStationListFromTrainSchedule(data: $data) {
      entity_id
      full_name
      express_code
      is_electricity_type
    }
  }
}
    `;

/**
 * __useElectricityTypeStationListQuery__
 *
 * To run a query within a React component, call `useElectricityTypeStationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useElectricityTypeStationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useElectricityTypeStationListQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useElectricityTypeStationListQuery(baseOptions: Apollo.QueryHookOptions<ElectricityTypeStationListQuery, ElectricityTypeStationListQueryVariables> & ({ variables: ElectricityTypeStationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ElectricityTypeStationListQuery, ElectricityTypeStationListQueryVariables>(ElectricityTypeStationListDocument, options);
      }
export function useElectricityTypeStationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ElectricityTypeStationListQuery, ElectricityTypeStationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ElectricityTypeStationListQuery, ElectricityTypeStationListQueryVariables>(ElectricityTypeStationListDocument, options);
        }
export function useElectricityTypeStationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ElectricityTypeStationListQuery, ElectricityTypeStationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ElectricityTypeStationListQuery, ElectricityTypeStationListQueryVariables>(ElectricityTypeStationListDocument, options);
        }
export type ElectricityTypeStationListQueryHookResult = ReturnType<typeof useElectricityTypeStationListQuery>;
export type ElectricityTypeStationListLazyQueryHookResult = ReturnType<typeof useElectricityTypeStationListLazyQuery>;
export type ElectricityTypeStationListSuspenseQueryHookResult = ReturnType<typeof useElectricityTypeStationListSuspenseQuery>;
export type ElectricityTypeStationListQueryResult = Apollo.QueryResult<ElectricityTypeStationListQuery, ElectricityTypeStationListQueryVariables>;
export const TrainsPairForLocomotiveAreaDocument = /*#__PURE__*/ gql`
    query trainsPairForLocomotiveArea($id: Float!, $directPeriodFilter: LocomotiveTotalCalculationsPeriodRequestDto!, $reversePeriodFilter: LocomotiveTotalCalculationsPeriodRequestDto!) {
  train {
    pair(id: $id) {
      direct {
        ...TrainsPairForLocomotiveArea
        locomotives_areas_calculations(period: $directPeriodFilter) {
          ...TotalCalculationsForLocomotiveArea
        }
      }
      reverse {
        ...TrainsPairForLocomotiveArea
        locomotives_areas_calculations(period: $reversePeriodFilter) {
          ...TotalCalculationsForLocomotiveArea
        }
      }
    }
  }
}
    ${TrainsPairForLocomotiveAreaFragmentDoc}
${TotalCalculationsForLocomotiveAreaFragmentDoc}`;

/**
 * __useTrainsPairForLocomotiveAreaQuery__
 *
 * To run a query within a React component, call `useTrainsPairForLocomotiveAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainsPairForLocomotiveAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainsPairForLocomotiveAreaQuery({
 *   variables: {
 *      id: // value for 'id'
 *      directPeriodFilter: // value for 'directPeriodFilter'
 *      reversePeriodFilter: // value for 'reversePeriodFilter'
 *   },
 * });
 */
export function useTrainsPairForLocomotiveAreaQuery(baseOptions: Apollo.QueryHookOptions<TrainsPairForLocomotiveAreaQuery, TrainsPairForLocomotiveAreaQueryVariables> & ({ variables: TrainsPairForLocomotiveAreaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainsPairForLocomotiveAreaQuery, TrainsPairForLocomotiveAreaQueryVariables>(TrainsPairForLocomotiveAreaDocument, options);
      }
export function useTrainsPairForLocomotiveAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainsPairForLocomotiveAreaQuery, TrainsPairForLocomotiveAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainsPairForLocomotiveAreaQuery, TrainsPairForLocomotiveAreaQueryVariables>(TrainsPairForLocomotiveAreaDocument, options);
        }
export function useTrainsPairForLocomotiveAreaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainsPairForLocomotiveAreaQuery, TrainsPairForLocomotiveAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainsPairForLocomotiveAreaQuery, TrainsPairForLocomotiveAreaQueryVariables>(TrainsPairForLocomotiveAreaDocument, options);
        }
export type TrainsPairForLocomotiveAreaQueryHookResult = ReturnType<typeof useTrainsPairForLocomotiveAreaQuery>;
export type TrainsPairForLocomotiveAreaLazyQueryHookResult = ReturnType<typeof useTrainsPairForLocomotiveAreaLazyQuery>;
export type TrainsPairForLocomotiveAreaSuspenseQueryHookResult = ReturnType<typeof useTrainsPairForLocomotiveAreaSuspenseQuery>;
export type TrainsPairForLocomotiveAreaQueryResult = Apollo.QueryResult<TrainsPairForLocomotiveAreaQuery, TrainsPairForLocomotiveAreaQueryVariables>;
export const UpdateLocomotiveAreasForTrainsPairDocument = /*#__PURE__*/ gql`
    mutation updateLocomotiveAreasForTrainsPair($data: UpdateLocomotiveAreasDto!) {
  train_schedules {
    update_locomotive_areas_for_trains_pair(data: $data)
  }
}
    `;
export type UpdateLocomotiveAreasForTrainsPairMutationFn = Apollo.MutationFunction<UpdateLocomotiveAreasForTrainsPairMutation, UpdateLocomotiveAreasForTrainsPairMutationVariables>;

/**
 * __useUpdateLocomotiveAreasForTrainsPairMutation__
 *
 * To run a mutation, you first call `useUpdateLocomotiveAreasForTrainsPairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocomotiveAreasForTrainsPairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocomotiveAreasForTrainsPairMutation, { data, loading, error }] = useUpdateLocomotiveAreasForTrainsPairMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLocomotiveAreasForTrainsPairMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocomotiveAreasForTrainsPairMutation, UpdateLocomotiveAreasForTrainsPairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocomotiveAreasForTrainsPairMutation, UpdateLocomotiveAreasForTrainsPairMutationVariables>(UpdateLocomotiveAreasForTrainsPairDocument, options);
      }
export type UpdateLocomotiveAreasForTrainsPairMutationHookResult = ReturnType<typeof useUpdateLocomotiveAreasForTrainsPairMutation>;
export type UpdateLocomotiveAreasForTrainsPairMutationResult = Apollo.MutationResult<UpdateLocomotiveAreasForTrainsPairMutation>;
export type UpdateLocomotiveAreasForTrainsPairMutationOptions = Apollo.BaseMutationOptions<UpdateLocomotiveAreasForTrainsPairMutation, UpdateLocomotiveAreasForTrainsPairMutationVariables>;
export const CheckScheduleCopyPossibilityDocument = /*#__PURE__*/ gql`
    query checkScheduleCopyPossibility($data: CopyScheduleDto!) {
  train {
    checkScheduleCopyPossibility(data: $data)
  }
}
    `;

/**
 * __useCheckScheduleCopyPossibilityQuery__
 *
 * To run a query within a React component, call `useCheckScheduleCopyPossibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckScheduleCopyPossibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckScheduleCopyPossibilityQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckScheduleCopyPossibilityQuery(baseOptions: Apollo.QueryHookOptions<CheckScheduleCopyPossibilityQuery, CheckScheduleCopyPossibilityQueryVariables> & ({ variables: CheckScheduleCopyPossibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckScheduleCopyPossibilityQuery, CheckScheduleCopyPossibilityQueryVariables>(CheckScheduleCopyPossibilityDocument, options);
      }
export function useCheckScheduleCopyPossibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckScheduleCopyPossibilityQuery, CheckScheduleCopyPossibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckScheduleCopyPossibilityQuery, CheckScheduleCopyPossibilityQueryVariables>(CheckScheduleCopyPossibilityDocument, options);
        }
export function useCheckScheduleCopyPossibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckScheduleCopyPossibilityQuery, CheckScheduleCopyPossibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckScheduleCopyPossibilityQuery, CheckScheduleCopyPossibilityQueryVariables>(CheckScheduleCopyPossibilityDocument, options);
        }
export type CheckScheduleCopyPossibilityQueryHookResult = ReturnType<typeof useCheckScheduleCopyPossibilityQuery>;
export type CheckScheduleCopyPossibilityLazyQueryHookResult = ReturnType<typeof useCheckScheduleCopyPossibilityLazyQuery>;
export type CheckScheduleCopyPossibilitySuspenseQueryHookResult = ReturnType<typeof useCheckScheduleCopyPossibilitySuspenseQuery>;
export type CheckScheduleCopyPossibilityQueryResult = Apollo.QueryResult<CheckScheduleCopyPossibilityQuery, CheckScheduleCopyPossibilityQueryVariables>;
export const CopyScheduleDocument = /*#__PURE__*/ gql`
    mutation copySchedule($data: CopyScheduleDto!) {
  train {
    copySchedule(data: $data)
  }
}
    `;
export type CopyScheduleMutationFn = Apollo.MutationFunction<CopyScheduleMutation, CopyScheduleMutationVariables>;

/**
 * __useCopyScheduleMutation__
 *
 * To run a mutation, you first call `useCopyScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyScheduleMutation, { data, loading, error }] = useCopyScheduleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCopyScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CopyScheduleMutation, CopyScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyScheduleMutation, CopyScheduleMutationVariables>(CopyScheduleDocument, options);
      }
export type CopyScheduleMutationHookResult = ReturnType<typeof useCopyScheduleMutation>;
export type CopyScheduleMutationResult = Apollo.MutationResult<CopyScheduleMutation>;
export type CopyScheduleMutationOptions = Apollo.BaseMutationOptions<CopyScheduleMutation, CopyScheduleMutationVariables>;
export const ExportScheduleDocument = /*#__PURE__*/ gql`
    mutation exportSchedule($data: ExportScheduleDto!) {
  train_schedules {
    exportSchedule(data: $data)
  }
}
    `;
export type ExportScheduleMutationFn = Apollo.MutationFunction<ExportScheduleMutation, ExportScheduleMutationVariables>;

/**
 * __useExportScheduleMutation__
 *
 * To run a mutation, you first call `useExportScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportScheduleMutation, { data, loading, error }] = useExportScheduleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExportScheduleMutation(baseOptions?: Apollo.MutationHookOptions<ExportScheduleMutation, ExportScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportScheduleMutation, ExportScheduleMutationVariables>(ExportScheduleDocument, options);
      }
export type ExportScheduleMutationHookResult = ReturnType<typeof useExportScheduleMutation>;
export type ExportScheduleMutationResult = Apollo.MutationResult<ExportScheduleMutation>;
export type ExportScheduleMutationOptions = Apollo.BaseMutationOptions<ExportScheduleMutation, ExportScheduleMutationVariables>;
export const StationsListForScheduleDocument = /*#__PURE__*/ gql`
    query StationsListForSchedule($where: StationQueryResolver_List_FilterInputType, $range: RangeInputDto!) {
  classifiers {
    station {
      list(
        paginate: {per_page: 20, page: 0}
        order_by: []
        where: $where
        range: $range
      ) {
        items {
          ...StationShortFragmentWithOperations
          railway {
            entity_id
            name
          }
        }
      }
    }
  }
}
    ${StationShortFragmentWithOperationsFragmentDoc}`;

/**
 * __useStationsListForScheduleQuery__
 *
 * To run a query within a React component, call `useStationsListForScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationsListForScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationsListForScheduleQuery({
 *   variables: {
 *      where: // value for 'where'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useStationsListForScheduleQuery(baseOptions: Apollo.QueryHookOptions<StationsListForScheduleQuery, StationsListForScheduleQueryVariables> & ({ variables: StationsListForScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StationsListForScheduleQuery, StationsListForScheduleQueryVariables>(StationsListForScheduleDocument, options);
      }
export function useStationsListForScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StationsListForScheduleQuery, StationsListForScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StationsListForScheduleQuery, StationsListForScheduleQueryVariables>(StationsListForScheduleDocument, options);
        }
export function useStationsListForScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StationsListForScheduleQuery, StationsListForScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StationsListForScheduleQuery, StationsListForScheduleQueryVariables>(StationsListForScheduleDocument, options);
        }
export type StationsListForScheduleQueryHookResult = ReturnType<typeof useStationsListForScheduleQuery>;
export type StationsListForScheduleLazyQueryHookResult = ReturnType<typeof useStationsListForScheduleLazyQuery>;
export type StationsListForScheduleSuspenseQueryHookResult = ReturnType<typeof useStationsListForScheduleSuspenseQuery>;
export type StationsListForScheduleQueryResult = Apollo.QueryResult<StationsListForScheduleQuery, StationsListForScheduleQueryVariables>;
export const ThreadOccupancyControlDocument = /*#__PURE__*/ gql`
    query threadOccupancyControl($trainId: Float!) {
  train_schedules {
    threadOccupancyControl(train_id: $trainId)
  }
}
    `;

/**
 * __useThreadOccupancyControlQuery__
 *
 * To run a query within a React component, call `useThreadOccupancyControlQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreadOccupancyControlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreadOccupancyControlQuery({
 *   variables: {
 *      trainId: // value for 'trainId'
 *   },
 * });
 */
export function useThreadOccupancyControlQuery(baseOptions: Apollo.QueryHookOptions<ThreadOccupancyControlQuery, ThreadOccupancyControlQueryVariables> & ({ variables: ThreadOccupancyControlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreadOccupancyControlQuery, ThreadOccupancyControlQueryVariables>(ThreadOccupancyControlDocument, options);
      }
export function useThreadOccupancyControlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreadOccupancyControlQuery, ThreadOccupancyControlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreadOccupancyControlQuery, ThreadOccupancyControlQueryVariables>(ThreadOccupancyControlDocument, options);
        }
export function useThreadOccupancyControlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ThreadOccupancyControlQuery, ThreadOccupancyControlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThreadOccupancyControlQuery, ThreadOccupancyControlQueryVariables>(ThreadOccupancyControlDocument, options);
        }
export type ThreadOccupancyControlQueryHookResult = ReturnType<typeof useThreadOccupancyControlQuery>;
export type ThreadOccupancyControlLazyQueryHookResult = ReturnType<typeof useThreadOccupancyControlLazyQuery>;
export type ThreadOccupancyControlSuspenseQueryHookResult = ReturnType<typeof useThreadOccupancyControlSuspenseQuery>;
export type ThreadOccupancyControlQueryResult = Apollo.QueryResult<ThreadOccupancyControlQuery, ThreadOccupancyControlQueryVariables>;
export const TrainsPairForScheduleViewDocument = /*#__PURE__*/ gql`
    query trainsPairForScheduleView($id: Float!) {
  train {
    pair(id: $id) {
      direct {
        id
        train_number
        branch_id
        gdp {
          id
          start_at
          end_at
        }
        lock_user {
          ...UserShortFragment
        }
        status
        schedule {
          ...TrainScheduleBaseFragment
          copy_meta {
            ...CopyMetaBaseFragment
          }
          train_schedule_fragments {
            ...TrainScheduleFragmentBaseFragment
            station {
              ...StationBaseFragment
              railway {
                ...RailwayShortFragment
              }
            }
          }
        }
        schemas {
          ...TrainSchemaBaseFragment
          locomotive_change {
            ...LocomotiveChangeFragment
          }
          locomotive_team_change {
            ...LocomotiveTeamChangeFragment
          }
          fuel_supply {
            ...FuelSupplyFragment
          }
          border_control {
            ...BorderControlFragment
          }
          eco_toilets {
            ...EcoToiletsFragment
          }
          water_supply {
            ...WaterSupplyFragment
          }
          waste_collection {
            ...WasteCollectionFragment
          }
          periodicity {
            ...PeriodicityInfoBaseFragment
            train {
              id
            }
          }
          carriage_numerations {
            ...CarriageNumerationFragment
          }
          carriage_allocations {
            ...CarriageAllocationBaseFragment
          }
          carriage_classes {
            ...CarriageClassesBaseFragment
          }
          direct_carriages {
            ...DirectCarriagesFragment
          }
          established_train_schema {
            ... on EstablishedTrainSchemaStationDto {
              ...EstablishedTrainSchemaStationFragment
            }
            ... on EstablishedTrainSchemaRailwayDto {
              ...EstablishedTrainSchemaRailwayFragment
            }
          }
          max_train_length {
            ... on MaxTrainLengthRailwayDto {
              ...MaxTrainLengthRailwayFragment
            }
            ... on MaxTrainLengthStationDto {
              ...MaxTrainLengthStationFragment
            }
          }
          luxury_carriages {
            ...LuxuryCarriagesBaseFragment
          }
          maneuvering_work {
            ...ManeuveringWorkBaseFragment
          }
          optional_carriages {
            ...OptionalCarriageBaseFragment
          }
          other_carriages {
            ...OtherCarriageFragment
          }
          trailed_carriages {
            ...TrailedCarriageFragment
          }
          train_change_directions {
            ...TrainChangeDirectionFragment
          }
        }
      }
      reverse {
        id
        train_number
        branch_id
      }
    }
  }
}
    ${UserShortFragmentFragmentDoc}
${TrainScheduleBaseFragmentFragmentDoc}
${CopyMetaBaseFragmentFragmentDoc}
${TrainScheduleFragmentBaseFragmentFragmentDoc}
${StationBaseFragmentFragmentDoc}
${RailwayShortFragmentFragmentDoc}
${TrainSchemaBaseFragmentFragmentDoc}
${LocomotiveChangeFragmentFragmentDoc}
${LocomotiveTeamChangeFragmentFragmentDoc}
${FuelSupplyFragmentFragmentDoc}
${BorderControlFragmentFragmentDoc}
${EcoToiletsFragmentFragmentDoc}
${WaterSupplyFragmentFragmentDoc}
${WasteCollectionFragmentFragmentDoc}
${PeriodicityInfoBaseFragmentFragmentDoc}
${CarriageNumerationFragmentFragmentDoc}
${CarriageAllocationBaseFragmentFragmentDoc}
${CarriageClassesBaseFragmentFragmentDoc}
${DirectCarriagesFragmentFragmentDoc}
${EstablishedTrainSchemaStationFragmentFragmentDoc}
${EstablishedTrainSchemaRailwayFragmentFragmentDoc}
${MaxTrainLengthRailwayFragmentFragmentDoc}
${MaxTrainLengthStationFragmentFragmentDoc}
${LuxuryCarriagesBaseFragmentFragmentDoc}
${ManeuveringWorkBaseFragmentFragmentDoc}
${OptionalCarriageBaseFragmentFragmentDoc}
${OtherCarriageFragmentFragmentDoc}
${TrailedCarriageFragmentFragmentDoc}
${TrainChangeDirectionFragmentFragmentDoc}`;

/**
 * __useTrainsPairForScheduleViewQuery__
 *
 * To run a query within a React component, call `useTrainsPairForScheduleViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainsPairForScheduleViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainsPairForScheduleViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainsPairForScheduleViewQuery(baseOptions: Apollo.QueryHookOptions<TrainsPairForScheduleViewQuery, TrainsPairForScheduleViewQueryVariables> & ({ variables: TrainsPairForScheduleViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainsPairForScheduleViewQuery, TrainsPairForScheduleViewQueryVariables>(TrainsPairForScheduleViewDocument, options);
      }
export function useTrainsPairForScheduleViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainsPairForScheduleViewQuery, TrainsPairForScheduleViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainsPairForScheduleViewQuery, TrainsPairForScheduleViewQueryVariables>(TrainsPairForScheduleViewDocument, options);
        }
export function useTrainsPairForScheduleViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainsPairForScheduleViewQuery, TrainsPairForScheduleViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainsPairForScheduleViewQuery, TrainsPairForScheduleViewQueryVariables>(TrainsPairForScheduleViewDocument, options);
        }
export type TrainsPairForScheduleViewQueryHookResult = ReturnType<typeof useTrainsPairForScheduleViewQuery>;
export type TrainsPairForScheduleViewLazyQueryHookResult = ReturnType<typeof useTrainsPairForScheduleViewLazyQuery>;
export type TrainsPairForScheduleViewSuspenseQueryHookResult = ReturnType<typeof useTrainsPairForScheduleViewSuspenseQuery>;
export type TrainsPairForScheduleViewQueryResult = Apollo.QueryResult<TrainsPairForScheduleViewQuery, TrainsPairForScheduleViewQueryVariables>;
export const TrainScheduleCreateDocument = /*#__PURE__*/ gql`
    mutation trainScheduleCreate($data: CreateTrainScheduleDto!) {
  train_schedules {
    createTrainSchedule(data: $data)
  }
}
    `;
export type TrainScheduleCreateMutationFn = Apollo.MutationFunction<TrainScheduleCreateMutation, TrainScheduleCreateMutationVariables>;

/**
 * __useTrainScheduleCreateMutation__
 *
 * To run a mutation, you first call `useTrainScheduleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainScheduleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainScheduleCreateMutation, { data, loading, error }] = useTrainScheduleCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTrainScheduleCreateMutation(baseOptions?: Apollo.MutationHookOptions<TrainScheduleCreateMutation, TrainScheduleCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainScheduleCreateMutation, TrainScheduleCreateMutationVariables>(TrainScheduleCreateDocument, options);
      }
export type TrainScheduleCreateMutationHookResult = ReturnType<typeof useTrainScheduleCreateMutation>;
export type TrainScheduleCreateMutationResult = Apollo.MutationResult<TrainScheduleCreateMutation>;
export type TrainScheduleCreateMutationOptions = Apollo.BaseMutationOptions<TrainScheduleCreateMutation, TrainScheduleCreateMutationVariables>;
export const TrainScheduleDeleteDocument = /*#__PURE__*/ gql`
    mutation trainScheduleDelete($id: Float!) {
  train_schedules {
    deleteTrainSchedule(id: $id)
  }
}
    `;
export type TrainScheduleDeleteMutationFn = Apollo.MutationFunction<TrainScheduleDeleteMutation, TrainScheduleDeleteMutationVariables>;

/**
 * __useTrainScheduleDeleteMutation__
 *
 * To run a mutation, you first call `useTrainScheduleDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainScheduleDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainScheduleDeleteMutation, { data, loading, error }] = useTrainScheduleDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainScheduleDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TrainScheduleDeleteMutation, TrainScheduleDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainScheduleDeleteMutation, TrainScheduleDeleteMutationVariables>(TrainScheduleDeleteDocument, options);
      }
export type TrainScheduleDeleteMutationHookResult = ReturnType<typeof useTrainScheduleDeleteMutation>;
export type TrainScheduleDeleteMutationResult = Apollo.MutationResult<TrainScheduleDeleteMutation>;
export type TrainScheduleDeleteMutationOptions = Apollo.BaseMutationOptions<TrainScheduleDeleteMutation, TrainScheduleDeleteMutationVariables>;
export const TrainScheduleImportDocument = /*#__PURE__*/ gql`
    mutation trainScheduleImport($data: UploadScheduleDto!) {
  train_schedules {
    import(data: $data)
  }
}
    `;
export type TrainScheduleImportMutationFn = Apollo.MutationFunction<TrainScheduleImportMutation, TrainScheduleImportMutationVariables>;

/**
 * __useTrainScheduleImportMutation__
 *
 * To run a mutation, you first call `useTrainScheduleImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainScheduleImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainScheduleImportMutation, { data, loading, error }] = useTrainScheduleImportMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTrainScheduleImportMutation(baseOptions?: Apollo.MutationHookOptions<TrainScheduleImportMutation, TrainScheduleImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainScheduleImportMutation, TrainScheduleImportMutationVariables>(TrainScheduleImportDocument, options);
      }
export type TrainScheduleImportMutationHookResult = ReturnType<typeof useTrainScheduleImportMutation>;
export type TrainScheduleImportMutationResult = Apollo.MutationResult<TrainScheduleImportMutation>;
export type TrainScheduleImportMutationOptions = Apollo.BaseMutationOptions<TrainScheduleImportMutation, TrainScheduleImportMutationVariables>;
export const ScheduleStencilDocument = /*#__PURE__*/ gql`
    query ScheduleStencil($data: GetTrainScheduleStencilDto!) {
  train_schedules {
    getScheduleStencil(data: $data) {
      initial_schedule {
        ...TrainScheduleStencilSingleFragment
        gdpRange {
          start_at
          end_at
        }
      }
      compared_schedule {
        ...TrainScheduleStencilSingleFragment
        gdpRange {
          start_at
          end_at
        }
      }
      stencil {
        ...TrainScheduleToStencilFragment
      }
    }
  }
}
    ${TrainScheduleStencilSingleFragmentFragmentDoc}
${TrainScheduleToStencilFragmentFragmentDoc}`;

/**
 * __useScheduleStencilQuery__
 *
 * To run a query within a React component, call `useScheduleStencilQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleStencilQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleStencilQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useScheduleStencilQuery(baseOptions: Apollo.QueryHookOptions<ScheduleStencilQuery, ScheduleStencilQueryVariables> & ({ variables: ScheduleStencilQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleStencilQuery, ScheduleStencilQueryVariables>(ScheduleStencilDocument, options);
      }
export function useScheduleStencilLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleStencilQuery, ScheduleStencilQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleStencilQuery, ScheduleStencilQueryVariables>(ScheduleStencilDocument, options);
        }
export function useScheduleStencilSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleStencilQuery, ScheduleStencilQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleStencilQuery, ScheduleStencilQueryVariables>(ScheduleStencilDocument, options);
        }
export type ScheduleStencilQueryHookResult = ReturnType<typeof useScheduleStencilQuery>;
export type ScheduleStencilLazyQueryHookResult = ReturnType<typeof useScheduleStencilLazyQuery>;
export type ScheduleStencilSuspenseQueryHookResult = ReturnType<typeof useScheduleStencilSuspenseQuery>;
export type ScheduleStencilQueryResult = Apollo.QueryResult<ScheduleStencilQuery, ScheduleStencilQueryVariables>;
export const TrainScheduleUpdateDocument = /*#__PURE__*/ gql`
    mutation trainScheduleUpdate($data: UpdateTrainScheduleDto!) {
  train_schedules {
    updateTrainSchedule(data: $data)
  }
}
    `;
export type TrainScheduleUpdateMutationFn = Apollo.MutationFunction<TrainScheduleUpdateMutation, TrainScheduleUpdateMutationVariables>;

/**
 * __useTrainScheduleUpdateMutation__
 *
 * To run a mutation, you first call `useTrainScheduleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainScheduleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainScheduleUpdateMutation, { data, loading, error }] = useTrainScheduleUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTrainScheduleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TrainScheduleUpdateMutation, TrainScheduleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainScheduleUpdateMutation, TrainScheduleUpdateMutationVariables>(TrainScheduleUpdateDocument, options);
      }
export type TrainScheduleUpdateMutationHookResult = ReturnType<typeof useTrainScheduleUpdateMutation>;
export type TrainScheduleUpdateMutationResult = Apollo.MutationResult<TrainScheduleUpdateMutation>;
export type TrainScheduleUpdateMutationOptions = Apollo.BaseMutationOptions<TrainScheduleUpdateMutation, TrainScheduleUpdateMutationVariables>;
export const ApproveCarriageGroupDocument = /*#__PURE__*/ gql`
    mutation approveCarriageGroup($data: ApproveCarriageGroupRequestDto!) {
  train_schemas {
    approveCarriageGroup(data: $data)
  }
}
    `;
export type ApproveCarriageGroupMutationFn = Apollo.MutationFunction<ApproveCarriageGroupMutation, ApproveCarriageGroupMutationVariables>;

/**
 * __useApproveCarriageGroupMutation__
 *
 * To run a mutation, you first call `useApproveCarriageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCarriageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCarriageGroupMutation, { data, loading, error }] = useApproveCarriageGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApproveCarriageGroupMutation(baseOptions?: Apollo.MutationHookOptions<ApproveCarriageGroupMutation, ApproveCarriageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveCarriageGroupMutation, ApproveCarriageGroupMutationVariables>(ApproveCarriageGroupDocument, options);
      }
export type ApproveCarriageGroupMutationHookResult = ReturnType<typeof useApproveCarriageGroupMutation>;
export type ApproveCarriageGroupMutationResult = Apollo.MutationResult<ApproveCarriageGroupMutation>;
export type ApproveCarriageGroupMutationOptions = Apollo.BaseMutationOptions<ApproveCarriageGroupMutation, ApproveCarriageGroupMutationVariables>;
export const ChangeTableBlockOrderNumberDocument = /*#__PURE__*/ gql`
    mutation changeTableBlockOrderNumber($data: ChangeTableBlockOrderNumber!) {
  train_schemas {
    changeTableBlockOrderNumber(data: $data)
  }
}
    `;
export type ChangeTableBlockOrderNumberMutationFn = Apollo.MutationFunction<ChangeTableBlockOrderNumberMutation, ChangeTableBlockOrderNumberMutationVariables>;

/**
 * __useChangeTableBlockOrderNumberMutation__
 *
 * To run a mutation, you first call `useChangeTableBlockOrderNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTableBlockOrderNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTableBlockOrderNumberMutation, { data, loading, error }] = useChangeTableBlockOrderNumberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChangeTableBlockOrderNumberMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTableBlockOrderNumberMutation, ChangeTableBlockOrderNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTableBlockOrderNumberMutation, ChangeTableBlockOrderNumberMutationVariables>(ChangeTableBlockOrderNumberDocument, options);
      }
export type ChangeTableBlockOrderNumberMutationHookResult = ReturnType<typeof useChangeTableBlockOrderNumberMutation>;
export type ChangeTableBlockOrderNumberMutationResult = Apollo.MutationResult<ChangeTableBlockOrderNumberMutation>;
export type ChangeTableBlockOrderNumberMutationOptions = Apollo.BaseMutationOptions<ChangeTableBlockOrderNumberMutation, ChangeTableBlockOrderNumberMutationVariables>;
export const ChangeTableBlockTrainQuantityDocument = /*#__PURE__*/ gql`
    mutation changeTableBlockTrainQuantity($data: ChangeTableBlockQuantityDto!) {
  train_schemas {
    changeTableBlockTrainQuantity(data: $data)
  }
}
    `;
export type ChangeTableBlockTrainQuantityMutationFn = Apollo.MutationFunction<ChangeTableBlockTrainQuantityMutation, ChangeTableBlockTrainQuantityMutationVariables>;

/**
 * __useChangeTableBlockTrainQuantityMutation__
 *
 * To run a mutation, you first call `useChangeTableBlockTrainQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTableBlockTrainQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTableBlockTrainQuantityMutation, { data, loading, error }] = useChangeTableBlockTrainQuantityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChangeTableBlockTrainQuantityMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTableBlockTrainQuantityMutation, ChangeTableBlockTrainQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTableBlockTrainQuantityMutation, ChangeTableBlockTrainQuantityMutationVariables>(ChangeTableBlockTrainQuantityDocument, options);
      }
export type ChangeTableBlockTrainQuantityMutationHookResult = ReturnType<typeof useChangeTableBlockTrainQuantityMutation>;
export type ChangeTableBlockTrainQuantityMutationResult = Apollo.MutationResult<ChangeTableBlockTrainQuantityMutation>;
export type ChangeTableBlockTrainQuantityMutationOptions = Apollo.BaseMutationOptions<ChangeTableBlockTrainQuantityMutation, ChangeTableBlockTrainQuantityMutationVariables>;
export const ChangeTableBlockUsageInTableCalculationsDocument = /*#__PURE__*/ gql`
    mutation changeTableBlockUsageInTableCalculations($table_block_id: Float!) {
  train_schemas {
    changeTableBlockUsageInTableCalculations(table_block_id: $table_block_id)
  }
}
    `;
export type ChangeTableBlockUsageInTableCalculationsMutationFn = Apollo.MutationFunction<ChangeTableBlockUsageInTableCalculationsMutation, ChangeTableBlockUsageInTableCalculationsMutationVariables>;

/**
 * __useChangeTableBlockUsageInTableCalculationsMutation__
 *
 * To run a mutation, you first call `useChangeTableBlockUsageInTableCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTableBlockUsageInTableCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTableBlockUsageInTableCalculationsMutation, { data, loading, error }] = useChangeTableBlockUsageInTableCalculationsMutation({
 *   variables: {
 *      table_block_id: // value for 'table_block_id'
 *   },
 * });
 */
export function useChangeTableBlockUsageInTableCalculationsMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTableBlockUsageInTableCalculationsMutation, ChangeTableBlockUsageInTableCalculationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTableBlockUsageInTableCalculationsMutation, ChangeTableBlockUsageInTableCalculationsMutationVariables>(ChangeTableBlockUsageInTableCalculationsDocument, options);
      }
export type ChangeTableBlockUsageInTableCalculationsMutationHookResult = ReturnType<typeof useChangeTableBlockUsageInTableCalculationsMutation>;
export type ChangeTableBlockUsageInTableCalculationsMutationResult = Apollo.MutationResult<ChangeTableBlockUsageInTableCalculationsMutation>;
export type ChangeTableBlockUsageInTableCalculationsMutationOptions = Apollo.BaseMutationOptions<ChangeTableBlockUsageInTableCalculationsMutation, ChangeTableBlockUsageInTableCalculationsMutationVariables>;
export const ChangeTableBlockVisibilityInExportDocument = /*#__PURE__*/ gql`
    mutation changeTableBlockVisibilityInExport($tableBlockId: Float!) {
  train_schemas {
    changeTableBlockVisibilityInExport(table_block_id: $tableBlockId)
  }
}
    `;
export type ChangeTableBlockVisibilityInExportMutationFn = Apollo.MutationFunction<ChangeTableBlockVisibilityInExportMutation, ChangeTableBlockVisibilityInExportMutationVariables>;

/**
 * __useChangeTableBlockVisibilityInExportMutation__
 *
 * To run a mutation, you first call `useChangeTableBlockVisibilityInExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTableBlockVisibilityInExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTableBlockVisibilityInExportMutation, { data, loading, error }] = useChangeTableBlockVisibilityInExportMutation({
 *   variables: {
 *      tableBlockId: // value for 'tableBlockId'
 *   },
 * });
 */
export function useChangeTableBlockVisibilityInExportMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTableBlockVisibilityInExportMutation, ChangeTableBlockVisibilityInExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTableBlockVisibilityInExportMutation, ChangeTableBlockVisibilityInExportMutationVariables>(ChangeTableBlockVisibilityInExportDocument, options);
      }
export type ChangeTableBlockVisibilityInExportMutationHookResult = ReturnType<typeof useChangeTableBlockVisibilityInExportMutation>;
export type ChangeTableBlockVisibilityInExportMutationResult = Apollo.MutationResult<ChangeTableBlockVisibilityInExportMutation>;
export type ChangeTableBlockVisibilityInExportMutationOptions = Apollo.BaseMutationOptions<ChangeTableBlockVisibilityInExportMutation, ChangeTableBlockVisibilityInExportMutationVariables>;
export const CreateSchemeDocument = /*#__PURE__*/ gql`
    mutation createScheme($trainIds: [Int!]!) {
  train_schemas {
    create(data: {train_ids: $trainIds})
  }
}
    `;
export type CreateSchemeMutationFn = Apollo.MutationFunction<CreateSchemeMutation, CreateSchemeMutationVariables>;

/**
 * __useCreateSchemeMutation__
 *
 * To run a mutation, you first call `useCreateSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchemeMutation, { data, loading, error }] = useCreateSchemeMutation({
 *   variables: {
 *      trainIds: // value for 'trainIds'
 *   },
 * });
 */
export function useCreateSchemeMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchemeMutation, CreateSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchemeMutation, CreateSchemeMutationVariables>(CreateSchemeDocument, options);
      }
export type CreateSchemeMutationHookResult = ReturnType<typeof useCreateSchemeMutation>;
export type CreateSchemeMutationResult = Apollo.MutationResult<CreateSchemeMutation>;
export type CreateSchemeMutationOptions = Apollo.BaseMutationOptions<CreateSchemeMutation, CreateSchemeMutationVariables>;
export const DeclineCarriageGroupDocument = /*#__PURE__*/ gql`
    mutation declineCarriageGroup($data: DeclineCarriageGroupRequestDto!) {
  train_schemas {
    declineCarriageGroup(data: $data)
  }
}
    `;
export type DeclineCarriageGroupMutationFn = Apollo.MutationFunction<DeclineCarriageGroupMutation, DeclineCarriageGroupMutationVariables>;

/**
 * __useDeclineCarriageGroupMutation__
 *
 * To run a mutation, you first call `useDeclineCarriageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineCarriageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineCarriageGroupMutation, { data, loading, error }] = useDeclineCarriageGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeclineCarriageGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeclineCarriageGroupMutation, DeclineCarriageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineCarriageGroupMutation, DeclineCarriageGroupMutationVariables>(DeclineCarriageGroupDocument, options);
      }
export type DeclineCarriageGroupMutationHookResult = ReturnType<typeof useDeclineCarriageGroupMutation>;
export type DeclineCarriageGroupMutationResult = Apollo.MutationResult<DeclineCarriageGroupMutation>;
export type DeclineCarriageGroupMutationOptions = Apollo.BaseMutationOptions<DeclineCarriageGroupMutation, DeclineCarriageGroupMutationVariables>;
export const DeleteSchemeDocument = /*#__PURE__*/ gql`
    mutation deleteScheme($schemaId: Int!, $trainIds: [Int!]!) {
  train_schemas {
    delete(data: {id: $schemaId, train_ids: $trainIds})
  }
}
    `;
export type DeleteSchemeMutationFn = Apollo.MutationFunction<DeleteSchemeMutation, DeleteSchemeMutationVariables>;

/**
 * __useDeleteSchemeMutation__
 *
 * To run a mutation, you first call `useDeleteSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchemeMutation, { data, loading, error }] = useDeleteSchemeMutation({
 *   variables: {
 *      schemaId: // value for 'schemaId'
 *      trainIds: // value for 'trainIds'
 *   },
 * });
 */
export function useDeleteSchemeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchemeMutation, DeleteSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchemeMutation, DeleteSchemeMutationVariables>(DeleteSchemeDocument, options);
      }
export type DeleteSchemeMutationHookResult = ReturnType<typeof useDeleteSchemeMutation>;
export type DeleteSchemeMutationResult = Apollo.MutationResult<DeleteSchemeMutation>;
export type DeleteSchemeMutationOptions = Apollo.BaseMutationOptions<DeleteSchemeMutation, DeleteSchemeMutationVariables>;
export const ExportSchemaDocument = /*#__PURE__*/ gql`
    mutation exportSchema($data: ExportSchemasDto!) {
  train_schemas {
    exportSchema(data: $data)
  }
}
    `;
export type ExportSchemaMutationFn = Apollo.MutationFunction<ExportSchemaMutation, ExportSchemaMutationVariables>;

/**
 * __useExportSchemaMutation__
 *
 * To run a mutation, you first call `useExportSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSchemaMutation, { data, loading, error }] = useExportSchemaMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExportSchemaMutation(baseOptions?: Apollo.MutationHookOptions<ExportSchemaMutation, ExportSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSchemaMutation, ExportSchemaMutationVariables>(ExportSchemaDocument, options);
      }
export type ExportSchemaMutationHookResult = ReturnType<typeof useExportSchemaMutation>;
export type ExportSchemaMutationResult = Apollo.MutationResult<ExportSchemaMutation>;
export type ExportSchemaMutationOptions = Apollo.BaseMutationOptions<ExportSchemaMutation, ExportSchemaMutationVariables>;
export const MergeTableBlocksDocument = /*#__PURE__*/ gql`
    mutation mergeTableBlocks($data: MergeTableBlocksDto!) {
  train_schemas {
    mergeTableBlocks(data: $data)
  }
}
    `;
export type MergeTableBlocksMutationFn = Apollo.MutationFunction<MergeTableBlocksMutation, MergeTableBlocksMutationVariables>;

/**
 * __useMergeTableBlocksMutation__
 *
 * To run a mutation, you first call `useMergeTableBlocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeTableBlocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeTableBlocksMutation, { data, loading, error }] = useMergeTableBlocksMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMergeTableBlocksMutation(baseOptions?: Apollo.MutationHookOptions<MergeTableBlocksMutation, MergeTableBlocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeTableBlocksMutation, MergeTableBlocksMutationVariables>(MergeTableBlocksDocument, options);
      }
export type MergeTableBlocksMutationHookResult = ReturnType<typeof useMergeTableBlocksMutation>;
export type MergeTableBlocksMutationResult = Apollo.MutationResult<MergeTableBlocksMutation>;
export type MergeTableBlocksMutationOptions = Apollo.BaseMutationOptions<MergeTableBlocksMutation, MergeTableBlocksMutationVariables>;
export const ReverseTableBlockDocument = /*#__PURE__*/ gql`
    mutation reverseTableBlock($blockId: Float!) {
  train_schemas {
    reverseTableBlockRows(table_block_id: $blockId)
  }
}
    `;
export type ReverseTableBlockMutationFn = Apollo.MutationFunction<ReverseTableBlockMutation, ReverseTableBlockMutationVariables>;

/**
 * __useReverseTableBlockMutation__
 *
 * To run a mutation, you first call `useReverseTableBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseTableBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseTableBlockMutation, { data, loading, error }] = useReverseTableBlockMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useReverseTableBlockMutation(baseOptions?: Apollo.MutationHookOptions<ReverseTableBlockMutation, ReverseTableBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseTableBlockMutation, ReverseTableBlockMutationVariables>(ReverseTableBlockDocument, options);
      }
export type ReverseTableBlockMutationHookResult = ReturnType<typeof useReverseTableBlockMutation>;
export type ReverseTableBlockMutationResult = Apollo.MutationResult<ReverseTableBlockMutation>;
export type ReverseTableBlockMutationOptions = Apollo.BaseMutationOptions<ReverseTableBlockMutation, ReverseTableBlockMutationVariables>;
export const ReverseTrainSchemaBetweenTrainPairDocument = /*#__PURE__*/ gql`
    mutation reverseTrainSchemaBetweenTrainPair($schemaId: Float!) {
  train_schemas {
    reverseTrainSchemaBetweenTrainPair(train_schema_id: $schemaId)
  }
}
    `;
export type ReverseTrainSchemaBetweenTrainPairMutationFn = Apollo.MutationFunction<ReverseTrainSchemaBetweenTrainPairMutation, ReverseTrainSchemaBetweenTrainPairMutationVariables>;

/**
 * __useReverseTrainSchemaBetweenTrainPairMutation__
 *
 * To run a mutation, you first call `useReverseTrainSchemaBetweenTrainPairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseTrainSchemaBetweenTrainPairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseTrainSchemaBetweenTrainPairMutation, { data, loading, error }] = useReverseTrainSchemaBetweenTrainPairMutation({
 *   variables: {
 *      schemaId: // value for 'schemaId'
 *   },
 * });
 */
export function useReverseTrainSchemaBetweenTrainPairMutation(baseOptions?: Apollo.MutationHookOptions<ReverseTrainSchemaBetweenTrainPairMutation, ReverseTrainSchemaBetweenTrainPairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseTrainSchemaBetweenTrainPairMutation, ReverseTrainSchemaBetweenTrainPairMutationVariables>(ReverseTrainSchemaBetweenTrainPairDocument, options);
      }
export type ReverseTrainSchemaBetweenTrainPairMutationHookResult = ReturnType<typeof useReverseTrainSchemaBetweenTrainPairMutation>;
export type ReverseTrainSchemaBetweenTrainPairMutationResult = Apollo.MutationResult<ReverseTrainSchemaBetweenTrainPairMutation>;
export type ReverseTrainSchemaBetweenTrainPairMutationOptions = Apollo.BaseMutationOptions<ReverseTrainSchemaBetweenTrainPairMutation, ReverseTrainSchemaBetweenTrainPairMutationVariables>;
export const SpreadBlockToAllSchemasDocument = /*#__PURE__*/ gql`
    mutation spreadBlockToAllSchemas($data: SpreadBlockToAllSchemasRequestDto!) {
  train_schemas {
    spreadBlockToAllSchemas(data: $data)
  }
}
    `;
export type SpreadBlockToAllSchemasMutationFn = Apollo.MutationFunction<SpreadBlockToAllSchemasMutation, SpreadBlockToAllSchemasMutationVariables>;

/**
 * __useSpreadBlockToAllSchemasMutation__
 *
 * To run a mutation, you first call `useSpreadBlockToAllSchemasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpreadBlockToAllSchemasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [spreadBlockToAllSchemasMutation, { data, loading, error }] = useSpreadBlockToAllSchemasMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSpreadBlockToAllSchemasMutation(baseOptions?: Apollo.MutationHookOptions<SpreadBlockToAllSchemasMutation, SpreadBlockToAllSchemasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SpreadBlockToAllSchemasMutation, SpreadBlockToAllSchemasMutationVariables>(SpreadBlockToAllSchemasDocument, options);
      }
export type SpreadBlockToAllSchemasMutationHookResult = ReturnType<typeof useSpreadBlockToAllSchemasMutation>;
export type SpreadBlockToAllSchemasMutationResult = Apollo.MutationResult<SpreadBlockToAllSchemasMutation>;
export type SpreadBlockToAllSchemasMutationOptions = Apollo.BaseMutationOptions<SpreadBlockToAllSchemasMutation, SpreadBlockToAllSchemasMutationVariables>;
export const UpdateTrainSchemaDocument = /*#__PURE__*/ gql`
    mutation updateTrainSchema($data: UpdateTrainSchemaDto!) {
  train_schemas {
    update(data: $data)
  }
}
    `;
export type UpdateTrainSchemaMutationFn = Apollo.MutationFunction<UpdateTrainSchemaMutation, UpdateTrainSchemaMutationVariables>;

/**
 * __useUpdateTrainSchemaMutation__
 *
 * To run a mutation, you first call `useUpdateTrainSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainSchemaMutation, { data, loading, error }] = useUpdateTrainSchemaMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTrainSchemaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainSchemaMutation, UpdateTrainSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainSchemaMutation, UpdateTrainSchemaMutationVariables>(UpdateTrainSchemaDocument, options);
      }
export type UpdateTrainSchemaMutationHookResult = ReturnType<typeof useUpdateTrainSchemaMutation>;
export type UpdateTrainSchemaMutationResult = Apollo.MutationResult<UpdateTrainSchemaMutation>;
export type UpdateTrainSchemaMutationOptions = Apollo.BaseMutationOptions<UpdateTrainSchemaMutation, UpdateTrainSchemaMutationVariables>;
export const CheckTrainSchemaDatesDocument = /*#__PURE__*/ gql`
    query checkTrainSchemaDates($trainSchemaId: Float!) {
  train_schemas {
    checkTrainSchemaDates(train_schema_id: $trainSchemaId)
  }
}
    `;

/**
 * __useCheckTrainSchemaDatesQuery__
 *
 * To run a query within a React component, call `useCheckTrainSchemaDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckTrainSchemaDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckTrainSchemaDatesQuery({
 *   variables: {
 *      trainSchemaId: // value for 'trainSchemaId'
 *   },
 * });
 */
export function useCheckTrainSchemaDatesQuery(baseOptions: Apollo.QueryHookOptions<CheckTrainSchemaDatesQuery, CheckTrainSchemaDatesQueryVariables> & ({ variables: CheckTrainSchemaDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckTrainSchemaDatesQuery, CheckTrainSchemaDatesQueryVariables>(CheckTrainSchemaDatesDocument, options);
      }
export function useCheckTrainSchemaDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckTrainSchemaDatesQuery, CheckTrainSchemaDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckTrainSchemaDatesQuery, CheckTrainSchemaDatesQueryVariables>(CheckTrainSchemaDatesDocument, options);
        }
export function useCheckTrainSchemaDatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckTrainSchemaDatesQuery, CheckTrainSchemaDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckTrainSchemaDatesQuery, CheckTrainSchemaDatesQueryVariables>(CheckTrainSchemaDatesDocument, options);
        }
export type CheckTrainSchemaDatesQueryHookResult = ReturnType<typeof useCheckTrainSchemaDatesQuery>;
export type CheckTrainSchemaDatesLazyQueryHookResult = ReturnType<typeof useCheckTrainSchemaDatesLazyQuery>;
export type CheckTrainSchemaDatesSuspenseQueryHookResult = ReturnType<typeof useCheckTrainSchemaDatesSuspenseQuery>;
export type CheckTrainSchemaDatesQueryResult = Apollo.QueryResult<CheckTrainSchemaDatesQuery, CheckTrainSchemaDatesQueryVariables>;
export const CheckIsSpreadPossibleToAllSchemasDocument = /*#__PURE__*/ gql`
    query checkIsSpreadPossibleToAllSchemas($data: CheckIsSpreadPossibleToAllSchemasRequestDto!) {
  train_schemas {
    checkIsSpreadPossibleToAllSchemas(data: $data)
  }
}
    `;

/**
 * __useCheckIsSpreadPossibleToAllSchemasQuery__
 *
 * To run a query within a React component, call `useCheckIsSpreadPossibleToAllSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIsSpreadPossibleToAllSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIsSpreadPossibleToAllSchemasQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckIsSpreadPossibleToAllSchemasQuery(baseOptions: Apollo.QueryHookOptions<CheckIsSpreadPossibleToAllSchemasQuery, CheckIsSpreadPossibleToAllSchemasQueryVariables> & ({ variables: CheckIsSpreadPossibleToAllSchemasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIsSpreadPossibleToAllSchemasQuery, CheckIsSpreadPossibleToAllSchemasQueryVariables>(CheckIsSpreadPossibleToAllSchemasDocument, options);
      }
export function useCheckIsSpreadPossibleToAllSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIsSpreadPossibleToAllSchemasQuery, CheckIsSpreadPossibleToAllSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIsSpreadPossibleToAllSchemasQuery, CheckIsSpreadPossibleToAllSchemasQueryVariables>(CheckIsSpreadPossibleToAllSchemasDocument, options);
        }
export function useCheckIsSpreadPossibleToAllSchemasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckIsSpreadPossibleToAllSchemasQuery, CheckIsSpreadPossibleToAllSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckIsSpreadPossibleToAllSchemasQuery, CheckIsSpreadPossibleToAllSchemasQueryVariables>(CheckIsSpreadPossibleToAllSchemasDocument, options);
        }
export type CheckIsSpreadPossibleToAllSchemasQueryHookResult = ReturnType<typeof useCheckIsSpreadPossibleToAllSchemasQuery>;
export type CheckIsSpreadPossibleToAllSchemasLazyQueryHookResult = ReturnType<typeof useCheckIsSpreadPossibleToAllSchemasLazyQuery>;
export type CheckIsSpreadPossibleToAllSchemasSuspenseQueryHookResult = ReturnType<typeof useCheckIsSpreadPossibleToAllSchemasSuspenseQuery>;
export type CheckIsSpreadPossibleToAllSchemasQueryResult = Apollo.QueryResult<CheckIsSpreadPossibleToAllSchemasQuery, CheckIsSpreadPossibleToAllSchemasQueryVariables>;
export const SchemaByIdForTrainDetailViewDocument = /*#__PURE__*/ gql`
    query schemaByIdForTrainDetailView($id: Float!) {
  train_schemas {
    byId(id: $id) {
      ...TrainSchemaBaseFragment
      locomotive_change {
        ...LocomotiveChangeFragment
      }
      locomotive_team_change {
        ...LocomotiveTeamChangeFragment
      }
      fuel_supply {
        ...FuelSupplyFragment
      }
      border_control {
        ...BorderControlFragment
      }
      eco_toilets {
        ...EcoToiletsFragment
      }
      water_supply {
        ...WaterSupplyFragment
      }
      waste_collection {
        ...WasteCollectionFragment
      }
      periodicity {
        ...PeriodicityInfoBaseFragment
        train {
          id
          train_number
        }
      }
      carriage_numerations {
        ...CarriageNumerationFragment
      }
      carriage_allocations {
        ...CarriageAllocationBaseFragment
      }
      carriage_classes {
        ...CarriageClassesBaseFragment
      }
      direct_carriages {
        ...DirectCarriagesFragment
      }
      established_train_schema {
        ... on EstablishedTrainSchemaStationDto {
          ...EstablishedTrainSchemaStationFragment
        }
        ... on EstablishedTrainSchemaRailwayDto {
          ...EstablishedTrainSchemaRailwayFragment
        }
      }
      max_train_length {
        ... on MaxTrainLengthRailwayDto {
          ...MaxTrainLengthRailwayFragment
        }
        ... on MaxTrainLengthStationDto {
          ...MaxTrainLengthStationFragment
        }
      }
      luxury_carriages {
        ...LuxuryCarriagesBaseFragment
      }
      maneuvering_work {
        ...ManeuveringWorkFragment
      }
      optional_carriages {
        ...OptionalCarriageBaseFragment
      }
      other_carriages {
        ...OtherCarriageFragment
      }
      trailed_carriages {
        ...TrailedCarriageFragment
      }
      train_change_directions {
        ...TrainChangeDirectionFragment
      }
      tables {
        table_blocks {
          carriage_group {
            name
          }
          table_block_rows {
            ...TableBlockRowBaseFragment
            stations {
              full_name
            }
          }
          ...TableBlockBaseFragment
        }
        ...TableBaseFragment
      }
    }
  }
}
    ${TrainSchemaBaseFragmentFragmentDoc}
${LocomotiveChangeFragmentFragmentDoc}
${LocomotiveTeamChangeFragmentFragmentDoc}
${FuelSupplyFragmentFragmentDoc}
${BorderControlFragmentFragmentDoc}
${EcoToiletsFragmentFragmentDoc}
${WaterSupplyFragmentFragmentDoc}
${WasteCollectionFragmentFragmentDoc}
${PeriodicityInfoBaseFragmentFragmentDoc}
${CarriageNumerationFragmentFragmentDoc}
${CarriageAllocationBaseFragmentFragmentDoc}
${CarriageClassesBaseFragmentFragmentDoc}
${DirectCarriagesFragmentFragmentDoc}
${EstablishedTrainSchemaStationFragmentFragmentDoc}
${EstablishedTrainSchemaRailwayFragmentFragmentDoc}
${MaxTrainLengthRailwayFragmentFragmentDoc}
${MaxTrainLengthStationFragmentFragmentDoc}
${LuxuryCarriagesBaseFragmentFragmentDoc}
${ManeuveringWorkFragmentFragmentDoc}
${OptionalCarriageBaseFragmentFragmentDoc}
${OtherCarriageFragmentFragmentDoc}
${TrailedCarriageFragmentFragmentDoc}
${TrainChangeDirectionFragmentFragmentDoc}
${TableBlockRowBaseFragmentFragmentDoc}
${TableBlockBaseFragmentFragmentDoc}
${TableBaseFragmentFragmentDoc}`;

/**
 * __useSchemaByIdForTrainDetailViewQuery__
 *
 * To run a query within a React component, call `useSchemaByIdForTrainDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaByIdForTrainDetailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaByIdForTrainDetailViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSchemaByIdForTrainDetailViewQuery(baseOptions: Apollo.QueryHookOptions<SchemaByIdForTrainDetailViewQuery, SchemaByIdForTrainDetailViewQueryVariables> & ({ variables: SchemaByIdForTrainDetailViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaByIdForTrainDetailViewQuery, SchemaByIdForTrainDetailViewQueryVariables>(SchemaByIdForTrainDetailViewDocument, options);
      }
export function useSchemaByIdForTrainDetailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaByIdForTrainDetailViewQuery, SchemaByIdForTrainDetailViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaByIdForTrainDetailViewQuery, SchemaByIdForTrainDetailViewQueryVariables>(SchemaByIdForTrainDetailViewDocument, options);
        }
export function useSchemaByIdForTrainDetailViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchemaByIdForTrainDetailViewQuery, SchemaByIdForTrainDetailViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemaByIdForTrainDetailViewQuery, SchemaByIdForTrainDetailViewQueryVariables>(SchemaByIdForTrainDetailViewDocument, options);
        }
export type SchemaByIdForTrainDetailViewQueryHookResult = ReturnType<typeof useSchemaByIdForTrainDetailViewQuery>;
export type SchemaByIdForTrainDetailViewLazyQueryHookResult = ReturnType<typeof useSchemaByIdForTrainDetailViewLazyQuery>;
export type SchemaByIdForTrainDetailViewSuspenseQueryHookResult = ReturnType<typeof useSchemaByIdForTrainDetailViewSuspenseQuery>;
export type SchemaByIdForTrainDetailViewQueryResult = Apollo.QueryResult<SchemaByIdForTrainDetailViewQuery, SchemaByIdForTrainDetailViewQueryVariables>;
export const ShortTrainsPairDocument = /*#__PURE__*/ gql`
    query shortTrainsPair($id: Float!) {
  train {
    pair(id: $id) {
      direct {
        id
        train_number
        sub_category {
          entity_id
        }
        schemas {
          id
          train_schema_number
        }
      }
      reverse {
        id
        train_number
        schemas {
          id
          train_schema_number
        }
      }
    }
  }
}
    `;

/**
 * __useShortTrainsPairQuery__
 *
 * To run a query within a React component, call `useShortTrainsPairQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortTrainsPairQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortTrainsPairQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShortTrainsPairQuery(baseOptions: Apollo.QueryHookOptions<ShortTrainsPairQuery, ShortTrainsPairQueryVariables> & ({ variables: ShortTrainsPairQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShortTrainsPairQuery, ShortTrainsPairQueryVariables>(ShortTrainsPairDocument, options);
      }
export function useShortTrainsPairLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortTrainsPairQuery, ShortTrainsPairQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShortTrainsPairQuery, ShortTrainsPairQueryVariables>(ShortTrainsPairDocument, options);
        }
export function useShortTrainsPairSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ShortTrainsPairQuery, ShortTrainsPairQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShortTrainsPairQuery, ShortTrainsPairQueryVariables>(ShortTrainsPairDocument, options);
        }
export type ShortTrainsPairQueryHookResult = ReturnType<typeof useShortTrainsPairQuery>;
export type ShortTrainsPairLazyQueryHookResult = ReturnType<typeof useShortTrainsPairLazyQuery>;
export type ShortTrainsPairSuspenseQueryHookResult = ReturnType<typeof useShortTrainsPairSuspenseQuery>;
export type ShortTrainsPairQueryResult = Apollo.QueryResult<ShortTrainsPairQuery, ShortTrainsPairQueryVariables>;
export const RailwayListFromTrainScheduleDocument = /*#__PURE__*/ gql`
    query railwayListFromTrainSchedule($trainId: Int!) {
  train_schemas {
    getRailwayListFromTrainSchedule(data: {train_id: $trainId}) {
      entity_id
      name
      short_name
      code
    }
  }
}
    `;

/**
 * __useRailwayListFromTrainScheduleQuery__
 *
 * To run a query within a React component, call `useRailwayListFromTrainScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRailwayListFromTrainScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRailwayListFromTrainScheduleQuery({
 *   variables: {
 *      trainId: // value for 'trainId'
 *   },
 * });
 */
export function useRailwayListFromTrainScheduleQuery(baseOptions: Apollo.QueryHookOptions<RailwayListFromTrainScheduleQuery, RailwayListFromTrainScheduleQueryVariables> & ({ variables: RailwayListFromTrainScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RailwayListFromTrainScheduleQuery, RailwayListFromTrainScheduleQueryVariables>(RailwayListFromTrainScheduleDocument, options);
      }
export function useRailwayListFromTrainScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RailwayListFromTrainScheduleQuery, RailwayListFromTrainScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RailwayListFromTrainScheduleQuery, RailwayListFromTrainScheduleQueryVariables>(RailwayListFromTrainScheduleDocument, options);
        }
export function useRailwayListFromTrainScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RailwayListFromTrainScheduleQuery, RailwayListFromTrainScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RailwayListFromTrainScheduleQuery, RailwayListFromTrainScheduleQueryVariables>(RailwayListFromTrainScheduleDocument, options);
        }
export type RailwayListFromTrainScheduleQueryHookResult = ReturnType<typeof useRailwayListFromTrainScheduleQuery>;
export type RailwayListFromTrainScheduleLazyQueryHookResult = ReturnType<typeof useRailwayListFromTrainScheduleLazyQuery>;
export type RailwayListFromTrainScheduleSuspenseQueryHookResult = ReturnType<typeof useRailwayListFromTrainScheduleSuspenseQuery>;
export type RailwayListFromTrainScheduleQueryResult = Apollo.QueryResult<RailwayListFromTrainScheduleQuery, RailwayListFromTrainScheduleQueryVariables>;
export const SchemasListForTrainSelectDocument = /*#__PURE__*/ gql`
    query schemasListForTrainSelect($trainId: Float!) {
  train {
    byId(id: $trainId) {
      id
      schemas {
        id
        train_schema_number
      }
    }
  }
}
    `;

/**
 * __useSchemasListForTrainSelectQuery__
 *
 * To run a query within a React component, call `useSchemasListForTrainSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemasListForTrainSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemasListForTrainSelectQuery({
 *   variables: {
 *      trainId: // value for 'trainId'
 *   },
 * });
 */
export function useSchemasListForTrainSelectQuery(baseOptions: Apollo.QueryHookOptions<SchemasListForTrainSelectQuery, SchemasListForTrainSelectQueryVariables> & ({ variables: SchemasListForTrainSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemasListForTrainSelectQuery, SchemasListForTrainSelectQueryVariables>(SchemasListForTrainSelectDocument, options);
      }
export function useSchemasListForTrainSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemasListForTrainSelectQuery, SchemasListForTrainSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemasListForTrainSelectQuery, SchemasListForTrainSelectQueryVariables>(SchemasListForTrainSelectDocument, options);
        }
export function useSchemasListForTrainSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchemasListForTrainSelectQuery, SchemasListForTrainSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemasListForTrainSelectQuery, SchemasListForTrainSelectQueryVariables>(SchemasListForTrainSelectDocument, options);
        }
export type SchemasListForTrainSelectQueryHookResult = ReturnType<typeof useSchemasListForTrainSelectQuery>;
export type SchemasListForTrainSelectLazyQueryHookResult = ReturnType<typeof useSchemasListForTrainSelectLazyQuery>;
export type SchemasListForTrainSelectSuspenseQueryHookResult = ReturnType<typeof useSchemasListForTrainSelectSuspenseQuery>;
export type SchemasListForTrainSelectQueryResult = Apollo.QueryResult<SchemasListForTrainSelectQuery, SchemasListForTrainSelectQueryVariables>;
export const StationListFromTrainScheduleDocument = /*#__PURE__*/ gql`
    query stationListFromTrainSchedule($data: GetStationListFromTrainScheduleDto!) {
  train_schemas {
    getStationListFromTrainSchedule(data: $data) {
      entity_id
      full_name
      express_code
      parking_direction
    }
  }
}
    `;

/**
 * __useStationListFromTrainScheduleQuery__
 *
 * To run a query within a React component, call `useStationListFromTrainScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationListFromTrainScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationListFromTrainScheduleQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStationListFromTrainScheduleQuery(baseOptions: Apollo.QueryHookOptions<StationListFromTrainScheduleQuery, StationListFromTrainScheduleQueryVariables> & ({ variables: StationListFromTrainScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StationListFromTrainScheduleQuery, StationListFromTrainScheduleQueryVariables>(StationListFromTrainScheduleDocument, options);
      }
export function useStationListFromTrainScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StationListFromTrainScheduleQuery, StationListFromTrainScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StationListFromTrainScheduleQuery, StationListFromTrainScheduleQueryVariables>(StationListFromTrainScheduleDocument, options);
        }
export function useStationListFromTrainScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StationListFromTrainScheduleQuery, StationListFromTrainScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StationListFromTrainScheduleQuery, StationListFromTrainScheduleQueryVariables>(StationListFromTrainScheduleDocument, options);
        }
export type StationListFromTrainScheduleQueryHookResult = ReturnType<typeof useStationListFromTrainScheduleQuery>;
export type StationListFromTrainScheduleLazyQueryHookResult = ReturnType<typeof useStationListFromTrainScheduleLazyQuery>;
export type StationListFromTrainScheduleSuspenseQueryHookResult = ReturnType<typeof useStationListFromTrainScheduleSuspenseQuery>;
export type StationListFromTrainScheduleQueryResult = Apollo.QueryResult<StationListFromTrainScheduleQuery, StationListFromTrainScheduleQueryVariables>;
export const TrainSubCategoryByTrainNumberForUpdateTrainViewDocument = /*#__PURE__*/ gql`
    query trainSubCategoryByTrainNumberForUpdateTrainView($trainNumber: String!, $range: RangeInputDto!) {
  classifiers {
    trainSubCategory {
      byTrainNumber(trainNumber: $trainNumber, range: $range) {
        items {
          entity_id
          train_sub_category
          train_category_id
        }
      }
    }
  }
}
    `;

/**
 * __useTrainSubCategoryByTrainNumberForUpdateTrainViewQuery__
 *
 * To run a query within a React component, call `useTrainSubCategoryByTrainNumberForUpdateTrainViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainSubCategoryByTrainNumberForUpdateTrainViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainSubCategoryByTrainNumberForUpdateTrainViewQuery({
 *   variables: {
 *      trainNumber: // value for 'trainNumber'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainSubCategoryByTrainNumberForUpdateTrainViewQuery(baseOptions: Apollo.QueryHookOptions<TrainSubCategoryByTrainNumberForUpdateTrainViewQuery, TrainSubCategoryByTrainNumberForUpdateTrainViewQueryVariables> & ({ variables: TrainSubCategoryByTrainNumberForUpdateTrainViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainSubCategoryByTrainNumberForUpdateTrainViewQuery, TrainSubCategoryByTrainNumberForUpdateTrainViewQueryVariables>(TrainSubCategoryByTrainNumberForUpdateTrainViewDocument, options);
      }
export function useTrainSubCategoryByTrainNumberForUpdateTrainViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainSubCategoryByTrainNumberForUpdateTrainViewQuery, TrainSubCategoryByTrainNumberForUpdateTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainSubCategoryByTrainNumberForUpdateTrainViewQuery, TrainSubCategoryByTrainNumberForUpdateTrainViewQueryVariables>(TrainSubCategoryByTrainNumberForUpdateTrainViewDocument, options);
        }
export function useTrainSubCategoryByTrainNumberForUpdateTrainViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainSubCategoryByTrainNumberForUpdateTrainViewQuery, TrainSubCategoryByTrainNumberForUpdateTrainViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainSubCategoryByTrainNumberForUpdateTrainViewQuery, TrainSubCategoryByTrainNumberForUpdateTrainViewQueryVariables>(TrainSubCategoryByTrainNumberForUpdateTrainViewDocument, options);
        }
export type TrainSubCategoryByTrainNumberForUpdateTrainViewQueryHookResult = ReturnType<typeof useTrainSubCategoryByTrainNumberForUpdateTrainViewQuery>;
export type TrainSubCategoryByTrainNumberForUpdateTrainViewLazyQueryHookResult = ReturnType<typeof useTrainSubCategoryByTrainNumberForUpdateTrainViewLazyQuery>;
export type TrainSubCategoryByTrainNumberForUpdateTrainViewSuspenseQueryHookResult = ReturnType<typeof useTrainSubCategoryByTrainNumberForUpdateTrainViewSuspenseQuery>;
export type TrainSubCategoryByTrainNumberForUpdateTrainViewQueryResult = Apollo.QueryResult<TrainSubCategoryByTrainNumberForUpdateTrainViewQuery, TrainSubCategoryByTrainNumberForUpdateTrainViewQueryVariables>;
export const TrainsListOnlyTotalCountForUpdateViewDocument = /*#__PURE__*/ gql`
    query trainsListOnlyTotalCountForUpdateView($paginate: PaginatorArgsDto, $orderBy: [TrainQueryResolver_List_SortingInputType!], $where: TrainQueryResolver_List_FilterInputType) {
  train {
    list(paginate: $paginate, order_by: $orderBy, where: $where) {
      totalCount
      items {
        id
      }
    }
  }
}
    `;

/**
 * __useTrainsListOnlyTotalCountForUpdateViewQuery__
 *
 * To run a query within a React component, call `useTrainsListOnlyTotalCountForUpdateViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainsListOnlyTotalCountForUpdateViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainsListOnlyTotalCountForUpdateViewQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrainsListOnlyTotalCountForUpdateViewQuery(baseOptions?: Apollo.QueryHookOptions<TrainsListOnlyTotalCountForUpdateViewQuery, TrainsListOnlyTotalCountForUpdateViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainsListOnlyTotalCountForUpdateViewQuery, TrainsListOnlyTotalCountForUpdateViewQueryVariables>(TrainsListOnlyTotalCountForUpdateViewDocument, options);
      }
export function useTrainsListOnlyTotalCountForUpdateViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainsListOnlyTotalCountForUpdateViewQuery, TrainsListOnlyTotalCountForUpdateViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainsListOnlyTotalCountForUpdateViewQuery, TrainsListOnlyTotalCountForUpdateViewQueryVariables>(TrainsListOnlyTotalCountForUpdateViewDocument, options);
        }
export function useTrainsListOnlyTotalCountForUpdateViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainsListOnlyTotalCountForUpdateViewQuery, TrainsListOnlyTotalCountForUpdateViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainsListOnlyTotalCountForUpdateViewQuery, TrainsListOnlyTotalCountForUpdateViewQueryVariables>(TrainsListOnlyTotalCountForUpdateViewDocument, options);
        }
export type TrainsListOnlyTotalCountForUpdateViewQueryHookResult = ReturnType<typeof useTrainsListOnlyTotalCountForUpdateViewQuery>;
export type TrainsListOnlyTotalCountForUpdateViewLazyQueryHookResult = ReturnType<typeof useTrainsListOnlyTotalCountForUpdateViewLazyQuery>;
export type TrainsListOnlyTotalCountForUpdateViewSuspenseQueryHookResult = ReturnType<typeof useTrainsListOnlyTotalCountForUpdateViewSuspenseQuery>;
export type TrainsListOnlyTotalCountForUpdateViewQueryResult = Apollo.QueryResult<TrainsListOnlyTotalCountForUpdateViewQuery, TrainsListOnlyTotalCountForUpdateViewQueryVariables>;
export const UpdateTrainNumberDocument = /*#__PURE__*/ gql`
    mutation updateTrainNumber($data: EditTrainNumberDto!) {
  train {
    editTrainNumber(data: $data)
  }
}
    `;
export type UpdateTrainNumberMutationFn = Apollo.MutationFunction<UpdateTrainNumberMutation, UpdateTrainNumberMutationVariables>;

/**
 * __useUpdateTrainNumberMutation__
 *
 * To run a mutation, you first call `useUpdateTrainNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainNumberMutation, { data, loading, error }] = useUpdateTrainNumberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTrainNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainNumberMutation, UpdateTrainNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainNumberMutation, UpdateTrainNumberMutationVariables>(UpdateTrainNumberDocument, options);
      }
export type UpdateTrainNumberMutationHookResult = ReturnType<typeof useUpdateTrainNumberMutation>;
export type UpdateTrainNumberMutationResult = Apollo.MutationResult<UpdateTrainNumberMutation>;
export type UpdateTrainNumberMutationOptions = Apollo.BaseMutationOptions<UpdateTrainNumberMutation, UpdateTrainNumberMutationVariables>;
export const UpdateTrainsPairDocument = /*#__PURE__*/ gql`
    mutation updateTrainsPair($data: UpdateTrainDto!) {
  train {
    update(data: $data)
  }
}
    `;
export type UpdateTrainsPairMutationFn = Apollo.MutationFunction<UpdateTrainsPairMutation, UpdateTrainsPairMutationVariables>;

/**
 * __useUpdateTrainsPairMutation__
 *
 * To run a mutation, you first call `useUpdateTrainsPairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainsPairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainsPairMutation, { data, loading, error }] = useUpdateTrainsPairMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTrainsPairMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainsPairMutation, UpdateTrainsPairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainsPairMutation, UpdateTrainsPairMutationVariables>(UpdateTrainsPairDocument, options);
      }
export type UpdateTrainsPairMutationHookResult = ReturnType<typeof useUpdateTrainsPairMutation>;
export type UpdateTrainsPairMutationResult = Apollo.MutationResult<UpdateTrainsPairMutation>;
export type UpdateTrainsPairMutationOptions = Apollo.BaseMutationOptions<UpdateTrainsPairMutation, UpdateTrainsPairMutationVariables>;
export const CopyTrainCarriageGroupDocument = /*#__PURE__*/ gql`
    mutation copyTrainCarriageGroup($id: Float!) {
  carriageGroups {
    copy(id: $id)
  }
}
    `;
export type CopyTrainCarriageGroupMutationFn = Apollo.MutationFunction<CopyTrainCarriageGroupMutation, CopyTrainCarriageGroupMutationVariables>;

/**
 * __useCopyTrainCarriageGroupMutation__
 *
 * To run a mutation, you first call `useCopyTrainCarriageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyTrainCarriageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyTrainCarriageGroupMutation, { data, loading, error }] = useCopyTrainCarriageGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCopyTrainCarriageGroupMutation(baseOptions?: Apollo.MutationHookOptions<CopyTrainCarriageGroupMutation, CopyTrainCarriageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyTrainCarriageGroupMutation, CopyTrainCarriageGroupMutationVariables>(CopyTrainCarriageGroupDocument, options);
      }
export type CopyTrainCarriageGroupMutationHookResult = ReturnType<typeof useCopyTrainCarriageGroupMutation>;
export type CopyTrainCarriageGroupMutationResult = Apollo.MutationResult<CopyTrainCarriageGroupMutation>;
export type CopyTrainCarriageGroupMutationOptions = Apollo.BaseMutationOptions<CopyTrainCarriageGroupMutation, CopyTrainCarriageGroupMutationVariables>;
export const DeleteTrainCarriageGroupDocument = /*#__PURE__*/ gql`
    mutation deleteTrainCarriageGroup($id: Float!) {
  carriageGroups {
    deleteCarriageGroup(id: $id)
  }
}
    `;
export type DeleteTrainCarriageGroupMutationFn = Apollo.MutationFunction<DeleteTrainCarriageGroupMutation, DeleteTrainCarriageGroupMutationVariables>;

/**
 * __useDeleteTrainCarriageGroupMutation__
 *
 * To run a mutation, you first call `useDeleteTrainCarriageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrainCarriageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrainCarriageGroupMutation, { data, loading, error }] = useDeleteTrainCarriageGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrainCarriageGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrainCarriageGroupMutation, DeleteTrainCarriageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrainCarriageGroupMutation, DeleteTrainCarriageGroupMutationVariables>(DeleteTrainCarriageGroupDocument, options);
      }
export type DeleteTrainCarriageGroupMutationHookResult = ReturnType<typeof useDeleteTrainCarriageGroupMutation>;
export type DeleteTrainCarriageGroupMutationResult = Apollo.MutationResult<DeleteTrainCarriageGroupMutation>;
export type DeleteTrainCarriageGroupMutationOptions = Apollo.BaseMutationOptions<DeleteTrainCarriageGroupMutation, DeleteTrainCarriageGroupMutationVariables>;
export const TrainCarriageGroupListDocument = /*#__PURE__*/ gql`
    query trainCarriageGroupList($paginate: PaginatorArgsDto, $orderBy: [CarriageGroupQueryResolver_CarriageGroupList_SortingInputType!], $where: CarriageGroupQueryResolver_CarriageGroupList_FilterInputType, $search: String!) {
  carriageGroups {
    carriageGroupList(
      paginate: $paginate
      order_by: $orderBy
      where: $where
      search: $search
    ) {
      totalCount
      items {
        ...CarriageGroupViewFragment
      }
    }
  }
}
    ${CarriageGroupViewFragmentFragmentDoc}`;

/**
 * __useTrainCarriageGroupListQuery__
 *
 * To run a query within a React component, call `useTrainCarriageGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainCarriageGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainCarriageGroupListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTrainCarriageGroupListQuery(baseOptions: Apollo.QueryHookOptions<TrainCarriageGroupListQuery, TrainCarriageGroupListQueryVariables> & ({ variables: TrainCarriageGroupListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainCarriageGroupListQuery, TrainCarriageGroupListQueryVariables>(TrainCarriageGroupListDocument, options);
      }
export function useTrainCarriageGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainCarriageGroupListQuery, TrainCarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainCarriageGroupListQuery, TrainCarriageGroupListQueryVariables>(TrainCarriageGroupListDocument, options);
        }
export function useTrainCarriageGroupListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainCarriageGroupListQuery, TrainCarriageGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainCarriageGroupListQuery, TrainCarriageGroupListQueryVariables>(TrainCarriageGroupListDocument, options);
        }
export type TrainCarriageGroupListQueryHookResult = ReturnType<typeof useTrainCarriageGroupListQuery>;
export type TrainCarriageGroupListLazyQueryHookResult = ReturnType<typeof useTrainCarriageGroupListLazyQuery>;
export type TrainCarriageGroupListSuspenseQueryHookResult = ReturnType<typeof useTrainCarriageGroupListSuspenseQuery>;
export type TrainCarriageGroupListQueryResult = Apollo.QueryResult<TrainCarriageGroupListQuery, TrainCarriageGroupListQueryVariables>;
export const TrainDetailDefaultFilterDocument = /*#__PURE__*/ gql`
    query trainDetailDefaultFilter($id: Float!) {
  train {
    pair(id: $id) {
      direct {
        id
        gdp {
          ...GdpShortFragment
        }
        rolling_stock_types
      }
      reverse {
        id
      }
    }
  }
}
    ${GdpShortFragmentFragmentDoc}`;

/**
 * __useTrainDetailDefaultFilterQuery__
 *
 * To run a query within a React component, call `useTrainDetailDefaultFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainDetailDefaultFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainDetailDefaultFilterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainDetailDefaultFilterQuery(baseOptions: Apollo.QueryHookOptions<TrainDetailDefaultFilterQuery, TrainDetailDefaultFilterQueryVariables> & ({ variables: TrainDetailDefaultFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainDetailDefaultFilterQuery, TrainDetailDefaultFilterQueryVariables>(TrainDetailDefaultFilterDocument, options);
      }
export function useTrainDetailDefaultFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainDetailDefaultFilterQuery, TrainDetailDefaultFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainDetailDefaultFilterQuery, TrainDetailDefaultFilterQueryVariables>(TrainDetailDefaultFilterDocument, options);
        }
export function useTrainDetailDefaultFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainDetailDefaultFilterQuery, TrainDetailDefaultFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainDetailDefaultFilterQuery, TrainDetailDefaultFilterQueryVariables>(TrainDetailDefaultFilterDocument, options);
        }
export type TrainDetailDefaultFilterQueryHookResult = ReturnType<typeof useTrainDetailDefaultFilterQuery>;
export type TrainDetailDefaultFilterLazyQueryHookResult = ReturnType<typeof useTrainDetailDefaultFilterLazyQuery>;
export type TrainDetailDefaultFilterSuspenseQueryHookResult = ReturnType<typeof useTrainDetailDefaultFilterSuspenseQuery>;
export type TrainDetailDefaultFilterQueryResult = Apollo.QueryResult<TrainDetailDefaultFilterQuery, TrainDetailDefaultFilterQueryVariables>;
export const TrainExportCarriageGroupListDocument = /*#__PURE__*/ gql`
    mutation trainExportCarriageGroupList($where: CarriageGroupMutationResolver_ExportCarriageGroupsList_FilterInputType!) {
  carriageGroups {
    exportCarriageGroupsList(where: $where)
  }
}
    `;
export type TrainExportCarriageGroupListMutationFn = Apollo.MutationFunction<TrainExportCarriageGroupListMutation, TrainExportCarriageGroupListMutationVariables>;

/**
 * __useTrainExportCarriageGroupListMutation__
 *
 * To run a mutation, you first call `useTrainExportCarriageGroupListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainExportCarriageGroupListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainExportCarriageGroupListMutation, { data, loading, error }] = useTrainExportCarriageGroupListMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrainExportCarriageGroupListMutation(baseOptions?: Apollo.MutationHookOptions<TrainExportCarriageGroupListMutation, TrainExportCarriageGroupListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainExportCarriageGroupListMutation, TrainExportCarriageGroupListMutationVariables>(TrainExportCarriageGroupListDocument, options);
      }
export type TrainExportCarriageGroupListMutationHookResult = ReturnType<typeof useTrainExportCarriageGroupListMutation>;
export type TrainExportCarriageGroupListMutationResult = Apollo.MutationResult<TrainExportCarriageGroupListMutation>;
export type TrainExportCarriageGroupListMutationOptions = Apollo.BaseMutationOptions<TrainExportCarriageGroupListMutation, TrainExportCarriageGroupListMutationVariables>;
export const TrainHeadCarriageGroupsDocument = /*#__PURE__*/ gql`
    query trainHeadCarriageGroups($id: Float!) {
  train {
    pair(id: $id) {
      direct {
        status
        gdp {
          ...GdpBaseFragment
        }
        lock_user {
          ...UserShortFragment
        }
        rolling_stock_types
      }
    }
  }
}
    ${GdpBaseFragmentFragmentDoc}
${UserShortFragmentFragmentDoc}`;

/**
 * __useTrainHeadCarriageGroupsQuery__
 *
 * To run a query within a React component, call `useTrainHeadCarriageGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainHeadCarriageGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainHeadCarriageGroupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainHeadCarriageGroupsQuery(baseOptions: Apollo.QueryHookOptions<TrainHeadCarriageGroupsQuery, TrainHeadCarriageGroupsQueryVariables> & ({ variables: TrainHeadCarriageGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainHeadCarriageGroupsQuery, TrainHeadCarriageGroupsQueryVariables>(TrainHeadCarriageGroupsDocument, options);
      }
export function useTrainHeadCarriageGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainHeadCarriageGroupsQuery, TrainHeadCarriageGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainHeadCarriageGroupsQuery, TrainHeadCarriageGroupsQueryVariables>(TrainHeadCarriageGroupsDocument, options);
        }
export function useTrainHeadCarriageGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainHeadCarriageGroupsQuery, TrainHeadCarriageGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainHeadCarriageGroupsQuery, TrainHeadCarriageGroupsQueryVariables>(TrainHeadCarriageGroupsDocument, options);
        }
export type TrainHeadCarriageGroupsQueryHookResult = ReturnType<typeof useTrainHeadCarriageGroupsQuery>;
export type TrainHeadCarriageGroupsLazyQueryHookResult = ReturnType<typeof useTrainHeadCarriageGroupsLazyQuery>;
export type TrainHeadCarriageGroupsSuspenseQueryHookResult = ReturnType<typeof useTrainHeadCarriageGroupsSuspenseQuery>;
export type TrainHeadCarriageGroupsQueryResult = Apollo.QueryResult<TrainHeadCarriageGroupsQuery, TrainHeadCarriageGroupsQueryVariables>;
export const TrainLockDocument = /*#__PURE__*/ gql`
    mutation trainLock($data: LockTrainDto!) {
  train {
    lock(data: $data)
  }
}
    `;
export type TrainLockMutationFn = Apollo.MutationFunction<TrainLockMutation, TrainLockMutationVariables>;

/**
 * __useTrainLockMutation__
 *
 * To run a mutation, you first call `useTrainLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainLockMutation, { data, loading, error }] = useTrainLockMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTrainLockMutation(baseOptions?: Apollo.MutationHookOptions<TrainLockMutation, TrainLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainLockMutation, TrainLockMutationVariables>(TrainLockDocument, options);
      }
export type TrainLockMutationHookResult = ReturnType<typeof useTrainLockMutation>;
export type TrainLockMutationResult = Apollo.MutationResult<TrainLockMutation>;
export type TrainLockMutationOptions = Apollo.BaseMutationOptions<TrainLockMutation, TrainLockMutationVariables>;
export const DeclineApprovedDocument = /*#__PURE__*/ gql`
    mutation declineApproved($data: UpdateTrainStatusDto!) {
  train {
    declineApproved(data: $data) {
      status
    }
  }
}
    `;
export type DeclineApprovedMutationFn = Apollo.MutationFunction<DeclineApprovedMutation, DeclineApprovedMutationVariables>;

/**
 * __useDeclineApprovedMutation__
 *
 * To run a mutation, you first call `useDeclineApprovedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineApprovedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineApprovedMutation, { data, loading, error }] = useDeclineApprovedMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeclineApprovedMutation(baseOptions?: Apollo.MutationHookOptions<DeclineApprovedMutation, DeclineApprovedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineApprovedMutation, DeclineApprovedMutationVariables>(DeclineApprovedDocument, options);
      }
export type DeclineApprovedMutationHookResult = ReturnType<typeof useDeclineApprovedMutation>;
export type DeclineApprovedMutationResult = Apollo.MutationResult<DeclineApprovedMutation>;
export type DeclineApprovedMutationOptions = Apollo.BaseMutationOptions<DeclineApprovedMutation, DeclineApprovedMutationVariables>;
export const DeleteTrainDocument = /*#__PURE__*/ gql`
    mutation deleteTrain($id: Float!) {
  train {
    delete(id: $id)
  }
}
    `;
export type DeleteTrainMutationFn = Apollo.MutationFunction<DeleteTrainMutation, DeleteTrainMutationVariables>;

/**
 * __useDeleteTrainMutation__
 *
 * To run a mutation, you first call `useDeleteTrainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrainMutation, { data, loading, error }] = useDeleteTrainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrainMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrainMutation, DeleteTrainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrainMutation, DeleteTrainMutationVariables>(DeleteTrainDocument, options);
      }
export type DeleteTrainMutationHookResult = ReturnType<typeof useDeleteTrainMutation>;
export type DeleteTrainMutationResult = Apollo.MutationResult<DeleteTrainMutation>;
export type DeleteTrainMutationOptions = Apollo.BaseMutationOptions<DeleteTrainMutation, DeleteTrainMutationVariables>;
export const ExportTrainListDocument = /*#__PURE__*/ gql`
    mutation exportTrainList($where: TrainMutationResolver_ExportTrainList_FilterInputType!, $data: ExportTrainListDto!) {
  train {
    exportTrainList(where: $where, data: $data)
  }
}
    `;
export type ExportTrainListMutationFn = Apollo.MutationFunction<ExportTrainListMutation, ExportTrainListMutationVariables>;

/**
 * __useExportTrainListMutation__
 *
 * To run a mutation, you first call `useExportTrainListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportTrainListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportTrainListMutation, { data, loading, error }] = useExportTrainListMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExportTrainListMutation(baseOptions?: Apollo.MutationHookOptions<ExportTrainListMutation, ExportTrainListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportTrainListMutation, ExportTrainListMutationVariables>(ExportTrainListDocument, options);
      }
export type ExportTrainListMutationHookResult = ReturnType<typeof useExportTrainListMutation>;
export type ExportTrainListMutationResult = Apollo.MutationResult<ExportTrainListMutation>;
export type ExportTrainListMutationOptions = Apollo.BaseMutationOptions<ExportTrainListMutation, ExportTrainListMutationVariables>;
export const TrainApproveBySubdivisionDocument = /*#__PURE__*/ gql`
    mutation trainApproveBySubdivision($id: Float!) {
  train {
    approveBySubdivision(train_id: $id)
  }
}
    `;
export type TrainApproveBySubdivisionMutationFn = Apollo.MutationFunction<TrainApproveBySubdivisionMutation, TrainApproveBySubdivisionMutationVariables>;

/**
 * __useTrainApproveBySubdivisionMutation__
 *
 * To run a mutation, you first call `useTrainApproveBySubdivisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainApproveBySubdivisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainApproveBySubdivisionMutation, { data, loading, error }] = useTrainApproveBySubdivisionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainApproveBySubdivisionMutation(baseOptions?: Apollo.MutationHookOptions<TrainApproveBySubdivisionMutation, TrainApproveBySubdivisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainApproveBySubdivisionMutation, TrainApproveBySubdivisionMutationVariables>(TrainApproveBySubdivisionDocument, options);
      }
export type TrainApproveBySubdivisionMutationHookResult = ReturnType<typeof useTrainApproveBySubdivisionMutation>;
export type TrainApproveBySubdivisionMutationResult = Apollo.MutationResult<TrainApproveBySubdivisionMutation>;
export type TrainApproveBySubdivisionMutationOptions = Apollo.BaseMutationOptions<TrainApproveBySubdivisionMutation, TrainApproveBySubdivisionMutationVariables>;
export const TrainCreateVersionDocument = /*#__PURE__*/ gql`
    mutation trainCreateVersion($data: CreateVersionDto!) {
  train {
    createVersion(data: $data) {
      train_ids
      error_message
    }
  }
}
    `;
export type TrainCreateVersionMutationFn = Apollo.MutationFunction<TrainCreateVersionMutation, TrainCreateVersionMutationVariables>;

/**
 * __useTrainCreateVersionMutation__
 *
 * To run a mutation, you first call `useTrainCreateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainCreateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainCreateVersionMutation, { data, loading, error }] = useTrainCreateVersionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTrainCreateVersionMutation(baseOptions?: Apollo.MutationHookOptions<TrainCreateVersionMutation, TrainCreateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainCreateVersionMutation, TrainCreateVersionMutationVariables>(TrainCreateVersionDocument, options);
      }
export type TrainCreateVersionMutationHookResult = ReturnType<typeof useTrainCreateVersionMutation>;
export type TrainCreateVersionMutationResult = Apollo.MutationResult<TrainCreateVersionMutation>;
export type TrainCreateVersionMutationOptions = Apollo.BaseMutationOptions<TrainCreateVersionMutation, TrainCreateVersionMutationVariables>;
export const TrainDeclineBySubdivisionDocument = /*#__PURE__*/ gql`
    mutation trainDeclineBySubdivision($id: Float!) {
  train {
    declineBySubdivision(train_id: $id)
  }
}
    `;
export type TrainDeclineBySubdivisionMutationFn = Apollo.MutationFunction<TrainDeclineBySubdivisionMutation, TrainDeclineBySubdivisionMutationVariables>;

/**
 * __useTrainDeclineBySubdivisionMutation__
 *
 * To run a mutation, you first call `useTrainDeclineBySubdivisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainDeclineBySubdivisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainDeclineBySubdivisionMutation, { data, loading, error }] = useTrainDeclineBySubdivisionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainDeclineBySubdivisionMutation(baseOptions?: Apollo.MutationHookOptions<TrainDeclineBySubdivisionMutation, TrainDeclineBySubdivisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainDeclineBySubdivisionMutation, TrainDeclineBySubdivisionMutationVariables>(TrainDeclineBySubdivisionDocument, options);
      }
export type TrainDeclineBySubdivisionMutationHookResult = ReturnType<typeof useTrainDeclineBySubdivisionMutation>;
export type TrainDeclineBySubdivisionMutationResult = Apollo.MutationResult<TrainDeclineBySubdivisionMutation>;
export type TrainDeclineBySubdivisionMutationOptions = Apollo.BaseMutationOptions<TrainDeclineBySubdivisionMutation, TrainDeclineBySubdivisionMutationVariables>;
export const TrainToApprovalDocument = /*#__PURE__*/ gql`
    mutation trainToApproval($data: UpdateTrainStatusDto!) {
  train {
    toApproval(data: $data) {
      status
    }
  }
}
    `;
export type TrainToApprovalMutationFn = Apollo.MutationFunction<TrainToApprovalMutation, TrainToApprovalMutationVariables>;

/**
 * __useTrainToApprovalMutation__
 *
 * To run a mutation, you first call `useTrainToApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainToApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainToApprovalMutation, { data, loading, error }] = useTrainToApprovalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTrainToApprovalMutation(baseOptions?: Apollo.MutationHookOptions<TrainToApprovalMutation, TrainToApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainToApprovalMutation, TrainToApprovalMutationVariables>(TrainToApprovalDocument, options);
      }
export type TrainToApprovalMutationHookResult = ReturnType<typeof useTrainToApprovalMutation>;
export type TrainToApprovalMutationResult = Apollo.MutationResult<TrainToApprovalMutation>;
export type TrainToApprovalMutationOptions = Apollo.BaseMutationOptions<TrainToApprovalMutation, TrainToApprovalMutationVariables>;
export const TrainToApprovedDocument = /*#__PURE__*/ gql`
    mutation trainToApproved($data: UpdateTrainStatusDto!) {
  train {
    toApproved(data: $data) {
      status
    }
  }
}
    `;
export type TrainToApprovedMutationFn = Apollo.MutationFunction<TrainToApprovedMutation, TrainToApprovedMutationVariables>;

/**
 * __useTrainToApprovedMutation__
 *
 * To run a mutation, you first call `useTrainToApprovedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainToApprovedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainToApprovedMutation, { data, loading, error }] = useTrainToApprovedMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTrainToApprovedMutation(baseOptions?: Apollo.MutationHookOptions<TrainToApprovedMutation, TrainToApprovedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainToApprovedMutation, TrainToApprovedMutationVariables>(TrainToApprovedDocument, options);
      }
export type TrainToApprovedMutationHookResult = ReturnType<typeof useTrainToApprovedMutation>;
export type TrainToApprovedMutationResult = Apollo.MutationResult<TrainToApprovedMutation>;
export type TrainToApprovedMutationOptions = Apollo.BaseMutationOptions<TrainToApprovedMutation, TrainToApprovedMutationVariables>;
export const TrainToPlanningDocument = /*#__PURE__*/ gql`
    mutation trainToPlanning($data: UpdateTrainStatusDto!) {
  train {
    toPlanning(data: $data) {
      status
    }
  }
}
    `;
export type TrainToPlanningMutationFn = Apollo.MutationFunction<TrainToPlanningMutation, TrainToPlanningMutationVariables>;

/**
 * __useTrainToPlanningMutation__
 *
 * To run a mutation, you first call `useTrainToPlanningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainToPlanningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainToPlanningMutation, { data, loading, error }] = useTrainToPlanningMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTrainToPlanningMutation(baseOptions?: Apollo.MutationHookOptions<TrainToPlanningMutation, TrainToPlanningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainToPlanningMutation, TrainToPlanningMutationVariables>(TrainToPlanningDocument, options);
      }
export type TrainToPlanningMutationHookResult = ReturnType<typeof useTrainToPlanningMutation>;
export type TrainToPlanningMutationResult = Apollo.MutationResult<TrainToPlanningMutation>;
export type TrainToPlanningMutationOptions = Apollo.BaseMutationOptions<TrainToPlanningMutation, TrainToPlanningMutationVariables>;
export const CheckCreateVersionPossibilityDocument = /*#__PURE__*/ gql`
    query checkCreateVersionPossibility($data: CheckCreateVersionPossibilityDto!) {
  train {
    checkCreateVersionPossibility(data: $data) {
      is_create_version_for_missed_trains
      is_create_version_possible
      message
    }
  }
}
    `;

/**
 * __useCheckCreateVersionPossibilityQuery__
 *
 * To run a query within a React component, call `useCheckCreateVersionPossibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCreateVersionPossibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCreateVersionPossibilityQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckCreateVersionPossibilityQuery(baseOptions: Apollo.QueryHookOptions<CheckCreateVersionPossibilityQuery, CheckCreateVersionPossibilityQueryVariables> & ({ variables: CheckCreateVersionPossibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCreateVersionPossibilityQuery, CheckCreateVersionPossibilityQueryVariables>(CheckCreateVersionPossibilityDocument, options);
      }
export function useCheckCreateVersionPossibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCreateVersionPossibilityQuery, CheckCreateVersionPossibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCreateVersionPossibilityQuery, CheckCreateVersionPossibilityQueryVariables>(CheckCreateVersionPossibilityDocument, options);
        }
export function useCheckCreateVersionPossibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckCreateVersionPossibilityQuery, CheckCreateVersionPossibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckCreateVersionPossibilityQuery, CheckCreateVersionPossibilityQueryVariables>(CheckCreateVersionPossibilityDocument, options);
        }
export type CheckCreateVersionPossibilityQueryHookResult = ReturnType<typeof useCheckCreateVersionPossibilityQuery>;
export type CheckCreateVersionPossibilityLazyQueryHookResult = ReturnType<typeof useCheckCreateVersionPossibilityLazyQuery>;
export type CheckCreateVersionPossibilitySuspenseQueryHookResult = ReturnType<typeof useCheckCreateVersionPossibilitySuspenseQuery>;
export type CheckCreateVersionPossibilityQueryResult = Apollo.QueryResult<CheckCreateVersionPossibilityQuery, CheckCreateVersionPossibilityQueryVariables>;
export const DivisionsListDocument = /*#__PURE__*/ gql`
    query divisionsList($paginate: PaginatorArgsDto, $orderBy: [RbacQueryResolver_Division_SortingInputType!], $where: RbacQueryResolver_Division_FilterInputType) {
  rbac {
    divisions(paginate: $paginate, order_by: $orderBy, where: $where) {
      totalCount
      items {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useDivisionsListQuery__
 *
 * To run a query within a React component, call `useDivisionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDivisionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDivisionsListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDivisionsListQuery(baseOptions?: Apollo.QueryHookOptions<DivisionsListQuery, DivisionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DivisionsListQuery, DivisionsListQueryVariables>(DivisionsListDocument, options);
      }
export function useDivisionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DivisionsListQuery, DivisionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DivisionsListQuery, DivisionsListQueryVariables>(DivisionsListDocument, options);
        }
export function useDivisionsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DivisionsListQuery, DivisionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DivisionsListQuery, DivisionsListQueryVariables>(DivisionsListDocument, options);
        }
export type DivisionsListQueryHookResult = ReturnType<typeof useDivisionsListQuery>;
export type DivisionsListLazyQueryHookResult = ReturnType<typeof useDivisionsListLazyQuery>;
export type DivisionsListSuspenseQueryHookResult = ReturnType<typeof useDivisionsListSuspenseQuery>;
export type DivisionsListQueryResult = Apollo.QueryResult<DivisionsListQuery, DivisionsListQueryVariables>;
export const GetRelatedTrainsDocument = /*#__PURE__*/ gql`
    query getRelatedTrains($data: GetRelatedTrainsDto!) {
  train {
    getRelatedTrains(data: $data) {
      totalCount
      items {
        ...RelatedTrainsFragments
        pair_train {
          ...RelatedTrainsFragments
        }
      }
    }
  }
}
    ${RelatedTrainsFragmentsFragmentDoc}`;

/**
 * __useGetRelatedTrainsQuery__
 *
 * To run a query within a React component, call `useGetRelatedTrainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedTrainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedTrainsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetRelatedTrainsQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedTrainsQuery, GetRelatedTrainsQueryVariables> & ({ variables: GetRelatedTrainsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedTrainsQuery, GetRelatedTrainsQueryVariables>(GetRelatedTrainsDocument, options);
      }
export function useGetRelatedTrainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedTrainsQuery, GetRelatedTrainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedTrainsQuery, GetRelatedTrainsQueryVariables>(GetRelatedTrainsDocument, options);
        }
export function useGetRelatedTrainsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRelatedTrainsQuery, GetRelatedTrainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRelatedTrainsQuery, GetRelatedTrainsQueryVariables>(GetRelatedTrainsDocument, options);
        }
export type GetRelatedTrainsQueryHookResult = ReturnType<typeof useGetRelatedTrainsQuery>;
export type GetRelatedTrainsLazyQueryHookResult = ReturnType<typeof useGetRelatedTrainsLazyQuery>;
export type GetRelatedTrainsSuspenseQueryHookResult = ReturnType<typeof useGetRelatedTrainsSuspenseQuery>;
export type GetRelatedTrainsQueryResult = Apollo.QueryResult<GetRelatedTrainsQuery, GetRelatedTrainsQueryVariables>;
export const NewTrainsListDocument = /*#__PURE__*/ gql`
    query newTrainsList($paginate: PaginatorArgsDto, $orderBy: [TrainQueryResolver_NewList_SortingInputType!], $where: TrainQueryResolver_NewList_FilterInputType, $is_including_expired_versions: Boolean!) {
  train {
    newList(
      paginate: $paginate
      order_by: $orderBy
      where: $where
      is_including_expired_versions: $is_including_expired_versions
    ) {
      totalCount
      items {
        is_latest_version
        ...NewTrainFragment
        pair_train {
          ...NewTrainFragment
        }
      }
    }
  }
}
    ${NewTrainFragmentFragmentDoc}`;

/**
 * __useNewTrainsListQuery__
 *
 * To run a query within a React component, call `useNewTrainsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewTrainsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewTrainsListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      is_including_expired_versions: // value for 'is_including_expired_versions'
 *   },
 * });
 */
export function useNewTrainsListQuery(baseOptions: Apollo.QueryHookOptions<NewTrainsListQuery, NewTrainsListQueryVariables> & ({ variables: NewTrainsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewTrainsListQuery, NewTrainsListQueryVariables>(NewTrainsListDocument, options);
      }
export function useNewTrainsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewTrainsListQuery, NewTrainsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewTrainsListQuery, NewTrainsListQueryVariables>(NewTrainsListDocument, options);
        }
export function useNewTrainsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewTrainsListQuery, NewTrainsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewTrainsListQuery, NewTrainsListQueryVariables>(NewTrainsListDocument, options);
        }
export type NewTrainsListQueryHookResult = ReturnType<typeof useNewTrainsListQuery>;
export type NewTrainsListLazyQueryHookResult = ReturnType<typeof useNewTrainsListLazyQuery>;
export type NewTrainsListSuspenseQueryHookResult = ReturnType<typeof useNewTrainsListSuspenseQuery>;
export type NewTrainsListQueryResult = Apollo.QueryResult<NewTrainsListQuery, NewTrainsListQueryVariables>;
export const RequestFormTrainListDocument = /*#__PURE__*/ gql`
    query requestFormTrainList($paginate: PaginatorArgsDto, $orderBy: [TrainQueryResolver_NewList_SortingInputType!], $where: TrainQueryResolver_NewList_FilterInputType, $is_including_expired_versions: Boolean!) {
  train {
    newList(
      paginate: $paginate
      order_by: $orderBy
      where: $where
      is_including_expired_versions: $is_including_expired_versions
    ) {
      totalCount
      items {
        ...RequestFormTrainListFragment
        pair_train {
          ...RequestFormTrainListFragment
        }
      }
    }
  }
}
    ${RequestFormTrainListFragmentFragmentDoc}`;

/**
 * __useRequestFormTrainListQuery__
 *
 * To run a query within a React component, call `useRequestFormTrainListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestFormTrainListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestFormTrainListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      is_including_expired_versions: // value for 'is_including_expired_versions'
 *   },
 * });
 */
export function useRequestFormTrainListQuery(baseOptions: Apollo.QueryHookOptions<RequestFormTrainListQuery, RequestFormTrainListQueryVariables> & ({ variables: RequestFormTrainListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestFormTrainListQuery, RequestFormTrainListQueryVariables>(RequestFormTrainListDocument, options);
      }
export function useRequestFormTrainListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestFormTrainListQuery, RequestFormTrainListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestFormTrainListQuery, RequestFormTrainListQueryVariables>(RequestFormTrainListDocument, options);
        }
export function useRequestFormTrainListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RequestFormTrainListQuery, RequestFormTrainListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestFormTrainListQuery, RequestFormTrainListQueryVariables>(RequestFormTrainListDocument, options);
        }
export type RequestFormTrainListQueryHookResult = ReturnType<typeof useRequestFormTrainListQuery>;
export type RequestFormTrainListLazyQueryHookResult = ReturnType<typeof useRequestFormTrainListLazyQuery>;
export type RequestFormTrainListSuspenseQueryHookResult = ReturnType<typeof useRequestFormTrainListSuspenseQuery>;
export type RequestFormTrainListQueryResult = Apollo.QueryResult<RequestFormTrainListQuery, RequestFormTrainListQueryVariables>;
export const TrainSubCategoryFiltersDocument = /*#__PURE__*/ gql`
    query trainSubCategoryFilters($range: RangeInputDto!) {
  classifiers {
    trainSubCategory {
      list(paginate: {per_page: 50, page: 0}, order_by: [], where: {}, range: $range) {
        items {
          id
          train_sub_category
          background_color
        }
      }
    }
  }
}
    `;

/**
 * __useTrainSubCategoryFiltersQuery__
 *
 * To run a query within a React component, call `useTrainSubCategoryFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainSubCategoryFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainSubCategoryFiltersQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useTrainSubCategoryFiltersQuery(baseOptions: Apollo.QueryHookOptions<TrainSubCategoryFiltersQuery, TrainSubCategoryFiltersQueryVariables> & ({ variables: TrainSubCategoryFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainSubCategoryFiltersQuery, TrainSubCategoryFiltersQueryVariables>(TrainSubCategoryFiltersDocument, options);
      }
export function useTrainSubCategoryFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainSubCategoryFiltersQuery, TrainSubCategoryFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainSubCategoryFiltersQuery, TrainSubCategoryFiltersQueryVariables>(TrainSubCategoryFiltersDocument, options);
        }
export function useTrainSubCategoryFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainSubCategoryFiltersQuery, TrainSubCategoryFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainSubCategoryFiltersQuery, TrainSubCategoryFiltersQueryVariables>(TrainSubCategoryFiltersDocument, options);
        }
export type TrainSubCategoryFiltersQueryHookResult = ReturnType<typeof useTrainSubCategoryFiltersQuery>;
export type TrainSubCategoryFiltersLazyQueryHookResult = ReturnType<typeof useTrainSubCategoryFiltersLazyQuery>;
export type TrainSubCategoryFiltersSuspenseQueryHookResult = ReturnType<typeof useTrainSubCategoryFiltersSuspenseQuery>;
export type TrainSubCategoryFiltersQueryResult = Apollo.QueryResult<TrainSubCategoryFiltersQuery, TrainSubCategoryFiltersQueryVariables>;
export const TrainVersionsListDocument = /*#__PURE__*/ gql`
    query trainVersionsList($where: TrainQueryResolver_NewList_FilterInputType, $paginate: PaginatorArgsDto, $is_including_expired_versions: Boolean!) {
  train {
    newList(
      where: $where
      paginate: $paginate
      is_including_expired_versions: $is_including_expired_versions
    ) {
      totalCount
      items {
        id
        parent_id
        version
        train_number
        status
        is_carriage_group_approval
        from_station {
          ...StationShortFragment
        }
        to_station {
          ...StationShortFragment
        }
        start_at
        end_at
        gdp {
          ...GdpShortFragment
        }
        pair_train {
          id
          train_number
          is_carriage_group_approval
          from_station {
            ...StationShortFragment
          }
          to_station {
            ...StationShortFragment
          }
        }
        parent {
          id
          train_number
          pair_train {
            id
            train_number
          }
        }
      }
    }
  }
}
    ${StationShortFragmentFragmentDoc}
${GdpShortFragmentFragmentDoc}`;

/**
 * __useTrainVersionsListQuery__
 *
 * To run a query within a React component, call `useTrainVersionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainVersionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainVersionsListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      paginate: // value for 'paginate'
 *      is_including_expired_versions: // value for 'is_including_expired_versions'
 *   },
 * });
 */
export function useTrainVersionsListQuery(baseOptions: Apollo.QueryHookOptions<TrainVersionsListQuery, TrainVersionsListQueryVariables> & ({ variables: TrainVersionsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainVersionsListQuery, TrainVersionsListQueryVariables>(TrainVersionsListDocument, options);
      }
export function useTrainVersionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainVersionsListQuery, TrainVersionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainVersionsListQuery, TrainVersionsListQueryVariables>(TrainVersionsListDocument, options);
        }
export function useTrainVersionsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainVersionsListQuery, TrainVersionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainVersionsListQuery, TrainVersionsListQueryVariables>(TrainVersionsListDocument, options);
        }
export type TrainVersionsListQueryHookResult = ReturnType<typeof useTrainVersionsListQuery>;
export type TrainVersionsListLazyQueryHookResult = ReturnType<typeof useTrainVersionsListLazyQuery>;
export type TrainVersionsListSuspenseQueryHookResult = ReturnType<typeof useTrainVersionsListSuspenseQuery>;
export type TrainVersionsListQueryResult = Apollo.QueryResult<TrainVersionsListQuery, TrainVersionsListQueryVariables>;
export const TrainsListDocument = /*#__PURE__*/ gql`
    query trainsList($paginate: PaginatorArgsDto, $orderBy: [TrainQueryResolver_List_SortingInputType!], $where: TrainQueryResolver_List_FilterInputType) {
  train {
    list(paginate: $paginate, order_by: $orderBy, where: $where) {
      totalCount
      items {
        ...TrainBaseFragment
        branch {
          ...BranchShortFragment
        }
        from_station {
          ...StationShortFragment
        }
        passenger_carrier {
          ...PassengerCarrierShortFragment
        }
        periodicity_season {
          ...PeriodicitySeasonBaseFragment
        }
        railway_administration {
          ...RailwayAdministrationBaseFragment
        }
        to_station {
          ...StationShortFragment
        }
        train_brand {
          ...TrainBrandBaseFragment
        }
        sub_category {
          ...TrainSubCategoryBaseFragment
        }
        lock_user {
          ...UserShortFragment
          branch {
            entity_id
            short_name
          }
        }
      }
    }
  }
}
    ${TrainBaseFragmentFragmentDoc}
${BranchShortFragmentFragmentDoc}
${StationShortFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}
${PeriodicitySeasonBaseFragmentFragmentDoc}
${RailwayAdministrationBaseFragmentFragmentDoc}
${TrainBrandBaseFragmentFragmentDoc}
${TrainSubCategoryBaseFragmentFragmentDoc}
${UserShortFragmentFragmentDoc}`;

/**
 * __useTrainsListQuery__
 *
 * To run a query within a React component, call `useTrainsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainsListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrainsListQuery(baseOptions?: Apollo.QueryHookOptions<TrainsListQuery, TrainsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainsListQuery, TrainsListQueryVariables>(TrainsListDocument, options);
      }
export function useTrainsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainsListQuery, TrainsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainsListQuery, TrainsListQueryVariables>(TrainsListDocument, options);
        }
export function useTrainsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainsListQuery, TrainsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainsListQuery, TrainsListQueryVariables>(TrainsListDocument, options);
        }
export type TrainsListQueryHookResult = ReturnType<typeof useTrainsListQuery>;
export type TrainsListLazyQueryHookResult = ReturnType<typeof useTrainsListLazyQuery>;
export type TrainsListSuspenseQueryHookResult = ReturnType<typeof useTrainsListSuspenseQuery>;
export type TrainsListQueryResult = Apollo.QueryResult<TrainsListQuery, TrainsListQueryVariables>;
export const DefaultFiltersDocument = /*#__PURE__*/ gql`
    query defaultFilters($rzdId: Float!, $fpkId: Float!, $range: RangeInputDto!) {
  classifiers {
    railwayAdministration {
      byEntityId(entityId: $rzdId, range: $range) {
        ...RailwayAdministrationShortFragment
      }
    }
    passengerCarrier {
      byEntityId(entityId: $fpkId, range: $range) {
        ...PassengerCarrierShortFragment
        code
      }
    }
  }
}
    ${RailwayAdministrationShortFragmentFragmentDoc}
${PassengerCarrierShortFragmentFragmentDoc}`;

/**
 * __useDefaultFiltersQuery__
 *
 * To run a query within a React component, call `useDefaultFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultFiltersQuery({
 *   variables: {
 *      rzdId: // value for 'rzdId'
 *      fpkId: // value for 'fpkId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useDefaultFiltersQuery(baseOptions: Apollo.QueryHookOptions<DefaultFiltersQuery, DefaultFiltersQueryVariables> & ({ variables: DefaultFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultFiltersQuery, DefaultFiltersQueryVariables>(DefaultFiltersDocument, options);
      }
export function useDefaultFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultFiltersQuery, DefaultFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultFiltersQuery, DefaultFiltersQueryVariables>(DefaultFiltersDocument, options);
        }
export function useDefaultFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefaultFiltersQuery, DefaultFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultFiltersQuery, DefaultFiltersQueryVariables>(DefaultFiltersDocument, options);
        }
export type DefaultFiltersQueryHookResult = ReturnType<typeof useDefaultFiltersQuery>;
export type DefaultFiltersLazyQueryHookResult = ReturnType<typeof useDefaultFiltersLazyQuery>;
export type DefaultFiltersSuspenseQueryHookResult = ReturnType<typeof useDefaultFiltersSuspenseQuery>;
export type DefaultFiltersQueryResult = Apollo.QueryResult<DefaultFiltersQuery, DefaultFiltersQueryVariables>;
export const UpdateUserConfigurationDocument = /*#__PURE__*/ gql`
    mutation updateUserConfiguration($data: String!) {
  configuration {
    user_configuration_update(data: $data) {
      id
      data
    }
  }
}
    `;
export type UpdateUserConfigurationMutationFn = Apollo.MutationFunction<UpdateUserConfigurationMutation, UpdateUserConfigurationMutationVariables>;

/**
 * __useUpdateUserConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateUserConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserConfigurationMutation, { data, loading, error }] = useUpdateUserConfigurationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserConfigurationMutation, UpdateUserConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserConfigurationMutation, UpdateUserConfigurationMutationVariables>(UpdateUserConfigurationDocument, options);
      }
export type UpdateUserConfigurationMutationHookResult = ReturnType<typeof useUpdateUserConfigurationMutation>;
export type UpdateUserConfigurationMutationResult = Apollo.MutationResult<UpdateUserConfigurationMutation>;
export type UpdateUserConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateUserConfigurationMutation, UpdateUserConfigurationMutationVariables>;
export const UserConfigurationDocument = /*#__PURE__*/ gql`
    query userConfiguration {
  configuration {
    user_configuration {
      id
      data
    }
  }
}
    `;

/**
 * __useUserConfigurationQuery__
 *
 * To run a query within a React component, call `useUserConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<UserConfigurationQuery, UserConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserConfigurationQuery, UserConfigurationQueryVariables>(UserConfigurationDocument, options);
      }
export function useUserConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserConfigurationQuery, UserConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserConfigurationQuery, UserConfigurationQueryVariables>(UserConfigurationDocument, options);
        }
export function useUserConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserConfigurationQuery, UserConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserConfigurationQuery, UserConfigurationQueryVariables>(UserConfigurationDocument, options);
        }
export type UserConfigurationQueryHookResult = ReturnType<typeof useUserConfigurationQuery>;
export type UserConfigurationLazyQueryHookResult = ReturnType<typeof useUserConfigurationLazyQuery>;
export type UserConfigurationSuspenseQueryHookResult = ReturnType<typeof useUserConfigurationSuspenseQuery>;
export type UserConfigurationQueryResult = Apollo.QueryResult<UserConfigurationQuery, UserConfigurationQueryVariables>;
export const MnemonicsFullListDocument = /*#__PURE__*/ gql`
    query mnemonicsFullList($orderBy: [MnemonicQueryResolver_List_SortingInputType!]) {
  classifiers {
    mnemonic {
      list(paginate: {per_page: 100, page: 0}, where: {}, order_by: $orderBy) {
        items {
          id
          mnemonic
          mnemonic_rus
          group_name
          group_name_rus
        }
      }
    }
  }
}
    `;

/**
 * __useMnemonicsFullListQuery__
 *
 * To run a query within a React component, call `useMnemonicsFullListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMnemonicsFullListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMnemonicsFullListQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMnemonicsFullListQuery(baseOptions?: Apollo.QueryHookOptions<MnemonicsFullListQuery, MnemonicsFullListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MnemonicsFullListQuery, MnemonicsFullListQueryVariables>(MnemonicsFullListDocument, options);
      }
export function useMnemonicsFullListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MnemonicsFullListQuery, MnemonicsFullListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MnemonicsFullListQuery, MnemonicsFullListQueryVariables>(MnemonicsFullListDocument, options);
        }
export function useMnemonicsFullListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MnemonicsFullListQuery, MnemonicsFullListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MnemonicsFullListQuery, MnemonicsFullListQueryVariables>(MnemonicsFullListDocument, options);
        }
export type MnemonicsFullListQueryHookResult = ReturnType<typeof useMnemonicsFullListQuery>;
export type MnemonicsFullListLazyQueryHookResult = ReturnType<typeof useMnemonicsFullListLazyQuery>;
export type MnemonicsFullListSuspenseQueryHookResult = ReturnType<typeof useMnemonicsFullListSuspenseQuery>;
export type MnemonicsFullListQueryResult = Apollo.QueryResult<MnemonicsFullListQuery, MnemonicsFullListQueryVariables>;
export const InitDataDocument = /*#__PURE__*/ gql`
    query initData {
  users {
    me {
      ...UserBaseFragment
      branch {
        ...BranchBaseFragment
      }
      division {
        ...DivisionFragment
        group {
          ...DivisionGroupFragment
          rules {
            ...RuleShortFragment
          }
        }
      }
      roles {
        ...RoleBaseFragment
        rules {
          method
          disabled
          module {
            name
          }
        }
      }
      rules {
        method
        disabled
        module {
          name
        }
      }
    }
  }
  configuration {
    feature_flag_list {
      items {
        ...FeatureFlagFragment
      }
    }
    feature_flag_user_list {
      items {
        id
        value
        user_id
        name
        description
      }
    }
  }
  classifiers {
    gdp {
      currentGdp: workingGDP(data: {variant: "current"}) {
        ...GdpShortFragment
      }
      nextGdp: workingGDP(data: {variant: "next"}) {
        ...GdpShortFragment
      }
      list(paginate: {page: 0, per_page: 0}) {
        items {
          ...GdpShortFragment
        }
      }
    }
  }
}
    ${UserBaseFragmentFragmentDoc}
${BranchBaseFragmentFragmentDoc}
${DivisionFragmentFragmentDoc}
${DivisionGroupFragmentFragmentDoc}
${RuleShortFragmentFragmentDoc}
${RoleBaseFragmentFragmentDoc}
${FeatureFlagFragmentFragmentDoc}
${GdpShortFragmentFragmentDoc}`;

/**
 * __useInitDataQuery__
 *
 * To run a query within a React component, call `useInitDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useInitDataQuery(baseOptions?: Apollo.QueryHookOptions<InitDataQuery, InitDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitDataQuery, InitDataQueryVariables>(InitDataDocument, options);
      }
export function useInitDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitDataQuery, InitDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitDataQuery, InitDataQueryVariables>(InitDataDocument, options);
        }
export function useInitDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InitDataQuery, InitDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InitDataQuery, InitDataQueryVariables>(InitDataDocument, options);
        }
export type InitDataQueryHookResult = ReturnType<typeof useInitDataQuery>;
export type InitDataLazyQueryHookResult = ReturnType<typeof useInitDataLazyQuery>;
export type InitDataSuspenseQueryHookResult = ReturnType<typeof useInitDataSuspenseQuery>;
export type InitDataQueryResult = Apollo.QueryResult<InitDataQuery, InitDataQueryVariables>;
export const UserNotificationCountDocument = /*#__PURE__*/ gql`
    query userNotificationCount {
  notification {
    not_viewed_user_messages_count
  }
}
    `;

/**
 * __useUserNotificationCountQuery__
 *
 * To run a query within a React component, call `useUserNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserNotificationCountQuery(baseOptions?: Apollo.QueryHookOptions<UserNotificationCountQuery, UserNotificationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationCountQuery, UserNotificationCountQueryVariables>(UserNotificationCountDocument, options);
      }
export function useUserNotificationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationCountQuery, UserNotificationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationCountQuery, UserNotificationCountQueryVariables>(UserNotificationCountDocument, options);
        }
export function useUserNotificationCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserNotificationCountQuery, UserNotificationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserNotificationCountQuery, UserNotificationCountQueryVariables>(UserNotificationCountDocument, options);
        }
export type UserNotificationCountQueryHookResult = ReturnType<typeof useUserNotificationCountQuery>;
export type UserNotificationCountLazyQueryHookResult = ReturnType<typeof useUserNotificationCountLazyQuery>;
export type UserNotificationCountSuspenseQueryHookResult = ReturnType<typeof useUserNotificationCountSuspenseQuery>;
export type UserNotificationCountQueryResult = Apollo.QueryResult<UserNotificationCountQuery, UserNotificationCountQueryVariables>;